webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports) {

module.exports = {"name":"journey-builder","version":"1.83.9","description":"Journey Builder App","main":"src/app/app.js","directories":{"doc":"docs","test":"tests"},"repository":"https://github.com/benchmarkinternetgroup/jb-webapp.git","scripts":{"test":"node server.js","start":"webpack-dev-server","start-dev-server":"webpack-dev-server 'webpack-dev-server/client?/","build":"rm -rf dist; webpack -p; mkdir -p dist/app/services; cp -R src/app/services/mocks dist/app/services/mocks; cp -R src/app/views dist/app/views; cp -R src/app/locales dist/app/locales; cp -R src/imgs dist; cp src/index.html dist; cp -R src/int-assets dist/int-assets; webpack -p --config webpack.tracker.config.js;","dev":"webpack-dev-server","copy-assets":"rm -rf src/int-assets/img; cp -R node_modules/BMEmail-Responsive/int-assets/img src/int-assets"},"keywords":["Benchmark","Journey","Builder"],"author":"Benchmark","license":"ISC","devDependencies":{"babel-core":"^6.24.1","babel-loader":"^7.0.0","babel-preset-env":"^1.5.1","css-loader":"^0.23.1","extract-text-webpack-plugin":"^2.1.0","file-loader":"^0.8.5","imports-loader":"^0.6.5","jasmine-core":"^2.4.1","json-loader":"^0.5.7","karma":"^0.13.19","karma-chrome-launcher":"^0.2.2","karma-jasmine":"^0.3.7","less":"^2.6.1","less-loader":"^2.2.2","lodash":"^4.17.4","node-sass":"^4.9.0","sass-loader":"^7.0.3","script-loader":"^0.6.1","style-loader":"^0.13.0","svg-url-loader":"^2.3.2","url-loader":"^0.5.7","webpack":"^2.6.1","webpack-dev-server":"^1.16.5","webpack-hot-middleware":"^2.10.0"},"dependencies":{"angular":"1.5.5","angular-cookies":"1.4.0","angular-ui-bootstrap":"^2.5.6","bootstrap":"^3.3.6","chosen":"0.0.2","clipboard":"^1.5.9","jquery":"^2.2.0","jquery-ui":"^1.9.2","jsplumb":"^2.0.7","jstz":"^1.0.6","moment":"^2.13.0"}}

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = initSubjectLinePicker;
var currentSuggetionInputId = "";

function initSubjectLinePicker(swrapper, canvasService, translate, selectCallBack) {
    function renderNoSuggestionMessage() {
        return "<div class='subject-line-no-container'>" + "	<div class='subject-line-no-image'></div>" + "	<div class='subject-line-no-message'>" + " 		<h2>" + translate('canvas.suggestions.no') + "</h2>" + "		<p class='subject-line-no-message-text'>" + translate('canvas.suggestions.no.data') + "</p>" + "	</div>" + "</div>";
    }

    function renderSubjectLineSuggestion(suggestion) {
        return "<li class='subject-line-picker-row'>" + "<div class='subject-line-row-icons'>" + "<span class='subject-line-increase-icon'></span>" + "<span class='subject-line-status status active'>" + Math.round(suggestion.OpenAverage) + "% " + translate('canvas.suggestions.open') + "</span>" + "</div>" + "<span class='subject-line-picker-text'>" + suggestion.EmailName + "</span>" + "</li>";
    }

    function renderSubjectLineSuggestionList(items) {
        var resultHtml = "<div class='subject-line-header'>" + translate('canvas.suggestions.top') + "</div>" + "<ul class='subject-line-list'>";

        var defaultItemCount = 20;

        for (var i = 0; i < Math.min(items.length, defaultItemCount); i++) {
            resultHtml += renderSubjectLineSuggestion(items[i]);
        }

        if (items.length > defaultItemCount) {
            resultHtml += "<div class='subject-line-extra-items' style='display: none;'>";
            for (var i = defaultItemCount; i < items.length; i++) {
                resultHtml += renderSubjectLineSuggestion(items[i]);
            }
            resultHtml += "</div>";
        }
        return resultHtml;
    }

    function normalizeWidth() {
        var maxWidth = 0;
        $(".subject-line-row-icons").each(function (i, item) {
            maxWidth = $(item).width() > maxWidth ? $(item).width() : maxWidth;
        });

        $(".subject-line-row-icons").each(function (i, item) {
            $(item).css('width', Math.ceil(maxWidth) + 'px');
        });
    }

    function setContainerPosition(input, container) {
        var inputRect = input.getBoundingClientRect();
        container.css({
            top: '45x',
            left: 0,
            width: Math.ceil(inputRect.width) + 1 + 'px',
            'z-index': 999999,
            height: '270px',
            overflow: 'auto'
        });
        container.slideDown(400);
        normalizeWidth();
    }

    function setSubjectLine(input, sender) {
        var subjectLine = "";
        if (sender.hasClass('subject-line-picker-text')) {
            subjectLine = sender.text();
        }

        if (sender.hasClass('subject-line-picker-row')) {
            var textContainer = sender.find('.subject-line-picker-text');
            subjectLine = textContainer.text();
        }

        if (sender.hasClass('subject-line-status') || sender.hasClass('subject-line-increase-icon') || sender.hasClass('subject-line-row-icons')) {
            var textContainer = sender.closest('.subject-line-picker-row').find('.subject-line-picker-text');
            subjectLine = textContainer.text();
        }

        selectCallBack(subjectLine);
        setTimeout(function () {
            document.getElementById(currentSuggetionInputId).click();
        }, 300);
    }

    function closeSubjectLinePicker(container) {
        container.slideUp(400);
        $('.subject-line-picker').each(function (i, item) {
            $(item).removeClass('is-active');
        });
    }

    function recognizeFooter(sender) {
        return sender.hasClass('subject-line-footer-link');
    }

    function recognizeRow(sender) {
        return sender.hasClass('subject-line-picker-row') || sender.hasClass('subject-line-picker-text') || sender.hasClass('subject-line-status') || sender.hasClass('subject-line-row-icons') || sender.hasClass('subject-line-increase-icon');
    }

    function recognizeNoMessage(sender) {
        return sender.hasClass('subject-line-no-container') || sender.hasClass('subject-line-no-image') || sender.hasClass('subject-line-no-message') || sender.hasClass('subject-line-no-mobile') || sender.hasClass('subject-line-no-message-text');
    }

    function recognizePicker(sender) {
        return sender.hasClass('subject-line-picker') || recognizeRow(sender) || recognizeFooter(sender) || recognizeNoMessage(sender);
    }

    $(window).on('resize', function () {
        if (!currentSuggetionInputId) {
            return;
        }

        var input = $('#' + currentSuggetionInputId)[0];
        var container = $("." + swrapper);
        setContainerPosition(input, container);
    });

    $(document).on('click touchend', function (event) {
        event.stopPropagation();

        var sender = $(event.target);
        if (sender.hasClass('disabled') || sender.attr('disabled')) {
            return;
        }

        var container = $("." + swrapper);
        if (!recognizePicker(sender)) {
            closeSubjectLinePicker(container);
            currentSuggetionInputId = null;
            return;
        }

        if (sender.hasClass('subject-line-picker')) {
            var inputId = event.target.dataset.for;

            if (!inputId) {
                return;
            }
            currentSuggetionInputId = inputId;

            var input = document.getElementById(inputId);
            setContainerPosition(input, container);
            sender.addClass('is-active');
        }

        if (recognizeRow(sender)) {
            var input = $('#' + currentSuggetionInputId)[0];
            setSubjectLine(input, sender);
            closeSubjectLinePicker(container);
        }

        if (sender.hasClass('subject-line-footer-link')) {
            var extraContainer = container.find('.subject-line-extra-items');
            if (!extraContainer) {
                return;
            }

            if (sender.hasClass("open")) {
                sender.removeClass("open");
                extraContainer.slideUp(400);
            } else {
                extraContainer.slideDown(400);
                sender.addClass("open");
            }

            normalizeWidth();
        }
    });

    // initialize suggestions
    canvasService.getSubjectLine().then(function (_ref) {
        var data = _ref.data;

        if (data.SubjectLines.length === 0) {
            $("." + swrapper).html(renderNoSuggestionMessage());
        } else {
            var truncatedData = data.SubjectLines.slice(0, 10);
            $("." + swrapper).html(renderSubjectLineSuggestionList(truncatedData));
        }
    });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    if (location.protocol === 'http:' && window.location.hostname !== 'jbdev.benchmarkemail.com') {
        window.location = location.href.replace('http', 'https');
    }
})();

__webpack_require__(274);
__webpack_require__(275);
__webpack_require__(284);
__webpack_require__(286);
__webpack_require__(285);
__webpack_require__(159);
__webpack_require__(157);

__webpack_require__(184);
__webpack_require__(168);
__webpack_require__(242);
__webpack_require__(253);

(function () {
    'use strict';

    angular.module('journeyBuilder', ['translateModule', 'JB.translate.srv', 'loginModule', 'auth.srv', 'ui.router', 'homeModule', 'canvasModule', 'headerModule', 'footerModule', 'indexModule', 'dataHandlingModule', 'customDate', 'faqModule', 'summaryModule', 'trackingReportsModule', 'trackingCodeModule', 'coachingModule', 'upgradeModule', 'ui.bootstrap', 'entryModalModule', 'reportModule']).config(['$stateProvider', '$urlRouterProvider', journeyRoute]).run(['$rootScope', '$state', 'AUTH_EVENTS', 'AuthSrv', '$stateParams', 'cacheService', accessControl]).run(['$rootScope', 'Translate', jbTranslate]);

    function journeyRoute($stateProvider, $urlRouterProvider) {
        $stateProvider.state('redirectcanvas', {
            url: "/redirectcanvas/:id",
            onEnter: ['$state', '$stateParams', function ($state, $stateParams) {
                window.location = window.location.origin + '/#/canvas/' + $stateParams.id;
                setTimeout(function () {
                    window.location.reload(true);
                }, 0);
                document.getElementsByTagName('body')[0].classList.add('hide');
            }]
        }).state('home', {
            url: '/home',
            templateUrl: 'app/views/home.tpl.html',
            controller: 'homeCon',
            resolve: {
                translate: ['$rootScope', function ($rootScope) {
                    return $rootScope.translatePromise;
                }]
            }
        }).state('canvas', {
            url: '/canvas',
            templateUrl: 'app/views/canvas.tpl.html',
            controller: 'canvasCon',
            resolve: {
                translate: ['$rootScope', function ($rootScope) {
                    return $rootScope.translatePromise;
                }]
            }
        }).state('canvas/:canvasId', {
            url: '/canvas/:canvasId',
            templateUrl: 'app/views/canvas.tpl.html',
            controller: 'canvasCon',
            resolve: {
                translate: ['$rootScope', function ($rootScope) {
                    $rootScope.$emit('jbLoader', true);
                    return $rootScope.translatePromise;
                }]
            }
        }).state('canvas/:canvasId/:emailId/:status', {
            url: '/canvas/:canvasId/:emailId/:status',
            templateUrl: 'app/views/canvas.tpl.html',
            controller: 'canvasCon',
            resolve: {
                translate: ['$rootScope', function ($rootScope) {
                    $rootScope.$emit('jbLoader', true);
                    return $rootScope.translatePromise;
                }]
            }
        }).state('report/:canvasId', {
            url: '/report/:canvasId',
            controller: 'reportController',
            resolve: {
                translate: ['$rootScope', function ($rootScope) {
                    $rootScope.$emit('jbLoader', true);
                    return $rootScope.translatePromise;
                }]
            }
        }).state("otherwise", { url: '/home' });

        $urlRouterProvider.otherwise('/home');
    }

    function accessControl($rootScope, $state, AUTH_EVENTS, AuthSrv, $stateParams, cacheService) {
        $rootScope.$on('$stateChangeStart', function (event, next, toParams) {

            if (next.name === 'home' && $stateParams.canvasId && $rootScope.jbToken && _notActive() && !_.isEqual($rootScope.currentJB, $rootScope.connections)) {
                if (window.confirm($rootScope.translate('common.back.message'))) {
                    $rootScope.$emit('pageLocationChanged', next);
                } else {
                    event.preventDefault();
                }
            } else {
                $rootScope.$emit('pageLocationChanged', next);
            }

            // if next route is home close the modal.
            if (next.name === 'home') {
                $rootScope.$emit('hideActionAddListModal');
                $rootScope.$emit('hideActionAddWaitTimeModal');
                $rootScope.$emit('hideActionRemoveListModal');
                $rootScope.$emit('hideActionSendEmailModal');
                $rootScope.$emit('hideConditionEmailEngagementtModal');
                $rootScope.$emit('hideConditionIfElseModal');
                $rootScope.$emit('hideConditionIsInListModal');
                $rootScope.$emit('hideConditionIsInSegmentModal');
                $rootScope.$emit('hideConditionIsNotInSegmentModal');
                $rootScope.$emit('hideConditionWebsiteActivityModal');
                $rootScope.$emit('hideEntryDateTimeModal');
                $rootScope.$emit('hideEntryEngagementModal');
                $rootScope.$emit('hideEntryListModal');
                $rootScope.$emit('hideEntrySegmentModal');
                $rootScope.$emit('hideReportsModal');
                $rootScope.$emit('hideFacebookAudienceModal');
            }

            //Check if user is logged in
            if ($rootScope.authCheckInProgress) return;

            event.preventDefault();
            $rootScope.authCheckInProgress = true;

            AuthSrv.isAuthenticated().then(function (isAuthenticated) {
                if (!isAuthenticated) {
                    $rootScope.authCheckInProgress = false;
                    window.location = AUTH_EVENTS.benchmarkLoginUrl;
                    return;
                }

                AuthSrv.getCurrentSession().then(function (session) {
                    var settingsData = sessionStorage.getItem('settingSession'),
                        settings = settingsData ? JSON.parse(settingsData) : {};

                    if (settingsData && settings.token === session.token) {
                        $rootScope.jbClient = settings.ClientId;
                        $rootScope.cSettings = settings;

                        //Intercom Script
                        if (settings.ClientId) {
                            window.intercomSettings = { app_id: "ilz8qnxk", user_id: settings.ClientId };
                        }

                        $state.go(next.name, toParams).then(function () {
                            $rootScope.authCheckInProgress = false;
                        });
                    } else {
                        cacheService.deleteCachable();

                        AuthSrv.authUser(session.token).success(function (data) {
                            data.token = session.token;

                            //Cache session
                            if ($rootScope.localStorageSupported) {
                                sessionStorage.setItem('settingSession', JSON.stringify(data));
                            }

                            $rootScope.jbClient = data.ClientId;
                            $rootScope.cSettings = data;

                            //Intercom Script
                            if (data.ClientId) {
                                window.intercomSettings = { app_id: "ilz8qnxk", user_id: data.ClientId };
                            }

                            $state.go(next.name, toParams).then(function () {
                                $rootScope.authCheckInProgress = false;
                            });
                        }).error(function (error, status) {
                            console.log(error, status);
                            if (status === 401) {
                                window.location = AUTH_EVENTS.benchmarkUi;
                            } else {
                                Intercom('trackEvent', 'AP-ERROR-404', {
                                    description: 'Trigger this event whenever a user will be redirected to 404',
                                    metadata: {
                                        api: 'settings api',
                                        errStatus: status
                                    }
                                });

                                window.location = AUTH_EVENTS.maintenancePage;
                            }
                            AuthSrv.destroySession();
                            $rootScope.authCheckInProgress = false;
                            return;
                        });
                    }
                });
            });

            function _notActive() {
                return $rootScope.currentJourneyStatus !== 3 && $rootScope.currentJourneyStatus !== 4 && $rootScope.currentJourneyStatus !== 8;
            }
        });

        var testKey = 'test',
            storage = window.sessionStorage;
        try {
            storage.setItem(testKey, '1');
            storage.removeItem(testKey);
            $rootScope.localStorageSupported = true;
        } catch (error) {
            $rootScope.localStorageSupported = false;
        }
    }

    function jbTranslate($rootScope, Translate) {
        $rootScope.$on('$stateChangeStart', function () {
            if (!$rootScope.translate) {
                Translate.buildDirectory();
            }
        });
    }
})();

/***/ }),
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */
/***/ (function(module, exports) {

/**
 * @license AngularJS v1.4.0
 * (c) 2010-2015 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular, undefined) {'use strict';

/**
 * @ngdoc module
 * @name ngCookies
 * @description
 *
 * # ngCookies
 *
 * The `ngCookies` module provides a convenient wrapper for reading and writing browser cookies.
 *
 *
 * <div doc-module-components="ngCookies"></div>
 *
 * See {@link ngCookies.$cookies `$cookies`} and
 * {@link ngCookies.$cookieStore `$cookieStore`} for usage.
 */


angular.module('ngCookies', ['ng']).
  /**
   * @ngdoc provider
   * @name $cookiesProvider
   * @description
   * Use `$cookiesProvider` to change the default behavior of the {@link ngCookies.$cookies $cookies} service.
   * */
   provider('$cookies', [function $CookiesProvider() {
    /**
     * @ngdoc property
     * @name $cookiesProvider#defaults
     * @description
     *
     * Object containing default options to pass when setting cookies.
     *
     * The object may have following properties:
     *
     * - **path** - `{string}` - The cookie will be available only for this path and its
     *   sub-paths. By default, this would be the URL that appears in your base tag.
     * - **domain** - `{string}` - The cookie will be available only for this domain and
     *   its sub-domains. For obvious security reasons the user agent will not accept the
     *   cookie if the current domain is not a sub domain or equals to the requested domain.
     * - **expires** - `{string|Date}` - String of the form "Wdy, DD Mon YYYY HH:MM:SS GMT"
     *   or a Date object indicating the exact date/time this cookie will expire.
     * - **secure** - `{boolean}` - The cookie will be available only in secured connection.
     *
     * Note: by default the address that appears in your <base> tag will be used as path.
     * This is import so that cookies will be visible for all routes in case html5mode is enabled
     *
     **/
    var defaults = this.defaults = {};

    function calcOptions(options) {
      return options ? angular.extend({}, defaults, options) : defaults;
    }

    /**
     * @ngdoc service
     * @name $cookies
     *
     * @description
     * Provides read/write access to browser's cookies.
     *
     * BREAKING CHANGE: `$cookies` no longer exposes properties that represent the
     * current browser cookie values. Now you must use the get/put/remove/etc. methods
     * as described below.
     *
     * Requires the {@link ngCookies `ngCookies`} module to be installed.
     *
     * @example
     *
     * ```js
     * angular.module('cookiesExample', ['ngCookies'])
     *   .controller('ExampleController', ['$cookies', function($cookies) {
     *     // Retrieving a cookie
     *     var favoriteCookie = $cookies.get('myFavorite');
     *     // Setting a cookie
     *     $cookies.put('myFavorite', 'oatmeal');
     *   }]);
     * ```
     */
    this.$get = ['$$cookieReader', '$$cookieWriter', function($$cookieReader, $$cookieWriter) {
      return {
        /**
         * @ngdoc method
         * @name $cookies#get
         *
         * @description
         * Returns the value of given cookie key
         *
         * @param {string} key Id to use for lookup.
         * @returns {string} Raw cookie value.
         */
        get: function(key) {
          return $$cookieReader()[key];
        },

        /**
         * @ngdoc method
         * @name $cookies#getObject
         *
         * @description
         * Returns the deserialized value of given cookie key
         *
         * @param {string} key Id to use for lookup.
         * @returns {Object} Deserialized cookie value.
         */
        getObject: function(key) {
          var value = this.get(key);
          return value ? angular.fromJson(value) : value;
        },

        /**
         * @ngdoc method
         * @name $cookies#getAll
         *
         * @description
         * Returns a key value object with all the cookies
         *
         * @returns {Object} All cookies
         */
        getAll: function() {
          return $$cookieReader();
        },

        /**
         * @ngdoc method
         * @name $cookies#put
         *
         * @description
         * Sets a value for given cookie key
         *
         * @param {string} key Id for the `value`.
         * @param {string} value Raw value to be stored.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */
        put: function(key, value, options) {
          $$cookieWriter(key, value, calcOptions(options));
        },

        /**
         * @ngdoc method
         * @name $cookies#putObject
         *
         * @description
         * Serializes and sets a value for given cookie key
         *
         * @param {string} key Id for the `value`.
         * @param {Object} value Value to be stored.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */
        putObject: function(key, value, options) {
          this.put(key, angular.toJson(value), options);
        },

        /**
         * @ngdoc method
         * @name $cookies#remove
         *
         * @description
         * Remove given cookie
         *
         * @param {string} key Id of the key-value pair to delete.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */
        remove: function(key, options) {
          $$cookieWriter(key, undefined, calcOptions(options));
        }
      };
    }];
  }]);

angular.module('ngCookies').
/**
 * @ngdoc service
 * @name $cookieStore
 * @deprecated
 * @requires $cookies
 *
 * @description
 * Provides a key-value (string-object) storage, that is backed by session cookies.
 * Objects put or retrieved from this storage are automatically serialized or
 * deserialized by angular's toJson/fromJson.
 *
 * Requires the {@link ngCookies `ngCookies`} module to be installed.
 *
 * <div class="alert alert-danger">
 * **Note:** The $cookieStore service is deprecated.
 * Please use the {@link ngCookies.$cookies `$cookies`} service instead.
 * </div>
 *
 * @example
 *
 * ```js
 * angular.module('cookieStoreExample', ['ngCookies'])
 *   .controller('ExampleController', ['$cookieStore', function($cookieStore) {
 *     // Put cookie
 *     $cookieStore.put('myFavorite','oatmeal');
 *     // Get cookie
 *     var favoriteCookie = $cookieStore.get('myFavorite');
 *     // Removing a cookie
 *     $cookieStore.remove('myFavorite');
 *   }]);
 * ```
 */
 factory('$cookieStore', ['$cookies', function($cookies) {

    return {
      /**
       * @ngdoc method
       * @name $cookieStore#get
       *
       * @description
       * Returns the value of given cookie key
       *
       * @param {string} key Id to use for lookup.
       * @returns {Object} Deserialized cookie value, undefined if the cookie does not exist.
       */
      get: function(key) {
        return $cookies.getObject(key);
      },

      /**
       * @ngdoc method
       * @name $cookieStore#put
       *
       * @description
       * Sets a value for given cookie key
       *
       * @param {string} key Id for the `value`.
       * @param {Object} value Value to be stored.
       */
      put: function(key, value) {
        $cookies.putObject(key, value);
      },

      /**
       * @ngdoc method
       * @name $cookieStore#remove
       *
       * @description
       * Remove given cookie
       *
       * @param {string} key Id of the key-value pair to delete.
       */
      remove: function(key) {
        $cookies.remove(key);
      }
    };

  }]);

/**
 * @name $$cookieWriter
 * @requires $document
 *
 * @description
 * This is a private service for writing cookies
 *
 * @param {string} name Cookie name
 * @param {string=} value Cookie value (if undefined, cookie will be deleted)
 * @param {Object=} options Object with options that need to be stored for the cookie.
 */
function $$CookieWriter($document, $log, $browser) {
  var cookiePath = $browser.baseHref();
  var rawDocument = $document[0];

  function buildCookieString(name, value, options) {
    var path, expires;
    options = options || {};
    expires = options.expires;
    path = angular.isDefined(options.path) ? options.path : cookiePath;
    if (value === undefined) {
      expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
      value = '';
    }
    if (angular.isString(expires)) {
      expires = new Date(expires);
    }

    var str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
    str += path ? ';path=' + path : '';
    str += options.domain ? ';domain=' + options.domain : '';
    str += expires ? ';expires=' + expires.toUTCString() : '';
    str += options.secure ? ';secure' : '';

    // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
    // - 300 cookies
    // - 20 cookies per unique domain
    // - 4096 bytes per cookie
    var cookieLength = str.length + 1;
    if (cookieLength > 4096) {
      $log.warn("Cookie '" + name +
        "' possibly not set or overflowed because it was too large (" +
        cookieLength + " > 4096 bytes)!");
    }

    return str;
  }

  return function(name, value, options) {
    rawDocument.cookie = buildCookieString(name, value, options);
  };
}

$$CookieWriter.$inject = ['$document', '$log', '$browser'];

angular.module('ngCookies').provider('$$cookieWriter', function $$CookieWriterProvider() {
  this.$get = $$CookieWriter;
});


})(window, window.angular);


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(156);
module.exports = 'ngCookies';


/***/ }),
/* 158 */
/***/ (function(module, exports) {

/*
 * angular-ui-bootstrap
 * http://angular-ui.github.io/bootstrap/

 * Version: 2.5.6 - 2017-10-14
 * License: MIT
 */angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.collapse","ui.bootstrap.tabindex","ui.bootstrap.accordion","ui.bootstrap.alert","ui.bootstrap.buttons","ui.bootstrap.carousel","ui.bootstrap.dateparser","ui.bootstrap.isClass","ui.bootstrap.datepicker","ui.bootstrap.position","ui.bootstrap.datepickerPopup","ui.bootstrap.debounce","ui.bootstrap.multiMap","ui.bootstrap.dropdown","ui.bootstrap.stackedMap","ui.bootstrap.modal","ui.bootstrap.paging","ui.bootstrap.pager","ui.bootstrap.pagination","ui.bootstrap.tooltip","ui.bootstrap.popover","ui.bootstrap.progressbar","ui.bootstrap.rating","ui.bootstrap.tabs","ui.bootstrap.timepicker","ui.bootstrap.typeahead"]);
angular.module("ui.bootstrap.tpls", ["uib/template/accordion/accordion-group.html","uib/template/accordion/accordion.html","uib/template/alert/alert.html","uib/template/carousel/carousel.html","uib/template/carousel/slide.html","uib/template/datepicker/datepicker.html","uib/template/datepicker/day.html","uib/template/datepicker/month.html","uib/template/datepicker/year.html","uib/template/datepickerPopup/popup.html","uib/template/modal/window.html","uib/template/pager/pager.html","uib/template/pagination/pagination.html","uib/template/tooltip/tooltip-html-popup.html","uib/template/tooltip/tooltip-popup.html","uib/template/tooltip/tooltip-template-popup.html","uib/template/popover/popover-html.html","uib/template/popover/popover-template.html","uib/template/popover/popover.html","uib/template/progressbar/bar.html","uib/template/progressbar/progress.html","uib/template/progressbar/progressbar.html","uib/template/rating/rating.html","uib/template/tabs/tab.html","uib/template/tabs/tabset.html","uib/template/timepicker/timepicker.html","uib/template/typeahead/typeahead-match.html","uib/template/typeahead/typeahead-popup.html"]);
angular.module('ui.bootstrap.collapse', [])

  .directive('uibCollapse', ['$animate', '$q', '$parse', '$injector', function($animate, $q, $parse, $injector) {
    var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
    return {
      link: function(scope, element, attrs) {
        var expandingExpr = $parse(attrs.expanding),
          expandedExpr = $parse(attrs.expanded),
          collapsingExpr = $parse(attrs.collapsing),
          collapsedExpr = $parse(attrs.collapsed),
          horizontal = false,
          css = {},
          cssTo = {};

        init();

        function init() {
          horizontal = !!('horizontal' in attrs);
          if (horizontal) {
            css = {
              width: ''
            };
            cssTo = {width: '0'};
          } else {
            css = {
              height: ''
            };
            cssTo = {height: '0'};
          }
          if (!scope.$eval(attrs.uibCollapse)) {
            element.addClass('in')
              .addClass('collapse')
              .attr('aria-expanded', true)
              .attr('aria-hidden', false)
              .css(css);
          }
        }

        function getScrollFromElement(element) {
          if (horizontal) {
            return {width: element.scrollWidth + 'px'};
          }
          return {height: element.scrollHeight + 'px'};
        }

        function expand() {
          if (element.hasClass('collapse') && element.hasClass('in')) {
            return;
          }

          $q.resolve(expandingExpr(scope))
            .then(function() {
              element.removeClass('collapse')
                .addClass('collapsing')
                .attr('aria-expanded', true)
                .attr('aria-hidden', false);

              if ($animateCss) {
                $animateCss(element, {
                  addClass: 'in',
                  easing: 'ease',
                  css: {
                    overflow: 'hidden'
                  },
                  to: getScrollFromElement(element[0])
                }).start()['finally'](expandDone);
              } else {
                $animate.addClass(element, 'in', {
                  css: {
                    overflow: 'hidden'
                  },
                  to: getScrollFromElement(element[0])
                }).then(expandDone);
              }
            }, angular.noop);
        }

        function expandDone() {
          element.removeClass('collapsing')
            .addClass('collapse')
            .css(css);
          expandedExpr(scope);
        }

        function collapse() {
          if (!element.hasClass('collapse') && !element.hasClass('in')) {
            return collapseDone();
          }

          $q.resolve(collapsingExpr(scope))
            .then(function() {
              element
              // IMPORTANT: The width must be set before adding "collapsing" class.
              // Otherwise, the browser attempts to animate from width 0 (in
              // collapsing class) to the given width here.
                .css(getScrollFromElement(element[0]))
                // initially all panel collapse have the collapse class, this removal
                // prevents the animation from jumping to collapsed state
                .removeClass('collapse')
                .addClass('collapsing')
                .attr('aria-expanded', false)
                .attr('aria-hidden', true);

              if ($animateCss) {
                $animateCss(element, {
                  removeClass: 'in',
                  to: cssTo
                }).start()['finally'](collapseDone);
              } else {
                $animate.removeClass(element, 'in', {
                  to: cssTo
                }).then(collapseDone);
              }
            }, angular.noop);
        }

        function collapseDone() {
          element.css(cssTo); // Required so that collapse works when animation is disabled
          element.removeClass('collapsing')
            .addClass('collapse');
          collapsedExpr(scope);
        }

        scope.$watch(attrs.uibCollapse, function(shouldCollapse) {
          if (shouldCollapse) {
            collapse();
          } else {
            expand();
          }
        });
      }
    };
  }]);

angular.module('ui.bootstrap.tabindex', [])

.directive('uibTabindexToggle', function() {
  return {
    restrict: 'A',
    link: function(scope, elem, attrs) {
      attrs.$observe('disabled', function(disabled) {
        attrs.$set('tabindex', disabled ? -1 : null);
      });
    }
  };
});

angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse', 'ui.bootstrap.tabindex'])

.constant('uibAccordionConfig', {
  closeOthers: true
})

.controller('UibAccordionController', ['$scope', '$attrs', 'uibAccordionConfig', function($scope, $attrs, accordionConfig) {
  // This array keeps track of the accordion groups
  this.groups = [];

  // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
  this.closeOthers = function(openGroup) {
    var closeOthers = angular.isDefined($attrs.closeOthers) ?
      $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
    if (closeOthers) {
      angular.forEach(this.groups, function(group) {
        if (group !== openGroup) {
          group.isOpen = false;
        }
      });
    }
  };

  // This is called from the accordion-group directive to add itself to the accordion
  this.addGroup = function(groupScope) {
    var that = this;
    this.groups.push(groupScope);

    groupScope.$on('$destroy', function(event) {
      that.removeGroup(groupScope);
    });
  };

  // This is called from the accordion-group directive when to remove itself
  this.removeGroup = function(group) {
    var index = this.groups.indexOf(group);
    if (index !== -1) {
      this.groups.splice(index, 1);
    }
  };
}])

// The accordion directive simply sets up the directive controller
// and adds an accordion CSS class to itself element.
.directive('uibAccordion', function() {
  return {
    controller: 'UibAccordionController',
    controllerAs: 'accordion',
    transclude: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/accordion/accordion.html';
    }
  };
})

// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
.directive('uibAccordionGroup', function() {
  return {
    require: '^uibAccordion',         // We need this directive to be inside an accordion
    transclude: true,              // It transcludes the contents of the directive into the template
    restrict: 'A',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/accordion/accordion-group.html';
    },
    scope: {
      heading: '@',               // Interpolate the heading attribute onto this scope
      panelClass: '@?',           // Ditto with panelClass
      isOpen: '=?',
      isDisabled: '=?'
    },
    controller: function() {
      this.setHeading = function(element) {
        this.heading = element;
      };
    },
    link: function(scope, element, attrs, accordionCtrl) {
      element.addClass('panel');
      accordionCtrl.addGroup(scope);

      scope.openClass = attrs.openClass || 'panel-open';
      scope.panelClass = attrs.panelClass || 'panel-default';
      scope.$watch('isOpen', function(value) {
        element.toggleClass(scope.openClass, !!value);
        if (value) {
          accordionCtrl.closeOthers(scope);
        }
      });

      scope.toggleOpen = function($event) {
        if (!scope.isDisabled) {
          if (!$event || $event.which === 32) {
            scope.isOpen = !scope.isOpen;
          }
        }
      };

      var id = 'accordiongroup-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
      scope.headingId = id + '-tab';
      scope.panelId = id + '-panel';
    }
  };
})

// Use accordion-heading below an accordion-group to provide a heading containing HTML
.directive('uibAccordionHeading', function() {
  return {
    transclude: true,   // Grab the contents to be used as the heading
    template: '',       // In effect remove this element!
    replace: true,
    require: '^uibAccordionGroup',
    link: function(scope, element, attrs, accordionGroupCtrl, transclude) {
      // Pass the heading to the accordion-group controller
      // so that it can be transcluded into the right place in the template
      // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
      accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
    }
  };
})

// Use in the accordion-group template to indicate where you want the heading to be transcluded
// You must provide the property on the accordion-group controller that will hold the transcluded element
.directive('uibAccordionTransclude', function() {
  return {
    require: '^uibAccordionGroup',
    link: function(scope, element, attrs, controller) {
      scope.$watch(function() { return controller[attrs.uibAccordionTransclude]; }, function(heading) {
        if (heading) {
          var elem = angular.element(element[0].querySelector(getHeaderSelectors()));
          elem.html('');
          elem.append(heading);
        }
      });
    }
  };

  function getHeaderSelectors() {
      return 'uib-accordion-header,' +
          'data-uib-accordion-header,' +
          'x-uib-accordion-header,' +
          'uib\\:accordion-header,' +
          '[uib-accordion-header],' +
          '[data-uib-accordion-header],' +
          '[x-uib-accordion-header]';
  }
});

angular.module('ui.bootstrap.alert', [])

.controller('UibAlertController', ['$scope', '$element', '$attrs', '$interpolate', '$timeout', function($scope, $element, $attrs, $interpolate, $timeout) {
  $scope.closeable = !!$attrs.close;
  $element.addClass('alert');
  $attrs.$set('role', 'alert');
  if ($scope.closeable) {
    $element.addClass('alert-dismissible');
  }

  var dismissOnTimeout = angular.isDefined($attrs.dismissOnTimeout) ?
    $interpolate($attrs.dismissOnTimeout)($scope.$parent) : null;

  if (dismissOnTimeout) {
    $timeout(function() {
      $scope.close();
    }, parseInt(dismissOnTimeout, 10));
  }
}])

.directive('uibAlert', function() {
  return {
    controller: 'UibAlertController',
    controllerAs: 'alert',
    restrict: 'A',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/alert/alert.html';
    },
    transclude: true,
    scope: {
      close: '&'
    }
  };
});

angular.module('ui.bootstrap.buttons', [])

.constant('uibButtonConfig', {
  activeClass: 'active',
  toggleEvent: 'click'
})

.controller('UibButtonsController', ['uibButtonConfig', function(buttonConfig) {
  this.activeClass = buttonConfig.activeClass || 'active';
  this.toggleEvent = buttonConfig.toggleEvent || 'click';
}])

.directive('uibBtnRadio', ['$parse', function($parse) {
  return {
    require: ['uibBtnRadio', 'ngModel'],
    controller: 'UibButtonsController',
    controllerAs: 'buttons',
    link: function(scope, element, attrs, ctrls) {
      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
      var uncheckableExpr = $parse(attrs.uibUncheckable);

      element.find('input').css({display: 'none'});

      //model -> UI
      ngModelCtrl.$render = function() {
        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.uibBtnRadio)));
      };

      //ui->model
      element.on(buttonsCtrl.toggleEvent, function() {
        if (attrs.disabled) {
          return;
        }

        var isActive = element.hasClass(buttonsCtrl.activeClass);

        if (!isActive || angular.isDefined(attrs.uncheckable)) {
          scope.$apply(function() {
            ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.uibBtnRadio));
            ngModelCtrl.$render();
          });
        }
      });

      if (attrs.uibUncheckable) {
        scope.$watch(uncheckableExpr, function(uncheckable) {
          attrs.$set('uncheckable', uncheckable ? '' : undefined);
        });
      }
    }
  };
}])

.directive('uibBtnCheckbox', function() {
  return {
    require: ['uibBtnCheckbox', 'ngModel'],
    controller: 'UibButtonsController',
    controllerAs: 'button',
    link: function(scope, element, attrs, ctrls) {
      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      element.find('input').css({display: 'none'});

      function getTrueValue() {
        return getCheckboxValue(attrs.btnCheckboxTrue, true);
      }

      function getFalseValue() {
        return getCheckboxValue(attrs.btnCheckboxFalse, false);
      }

      function getCheckboxValue(attribute, defaultValue) {
        return angular.isDefined(attribute) ? scope.$eval(attribute) : defaultValue;
      }

      //model -> UI
      ngModelCtrl.$render = function() {
        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
      };

      //ui->model
      element.on(buttonsCtrl.toggleEvent, function() {
        if (attrs.disabled) {
          return;
        }

        scope.$apply(function() {
          ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
          ngModelCtrl.$render();
        });
      });
    }
  };
});

angular.module('ui.bootstrap.carousel', [])

.controller('UibCarouselController', ['$scope', '$element', '$interval', '$timeout', '$animate', function($scope, $element, $interval, $timeout, $animate) {
  var self = this,
    slides = self.slides = $scope.slides = [],
    SLIDE_DIRECTION = 'uib-slideDirection',
    currentIndex = $scope.active,
    currentInterval, isPlaying;

  var destroyed = false;
  $element.addClass('carousel');

  self.addSlide = function(slide, element) {
    slides.push({
      slide: slide,
      element: element
    });
    slides.sort(function(a, b) {
      return +a.slide.index - +b.slide.index;
    });
    //if this is the first slide or the slide is set to active, select it
    if (slide.index === $scope.active || slides.length === 1 && !angular.isNumber($scope.active)) {
      if ($scope.$currentTransition) {
        $scope.$currentTransition = null;
      }

      currentIndex = slide.index;
      $scope.active = slide.index;
      setActive(currentIndex);
      self.select(slides[findSlideIndex(slide)]);
      if (slides.length === 1) {
        $scope.play();
      }
    }
  };

  self.getCurrentIndex = function() {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].slide.index === currentIndex) {
        return i;
      }
    }
  };

  self.next = $scope.next = function() {
    var newIndex = (self.getCurrentIndex() + 1) % slides.length;

    if (newIndex === 0 && $scope.noWrap()) {
      $scope.pause();
      return;
    }

    return self.select(slides[newIndex], 'next');
  };

  self.prev = $scope.prev = function() {
    var newIndex = self.getCurrentIndex() - 1 < 0 ? slides.length - 1 : self.getCurrentIndex() - 1;

    if ($scope.noWrap() && newIndex === slides.length - 1) {
      $scope.pause();
      return;
    }

    return self.select(slides[newIndex], 'prev');
  };

  self.removeSlide = function(slide) {
    var index = findSlideIndex(slide);

    //get the index of the slide inside the carousel
    slides.splice(index, 1);
    if (slides.length > 0 && currentIndex === index) {
      if (index >= slides.length) {
        currentIndex = slides.length - 1;
        $scope.active = currentIndex;
        setActive(currentIndex);
        self.select(slides[slides.length - 1]);
      } else {
        currentIndex = index;
        $scope.active = currentIndex;
        setActive(currentIndex);
        self.select(slides[index]);
      }
    } else if (currentIndex > index) {
      currentIndex--;
      $scope.active = currentIndex;
    }

    //clean the active value when no more slide
    if (slides.length === 0) {
      currentIndex = null;
      $scope.active = null;
    }
  };

  /* direction: "prev" or "next" */
  self.select = $scope.select = function(nextSlide, direction) {
    var nextIndex = findSlideIndex(nextSlide.slide);
    //Decide direction if it's not given
    if (direction === undefined) {
      direction = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
    }
    //Prevent this user-triggered transition from occurring if there is already one in progress
    if (nextSlide.slide.index !== currentIndex &&
      !$scope.$currentTransition) {
      goNext(nextSlide.slide, nextIndex, direction);
    }
  };

  /* Allow outside people to call indexOf on slides array */
  $scope.indexOfSlide = function(slide) {
    return +slide.slide.index;
  };

  $scope.isActive = function(slide) {
    return $scope.active === slide.slide.index;
  };

  $scope.isPrevDisabled = function() {
    return $scope.active === 0 && $scope.noWrap();
  };

  $scope.isNextDisabled = function() {
    return $scope.active === slides.length - 1 && $scope.noWrap();
  };

  $scope.pause = function() {
    if (!$scope.noPause) {
      isPlaying = false;
      resetTimer();
    }
  };

  $scope.play = function() {
    if (!isPlaying) {
      isPlaying = true;
      restartTimer();
    }
  };

  $element.on('mouseenter', $scope.pause);
  $element.on('mouseleave', $scope.play);

  $scope.$on('$destroy', function() {
    destroyed = true;
    resetTimer();
  });

  $scope.$watch('noTransition', function(noTransition) {
    $animate.enabled($element, !noTransition);
  });

  $scope.$watch('interval', restartTimer);

  $scope.$watchCollection('slides', resetTransition);

  $scope.$watch('active', function(index) {
    if (angular.isNumber(index) && currentIndex !== index) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].slide.index === index) {
          index = i;
          break;
        }
      }

      var slide = slides[index];
      if (slide) {
        setActive(index);
        self.select(slides[index]);
        currentIndex = index;
      }
    }
  });

  function getSlideByIndex(index) {
    for (var i = 0, l = slides.length; i < l; ++i) {
      if (slides[i].index === index) {
        return slides[i];
      }
    }
  }

  function setActive(index) {
    for (var i = 0; i < slides.length; i++) {
      slides[i].slide.active = i === index;
    }
  }

  function goNext(slide, index, direction) {
    if (destroyed) {
      return;
    }

    angular.extend(slide, {direction: direction});
    angular.extend(slides[currentIndex].slide || {}, {direction: direction});
    if ($animate.enabled($element) && !$scope.$currentTransition &&
      slides[index].element && self.slides.length > 1) {
      slides[index].element.data(SLIDE_DIRECTION, slide.direction);
      var currentIdx = self.getCurrentIndex();

      if (angular.isNumber(currentIdx) && slides[currentIdx].element) {
        slides[currentIdx].element.data(SLIDE_DIRECTION, slide.direction);
      }

      $scope.$currentTransition = true;
      $animate.on('addClass', slides[index].element, function(element, phase) {
        if (phase === 'close') {
          $scope.$currentTransition = null;
          $animate.off('addClass', element);
        }
      });
    }

    $scope.active = slide.index;
    currentIndex = slide.index;
    setActive(index);

    //every time you change slides, reset the timer
    restartTimer();
  }

  function findSlideIndex(slide) {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].slide === slide) {
        return i;
      }
    }
  }

  function resetTimer() {
    if (currentInterval) {
      $interval.cancel(currentInterval);
      currentInterval = null;
    }
  }

  function resetTransition(slides) {
    if (!slides.length) {
      $scope.$currentTransition = null;
    }
  }

  function restartTimer() {
    resetTimer();
    var interval = +$scope.interval;
    if (!isNaN(interval) && interval > 0) {
      currentInterval = $interval(timerFn, interval);
    }
  }

  function timerFn() {
    var interval = +$scope.interval;
    if (isPlaying && !isNaN(interval) && interval > 0 && slides.length) {
      $scope.next();
    } else {
      $scope.pause();
    }
  }
}])

.directive('uibCarousel', function() {
  return {
    transclude: true,
    controller: 'UibCarouselController',
    controllerAs: 'carousel',
    restrict: 'A',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/carousel/carousel.html';
    },
    scope: {
      active: '=',
      interval: '=',
      noTransition: '=',
      noPause: '=',
      noWrap: '&'
    }
  };
})

.directive('uibSlide', ['$animate', function($animate) {
  return {
    require: '^uibCarousel',
    restrict: 'A',
    transclude: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/carousel/slide.html';
    },
    scope: {
      actual: '=?',
      index: '=?'
    },
    link: function (scope, element, attrs, carouselCtrl) {
      element.addClass('item');
      carouselCtrl.addSlide(scope, element);
      //when the scope is destroyed then remove the slide from the current slides array
      scope.$on('$destroy', function() {
        carouselCtrl.removeSlide(scope);
      });

      scope.$watch('active', function(active) {
        $animate[active ? 'addClass' : 'removeClass'](element, 'active');
      });
    }
  };
}])

.animation('.item', ['$animateCss',
function($animateCss) {
  var SLIDE_DIRECTION = 'uib-slideDirection';

  function removeClass(element, className, callback) {
    element.removeClass(className);
    if (callback) {
      callback();
    }
  }

  return {
    beforeAddClass: function(element, className, done) {
      if (className === 'active') {
        var stopped = false;
        var direction = element.data(SLIDE_DIRECTION);
        var directionClass = direction === 'next' ? 'left' : 'right';
        var removeClassFn = removeClass.bind(this, element,
          directionClass + ' ' + direction, done);
        element.addClass(direction);

        $animateCss(element, {addClass: directionClass})
          .start()
          .done(removeClassFn);

        return function() {
          stopped = true;
        };
      }
      done();
    },
    beforeRemoveClass: function (element, className, done) {
      if (className === 'active') {
        var stopped = false;
        var direction = element.data(SLIDE_DIRECTION);
        var directionClass = direction === 'next' ? 'left' : 'right';
        var removeClassFn = removeClass.bind(this, element, directionClass, done);

        $animateCss(element, {addClass: directionClass})
          .start()
          .done(removeClassFn);

        return function() {
          stopped = true;
        };
      }
      done();
    }
  };
}]);

angular.module('ui.bootstrap.dateparser', [])

.service('uibDateParser', ['$log', '$locale', 'dateFilter', 'orderByFilter', 'filterFilter', function($log, $locale, dateFilter, orderByFilter, filterFilter) {
  // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
  var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;

  var localeId;
  var formatCodeToRegex;

  this.init = function() {
    localeId = $locale.id;

    this.parsers = {};
    this.formatters = {};

    formatCodeToRegex = [
      {
        key: 'yyyy',
        regex: '\\d{4}',
        apply: function(value) { this.year = +value; },
        formatter: function(date) {
          var _date = new Date();
          _date.setFullYear(Math.abs(date.getFullYear()));
          return dateFilter(_date, 'yyyy');
        }
      },
      {
        key: 'yy',
        regex: '\\d{2}',
        apply: function(value) { value = +value; this.year = value < 69 ? value + 2000 : value + 1900; },
        formatter: function(date) {
          var _date = new Date();
          _date.setFullYear(Math.abs(date.getFullYear()));
          return dateFilter(_date, 'yy');
        }
      },
      {
        key: 'y',
        regex: '\\d{1,4}',
        apply: function(value) { this.year = +value; },
        formatter: function(date) {
          var _date = new Date();
          _date.setFullYear(Math.abs(date.getFullYear()));
          return dateFilter(_date, 'y');
        }
      },
      {
        key: 'M!',
        regex: '0?[1-9]|1[0-2]',
        apply: function(value) { this.month = value - 1; },
        formatter: function(date) {
          var value = date.getMonth();
          if (/^[0-9]$/.test(value)) {
            return dateFilter(date, 'MM');
          }

          return dateFilter(date, 'M');
        }
      },
      {
        key: 'MMMM',
        regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
        apply: function(value) { this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value); },
        formatter: function(date) { return dateFilter(date, 'MMMM'); }
      },
      {
        key: 'MMM',
        regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
        apply: function(value) { this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value); },
        formatter: function(date) { return dateFilter(date, 'MMM'); }
      },
      {
        key: 'MM',
        regex: '0[1-9]|1[0-2]',
        apply: function(value) { this.month = value - 1; },
        formatter: function(date) { return dateFilter(date, 'MM'); }
      },
      {
        key: 'M',
        regex: '[1-9]|1[0-2]',
        apply: function(value) { this.month = value - 1; },
        formatter: function(date) { return dateFilter(date, 'M'); }
      },
      {
        key: 'd!',
        regex: '[0-2]?[0-9]{1}|3[0-1]{1}',
        apply: function(value) { this.date = +value; },
        formatter: function(date) {
          var value = date.getDate();
          if (/^[1-9]$/.test(value)) {
            return dateFilter(date, 'dd');
          }

          return dateFilter(date, 'd');
        }
      },
      {
        key: 'dd',
        regex: '[0-2][0-9]{1}|3[0-1]{1}',
        apply: function(value) { this.date = +value; },
        formatter: function(date) { return dateFilter(date, 'dd'); }
      },
      {
        key: 'd',
        regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
        apply: function(value) { this.date = +value; },
        formatter: function(date) { return dateFilter(date, 'd'); }
      },
      {
        key: 'EEEE',
        regex: $locale.DATETIME_FORMATS.DAY.join('|'),
        formatter: function(date) { return dateFilter(date, 'EEEE'); }
      },
      {
        key: 'EEE',
        regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|'),
        formatter: function(date) { return dateFilter(date, 'EEE'); }
      },
      {
        key: 'HH',
        regex: '(?:0|1)[0-9]|2[0-3]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'HH'); }
      },
      {
        key: 'hh',
        regex: '0[0-9]|1[0-2]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'hh'); }
      },
      {
        key: 'H',
        regex: '1?[0-9]|2[0-3]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'H'); }
      },
      {
        key: 'h',
        regex: '[0-9]|1[0-2]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'h'); }
      },
      {
        key: 'mm',
        regex: '[0-5][0-9]',
        apply: function(value) { this.minutes = +value; },
        formatter: function(date) { return dateFilter(date, 'mm'); }
      },
      {
        key: 'm',
        regex: '[0-9]|[1-5][0-9]',
        apply: function(value) { this.minutes = +value; },
        formatter: function(date) { return dateFilter(date, 'm'); }
      },
      {
        key: 'sss',
        regex: '[0-9][0-9][0-9]',
        apply: function(value) { this.milliseconds = +value; },
        formatter: function(date) { return dateFilter(date, 'sss'); }
      },
      {
        key: 'ss',
        regex: '[0-5][0-9]',
        apply: function(value) { this.seconds = +value; },
        formatter: function(date) { return dateFilter(date, 'ss'); }
      },
      {
        key: 's',
        regex: '[0-9]|[1-5][0-9]',
        apply: function(value) { this.seconds = +value; },
        formatter: function(date) { return dateFilter(date, 's'); }
      },
      {
        key: 'a',
        regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),
        apply: function(value) {
          if (this.hours === 12) {
            this.hours = 0;
          }

          if (value === 'PM') {
            this.hours += 12;
          }
        },
        formatter: function(date) { return dateFilter(date, 'a'); }
      },
      {
        key: 'Z',
        regex: '[+-]\\d{4}',
        apply: function(value) {
          var matches = value.match(/([+-])(\d{2})(\d{2})/),
            sign = matches[1],
            hours = matches[2],
            minutes = matches[3];
          this.hours += toInt(sign + hours);
          this.minutes += toInt(sign + minutes);
        },
        formatter: function(date) {
          return dateFilter(date, 'Z');
        }
      },
      {
        key: 'ww',
        regex: '[0-4][0-9]|5[0-3]',
        formatter: function(date) { return dateFilter(date, 'ww'); }
      },
      {
        key: 'w',
        regex: '[0-9]|[1-4][0-9]|5[0-3]',
        formatter: function(date) { return dateFilter(date, 'w'); }
      },
      {
        key: 'GGGG',
        regex: $locale.DATETIME_FORMATS.ERANAMES.join('|').replace(/\s/g, '\\s'),
        formatter: function(date) { return dateFilter(date, 'GGGG'); }
      },
      {
        key: 'GGG',
        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
        formatter: function(date) { return dateFilter(date, 'GGG'); }
      },
      {
        key: 'GG',
        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
        formatter: function(date) { return dateFilter(date, 'GG'); }
      },
      {
        key: 'G',
        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
        formatter: function(date) { return dateFilter(date, 'G'); }
      }
    ];

    if (angular.version.major >= 1 && angular.version.minor > 4) {
      formatCodeToRegex.push({
        key: 'LLLL',
        regex: $locale.DATETIME_FORMATS.STANDALONEMONTH.join('|'),
        apply: function(value) { this.month = $locale.DATETIME_FORMATS.STANDALONEMONTH.indexOf(value); },
        formatter: function(date) { return dateFilter(date, 'LLLL'); }
      });
    }
  };

  this.init();

  function getFormatCodeToRegex(key) {
    return filterFilter(formatCodeToRegex, {key: key}, true)[0];
  }

  this.getParser = function (key) {
    var f = getFormatCodeToRegex(key);
    return f && f.apply || null;
  };

  this.overrideParser = function (key, parser) {
    var f = getFormatCodeToRegex(key);
    if (f && angular.isFunction(parser)) {
      this.parsers = {};
      f.apply = parser;
    }
  }.bind(this);

  function createParser(format) {
    var map = [], regex = format.split('');

    // check for literal values
    var quoteIndex = format.indexOf('\'');
    if (quoteIndex > -1) {
      var inLiteral = false;
      format = format.split('');
      for (var i = quoteIndex; i < format.length; i++) {
        if (inLiteral) {
          if (format[i] === '\'') {
            if (i + 1 < format.length && format[i+1] === '\'') { // escaped single quote
              format[i+1] = '$';
              regex[i+1] = '';
            } else { // end of literal
              regex[i] = '';
              inLiteral = false;
            }
          }
          format[i] = '$';
        } else {
          if (format[i] === '\'') { // start of literal
            format[i] = '$';
            regex[i] = '';
            inLiteral = true;
          }
        }
      }

      format = format.join('');
    }

    angular.forEach(formatCodeToRegex, function(data) {
      var index = format.indexOf(data.key);

      if (index > -1) {
        format = format.split('');

        regex[index] = '(' + data.regex + ')';
        format[index] = '$'; // Custom symbol to define consumed part of format
        for (var i = index + 1, n = index + data.key.length; i < n; i++) {
          regex[i] = '';
          format[i] = '$';
        }
        format = format.join('');

        map.push({
          index: index,
          key: data.key,
          apply: data.apply,
          matcher: data.regex
        });
      }
    });

    return {
      regex: new RegExp('^' + regex.join('') + '$'),
      map: orderByFilter(map, 'index')
    };
  }

  function createFormatter(format) {
    var formatters = [];
    var i = 0;
    var formatter, literalIdx;
    while (i < format.length) {
      if (angular.isNumber(literalIdx)) {
        if (format.charAt(i) === '\'') {
          if (i + 1 >= format.length || format.charAt(i + 1) !== '\'') {
            formatters.push(constructLiteralFormatter(format, literalIdx, i));
            literalIdx = null;
          }
        } else if (i === format.length) {
          while (literalIdx < format.length) {
            formatter = constructFormatterFromIdx(format, literalIdx);
            formatters.push(formatter);
            literalIdx = formatter.endIdx;
          }
        }

        i++;
        continue;
      }

      if (format.charAt(i) === '\'') {
        literalIdx = i;
        i++;
        continue;
      }

      formatter = constructFormatterFromIdx(format, i);

      formatters.push(formatter.parser);
      i = formatter.endIdx;
    }

    return formatters;
  }

  function constructLiteralFormatter(format, literalIdx, endIdx) {
    return function() {
      return format.substr(literalIdx + 1, endIdx - literalIdx - 1);
    };
  }

  function constructFormatterFromIdx(format, i) {
    var currentPosStr = format.substr(i);
    for (var j = 0; j < formatCodeToRegex.length; j++) {
      if (new RegExp('^' + formatCodeToRegex[j].key).test(currentPosStr)) {
        var data = formatCodeToRegex[j];
        return {
          endIdx: i + data.key.length,
          parser: data.formatter
        };
      }
    }

    return {
      endIdx: i + 1,
      parser: function() {
        return currentPosStr.charAt(0);
      }
    };
  }

  this.filter = function(date, format) {
    if (!angular.isDate(date) || isNaN(date) || !format) {
      return '';
    }

    format = $locale.DATETIME_FORMATS[format] || format;

    if ($locale.id !== localeId) {
      this.init();
    }

    if (!this.formatters[format]) {
      this.formatters[format] = createFormatter(format);
    }

    var formatters = this.formatters[format];

    return formatters.reduce(function(str, formatter) {
      return str + formatter(date);
    }, '');
  };

  this.parse = function(input, format, baseDate) {
    if (!angular.isString(input) || !format) {
      return input;
    }

    format = $locale.DATETIME_FORMATS[format] || format;
    format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');

    if ($locale.id !== localeId) {
      this.init();
    }

    if (!this.parsers[format]) {
      this.parsers[format] = createParser(format, 'apply');
    }

    var parser = this.parsers[format],
        regex = parser.regex,
        map = parser.map,
        results = input.match(regex),
        tzOffset = false;
    if (results && results.length) {
      var fields, dt;
      if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
        fields = {
          year: baseDate.getFullYear(),
          month: baseDate.getMonth(),
          date: baseDate.getDate(),
          hours: baseDate.getHours(),
          minutes: baseDate.getMinutes(),
          seconds: baseDate.getSeconds(),
          milliseconds: baseDate.getMilliseconds()
        };
      } else {
        if (baseDate) {
          $log.warn('dateparser:', 'baseDate is not a valid date');
        }
        fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
      }

      for (var i = 1, n = results.length; i < n; i++) {
        var mapper = map[i - 1];
        if (mapper.matcher === 'Z') {
          tzOffset = true;
        }

        if (mapper.apply) {
          mapper.apply.call(fields, results[i]);
        }
      }

      var datesetter = tzOffset ? Date.prototype.setUTCFullYear :
        Date.prototype.setFullYear;
      var timesetter = tzOffset ? Date.prototype.setUTCHours :
        Date.prototype.setHours;

      if (isValid(fields.year, fields.month, fields.date)) {
        if (angular.isDate(baseDate) && !isNaN(baseDate.getTime()) && !tzOffset) {
          dt = new Date(baseDate);
          datesetter.call(dt, fields.year, fields.month, fields.date);
          timesetter.call(dt, fields.hours, fields.minutes,
            fields.seconds, fields.milliseconds);
        } else {
          dt = new Date(0);
          datesetter.call(dt, fields.year, fields.month, fields.date);
          timesetter.call(dt, fields.hours || 0, fields.minutes || 0,
            fields.seconds || 0, fields.milliseconds || 0);
        }
      }

      return dt;
    }
  };

  // Check if date is valid for specific month (and year for February).
  // Month: 0 = Jan, 1 = Feb, etc
  function isValid(year, month, date) {
    if (date < 1) {
      return false;
    }

    if (month === 1 && date > 28) {
      return date === 29 && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);
    }

    if (month === 3 || month === 5 || month === 8 || month === 10) {
      return date < 31;
    }

    return true;
  }

  function toInt(str) {
    return parseInt(str, 10);
  }

  this.toTimezone = toTimezone;
  this.fromTimezone = fromTimezone;
  this.timezoneToOffset = timezoneToOffset;
  this.addDateMinutes = addDateMinutes;
  this.convertTimezoneToLocal = convertTimezoneToLocal;

  function toTimezone(date, timezone) {
    return date && timezone ? convertTimezoneToLocal(date, timezone) : date;
  }

  function fromTimezone(date, timezone) {
    return date && timezone ? convertTimezoneToLocal(date, timezone, true) : date;
  }

  //https://github.com/angular/angular.js/blob/622c42169699ec07fc6daaa19fe6d224e5d2f70e/src/Angular.js#L1207
  function timezoneToOffset(timezone, fallback) {
    timezone = timezone.replace(/:/g, '');
    var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
    return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
  }

  function addDateMinutes(date, minutes) {
    date = new Date(date.getTime());
    date.setMinutes(date.getMinutes() + minutes);
    return date;
  }

  function convertTimezoneToLocal(date, timezone, reverse) {
    reverse = reverse ? -1 : 1;
    var dateTimezoneOffset = date.getTimezoneOffset();
    var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
    return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
  }
}]);

// Avoiding use of ng-class as it creates a lot of watchers when a class is to be applied to
// at most one element.
angular.module('ui.bootstrap.isClass', [])
.directive('uibIsClass', [
         '$animate',
function ($animate) {
  //                    11111111          22222222
  var ON_REGEXP = /^\s*([\s\S]+?)\s+on\s+([\s\S]+?)\s*$/;
  //                    11111111           22222222
  var IS_REGEXP = /^\s*([\s\S]+?)\s+for\s+([\s\S]+?)\s*$/;

  var dataPerTracked = {};

  return {
    restrict: 'A',
    compile: function(tElement, tAttrs) {
      var linkedScopes = [];
      var instances = [];
      var expToData = {};
      var lastActivated = null;
      var onExpMatches = tAttrs.uibIsClass.match(ON_REGEXP);
      var onExp = onExpMatches[2];
      var expsStr = onExpMatches[1];
      var exps = expsStr.split(',');

      return linkFn;

      function linkFn(scope, element, attrs) {
        linkedScopes.push(scope);
        instances.push({
          scope: scope,
          element: element
        });

        exps.forEach(function(exp, k) {
          addForExp(exp, scope);
        });

        scope.$on('$destroy', removeScope);
      }

      function addForExp(exp, scope) {
        var matches = exp.match(IS_REGEXP);
        var clazz = scope.$eval(matches[1]);
        var compareWithExp = matches[2];
        var data = expToData[exp];
        if (!data) {
          var watchFn = function(compareWithVal) {
            var newActivated = null;
            instances.some(function(instance) {
              var thisVal = instance.scope.$eval(onExp);
              if (thisVal === compareWithVal) {
                newActivated = instance;
                return true;
              }
            });
            if (data.lastActivated !== newActivated) {
              if (data.lastActivated) {
                $animate.removeClass(data.lastActivated.element, clazz);
              }
              if (newActivated) {
                $animate.addClass(newActivated.element, clazz);
              }
              data.lastActivated = newActivated;
            }
          };
          expToData[exp] = data = {
            lastActivated: null,
            scope: scope,
            watchFn: watchFn,
            compareWithExp: compareWithExp,
            watcher: scope.$watch(compareWithExp, watchFn)
          };
        }
        data.watchFn(scope.$eval(compareWithExp));
      }

      function removeScope(e) {
        var removedScope = e.targetScope;
        var index = linkedScopes.indexOf(removedScope);
        linkedScopes.splice(index, 1);
        instances.splice(index, 1);
        if (linkedScopes.length) {
          var newWatchScope = linkedScopes[0];
          angular.forEach(expToData, function(data) {
            if (data.scope === removedScope) {
              data.watcher = newWatchScope.$watch(data.compareWithExp, data.watchFn);
              data.scope = newWatchScope;
            }
          });
        } else {
          expToData = {};
        }
      }
    }
  };
}]);
angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.isClass'])

.value('$datepickerSuppressError', false)

.value('$datepickerLiteralWarning', true)

.constant('uibDatepickerConfig', {
  datepickerMode: 'day',
  formatDay: 'dd',
  formatMonth: 'MMMM',
  formatYear: 'yyyy',
  formatDayHeader: 'EEE',
  formatDayTitle: 'MMMM yyyy',
  formatMonthTitle: 'yyyy',
  maxDate: null,
  maxMode: 'year',
  minDate: null,
  minMode: 'day',
  monthColumns: 3,
  ngModelOptions: {},
  shortcutPropagation: false,
  showWeeks: true,
  yearColumns: 5,
  yearRows: 4
})

.controller('UibDatepickerController', ['$scope', '$element', '$attrs', '$parse', '$interpolate', '$locale', '$log', 'dateFilter', 'uibDatepickerConfig', '$datepickerLiteralWarning', '$datepickerSuppressError', 'uibDateParser',
  function($scope, $element, $attrs, $parse, $interpolate, $locale, $log, dateFilter, datepickerConfig, $datepickerLiteralWarning, $datepickerSuppressError, dateParser) {
  var self = this,
      ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl;
      ngModelOptions = {},
      watchListeners = [];

  $element.addClass('uib-datepicker');
  $attrs.$set('role', 'application');

  if (!$scope.datepickerOptions) {
    $scope.datepickerOptions = {};
  }

  // Modes chain
  this.modes = ['day', 'month', 'year'];

  [
    'customClass',
    'dateDisabled',
    'datepickerMode',
    'formatDay',
    'formatDayHeader',
    'formatDayTitle',
    'formatMonth',
    'formatMonthTitle',
    'formatYear',
    'maxDate',
    'maxMode',
    'minDate',
    'minMode',
    'monthColumns',
    'showWeeks',
    'shortcutPropagation',
    'startingDay',
    'yearColumns',
    'yearRows'
  ].forEach(function(key) {
    switch (key) {
      case 'customClass':
      case 'dateDisabled':
        $scope[key] = $scope.datepickerOptions[key] || angular.noop;
        break;
      case 'datepickerMode':
        $scope.datepickerMode = angular.isDefined($scope.datepickerOptions.datepickerMode) ?
          $scope.datepickerOptions.datepickerMode : datepickerConfig.datepickerMode;
        break;
      case 'formatDay':
      case 'formatDayHeader':
      case 'formatDayTitle':
      case 'formatMonth':
      case 'formatMonthTitle':
      case 'formatYear':
        self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
          $interpolate($scope.datepickerOptions[key])($scope.$parent) :
          datepickerConfig[key];
        break;
      case 'monthColumns':
      case 'showWeeks':
      case 'shortcutPropagation':
      case 'yearColumns':
      case 'yearRows':
        self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
          $scope.datepickerOptions[key] : datepickerConfig[key];
        break;
      case 'startingDay':
        if (angular.isDefined($scope.datepickerOptions.startingDay)) {
          self.startingDay = $scope.datepickerOptions.startingDay;
        } else if (angular.isNumber(datepickerConfig.startingDay)) {
          self.startingDay = datepickerConfig.startingDay;
        } else {
          self.startingDay = ($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7;
        }

        break;
      case 'maxDate':
      case 'minDate':
        $scope.$watch('datepickerOptions.' + key, function(value) {
          if (value) {
            if (angular.isDate(value)) {
              self[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.getOption('timezone'));
            } else {
              if ($datepickerLiteralWarning) {
                $log.warn('Literal date support has been deprecated, please switch to date object usage');
              }

              self[key] = new Date(dateFilter(value, 'medium'));
            }
          } else {
            self[key] = datepickerConfig[key] ?
              dateParser.fromTimezone(new Date(datepickerConfig[key]), ngModelOptions.getOption('timezone')) :
              null;
          }

          self.refreshView();
        });

        break;
      case 'maxMode':
      case 'minMode':
        if ($scope.datepickerOptions[key]) {
          $scope.$watch(function() { return $scope.datepickerOptions[key]; }, function(value) {
            self[key] = $scope[key] = angular.isDefined(value) ? value : $scope.datepickerOptions[key];
            if (key === 'minMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) < self.modes.indexOf(self[key]) ||
              key === 'maxMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) > self.modes.indexOf(self[key])) {
              $scope.datepickerMode = self[key];
              $scope.datepickerOptions.datepickerMode = self[key];
            }
          });
        } else {
          self[key] = $scope[key] = datepickerConfig[key] || null;
        }

        break;
    }
  });

  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);

  $scope.disabled = angular.isDefined($attrs.disabled) || false;
  if (angular.isDefined($attrs.ngDisabled)) {
    watchListeners.push($scope.$parent.$watch($attrs.ngDisabled, function(disabled) {
      $scope.disabled = disabled;
      self.refreshView();
    }));
  }

  $scope.isActive = function(dateObject) {
    if (self.compare(dateObject.date, self.activeDate) === 0) {
      $scope.activeDateId = dateObject.uid;
      return true;
    }
    return false;
  };

  this.init = function(ngModelCtrl_) {
    ngModelCtrl = ngModelCtrl_;
    ngModelOptions = extractOptions(ngModelCtrl);

    if ($scope.datepickerOptions.initDate) {
      self.activeDate = dateParser.fromTimezone($scope.datepickerOptions.initDate, ngModelOptions.getOption('timezone')) || new Date();
      $scope.$watch('datepickerOptions.initDate', function(initDate) {
        if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
          self.activeDate = dateParser.fromTimezone(initDate, ngModelOptions.getOption('timezone'));
          self.refreshView();
        }
      });
    } else {
      self.activeDate = new Date();
    }

    var date = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : new Date();
    this.activeDate = !isNaN(date) ?
      dateParser.fromTimezone(date, ngModelOptions.getOption('timezone')) :
      dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));

    ngModelCtrl.$render = function() {
      self.render();
    };
  };

  this.render = function() {
    if (ngModelCtrl.$viewValue) {
      var date = new Date(ngModelCtrl.$viewValue),
          isValid = !isNaN(date);

      if (isValid) {
        this.activeDate = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
      } else if (!$datepickerSuppressError) {
        $log.error('Datepicker directive: "ng-model" value must be a Date object');
      }
    }
    this.refreshView();
  };

  this.refreshView = function() {
    if (this.element) {
      $scope.selectedDt = null;
      this._refreshView();
      if ($scope.activeDt) {
        $scope.activeDateId = $scope.activeDt.uid;
      }

      var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
      date = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
      ngModelCtrl.$setValidity('dateDisabled', !date ||
        this.element && !this.isDisabled(date));
    }
  };

  this.createDateObject = function(date, format) {
    var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
    model = dateParser.fromTimezone(model, ngModelOptions.getOption('timezone'));
    var today = new Date();
    today = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
    var time = this.compare(date, today);
    var dt = {
      date: date,
      label: dateParser.filter(date, format),
      selected: model && this.compare(date, model) === 0,
      disabled: this.isDisabled(date),
      past: time < 0,
      current: time === 0,
      future: time > 0,
      customClass: this.customClass(date) || null
    };

    if (model && this.compare(date, model) === 0) {
      $scope.selectedDt = dt;
    }

    if (self.activeDate && this.compare(dt.date, self.activeDate) === 0) {
      $scope.activeDt = dt;
    }

    return dt;
  };

  this.isDisabled = function(date) {
    return $scope.disabled ||
      this.minDate && this.compare(date, this.minDate) < 0 ||
      this.maxDate && this.compare(date, this.maxDate) > 0 ||
      $scope.dateDisabled && $scope.dateDisabled({date: date, mode: $scope.datepickerMode});
  };

  this.customClass = function(date) {
    return $scope.customClass({date: date, mode: $scope.datepickerMode});
  };

  // Split array into smaller arrays
  this.split = function(arr, size) {
    var arrays = [];
    while (arr.length > 0) {
      arrays.push(arr.splice(0, size));
    }
    return arrays;
  };

  $scope.select = function(date) {
    if ($scope.datepickerMode === self.minMode) {
      var dt = ngModelCtrl.$viewValue ? dateParser.fromTimezone(new Date(ngModelCtrl.$viewValue), ngModelOptions.getOption('timezone')) : new Date(0, 0, 0, 0, 0, 0, 0);
      dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
      dt = dateParser.toTimezone(dt, ngModelOptions.getOption('timezone'));
      ngModelCtrl.$setViewValue(dt);
      ngModelCtrl.$render();
    } else {
      self.activeDate = date;
      setMode(self.modes[self.modes.indexOf($scope.datepickerMode) - 1]);

      $scope.$emit('uib:datepicker.mode');
    }

    $scope.$broadcast('uib:datepicker.focus');
  };

  $scope.move = function(direction) {
    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
        month = self.activeDate.getMonth() + direction * (self.step.months || 0);
    self.activeDate.setFullYear(year, month, 1);
    self.refreshView();
  };

  $scope.toggleMode = function(direction) {
    direction = direction || 1;

    if ($scope.datepickerMode === self.maxMode && direction === 1 ||
      $scope.datepickerMode === self.minMode && direction === -1) {
      return;
    }

    setMode(self.modes[self.modes.indexOf($scope.datepickerMode) + direction]);

    $scope.$emit('uib:datepicker.mode');
  };

  // Key event mapper
  $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };

  var focusElement = function() {
    self.element[0].focus();
  };

  // Listen for focus requests from popup directive
  $scope.$on('uib:datepicker.focus', focusElement);

  $scope.keydown = function(evt) {
    var key = $scope.keys[evt.which];

    if (!key || evt.shiftKey || evt.altKey || $scope.disabled) {
      return;
    }

    evt.preventDefault();
    if (!self.shortcutPropagation) {
      evt.stopPropagation();
    }

    if (key === 'enter' || key === 'space') {
      if (self.isDisabled(self.activeDate)) {
        return; // do nothing
      }
      $scope.select(self.activeDate);
    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
      $scope.toggleMode(key === 'up' ? 1 : -1);
    } else {
      self.handleKeyDown(key, evt);
      self.refreshView();
    }
  };

  $element.on('keydown', function(evt) {
    $scope.$apply(function() {
      $scope.keydown(evt);
    });
  });

  $scope.$on('$destroy', function() {
    //Clear all watch listeners on destroy
    while (watchListeners.length) {
      watchListeners.shift()();
    }
  });

  function setMode(mode) {
    $scope.datepickerMode = mode;
    $scope.datepickerOptions.datepickerMode = mode;
  }

  function extractOptions(ngModelCtrl) {
    var ngModelOptions;

    if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
      // guarantee a value
      ngModelOptions = ngModelCtrl.$options ||
        $scope.datepickerOptions.ngModelOptions ||
        datepickerConfig.ngModelOptions ||
        {};

      // mimic 1.6+ api
      ngModelOptions.getOption = function (key) {
        return ngModelOptions[key];
      };
    } else { // in angular >=1.6 $options is always present
      // ng-model-options defaults timezone to null; don't let its precedence squash a non-null value
      var timezone = ngModelCtrl.$options.getOption('timezone') ||
        ($scope.datepickerOptions.ngModelOptions ? $scope.datepickerOptions.ngModelOptions.timezone : null) ||
        (datepickerConfig.ngModelOptions ? datepickerConfig.ngModelOptions.timezone : null);

      // values passed to createChild override existing values
      ngModelOptions = ngModelCtrl.$options // start with a ModelOptions instance
        .createChild(datepickerConfig.ngModelOptions) // lowest precedence
        .createChild($scope.datepickerOptions.ngModelOptions)
        .createChild(ngModelCtrl.$options) // highest precedence
        .createChild({timezone: timezone}); // to keep from squashing a non-null value
    }

    return ngModelOptions;
  }
}])

.controller('UibDaypickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
  var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  this.step = { months: 1 };
  this.element = $element;
  function getDaysInMonth(year, month) {
    return month === 1 && year % 4 === 0 &&
      (year % 100 !== 0 || year % 400 === 0) ? 29 : DAYS_IN_MONTH[month];
  }

  this.init = function(ctrl) {
    angular.extend(ctrl, this);
    scope.showWeeks = ctrl.showWeeks;
    ctrl.refreshView();
  };

  this.getDates = function(startDate, n) {
    var dates = new Array(n), current = new Date(startDate), i = 0, date;
    while (i < n) {
      date = new Date(current);
      dates[i++] = date;
      current.setDate(current.getDate() + 1);
    }
    return dates;
  };

  this._refreshView = function() {
    var year = this.activeDate.getFullYear(),
      month = this.activeDate.getMonth(),
      firstDayOfMonth = new Date(this.activeDate);

    firstDayOfMonth.setFullYear(year, month, 1);

    var difference = this.startingDay - firstDayOfMonth.getDay(),
      numDisplayedFromPreviousMonth = difference > 0 ?
        7 - difference : - difference,
      firstDate = new Date(firstDayOfMonth);

    if (numDisplayedFromPreviousMonth > 0) {
      firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
    }

    // 42 is the number of days on a six-week calendar
    var days = this.getDates(firstDate, 42);
    for (var i = 0; i < 42; i ++) {
      days[i] = angular.extend(this.createDateObject(days[i], this.formatDay), {
        secondary: days[i].getMonth() !== month,
        uid: scope.uniqueId + '-' + i
      });
    }

    scope.labels = new Array(7);
    for (var j = 0; j < 7; j++) {
      scope.labels[j] = {
        abbr: dateFilter(days[j].date, this.formatDayHeader),
        full: dateFilter(days[j].date, 'EEEE')
      };
    }

    scope.title = dateFilter(this.activeDate, this.formatDayTitle);
    scope.rows = this.split(days, 7);

    if (scope.showWeeks) {
      scope.weekNumbers = [];
      var thursdayIndex = (4 + 7 - this.startingDay) % 7,
          numWeeks = scope.rows.length;
      for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
        scope.weekNumbers.push(
          getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
      }
    }
  };

  this.compare = function(date1, date2) {
    var _date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    var _date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
    _date1.setFullYear(date1.getFullYear());
    _date2.setFullYear(date2.getFullYear());
    return _date1 - _date2;
  };

  function getISO8601WeekNumber(date) {
    var checkDate = new Date(date);
    checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
    var time = checkDate.getTime();
    checkDate.setMonth(0); // Compare with Jan 1
    checkDate.setDate(1);
    return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
  }

  this.handleKeyDown = function(key, evt) {
    var date = this.activeDate.getDate();

    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - 7;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + 7;
    } else if (key === 'pageup' || key === 'pagedown') {
      var month = this.activeDate.getMonth() + (key === 'pageup' ? - 1 : 1);
      this.activeDate.setMonth(month, 1);
      date = Math.min(getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth()), date);
    } else if (key === 'home') {
      date = 1;
    } else if (key === 'end') {
      date = getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth());
    }
    this.activeDate.setDate(date);
  };
}])

.controller('UibMonthpickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
  this.step = { years: 1 };
  this.element = $element;

  this.init = function(ctrl) {
    angular.extend(ctrl, this);
    ctrl.refreshView();
  };

  this._refreshView = function() {
    var months = new Array(12),
        year = this.activeDate.getFullYear(),
        date;

    for (var i = 0; i < 12; i++) {
      date = new Date(this.activeDate);
      date.setFullYear(year, i, 1);
      months[i] = angular.extend(this.createDateObject(date, this.formatMonth), {
        uid: scope.uniqueId + '-' + i
      });
    }

    scope.title = dateFilter(this.activeDate, this.formatMonthTitle);
    scope.rows = this.split(months, this.monthColumns);
    scope.yearHeaderColspan = this.monthColumns > 3 ? this.monthColumns - 2 : 1;
  };

  this.compare = function(date1, date2) {
    var _date1 = new Date(date1.getFullYear(), date1.getMonth());
    var _date2 = new Date(date2.getFullYear(), date2.getMonth());
    _date1.setFullYear(date1.getFullYear());
    _date2.setFullYear(date2.getFullYear());
    return _date1 - _date2;
  };

  this.handleKeyDown = function(key, evt) {
    var date = this.activeDate.getMonth();

    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - this.monthColumns;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + this.monthColumns;
    } else if (key === 'pageup' || key === 'pagedown') {
      var year = this.activeDate.getFullYear() + (key === 'pageup' ? - 1 : 1);
      this.activeDate.setFullYear(year);
    } else if (key === 'home') {
      date = 0;
    } else if (key === 'end') {
      date = 11;
    }
    this.activeDate.setMonth(date);
  };
}])

.controller('UibYearpickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
  var columns, range;
  this.element = $element;

  function getStartingYear(year) {
    return parseInt((year - 1) / range, 10) * range + 1;
  }

  this.yearpickerInit = function() {
    columns = this.yearColumns;
    range = this.yearRows * columns;
    this.step = { years: range };
  };

  this._refreshView = function() {
    var years = new Array(range), date;

    for (var i = 0, start = getStartingYear(this.activeDate.getFullYear()); i < range; i++) {
      date = new Date(this.activeDate);
      date.setFullYear(start + i, 0, 1);
      years[i] = angular.extend(this.createDateObject(date, this.formatYear), {
        uid: scope.uniqueId + '-' + i
      });
    }

    scope.title = [years[0].label, years[range - 1].label].join(' - ');
    scope.rows = this.split(years, columns);
    scope.columns = columns;
  };

  this.compare = function(date1, date2) {
    return date1.getFullYear() - date2.getFullYear();
  };

  this.handleKeyDown = function(key, evt) {
    var date = this.activeDate.getFullYear();

    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - columns;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + columns;
    } else if (key === 'pageup' || key === 'pagedown') {
      date += (key === 'pageup' ? - 1 : 1) * range;
    } else if (key === 'home') {
      date = getStartingYear(this.activeDate.getFullYear());
    } else if (key === 'end') {
      date = getStartingYear(this.activeDate.getFullYear()) + range - 1;
    }
    this.activeDate.setFullYear(date);
  };
}])

.directive('uibDatepicker', function() {
  return {
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/datepicker.html';
    },
    scope: {
      datepickerOptions: '=?'
    },
    require: ['uibDatepicker', '^ngModel'],
    restrict: 'A',
    controller: 'UibDatepickerController',
    controllerAs: 'datepicker',
    link: function(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      datepickerCtrl.init(ngModelCtrl);
    }
  };
})

.directive('uibDaypicker', function() {
  return {
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/day.html';
    },
    require: ['^uibDatepicker', 'uibDaypicker'],
    restrict: 'A',
    controller: 'UibDaypickerController',
    link: function(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0],
        daypickerCtrl = ctrls[1];

      daypickerCtrl.init(datepickerCtrl);
    }
  };
})

.directive('uibMonthpicker', function() {
  return {
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/month.html';
    },
    require: ['^uibDatepicker', 'uibMonthpicker'],
    restrict: 'A',
    controller: 'UibMonthpickerController',
    link: function(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0],
        monthpickerCtrl = ctrls[1];

      monthpickerCtrl.init(datepickerCtrl);
    }
  };
})

.directive('uibYearpicker', function() {
  return {
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/year.html';
    },
    require: ['^uibDatepicker', 'uibYearpicker'],
    restrict: 'A',
    controller: 'UibYearpickerController',
    link: function(scope, element, attrs, ctrls) {
      var ctrl = ctrls[0];
      angular.extend(ctrl, ctrls[1]);
      ctrl.yearpickerInit();

      ctrl.refreshView();
    }
  };
});

angular.module('ui.bootstrap.position', [])

/**
 * A set of utility methods for working with the DOM.
 * It is meant to be used where we need to absolute-position elements in
 * relation to another element (this is the case for tooltips, popovers,
 * typeahead suggestions etc.).
 */
  .factory('$uibPosition', ['$document', '$window', function($document, $window) {
    /**
     * Used by scrollbarWidth() function to cache scrollbar's width.
     * Do not access this variable directly, use scrollbarWidth() instead.
     */
    var SCROLLBAR_WIDTH;
    /**
     * scrollbar on body and html element in IE and Edge overlay
     * content and should be considered 0 width.
     */
    var BODY_SCROLLBAR_WIDTH;
    var OVERFLOW_REGEX = {
      normal: /(auto|scroll)/,
      hidden: /(auto|scroll|hidden)/
    };
    var PLACEMENT_REGEX = {
      auto: /\s?auto?\s?/i,
      primary: /^(top|bottom|left|right)$/,
      secondary: /^(top|bottom|left|right|center)$/,
      vertical: /^(top|bottom)$/
    };
    var BODY_REGEX = /(HTML|BODY)/;

    return {

      /**
       * Provides a raw DOM element from a jQuery/jQLite element.
       *
       * @param {element} elem - The element to convert.
       *
       * @returns {element} A HTML element.
       */
      getRawNode: function(elem) {
        return elem.nodeName ? elem : elem[0] || elem;
      },

      /**
       * Provides a parsed number for a style property.  Strips
       * units and casts invalid numbers to 0.
       *
       * @param {string} value - The style value to parse.
       *
       * @returns {number} A valid number.
       */
      parseStyle: function(value) {
        value = parseFloat(value);
        return isFinite(value) ? value : 0;
      },

      /**
       * Provides the closest positioned ancestor.
       *
       * @param {element} element - The element to get the offest parent for.
       *
       * @returns {element} The closest positioned ancestor.
       */
      offsetParent: function(elem) {
        elem = this.getRawNode(elem);

        var offsetParent = elem.offsetParent || $document[0].documentElement;

        function isStaticPositioned(el) {
          return ($window.getComputedStyle(el).position || 'static') === 'static';
        }

        while (offsetParent && offsetParent !== $document[0].documentElement && isStaticPositioned(offsetParent)) {
          offsetParent = offsetParent.offsetParent;
        }

        return offsetParent || $document[0].documentElement;
      },

      /**
       * Provides the scrollbar width, concept from TWBS measureScrollbar()
       * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
       * In IE and Edge, scollbar on body and html element overlay and should
       * return a width of 0.
       *
       * @returns {number} The width of the browser scollbar.
       */
      scrollbarWidth: function(isBody) {
        if (isBody) {
          if (angular.isUndefined(BODY_SCROLLBAR_WIDTH)) {
            var bodyElem = $document.find('body');
            bodyElem.addClass('uib-position-body-scrollbar-measure');
            BODY_SCROLLBAR_WIDTH = $window.innerWidth - bodyElem[0].clientWidth;
            BODY_SCROLLBAR_WIDTH = isFinite(BODY_SCROLLBAR_WIDTH) ? BODY_SCROLLBAR_WIDTH : 0;
            bodyElem.removeClass('uib-position-body-scrollbar-measure');
          }
          return BODY_SCROLLBAR_WIDTH;
        }

        if (angular.isUndefined(SCROLLBAR_WIDTH)) {
          var scrollElem = angular.element('<div class="uib-position-scrollbar-measure"></div>');
          $document.find('body').append(scrollElem);
          SCROLLBAR_WIDTH = scrollElem[0].offsetWidth - scrollElem[0].clientWidth;
          SCROLLBAR_WIDTH = isFinite(SCROLLBAR_WIDTH) ? SCROLLBAR_WIDTH : 0;
          scrollElem.remove();
        }

        return SCROLLBAR_WIDTH;
      },

      /**
       * Provides the padding required on an element to replace the scrollbar.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**scrollbarWidth**: the width of the scrollbar</li>
       *     <li>**widthOverflow**: whether the the width is overflowing</li>
       *     <li>**right**: the amount of right padding on the element needed to replace the scrollbar</li>
       *     <li>**rightOriginal**: the amount of right padding currently on the element</li>
       *     <li>**heightOverflow**: whether the the height is overflowing</li>
       *     <li>**bottom**: the amount of bottom padding on the element needed to replace the scrollbar</li>
       *     <li>**bottomOriginal**: the amount of bottom padding currently on the element</li>
       *   </ul>
       */
      scrollbarPadding: function(elem) {
        elem = this.getRawNode(elem);

        var elemStyle = $window.getComputedStyle(elem);
        var paddingRight = this.parseStyle(elemStyle.paddingRight);
        var paddingBottom = this.parseStyle(elemStyle.paddingBottom);
        var scrollParent = this.scrollParent(elem, false, true);
        var scrollbarWidth = this.scrollbarWidth(BODY_REGEX.test(scrollParent.tagName));

        return {
          scrollbarWidth: scrollbarWidth,
          widthOverflow: scrollParent.scrollWidth > scrollParent.clientWidth,
          right: paddingRight + scrollbarWidth,
          originalRight: paddingRight,
          heightOverflow: scrollParent.scrollHeight > scrollParent.clientHeight,
          bottom: paddingBottom + scrollbarWidth,
          originalBottom: paddingBottom
         };
      },

      /**
       * Checks to see if the element is scrollable.
       *
       * @param {element} elem - The element to check.
       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
       *   default is false.
       *
       * @returns {boolean} Whether the element is scrollable.
       */
      isScrollable: function(elem, includeHidden) {
        elem = this.getRawNode(elem);

        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
        var elemStyle = $window.getComputedStyle(elem);
        return overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX);
      },

      /**
       * Provides the closest scrollable ancestor.
       * A port of the jQuery UI scrollParent method:
       * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
       *
       * @param {element} elem - The element to find the scroll parent of.
       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
       *   default is false.
       * @param {boolean=} [includeSelf=false] - Should the element being passed be
       * included in the scrollable llokup.
       *
       * @returns {element} A HTML element.
       */
      scrollParent: function(elem, includeHidden, includeSelf) {
        elem = this.getRawNode(elem);

        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
        var documentEl = $document[0].documentElement;
        var elemStyle = $window.getComputedStyle(elem);
        if (includeSelf && overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX)) {
          return elem;
        }
        var excludeStatic = elemStyle.position === 'absolute';
        var scrollParent = elem.parentElement || documentEl;

        if (scrollParent === documentEl || elemStyle.position === 'fixed') {
          return documentEl;
        }

        while (scrollParent.parentElement && scrollParent !== documentEl) {
          var spStyle = $window.getComputedStyle(scrollParent);
          if (excludeStatic && spStyle.position !== 'static') {
            excludeStatic = false;
          }

          if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {
            break;
          }
          scrollParent = scrollParent.parentElement;
        }

        return scrollParent;
      },

      /**
       * Provides read-only equivalent of jQuery's position function:
       * http://api.jquery.com/position/ - distance to closest positioned
       * ancestor.  Does not account for margins by default like jQuery position.
       *
       * @param {element} elem - The element to caclulate the position on.
       * @param {boolean=} [includeMargins=false] - Should margins be accounted
       * for, default is false.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**width**: the width of the element</li>
       *     <li>**height**: the height of the element</li>
       *     <li>**top**: distance to top edge of offset parent</li>
       *     <li>**left**: distance to left edge of offset parent</li>
       *   </ul>
       */
      position: function(elem, includeMagins) {
        elem = this.getRawNode(elem);

        var elemOffset = this.offset(elem);
        if (includeMagins) {
          var elemStyle = $window.getComputedStyle(elem);
          elemOffset.top -= this.parseStyle(elemStyle.marginTop);
          elemOffset.left -= this.parseStyle(elemStyle.marginLeft);
        }
        var parent = this.offsetParent(elem);
        var parentOffset = {top: 0, left: 0};

        if (parent !== $document[0].documentElement) {
          parentOffset = this.offset(parent);
          parentOffset.top += parent.clientTop - parent.scrollTop;
          parentOffset.left += parent.clientLeft - parent.scrollLeft;
        }

        return {
          width: Math.round(angular.isNumber(elemOffset.width) ? elemOffset.width : elem.offsetWidth),
          height: Math.round(angular.isNumber(elemOffset.height) ? elemOffset.height : elem.offsetHeight),
          top: Math.round(elemOffset.top - parentOffset.top),
          left: Math.round(elemOffset.left - parentOffset.left)
        };
      },

      /**
       * Provides read-only equivalent of jQuery's offset function:
       * http://api.jquery.com/offset/ - distance to viewport.  Does
       * not account for borders, margins, or padding on the body
       * element.
       *
       * @param {element} elem - The element to calculate the offset on.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**width**: the width of the element</li>
       *     <li>**height**: the height of the element</li>
       *     <li>**top**: distance to top edge of viewport</li>
       *     <li>**right**: distance to bottom edge of viewport</li>
       *   </ul>
       */
      offset: function(elem) {
        elem = this.getRawNode(elem);

        var elemBCR = elem.getBoundingClientRect();
        return {
          width: Math.round(angular.isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),
          height: Math.round(angular.isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),
          top: Math.round(elemBCR.top + ($window.pageYOffset || $document[0].documentElement.scrollTop)),
          left: Math.round(elemBCR.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft))
        };
      },

      /**
       * Provides offset distance to the closest scrollable ancestor
       * or viewport.  Accounts for border and scrollbar width.
       *
       * Right and bottom dimensions represent the distance to the
       * respective edge of the viewport element.  If the element
       * edge extends beyond the viewport, a negative value will be
       * reported.
       *
       * @param {element} elem - The element to get the viewport offset for.
       * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
       * of the first scrollable element, default is false.
       * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
       * be accounted for, default is true.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**top**: distance to the top content edge of viewport element</li>
       *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
       *     <li>**left**: distance to the left content edge of viewport element</li>
       *     <li>**right**: distance to the right content edge of viewport element</li>
       *   </ul>
       */
      viewportOffset: function(elem, useDocument, includePadding) {
        elem = this.getRawNode(elem);
        includePadding = includePadding !== false ? true : false;

        var elemBCR = elem.getBoundingClientRect();
        var offsetBCR = {top: 0, left: 0, bottom: 0, right: 0};

        var offsetParent = useDocument ? $document[0].documentElement : this.scrollParent(elem);
        var offsetParentBCR = offsetParent.getBoundingClientRect();

        offsetBCR.top = offsetParentBCR.top + offsetParent.clientTop;
        offsetBCR.left = offsetParentBCR.left + offsetParent.clientLeft;
        if (offsetParent === $document[0].documentElement) {
          offsetBCR.top += $window.pageYOffset;
          offsetBCR.left += $window.pageXOffset;
        }
        offsetBCR.bottom = offsetBCR.top + offsetParent.clientHeight;
        offsetBCR.right = offsetBCR.left + offsetParent.clientWidth;

        if (includePadding) {
          var offsetParentStyle = $window.getComputedStyle(offsetParent);
          offsetBCR.top += this.parseStyle(offsetParentStyle.paddingTop);
          offsetBCR.bottom -= this.parseStyle(offsetParentStyle.paddingBottom);
          offsetBCR.left += this.parseStyle(offsetParentStyle.paddingLeft);
          offsetBCR.right -= this.parseStyle(offsetParentStyle.paddingRight);
        }

        return {
          top: Math.round(elemBCR.top - offsetBCR.top),
          bottom: Math.round(offsetBCR.bottom - elemBCR.bottom),
          left: Math.round(elemBCR.left - offsetBCR.left),
          right: Math.round(offsetBCR.right - elemBCR.right)
        };
      },

      /**
       * Provides an array of placement values parsed from a placement string.
       * Along with the 'auto' indicator, supported placement strings are:
       *   <ul>
       *     <li>top: element on top, horizontally centered on host element.</li>
       *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
       *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
       *     <li>bottom: element on bottom, horizontally centered on host element.</li>
       *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
       *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
       *     <li>left: element on left, vertically centered on host element.</li>
       *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
       *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
       *     <li>right: element on right, vertically centered on host element.</li>
       *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
       *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
       *   </ul>
       * A placement string with an 'auto' indicator is expected to be
       * space separated from the placement, i.e: 'auto bottom-left'  If
       * the primary and secondary placement values do not match 'top,
       * bottom, left, right' then 'top' will be the primary placement and
       * 'center' will be the secondary placement.  If 'auto' is passed, true
       * will be returned as the 3rd value of the array.
       *
       * @param {string} placement - The placement string to parse.
       *
       * @returns {array} An array with the following values
       * <ul>
       *   <li>**[0]**: The primary placement.</li>
       *   <li>**[1]**: The secondary placement.</li>
       *   <li>**[2]**: If auto is passed: true, else undefined.</li>
       * </ul>
       */
      parsePlacement: function(placement) {
        var autoPlace = PLACEMENT_REGEX.auto.test(placement);
        if (autoPlace) {
          placement = placement.replace(PLACEMENT_REGEX.auto, '');
        }

        placement = placement.split('-');

        placement[0] = placement[0] || 'top';
        if (!PLACEMENT_REGEX.primary.test(placement[0])) {
          placement[0] = 'top';
        }

        placement[1] = placement[1] || 'center';
        if (!PLACEMENT_REGEX.secondary.test(placement[1])) {
          placement[1] = 'center';
        }

        if (autoPlace) {
          placement[2] = true;
        } else {
          placement[2] = false;
        }

        return placement;
      },

      /**
       * Provides coordinates for an element to be positioned relative to
       * another element.  Passing 'auto' as part of the placement parameter
       * will enable smart placement - where the element fits. i.e:
       * 'auto left-top' will check to see if there is enough space to the left
       * of the hostElem to fit the targetElem, if not place right (same for secondary
       * top placement).  Available space is calculated using the viewportOffset
       * function.
       *
       * @param {element} hostElem - The element to position against.
       * @param {element} targetElem - The element to position.
       * @param {string=} [placement=top] - The placement for the targetElem,
       *   default is 'top'. 'center' is assumed as secondary placement for
       *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
       *   <ul>
       *     <li>top</li>
       *     <li>top-right</li>
       *     <li>top-left</li>
       *     <li>bottom</li>
       *     <li>bottom-left</li>
       *     <li>bottom-right</li>
       *     <li>left</li>
       *     <li>left-top</li>
       *     <li>left-bottom</li>
       *     <li>right</li>
       *     <li>right-top</li>
       *     <li>right-bottom</li>
       *   </ul>
       * @param {boolean=} [appendToBody=false] - Should the top and left values returned
       *   be calculated from the body element, default is false.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**top**: Value for targetElem top.</li>
       *     <li>**left**: Value for targetElem left.</li>
       *     <li>**placement**: The resolved placement.</li>
       *   </ul>
       */
      positionElements: function(hostElem, targetElem, placement, appendToBody) {
        hostElem = this.getRawNode(hostElem);
        targetElem = this.getRawNode(targetElem);

        // need to read from prop to support tests.
        var targetWidth = angular.isDefined(targetElem.offsetWidth) ? targetElem.offsetWidth : targetElem.prop('offsetWidth');
        var targetHeight = angular.isDefined(targetElem.offsetHeight) ? targetElem.offsetHeight : targetElem.prop('offsetHeight');

        placement = this.parsePlacement(placement);

        var hostElemPos = appendToBody ? this.offset(hostElem) : this.position(hostElem);
        var targetElemPos = {top: 0, left: 0, placement: ''};

        if (placement[2]) {
          var viewportOffset = this.viewportOffset(hostElem, appendToBody);

          var targetElemStyle = $window.getComputedStyle(targetElem);
          var adjustedSize = {
            width: targetWidth + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft) + this.parseStyle(targetElemStyle.marginRight))),
            height: targetHeight + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop) + this.parseStyle(targetElemStyle.marginBottom)))
          };

          placement[0] = placement[0] === 'top' && adjustedSize.height > viewportOffset.top && adjustedSize.height <= viewportOffset.bottom ? 'bottom' :
                         placement[0] === 'bottom' && adjustedSize.height > viewportOffset.bottom && adjustedSize.height <= viewportOffset.top ? 'top' :
                         placement[0] === 'left' && adjustedSize.width > viewportOffset.left && adjustedSize.width <= viewportOffset.right ? 'right' :
                         placement[0] === 'right' && adjustedSize.width > viewportOffset.right && adjustedSize.width <= viewportOffset.left ? 'left' :
                         placement[0];

          placement[1] = placement[1] === 'top' && adjustedSize.height - hostElemPos.height > viewportOffset.bottom && adjustedSize.height - hostElemPos.height <= viewportOffset.top ? 'bottom' :
                         placement[1] === 'bottom' && adjustedSize.height - hostElemPos.height > viewportOffset.top && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom ? 'top' :
                         placement[1] === 'left' && adjustedSize.width - hostElemPos.width > viewportOffset.right && adjustedSize.width - hostElemPos.width <= viewportOffset.left ? 'right' :
                         placement[1] === 'right' && adjustedSize.width - hostElemPos.width > viewportOffset.left && adjustedSize.width - hostElemPos.width <= viewportOffset.right ? 'left' :
                         placement[1];

          if (placement[1] === 'center') {
            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
              var xOverflow = hostElemPos.width / 2 - targetWidth / 2;
              if (viewportOffset.left + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.right) {
                placement[1] = 'left';
              } else if (viewportOffset.right + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.left) {
                placement[1] = 'right';
              }
            } else {
              var yOverflow = hostElemPos.height / 2 - adjustedSize.height / 2;
              if (viewportOffset.top + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom) {
                placement[1] = 'top';
              } else if (viewportOffset.bottom + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.top) {
                placement[1] = 'bottom';
              }
            }
          }
        }

        switch (placement[0]) {
          case 'top':
            targetElemPos.top = hostElemPos.top - targetHeight;
            break;
          case 'bottom':
            targetElemPos.top = hostElemPos.top + hostElemPos.height;
            break;
          case 'left':
            targetElemPos.left = hostElemPos.left - targetWidth;
            break;
          case 'right':
            targetElemPos.left = hostElemPos.left + hostElemPos.width;
            break;
        }

        switch (placement[1]) {
          case 'top':
            targetElemPos.top = hostElemPos.top;
            break;
          case 'bottom':
            targetElemPos.top = hostElemPos.top + hostElemPos.height - targetHeight;
            break;
          case 'left':
            targetElemPos.left = hostElemPos.left;
            break;
          case 'right':
            targetElemPos.left = hostElemPos.left + hostElemPos.width - targetWidth;
            break;
          case 'center':
            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
              targetElemPos.left = hostElemPos.left + hostElemPos.width / 2 - targetWidth / 2;
            } else {
              targetElemPos.top = hostElemPos.top + hostElemPos.height / 2 - targetHeight / 2;
            }
            break;
        }

        targetElemPos.top = Math.round(targetElemPos.top);
        targetElemPos.left = Math.round(targetElemPos.left);
        targetElemPos.placement = placement[1] === 'center' ? placement[0] : placement[0] + '-' + placement[1];

        return targetElemPos;
      },

      /**
       * Provides a way to adjust the top positioning after first
       * render to correctly align element to top after content
       * rendering causes resized element height
       *
       * @param {array} placementClasses - The array of strings of classes
       * element should have.
       * @param {object} containerPosition - The object with container
       * position information
       * @param {number} initialHeight - The initial height for the elem.
       * @param {number} currentHeight - The current height for the elem.
       */
      adjustTop: function(placementClasses, containerPosition, initialHeight, currentHeight) {
        if (placementClasses.indexOf('top') !== -1 && initialHeight !== currentHeight) {
          return {
            top: containerPosition.top - currentHeight + 'px'
          };
        }
      },

      /**
       * Provides a way for positioning tooltip & dropdown
       * arrows when using placement options beyond the standard
       * left, right, top, or bottom.
       *
       * @param {element} elem - The tooltip/dropdown element.
       * @param {string} placement - The placement for the elem.
       */
      positionArrow: function(elem, placement) {
        elem = this.getRawNode(elem);

        var innerElem = elem.querySelector('.tooltip-inner, .popover-inner');
        if (!innerElem) {
          return;
        }

        var isTooltip = angular.element(innerElem).hasClass('tooltip-inner');

        var arrowElem = isTooltip ? elem.querySelector('.tooltip-arrow') : elem.querySelector('.arrow');
        if (!arrowElem) {
          return;
        }

        var arrowCss = {
          top: '',
          bottom: '',
          left: '',
          right: ''
        };

        placement = this.parsePlacement(placement);
        if (placement[1] === 'center') {
          // no adjustment necessary - just reset styles
          angular.element(arrowElem).css(arrowCss);
          return;
        }

        var borderProp = 'border-' + placement[0] + '-width';
        var borderWidth = $window.getComputedStyle(arrowElem)[borderProp];

        var borderRadiusProp = 'border-';
        if (PLACEMENT_REGEX.vertical.test(placement[0])) {
          borderRadiusProp += placement[0] + '-' + placement[1];
        } else {
          borderRadiusProp += placement[1] + '-' + placement[0];
        }
        borderRadiusProp += '-radius';
        var borderRadius = $window.getComputedStyle(isTooltip ? innerElem : elem)[borderRadiusProp];

        switch (placement[0]) {
          case 'top':
            arrowCss.bottom = isTooltip ? '0' : '-' + borderWidth;
            break;
          case 'bottom':
            arrowCss.top = isTooltip ? '0' : '-' + borderWidth;
            break;
          case 'left':
            arrowCss.right = isTooltip ? '0' : '-' + borderWidth;
            break;
          case 'right':
            arrowCss.left = isTooltip ? '0' : '-' + borderWidth;
            break;
        }

        arrowCss[placement[1]] = borderRadius;

        angular.element(arrowElem).css(arrowCss);
      }
    };
  }]);

angular.module('ui.bootstrap.datepickerPopup', ['ui.bootstrap.datepicker', 'ui.bootstrap.position'])

.value('$datepickerPopupLiteralWarning', true)

.constant('uibDatepickerPopupConfig', {
  altInputFormats: [],
  appendToBody: false,
  clearText: 'Clear',
  closeOnDateSelection: true,
  closeText: 'Done',
  currentText: 'Today',
  datepickerPopup: 'yyyy-MM-dd',
  datepickerPopupTemplateUrl: 'uib/template/datepickerPopup/popup.html',
  datepickerTemplateUrl: 'uib/template/datepicker/datepicker.html',
  html5Types: {
    date: 'yyyy-MM-dd',
    'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
    'month': 'yyyy-MM'
  },
  onOpenFocus: true,
  showButtonBar: true,
  placement: 'auto bottom-left'
})

.controller('UibDatepickerPopupController', ['$scope', '$element', '$attrs', '$compile', '$log', '$parse', '$window', '$document', '$rootScope', '$uibPosition', 'dateFilter', 'uibDateParser', 'uibDatepickerPopupConfig', '$timeout', 'uibDatepickerConfig', '$datepickerPopupLiteralWarning',
function($scope, $element, $attrs, $compile, $log, $parse, $window, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout, datepickerConfig, $datepickerPopupLiteralWarning) {
  var cache = {},
    isHtml5DateInput = false;
  var dateFormat, closeOnDateSelection, appendToBody, onOpenFocus,
    datepickerPopupTemplateUrl, datepickerTemplateUrl, popupEl, datepickerEl, scrollParentEl,
    ngModel, ngModelOptions, $popup, altInputFormats, watchListeners = [];

  this.init = function(_ngModel_) {
    ngModel = _ngModel_;
    ngModelOptions = extractOptions(ngModel);
    closeOnDateSelection = angular.isDefined($attrs.closeOnDateSelection) ?
      $scope.$parent.$eval($attrs.closeOnDateSelection) :
      datepickerPopupConfig.closeOnDateSelection;
    appendToBody = angular.isDefined($attrs.datepickerAppendToBody) ?
      $scope.$parent.$eval($attrs.datepickerAppendToBody) :
      datepickerPopupConfig.appendToBody;
    onOpenFocus = angular.isDefined($attrs.onOpenFocus) ?
      $scope.$parent.$eval($attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus;
    datepickerPopupTemplateUrl = angular.isDefined($attrs.datepickerPopupTemplateUrl) ?
      $attrs.datepickerPopupTemplateUrl :
      datepickerPopupConfig.datepickerPopupTemplateUrl;
    datepickerTemplateUrl = angular.isDefined($attrs.datepickerTemplateUrl) ?
      $attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl;
    altInputFormats = angular.isDefined($attrs.altInputFormats) ?
      $scope.$parent.$eval($attrs.altInputFormats) :
      datepickerPopupConfig.altInputFormats;

    $scope.showButtonBar = angular.isDefined($attrs.showButtonBar) ?
      $scope.$parent.$eval($attrs.showButtonBar) :
      datepickerPopupConfig.showButtonBar;

    if (datepickerPopupConfig.html5Types[$attrs.type]) {
      dateFormat = datepickerPopupConfig.html5Types[$attrs.type];
      isHtml5DateInput = true;
    } else {
      dateFormat = $attrs.uibDatepickerPopup || datepickerPopupConfig.datepickerPopup;
      $attrs.$observe('uibDatepickerPopup', function(value, oldValue) {
        var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
        // Invalidate the $modelValue to ensure that formatters re-run
        // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
        if (newDateFormat !== dateFormat) {
          dateFormat = newDateFormat;
          ngModel.$modelValue = null;

          if (!dateFormat) {
            throw new Error('uibDatepickerPopup must have a date format specified.');
          }
        }
      });
    }

    if (!dateFormat) {
      throw new Error('uibDatepickerPopup must have a date format specified.');
    }

    if (isHtml5DateInput && $attrs.uibDatepickerPopup) {
      throw new Error('HTML5 date input types do not support custom formats.');
    }

    // popup element used to display calendar
    popupEl = angular.element('<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>');

    popupEl.attr({
      'ng-model': 'date',
      'ng-change': 'dateSelection(date)',
      'template-url': datepickerPopupTemplateUrl
    });

    // datepicker element
    datepickerEl = angular.element(popupEl.children()[0]);
    datepickerEl.attr('template-url', datepickerTemplateUrl);

    if (!$scope.datepickerOptions) {
      $scope.datepickerOptions = {};
    }

    if (isHtml5DateInput) {
      if ($attrs.type === 'month') {
        $scope.datepickerOptions.datepickerMode = 'month';
        $scope.datepickerOptions.minMode = 'month';
      }
    }

    datepickerEl.attr('datepicker-options', 'datepickerOptions');

    if (!isHtml5DateInput) {
      // Internal API to maintain the correct ng-invalid-[key] class
      ngModel.$$parserName = 'date';
      ngModel.$validators.date = validator;
      ngModel.$parsers.unshift(parseDate);
      ngModel.$formatters.push(function(value) {
        if (ngModel.$isEmpty(value)) {
          $scope.date = value;
          return value;
        }

        if (angular.isNumber(value)) {
          value = new Date(value);
        }

        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));

        return dateParser.filter($scope.date, dateFormat);
      });
    } else {
      ngModel.$formatters.push(function(value) {
        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));
        return value;
      });
    }

    // Detect changes in the view from the text box
    ngModel.$viewChangeListeners.push(function() {
      $scope.date = parseDateString(ngModel.$viewValue);
    });

    $element.on('keydown', inputKeydownBind);

    $popup = $compile(popupEl)($scope);
    // Prevent jQuery cache memory leak (template is now redundant after linking)
    popupEl.remove();

    if (appendToBody) {
      $document.find('body').append($popup);
    } else {
      $element.after($popup);
    }

    $scope.$on('$destroy', function() {
      if ($scope.isOpen === true) {
        if (!$rootScope.$$phase) {
          $scope.$apply(function() {
            $scope.isOpen = false;
          });
        }
      }

      $popup.remove();
      $element.off('keydown', inputKeydownBind);
      $document.off('click', documentClickBind);
      if (scrollParentEl) {
        scrollParentEl.off('scroll', positionPopup);
      }
      angular.element($window).off('resize', positionPopup);

      //Clear all watch listeners on destroy
      while (watchListeners.length) {
        watchListeners.shift()();
      }
    });
  };

  $scope.getText = function(key) {
    return $scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
  };

  $scope.isDisabled = function(date) {
    if (date === 'today') {
      date = dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));
    }

    var dates = {};
    angular.forEach(['minDate', 'maxDate'], function(key) {
      if (!$scope.datepickerOptions[key]) {
        dates[key] = null;
      } else if (angular.isDate($scope.datepickerOptions[key])) {
        dates[key] = new Date($scope.datepickerOptions[key]);
      } else {
        if ($datepickerPopupLiteralWarning) {
          $log.warn('Literal date support has been deprecated, please switch to date object usage');
        }

        dates[key] = new Date(dateFilter($scope.datepickerOptions[key], 'medium'));
      }
    });

    return $scope.datepickerOptions &&
      dates.minDate && $scope.compare(date, dates.minDate) < 0 ||
      dates.maxDate && $scope.compare(date, dates.maxDate) > 0;
  };

  $scope.compare = function(date1, date2) {
    return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
  };

  // Inner change
  $scope.dateSelection = function(dt) {
    $scope.date = dt;
    var date = $scope.date ? dateParser.filter($scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
    $element.val(date);
    ngModel.$setViewValue(date);

    if (closeOnDateSelection) {
      $scope.isOpen = false;
      $element[0].focus();
    }
  };

  $scope.keydown = function(evt) {
    if (evt.which === 27) {
      evt.stopPropagation();
      $scope.isOpen = false;
      $element[0].focus();
    }
  };

  $scope.select = function(date, evt) {
    evt.stopPropagation();

    if (date === 'today') {
      var today = new Date();
      if (angular.isDate($scope.date)) {
        date = new Date($scope.date);
        date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
      } else {
        date = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
        date.setHours(0, 0, 0, 0);
      }
    }
    $scope.dateSelection(date);
  };

  $scope.close = function(evt) {
    evt.stopPropagation();

    $scope.isOpen = false;
    $element[0].focus();
  };

  $scope.disabled = angular.isDefined($attrs.disabled) || false;
  if ($attrs.ngDisabled) {
    watchListeners.push($scope.$parent.$watch($parse($attrs.ngDisabled), function(disabled) {
      $scope.disabled = disabled;
    }));
  }

  $scope.$watch('isOpen', function(value) {
    if (value) {
      if (!$scope.disabled) {
        $timeout(function() {
          positionPopup();

          if (onOpenFocus) {
            $scope.$broadcast('uib:datepicker.focus');
          }

          $document.on('click', documentClickBind);

          var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
          if (appendToBody || $position.parsePlacement(placement)[2]) {
            scrollParentEl = scrollParentEl || angular.element($position.scrollParent($element));
            if (scrollParentEl) {
              scrollParentEl.on('scroll', positionPopup);
            }
          } else {
            scrollParentEl = null;
          }

          angular.element($window).on('resize', positionPopup);
        }, 0, false);
      } else {
        $scope.isOpen = false;
      }
    } else {
      $document.off('click', documentClickBind);
      if (scrollParentEl) {
        scrollParentEl.off('scroll', positionPopup);
      }
      angular.element($window).off('resize', positionPopup);
    }
  });

  function cameltoDash(string) {
    return string.replace(/([A-Z])/g, function($1) { return '-' + $1.toLowerCase(); });
  }

  function parseDateString(viewValue) {
    var date = dateParser.parse(viewValue, dateFormat, $scope.date);
    if (isNaN(date)) {
      for (var i = 0; i < altInputFormats.length; i++) {
        date = dateParser.parse(viewValue, altInputFormats[i], $scope.date);
        if (!isNaN(date)) {
          return date;
        }
      }
    }
    return date;
  }

  function parseDate(viewValue) {
    if (angular.isNumber(viewValue)) {
      // presumably timestamp to date object
      viewValue = new Date(viewValue);
    }

    if (!viewValue) {
      return null;
    }

    if (angular.isDate(viewValue) && !isNaN(viewValue)) {
      return viewValue;
    }

    if (angular.isString(viewValue)) {
      var date = parseDateString(viewValue);
      if (!isNaN(date)) {
        return dateParser.toTimezone(date, ngModelOptions.getOption('timezone'));
      }
    }

    return ngModelOptions.getOption('allowInvalid') ? viewValue : undefined;
  }

  function validator(modelValue, viewValue) {
    var value = modelValue || viewValue;

    if (!$attrs.ngRequired && !value) {
      return true;
    }

    if (angular.isNumber(value)) {
      value = new Date(value);
    }

    if (!value) {
      return true;
    }

    if (angular.isDate(value) && !isNaN(value)) {
      return true;
    }

    if (angular.isString(value)) {
      return !isNaN(parseDateString(value));
    }

    return false;
  }

  function documentClickBind(event) {
    if (!$scope.isOpen && $scope.disabled) {
      return;
    }

    var popup = $popup[0];
    var dpContainsTarget = $element[0].contains(event.target);
    // The popup node may not be an element node
    // In some browsers (IE) only element nodes have the 'contains' function
    var popupContainsTarget = popup.contains !== undefined && popup.contains(event.target);
    if ($scope.isOpen && !(dpContainsTarget || popupContainsTarget)) {
      $scope.$apply(function() {
        $scope.isOpen = false;
      });
    }
  }

  function inputKeydownBind(evt) {
    if (evt.which === 27 && $scope.isOpen) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.$apply(function() {
        $scope.isOpen = false;
      });
      $element[0].focus();
    } else if (evt.which === 40 && !$scope.isOpen) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.$apply(function() {
        $scope.isOpen = true;
      });
    }
  }

  function positionPopup() {
    if ($scope.isOpen) {
      var dpElement = angular.element($popup[0].querySelector('.uib-datepicker-popup'));
      var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
      var position = $position.positionElements($element, dpElement, placement, appendToBody);
      dpElement.css({top: position.top + 'px', left: position.left + 'px'});
      if (dpElement.hasClass('uib-position-measure')) {
        dpElement.removeClass('uib-position-measure');
      }
    }
  }

  function extractOptions(ngModelCtrl) {
    var ngModelOptions;

    if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
      // guarantee a value
      ngModelOptions = angular.isObject(ngModelCtrl.$options) ?
        ngModelCtrl.$options :
        {
          timezone: null
        };

      // mimic 1.6+ api
      ngModelOptions.getOption = function (key) {
        return ngModelOptions[key];
      };
    } else { // in angular >=1.6 $options is always present
      ngModelOptions = ngModelCtrl.$options;
    }

    return ngModelOptions;
  }

  $scope.$on('uib:datepicker.mode', function() {
    $timeout(positionPopup, 0, false);
  });
}])

.directive('uibDatepickerPopup', function() {
  return {
    require: ['ngModel', 'uibDatepickerPopup'],
    controller: 'UibDatepickerPopupController',
    scope: {
      datepickerOptions: '=?',
      isOpen: '=?',
      currentText: '@',
      clearText: '@',
      closeText: '@'
    },
    link: function(scope, element, attrs, ctrls) {
      var ngModel = ctrls[0],
        ctrl = ctrls[1];

      ctrl.init(ngModel);
    }
  };
})

.directive('uibDatepickerPopupWrap', function() {
  return {
    restrict: 'A',
    transclude: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepickerPopup/popup.html';
    }
  };
});

angular.module('ui.bootstrap.debounce', [])
/**
 * A helper, internal service that debounces a function
 */
  .factory('$$debounce', ['$timeout', function($timeout) {
    return function(callback, debounceTime) {
      var timeoutPromise;

      return function() {
        var self = this;
        var args = Array.prototype.slice.call(arguments);
        if (timeoutPromise) {
          $timeout.cancel(timeoutPromise);
        }

        timeoutPromise = $timeout(function() {
          callback.apply(self, args);
        }, debounceTime);
      };
    };
  }]);

angular.module('ui.bootstrap.multiMap', [])
/**
 * A helper, internal data structure that stores all references attached to key
 */
  .factory('$$multiMap', function() {
    return {
      createNew: function() {
        var map = {};

        return {
          entries: function() {
            return Object.keys(map).map(function(key) {
              return {
                key: key,
                value: map[key]
              };
            });
          },
          get: function(key) {
            return map[key];
          },
          hasKey: function(key) {
            return !!map[key];
          },
          keys: function() {
            return Object.keys(map);
          },
          put: function(key, value) {
            if (!map[key]) {
              map[key] = [];
            }

            map[key].push(value);
          },
          remove: function(key, value) {
            var values = map[key];

            if (!values) {
              return;
            }

            var idx = values.indexOf(value);

            if (idx !== -1) {
              values.splice(idx, 1);
            }

            if (!values.length) {
              delete map[key];
            }
          }
        };
      }
    };
  });

angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.multiMap', 'ui.bootstrap.position'])

.constant('uibDropdownConfig', {
  appendToOpenClass: 'uib-dropdown-open',
  openClass: 'open'
})

.service('uibDropdownService', ['$document', '$rootScope', '$$multiMap', function($document, $rootScope, $$multiMap) {
  var openScope = null;
  var openedContainers = $$multiMap.createNew();

  this.isOnlyOpen = function(dropdownScope, appendTo) {
    var openedDropdowns = openedContainers.get(appendTo);
    if (openedDropdowns) {
      var openDropdown = openedDropdowns.reduce(function(toClose, dropdown) {
        if (dropdown.scope === dropdownScope) {
          return dropdown;
        }

        return toClose;
      }, {});
      if (openDropdown) {
        return openedDropdowns.length === 1;
      }
    }

    return false;
  };

  this.open = function(dropdownScope, element, appendTo) {
    if (!openScope) {
      $document.on('click', closeDropdown);
    }

    if (openScope && openScope !== dropdownScope) {
      openScope.isOpen = false;
    }

    openScope = dropdownScope;

    if (!appendTo) {
      return;
    }

    var openedDropdowns = openedContainers.get(appendTo);
    if (openedDropdowns) {
      var openedScopes = openedDropdowns.map(function(dropdown) {
        return dropdown.scope;
      });
      if (openedScopes.indexOf(dropdownScope) === -1) {
        openedContainers.put(appendTo, {
          scope: dropdownScope
        });
      }
    } else {
      openedContainers.put(appendTo, {
        scope: dropdownScope
      });
    }
  };

  this.close = function(dropdownScope, element, appendTo) {
    if (openScope === dropdownScope) {
      $document.off('click', closeDropdown);
      $document.off('keydown', this.keybindFilter);
      openScope = null;
    }

    if (!appendTo) {
      return;
    }

    var openedDropdowns = openedContainers.get(appendTo);
    if (openedDropdowns) {
      var dropdownToClose = openedDropdowns.reduce(function(toClose, dropdown) {
        if (dropdown.scope === dropdownScope) {
          return dropdown;
        }

        return toClose;
      }, {});
      if (dropdownToClose) {
        openedContainers.remove(appendTo, dropdownToClose);
      }
    }
  };

  var closeDropdown = function(evt) {
    // This method may still be called during the same mouse event that
    // unbound this event handler. So check openScope before proceeding.
    if (!openScope || !openScope.isOpen) { return; }

    if (evt && openScope.getAutoClose() === 'disabled') { return; }

    if (evt && evt.which === 3) { return; }

    var toggleElement = openScope.getToggleElement();
    if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
      return;
    }

    var dropdownElement = openScope.getDropdownElement();
    if (evt && openScope.getAutoClose() === 'outsideClick' &&
      dropdownElement && dropdownElement[0].contains(evt.target)) {
      return;
    }

    openScope.focusToggleElement();
    openScope.isOpen = false;

    if (!$rootScope.$$phase) {
      openScope.$apply();
    }
  };

  this.keybindFilter = function(evt) {
    if (!openScope) {
      // see this.close as ESC could have been pressed which kills the scope so we can not proceed
      return;
    }

    var dropdownElement = openScope.getDropdownElement();
    var toggleElement = openScope.getToggleElement();
    var dropdownElementTargeted = dropdownElement && dropdownElement[0].contains(evt.target);
    var toggleElementTargeted = toggleElement && toggleElement[0].contains(evt.target);
    if (evt.which === 27) {
      evt.stopPropagation();
      openScope.focusToggleElement();
      closeDropdown();
    } else if (openScope.isKeynavEnabled() && [38, 40].indexOf(evt.which) !== -1 && openScope.isOpen && (dropdownElementTargeted || toggleElementTargeted)) {
      evt.preventDefault();
      evt.stopPropagation();
      openScope.focusDropdownEntry(evt.which);
    }
  };
}])

.controller('UibDropdownController', ['$scope', '$element', '$attrs', '$parse', 'uibDropdownConfig', 'uibDropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', function($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest) {
  var self = this,
    scope = $scope.$new(), // create a child scope so we are not polluting original one
    templateScope,
    appendToOpenClass = dropdownConfig.appendToOpenClass,
    openClass = dropdownConfig.openClass,
    getIsOpen,
    setIsOpen = angular.noop,
    toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
    keynavEnabled = false,
    selectedOption = null,
    body = $document.find('body');

  $element.addClass('dropdown');

  this.init = function() {
    if ($attrs.isOpen) {
      getIsOpen = $parse($attrs.isOpen);
      setIsOpen = getIsOpen.assign;

      $scope.$watch(getIsOpen, function(value) {
        scope.isOpen = !!value;
      });
    }

    keynavEnabled = angular.isDefined($attrs.keyboardNav);
  };

  this.toggle = function(open) {
    scope.isOpen = arguments.length ? !!open : !scope.isOpen;
    if (angular.isFunction(setIsOpen)) {
      setIsOpen(scope, scope.isOpen);
    }

    return scope.isOpen;
  };

  // Allow other directives to watch status
  this.isOpen = function() {
    return scope.isOpen;
  };

  scope.getToggleElement = function() {
    return self.toggleElement;
  };

  scope.getAutoClose = function() {
    return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
  };

  scope.getElement = function() {
    return $element;
  };

  scope.isKeynavEnabled = function() {
    return keynavEnabled;
  };

  scope.focusDropdownEntry = function(keyCode) {
    var elems = self.dropdownMenu ? //If append to body is used.
      angular.element(self.dropdownMenu).find('a') :
      $element.find('ul').eq(0).find('a');

    switch (keyCode) {
      case 40: {
        if (!angular.isNumber(self.selectedOption)) {
          self.selectedOption = 0;
        } else {
          self.selectedOption = self.selectedOption === elems.length - 1 ?
            self.selectedOption :
            self.selectedOption + 1;
        }
        break;
      }
      case 38: {
        if (!angular.isNumber(self.selectedOption)) {
          self.selectedOption = elems.length - 1;
        } else {
          self.selectedOption = self.selectedOption === 0 ?
            0 : self.selectedOption - 1;
        }
        break;
      }
    }
    elems[self.selectedOption].focus();
  };

  scope.getDropdownElement = function() {
    return self.dropdownMenu;
  };

  scope.focusToggleElement = function() {
    if (self.toggleElement) {
      self.toggleElement[0].focus();
    }
  };

  function removeDropdownMenu() {
    $element.append(self.dropdownMenu);
  }

  scope.$watch('isOpen', function(isOpen, wasOpen) {
    var appendTo = null,
      appendToBody = false;

    if (angular.isDefined($attrs.dropdownAppendTo)) {
      var appendToEl = $parse($attrs.dropdownAppendTo)(scope);
      if (appendToEl) {
        appendTo = angular.element(appendToEl);
      }
    }

    if (angular.isDefined($attrs.dropdownAppendToBody)) {
      var appendToBodyValue = $parse($attrs.dropdownAppendToBody)(scope);
      if (appendToBodyValue !== false) {
        appendToBody = true;
      }
    }

    if (appendToBody && !appendTo) {
      appendTo = body;
    }

    if (appendTo && self.dropdownMenu) {
      if (isOpen) {
        appendTo.append(self.dropdownMenu);
        $element.on('$destroy', removeDropdownMenu);
      } else {
        $element.off('$destroy', removeDropdownMenu);
        removeDropdownMenu();
      }
    }

    if (appendTo && self.dropdownMenu) {
      var pos = $position.positionElements($element, self.dropdownMenu, 'bottom-left', true),
        css,
        rightalign,
        scrollbarPadding,
        scrollbarWidth = 0;

      css = {
        top: pos.top + 'px',
        display: isOpen ? 'block' : 'none'
      };

      rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
      if (!rightalign) {
        css.left = pos.left + 'px';
        css.right = 'auto';
      } else {
        css.left = 'auto';
        scrollbarPadding = $position.scrollbarPadding(appendTo);

        if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
          scrollbarWidth = scrollbarPadding.scrollbarWidth;
        }

        css.right = window.innerWidth - scrollbarWidth -
          (pos.left + $element.prop('offsetWidth')) + 'px';
      }

      // Need to adjust our positioning to be relative to the appendTo container
      // if it's not the body element
      if (!appendToBody) {
        var appendOffset = $position.offset(appendTo);

        css.top = pos.top - appendOffset.top + 'px';

        if (!rightalign) {
          css.left = pos.left - appendOffset.left + 'px';
        } else {
          css.right = window.innerWidth -
            (pos.left - appendOffset.left + $element.prop('offsetWidth')) + 'px';
        }
      }

      self.dropdownMenu.css(css);
    }

    var openContainer = appendTo ? appendTo : $element;
    var dropdownOpenClass = appendTo ? appendToOpenClass : openClass;
    var hasOpenClass = openContainer.hasClass(dropdownOpenClass);
    var isOnlyOpen = uibDropdownService.isOnlyOpen($scope, appendTo);

    if (hasOpenClass === !isOpen) {
      var toggleClass;
      if (appendTo) {
        toggleClass = !isOnlyOpen ? 'addClass' : 'removeClass';
      } else {
        toggleClass = isOpen ? 'addClass' : 'removeClass';
      }
      $animate[toggleClass](openContainer, dropdownOpenClass).then(function() {
        if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
          toggleInvoker($scope, { open: !!isOpen });
        }
      });
    }

    if (isOpen) {
      if (self.dropdownMenuTemplateUrl) {
        $templateRequest(self.dropdownMenuTemplateUrl).then(function(tplContent) {
          templateScope = scope.$new();
          $compile(tplContent.trim())(templateScope, function(dropdownElement) {
            var newEl = dropdownElement;
            self.dropdownMenu.replaceWith(newEl);
            self.dropdownMenu = newEl;
            $document.on('keydown', uibDropdownService.keybindFilter);
          });
        });
      } else {
        $document.on('keydown', uibDropdownService.keybindFilter);
      }

      scope.focusToggleElement();
      uibDropdownService.open(scope, $element, appendTo);
    } else {
      uibDropdownService.close(scope, $element, appendTo);
      if (self.dropdownMenuTemplateUrl) {
        if (templateScope) {
          templateScope.$destroy();
        }
        var newEl = angular.element('<ul class="dropdown-menu"></ul>');
        self.dropdownMenu.replaceWith(newEl);
        self.dropdownMenu = newEl;
      }

      self.selectedOption = null;
    }

    if (angular.isFunction(setIsOpen)) {
      setIsOpen($scope, isOpen);
    }
  });
}])

.directive('uibDropdown', function() {
  return {
    controller: 'UibDropdownController',
    link: function(scope, element, attrs, dropdownCtrl) {
      dropdownCtrl.init();
    }
  };
})

.directive('uibDropdownMenu', function() {
  return {
    restrict: 'A',
    require: '?^uibDropdown',
    link: function(scope, element, attrs, dropdownCtrl) {
      if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {
        return;
      }

      element.addClass('dropdown-menu');

      var tplUrl = attrs.templateUrl;
      if (tplUrl) {
        dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
      }

      if (!dropdownCtrl.dropdownMenu) {
        dropdownCtrl.dropdownMenu = element;
      }
    }
  };
})

.directive('uibDropdownToggle', function() {
  return {
    require: '?^uibDropdown',
    link: function(scope, element, attrs, dropdownCtrl) {
      if (!dropdownCtrl) {
        return;
      }

      element.addClass('dropdown-toggle');

      dropdownCtrl.toggleElement = element;

      var toggleDropdown = function(event) {
        event.preventDefault();

        if (!element.hasClass('disabled') && !attrs.disabled) {
          scope.$apply(function() {
            dropdownCtrl.toggle();
          });
        }
      };

      element.on('click', toggleDropdown);

      // WAI-ARIA
      element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
      scope.$watch(dropdownCtrl.isOpen, function(isOpen) {
        element.attr('aria-expanded', !!isOpen);
      });

      scope.$on('$destroy', function() {
        element.off('click', toggleDropdown);
      });
    }
  };
});

angular.module('ui.bootstrap.stackedMap', [])
/**
 * A helper, internal data structure that acts as a map but also allows getting / removing
 * elements in the LIFO order
 */
  .factory('$$stackedMap', function() {
    return {
      createNew: function() {
        var stack = [];

        return {
          add: function(key, value) {
            stack.push({
              key: key,
              value: value
            });
          },
          get: function(key) {
            for (var i = 0; i < stack.length; i++) {
              if (key === stack[i].key) {
                return stack[i];
              }
            }
          },
          keys: function() {
            var keys = [];
            for (var i = 0; i < stack.length; i++) {
              keys.push(stack[i].key);
            }
            return keys;
          },
          top: function() {
            return stack[stack.length - 1];
          },
          remove: function(key) {
            var idx = -1;
            for (var i = 0; i < stack.length; i++) {
              if (key === stack[i].key) {
                idx = i;
                break;
              }
            }
            return stack.splice(idx, 1)[0];
          },
          removeTop: function() {
            return stack.pop();
          },
          length: function() {
            return stack.length;
          }
        };
      }
    };
  });
angular.module('ui.bootstrap.modal', ['ui.bootstrap.multiMap', 'ui.bootstrap.stackedMap', 'ui.bootstrap.position'])
/**
 * Pluggable resolve mechanism for the modal resolve resolution
 * Supports UI Router's $resolve service
 */
  .provider('$uibResolve', function() {
    var resolve = this;
    this.resolver = null;

    this.setResolver = function(resolver) {
      this.resolver = resolver;
    };

    this.$get = ['$injector', '$q', function($injector, $q) {
      var resolver = resolve.resolver ? $injector.get(resolve.resolver) : null;
      return {
        resolve: function(invocables, locals, parent, self) {
          if (resolver) {
            return resolver.resolve(invocables, locals, parent, self);
          }

          var promises = [];

          angular.forEach(invocables, function(value) {
            if (angular.isFunction(value) || angular.isArray(value)) {
              promises.push($q.resolve($injector.invoke(value)));
            } else if (angular.isString(value)) {
              promises.push($q.resolve($injector.get(value)));
            } else {
              promises.push($q.resolve(value));
            }
          });

          return $q.all(promises).then(function(resolves) {
            var resolveObj = {};
            var resolveIter = 0;
            angular.forEach(invocables, function(value, key) {
              resolveObj[key] = resolves[resolveIter++];
            });

            return resolveObj;
          });
        }
      };
    }];
  })

/**
 * A helper directive for the $modal service. It creates a backdrop element.
 */
  .directive('uibModalBackdrop', ['$animate', '$injector', '$uibModalStack',
  function($animate, $injector, $modalStack) {
    return {
      restrict: 'A',
      compile: function(tElement, tAttrs) {
        tElement.addClass(tAttrs.backdropClass);
        return linkFn;
      }
    };

    function linkFn(scope, element, attrs) {
      if (attrs.modalInClass) {
        $animate.addClass(element, attrs.modalInClass);

        scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
          var done = setIsAsync();
          if (scope.modalOptions.animation) {
            $animate.removeClass(element, attrs.modalInClass).then(done);
          } else {
            done();
          }
        });
      }
    }
  }])

  .directive('uibModalWindow', ['$uibModalStack', '$q', '$animateCss', '$document',
  function($modalStack, $q, $animateCss, $document) {
    return {
      scope: {
        index: '@'
      },
      restrict: 'A',
      transclude: true,
      templateUrl: function(tElement, tAttrs) {
        return tAttrs.templateUrl || 'uib/template/modal/window.html';
      },
      link: function(scope, element, attrs) {
        element.addClass(attrs.windowTopClass || '');
        scope.size = attrs.size;

        scope.close = function(evt) {
          var modal = $modalStack.getTop();
          if (modal && modal.value.backdrop &&
            modal.value.backdrop !== 'static' &&
            evt.target === evt.currentTarget) {
            evt.preventDefault();
            evt.stopPropagation();
            $modalStack.dismiss(modal.key, 'backdrop click');
          }
        };

        // moved from template to fix issue #2280
        element.on('click', scope.close);

        // This property is only added to the scope for the purpose of detecting when this directive is rendered.
        // We can detect that by using this property in the template associated with this directive and then use
        // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
        scope.$isRendered = true;

        // Deferred object that will be resolved when this modal is rendered.
        var modalRenderDeferObj = $q.defer();
        // Resolve render promise post-digest
        scope.$$postDigest(function() {
          modalRenderDeferObj.resolve();
        });

        modalRenderDeferObj.promise.then(function() {
          var animationPromise = null;

          if (attrs.modalInClass) {
            animationPromise = $animateCss(element, {
              addClass: attrs.modalInClass
            }).start();

            scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
              var done = setIsAsync();
              $animateCss(element, {
                removeClass: attrs.modalInClass
              }).start().then(done);
            });
          }


          $q.when(animationPromise).then(function() {
            // Notify {@link $modalStack} that modal is rendered.
            var modal = $modalStack.getTop();
            if (modal) {
              $modalStack.modalRendered(modal.key);
            }

            /**
             * If something within the freshly-opened modal already has focus (perhaps via a
             * directive that causes focus) then there's no need to try to focus anything.
             */
            if (!($document[0].activeElement && element[0].contains($document[0].activeElement))) {
              var inputWithAutofocus = element[0].querySelector('[autofocus]');
              /**
               * Auto-focusing of a freshly-opened modal element causes any child elements
               * with the autofocus attribute to lose focus. This is an issue on touch
               * based devices which will show and then hide the onscreen keyboard.
               * Attempts to refocus the autofocus element via JavaScript will not reopen
               * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
               * the modal element if the modal does not contain an autofocus element.
               */
              if (inputWithAutofocus) {
                inputWithAutofocus.focus();
              } else {
                element[0].focus();
              }
            }
          });
        });
      }
    };
  }])

  .directive('uibModalAnimationClass', function() {
    return {
      compile: function(tElement, tAttrs) {
        if (tAttrs.modalAnimation) {
          tElement.addClass(tAttrs.uibModalAnimationClass);
        }
      }
    };
  })

  .directive('uibModalTransclude', ['$animate', function($animate) {
    return {
      link: function(scope, element, attrs, controller, transclude) {
        transclude(scope.$parent, function(clone) {
          element.empty();
          $animate.enter(clone, element);
        });
      }
    };
  }])

  .factory('$uibModalStack', ['$animate', '$animateCss', '$document',
    '$compile', '$rootScope', '$q', '$$multiMap', '$$stackedMap', '$uibPosition',
    function($animate, $animateCss, $document, $compile, $rootScope, $q, $$multiMap, $$stackedMap, $uibPosition) {
      var OPENED_MODAL_CLASS = 'modal-open';

      var backdropDomEl, backdropScope;
      var openedWindows = $$stackedMap.createNew();
      var openedClasses = $$multiMap.createNew();
      var $modalStack = {
        NOW_CLOSING_EVENT: 'modal.stack.now-closing'
      };
      var topModalIndex = 0;
      var previousTopOpenedModal = null;
      var ARIA_HIDDEN_ATTRIBUTE_NAME = 'data-bootstrap-modal-aria-hidden-count';

      //Modal focus behavior
      var tabbableSelector = 'a[href], area[href], input:not([disabled]):not([tabindex=\'-1\']), ' +
        'button:not([disabled]):not([tabindex=\'-1\']),select:not([disabled]):not([tabindex=\'-1\']), textarea:not([disabled]):not([tabindex=\'-1\']), ' +
        'iframe, object, embed, *[tabindex]:not([tabindex=\'-1\']), *[contenteditable=true]';
      var scrollbarPadding;
      var SNAKE_CASE_REGEXP = /[A-Z]/g;

      // TODO: extract into common dependency with tooltip
      function snake_case(name) {
        var separator = '-';
        return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
          return (pos ? separator : '') + letter.toLowerCase();
        });
      }

      function isVisible(element) {
        return !!(element.offsetWidth ||
          element.offsetHeight ||
          element.getClientRects().length);
      }

      function backdropIndex() {
        var topBackdropIndex = -1;
        var opened = openedWindows.keys();
        for (var i = 0; i < opened.length; i++) {
          if (openedWindows.get(opened[i]).value.backdrop) {
            topBackdropIndex = i;
          }
        }

        // If any backdrop exist, ensure that it's index is always
        // right below the top modal
        if (topBackdropIndex > -1 && topBackdropIndex < topModalIndex) {
          topBackdropIndex = topModalIndex;
        }
        return topBackdropIndex;
      }

      $rootScope.$watch(backdropIndex, function(newBackdropIndex) {
        if (backdropScope) {
          backdropScope.index = newBackdropIndex;
        }
      });

      function removeModalWindow(modalInstance, elementToReceiveFocus) {
        var modalWindow = openedWindows.get(modalInstance).value;
        var appendToElement = modalWindow.appendTo;

        //clean up the stack
        openedWindows.remove(modalInstance);
        previousTopOpenedModal = openedWindows.top();
        if (previousTopOpenedModal) {
          topModalIndex = parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10);
        }

        removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function() {
          var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
          openedClasses.remove(modalBodyClass, modalInstance);
          var areAnyOpen = openedClasses.hasKey(modalBodyClass);
          appendToElement.toggleClass(modalBodyClass, areAnyOpen);
          if (!areAnyOpen && scrollbarPadding && scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
            if (scrollbarPadding.originalRight) {
              appendToElement.css({paddingRight: scrollbarPadding.originalRight + 'px'});
            } else {
              appendToElement.css({paddingRight: ''});
            }
            scrollbarPadding = null;
          }
          toggleTopWindowClass(true);
        }, modalWindow.closedDeferred);
        checkRemoveBackdrop();

        //move focus to specified element if available, or else to body
        if (elementToReceiveFocus && elementToReceiveFocus.focus) {
          elementToReceiveFocus.focus();
        } else if (appendToElement.focus) {
          appendToElement.focus();
        }
      }

      // Add or remove "windowTopClass" from the top window in the stack
      function toggleTopWindowClass(toggleSwitch) {
        var modalWindow;

        if (openedWindows.length() > 0) {
          modalWindow = openedWindows.top().value;
          modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);
        }
      }

      function checkRemoveBackdrop() {
        //remove backdrop if no longer needed
        if (backdropDomEl && backdropIndex() === -1) {
          var backdropScopeRef = backdropScope;
          removeAfterAnimate(backdropDomEl, backdropScope, function() {
            backdropScopeRef = null;
          });
          backdropDomEl = undefined;
          backdropScope = undefined;
        }
      }

      function removeAfterAnimate(domEl, scope, done, closedDeferred) {
        var asyncDeferred;
        var asyncPromise = null;
        var setIsAsync = function() {
          if (!asyncDeferred) {
            asyncDeferred = $q.defer();
            asyncPromise = asyncDeferred.promise;
          }

          return function asyncDone() {
            asyncDeferred.resolve();
          };
        };
        scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);

        // Note that it's intentional that asyncPromise might be null.
        // That's when setIsAsync has not been called during the
        // NOW_CLOSING_EVENT broadcast.
        return $q.when(asyncPromise).then(afterAnimating);

        function afterAnimating() {
          if (afterAnimating.done) {
            return;
          }
          afterAnimating.done = true;

          $animate.leave(domEl).then(function() {
            if (done) {
              done();
            }

            domEl.remove();
            if (closedDeferred) {
              closedDeferred.resolve();
            }
          });

          scope.$destroy();
        }
      }

      $document.on('keydown', keydownListener);

      $rootScope.$on('$destroy', function() {
        $document.off('keydown', keydownListener);
      });

      function keydownListener(evt) {
        if (evt.isDefaultPrevented()) {
          return evt;
        }

        var modal = openedWindows.top();
        if (modal) {
          switch (evt.which) {
            case 27: {
              if (modal.value.keyboard) {
                evt.preventDefault();
                $rootScope.$apply(function() {
                  $modalStack.dismiss(modal.key, 'escape key press');
                });
              }
              break;
            }
            case 9: {
              var list = $modalStack.loadFocusElementList(modal);
              var focusChanged = false;
              if (evt.shiftKey) {
                if ($modalStack.isFocusInFirstItem(evt, list) || $modalStack.isModalFocused(evt, modal)) {
                  focusChanged = $modalStack.focusLastFocusableElement(list);
                }
              } else {
                if ($modalStack.isFocusInLastItem(evt, list)) {
                  focusChanged = $modalStack.focusFirstFocusableElement(list);
                }
              }

              if (focusChanged) {
                evt.preventDefault();
                evt.stopPropagation();
              }

              break;
            }
          }
        }
      }

      $modalStack.open = function(modalInstance, modal) {
        var modalOpener = $document[0].activeElement,
          modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;

        toggleTopWindowClass(false);

        // Store the current top first, to determine what index we ought to use
        // for the current top modal
        previousTopOpenedModal = openedWindows.top();

        openedWindows.add(modalInstance, {
          deferred: modal.deferred,
          renderDeferred: modal.renderDeferred,
          closedDeferred: modal.closedDeferred,
          modalScope: modal.scope,
          backdrop: modal.backdrop,
          keyboard: modal.keyboard,
          openedClass: modal.openedClass,
          windowTopClass: modal.windowTopClass,
          animation: modal.animation,
          appendTo: modal.appendTo
        });

        openedClasses.put(modalBodyClass, modalInstance);

        var appendToElement = modal.appendTo,
            currBackdropIndex = backdropIndex();

        if (currBackdropIndex >= 0 && !backdropDomEl) {
          backdropScope = $rootScope.$new(true);
          backdropScope.modalOptions = modal;
          backdropScope.index = currBackdropIndex;
          backdropDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
          backdropDomEl.attr({
            'class': 'modal-backdrop',
            'ng-style': '{\'z-index\': 1040 + (index && 1 || 0) + index*10}',
            'uib-modal-animation-class': 'fade',
            'modal-in-class': 'in'
          });
          if (modal.backdropClass) {
            backdropDomEl.addClass(modal.backdropClass);
          }

          if (modal.animation) {
            backdropDomEl.attr('modal-animation', 'true');
          }
          $compile(backdropDomEl)(backdropScope);
          $animate.enter(backdropDomEl, appendToElement);
          if ($uibPosition.isScrollable(appendToElement)) {
            scrollbarPadding = $uibPosition.scrollbarPadding(appendToElement);
            if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
              appendToElement.css({paddingRight: scrollbarPadding.right + 'px'});
            }
          }
        }

        var content;
        if (modal.component) {
          content = document.createElement(snake_case(modal.component.name));
          content = angular.element(content);
          content.attr({
            resolve: '$resolve',
            'modal-instance': '$uibModalInstance',
            close: '$close($value)',
            dismiss: '$dismiss($value)'
          });
        } else {
          content = modal.content;
        }

        // Set the top modal index based on the index of the previous top modal
        topModalIndex = previousTopOpenedModal ? parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10) + 1 : 0;
        var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
        angularDomEl.attr({
          'class': 'modal',
          'template-url': modal.windowTemplateUrl,
          'window-top-class': modal.windowTopClass,
          'role': 'dialog',
          'aria-labelledby': modal.ariaLabelledBy,
          'aria-describedby': modal.ariaDescribedBy,
          'size': modal.size,
          'index': topModalIndex,
          'animate': 'animate',
          'ng-style': '{\'z-index\': 1050 + $$topModalIndex*10, display: \'block\'}',
          'tabindex': -1,
          'uib-modal-animation-class': 'fade',
          'modal-in-class': 'in'
        }).append(content);
        if (modal.windowClass) {
          angularDomEl.addClass(modal.windowClass);
        }

        if (modal.animation) {
          angularDomEl.attr('modal-animation', 'true');
        }

        appendToElement.addClass(modalBodyClass);
        if (modal.scope) {
          // we need to explicitly add the modal index to the modal scope
          // because it is needed by ngStyle to compute the zIndex property.
          modal.scope.$$topModalIndex = topModalIndex;
        }
        $animate.enter($compile(angularDomEl)(modal.scope), appendToElement);

        openedWindows.top().value.modalDomEl = angularDomEl;
        openedWindows.top().value.modalOpener = modalOpener;

        applyAriaHidden(angularDomEl);

        function applyAriaHidden(el) {
          if (!el || el[0].tagName === 'BODY') {
            return;
          }

          getSiblings(el).forEach(function(sibling) {
            var elemIsAlreadyHidden = sibling.getAttribute('aria-hidden') === 'true',
              ariaHiddenCount = parseInt(sibling.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10);

            if (!ariaHiddenCount) {
              ariaHiddenCount = elemIsAlreadyHidden ? 1 : 0;
            }

            sibling.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, ariaHiddenCount + 1);
            sibling.setAttribute('aria-hidden', 'true');
          });

          return applyAriaHidden(el.parent());

          function getSiblings(el) {
            var children = el.parent() ? el.parent().children() : [];

            return Array.prototype.filter.call(children, function(child) {
              return child !== el[0];
            });
          }
        }
      };

      function broadcastClosing(modalWindow, resultOrReason, closing) {
        return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
      }

      function unhideBackgroundElements() {
        Array.prototype.forEach.call(
          document.querySelectorAll('[' + ARIA_HIDDEN_ATTRIBUTE_NAME + ']'),
          function(hiddenEl) {
            var ariaHiddenCount = parseInt(hiddenEl.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10),
              newHiddenCount = ariaHiddenCount - 1;
            hiddenEl.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, newHiddenCount);

            if (!newHiddenCount) {
              hiddenEl.removeAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME);
              hiddenEl.removeAttribute('aria-hidden');
            }
          }
        );
      }

      $modalStack.close = function(modalInstance, result) {
        var modalWindow = openedWindows.get(modalInstance);
        unhideBackgroundElements();
        if (modalWindow && broadcastClosing(modalWindow, result, true)) {
          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
          modalWindow.value.deferred.resolve(result);
          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
          return true;
        }

        return !modalWindow;
      };

      $modalStack.dismiss = function(modalInstance, reason) {
        var modalWindow = openedWindows.get(modalInstance);
        unhideBackgroundElements();
        if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
          modalWindow.value.deferred.reject(reason);
          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
          return true;
        }
        return !modalWindow;
      };

      $modalStack.dismissAll = function(reason) {
        var topModal = this.getTop();
        while (topModal && this.dismiss(topModal.key, reason)) {
          topModal = this.getTop();
        }
      };

      $modalStack.getTop = function() {
        return openedWindows.top();
      };

      $modalStack.modalRendered = function(modalInstance) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow) {
          modalWindow.value.renderDeferred.resolve();
        }
      };

      $modalStack.focusFirstFocusableElement = function(list) {
        if (list.length > 0) {
          list[0].focus();
          return true;
        }
        return false;
      };

      $modalStack.focusLastFocusableElement = function(list) {
        if (list.length > 0) {
          list[list.length - 1].focus();
          return true;
        }
        return false;
      };

      $modalStack.isModalFocused = function(evt, modalWindow) {
        if (evt && modalWindow) {
          var modalDomEl = modalWindow.value.modalDomEl;
          if (modalDomEl && modalDomEl.length) {
            return (evt.target || evt.srcElement) === modalDomEl[0];
          }
        }
        return false;
      };

      $modalStack.isFocusInFirstItem = function(evt, list) {
        if (list.length > 0) {
          return (evt.target || evt.srcElement) === list[0];
        }
        return false;
      };

      $modalStack.isFocusInLastItem = function(evt, list) {
        if (list.length > 0) {
          return (evt.target || evt.srcElement) === list[list.length - 1];
        }
        return false;
      };

      $modalStack.loadFocusElementList = function(modalWindow) {
        if (modalWindow) {
          var modalDomE1 = modalWindow.value.modalDomEl;
          if (modalDomE1 && modalDomE1.length) {
            var elements = modalDomE1[0].querySelectorAll(tabbableSelector);
            return elements ?
              Array.prototype.filter.call(elements, function(element) {
                return isVisible(element);
              }) : elements;
          }
        }
      };

      return $modalStack;
    }])

  .provider('$uibModal', function() {
    var $modalProvider = {
      options: {
        animation: true,
        backdrop: true, //can also be false or 'static'
        keyboard: true
      },
      $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$uibResolve', '$uibModalStack',
        function ($rootScope, $q, $document, $templateRequest, $controller, $uibResolve, $modalStack) {
          var $modal = {};

          function getTemplatePromise(options) {
            return options.template ? $q.when(options.template) :
              $templateRequest(angular.isFunction(options.templateUrl) ?
                options.templateUrl() : options.templateUrl);
          }

          var promiseChain = null;
          $modal.getPromiseChain = function() {
            return promiseChain;
          };

          $modal.open = function(modalOptions) {
            var modalResultDeferred = $q.defer();
            var modalOpenedDeferred = $q.defer();
            var modalClosedDeferred = $q.defer();
            var modalRenderDeferred = $q.defer();

            //prepare an instance of a modal to be injected into controllers and returned to a caller
            var modalInstance = {
              result: modalResultDeferred.promise,
              opened: modalOpenedDeferred.promise,
              closed: modalClosedDeferred.promise,
              rendered: modalRenderDeferred.promise,
              close: function (result) {
                return $modalStack.close(modalInstance, result);
              },
              dismiss: function (reason) {
                return $modalStack.dismiss(modalInstance, reason);
              }
            };

            //merge and clean up options
            modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
            modalOptions.resolve = modalOptions.resolve || {};
            modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);

            if (!modalOptions.appendTo.length) {
              throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');
            }

            //verify options
            if (!modalOptions.component && !modalOptions.template && !modalOptions.templateUrl) {
              throw new Error('One of component or template or templateUrl options is required.');
            }

            var templateAndResolvePromise;
            if (modalOptions.component) {
              templateAndResolvePromise = $q.when($uibResolve.resolve(modalOptions.resolve, {}, null, null));
            } else {
              templateAndResolvePromise =
                $q.all([getTemplatePromise(modalOptions), $uibResolve.resolve(modalOptions.resolve, {}, null, null)]);
            }

            function resolveWithTemplate() {
              return templateAndResolvePromise;
            }

            // Wait for the resolution of the existing promise chain.
            // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
            // Then add to $modalStack and resolve opened.
            // Finally clean up the chain variable if no subsequent modal has overwritten it.
            var samePromise;
            samePromise = promiseChain = $q.all([promiseChain])
              .then(resolveWithTemplate, resolveWithTemplate)
              .then(function resolveSuccess(tplAndVars) {
                var providedScope = modalOptions.scope || $rootScope;

                var modalScope = providedScope.$new();
                modalScope.$close = modalInstance.close;
                modalScope.$dismiss = modalInstance.dismiss;

                modalScope.$on('$destroy', function() {
                  if (!modalScope.$$uibDestructionScheduled) {
                    modalScope.$dismiss('$uibUnscheduledDestruction');
                  }
                });

                var modal = {
                  scope: modalScope,
                  deferred: modalResultDeferred,
                  renderDeferred: modalRenderDeferred,
                  closedDeferred: modalClosedDeferred,
                  animation: modalOptions.animation,
                  backdrop: modalOptions.backdrop,
                  keyboard: modalOptions.keyboard,
                  backdropClass: modalOptions.backdropClass,
                  windowTopClass: modalOptions.windowTopClass,
                  windowClass: modalOptions.windowClass,
                  windowTemplateUrl: modalOptions.windowTemplateUrl,
                  ariaLabelledBy: modalOptions.ariaLabelledBy,
                  ariaDescribedBy: modalOptions.ariaDescribedBy,
                  size: modalOptions.size,
                  openedClass: modalOptions.openedClass,
                  appendTo: modalOptions.appendTo
                };

                var component = {};
                var ctrlInstance, ctrlInstantiate, ctrlLocals = {};

                if (modalOptions.component) {
                  constructLocals(component, false, true, false);
                  component.name = modalOptions.component;
                  modal.component = component;
                } else if (modalOptions.controller) {
                  constructLocals(ctrlLocals, true, false, true);

                  // the third param will make the controller instantiate later,private api
                  // @see https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L126
                  ctrlInstantiate = $controller(modalOptions.controller, ctrlLocals, true, modalOptions.controllerAs);
                  if (modalOptions.controllerAs && modalOptions.bindToController) {
                    ctrlInstance = ctrlInstantiate.instance;
                    ctrlInstance.$close = modalScope.$close;
                    ctrlInstance.$dismiss = modalScope.$dismiss;
                    angular.extend(ctrlInstance, {
                      $resolve: ctrlLocals.$scope.$resolve
                    }, providedScope);
                  }

                  ctrlInstance = ctrlInstantiate();

                  if (angular.isFunction(ctrlInstance.$onInit)) {
                    ctrlInstance.$onInit();
                  }
                }

                if (!modalOptions.component) {
                  modal.content = tplAndVars[0];
                }

                $modalStack.open(modalInstance, modal);
                modalOpenedDeferred.resolve(true);

                function constructLocals(obj, template, instanceOnScope, injectable) {
                  obj.$scope = modalScope;
                  obj.$scope.$resolve = {};
                  if (instanceOnScope) {
                    obj.$scope.$uibModalInstance = modalInstance;
                  } else {
                    obj.$uibModalInstance = modalInstance;
                  }

                  var resolves = template ? tplAndVars[1] : tplAndVars;
                  angular.forEach(resolves, function(value, key) {
                    if (injectable) {
                      obj[key] = value;
                    }

                    obj.$scope.$resolve[key] = value;
                  });
                }
            }, function resolveError(reason) {
              modalOpenedDeferred.reject(reason);
              modalResultDeferred.reject(reason);
            })['finally'](function() {
              if (promiseChain === samePromise) {
                promiseChain = null;
              }
            });

            return modalInstance;
          };

          return $modal;
        }
      ]
    };

    return $modalProvider;
  });

angular.module('ui.bootstrap.paging', [])
/**
 * Helper internal service for generating common controller code between the
 * pager and pagination components
 */
.factory('uibPaging', ['$parse', function($parse) {
  return {
    create: function(ctrl, $scope, $attrs) {
      ctrl.setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
      ctrl.ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl
      ctrl._watchers = [];

      ctrl.init = function(ngModelCtrl, config) {
        ctrl.ngModelCtrl = ngModelCtrl;
        ctrl.config = config;

        ngModelCtrl.$render = function() {
          ctrl.render();
        };

        if ($attrs.itemsPerPage) {
          ctrl._watchers.push($scope.$parent.$watch($attrs.itemsPerPage, function(value) {
            ctrl.itemsPerPage = parseInt(value, 10);
            $scope.totalPages = ctrl.calculateTotalPages();
            ctrl.updatePage();
          }));
        } else {
          ctrl.itemsPerPage = config.itemsPerPage;
        }

        $scope.$watch('totalItems', function(newTotal, oldTotal) {
          if (angular.isDefined(newTotal) || newTotal !== oldTotal) {
            $scope.totalPages = ctrl.calculateTotalPages();
            ctrl.updatePage();
          }
        });
      };

      ctrl.calculateTotalPages = function() {
        var totalPages = ctrl.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / ctrl.itemsPerPage);
        return Math.max(totalPages || 0, 1);
      };

      ctrl.render = function() {
        $scope.page = parseInt(ctrl.ngModelCtrl.$viewValue, 10) || 1;
      };

      $scope.selectPage = function(page, evt) {
        if (evt) {
          evt.preventDefault();
        }

        var clickAllowed = !$scope.ngDisabled || !evt;
        if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
          if (evt && evt.target) {
            evt.target.blur();
          }
          ctrl.ngModelCtrl.$setViewValue(page);
          ctrl.ngModelCtrl.$render();
        }
      };

      $scope.getText = function(key) {
        return $scope[key + 'Text'] || ctrl.config[key + 'Text'];
      };

      $scope.noPrevious = function() {
        return $scope.page === 1;
      };

      $scope.noNext = function() {
        return $scope.page === $scope.totalPages;
      };

      ctrl.updatePage = function() {
        ctrl.setNumPages($scope.$parent, $scope.totalPages); // Readonly variable

        if ($scope.page > $scope.totalPages) {
          $scope.selectPage($scope.totalPages);
        } else {
          ctrl.ngModelCtrl.$render();
        }
      };

      $scope.$on('$destroy', function() {
        while (ctrl._watchers.length) {
          ctrl._watchers.shift()();
        }
      });
    }
  };
}]);

angular.module('ui.bootstrap.pager', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])

.controller('UibPagerController', ['$scope', '$attrs', 'uibPaging', 'uibPagerConfig', function($scope, $attrs, uibPaging, uibPagerConfig) {
  $scope.align = angular.isDefined($attrs.align) ? $scope.$parent.$eval($attrs.align) : uibPagerConfig.align;

  uibPaging.create(this, $scope, $attrs);
}])

.constant('uibPagerConfig', {
  itemsPerPage: 10,
  previousText: '« Previous',
  nextText: 'Next »',
  align: true
})

.directive('uibPager', ['uibPagerConfig', function(uibPagerConfig) {
  return {
    scope: {
      totalItems: '=',
      previousText: '@',
      nextText: '@',
      ngDisabled: '='
    },
    require: ['uibPager', '?ngModel'],
    restrict: 'A',
    controller: 'UibPagerController',
    controllerAs: 'pager',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/pager/pager.html';
    },
    link: function(scope, element, attrs, ctrls) {
      element.addClass('pager');
      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if (!ngModelCtrl) {
        return; // do nothing if no ng-model
      }

      paginationCtrl.init(ngModelCtrl, uibPagerConfig);
    }
  };
}]);

angular.module('ui.bootstrap.pagination', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])
.controller('UibPaginationController', ['$scope', '$attrs', '$parse', 'uibPaging', 'uibPaginationConfig', function($scope, $attrs, $parse, uibPaging, uibPaginationConfig) {
  var ctrl = this;
  // Setup configuration parameters
  var maxSize = angular.isDefined($attrs.maxSize) ? $scope.$parent.$eval($attrs.maxSize) : uibPaginationConfig.maxSize,
    rotate = angular.isDefined($attrs.rotate) ? $scope.$parent.$eval($attrs.rotate) : uibPaginationConfig.rotate,
    forceEllipses = angular.isDefined($attrs.forceEllipses) ? $scope.$parent.$eval($attrs.forceEllipses) : uibPaginationConfig.forceEllipses,
    boundaryLinkNumbers = angular.isDefined($attrs.boundaryLinkNumbers) ? $scope.$parent.$eval($attrs.boundaryLinkNumbers) : uibPaginationConfig.boundaryLinkNumbers,
    pageLabel = angular.isDefined($attrs.pageLabel) ? function(idx) { return $scope.$parent.$eval($attrs.pageLabel, {$page: idx}); } : angular.identity;
  $scope.boundaryLinks = angular.isDefined($attrs.boundaryLinks) ? $scope.$parent.$eval($attrs.boundaryLinks) : uibPaginationConfig.boundaryLinks;
  $scope.directionLinks = angular.isDefined($attrs.directionLinks) ? $scope.$parent.$eval($attrs.directionLinks) : uibPaginationConfig.directionLinks;
  $attrs.$set('role', 'menu');

  uibPaging.create(this, $scope, $attrs);

  if ($attrs.maxSize) {
    ctrl._watchers.push($scope.$parent.$watch($parse($attrs.maxSize), function(value) {
      maxSize = parseInt(value, 10);
      ctrl.render();
    }));
  }

  // Create page object used in template
  function makePage(number, text, isActive) {
    return {
      number: number,
      text: text,
      active: isActive
    };
  }

  function getPages(currentPage, totalPages) {
    var pages = [];

    // Default page limits
    var startPage = 1, endPage = totalPages;
    var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;

    // recompute if maxSize
    if (isMaxSized) {
      if (rotate) {
        // Current page is displayed in the middle of the visible ones
        startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
        endPage = startPage + maxSize - 1;

        // Adjust if limit is exceeded
        if (endPage > totalPages) {
          endPage = totalPages;
          startPage = endPage - maxSize + 1;
        }
      } else {
        // Visible pages are paginated with maxSize
        startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;

        // Adjust last page if limit is exceeded
        endPage = Math.min(startPage + maxSize - 1, totalPages);
      }
    }

    // Add page number links
    for (var number = startPage; number <= endPage; number++) {
      var page = makePage(number, pageLabel(number), number === currentPage);
      pages.push(page);
    }

    // Add links to move between page sets
    if (isMaxSized && maxSize > 0 && (!rotate || forceEllipses || boundaryLinkNumbers)) {
      if (startPage > 1) {
        if (!boundaryLinkNumbers || startPage > 3) { //need ellipsis for all options unless range is too close to beginning
        var previousPageSet = makePage(startPage - 1, '...', false);
        pages.unshift(previousPageSet);
      }
        if (boundaryLinkNumbers) {
          if (startPage === 3) { //need to replace ellipsis when the buttons would be sequential
            var secondPageLink = makePage(2, '2', false);
            pages.unshift(secondPageLink);
          }
          //add the first page
          var firstPageLink = makePage(1, '1', false);
          pages.unshift(firstPageLink);
        }
      }

      if (endPage < totalPages) {
        if (!boundaryLinkNumbers || endPage < totalPages - 2) { //need ellipsis for all options unless range is too close to end
        var nextPageSet = makePage(endPage + 1, '...', false);
        pages.push(nextPageSet);
      }
        if (boundaryLinkNumbers) {
          if (endPage === totalPages - 2) { //need to replace ellipsis when the buttons would be sequential
            var secondToLastPageLink = makePage(totalPages - 1, totalPages - 1, false);
            pages.push(secondToLastPageLink);
          }
          //add the last page
          var lastPageLink = makePage(totalPages, totalPages, false);
          pages.push(lastPageLink);
        }
      }
    }
    return pages;
  }

  var originalRender = this.render;
  this.render = function() {
    originalRender();
    if ($scope.page > 0 && $scope.page <= $scope.totalPages) {
      $scope.pages = getPages($scope.page, $scope.totalPages);
    }
  };
}])

.constant('uibPaginationConfig', {
  itemsPerPage: 10,
  boundaryLinks: false,
  boundaryLinkNumbers: false,
  directionLinks: true,
  firstText: 'First',
  previousText: 'Previous',
  nextText: 'Next',
  lastText: 'Last',
  rotate: true,
  forceEllipses: false
})

.directive('uibPagination', ['$parse', 'uibPaginationConfig', function($parse, uibPaginationConfig) {
  return {
    scope: {
      totalItems: '=',
      firstText: '@',
      previousText: '@',
      nextText: '@',
      lastText: '@',
      ngDisabled:'='
    },
    require: ['uibPagination', '?ngModel'],
    restrict: 'A',
    controller: 'UibPaginationController',
    controllerAs: 'pagination',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/pagination/pagination.html';
    },
    link: function(scope, element, attrs, ctrls) {
      element.addClass('pagination');
      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if (!ngModelCtrl) {
         return; // do nothing if no ng-model
      }

      paginationCtrl.init(ngModelCtrl, uibPaginationConfig);
    }
  };
}]);

/**
 * The following features are still outstanding: animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, html tooltips, and selector delegation.
 */
angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.stackedMap'])

/**
 * The $tooltip service creates tooltip- and popover-like directives as well as
 * houses global options for them.
 */
.provider('$uibTooltip', function() {
  // The default options tooltip and popover.
  var defaultOptions = {
    placement: 'top',
    placementClassPrefix: '',
    animation: true,
    popupDelay: 0,
    popupCloseDelay: 0,
    useContentExp: false
  };

  // Default hide triggers for each show trigger
  var triggerMap = {
    'mouseenter': 'mouseleave',
    'click': 'click',
    'outsideClick': 'outsideClick',
    'focus': 'blur',
    'none': ''
  };

  // The options specified to the provider globally.
  var globalOptions = {};

  /**
   * `options({})` allows global configuration of all tooltips in the
   * application.
   *
   *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
   *     // place tooltips left instead of top by default
   *     $tooltipProvider.options( { placement: 'left' } );
   *   });
   */
	this.options = function(value) {
		angular.extend(globalOptions, value);
	};

  /**
   * This allows you to extend the set of trigger mappings available. E.g.:
   *
   *   $tooltipProvider.setTriggers( { 'openTrigger': 'closeTrigger' } );
   */
  this.setTriggers = function setTriggers(triggers) {
    angular.extend(triggerMap, triggers);
  };

  /**
   * This is a helper function for translating camel-case to snake_case.
   */
  function snake_case(name) {
    var regexp = /[A-Z]/g;
    var separator = '-';
    return name.replace(regexp, function(letter, pos) {
      return (pos ? separator : '') + letter.toLowerCase();
    });
  }

  /**
   * Returns the actual instance of the $tooltip service.
   * TODO support multiple triggers
   */
  this.$get = ['$window', '$compile', '$timeout', '$document', '$uibPosition', '$interpolate', '$rootScope', '$parse', '$$stackedMap', function($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse, $$stackedMap) {
    var openedTooltips = $$stackedMap.createNew();
    $document.on('keyup', keypressListener);

    $rootScope.$on('$destroy', function() {
      $document.off('keyup', keypressListener);
    });

    function keypressListener(e) {
      if (e.which === 27) {
        var last = openedTooltips.top();
        if (last) {
          last.value.close();
          last = null;
        }
      }
    }

    return function $tooltip(ttType, prefix, defaultTriggerShow, options) {
      options = angular.extend({}, defaultOptions, globalOptions, options);

      /**
       * Returns an object of show and hide triggers.
       *
       * If a trigger is supplied,
       * it is used to show the tooltip; otherwise, it will use the `trigger`
       * option passed to the `$tooltipProvider.options` method; else it will
       * default to the trigger supplied to this directive factory.
       *
       * The hide trigger is based on the show trigger. If the `trigger` option
       * was passed to the `$tooltipProvider.options` method, it will use the
       * mapped trigger from `triggerMap` or the passed trigger if the map is
       * undefined; otherwise, it uses the `triggerMap` value of the show
       * trigger; else it will just use the show trigger.
       */
      function getTriggers(trigger) {
        var show = (trigger || options.trigger || defaultTriggerShow).split(' ');
        var hide = show.map(function(trigger) {
          return triggerMap[trigger] || trigger;
        });
        return {
          show: show,
          hide: hide
        };
      }

      var directiveName = snake_case(ttType);

      var startSym = $interpolate.startSymbol();
      var endSym = $interpolate.endSymbol();
      var template =
        '<div '+ directiveName + '-popup ' +
          'uib-title="' + startSym + 'title' + endSym + '" ' +
          (options.useContentExp ?
            'content-exp="contentExp()" ' :
            'content="' + startSym + 'content' + endSym + '" ') +
          'origin-scope="origScope" ' +
          'class="uib-position-measure ' + prefix + '" ' +
          'tooltip-animation-class="fade"' +
          'uib-tooltip-classes ' +
          'ng-class="{ in: isOpen }" ' +
          '>' +
        '</div>';

      return {
        compile: function(tElem, tAttrs) {
          var tooltipLinker = $compile(template);

          return function link(scope, element, attrs, tooltipCtrl) {
            var tooltip;
            var tooltipLinkedScope;
            var transitionTimeout;
            var showTimeout;
            var hideTimeout;
            var positionTimeout;
            var adjustmentTimeout;
            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
            var triggers = getTriggers(undefined);
            var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
            var ttScope = scope.$new(true);
            var repositionScheduled = false;
            var isOpenParse = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;
            var contentParse = options.useContentExp ? $parse(attrs[ttType]) : false;
            var observers = [];
            var lastPlacement;

            var positionTooltip = function() {
              // check if tooltip exists and is not empty
              if (!tooltip || !tooltip.html()) { return; }

              if (!positionTimeout) {
                positionTimeout = $timeout(function() {
                  var ttPosition = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
                  var initialHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
                  var elementPos = appendToBody ? $position.offset(element) : $position.position(element);
                  tooltip.css({ top: ttPosition.top + 'px', left: ttPosition.left + 'px' });
                  var placementClasses = ttPosition.placement.split('-');

                  if (!tooltip.hasClass(placementClasses[0])) {
                    tooltip.removeClass(lastPlacement.split('-')[0]);
                    tooltip.addClass(placementClasses[0]);
                  }

                  if (!tooltip.hasClass(options.placementClassPrefix + ttPosition.placement)) {
                    tooltip.removeClass(options.placementClassPrefix + lastPlacement);
                    tooltip.addClass(options.placementClassPrefix + ttPosition.placement);
                  }

                  adjustmentTimeout = $timeout(function() {
                    var currentHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
                    var adjustment = $position.adjustTop(placementClasses, elementPos, initialHeight, currentHeight);
                    if (adjustment) {
                      tooltip.css(adjustment);
                    }
                    adjustmentTimeout = null;
                  }, 0, false);

                  // first time through tt element will have the
                  // uib-position-measure class or if the placement
                  // has changed we need to position the arrow.
                  if (tooltip.hasClass('uib-position-measure')) {
                    $position.positionArrow(tooltip, ttPosition.placement);
                    tooltip.removeClass('uib-position-measure');
                  } else if (lastPlacement !== ttPosition.placement) {
                    $position.positionArrow(tooltip, ttPosition.placement);
                  }
                  lastPlacement = ttPosition.placement;

                  positionTimeout = null;
                }, 0, false);
              }
            };

            // Set up the correct scope to allow transclusion later
            ttScope.origScope = scope;

            // By default, the tooltip is not open.
            // TODO add ability to start tooltip opened
            ttScope.isOpen = false;

            function toggleTooltipBind() {
              if (!ttScope.isOpen) {
                showTooltipBind();
              } else {
                hideTooltipBind();
              }
            }

            // Show the tooltip with delay if specified, otherwise show it immediately
            function showTooltipBind() {
              if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
                return;
              }

              cancelHide();
              prepareTooltip();

              if (ttScope.popupDelay) {
                // Do nothing if the tooltip was already scheduled to pop-up.
                // This happens if show is triggered multiple times before any hide is triggered.
                if (!showTimeout) {
                  showTimeout = $timeout(show, ttScope.popupDelay, false);
                }
              } else {
                show();
              }
            }

            function hideTooltipBind() {
              cancelShow();

              if (ttScope.popupCloseDelay) {
                if (!hideTimeout) {
                  hideTimeout = $timeout(hide, ttScope.popupCloseDelay, false);
                }
              } else {
                hide();
              }
            }

            // Show the tooltip popup element.
            function show() {
              cancelShow();
              cancelHide();

              // Don't show empty tooltips.
              if (!ttScope.content) {
                return angular.noop;
              }

              createTooltip();

              // And show the tooltip.
              ttScope.$evalAsync(function() {
                ttScope.isOpen = true;
                assignIsOpen(true);
                positionTooltip();
              });
            }

            function cancelShow() {
              if (showTimeout) {
                $timeout.cancel(showTimeout);
                showTimeout = null;
              }

              if (positionTimeout) {
                $timeout.cancel(positionTimeout);
                positionTimeout = null;
              }
            }

            // Hide the tooltip popup element.
            function hide() {
              if (!ttScope) {
                return;
              }

              // First things first: we don't show it anymore.
              ttScope.$evalAsync(function() {
                if (ttScope) {
                  ttScope.isOpen = false;
                  assignIsOpen(false);
                  // And now we remove it from the DOM. However, if we have animation, we
                  // need to wait for it to expire beforehand.
                  // FIXME: this is a placeholder for a port of the transitions library.
                  // The fade transition in TWBS is 150ms.
                  if (ttScope.animation) {
                    if (!transitionTimeout) {
                      transitionTimeout = $timeout(removeTooltip, 150, false);
                    }
                  } else {
                    removeTooltip();
                  }
                }
              });
            }

            function cancelHide() {
              if (hideTimeout) {
                $timeout.cancel(hideTimeout);
                hideTimeout = null;
              }

              if (transitionTimeout) {
                $timeout.cancel(transitionTimeout);
                transitionTimeout = null;
              }
            }

            function createTooltip() {
              // There can only be one tooltip element per directive shown at once.
              if (tooltip) {
                return;
              }

              tooltipLinkedScope = ttScope.$new();
              tooltip = tooltipLinker(tooltipLinkedScope, function(tooltip) {
                if (appendToBody) {
                  $document.find('body').append(tooltip);
                } else {
                  element.after(tooltip);
                }
              });

              openedTooltips.add(ttScope, {
                close: hide
              });

              prepObservers();
            }

            function removeTooltip() {
              cancelShow();
              cancelHide();
              unregisterObservers();

              if (tooltip) {
                tooltip.remove();
                
                tooltip = null;
                if (adjustmentTimeout) {
                  $timeout.cancel(adjustmentTimeout);
                }
              }

              openedTooltips.remove(ttScope);
              
              if (tooltipLinkedScope) {
                tooltipLinkedScope.$destroy();
                tooltipLinkedScope = null;
              }
            }

            /**
             * Set the initial scope values. Once
             * the tooltip is created, the observers
             * will be added to keep things in sync.
             */
            function prepareTooltip() {
              ttScope.title = attrs[prefix + 'Title'];
              if (contentParse) {
                ttScope.content = contentParse(scope);
              } else {
                ttScope.content = attrs[ttType];
              }

              ttScope.popupClass = attrs[prefix + 'Class'];
              ttScope.placement = angular.isDefined(attrs[prefix + 'Placement']) ? attrs[prefix + 'Placement'] : options.placement;
              var placement = $position.parsePlacement(ttScope.placement);
              lastPlacement = placement[1] ? placement[0] + '-' + placement[1] : placement[0];

              var delay = parseInt(attrs[prefix + 'PopupDelay'], 10);
              var closeDelay = parseInt(attrs[prefix + 'PopupCloseDelay'], 10);
              ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
              ttScope.popupCloseDelay = !isNaN(closeDelay) ? closeDelay : options.popupCloseDelay;
            }

            function assignIsOpen(isOpen) {
              if (isOpenParse && angular.isFunction(isOpenParse.assign)) {
                isOpenParse.assign(scope, isOpen);
              }
            }

            ttScope.contentExp = function() {
              return ttScope.content;
            };

            /**
             * Observe the relevant attributes.
             */
            attrs.$observe('disabled', function(val) {
              if (val) {
                cancelShow();
              }

              if (val && ttScope.isOpen) {
                hide();
              }
            });

            if (isOpenParse) {
              scope.$watch(isOpenParse, function(val) {
                if (ttScope && !val === ttScope.isOpen) {
                  toggleTooltipBind();
                }
              });
            }

            function prepObservers() {
              observers.length = 0;

              if (contentParse) {
                observers.push(
                  scope.$watch(contentParse, function(val) {
                    ttScope.content = val;
                    if (!val && ttScope.isOpen) {
                      hide();
                    }
                  })
                );

                observers.push(
                  tooltipLinkedScope.$watch(function() {
                    if (!repositionScheduled) {
                      repositionScheduled = true;
                      tooltipLinkedScope.$$postDigest(function() {
                        repositionScheduled = false;
                        if (ttScope && ttScope.isOpen) {
                          positionTooltip();
                        }
                      });
                    }
                  })
                );
              } else {
                observers.push(
                  attrs.$observe(ttType, function(val) {
                    ttScope.content = val;
                    if (!val && ttScope.isOpen) {
                      hide();
                    } else {
                      positionTooltip();
                    }
                  })
                );
              }

              observers.push(
                attrs.$observe(prefix + 'Title', function(val) {
                  ttScope.title = val;
                  if (ttScope.isOpen) {
                    positionTooltip();
                  }
                })
              );

              observers.push(
                attrs.$observe(prefix + 'Placement', function(val) {
                  ttScope.placement = val ? val : options.placement;
                  if (ttScope.isOpen) {
                    positionTooltip();
                  }
                })
              );
            }

            function unregisterObservers() {
              if (observers.length) {
                angular.forEach(observers, function(observer) {
                  observer();
                });
                observers.length = 0;
              }
            }

            // hide tooltips/popovers for outsideClick trigger
            function bodyHideTooltipBind(e) {
              if (!ttScope || !ttScope.isOpen || !tooltip) {
                return;
              }
              // make sure the tooltip/popover link or tool tooltip/popover itself were not clicked
              if (!element[0].contains(e.target) && !tooltip[0].contains(e.target)) {
                hideTooltipBind();
              }
            }

            // KeyboardEvent handler to hide the tooltip on Escape key press
            function hideOnEscapeKey(e) {
              if (e.which === 27) {
                hideTooltipBind();
              }
            }

            var unregisterTriggers = function() {
              triggers.show.forEach(function(trigger) {
                if (trigger === 'outsideClick') {
                  element.off('click', toggleTooltipBind);
                } else {
                  element.off(trigger, showTooltipBind);
                  element.off(trigger, toggleTooltipBind);
                }
                element.off('keypress', hideOnEscapeKey);
              });
              triggers.hide.forEach(function(trigger) {
                if (trigger === 'outsideClick') {
                  $document.off('click', bodyHideTooltipBind);
                } else {
                  element.off(trigger, hideTooltipBind);
                }
              });
            };

            function prepTriggers() {
              var showTriggers = [], hideTriggers = [];
              var val = scope.$eval(attrs[prefix + 'Trigger']);
              unregisterTriggers();

              if (angular.isObject(val)) {
                Object.keys(val).forEach(function(key) {
                  showTriggers.push(key);
                  hideTriggers.push(val[key]);
                });
                triggers = {
                  show: showTriggers,
                  hide: hideTriggers
                };
              } else {
                triggers = getTriggers(val);
              }

              if (triggers.show !== 'none') {
                triggers.show.forEach(function(trigger, idx) {
                  if (trigger === 'outsideClick') {
                    element.on('click', toggleTooltipBind);
                    $document.on('click', bodyHideTooltipBind);
                  } else if (trigger === triggers.hide[idx]) {
                    element.on(trigger, toggleTooltipBind);
                  } else if (trigger) {
                    element.on(trigger, showTooltipBind);
                    element.on(triggers.hide[idx], hideTooltipBind);
                  }
                  element.on('keypress', hideOnEscapeKey);
                });
              }
            }

            prepTriggers();

            var animation = scope.$eval(attrs[prefix + 'Animation']);
            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;

            var appendToBodyVal;
            var appendKey = prefix + 'AppendToBody';
            if (appendKey in attrs && attrs[appendKey] === undefined) {
              appendToBodyVal = true;
            } else {
              appendToBodyVal = scope.$eval(attrs[appendKey]);
            }

            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;

            // Make sure tooltip is destroyed and removed.
            scope.$on('$destroy', function onDestroyTooltip() {
              unregisterTriggers();
              removeTooltip();
              ttScope = null;
            });
          };
        }
      };
    };
  }];
})

// This is mostly ngInclude code but with a custom scope
.directive('uibTooltipTemplateTransclude', [
         '$animate', '$sce', '$compile', '$templateRequest',
function ($animate, $sce, $compile, $templateRequest) {
  return {
    link: function(scope, elem, attrs) {
      var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);

      var changeCounter = 0,
        currentScope,
        previousElement,
        currentElement;

      var cleanupLastIncludeContent = function() {
        if (previousElement) {
          previousElement.remove();
          previousElement = null;
        }

        if (currentScope) {
          currentScope.$destroy();
          currentScope = null;
        }

        if (currentElement) {
          $animate.leave(currentElement).then(function() {
            previousElement = null;
          });
          previousElement = currentElement;
          currentElement = null;
        }
      };

      scope.$watch($sce.parseAsResourceUrl(attrs.uibTooltipTemplateTransclude), function(src) {
        var thisChangeId = ++changeCounter;

        if (src) {
          //set the 2nd param to true to ignore the template request error so that the inner
          //contents and scope can be cleaned up.
          $templateRequest(src, true).then(function(response) {
            if (thisChangeId !== changeCounter) { return; }
            var newScope = origScope.$new();
            var template = response;

            var clone = $compile(template)(newScope, function(clone) {
              cleanupLastIncludeContent();
              $animate.enter(clone, elem);
            });

            currentScope = newScope;
            currentElement = clone;

            currentScope.$emit('$includeContentLoaded', src);
          }, function() {
            if (thisChangeId === changeCounter) {
              cleanupLastIncludeContent();
              scope.$emit('$includeContentError', src);
            }
          });
          scope.$emit('$includeContentRequested', src);
        } else {
          cleanupLastIncludeContent();
        }
      });

      scope.$on('$destroy', cleanupLastIncludeContent);
    }
  };
}])

/**
 * Note that it's intentional that these classes are *not* applied through $animate.
 * They must not be animated as they're expected to be present on the tooltip on
 * initialization.
 */
.directive('uibTooltipClasses', ['$uibPosition', function($uibPosition) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      // need to set the primary position so the
      // arrow has space during position measure.
      // tooltip.positionTooltip()
      if (scope.placement) {
        // // There are no top-left etc... classes
        // // in TWBS, so we need the primary position.
        var position = $uibPosition.parsePlacement(scope.placement);
        element.addClass(position[0]);
      }

      if (scope.popupClass) {
        element.addClass(scope.popupClass);
      }

      if (scope.animation) {
        element.addClass(attrs.tooltipAnimationClass);
      }
    }
  };
}])

.directive('uibTooltipPopup', function() {
  return {
    restrict: 'A',
    scope: { content: '@' },
    templateUrl: 'uib/template/tooltip/tooltip-popup.html'
  };
})

.directive('uibTooltip', [ '$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibTooltip', 'tooltip', 'mouseenter');
}])

.directive('uibTooltipTemplatePopup', function() {
  return {
    restrict: 'A',
    scope: { contentExp: '&', originScope: '&' },
    templateUrl: 'uib/template/tooltip/tooltip-template-popup.html'
  };
})

.directive('uibTooltipTemplate', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibTooltipTemplate', 'tooltip', 'mouseenter', {
    useContentExp: true
  });
}])

.directive('uibTooltipHtmlPopup', function() {
  return {
    restrict: 'A',
    scope: { contentExp: '&' },
    templateUrl: 'uib/template/tooltip/tooltip-html-popup.html'
  };
})

.directive('uibTooltipHtml', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibTooltipHtml', 'tooltip', 'mouseenter', {
    useContentExp: true
  });
}]);

/**
 * The following features are still outstanding: popup delay, animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, and selector delegatation.
 */
angular.module('ui.bootstrap.popover', ['ui.bootstrap.tooltip'])

.directive('uibPopoverTemplatePopup', function() {
  return {
    restrict: 'A',
    scope: { uibTitle: '@', contentExp: '&', originScope: '&' },
    templateUrl: 'uib/template/popover/popover-template.html'
  };
})

.directive('uibPopoverTemplate', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibPopoverTemplate', 'popover', 'click', {
    useContentExp: true
  });
}])

.directive('uibPopoverHtmlPopup', function() {
  return {
    restrict: 'A',
    scope: { contentExp: '&', uibTitle: '@' },
    templateUrl: 'uib/template/popover/popover-html.html'
  };
})

.directive('uibPopoverHtml', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibPopoverHtml', 'popover', 'click', {
    useContentExp: true
  });
}])

.directive('uibPopoverPopup', function() {
  return {
    restrict: 'A',
    scope: { uibTitle: '@', content: '@' },
    templateUrl: 'uib/template/popover/popover.html'
  };
})

.directive('uibPopover', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibPopover', 'popover', 'click');
}]);

angular.module('ui.bootstrap.progressbar', [])

.constant('uibProgressConfig', {
  animate: true,
  max: 100
})

.controller('UibProgressController', ['$scope', '$attrs', 'uibProgressConfig', function($scope, $attrs, progressConfig) {
  var self = this,
      animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;

  this.bars = [];
  $scope.max = getMaxOrDefault();

  this.addBar = function(bar, element, attrs) {
    if (!animate) {
      element.css({'transition': 'none'});
    }

    this.bars.push(bar);

    bar.max = getMaxOrDefault();
    bar.title = attrs && angular.isDefined(attrs.title) ? attrs.title : 'progressbar';

    bar.$watch('value', function(value) {
      bar.recalculatePercentage();
    });

    bar.recalculatePercentage = function() {
      var totalPercentage = self.bars.reduce(function(total, bar) {
        bar.percent = +(100 * bar.value / bar.max).toFixed(2);
        return total + bar.percent;
      }, 0);

      if (totalPercentage > 100) {
        bar.percent -= totalPercentage - 100;
      }
    };

    bar.$on('$destroy', function() {
      element = null;
      self.removeBar(bar);
    });
  };

  this.removeBar = function(bar) {
    this.bars.splice(this.bars.indexOf(bar), 1);
    this.bars.forEach(function (bar) {
      bar.recalculatePercentage();
    });
  };

  //$attrs.$observe('maxParam', function(maxParam) {
  $scope.$watch('maxParam', function(maxParam) {
    self.bars.forEach(function(bar) {
      bar.max = getMaxOrDefault();
      bar.recalculatePercentage();
    });
  });

  function getMaxOrDefault () {
    return angular.isDefined($scope.maxParam) ? $scope.maxParam : progressConfig.max;
  }
}])

.directive('uibProgress', function() {
  return {
    replace: true,
    transclude: true,
    controller: 'UibProgressController',
    require: 'uibProgress',
    scope: {
      maxParam: '=?max'
    },
    templateUrl: 'uib/template/progressbar/progress.html'
  };
})

.directive('uibBar', function() {
  return {
    replace: true,
    transclude: true,
    require: '^uibProgress',
    scope: {
      value: '=',
      type: '@'
    },
    templateUrl: 'uib/template/progressbar/bar.html',
    link: function(scope, element, attrs, progressCtrl) {
      progressCtrl.addBar(scope, element, attrs);
    }
  };
})

.directive('uibProgressbar', function() {
  return {
    replace: true,
    transclude: true,
    controller: 'UibProgressController',
    scope: {
      value: '=',
      maxParam: '=?max',
      type: '@'
    },
    templateUrl: 'uib/template/progressbar/progressbar.html',
    link: function(scope, element, attrs, progressCtrl) {
      progressCtrl.addBar(scope, angular.element(element.children()[0]), {title: attrs.title});
    }
  };
});

angular.module('ui.bootstrap.rating', [])

.constant('uibRatingConfig', {
  max: 5,
  stateOn: null,
  stateOff: null,
  enableReset: true,
  titles: ['one', 'two', 'three', 'four', 'five']
})

.controller('UibRatingController', ['$scope', '$attrs', 'uibRatingConfig', function($scope, $attrs, ratingConfig) {
  var ngModelCtrl = { $setViewValue: angular.noop },
    self = this;

  this.init = function(ngModelCtrl_) {
    ngModelCtrl = ngModelCtrl_;
    ngModelCtrl.$render = this.render;

    ngModelCtrl.$formatters.push(function(value) {
      if (angular.isNumber(value) && value << 0 !== value) {
        value = Math.round(value);
      }

      return value;
    });

    this.stateOn = angular.isDefined($attrs.stateOn) ? $scope.$parent.$eval($attrs.stateOn) : ratingConfig.stateOn;
    this.stateOff = angular.isDefined($attrs.stateOff) ? $scope.$parent.$eval($attrs.stateOff) : ratingConfig.stateOff;
    this.enableReset = angular.isDefined($attrs.enableReset) ?
      $scope.$parent.$eval($attrs.enableReset) : ratingConfig.enableReset;
    var tmpTitles = angular.isDefined($attrs.titles) ? $scope.$parent.$eval($attrs.titles) : ratingConfig.titles;
    this.titles = angular.isArray(tmpTitles) && tmpTitles.length > 0 ?
      tmpTitles : ratingConfig.titles;

    var ratingStates = angular.isDefined($attrs.ratingStates) ?
      $scope.$parent.$eval($attrs.ratingStates) :
      new Array(angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : ratingConfig.max);
    $scope.range = this.buildTemplateObjects(ratingStates);
  };

  this.buildTemplateObjects = function(states) {
    for (var i = 0, n = states.length; i < n; i++) {
      states[i] = angular.extend({ index: i }, { stateOn: this.stateOn, stateOff: this.stateOff, title: this.getTitle(i) }, states[i]);
    }
    return states;
  };

  this.getTitle = function(index) {
    if (index >= this.titles.length) {
      return index + 1;
    }

    return this.titles[index];
  };

  $scope.rate = function(value) {
    if (!$scope.readonly && value >= 0 && value <= $scope.range.length) {
      var newViewValue = self.enableReset && ngModelCtrl.$viewValue === value ? 0 : value;
      ngModelCtrl.$setViewValue(newViewValue);
      ngModelCtrl.$render();
    }
  };

  $scope.enter = function(value) {
    if (!$scope.readonly) {
      $scope.value = value;
    }
    $scope.onHover({value: value});
  };

  $scope.reset = function() {
    $scope.value = ngModelCtrl.$viewValue;
    $scope.onLeave();
  };

  $scope.onKeydown = function(evt) {
    if (/(37|38|39|40)/.test(evt.which)) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.rate($scope.value + (evt.which === 38 || evt.which === 39 ? 1 : -1));
    }
  };

  this.render = function() {
    $scope.value = ngModelCtrl.$viewValue;
    $scope.title = self.getTitle($scope.value - 1);
  };
}])

.directive('uibRating', function() {
  return {
    require: ['uibRating', 'ngModel'],
    restrict: 'A',
    scope: {
      readonly: '=?readOnly',
      onHover: '&',
      onLeave: '&'
    },
    controller: 'UibRatingController',
    templateUrl: 'uib/template/rating/rating.html',
    link: function(scope, element, attrs, ctrls) {
      var ratingCtrl = ctrls[0], ngModelCtrl = ctrls[1];
      ratingCtrl.init(ngModelCtrl);
    }
  };
});

angular.module('ui.bootstrap.tabs', [])

.controller('UibTabsetController', ['$scope', function ($scope) {
  var ctrl = this,
    oldIndex;
  ctrl.tabs = [];

  ctrl.select = function(index, evt) {
    if (!destroyed) {
      var previousIndex = findTabIndex(oldIndex);
      var previousSelected = ctrl.tabs[previousIndex];
      if (previousSelected) {
        previousSelected.tab.onDeselect({
          $event: evt,
          $selectedIndex: index
        });
        if (evt && evt.isDefaultPrevented()) {
          return;
        }
        previousSelected.tab.active = false;
      }

      var selected = ctrl.tabs[index];
      if (selected) {
        selected.tab.onSelect({
          $event: evt
        });
        selected.tab.active = true;
        ctrl.active = selected.index;
        oldIndex = selected.index;
      } else if (!selected && angular.isDefined(oldIndex)) {
        ctrl.active = null;
        oldIndex = null;
      }
    }
  };

  ctrl.addTab = function addTab(tab) {
    ctrl.tabs.push({
      tab: tab,
      index: tab.index
    });
    ctrl.tabs.sort(function(t1, t2) {
      if (t1.index > t2.index) {
        return 1;
      }

      if (t1.index < t2.index) {
        return -1;
      }

      return 0;
    });

    if (tab.index === ctrl.active || !angular.isDefined(ctrl.active) && ctrl.tabs.length === 1) {
      var newActiveIndex = findTabIndex(tab.index);
      ctrl.select(newActiveIndex);
    }
  };

  ctrl.removeTab = function removeTab(tab) {
    var index;
    for (var i = 0; i < ctrl.tabs.length; i++) {
      if (ctrl.tabs[i].tab === tab) {
        index = i;
        break;
      }
    }

    if (ctrl.tabs[index].index === ctrl.active) {
      var newActiveTabIndex = index === ctrl.tabs.length - 1 ?
        index - 1 : index + 1 % ctrl.tabs.length;
      ctrl.select(newActiveTabIndex);
    }

    ctrl.tabs.splice(index, 1);
  };

  $scope.$watch('tabset.active', function(val) {
    if (angular.isDefined(val) && val !== oldIndex) {
      ctrl.select(findTabIndex(val));
    }
  });

  var destroyed;
  $scope.$on('$destroy', function() {
    destroyed = true;
  });

  function findTabIndex(index) {
    for (var i = 0; i < ctrl.tabs.length; i++) {
      if (ctrl.tabs[i].index === index) {
        return i;
      }
    }
  }
}])

.directive('uibTabset', function() {
  return {
    transclude: true,
    replace: true,
    scope: {},
    bindToController: {
      active: '=?',
      type: '@'
    },
    controller: 'UibTabsetController',
    controllerAs: 'tabset',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/tabs/tabset.html';
    },
    link: function(scope, element, attrs) {
      scope.vertical = angular.isDefined(attrs.vertical) ?
        scope.$parent.$eval(attrs.vertical) : false;
      scope.justified = angular.isDefined(attrs.justified) ?
        scope.$parent.$eval(attrs.justified) : false;
    }
  };
})

.directive('uibTab', ['$parse', function($parse) {
  return {
    require: '^uibTabset',
    replace: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/tabs/tab.html';
    },
    transclude: true,
    scope: {
      heading: '@',
      index: '=?',
      classes: '@?',
      onSelect: '&select', //This callback is called in contentHeadingTransclude
                          //once it inserts the tab's content into the dom
      onDeselect: '&deselect'
    },
    controller: function() {
      //Empty controller so other directives can require being 'under' a tab
    },
    controllerAs: 'tab',
    link: function(scope, elm, attrs, tabsetCtrl, transclude) {
      scope.disabled = false;
      if (attrs.disable) {
        scope.$parent.$watch($parse(attrs.disable), function(value) {
          scope.disabled = !! value;
        });
      }

      if (angular.isUndefined(attrs.index)) {
        if (tabsetCtrl.tabs && tabsetCtrl.tabs.length) {
          scope.index = Math.max.apply(null, tabsetCtrl.tabs.map(function(t) { return t.index; })) + 1;
        } else {
          scope.index = 0;
        }
      }

      if (angular.isUndefined(attrs.classes)) {
        scope.classes = '';
      }

      scope.select = function(evt) {
        if (!scope.disabled) {
          var index;
          for (var i = 0; i < tabsetCtrl.tabs.length; i++) {
            if (tabsetCtrl.tabs[i].tab === scope) {
              index = i;
              break;
            }
          }

          tabsetCtrl.select(index, evt);
        }
      };

      tabsetCtrl.addTab(scope);
      scope.$on('$destroy', function() {
        tabsetCtrl.removeTab(scope);
      });

      //We need to transclude later, once the content container is ready.
      //when this link happens, we're inside a tab heading.
      scope.$transcludeFn = transclude;
    }
  };
}])

.directive('uibTabHeadingTransclude', function() {
  return {
    restrict: 'A',
    require: '^uibTab',
    link: function(scope, elm) {
      scope.$watch('headingElement', function updateHeadingElement(heading) {
        if (heading) {
          elm.html('');
          elm.append(heading);
        }
      });
    }
  };
})

.directive('uibTabContentTransclude', function() {
  return {
    restrict: 'A',
    require: '^uibTabset',
    link: function(scope, elm, attrs) {
      var tab = scope.$eval(attrs.uibTabContentTransclude).tab;

      //Now our tab is ready to be transcluded: both the tab heading area
      //and the tab content area are loaded.  Transclude 'em both.
      tab.$transcludeFn(tab.$parent, function(contents) {
        angular.forEach(contents, function(node) {
          if (isTabHeading(node)) {
            //Let tabHeadingTransclude know.
            tab.headingElement = node;
          } else {
            elm.append(node);
          }
        });
      });
    }
  };

  function isTabHeading(node) {
    return node.tagName && (
      node.hasAttribute('uib-tab-heading') ||
      node.hasAttribute('data-uib-tab-heading') ||
      node.hasAttribute('x-uib-tab-heading') ||
      node.tagName.toLowerCase() === 'uib-tab-heading' ||
      node.tagName.toLowerCase() === 'data-uib-tab-heading' ||
      node.tagName.toLowerCase() === 'x-uib-tab-heading' ||
      node.tagName.toLowerCase() === 'uib:tab-heading'
    );
  }
});

angular.module('ui.bootstrap.timepicker', [])

.constant('uibTimepickerConfig', {
  hourStep: 1,
  minuteStep: 1,
  secondStep: 1,
  showMeridian: true,
  showSeconds: false,
  meridians: null,
  readonlyInput: false,
  mousewheel: true,
  arrowkeys: true,
  showSpinners: true,
  templateUrl: 'uib/template/timepicker/timepicker.html'
})

.controller('UibTimepickerController', ['$scope', '$element', '$attrs', '$parse', '$log', '$locale', 'uibTimepickerConfig', function($scope, $element, $attrs, $parse, $log, $locale, timepickerConfig) {
  var hoursModelCtrl, minutesModelCtrl, secondsModelCtrl;
  var selected = new Date(),
    watchers = [],
    ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
    meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS,
    padHours = angular.isDefined($attrs.padHours) ? $scope.$parent.$eval($attrs.padHours) : true;

  $scope.tabindex = angular.isDefined($attrs.tabindex) ? $attrs.tabindex : 0;
  $element.removeAttr('tabindex');

  this.init = function(ngModelCtrl_, inputs) {
    ngModelCtrl = ngModelCtrl_;
    ngModelCtrl.$render = this.render;

    ngModelCtrl.$formatters.unshift(function(modelValue) {
      return modelValue ? new Date(modelValue) : null;
    });

    var hoursInputEl = inputs.eq(0),
        minutesInputEl = inputs.eq(1),
        secondsInputEl = inputs.eq(2);

    hoursModelCtrl = hoursInputEl.controller('ngModel');
    minutesModelCtrl = minutesInputEl.controller('ngModel');
    secondsModelCtrl = secondsInputEl.controller('ngModel');

    var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;

    if (mousewheel) {
      this.setupMousewheelEvents(hoursInputEl, minutesInputEl, secondsInputEl);
    }

    var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : timepickerConfig.arrowkeys;
    if (arrowkeys) {
      this.setupArrowkeyEvents(hoursInputEl, minutesInputEl, secondsInputEl);
    }

    $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
    this.setupInputEvents(hoursInputEl, minutesInputEl, secondsInputEl);
  };

  var hourStep = timepickerConfig.hourStep;
  if ($attrs.hourStep) {
    watchers.push($scope.$parent.$watch($parse($attrs.hourStep), function(value) {
      hourStep = +value;
    }));
  }

  var minuteStep = timepickerConfig.minuteStep;
  if ($attrs.minuteStep) {
    watchers.push($scope.$parent.$watch($parse($attrs.minuteStep), function(value) {
      minuteStep = +value;
    }));
  }

  var min;
  watchers.push($scope.$parent.$watch($parse($attrs.min), function(value) {
    var dt = new Date(value);
    min = isNaN(dt) ? undefined : dt;
  }));

  var max;
  watchers.push($scope.$parent.$watch($parse($attrs.max), function(value) {
    var dt = new Date(value);
    max = isNaN(dt) ? undefined : dt;
  }));

  var disabled = false;
  if ($attrs.ngDisabled) {
    watchers.push($scope.$parent.$watch($parse($attrs.ngDisabled), function(value) {
      disabled = value;
    }));
  }

  $scope.noIncrementHours = function() {
    var incrementedSelected = addMinutes(selected, hourStep * 60);
    return disabled || incrementedSelected > max ||
      incrementedSelected < selected && incrementedSelected < min;
  };

  $scope.noDecrementHours = function() {
    var decrementedSelected = addMinutes(selected, -hourStep * 60);
    return disabled || decrementedSelected < min ||
      decrementedSelected > selected && decrementedSelected > max;
  };

  $scope.noIncrementMinutes = function() {
    var incrementedSelected = addMinutes(selected, minuteStep);
    return disabled || incrementedSelected > max ||
      incrementedSelected < selected && incrementedSelected < min;
  };

  $scope.noDecrementMinutes = function() {
    var decrementedSelected = addMinutes(selected, -minuteStep);
    return disabled || decrementedSelected < min ||
      decrementedSelected > selected && decrementedSelected > max;
  };

  $scope.noIncrementSeconds = function() {
    var incrementedSelected = addSeconds(selected, secondStep);
    return disabled || incrementedSelected > max ||
      incrementedSelected < selected && incrementedSelected < min;
  };

  $scope.noDecrementSeconds = function() {
    var decrementedSelected = addSeconds(selected, -secondStep);
    return disabled || decrementedSelected < min ||
      decrementedSelected > selected && decrementedSelected > max;
  };

  $scope.noToggleMeridian = function() {
    if (selected.getHours() < 12) {
      return disabled || addMinutes(selected, 12 * 60) > max;
    }

    return disabled || addMinutes(selected, -12 * 60) < min;
  };

  var secondStep = timepickerConfig.secondStep;
  if ($attrs.secondStep) {
    watchers.push($scope.$parent.$watch($parse($attrs.secondStep), function(value) {
      secondStep = +value;
    }));
  }

  $scope.showSeconds = timepickerConfig.showSeconds;
  if ($attrs.showSeconds) {
    watchers.push($scope.$parent.$watch($parse($attrs.showSeconds), function(value) {
      $scope.showSeconds = !!value;
    }));
  }

  // 12H / 24H mode
  $scope.showMeridian = timepickerConfig.showMeridian;
  if ($attrs.showMeridian) {
    watchers.push($scope.$parent.$watch($parse($attrs.showMeridian), function(value) {
      $scope.showMeridian = !!value;

      if (ngModelCtrl.$error.time) {
        // Evaluate from template
        var hours = getHoursFromTemplate(), minutes = getMinutesFromTemplate();
        if (angular.isDefined(hours) && angular.isDefined(minutes)) {
          selected.setHours(hours);
          refresh();
        }
      } else {
        updateTemplate();
      }
    }));
  }

  // Get $scope.hours in 24H mode if valid
  function getHoursFromTemplate() {
    var hours = +$scope.hours;
    var valid = $scope.showMeridian ? hours > 0 && hours < 13 :
      hours >= 0 && hours < 24;
    if (!valid || $scope.hours === '') {
      return undefined;
    }

    if ($scope.showMeridian) {
      if (hours === 12) {
        hours = 0;
      }
      if ($scope.meridian === meridians[1]) {
        hours = hours + 12;
      }
    }
    return hours;
  }

  function getMinutesFromTemplate() {
    var minutes = +$scope.minutes;
    var valid = minutes >= 0 && minutes < 60;
    if (!valid || $scope.minutes === '') {
      return undefined;
    }
    return minutes;
  }

  function getSecondsFromTemplate() {
    var seconds = +$scope.seconds;
    return seconds >= 0 && seconds < 60 ? seconds : undefined;
  }

  function pad(value, noPad) {
    if (value === null) {
      return '';
    }

    return angular.isDefined(value) && value.toString().length < 2 && !noPad ?
      '0' + value : value.toString();
  }

  // Respond on mousewheel spin
  this.setupMousewheelEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
    var isScrollingUp = function(e) {
      if (e.originalEvent) {
        e = e.originalEvent;
      }
      //pick correct delta variable depending on event
      var delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
      return e.detail || delta > 0;
    };

    hoursInputEl.on('mousewheel wheel', function(e) {
      if (!disabled) {
        $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());
      }
      e.preventDefault();
    });

    minutesInputEl.on('mousewheel wheel', function(e) {
      if (!disabled) {
        $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());
      }
      e.preventDefault();
    });

     secondsInputEl.on('mousewheel wheel', function(e) {
      if (!disabled) {
        $scope.$apply(isScrollingUp(e) ? $scope.incrementSeconds() : $scope.decrementSeconds());
      }
      e.preventDefault();
    });
  };

  // Respond on up/down arrowkeys
  this.setupArrowkeyEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
    hoursInputEl.on('keydown', function(e) {
      if (!disabled) {
        if (e.which === 38) { // up
          e.preventDefault();
          $scope.incrementHours();
          $scope.$apply();
        } else if (e.which === 40) { // down
          e.preventDefault();
          $scope.decrementHours();
          $scope.$apply();
        }
      }
    });

    minutesInputEl.on('keydown', function(e) {
      if (!disabled) {
        if (e.which === 38) { // up
          e.preventDefault();
          $scope.incrementMinutes();
          $scope.$apply();
        } else if (e.which === 40) { // down
          e.preventDefault();
          $scope.decrementMinutes();
          $scope.$apply();
        }
      }
    });

    secondsInputEl.on('keydown', function(e) {
      if (!disabled) {
        if (e.which === 38) { // up
          e.preventDefault();
          $scope.incrementSeconds();
          $scope.$apply();
        } else if (e.which === 40) { // down
          e.preventDefault();
          $scope.decrementSeconds();
          $scope.$apply();
        }
      }
    });
  };

  this.setupInputEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
    if ($scope.readonlyInput) {
      $scope.updateHours = angular.noop;
      $scope.updateMinutes = angular.noop;
      $scope.updateSeconds = angular.noop;
      return;
    }

    var invalidate = function(invalidHours, invalidMinutes, invalidSeconds) {
      ngModelCtrl.$setViewValue(null);
      ngModelCtrl.$setValidity('time', false);
      if (angular.isDefined(invalidHours)) {
        $scope.invalidHours = invalidHours;
        if (hoursModelCtrl) {
          hoursModelCtrl.$setValidity('hours', false);
        }
      }

      if (angular.isDefined(invalidMinutes)) {
        $scope.invalidMinutes = invalidMinutes;
        if (minutesModelCtrl) {
          minutesModelCtrl.$setValidity('minutes', false);
        }
      }

      if (angular.isDefined(invalidSeconds)) {
        $scope.invalidSeconds = invalidSeconds;
        if (secondsModelCtrl) {
          secondsModelCtrl.$setValidity('seconds', false);
        }
      }
    };

    $scope.updateHours = function() {
      var hours = getHoursFromTemplate(),
        minutes = getMinutesFromTemplate();

      ngModelCtrl.$setDirty();

      if (angular.isDefined(hours) && angular.isDefined(minutes)) {
        selected.setHours(hours);
        selected.setMinutes(minutes);
        if (selected < min || selected > max) {
          invalidate(true);
        } else {
          refresh('h');
        }
      } else {
        invalidate(true);
      }
    };

    hoursInputEl.on('blur', function(e) {
      ngModelCtrl.$setTouched();
      if (modelIsEmpty()) {
        makeValid();
      } else if ($scope.hours === null || $scope.hours === '') {
        invalidate(true);
      } else if (!$scope.invalidHours && $scope.hours < 10) {
        $scope.$apply(function() {
          $scope.hours = pad($scope.hours, !padHours);
        });
      }
    });

    $scope.updateMinutes = function() {
      var minutes = getMinutesFromTemplate(),
        hours = getHoursFromTemplate();

      ngModelCtrl.$setDirty();

      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
        selected.setHours(hours);
        selected.setMinutes(minutes);
        if (selected < min || selected > max) {
          invalidate(undefined, true);
        } else {
          refresh('m');
        }
      } else {
        invalidate(undefined, true);
      }
    };

    minutesInputEl.on('blur', function(e) {
      ngModelCtrl.$setTouched();
      if (modelIsEmpty()) {
        makeValid();
      } else if ($scope.minutes === null) {
        invalidate(undefined, true);
      } else if (!$scope.invalidMinutes && $scope.minutes < 10) {
        $scope.$apply(function() {
          $scope.minutes = pad($scope.minutes);
        });
      }
    });

    $scope.updateSeconds = function() {
      var seconds = getSecondsFromTemplate();

      ngModelCtrl.$setDirty();

      if (angular.isDefined(seconds)) {
        selected.setSeconds(seconds);
        refresh('s');
      } else {
        invalidate(undefined, undefined, true);
      }
    };

    secondsInputEl.on('blur', function(e) {
      if (modelIsEmpty()) {
        makeValid();
      } else if (!$scope.invalidSeconds && $scope.seconds < 10) {
        $scope.$apply( function() {
          $scope.seconds = pad($scope.seconds);
        });
      }
    });

  };

  this.render = function() {
    var date = ngModelCtrl.$viewValue;

    if (isNaN(date)) {
      ngModelCtrl.$setValidity('time', false);
      $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
    } else {
      if (date) {
        selected = date;
      }

      if (selected < min || selected > max) {
        ngModelCtrl.$setValidity('time', false);
        $scope.invalidHours = true;
        $scope.invalidMinutes = true;
      } else {
        makeValid();
      }
      updateTemplate();
    }
  };

  // Call internally when we know that model is valid.
  function refresh(keyboardChange) {
    makeValid();
    ngModelCtrl.$setViewValue(new Date(selected));
    updateTemplate(keyboardChange);
  }

  function makeValid() {
    if (hoursModelCtrl) {
      hoursModelCtrl.$setValidity('hours', true);
    }

    if (minutesModelCtrl) {
      minutesModelCtrl.$setValidity('minutes', true);
    }

    if (secondsModelCtrl) {
      secondsModelCtrl.$setValidity('seconds', true);
    }

    ngModelCtrl.$setValidity('time', true);
    $scope.invalidHours = false;
    $scope.invalidMinutes = false;
    $scope.invalidSeconds = false;
  }

  function updateTemplate(keyboardChange) {
    if (!ngModelCtrl.$modelValue) {
      $scope.hours = null;
      $scope.minutes = null;
      $scope.seconds = null;
      $scope.meridian = meridians[0];
    } else {
      var hours = selected.getHours(),
        minutes = selected.getMinutes(),
        seconds = selected.getSeconds();

      if ($scope.showMeridian) {
        hours = hours === 0 || hours === 12 ? 12 : hours % 12; // Convert 24 to 12 hour system
      }

      $scope.hours = keyboardChange === 'h' ? hours : pad(hours, !padHours);
      if (keyboardChange !== 'm') {
        $scope.minutes = pad(minutes);
      }
      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];

      if (keyboardChange !== 's') {
        $scope.seconds = pad(seconds);
      }
      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
    }
  }

  function addSecondsToSelected(seconds) {
    selected = addSeconds(selected, seconds);
    refresh();
  }

  function addMinutes(selected, minutes) {
    return addSeconds(selected, minutes*60);
  }

  function addSeconds(date, seconds) {
    var dt = new Date(date.getTime() + seconds * 1000);
    var newDate = new Date(date);
    newDate.setHours(dt.getHours(), dt.getMinutes(), dt.getSeconds());
    return newDate;
  }

  function modelIsEmpty() {
    return ($scope.hours === null || $scope.hours === '') &&
      ($scope.minutes === null || $scope.minutes === '') &&
      (!$scope.showSeconds || $scope.showSeconds && ($scope.seconds === null || $scope.seconds === ''));
  }

  $scope.showSpinners = angular.isDefined($attrs.showSpinners) ?
    $scope.$parent.$eval($attrs.showSpinners) : timepickerConfig.showSpinners;

  $scope.incrementHours = function() {
    if (!$scope.noIncrementHours()) {
      addSecondsToSelected(hourStep * 60 * 60);
    }
  };

  $scope.decrementHours = function() {
    if (!$scope.noDecrementHours()) {
      addSecondsToSelected(-hourStep * 60 * 60);
    }
  };

  $scope.incrementMinutes = function() {
    if (!$scope.noIncrementMinutes()) {
      addSecondsToSelected(minuteStep * 60);
    }
  };

  $scope.decrementMinutes = function() {
    if (!$scope.noDecrementMinutes()) {
      addSecondsToSelected(-minuteStep * 60);
    }
  };

  $scope.incrementSeconds = function() {
    if (!$scope.noIncrementSeconds()) {
      addSecondsToSelected(secondStep);
    }
  };

  $scope.decrementSeconds = function() {
    if (!$scope.noDecrementSeconds()) {
      addSecondsToSelected(-secondStep);
    }
  };

  $scope.toggleMeridian = function() {
    var minutes = getMinutesFromTemplate(),
        hours = getHoursFromTemplate();

    if (!$scope.noToggleMeridian()) {
      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
        addSecondsToSelected(12 * 60 * (selected.getHours() < 12 ? 60 : -60));
      } else {
        $scope.meridian = $scope.meridian === meridians[0] ? meridians[1] : meridians[0];
      }
    }
  };

  $scope.blur = function() {
    ngModelCtrl.$setTouched();
  };

  $scope.$on('$destroy', function() {
    while (watchers.length) {
      watchers.shift()();
    }
  });
}])

.directive('uibTimepicker', ['uibTimepickerConfig', function(uibTimepickerConfig) {
  return {
    require: ['uibTimepicker', '?^ngModel'],
    restrict: 'A',
    controller: 'UibTimepickerController',
    controllerAs: 'timepicker',
    scope: {},
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || uibTimepickerConfig.templateUrl;
    },
    link: function(scope, element, attrs, ctrls) {
      var timepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if (ngModelCtrl) {
        timepickerCtrl.init(ngModelCtrl, element.find('input'));
      }
    }
  };
}]);

angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.debounce', 'ui.bootstrap.position'])

/**
 * A helper service that can parse typeahead's syntax (string provided by users)
 * Extracted to a separate service for ease of unit testing
 */
  .factory('uibTypeaheadParser', ['$parse', function($parse) {
    //                      000001111111100000000000002222222200000000000000003333333333333330000000000044444444000
    var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
    return {
      parse: function(input) {
        var match = input.match(TYPEAHEAD_REGEXP);
        if (!match) {
          throw new Error(
            'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' +
              ' but got "' + input + '".');
        }

        return {
          itemName: match[3],
          source: $parse(match[4]),
          viewMapper: $parse(match[2] || match[1]),
          modelMapper: $parse(match[1])
        };
      }
    };
  }])

  .controller('UibTypeaheadController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$$debounce', '$uibPosition', 'uibTypeaheadParser',
    function(originalScope, element, attrs, $compile, $parse, $q, $timeout, $document, $window, $rootScope, $$debounce, $position, typeaheadParser) {
    var HOT_KEYS = [9, 13, 27, 38, 40];
    var eventDebounceTime = 200;
    var modelCtrl, ngModelOptions;
    //SUPPORTED ATTRIBUTES (OPTIONS)

    //minimal no of characters that needs to be entered before typeahead kicks-in
    var minLength = originalScope.$eval(attrs.typeaheadMinLength);
    if (!minLength && minLength !== 0) {
      minLength = 1;
    }

    originalScope.$watch(attrs.typeaheadMinLength, function (newVal) {
        minLength = !newVal && newVal !== 0 ? 1 : newVal;
    });

    //minimal wait time after last character typed before typeahead kicks-in
    var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;

    //should it restrict model values to the ones selected from the popup only?
    var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
    originalScope.$watch(attrs.typeaheadEditable, function (newVal) {
      isEditable = newVal !== false;
    });

    //binding to a variable that indicates if matches are being retrieved asynchronously
    var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;

    //a function to determine if an event should cause selection
    var isSelectEvent = attrs.typeaheadShouldSelect ? $parse(attrs.typeaheadShouldSelect) : function(scope, vals) {
      var evt = vals.$event;
      return evt.which === 13 || evt.which === 9;
    };

    //a callback executed when a match is selected
    var onSelectCallback = $parse(attrs.typeaheadOnSelect);

    //should it select highlighted popup value when losing focus?
    var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;

    //binding to a variable that indicates if there were no results after the query is completed
    var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;

    var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;

    var appendToBody = attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;

    var appendTo = attrs.typeaheadAppendTo ?
      originalScope.$eval(attrs.typeaheadAppendTo) : null;

    var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;

    //If input matches an item of the list exactly, select it automatically
    var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;

    //binding to a variable that indicates if dropdown is open
    var isOpenSetter = $parse(attrs.typeaheadIsOpen).assign || angular.noop;

    var showHint = originalScope.$eval(attrs.typeaheadShowHint) || false;

    //INTERNAL VARIABLES

    //model setter executed upon match selection
    var parsedModel = $parse(attrs.ngModel);
    var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
    var $setModelValue = function(scope, newValue) {
      if (angular.isFunction(parsedModel(originalScope)) &&
        ngModelOptions.getOption('getterSetter')) {
        return invokeModelSetter(scope, {$$$p: newValue});
      }

      return parsedModel.assign(scope, newValue);
    };

    //expressions used by typeahead
    var parserResult = typeaheadParser.parse(attrs.uibTypeahead);

    var hasFocus;

    //Used to avoid bug in iOS webview where iOS keyboard does not fire
    //mousedown & mouseup events
    //Issue #3699
    var selected;

    //create a child scope for the typeahead directive so we are not polluting original scope
    //with typeahead-specific data (matches, query etc.)
    var scope = originalScope.$new();
    var offDestroy = originalScope.$on('$destroy', function() {
      scope.$destroy();
    });
    scope.$on('$destroy', offDestroy);

    // WAI-ARIA
    var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
    element.attr({
      'aria-autocomplete': 'list',
      'aria-expanded': false,
      'aria-owns': popupId
    });

    var inputsContainer, hintInputElem;
    //add read-only input to show hint
    if (showHint) {
      inputsContainer = angular.element('<div></div>');
      inputsContainer.css('position', 'relative');
      element.after(inputsContainer);
      hintInputElem = element.clone();
      hintInputElem.attr('placeholder', '');
      hintInputElem.attr('tabindex', '-1');
      hintInputElem.val('');
      hintInputElem.css({
        'position': 'absolute',
        'top': '0px',
        'left': '0px',
        'border-color': 'transparent',
        'box-shadow': 'none',
        'opacity': 1,
        'background': 'none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)',
        'color': '#999'
      });
      element.css({
        'position': 'relative',
        'vertical-align': 'top',
        'background-color': 'transparent'
      });

      if (hintInputElem.attr('id')) {
        hintInputElem.removeAttr('id'); // remove duplicate id if present.
      }
      inputsContainer.append(hintInputElem);
      hintInputElem.after(element);
    }

    //pop-up element used to display matches
    var popUpEl = angular.element('<div uib-typeahead-popup></div>');
    popUpEl.attr({
      id: popupId,
      matches: 'matches',
      active: 'activeIdx',
      select: 'select(activeIdx, evt)',
      'move-in-progress': 'moveInProgress',
      query: 'query',
      position: 'position',
      'assign-is-open': 'assignIsOpen(isOpen)',
      debounce: 'debounceUpdate'
    });
    //custom item template
    if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
      popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
    }

    if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {
      popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);
    }

    var resetHint = function() {
      if (showHint) {
        hintInputElem.val('');
      }
    };

    var resetMatches = function() {
      scope.matches = [];
      scope.activeIdx = -1;
      element.attr('aria-expanded', false);
      resetHint();
    };

    var getMatchId = function(index) {
      return popupId + '-option-' + index;
    };

    // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
    // This attribute is added or removed automatically when the `activeIdx` changes.
    scope.$watch('activeIdx', function(index) {
      if (index < 0) {
        element.removeAttr('aria-activedescendant');
      } else {
        element.attr('aria-activedescendant', getMatchId(index));
      }
    });

    var inputIsExactMatch = function(inputValue, index) {
      if (scope.matches.length > index && inputValue) {
        return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
      }

      return false;
    };

    var getMatchesAsync = function(inputValue, evt) {
      var locals = {$viewValue: inputValue};
      isLoadingSetter(originalScope, true);
      isNoResultsSetter(originalScope, false);
      $q.when(parserResult.source(originalScope, locals)).then(function(matches) {
        //it might happen that several async queries were in progress if a user were typing fast
        //but we are interested only in responses that correspond to the current view value
        var onCurrentRequest = inputValue === modelCtrl.$viewValue;
        if (onCurrentRequest && hasFocus) {
          if (matches && matches.length > 0) {
            scope.activeIdx = focusFirst ? 0 : -1;
            isNoResultsSetter(originalScope, false);
            scope.matches.length = 0;

            //transform labels
            for (var i = 0; i < matches.length; i++) {
              locals[parserResult.itemName] = matches[i];
              scope.matches.push({
                id: getMatchId(i),
                label: parserResult.viewMapper(scope, locals),
                model: matches[i]
              });
            }

            scope.query = inputValue;
            //position pop-up with matches - we need to re-calculate its position each time we are opening a window
            //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
            //due to other elements being rendered
            recalculatePosition();

            element.attr('aria-expanded', true);

            //Select the single remaining option if user input matches
            if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
              if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
                $$debounce(function() {
                  scope.select(0, evt);
                }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
              } else {
                scope.select(0, evt);
              }
            }

            if (showHint) {
              var firstLabel = scope.matches[0].label;
              if (angular.isString(inputValue) &&
                inputValue.length > 0 &&
                firstLabel.slice(0, inputValue.length).toUpperCase() === inputValue.toUpperCase()) {
                hintInputElem.val(inputValue + firstLabel.slice(inputValue.length));
              } else {
                hintInputElem.val('');
              }
            }
          } else {
            resetMatches();
            isNoResultsSetter(originalScope, true);
          }
        }
        if (onCurrentRequest) {
          isLoadingSetter(originalScope, false);
        }
      }, function() {
        resetMatches();
        isLoadingSetter(originalScope, false);
        isNoResultsSetter(originalScope, true);
      });
    };

    // bind events only if appendToBody params exist - performance feature
    if (appendToBody) {
      angular.element($window).on('resize', fireRecalculating);
      $document.find('body').on('scroll', fireRecalculating);
    }

    // Declare the debounced function outside recalculating for
    // proper debouncing
    var debouncedRecalculate = $$debounce(function() {
      // if popup is visible
      if (scope.matches.length) {
        recalculatePosition();
      }

      scope.moveInProgress = false;
    }, eventDebounceTime);

    // Default progress type
    scope.moveInProgress = false;

    function fireRecalculating() {
      if (!scope.moveInProgress) {
        scope.moveInProgress = true;
        scope.$digest();
      }

      debouncedRecalculate();
    }

    // recalculate actual position and set new values to scope
    // after digest loop is popup in right position
    function recalculatePosition() {
      scope.position = appendToBody ? $position.offset(element) : $position.position(element);
      scope.position.top += element.prop('offsetHeight');
    }

    //we need to propagate user's query so we can higlight matches
    scope.query = undefined;

    //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
    var timeoutPromise;

    var scheduleSearchWithTimeout = function(inputValue) {
      timeoutPromise = $timeout(function() {
        getMatchesAsync(inputValue);
      }, waitTime);
    };

    var cancelPreviousTimeout = function() {
      if (timeoutPromise) {
        $timeout.cancel(timeoutPromise);
      }
    };

    resetMatches();

    scope.assignIsOpen = function (isOpen) {
      isOpenSetter(originalScope, isOpen);
    };

    scope.select = function(activeIdx, evt) {
      //called from within the $digest() cycle
      var locals = {};
      var model, item;

      selected = true;
      locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
      model = parserResult.modelMapper(originalScope, locals);
      $setModelValue(originalScope, model);
      modelCtrl.$setValidity('editable', true);
      modelCtrl.$setValidity('parse', true);

      onSelectCallback(originalScope, {
        $item: item,
        $model: model,
        $label: parserResult.viewMapper(originalScope, locals),
        $event: evt
      });

      resetMatches();

      //return focus to the input element if a match was selected via a mouse click event
      // use timeout to avoid $rootScope:inprog error
      if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {
        $timeout(function() { element[0].focus(); }, 0, false);
      }
    };

    //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
    element.on('keydown', function(evt) {
      //typeahead is open and an "interesting" key was pressed
      if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
        return;
      }

      var shouldSelect = isSelectEvent(originalScope, {$event: evt});

      /**
       * if there's nothing selected (i.e. focusFirst) and enter or tab is hit
       * or
       * shift + tab is pressed to bring focus to the previous element
       * then clear the results
       */
      if (scope.activeIdx === -1 && shouldSelect || evt.which === 9 && !!evt.shiftKey) {
        resetMatches();
        scope.$digest();
        return;
      }

      evt.preventDefault();
      var target;
      switch (evt.which) {
        case 27: // escape
          evt.stopPropagation();

          resetMatches();
          originalScope.$digest();
          break;
        case 38: // up arrow
          scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
          scope.$digest();
          target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];
          target.parentNode.scrollTop = target.offsetTop;
          break;
        case 40: // down arrow
          scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
          scope.$digest();
          target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];
          target.parentNode.scrollTop = target.offsetTop;
          break;
        default:
          if (shouldSelect) {
            scope.$apply(function() {
              if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
                $$debounce(function() {
                  scope.select(scope.activeIdx, evt);
                }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
              } else {
                scope.select(scope.activeIdx, evt);
              }
            });
          }
      }
    });

    element.on('focus', function (evt) {
      hasFocus = true;
      if (minLength === 0 && !modelCtrl.$viewValue) {
        $timeout(function() {
          getMatchesAsync(modelCtrl.$viewValue, evt);
        }, 0);
      }
    });

    element.on('blur', function(evt) {
      if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
        selected = true;
        scope.$apply(function() {
          if (angular.isObject(scope.debounceUpdate) && angular.isNumber(scope.debounceUpdate.blur)) {
            $$debounce(function() {
              scope.select(scope.activeIdx, evt);
            }, scope.debounceUpdate.blur);
          } else {
            scope.select(scope.activeIdx, evt);
          }
        });
      }
      if (!isEditable && modelCtrl.$error.editable) {
        modelCtrl.$setViewValue();
        scope.$apply(function() {
          // Reset validity as we are clearing
          modelCtrl.$setValidity('editable', true);
          modelCtrl.$setValidity('parse', true);
        });
        element.val('');
      }
      hasFocus = false;
      selected = false;
    });

    // Keep reference to click handler to unbind it.
    var dismissClickHandler = function(evt) {
      // Issue #3973
      // Firefox treats right click as a click on document
      if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
        resetMatches();
        if (!$rootScope.$$phase) {
          originalScope.$digest();
        }
      }
    };

    $document.on('click', dismissClickHandler);

    originalScope.$on('$destroy', function() {
      $document.off('click', dismissClickHandler);
      if (appendToBody || appendTo) {
        $popup.remove();
      }

      if (appendToBody) {
        angular.element($window).off('resize', fireRecalculating);
        $document.find('body').off('scroll', fireRecalculating);
      }
      // Prevent jQuery cache memory leak
      popUpEl.remove();

      if (showHint) {
          inputsContainer.remove();
      }
    });

    var $popup = $compile(popUpEl)(scope);

    if (appendToBody) {
      $document.find('body').append($popup);
    } else if (appendTo) {
      angular.element(appendTo).eq(0).append($popup);
    } else {
      element.after($popup);
    }

    this.init = function(_modelCtrl) {
      modelCtrl = _modelCtrl;
      ngModelOptions = extractOptions(modelCtrl);

      scope.debounceUpdate = $parse(ngModelOptions.getOption('debounce'))(originalScope);

      //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
      //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
      modelCtrl.$parsers.unshift(function(inputValue) {
        hasFocus = true;

        if (minLength === 0 || inputValue && inputValue.length >= minLength) {
          if (waitTime > 0) {
            cancelPreviousTimeout();
            scheduleSearchWithTimeout(inputValue);
          } else {
            getMatchesAsync(inputValue);
          }
        } else {
          isLoadingSetter(originalScope, false);
          cancelPreviousTimeout();
          resetMatches();
        }

        if (isEditable) {
          return inputValue;
        }

        if (!inputValue) {
          // Reset in case user had typed something previously.
          modelCtrl.$setValidity('editable', true);
          return null;
        }

        modelCtrl.$setValidity('editable', false);
        return undefined;
      });

      modelCtrl.$formatters.push(function(modelValue) {
        var candidateViewValue, emptyViewValue;
        var locals = {};

        // The validity may be set to false via $parsers (see above) if
        // the model is restricted to selected values. If the model
        // is set manually it is considered to be valid.
        if (!isEditable) {
          modelCtrl.$setValidity('editable', true);
        }

        if (inputFormatter) {
          locals.$model = modelValue;
          return inputFormatter(originalScope, locals);
        }

        //it might happen that we don't have enough info to properly render input value
        //we need to check for this situation and simply return model value if we can't apply custom formatting
        locals[parserResult.itemName] = modelValue;
        candidateViewValue = parserResult.viewMapper(originalScope, locals);
        locals[parserResult.itemName] = undefined;
        emptyViewValue = parserResult.viewMapper(originalScope, locals);

        return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
      });
    };

    function extractOptions(ngModelCtrl) {
      var ngModelOptions;

      if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
        // guarantee a value
        ngModelOptions = ngModelCtrl.$options || {};

        // mimic 1.6+ api
        ngModelOptions.getOption = function (key) {
          return ngModelOptions[key];
        };
      } else { // in angular >=1.6 $options is always present
        ngModelOptions = ngModelCtrl.$options;
      }

      return ngModelOptions;
    }
  }])

  .directive('uibTypeahead', function() {
    return {
      controller: 'UibTypeaheadController',
      require: ['ngModel', 'uibTypeahead'],
      link: function(originalScope, element, attrs, ctrls) {
        ctrls[1].init(ctrls[0]);
      }
    };
  })

  .directive('uibTypeaheadPopup', ['$$debounce', function($$debounce) {
    return {
      scope: {
        matches: '=',
        query: '=',
        active: '=',
        position: '&',
        moveInProgress: '=',
        select: '&',
        assignIsOpen: '&',
        debounce: '&'
      },
      replace: true,
      templateUrl: function(element, attrs) {
        return attrs.popupTemplateUrl || 'uib/template/typeahead/typeahead-popup.html';
      },
      link: function(scope, element, attrs) {
        scope.templateUrl = attrs.templateUrl;

        scope.isOpen = function() {
          var isDropdownOpen = scope.matches.length > 0;
          scope.assignIsOpen({ isOpen: isDropdownOpen });
          return isDropdownOpen;
        };

        scope.isActive = function(matchIdx) {
          return scope.active === matchIdx;
        };

        scope.selectActive = function(matchIdx) {
          scope.active = matchIdx;
        };

        scope.selectMatch = function(activeIdx, evt) {
          var debounce = scope.debounce();
          if (angular.isNumber(debounce) || angular.isObject(debounce)) {
            $$debounce(function() {
              scope.select({activeIdx: activeIdx, evt: evt});
            }, angular.isNumber(debounce) ? debounce : debounce['default']);
          } else {
            scope.select({activeIdx: activeIdx, evt: evt});
          }
        };
      }
    };
  }])

  .directive('uibTypeaheadMatch', ['$templateRequest', '$compile', '$parse', function($templateRequest, $compile, $parse) {
    return {
      scope: {
        index: '=',
        match: '=',
        query: '='
      },
      link: function(scope, element, attrs) {
        var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'uib/template/typeahead/typeahead-match.html';
        $templateRequest(tplUrl).then(function(tplContent) {
          var tplEl = angular.element(tplContent.trim());
          element.replaceWith(tplEl);
          $compile(tplEl)(scope);
        });
      }
    };
  }])

  .filter('uibTypeaheadHighlight', ['$sce', '$injector', '$log', function($sce, $injector, $log) {
    var isSanitizePresent;
    isSanitizePresent = $injector.has('$sanitize');

    function escapeRegexp(queryToEscape) {
      // Regex: capture the whole query string and replace it with the string that will be used to match
      // the results, for example if the capture is "a" the result will be \a
      return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
    }

    function containsHtml(matchItem) {
      return /<.*>/g.test(matchItem);
    }

    return function(matchItem, query) {
      if (!isSanitizePresent && containsHtml(matchItem)) {
        $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
      }
      matchItem = query ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
      if (!isSanitizePresent) {
        matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
      }
      return matchItem;
    };
  }]);

angular.module("uib/template/accordion/accordion-group.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/accordion/accordion-group.html",
    "<div role=\"tab\" id=\"{{::headingId}}\" aria-selected=\"{{isOpen}}\" class=\"panel-heading\" ng-keypress=\"toggleOpen($event)\">\n" +
    "  <h4 class=\"panel-title\">\n" +
    "    <a role=\"button\" data-toggle=\"collapse\" href aria-expanded=\"{{isOpen}}\" aria-controls=\"{{::panelId}}\" tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" uib-accordion-transclude=\"heading\" ng-disabled=\"isDisabled\" uib-tabindex-toggle><span uib-accordion-header ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" +
    "  </h4>\n" +
    "</div>\n" +
    "<div id=\"{{::panelId}}\" aria-labelledby=\"{{::headingId}}\" aria-hidden=\"{{!isOpen}}\" role=\"tabpanel\" class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n" +
    "  <div class=\"panel-body\" ng-transclude></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/accordion/accordion.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/accordion/accordion.html",
    "<div role=\"tablist\" class=\"panel-group\" ng-transclude></div>");
}]);

angular.module("uib/template/alert/alert.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/alert/alert.html",
    "<button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close({$event: $event})\">\n" +
    "  <span aria-hidden=\"true\">&times;</span>\n" +
    "  <span class=\"sr-only\">Close</span>\n" +
    "</button>\n" +
    "<div ng-transclude></div>\n" +
    "");
}]);

angular.module("uib/template/carousel/carousel.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/carousel/carousel.html",
    "<div class=\"carousel-inner\" ng-transclude></div>\n" +
    "<a role=\"button\" href class=\"left carousel-control\" ng-click=\"prev()\" ng-class=\"{ disabled: isPrevDisabled() }\" ng-show=\"slides.length > 1\">\n" +
    "  <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></span>\n" +
    "  <span class=\"sr-only\">previous</span>\n" +
    "</a>\n" +
    "<a role=\"button\" href class=\"right carousel-control\" ng-click=\"next()\" ng-class=\"{ disabled: isNextDisabled() }\" ng-show=\"slides.length > 1\">\n" +
    "  <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></span>\n" +
    "  <span class=\"sr-only\">next</span>\n" +
    "</a>\n" +
    "<ol class=\"carousel-indicators\" ng-show=\"slides.length > 1\">\n" +
    "  <li ng-repeat=\"slide in slides | orderBy:indexOfSlide track by $index\" ng-class=\"{ active: isActive(slide) }\" ng-click=\"select(slide)\">\n" +
    "    <span class=\"sr-only\">slide {{ $index + 1 }} of {{ slides.length }}<span ng-if=\"isActive(slide)\">, currently active</span></span>\n" +
    "  </li>\n" +
    "</ol>\n" +
    "");
}]);

angular.module("uib/template/carousel/slide.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/carousel/slide.html",
    "<div class=\"text-center\" ng-transclude></div>\n" +
    "");
}]);

angular.module("uib/template/datepicker/datepicker.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/datepicker/datepicker.html",
    "<div ng-switch=\"datepickerMode\">\n" +
    "  <div uib-daypicker ng-switch-when=\"day\" tabindex=\"0\" class=\"uib-daypicker\"></div>\n" +
    "  <div uib-monthpicker ng-switch-when=\"month\" tabindex=\"0\" class=\"uib-monthpicker\"></div>\n" +
    "  <div uib-yearpicker ng-switch-when=\"year\" tabindex=\"0\" class=\"uib-yearpicker\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/datepicker/day.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/datepicker/day.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
    "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></button></th>\n" +
    "    </tr>\n" +
    "    <tr>\n" +
    "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" +
    "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr class=\"uib-weeks\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
    "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" +
    "      <td ng-repeat=\"dt in row\" class=\"uib-day text-center\" role=\"gridcell\"\n" +
    "        id=\"{{::dt.uid}}\"\n" +
    "        ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" class=\"btn btn-default btn-sm\"\n" +
    "          uib-is-class=\"\n" +
    "            'btn-info' for selectedDt,\n" +
    "            'active' for activeDt\n" +
    "            on dt\"\n" +
    "          ng-click=\"select(dt.date)\"\n" +
    "          ng-disabled=\"::dt.disabled\"\n" +
    "          tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/datepicker/month.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/datepicker/month.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
    "      <th colspan=\"{{::yearHeaderColspan}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></i></button></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr class=\"uib-months\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
    "      <td ng-repeat=\"dt in row\" class=\"uib-month text-center\" role=\"gridcell\"\n" +
    "        id=\"{{::dt.uid}}\"\n" +
    "        ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" class=\"btn btn-default\"\n" +
    "          uib-is-class=\"\n" +
    "            'btn-info' for selectedDt,\n" +
    "            'active' for activeDt\n" +
    "            on dt\"\n" +
    "          ng-click=\"select(dt.date)\"\n" +
    "          ng-disabled=\"::dt.disabled\"\n" +
    "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/datepicker/popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/datepicker/popup.html",
    "<div>\n" +
    "  <ul class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
    "    <li ng-transclude></li>\n" +
    "    <li ng-if=\"showButtonBar\" class=\"uib-button-bar\">\n" +
    "      <span class=\"btn-group pull-left\">\n" +
    "        <button type=\"button\" class=\"btn btn-sm btn-info uib-datepicker-current\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
    "        <button type=\"button\" class=\"btn btn-sm btn-danger uib-clear\" ng-click=\"select(null, $event)\">{{ getText('clear') }}</button>\n" +
    "      </span>\n" +
    "      <button type=\"button\" class=\"btn btn-sm btn-success pull-right uib-close\" ng-click=\"close($event)\">{{ getText('close') }}</button>\n" +
    "    </li>\n" +
    "  </ul>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/datepicker/year.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/datepicker/year.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
    "      <th colspan=\"{{::columns - 2}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></button></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr class=\"uib-years\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
    "      <td ng-repeat=\"dt in row\" class=\"uib-year text-center\" role=\"gridcell\"\n" +
    "        id=\"{{::dt.uid}}\"\n" +
    "        ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" class=\"btn btn-default\"\n" +
    "          uib-is-class=\"\n" +
    "            'btn-info' for selectedDt,\n" +
    "            'active' for activeDt\n" +
    "            on dt\"\n" +
    "          ng-click=\"select(dt.date)\"\n" +
    "          ng-disabled=\"::dt.disabled\"\n" +
    "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/datepickerPopup/popup.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/datepickerPopup/popup.html",
    "<ul role=\"presentation\" class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
    "  <li ng-transclude></li>\n" +
    "  <li ng-if=\"showButtonBar\" class=\"uib-button-bar\">\n" +
    "    <span class=\"btn-group pull-left\">\n" +
    "      <button type=\"button\" class=\"btn btn-sm btn-info uib-datepicker-current\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
    "      <button type=\"button\" class=\"btn btn-sm btn-danger uib-clear\" ng-click=\"select(null, $event)\">{{ getText('clear') }}</button>\n" +
    "    </span>\n" +
    "    <button type=\"button\" class=\"btn btn-sm btn-success pull-right uib-close\" ng-click=\"close($event)\">{{ getText('close') }}</button>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("uib/template/modal/backdrop.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/modal/backdrop.html",
    "<div class=\"modal-backdrop\"\n" +
    "     uib-modal-animation-class=\"fade\"\n" +
    "     modal-in-class=\"in\"\n" +
    "     ng-style=\"{'z-index': 1040 + (index && 1 || 0) + index*10}\"\n" +
    "></div>\n" +
    "");
}]);

angular.module("uib/template/modal/window.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/modal/window.html",
    "<div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n" +
    "");
}]);

angular.module("uib/template/pager/pager.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/pager/pager.html",
    "<li ng-class=\"{disabled: noPrevious()||ngDisabled, previous: align}\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" +
    "<li ng-class=\"{disabled: noNext()||ngDisabled, next: align}\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" +
    "");
}]);

angular.module("uib/template/pagination/pagination.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/pagination/pagination.html",
    "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-first\"><a href ng-click=\"selectPage(1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('first')}}</a></li>\n" +
    "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-prev\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" +
    "<li role=\"menuitem\" ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=\"pagination-page\"><a href ng-click=\"selectPage(page.number, $event)\" ng-disabled=\"ngDisabled&&!page.active\" uib-tabindex-toggle>{{page.text}}</a></li>\n" +
    "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-next\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" +
    "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-last\"><a href ng-click=\"selectPage(totalPages, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('last')}}</a></li>\n" +
    "");
}]);

angular.module("uib/template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/tooltip/tooltip-html-popup.html",
    "<div class=\"tooltip-arrow\"></div>\n" +
    "<div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" +
    "");
}]);

angular.module("uib/template/tooltip/tooltip-popup.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/tooltip/tooltip-popup.html",
    "<div class=\"tooltip-arrow\"></div>\n" +
    "<div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" +
    "");
}]);

angular.module("uib/template/tooltip/tooltip-template-popup.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/tooltip/tooltip-template-popup.html",
    "<div class=\"tooltip-arrow\"></div>\n" +
    "<div class=\"tooltip-inner\"\n" +
    "  uib-tooltip-template-transclude=\"contentExp()\"\n" +
    "  tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
    "");
}]);

angular.module("uib/template/popover/popover-html.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/popover/popover-html.html",
    "<div class=\"arrow\"></div>\n" +
    "\n" +
    "<div class=\"popover-inner\">\n" +
    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
    "    <div class=\"popover-content\" ng-bind-html=\"contentExp()\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/popover/popover-template.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/popover/popover-template.html",
    "<div class=\"arrow\"></div>\n" +
    "\n" +
    "<div class=\"popover-inner\">\n" +
    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
    "    <div class=\"popover-content\"\n" +
    "      uib-tooltip-template-transclude=\"contentExp()\"\n" +
    "      tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/popover/popover.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/popover/popover.html",
    "<div class=\"arrow\"></div>\n" +
    "\n" +
    "<div class=\"popover-inner\">\n" +
    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
    "    <div class=\"popover-content\" ng-bind=\"content\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/progressbar/bar.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/progressbar/bar.html",
    "<div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
    "");
}]);

angular.module("uib/template/progressbar/progress.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/progressbar/progress.html",
    "<div class=\"progress\" ng-transclude aria-labelledby=\"{{::title}}\"></div>");
}]);

angular.module("uib/template/progressbar/progressbar.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/progressbar/progressbar.html",
    "<div class=\"progress\">\n" +
    "  <div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/rating/rating.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/rating/rating.html",
    "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\" aria-valuetext=\"{{title}}\">\n" +
    "    <span ng-repeat-start=\"r in range track by $index\" class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>\n" +
    "    <i ng-repeat-end ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"glyphicon\" ng-class=\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\" ng-attr-title=\"{{r.title}}\"></i>\n" +
    "</span>\n" +
    "");
}]);

angular.module("uib/template/tabs/tab.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/tabs/tab.html",
    "<li ng-class=\"[{active: active, disabled: disabled}, classes]\" class=\"uib-tab nav-item\">\n" +
    "  <a href ng-click=\"select($event)\" class=\"nav-link\" uib-tab-heading-transclude>{{heading}}</a>\n" +
    "</li>\n" +
    "");
}]);

angular.module("uib/template/tabs/tabset.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/tabs/tabset.html",
    "<div>\n" +
    "  <ul class=\"nav nav-{{tabset.type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" +
    "  <div class=\"tab-content\">\n" +
    "    <div class=\"tab-pane\"\n" +
    "         ng-repeat=\"tab in tabset.tabs\"\n" +
    "         ng-class=\"{active: tabset.active === tab.index}\"\n" +
    "         uib-tab-content-transclude=\"tab\">\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/timepicker/timepicker.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/timepicker/timepicker.html",
    "<table class=\"uib-timepicker\">\n" +
    "  <tbody>\n" +
    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
    "      <td class=\"uib-increment hours\"><a ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementHours()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "      <td>&nbsp;</td>\n" +
    "      <td class=\"uib-increment minutes\"><a ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementMinutes()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
    "      <td ng-show=\"showSeconds\" class=\"uib-increment seconds\"><a ng-click=\"incrementSeconds()\" ng-class=\"{disabled: noIncrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementSeconds()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "      <td ng-show=\"showMeridian\"></td>\n" +
    "    </tr>\n" +
    "    <tr>\n" +
    "      <td class=\"form-group uib-time hours\" ng-class=\"{'has-error': invalidHours}\">\n" +
    "        <input type=\"text\" placeholder=\"HH\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementHours()\" ng-blur=\"blur()\">\n" +
    "      </td>\n" +
    "      <td class=\"uib-separator\">:</td>\n" +
    "      <td class=\"form-group uib-time minutes\" ng-class=\"{'has-error': invalidMinutes}\">\n" +
    "        <input type=\"text\" placeholder=\"MM\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementMinutes()\" ng-blur=\"blur()\">\n" +
    "      </td>\n" +
    "      <td ng-show=\"showSeconds\" class=\"uib-separator\">:</td>\n" +
    "      <td class=\"form-group uib-time seconds\" ng-class=\"{'has-error': invalidSeconds}\" ng-show=\"showSeconds\">\n" +
    "        <input type=\"text\" placeholder=\"SS\" ng-model=\"seconds\" ng-change=\"updateSeconds()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementSeconds()\" ng-blur=\"blur()\">\n" +
    "      </td>\n" +
    "      <td ng-show=\"showMeridian\" class=\"uib-time am-pm\"><button type=\"button\" ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\" ng-disabled=\"noToggleMeridian()\" tabindex=\"{{::tabindex}}\">{{meridian}}</button></td>\n" +
    "    </tr>\n" +
    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
    "      <td class=\"uib-decrement hours\"><a ng-click=\"decrementHours()\" ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementHours()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "      <td>&nbsp;</td>\n" +
    "      <td class=\"uib-decrement minutes\"><a ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementMinutes()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
    "      <td ng-show=\"showSeconds\" class=\"uib-decrement seconds\"><a ng-click=\"decrementSeconds()\" ng-class=\"{disabled: noDecrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementSeconds()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "      <td ng-show=\"showMeridian\"></td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/typeahead/typeahead-match.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/typeahead/typeahead-match.html",
    "<a href\n" +
    "   tabindex=\"-1\"\n" +
    "   ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"\n" +
    "   ng-attr-title=\"{{match.label}}\"></a>\n" +
    "");
}]);

angular.module("uib/template/typeahead/typeahead-popup.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/typeahead/typeahead-popup.html",
    "<ul class=\"dropdown-menu\" ng-show=\"isOpen() && !moveInProgress\" ng-style=\"{top: position().top+'px', left: position().left+'px'}\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n" +
    "    <li class=\"uib-typeahead-match\" ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index, $event)\" role=\"option\" id=\"{{::match.id}}\">\n" +
    "        <div uib-typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n" +
    "    </li>\n" +
    "</ul>\n" +
    "");
}]);
angular.module('ui.bootstrap.carousel').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibCarouselCss && angular.element(document).find('head').prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>'); angular.$$uibCarouselCss = true; });
angular.module('ui.bootstrap.datepicker').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibDatepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker .uib-title{width:100%;}.uib-day button,.uib-month button,.uib-year button{min-width:100%;}.uib-left,.uib-right{width:100%}</style>'); angular.$$uibDatepickerCss = true; });
angular.module('ui.bootstrap.position').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibPositionCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-position-measure{display:block !important;visibility:hidden !important;position:absolute !important;top:-9999px !important;left:-9999px !important;}.uib-position-scrollbar-measure{position:absolute !important;top:-9999px !important;width:50px !important;height:50px !important;overflow:scroll !important;}.uib-position-body-scrollbar-measure{overflow:scroll !important;}</style>'); angular.$$uibPositionCss = true; });
angular.module('ui.bootstrap.datepickerPopup').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibDatepickerpopupCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker-popup.dropdown-menu{display:block;float:none;margin:0;}.uib-button-bar{padding:10px 9px 2px;}</style>'); angular.$$uibDatepickerpopupCss = true; });
angular.module('ui.bootstrap.tooltip').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTooltipCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-tooltip-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-bottom > .tooltip-arrow,[uib-popover-popup].popover.top-left > .arrow,[uib-popover-popup].popover.top-right > .arrow,[uib-popover-popup].popover.bottom-left > .arrow,[uib-popover-popup].popover.bottom-right > .arrow,[uib-popover-popup].popover.left-top > .arrow,[uib-popover-popup].popover.left-bottom > .arrow,[uib-popover-popup].popover.right-top > .arrow,[uib-popover-popup].popover.right-bottom > .arrow,[uib-popover-html-popup].popover.top-left > .arrow,[uib-popover-html-popup].popover.top-right > .arrow,[uib-popover-html-popup].popover.bottom-left > .arrow,[uib-popover-html-popup].popover.bottom-right > .arrow,[uib-popover-html-popup].popover.left-top > .arrow,[uib-popover-html-popup].popover.left-bottom > .arrow,[uib-popover-html-popup].popover.right-top > .arrow,[uib-popover-html-popup].popover.right-bottom > .arrow,[uib-popover-template-popup].popover.top-left > .arrow,[uib-popover-template-popup].popover.top-right > .arrow,[uib-popover-template-popup].popover.bottom-left > .arrow,[uib-popover-template-popup].popover.bottom-right > .arrow,[uib-popover-template-popup].popover.left-top > .arrow,[uib-popover-template-popup].popover.left-bottom > .arrow,[uib-popover-template-popup].popover.right-top > .arrow,[uib-popover-template-popup].popover.right-bottom > .arrow{top:auto;bottom:auto;left:auto;right:auto;margin:0;}[uib-popover-popup].popover,[uib-popover-html-popup].popover,[uib-popover-template-popup].popover{display:block !important;}</style>'); angular.$$uibTooltipCss = true; });
angular.module('ui.bootstrap.timepicker').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTimepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-time input{width:50px;}</style>'); angular.$$uibTimepickerCss = true; });
angular.module('ui.bootstrap.typeahead').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTypeaheadCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-typeahead-popup].dropdown-menu{display:block;}</style>'); angular.$$uibTypeaheadCss = true; });

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(158);

module.exports = 'ui.bootstrap';


/***/ }),
/* 160 */,
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _emojiPicker = __webpack_require__(257);

var _emojiPicker2 = _interopRequireDefault(_emojiPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
    'use strict';

    angular.module('canvasModule', ['ngCanvas.dir', 'journey-loader.dir', 'angular.chosen', 'ngCookies']).controller('canvasCon', ['$rootScope', '$scope', '$cookies', '$stateParams', 'canvasService', '$compile', '$timeout', 'helpers', '$q', 'AUTH_EVENTS', 'APRO_BME_URL', canvasController]);

    function canvasController($rootScope, $scope, $cookies, $stateParams, canvasService, $compile, $timeout, helpers, $q, AUTH_EVENTS, APRO_BME_URL) {
        // empty the reference
        $rootScope.userEmailAddress = null;
        //Init the green plus icon in false
        $rootScope.activePlus = false;
        // extending translate method, this method not available on isolate scope
        $scope.translate = $rootScope.translate;
        //View Title
        $scope.title = 'Canvas';
        //Set a journey Id for local storage
        $scope.journeyStorageId = 'journey';
        //Loading Type, local storage as default
        $scope.loaderType = 'local';
        //Results of the http call are stored here
        $scope.journeyRes = {};
        //Translate scope
        $scope.translate = $rootScope.translate;
        //Emit jbloader
        $scope.$emit('jbLoader', true);
        //Unsaved data global
        $rootScope.unsavedData = [];
        // Reset rootScope connections
        $rootScope.connections = [];
        // keeps track of the status of the current journey
        $rootScope.currentJourneyStatus = 0;
        // keep track of the segment list page
        $rootScope.segmentListOffset = $rootScope.segmentListOffset || 1;
        // keep track of the list page
        $rootScope.contactListOffset = $rootScope.contactListOffset || 1;
        // keep track of the email page
        $rootScope.emailListOffset = 2;
        // check when to stop loading the list
        $rootScope.stopLoadingList = false;
        //Get the param of the journey
        var journeyId = $stateParams.canvasId;
        // current AP Id
        $rootScope.currentAPId = journeyId;
        // check if smart send is enabled
        $rootScope.isSmartSendingEnabled = false;
        // check if canvas has email node
        $rootScope.canvasHasEmailNode = false;
        // Feature flags
        $rootScope.hasCodeEditor = true;
        $rootScope.hasAproPublish = true;

        $rootScope.isMasterAccount = helpers.readCookie('isMasterAccount') === '1';
        $scope.bmeUrl = APRO_BME_URL;

        // Todo: 'timer' remove this is just to test loading time
        if (console && typeof console.time === 'function') {
            console.time("answer time");
        }

        Intercom('trackEvent', 'AP-LoadsCanvas');

        localStorage.removeItem('journey');

        var templateId = 'jbFromDefaultTemplate-' + journeyId;
        if (journeyId && localStorage.getItem(templateId) === 'true') {
            var templateName = localStorage.getItem('jbFromDefaultTemplateName-' + journeyId);

            localStorage.removeItem(templateId);
            localStorage.removeItem(templateName);
            $timeout(function () {
                $rootScope.$emit('coach-register', templateName);
            }, 500);
        }

        //Check RootScope connection to check if there is only an Entry on the Canvas.
        //We listen the saveJourneyStorage function on Canvas Service.
        $rootScope.$watch('conn', function () {
            if ($rootScope.currentJourneyStatus != 3 && $rootScope.currentJourneyStatus != 8 && $rootScope.currentJourneyStatus != 4) {
                if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry') {
                    $rootScope.activePlus = true;
                } else {
                    $rootScope.activePlus = false;
                }
            }

            var validAp = helpers.isValidJourney();
            // Reuse this watch for emit the event for show arrow connect or delete arrow
            if ($rootScope.conn) {
                for (var i = 0, l = $rootScope.conn.length; i < l; i++) {
                    var connId = $rootScope.conn[i].id || null;

                    if ($rootScope.conn[i].type === 'Looping') {
                        if ($rootScope.conn[i].hasOwnProperty('children')) {
                            $rootScope.$emit('showConnectionArrow_' + connId, false, connId);
                            $rootScope.$emit('showDeleteArrow_' + connId, true, connId);
                        } else {
                            $rootScope.$emit('showConnectionArrow_' + connId, true, connId);
                            $rootScope.$emit('showDeleteArrow_' + connId, false, connId);
                        }
                    }
                    // get disconnected nodes
                    else if ($rootScope.conn[i].hasOwnProperty('children')) {
                            $rootScope.$emit('showConnectionArrow_' + connId, false, connId);
                            $rootScope.$emit('showDeleteArrow_' + connId, true, connId);
                        } else {
                            if (validAp.disconnectedElements.length === 1 && !$rootScope.conn[i].hasOwnProperty('children') && validAp.disconnectedElements[0] === $rootScope.conn[i].parent || validAp.disconnectedElements.length === 1 && !$rootScope.conn[i].hasOwnProperty('children') && !$rootScope.conn[i].hasOwnProperty('parent') && !$rootScope.conn[i].isRoot || validAp.isValid) {
                                $rootScope.$emit('showConnectionArrow_' + connId, false, connId);
                                $rootScope.$emit('showDeleteArrow_' + connId, false, connId);
                            } else {
                                $rootScope.$emit('showConnectionArrow_' + connId, true, connId);
                                $rootScope.$emit('showDeleteArrow_' + connId, false, connId);
                            }
                        }
                }
            }
        });

        if (journeyId && $rootScope.jbToken) {
            $scope.$emit('displayVeil', false);
            //so if the service fails the app does not crashes
            try {
                //Get the journey
                canvasService.getJourney(journeyId).then(function (result) {
                    _jbCloak();
                    //Set the result data
                    $scope.journeyRes = result.data.JourneyConfiguration;
                    $rootScope.currentJB = JSON.parse(result.data.JourneyConfiguration);
                    // saves current status
                    $rootScope.currentStatus = result.data.Status;
                    //Send the title to the header controller
                    $scope.$emit('journey-title', { name: result.data.JourneyTitle });
                    //Change the canvas loader to grab from service or active journey
                    $scope.loaderType = 'service';
                    //Journey Id
                    $scope.jbId = journeyId;
                    //Set global current status
                    $rootScope.currentJourneyStatus = result.data.Status;
                    // set active days
                    $rootScope.activeDays = helpers.getDayDiff(result.data.ActivatedDate, result.data.LastEditOn);

                    var automationExists = localStorage.getItem('newAutomation' + journeyId) || helpers.readCookie('newAutomation' + journeyId);

                    if (automationExists === 'true') {
                        localStorage.removeItem('newAutomation' + journeyId);
                        $cookies.remove('newAutomation' + journeyId, { domain: 'benchmarkemail.com', path: '/' });
                        $rootScope.$emit('use-template-view');
                    }

                    $scope.fixTopPosCanvas();

                    if (result.data.Status === 3 || result.data.Status === 4 || result.data.Status === 8) {
                        $scope.loaderType = 'active';
                        $rootScope.statusType = 'active';
                        if (result.data.Status === 4) {
                            $scope.$emit('deactivateJourney', true);
                            $scope.$emit('deactivatedJourney', true);
                        } else if (result.data.Status === 8) {
                            $scope.$emit('blockedJourney', true, result.data.LastEditOn);
                        } else {
                            $scope.$emit('activeJourney', true);
                        }
                    } else {
                        $rootScope.statusType = 'draft';
                        $scope.$emit('activeJourney', false);
                    }
                    // clean dom garbage
                    $scope.cleanJourney();
                    $scope.compileLoader();
                    $rootScope.$emit('displayOnboard');

                    var journeyResults = JSON.parse($scope.journeyRes);

                    $scope.journeySegments = $scope._getJourneySegments(journeyResults);
                    if ($scope.journeySegments.length) {
                        $scope.loadingSegments = true;
                        canvasService.getSegmentsById($scope.journeySegments).success(function (res) {
                            res = res.Results;
                            var segmentData = res.map(function (segment) {
                                return {
                                    ContactCount: segment.ContactCount,
                                    ListId: segment.ListId,
                                    ListName: segment.ListName,
                                    SegmentId: segment.SegmentId,
                                    SegmentName: segment.SegmentName,
                                    Segmentdescription: ''
                                };
                            });
                            $rootScope.segmentData = $rootScope.segmentData || [];
                            $rootScope.segmentData = _.reverse(_.uniqBy($rootScope.segmentData.concat(segmentData), 'SegmentId'));
                        }).error(function () {
                            $rootScope.segmentData = $rootScope.segmentData || [];
                        });
                    }

                    $scope.journeyLists = $scope._getJourneyList(journeyResults);
                    $rootScope.journeyLists = $scope.journeyLists;
                    $rootScope.firstNodejourneyLists = [];
                    $scope.firstNodejourneyLists = $scope._getJourneyFirstNodeList(journeyResults);
                    if ($scope.firstNodejourneyLists && $scope.firstNodejourneyLists != null && $scope.firstNodejourneyLists != undefined) {
                        $rootScope.firstNodejourneyLists = $scope.firstNodejourneyLists;
                    }
                    if ($scope.journeyLists.length) {
                        $scope.loadingLists = true;
                        canvasService.getLists($scope.journeyLists).success(function (res) {
                            var listData = res.map(function (list) {
                                return {
                                    ContactCount: list.Contactcount,
                                    ListId: list.Id,
                                    ListName: list.Listname
                                };
                            });
                            $rootScope.contactListData = $rootScope.contactListData || [];
                            $rootScope.contactListData = _.reverse(_.uniqBy($rootScope.contactListData.concat(listData), 'ListId'));
                            $scope.journeyLists = listData.map(function (list) {
                                return list.ListId;
                            });
                            $rootScope.journeyLists = $scope.journeyLists;
                        }).error(function () {
                            $rootScope.contactListData = $rootScope.contactListData || [];
                        });
                    }
                });
            } catch (ex) {
                console.log(ex);
            }
        } else {
            _jbCloak();
            $scope.$emit('jbLoader', false);
            $rootScope.connections = [];
            $timeout(function () {
                $scope.$emit('displayJourney', true);
                $scope.cleanJourney();
                $rootScope.$broadcast('show-box');
            }, 0);
        }

        $scope.fixTopPosCanvas = function () {
            var conns = JSON.parse($scope.journeyRes),
                entry = conns[0];

            if (entry && entry.top < 12020) {
                $('#canvas').css({
                    top: -(entry.top - 40) + 'px'
                });
            }
        };

        $scope.compileLoader = function () {
            // load the journey
            $timeout(function () {
                $compile('<journey-loader></journey-loader>')($scope);
            }, 0);
        };

        $scope._getJourneyList = function (journeyResults) {
            var propsArray = _.map(journeyResults, function (i) {
                if (i.elemName === 'IfElse') {
                    return i.data.conditionGroups.map(function (i) {
                        if (i.type === 'list') {
                            return i.map(function (test) {
                                return test.selectedOpt;
                            });
                        } else {
                            return '';
                        }
                    });
                }if (i.elemName === 'DateAndTime' || i.elemName === 'AddedToList' || i.elemName === 'AddToList' || i.elemName === 'DeleteContactList' || i.elemName === 'IsOnList') {
                    return i.data.selectedList;
                } else {
                    return '';
                }
            });

            return _.uniq(_.compact(_.flattenDeep(propsArray))) || [];
        };

        $scope._getJourneyFirstNodeList = function (journeyResults) {
            var propsArray = [];
            if (journeyResults && journeyResults.length > 0 && journeyResults[0].id) {
                var firstNode = journeyResults[0];
                if (firstNode && firstNode.data && firstNode.data.selectedList && firstNode != null && firstNode != undefined && firstNode.data != null && firstNode.data != undefined && firstNode.data.selectedList != null && firstNode.data.selectedList != undefined) {
                    propsArray = firstNode.data.selectedList || [];
                }
            }

            return _.uniq(_.compact(_.flattenDeep(propsArray))) || [];
        };

        $scope._getJourneySegments = function (journeyResults) {
            var propsArray = _.map(journeyResults, function (i) {
                if (i.elemName === 'IsInSegment' || i.elemName === 'AddedToSegment' || i.elemName === 'DeleteSegmentList' || i.elemName === 'IsNotInSegment') {
                    return i.data.selectedList;
                } else {
                    return '';
                }
            });

            return _.uniq(_.compact(_.flattenDeep(propsArray))) || [];
        };

        $scope._inCurrentSegmentList = function () {
            if (!$rootScope.segmentData) {
                return false;
            }

            var result = $rootScope.segmentData.filter(function (i) {
                return $scope.journeySegments.indexOf(i.SegmentId) > -1;
            }) || [];

            return result.length === $scope.journeySegments.length && result.length > 0;
        };

        $scope._inCurrentContactList = function () {
            if (!$rootScope.contactListData) {
                return false;
            }

            var result = $rootScope.contactListData.filter(function (i) {
                return $scope.journeyLists.indexOf(i.ListId) > -1;
            }) || [];

            return result.length === $scope.journeyLists.length && result.length > 0;
        };

        //Line to scroll canvas to top everytime we come from another page inside the JB
        window.scrollTo(0, 0);

        if ($(window).width() < 768) {
            $timeout(function () {
                $scope.mobileMsg = true;
            }, 2000);
        }

        $scope.hideMobileMsg = function () {
            $scope.mobileMsg = false;
        };

        $scope.cleanJourney = function () {
            $('.canvas ng-init-journey').nextAll().remove();
        };

        function _jbCloak() {
            var cloak = document.getElementById("jbCloak");
            if (cloak) {
                cloak.remove();
            }
            $timeout(function () {
                var css = '.jb-cloak { display:block!important;}',
                    head = document.head || document.getElementsByTagName('head')[0],
                    style = document.createElement('style');

                style.type = 'text/css';
                style.id = 'jbCloak';

                if (style.styleSheet) {
                    style.styleSheet.cssText = css;
                } else {
                    style.appendChild(document.createTextNode(css));
                }

                head.appendChild(style);
            }, 2000);
        }

        $rootScope.isFireFox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
        $rootScope.isChrome = /chrom(e|ium)/.test(navigator.userAgent.toLowerCase());
        if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
            document.onkeydown = function checkKey(e) {
                e = e || window.event;
                if (e.keyCode === 9 || e.keyCode === 32 && e.target.localName === 'body') {
                    return false;
                }
            };
        }

        /*
        * Load Services Section
        * */
        if (!$rootScope.contactListData && !$rootScope.segmentData && journeyId && $rootScope.jbToken) {
            var promiseKeysAsync = ['contactListData', 'segmentData'];
            $rootScope.JBPromisesAsync = [canvasService.getContactList(0, 10) || '', canvasService.getSegments(0, 10) || ''] || [];

            $q.all($rootScope.JBPromisesAsync).then(function (res) {
                var promise;
                for (var i = 0; i < promiseKeysAsync.length; i++) {
                    promise = promiseKeysAsync[i];
                    if (res[i].data.Results && res[i].data.hasOwnProperty('Results')) {
                        $rootScope[promise] = res[i].data.Results;
                    } else {
                        $rootScope[promise] = [{
                            ListId: "400 Error",
                            ListName: "Opps.. Something went wrong"
                        }];
                    }
                }
            }).catch(function (error, status) {
                console.log(error, status);
                if (status === 401) {
                    window.location = AUTH_EVENTS.benchmarkUi;
                } else if (status >= 500) {
                    Intercom('trackEvent', 'AP-ERROR-404', {
                        description: 'Trigger this event whenever a user will be redirected to 404',
                        metadata: {
                            api: 'contactListData and segmentData api',
                            errStatus: status
                        }
                    });

                    window.location = AUTH_EVENTS.maintenancePage;
                }
            });
        }

        canvasService.getEmptyEmail().then(function (_ref) {
            var data = _ref.data;

            $rootScope.emptyEmail = data.Response.Data;
        });

        var emojiWrapper = $('.emoji-picker-wrapper');
        (0, _emojiPicker2.default)(emojiWrapper, function (syncVal, isPreview) {
            if (isPreview) {
                $rootScope.$emit('syncEmojiPreviewText', syncVal);
            } else {
                $rootScope.$emit('syncEmoji', syncVal);
            }
        });

        $scope.zIndex = false;
        $rootScope.$on('zIndex', function (evt, state) {
            $scope.zIndex = state;
        });

        var currectCAnvasPos = $('#canvas-container .canvas').position();
        var xCanvasTop = currectCAnvasPos.top;
        var xCanvasLeft = currectCAnvasPos.left;

        var scale = 1;
        var MAX_SCALE = 1.5;
        var MIN_SCALE = .5;
        $('#selectSlider').slider({
            min: MIN_SCALE,
            value: 1,
            max: MAX_SCALE,
            step: .01,
            slide: function slide(event, ui) {
                scale = ui.value;
                $('#canvas-container .canvas').css({
                    '-webkit-transform': 'scale(' + scale + ')',
                    '-moz-transform': 'scale(' + scale + ')',
                    '-ms-transform': 'scale(' + scale + ')',
                    '-o-transform': 'scale(' + scale + ')',
                    'transform': 'scale(' + scale + ')'
                });

                $('#zoomFill').css({
                    width: (MAX_SCALE - scale - 1) * -100 + '%'
                });
            }
        });

        $scope.recenter = function () {
            scale = 1;
            $('#canvas-container .canvas').css({
                '-webkit-transform': 'scale(' + scale + ')',
                '-moz-transform': 'scale(' + scale + ')',
                '-ms-transform': 'scale(' + scale + ')',
                '-o-transform': 'scale(' + scale + ')',
                'transform': 'scale(' + scale + ')'
            });

            $('#zoomFill').css({
                width: '50%'
            });

            $("#selectSlider").slider('value', 1);

            setTimeout(function () {
                var entryPos = $('.Entry').position();

                currectCAnvasPos = {
                    top: -(entryPos.top - (entryPos.top - 12000)),
                    left: -(entryPos.left - (entryPos.left - 11980))
                };

                $('#canvas').css({ top: currectCAnvasPos.top, left: currectCAnvasPos.left });

                xCanvasLeft = currectCAnvasPos.left;
                xCanvasTop = currectCAnvasPos.top;
            }, 300);
        };

        $scope.zoomOut = function () {
            scale = scale - scale * .18;

            if (scale > MAX_SCALE) {
                scale = MAX_SCALE;
            }

            if (scale < MIN_SCALE) {
                scale = MIN_SCALE;
            }

            $('#canvas-container .canvas').css({
                '-webkit-transform': 'scale(' + scale + ')',
                '-moz-transform': 'scale(' + scale + ')',
                '-ms-transform': 'scale(' + scale + ')',
                '-o-transform': 'scale(' + scale + ')',
                'transform': 'scale(' + scale + ')'
            });

            $('#zoomFill').css({
                width: (MAX_SCALE - scale - 1) * -100 + '%'
            });

            $("#selectSlider").slider('value', scale);
        };

        $scope.zoomIn = function () {
            scale = scale + scale * .18;

            if (scale > MAX_SCALE) {
                scale = MAX_SCALE;
            }

            if (scale < MIN_SCALE) {
                scale = MIN_SCALE;
            }

            $('#canvas-container .canvas').css({
                '-webkit-transform': 'scale(' + scale + ')',
                '-moz-transform': 'scale(' + scale + ')',
                '-ms-transform': 'scale(' + scale + ')',
                '-o-transform': 'scale(' + scale + ')',
                'transform': 'scale(' + scale + ')'
            });

            $('#zoomFill').css({
                width: (MAX_SCALE - scale - 1) * -100 + '%'
            });

            $("#selectSlider").slider('value', scale);
        };

        var canvas = document.getElementById('canvas');
        canvas.onwheel = function (e) {
            e.preventDefault();
            if (e.ctrlKey || e.metaKey) {
                // Your zoom/scale factor
                if (scale <= MAX_SCALE && scale >= MIN_SCALE) {
                    scale -= e.deltaY * 0.01;
                }
                if (scale > MAX_SCALE) {
                    scale = MAX_SCALE;
                }

                if (scale < MIN_SCALE) {
                    scale = MIN_SCALE;
                }

                $("#selectSlider").slider('value', scale);

                $('#zoomFill').css({
                    width: (MAX_SCALE - scale - 1) * -100 + '%'
                });

                $('#canvas-container .canvas').css({
                    '-webkit-transform': 'scale(' + scale + ')',
                    '-moz-transform': 'scale(' + scale + ')',
                    '-ms-transform': 'scale(' + scale + ')',
                    '-o-transform': 'scale(' + scale + ')',
                    'transform': 'scale(' + scale + ')'
                });
            } else {
                xCanvasLeft = xCanvasLeft - e.deltaX;
                xCanvasTop = xCanvasTop - e.deltaY;

                $('#canvas').css({ top: xCanvasTop, left: xCanvasLeft });
            }
        };

        var CANVAS_ARROW = 350;
        // register the shortcut handler handler
        document.addEventListener('keyup', function (e) {
            var visibleEl = $('.options-modal').is(':visible');
            var visibleEl2 = $('.modal').is(':visible');

            if (e.target.tagName === 'BODY' && !visibleEl && !visibleEl2) {
                // arrow left
                if (e.keyCode === 37) {
                    xCanvasLeft += CANVAS_ARROW;
                }

                // arrow top
                if (e.keyCode === 38) {
                    xCanvasTop += CANVAS_ARROW;
                }

                // arrow right
                if (e.keyCode === 39) {
                    xCanvasLeft -= CANVAS_ARROW;
                }

                // arrow bottom
                if (e.keyCode === 40) {
                    xCanvasTop -= CANVAS_ARROW;
                }

                $('#canvas').css({
                    top: xCanvasTop,
                    left: xCanvasLeft,
                    transition: 'all .3s ease'
                });

                setTimeout(function () {
                    $('#canvas').css({ transition: '' });
                }, 400);
            }

            if (e.ctrlKey && e.keyCode == 190) {
                $scope.recenter();
            }
        }, false);

        $scope.instructionsModal = '\n            <table class=contactUsageBreakdown-table>\n                <thead>\n                    <tr>\n                        <th colspan=2>' + $scope.translate('canvas.zoom.tooltip.1') + '</th>\n                    </tr>\n                </thead>\n                <tbody>\n                    <tr>\n                        <td>' + $scope.translate('canvas.zoom') + '</td>\n                        <td><span class=tooltip-button>CTRL</span> + Scroll</td>\n                    </tr>\n                    <tr>\n                        <td>' + $scope.translate('canvas.zoom.reset') + '</td>\n                        <td><span class=tooltip-button>CTRL</span> + <span class=tooltip-button>.</span></td>\n                    </tr>\n                    <tr>\n                        <td>' + $scope.translate('canvas.zoom.move') + '</td>\n                        <td><span class=tooltip-button>&#9664;</span> <span class=tooltip-button>&#9650;</span> <span class=tooltip-button>&#9654;</span> <span class=tooltip-button>&#9660;</span></td>\n                    </tr>\n                </tbody>\n            </table>\n            <span class=instructions-text>' + $scope.translate('canvas.zoom.tooltip.2') + '</span>';

        canvasService.getSmartSendingInfo().success(function (_ref2) {
            var Response = _ref2.Response;

            $rootScope.isSmartSendingEnabled = Response.Data.SSEnabled === '1';
        });

        helpers.getFeatureFlags().then(function (response) {
            var hasCodeEditor = response.data.data['code-editor'];
            var hasAproPublish = response.data.data['apro-publish'];
            $rootScope.hasCodeEditor = assignValue(hasCodeEditor, true);
            $rootScope.hasAproPublish = assignValue(hasAproPublish, true);
        }).finally(function () {
            return $rootScope.$emit('featureFlagsLoaded', true);
        });

        function assignValue(value, defaultValue) {
            if (typeof value === 'undefined') {
                return defaultValue;
            }

            return value;
        }
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    angular.module('coachingModule', ['ngAnimate', 'journey.canvas.srv']).controller('coachingCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', '$sce', '$templateCache', function ($scope, $rootScope, $timeout, canvasService, helpers, $sce, $templateCache) {
        $scope.coachingSilentMode = false;
        $scope.silent = {};
        $scope.entryQueue = [];
        $scope.entryInProgress = false;
        $scope.coachingFull = false;
        $scope.emptyData = false;

        $rootScope.$watch('translate', function (func) {
            if (func) {
                $scope.translate = func;
            }
        });

        $scope.init = function () {
            $scope.loadingCoach = true;
            canvasService.getCoach($rootScope.currentAPId).success(function (res) {
                $scope.loadingCoach = false;

                if (res.Parameters) {
                    $scope.coachData = {
                        entries: [],
                        enabled: true
                    };

                    var entries = JSON.parse(res.Parameters) || [];
                    $scope.coachData.entries = entries.map(function (entry) {
                        if (entry.category) {
                            entry.category = $scope.translate('canvas.coach.' + entry.key + '.category');
                            entry.subCategory = $scope.translate('canvas.coach.' + entry.key + '.subcategory');
                            entry.description = $scope.translate('canvas.coach.' + entry.key + '.description');
                            entry.description2 = $scope.translate('canvas.coach.' + entry.key + '.description2');
                            entry.event = $scope.translate('canvas.coach.' + entry.key + '.event');
                            entry.eventText = $scope.translate('canvas.coach.' + entry.key + '.eventText');
                        }

                        return entry;
                    });

                    $scope.coachData.enabled = res.Enable;
                } else {
                    $scope.coachData = {
                        entries: [],
                        enabled: res.Enable
                    };
                }
            });
        }();

        $scope.$watch('coachData', function (data) {
            if (data && !$scope.loadingCoach && $scope.deferrKeys.length) {
                $scope.deferrKeys.map(function (key) {
                    $timeout(function () {
                        $rootScope.$emit('coach-register', key);
                    }, 100);
                });
            }
        });

        $scope.deferrKeys = [];
        $rootScope.$on('coach-register', function (evt, key) {
            if (key && key === 'tipLooping') {
                var coachTip = window.localStorage.getItem('looping-coach-' + $rootScope.currentAPId);
                if (coachTip) {
                    return;
                } else {
                    window.localStorage.setItem('looping-coach-' + $rootScope.currentAPId, 'true');
                }
            }

            if ($scope.loadingCoach && !$scope.coachData) {
                $scope.deferrKeys.push(key);
                return;
            }

            if (key) {
                $scope.newEntry = true;
                $timeout(function () {
                    $scope.newEntry = false;
                }, 4500);

                if (!$scope.coachData.enabled) {
                    $scope.processEntry(key);
                }
                if (!$scope.entryInProgress) {
                    $scope.processEntry(key);
                } else {
                    if ($scope.coachData.entries[0].key !== key) {
                        $scope.entryQueue.push(key);
                    }
                }
            }
        });

        $scope.processEntry = function (key) {
            var entry = {
                key: key,
                category: $scope.translate('canvas.coach.' + key + '.category'),
                categoryId: $scope.translate('canvas.coach.' + key + '.category.id'),
                subCategory: $scope.translate('canvas.coach.' + key + '.subcategory'),
                description: $scope.translate('canvas.coach.' + key + '.description'),
                description2: $scope.translate('canvas.coach.' + key + '.description2'),
                eventText: $scope.translate('canvas.coach.' + key + '.eventText'),
                event: $scope.translate('canvas.coach.' + key + '.event')
            },
                temp = [];

            var img = $scope.translate('canvas.coach.' + key + '.img');
            if (img) {
                entry.img = 'imgs/coaching/' + img;
            }

            if ($scope.coachData.entries.length) {
                temp = $scope.coachData.entries.filter(function (item, index) {
                    if (item.key === key) {
                        $scope.cIndex = index;
                    }

                    return item.key === key;
                });
            }

            if (temp.length) {
                if ($scope.cIndex !== 0) {
                    $scope.coachData.entries = helpers.move($scope.coachData.entries, $scope.cIndex, 0);
                }
            } else {
                $scope.coachData.entries.unshift(entry);
            }

            if ($scope.coachData.enabled) {
                $scope.goSilent();
            }

            if (entry.category === 'TEMPLATE') {
                $scope.displayCoaching();
            }

            canvasService.saveCoach($rootScope.currentAPId, $scope.coachData.entries, $scope.coachData.enabled).success(function (res) {});
        };

        $scope.disableCoach = function () {
            Intercom('trackEvent', 'AP Coach - Clicked Silent Mode');
            $scope.coachData.enabled = false;
            $scope.coachingFull = false;
            canvasService.saveCoach($rootScope.currentAPId, $scope.coachData.entries, $scope.coachData.enabled).success(function (res) {});
        };

        $scope.enableCoach = function () {
            $scope.coachData.enabled = true;
            canvasService.saveCoach($rootScope.currentAPId, $scope.coachData.entries, $scope.coachData.enabled).success(function (res) {});
        };

        $scope.displayCoaching = function () {
            Intercom('trackEvent', 'AP Clicked Coach Icon');
            $scope.emptyData = $scope.coachData.entries.length <= 0;
            $scope.coachingFull = true;
            $scope.coachingSilentMode = false;
            $scope.preventClosing = true;
        };

        $scope.hideCoaching = function () {
            $scope.coachingFull = false;
        };

        $scope.goSilent = function () {
            $scope.coachingSilentMode = true;
            $scope.entryInProgress = true;

            $timeout(function () {
                $scope.coachingSilentMode = false;

                if ($scope.entryQueue.length) {
                    $scope.processEntry($scope.entryQueue.pop());
                }

                $scope.entryInProgress = false;
            }, 7000);
        };

        $scope.$on('closeCoaching', function () {
            if (!$scope.preventClosing) {
                $scope.coachingFull = false;
            } else {
                $scope.preventClosing = false;
            }
        });

        $scope.triggerEvent = function (evt, data) {
            $rootScope.$emit(evt, data);
        };
    }]);
})();

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    'use strict';

    angular.module('dataHandlingModule', ['ngAnimate', 'journey.canvas.srv', 'dataHandlingActionAddList', 'dataHandlingIsNotInSegment', 'dataHandlingIsInSegment', 'dataHandlingActionAddWaitTime', 'dataHandlingActionUpdateField', 'dataHandlingActionRemoveList', 'dataHandlingConditionIsInList', 'dataHandlingConditionWebsiteActivity', 'dataHandlingConditionIfElse', 'dataHandlingConditionEmailEngagement', 'dataHandlingActionSendEmail', 'dataHandlingActionFacebookAudience']).controller('dataHandleCtrl', ['$scope', '$rootScope', '$location', '$timeout', '$stateParams', 'canvasService', 'helpers', dataController]);

    function dataController($scope, $rootScope) {
        $rootScope.$watch('translate', function (func) {
            if (func) {
                $scope.translate = func;
                $scope.selectedKey = $scope.translate('commons.selectList');
            }
        });
    }
})();

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    'use strict';

    angular.module('entryModalModule', []).controller('entryModalCtrl', ['$scope', '$rootScope', '$location', '$timeout', '$stateParams', 'canvasService', '$compile', 'helpers', 'CANVAS_OPTS', entryModalCtrl]);

    function entryModalCtrl($scope, $rootScope, $location, $timeout, $stateParams, canvasService, $compile, helpers, CANVAS_OPTS) {
        $rootScope.$on('displayEntryModal', function (evt, view, connection) {

            // Listener to close modal if user click outside the modal
            $('body, .trigger-panel-modal').on('click', '.modal-dialog', function (e) {
                if ($(e.target).hasClass('modal-dialog')) {
                    $scope.showTriggerPanelModal = false;
                }
            });

            if (!view && !connection) {
                $scope.showTriggerPanelModal = true;
                $scope.showTriggerPanelMenu = true;
                $scope.isWebsiteEngagementFormDisplayed = false;
                $scope.isAddToSegmentFormDisplayed = false;
                $scope.isAddToListFormDisplayed = false;
                $scope.isDateTimeFormDisplayed = false;
                $scope.editView = false;
                $scope.connections = [];
            } else {
                $scope.connections = angular.copy(connection);
                $scope.showTriggerPanelMenu = false;
                $scope.showTriggerPanelModal = true;
                $scope[view] = true;
                $scope.editView = true;
            }
        });

        // Close modal
        $scope.closeTriggerPanelModal = function () {
            $scope.showTriggerPanelModal = false;
            $scope.isWebsiteEngagementFormDisplayed = false;
            $scope.isAddToSegmentFormDisplayed = false;
            $scope.isAddToListFormDisplayed = false;
            $scope.isDateTimeFormDisplayed = false;
        };

        // Show Add To List Form
        $scope.showAddToListForm = function () {
            $scope.isAddToListFormDisplayed = true;
            $scope.showTriggerPanelMenu = false;
        };

        // Show Add To Segment Form
        $scope.showAddToSegmentForm = function () {
            $scope.isAddToSegmentFormDisplayed = true;
            $scope.showTriggerPanelMenu = false;
        };

        // Show Web Site Engagement Form
        $scope.showWebsiteEngagementForm = function () {
            $scope.isWebsiteEngagementFormDisplayed = true;
            $scope.showTriggerPanelMenu = false;
        };

        // Show Specific Date and Time Form
        $scope.showDateTimeForm = function () {
            $scope.isDateTimeFormDisplayed = true;
            $scope.showTriggerPanelMenu = false;
        };

        // Save Join to List
        $scope.saveJoinToListForm = function () {
            $scope.showListSelectionError = false;

            if ($scope.connections.data.selectedList.length === 0) {
                $scope.showListSelectionError = true;
                return;
            }

            if ($scope.editView) {
                // Emit the save connections
                $rootScope.$emit('saveEntryData' + $scope.connections.id, $scope.connections);
            } else {
                var now = new Date(),
                    directiveName = 'add-to-list-entry',
                    newScope = $scope.$new(true);

                // to display step 2
                $rootScope.activePlus = true;

                // load the journey
                $scope.connections.id = 'entry_' + now.getTime();
                $scope.connections.top = CANVAS_OPTS.canvasOptions.top;
                $scope.connections.left = CANVAS_OPTS.canvasOptions.left;
                $scope.connections.type = 'Entry';
                $scope.connections.elemClass = { 'addToListEntry': 'add-to-list-entry' };
                $scope.connections.elemName = 'AddedToList';
                $scope.connections.color = '#4F4FC9';
                $scope.connections.isRoot = true;
                $scope.connections.isElegibleForUpdate = true;

                $timeout(function () {
                    $rootScope.cElement = $scope.connections;
                    $compile('<' + directiveName + '></' + directiveName + '>')(newScope);
                    $scope.connections.wasSave = true;
                }, 10);

                $timeout(function () {
                    $scope.connections.wasSave = false;
                }, 1500);
            }

            $scope.isAddToListFormDisplayed = false;
            $scope.showTriggerPanelModal = false;
            $scope.hideJourney();
        };

        // Save Join to Segment
        $scope.saveJoinToSegmentForm = function () {
            $scope.showSegmentSelectionError = false;

            if ($scope.connections.data.selectedList.length === 0) {
                $scope.showSegmentSelectionError = true;
                return;
            }

            if ($scope.editView) {
                // Emit the save connections
                $rootScope.$emit('saveEntrySegmentData' + $scope.connections.id, $scope.connections);
            } else {
                var directiveName = 'add-to-segment-entry',
                    newScope = $scope.$new(true);

                // to display step 2
                $rootScope.activePlus = true;

                // load the journey
                $scope.connections.top = CANVAS_OPTS.canvasOptions.top;
                $scope.connections.left = CANVAS_OPTS.canvasOptions.left;
                $scope.connections.type = 'Entry';
                $scope.connections.elemClass = { 'addToSegmentEntry': 'add-to-segment-entry' };
                $scope.connections.elemName = 'AddedToSegment';
                $scope.connections.color = '#4F4FC9';
                $scope.connections.isRoot = true;
                $scope.connections.isElegibleForUpdate = true;

                $timeout(function () {
                    $rootScope.cElement = $scope.connections;
                    $compile('<' + directiveName + '></' + directiveName + '>')(newScope);
                    $scope.connections.wasSave = true;
                }, 10);

                $timeout(function () {
                    $scope.connections.wasSave = false;
                }, 2000);
            }

            $scope.isAddToSegmentFormDisplayed = false;
            $scope.showTriggerPanelModal = false;
            $scope.hideJourney();
        };

        // Save web site engagement
        $scope.saveWebsiteEngagement = function () {
            $scope.showSpecificUrlError = false;

            if ($scope.connections.data.specificUrl === '' && $scope.connections.data.source !== 'any-tracked-page' || $scope.specificUrlError) {
                $scope.showSpecificUrlError = true;
                return;
            }

            if ($scope.editView) {
                // Emit the save connections
                $rootScope.$emit('saveEngagementEntryData' + $scope.connections.id, $scope.connections);
            } else {
                var directiveName = 'website-engagement',
                    newScope = $scope.$new(true);

                // to display step 2
                $rootScope.activePlus = true;

                // load the journey
                // load the journey
                $scope.connections.top = CANVAS_OPTS.canvasOptions.top;
                $scope.connections.left = CANVAS_OPTS.canvasOptions.left;
                $scope.connections.type = 'Entry';
                $scope.connections.elemClass = { 'websiteEngagement': 'website-engagement' };
                $scope.connections.elemName = 'WebsiteEngagement';
                $scope.connections.color = '#4F4FC9';
                $scope.connections.isRoot = true;
                $scope.connections.isElegibleForUpdate = true;

                $timeout(function () {
                    $rootScope.cElement = $scope.connections;
                    $compile('<' + directiveName + '></' + directiveName + '>')(newScope);
                    $scope.connections.wasSave = true;
                }, 10);

                $timeout(function () {
                    $scope.connections.wasSave = false;
                }, 2000);
            }

            $scope.isWebsiteEngagementFormDisplayed = false;
            $scope.showTriggerPanelModal = false;
            $scope.hideJourney();
        };

        // Save Join to Segment
        $scope.saveDateTimeForm = function () {
            $scope.showListSelectionError = false;
            $scope.showDateSelectionError = false;
            $scope.showTimeSelectionError = false;

            if ($scope.connections.data.selectedList.length === 0 || $scope.connections.data.time === '' || $scope.connections.data.timezoneName === '') {
                if ($scope.connections.data.selectedList.length === 0) {
                    $scope.showListSelectionError = true;
                }

                if ($scope.connections.data.time === '') {
                    $scope.showDateSelectionError = true;
                }

                if ($scope.connections.data.timezoneName === '') {
                    $scope.showTimeSelectionError = true;
                }

                return;
            }

            if ($scope.editView) {
                // Emit the save connections
                $rootScope.$emit('saveEntryDateTimeData' + $scope.connections.id, $scope.connections);
            } else {
                var directiveName = 'date-and-time',
                    newScope = $scope.$new(true);

                // to display step 2
                $rootScope.activePlus = true;

                // load the journey
                $scope.connections.top = CANVAS_OPTS.canvasOptions.top;
                $scope.connections.left = CANVAS_OPTS.canvasOptions.left;
                $scope.connections.type = 'Entry';
                $scope.connections.elemClass = { 'dateAndTime': 'date-and-time' };
                $scope.connections.elemName = 'DateAndTime';
                $scope.connections.color = '#4F4FC9';
                $scope.connections.isRoot = true;
                $scope.connections.isElegibleForUpdate = true;

                $timeout(function () {
                    $rootScope.cElement = $scope.connections;
                    $compile('<' + directiveName + '></' + directiveName + '>')(newScope);
                    $scope.connections.wasSave = true;
                }, 10);

                $timeout(function () {
                    $scope.connections.wasSave = false;
                }, 2000);
            }

            $scope.isAddToSegmentFormDisplayed = false;
            $scope.showTriggerPanelModal = false;
            $scope.hideJourney();
        };

        $scope.$on('updateDateFormCtrl', function (evt, time) {
            if ($scope.connections && $scope.connections.data) {
                $scope.connections.data.time = time;
            }
        });
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    'use strict';

    angular.module('footerModule', ['journey.veil', 'journey.canvas.srv', 'infinite-scroll']).controller('footerCtrl', ['$scope', '$location', '$rootScope', 'veilService', '$stateParams', 'canvasService', '$timeout', 'cacheService', 'scrollLoader', 'helpers', '$sce', '$q', footerController]);

    function footerController($scope, $location, $rootScope, veilService, $stateParams, canvasService, $timeout, cacheService, scrollLoader, helpers, $sce, $q) {
        //Save as Template modal
        $scope.saveAsTemp = false;
        $scope.featureFlagsLoaded = false;

        $scope.isMasterAccount = helpers.readCookie('isMasterAccount') === '1';

        $scope.defaultTemplateList = $rootScope.journeyDefaultTemplates;

        $scope.$watch('journeyDefaultTemplates', function (val) {
            if (val) {
                $scope.defaultTemplateList = $rootScope.journeyDefaultTemplates;
                $scope.defaultTemplateList.unshift({
                    key: 'startFromScratch',
                    id: 'scratch',
                    JourneyName: 'custom.templates.fromScratch',
                    JourneyDescription: 'custom.templates.fromScratch.desc'
                });
            }
        });

        //Checks if path contains canvas word in the url
        var isCanvasPath = function isCanvasPath() {
            return $location.path().indexOf('canvas') > -1;
        };

        var init = function init() {
            $scope.footerModule = isCanvasPath();
        };
        init();

        $scope.$watch('footerModule', function (val) {
            $scope.templatesModal = false;
            $scope.extraVeilHeader = false;
            $scope.saveAsTemp = false;
        });

        //Save Journey global button
        $scope.saveJourney = function (noLoader) {
            // we should only save draft ones
            if ($rootScope.currentStatus !== 1) {
                //log status save
                Intercom('trackEvent', 'AP-ERRORS', {
                    description: 'Trigger this event when an incorrect status is triggered',
                    metadata: {
                        errorType: 'status',
                        api: 'update journeys',
                        status: $rootScope.currentStatus
                    }
                });

                return;
            }
            var jbTitle = $rootScope.currentJBTitle || 'Journey Name';
            if (!noLoader) {
                //$rootScope.$emit('jbLoader', true, true);
                $rootScope.$emit('errorMsg', $scope.translate('common.saved.successful'), 'confirmation', 2500);
            }

            if ($stateParams.canvasId) {
                if ($rootScope.unsavedData.length && !noLoader) {
                    $rootScope.unsavedData.forEach(function (id) {
                        $rootScope.$emit('saveUnsavedData' + id);
                    });
                }
                // existing canvas only update the canvas
                var connData = helpers.updateAllPos($rootScope.connections);
                var payload = {
                    JourneyTitle: jbTitle,
                    JourneyConfiguration: JSON.stringify(connData)
                };

                if (!$rootScope.connections) {
                    return;
                }
                canvasService.updateJourney(payload, $stateParams.canvasId, $rootScope.connections.length).success(function (res) {
                    $timeout(function () {
                        $rootScope.$emit('jbLoader', false, true);
                    }, 0);
                }).error(function (err) {
                    //Error msg from backend when failing
                    $rootScope.$emit('errorMsg', err.Message);
                    $timeout(function () {
                        $rootScope.$emit('jbLoader', false, true);
                    }, 0);
                });
            }
        };
        //End Save Journey global button

        $scope.duplicateAutomation = function () {
            $scope.apToCopy = { id: $stateParams.canvasId, title: $rootScope.currentJBTitle };
            $scope.copyApModal = true;
        };

        $scope.cancelCopy = function () {
            $scope.copyApModal = false;
            $scope.copyError = false;
        };

        $scope.copyName = { input: '' };
        $scope.savefromCanvas = true;
        $scope.saveCopy = function () {
            if (!$scope.copyName.input) {
                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.601'));
                $scope.copyError = true;
                return;
            }
            var jbName = $scope.copyName.input;
            $scope.displayCopyMenu = [];
            $scope.toolsOpts = [];

            var _next = function _next(res) {
                if (res.data) {
                    var jbConfig = JSON.parse(res.data.JourneyConfiguration) || [],
                        jbEmails = [],
                        jbEmailIds = [],
                        emailPromises;

                    jbEmails = jbConfig.filter(function (i) {
                        return i.elemName === 'SendMail' && !i.isDummy && i.data.emailId !== '11111111';
                    });
                    jbEmailIds = jbEmails.map(function (i) {
                        return i.data.emailId;
                    });
                    emailPromises = jbEmails.map(function (i) {
                        return canvasService.duplicateEmailValidName(i.data.emailId, i.emailData.EmailName, res.data.Status, res.data.JourneyId);
                    });

                    if (jbEmails.length) {
                        $q.all(emailPromises).then(function (res) {

                            jbConfig = jbConfig.map(function (item) {
                                if (item.elemName === 'SendMail') {
                                    var sendEmailIndex = jbEmailIds.indexOf(item.data.emailId);
                                    if (sendEmailIndex > -1) {
                                        item.data.emailId = res[sendEmailIndex].data.Id;
                                        item.data.emailName = res[sendEmailIndex].data.EmailName;
                                        item.emailData = res[sendEmailIndex].data;
                                        item.emailData.TemplateContent = '';
                                        item.emailData.TemplateText = '';
                                        canvasService.generateThumbs(item.data.emailId).then(function () {});
                                    }
                                }

                                return item;
                            });

                            canvasService.createJourney(jbName, JSON.stringify(jbConfig)).success(function (res) {
                                $scope.copyName = { input: '' };
                                $scope.cancelCopy();
                                $scope.isLoading = false;
                                window.location = window.location.origin + '/#/canvas/' + res.JourneyId;
                                window.location.reload(true);
                            });
                        }).catch(function () {
                            $rootScope.$emit('jbLoader', false);
                            $scope.isLoading = false;
                        });
                    } else {
                        canvasService.createJourney(jbName, JSON.stringify(jbConfig)).success(function (res) {
                            $scope.copyName = { input: '' };
                            $scope.cancelCopy();
                            $scope.isLoading = false;
                            window.location = window.location.origin + '/#/canvas/' + res.JourneyId;
                            window.location.reload(true);
                        }).catch(function () {
                            $scope.isLoading = false;
                        });
                    }
                } else {
                    $rootScope.$emit('errorMsg', $scope.translate('canvas.error.607'));
                    $scope.isLoading = false;
                }
            };

            if (!$scope.isLoading) {
                $scope.isLoading = true;
                //Get the journey
                canvasService.getJourney($scope.apToCopy.id).then(_next);
            }
        };

        //Save Journey as a Template Function
        var _saveJourneyTemplate = function _saveJourneyTemplate() {
            var jbTitle = $rootScope.currentJBTitle || 'Journey Name',
                jbTemplateName = $scope.templateName,
                jbTemplateDescription = $scope.templateDescription;

            $rootScope.$emit('jbLoader', true);
            //new canvas, create and redirect
            canvasService.createJourneyTemplate(jbTitle, jbTemplateName, jbTemplateDescription, JSON.stringify($rootScope.connections)).success(function (res) {
                if ($scope.paginateTemplateList && $scope.paginateTemplateList.resList) {
                    if (!$scope.findInList(res.TemplateId)[0]) {
                        $scope.paginateTemplateList.resList[0].unshift(res);
                    }
                } else {
                    $scope.newTemplate = res;
                }

                $rootScope.$emit('errorMsg', $scope.translate('canvas.templates.confirmSavedTpl'), 'confirmation');
                $rootScope.$emit('jbLoader', false);
                $scope.templateName = '';
                $scope.templateDescription = '';
            });
        };
        //End Save Journey as a Template Function

        $scope.loadTemplateConfirmation = false;
        //Select Template Journey
        $scope.selectTemplate = function (template) {

            if (template.IsGeneralTemplate) {
                //load template data for "canvas.general.template.1.title"
                $scope.displayInfoTemplateModal = true;
                $scope.setUpTemplate(template);
            } else {
                $scope.loadTemplateConfirmation = true;
            }

            $scope.cancelTplSelect = function (closeBoth) {
                if (closeBoth) {
                    $scope.hideModal();
                }
                $scope.loadTemplateConfirmation = false;
                $scope.displayInfoTemplateModal = false;
                $scope.videoData = '';
            };

            $scope.selectTplConfirm = function () {
                var tplTitle = template.JourneyTitle || 'Journey Name',
                    tplConfig = template.JourneyConfiguration;
                $scope.loadTemplateConfirmation = false;
                $rootScope.$emit('jbLoader', true);

                if (template.IsGeneralTemplate) {
                    tplConfig = JSON.stringify(template.JourneyConfiguration);
                    tplTitle = $rootScope.currentJBTitle;
                }

                if ($stateParams.canvasId) {
                    // existing canvas only update the canvas
                    var payload = {
                        JourneyTitle: tplTitle,
                        JourneyConfiguration: tplConfig
                    };
                    canvasService.updateJourney(payload, $stateParams.canvasId, template.JourneyConfiguration.length).success(function (res) {
                        cacheService.destroyCache('jb:' + res.JourneyId + ':config');
                        cacheService.destroyCache('jb:' + res.JourneyId + ':title');
                        cacheService.deleteCachePattern('journeys:all:');

                        if (template.IsGeneralTemplate && $rootScope.localStorageSupported) {
                            localStorage.setItem('jbFromDefaultTemplate-' + res.JourneyId, 'true');
                            localStorage.setItem('jbFromDefaultTemplateName-' + res.JourneyId, template.key);

                            switch (template.key) {
                                case 'welcomeNewSubscribers':
                                    AP.Analytics({ eventLabel: 'welcometactivated' });
                                    Intercom('trackEvent', 'ap-t-welcome');
                                    break;
                                case 'promoteTargetOpens':
                                    Intercom('trackEvent', 'AP-T-PromoteTargetOpens');
                                    break;
                                case 'promoteTargetClicks':
                                    Intercom('trackEvent', 'AP-T-PromoteTargetClicks');
                                    break;
                                case 'promoteTargetOpensClicksWebsiteEngagement':
                                    Intercom('trackEvent', 'AP-T-PromoteTargetWE');
                                    break;
                                case 'followUpSeries':
                                    Intercom('trackEvent', 'AP-T-Followup');
                                    break;
                                case 'abandonedCart':
                                    Intercom('trackEvent', 'AP-T-Cart');
                                    break;
                                case 'feedbackRequest':
                                    Intercom('trackEvent', 'AP-T-Feedback');
                                    break;
                                case 'reviewRequest':
                                    Intercom('trackEvent', 'AP-T-Review');
                                    break;
                            }
                        } else {
                            //Track Event Intecrom - Created from Template
                            Intercom('trackEvent', 'AP - created journey from template');
                        }

                        window.location = '/#/canvas/' + res.JourneyId;
                        window.location.reload(true);
                    }).error(function (err) {
                        //Error msg from backend when failing
                        $rootScope.$emit('errorMsg', err.Message);
                        $timeout(function () {
                            $rootScope.$emit('jbLoader', false);
                        }, 0);
                    });
                } else {
                    //new canvas, create and redirect
                    canvasService.createJourney(tplTitle, tplConfig).success(function (res) {
                        if (template.IsGeneralTemplate && $rootScope.localStorageSupported) {
                            localStorage.setItem('jbFromDefaultTemplate-' + res.JourneyId, 'true');
                        }

                        window.location = '/#/canvas/' + res.JourneyId;
                        window.location.reload(true);
                        return;
                    });
                }
            };
        };

        $rootScope.$on('displayInfoSubModal', function (evt, data) {
            $scope.welcomeNewSubscribers = false;
            $scope.promoteTargetOpens = false;
            $scope.promoteTargetClicks = false;
            $scope.promoteTargetOpensClicksWebsiteEngagement = false;
            $scope.followUpSeries = false;
            $scope.abandonedCart = false;
            $scope.feedbackRequest = false;
            $scope.reviewRequest = false;
            $scope.facebookAudience = false;
            $scope.displayInfoSingleModal = true;
            $scope.journeyTplTitle = $scope.translate('canvas.coach.' + data + '.subcategory');
            $scope.videoData = $sce.trustAsHtml($scope.getVideoData(data));
            $scope[data] = true;

            setTimeout(function () {
                $(".template-info .content").scrollTop(0);
            }, 100);
        });

        $scope.setUpTemplate = function (template) {
            $(".template-info .content").scrollTop(0);

            $scope.welcomeNewSubscribers = false;
            $scope.promoteTargetOpens = false;
            $scope.promoteTargetClicks = false;
            $scope.promoteTargetOpensClicksWebsiteEngagement = false;
            $scope.followUpSeries = false;
            $scope.abandonedCart = false;
            $scope.feedbackRequest = false;
            $scope.reviewRequest = false;
            $scope.facebookAudience = false;

            $scope.videoData = $sce.trustAsHtml($scope.getVideoData(template.key));
            $scope[template.key] = true;

            $scope.level = template.level;
            $scope.journeyTplTitle = $scope.translate(template.JourneyName);
            $scope.currentTplId = template.id;
        };

        $scope.getVideoData = function (key) {
            return {
                welcomeNewSubscribers: '<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_amtyi1h65a seo=false videoFoam=true" style="height:100%;width:100%">&nbsp;</div></div></div>',
                promoteTargetOpens: '<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_ghuhu5wxr4 seo=false videoFoam=true" style="height:100%;width:100%">&nbsp;</div></div></div>',
                promoteTargetClicks: '<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_fpf9tlxifv seo=false videoFoam=true" style="height:100%;width:100%">&nbsp;</div></div></div>',
                promoteTargetOpensClicksWebsiteEngagement: '<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_5g9jzvl1ql seo=false videoFoam=true" style="height:100%;width:100%">&nbsp;</div></div></div>',
                followUpSeries: '<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_h4xh22op0s seo=false videoFoam=true" style="height:100%;width:100%">&nbsp;</div></div></div>',
                abandonedCart: '<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_qt67p83yr0 seo=false videoFoam=true" style="height:100%;width:100%">&nbsp;</div></div></div>',
                feedbackRequest: '<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_yauft446ny seo=false videoFoam=true" style="height:100%;width:100%">&nbsp;</div></div></div>',
                reviewRequest: '<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_0ecb16y4xe seo=false videoFoam=true" style="height:100%;width:100%">&nbsp;</div></div></div>',
                facebookAudience: '<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_0ecb16y4xe seo=false videoFoam=true" style="height:100%;width:100%">&nbsp;</div></div></div>'
            }[key || 'welcomeNewSubscribers'];
        };
        $scope.getVideoData();

        //Display the Save As Template modal
        $scope.saveAsTemplate = function () {
            $scope.saveAsTemp = true;
        };

        //Cancel save as Template Action
        $scope.cancelSaveAs = function () {
            $scope.saveAsTemp = false;
        };

        //Save as template button
        $scope.saveAsTemplateBtn = function () {
            //Track saved template Intercom
            Intercom('trackEvent', 'AP - saved journey templates');

            var rootConn = $rootScope.connections || [];
            if ($scope.dataTplFormFilledCorrectly()) {
                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.601'));
                //validate that we have something to save.
            } else if (rootConn.length === 0) {
                $rootScope.$emit('errorMsg', $scope.translate('canvas.activate.error.2'));
                return;
            }
            //If data is correct, we proceed to save the data
            else {
                    _saveJourneyTemplate();
                    $scope.saveAsTemp = false;
                }
        };

        //Validates if data is filled correctly or not for save as template form
        $scope.templateDescription = '';
        $scope.templateName = '';
        $scope.dataTplFormFilledCorrectly = function () {
            var res = false;
            $scope.displayErrorName = false;
            $scope.displayErrorDescription = false;

            if (!$scope.templateName) {
                $scope.displayErrorName = true;
                res = true;
            }

            if (!$scope.templateDescription) {
                $scope.displayErrorDescription = true;
                res = true;
            }

            return res;
        };

        //Functions for crop text on templates, title and description
        $scope.parseText = function (text, type) {

            if (text === null || text === undefined) {
                text = 'No text available';
            }
            var textLength = text.length;

            if (textLength > 21 && type === 'title') {
                text = text.slice(0, 21) + "...";
            } else if (textLength > 110 && type === 'description') {
                text = text.slice(0, 110) + "...";
            }

            return text;
        };
        //End function for crop text


        //Clear all selected templates
        $scope.clearSelected = function () {
            $scope.selectedTemplate.length = 0;
            $scope.savedOptions = false;
        };
        //End Clear selected

        //Toggle List Item to check if a checkbox is checked, If not we add it to the array of IDs, if not we delete it and just save the ones selected
        $scope.selectedTemplate = [];

        $scope.toggelListItem = function (listItem) {

            var index = $scope.selectedTemplate.indexOf(listItem);

            if (index > -1) {
                $scope.selectedTemplate.splice(index, 1);
            } else {
                $scope.selectedTemplate.push(listItem);
            }

            if ($scope.selectedTemplate.length) {
                $scope.defaultOptions = true;
                $scope.savedOptions = true;
            } else {
                $scope.defaultOptions = false;
                $scope.savedOptions = false;
            }
        };
        //End toggle list

        //Find ids into Template list
        $scope.findInList = function (id) {
            var index, dept;
            for (var i = 0; i < $scope.paginateTemplateList.resList.length; i++) {
                for (var j = 0; j < $scope.paginateTemplateList.resList[i].length; j++) {
                    if ($scope.paginateTemplateList.resList[i][j].TemplateId === id) {
                        index = j;
                        dept = i;
                        break;
                    }
                }
            }
            return [dept, index];
        };

        //Function to receive list of array and prepare them to be deleted on the front end view
        $scope.deleteArray = function (ids) {
            var idsToDelete = [];
            ids.forEach(function (entry) {
                idsToDelete.push($scope.findInList(entry));
            });
            return idsToDelete;
        };

        $scope.deleteSelected = function () {
            $scope.deleteConfirmation = true;

            $scope.deleteTemplates = function () {
                $rootScope.$emit('jbLoader', true);

                var templatesArray = $scope.selectedTemplate;

                canvasService.deleteTemplate(templatesArray).success(function () {
                    var _loop = function _loop(i) {
                        $scope.paginateTemplateList.resList[0] = $scope.paginateTemplateList.resList[0].filter(function (list) {
                            return list.TemplateId !== templatesArray[i];
                        });
                    };

                    //Delete Templates on the front end view
                    for (var i = 0; i < templatesArray.length; i++) {
                        _loop(i);
                    }

                    //Close Confirmation Modal
                    $scope.deleteConfirmation = false;
                    // Close options for delete templates
                    $scope.savedOptions = false;
                    //Empty the array
                    $scope.selectedTemplate = [];

                    //Close Modal
                    $timeout(function () {
                        $rootScope.$emit('jbLoader', false);
                    }, 0);
                }).error(function () {

                    $timeout(function () {
                        $rootScope.$emit('jbLoader', false);
                    }, 0);
                    $rootScope.$emit('errorMsg', $scope.translate('canvas.error.607'));
                });
            };

            $scope.cancelDelete = function () {
                $scope.deleteConfirmation = !$scope.deleteConfirmation;
            };
        };

        //Handling views on the Default Benchmark Templates. Display Grid or List view
        $scope.gridDefaultTemplate = true;
        $scope.gridTemplate = true;

        $scope.defaultViews = function (tpl) {
            //Checking which tab is open. Saved Templates or Default Template
            if ($scope.savedTemplateView === true) {

                if (tpl === 'list') {
                    $scope.gridTemplate = false;
                    $scope.listTemplate = true;
                } else {
                    $scope.gridTemplate = true;
                    $scope.listTemplate = false;
                }
            } else {

                if (tpl === 'list') {
                    $scope.listDefaultTemplate = true;
                    $scope.gridDefaultTemplate = false;
                } else {
                    $scope.gridDefaultTemplate = true;
                    $scope.listDefaultTemplate = false;
                }
            }
        };
        //End Handling views on the Default Benchmark Templates. Display Grid or List view

        $scope.$watch('paginateTemplateList.resList[0]', function (val) {
            if (val && $scope.newTemplate) {
                if (!$scope.findInList($scope.newTemplate.TemplateId)) {
                    $scope.paginateTemplateList.resList[0].unshift($scope.newTemplate);
                }

                $scope.newTemplate = '';
            }
        });

        $scope.displaySearch = function () {
            $scope.searchHandler = true;
        };

        $scope.hideSearch = function () {
            $scope.searchHandler = false;
            $scope.searchTemplate = '';
            $scope.searchText = false;
        };

        $scope.$watch('searchTemplate', function (val) {
            if (val) {
                $scope.searchText = true;
            } else {
                $scope.searchText = false;
            }
        });

        $scope.displayTemplatesMenu = function () {
            $scope.saveAsTemp = false;
            $scope.showTemplatesMenu = true;
            $scope.preventClosing = true;
        };

        $scope.displayTemplatesModalMenu = function () {
            $scope.templateModalOptions = true;
            $scope.preventClosing = true;
        };

        $scope.$on('closeTemplateMenu', function () {
            if ($scope.newAutomation) {
                $scope.validClickingArea();
            } else {
                if (!$scope.preventClosing) {
                    $scope.showTemplatesMenu = false;
                    $scope.templateModalOptions = false;
                } else {
                    $scope.preventClosing = false;
                }
            }
        });

        $scope.newAutomation = false;
        $rootScope.$on('use-template-view', function () {
            $scope.useTemplate();$scope.newAutomation = true;
        });

        //Use Template
        $scope.useTemplate = function () {
            if (!$scope.paginateTemplateList) {
                $scope.paginateTemplateList = new scrollLoader(true);
                $scope.paginateTemplateList.nextPage();
                $scope.setTemplateScrollLogic();
            }

            var canvasEl = document.querySelector(".canvas");
            $scope.modalLeft = canvasEl.offsetLeft * -1 + 200;
            $scope.modalTop = canvasEl.offsetTop * -1.0090;
            $scope.displayInfoTemplateModal = false;
            $scope.videoData = '';
            $scope.templatesModal = true;
            $rootScope.$emit('displayExtraVeil', true, false);
            $scope.extraVeilHeader = true;
            $scope.saveAsTemp = false;
        };

        $scope.setTemplateScrollLogic = function () {
            angular.element(document.querySelector('.templatesContainer')).bind("scroll", function () {
                if (!$scope.paginateTemplateList.busy && !$scope.paginateTemplateList.stopLoading) {
                    $scope.paginateTemplateList.nextPage();
                }
            });
        };

        $scope.hideModal = function () {
            $scope.templatesModal = false;
            $scope.displayInfoTemplateModal = false;
            $scope.videoData = '';
            $scope.extraVeilHeader = false;
            $rootScope.$emit('displayExtraVeil', false, false);
        };

        $scope.buildFromScratch = function () {
            $scope.newAutomation = false;
            AP.Analytics({ eventLabel: 'startfromscratch' });
            Intercom('trackEvent', 'ap-startedfromscratch');
            if ($rootScope.connections && $rootScope.connections.length) {
                $rootScope.connections = [];
                $scope.saveJourney(true);
                $timeout(function () {
                    window.location = '/#/canvas/' + $stateParams.canvasId;
                    window.location.reload(true);
                    return;
                }, 300);
            } else {
                $scope.hideModal();
                $rootScope.$emit('displayEntryModal');
            }
        };

        //Use template functions
        $scope.templateView = true;
        $scope.activeTabTemplate = true;
        $scope.savedTemplateView = false;
        $scope.activeTabSavedTemplates = false;

        //Show templates tab
        $scope.showTemplates = function () {
            $scope.activeTabSavedTemplates = false;
            $scope.savedTemplateView = false;
            $scope.savedOptions = false;
            $rootScope.$emit('displayExtraVeil', true, false);
            $scope.templateView = true;
            $scope.activeTabTemplate = true;
            $scope.clientEmail = $scope.clientEmail || $rootScope.cSettings.SignEmail;
        };

        //Show saved templates tab
        $scope.showSavedTemplates = function () {
            $scope.templateView = false;
            $scope.activeTabTemplate = false;
            $scope.activeTabSavedTemplates = true;
            $scope.savedTemplateView = true;
            $scope.clientEmail = $scope.clientEmail || $rootScope.cSettings.SignEmail;
        };

        $scope.displayDeactivateModal = function () {
            $scope.deactivateModal = true;
        };

        $scope.closeDeactivateJourney = function () {
            $scope.deactivateModal = false;
        };

        $scope.deactivateJourney = function () {
            var journeyId = $stateParams.canvasId;

            if (!$stateParams.canvasId || !$rootScope.jbToken) {
                $rootScope.$emit('errorMsg', $scope.translate('canvas.deactivate.error'), 'error');
                return;
            }

            canvasService.setJourneyStatus(journeyId, 4).success(function () {
                $scope.deactivateModal = false;
                location.reload(true);
            }).error(function () {
                $rootScope.$emit('errorMsg', $scope.translate('canvas.deactivate.error'), 'error');
            });
        };

        $rootScope.$on('connectionUpdated', function (evt, conns) {
            if (conns && conns.length > 1) {
                $scope.disableActivate = false;
            } else {
                $scope.disableActivate = true;
            }
        });

        $scope._validflow = function (validRes) {
            var errSent = false,
                journeyId = $stateParams.canvasId;

            if (validRes.isValid) {
                //Track Intercom Activated journeys
                Intercom('trackEvent', 'AP - Activated Journey');
                if ($rootScope.connections[0].fromTemplate) {
                    Intercom('trackEvent', 'AP-ActivateT-' + $rootScope.connections[0].fromTemplate);
                } else {
                    Intercom('trackEvent', 'ap-activate-startedfromscratch');
                }

                var connData = helpers.updateAllPos($rootScope.connections);
                var payload = {
                    JourneyTitle: $rootScope.currentJBTitle,
                    JourneyConfiguration: JSON.stringify(connData)
                };

                canvasService.updateJourney(payload, $stateParams.canvasId, $rootScope.connections.length).success(function (res) {
                    canvasService.activateJourney(journeyId).success(function (res) {
                        $scope.disableButton = false;
                        if (res.JourneyConverted) {
                            $rootScope.$emit('journeyActivated');
                        } else {
                            $rootScope.$emit('errorMsg', $scope.translate('canvas.activate.error.1'), 'error');
                            Intercom('trackEvent', 'AP-E-BE');
                        }
                    }).error(function (err) {
                        if (err && err.Message) {
                            err.Message = err.Message.replace(/^\s+|\s+$/g, '');
                        }

                        if (err.Message === '1002' || err.Message === '1007') {
                            $rootScope.$emit('errorMsg', $scope.translate('canvas.activate.error.2'), 'error');
                        } else if (err.Message === '1006') {
                            Intercom('trackEvent', 'AP-E-BE');
                            $rootScope.$emit('errorMsg', $scope.translate('canvas.activate.error.9'), 'error');
                        } else if (err.Message === '1008') {
                            Intercom('trackEvent', 'AP-E-MultipleErrors');
                            $rootScope.$emit('errorMsg', $scope.translate('canvas.activate.error.8'), 'error');
                        } else if (err.Message === '1009') {
                            Intercom('trackEvent', 'AP-E-BE');
                            $rootScope.$emit('errorMsg', $scope.translate('canvas.activate.error.7'), 'error');
                        } else if (err.Message === '1010') {
                            Intercom('trackEvent', 'AP-E-MultiDisconnects');
                            $rootScope.$emit('errorMsg', $scope.translate('canvas.activate.error.3'), 'error');
                        } else if (err.Message === '1011') {
                            Intercom('trackEvent', 'AP-E-MultipleErrors');
                            $rootScope.$emit('errorMsg', $scope.translate('canvas.activate.error.5'), 'error');
                        } else if (err.ErrorType === 'Activate' && err.Message === '1020') {
                            Intercom('trackEvent', 'AP-E-BE');
                            $rootScope.$emit('errorMsg', $scope.translate('canvas.email.engagement.email.error'), 'error');
                            $rootScope.$emit('errEngagement_' + err.ElementId, true);
                        } else if (err.ErrorType === 'Activate' && AP.Flags.expire && err.Message.indexOf('1013') > -1) {
                            $rootScope.$emit('expire');
                        } else if (err.ErrorType === 'Activate' && AP.Flags.upgrade && (err.Message.indexOf('1004') > -1 || err.Message.indexOf('1005') > -1)) {
                            $rootScope.$emit('upgrade');
                        } else if (err.Message > '1000' && err.Message < '1012') {
                            Intercom('trackEvent', 'AP-E-BE');
                            $rootScope.$emit('errorMsg', $scope.translate('canvas.activate.error.1'), 'error');
                        } else {
                            Intercom('trackEvent', 'AP-E-BE');
                            $rootScope.$emit('errorMsg', $scope.translate('canvas.activate.error.1'), 'error');
                        }

                        $scope.disableButton = false;
                    });
                }).error(function (err) {
                    $scope.disableButton = false;
                });
            } else {
                $scope.disableButton = false;
                if (validRes.disconnectedElements.length > 0 && validRes.unsavedData.length > 0) {
                    for (var i = 0; i < validRes.disconnectedElements.length; i++) {
                        $scope.$emit('activateErr_' + validRes.disconnectedElements[i], true);
                    }

                    for (var i = 0; i < validRes.unsavedData.length; i++) {
                        $scope.$emit('emptyErr_' + validRes.unsavedData[i], true);
                    }

                    Intercom('trackEvent', 'AP-E-MultipleErrors');
                    $rootScope.$emit('errorMsg', $scope.translate('canvas.activate.error.5'), 'error');
                } else {
                    if (validRes.disconnectedElements.length > 0) {
                        for (var i = 0; i < validRes.disconnectedElements.length; i++) {
                            $scope.$emit('activateErr_' + validRes.disconnectedElements[i], true);
                        }
                        Intercom('trackEvent', 'AP-E-MultiDisconnects');
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.activate.error.3'), 'error');
                        errSent = true;
                    }

                    if (validRes.unsavedData.length > 0) {
                        for (var i = 0; i < validRes.unsavedData.length; i++) {
                            $scope.$emit('emptyErr_' + validRes.unsavedData[i], true);
                        }
                        if (!errSent) {
                            $rootScope.$emit('errorMsg', $scope.translate('canvas.activate.error.4'), 'error');
                            Intercom('trackEvent', 'AP-E-MultiMissingDetails');
                        }
                    }

                    if (validRes.dummyNodes.length > 0) {
                        for (var i = 0; i < validRes.dummyNodes.length; i++) {
                            $scope.$emit('emptyErr_' + validRes.dummyNodes[i], true);
                        }
                        if (!errSent) {
                            $rootScope.$emit('errorMsg', $scope.translate('canvas.activate.error.8'), 'error');
                            Intercom('trackEvent', 'AP-E-MultipleErrors');
                        }
                    }
                }
            }
        };

        $scope.disableActivate = true;
        $scope.activateJourney = function () {
            if (!$rootScope.hasAproPublish) {
                $rootScope.$emit('upgrade');
                return false;
            }

            //Get the param of the journey
            var validRes,
                rootConn = $rootScope.connections || [];

            $scope.disableButton = true;

            // set all to false, before validating
            for (var i = 0; i < rootConn.length; i++) {
                $scope.$emit('activateErr_' + rootConn[i].id, false);
            }

            // test for a valid jb
            validRes = helpers.isValidJourney();
            if (validRes.hasFacebookAudience && validRes.hasFacebookAudience.length) {
                canvasService.getConnections().then(function (_ref) {
                    var data = _ref.data;

                    if (data.ValidConnection) {
                        for (var i = 0; i < validRes.hasFacebookAudience.length; i++) {
                            $scope.$emit('activateFbErr_' + validRes.hasFacebookAudience[i], false);
                        }
                        $scope._validflow(validRes);
                    } else {
                        for (var i = 0; i < validRes.hasFacebookAudience.length; i++) {
                            $scope.$emit('activateFbErr_' + validRes.hasFacebookAudience[i], true);
                        }
                        $scope.disableButton = false;
                    }
                }).catch(function () {
                    $scope._validflow(validRes);
                });
            } else {
                $scope._validflow(validRes);
            }
        };

        // Check if active
        $scope.isActive = false;
        $rootScope.$on('activeJourney', function (evt, status) {
            $scope.isActive = status;
            $scope.isDeactive = false;
            $scope.isBlocked = false;
        });

        // Check if active
        $scope.isBlocked = false;
        $rootScope.$on('blockedJourney', function (evt, status, blockDate) {
            $scope.isBlocked = true;
            $scope.isActive = true;
            $scope.isDeactive = false;
            $timeout(function () {
                $rootScope.$emit('entryBlock', true, blockDate);
            }, 1000);
        });

        $scope.isDeactive = false;
        $rootScope.$on('deactivateJourney', function (evt, status) {
            $scope.isDeactive = status;
            $scope.isActive = true;

            // Added new isJourneyDeactive for know in the journey is deactive in the
            // other modal
            $rootScope.isJourneyDeactive = status;
            //Intercom track event De-activated Journey
            Intercom('trackEvent', 'AP - De-activated Journey');
        });

        //Checking url to display the footer module on the canvas section
        $rootScope.$on('pageLocationChanged', function (evt, next) {
            $scope.footerModule = next.name.indexOf('canvas') > -1 && isCanvasPath();
        });

        // creates an email, when the event is triggered
        $rootScope.$on('createEmail', function (evt, noLoader) {
            $scope.saveJourney(noLoader);
        });

        $scope.hideMCont = 0;
        $scope.stopHide = function () {
            $scope.hideMCont = 0;
        };

        $scope.$on('hideFooterSaveTemplate', function () {
            if ($scope.saveAsTemp) {
                if ($scope.hideMCont === 0) {
                    $scope.hideMCont = 1;
                } else {
                    $scope.saveAsTemp = false;
                    $scope.hideMCont = 0;
                }
            } else {
                $scope.hideMCont = 0;
            }
        });

        $scope.hideTemplateModal = function () {
            $scope.hideModal();
        };

        $scope.contMenu = 0;
        $scope.validClickingArea = function () {
            $scope.contMenu = 0;
            if (!$scope.searchTemplate && $scope.searchHandler) {
                $scope.hideSearch();
            }
        };

        $scope.showSummary = function () {
            $rootScope.$emit('summary', true, $stateParams.canvasId, $rootScope.currentJBTitle);
        };

        $scope.$on('hideUseTemplateModal', function () {
            if ($scope.templatesModal) {
                if ($scope.contMenu === 0) {
                    $scope.contMenu = 1;
                } else {
                    $scope.hideModal();
                    //Close Confirmation modals
                    $scope.loadTemplateConfirmation = false;
                    $scope.deleteConfirmation = false;
                    $scope.contMenu = 0;
                }
            } else {
                $scope.contMenu = 0;
            }
        });

        $rootScope.$on('useTemplate', function (evt, use) {
            if (use) {
                $scope.useTemplate();
            }
        });

        $scope.replaceSearch = function () {
            $scope.searchFilter = $scope.searchTemplate.replace(/\s/g, '');
        };

        $rootScope.$on('featureFlagsLoaded', function (_, key) {
            $scope.featureFlagsLoaded = key;

            if (!$rootScope.hasAproPublish) {
                $scope.showUpsellButton = true;
            }
        });
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _livechat = __webpack_require__(258);

(function () {
    'use strict';

    angular.module('headerModule', ['journey.veil', 'JB.translate.srv', 'auth.srv']).controller('headerCtrl', ['$scope', '$location', '$rootScope', '$stateParams', 'Session', 'canvasService', 'APRO_BME_URL', 'helpers', headerController]);

    function headerController($scope, $location, $rootScope, $stateParams, Session, canvasService, APRO_BME_URL, helpers) {
        //Checks if path contains canvas word in the url
        var isCanvasPath = function isCanvasPath() {
            return $location.path().indexOf('canvas') > -1;
        };

        (0, _livechat.useLiveChat)(helpers.readCookie('L') || 'english');

        $('body').on('click', function () {
            $scope.showGlobalHelpMenu = false;
            $scope.$apply();
        });

        $scope.parseName = function (name) {
            var parseName = name;

            if (name && name.length > 40) {
                parseName = name.slice(0, 40) + '...';
            }

            return parseName;
        };

        $scope.bmeUrl = APRO_BME_URL;

        //Flag to show Journey name Box.
        $scope.showBox = false;

        //Flag to show extra veil on creating new canvas
        $scope.extraCanvasVeil = false;

        //show or hide pencil
        $scope.showPencil = false;

        // show global help menu
        $scope.showGlobalHelpMenu = false;

        // show / hide tooltip for global help button
        $scope.tooltipState = false;

        //Flag to display Journey name/title on Canvas URL
        $scope.journeyTitle = isCanvasPath();
        $scope.$emit('displayVeil', isCanvasPath());

        $scope.showHeader = isCanvasPath();

        //Checking url to display the header module on the canvas section
        $rootScope.$on('pageLocationChanged', function (evt, next) {
            $scope.showHeader = next.name.indexOf('canvas') > -1 && isCanvasPath();
        });

        // $watch the method to see if it already got resolved
        $rootScope.$watch('translate', function (key) {
            //Flag to display Journey name on Canvas URL
            if (typeof key === 'function') {
                $scope.journeyTplName = $rootScope.translate('canvas.header.title');
            }
        });

        $scope.$watch('journeyTplName', function (val) {
            $rootScope.currentJBTitle = val;
        });

        //Function to display Journey name on Header.
        $scope.showBoxName = function () {
            $scope.showBox = true;
        };

        //Function to hide Journey box template
        $scope.saveJourneyTplName = function () {
            if ($scope.journeyTplName == "") {
                //Error msg from backend when failing
                $rootScope.$emit('errorMsg', $scope.translate('canvas.header.pleaseAddJourneyName'));
                $scope.displayError = true;
            } else {
                $scope.$emit('createEmail');
            }
        };

        $scope.toggleGlobalHelpMenu = function () {
            $scope.tooltipState = false;
            $scope.showGlobalHelpMenu = !$scope.showGlobalHelpMenu;
        };

        $scope.toggleTooltip = function (show) {
            $scope.tooltipState = show;
        };

        $scope.liveChat = function () {
            if (window.LC_API) {
                window.LC_API.open_chat_window();
            }
        };

        //Checking url to display Journey name Element.
        $scope.$on('$locationChangeStart', function () {
            $scope.journeyTitle = isCanvasPath();
            $scope.showBox = !isCanvasPath();
            $scope.$emit('displayVeil', isCanvasPath());
            $scope.extraCanvasVeil = false;
        });

        //When canvas already exists we change the title
        $rootScope.$on('journey-title', function (events, args) {
            $scope.journeyTplName = args.name;
        });

        //Display the box when new canvas
        $scope.$on('show-box', function () {
            $scope.journeyTplName = '';
            $scope.showBoxName();
            //Extra veils to hide header and footer
            $scope.extraCanvasVeil = true;
        });

        $scope.contMenu = 0;
        $scope.stopMenuBroadcast = function () {
            $scope.contMenu = 0;
        };

        $scope.$on('hideHeaderHomeMenu', function () {
            if ($scope.showBox) {
                if ($scope.contMenu === 0) {
                    $scope.contMenu = 1;
                } else {
                    if ($scope.journeyTplName) {
                        $scope.$emit('createEmail', true);
                        $scope.showBox = false;
                        $scope.contMenu = 0;
                    }
                }
            } else {
                $scope.contMenu = 0;
            }
        });

        //Log out from the app
        $scope.exit = function () {
            Session.destroy();
            window.location = 'http://ui.benchmarkemail.com/Login';
        };

        $scope.displayFaq = function () {
            //Track Event Intecrom - Help Overlay
            Intercom('trackEvent', 'AP - Help Overlay');
            $rootScope.$emit('displayFAQ');
        };

        $scope.redirectHome = function () {
            window.location = APRO_BME_URL;
        };

        $scope.displayTrackingReports = function () {
            $rootScope.$emit('trackingReports');
        };

        $rootScope.$on('displayTrackingCanvas', function () {
            $scope.displayTracking();
        });

        $scope.displayTracking = function () {
            var tplName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'tracking-code';

            if ($rootScope.getTrackerToken) {
                $rootScope.$emit('displayTracking', tplName, $rootScope.getTrackerToken);
            } else {
                Intercom('trackEvent', 'AP Tracking Code Overlay');

                canvasService.getTrackerToken().success(function (token) {
                    $rootScope.getTrackerToken = token;
                    $rootScope.$emit('displayTracking', tplName, token);
                }).error(function () {
                    $rootScope.$emit('errorMsg', $scope.translate('canvas.error.607'));
                });
            }
        };

        $rootScope.$on('displayTrackerModal', function () {
            $scope.displayTracking();
        });

        $rootScope.$watch('currentJourneyStatus', function (status) {
            if (status == 1) {
                $scope.showPencil = true;
            }
        });

        $scope.defineStatus = function (capitalize) {
            var res = $scope.translate('dashboard.inactive');
            if ($rootScope.currentJourneyStatus === 3 || $rootScope.currentJourneyStatus === 8) {
                res = $scope.translate('dashboard.active');
            } else if ($rootScope.currentJourneyStatus === 4) {
                res = $scope.translate('dashboard.deactivated');
            }
            if (capitalize) {
                res = res.firstUpper();
            }

            return res;
        };

        $scope.defineStatusClass = function () {
            var res = 'inactive';
            if ($rootScope.currentJourneyStatus === 3 || $rootScope.currentJourneyStatus === 8) {
                res = 'active';
            } else if ($rootScope.currentJourneyStatus === 4) {
                res = 'deactivated';
            }

            return res;
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    'use strict';

    angular.module('homeModule', []).controller('homeCon', ['APRO_BME_URL', homeController]);

    function homeController(APRO_BME_URL) {
        window.location = APRO_BME_URL;
    }
})();

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
    __webpack_require__(189);
    __webpack_require__(166);
    __webpack_require__(167);
    __webpack_require__(161);
    __webpack_require__(169);
    __webpack_require__(170);
    __webpack_require__(165);
    __webpack_require__(162);
    __webpack_require__(194);
    __webpack_require__(163);
    __webpack_require__(164);
    __webpack_require__(188);
}();

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _package = __webpack_require__(2);

(function () {
    'use strict';

    angular.module('indexModule', ['ngAnimate', 'journey.canvas.srv']).controller('indexCtrl', ['$scope', '$rootScope', '$location', '$timeout', '$stateParams', 'canvasService', 'helpers', 'Session', indexController]);

    function indexController($scope, $rootScope, $location, $timeout, $stateParams, canvasService, helpers, Session) {
        //loader initial state
        $scope.showLoader = false;
        $scope.overflowHidden = false;
        $scope.errorMsgStatus = false;
        $scope.journeyVeil = false;
        $scope.showVeil = false;
        $scope.deactivateModal = false;
        $scope.lang = Session.getCookie('L');
        $scope.removeHide = true;

        $scope.pageTitle = function () {
            var title,
                langs = {
                spanish: 'Automatizaciónes Pro',
                french: 'Automatisation Pro',
                german: 'Profi-Automatisierung',
                brazil: 'Automations Pro',
                italian: 'Automazioni Pro',
                japanese: 'EMA',
                chineset: '营销规划流程图',
                chinese: '行銷規劃流程圖',
                defaultTitle: 'Automation Pro'
            };

            title = langs[$scope.lang] || langs.defaultTitle;

            return title;
        };

        //Checks if path contains canvas word in the url
        var isCanvasPath = function isCanvasPath() {
            return $location.path().indexOf('canvas') > -1;
        };

        $scope.reloadJourney = function () {
            location.reload(true);
        };

        //Checking url to display Journey name Element.
        $rootScope.$on('$locationChangeStart', function () {
            $scope.overflowHidden = isCanvasPath();
            $scope.section = isCanvasPath() ? 'canvas-section' : 'home-section';
            $scope.isCanvas = isCanvasPath();
            $scope.isHome = !isCanvasPath();

            $rootScope.isHome_Global = $scope.isHome;
        });

        $rootScope.$on('setBodyOverflow', function () {
            $scope.overflowHidden = true;
        });

        $rootScope.$on('removeBodyOverflow', function () {
            if (!isCanvasPath()) {
                $scope.overflowHidden = false;
            }
        });

        //Veil Functions
        $scope.$on('displayVeil', function (evt, veilVal) {
            $scope.showVeil = veilVal;
        });

        //Extra Veil Functions for hiding header and Footer
        $rootScope.$on('displayExtraVeil', function (evt, extraVeilVal, extraVeilFooter) {
            $scope.extraVeil = extraVeilVal;
            $scope.extraVeilFooter = typeof extraVeilFooter === 'boolean' ? extraVeilFooter : extraVeilFooter || true;
        });

        //Display Loader
        $rootScope.$on('jbLoader', function (evt, state, transparent) {
            if (transparent) {
                $scope.showLoaderTransparent = state;
            } else {
                if ($scope.showLoader !== state) {
                    $scope.showLoader = state;
                }
            }
        });

        //Display Error Message
        $rootScope.$on('errorMsg', function (evt, msg, type) {
            var time = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 5000;

            if ($scope.messageRunning) {
                return;
            }
            $scope.messageRunning = true;
            $scope.errorMsg = msg;
            $scope.errorMsgStatus = true;

            switch (type) {
                case 'confirmation':
                    $scope.confirmation = true;
                    break;
                case 'error':
                    $scope.errorAlert = true;
                    break;
                case 'disconnected':
                    $scope.disconnectAlert = true;
                    break;
                default:
                    $scope.confirmation = false;
                    $scope.errorAlert = false;
                    $scope.disconnectAlert = false;
            }

            $timeout(function () {
                $scope.errorMsgStatus = false;
                $timeout(function () {
                    $scope.confirmation = false;
                    $scope.errorAlert = false;
                    $scope.messageRunning = false;
                    $scope.disconnectAlert = false;
                }, 500);
            }, time);
        });

        //On journey Activation
        $rootScope.$on('journeyActivated', function (evt) {
            $scope.journeyVeil = true;
        });

        //On journey Deactivation
        $scope.$on('activateError', function () {
            $scope.activateError = true;
        });

        $scope.getLocaleFeedback = function () {
            var currentLang = Session.getCookie('L'),
                langs = {
                spanish: 'es/',
                french: 'fr/',
                german: 'de/',
                brazil: '',
                italian: 'it/',
                japanese: 'jp/',
                chineset: 'cn/',
                chinese: 'tw/',
                defaultTitle: ''
            };

            return langs[currentLang] || langs.defaultTitle;
        };

        $scope.displayFeedbackForm = function (type) {
            var settings = JSON.parse(sessionStorage.getItem('settingSession') || ''),
                locale = $scope.getLocaleFeedback();

            $scope.feedBackType = type;
            $scope.feedbackModal = true;
            $scope.feedBackOptions = {};
            Session.getClientDetailsViaAPI().then(function (data) {
                var client_first_name = data["f"];
                var client_last_name = data["l"];
                $scope.feedBackOptions.name = client_first_name + ' ' + client_last_name;
                $scope.feedBackOptions.email = settings.SignEmail;

                $scope.feebackHelpUrl = 'https://www.benchmarkemail.com/' + locale + 'help-email?name=' + encodeURI($scope.feedBackOptions.name) + '&email=' + encodeURI($scope.feedBackOptions.email);

                canvasService.getClientInfo().then(function (_ref) {
                    var data = _ref.data;

                    $scope.feedBackOptions.region = data.Response.RegionName;
                });

                canvasService.getResponsiveInfo().then(function (_ref2) {
                    var data = _ref2.data;

                    if (data.Response.ResponsiveOnly == "0") {
                        $scope.feedBackOptions.userType = 'existing';
                    } else {
                        $scope.feedBackOptions.userType = 'new';
                    }
                });

                canvasService.getPlanInfo().then(function (_ref3) {
                    var data = _ref3.data;

                    $scope.feedBackOptions.plan = data.Response.EmailPlan.PlanName;
                });
            });
        };

        $scope.hideFeedbackModal = function () {
            $scope.feedbackModal = false;
            $scope.feedbackMsg = '';
        };

        $scope.sendFeedback = function () {
            if (!$scope.feedbackMsg) {
                $scope.feedbackError = true;
                $timeout(function () {
                    $scope.feedbackError = false;
                }, 3000);
            } else {
                // send the feedback to google spreadsheet
                var payload = {
                    email: $scope.feedBackOptions.email,
                    name: $scope.feedBackOptions.name,
                    user_type: $scope.feedBackOptions.userType,
                    is_paid: Session.getCookie('isPaid') == '1',
                    plan_name: $scope.feedBackOptions.plan,
                    region: $scope.feedBackOptions.region,
                    language: $scope.lang || 'english',
                    type: $scope.feedBackType,
                    date_submitted: new Date(),
                    message: $scope.feedbackMsg,
                    'Full Story Review': '',
                    'Action to Take': '',
                    'Zendesk Tickets Created': ''
                };

                if (!$scope.isLoading && window.IS_PROD) {
                    $scope.isLoading = true;
                    canvasService.sendFeedback(payload).then(function () {
                        $scope.hideFeedbackModal();
                        $scope.isLoading = false;
                    }).catch(function () {
                        $scope.hideFeedbackModal();
                        $scope.isLoading = false;
                    });
                }

                $scope.feedbackError = false;
            }
        };

        $rootScope.$on('closeMenus', function (evt, close) {
            if (close) {
                $scope.closeMenus();
            }
        });

        $scope.closePreviewModal = function () {
            $scope.emailPreviewIn = false;

            if ($rootScope.currentJourneyStatus === 3 || $rootScope.currentJourneyStatus === 4 || $rootScope.currentJourneyStatus === 8) {
                // For close the preview email on active send email
                $rootScope.$emit('closePreviewEmail' + $scope.previewId);
                $scope.emailPreview = false;
            } else {
                $timeout(function () {
                    $scope.emailPreview = false;
                    if ($scope.emailPreviewData.conn == 'showEmailList') {
                        $rootScope.$emit('closePreviewEmailShowModal' + $scope.previewId);
                    } else {
                        $rootScope.$emit('displayActionSendEmailModal', $scope.emailPreviewData.conn, false, true);
                    }
                }, 300);
            }
        };

        $scope.emailPreviewData = {};
        $scope.emailPreviewIn = false;
        $rootScope.$on('previewEmail', function (evt, conn, isSelected, showTooltip, id) {
            $scope.emailPreviewData = {
                conn: conn,
                isSelected: isSelected,
                showTooltip: showTooltip
            };

            if (id) {
                $scope.previewId = id;
            }

            $scope.emailPreview = true;
            $timeout(function () {
                $scope.emailPreviewIn = true;
            }, 300);
        });

        $scope.closeMenus = function () {
            $scope.$broadcast('hideSubMenuIf');
            $scope.$broadcast('hideHomeMenus');
            $scope.$broadcast('hideFooterMenu');
            $scope.$broadcast('hideHeaderMenu');
            if (isCanvasPath()) {
                $scope.$broadcast('hideHeaderHomeMenu');
                $scope.$broadcast('hideFooterSaveTemplate');
                $scope.$broadcast('hideUseTemplateModal');
                $scope.$broadcast('closeConfigMenus');
                $scope.$broadcast('closeCoaching');
                $scope.$broadcast('closeTemplateMenu');
                $rootScope.$emit('closeInnerMenuIfElse');
            }
        };
    };
})();

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    'use strict';

    angular.module('loginModule', []).controller('loginCon', ['$scope', 'AuthSrv', 'Session', 'APRO_BME_URL', loginController]);

    function loginController($scope, AuthSrv, Session, APRO_BME_URL) {
        $scope.title = 'Login';
        $scope.user = '';
        $scope.password = '';

        $scope.login = function () {
            AuthSrv.authUser($scope.user, $scope.password).success(function (res) {
                if (res.Token) {
                    Session.create(res.Token, res.ClientId);
                    AuthSrv.isAuthenticated().then(function (isAuthenticated) {
                        if (isAuthenticated) {
                            window.location = APRO_BME_URL;
                            location.reload(true);
                        }
                    });
                } else {
                    alert('user or password is incorrect');
                }
            }).error(function (err) {
                console.log(err);
                alert('something went wrong witht the login');
            });
        };
    }
})();

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    'use strict';

    angular.module('dataHandlingActionAddList', ['ngAnimate', 'journey.canvas.srv', 'ngModalDragabble']).controller('actionAddListCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', actionAddListCtrl]);

    function actionAddListCtrl($scope, $rootScope, $timeout, canvasService, helpers) {
        $scope.displayAddListActionOptions = false;
        $scope.displayError = false;
        $scope.descriptionEmpty = false;
        $scope.createListName = {};
        $scope.search = {};

        $scope.contactOptions = [{
            value: 'all-in-any-future',
            message: $scope.translate('commons.all.subscribers')
        }, {
            value: 'add-contacts-list',
            message: $scope.translate('commons.existing.subscribers')
        }, {
            value: 'add-contacts-future',
            message: $scope.translate('commons.new.subscribers')
        }];

        function resetNode() {
            $scope.search.list = '';
            $scope.displayAddListActionOptions = false;
            $scope.showSelectListError = false;
        }

        $rootScope.$on('displayActionAddListModal', function (evt, conn, showTip) {
            $scope.contactListData = $rootScope.contactListData;
            $scope.displayAddListActionOptions = true;
            $scope.connections = angular.copy(conn);
            $scope.displayError = false;
            $scope.descriptionEmpty = false;
            $scope.selectedKey = $scope.translate('commons.selectList');

            $timeout(function () {
                $scope.setScrollLogic($scope.connections.id);
            }, 300);

            $scope.sortDataList();
        });

        $scope.sortDataList = function () {
            $scope.contactListData = $scope.contactListData.map(function (i) {
                if ($scope.connections.data.selectedList.indexOf(i.ListId) > -1) {
                    i.selectedItem = true;
                } else {
                    delete i.selectedItem;
                }

                return i;
            });

            Object.assign($scope.contactListData, _.orderBy($scope.contactListData, ['selectedItem'], ['asc']));
        };

        $rootScope.$on('hideActionAddListModal', function () {
            $scope.displayError = false;
            resetNode();
        });

        $rootScope.$on('displayActionAddListModalError', function () {
            $scope.displayError = true;
        });

        $scope.createListClick = function () {
            $scope.createList = true;
            $scope.displayAddListActionOptions = false;
            $scope.createListName.name = '';
        };

        $scope.goCreateList = function () {
            if (!$scope.createListName.name) {
                $scope.showNewListNameError = true;
            }

            if ($scope.createListName.name) {
                $scope.createListLoader = true;
                canvasService.createContactList($scope.createListName.name).success(function (_ref) {
                    var Results = _ref.Results;

                    $scope.createListLoader = false;
                    if (Results.length) {
                        var result = Results[0];
                        var listItem = {
                            ContactCount: 0,
                            ListId: result.ListId,
                            ListName: result.ListName
                        };
                        $scope.contactListData.unshift(listItem);
                        $rootScope.contactListData.unshift(listItem);
                        $scope.toggelListItem(result.ListId, 0);
                        $scope.goBackList();
                        $rootScope.$emit('errorMsg', $scope.translate('common.list.message'), 'confirmation');
                    } else {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.607'));
                    }
                }).error(function () {
                    $rootScope.$emit('errorMsg', $scope.translate('canvas.error.607'));
                    $scope.createListLoader = false;
                });
            }
        };

        $scope.goBackList = function () {
            $scope.createList = false;
            $scope.displayAddListActionOptions = true;
        };

        $scope.cancel = function () {
            resetNode();

            var node = _.find($rootScope.connections, function (conn) {
                return conn.id === $scope.connections.id;
            });

            if (!node) {
                // Execute listener when user cancel the add the node of delay
                $rootScope.$broadcast('deleteAddListNode' + $scope.connections.id);
            }
        };

        $scope.save = function () {
            if ($scope.connections.data.selectedList.length === 0) {
                $scope.showSelectListError = true;
            } else {
                Intercom('trackEvent', 'AP - AddtoList');
                $rootScope.$emit('saveActionAddListData' + $scope.connections.id, $scope.connections, $scope.descriptionEmpty, $scope.contactListData);
            }
        };

        //Toggle List Item to check if a checkbox is checked, If not we add it to the array of IDs, if not we delete it and just save the ones selected
        $scope.toggelListItem = function (listItem, $i) {
            if ($scope.connections.isDummy) {
                $scope.connections.data.selectedList = [];
                delete $scope.connections.isDummy;
            }

            var index = $scope.connections.data.selectedList.indexOf(listItem);
            if (index > -1) {
                $scope.connections.data.selectedList.splice(index, 1);
                delete $scope.contactListData[$i].selectedItem;
            } else {
                $scope.connections.data.selectedList.push(listItem);
                $scope.contactListData[$i].selectedItem = true;
            }

            Object.assign($scope.contactListData, _.orderBy($scope.contactListData, ['selectedItem'], ['asc']));

            if ($scope.connections.data.selectedList.length) {
                $scope.selectedKey = $scope.translate('commons.editSelection');
            } else {
                $scope.selectedKey = $scope.translate('commons.selectList');
            }
        };

        $scope.setScrollLogic = function (id) {
            $scope.listLoader = false;
            angular.element(document.getElementById('contactListContainer' + id)).bind("scroll", function () {
                if (!$scope.listLoader && !$rootScope.stopLoadingList && !$scope.search.list) {
                    $scope.listLoader = true;
                    canvasService.getContactList($rootScope.contactListOffset, 10).success(function (data) {
                        if (!data.Results.length) {
                            $rootScope.stopLoadingList = true;
                        } else {
                            $rootScope.contactListOffset++;
                            $rootScope.contactListData = _.uniqBy($rootScope.contactListData.concat(data.Results), 'ListId');
                            $scope.contactListData = $rootScope.contactListData;
                            Object.assign($scope.contactListData, _.orderBy($scope.contactListData, ['selectedItem'], ['asc']));
                        }
                        $scope.listLoader = false;
                    }).error(function () {
                        $scope.listLoader = false;
                    });
                }
            });
        };

        $scope.searching = false;
        $scope.search.search = function (val) {
            if (val && val.length > 0 && !$scope.searching) {
                $scope.searching = true;
                canvasService.searchContactList(val).then(function (res) {
                    $scope.searching = false;
                    $rootScope.contactListData = _.uniqBy($rootScope.contactListData.concat(res.data.Results), 'ListId');
                    $scope.contactListData = [];
                    $scope.contactListData = $scope.contactListData.concat(res.data.Results);
                    $scope.sortDataList();
                }).catch(function () {
                    $scope.searching = false;
                });
            } else {
                $scope.contactListData = $rootScope.contactListData;
                $scope.sortDataList();
            }
        };
    };
})();

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    'use strict';

    angular.module('dataHandlingActionAddWaitTime', ['ngAnimate', 'journey.canvas.srv', 'ngModalDragabble']).controller('actionAddWaitTimeCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', actionAddWaitTimeCtrl]);

    function actionAddWaitTimeCtrl($scope, $rootScope, $timeout, canvasService, helpers) {
        $scope.displayAddWaitTimeActionOptions = false;
        $scope.errorUnits = false;
        $scope.errorDelay = false;
        $scope.descriptionEmpty = false;

        // accepted values
        $scope.enums = {
            minutes: 60,
            hours: 24,
            days: 365,
            weeks: 52,
            months: 12
        };

        $scope.setUnits = function (delay) {
            var period = delay > 1 ? 'plural' : 'singular';

            $scope.units = {
                hours: $scope.translate('canvas.action.addWaitTime.hours.' + period),
                days: $scope.translate('canvas.action.addWaitTime.days.' + period),
                weeks: $scope.translate('canvas.action.addWaitTime.weeks.' + period),
                months: $scope.translate('canvas.action.addWaitTime.months.' + period)
            };
        };

        var delay = 0;
        if ($scope.connections) {
            delay = $scope.connections.data.delay;
        }
        $scope.setUnits(delay);

        $rootScope.$on('displayActionAddWaitTimeModal', function (evt, conn, showTip) {
            $scope.contactListData = $rootScope.contactListData;
            $scope.showTip = showTip;
            $scope.displayAddWaitTimeActionOptions = true;
            $scope.connections = angular.copy(conn);
            $scope.errorUnits = false;
            $scope.errorDelay = false;
            $scope.descriptionEmpty = false;
        });

        $rootScope.$on('hideActionAddWaitTimeModal', function () {
            $scope.errorUnits = false;
            $scope.errorDelay = false;
            $scope.displayAddWaitTimeActionOptions = false;
        });

        $rootScope.$on('displayActionAddWaitTimeModalError', function (evt, unitsErr, delayErr) {
            $scope.errorUnits = unitsErr;
            $scope.errorDelay = delayErr;
        });

        $scope.cancel = function () {
            $scope.displayAddWaitTimeActionOptions = false;

            var node = _.find($rootScope.connections, function (conn) {
                return conn.id === $scope.connections.id;
            });

            // Execute listener when user cancel the add the node of delay
            if (!node) {
                $rootScope.$broadcast('deleteWaitTimeNode' + $scope.connections.id);
            }
        };

        $scope.save = function () {
            Intercom('trackEvent', 'AP - Delay');
            $rootScope.$emit('saveActionAddWaitTimeData' + $scope.connections.id, $scope.connections);
        };

        $scope.$watch('connections.data.delay', function (val) {
            if (val) {
                $scope.setUnits(val);
            }
        });

        $scope.$watch('connections.data.units', function (val) {
            if (val) {
                if ($scope.connections.data.delay > $scope.enums[val]) {
                    $scope.connections.data.delay = '';
                }
            }
        });
    };
})();

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    'use strict';

    angular.module('dataHandlingActionFacebookAudience', ['ngAnimate', 'journey.canvas.srv', 'ngModalDragabble']).controller('actionFacebookAudienceCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', actionFacebookAudienceCtrl]);

    function actionFacebookAudienceCtrl($scope, $rootScope, $timeout, canvasService, helpers) {
        $scope.displayFacebookAudienceOptions = false;
        $scope.descriptionEmpty = false;
        $scope.createListName = {};
        $scope.search = {};

        function resetNode() {
            $scope.search.list = '';
            $scope.displayFacebookAudienceOptions = false;
            $scope.showSelectListError = false;
        }

        $rootScope.$on('displayFacebookAudienceModal', function (evt, conn, showTip) {
            var entry = document.getElementById(conn.id).getBoundingClientRect();
            var currentLang = $rootScope.jbLang;

            if (currentLang.toLowerCase() === 'japanese') {
                document.getElementById('facebook_audience_helperlink').setAttribute('href', 'https://kb.benchmarkemail.com/jp/automation-pro-facebook-audience/');
            }

            $scope.displayFacebookAudienceOptions = true;
            $scope.connections = angular.copy(conn);
            $scope.audienceError = false;
            $scope.descriptionEmpty = false;
            $scope.isLoading = true;
            $scope.audiences = [];

            if (!$scope.connections.data.action) {
                $scope.connections.data.action = '1';
            }

            $scope.setInitialState();
        });

        $scope.setInitialState = function () {
            canvasService.getConnections().then(function (_ref) {
                var data = _ref.data;

                $scope.isFbConnect = data.ValidConnection;
                if ($scope.isFbConnect) {
                    $scope.connectedUser = data.UserName || 'Unknown';
                    canvasService.getAudiences().then(function (_ref2) {
                        var data = _ref2.data;

                        $scope.audiences = data.Audiances.data;
                        // select init audience
                        if (!$scope.connections.data.audiances.length && $scope.audiences.length) {
                            $scope.connections.data.audiances.push($scope.audiences[0].id);
                            $scope.connections.audience = JSON.stringify($scope.audiences[0]);
                        }
                        $scope.isLoading = false;
                    }).catch(function () {
                        $scope.isFbConnect = false;
                        $scope.isLoading = false;
                    });
                } else {
                    $scope.isLoading = false;
                }
            }).catch(function () {
                $scope.isFbConnect = false;
                $scope.isLoading = false;
            });
        };

        $scope.$watch('connections.audience', function (newData, old) {
            if (newData && newData !== old) {
                var data = JSON.parse(newData);
                $scope.connections.data.audiances[0] = data.id;
                $scope.audienceError = false;
            }
        });

        $scope.$watch('connections.data.action', function (newData, old) {
            if (newData && newData !== old) {
                if ($scope.connections.data.action == '1') {
                    Intercom('trackEvent', 'FB-Biz-AddAud', {
                        description: 'Facebook audience Add selected from removed to add'
                    });
                } else {
                    Intercom('trackEvent', 'FB-Biz-RemoveAud', {
                        description: 'Facebook audience Remove selected from add to remove'
                    });
                }
            }
        });

        $rootScope.$on('hideFacebookAudienceModal', function () {
            $scope.audienceError = false;
            resetNode();
        });

        $scope.goBackList = function () {
            $scope.createList = false;
            $scope.displayFacebookAudienceOptions = true;
        };

        $scope.cancel = function () {
            Intercom('trackEvent', 'FB-Biz-Cancel-C', {
                description: 'Facebook audience Cancel button click'
            });

            resetNode();

            var node = _.find($rootScope.connections, function (conn) {
                return conn.id === $scope.connections.id;
            });

            if ((!node || !(node.data && node.audience)) && !$scope.connections.isDummy) {
                // Execute listener when user cancel the add the node of delay
                $rootScope.$broadcast('deleteFBAudienceNode' + $scope.connections.id);
            }
        };

        $scope.save = function () {
            if (!$scope.connections.audience) {
                $scope.audienceError = true;
            } else {
                if ($scope.connections.data.action == '1') {
                    Intercom('trackEvent', 'FB-Biz-Aud-AddSave', {
                        description: 'Facebook audience Add plus save'
                    });
                } else {
                    Intercom('trackEvent', 'FB-Biz-Aud-RemSave', {
                        description: 'Facebook audience Remove plus save'
                    });
                }

                Intercom('trackEvent', 'FB-Biz-SaveAudience', {
                    description: 'Facebook audience Save'
                });

                $rootScope.$emit('saveActionFacebookAudienceData' + $scope.connections.id, $scope.connections);
            }
        };

        $scope.connect = function () {
            Intercom('trackEvent', 'FB-Biz-Connect-C', {
                description: 'Facebook audience Connect button click'
            });

            var redirectUrl = window.location.origin + '/#/canvas/' + $rootScope.currentAPId;
            canvasService.fbConnect(redirectUrl).then(function (_ref3) {
                var data = _ref3.data;

                $rootScope.$emit('saveActionFacebookAudienceData' + $scope.connections.id, $scope.connections);
                if (data !== undefined && data !== null && data.RedirectUrl !== undefined && data.RedirectUrl !== null) {
                    localStorage.setItem('offToFacebook_' + $scope.connections.id, '1');
                    $timeout(function () {
                        window.location.replace(data.RedirectUrl);
                    }, 500);
                }
            });
        };

        $scope.goBack = function () {
            $scope.disconnectFailed = false;
            $scope.isFbConnect = true;
        };

        $scope.sendToProListing = function () {
            window.location.replace(window.origin);
        };

        $scope.disconnectFacebook = function () {
            $scope.isLoading = true;
            canvasService.fbDisconnect().then(function (_ref4) {
                var data = _ref4.data;

                if (data.Disconnected === false) {
                    $scope.disconnectFailed = true;
                    $scope.apTitles = data.ValidateInformation && data.ValidateInformation.Journeys && data.ValidateInformation.Journeys.JourneySummary.length && data.ValidateInformation.Journeys.JourneySummary.map(function (i) {
                        return i.JourneyTitle;
                    }) || [];
                    $scope.isLoading = false;
                } else {
                    $rootScope.$emit('errorMsg', $scope.translate('canvas.facebook.audience.disconnected'), 'disconnected');
                    $scope.setInitialState();
                }
            }).catch(function (err) {
                $scope.isLoading = false;
            });
        };

        $scope.displayModal = function (evt) {
            var windowHeight = window.innerHeight * 0.50;
            //Bottom to top
            if (evt.clientY > windowHeight) {
                $(".poc-list").css("top", "-270px");
            } else {
                $(".poc-list").css("top", "");
            }
            $scope.modalWindow = true;
        };

        $scope.hideModal = function (clearList) {
            if (clearList) {
                $scope.selectedKey = $scope.translate('commons.selectList');
                $scope.connections.data.selectedList = [];
            }
            $scope.modalWindow = false;
            $scope.search.list = "";
            $scope.contactListData = $rootScope.contactListData;
        };
    };
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    'use strict';

    angular.module('dataHandlingActionRemoveList', ['ngAnimate', 'journey.canvas.srv', 'ngModalDragabble']).controller('actionRemoveListCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', actionRemoveListCtrl]);

    function actionRemoveListCtrl($scope, $rootScope, $timeout, canvasService, helpers) {
        $scope.displayRemoveListActionOptions = false;
        $scope.displayError = false;
        $scope.descriptionEmpty = false;
        $scope.createListName = {};
        $scope.search = {};

        function resetNode() {
            $scope.search.list = '';
            $scope.displayRemoveListActionOptions = false;
            $scope.showSelectListError = false;
        }

        $rootScope.$on('displayActionRemoveListModal', function (evt, conn, showTip) {
            $scope.contactListData = $rootScope.contactListData;
            $scope.displayRemoveListActionOptions = true;
            $scope.connections = angular.copy(conn);
            $scope.displayError = false;
            $scope.descriptionEmpty = false;
            $scope.selectedKey = $scope.translate('commons.selectList');

            $timeout(function () {
                $scope.setScrollLogic($scope.connections.id);
            }, 300);

            $scope.sortDataList();
        });

        $rootScope.$on('hideActionRemoveListModal', function () {
            $scope.displayError = false;
            resetNode();
        });

        $rootScope.$on('displayActionRemoveListModalError', function () {
            $scope.displayError = true;
        });

        $scope.sortDataList = function () {
            $scope.contactListData = $scope.contactListData.map(function (i) {
                if ($scope.connections.data.selectedList.indexOf(i.ListId) > -1) {
                    i.selectedItem = true;
                } else {
                    delete i.selectedItem;
                }

                return i;
            });

            Object.assign($scope.contactListData, _.orderBy($scope.contactListData, ['selectedItem'], ['asc']));
        };

        $scope.createListClick = function () {
            $scope.createList = true;
            $scope.displayRemoveListActionOptions = false;
            $scope.createListName.name = '';
        };

        $scope.goCreateList = function () {
            if (!$scope.createListName.name) {
                $scope.showNewListNameError = true;
            }

            if ($scope.createListName.name) {
                $scope.createListLoader = true;
                canvasService.createContactList($scope.createListName.name).success(function (_ref) {
                    var Results = _ref.Results;

                    $scope.createListLoader = false;
                    if (Results.length) {
                        var result = Results[0];
                        var listItem = {
                            ContactCount: 0,
                            ListId: result.ListId,
                            ListName: result.ListName
                        };
                        $scope.contactListData.unshift(listItem);
                        $rootScope.contactListData.unshift(listItem);
                        $scope.toggelListItem(result.ListId, 0);
                        $scope.goBackList();
                        $rootScope.$emit('errorMsg', $scope.translate('common.list.message'), 'confirmation');
                    } else {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.607'));
                    }
                }).error(function () {
                    $rootScope.$emit('errorMsg', $scope.translate('canvas.error.607'));
                    $scope.createListLoader = false;
                });
            }
        };

        $scope.goBackList = function () {
            $scope.createList = false;
            $scope.displayRemoveListActionOptions = true;
        };

        $scope.cancel = function () {
            resetNode();

            var node = _.find($rootScope.connections, function (conn) {
                return conn.id === $scope.connections.id;
            });

            if (!node) {
                // Execute listener when user cancel the remove list
                $rootScope.$broadcast('deleteRemoveListNode' + $scope.connections.id);
            }
        };

        $scope.save = function () {
            if ($scope.connections.data.selectedList.length === 0) {
                $scope.showSelectListError = true;
            } else {
                Intercom('trackEvent', 'AP - RemovefromList');
                $rootScope.$emit('saveActionRemoveListData' + $scope.connections.id, $scope.connections, $scope.descriptionEmpty);
            }
        };

        //Toggle List Item to check if a checkbox is checked, If not we add it to the array of IDs, if not we delete it and just save the ones selected
        $scope.toggelListItem = function (listItem, $i) {
            if ($scope.connections.isDummy) {
                $scope.connections.data.selectedList = [];
                delete $scope.connections.isDummy;
            }

            var index = $scope.connections.data.selectedList.indexOf(listItem);
            if (index > -1) {
                $scope.connections.data.selectedList.splice(index, 1);
                delete $scope.contactListData[$i].selectedItem;
            } else {
                $scope.connections.data.selectedList.push(listItem);
                $scope.contactListData[$i].selectedItem = true;
            }

            Object.assign($scope.contactListData, _.orderBy($scope.contactListData, ['selectedItem'], ['asc']));

            if ($scope.connections.data.selectedList.length) {
                $scope.selectedKey = $scope.translate('commons.editSelection');
            } else {
                $scope.selectedKey = $scope.translate('commons.selectList');
            }
        };

        $scope.parseDescription = function (desc, selected) {
            if (desc && (typeof desc === 'undefined' ? 'undefined' : _typeof(desc)) === 'object') {
                var descriptionCheck = false;
                for (var item in desc) {

                    if (desc[item]) {
                        $scope.descriptionEmpty = false;
                        descriptionCheck = true;
                        //Lists that are currently selected on the node
                        var totalLists = $scope.connections.data.selectedList.length;
                        desc = helpers.getContactListItem(desc[item], $scope.contactListData);

                        //One list selected and > 19
                        if (totalLists === 1 && desc.length > 19) {
                            desc = desc.slice(0, 19) + '...';
                            //More than one selected
                        } else if (totalLists > 1) {
                            desc = totalLists + " " + $scope.translate('commons.selectedList');
                            //One selected but < 19
                        } else if (totalLists === 1 && desc.length < 19) {
                            desc = desc;
                        }

                        break;
                    }
                }
                if (!descriptionCheck) {
                    $scope.descriptionEmpty = true;

                    if (selected === 'showSelectedList') {
                        return '';
                    } else {
                        return $scope.translate('commons.enterDetails');
                    }
                }
            } else {
                $scope.descriptionEmpty = true;

                if (selected === 'showSelectedList') {
                    return '';
                } else {
                    return $scope.translate('commons.enterDetails');
                }
            }

            return desc;
        };

        $scope.setScrollLogic = function (id) {
            $scope.listLoader = false;
            angular.element(document.getElementById('contactListContainer' + id)).bind("scroll", function () {
                if (!$scope.listLoader && !$rootScope.stopLoadingList && !$scope.search.list) {
                    $scope.listLoader = true;
                    canvasService.getContactList($rootScope.contactListOffset, 10).success(function (data) {
                        if (!data.Results.length) {
                            $rootScope.stopLoadingList = true;
                        } else {
                            $rootScope.contactListOffset++;
                            $rootScope.contactListData = _.uniqBy($rootScope.contactListData.concat(data.Results), 'ListId');
                            $scope.contactListData = $rootScope.contactListData;
                            Object.assign($scope.contactListData, _.orderBy($scope.contactListData, ['selectedItem'], ['asc']));
                        }
                        $scope.listLoader = false;
                    }).error(function () {
                        $scope.listLoader = false;
                    });
                }
            });
        };

        $scope.searching = false;
        $scope.search.search = function (val) {
            if (val && val.length > 0 && !$scope.searching) {
                $scope.searching = true;
                canvasService.searchContactList(val).then(function (res) {
                    $scope.searching = false;
                    $rootScope.contactListData = _.uniqBy($rootScope.contactListData.concat(res.data.Results), 'ListId');
                    $scope.contactListData = [];
                    $scope.contactListData = $scope.contactListData.concat(res.data.Results);
                    $scope.sortDataList();
                }).catch(function () {
                    $scope.searching = false;
                });
            } else {
                $scope.contactListData = $rootScope.contactListData;
                $scope.sortDataList();
            }
        };
    };
})();

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _subjectLinePicker = __webpack_require__(5);

var _subjectLinePicker2 = _interopRequireDefault(_subjectLinePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
    'use strict';

    angular.module('dataHandlingActionSendEmail', ['ngAnimate', 'journey.canvas.srv', 'ngModalDragabble', 'ngSanitize']).controller('actionSendEmailCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', '$stateParams', 'Session', actionSendEmailCtrl]);

    function actionSendEmailCtrl($scope, $rootScope, $timeout, canvasService, helpers, $stateParams, Session) {
        $scope.displaySendEmailActionOptions = false;
        $scope.displayList = false;
        $scope.selectedView = false;
        $scope.advancedOptionsBtn = false;
        $scope.advancedOptionsTitle = true;
        $scope.emailOptions = false;
        $scope.wrapOptions = false;
        $scope.validating = false;
        var cEid;

        // When it’s blank, we insert the email title (replace spaces with underlines)
        function initGoogleCampaign() {
            if (!$scope.connections.data.googleAnalyticsAllUrl) {
                $scope.connections.emailData.GoogleAnalyticsCampaign = '';
            } else {
                $scope.connections.emailData.GoogleAnalyticsCampaign = $scope.connections.emailData.EmailName.replace(/ /g, '_');
            }
        };

        $rootScope.$on('displayActionSendEmailModal', function (evt, conn, displayList, selectedView, showTip) {
            $scope.displayList = displayList;
            $scope.selectedView = selectedView;
            if (!$scope.displayList && !$scope.selectedView) $scope.displayList = true;
            $scope.advancedOptionsBtn = false;
            $scope.advancedOptionsTitle = true;
            $scope.emailOptions = false;
            $scope.wrapOptions = false;
            $scope.showTip = showTip;
            $scope.displaySendEmailActionOptions = true;
            $scope.validating = false;
            $scope.connections = angular.copy(conn);
            $scope.displayEmojiModal = false;

            (0, _subjectLinePicker2.default)('subject-line-picker-container-' + $scope.connections.id, canvasService, $rootScope.translate, function (syncVal) {
                if ($scope.connections && $scope.connections.emailData) {
                    $scope.connections.emailData.Subject = syncVal;
                    $('#delay-modal .modal-body').scrollTop(0);
                }
            });

            if (!$rootScope.userEmailAddress) {
                canvasService.getUserEmailAddress().success(function (data) {
                    $rootScope.userEmailAddress = data.Results || [];
                    $scope.emailAddressList = $rootScope.userEmailAddress.map(function (obj) {
                        return obj.Email;
                    });
                });
            } else {
                $scope.emailAddressList = $rootScope.userEmailAddress.map(function (obj) {
                    return obj.Email;
                });
            }

            $scope.mergeTags = helpers.getMergeTags();

            if (!$scope.mergeTags.length) {
                $scope.showTagDefault = true;
                $scope.connections.emailData.ToListId = "";
            } else if ($scope.connections.emailData && !$scope.connections.emailData.ToListId) {
                $scope.connections.emailData.ToListId = $scope.mergeTags[0].id;
            } else {
                $scope.connections.emailData.ToListId = $scope.connections.emailData.ToListId + '';
            }

            cEid = conn && conn.data ? conn.data.emailId : '';

            var lang = Session.getCookie('L');
            $scope.faqHelpLink = {
                english: 'https://kb.benchmarkemail.com/can-i-add-google-analytics-tracking-to-my-email-campaigns/',
                spanish: 'https://kb.benchmarkemail.com/es/puedo-agregar-seguimiento-de-google-analytics-a-mis-campanas-de-correo-electronico/',
                chineset: 'https://kb.benchmarkemail.com/cn/can-i-add-google-analytics-tracking-to-my-email-campaigns/',
                chinese: 'https://kb.benchmarkemail.com/tw/can-i-add-google-analytics-tracking-to-my-email-campaigns/',
                japanese: 'https://kb.benchmarkemail.com/jp/can-i-add-google-analytics-tracking-to-my-email-campaigns/',
                italian: 'https://kb.benchmarkemail.com/it/posso-aggiungere-google-analytics-alla-mia-campagna-email/',
                french: 'https://kb.benchmarkemail.com/fr/comment-ajouter-le-tracking-de-google-analytics-a-mes-campagnes-d-email/',
                brazil: 'https://kb.benchmarkemail.com/br/posso-adicionar-o-monitoramento-do-google-analytics-nas-minhas-campanhas-de-email/',
                german: 'https://kb.benchmarkemail.com/de/kann-ich-google-analytics-tracking-in-meine-e-mail-kampagnen-einfuegen/'
            }[lang || 'english'];
        });

        $rootScope.$on('hideActionSendEmailModal', function () {
            $scope.displaySendEmailActionOptions = false;
            $scope.validating = false;
        });

        $rootScope.$on('displayActionSendEmailModalError', function (evt, errors) {
            $scope.validating = false;
            angular.extend($scope, errors);
        });

        $scope.parseDescription = function (desc) {

            if (desc) {
                if (desc.length > 15) {
                    desc = desc.slice(0, 15) + '...';
                    //Desc < 15
                } else if (desc.length < 15) {
                    desc = desc;
                }
            } else {
                return $scope.translate('commons.enterDetails');
            }

            return desc;
        };

        $scope.showDetails = function (evt) {
            $scope.connections.data.emailStatus = 'updateEmail';
            $scope.displayList = true;
            $scope.modalWindow = false;
            $scope.selectedView = false;
            $scope.editorSubMenu = false;

            if ($scope.connections.emailData.Reuse) {
                // We create a clone in case that the user does not change anything and save the connection with the clone
                $scope.cloneConn = angular.copy($scope.connections);
            }
        };

        $scope.previewEmail = function () {
            var emailPreview = $scope.connections.data.emailId;
            $scope.displaySendEmailActionOptions = false;
            $rootScope.$emit('previewEmail', $scope.connections, false, $scope.connections.isDummy);
            $("#dvPreviewContent").html("<div class=\"loading-animation\"><span></span><span></span><span></span><span></span></div>");
            if ($scope.connections.isDummy) {
                emailPreview = cEid;
            }
            canvasService.getPreview(emailPreview).then(function (_ref) {
                var data = _ref.data;

                if (data.Response.ID) {
                    var obj = data.Response;
                    var content = obj.TemplateContent;
                    if (content.indexOf("<!-- /Footer Path -->") != -1) {
                        content = content.substring(0, content.indexOf("<!-- /Footer Path -->"));
                    }
                    $("#dvPreviewContent").html("");
                    var iframe = document.createElement('iframe');
                    $(iframe).attr("id", "ifrPreviewContent");
                    $("div#dvPreviewContent").append(iframe);
                    iframe.contentWindow.document.open();
                    iframe.contentWindow.document.write(content);
                    iframe.contentWindow.document.close();
                } else {
                    alert("Could not load Preview");
                }
            });
        };

        $rootScope.$on('redirectToEditor', function (evt, type, fromDetails, designLink) {
            var _onError = function _onError(err) {
                //Error msg from backend when failing
                if (helpers.getJourneyFirstList() == '11111111') {
                    $rootScope.$emit('errorMsg', $scope.translate('canvas.error.613'));
                } else {
                    $rootScope.$emit('errorMsg', err.Message);
                }

                //Close loader
                $rootScope.$emit('jbLoader', false);

                //When fail we open the list and show another error mesg
                $scope.displayList = true;
                $rootScope.$emit('displayActionSendEmailModal', $scope.connections, true, false);
            };

            var _next = function _next() {
                var jbTitle = $rootScope.currentJBTitle || 'Journey Name';
                $scope.connections.data.emailStatus = 'fromEditor';
                //If design link has been clicked we change the email status
                if (designLink) {
                    $scope.connections.data.emailStatus = 'updateExisting';
                }

                if ($stateParams.canvasId) {
                    $scope.saveData();
                    $timeout(function () {
                        // when the canvas exists already
                        canvasService.updateJourney({
                            JourneyTitle: jbTitle,
                            JourneyConfiguration: JSON.stringify($rootScope.connections)
                        }, $stateParams.canvasId, $rootScope.connections.length).success(function (res) {
                            canvasService.redirectToEditor($scope.connections.emailData.Version, $scope.connections.data.emailId, res.JourneyId);
                        }).error(_onError);
                    }, 300);
                }
            };

            if (type) {
                $rootScope.$emit('jbLoader', true);
                if (fromDetails) {
                    _next();
                } else if ($scope.connections.data.emailStatus === 'createNew') {
                    $scope.connections.emailData.Version = canvasService.getVersionByType(type);

                    // Dummy email bullet proof
                    if ($scope.connections.emailData.ToListId === '11111111') {
                        $scope.connections.emailData.ToListId = 0;
                    }

                    var payload = angular.copy($scope.connections.emailData);

                    canvasService.createEmail(payload).success(function (id) {
                        angular.merge($scope.connections.emailData, payload);
                        $scope.connections.data.emailId = id;
                        canvasService.generateThumbs(id).then(function () {});
                        _next();
                    }).error(_onError);
                }
            }
        });

        // when the design button is clicked
        $scope.sendToEditor = function () {
            $scope.$emit('redirectToEditor', $scope.connections.emailData.Version, true, true);
        };

        $scope.selectedCancel = function () {
            $scope.displaySendEmailActionOptions = false;
            if ($scope.connections) {
                var conn = helpers.getStorageConnectionById($scope.connections.id);
                if (conn) {
                    $scope.connections.data = conn.data;
                    $scope.connections.emailData = conn.emailData;
                    $scope.selectedView = false;
                    $scope.updateConnections();
                }
            }

            if ($scope.connections.emailData.Reuse) {
                $scope.connections.emailData.Reuse = false;
                $scope.saveData();
            }

            $rootScope.$emit('cleanSendEmailErrors');
        };

        //Cancel Button
        $scope.cancel = function () {
            $scope.displaySendEmailActionOptions = false;
            if ($scope.connections) {
                var conn = helpers.getStorageConnectionById($scope.connections.id);
                if (conn) {
                    $scope.connections.data = conn.data;
                    $scope.connections.emailData = conn.emailData;
                    $scope.selectedView = false;
                    $scope.updateConnections();
                }
            }

            $rootScope.$broadcast('cleanSendEmailErrors');

            var node = _.find($rootScope.connections, function (conn) {
                return conn.id === $scope.connections.id;
            });

            if (!node && !$scope.connections.emailData.Reuse) {
                // Execute listener when user cancel the send email
                $rootScope.$broadcast('deleteSendEmailNode' + $scope.connections.id);
            } else {
                if (!angular.equals($scope.connections, $scope.cloneConn)) {
                    $scope.connections = $scope.cloneConn;
                }
                $scope.save();
            }
        };

        $scope.switcher = function (type) {
            switch (type) {
                case 'permisionReminder':
                    $scope.connections.data.permisionReminder = !$scope.connections.data.permisionReminder;
                    if ($scope.connections.data.permisionReminder) {
                        $scope.connections.emailData.PermissionReminderMessage = $rootScope.emptyEmail.PermissionReminderMessage;
                    } else {
                        $scope.connections.emailData.PermissionReminderMessage = '';
                    }
                    break;
                case 'webPageVersion':
                    $scope.connections.emailData.WebpageVersion = !$scope.connections.emailData.WebpageVersion;
                    break;
                case 'previewText':
                    $scope.connections.data.pageTextTextarea = !$scope.connections.data.pageTextTextarea;
                    break;
                case 'googleAnalyticsAllUrl':
                    $scope.connections.data.googleAnalyticsAllUrl = !$scope.connections.data.googleAnalyticsAllUrl;
                    initGoogleCampaign();
                    break;
            }
        };

        $scope.saveData = function () {
            Intercom('trackEvent', 'AP - SendEmail');
            $scope.displaySendEmailActionOptions = false;
            $rootScope.$emit('saveActionSendEmailData' + $scope.connections.id, $scope.connections);
        };

        $scope.save = function () {
            if (!$scope.validating) {
                $scope.validating = true;
                $rootScope.$emit('saveActionSendEmail' + $scope.connections.id, $scope.connections);
            }
        };

        $scope.updateConnections = function () {
            $rootScope.$emit('updateSendEmailConn' + $scope.connections.id, $scope.connections, $scope.selectedView);
        };

        $scope.displayModal = function () {
            $scope.displaySendEmailActionOptions = false;
            $scope.displayList = false;
            $scope.selectedView = false;
            $rootScope.$emit('displayModalSendEmail' + $scope.connections.id);
        };

        $scope.toggleEmojiModal = function () {
            $scope.displayEmojiModal = !$scope.displayEmojiModal;
            $scope.displaySendEmailActionOptions = !$scope.displaySendEmailActionOptions;
        };

        $rootScope.$on('hideEditorModal', function (event, connections) {
            $scope.connections = connections;
            $scope.displaySendEmailActionOptions = true;
            $scope.displayList = true;
        });

        $rootScope.$on('cleanSendEmailErrors', function () {
            $scope.eNameErr = false;
            $scope.sbjErr = false;
            $scope.pgTextError = false;
            $scope.eFromErr = false;
            $scope.eFromReplyErr = false;
            $scope.eFromSubjErr = false;
            $scope.ePermissionReminder = false;
            $scope.analyticsError = false;
        });

        $rootScope.$on('syncEmoji', function (evt, emojiVal) {
            if ($scope.connections && $scope.connections.emailData) {
                $scope.connections.emailData.Subject = emojiVal;
            }
        });

        $rootScope.$on('syncEmojiPreviewText', function (evt, emojiVal) {
            if ($scope.connections && $scope.connections.emailData) {
                $scope.connections.emailData.InboxPreviewText = emojiVal;
            }
        });
    };
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    'use strict';

    angular.module('dataHandlingActionUpdateField', ['ngAnimate', 'journey.canvas.srv', 'ngModalDragabble']).controller('actionUpdateFieldCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', actionUpdateFieldCtrl]);

    function actionUpdateFieldCtrl($scope, $rootScope, $timeout, canvasService, helpers) {
        $scope.displayAddWaitTimeActionOptions = false;
        $scope.errors = [];
        $scope.descriptionEmpty = false;

        var sunDay = $scope.translate('timePicker.sun'),
            mon = $scope.translate('timePicker.mon'),
            tue = $scope.translate('timePicker.tue'),
            wed = $scope.translate('timePicker.wed'),
            thu = $scope.translate('timePicker.thrus'),
            fri = $scope.translate('timePicker.fri'),
            sat = $scope.translate('timePicker.sat'),
            jan = $scope.translate('timePicker.jan'),
            feb = $scope.translate('timePicker.feb'),
            mar = $scope.translate('timePicker.mar'),
            apr = $scope.translate('timePicker.apr'),
            may = $scope.translate('timePicker.may'),
            jun = $scope.translate('timePicker.jun'),
            jul = $scope.translate('timePicker.jul'),
            aug = $scope.translate('timePicker.aug'),
            set = $scope.translate('timePicker.set'),
            oct = $scope.translate('timePicker.oct'),
            nov = $scope.translate('timePicker.nov'),
            dec = $scope.translate('timePicker.dec');

        $rootScope.$on('displayActionUpdateFieldModal', function (evt, conn, showTip) {
            var entry = document.getElementById(conn.id).getBoundingClientRect();

            $scope.top = entry.top;
            $scope.left = entry.left;
            $scope.entryTop = entry.top;
            $scope.contactListData = $rootScope.contactListData;
            $scope.showTip = showTip;
            $scope.displayAddWaitTimeActionOptions = true;
            $scope.connections = angular.copy(conn);
            $scope.errorUnits = false;
            $scope.errorDelay = false;
            $scope.descriptionEmpty = false;
            $scope.setInitListItem();
        });

        $rootScope.$on('hideActionUpdateFieldModal', function () {
            $scope.displayAddWaitTimeActionOptions = false;
        });

        $rootScope.$on('displayActionUpdateFieldModalError', function (evt, errors) {
            $scope.errors = errors;
        });

        $scope.$watch('connections.data.list', function (newVal, oldVal) {
            if (oldVal && oldVal != newVal) {
                $scope.connections.data.fields = [];
            }
        });

        $scope.cancel = function () {
            $scope.displayAddWaitTimeActionOptions = false;

            var node = _.find($rootScope.connections, function (conn) {
                return conn.id === $scope.connections.id;
            });

            // execute listener when user cancel the add the node of delay
            if (!node) {
                $rootScope.$broadcast('deleteUpdateFieldNode' + $scope.connections.id);
            }
        };

        $scope.save = function () {
            $rootScope.$emit('saveActionUpdateFieldData' + $scope.connections.id, $scope.connections);
        };

        $scope.setInitListItem = function () {

            if (!$scope.connections.data.fields.length) {
                $scope.addToFieldList();
                $scope.connections.data.fields[0].pickedList = $rootScope.journeyLists && $rootScope.journeyLists[0] || '';
                $scope.updateFields();
            } else {
                $scope.updateFields();
            }

            $scope.connections.data.fields.map(function (i, index) {
                $timeout(function () {
                    if (i.fieldType == 4) {
                        var id = '#field-date-picker-' + index;
                        $(id).datetimepicker({
                            stepMinute: 15,
                            minDate: 0,
                            dayNamesMin: [sunDay, mon, tue, wed, thu, fri, sat],
                            monthNames: [jan, feb, mar, apr, may, jun, jul, aug, set, oct, nov, dec],
                            currentText: $scope.translate('timePicker.now'),
                            closeText: $scope.translate('timePicker.done'),
                            amNames: ['AM', 'A'],
                            pmNames: ['PM', 'P'],
                            timeFormat: 'HH:mm',
                            timeSuffix: '',
                            timeOnlyTitle: $scope.translate('timePicker.choooseTime'),
                            timeText: $scope.translate('timePicker.time'),
                            hourText: $scope.translate('timePicker.hour'),
                            minuteText: $scope.translate('timePicker.minute'),
                            secondText: $scope.translate('timePicker.second'),
                            millisecText: $scope.translate('timePicker.millisecond'),
                            microsecText: $scope.translate('timePicker.microsecond'),
                            timezoneText: $scope.translate('timePicker.timeZone')
                        });

                        $(id).on('change', function () {
                            $scope.connections.data.fields[index].updateTo = $(this).val();
                        });
                    }
                }, 500);
            });
        };

        $scope.updateFields = function () {
            canvasService.getFields($scope.connections.data.fields[0].pickedList).then(function (_ref) {
                var data = _ref.data;

                $scope.fieldList = data.Details;
                if (!$scope.connections.data.fields.length) {
                    $scope.connections.data.fields.push({
                        pickedList: '',
                        pickedField: '',
                        pickedFieldName: '',
                        updateTo: '',
                        fieldType: 1
                    });
                }
            });
        };

        $scope.triggerDatePicker = function (id) {
            $timeout(function () {
                document.getElementById(id).focus();
            });
        };

        $scope.updateFieldtype = function (index) {
            var dataField = $scope.fieldList.find(function (i) {
                return i.FieldKey == $scope.connections.data.fields[index].pickedField;
            });
            var newType = dataField['FieldType'] || 1;
            $scope.connections.data.fields[index].pickedFieldName = dataField.FieldName;

            if ($scope.connections.data.fields[index].fieldType != newType) {
                $scope.connections.data.fields[index].fieldType = 8;
                $timeout(function () {
                    $scope.connections.data.fields[index].fieldType = newType;
                    $scope.connections.data.fields[index].updateTo = '';
                }, 300);

                $timeout(function () {
                    if (newType == 4) {
                        var id = '#field-date-picker-' + index;
                        $(id).datetimepicker({
                            stepMinute: 15,
                            minDate: 0,
                            dayNamesMin: [sunDay, mon, tue, wed, thu, fri, sat],
                            monthNames: [jan, feb, mar, apr, may, jun, jul, aug, set, oct, nov, dec],
                            currentText: $scope.translate('timePicker.now'),
                            closeText: $scope.translate('timePicker.done'),
                            amNames: ['AM', 'A'],
                            pmNames: ['PM', 'P'],
                            timeFormat: 'HH:mm',
                            timeSuffix: '',
                            timeOnlyTitle: $scope.translate('timePicker.choooseTime'),
                            timeText: $scope.translate('timePicker.time'),
                            hourText: $scope.translate('timePicker.hour'),
                            minuteText: $scope.translate('timePicker.minute'),
                            secondText: $scope.translate('timePicker.second'),
                            millisecText: $scope.translate('timePicker.millisecond'),
                            microsecText: $scope.translate('timePicker.microsecond'),
                            timezoneText: $scope.translate('timePicker.timeZone')
                        });
                        $(id).on('change', function () {
                            $scope.connections.data.fields[index].updateTo = $(this).val();
                        });
                    }
                }, 500);
            }
        };

        var height = 431;
        $scope.addToFieldList = function () {
            $timeout(function () {
                height += 300;
                document.getElementById('field-modal-' + $scope.connections.id).scrollTop = height;
            }, 300);

            $scope.connections.data.fields.push({
                pickedList: '',
                pickedField: '',
                pickedFieldName: '',
                updateTo: '',
                fieldType: 1
            });
        };

        $scope.deleteFieldSet = function ($index) {
            $scope.connections.data.fields.splice($index, 1);
        };
    };
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    'use strict';

    angular.module('dataHandlingConditionEmailEngagement', ['ngAnimate', 'journey.canvas.srv', 'ngModalDragabble']).controller('conditionEmailEngagementCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', conditionEmailEngagementCtrl]);

    function conditionEmailEngagementCtrl($scope, $rootScope, $timeout, canvasService, helpers) {
        $scope.displayEmailEngagementConditionOpt = false;
        $scope.displayError = false;
        $scope.descriptionEmpty = false;

        $rootScope.$on('displayConditionEmailEngagementModal', function (evt, conn, showTip) {
            var entry = document.getElementById(conn.id).getBoundingClientRect();

            $scope.top = entry.top;
            $scope.left = entry.left;
            $scope.entryTop = entry.top;
            $scope.showTip = showTip;
            $scope.modalPos = $scope.calculateModalPos($scope.top, $scope.left);
            $scope.displayEmailEngagementConditionOpt = true;
            $scope.connections = angular.copy(conn);
            $scope.displayError = false;
            $scope.descriptionEmpty = false;
            $scope.conditionList = $scope.getConditionList();
            $scope.emailList = helpers.jbContainsSendEmail();
            $scope.conditionError = [];
            $scope.emailError = false;

            $(window).resize(function () {
                var entry = document.getElementById($scope.connections.id).getBoundingClientRect();
                $scope.$apply(function () {
                    $scope.top = entry.top;
                    $scope.left = entry.left;
                    $scope.calculateModalPos($scope.top, $scope.left);
                });
            });
        });

        $rootScope.$on('hideConditionEmailEngagementtModal', function () {
            $scope.displayError = false;
            $scope.displayEmailEngagementConditionOpt = false;
        });

        $rootScope.$on('displayConditionEmailEngagementError', function (evt, emailErr, conditionErr, item) {
            $scope.emailError = emailErr;
            if (item != undefined && conditionErr) {
                $scope.conditionError[parseInt(item)] = conditionErr;
            }
        });

        var conditionCount = 2;

        $scope.getConditionList = function () {
            return {
                hasOpened: $scope.translate('canvas.condition.emailEngagement.hasOpened'),
                hasNotOpened: $scope.translate('canvas.condition.emailEngagement.hasNotOpened'),
                hasClicked: $scope.translate('canvas.condition.emailEngagement.hasClicked'),
                hasNotClicked: $scope.translate('canvas.condition.emailEngagement.hasNotClicked')
            };
        };

        $scope.isRepeated = function (condition) {
            var res = _.filter($scope.connections.data.conditions, function (item) {
                return condition === item.selectedCondition;
            }) || [];

            return res.length > 1;
        };

        //On select change we sent via paramer the selected condition and which one it is.
        //Loop in to the condition list and flag the status = true when visited and the conditionSelected fill what condition is (1,2 or 3) to know if its visited and which one did.
        $scope.selectCondition = function (condition, index) {
            if (condition != null) {
                if ($scope.isRepeated(condition.selectedCondition)) {
                    $scope.connections.data.conditions[index].selectedCondition = '';
                    $rootScope.$emit('errorMsg', $scope.translate('canvas.condition.emailEngagement.repeatedOptions'));
                }
            }
        };

        //Filter the conditions to show on the selector from the condition number
        $scope.conditionFilter = function (param) {
            return function (condition) {
                return condition.status == false || condition.conditionSelected == param;
            };
        };

        //function to add a new condition into the dom
        $scope.addNewCondition = function () {
            var index = $scope.connections.data.conditions.length;
            $rootScope.myConnections = $scope.connections.data.conditions;

            if (!$scope.connections.data.emailNode || !$scope.connections.data.conditions[index - 1].selectedCondition) {
                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.condition.604'));
            } else if (index > 3) {
                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.condition.605'));
            } else {
                $scope.connections.data.conditions.push({
                    label: $scope.translate('canvas.condition.emailEngagement.conditionLabel.' + (index + 1)),
                    selectedCondition: '',
                    url: '',
                    deleteClass: 'added-condition'
                });
            }
        };

        //Function to remove conditions on the screen
        $scope.removeCondition = function (index) {
            $scope.connections.data.conditions.splice(index, 1);
            for (var i = 0; i < $scope.conditionList.length; i++) {
                if ($scope.conditionList[i].conditionSelected === 'condition' + index) {
                    $scope.conditionList[i].conditionSelected = '';
                    $scope.conditionList[i].status = false;
                }
            }
            for (var j = index; j < $scope.connections.data.conditions.length + 1; j++) {
                for (var k = 0; k < $scope.conditionList.length; k++) {
                    if ($scope.conditionList[k].conditionSelected === 'condition' + Number(j + 1)) {
                        $scope.conditionList[k].conditionSelected = 'condition' + j;
                        $scope.conditionList[k].status = true;
                        for (var h = 0; h < $scope.connections.data.conditions.length; h++) {
                            if ($scope.connections.data.conditions[h].selectedCondition === 'Has clicked URL') {
                                $scope.selectUrl[h] = true;
                            }
                        }
                    }
                }
            }
        };

        $scope.calculateModalPos = function (top, left) {
            var currentTopPercent = top / window.innerHeight * 100;
            var currentLeftPercent = left / window.innerWidth * 100;
            var fixedHeight = 400;
            var fixedwidth = 450;

            if (left + 160 > window.innerWidth) {
                currentLeftPercent = 20;
                left = 0;
            }

            $scope.modalTop = (currentTopPercent + _calculateTopByPos()).toFixed(0) + '%';
            $scope.modalLeft = (currentLeftPercent + _calculateLeftByPos()).toFixed(0) + '%';

            function _calculateTopByPos() {
                var totalTop = top + fixedHeight,
                    resTop = 0;

                if (totalTop > window.innerHeight) {
                    resTop = -38;
                }

                return resTop;
            }

            function _calculateLeftByPos() {
                var totalLeft = left + fixedwidth,
                    resLeft = 14;

                if ($scope.showTip) {
                    resLeft = 22;
                }

                if (totalLeft > window.innerWidth) {
                    resLeft = -20;
                }

                return resLeft;
            }
        };

        $scope.cancel = function () {
            $scope.displayEmailEngagementConditionOpt = false;

            var node = _.find($rootScope.connections, function (conn) {
                return conn.id === $scope.connections.id;
            });

            if (!node) {
                // Execute listener when user cancel the email engagement node
                $rootScope.$broadcast('deleteEmailEngagementNode' + $scope.connections.id);
            }
        };

        $scope.save = function () {
            Intercom('trackEvent', 'AP - EmailEngagement');
            $rootScope.$emit('saveConditionEmailEngagementData' + $scope.connections.id, $scope.connections, $scope.descriptionEmpty);
        };

        //Toggle List Item to check if a checkbox is checked, If not we add it to the array of IDs, if not we delete it and just save the ones selected
        $scope.toggelListItem = function (listItem) {
            if ($scope.connections.isDummy) {
                $scope.connections.data.selectedList = [];
                delete $scope.connections.isDummy;
            }

            var index = $scope.connections.data.selectedList.indexOf(listItem);
            if (index > -1) {
                $scope.connections.data.selectedList.splice(index, 1);
            } else {
                $scope.connections.data.selectedList.push(listItem);
            }

            if ($scope.connections.data.selectedList.length) {
                $scope.selectedKey = $scope.translate('commons.editSelection');
            } else {
                $scope.selectedKey = $scope.translate('commons.selectList');
            }
        };

        $scope.parseDescription = function (id) {
            var eName;
            if (!id) {
                return $scope.translate('commons.enterDetails');
            }
            for (var i = 0; i < $scope.emailList.length; i++) {
                if ($scope.emailList[i].id === id) {
                    eName = $scope.emailList[i].name;
                    break;
                }
            }

            return eName;
        };
    };
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    'use strict';

    angular.module('dataHandlingConditionIfElse', ['ngAnimate', 'journey.canvas.srv']).controller('conditionIfElseCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', conditionIfElseCtrl]);

    function conditionIfElseCtrl($scope, $rootScope, $timeout, canvasService, helpers) {
        $scope.displayIfElseConditionOptions = false;
        $scope.createListName = {};
        $scope.createList = {};
        $scope.search = {};

        function resetNode() {
            $scope.displayIfElseConditionOptions = false;
            $scope.errorUrl = false;
        }

        $rootScope.$on('displayConditionIfElseModal', function (evt, conn, showTip) {
            $scope.specificUrlOptions = [{
                value: 'any-tracked-page',
                message: $scope.translate('canvas.entry.websiteEngagement.anyTracked')
            }, {
                value: 'is-url',
                message: $scope.translate('canvas.entry.websiteEngagement.specificUrl')
            }, {
                value: 'contains-url',
                message: $scope.translate('canvas.entry.websiteEngagement.containsUrl')
            }, {
                value: 'doesnotcontain-url',
                message: $scope.translate('canvas.entry.websiteEngagement.not.containsUrl')
            }, {
                value: 'startswith-url',
                message: $scope.translate('canvas.entry.websiteEngagement.starts.with.url')
            }, {
                value: 'endswith-url',
                message: $scope.translate('canvas.entry.websiteEngagement.ends.with.url')
            }, {
                value: 'wildcardmatch-url',
                message: $scope.translate('canvas.entry.websiteEngagement.wildcard.url')
            }];

            var entry = document.getElementById(conn.id).getBoundingClientRect();

            $scope.top = entry.top;
            $scope.left = entry.left;
            $scope.entryTop = entry.top;

            $scope.errorUrl = false;
            $scope.displayForm = true;

            $scope.newlyCreate = true;
            $scope.displayError = false;
            $scope.displaySubMenuIf = false;
            $scope.selectedAction = {};
            $scope.ConnectionsFromLoader = false;
            $scope.displayPlus = [];
            $scope.rectangleCons = [];
            $scope.isElegibleForUpdate = true;
            $scope.modalWindow = [];
            $scope.hideForLimitCon = [];
            $scope.displayInnerSubMenuIf = [];
            $scope.checkList = [];
            $scope.listTitle = [];
            $scope.linkList = [];

            $scope.append = [];
            $scope.urlError = [];
            $scope.emailList = helpers.jbContainsSendEmail();
            $scope.hasArrow = {};
            $scope.showTip = showTip;
            $scope.modalPos = $scope.calculateModalPos($scope.top, $scope.left);
            $scope.displayIfElseConditionOptions = true;
            $scope.connections = angular.copy(conn);
            $scope.hideWhenLimit = true;

            if ($scope.connections.data.conditionGroups) {
                $scope.hideWhenLimit = !($scope.connections.data.conditionGroups.length > 3);

                for (var i = 0; i < $scope.connections.data.conditionGroups.length; i++) {
                    $scope.setActionsModel(i);

                    $scope.checkList[i] = [];
                    $scope.listTitle[i] = [];
                    $scope.modalWindow[i] = [];
                    $scope.append[i] = [];
                    $scope.urlError[i] = [];
                    if ($scope.connections.data.conditionGroups[i].length >= 5) {
                        $scope.hideForLimitCon[i] = true;
                    }
                    for (var j = 0; j < $scope.connections.data.conditionGroups[i].length; j++) {
                        if ($scope.connections.data.conditionGroups[i][j].type === 'email' || $scope.connections.data.conditionGroups[i][j].type === 'link') {
                            $scope.connections.data.conditionGroups[i][j].selectedOpt[0] = conn.data.conditionGroups[i][j].selectedOpt[0];

                            (function (i, j, conn) {
                                $timeout(function () {

                                    $scope.connections.data.conditionGroups[i][j].selectedOpt[0] = conn.data.conditionGroups[i][j].selectedOpt[0];
                                    var eId = helpers.getConnectionById(conn.data.conditionGroups[i][j].selectedOpt[0]).data.emailId;
                                    if (!$scope.linkList[i]) {
                                        $scope.linkList[i] = [];
                                    }
                                    canvasService.emailUrls(eId).then(function (response) {
                                        response = _.uniq(response.data);
                                        $scope.linkList[i][j] = response;
                                        $scope.linkList[i][j].unshift('Any Link');
                                        $scope.connections.data.conditionGroups[i][j].selectedOpt[1] = conn.data.conditionGroups[i][j].selectedOpt[1];
                                    }).catch(function () {
                                        $scope.linkList[i][j] = [];
                                        $scope.linkList[i][j].unshift('Any Link');
                                        $scope.connections.data.conditionGroups[i][j].selectedOpt[1] = conn.data.conditionGroups[i][j].selectedOpt[1];
                                    });
                                }, 0);
                            })(i, j, conn);
                        }

                        if ($scope.connections.data.conditionGroups[i][j].type === 'list') {
                            var key = $scope.connections.data.conditionGroups[i][j].selectedOpt[0],
                                val = helpers.getContactListItem(key, $scope.contactListData, $scope.segmentData);

                            (function (i, j, val, conn) {
                                $timeout(function () {
                                    $scope.checkList[i][j] = {};
                                    $scope.checkList[i][j][key] = true;
                                    $scope.listTitle[i][j] = val.substring(0, 26) + '...';
                                    $scope.connections.data.conditionGroups[i][j].selectedOpt[0] = conn.data.conditionGroups[i][j].selectedOpt[0];
                                }, 0);
                            })(i, j, val, conn);
                        }
                    }
                }
            }

            $(window).resize(function () {
                var entry = document.getElementById($scope.connections.id).getBoundingClientRect();
                $scope.$apply(function () {
                    $scope.top = entry.top;
                    $scope.left = entry.left;
                });
            });
        });

        $rootScope.$on('hideConditionIfElseModal', function () {
            resetNode();
        });

        $scope.contMenu = 0;
        $scope.contMenuInner = 0;

        $scope.stopMenuBroadcast = function () {
            $scope.contMenu = 0;
            $scope.contMenuInner = 0;
        };

        $rootScope.$on('closeInnerMenuIfElse', function () {
            if ($scope.displaySubMenuIf) {
                if ($scope.contMenu === 0) {
                    $scope.contMenu = 1;
                } else {
                    $scope.displaySubMenuIf = false;
                    $scope.contMenu = 0;
                }
            } else {
                $scope.contMenu = 0;
            }

            if ($scope.displayInnerSubMenuIf && $scope.displayInnerSubMenuIf[0]) {
                if ($scope.contMenuInner === 0) {
                    $scope.contMenuInner = 1;
                } else {
                    $scope.displayInnerSubMenuIf[0] = false;
                    $scope.contMenuInner = 0;
                }
            } else {
                $scope.contMenuInner = 0;
            }
        });

        $rootScope.$on('displayConditionIfElseModalError', function () {
            $scope.errorUrl = true;
        });

        $rootScope.$on('inputErrorsConditionIfElse', function (evt, conditionGroups) {
            angular.extend($scope.connections.data.conditionGroups, conditionGroups);
        });

        $scope.createListClick = function (parent, index) {
            $scope.createList[parent] = {};
            $scope.createList[parent][index] = true;
            $scope.createListName.name = '';
        };

        $scope.goCreateList = function (parent, index) {
            if ($scope.createListName.name) {
                $scope.createListLoader = true;
                canvasService.createContactList($scope.createListName.name).success(function (_ref) {
                    var Results = _ref.Results;

                    $scope.createListLoader = false;
                    if (Results.length) {
                        var result = Results[0];
                        $scope.contactListData.unshift({
                            ContactCount: 0,
                            ListId: result.ListId,
                            ListName: $scope.createListName.name
                        });

                        $scope.createList[parent][index] = false;
                        $scope.setTitle('', parent, index, result.ListId, $scope.createListName.name);
                        $rootScope.$emit('errorMsg', $scope.translate('common.list.message'), 'confirmation');
                    } else {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.607'));
                    }
                }).error(function () {
                    $rootScope.$emit('errorMsg', $scope.translate('canvas.error.607'));
                    $scope.createListLoader = false;
                });
            }
        };

        $scope.goBackList = function (parent, index) {
            $scope.createList[parent][index] = false;
        };

        $scope.calculateModalPos = function (top, left) {
            var currentTopPercent = top / window.innerHeight * 100;
            var currentLeftPercent = left / window.innerWidth * 100;
            var fixedHeight = 400;
            var fixedwidth = 700;

            if (left + 160 > window.innerWidth) {
                currentLeftPercent = 20;
                left = 0;
            }

            $scope.modalTop = (currentTopPercent + _calculateTopByPos()).toFixed(0) + '%';
            $scope.modalLeft = (currentLeftPercent + _calculateLeftByPos()).toFixed(0) + '%';

            function _calculateTopByPos() {
                var totalTop = top + fixedHeight,
                    resTop = 0;

                if (totalTop > window.innerHeight) {
                    resTop = -42;
                }

                return resTop;
            }

            function _calculateLeftByPos() {
                var totalLeft = left + fixedwidth,
                    resLeft = 14;

                if ($scope.showTip) {
                    resLeft = 22;
                }

                if (totalLeft > window.innerWidth) {
                    resLeft = -45;
                }

                return resLeft;
            }
        };

        $scope.selectCondition = function (groupIndex) {
            $scope.groupIndex = groupIndex;
            $scope.displaySubMenuIf = true;
            $scope.displayInnerSubMenuIf[groupIndex] = true;
        };

        $scope.setActionsModel = function (group) {
            var elIndex = $scope.connections.data.conditionGroups[group].length - 1;

            $scope.$watch('connections.data.conditionGroups[' + group + '][' + elIndex + '].condition', function (andOr) {
                if (andOr) {
                    for (var i = 0; i < $scope.connections.data.conditionGroups[group].length; i++) {
                        $scope.connections.data.conditionGroups[group][i].condition = andOr;
                    }
                }
            });

            var UpdateFlag = false;
            $scope.$watch('connections.data.conditionGroups[' + group + '][' + elIndex + '].selectedAction', function (newValue, oldValue) {
                if (newValue !== oldValue && newValue !== undefined) {
                    if ((newValue === 'hasOpenedEmail' || newValue === 'hasNotOpenedEmail' || newValue === 'hasClickedALink' || newValue === 'hasNotClickedALink') && !$scope.emailList) {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.606'));
                        UpdateFlag = true;
                        var selectedOpt = $scope.connections.data.conditionGroups[group][elIndex].selectedOpt;
                        //update connection model
                        $scope.connections.data.conditionGroups[group][elIndex] = canvasService.getInitIfElseModel(oldValue);
                        $scope.connections.data.conditionGroups[group][elIndex].selectedOpt = selectedOpt;
                        $scope.linkList[group][elIndex] = '';
                    } else if (!UpdateFlag) {
                        //update connection model
                        $scope.connections.data.conditionGroups[group][elIndex] = canvasService.getInitIfElseModel(newValue);
                        $scope.connections.data.conditionGroups[group][elIndex].selectedOpt = [];
                        $scope.checkList[group][elIndex] = {};
                        $scope.listTitle[group][elIndex] = 'Select Option';
                        $scope.linkList[group][elIndex] = '';
                    } else {
                        UpdateFlag = false;
                    }
                }
            });

            $scope.$watch('connections.data.conditionGroups[' + group + '][' + elIndex + '].selectedOpt', function (val) {
                if (val) {
                    if (val === 'any-tracked-page') {
                        $scope.connections.data.conditionGroups[group][elIndex].selectedOpt[1] = '';
                        $scope.append[group][elIndex] = false;
                    }
                }
            });

            $scope.$watch('connections.data.conditionGroups[' + group + '][' + elIndex + '].selectedOpt[1]', function (url) {
                if ($scope.connections.data.conditionGroups && url && $scope.connections.data.conditionGroups[group][elIndex].selectedOpt[0] === 'is-url' && $scope.connections.data.conditionGroups[group][elIndex].type !== 'link') {
                    if (url && ($scope.connections.data.conditionGroups[group][elIndex].selectedOpt[0] === 'is-url' || $scope.connections.data.conditionGroups[group][elIndex].selectedOpt[0] === 'wildcardmatch-url') && $scope.connections.data.conditionGroups[group][elIndex].type !== 'link') {
                        var reg;

                        if ($scope.connections.data.conditionGroups[group][elIndex].selectedOpt[0] === 'is-url') {
                            reg = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
                        } else {
                            reg = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+\/\*$/;
                        }

                        if (!reg.test(url)) {
                            $scope.urlError[group][elIndex] = true;
                        } else {
                            $scope.urlError[group][elIndex] = false;
                        }
                    }
                }
            });

            $scope.$watch('connections.data.conditionGroups[' + group + '][' + elIndex + '].selectedOpt[0]', function (newVal, old) {
                if (old != newVal && newVal) {
                    if ($scope.connections.data.conditionGroups && group > $scope.connections.data.conditionGroups.length - 1) {
                        return;
                    }
                    if ($scope.connections.data.conditionGroups[group][elIndex].type == 'link') {
                        var eId = helpers.getConnectionById(newVal).data.emailId;
                        if (!$scope.linkList[group]) {
                            $scope.linkList[group] = [];
                        }
                        canvasService.emailUrls(eId).then(function (response) {
                            response = _.uniq(response.data);
                            $scope.linkList[group][elIndex] = response;
                            $scope.linkList[group][elIndex].unshift('Any Link');
                            $scope.connections.data.conditionGroups[group][elIndex].selectedOpt[1] = $scope.linkList[group][elIndex][0];
                        }).catch(function () {
                            $scope.linkList[group][elIndex] = [];
                            $scope.linkList[group][elIndex].unshift('Any Link');
                            $scope.connections.data.conditionGroups[group][elIndex].selectedOpt[1] = $scope.linkList[group][elIndex][0];
                        });
                    }

                    if ($scope.connections.data.conditionGroups && $scope.connections.data.conditionGroups[group][elIndex].selectedOpt && ($scope.connections.data.conditionGroups[group][elIndex].selectedOpt[0] === 'any-tracked-page' || $scope.connections.data.conditionGroups[group][elIndex].selectedOpt[0] === 'is-url' || $scope.connections.data.conditionGroups[group][elIndex].selectedOpt[0] === 'contains-url' || $scope.connections.data.conditionGroups[group][elIndex].selectedOpt[0] === 'doesnotcontain-url' || $scope.connections.data.conditionGroups[group][elIndex].selectedOpt[0] === 'startswith-url' || $scope.connections.data.conditionGroups[group][elIndex].selectedOpt[0] === 'endswith-url' || $scope.connections.data.conditionGroups[group][elIndex].selectedOpt[0] === 'wildcardmatch-url')) {
                        $scope.append[group][elIndex] = false;
                        $scope.urlError[group][elIndex] = false;
                        $scope.connections.data.conditionGroups[group][elIndex].selectedOpt[1] = '';
                    }
                }
            });
        };

        $scope.$on('selectedOption', function (event, option, elId) {
            if ($scope.connections.id != elId) {
                return false;
            }

            var opts = option.split(':'),
                type = opts[0],
                val = opts[1],
                group,
                currentLength;

            if ((val === 'hasOpenedEmail' || val === 'hasNotOpenedEmail' || val === 'hasClickedALink' || val === 'hasNotClickedALink') && !$scope.emailList) {
                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.606'));
                return false;
            }

            if ($scope.groupIndex > -1) {
                group = $scope.groupIndex;
                $scope.hideForLimitCon[group] = false;
            } else {
                group = 0;
                $scope.connections.data.conditionGroups = [];
                $scope.connections.data.conditionGroups[group] = [];
                $scope.listTitle = [];
                $scope.modalWindow = [];
                $scope.hideForLimitCon = [];
                $scope.checkList = [];
                $scope.append = [];
                $scope.urlError = [];
            }

            if (typeof $scope.listTitle[group] === 'undefined') {
                $scope.listTitle[group] = [];
                $scope.modalWindow[group] = [];
                $scope.checkList[group] = [];
                $scope.append[group] = [];
                $scope.urlError[group] = [];
            }

            $scope.connections.data.additionals.showForNewGroup[group] = false;

            currentLength = $scope.connections.data.conditionGroups[group].length;
            $scope.connections.data.conditionGroups[group][currentLength] = canvasService.getInitIfElseModel(val);
            $scope.connections.data.actionsList = canvasService.getActionIfElseList(type);

            $scope.setActionsModel(group);

            $scope.displaySubMenuIf = false;
            $scope.displayInnerSubMenuIf = [];
            $scope.connections.data.additionals.initialCondition = false;

            $scope.listTitle[group][currentLength] = $scope.translate('canvas.condition.ifElse.selectOption');
            $scope.modalWindow[group][currentLength] = false;

            if (val !== 'inList' && val !== 'notInList' && val !== 'inSegment' && val !== 'notInSegment') {
                $scope.connections.data.conditionGroups[group][currentLength].selectedOpt = [];
            }

            if (currentLength > 1) {
                var previousCon = $scope.connections.data.conditionGroups[group][currentLength - 1].condition;
                $scope.connections.data.conditionGroups[group][currentLength].condition = previousCon;
            }

            if (currentLength === 4) {
                $scope.hideForLimitCon[group] = true;
            }
        });

        $scope.setGroupWatcher = function (group) {
            $scope.$watch('connections.data.selectedGroupConditions[' + group + ']', function (andOr) {
                if (andOr) {
                    for (var i = 0; i < $scope.connections.data.selectedGroupConditions.length; i++) {
                        $scope.connections.data.selectedGroupConditions[i] = andOr;
                    }
                }
            });
        };

        $scope.addNewConditionGroup = function () {
            if ($scope.connections.data.conditionGroups !== undefined) {
                var groupsLength = $scope.connections.data.conditionGroups.length;
                if ($scope.connections.data.conditionGroups[groupsLength - 1].length < 1) {
                    $rootScope.$emit('errorMsg', $scope.translate('canvas.error.608'));
                } else {
                    $scope.connections.data.selectedGroupConditions[groupsLength] = 'and';
                    $scope.connections.data.conditionGroups[groupsLength] = [];
                    $scope.hideForLimitCon[groupsLength] = true;
                    $scope.connections.data.additionals.showForNewGroup[groupsLength] = true;

                    if (groupsLength > 1) {
                        var prevCon = $scope.connections.data.selectedGroupConditions[groupsLength - 1];
                        $scope.connections.data.selectedGroupConditions[groupsLength] = prevCon;
                    }

                    if (groupsLength >= 3) {
                        $scope.hideWhenLimit = false;
                    }
                    $scope.setGroupWatcher(groupsLength);
                }
            } else {
                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.608'));
            }
        };

        $scope.removeGroupCondition = function (childIndex, parentIndex) {
            $scope.connections.data.conditionGroups[parentIndex].splice(childIndex, 1);
            $scope.hideForLimitCon[parentIndex] = false;
        };

        $scope.deleteGroup = function (group) {
            $scope.connections.data.conditionGroups.splice(group, 1);
            $scope.hideWhenLimit = true;
        };

        $scope.displayModal = function (pidx, idx) {
            var name = pidx + '' + idx;
            $scope.contactListData = $rootScope.contactListData;

            if (!$scope.bindArray) {
                $scope.bindArray = [name];
                $scope.setScrollLogic(name);
                $scope.setScrollSegmentLogic(name);
            } else {
                if ($scope.bindArray.indexOf(name) === -1) {
                    $scope.setScrollLogic(name);
                    $scope.setScrollSegmentLogic(name);
                    $scope.bindArray.push(name);
                }
            }

            $scope.modalWindow[pidx][idx] = true;
        };

        $scope.hideModal = function (pidx, idx, clearList) {
            if (clearList) {
                $scope.checkList[pidx][idx] = {};
                $scope.connections.data.conditionGroups[pidx][idx].selectedOpt[0] = '';
                $scope.listTitle[pidx][idx] = $scope.translate('canvas.condition.ifElse.selectOption');
            }
            $scope.modalWindow[pidx][idx] = false;
            $scope.search.list = "";
            $scope.contactListData = $rootScope.contactListData;
        };

        $scope.setTitle = function (evt, parent, index, key, val) {
            if (key && val) {
                if ($scope.connections.isDummy) {
                    delete $scope.connections.isDummy;
                }

                $scope.checkList[parent][index] = {};
                $scope.checkList[parent][index][key] = true;
                $scope.connections.data.conditionGroups[parent][index].selectedOpt[0] = key;
                if (val.length > 26) {
                    val = val.substring(0, 26) + '...';
                }
                $scope.listTitle[parent][index] = val;
            }
        };

        $scope.parseDescription = function (desc) {
            if (!desc) {
                return $scope.translate('commons.enterDetails');
            }

            return desc;
        };

        $scope.setScrollLogic = function (id) {
            $scope.listLoader = false;
            angular.element(document.getElementById('listContainer' + id)).bind("scroll", function () {
                if (!$scope.listLoader && !$rootScope.stopLoadingList && !$scope.search.list) {
                    $scope.listLoader = true;
                    canvasService.getContactList($rootScope.contactListOffset, 10).success(function (data) {
                        if (!data.Results.length) {
                            $rootScope.stopLoadingList = true;
                        } else {
                            $rootScope.contactListOffset++;
                            $rootScope.contactListData = _.uniqBy($rootScope.contactListData.concat(data.Results), 'ListId');
                            $scope.contactListData = $rootScope.contactListData;
                        }
                        $scope.listLoader = false;
                    }).error(function () {
                        $scope.listLoader = false;
                    });
                }
            });
        };

        $scope.searching = false;
        $scope.search.search = function (val) {
            if (val && val.length > 0 && !$scope.searching) {
                $scope.searching = true;
                canvasService.searchContactList(val).then(function (res) {
                    $scope.searching = false;
                    $rootScope.contactListData = _.uniqBy($rootScope.contactListData.concat(res.data.Results), 'ListId');
                    $scope.contactListData = [];
                    if ($scope.connections.data.selectedList && $scope.connections.data.selectedList.length) {
                        $scope.connections.data.selectedList.forEach(function (item) {
                            for (var i = 0; i < $rootScope.contactListData.length; i++) {
                                if ($rootScope.contactListData[i].ListId === item) {
                                    $scope.contactListData.push($rootScope.contactListData[i]);
                                    break;
                                }
                            }
                        });
                    }

                    $scope.contactListData = $scope.contactListData.concat(res.data.Results);
                }).catch(function () {
                    $scope.searching = false;
                });
            } else {
                $scope.contactListData = $rootScope.contactListData;
            }
        };

        $scope.setScrollSegmentLogic = function (id) {
            $scope.listLoader = false;
            angular.element(document.getElementById('segmentContainer' + id)).bind("scroll", function () {
                if (!$scope.listLoader && !$rootScope.stopLoadingList && !$scope.search.list) {
                    $scope.listLoader = true;
                    canvasService.getSegments($rootScope.segmentListOffset, 10).success(function (data) {
                        if (!data.Results.length) {
                            $rootScope.stopLoadingList = true;
                        } else {
                            $rootScope.segmentListOffset++;
                            $rootScope.segmentData = _.uniqBy($rootScope.segmentData.concat(data.Results), 'SegmentId');
                            $scope.segmentData = $rootScope.segmentData;
                        }
                        $scope.listLoader = false;
                    }).error(function () {
                        $scope.listLoader = false;
                    });
                }
            });
        };

        $scope.searching = false;
        $scope.search.searchSegment = function (val) {
            if (val && val.length > 0 && !$scope.searching) {
                $scope.searching = true;
                canvasService.searchContactSegment(val).then(function (res) {
                    $scope.searching = false;
                    $rootScope.segmentData = _.uniqBy($rootScope.segmentData.concat(res.data.Results), 'ListId');
                    $scope.segmentData = [];
                    if ($scope.connections.data.selectedList && $scope.connections.data.selectedList.length) {
                        $scope.connections.data.selectedList.forEach(function (item) {
                            for (var i = 0; i < $rootScope.segmentData.length; i++) {
                                if ($rootScope.segmentData[i].ListId === item) {
                                    $scope.segmentData.push($rootScope.segmentData[i]);
                                    break;
                                }
                            }
                        });
                    }

                    $scope.segmentData = $scope.segmentData.concat(res.data.Results);
                }).catch(function () {
                    $scope.searching = false;
                });
            } else {
                $scope.segmentData = $rootScope.segmentData;
            }
        };

        //Cancel Button
        $scope.cancel = function () {
            resetNode();

            var node = _.find($rootScope.connections, function (conn) {
                return conn.id === $scope.connections.id;
            });

            if (!node) {
                // Execute listener when user cancel the if/else node
                $rootScope.$broadcast('deleteIfElseNode' + $scope.connections.id);
            }
        };

        $scope.save = function () {
            var conditionsGroup = $scope.connections.data.conditionGroups;
            for (var grp = 0; grp < conditionsGroup.length; grp++) {
                for (var con = 0; con < conditionsGroup[grp].length; con++) {
                    $scope.connections.data.conditionGroups[grp][con].hasError = false;
                }
            }
            $rootScope.$emit('saveConditionIfElse' + $scope.connections.id, $scope.connections);
        };
    };
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    'use strict';

    angular.module('dataHandlingConditionIsInList', ['ngAnimate', 'journey.canvas.srv', 'ngModalDragabble']).controller('conditionIsInListCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', conditionIsInListCtrl]);

    function conditionIsInListCtrl($scope, $rootScope, $timeout, canvasService, helpers) {
        $scope.displayIsInListConditionOptions = false;
        $scope.displayError = false;
        $scope.descriptionEmpty = false;
        $scope.createListName = {};
        $scope.search = {};

        $rootScope.$on('displayConditionIsInListModal', function (evt, conn, showTip) {
            var entry = document.getElementById(conn.id).getBoundingClientRect();

            $scope.top = entry.top;
            $scope.left = entry.left;
            $scope.entryTop = entry.top;
            $scope.contactListData = $rootScope.contactListData;
            $scope.showTip = showTip;
            $scope.modalPos = $scope.calculateModalPos($scope.top, $scope.left);
            $scope.displayIsInListConditionOptions = true;
            $scope.connections = angular.copy(conn);
            $scope.displayError = false;
            $scope.descriptionEmpty = false;
            $scope.selectedKey = $scope.translate('commons.selectList');

            $timeout(function () {
                $scope.setScrollLogic($scope.connections.id);
            }, 300);

            $scope.sortDataList();

            $(window).resize(function () {
                var entry = document.getElementById($scope.connections.id).getBoundingClientRect();
                $scope.$apply(function () {
                    $scope.top = entry.top;
                    $scope.left = entry.left;
                    $scope.calculateModalPos($scope.top, $scope.left);
                });
            });
        });

        $rootScope.$on('hideConditionIsInListModal', function () {
            $scope.displayError = false;
            $scope.displayIsInListConditionOptions = false;
        });

        $rootScope.$on('displayConditionIsInListModalError', function () {
            $scope.displayError = true;
        });

        $scope.sortDataList = function () {
            $scope.contactListData = $scope.contactListData.map(function (i) {
                if ($scope.connections.data.selectedList.indexOf(i.ListId) > -1) {
                    i.selectedItem = true;
                } else {
                    delete i.selectedItem;
                }

                return i;
            });

            Object.assign($scope.contactListData, _.orderBy($scope.contactListData, ['selectedItem'], ['asc']));
        };

        $scope.createListClick = function () {
            $scope.createList = true;
            $scope.createListName.name = '';
        };

        $scope.goCreateList = function () {
            if ($scope.createListName.name) {
                $scope.createListLoader = true;
                canvasService.createContactList($scope.createListName.name).success(function (_ref) {
                    var Results = _ref.Results;

                    $scope.createListLoader = false;
                    if (Results.length) {
                        var result = Results[0];
                        var listItem = {
                            ContactCount: 0,
                            ListId: result.ListId,
                            ListName: result.ListName
                        };
                        $scope.contactListData.unshift(listItem);
                        $rootScope.contactListData.unshift(listItem);
                        $scope.toggelListItem(result.ListId, 0);
                        $scope.createList = false;
                        $rootScope.$emit('errorMsg', $scope.translate('common.list.message'), 'confirmation');
                    } else {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.607'));
                    }
                }).error(function () {
                    $rootScope.$emit('errorMsg', $scope.translate('canvas.error.607'));
                    $scope.createListLoader = false;
                });
            }
        };

        $scope.goBackList = function () {
            $scope.createList = false;
        };

        $scope.calculateModalPos = function (top, left) {
            var currentTopPercent = top / window.innerHeight * 100;
            var currentLeftPercent = left / window.innerWidth * 100;
            var fixedHeight = 400;
            var fixedwidth = 450;

            if ($scope.modalWindow) {
                fixedwidth = 610;
                fixedHeight = 600;
            }

            if (left + 160 > window.innerWidth) {
                currentLeftPercent = 20;
                left = 0;
            }

            var topVal = currentTopPercent + _calculateTopByPos();

            $scope.modalTop = topVal < 0 ? '0%' : topVal.toFixed(0) + '%';
            $scope.modalLeft = (currentLeftPercent + _calculateLeftByPos()).toFixed(0) + '%';

            function _calculateTopByPos() {
                var totalTop = top + fixedHeight,
                    resTop = 0;

                if (totalTop > window.innerHeight) {
                    resTop = -38;
                    if ($scope.modalWindow) {
                        resTop = -55;
                    }
                }

                return resTop;
            }

            function _calculateLeftByPos() {
                var totalLeft = left + fixedwidth,
                    resLeft = 14;

                if ($scope.showTip) {
                    resLeft = 22;
                }

                if (totalLeft > window.innerWidth) {
                    resLeft = -20;
                    if ($scope.modalWindow) {
                        resLeft = -25;
                    }
                }

                return resLeft;
            }
        };

        $scope.cancel = function () {
            $scope.displayIsInListConditionOptions = false;

            var node = _.find($rootScope.connections, function (conn) {
                return conn.id === $scope.connections.id;
            });

            if (!node) {
                // Execute listener when user cancel the is in the list node
                $rootScope.$broadcast('deleteIsInListNode' + $scope.connections.id);
            }
        };

        $scope.save = function () {
            Intercom('trackEvent', 'AP - IsinList');
            $rootScope.$emit('saveConditionIsInListData' + $scope.connections.id, $scope.connections, $scope.descriptionEmpty);
        };

        //Toggle List Item to check if a checkbox is checked, If not we add it to the array of IDs, if not we delete it and just save the ones selected
        $scope.toggelListItem = function (listItem, $i) {
            if ($scope.connections.isDummy) {
                $scope.connections.data.selectedList = [];
                delete $scope.connections.isDummy;
            }

            var index = $scope.connections.data.selectedList.indexOf(listItem);
            if (index > -1) {
                $scope.connections.data.selectedList.splice(index, 1);
                delete $scope.contactListData[$i].selectedItem;
            } else {
                $scope.connections.data.selectedList.push(listItem);
                $scope.contactListData[$i].selectedItem = true;
            }

            Object.assign($scope.contactListData, _.orderBy($scope.contactListData, ['selectedItem'], ['asc']));

            if ($scope.connections.data.selectedList.length) {
                $scope.selectedKey = $scope.translate('commons.editSelection');
            } else {
                $scope.selectedKey = $scope.translate('commons.selectList');
            }
        };

        $scope.displayModal = function (evt) {
            var windowHeight = window.innerHeight * 0.50;
            //Bottom to top
            if (evt.clientY > windowHeight) {
                $(".poc-list").css("top", "-270px");
            } else {
                $(".poc-list").css("top", "");
            }
            $scope.modalWindow = true;
        };

        $scope.hideModal = function (clearList) {
            if (clearList) {
                $scope.selectedKey = $scope.translate('commons.selectList');
                $scope.connections.data.selectedList = [];
            }
            $scope.modalWindow = false;
            $scope.search.list = "";
            $scope.contactListData = $rootScope.contactListData;
        };

        $scope.parseDescription = function (desc, selected) {
            if (desc && (typeof desc === 'undefined' ? 'undefined' : _typeof(desc)) === 'object') {
                var descriptionCheck = false;
                for (var item in desc) {
                    if (desc[item]) {
                        $scope.descriptionEmpty = false;
                        descriptionCheck = true;
                        //Lists that are currently selected on the node
                        var totalLists = $scope.connections.data.selectedList.length;
                        desc = helpers.getContactListItem(desc[item], $scope.contactListData);

                        //One list selected and > 19
                        if (totalLists === 1 && desc.length > 19) {
                            desc = desc.slice(0, 19) + '...';
                            //More than one selected
                        } else if (totalLists > 1) {
                            desc = totalLists + $scope.translate('commons.selectedList');
                            //One selected but < 19
                        } else if (totalLists === 1 && desc.length < 19) {
                            desc = desc;
                        }
                        break;
                    }
                }
                if (!descriptionCheck) {
                    $scope.descriptionEmpty = true;

                    if (selected === 'showSelectedList') {
                        return '';
                    } else {
                        return $scope.translate('commons.enterDetails');
                    }
                }
            } else {
                $scope.descriptionEmpty = true;

                if (selected === 'showSelectedList') {
                    return '';
                } else {
                    return $scope.translate('commons.enterDetails');
                }
            }

            return desc;
        };

        $scope.setScrollLogic = function (id) {
            $scope.listLoader = false;
            angular.element(document.getElementById('contactListContainer' + id)).bind("scroll", function () {
                if (!$scope.listLoader && !$rootScope.stopLoadingList && !$scope.search.list) {
                    $scope.listLoader = true;
                    canvasService.getContactList($rootScope.contactListOffset, 10).success(function (data) {
                        if (!data.Results.length) {
                            $rootScope.stopLoadingList = true;
                        } else {
                            $rootScope.contactListOffset++;
                            $rootScope.contactListData = _.uniqBy($rootScope.contactListData.concat(data.Results), 'ListId');
                            $scope.contactListData = $rootScope.contactListData;
                            Object.assign($scope.contactListData, _.orderBy($scope.contactListData, ['selectedItem'], ['asc']));
                        }
                        $scope.listLoader = false;
                    }).error(function () {
                        $scope.listLoader = false;
                    });
                }
            });
        };

        $scope.searching = false;
        $scope.search.search = function (val) {
            if (val && val.length > 0 && !$scope.searching) {
                $scope.searching = true;
                canvasService.searchContactList(val).then(function (res) {
                    $scope.searching = false;
                    $rootScope.contactListData = _.uniqBy($rootScope.contactListData.concat(res.data.Results), 'ListId');
                    $scope.contactListData = [];
                    $scope.contactListData = $scope.contactListData.concat(res.data.Results);
                    $scope.sortDataList();
                }).catch(function () {
                    $scope.searching = false;
                });
            } else {
                $scope.contactListData = $rootScope.contactListData;
                $scope.sortDataList();
            }
        };
    };
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    'use strict';

    angular.module('dataHandlingIsInSegment', ['ngAnimate', 'journey.canvas.srv', 'ngModalDragabble']).controller('isInSegmentCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', isInSegmentCtrl]);

    function isInSegmentCtrl($scope, $rootScope, $timeout, canvasService, helpers) {
        $scope.displayInSegmentOptions = false;
        $scope.displayError = false;
        $scope.descriptionEmpty = false;
        $scope.search = {};

        $rootScope.$on('displayConditionIsInSegmentModal', function (evt, conn, showTip) {
            var entry = document.getElementById(conn.id).getBoundingClientRect();

            $scope.top = entry.top;
            $scope.left = entry.left;
            $scope.entryTop = entry.top;
            $scope.segmentData = $rootScope.segmentData;
            $scope.showTip = showTip;
            $scope.modalPos = $scope.calculateModalPos($scope.top, $scope.left);
            $scope.displayInSegmentOptions = true;
            $scope.connections = angular.copy(conn);
            $scope.displayError = false;
            $scope.descriptionEmpty = false;
            $scope.selectedKey = $scope.translate('canvas.condition.isInSegment.selectSegment');

            $timeout(function () {
                $scope.setScrollLogic($scope.connections.id);
            }, 300);

            $(window).resize(function () {
                var entry = document.getElementById($scope.connections.id).getBoundingClientRect();
                $scope.$apply(function () {
                    $scope.top = entry.top;
                    $scope.left = entry.left;
                    $scope.calculateModalPos($scope.top, $scope.left);
                });
            });
        });

        $rootScope.$on('hideConditionIsInSegmentModal', function () {
            $scope.displayError = false;
            $scope.displayInSegmentOptions = false;
        });

        $rootScope.$on('displayConditionIsInSegmentModalError', function () {
            $scope.displayError = true;
        });

        $scope.calculateModalPos = function (top, left) {
            var currentTopPercent = top / window.innerHeight * 100;
            var currentLeftPercent = left / window.innerWidth * 100;
            var fixedHeight = 400;
            var fixedwidth = 450;

            if ($scope.modalWindow) {
                fixedwidth = 610;
                fixedHeight = 600;
            }

            if (left + 160 > window.innerWidth) {
                currentLeftPercent = 20;
                left = 0;
            }

            var topVal = currentTopPercent + _calculateTopByPos();

            $scope.modalTop = topVal < 0 ? '0%' : topVal.toFixed(0) + '%';
            $scope.modalLeft = (currentLeftPercent + _calculateLeftByPos()).toFixed(0) + '%';

            function _calculateTopByPos() {
                var totalTop = top + fixedHeight,
                    resTop = 0;

                if (totalTop > window.innerHeight) {
                    resTop = -38;
                    if ($scope.modalWindow) {
                        resTop = -55;
                    }
                }

                return resTop;
            }

            function _calculateLeftByPos() {
                var totalLeft = left + fixedwidth,
                    resLeft = 14;

                if ($scope.showTip) {
                    resLeft = 22;
                }

                if (totalLeft > window.innerWidth) {
                    resLeft = -20;
                    if ($scope.modalWindow) {
                        resLeft = -25;
                    }
                }

                return resLeft;
            }
        };

        $scope.cancel = function () {
            $scope.displayInSegmentOptions = false;

            var node = _.find($rootScope.connections, function (conn) {
                return conn.id === $scope.connections.id;
            });

            if (!node) {
                // Execute listener when user cancel the is in segment node
                $rootScope.$broadcast('deleteIsInSegmentNode' + $scope.connections.id);
            }
        };

        $scope.save = function () {
            Intercom('trackEvent', 'AP - IsinSegment');
            $rootScope.$emit('saveConditionIsInSegmentData' + $scope.connections.id, $scope.connections, $scope.descriptionEmpty);
        };

        //Toggle List Item to check if a checkbox is checked, If not we add it to the array of IDs, if not we delete it and just save the ones selected
        $scope.toggelListItem = function (listItem) {
            if ($scope.connections.isDummy) {
                $scope.connections.data.selectedList = [];
                delete $scope.connections.isDummy;
            }

            $scope.connections.data.selectedList = [];
            $scope.connections.data.selectedList.push(listItem);

            if ($scope.connections.data.selectedList.length) {
                $scope.selectedKey = $scope.translate('commons.editSelection');
            } else {
                $scope.selectedKey = $scope.translate('canvas.condition.isInSegment.selectSegment');
            }
        };

        $scope.displayModal = function (evt) {
            var windowHeight = window.innerHeight * 0.50;
            //Bottom to top
            if (evt.clientY > windowHeight) {
                $(".poc-list").css("top", "-135px");
            } else {
                $(".poc-list").css("top", "");
            }
            $scope.modalWindow = true;
            $scope.segmentData = $rootScope.segmentData;
        };

        $scope.hideModal = function (clearList) {
            if (clearList) {
                $scope.selectedKey = $scope.translate('canvas.condition.isInSegment.selectSegment');
                $scope.connections.data.selectedList = [];
            }
            $scope.modalWindow = false;
            $scope.search.list = "";
            $scope.segmentData = $rootScope.segmentData;
        };

        $scope.decodeHtml = function (html) {
            var txt = document.createElement("textarea");
            txt.innerHTML = html;
            return txt.value;
        };

        $scope.parseDescription = function (desc, selected) {
            if (desc && (typeof desc === 'undefined' ? 'undefined' : _typeof(desc)) === 'object') {
                var descriptionCheck = false;
                for (var item in desc) {
                    if (desc[item]) {
                        $scope.descriptionEmpty = false;
                        descriptionCheck = true;
                        //Lists that are currently selected on the node
                        var totalLists = $scope.connections.data.selectedList.length;
                        desc = $scope.decodeHtml(helpers.getContactListItem(desc[item], $scope.ListName, $scope.segmentData));

                        //One list selected and > 19
                        if (totalLists === 1 && desc.length > 19) {
                            desc = desc.slice(0, 19) + '...';
                            //More than one selected
                        } else if (totalLists > 1) {
                            desc = totalLists + " Segment Selected";
                            //One selected but < 19
                        } else if (totalLists === 1 && desc.length < 19) {
                            desc = desc;
                        }
                        break;
                    }
                }
                if (!descriptionCheck) {
                    $scope.descriptionEmpty = true;

                    if (selected === 'showSelectedList') {
                        return '';
                    } else {
                        return $scope.translate('commons.enterDetails');
                    }
                }
            } else {
                $scope.descriptionEmpty = true;

                if (selected === 'showSelectedList') {
                    return '';
                } else {
                    return $scope.translate('commons.enterDetails');
                }
            }

            return desc;
        };

        $scope.setScrollLogic = function (id) {
            $scope.listLoader = false;
            angular.element(document.getElementById('contactSegmentContainer' + id)).bind("scroll", function () {
                if (!$scope.listLoader && !$rootScope.stopLoadingList && !$scope.search.list) {
                    $scope.listLoader = true;
                    canvasService.getSegments($rootScope.segmentListOffset, 10).success(function (data) {
                        if (!data.Results.length) {
                            $rootScope.stopLoadingList = true;
                        } else {
                            $rootScope.segmentListOffset++;
                            $rootScope.segmentData = _.uniqBy($rootScope.segmentData.concat(data.Results), 'SegmentId');
                            $scope.segmentData = $rootScope.segmentData;
                        }
                        $scope.listLoader = false;
                    }).error(function () {
                        $scope.listLoader = false;
                    });
                }
            });
        };

        $scope.searching = false;
        $scope.search.search = function (val) {
            if (val && val.length > 0 && !$scope.searching) {
                $scope.searching = true;
                canvasService.searchContactSegment(val).then(function (res) {
                    $scope.searching = false;
                    $rootScope.segmentData = _.uniqBy($rootScope.segmentData.concat(res.data.Results), 'ListId');
                    $scope.segmentData = [];
                    if ($scope.connections.data.selectedList && $scope.connections.data.selectedList.length) {
                        $scope.connections.data.selectedList.forEach(function (item) {
                            for (var i = 0; i < $rootScope.segmentData.length; i++) {
                                if ($rootScope.segmentData[i].ListId === item) {
                                    $scope.segmentData.push($rootScope.segmentData[i]);
                                    break;
                                }
                            }
                        });
                    }

                    $scope.segmentData = $scope.segmentData.concat(res.data.Results);
                }).catch(function () {
                    $scope.searching = false;
                });
            } else {
                $scope.segmentData = $rootScope.segmentData;
            }
        };
    };
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    'use strict';

    angular.module('dataHandlingIsNotInSegment', ['ngAnimate', 'journey.canvas.srv', 'ngModalDragabble']).controller('isNotInSegmentCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', isNotInSegmentCtrl]);

    function isNotInSegmentCtrl($scope, $rootScope, $timeout, canvasService, helpers) {
        $scope.displayNotInListOptions = false;
        $scope.displayError = false;
        $scope.descriptionEmpty = false;
        $scope.search = {};

        $rootScope.$on('displayConditionIsNotInSegmentModal', function (evt, conn, showTip) {
            var entry = document.getElementById(conn.id).getBoundingClientRect();

            $scope.top = entry.top;
            $scope.left = entry.left;
            $scope.entryTop = entry.top;
            $scope.segmentData = $rootScope.segmentData;
            $scope.showTip = showTip;
            $scope.modalPos = $scope.calculateModalPos($scope.top, $scope.left);
            $scope.displayNotInListOptions = true;
            $scope.connections = angular.copy(conn);
            $scope.displayError = false;
            $scope.descriptionEmpty = false;
            $scope.selectedKey = $scope.translate('canvas.condition.isInSegment.selectSegment');

            $timeout(function () {
                $scope.setScrollLogic($scope.connections.id);
            }, 300);

            $(window).resize(function () {
                var entry = document.getElementById($scope.connections.id).getBoundingClientRect();
                $scope.$apply(function () {
                    $scope.top = entry.top;
                    $scope.left = entry.left;
                    $scope.calculateModalPos($scope.top, $scope.left);
                });
            });
        });

        $rootScope.$on('hideConditionIsNotInSegmentModal', function () {
            $scope.displayError = false;
            $scope.displayNotInListOptions = false;
        });

        $rootScope.$on('displayConditionIsNotInSegmentModalError', function () {
            $scope.displayError = true;
        });

        $scope.calculateModalPos = function (top, left) {
            var currentTopPercent = top / window.innerHeight * 100;
            var currentLeftPercent = left / window.innerWidth * 100;
            var fixedHeight = 400;
            var fixedwidth = 450;

            if ($scope.modalWindow) {
                fixedwidth = 610;
                fixedHeight = 600;
            }

            if (left + 160 > window.innerWidth) {
                currentLeftPercent = 20;
                left = 0;
            }

            var topVal = currentTopPercent + _calculateTopByPos();

            $scope.modalTop = topVal < 0 ? '0%' : topVal.toFixed(0) + '%';
            $scope.modalLeft = (currentLeftPercent + _calculateLeftByPos()).toFixed(0) + '%';

            function _calculateTopByPos() {
                var totalTop = top + fixedHeight,
                    resTop = 0;

                if (totalTop > window.innerHeight) {
                    resTop = -38;
                    if ($scope.modalWindow) {
                        resTop = -55;
                    }
                }

                return resTop;
            }

            function _calculateLeftByPos() {
                var totalLeft = left + fixedwidth,
                    resLeft = 14;

                if ($scope.showTip) {
                    resLeft = 22;
                }

                if (totalLeft > window.innerWidth) {
                    resLeft = -20;
                    if ($scope.modalWindow) {
                        resLeft = -25;
                    }
                }

                return resLeft;
            }
        };

        $scope.cancel = function () {
            $scope.displayNotInListOptions = false;

            var node = _.find($rootScope.connections, function (conn) {
                return conn.id === $scope.connections.id;
            });

            if (!node) {
                // Execute listener when user cancel the is not in segment node
                $rootScope.$broadcast('deleteIsNotInSegmentNode' + $scope.connections.id);
            }
        };

        $scope.save = function () {
            Intercom('trackEvent', 'AP - IsnotinSegment');
            $rootScope.$emit('saveConditionIsNotInSegmentData' + $scope.connections.id, $scope.connections, $scope.descriptionEmpty);
        };

        //Toggle List Item to check if a checkbox is checked, If not we add it to the array of IDs, if not we delete it and just save the ones selected
        $scope.toggelListItem = function (listItem) {
            if ($scope.connections.isDummy) {
                $scope.connections.data.selectedList = [];
                delete $scope.connections.isDummy;
            }

            $scope.connections.data.selectedList = [];
            $scope.connections.data.selectedList.push(listItem);

            if ($scope.connections.data.selectedList.length) {
                $scope.selectedKey = $scope.translate('commons.editSelection');
            } else {
                $scope.selectedKey = $scope.translate('canvas.condition.isInSegment.selectSegment');
            }
        };

        $scope.displayModal = function (evt) {
            var windowHeight = window.innerHeight * 0.50;
            //Bottom to top
            if (evt.clientY > windowHeight) {
                $(".poc-list").css("top", "-135px");
            } else {
                $(".poc-list").css("top", "");
            }
            $scope.modalWindow = true;
            $scope.segmentData = $rootScope.segmentData;
        };

        $scope.hideModal = function (clearList) {
            if (clearList) {
                $scope.selectedKey = $scope.translate('canvas.condition.isInSegment.selectSegment');
                $scope.connections.data.selectedList = [];
            }
            $scope.modalWindow = false;
            $scope.search.list = "";
            $scope.segmentData = $rootScope.segmentData;
        };

        $scope.decodeHtml = function (html) {
            var txt = document.createElement("textarea");
            txt.innerHTML = html;
            return txt.value;
        };

        $scope.parseDescription = function (desc, selected) {
            if (desc && (typeof desc === 'undefined' ? 'undefined' : _typeof(desc)) === 'object') {
                var descriptionCheck = false;
                for (var item in desc) {
                    if (desc[item]) {
                        $scope.descriptionEmpty = false;
                        descriptionCheck = true;
                        //Lists that are currently selected on the node
                        var totalLists = $scope.connections.data.selectedList.length;
                        desc = $scope.decodeHtml(helpers.getContactListItem(desc[item], $scope.ListName, $scope.segmentData));

                        //One list selected and > 19
                        if (totalLists === 1 && desc.length > 19) {
                            desc = desc.slice(0, 19) + '...';
                            //More than one selected
                        } else if (totalLists > 1) {
                            desc = totalLists + " Segment Selected";
                            //One selected but < 19
                        } else if (totalLists === 1 && desc.length < 19) {
                            desc = desc;
                        }
                        break;
                    }
                }
                if (!descriptionCheck) {
                    $scope.descriptionEmpty = true;

                    if (selected === 'showSelectedList') {
                        return '';
                    } else {
                        return $scope.translate('commons.enterDetails');
                    }
                }
            } else {
                $scope.descriptionEmpty = true;

                if (selected === 'showSelectedList') {
                    return '';
                } else {
                    return $scope.translate('commons.enterDetails');
                }
            }

            return desc;
        };

        $scope.setScrollLogic = function (id) {
            $scope.listLoader = false;
            angular.element(document.getElementById('contactSegmentContainer' + id)).bind("scroll", function () {
                if (!$scope.listLoader && !$rootScope.stopLoadingList && !$scope.search.list) {
                    $scope.listLoader = true;
                    canvasService.getSegments($rootScope.segmentListOffset, 10).success(function (data) {
                        if (!data.Results.length) {
                            $rootScope.stopLoadingList = true;
                        } else {
                            $rootScope.segmentListOffset++;
                            $rootScope.segmentData = _.uniqBy($rootScope.segmentData.concat(data.Results), 'SegmentId');
                            $scope.segmentData = $rootScope.segmentData;
                        }
                        $scope.listLoader = false;
                    }).error(function () {
                        $scope.listLoader = false;
                    });
                }
            });
        };

        $scope.searching = false;
        $scope.search.search = function (val) {
            if (val && val.length > 0 && !$scope.searching) {
                $scope.searching = true;
                canvasService.searchContactSegment(val).then(function (res) {
                    $scope.searching = false;
                    $rootScope.segmentData = _.uniqBy($rootScope.segmentData.concat(res.data.Results), 'ListId');
                    $scope.segmentData = [];
                    if ($scope.connections.data.selectedList && $scope.connections.data.selectedList.length) {
                        $scope.connections.data.selectedList.forEach(function (item) {
                            for (var i = 0; i < $rootScope.segmentData.length; i++) {
                                if ($rootScope.segmentData[i].ListId === item) {
                                    $scope.segmentData.push($rootScope.segmentData[i]);
                                    break;
                                }
                            }
                        });
                    }

                    $scope.segmentData = $scope.segmentData.concat(res.data.Results);
                }).catch(function () {
                    $scope.searching = false;
                });
            } else {
                $scope.segmentData = $rootScope.segmentData;
            }
        };
    };
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    'use strict';

    angular.module('dataHandlingConditionWebsiteActivity', ['ngAnimate', 'journey.canvas.srv']).controller('conditionWebsiteActivityCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', '$interval', conditionWebsiteActivityCtrl]);

    function conditionWebsiteActivityCtrl($scope, $rootScope, $timeout, canvasService, helpers, $interval) {
        $scope.displayWebsiteActivityConditionOptions = false;
        $scope.errorUrl = false;
        $scope.displayForm = true;

        function resetNode() {
            $scope.trackingTestState = $scope.translate('canvas.entry.websiteEngagement.url.test');
            $scope.trackingTestClass = '';
            $scope.displayWebsiteActivityConditionOptions = false;
            $scope.errorUrl = false;
        }

        $scope.specificUrlOptions = [{
            value: 'any-tracked-page',
            message: $scope.translate('canvas.entry.websiteEngagement.anyTracked')
        }, {
            value: 'is-url',
            message: $scope.translate('canvas.entry.websiteEngagement.specificUrl')
        }, {
            value: 'contains-url',
            message: $scope.translate('canvas.entry.websiteEngagement.containsUrl')
        }, {
            value: 'doesnotcontain-url',
            message: $scope.translate('canvas.entry.websiteEngagement.not.containsUrl')
        }, {
            value: 'startswith-url',
            message: $scope.translate('canvas.entry.websiteEngagement.starts.with.url')
        }, {
            value: 'endswith-url',
            message: $scope.translate('canvas.entry.websiteEngagement.ends.with.url')
        }, {
            value: 'wildcardmatch-url',
            message: $scope.translate('canvas.entry.websiteEngagement.wildcard.url')
        }];

        $rootScope.$on('displayConditionWebsiteActivityModal', function (evt, conn, showTip) {
            var entry = document.getElementById(conn.id).getBoundingClientRect();

            $scope.top = entry.top;
            $scope.left = entry.left;
            $scope.entryTop = entry.top;

            $scope.displayWebsiteActivityConditionOptions = false;
            $scope.errorUrl = false;
            $scope.displayForm = true;

            $scope.trackingTestState = $scope.translate('canvas.entry.websiteEngagement.url.test');

            $scope.showTip = showTip;

            $scope.trackingTestClass = '';
            $scope.modalPos = $scope.calculateModalPos($scope.top, $scope.left);
            $scope.displayWebsiteActivityConditionOptions = true;

            $scope.connections = angular.copy(conn);

            $(window).resize(function () {
                var entry = document.getElementById($scope.connections.id).getBoundingClientRect();
                $scope.$apply(function () {
                    $scope.top = entry.top;
                    $scope.left = entry.left;
                    $scope.calculateModalPos($scope.top, $scope.left);
                });
            });
        });

        $rootScope.$on('hideConditionWebsiteActivityModal', function () {
            resetNode();
        });

        $rootScope.$on('displayConditionWebsiteActivityModalError', function () {
            $scope.errorUrl = true;
        });

        $scope.calculateModalPos = function (top, left) {
            var currentTopPercent = top / window.innerHeight * 100;
            var currentLeftPercent = left / window.innerWidth * 100;
            var fixedHeight = 400;
            var fixedwidth = 450;

            if (left + 160 > window.innerWidth) {
                currentLeftPercent = 20;
                left = 0;
            }

            $scope.modalTop = (currentTopPercent + _calculateTopByPos()).toFixed(0) + '%';
            $scope.modalLeft = (currentLeftPercent + _calculateLeftByPos()).toFixed(0) + '%';

            function _calculateTopByPos() {
                var totalTop = top + fixedHeight,
                    resTop = 0;

                if (totalTop > window.innerHeight) {
                    resTop = -38;
                }

                return resTop;
            }

            function _calculateLeftByPos() {
                var totalLeft = left + fixedwidth,
                    resLeft = 14;

                if ($scope.showTip) {
                    resLeft = 22;
                }

                if (totalLeft > window.innerWidth) {
                    resLeft = -20;
                }

                return resLeft;
            }
        };

        $scope.displayTrackerModal = function () {
            $rootScope.$emit('displayTrackerModal');
        };

        $scope.parseDescription = function (desc, specificUrl) {
            if (!$scope.connections) return;

            if (specificUrl) {
                if (!$scope.connections.data) return;

                if (desc) {
                    var arrLen = desc.split("");
                    arrLen = arrLen.length;
                    if (arrLen > 20) {
                        return desc.slice(0, 22) + '...';
                    } else {
                        return desc;
                    }
                } else if ($scope.connections.data.source === 'contains-url') {
                    return $scope.translate('canvas.entry.websiteEngagement.containsUrl');
                } else {
                    return $scope.translate('canvas.condition.websiteActivity.specificUrl');
                }
            } else {
                if (desc) {
                    desc = $scope.translate('canvas.condition.websiteActivity.anyTracked');
                } else {
                    return $scope.translate('commons.enterDetails');
                }
                return desc;
            }
        };

        var stop = void 0,
            intents = 0;
        $scope.testUrl = function () {
            if ($scope.connections.data.specificUrl) {
                $scope.trackingTestState = $scope.translate('canvas.entry.websiteEngagement.url.checking');
                $scope.trackingTestClass = 'checking-url';
                var testUrl = $scope.connections.data.specificUrl + '?apTestApi=true&url=' + encodeURIComponent($scope.connections.data.specificUrl);
                if (/^http:\/\//i.test(testUrl)) {
                    window.open(testUrl, '_blank');
                } else {
                    document.getElementsByName('testSiteIFrame')[0].onerror = function () {
                        window.open(testUrl, '_blank');
                    };

                    document.getElementsByName('testSiteIFrame')[0].src = testUrl;
                }
                stop = $interval(function () {
                    canvasService.testTracker($scope.connections.data.specificUrl).then(function (result) {
                        if (result.data.TestTrackerInformation.IsInstalled) {
                            $interval.cancel(stop);
                            $scope.trackingTestState = $scope.translate('canvas.entry.websiteEngagement.url.confirm');
                            $scope.trackingTestClass = 'url-confirm';
                            intents = 0;
                        } else if (intents >= 4) {
                            $scope.trackingTestState = $scope.translate('canvas.entry.websiteEngagement.url.notDetected');
                            $scope.trackingTestClass = 'url-fail';
                            $interval.cancel(stop);
                            intents = 0;
                        }
                        intents++;
                    }).catch(function () {
                        $scope.trackingTestState = $scope.translate('canvas.entry.websiteEngagement.url.notDetected');
                        $scope.trackingTestClass = 'url-fail';
                        $interval.cancel(stop);
                        intents = 0;
                    });
                }, 2000);
            } else {
                $scope.$emit('errorMsg', $scope.translate('canvas.entry.websiteEngagement.url.error'), 'error');
            }
        };

        $scope.$watch('connections.data.specificUrl', function (url) {
            if (url && ($scope.connections.data.source === 'is-url' || $scope.connections.data.source === 'wildcardmatch-url')) {
                var reg;

                if ($scope.connections.data.source === 'is-url') {
                    reg = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
                } else {
                    reg = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+\/\*$/;
                }

                if (!reg.test(url)) {
                    $scope.$parent.specificUrlError = true;
                } else {
                    $scope.$parent.specificUrlError = false;
                }
            }
        });

        $scope.$watch('connections.data.source', function (old, newVal) {
            if (newVal === 'any-tracked-page') {
                $scope.connections.data.specificUrl = '';
                $scope.append = false;
            }

            if (old != newVal) {
                $scope.errorUrl = false;
                $scope.append = false;
            }
        });

        //Cancel Button
        $scope.cancel = function () {
            resetNode();

            var node = _.find($rootScope.connections, function (conn) {
                return conn.id === $scope.connections.id;
            });

            if (!node) {
                // Execute listener when user cancel the web site activity node
                $rootScope.$broadcast('deleteWebSiteActivityNode' + $scope.connections.id);
            }
        };

        $scope.save = function () {
            Intercom('trackEvent', 'AP - WebsiteActivity');
            $rootScope.$emit('saveConditionWebsiteActivityData' + $scope.connections.id, $scope.connections, $scope.errorUrl);
        };
    };
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    angular.module('faqModule', ['ngAnimate', 'journey.canvas.srv']).controller('faqCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', '$sce', '$templateCache', '$compile', function ($scope, $rootScope, $timeout, canvasService, helpers, $sce, $templateCache, $compile) {

        $rootScope.$watch('translate', function (func) {
            if (func) {
                $scope.translate = func;
            }
        });

        $scope.cLang = helpers.readCookie('L') || 'english';

        $rootScope.$on('displayFAQ', function (evt, faqViewName) {
            $scope.faq = true;

            //If there link is coming from Empty listing home page. We dipslay overview section
            if (faqViewName) {
                $scope.faqContent(faqViewName);
            };

            $rootScope.$emit('setBodyOverflow');
        });

        $scope.trustSrc = function (src) {
            return $sce.trustAsResourceUrl(src);
        };

        $scope.faqContent = function (view) {
            var url = {
                english: {
                    overview: 'https://kb.benchmarkemail.com/what-is-automation-pro/',
                    strategy: 'https://kb.benchmarkemail.com/does-automation-pro-have-templates/',
                    basics: 'https://kb.benchmarkemail.com/how-to-use-the-canvas-in-automation-pro/',
                    tracking: 'https://kb.benchmarkemail.com/?s=Website+Engagement',
                    active: 'https://kb.benchmarkemail.com/?s=active+automation',
                    reports: 'https://kb.benchmarkemail.com/how-to-access-reports-in-automation-pro/'
                },
                spanish: {
                    overview: 'https://kb.benchmarkemail.com/es/what-is-automation-pro/',
                    strategy: 'https://kb.benchmarkemail.com/es/tiene-plantillas-automatizaciones-pro/',
                    basics: 'https://kb.benchmarkemail.com/es/como-usar-el-canvas-de-automatizaciones-pro/',
                    tracking: 'https://kb.benchmarkemail.com/es/?s=website+tracking',
                    active: 'https://kb.benchmarkemail.com/es/puedo-actualizar-o-cambiar-un-email-dentro-de-una-automatizacion-activa/',
                    reports: 'https://kb.benchmarkemail.com/es/con-acceder-a-los-informes-en-automatizaciones-pro/'
                },
                italian: {
                    overview: 'https://kb.benchmarkemail.com/it/che-cose-automazioni-pro/',
                    strategy: 'https://kb.benchmarkemail.com/it/ci-sono-dei-template-in-automazioni-pro/',
                    basics: 'https://kb.benchmarkemail.com/it/come-posso-usare-il-canvas-in-automazioni-pro/',
                    tracking: 'https://kb.benchmarkemail.com/it/?s=website+attivita',
                    active: 'https://kb.benchmarkemail.com/it/posso-modificare-o-cambiare-une-mail-in-unautomazione-attiva/',
                    reports: 'https://kb.benchmarkemail.com/it/come-posso-accedere-ai-reports-di-automazioni-pro/'
                },
                brazil: {
                    overview: 'https://kb.benchmarkemail.com/br/o-que-e-o-automation-pro/',
                    strategy: 'https://kb.benchmarkemail.com/br/o-automation-pro-possui-templates/',
                    basics: 'https://kb.benchmarkemail.com/br/how-to-use-the-canvas-in-automation-pro/',
                    tracking: 'https://kb.benchmarkemail.com/br/?s=website+engajamento',
                    active: 'https://kb.benchmarkemail.com/br/posso-atualizar-ou-alterar-um-email-dentro-de-uma-automacao-ativa/',
                    reports: 'https://kb.benchmarkemail.com/br/como-acessar-os-relatorios-no-automation-pro/'
                },
                japanese: {
                    overview: 'https://kb.benchmarkemail.com/jp/what-is-automation-pro/',
                    strategy: 'https://kb.benchmarkemail.com/jp/does-automation-pro-have-templates/',
                    basics: 'https://kb.benchmarkemail.com/jp/how-to-use-the-canvas-in-automation-pro/',
                    tracking: 'https://kb.benchmarkemail.com/jp/how-to-use-website-engagement-or-website-activity/',
                    active: 'https://kb.benchmarkemail.com/jp/can-i-update-or-change-an-email-in-an-active-automation/',
                    reports: 'https://kb.benchmarkemail.com/jp/how-to-access-reports-in-automation-pro/'
                },
                chinese: {
                    overview: 'https://kb.benchmarkemail.com/cn/what-is-automation-pro/',
                    strategy: 'https://kb.benchmarkemail.com/cn/does-automation-pro-have-templates/',
                    basics: 'https://kb.benchmarkemail.com/cn/how-to-use-the-canvas-in-automation-pro/',
                    tracking: 'https://kb.benchmarkemail.com/cn/?s=如何追踪网站活动',
                    active: 'https://kb.benchmarkemail.com/tw/can-i-update-or-change-an-email-in-an-active-automation/',
                    reports: 'https://kb.benchmarkemail.com/cn/how-to-access-reports-in-automation-pro/'
                },
                chineset: {
                    overview: 'https://kb.benchmarkemail.com/tw/what-is-automation-pro/',
                    strategy: 'https://kb.benchmarkemail.com/tw/does-automation-pro-have-templates/',
                    basics: 'https://kb.benchmarkemail.com/tw/how-to-use-the-canvas-in-automation-pro/',
                    tracking: 'https://kb.benchmarkemail.com/tw/?s=如何追蹤網站活動',
                    active: 'https://kb.benchmarkemail.com/tw/can-i-update-or-change-an-email-in-an-active-automation/',
                    reports: 'https://kb.benchmarkemail.com/tw/how-to-access-reports-in-automation-pro/'
                },
                french: {
                    overview: 'https://kb.benchmarkemail.com/fr/qu-est-ce-qu-automatisation-pro/',
                    strategy: 'https://kb.benchmarkemail.com/fr/est-ce-que-automatisation-pro-a-des-templates/',
                    basics: 'https://kb.benchmarkemail.com/fr/comment-utilser-automatisation-pro/',
                    tracking: 'https://kb.benchmarkemail.com/fr/?s=website+activite',
                    active: 'https://kb.benchmarkemail.com/fr/est-ce-possible-de-modifier-ou-actualiser-un-email-actif-dans-une-automatisation/',
                    reports: 'https://kb.benchmarkemail.com/fr/comment-acceder-aux-rapports-d-automatisation-pro/'
                },
                german: {
                    overview: 'https://kb.benchmarkemail.com/de/was-ist-die-profi-automatisierung/',
                    strategy: 'https://kb.benchmarkemail.com/de/gibt-es-auch-vorlagen-fur-die-profi-automatisierung/',
                    basics: 'https://kb.benchmarkemail.com/de/wie-nutze-ich-die-ubersicht-bei-der-profi-automatisierung/',
                    tracking: 'https://kb.benchmarkemail.com/de/?s=website+interagieren',
                    active: 'https://kb.benchmarkemail.com/de/kann-ich-eine-e-mail-in-einer-aktiven-automatisierung-andern-oder-ersetzen/',
                    reports: 'https://kb.benchmarkemail.com/de/wie-kann-man-die-berichte-der-profi-automatisierung-einsehen/'
                }
            };

            window.open(url[$scope.cLang || 'english'][view], '_blank');
        };

        $scope.closeFaq = function () {
            $scope.faq = false;
            $rootScope.$emit('removeBodyOverflow');
        };
    }]);
})();

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (angular) {
    __webpack_require__(171);
    __webpack_require__(173);
    __webpack_require__(172);
    __webpack_require__(174);
    __webpack_require__(175);
    __webpack_require__(176);
    __webpack_require__(179);
    __webpack_require__(181);
    __webpack_require__(180);
    __webpack_require__(182);
    __webpack_require__(178);
    __webpack_require__(177);
    __webpack_require__(183);
    __webpack_require__(185);
    __webpack_require__(186);
    __webpack_require__(187);
}();

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    angular.module('summaryModule', ['ngAnimate', 'journey.canvas.srv']).controller('summaryCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', '$sce', '$templateCache', '$compile', function ($scope, $rootScope, $timeout, canvasService, helpers, $sce, $templateCache, $compile) {
        $scope.mainView = true;
        $scope.innerView = false;
        $scope.innerView2 = false;
        $scope.summary = false;
        $scope.summaryData = {};
        $scope.summaryAllData = {};

        $rootScope.$watch('translate', function (func) {
            if (func) {
                $scope.translate = func;
            }
        });

        $rootScope.$on('setBodyOverflow', function () {
            $scope.overflowHidden = true;
        });

        $rootScope.$on('summary', function (e, display, id, title, emailName, days, hideClose, nodeMetricFlag, nodeReportInfo) {
            //Node Metrics
            $scope.currentId = id;
            $scope.nodeReportInfo = nodeReportInfo || [];
            $scope.contactsToRender = [];
            $scope.loadingContacts = true;
            $scope.nodeMetricFlag = nodeMetricFlag;
            $scope.currentMetricType = nodeReportInfo && nodeReportInfo.length && nodeReportInfo[1].MetricTypeSummaries.length ? nodeReportInfo[1].MetricTypeSummaries[0].MetricType : '';
            $scope.currentCount = 0;
            $scope.minBigCount = 150000;

            //Reset pagination
            $scope.metricsPagination.currentPage = 0;
            $scope.metricsPagination.pageSize = '10';
            $scope.metricsPagination.pages = 0;

            //Reset search
            $scope.metricsSearch.value = '', $scope.metricsSearch.isActive = false, $scope.metricsSearch.expanded = false, $scope.hideClose = hideClose;
            $scope.activeDays = $rootScope.activeDays || days;
            if (emailName) {
                $scope.mainView = false;
                $scope.innerView = true;
            } else {
                $scope.mainView = true;
                $scope.innerView = false;
                Intercom('trackEvent', 'AP - Summary');
            }

            if ($scope.currentMetricType) {
                $scope.currentCount = nodeReportInfo[1].MetricTypeSummaries.find(function (summary) {
                    return summary.MetricType === $scope.currentMetricType;
                }).Count;
            }

            $scope.emptyState = false;

            $scope.innerView2 = false;
            $scope.title = title;
            $scope.summary = display;
            $scope.loading = true;

            if ($scope.summaryAllData[id] && $scope.summaryAllData[id].Summary) {
                $scope.summaryData = $scope.summaryAllData[id];
                $scope.currentId = id;

                if (!$scope.summaryData.Summaries.length) {
                    $scope.emptyState = true;
                }

                if (emailName) {
                    var summaries = $scope.summaryData.Summaries.find(function (i) {
                        var find = i.Summaries.find(function (j) {
                            if (j.TemplateName == emailName) {
                                return true;
                            }
                        });
                        if (find) return i;
                    });
                    var summary = summaries ? summaries.Summaries.filter(function (i) {
                        if (i.TemplateName == emailName) {
                            return i;
                        }
                    }) : [];
                    $scope.goInner(summary[1] || summary[0], summaries);
                }

                $scope.loading = false;
            } else {
                canvasService.getAllSummaryReports(id).then(function (_ref) {
                    var data = _ref.data;

                    $scope.summaryAllData[id] = data.Result;
                    $scope.summaryData = $scope.summaryAllData[id];
                    $scope.currentId = id;

                    if (!$scope.summaryData.Summaries.length) {
                        $scope.emptyState = true;
                    }

                    if (emailName) {
                        var _summaries = $scope.summaryData.Summaries.find(function (i) {
                            var find = i.Summaries.find(function (j) {
                                if (j.TemplateName == emailName) {
                                    return true;
                                }
                            });
                            if (find) return i;
                        });
                        var _summary = _summaries && _summaries.Summaries.filter(function (i) {
                            if (i.TemplateName == emailName) {
                                return i;
                            }
                        }) || [];

                        $scope.goInner(_summary[1] || _summary[0], _summaries);
                    }

                    $scope.loading = false;
                });
            }

            if ($scope.nodeReportInfo.length && $scope.nodeReportInfo[1].MetricTypeSummaries.length) {
                $scope.showMetricNodeDetail($scope.nodeReportInfo[1].MetricTypeSummaries[0].MetricType);
            } else {
                $scope.loadingContacts = false;
            }

            $rootScope.$emit('setBodyOverflow');
        });

        $scope.close = function () {
            $scope.summary = false;
            $rootScope.$emit('removeBodyOverflow');
        };

        $scope.goInner = function (summary, summaries) {
            $scope.innerSummary = summary;
            $scope.innerVersions = summaries && summaries.Summaries;
            $scope.mainView = false;
            $scope.innerView2 = false;
            $scope.innerDetails = false;
            $scope.innerView = true;

            $scope.innerSummary && canvasService.getEmailDetails($scope.innerSummary.EmailId).then(function (_ref2) {
                var data = _ref2.data;
                $scope.eDetails = data;
            });
        };

        $scope.goBackInner = function () {
            $scope.mainView = false;
            $scope.innerView2 = false;
            $scope.innerDetails = false;
            $scope.pagination.pages = 0;
            $scope.innerView = true;
        };

        $scope.goBack = function () {
            $scope.innerView = false;
            $scope.innerView2 = false;
            $scope.innerDetails = false;
            $scope.mainView = true;
            Intercom('trackEvent', 'AP - Summary');
        };

        $scope.isMetricTypeAvailable = function (metricType) {
            var isMetricAvailable = $scope.nodeReportInfo[1].AvailableMetricTypes.some(function (availableMetricType) {
                return availableMetricType.MetricType === metricType;
            });
            return isMetricAvailable;
        };

        $scope.renderMetricType = function (metricType) {
            var metric = $scope.nodeReportInfo[1].AvailableMetricTypes.find(function (element) {
                return element.MetricType === metricType;
            }).Name;
            return metric;
        };

        $scope.showMetricNodeDetail = function (metricType) {
            $scope.currentMetricType = metricType;
            $scope.loadingContacts = true;
            $scope.contactsToRender = [];
            canvasService.getNodeMetricDetailsSummaryByType($scope.currentId, $scope.nodeReportInfo[0].NodeId, metricType, $scope.metricsPagination.currentPage, $scope.metricsPagination.pageSize, $scope.metricsSearch.value).then(function (res) {
                $scope.metricsPagination.pages = Math.ceil(parseInt(res.data.TotalCount) / parseInt($scope.metricsPagination.pageSize));
                $scope.contactsToRender = res.data.Contacts;
                $scope.loadingContacts = false;
            });
        };

        $scope.getNodeName = function () {
            switch ($scope.nodeReportInfo[0].NodeActionType) {
                case 4:
                    return 'canvas.action.addTolList.title';
                case 5:
                    return 'canvas.action.removeFromList.title';
                case 13:
                    return 'canvas.entry.websiteEngagement.title';
                case 20:
                    return 'canvas.entry.addedToList.title';
                case 21:
                    return 'canvas.entry.dateTime.title';
                case 27:
                    return 'canvas.entry.addedToSegment.title';
                default:
                    return 'commons.loadingMoreResults';
            }
        };

        $scope.goToView2 = function (type, shouldDisplaySecondView) {
            var sort = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'desc';
            var pageNum = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

            if (!shouldDisplaySecondView) {
                return false;
            }
            $scope.innerView2 = true;
            $scope.mainView = false;
            $scope.innerView = false;
            $scope.pagination.currentPage = pageNum;
            $scope.currentType = type;
            $scope.reportsTitle = $scope.getTitleByType(type);
            $scope.reportsOpt = type;
            $scope.innerViewData = [];
            $scope.clickPerformanceData = [];
            $scope.noRecords = false;
            $scope.content = true;

            if (type == 'Clicks') {
                canvasService.getReportByType($scope.innerSummary.EmailId, 'ClickPerformance').then(function (_ref3) {
                    var data = _ref3.data;

                    $scope.clickPerformanceData = data.Response.Data;
                    if (!$scope.clickPerformanceData.length) {
                        $scope.clickPerformanceNoRecords = true;
                    }
                });
            }
            canvasService.getReportByType($scope.innerSummary.EmailId, type, sort, pageNum, $scope.pagination.pageSize).then(function (_ref4) {
                var data = _ref4.data;

                $scope.reportsView = false;
                $scope.innerViewData = data.Response.Data;
                $scope.pagination.pages = Math.ceil(data.Response.Count / $scope.pagination.pageSize);

                if (!$scope.innerViewData.length) {
                    $scope.noRecords = true;
                }
            });
        };

        $scope.setSummary = function ($index) {
            $scope.innerSummary = $scope.innerVersions[$index];
            canvasService.getEmailDetails($scope.innerSummary.EmailId).then(function (_ref5) {
                var data = _ref5.data;
                $scope.eDetails = data;
            });
            canvasService.generateThumbs($scope.innerSummary.EmailId).then(function () {});
        };

        $scope.formatPercent = function (percent) {
            percent = percent * 100;
            if (isNaN(percent)) {
                return '0.00';
            }
            return percent.toFixed(2);
        };

        $scope.summaryView = {
            'sent': true,
            'opened': false,
            'clicks': false,
            'bounces': false,
            'unsubscribes': false
        };
        $scope.showSummaryView = function (view) {
            $scope.resetSummaryView();
            $scope.summaryView[view] = true;
        };

        $scope.resetSummaryView = function (view) {
            $scope.summaryView = {
                'sent': false,
                'opened': false,
                'clicks': false,
                'bounces': false,
                'unsubscribes': false
            };
        };

        $scope.saveStats = false;
        $scope.stats = {};
        $scope.stats.enums = {
            Unknow: 0,
            Open: 1,
            Unopen: 2,
            Clicked: 3,
            UnCliked: 4
        };

        $scope.showStats = function (type) {
            var processType = 1;

            if (type == 'Unopens') {
                processType = 2;
            }

            if (type == 'Clicks') {
                type = 'LinksClicked';
                processType = 3;
            }

            $scope.stats.payload = {};
            $scope.stats.payload.JourneyId = $scope.currentId;
            $scope.stats.payload.JourneyVersion = '1';
            $scope.stats.payload.NodeName = $scope.innerSummary.ElementId;
            $scope.stats.payload.ProcessType = processType;
            $scope.stats.payload.ProcessFromType = '1';
            $scope.saveStats = true;
            $scope.summary = false;
            $scope.statType = type;
        };

        $scope.saveStatsAsList = function () {
            if ($scope.stats.listName) {

                Intercom('trackEvent', 'AP - ' + $scope.statType + '-SaveList');
                $scope.inputError = false;
                $scope.duplicateError = false;
                $scope.stats.payload.ListName = $scope.stats.listName;

                // This value comes from the beginning of the file
                $scope.stats.payload.ListId = $scope.eDetails.ToListId;

                $scope.stats.payload.Version = $scope.summary.apVersion;

                canvasService.saveStatsAsLists(JSON.stringify($scope.stats.payload)).then(function (res) {
                    if (!res.data.ProcessAdded) {
                        $scope.inputError = true;
                        $scope.duplicateError = true;
                    } else {
                        $scope.cancelStats();
                        $rootScope.$emit('errorMsg', $scope.translate('common.list.message'), 'confirmation');
                    }
                }).catch(function () {
                    $scope.inputError = true;
                    $scope.duplicateError = false;
                    $scope.cancelStats();
                    $rootScope.$emit('errorMsg', 'Something went wrong, try again later.');
                });
            } else {
                $scope.inputError = true;
                $scope.duplicateError = false;
            }
        };

        $scope.cancelStats = function () {
            $scope.saveStats = false;
            $scope.summary = true;
            $scope.innerDetails = true;
            $scope.stats = {};
        };

        $scope.fields = {};
        $scope.pin = '';
        $scope.displayExport = function (reportType) {
            if (!$scope.hasPin || !$scope.fieldData || $scope.ReportType != reportType) {
                $scope.ReportType = reportType;
                canvasService.getDownloadInfo($scope.innerSummary.EmailId, reportType).then(function (_ref6) {
                    var data = _ref6.data;

                    var chunks = helpers.createChunks(data.Response.Data, 2);
                    chunks.forEach(function (field) {
                        if (field && field[0] && field[0].FieldName == 'email') {
                            $scope.fields[field[0].FieldName] = true;
                        } else if (field && field[0]) {
                            $scope.fields[field[0].FieldName] = false;
                        }

                        if (field && field[1] && field[1].FieldName == 'email') {
                            $scope.fields[field[1].FieldName] = true;
                        } else if (field && field[1]) {
                            $scope.fields[field[1].FieldName] = false;
                        }
                    });

                    $scope.fieldData = chunks;
                    $scope.hasPin = data.Response.HasPin == 1;
                });
            }

            $scope.displayExportView = true;
            $scope.summary = false;
        };

        $scope.hideExport = function () {
            $scope.reportsView = false;
            $scope.pinView = false;
            $scope.displayExportView = false;
            $scope.fields = {};
            $scope.checkAll = false;
            $scope.summary = true;
        };

        $scope.getTitleByType = function (type) {
            return {
                Opens: $scope.translate('reports.openedEmails'),
                Bounces: $scope.translate('reports.emailsBounced'),
                Unopens: $scope.translate('reports.unopened'),
                Clicks: $scope.translate('reports.linksClicked'),
                Unsubscribes: $scope.translate('reports.unsubscribes'),
                Abuse: $scope.translate('reports.complaints')
            }[type] || '';
        };

        $scope.sortReports = false;
        $scope.searchWithSort = function () {
            $scope.sortReports = !$scope.sortReports;

            var sort = 'desc';

            if ($scope.sortReports) sort = 'asc';

            $scope.goToView2($scope.currentType, true, sort, $scope.pagination.currentPage, $scope.pagination.pageSize);
        };

        $scope.pagination = {
            pages: 1,
            currentPage: 1,
            pageSize: '10'
        };

        $scope.$watch('pagination.pageSize', function (newVal, oldVal) {
            if (newVal != oldVal) {
                var sort = 'desc';
                if ($scope.sortReports) sort = 'asc';
                $scope.pagination.currentPage = 1;
                $scope.goToView2($scope.currentType, true, sort, $scope.pagination.currentPage);
            }
        });

        $scope.nextPage = function () {
            var sort = 'desc';
            if ($scope.sortReports) sort = 'asc';

            $scope.pagination.currentPage++;
            $scope.goToView2($scope.currentType, true, sort, $scope.pagination.currentPage);
        };

        $scope.previousPage = function () {
            var sort = 'desc';
            if ($scope.sortReports) sort = 'asc';
            $scope.pagination.currentPage--;
            $scope.goToView2($scope.currentType, true, sort, $scope.pagination.currentPage);
        };

        $scope.downloadFile = function (type) {
            $scope.currentType = type;

            if (!$scope.hasPin) {
                $scope.pin = '1234';
            }

            if (!$scope.pin) {
                $scope.pinView = true;
                $scope.displayExportView = false;
            } else {
                var payload = {
                    Fields: "",
                    Mode: type,
                    PIN: $scope.pin
                },
                    fields = Object.keys($scope.fields).filter(function (key) {
                    if (key != 'email') {
                        return $scope.fields[key];
                    } else {
                        return false;
                    }
                }) || [];

                fields = fields.join(',');

                canvasService.downloadFile($scope.innerSummary.EmailId, 3, payload).then(function (_ref7) {
                    var data = _ref7.data;

                    if (data.Response.Status == '-1') {
                        //invalid pin error
                        $scope.pinError = true;
                    } else {
                        $scope.pinError = false;
                        var url = 'https://ui.benchmarkemail.com/Reports/File?mode=' + type + '&field=' + fields + '&rtype=3&eid=' + $scope.innerSummary.EmailId + '&region=&linkname=&seq=&pin=' + $scope.pin;
                        $(location).attr('href', url);

                        $scope.hideExport();
                    }
                });
            }
        };

        $scope.checkAll = false;
        $scope.selectAll = function () {
            Object.keys($scope.fields).forEach(function (key) {
                if (key == 'email') {
                    $scope.fields[key] = true;
                } else {
                    $scope.fields[key] = !$scope.fields[key];
                }
            });
        };

        $scope.sendPin = function () {
            canvasService.emailPin($scope.innerSummary.EmailId).then(function () {
                $scope.showPinSent = true;
            });
        };

        $scope.displayPrevSummary = function (eId) {
            $scope.previewEmailSummary(eId);
            $scope.summaryEmailPreview = true;
            $timeout(function () {
                $scope.summaryEmailPreviewIn = true;
            }, 300);
        };

        $scope.closePreviewModal = function () {
            $scope.summaryEmailPreviewIn = false;
            $timeout(function () {
                $scope.summaryEmailPreview = false;
            }, 300);
        };

        $scope.previewEmailSummary = function (eId) {
            var selector = '#dvPreviewContent';

            $(selector).html("<div class=\"loading-animation\"><span></span><span></span><span></span><span></span></div>");

            canvasService.getPreview(eId).then(function (_ref8) {
                var data = _ref8.data;

                if (data.Response.ID) {
                    var obj = data.Response;
                    var content = obj.TemplateContent;

                    if (content.indexOf("<!-- /Footer Path -->") != -1) {
                        content = content.substring(0, content.indexOf("<!-- /Footer Path -->"));
                    }

                    $(selector).html("");
                    var iframe = document.createElement('iframe');

                    $(iframe).attr("id", "ifrPreviewContent");
                    $(selector).append(iframe);
                    iframe.contentWindow.document.open();
                    iframe.contentWindow.document.write(content);
                    iframe.contentWindow.document.close();
                } else {
                    alert("Could not load Preview");
                }
            });
        };

        $scope.parseEmailTitle = function (desc, limit) {
            if (desc) {
                if (desc.length > limit) {
                    desc = desc.slice(0, limit) + '...';
                }
            }

            return desc;
        };

        //APro Node Metrics Pagination
        $scope.metricsPagination = {
            currentPage: 0,
            pageSize: '10',
            pages: 0,
            pageLimit: 3,
            previousPage: function previousPage() {
                $scope.metricsPagination.currentPage--;
                $scope.showMetricNodeDetail($scope.currentMetricType);
            },
            nextPage: function nextPage() {
                $scope.metricsPagination.currentPage++;
                $scope.showMetricNodeDetail($scope.currentMetricType);
            },
            changePageSize: function changePageSize() {
                $scope.metricsPagination.currentPage = 0;
                $scope.showMetricNodeDetail($scope.currentMetricType);
            },
            getEndPage: function getEndPage() {
                var start = void 0;
                if ($scope.metricsPagination.currentPage - $scope.metricsPagination.pageLimit < 0) {
                    start = 0;
                } else {
                    start = $scope.metricsPagination.currentPage;
                }
                var end = start + $scope.metricsPagination.pageLimit;
                if (end > $scope.metricsPagination.pages) {
                    return $scope.metricsPagination.pages;
                }
                return end;
            },
            getStartPage: function getStartPage() {
                var start = $scope.metricsPagination.getEndPage() - $scope.metricsPagination.pageLimit;
                if (start < 0) {
                    return 0;
                }
                return start;
            },
            getPageNumbers: function getPageNumbers() {
                var pageArray = [];
                for (var page = $scope.metricsPagination.getStartPage(); page < $scope.metricsPagination.getEndPage(); page += 1) {
                    pageArray.push(page);
                }
                return pageArray;
            },
            goToPage: function goToPage(page) {
                $scope.metricsPagination.currentPage = page;
                $scope.showMetricNodeDetail($scope.currentMetricType);
            }

            //APro metrics Search
        };$scope.metricsSearch = {
            value: '',
            isActive: false,
            expanded: false,
            toggleSearch: function toggleSearch() {
                if ($scope.metricsSearch.expanded && $scope.metricsSearch.value.length > 0) {
                    return;
                }

                $scope.metricsSearch.isActive = !$scope.metricsSearch.isActive;

                if ($scope.metricsSearch.isActive) {
                    window.document.getElementById('search-metrics-input').focus();
                }
            },
            toggleInput: function toggleInput() {
                if ($scope.metricsSearch.expanded && $scope.metricsSearch.value.length > 0) {
                    return;
                }

                if ($scope.metricsSearch.value.length == 0) {
                    $scope.metricsSearch.isActive = false;
                }
            },
            clearInput: function clearInput() {
                $scope.metricsSearch.isActive = false;
                $scope.metricsSearch.value = '';

                $scope.metricsSearch.execute();
            },
            execute: function execute() {
                $scope.metricsPagination.currentPage = 0;
                $scope.showMetricNodeDetail($scope.currentMetricType);
            }
        };

        $scope.$watch('metricsSearch.value', function (newVal, oldVal) {
            if (newVal != oldVal) {
                $scope.metricsSearch.execute();
            }
        });
    }]);
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    angular.module('trackingCodeModule', ['ngAnimate', 'journey.canvas.srv']).controller('trackingCodeCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', '$sce', '$templateCache', 'Session', function ($scope, $rootScope, $timeout, canvasService, helpers, $sce, $templateCache, Session) {

        $rootScope.$watch('translate', function (func) {
            if (func) {
                $scope.translate = func;
            }
        });

        $rootScope.$on('displayTracking', function (evt, faqViewName) {
            var token = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

            $scope.tracking = true;

            if (token) {
                $scope.token = helpers.generateTrackerScript(token);
            }
        });

        $scope.closeFaq = function () {
            $scope.tracking = false;

            // Emit showWebSiteEngagement event when user copy the code
            $rootScope.$emit('showWebSiteEngagement');
        };

        $scope.trackingShowMore = function () {
            $scope.showMore = !$scope.showMore;
        };

        $scope.copied = false;
        $scope.copiedTracking = function () {
            $scope.copied = true;
            $timeout(function () {
                $scope.copied = false;
            }, 3000);
        };

        // Tracking for Website Tracking Code
        $scope.copyWebsiteTrackingCode = function () {
            Intercom('trackEvent', 'AP - Copied Tracking');
        };

        var lang = Session.getCookie('L');
        var gdpr = {
            english: 'https://kb.benchmarkemail.com/is-the-website-tracking-in-automations-gdpr-compliant/',
            spanish: 'https://kb.benchmarkemail.com/es/el-seguimiento-a-sitios-web-en-automatizaciones-cumple-con-el-rgpd/',
            chineset: 'https://kb.benchmarkemail.com/cn/is-the-website-tracking-in-automations-gdpr-compliant/',
            chinese: 'https://kb.benchmarkemail.com/tw/is-the-website-tracking-in-automations-gdpr-compliant/',
            japanese: 'https://kb.benchmarkemail.com/jp/is-the-website-tracking-in-automations-gdpr-compliant/',
            italian: 'https://kb.benchmarkemail.com/it/il-tracking-del-sito-web-nelle-automazioni-e-conforme-a-gdpr/',
            french: 'https://kb.benchmarkemail.com/fr/le-suivi-du-site-web-est-il-conforme-aux-gdpr-automations/',
            brazil: 'https://kb.benchmarkemail.com/br/o-rastreamento-de-site-nas-automacoes-esta-de-acordo-com-o-rgdp/',
            german: ' https://kb.benchmarkemail.com/de/ist-website-tracking-in-automatisierungen-dsgvo-konform/'
        };
        $scope.getGdprLink = gdpr[lang] || gdpr['english'];
    }]);
})();

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    angular.module('trackingReportsModule', ['ngAnimate', 'journey.canvas.srv']).controller('trackingReportsCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', '$sce', '$templateCache', '$compile', '$location', function ($scope, $rootScope, $timeout, canvasService, helpers, $sce, $templateCache, $compile, $location) {
        $scope.mainView = true;
        $scope.innerView = false;
        $scope.trackerData = [];

        $rootScope.$watch('translate', function (func) {
            if (func) {
                $scope.translate = func;
            }
        });

        $rootScope.$on('trackingReports', function (e) {
            $scope.mainView = true;
            $scope.innerView = false;
            $scope.tracking = true;
            $scope.getMainTrackerData('2017-01-01');
            $rootScope.$emit('setBodyOverflow');
        });

        $scope.filterMainBy = function (filter) {
            var startDate = '2017-01-01';

            var date = new Date();
            if (filter == 'oneDay') {
                date.setDate(date.getDate() - 1);
                var dd = date.getDate();
                var mm = date.getMonth() + 1; //January is 0!
                var yyyy = date.getFullYear();

                startDate = yyyy + '-' + mm + '-' + dd;
            }

            if (filter == 'oneWeek') {
                date.setDate(date.getDate() - 7);
                var _dd = date.getDate();
                var _mm = date.getMonth() + 1; //January is 0!
                var _yyyy = date.getFullYear();

                startDate = _yyyy + '-' + _mm + '-' + _dd;
            }

            if (filter == 'oneMonth') {
                date.setDate(date.getDate() - 30);
                var _dd2 = date.getDate();
                var _mm2 = date.getMonth() + 1; //January is 0!
                var _yyyy2 = date.getFullYear();

                startDate = _yyyy2 + '-' + _mm2 + '-' + _dd2;
            }

            $scope.getMainTrackerData(startDate, 'filter');
        };

        $scope.filterInnerBy = function (filter) {
            var startDate = '2017-01-01';
            var endDate = $scope.calcEndDate();

            var date = new Date();
            if (filter == 'oneDay') {
                date.setDate(date.getDate() - 1);
                var dd = date.getDate();
                var mm = date.getMonth() + 1; //January is 0!
                var yyyy = date.getFullYear();

                startDate = yyyy + '-' + mm + '-' + dd;
            }

            if (filter == 'oneWeek') {
                date.setDate(date.getDate() - 7);
                var _dd3 = date.getDate();
                var _mm3 = date.getMonth() + 1; //January is 0!
                var _yyyy3 = date.getFullYear();

                startDate = _yyyy3 + '-' + _mm3 + '-' + _dd3;
            }

            if (filter == 'oneMonth') {
                date.setDate(date.getDate() - 31);
                var _dd4 = date.getDate();
                var _mm4 = date.getMonth() + 1; //January is 0!
                var _yyyy4 = date.getFullYear();

                startDate = _yyyy4 + '-' + _mm4 + '-' + _dd4;
            }

            $scope.getInnerTrackerData(startDate, 'filter');
        };

        $scope.calcEndDate = function () {
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth() + 1; //January is 0!
            var yyyy = today.getFullYear();

            return yyyy + '-' + mm + '-' + dd;
        };

        $scope.getMainTrackerData = function (startDate, isFilter) {
            $scope.loading = true;
            var endDate = $scope.calcEndDate();

            canvasService.getTrackerSummary(startDate, endDate).then(function (_ref) {
                var data = _ref.data;

                $scope.trackerData = data.TrackerInformations;
                if (isFilter) {
                    if ($scope.trackerData.length) {
                        $scope.noRecordsFound = false;
                    } else {
                        $scope.noRecordsFound = true;
                    }
                } else {
                    if ($scope.trackerData.length) {
                        $scope.emptyState = false;
                    } else {
                        $scope.emptyState = true;
                    }
                }
                $scope.loading = false;
            }).catch(function () {
                $scope.loading = false;
            });
        };

        $scope.getInnerTrackerData = function (startDate, isFilter) {
            var endDate = $scope.calcEndDate();
            $scope.tDetails = [];
            $scope.mainView = false;
            $scope.innerView = true;
            $scope.loading = false;

            canvasService.getTrackerSummaryDetails(startDate, endDate, $scope.currentUrl).then(function (_ref2) {
                var data = _ref2.data;

                $scope.tDetails = data.TrackerInformations;
                if (isFilter) {
                    if ($scope.tDetails.length) {
                        $scope.noRecordsFound = false;
                    } else {
                        $scope.noRecordsFound = true;
                    }
                }
            });
        };

        $scope.displayTracking = function () {
            if ($rootScope.isHome_Global) {
                $rootScope.$emit('displayTrackingHome');
            } else {
                $rootScope.$emit('displayTrackingCanvas');
            }
        };

        $scope.close = function () {
            $scope.tracking = false;
            $rootScope.$emit('removeBodyOverflow');
        };

        $scope.displayInnerView = function (url) {
            $scope.currentUrl = url;
            $scope.getInnerTrackerData('2017-01-01');
        };

        $scope.goBack = function () {
            $scope.innerView = false;
            $scope.mainView = true;
        };

        $scope.propertyName = 'UniqueVisits';
        $scope.reverse = true;
        $scope.sortBy = function (propertyName) {
            $scope.reverse = $scope.propertyName === propertyName ? !$scope.reverse : false;
            $scope.propertyName = propertyName;
        };

        $scope.getSortDirUnique = function () {
            if ($scope.propertyName === 'UniqueVisits' && !$scope.noRecordsFound) {
                return $scope.reverse ? 'asc' : 'desc';
            }
        };

        $scope.getSortDirVisits = function () {
            if ($scope.propertyName === 'TotalVisits' && !$scope.noRecordsFound) {
                return $scope.reverse ? 'asc' : 'desc';
            }
        };

        $scope.propertyNameInner = 'TotalVisits';
        $scope.reverseInner = true;
        $scope.sortByInner = function (propertyName) {
            $scope.reverseInner = $scope.propertyNameInner === propertyName ? !$scope.reverseInner : false;
            $scope.propertyNameInner = propertyName;
        };

        $scope.getSortDirTotalInner = function () {
            if ($scope.propertyNameInner === 'TotalVisits' && !$scope.noRecordsFound) {
                return $scope.reverseInner ? 'asc' : 'desc';
            }
        };

        $scope.getSortDirVisitsInner = function () {
            if ($scope.propertyNameInner === 'DaysLastVist' && !$scope.noRecordsFound) {
                return $scope.reverseInner ? 'asc' : 'desc';
            }
        };
    }]);
})();

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    'use strict';

    angular.module('reportModule', []).controller('reportController', ['$rootScope', '$scope', '$stateParams', 'canvasService', 'helpers', reportController]);

    function reportController($rootScope, $scope, $stateParams, canvasService, helpers) {
        $scope.translate = $rootScope.translate;
        var journeyId = $stateParams.canvasId;

        if (journeyId && $rootScope.jbToken) {
            canvasService.getJourney(journeyId).then(function (result) {
                var data = result.data;
                var title = data.JourneyTitle;
                var activeDays = helpers.getDayDiff(data.ActivatedDate, data.LastEditOn);

                $scope.$emit('jbLoader', false);
                $rootScope.$emit('summary', true, journeyId, title, null, activeDays, true);
            }).catch(function (error) {
                return console.log(error);
            });
        }
    }
})();

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    'use strict';

    angular.module('translateModule', ['JB.translate.srv']).run(['$rootScope', 'Translate', jbTranslate]);

    function jbTranslate($rootScope, Translate) {
        if (!$rootScope.translate) {
            Translate.buildDirectory();
        }
    }
})();

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

module.exports = angular.module('add-date-time-ctrl', []).controller('addDateTimeFormCtrl', ['$rootScope', '$scope', 'canvasService', 'timezoneFactory', '$timeout', function ($rootScope, $scope, canvasService, timezoneFactory, $timeout) {
    $scope.timeZones = timezoneFactory.get();
    $scope.displayAddListActionOptions = false;
    $scope.displayError = false;
    $scope.descriptionEmpty = false;
    $scope.$parent.createListName = {};
    $scope.search = {};

    if ($scope.connections.length !== undefined) {
        var now = new Date();

        //Start new Connection obj
        $scope.connections = {
            id: 'entry_' + now.getTime(),
            data: {
                time: '',
                timezoneName: '',
                selectedList: []
            }
        };
    }

    $scope.$parent.connections = $scope.connections;

    var sunDay = $scope.translate('timePicker.sun'),
        mon = $scope.translate('timePicker.mon'),
        tue = $scope.translate('timePicker.tue'),
        wed = $scope.translate('timePicker.wed'),
        thu = $scope.translate('timePicker.thrus'),
        fri = $scope.translate('timePicker.fri'),
        sat = $scope.translate('timePicker.sat'),
        jan = $scope.translate('timePicker.jan'),
        feb = $scope.translate('timePicker.feb'),
        mar = $scope.translate('timePicker.mar'),
        apr = $scope.translate('timePicker.apr'),
        may = $scope.translate('timePicker.may'),
        jun = $scope.translate('timePicker.jun'),
        jul = $scope.translate('timePicker.jul'),
        aug = $scope.translate('timePicker.aug'),
        set = $scope.translate('timePicker.set'),
        oct = $scope.translate('timePicker.oct'),
        nov = $scope.translate('timePicker.nov'),
        dec = $scope.translate('timePicker.dec');

    $('#date-picker').datetimepicker({
        stepMinute: 15,
        minDate: 0,
        dayNamesMin: [sunDay, mon, tue, wed, thu, fri, sat],
        monthNames: [jan, feb, mar, apr, may, jun, jul, aug, set, oct, nov, dec],
        currentText: $scope.translate('timePicker.now'),
        closeText: $scope.translate('timePicker.done'),
        amNames: ['AM', 'A'],
        pmNames: ['PM', 'P'],
        timeFormat: 'HH:mm',
        timeSuffix: '',
        timeOnlyTitle: $scope.translate('timePicker.choooseTime'),
        timeText: $scope.translate('timePicker.time'),
        hourText: $scope.translate('timePicker.hour'),
        minuteText: $scope.translate('timePicker.minute'),
        secondText: $scope.translate('timePicker.second'),
        millisecText: $scope.translate('timePicker.millisecond'),
        microsecText: $scope.translate('timePicker.microsecond'),
        timezoneText: $scope.translate('timePicker.timeZone')
    });

    $('#date-picker').on('change', function () {
        $scope.$emit('updateDateFormCtrl', $(this).val());
    });

    $scope.triggerDatePicker = function () {
        $timeout(function () {
            document.getElementById('date-picker').focus();
        });
    };

    $scope.sortDataList = function () {
        $scope.contactListData = $scope.contactListData.map(function (i) {
            if ($scope.connections.data.selectedList.indexOf(i.ListId) > -1) {
                i.selectedItem = true;
            } else {
                delete i.selectedItem;
            }

            return i;
        });

        Object.assign($scope.contactListData, _.orderBy($scope.contactListData, ['selectedItem'], ['asc']));
    };
    $scope.sortDataList();

    $scope.toggelListItem = function (listItem, $i) {
        if ($scope.connections.isDummy) {
            $scope.connections.data.selectedList = [];
            delete $scope.connections.isDummy;
        }

        var index = $scope.connections.data.selectedList.indexOf(listItem);
        if (index > -1) {
            $scope.connections.data.selectedList.splice(index, 1);
            delete $scope.contactListData[$i].selectedItem;
        } else {
            $scope.connections.data.selectedList.push(listItem);
            $scope.contactListData[$i].selectedItem = true;
        }

        Object.assign($scope.contactListData, _.orderBy($scope.contactListData, ['selectedItem'], ['asc']));

        if ($scope.connections.data.selectedList.length) {
            $scope.selectedKey = $scope.translate('commons.editSelection');
        } else {
            $scope.selectedKey = $scope.translate('commons.selectList');
        }
    };

    $scope.triggerDatePicker = function () {
        $timeout(function () {
            document.getElementById('date-picker').focus();
        });
    };

    $scope.setScrollLogic = function (id) {
        $scope.listLoader = false;
        angular.element(document.getElementById('contactListContainer' + id)).bind("scroll", function () {
            if (!$scope.listLoader && !$rootScope.stopLoadingList && !$scope.search.list) {
                $scope.listLoader = true;
                canvasService.getContactList($rootScope.contactListOffset, 10).success(function (data) {
                    if (!data.Results.length) {
                        $rootScope.stopLoadingList = true;
                    } else {
                        $rootScope.contactListOffset++;
                        $rootScope.contactListData = _.uniqBy($rootScope.contactListData.concat(data.Results), 'ListId');
                        $scope.contactListData = $rootScope.contactListData;
                        Object.assign($scope.contactListData, _.orderBy($scope.contactListData, ['selectedItem'], ['asc']));
                    }
                    $scope.listLoader = false;
                }).error(function () {
                    $scope.listLoader = false;
                });
            }
        });
    };

    $scope.searching = false;
    $scope.search.search = function (val) {
        if (val && val.length > 0 && !$scope.searching) {
            $scope.searching = true;
            canvasService.searchContactList(val).then(function (res) {
                $scope.searching = false;
                $rootScope.contactListData = _.uniqBy($rootScope.contactListData.concat(res.data.Results), 'ListId');
                $scope.contactListData = [];
                $scope.contactListData = $scope.contactListData.concat(res.data.Results);
                $scope.sortDataList();
            }).catch(function () {
                $scope.searching = false;
            });
        } else {
            $scope.contactListData = $rootScope.contactListData;
            $scope.sortDataList();
        }
    };

    setTimeout(function () {
        $scope.setScrollLogic($scope.connections.id);
    }, 100);

    // Functionality for add a new list name
    $scope.showCreateListNameModal = function () {
        $scope.$parent.showTriggerPanelModal = false;
        $scope.$parent.showCreateListName = true;
    };

    $scope.$parent.goCreateList = function () {
        if ($scope.$parent.createListName.name === undefined) {
            $scope.$parent.showNewListNameError = true;
        }

        if ($scope.$parent.createListName.name) {
            $scope.$parent.createListLoader = true;

            canvasService.createContactList($scope.$parent.createListName.name).success(function (_ref) {
                var Results = _ref.Results;

                if (Results.length) {
                    var result = Results[0];
                    var listItem = {
                        ContactCount: 0,
                        ListId: result.ListId,
                        ListName: result.ListName
                    };
                    $scope.contactListData.unshift(listItem);
                    $rootScope.contactListData.unshift(listItem);
                    $scope.toggelListItem(result.ListId, 0);
                    $scope.createList = false;
                    $rootScope.$emit('errorMsg', $scope.translate('common.list.message'), 'confirmation');
                    $scope.$parent.hideAddNewList();
                } else {
                    $rootScope.$emit('errorMsg', $scope.translate('canvas.error.607'));
                }
            }).error(function () {
                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.607'));
            }).finally(function () {
                $scope.$parent.createListLoader = false;
            });
        }
    };

    $scope.$parent.hideAddNewList = function () {
        $scope.$parent.showTriggerPanelModal = true;
        $scope.isAddToListFormDisplayed = true;
        $scope.$parent.showCreateListName = false;
    };
    // End Functionality for add a new list name

    $scope.$watch('connections.data.timezoneName', function (val) {
        if (val) {
            var valuesArray = ["Morocco Standard Time, Text=Casablanca", "GMT Standard Time, Text=(GMT) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London ", "Greenwich Standard Time, Text=(GMT) Monrovia, Reykjavik ", "W. Europe Standard Time, Text=(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna ", "Central Europe Standard Time, Text=(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague ", "Romance Standard Time, Text=(GMT+01:00) Brussels, Copenhagen, Madrid, Paris ", "Central European Standard Time, Text=(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb ", "W. Central Africa Standard Time, Text=(GMT+01:00) West Central Africa ", "Jordan Standard Time, Text=(GMT+02:00) Amman ", "GTB Standard Time, Text=(GMT+02:00) Athens, Bucharest, Istanbul ", "Middle East Standard Time, Text=(GMT+02:00) Beirut ", "Egypt Standard Time, Text=(GMT+02:00) Cairo ", "South Africa Standard Time, Text=(GMT+02:00) Harare, Pretoria ", "FLE Standard Time, Text=(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius ", "Israel Standard Time, Text=(GMT+02:00) Jerusalem ", "E. Europe Standard Time, Text=(GMT+02:00) Minsk ", "Namibia Standard Time, Text=(GMT+02:00) Windhoek ", "Arabic Standard Time, Text=(GMT+03:00) Baghdad ", "Arab Standard Time, Text=(GMT+03:00) Kuwait, Riyadh ", "Russian Standard Time, Text=(GMT+03:00) Moscow, St. Petersburg, Volgograd ", "E. Africa Standard Time, Text=(GMT+03:00) Nairobi ", "Georgian Standard Time, Text=(GMT+03:00) Tbilisi ", "Iran Standard Time, Text=(GMT+03:30) Tehran ", "Arabian Standard Time, Text=(GMT+04:00) Abu Dhabi, Muscat ", "Azerbaijan Standard Time, Text=(GMT+04:00) Baku ", "Mauritius Standard Time, Text=(GMT+04:00) Port Louis ", "Caucasus Standard Time, Text=(GMT+04:00) Yerevan ", "Afghanistan Standard Time, Text=(GMT+04:30) Kabul ", "Ekaterinburg Standard Time, Text=(GMT+05:00) Ekaterinburg ", "Pakistan Standard Time, Text=(GMT+05:00) Islamabad, Karachi ", "West Asia Standard Time, Text=(GMT+05:00) Tashkent ", "India Standard Time, Text=(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi ", "Sri Lanka Standard Time, Text=(GMT+05:30) Sri Jayawardenepura ", "Nepal Standard Time, Text=(GMT+05:45) Kathmandu ", "N. Central Asia Standard Time, Text=(GMT+06:00) Almaty, Novosibirsk ", "Central Asia Standard Time, Text=(GMT+06:00) Astana, Dhaka ", "Myanmar Standard Time, Text=(GMT+06:30) Yangon (Rangoon) ", "SE Asia Standard Time, Text=(GMT+07:00) Bangkok, Hanoi, Jakarta ", "North Asia Standard Time, Text=(GMT+07:00) Krasnoyarsk ", "China Standard Time, Text=(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi ", "North Asia East Standard Time, Text=(GMT+08:00) Irkutsk, Ulaan Bataar ", "Singapore Standard Time, Text=(GMT+08:00) Kuala Lumpur, Singapore ", "W. Australia Standard Time, Text=(GMT+08:00) Perth ", "Taipei Standard Time, Text=(GMT+08:00) Taipei ", "Tokyo Standard Time, Text=(GMT+09:00) Osaka, Sapporo, Tokyo ", "Korea Standard Time, Text=(GMT+09:00) Seoul ", "Yakutsk Standard Time, Text=(GMT+09:00) Yakutsk ", "Cen. Australia Standard Time, Text=(GMT+09:30) Adelaide ", "AUS Central Standard Time, Text=(GMT+09:30) Darwin ", "E. Australia Standard Time, Text=(GMT+10:00) Brisbane ", "AUS Eastern Standard Time, Text=(GMT+10:00) Canberra, Melbourne, Sydney ", "West Pacific Standard Time, Text=(GMT+10:00) Guam, Port Moresby ", "Tasmania Standard Time, Text=(GMT+10:00) Hobart ", "Vladivostok Standard Time, Text=(GMT+10:00) Vladivostok ", "Central Pacific Standard Time, Text=(GMT+11:00) Magadan, Solomon Is., New Caledonia ", "New Zealand Standard Time, Text=(GMT+12:00) Auckland, Wellington ", "Fiji Standard Time, Text=(GMT+12:00) Fiji, Kamchatka, Marshall Is. ", "Tonga Standard Time, Text=(GMT+13:00) Nuku'alofa ", "Azores Standard Time, Text=(GMT-01:00) Azores ", "Cape Verde Standard Time, Text=(GMT-01:00) Cape Verde Is. ", "Mid-Atlantic Standard Time, Text=(GMT-02:00) Mid-Atlantic ", "E. South America Standard Time, Text=(GMT-03:00) Brasilia ", "Argentina Standard Time, Text=(GMT-03:00) Buenos Aires ", "SA Eastern Standard Time, Text=(GMT-03:00) Georgetown ", "Greenland Standard Time, Text=(GMT-03:00) Greenland ", "Montevideo Standard Time, Text=(GMT-03:00) Montevideo ", "Newfoundland Standard Time, Text=(GMT-03:30) Newfoundland ", "Atlantic Standard Time, Text=(GMT-04:00) Atlantic Time (Canada) ", "SA Western Standard Time, Text=(GMT-04:00) La Paz ", "Central Brazilian Standard Time, Text=(GMT-04:00) Manaus ", "Pacific SA Standard Time, Text=(GMT-04:00) Santiago ", "Venezuela Standard Time, Text=(GMT-04:30) Caracas ", "SA Pacific Standard Time, Text=(GMT-05:00) Bogota, Lima, Quito, Rio Branco ", "Eastern Standard Time, Text=(GMT-05:00) Eastern Time (US & Canada) ", "US Eastern Standard Time, Text=(GMT-05:00) Indiana (East) ", "Central America Standard Time, Text=(GMT-06:00) Central America ", "Central Standard Time, Text=(GMT-06:00) Central Time (US & Canada) ", "Central Standard Time (Mexico), Text=(GMT-06:00) Guadalajara, Mexico City, Monterrey ", "Canada Central Standard Time, Text=(GMT-06:00) Saskatchewan ", "US Mountain Standard Time, Text=(GMT-07:00) Arizona ", "Mountain Standard Time (Mexico), Text=(GMT-07:00) Chihuahua, La Paz, Mazatlan ", "Mountain Standard Time, Text=(GMT-07:00) Mountain Time (US & Canada) ", "Pacific Standard Time, Text=(GMT-08:00) Pacific Time (US & Canada) ", "Pacific Standard Time (Mexico), Text=(GMT-08:00) Tijuana, Baja California ", "Alaskan Standard Time, Text=(GMT-09:00) Alaska ", "Hawaiian Standard Time, Text=(GMT-10:00) Hawaii ", "Samoa Standard Time, Text=(GMT-11:00) Midway Island, Samoa ", "Dateline Standard Time, Text=(GMT-12:00) International Date Line West"],
                onlyName = val.split(' (GMT'),
                rawItem = _.filter(valuesArray, function (item) {
                return item.indexOf(onlyName[0]) > -1;
            }) || [];

            if (rawItem.length > 0) {
                rawItem = rawItem[0].split(', Text=(');
                $scope.connections.data.timezone = rawItem[0];
            }
        }
    });
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = angular.module('add-to-list-ctrl', []).controller('addToListFormCtrl', ['$rootScope', '$scope', 'canvasService', function ($rootScope, $scope, canvasService) {
    $scope.displayAddListActionOptions = false;
    $scope.displayError = false;
    $scope.descriptionEmpty = false;
    $scope.search = {};
    $scope.$parent.createListName = {};
    $scope.showContactsWarning = false;

    if ($scope.connections.length !== undefined) {
        var now = new Date();

        //Start new Connection obj
        $scope.connections = {
            id: 'entry_' + now.getTime(),
            data: {
                selectedList: [],
                contactOptions: 'add-contacts-future'
            }
        };
    }

    $scope.$parent.connections = $scope.connections;

    $scope.contactOptions = [{
        value: 'all-in-any-future',
        message: $scope.translate('commons.all.subscribers')
    }, {
        value: 'add-contacts-list',
        message: $scope.translate('commons.existing.subscribers')
    }, {
        value: 'add-contacts-future',
        message: $scope.translate('commons.new.subscribers')
    }];

    $scope.sortDataList = function () {
        $scope.contactListData = $scope.contactListData.map(function (i) {
            if ($scope.connections.data.selectedList.indexOf(i.ListId) > -1) {
                i.selectedItem = true;
            } else {
                delete i.selectedItem;
            }

            return i;
        });

        Object.assign($scope.contactListData, _.orderBy($scope.contactListData, ['selectedItem'], ['asc']));
    };
    $scope.sortDataList();

    $scope.toggelListItem = function (listItem, $i) {
        if ($scope.connections.isDummy) {
            $scope.connections.data.selectedList = [];
            delete $scope.connections.isDummy;
        }

        var index = $scope.connections.data.selectedList.indexOf(listItem);
        if (index > -1) {
            $scope.connections.data.selectedList.splice(index, 1);
            delete $scope.contactListData[$i].selectedItem;
        } else {
            $scope.connections.data.selectedList.push(listItem);
            $scope.contactListData[$i].selectedItem = true;
        }

        Object.assign($scope.contactListData, _.orderBy($scope.contactListData, ['selectedItem'], ['asc']));

        if ($scope.connections.data.selectedList.length) {
            $scope.selectedKey = $scope.translate('commons.editSelection');
        } else {
            $scope.selectedKey = $scope.translate('commons.selectList');
        }
    };

    $scope.setScrollLogic = function (id) {
        $scope.listLoader = false;
        angular.element(document.getElementById('contactListContainer' + id)).bind("scroll", function () {
            if (!$scope.listLoader && !$rootScope.stopLoadingList && !$scope.search.list) {
                $scope.listLoader = true;
                canvasService.getContactList($rootScope.contactListOffset, 10).success(function (data) {
                    if (!data.Results.length) {
                        $rootScope.stopLoadingList = true;
                    } else {
                        $rootScope.contactListOffset++;
                        $rootScope.contactListData = _.uniqBy($rootScope.contactListData.concat(data.Results), 'ListId');
                        $scope.contactListData = $rootScope.contactListData;
                        Object.assign($scope.contactListData, _.orderBy($scope.contactListData, ['selectedItem'], ['asc']));
                    }
                    $scope.listLoader = false;
                }).error(function () {
                    $scope.listLoader = false;
                });
            }
        });
    };

    $scope.searching = false;
    $scope.search.search = function (val) {
        if (val && val.length > 0 && !$scope.searching) {
            $scope.searching = true;
            canvasService.searchContactList(val).then(function (res) {
                $scope.searching = false;
                $rootScope.contactListData = _.uniqBy($rootScope.contactListData.concat(res.data.Results), 'ListId');
                $scope.contactListData = [];
                $scope.contactListData = $scope.contactListData.concat(res.data.Results);
                $scope.sortDataList();
            }).catch(function () {
                $scope.searching = false;
            });
        } else {
            $scope.contactListData = $rootScope.contactListData;
            $scope.sortDataList();
        }
    };

    setTimeout(function () {
        $scope.setScrollLogic($scope.connections.id);
    }, 100);

    // Functionality for add a new list name
    $scope.showCreateListNameModal = function () {
        $scope.$parent.showTriggerPanelModal = false;
        $scope.$parent.showCreateListName = true;
    };

    $scope.$parent.goCreateList = function () {
        if ($scope.$parent.createListName.name === undefined) {
            $scope.$parent.showNewListNameError = true;
        }

        if ($scope.$parent.createListName.name) {
            $scope.$parent.createListLoader = true;
            canvasService.createContactList($scope.$parent.createListName.name).success(function (_ref) {
                var Results = _ref.Results;

                if (Results.length) {
                    var result = Results[0];
                    var listItem = {
                        ContactCount: 0,
                        ListId: result.ListId,
                        ListName: result.ListName
                    };
                    $scope.contactListData.unshift(listItem);
                    $rootScope.contactListData.unshift(listItem);
                    $scope.toggelListItem(result.ListId, 0);
                    $scope.createList = false;
                    $rootScope.$emit('errorMsg', $scope.translate('common.list.message'), 'confirmation');
                    $scope.$parent.hideAddNewList();
                } else {
                    $rootScope.$emit('errorMsg', $scope.translate('canvas.error.607'));
                }
            }).error(function () {
                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.607'));
            }).finally(function () {
                $scope.$parent.createListLoader = false;
            });
        }
    };

    $scope.$parent.hideAddNewList = function () {
        $scope.$parent.showTriggerPanelModal = true;
        $scope.isAddToListFormDisplayed = true;
        $scope.$parent.showCreateListName = false;
    };

    $scope.$watch('connections.data.contactOptions', function (newVal) {
        $scope.showContactsWarning = newVal === 'add-contacts-list';
    });
    // End Functionality for add a new list name
}]);

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = angular.module('add-to-segment-ctrl', []).controller('addToSegmentFormCtrl', ['$rootScope', '$scope', 'canvasService', function ($rootScope, $scope, canvasService) {
    $scope.displayAddListActionOptions = false;
    $scope.displayError = false;
    $scope.descriptionEmpty = false;
    $scope.createListName = {};
    $scope.search = {};

    if ($scope.connections.length !== undefined) {
        var now = new Date();

        //Start new Connection obj
        $scope.connections = {
            id: 'entry_' + now.getTime(),
            data: {
                selectedList: [],
                contactOptions: 'add-contacts-future',
                listData: []
            }
        };
    }

    $scope.$parent.connections = $scope.connections;

    $scope.contactOptions = [{
        value: 'all-in-any-future',
        message: $scope.translate('commons.all.subscribers')
    }, {
        value: 'add-contacts-list',
        message: $scope.translate('commons.existing.subscribers')
    }, {
        value: 'add-contacts-future',
        message: $scope.translate('commons.new.subscribers')
    }];

    $scope.sortDataList = function () {
        $scope.segmentData = $scope.segmentData.map(function (i) {
            if ($scope.connections.data.selectedList.indexOf(i.SegmentId) > -1) {
                i.selectedItem = true;
            } else {
                delete i.selectedItem;
            }

            return i;
        });

        Object.assign($scope.segmentData, _.orderBy($scope.segmentData, ['selectedItem'], ['asc']));
    };
    $scope.segmentData && $scope.segmentData.length && $scope.sortDataList();

    $scope.toggelListItem = function (listItem, $i) {
        if ($scope.connections.isDummy) {
            $scope.connections.data.selectedList = [];
            delete $scope.connections.isDummy;
        }

        var index = $scope.connections.data.selectedList.indexOf(listItem);
        if (index > -1) {
            $scope.connections.data.selectedList.splice(index, 1);
            delete $scope.segmentData[$i].selectedItem;
        } else {
            $scope.connections.data.selectedList.push(listItem);
            $scope.segmentData[$i].selectedItem = true;
        }

        Object.assign($scope.segmentData, _.orderBy($scope.segmentData, ['selectedItem'], ['asc']));

        if ($scope.connections.data.selectedList.length) {
            $scope.selectedKey = $scope.translate('commons.editSelection');
        } else {
            $scope.selectedKey = $scope.translate('commons.selectSegment');
        }
    };

    $scope.setSegmentScrollLogic = function (id) {
        $scope.listLoader = false;
        angular.element(document.getElementById('contactSegmentContainer' + id)).bind('scroll', function () {
            if (!$scope.listLoader && !$rootScope.stopLoadingSegments && !$scope.search.list) {
                $scope.listLoader = true;
                canvasService.getSegments($rootScope.segmentListOffset, 10).success(function (data) {
                    if (!data.Results.length) {
                        $rootScope.stopLoadingSegments = true;
                    } else {
                        $rootScope.segmentListOffset++;
                        $rootScope.segmentData = _.uniqBy($rootScope.segmentData.concat(data.Results), 'SegmentId');
                        $scope.segmentData = $rootScope.segmentData;
                    }
                    $scope.listLoader = false;
                    $scope.sortDataList();
                }).error(function () {
                    $scope.listLoader = false;
                });
            }
        });
    };

    $scope.searching = false;
    $scope.search.search = function (val) {
        if (val && val.length > 0 && !$scope.searching) {
            $scope.searching = true;
            canvasService.searchContactSegment(val).then(function (res) {
                $scope.searching = false;
                $rootScope.segmentData = _.uniqBy($rootScope.segmentData.concat(res.data.Results), 'ListId');
                $scope.segmentData = [];
                if ($scope.connections.data.selectedList && $scope.connections.data.selectedList.length) {
                    $scope.connections.data.selectedList.forEach(function (item) {
                        for (var i = 0; i < $rootScope.segmentData.length; i++) {
                            if ($rootScope.segmentData[i].ListId === item) {
                                $scope.segmentData.push($rootScope.segmentData[i]);
                                break;
                            }
                        }
                    });
                }

                $scope.segmentData = $scope.segmentData.concat(res.data.Results);
                $scope.sortDataList();
            }).catch(function () {
                $scope.searching = false;
            });
        } else {
            $scope.segmentData = $rootScope.segmentData;
            $scope.sortDataList();
        }
    };

    setTimeout(function () {
        $scope.setSegmentScrollLogic($scope.connections.id);
    }, 100);

    $scope.$watch('connections.data.contactOptions', function (newVal) {
        $scope.showContactsWarning = newVal === 'add-contacts-list';
    });
}]);

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = angular.module('website-engagement-ctrl', []).controller('websiteEngagementCtrl', ['$rootScope', '$scope', 'canvasService', '$interval', function ($rootScope, $scope, canvasService, $interval) {
    if ($scope.connections.length !== undefined) {
        var now = new Date();

        //Start new Connection obj
        $scope.connections = {
            id: 'entry_' + now.getTime(),
            data: {
                source: 'any-tracked-page',
                specificUrl: ''
            }
        };
    }

    var stop = void 0,
        intents = 0;

    $scope.$parent.connections = $scope.connections;

    $scope.specificUrlOptions = [{
        value: 'any-tracked-page',
        message: $scope.translate('canvas.entry.websiteEngagement.anyTracked')
    }, {
        value: 'is-url',
        message: $scope.translate('canvas.entry.websiteEngagement.specificUrl')
    }, {
        value: 'contains-url',
        message: $scope.translate('canvas.entry.websiteEngagement.containsUrl')
    }, {
        value: 'doesnotcontain-url',
        message: $scope.translate('canvas.entry.websiteEngagement.not.containsUrl')
    }, {
        value: 'startswith-url',
        message: $scope.translate('canvas.entry.websiteEngagement.starts.with.url')
    }, {
        value: 'endswith-url',
        message: $scope.translate('canvas.entry.websiteEngagement.ends.with.url')
    }, {
        value: 'wildcardmatch-url',
        message: $scope.translate('canvas.entry.websiteEngagement.wildcard.url')
    }];

    $scope.$watch('connections.data.source', function (newVal) {
        if (newVal === 'is-url') {
            $scope.specificUrlPlaceholder = $scope.translate('commons.url.is');
        } else if (newVal === 'contains-url' || newVal === 'doesnotcontain-url') {
            $scope.specificUrlPlaceholder = $scope.translate('commons.url.contains');
        } else if (newVal === 'startswith-url') {
            $scope.specificUrlPlaceholder = $scope.translate('commons.url.starts');
        } else if (newVal === 'endswith-url') {
            $scope.specificUrlPlaceholder = $scope.translate('commons.url.ends');
        } else if (newVal === 'wildcardmatch-url') {
            $scope.specificUrlPlaceholder = $scope.translate('commons.url.wildcard');
        }
    });

    $scope.testUrl = function () {
        if ($scope.connections.data.specificUrl) {
            $scope.trackingTestState = $scope.translate('canvas.entry.websiteEngagement.url.checking');
            $scope.trackingTestClass = 'checking-url';
            var testUrl = $scope.connections.data.specificUrl + '?apTestApi=true&url=' + encodeURIComponent($scope.connections.data.specificUrl);
            if (/^http:\/\//i.test(testUrl)) {
                document.getElementsByName('testSiteIFrame')[0].src = testUrl;
            } else {
                window.open(testUrl, '_blank');
            }
            stop = $interval(function () {
                canvasService.testTracker($scope.connections.data.specificUrl).then(function (result) {
                    if (result.data.TestTrackerInformation.IsInstalled) {
                        $interval.cancel(stop);
                        $scope.trackingTestState = $scope.translate('canvas.entry.websiteEngagement.url.confirm');
                        $scope.trackingTestClass = 'url-confirm';
                        intents = 0;
                    } else if (intents >= 4) {
                        $scope.trackingTestState = $scope.translate('canvas.entry.websiteEngagement.url.notDetected');
                        $scope.trackingTestClass = 'url-fail';
                        $interval.cancel(stop);
                        intents = 0;
                    }
                    intents++;
                }).catch(function () {
                    $scope.trackingTestState = $scope.translate('canvas.entry.websiteEngagement.url.notDetected');
                    $scope.trackingTestClass = 'url-fail';
                    $interval.cancel(stop);
                    intents = 0;
                });
            }, 2000);
        } else {
            $scope.$emit('errorMsg', $scope.translate('canvas.entry.websiteEngagement.url.error'), 'error');
        }
    };

    $scope.$watch('connections.data.specificUrl', function (url) {
        if (url && ($scope.connections.data.source === 'is-url' || $scope.connections.data.source === 'wildcardmatch-url')) {
            var reg;

            if ($scope.connections.data.source === 'is-url') {
                reg = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
            } else {
                reg = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+\/\*$/;
            }

            if (!reg.test(url)) {
                $scope.$parent.specificUrlError = true;
            } else {
                $scope.$parent.specificUrlError = false;
            }
        } else {
            $scope.$parent.specificUrlError = false;
        }
    });

    $scope.displayTrackerModal = function () {
        $scope.$parent.showTriggerPanelModal = false;
        $rootScope.$emit('displayTrackerModal');
    };

    // Show web site engagement when user copy the code
    $rootScope.$on('showWebSiteEngagement', function () {
        $scope.$parent.showTriggerPanelModal = true;
    });

    $scope.changeUrlState = function () {
        if ($scope.connections.data.source !== 'is-url' || $scope.connections.data.source !== 'wildcardmatch-url') {
            $scope.$parent.specificUrlError = false;
        }
    };
}]);

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    angular.module('upgradeModule', ['ngAnimate', 'journey.canvas.srv']).controller('upgradeCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', '$sce', '$templateCache', function ($scope, $rootScope, $timeout, canvasService, helpers, $sce, $templateCache) {
        $scope.upgradePlan = false;
        $scope.isMasterAccount = helpers.readCookie('isMasterAccount') === '1';

        $rootScope.$watch('translate', function (func) {
            if (func) {
                $scope.translate = func;
            }
        });

        $scope.closeUpgrade = function () {
            Intercom('trackEvent', 'AP Upgrade Cancel');
            $scope.upgradePlan = false;
        };

        $rootScope.$on('upgrade', function () {
            $scope.upgradePlan = true;
        });

        if (window.location.search === '?showExpire=true') {
            $scope.expirePlan = true;
        }

        $scope.goUpgrade = function () {
            Intercom('trackEvent', 'apro modal upsell - button');
            FS.event('apro modal upsell - button');
            window.location.href = 'https://app.benchmarkemail.com/process/upgradeemail?upg=aProCanvas';
        };

        $scope.closeExp = function () {
            $scope.expirePlan = false;
        };

        $rootScope.$on('expire', function () {
            $scope.expirePlan = true;
        });
    }]);
})();

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2016 Aditya Sharat
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 *
 * Use this directive to convert drop downs into chosen drop downs.
 * http://harvesthq.github.io/chosen/
 * http://adityasharat.github.io/angular-chosen/
 */
(function (angular) {
    var AngularChosen = angular.module('angular.chosen', []);

    function chosen($timeout) {
        var EVENTS, scope, linker, watchCollection;

        /*
         * List of events and the alias used for binding with angularJS
         */
        EVENTS = [{
            onChange: 'change'
        }, {
            onReady: 'chosen:ready'
        }, {
            onMaxSelected: 'chosen:maxselected'
        }, {
            onShowDropdown: 'chosen:showing_dropdown'
        }, {
            onHideDropdown: 'chosen:hiding_dropdown'
        }, {
            onNoResult: 'chosen:no_results'
        }];

        /*
         * Items to be added in the scope of the directive
         */
        scope = {
            options: '=', // the options array
            ngModel: '=', // the model to bind to,,
            ngDisabled: '='
        };

        /*
         * initialize the list of items
         * to watch to trigger the chosen:updated event
         */
        watchCollection = [];
        Object.keys(scope).forEach(function (scopeName) {
            watchCollection.push(scopeName);
        });

        /*
         * Add the list of event handler of the chosen
         * in the scope.
         */
        EVENTS.forEach(function (event) {
            var eventNameAlias = Object.keys(event)[0];
            scope[eventNameAlias] = '=';
        });

        /* Linker for the directive */
        linker = function linker($scope, iElm, iAttr) {
            var maxSelection = parseInt(iAttr.maxSelection, 10),
                searchThreshold = parseInt(iAttr.searchThreshold, 10);

            if (isNaN(maxSelection) || maxSelection === Infinity) {
                maxSelection = undefined;
            }

            if (isNaN(searchThreshold) || searchThreshold === Infinity) {
                searchThreshold = undefined;
            }

            var allowSingleDeselect = iElm.attr('allow-single-deselect') !== undefined ? true : false;
            var noResultsText = iElm.attr('no-results-text') !== undefined ? iAttr.noResultsText : "No results found.";
            var disableSearch = iElm.attr('disable-search') !== undefined ? JSON.parse(iAttr.disableSearch) : false;
            var placeholderTextSingle = iElm.attr('placeholder-text-single') !== undefined ? iAttr.placeholderTextSingle : "Select an Option";
            var placeholderTextMultiple = iElm.attr('placeholder-text-multiple') !== undefined ? iAttr.placeholderTextMultiple : "Select Some Options";
            var displayDisabledOptions = iElm.attr('display-disabled-options') !== undefined ? JSON.parse(iAttr.displayDisabledOptions) : true;
            var displaySelectedOptions = iElm.attr('display-selected-options') !== undefined ? JSON.parse(iAttr.displaySelectedOptions) : true;

            $(iElm).chosen({
                width: '100%',
                max_selected_options: maxSelection,
                disable_search_threshold: searchThreshold,
                search_contains: true,
                allow_single_deselect: allowSingleDeselect,
                no_results_text: noResultsText,
                disable_search: disableSearch,
                placeholder_text_single: placeholderTextSingle,
                placeholder_text_multiple: placeholderTextMultiple,
                display_disabled_options: displayDisabledOptions,
                display_selected_options: displaySelectedOptions
            });

            $(iElm).on('change', function () {
                $(iElm).trigger('chosen:updated');
                $scope.ngModel = $(iElm).val();
                $scope.$apply('ngModel');
            });

            $scope.$watchGroup(watchCollection, function () {
                $timeout(function () {
                    $(iElm).trigger('chosen:updated');
                }, 100);
            });

            // assign event handlers
            EVENTS.forEach(function (event) {
                var eventNameAlias = Object.keys(event)[0];

                if (typeof $scope[eventNameAlias] === 'function') {
                    // check if the handler is a function
                    $(iElm).on(event[eventNameAlias], function (event) {
                        $scope.$apply(function () {
                            $scope[eventNameAlias](event);
                        });
                    }); // listen to the event triggered by chosen
                }
            });
        };

        // return the directive
        return {
            name: 'chosen',
            scope: scope,
            restrict: 'A',
            link: linker
        };
    }

    AngularChosen.directive('chosen', ['$timeout', chosen]);
})(angular);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    angular.module('active-add-to-list-action.dir', []).directive('activeAddToListAction', ['$rootScope', '$compile', '$templateCache', 'helpers', 'canvasService', activeAddToListAction]);

    function activeAddToListAction($rootScope, $compile, $templateCache, helpers, canvasService) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;
                $scope.descriptionEmpty = false;

                $scope.getAPLists = function () {
                    if ($scope.lists) {
                        $scope.listView = true;
                    } else {
                        canvasService.getLists($scope.data.selectedList).success(function (res) {
                            $scope.lists = res;
                            $scope.listView = true;
                        });
                    }
                };

                $scope.getSelectedText = function (desc) {
                    if ($scope.data.selectedList.length === 1) {
                        for (var item in desc) {
                            desc = helpers.getContactListItem(desc[item], $scope.contactListData);
                        }

                        return desc;
                    } else {
                        var lists = [];

                        for (var i = 0; i < desc.length; i++) {
                            lists.push(helpers.getContactListItem(desc[i], $scope.contactListData));
                        }

                        return lists.join().replace(/,/g, '<br />');
                    }
                };

                $scope.showReport = function () {
                    var firstOccurrence = $scope.id.indexOf('_');
                    var secondOccurrence = $scope.id.indexOf('_', firstOccurrence + 1);
                    var elementId = $scope.id.slice(0, secondOccurrence);
                    canvasService.getNodeDetails($rootScope.currentAPId, elementId).then(function (res) {
                        return res.data;
                    }).then(function (nodeDetails) {
                        canvasService.getNodeMetricDetailsGroupByType($rootScope.currentAPId, nodeDetails.NodeId, nodeDetails.NodeActionType).then(function (res) {
                            var data = [nodeDetails, res.data];
                            $rootScope.$emit('summary', true, $rootScope.currentAPId, $rootScope.currentJBTitle, undefined, -1, false, true, data);
                        });
                    });
                };

                $scope.parseDescription = function (desc, selected) {
                    var textToParse = desc;

                    if (textToParse && (typeof textToParse === 'undefined' ? 'undefined' : _typeof(textToParse)) === 'object') {

                        var descriptionCheck = false;
                        for (var item in textToParse) {
                            if (textToParse[item]) {

                                $scope.descriptionEmpty = false;
                                descriptionCheck = true;
                                var totalLists = $scope.data.selectedList.length;
                                textToParse = helpers.getContactListItem(textToParse[item], $scope.contactListData);

                                //One list selected and > 19
                                if (totalLists === 1 && textToParse.length > 15) {
                                    textToParse = textToParse.slice(0, 15) + '...';
                                    //More than one selected
                                } else if (totalLists > 1) {
                                    textToParse = totalLists + " Lists Selected";
                                }
                            }
                        }
                        if (!descriptionCheck) {
                            textToParse = parseDescriptionHelper(selected);
                        }
                    } else {
                        textToParse = parseDescriptionHelper(selected);
                    }

                    return textToParse;
                };

                var parseDescriptionHelper = function parseDescriptionHelper(selected) {
                    $scope.descriptionEmpty = true;
                    return selected === "showSelectedList" ? "" : "Description";
                };

                //Show or hide menu on Element click
                $scope.config = function (evt) {
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $scope.listView = false;
                    } else {
                        $scope.displayList = false;
                    }
                };

                $scope.contMenuConfigs = 0;
                $scope.stopMenuBroadcast = function () {
                    $scope.contMenuConfigs = 0;
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displayList || $scope.displaySubMenu) {
                        if ($scope.contMenuConfigs === 0) {
                            $scope.contMenuConfigs = 1;
                        } else {
                            $scope.cancel();
                            $scope.displaySubMenu = false;
                            $scope.contMenuConfigs = 0;
                        }
                    } else {
                        $scope.contMenuConfigs = 0;
                    }
                });
                //Close menu
                $scope.cancel = function () {
                    $scope.displayList = false;
                };

                $scope.description = '';
                $rootScope.$watch('contactListData', function (list) {
                    if (list && list.length) {
                        $scope.contactListData = list;
                        var desc = $scope.parseDescription($scope.data.selectedList, 'showDescription');

                        if (desc) {
                            $scope.description = desc;
                        }
                    }
                });
            }],
            link: function link(scope, elem, attr) {
                if ($rootScope.aElement) {
                    // bullet proving multiple targets
                    if (document.getElementById($rootScope.aElement.id)) {
                        delete $rootScope.aElement;
                        return false;
                    }

                    // load template
                    var template = $templateCache.get('active_templates/actions/active-add-to-list');

                    scope.left = $rootScope.aElement.left;
                    scope.top = $rootScope.aElement.top;
                    scope.id = $rootScope.aElement.id;
                    scope.color = $rootScope.aElement.color;
                    scope.type = $rootScope.aElement.type;
                    scope.data = $rootScope.aElement.data;
                    scope.contactListData = $rootScope.contactListData;
                    scope.numbers = '0';

                    delete $rootScope.aElement;

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('reporter_' + $rootScope.currentAPId + scope.id, function (evt, data) {
                        if (data) {
                            scope.numbers = data;
                        }
                    });
                }
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    angular.module('active-add-wait-time-action.dir', []).directive('activeAddWaitTimeAction', ['$rootScope', '$compile', '$templateCache', 'helpers', 'canvasService', '$timeout', activeAddWaitTimeAction]);

    function activeAddWaitTimeAction($rootScope, $compile, $templateCache, helpers, canvasService, $timeout) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;
                $scope.wasSave = false;

                // accepted values
                $scope.enums = {
                    minutes: 60,
                    hours: 24,
                    days: 365,
                    weeks: 52,
                    months: 12
                };

                //When we save a the form
                $scope.save = function () {
                    if ($scope.dataFilledCorrectly()) {
                        //Save to the global canvas object

                        $rootScope.currentJB = $rootScope.currentJB.map(function (i) {
                            if (i.id === $scope.naturalId) {
                                i.data.delay = $scope.data.delay;
                                i.data.units = $scope.data.units;
                            }

                            return i;
                        });

                        var currentNode = $rootScope.currentJB.filter(function (i) {
                            if (i.id === $scope.naturalId) {
                                return i;
                            }
                        });

                        var payload = {
                            JourneyName: $rootScope.currentJBTitle,
                            JourneyVersion: 1,
                            JourneyConfiguration: JSON.stringify($rootScope.currentJB),
                            JourneyTitle: $rootScope.currentJBTitle,
                            JourneyId: $rootScope.currentAPId,
                            NodeUpdated: JSON.stringify(currentNode[0])
                        };

                        canvasService.updateActivatedNodes(payload).then(function () {});

                        $scope.displayList = false;
                        $scope.isElegibleForUpdate = true;
                        $scope.displayActivateError = false;
                        $scope.displayErrorBlink = false;

                        $scope.wasSave = true;
                        $timeout(function () {
                            $scope.wasSave = false;
                        }, 1500);
                    }
                };

                // accepted values
                $scope.enums = {
                    minutes: 60,
                    hours: 24,
                    days: 365,
                    weeks: 52,
                    months: 12
                };

                $scope.parseDescription = function (delay, units) {
                    var textToParse = delay;

                    if (delay && units) {
                        var period = delay > 1 ? 'plural' : 'singular';

                        switch (units) {
                            case "minutes":
                                units = $scope.translate('canvas.action.addWaitTime.minutes.' + period);
                                $scope.data.units = '';
                                break;
                            case "hours":
                                units = $scope.translate('canvas.action.addWaitTime.hours.' + period);
                                break;
                            case "days":
                                units = $scope.translate('canvas.action.addWaitTime.days.' + period);
                                break;
                            case "weeks":
                                units = $scope.translate('canvas.action.addWaitTime.weeks.' + period);
                                break;
                            case "months":
                                units = $scope.translate('canvas.action.addWaitTime.months.' + period);
                                break;
                            default:
                                units = units;
                        }

                        textToParse = textToParse + ' ' + units.firstUpper();
                    } else {
                        textToParse = $scope.translate('commons.enterDetails');
                    }

                    return textToParse;
                };

                $scope.setUnits = function (delay) {
                    var period = delay > 1 ? 'plural' : 'singular';

                    $scope.units = {
                        hours: $scope.translate('canvas.action.addWaitTime.hours.' + period),
                        days: $scope.translate('canvas.action.addWaitTime.days.' + period),
                        weeks: $scope.translate('canvas.action.addWaitTime.weeks.' + period),
                        months: $scope.translate('canvas.action.addWaitTime.months.' + period)
                    };
                };

                var delay = 0;
                if ($scope.connections) {
                    delay = $scope.connections.data.delay;
                }
                $scope.setUnits(delay);

                // validates if data is filled correctly or not
                $scope.dataFilledCorrectly = function () {
                    var res = true;
                    $scope.errorUnits = false;
                    $scope.errorDelay = false;

                    if ($scope.data.delay && $scope.data.units) {
                        if ($scope.data.delay > $scope.enums[$scope.data.units]) {
                            $scope.data.delay = '';
                            $scope.errorDelay = true;
                            res = false;
                        }
                    }

                    if (!$scope.data.delay) {
                        $scope.errorDelay = true;
                        res = false;
                    }

                    if (!$scope.data.units) {
                        $scope.errorUnits = true;
                        res = false;
                    }

                    return res;
                };

                //Show or hide menu on Element click
                $scope.displayList = false;
                $scope.config = function () {
                    $scope.displayList = !$scope.displayList;
                };

                //Close menu
                $scope.cancel = function () {
                    $scope.displayList = false;
                };
            }],
            link: function link(scope, elem, attr) {
                if ($rootScope.aElement) {
                    // bullet proving multiple targets
                    if (document.getElementById($rootScope.aElement.id)) {
                        delete $rootScope.aElement;
                        return false;
                    }

                    // load template
                    var template = $templateCache.get('active_templates/actions/active-add-wait-time');
                    var modalTemplate = $templateCache.get('active_templates/actions/modal-active-add-wait-time');
                    scope.left = $rootScope.aElement.left;
                    scope.top = $rootScope.aElement.top;
                    scope.id = $rootScope.aElement.id;
                    scope.naturalId = helpers.getNaturalId(scope.id);
                    scope.color = $rootScope.aElement.color;
                    scope.type = $rootScope.aElement.type;
                    scope.data = $rootScope.aElement.data;
                    scope.numbers = '0';

                    delete $rootScope.aElement;

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    var modalContent = $compile(modalTemplate)(scope);
                    $('body').append(modalContent);

                    $rootScope.$on('reporter_' + $rootScope.currentAPId + scope.id, function (evt, data) {
                        if (data) {
                            scope.numbers = data;
                        }
                    });
                }
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    angular.module('active-facebook-audience.dir', []).directive('activeFacebookAudience', ['$rootScope', '$compile', '$templateCache', 'helpers', 'canvasService', activeFacebookAudience]);

    function activeFacebookAudience($rootScope, $compile, $templateCache, helpers, canvasService) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                $scope.parseTitle = function (desc) {
                    if (desc) {
                        var title = desc;
                        return title.name;
                    }

                    return desc;
                };

                $scope.defineTitle = function (title) {
                    if (title) {
                        if (title === '1') {
                            return 'Add to';
                        }
                        return 'Remove from';
                    }

                    return title;
                };

                //Show or hide menu on Element click
                $scope.config = function (evt) {
                    //Show form menu
                    if (!$scope.displayList) {
                        $scope.displayList = true;
                        if (!$scope.isFbConnect) {
                            $scope.testConn();
                        }
                    } else {
                        $scope.displayList = false;
                    }
                };

                $scope.cancel = function () {
                    $scope.displayList = false;
                };

                $scope.testConn = function () {
                    $scope.isLoading = true;
                    canvasService.getConnections().then(function (_ref) {
                        var data = _ref.data;

                        $scope.isFbConnect = data.ValidConnection;
                        if ($scope.isFbConnect) {
                            $scope.connectedUser = data.UserName || false;
                        }
                        $scope.isLoading = false;
                    }).catch(function () {
                        $scope.isFbConnect = false;
                        $scope.isLoading = false;
                    });
                };

                $rootScope.$on('hideFacebookAudienceModal', function () {
                    $scope.displayList = false;
                });
            }],
            link: function link(scope, elem, attr) {
                if ($rootScope.aElement) {
                    // bullet proving multiple targets
                    if (document.getElementById($rootScope.aElement.id)) {
                        delete $rootScope.aElement;
                        return false;
                    }

                    // load template
                    var template = $templateCache.get('active_templates/actions/active-facebook-audience'),
                        modalTemplate = $templateCache.get('active_templates/actions/modal-active-facebook-audience');

                    scope.left = $rootScope.aElement.left;
                    scope.top = $rootScope.aElement.top;
                    scope.id = $rootScope.aElement.id;
                    scope.color = $rootScope.aElement.color;
                    scope.type = $rootScope.aElement.type;
                    scope.data = $rootScope.aElement.data;
                    scope.audience = JSON.parse($rootScope.aElement.audience);
                    scope.numbers = '0';

                    delete $rootScope.aElement;

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    var modalContent = $compile(modalTemplate)(scope);
                    $('body').append(modalContent);

                    $rootScope.$on('reporter_' + $rootScope.currentAPId + scope.id, function (evt, data) {
                        if (data) {
                            scope.numbers = data;
                        }
                    });
                }
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    angular.module('active-looping-action.dir', []).directive('activeLoopingAction', ['$rootScope', '$compile', '$templateCache', 'helpers', 'canvasService', activeLoopingAction]);

    function activeLoopingAction($rootScope, $compile, $templateCache, helpers, canvasService) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;
                $scope.descriptionEmpty = false;

                $scope.getAPLists = function () {
                    if ($scope.lists) {
                        $scope.listView = true;
                    } else {
                        canvasService.getLists($scope.data.selectedList).success(function (res) {
                            $scope.lists = res;
                            $scope.listView = true;
                        });
                    }
                };

                $scope.getSelectedText = function (desc) {
                    if ($scope.data.selectedList.length === 1) {
                        for (var item in desc) {
                            desc = helpers.getContactListItem(desc[item], $scope.contactListData);
                        }

                        return desc;
                    } else {
                        var lists = [];

                        for (var i = 0; i < desc.length; i++) {
                            lists.push(helpers.getContactListItem(desc[i], $scope.contactListData));
                        }

                        return lists.join().replace(/,/g, '<br />');
                    }
                };

                $scope.parseDescription = function (desc, selected) {
                    var textToParse = desc;

                    if (textToParse && (typeof textToParse === 'undefined' ? 'undefined' : _typeof(textToParse)) === 'object') {

                        var descriptionCheck = false;
                        for (var item in textToParse) {
                            if (textToParse[item]) {

                                $scope.descriptionEmpty = false;
                                descriptionCheck = true;
                                var totalLists = $scope.data.selectedList.length;
                                textToParse = helpers.getContactListItem(textToParse[item], $scope.contactListData);

                                //One list selected and > 19
                                if (totalLists === 1 && textToParse.length > 15) {
                                    textToParse = textToParse.slice(0, 15) + '...';
                                    //More than one selected
                                } else if (totalLists > 1) {
                                    textToParse = totalLists + " Lists Selected";
                                }
                            }
                        }
                        if (!descriptionCheck) {
                            textToParse = parseDescriptionHelper(selected);
                        }
                    } else {
                        textToParse = parseDescriptionHelper(selected);
                    }

                    return textToParse;
                };

                var parseDescriptionHelper = function parseDescriptionHelper(selected) {
                    $scope.descriptionEmpty = true;
                    return selected === "showSelectedList" ? "" : "Description";
                };

                //Show or hide menu on Element click
                $scope.config = function (evt) {
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $scope.listView = false;
                    } else {
                        $scope.displayList = false;
                    }
                };

                $scope.contMenuConfigs = 0;
                $scope.stopMenuBroadcast = function () {
                    $scope.contMenuConfigs = 0;
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displayList || $scope.displaySubMenu) {
                        if ($scope.contMenuConfigs === 0) {
                            $scope.contMenuConfigs = 1;
                        } else {
                            $scope.cancel();
                            $scope.displaySubMenu = false;
                            $scope.contMenuConfigs = 0;
                        }
                    } else {
                        $scope.contMenuConfigs = 0;
                    }
                });
                //Close menu
                $scope.cancel = function () {
                    $scope.displayList = false;
                };

                $scope.description = '';
                $rootScope.$watch('contactListData', function (list) {
                    if (list && list.length) {
                        $scope.contactListData = list;
                        var desc = $scope.parseDescription($scope.data.selectedList, 'showDescription');

                        if (desc) {
                            $scope.description = desc;
                        }
                    }
                });
            }],
            link: function link(scope) {
                if ($rootScope.aElement) {
                    // bullet proving multiple targets
                    if (document.getElementById($rootScope.aElement.id)) {
                        delete $rootScope.aElement;
                        return false;
                    }

                    // load template
                    var template = $templateCache.get('active_templates/actions/active-looping');

                    scope.left = $rootScope.aElement.left;
                    scope.top = $rootScope.aElement.top;
                    scope.id = $rootScope.aElement.id;
                    scope.color = $rootScope.aElement.color;
                    scope.type = $rootScope.aElement.type;
                    scope.data = $rootScope.aElement.data;
                    scope.contactListData = $rootScope.contactListData;
                    scope.numbers = '0';

                    delete $rootScope.aElement;

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('reporter_' + $rootScope.currentAPId + scope.id, function (evt, data) {
                        if (data) {
                            scope.numbers = data;
                        }
                    });
                }
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    angular.module('active-remove-from-list-action.dir', []).directive('activeRemoveFromListAction', ['$rootScope', '$compile', '$templateCache', 'helpers', 'canvasService', activeRemoveFromListAction]);

    function activeRemoveFromListAction($rootScope, $compile, $templateCache, helpers, canvasService) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;
                $scope.descriptionEmpty = false;

                $scope.getAPLists = function () {
                    if ($scope.lists) {
                        $scope.listView = true;
                    } else {
                        canvasService.getLists($scope.data.selectedList).success(function (res) {
                            $scope.lists = res;
                            $scope.listView = true;
                        });
                    }
                };

                $scope.getSelectedText = function (desc) {
                    if ($scope.data.selectedList.length === 1) {
                        for (var item in desc) {
                            desc = helpers.getContactListItem(desc[item], $scope.contactListData);
                        }

                        return desc;
                    } else {
                        var lists = [];

                        for (var i = 0; i < desc.length; i++) {
                            lists.push(helpers.getContactListItem(desc[i], $scope.contactListData));
                        }

                        return lists.join().replace(/,/g, '<br />');
                    }
                };

                //Node metric show report
                $scope.showReport = function () {
                    var firstOccurrence = $scope.id.indexOf('_');
                    var secondOccurrence = $scope.id.indexOf('_', firstOccurrence + 1);
                    var elementId = $scope.id.slice(0, secondOccurrence);
                    canvasService.getNodeDetails($rootScope.currentAPId, elementId).then(function (res) {
                        return res.data;
                    }).then(function (nodeDetails) {
                        canvasService.getNodeMetricDetailsGroupByType($rootScope.currentAPId, nodeDetails.NodeId, nodeDetails.NodeActionType).then(function (res) {
                            var data = [nodeDetails, res.data];
                            $rootScope.$emit('summary', true, $rootScope.currentAPId, $rootScope.currentJBTitle, undefined, -1, false, true, data);
                        });
                    });
                };

                $scope.parseDescription = function (desc, selected) {
                    var textToParse = desc;

                    if (textToParse && (typeof textToParse === 'undefined' ? 'undefined' : _typeof(textToParse)) === 'object') {

                        var descriptionCheck = false;
                        for (var item in textToParse) {
                            if (textToParse[item]) {

                                $scope.descriptionEmpty = false;
                                descriptionCheck = true;
                                var totalLists = $scope.data.selectedList.length;
                                textToParse = helpers.getContactListItem(textToParse[item], $scope.contactListData);

                                //One list selected and > 19
                                if (totalLists === 1 && textToParse.length > 15) {
                                    textToParse = textToParse.slice(0, 15) + '...';
                                    //More than one selected
                                } else if (totalLists > 1) {
                                    textToParse = totalLists + " Lists Selected";
                                }
                            }
                        }
                        if (!descriptionCheck) {
                            textToParse = parseDescriptionHelper(selected);
                        }
                    } else {
                        textToParse = parseDescriptionHelper(selected);
                    }

                    return textToParse;
                };

                var parseDescriptionHelper = function parseDescriptionHelper(selected) {
                    $scope.descriptionEmpty = true;
                    return selected === "showSelectedList" ? "" : "Description";
                };

                //Show or hide menu on Element click
                $scope.config = function (evt) {
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $scope.listView = false;
                    } else {
                        $scope.displayList = false;
                    }
                };

                $scope.contMenuConfigs = 0;
                $scope.stopMenuBroadcast = function () {
                    $scope.contMenuConfigs = 0;
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displayList || $scope.displaySubMenu) {
                        if ($scope.contMenuConfigs === 0) {
                            $scope.contMenuConfigs = 1;
                        } else {
                            $scope.cancel();
                            $scope.displaySubMenu = false;
                            $scope.contMenuConfigs = 0;
                        }
                    } else {
                        $scope.contMenuConfigs = 0;
                    }
                });
                //Close menu
                $scope.cancel = function () {
                    $scope.displayList = false;
                };

                $scope.description = '';
                $rootScope.$watch('contactListData', function (list) {
                    if (list && list.length) {
                        $scope.contactListData = list;
                        var desc = $scope.parseDescription($scope.data.selectedList, 'showDescription');

                        if (desc) {
                            $scope.description = desc;
                            $scope.placeholder = false;
                        }
                    }
                });
            }],
            link: function link(scope, elem, attr) {
                if ($rootScope.aElement) {
                    // bullet proving multiple targets
                    if (document.getElementById($rootScope.aElement.id)) {
                        delete $rootScope.aElement;
                        return false;
                    }

                    // load template
                    var template = $templateCache.get('active_templates/actions/active-remove-from-list');

                    scope.left = $rootScope.aElement.left;
                    scope.top = $rootScope.aElement.top;
                    scope.id = $rootScope.aElement.id;
                    scope.color = $rootScope.aElement.color;
                    scope.type = $rootScope.aElement.type;
                    scope.data = $rootScope.aElement.data;
                    scope.contactListData = $rootScope.contactListData;
                    scope.numbers = '0';

                    delete $rootScope.aElement;

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('reporter_' + $rootScope.currentAPId + scope.id, function (evt, data) {
                        if (data) {
                            scope.numbers = data;
                        }
                    });
                }
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _subjectLinePicker = __webpack_require__(5);

var _subjectLinePicker2 = _interopRequireDefault(_subjectLinePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var moment = __webpack_require__(0);

(function () {
    angular.module('active-send-email-action.dir', []).directive('activeSendEmailAction', ['$rootScope', '$compile', '$templateCache', 'helpers', 'canvasService', '$stateParams', '$timeout', '$q', '$document', 'Session', activeSendEmailAction]);

    function activeSendEmailAction($rootScope, $compile, $templateCache, helpers, canvasService, $stateParams, $timeout, $q, $document, Session) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                var timezones = [{ value: 'ADT', offset: '-0300', label: '(US) Atlantic Daylight' }, { value: 'AST', offset: '-0400', label: '(US) Atlantic Standard' }, { value: 'AT', offset: '-0400', label: '(US) Atlantic' }, { value: 'CDT', offset: '-0500', label: '(US) Central Daylight' }, { value: 'CST', offset: '-0600', label: '(US) Central Standard' }, { value: 'CT', offset: '-0600', label: '(US) Central' }, { value: 'EDT', offset: '-0400', label: '(US) Eastern Daylight' }, { value: 'EST', offset: '-0500', label: '(US) Eastern Standard' }, { value: 'ET', offset: '-0500', label: '(US) Eastern' }, { value: 'MDT', offset: '-0600', label: '(US) Mountain Daylight' }, { value: 'MST', offset: '-0700', label: '(US) Mountain Standard' }, { value: 'MT', offset: '-0700', label: '(US) Mountain' }, { value: 'PDT', offset: '-0700', label: '(US) Pacific Daylight' }, { value: 'PST', offset: '-0800', label: '(US) Pacific Standard' }, { value: 'PT', offset: '-0800', label: '(US) Pacific' }, { value: 'ACDT', offset: '+1030', label: 'Australian Central Daylight' }, { value: 'ACST', offset: '+0930', label: 'Australian Central Standard' }, { value: 'AEDT', offset: '+1100', label: 'Australian East Daylight' }, { value: 'AEST', offset: '+1000', label: 'Australian East Standard' }, { value: 'SAD', offset: '+1000', label: 'Australian South Daylight' }, { value: 'SAST', offset: '+0900', label: 'Australian South Standard' }, { value: 'AWDT', offset: '+0900', label: 'Australian West Daylight' }, { value: 'AWST', offset: '+0800', label: 'Australian West Standard' }, { value: 'BT', offset: '+0300', label: 'Baghdad' }, { value: 'BET', offset: '-1100', label: 'Bering Standard' }, { value: 'BZT2', offset: '-0300', label: 'Brazil Zone 2' }, { value: 'BDST', offset: '+0200', label: 'British Double Summer' }, { value: 'BST', offset: '+0100', label: 'British Summer Time' }, { value: 'CAT', offset: '-1000', label: 'Central Alaska' }, { value: 'CED', offset: '+0200', label: 'Central European Daylight' }, { value: 'CCT', offset: '+0800', label: 'China Coast' }, { value: 'HKT', offset: '+0800', label: 'Hong Kong Time' }, { value: 'SGT', offset: '+0800', label: 'Singapore Time' }, { value: 'MYT', offset: '+0800', label: 'Malaysia Time' }, { value: 'CAF', offset: '+0200', label: 'Central Africa Time' }, { value: 'CET', offset: '+0100', label: 'Central European' }, { value: 'CEST', offset: '+0200', label: 'Central European Summer' }, { value: 'EED', offset: '+0300', label: 'Eastern European Daylight' }, { value: 'EET', offset: '+0200', label: 'Eastern Europe' }, { value: 'EEST', offset: '+0300', label: 'Eastern Europe Summer' }, { value: 'MED', offset: '+0200', label: 'European Middle Daylight' }, { value: 'MET', offset: '+0100', label: 'European Middle' }, { value: 'MEST', offset: '+0200', label: 'European Middle Summer' }, { value: 'MEWT', offset: '+0100', label: 'European Middle Winter' }, { value: 'FST', offset: '+0200', label: 'French Summer' }, { value: 'FWT', offset: '+0100', label: 'French Winter' }, { value: 'GMT', offset: '-0000', label: 'Greenwich Mean' }, { value: 'GMT', offset: '+0000', label: 'Greenwich Mean' }, { value: 'GST', offset: '+1000', label: 'Guam Standard' }, { value: 'HDT', offset: '-0900', label: 'Hawaii Daylight' }, { value: 'HST', offset: '-1000', label: 'Hawaii Standard' }, { value: 'IDLE', offset: '+1200', label: 'Internation Date Line East' }, { value: 'IDLW', offset: '-1200', label: 'Internation Date Line West' }, { value: 'IST', offset: '+0530', label: 'Indian Standard' }, { value: 'IT', offset: '+0330', label: 'Iran' }, { value: 'JST', offset: '+0900', label: 'Japan Standard' }, { value: 'JT', offset: '+0700', label: 'Java' }, { value: 'PMDT', offset: '-0200', label: 'Mid-Atlantic' }, { value: 'NDT', offset: '-0230', label: 'Newfoundland Daylight' }, { value: 'NFT', offset: '-0330', label: 'Newfoundland' }, { value: 'NT', offset: '-1100', label: 'Nome' }, { value: 'NST', offset: '+0630', label: 'North Sumatra' }, { value: 'NZST', offset: '+1200', label: 'New Zealand Standard' }, { value: 'NZDT', offset: '+1300', label: 'New Zealand Daylight ' }, { value: 'ROK', offset: '+0900', label: 'Republic of Korea' }, { value: 'SST', offset: '+0200', label: 'Swedish Summer' }, { value: 'SWT', offset: '+0100', label: 'Swedish Winter' }, { value: 'USZ3', offset: '+0400', label: 'USSR Zone 3' }, { value: 'USZ4', offset: '+0500', label: 'USSR Zone 4' }, { value: 'USZ5', offset: '+0600', label: 'USSR Zone 5' }, { value: 'USZ6', offset: '+0700', label: 'USSR Zone 6' }, { value: 'UTC', offset: '-0000', label: 'Universal Coordinated' }, { value: 'UZ10', offset: '+1100', label: 'USSR Zone 10' }, { value: 'WAT', offset: '-0100', label: 'West Africa' }, { value: 'WET', offset: '-0000', label: 'West European' }, { value: 'YDT', offset: '-0800', label: 'Yukon Daylight' }, { value: 'YST', offset: '-0900', label: 'Yukon Standard' }];

                var lang = Session.getCookie('L');
                $scope.faqHelpLink = {
                    english: 'https://kb.benchmarkemail.com/can-i-add-google-analytics-tracking-to-my-email-campaigns/',
                    spanish: 'https://kb.benchmarkemail.com/es/puedo-agregar-seguimiento-de-google-analytics-a-mis-campanas-de-correo-electronico/',
                    chineset: 'https://kb.benchmarkemail.com/cn/can-i-add-google-analytics-tracking-to-my-email-campaigns/',
                    chinese: 'https://kb.benchmarkemail.com/tw/can-i-add-google-analytics-tracking-to-my-email-campaigns/',
                    japanese: 'https://kb.benchmarkemail.com/jp/can-i-add-google-analytics-tracking-to-my-email-campaigns/',
                    italian: 'https://kb.benchmarkemail.com/it/posso-aggiungere-google-analytics-alla-mia-campagna-email/',
                    french: 'https://kb.benchmarkemail.com/fr/comment-ajouter-le-tracking-de-google-analytics-a-mes-campagnes-d-email/',
                    brazil: 'https://kb.benchmarkemail.com/br/posso-adicionar-o-monitoramento-do-google-analytics-nas-minhas-campanhas-de-email/',
                    german: 'https://kb.benchmarkemail.com/de/kann-ich-google-analytics-tracking-in-meine-e-mail-kampagnen-einfuegen/'
                }[lang || 'english'];

                // When it’s blank, we insert the email title (replace spaces with underlines)
                function initGoogleCampaign() {
                    if (!$scope.advancedEmailOptions.googleAnalyticsAllUrl) {
                        $scope.emailData.GoogleAnalyticsCampaign = '';
                    } else {
                        $scope.emailData.GoogleAnalyticsCampaign = $scope.emailData.EmailName.replace(/ /g, '_');
                    }
                }

                $rootScope.summaries = {};

                var naturalElement = helpers.getNaturalId($rootScope.aElement.id);
                var emailDetailsPromises = [];

                // Get the ToListId and ToListName from email parent for assign to the new emails versions
                var listId = $rootScope.aElement.emailData.ToListId;
                var enableNode = false;
                var timezone = void 0;

                // Init email options for show every email details
                $scope.emailDetailsOptions = [];
                $scope.emailVersions = [];

                // Init for duplicate email
                $scope.duplicateModal = false;
                $scope.duplicateSettings = [];
                $scope.duplicateName = '';

                // Init default filter for create new automation email
                $scope.sortList = '-EmailTemplateCreatedDate';

                function initEmails() {
                    if ($scope.emailDetailsOptions.length === 0) {
                        // Get the activated email for this element ($scope.naturalId)
                        canvasService.getActiveEmails(naturalElement, $stateParams.canvasId).then(function (response) {
                            // TODO This logic has to disappear when the BE response return the correct information
                            var draft = response.data.filter(function (draft) {
                                return draft.UIStatus === 1;
                            }),
                                active = response.data.filter(function (active) {
                                return active.UIStatus === 2;
                            }),
                                result = [];

                            if (active && active.length) {
                                result.push(active.pop());
                            }

                            if (draft && draft.length) {
                                result.push(draft[0]);
                            }

                            return result;
                        }).then(function (emails) {
                            for (var i = 0, l = emails.length; i < l; i++) {
                                emailDetailsPromises.push(canvasService.getEmailDetails(emails[i].EmailId));

                                // Push every email
                                $scope.emailVersions.push(emails[i]);
                            }
                            return emailDetailsPromises;
                        }).then(function (emailDetails) {
                            return $q.all(emailDetails);
                        }).then(function (details) {
                            for (var i = 0, l = details.length; i < l; i++) {
                                $scope.emailDetailsOptions.push(details[i].data);

                                // We assign the email name to every version that comes from details
                                $scope.emailVersions[i].emailName = details[i].data.EmailName;
                                $scope.emailVersions[i].editor = details[i].data.Version;
                            }

                            // Assign the active email for show in the node
                            $scope.activeEmail = $scope.emailVersions.find(function (email) {
                                return email.UIStatus === 2;
                            });
                            $rootScope.$emit('getActiveEmails', true);
                            enableNode = true;

                            // Client settings
                            return canvasService.getClientSettings();
                        }).then(function (settings) {
                            timezone = _.find(timezones, function (timezone) {
                                return timezone.value === settings.data.Response.TimeZone;
                            });
                        }).catch(function (error) {
                            console.log(error);
                        });
                    }
                }
                // Load emails list
                function loadEmailListAsync() {
                    if (!$rootScope.emailData) {
                        canvasService.getEmailList(0, 5).success(function (data) {
                            $rootScope.emailData = data.Results;
                            $scope.emailList = $rootScope.emailData;
                            $scope.setScrollLogic($scope.id);
                        });
                    } else {
                        $scope.emailList = $rootScope.emailData;
                        $scope.setScrollLogic($scope.id);
                    }
                }

                function loadTrashEmailListAsync() {
                    if (!$rootScope.trashList) {
                        canvasService.getTrashEmails().then(function (_ref) {
                            var data = _ref.data;

                            $rootScope.trashList = data.Results;
                            $rootScope.trashCount = data.Results && data.Results.length || 0;
                        });
                    }
                };

                $scope.displaySearchInput = function (show) {
                    var input = document.getElementById("search-email");
                    $scope.displaySearch = show;
                    $scope.search.email = '';

                    input.focus();
                };

                var checkPermissionReminder = function checkPermissionReminder() {
                    if (!$scope.data.permisionReminder) {
                        return true;
                    } else if ($scope.emailData.PermissionReminderMessage !== '') {
                        return true;
                    } else {
                        return false;
                    }
                };

                // Validate form email inputs
                function validateFields(status) {
                    var partialRes = void 0,
                        emailName = $scope.emailData.EmailName,
                        deferred = $q.defer();

                    if (!$scope.emailData.Subject || !emailName || !$scope.emailData.FromName || !$scope.emailData.FromEmail || !$scope.emailData.ReplyEmail) {

                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.601'));
                        $scope.sbjErr = $scope.emailData.Subject === '';
                        $scope.eNameErr = emailName === '';
                        $scope.eFromErr = $scope.emailData.FromName === '';
                        $scope.eFromSubjErr = $scope.emailData.FromEmail === '';
                        $scope.eFromReplyErr = $scope.emailData.ReplyEmail === '';

                        partialRes = true;
                    }

                    if (checkPermissionReminder() || $scope.advancedEmailOptions.googleAnalyticsAllUrl && !$scope.emailData.GoogleAnalyticsCampaign || $scope.advancedEmailOptions.pageTextTextarea && !$scope.emailData.InboxPreviewText) {

                        $scope.permError = $scope.emailData.PermissionReminderMessage === '' && $scope.advancedEmailOptions.permisionReminder;
                        $scope.analyticsError = $scope.emailData.GoogleAnalyticsCampaign === '' && $scope.advancedEmailOptions.googleAnalyticsAllUrl;
                        $scope.pgTextError = $scope.emailData.InboxPreviewText === '' && $scope.advancedEmailOptions.pageTextTextarea;

                        partialRes = $scope.analyticsError || $scope.permError || $scope.pgTextError || partialRes;
                    }

                    if (!partialRes) {
                        $scope.sbjErr = $scope.eNameErr = $scope.eFromErr = $scope.eFromSubjErr = $scope.eFromReplyErr = false;
                        $scope.permError = $scope.analyticsError = $scope.pgTextError = false;
                        if (status !== 'updateEmail') {
                            canvasService.validateDuplicateEmailName(emailName).success(function (res) {
                                if (res.IsUniqueName) {
                                    $scope.eNameErr = false;
                                    $scope.storedEmailName = emailName;
                                    $scope.emailChanged = false;
                                    deferred.resolve();
                                } else {
                                    $rootScope.$emit('errorMsg', $scope.translate('canvas.action.sendEmail.duplicateEmailName'));
                                    $scope.eNameErr = true;
                                    deferred.reject();
                                }
                            }).error(function (err) {
                                var error = err.Message || $scope.translate('canvas.error.601');
                                //Error msg from backend when failing
                                $rootScope.$emit('errorMsg', error);
                                $scope.eNameErr = true;
                                deferred.reject();
                            });
                        } else {
                            deferred.resolve();
                        }
                    } else {
                        deferred.reject();
                    }

                    return deferred.promise;
                }

                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                $scope.advancedOptionsTitle = true;

                // Init email address list for select
                if (!$rootScope.userEmailAddress) {
                    canvasService.getUserEmailAddress().success(function (data) {
                        $rootScope.userEmailAddress = data.Results || [];
                        $scope.emailAddressList = $rootScope.userEmailAddress.map(function (obj) {
                            return obj.Email;
                        });
                    });
                }

                // Init emails options
                initEmails();

                $scope.showEmailOptions = function () {
                    $scope.emailOptionsAvailable = true;
                };

                $scope.chooseEmailOption = function (option) {
                    $scope.emailOption = option;
                    $scope.emailOptionsAvailable = false;
                };

                $scope.isCopyAndEdit = false;
                $scope.showDuplicateModal = function () {
                    Intercom('trackEvent', 'AP - NewEmailVersion');
                    var modalTemplate = $templateCache.get('actions/send-email-modal'),
                        modalContent = void 0;

                    //Create template and compile it
                    if (!$('.modal-email-form-' + $scope.connections.id).length) {
                        modalContent = $compile(modalTemplate)($scope);
                        $('body').append(modalContent);
                    }

                    $scope.isCopyAndEdit = true;
                    $scope.modalWindow = true;
                    $scope.duplicateModal = true;
                };

                // Show Email Modal (Automation Email)
                $scope.showSendEmailModal = function () {
                    Intercom('trackEvent', 'AP - NewEmailVersion');
                    var modalTemplate = $templateCache.get('actions/send-email-modal'),
                        modalContent = void 0;

                    //Create template and compile it
                    if (!$('.modal-email-form-' + $scope.connections.id).length) {
                        modalContent = $compile(modalTemplate)($scope);
                        $('body').append(modalContent);
                    }

                    // Init variables for reuse modal
                    $scope.modalWindow = true;
                    $scope.selectedView = false;
                    $scope.search = {};

                    loadEmailListAsync();
                    loadTrashEmailListAsync();

                    // Get values from selects
                    if (!$rootScope.userEmailAddress) {
                        canvasService.getUserEmailAddress().success(function (data) {
                            $rootScope.userEmailAddress = data.Results || [];
                            $scope.emailAddressList = $rootScope.userEmailAddress.map(function (obj) {
                                return obj.Email;
                            });
                        });
                    }

                    // Search functionality Email Modal (Automation Email)
                    $scope.search.search = function (val) {
                        if (val && val.length > 0 && !$scope.searching) {
                            $scope.searching = true;
                            canvasService.searchEmails(val).then(function (res) {
                                $scope.searching = false;
                                $scope.emailList = res.data.Results;
                            }).catch(function () {
                                $scope.searching = false;
                            });
                        } else {
                            $scope.emailList = $rootScope.emailData;
                        }
                    };
                };

                // Create new automation email
                $scope.createNew = function () {
                    $scope.selectedView = true;
                    $scope.showAddSendEmailModal = true;
                    $scope.displayEmailForm = true;
                    $scope.displayList = true;
                    $scope.showEmailVersions = false;
                    $scope.modalWindow = false;
                    $scope.emailOptionsAvailable = false;
                    $scope.isEditable = true;

                    $scope.mergeTags = helpers.getMergeTags($rootScope.loaderData);

                    // Init new email data (First view)
                    $scope.emailData = {
                        Subject: '',
                        EmailName: '',
                        FromName: $rootScope.emptyEmail.FromName,
                        FromEmail: $rootScope.emptyEmail.FromEmail,
                        ReplyEmail: $rootScope.emptyEmail.ReplyEmail,
                        GoogleAnalyticsCampaign: '',
                        PermissionReminderMessage: $rootScope.emptyEmail.PermissionReminderMessage,
                        WebpageVersion: true,
                        TemplateContent: '',
                        InboxPreviewText: ''
                    };

                    if (!$scope.mergeTags.length) {
                        $scope.showTagDefault = true;
                        $scope.emailData.ToListId = '';
                        $scope.emailData.ToListName = '';
                    } else if ($scope.emailData && !$scope.emailData.ToListId) {
                        $scope.emailData.ToListId = $scope.mergeTags[0].id;
                    } else {
                        $scope.emailData.ToListId = $scope.emailData.ToListId + '';
                    }

                    // Init Advanced Email Options (Second view)
                    $scope.advancedEmailOptions = {
                        pageTextTextarea: false,
                        googleAnalyticsAllUrl: false,
                        editorType: '',
                        permisionReminder: true
                    };
                };

                $scope.$watch('emailData.ToListId', function (value) {
                    if ($scope.mergeTags) {
                        $scope.emailData.ToListName = $scope.mergeTags.find(function (tag) {
                            return tag.id === value;
                        }).name;
                    }
                });

                // Reuse existing automation email
                $scope.insertExisting = function (emailId, fromEditor) {
                    var emailName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Copy';

                    $scope.isFromEditor = fromEditor;
                    $scope.currentDuplicateEmailId = emailId;
                    $scope.duplicateName = emailName + ' Copy';
                    $scope.duplicateModal = !$scope.duplicateModal;
                    canvasService.generateThumbs(emailId).then(function () {});
                };

                // Scroll for get more results
                $scope.setScrollLogic = function (id) {
                    $scope.emailListLoader = false;
                    angular.element(document.getElementById('listEmailContainer' + id)).bind("scroll", function () {
                        if (!$scope.emailListLoader && !$rootScope.stopLoadingEmailList && !$scope.search.email) {
                            $scope.emailListLoader = true;
                            canvasService.getEmailList($rootScope.emailListOffset, 5).success(function (data) {
                                if (!data.Results.length) {
                                    $rootScope.stopLoadingEmailList = true;
                                } else {
                                    $rootScope.emailListOffset++;
                                    $rootScope.emailData = _.uniqBy($rootScope.emailData.concat(data.Results), 'EmailTemplateId');
                                    $scope.emailList = $rootScope.emailData;
                                }
                                $scope.emailListLoader = false;
                            }).error(function () {
                                $scope.emailListLoader = false;
                            });
                        }
                    });
                };

                var inProcess = false;
                $scope.moveToTrash = function (eId) {
                    if (!inProcess) {
                        inProcess = true;
                        canvasService.trashEmail(eId).then(function () {
                            var index = $rootScope.emailData.findIndex(function (i) {
                                return i.EmailTemplateId == eId;
                            });
                            var splicedEl = $rootScope.emailData.splice(index, 1);
                            $scope.emailList = $rootScope.emailData;

                            delete splicedEl.$$hashKey;
                            $rootScope.trashList.unshift(splicedEl[0]);
                            $rootScope.trashCount++;
                        }).finally(function () {
                            inProcess = false;
                        });
                    }
                };

                $scope.restoreEmail = function (eId) {
                    if (!inProcess) {
                        inProcess = true;
                        canvasService.restoreTrashEmail(eId).then(function () {
                            var index = $rootScope.trashList.findIndex(function (i) {
                                return i.EmailTemplateId == eId;
                            });
                            var splicedEl = $rootScope.trashList.splice(index, 1);
                            $rootScope.trashCount--;

                            delete splicedEl.$$hashKey;
                            $rootScope.emailData.unshift(splicedEl[0]);
                            $scope.emailList = $rootScope.emailData;
                        }).finally(function () {
                            inProcess = false;
                        });
                    }
                };

                $scope.listView = true;
                $scope.toggleEmailsView = function (display) {
                    $scope.listView = display;
                };

                $scope.validClickingArea = function () {
                    $scope.contMenu = 0;
                };

                // Hide Email Modal (Automation Email)
                $scope.hideModal = function () {
                    $scope.modalWindow = false;
                    $scope.displayList = false;
                    $scope.selectedView = true;
                    $rootScope.$emit('displayExtraVeil', false);
                    $rootScope.$emit('hideActionSendEmailModal');
                    if ($scope.search) {
                        $scope.search.email = '';
                    }
                    $scope.emailList = $rootScope.emailData;
                };

                // Save new duplicate email
                $scope.saveDuplicate = function () {
                    var payload = void 0,
                        emailCreated = void 0;

                    if ($scope.duplicateName) {
                        $scope.duplicateError = false;
                        $scope.didReuse = false;
                        $scope.reuse = false;
                        $scope.duplicating = true;

                        // Validate that email name does not exist
                        canvasService.validateDuplicateEmailName($scope.duplicateName).then(function (response) {
                            if (response.data.IsUniqueName) {
                                // Create new payload
                                payload = {
                                    EmailName: $scope.duplicateName,
                                    JourneyId: $stateParams.canvasId,
                                    JourneyVersion: 1,
                                    ElementId: $scope.naturalId
                                };

                                // Create new email draft
                                return canvasService.createDuplicateActivated(payload, $scope.currentDuplicateEmailId);
                            } else {
                                // This response does not return a fail for catch the error we need to reject
                                return $q.reject($scope.translate('canvas.action.sendEmail.duplicateEmailName'));
                            }
                        }).then(function (_ref2) {
                            var data = _ref2.data;

                            emailCreated = data;
                            // Create email versions
                            return canvasService.getActiveEmails($scope.naturalId, $stateParams.canvasId);
                        }).then(function (emails) {
                            // TODO This logic has to disappear when the BE response return the correct information
                            var draft = emails.data.filter(function (draft) {
                                return draft.UIStatus === 1;
                            }),
                                active = emails.data.filter(function (active) {
                                return active.UIStatus === 2;
                            });

                            $scope.emailVersions = [];

                            if (active && active.length) {
                                $scope.emailVersions.push(active.pop());
                            }

                            if (draft && draft.length) {
                                $scope.emailVersions.push(draft[0]);
                            }

                            // Assign new values to array of version and details
                            $scope.emailDetailsOptions.push(emailCreated);

                            // Assign the name of the email to every version
                            for (var i = 0, l = $scope.emailVersions.length; i < l; i++) {
                                $scope.emailDetailsOptions[i].Id = $scope.emailVersions[i].EmailId;
                                $scope.emailVersions[i].emailName = $scope.emailDetailsOptions[i].EmailName;
                                $scope.emailVersions[i].editor = $scope.emailDetailsOptions[i].Version;
                                canvasService.generateThumbs($scope.emailVersions[i].EmailId).then(function () {});
                            }

                            $scope.duplicating = false;
                            $scope.didReuse = true;
                            $scope.reuse = true;
                            $scope.duplicateName = '';
                            $scope.duplicateModal = !$scope.duplicateModal;
                            $rootScope.$emit('displayExtraVeil', false);
                            $scope.hideModal();
                        }).catch(function (error) {
                            $rootScope.$emit('errorMsg', error);
                            $scope.duplicateName = '';
                            $scope.duplicating = false;
                        });
                    } else {
                        $scope.duplicateError = true;
                    }
                };

                // Close option for reuse email
                $scope.cancelDuplicate = function () {
                    $scope.duplicateModal = !$scope.duplicateModal;

                    if ($scope.isCopyAndEdit) {
                        $scope.isCopyAndEdit = false;
                        $scope.modalWindow = false;
                        $scope.displayList = false;
                        $scope.selectedView = true;
                    }
                };

                $scope.copyEmail = function (emailId, emailName) {
                    $scope.isFromEditor = true;
                    $scope.currentDuplicateEmailId = emailId;
                    $scope.duplicateName = emailName + ' Copy';
                    $scope.showDuplicateModal();
                };

                // Save new email function
                $scope.save = function () {
                    var status = 'fromEmail';
                    if ($scope.emailData.Id) {
                        status = 'updateEmail';
                    }

                    validateFields(status).then(function () {
                        if (status === 'updateEmail') {
                            // this is an update email action
                            canvasService.updateEmailData($scope.emailData.Id, $scope.emailData).success(function (id) {
                                if (id) {
                                    $timeout(function () {
                                        $scope.cancel();
                                    }, 100);
                                }
                            });
                        } else {
                            $scope.editorSubMenu = true;
                            $scope.displayList = false;
                        }
                    }).catch(function () {
                        var errors = {
                            sbjErr: $scope.sbjErr,
                            eNameErr: $scope.eNameErr,
                            eFromErr: $scope.eFromErr,
                            eFromSubjErr: $scope.eFromSubjErr,
                            eFromReplyErr: $scope.eFromReplyErr,
                            permError: $scope.permError,
                            analyticsError: $scope.analyticsError,
                            pgTextError: $scope.pgTextError
                        };

                        $rootScope.$emit('displayActionSendEmailModalError', errors);
                    });
                };

                $scope.switcher = function (type) {
                    switch (type) {
                        case 'permisionReminder':
                            $scope.advancedEmailOptions.permisionReminder = !$scope.advancedEmailOptions.permisionReminder;
                            if ($scope.advancedEmailOptions.permisionReminder) {
                                var orgName = $rootScope.cSettings ? $rootScope.cSettings.ClientCompany : '';
                                $scope.emailData.PermissionReminderMessage = $scope.translate('canvas.action.sendEmail.permisionReminder1') + orgName + $scope.translate('canvas.action.sendEmail.permisionReminder2');
                            } else {
                                $scope.emailData.PermissionReminderMessage = '';
                            }
                            break;
                        case 'webPageVersion':
                            $scope.emailData.WebpageVersion = !$scope.emailData.WebpageVersion;
                            break;
                        case 'previewText':
                            $scope.advancedEmailOptions.pageTextTextarea = !$scope.advancedEmailOptions.pageTextTextarea;
                            break;
                        case 'googleAnalyticsAllUrl':
                            $scope.advancedEmailOptions.googleAnalyticsAllUrl = !$scope.advancedEmailOptions.googleAnalyticsAllUrl;
                            initGoogleCampaign();
                            break;
                    }
                };

                $rootScope.$on('activeRedirectTo', function (event, type, fromDetails, designLink) {
                    var _onError = function _onError(err) {
                        //Error msg from backend when failing
                        if (helpers.getJourneyFirstList() == '11111111') {
                            $rootScope.$emit('errorMsg', $scope.translate('canvas.error.613'));
                        } else {
                            $rootScope.$emit('errorMsg', err.Message);
                        }

                        //Close loader
                        $rootScope.$emit('jbLoader', false);

                        //When fail we open the list and show another error mesg
                        $scope.displayList = true;
                    };

                    var _next = function _next() {
                        canvasService.redirectToEditor($scope.emailData.Version, $scope.advancedEmailOptions.emailId, $stateParams.canvasId);
                    };

                    if (type) {
                        $rootScope.$emit('jbLoader', true);

                        if (fromDetails) {
                            _next();
                        } else {
                            var journeyPayload = void 0,
                                payload = void 0;

                            journeyPayload = {
                                JourneyId: $stateParams.canvasId,
                                JourneyVersion: 1,
                                ElementId: $scope.naturalId
                            };

                            $scope.emailData.Version = canvasService.getVersionByType(type);

                            // Dummy email bullet proof
                            if ($scope.emailData.ToListId === '11111111') {
                                $scope.emailData.ToListId = 0;
                            }

                            payload = angular.merge($scope.emailData, journeyPayload);

                            canvasService.createDraftEmail(payload).then(function (response) {
                                angular.merge($scope.emailData, payload);
                                $scope.advancedEmailOptions.emailId = response.data;
                                _next();
                            }).catch(_onError);
                        }
                    }
                });

                $scope.parseEmailTitle = function (desc, limit) {
                    if (desc) {
                        if (desc.length > limit) {
                            desc = desc.slice(0, limit) + '...';
                        }
                    }

                    return desc;
                };

                $scope.parseDescription = function (desc) {
                    var textToParse = desc;

                    if (desc) {
                        if (textToParse.length > 15) {
                            textToParse = textToParse.slice(0, 15) + '...';
                            //Desc < 15
                        } else if (textToParse.length < 15) {
                            textToParse = textToParse;
                        }
                    } else {
                        textToParse = 'Description';
                    }

                    return textToParse;
                };

                $scope.getListName = function () {
                    return $scope.emailData.ToListName || $rootScope.segmentSelected || $rootScope.listSelected || '';
                };

                $scope.selectedCancel = function () {
                    $scope.selectedView = false;
                };

                $scope.config = function (evt) {
                    if (!enableNode) {
                        return;
                    }
                    var type = 'displayList';
                    if ($scope.data.emailId) {
                        $scope[type] = false;
                        type = 'selectedView';
                    }

                    if (!$rootScope.isSibligNodeOpen && !$scope[type] || $rootScope.isSibligNodeOpen && $scope[type]) {
                        if ($scope.editorSubMenu) {
                            $scope.editorSubMenu = false;
                            $scope.displayList = true;
                            $scope.selectedView = false;

                            if ($scope.data.emailId) {
                                $scope.data.emailStatus = 'updateEmail';
                            } else {
                                $scope.data.emailStatus = 'createNew';
                            }
                        } else {
                            //Show form menu
                            $scope[type] = !$scope[type];

                            // Detect when a sibling element is open
                            if ($scope[type]) {
                                $rootScope.isSibligNodeOpen = true;
                                $rootScope.siblingEmailName = $scope.activeEmail.emailName;
                            } else {
                                $rootScope.isSibligNodeOpen = false;
                            }

                            // add z-index to canvas to avoid elements overlap
                            if (type === 'selectedView') {
                                $rootScope.$emit('zIndex', $scope[type]);
                            }
                        }
                        $scope.displaySubMenu = false;
                    }
                };

                $scope.showDetails = function (id, status) {
                    $scope.displayList = true;
                    $scope.selectedView = true;
                    $scope.modalWindow = false;
                    $scope.editorSubMenu = false;
                    $scope.mergeTags = [];

                    // Find email d ata base on id
                    $scope.emailData = $scope.emailDetailsOptions.find(function (email) {
                        return parseInt(email.Id) === id;
                    });

                    $scope.mergeTags.push({
                        id: $scope.emailData.ToListId,
                        name: $scope.emailData.ToListName
                    });

                    $scope.advancedEmailOptions = {
                        pageTextTextarea: $scope.emailData.InboxPreviewText !== '',
                        googleAnalyticsAllUrl: $scope.emailData.GoogleAnalyticsCampaign !== '',
                        permisionReminder: $scope.emailData.PermissionReminderMessage !== ''
                    };

                    if (status === 1) {
                        $scope.isEditable = true;
                    }

                    if (status === 2) {
                        $scope.isEditable = false;
                    }
                };

                // when the design button is clicked
                $scope.sendToEditor = function (editor, emailId) {
                    canvasService.redirectToEditor(editor, emailId, $stateParams.canvasId);
                };

                $scope.reportsView = true;
                $scope.showReport = function (emailName) {
                    Intercom('trackEvent', 'AP - EmailReport');
                    $rootScope.$emit('summary', true, $stateParams.canvasId, $rootScope.currentJBTitle, emailName);
                };

                $scope.showVersions = function ($event) {
                    $event.stopPropagation();
                    $scope.isVersionsAvailable = !$scope.isVersionsAvailable;
                };

                //Cancel Button
                $scope.cancel = function () {
                    $scope.displayList = false;

                    // Put merge tags null if the user go back to versions
                    $scope.mergeTags = null;
                };

                // Close all modals
                $scope.close = function () {
                    $scope.displayList = false;
                    $scope.selectedView = false;

                    $rootScope.isSibligNodeOpen = false;

                    // add z-index to canvas to avoid elements overlap
                    $rootScope.$emit('zIndex', $scope['selectedView']);
                };

                // Functionality for show make active draft modal
                $scope.activeDraftModal = function (id) {
                    $scope.showActiveDraftModal = true;
                    $scope.selectedView = false;
                    $scope.displayList = false;
                    $scope.editorSubMenu = false;
                    $scope.draftEmailId = id;
                };

                // Hide make active draft modal
                $scope.hideActiveDraftModal = function () {
                    $scope.showActiveDraftModal = false;
                    $scope.selectedView = true;
                    $scope.displayList = false;
                    $scope.editorSubMenu = false;
                };

                // Call event for active draft email
                $scope.activeDraft = function () {
                    $rootScope.$emit('activeDraftEmail');
                };

                // Active draft email event
                $rootScope.$on('activeDraftEmail', function () {
                    if ($scope.draftEmailId) {
                        var email = $scope.emailVersions.find(function (email) {
                            return email.EmailId === $scope.draftEmailId;
                        }),
                            payload = void 0;

                        payload = {
                            JourneyId: email.JourneyId,
                            JourneyVersion: email.JourneyVersion,
                            ElementId: $scope.naturalId
                        };
                        $scope.loadingActivateDraft = true;
                        canvasService.activeDraftEmail(payload, email.Vertsion).then(function () {
                            // Change the status of the draft email to active and assign last update new date
                            email.UIStatus = 2;
                            email.ActivationDate = new Date();

                            // Filter emails
                            $scope.emailVersions = $scope.emailVersions.filter(function (email) {
                                return email.EmailId === $scope.draftEmailId;
                            });
                            $scope.emailDetailsOptions = $scope.emailDetailsOptions.filter(function (email) {
                                return parseInt(email.Id) === $scope.draftEmailId;
                            });

                            // Assign new value to active email to the node
                            $scope.activeEmail = $scope.emailVersions.find(function (email) {
                                return email.UIStatus === 2;
                            });
                            $rootScope.siblingEmailName = $scope.activeEmail.emailName;

                            // Execute listener to get the email versions, when a email its activated
                            $rootScope.$emit('getActiveEmails', true);
                            Intercom('trackEvent', 'AP - ActivateEmail');

                            $scope.showActiveDraftModal = false;
                            $scope.selectedView = true;
                            $scope.displayList = false;
                            $scope.editorSubMenu = false;
                            $scope.draftEmailId = null;
                            $scope.loadingActivateDraft = false;
                        }).catch(function (error) {
                            $scope.loadingActivateDraft = false;
                        });
                    }
                });

                // Functionality for show delete draft modal
                $scope.deleteDraftModal = function (id) {
                    // The modal its outside this view we need to attach to root the variable
                    $scope.$root.showDeleteDraftModal = true;
                    $scope.draftEmailId = id;
                    $scope.displayList = false;
                    $scope.selectedView = false;
                };

                // Hide delete draft email modal
                $scope.$root.hideDeleteDraftModal = function () {
                    $scope.$root.showDeleteDraftModal = false;
                    $scope.$root.displayList = true;
                    $scope.selectedView = true;
                };

                // Call event for delete draft email
                $scope.$root.deleteDraft = function () {
                    $rootScope.$emit('deleteDraftEmail');
                    $timeout(function () {
                        $scope.$root.displayList = true;
                        $scope.selectedView = true;
                    }, 500);
                };

                // Delete draft email
                $rootScope.$on('deleteDraftEmail', function () {
                    if ($scope.draftEmailId) {
                        var email = $scope.emailVersions.find(function (email) {
                            return email.EmailId === $scope.draftEmailId;
                        }),
                            payload = void 0;

                        payload = {
                            JourneyId: email.JourneyId,
                            JourneyVersion: email.JourneyVersion,
                            ElementId: $scope.naturalId
                        };

                        canvasService.deleteDraftEmail(payload, email.Vertsion).then(function () {
                            $scope.emailVersions = $scope.emailVersions.filter(function (email) {
                                return email.EmailId !== $scope.draftEmailId;
                            });
                            $scope.emailDetailsOptions = $scope.emailDetailsOptions.filter(function (email) {
                                return parseInt(email.Id) !== $scope.draftEmailId;
                            });
                            $scope.$root.showDeleteDraftModal = false;
                            $scope.draftEmailId = null;
                        }).catch(function (error) {
                            console.log(error);
                        });
                    }
                });

                $scope.previewEmail = function (emailId) {
                    $scope.isPreviewOpen = true;
                    $scope.displayList = false;
                    $scope.selectedView = false;

                    $rootScope.$emit('previewEmail', '', '', '', $scope.id);
                    $("#dvPreviewContent").html("<div class=\"loading-animation\"><span></span><span></span><span></span><span></span></div>");
                    canvasService.getPreview(emailId).then(function (_ref3) {
                        var data = _ref3.data;

                        if (data.Response.ID) {
                            var obj = data.Response;
                            var content = obj.TemplateContent;
                            if (content.indexOf("<!-- /Footer Path -->") != -1) {
                                content = content.substring(0, content.indexOf("<!-- /Footer Path -->"));
                            }
                            $("#dvPreviewContent").html("");
                            var iframe = document.createElement('iframe');
                            $(iframe).attr("id", "ifrPreviewContent");
                            $("div#dvPreviewContent").append(iframe);
                            iframe.contentWindow.document.open();
                            iframe.contentWindow.document.write(content);
                            iframe.contentWindow.document.close();
                        } else {
                            alert("Could not load Preview");
                        }
                    });
                };

                // Get the active emails of every node
                $rootScope.$on('getActiveEmails', function (evt, doEmit) {
                    if (doEmit) {
                        var active = $scope.emailVersions.find(function (email) {
                            return email.UIStatus === 2;
                        });

                        $rootScope.summaries[$scope.naturalId] = {
                            emailId: active.EmailId,
                            emailName: active.emailName,
                            elementId: $scope.naturalId
                        };

                        $rootScope.$emit('newActiveEmail' + $scope.naturalId, $rootScope.summaries[$scope.naturalId]);
                    }
                });

                // Default value for editor
                $scope.editor = 'dad';

                $scope.redirectTo = function (id) {
                    $rootScope.$emit('activeRedirectTo', id);
                    $scope.editorSubMenu = false;
                };

                $scope.editorSwitcher = function (editor) {
                    $scope.editor = editor;
                };

                $scope.hideEditorModal = function () {
                    $scope.editorSubMenu = false;
                };

                $scope.sortBy = function (val) {
                    $scope.sortList = val;
                };

                $scope.toggleEmojiModal = function () {
                    $scope.displayEmojiModal = !$scope.displayEmojiModal;
                    $scope.selectedView = !$scope.selectedView;
                    $scope.displayList = !$scope.displayList;
                };
            }],
            link: function link(scope, elem, attr) {
                if ($rootScope.aElement) {
                    // bullet proving multiple targets
                    if (document.getElementById($rootScope.aElement.id)) {
                        delete $rootScope.aElement;
                        return false;
                    }

                    // load template
                    var template = $templateCache.get('active_templates/actions/active-send-email');
                    var modalTemplate = $templateCache.get('active_templates/actions/active-send-email-modal');
                    scope.connections = scope.connections || {};
                    scope.left = $rootScope.aElement.left;
                    scope.top = $rootScope.aElement.top;
                    scope.id = $rootScope.aElement.id;
                    scope.connections.id = scope.id;
                    scope.naturalId = helpers.getNaturalId(scope.id);
                    scope.color = $rootScope.aElement.color;
                    scope.type = $rootScope.aElement.type;
                    scope.data = $rootScope.aElement.data;
                    scope.numbers = '0';
                    scope.summaries = [];
                    $rootScope.canvasHasEmailNode = true;
                    delete $rootScope.aElement;

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);
                    var modalContent = $compile(modalTemplate)(scope);
                    $('body').append(modalContent);

                    $rootScope.$on('syncEmoji', function (evt, emojiVal) {
                        if (scope.emailData) {
                            scope.emailData.Subject = emojiVal;
                        }
                    });

                    $rootScope.$on('syncEmojiPreviewText', function (evt, emojiVal) {
                        if (scope.emailData) {
                            scope.emailData.InboxPreviewText = emojiVal;
                        }
                    });

                    (0, _subjectLinePicker2.default)('subject-line-picker-container-' + scope.id, canvasService, $rootScope.translate, function (syncVal) {
                        if (scope.emailData) {
                            scope.emailData.Subject = syncVal;
                            $('#delay-modal .modal-body').scrollTop(0);
                        }
                    });

                    $rootScope.$on('reporter_' + $rootScope.currentAPId + scope.id, function (evt, data) {
                        if (data) {
                            scope.numbers = data;
                        }
                    });

                    // Close the preview email modal and change the z-index
                    $rootScope.$on('closePreviewEmail' + scope.id, function () {
                        scope.isPreviewOpen = false;
                        scope.displayList = false;
                        scope.selectedView = true;
                    });
                }

                // Listener for close versions dropdown of reports
                $document.on('click', function (event) {
                    event.stopPropagation();
                    if (scope.isVersionsAvailable) {
                        scope.$apply(function () {
                            scope.isVersionsAvailable = false;
                        });
                    }
                });
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    angular.module('active-update-field-action.dir', []).directive('activeUpdateFieldAction', ['$rootScope', '$compile', '$templateCache', 'plumbService', 'helpers', 'canvasService', '$timeout', activeUpdateFieldAction]);

    function activeUpdateFieldAction($rootScope, $compile, $templateCache, plumbService, helpers, canvasService, $timeout) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                //When we save a the form
                $scope.save = function (dummy) {
                    var check = $scope.dataFilledCorrectly();
                    $rootScope.$emit('displayActionUpdateFieldModalError', check.errors);

                    //If form data is missing
                    if (check.result === false) {
                        if ($scope.tempConn) {
                            $scope.connections = angular.copy($scope.tempConn);
                        }
                    }
                    //Else we proceed to save and create new elements
                    else {
                            $rootScope.currentJB = $rootScope.currentJB.map(function (i) {
                                return i;
                            });

                            var currentNode = $rootScope.currentJB.filter(function (i) {
                                if (i.id === $scope.naturalId) {
                                    return i;
                                }
                            });

                            currentNode[0].data = $scope.connections.data;

                            var payload = {
                                JourneyName: $rootScope.currentJBTitle,
                                JourneyVersion: 1,
                                JourneyConfiguration: JSON.stringify($rootScope.currentJB),
                                JourneyTitle: $rootScope.currentJBTitle,
                                JourneyId: $rootScope.currentAPId,
                                NodeUpdated: JSON.stringify(currentNode[0])
                            };

                            $scope.wasSave = true;
                            canvasService.updateActivatedNodes(payload).finally(function () {
                                $timeout(function () {
                                    $scope.wasSave = false;
                                }, 1000);
                            });

                            //Displays th form data
                            $scope.displayList = false;
                            $rootScope.$emit('hideActionUpdateFieldModal');
                            //Hides Error
                            $scope.displayError = false;
                        }
                };

                // validates if data is filled correctly or not
                $scope.dataFilledCorrectly = function () {
                    var res = true,
                        errorList = [];

                    $scope.connections.data.fields.map(function (f, index) {
                        errorList.push({});

                        if (!f.pickedField) {
                            errorList[index].pickedField = true;
                            res = false;
                        } else {
                            errorList[index].pickedField = false;
                        }

                        if (!f.pickedList) {
                            errorList[index].pickedList = true;
                            res = false;
                        } else {
                            errorList[index].pickedList = false;
                        }
                    });

                    return {
                        result: res,
                        errors: errorList
                    };
                };

                $scope.showTipModal = function () {
                    // displays tip modal
                    $rootScope.$emit('displayActionUpdateFieldModal', $scope.connections, true);
                };

                $scope.config = function (evt) {
                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left'));

                    // check if being dragged and update position
                    if (newTop !== $scope.connections.top || $scope.connections.left !== newLeft) {
                        $scope.displayList = false;
                        //update rootScope position
                        var wasUpdated = helpers.updatePos($scope.connections.id, newTop, newLeft);
                        // To check if the element has been saved or not in the rootScope
                        if (!wasUpdated) {
                            $scope.connections.top = newTop;
                            $scope.connections.left = newLeft;
                        }
                        $rootScope.$emit('hideActionUpdateFieldModal');
                        return false;
                    }
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $rootScope.$emit('displayActionUpdateFieldModal', $scope.connections);
                    } else {
                        $scope.displayList = false;
                        $rootScope.$emit('hideActionUpdateFieldModal');
                    }
                    //Hide Error
                    $scope.displayError = false;
                    $scope.displaySubMenu = false;
                };

                $scope.parseDescription = function () {
                    var description = '';
                    var fieldCount = $scope.connections && $scope.connections.data && $scope.connections.data.fields.length;
                    if (fieldCount) {
                        if (fieldCount > 1) {
                            description = fieldCount + ' Fields';
                        } else {
                            description = $scope.connections.data.fields[0].pickedFieldName;
                        }
                    }

                    var fieldsDesc = '';
                    $scope.connections.data.fields.map(function (i) {
                        fieldsDesc += '<tr><td>' + i.pickedFieldName + '</td><td>' + i.updateTo + '</tr>';
                    });

                    $scope.descriptionTooltip = '<table class=contactUsageBreakdown-table><tbody>' + fieldsDesc + '</tbody></table>';

                    return description;
                };

                $scope.saveEvents = function () {
                    $rootScope.$on('saveActionUpdateFieldData' + $scope.connections.id, function (evt, conn) {
                        $scope.tempConn = angular.copy($scope.connections);
                        $scope.connections = angular.copy(conn);
                        $scope.save();
                    });
                };
            }],
            link: function link(scope, elem, attr) {
                //Scope data initialization
                scope.isElegibleForUpdate = true;
                scope.wasSave = false;

                //load existing
                if ($rootScope.aElement) {
                    // bullet proving multiple targets
                    if (scope.connections) {
                        if (document.getElementById(scope.connections.id)) {
                            delete $rootScope.aElement;
                            return false;
                        }
                    }

                    var template = $templateCache.get('active_templates/actions/active-update-field');

                    scope.left = $rootScope.aElement.left;
                    scope.top = $rootScope.aElement.top;
                    scope.id = $rootScope.aElement.id;
                    scope.color = $rootScope.aElement.color;
                    scope.type = $rootScope.aElement.type;
                    scope.data = $rootScope.aElement.data;
                    scope.numbers = '0';
                    scope.naturalId = helpers.getNaturalId(scope.id);

                    scope.connections = $rootScope.aElement;
                    delete $rootScope.aElement;
                    scope.isElegibleForUpdate = false;

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('reporter_' + $rootScope.currentAPId + scope.id, function (evt, data) {
                        if (data) {
                            scope.numbers = data;
                        }
                    });

                    scope.saveEvents();
                }
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    angular.module('active-email-engagement-condition.dir', []).directive('activeEmailEngagementCondition', ['$rootScope', '$compile', '$templateCache', 'helpers', 'canvasService', activeEmailEngagementCondition]);

    function activeEmailEngagementCondition($rootScope, $compile, $templateCache, helpers, canvasService) {
        return {
            scope: {},
            controller: ['$scope', '$http', function ($scope, $http) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                $scope.breakUrl = function () {
                    return $scope.data.specificUrl.replace(/(.{70})/g, "$1<br />");
                };

                $scope.parseDescription = function (desc) {
                    var textToParse = desc;
                    if (textToParse) {
                        if (textToParse.length > 15) {
                            textToParse = textToParse.slice(0, 15) + '...';
                            //Desc < 15
                        } else if (textToParse.length < 15) {
                            textToParse = textToParse;
                        }
                    } else {
                        textToParse = $scope.translate('commons.description');
                    }

                    return textToParse;
                };

                $scope.config = function (evt) {
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $scope.displayConditionMenu = [];
                    } else {
                        $scope.displayList = false;
                    }
                    $scope.displaySubMenu = false;
                };

                $scope.contMenuConfigs = 0;
                $scope.stopMenuBroadcast = function () {
                    $scope.contMenuConfigs = 0;
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displayConditionMenu) {
                        var rectangleMenu = $scope.displayConditionMenu.length > 0;
                    }

                    if ($scope.displayList || $scope.displaySubMenu || rectangleMenu) {
                        if ($scope.contMenuConfigs === 0) {
                            $scope.contMenuConfigs = 1;
                        } else {
                            $scope.cancel();
                            $scope.displaySubMenu = false;
                            $scope.displayConditionMenu = [];
                            $scope.contMenuConfigs = 0;
                        }
                    } else {
                        $scope.contMenuConfigs = 0;
                    }
                });
                //Close menu
                $scope.cancel = function () {
                    $scope.displayList = false;
                };
            }],
            link: function link(scope, elem, attr) {
                if ($rootScope.aElement) {
                    // bullet proving multiple targets
                    if (document.getElementById($rootScope.aElement.id)) {
                        delete $rootScope.aElement;
                        return false;
                    }

                    // load template
                    var template = $templateCache.get('active_templates/conditions/active-email-engagement');

                    scope.left = $rootScope.aElement.left;
                    scope.top = $rootScope.aElement.top;
                    scope.id = $rootScope.aElement.id;
                    scope.color = $rootScope.aElement.color;
                    scope.type = $rootScope.aElement.type;
                    scope.data = $rootScope.aElement.data;
                    scope.emailList = helpers.jbContainsSendEmail();
                    scope.numbers = '0';
                    //Gettiing Node by ID (Send Email node)
                    var emailConnection = helpers.getLoaderConnectionById(scope.data.emailNode);
                    //Adding Email node name to the scope
                    scope.emailNodeName = emailConnection.emailData.EmailName;
                    delete $rootScope.aElement;

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('reporter_' + $rootScope.currentAPId + scope.id, function (evt, data) {
                        if (data) {
                            scope.numbers = data;
                        }
                    });

                    $rootScope.$on('newActiveEmail' + scope.data.emailNode, function (evt, summary) {
                        if (summary && summary.emailName) {
                            scope.emailNodeName = summary.emailName;
                        }
                    });
                }
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    angular.module('active-if-else.dir', []).directive('activeIfElse', ['$rootScope', '$compile', '$templateCache', 'plumbService', 'helpers', 'canvasService', '$timeout', activeIfElse]);

    function activeIfElse($rootScope, $compile, $templateCache, plumbService, helpers, canvasService, $timeout) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                $scope.specificUrlOptions = [{
                    value: 'any-tracked-page',
                    message: $scope.translate('canvas.entry.websiteEngagement.anyTracked')
                }, {
                    value: 'is-url',
                    message: $scope.translate('canvas.entry.websiteEngagement.specificUrl')
                }, {
                    value: 'contains-url',
                    message: $scope.translate('canvas.entry.websiteEngagement.containsUrl')
                }, {
                    value: 'doesnotcontain-url',
                    message: $scope.translate('canvas.entry.websiteEngagement.not.containsUrl')
                }, {
                    value: 'startswith-url',
                    message: $scope.translate('canvas.entry.websiteEngagement.starts.with.url')
                }, {
                    value: 'endswith-url',
                    message: $scope.translate('canvas.entry.websiteEngagement.ends.with.url')
                }, {
                    value: 'wildcardmatch-url',
                    message: $scope.translate('canvas.entry.websiteEngagement.wildcard.url')
                }];

                $scope.parseDescription = function (desc) {
                    if (!desc) {
                        return 'Description';
                    }
                    return desc;
                };

                //When we save a the form
                $scope.save = function (dummy) {
                    //If form data is missing
                    if ($scope.passesConnectionCheck() === false) {
                        $scope.displayError = true;
                        $rootScope.$emit('errorMsg', $rootScope.translate('canvas.error.601'));

                        if ($scope.tempConn) {
                            $scope.connections = angular.copy($scope.tempConn);
                        }
                    }
                    //Else we proceed to save and create new elements
                    else {
                            Intercom('trackEvent', 'AP Node - Multiple Condition');

                            $rootScope.currentJB = $rootScope.currentJB.map(function (i) {
                                if (i.id === $scope.naturalId) {
                                    i.data = $scope.connections.data;
                                }

                                return i;
                            });

                            var currentNode = $rootScope.currentJB.filter(function (i) {
                                if (i.id === $scope.naturalId) {
                                    return i;
                                }
                            });

                            var payload = {
                                JourneyName: $rootScope.currentJBTitle,
                                JourneyVersion: 1,
                                JourneyConfiguration: JSON.stringify($rootScope.currentJB),
                                JourneyTitle: $rootScope.currentJBTitle,
                                JourneyId: $rootScope.currentAPId,
                                NodeUpdated: JSON.stringify(currentNode[0])
                            };

                            canvasService.updateActivatedNodes(payload).then(function () {});

                            //Displays th form data
                            $scope.displayList = false;
                            $rootScope.$emit('hideConditionIfElseModal');

                            //Displays action menu
                            $scope.displaySubMenuIf = false;
                            $scope.displayInnerSubMenuIf = [];
                            //Hides Error
                            $scope.displayError = false;

                            $scope.displayConditionMenu = [];
                            $scope.displayConditionConnectors = true;

                            if ($scope.isElegibleForUpdate) {
                                $scope.wasSave = true;
                                $timeout(function () {
                                    $scope.wasSave = false;
                                }, 1500);
                            }

                            //Set Back to autoSave
                            $scope.isElegibleForUpdate = true;
                        }
                };

                $scope.config = function (evt) {
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $scope.displayConditionMenu = [];
                        $rootScope.$emit('displayConditionIfElseModal', $scope.connections);
                    } else {
                        $scope.displayList = false;
                        $rootScope.$emit('hideConditionIfElseModal');
                    }
                    //Hide Error
                    $scope.displayError = false;
                    $scope.displaySubMenu = false;
                    $scope.displayInnerSubMenuIf = [];
                };

                $scope.passesConnectionCheck = function () {
                    var conditionsGroup = $scope.connections.data.conditionGroups,
                        res = true;

                    if (conditionsGroup === undefined) {
                        res = false;
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.603'));
                    } else {
                        for (var grp = 0; grp < conditionsGroup.length; grp++) {
                            if (conditionsGroup[grp] === undefined) {
                                res = false;
                            }

                            if (conditionsGroup[grp].length === 0) {
                                res = false;
                            }

                            for (var con = 0; con < conditionsGroup[grp].length; con++) {
                                if (conditionsGroup[grp][con].type === 'list') {
                                    if (conditionsGroup[grp][con].selectedOpt.length === 0) {
                                        res = false;
                                        $scope.connections.data.conditionGroups[grp][con].hasError = true;
                                    }
                                }

                                if (conditionsGroup[grp][con].type === 'url' && conditionsGroup[grp][con].selectedOpt[0] !== 'any-tracked-page' && !conditionsGroup[grp][con].selectedOpt[1]) {
                                    res = false;
                                    $scope.connections.data.conditionGroups[grp][con].hasError = true;
                                }

                                if ((conditionsGroup[grp][con].selectedOpt[0] === '' || conditionsGroup[grp][con].selectedOpt[0] === undefined) && conditionsGroup[grp][con].type !== 'visited') {
                                    res = false;
                                    $scope.connections.data.conditionGroups[grp][con].hasError = true;
                                }
                            }
                        }
                    }

                    if (!res) {
                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index === -1) {
                            $rootScope.unsavedData.push($scope.connections.id);
                        }

                        $rootScope.$emit('inputErrorsConditionIfElse', $scope.connections.data.conditionGroups);
                    }

                    return res;
                };

                $scope.contMenuConfigs = 0;
                $scope.stopMenuBroadcast = function () {
                    $scope.contMenuConfigs = 0;
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displayConditionMenu) {
                        var rectangleMenu = $scope.displayConditionMenu.length > 0;
                    }

                    if ($scope.displayList || $scope.displaySubMenu || rectangleMenu) {
                        if ($scope.contMenuConfigs === 0) {
                            $scope.contMenuConfigs = 1;
                        } else {
                            $scope.cancel();
                            $scope.displaySubMenu = false;
                            $scope.displayConditionMenu = [];
                            $scope.contMenuConfigs = 0;
                        }
                    } else {
                        $scope.contMenuConfigs = 0;
                    }
                });
                //Close menu
                $scope.cancel = function () {
                    $scope.displayList = false;
                };
            }],
            link: function link(scope, elem, attr) {
                //Scope data initialization
                scope.displayList = true;
                scope.displayError = false;
                scope.displaySubMenuIf = false;
                scope.selectedAction = {};
                scope.ConnectionsFromLoader = false;
                scope.displayPlus = [];
                scope.rectangleCons = [];
                scope.isElegibleForUpdate = true;
                scope.hideWhenLimit = true;
                scope.modalWindow = [];
                scope.hideForLimitCon = [];
                scope.displayInnerSubMenuIf = [];
                scope.checkList = [];
                scope.listTitle = [];
                scope.append = [];
                scope.urlError = [];
                scope.emailList = helpers.jbContainsSendEmail();
                scope.hasArrow = {};
                scope.showConnectionArrow = {};

                if ($rootScope.aElement) {
                    // bullet proving multiple targets
                    if (document.getElementById($rootScope.aElement.id)) {
                        delete $rootScope.aElement;
                        return false;
                    }

                    scope.connections = $rootScope.aElement;

                    if (!scope.contactListData) {
                        scope.contactListData = $rootScope.contactListData;
                    }

                    if (!scope.segmentData) {
                        scope.segmentData = $rootScope.segmentData;
                    }

                    // load template
                    var template = $templateCache.get('active_templates/conditions/active-if-else');

                    scope.left = $rootScope.aElement.left;
                    scope.top = $rootScope.aElement.top;
                    scope.id = $rootScope.aElement.id;
                    scope.naturalId = helpers.getNaturalId(scope.id);
                    scope.color = $rootScope.aElement.color;
                    scope.type = $rootScope.aElement.type;
                    scope.data = $rootScope.aElement.data;
                    scope.numbers = '0';
                    scope.listTitle = [];
                    scope.nodeTitle = scope.data.actionsList[scope.data.conditionGroups[0][0].selectedAction];

                    if (scope.data.conditionGroups) {
                        for (var i = 0; i < scope.data.conditionGroups.length; i++) {
                            scope.listTitle[i] = [];

                            for (var j = 0; j < scope.data.conditionGroups[i].length; j++) {

                                var type = scope.data.conditionGroups[i][j].type,
                                    key = scope.data.conditionGroups[i][j].selectedOpt[0];

                                scope.data.conditionGroups[i][j].selectedValue = scope.data.actionsList[scope.data.conditionGroups[i][j].selectedAction];

                                if (type === 'list') {
                                    var val = helpers.getContactListItem(key, scope.contactListData, scope.segmentData);
                                    scope.listTitle[i][j] = val.substring(0, 26) + '...';
                                } else if (type === 'email' || type === 'link') {
                                    var emailNodeId = helpers.getLoaderConnectionById(key);
                                    if (emailNodeId.emailData) {
                                        scope.data.conditionGroups[i][j].emailNodeName = emailNodeId.emailData.EmailName;

                                        $rootScope.$on('newActiveEmail' + key, function (evt, summary) {
                                            if (summary && summary.emailName) {
                                                for (var _i = 0; _i < scope.data.conditionGroups.length; _i++) {
                                                    for (var _j = 0; _j < scope.data.conditionGroups[_i].length; _j++) {
                                                        var _type = scope.data.conditionGroups[_i][_j].type,
                                                            _key = scope.data.conditionGroups[_i][_j].selectedOpt[0];

                                                        if (_type === 'email' || _type === 'link' && _key === summary.elementId) {
                                                            scope.data.conditionGroups[_i][_j].emailNodeName = summary.emailName;
                                                        }
                                                    }
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                        }
                    }

                    delete $rootScope.aElement;

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('reporter_' + $rootScope.currentAPId + scope.id, function (evt, data) {
                        if (data) {
                            scope.numbers = data;
                        }
                    });

                    $rootScope.$on('saveConditionIfElse' + scope.connections.id, function (evt, conn) {
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });
                }
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    angular.module('active-is-in-segment.dir', []).directive('activeIsInSegment', ['$rootScope', '$compile', '$templateCache', 'helpers', 'canvasService', activeIsInSegment]);

    function activeIsInSegment($rootScope, $compile, $templateCache, helpers, canvasService) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                $scope.getAPLSegments = function () {
                    if ($scope.lists) {
                        $scope.listView = true;
                    } else {
                        canvasService.getSegmentsById($scope.data.selectedList).success(function (res) {
                            $scope.lists = res.Results;
                            $scope.listView = true;
                        });
                    }
                };

                $scope.getSelectedText = function (desc) {
                    if ($scope.data.selectedList.length === 1) {
                        for (var item in desc) {
                            desc = helpers.getContactListItem(desc[item], $scope.ListName, $scope.segmentData);
                        }

                        return desc;
                    }
                };

                $scope.parseDescription = function (desc, selected) {
                    var textToParse = desc;

                    if (textToParse && (typeof textToParse === 'undefined' ? 'undefined' : _typeof(textToParse)) === 'object') {

                        var descriptionCheck = false;
                        for (var item in textToParse) {
                            if (textToParse[item]) {

                                $scope.descriptionEmpty = false;
                                descriptionCheck = true;
                                var totalLists = $scope.data.selectedList.length;
                                textToParse = helpers.getContactListItem(textToParse[item], $scope.ListName, $scope.segmentData);

                                //One list selected and > 19
                                if (totalLists === 1 && textToParse.length > 15) {
                                    textToParse = textToParse.slice(0, 15) + '...';
                                    //More than one selected
                                } else if (totalLists > 1) {
                                    textToParse = totalLists + " Lists Selected";
                                    //One selected but < 19
                                } else if (totalLists === 1 && textToParse.length < 15) {
                                    textToParse = textToParse;
                                }
                            }
                        }
                        if (!descriptionCheck) {
                            textToParse = parseDescriptionHelper(selected);
                        }
                    } else {
                        textToParse = parseDescriptionHelper(selected);
                    }

                    return textToParse;
                };

                var parseDescriptionHelper = function parseDescriptionHelper(selected) {
                    $scope.descriptionEmpty = true;
                    return selected === "showSelectedList" ? "" : "Description";
                };
                //Show or hide menu on Element click
                $scope.config = function (evt) {
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $scope.listView = false;
                    } else {
                        $scope.displayList = false;
                    }
                };

                $scope.contMenuConfigs = 0;
                $scope.stopMenuBroadcast = function () {
                    $scope.contMenuConfigs = 0;
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displayList || $scope.displaySubMenu) {
                        if ($scope.contMenuConfigs === 0) {
                            $scope.contMenuConfigs = 1;
                        } else {
                            $scope.cancel();
                            $scope.displaySubMenu = false;
                            $scope.contMenuConfigs = 0;
                        }
                    } else {
                        $scope.contMenuConfigs = 0;
                    }
                });
                //Close menu
                $scope.cancel = function () {
                    $scope.displayList = false;
                };

                $scope.description = '';
                $rootScope.$watch('contactListData', function (list) {
                    if (list && list.length) {
                        $scope.contactListData = list;
                        var desc = $scope.parseDescription($scope.data.selectedList, 'showDescription');

                        if (desc) {
                            $scope.description = desc;
                        }
                    }
                });
            }],
            link: function link(scope, elem, attr) {
                if ($rootScope.aElement) {
                    // bullet proving multiple targets
                    if (document.getElementById($rootScope.aElement.id)) {
                        delete $rootScope.aElement;
                        return false;
                    }

                    // load template
                    var template = $templateCache.get('active_templates/conditions/active-in-segment-condition');

                    scope.left = $rootScope.aElement.left;
                    scope.top = $rootScope.aElement.top;
                    scope.id = $rootScope.aElement.id;
                    scope.color = $rootScope.aElement.color;
                    scope.type = $rootScope.aElement.type;
                    scope.data = $rootScope.aElement.data;
                    scope.segmentData = $rootScope.segmentData;
                    scope.numbers = '0';

                    delete $rootScope.aElement;

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('reporter_' + $rootScope.currentAPId + scope.id, function (evt, data) {
                        if (data) {
                            scope.numbers = data;
                        }
                    });
                }
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    angular.module('active-is-not-in-segment.dir', []).directive('activeIsNotInSegment', ['$rootScope', '$compile', '$templateCache', 'helpers', 'canvasService', activeIsNotInListSegment]);

    function activeIsNotInListSegment($rootScope, $compile, $templateCache, helpers, canvasService) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                $scope.getAPLSegments = function () {
                    if ($scope.lists) {
                        $scope.listView = true;
                    } else {
                        canvasService.getSegmentsById($scope.data.selectedList).success(function (res) {
                            $scope.lists = res.Results;
                            $scope.listView = true;
                        });
                    }
                };

                $scope.getSelectedText = function (desc) {
                    if ($scope.data.selectedList.length === 1) {
                        for (var item in desc) {
                            desc = helpers.getContactListItem(desc[item], false, $scope.segmentData);
                        }

                        return desc;
                    }
                };

                $scope.parseDescription = function (desc, selected) {
                    var textToParse = desc;

                    if (textToParse && (typeof textToParse === 'undefined' ? 'undefined' : _typeof(textToParse)) === 'object') {

                        var descriptionCheck = false;
                        for (var item in textToParse) {
                            if (textToParse[item]) {

                                $scope.descriptionEmpty = false;
                                descriptionCheck = true;
                                var totalLists = $scope.data.selectedList.length;
                                textToParse = helpers.getContactListItem(textToParse[item], false, $scope.segmentData);

                                //One list selected and > 19
                                if (totalLists === 1 && textToParse.length > 15) {
                                    textToParse = textToParse.slice(0, 15) + '...';
                                    //More than one selected
                                } else if (totalLists > 1) {
                                    textToParse = totalLists + " Lists Selected";
                                    //One selected but < 19
                                } else if (totalLists === 1 && textToParse.length < 15) {
                                    textToParse = textToParse;
                                }
                            }
                        }
                        if (!descriptionCheck) {
                            textToParse = parseDescriptionHelper(selected);
                        }
                    } else {
                        textToParse = parseDescriptionHelper(selected);
                    }

                    return textToParse;
                };

                var parseDescriptionHelper = function parseDescriptionHelper(selected) {
                    $scope.descriptionEmpty = true;
                    return selected === "showSelectedList" ? "" : "Description";
                };
                //Show or hide menu on Element click
                $scope.config = function (evt) {
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $scope.listView = false;
                    } else {
                        $scope.displayList = false;
                    }
                };

                $scope.contMenuConfigs = 0;
                $scope.stopMenuBroadcast = function () {
                    $scope.contMenuConfigs = 0;
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displayList || $scope.displaySubMenu) {
                        if ($scope.contMenuConfigs === 0) {
                            $scope.contMenuConfigs = 1;
                        } else {
                            $scope.cancel();
                            $scope.displaySubMenu = false;
                            $scope.contMenuConfigs = 0;
                        }
                    } else {
                        $scope.contMenuConfigs = 0;
                    }
                });
                //Close menu
                $scope.cancel = function () {
                    $scope.displayList = false;
                };

                $scope.description = '';
                $rootScope.$watch('segmentData', function (list) {
                    if (list && list.length) {
                        $scope.segmentData = list;
                        var desc = $scope.parseDescription($scope.data.selectedList, 'showDescription');

                        if (desc) {
                            $scope.description = desc;
                        }
                    }
                });
            }],
            link: function link(scope, elem, attr) {
                if ($rootScope.aElement) {
                    // bullet proving multiple targets
                    if (document.getElementById($rootScope.aElement.id)) {
                        delete $rootScope.aElement;
                        return false;
                    }

                    // load template
                    var template = $templateCache.get('active_templates/conditions/active-not-in-segment');

                    scope.left = $rootScope.aElement.left;
                    scope.top = $rootScope.aElement.top;
                    scope.id = $rootScope.aElement.id;
                    scope.color = $rootScope.aElement.color;
                    scope.type = $rootScope.aElement.type;
                    scope.data = $rootScope.aElement.data;
                    scope.numbers = '0';

                    $rootScope.$watch('segmentData', function (newData) {
                        if (newData) {
                            scope.segmentData = $rootScope.segmentData;
                            scope.parseDescription(scope.data.selectedList, 'showSelectedList');
                        }
                    });

                    delete $rootScope.aElement;

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('reporter_' + $rootScope.currentAPId + scope.id, function (evt, data) {
                        if (data) {
                            scope.numbers = data;
                        }
                    });
                }
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    angular.module('active-is-in-list-or-segment.dir', []).directive('activeListSegment', ['$rootScope', '$compile', '$templateCache', 'helpers', 'canvasService', activeListSegment]);

    function activeListSegment($rootScope, $compile, $templateCache, helpers, canvasService) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                $scope.getAPLists = function () {
                    if ($scope.lists) {
                        $scope.listView = true;
                    } else {
                        canvasService.getLists($scope.data.selectedList).success(function (res) {
                            $scope.lists = res;
                            $scope.listView = true;
                        });
                    }
                };

                $scope.getSelectedText = function (desc) {
                    if ($scope.data.selectedList.length === 1) {
                        for (var item in desc) {
                            desc = helpers.getContactListItem(desc[item], $scope.contactListData);
                        }

                        return desc;
                    } else {
                        var lists = [];

                        for (var i = 0; i < desc.length; i++) {
                            lists.push(helpers.getContactListItem(desc[i], $scope.contactListData));
                        }

                        return lists.join().replace(/,/g, '<br />');
                    }
                };

                $scope.parseDescription = function (desc, selected) {
                    var textToParse = desc;

                    if (textToParse && (typeof textToParse === 'undefined' ? 'undefined' : _typeof(textToParse)) === 'object') {

                        var descriptionCheck = false;
                        for (var item in textToParse) {
                            if (textToParse[item]) {

                                $scope.descriptionEmpty = false;
                                descriptionCheck = true;
                                var totalLists = $scope.data.selectedList.length;
                                textToParse = helpers.getContactListItem(textToParse[item], $scope.contactListData);

                                //One list selected and > 19
                                if (totalLists === 1 && textToParse.length > 15) {
                                    textToParse = textToParse.slice(0, 15) + '...';
                                    //More than one selected
                                } else if (totalLists > 1) {
                                    textToParse = totalLists + " Lists Selected";
                                }
                            }
                        }
                        if (!descriptionCheck) {
                            textToParse = parseDescriptionHelper(selected);
                        }
                    } else {
                        textToParse = parseDescriptionHelper(selected);
                    }

                    return textToParse;
                };

                var parseDescriptionHelper = function parseDescriptionHelper(selected) {
                    $scope.descriptionEmpty = true;
                    return selected === "showSelectedList" ? "" : "Description";
                };
                //Show or hide menu on Element click
                $scope.config = function (evt) {
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $scope.listView = false;
                    } else {
                        $scope.displayList = false;
                    }
                };

                $scope.contMenuConfigs = 0;
                $scope.stopMenuBroadcast = function () {
                    $scope.contMenuConfigs = 0;
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displayList || $scope.displaySubMenu) {
                        if ($scope.contMenuConfigs === 0) {
                            $scope.contMenuConfigs = 1;
                        } else {
                            $scope.cancel();
                            $scope.displaySubMenu = false;
                            $scope.contMenuConfigs = 0;
                        }
                    } else {
                        $scope.contMenuConfigs = 0;
                    }
                });
                //Close menu
                $scope.cancel = function () {
                    $scope.displayList = false;
                };

                $scope.description = '';
                $rootScope.$watch('contactListData', function (list) {
                    if (list && list.length) {
                        $scope.contactListData = list;
                        var desc = $scope.parseDescription($scope.data.selectedList, 'showDescription');

                        if (desc) {
                            $scope.description = desc;
                        }
                    }
                });
            }],
            link: function link(scope, elem, attr) {
                if ($rootScope.aElement) {
                    // bullet proving multiple targets
                    if (document.getElementById($rootScope.aElement.id)) {
                        delete $rootScope.aElement;
                        return false;
                    }

                    // load template
                    var template = $templateCache.get('active_templates/conditions/active-is-on-list-or-segment');

                    scope.left = $rootScope.aElement.left;
                    scope.top = $rootScope.aElement.top;
                    scope.id = $rootScope.aElement.id;
                    scope.color = $rootScope.aElement.color;
                    scope.type = $rootScope.aElement.type;
                    scope.data = $rootScope.aElement.data;
                    scope.contactListData = $rootScope.contactListData;
                    scope.numbers = '0';

                    delete $rootScope.aElement;

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('reporter_' + $rootScope.currentAPId + scope.id, function (evt, data) {
                        if (data) {
                            scope.numbers = data;
                        }
                    });
                }
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    angular.module('active-rectangle-connector.dir', []).directive('activeRectangleConnector', ['$rootScope', '$compile', '$templateCache', 'helpers', 'canvasService', activeRectangleConnector]);

    function activeRectangleConnector($rootScope, $compile, $templateCache, helpers, canvasService) {
        return {
            scope: {},
            controller: ['$scope', '$http', function ($scope, $http) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;
            }],
            link: function link(scope, elem, attr) {

                if ($rootScope.aElement) {
                    // bullet proving multiple targets
                    if (document.getElementById($rootScope.aElement.id)) {
                        delete $rootScope.aElement;
                        return false;
                    }

                    // load template
                    var template = $templateCache.get('active_templates/conditions/active-rectangle-connector');

                    scope.left = $rootScope.aElement.left;
                    scope.top = $rootScope.aElement.top;
                    scope.id = $rootScope.aElement.id;
                    scope.label = $rootScope.aElement.label;
                    scope.elemClass = $rootScope.aElement.elemClass;

                    delete $rootScope.aElement;

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);
                }
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    angular.module('active-website-activity-condition.dir', ['ngclipboard']).directive('activeWebsiteActivityCondition', ['$rootScope', '$compile', '$templateCache', 'helpers', 'canvasService', activeWebsiteActivityCondition]);

    function activeWebsiteActivityCondition($rootScope, $compile, $templateCache, helpers, canvasService) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                $scope.breakUrl = function () {
                    return $scope.data.specificUrl.replace(/(.{70})/g, "$1<br />");
                };

                $scope.specificUrlOptions = [{
                    value: 'any-tracked-page',
                    message: $scope.translate('canvas.entry.websiteEngagement.anyTracked')
                }, {
                    value: 'is-url',
                    message: $scope.translate('canvas.entry.websiteEngagement.specificUrl')
                }, {
                    value: 'contains-url',
                    message: $scope.translate('canvas.entry.websiteEngagement.containsUrl')
                }, {
                    value: 'doesnotcontain-url',
                    message: $scope.translate('canvas.entry.websiteEngagement.not.containsUrl')
                }, {
                    value: 'startswith-url',
                    message: $scope.translate('canvas.entry.websiteEngagement.starts.with.url')
                }, {
                    value: 'endswith-url',
                    message: $scope.translate('canvas.entry.websiteEngagement.ends.with.url')
                }, {
                    value: 'wildcardmatch-url',
                    message: $scope.translate('canvas.entry.websiteEngagement.wildcard.url')
                }];

                $scope.parseDescription = function (desc, specificUrl) {
                    if (specificUrl) {
                        if (desc) {
                            var arrLen = desc.split("");
                            arrLen = arrLen.length;
                            if (arrLen > 15) {
                                return desc.slice(0, 15) + '...';
                            } else {
                                return desc;
                            }
                        } else if ($scope.data.source === 'contains-url') {
                            return $scope.translate('canvas.entry.websiteEngagement.containsUrl');
                        } else {
                            return $scope.translate('canvas.condition.websiteActivity.specificUrl');
                        }
                    } else {
                        if (desc) {
                            desc = desc.splitCharAndUpper();
                        } else {
                            return $scope.translate('commons.enterDetails');
                        }
                    }

                    return desc;
                };

                $scope.config = function (evt) {
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                    } else {
                        $scope.displayList = false;
                        $scope.trackingTestState = $scope.translate('canvas.entry.websiteEngagement.url.test');
                        $scope.trackingTestClass = '';
                    }
                    $scope.displaySubMenu = false;
                };

                $scope.contMenuConfigs = 0;
                $scope.stopMenuBroadcast = function () {
                    $scope.contMenuConfigs = 0;
                };
                //Close menu
                $scope.cancel = function () {
                    $scope.displayList = false;
                };

                $scope.displayTrackerModal = function () {
                    $rootScope.$emit('displayTrackerModal');
                };
            }],
            link: function link(scope, elem, attr) {
                //Setting initial form on true to display radio buttons
                scope.displayForm = true;

                if ($rootScope.aElement) {
                    // bullet proving multiple targets
                    if (document.getElementById($rootScope.aElement.id)) {
                        delete $rootScope.aElement;
                        return false;
                    }

                    // load template
                    var template = $templateCache.get('active_templates/conditions/active-website-activity');

                    scope.left = $rootScope.aElement.left;
                    scope.top = $rootScope.aElement.top;
                    scope.id = $rootScope.aElement.id;
                    scope.color = $rootScope.aElement.color;
                    scope.type = $rootScope.aElement.type;
                    scope.data = $rootScope.aElement.data;
                    scope.numbers = '0';

                    delete $rootScope.aElement;

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('reporter_' + $rootScope.currentAPId + scope.id, function (evt, data) {
                        if (data) {
                            scope.numbers = data;
                        }
                    });
                }
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    angular.module('active-add-to-list-entry.dir', []).directive('activeAddToListEntry', ['$rootScope', '$compile', '$templateCache', 'canvasService', 'helpers', activeAddToListEntry]);

    function activeAddToListEntry($rootScope, $compile, $templateCache, canvasService, helpers) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;
                $scope.descriptionEmpty = false;

                $scope.getSelectedText = function (desc) {
                    if ($scope.data.selectedList.length === 1) {
                        for (var item in desc) {
                            desc = helpers.getContactListItem(desc[item], $scope.contactListData);
                        }

                        return desc;
                    } else {
                        var lists = [];

                        for (var i = 0; i < desc.length; i++) {
                            lists.push(helpers.getContactListItem(desc[i], $scope.contactListData));
                        }

                        return lists.join().replace(/,/g, '<br />');
                    }
                };

                $scope.showReport = function () {
                    var firstOccurrence = $scope.id.indexOf('_');
                    var secondOccurrence = $scope.id.indexOf('_', firstOccurrence + 1);
                    var elementId = $scope.id.slice(0, secondOccurrence);
                    canvasService.getNodeDetails($rootScope.currentAPId, elementId).then(function (res) {
                        return res.data;
                    }).then(function (nodeDetails) {
                        canvasService.getNodeMetricDetailsGroupByType($rootScope.currentAPId, nodeDetails.NodeId, nodeDetails.NodeActionType).then(function (res) {
                            var data = [nodeDetails, res.data];
                            $rootScope.$emit('summary', true, $rootScope.currentAPId, $rootScope.currentJBTitle, undefined, -1, false, true, data);
                        });
                    });
                };

                $scope.parseDescription = function (desc, selected) {
                    var textToParse = desc;

                    if (textToParse && (typeof textToParse === 'undefined' ? 'undefined' : _typeof(textToParse)) === 'object') {

                        var descriptionCheck = false;
                        for (var item in textToParse) {
                            if (textToParse[item]) {

                                $scope.descriptionEmpty = false;
                                descriptionCheck = true;
                                var totalLists = $scope.data.selectedList.length;
                                textToParse = helpers.getContactListItem(textToParse[item], $scope.contactListData);

                                //One list selected and > 19
                                if (totalLists === 1 && textToParse.length > 15) {
                                    textToParse = textToParse.slice(0, 15) + '...';
                                    //More than one selected
                                } else if (totalLists > 1) {
                                    textToParse = totalLists + " Lists Selected";
                                }
                            }
                        }
                        if (!descriptionCheck) {
                            textToParse = parseDescriptionHelper(selected);
                        }
                    } else {
                        textToParse = parseDescriptionHelper(selected);
                    }

                    return textToParse;
                };

                $scope.getAPLists = function () {
                    if ($scope.lists) {
                        $scope.listView = true;
                    } else {
                        canvasService.getLists($scope.data.selectedList).success(function (res) {
                            $scope.lists = res;
                            $scope.listView = true;
                        });
                    }
                };

                //Show or hide menu on Element click
                $scope.config = function (evt) {
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.listView = false;
                        $scope.displayList = true;
                    } else {
                        $scope.displayList = false;
                    }
                };

                $scope.contMenuConfigs = 0;
                $scope.stopMenuBroadcast = function () {
                    $scope.contMenuConfigs = 0;
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displayList || $scope.displaySubMenu) {
                        if ($scope.contMenuConfigs === 0) {
                            $scope.contMenuConfigs = 1;
                        } else {
                            $scope.cancel();
                            $scope.displaySubMenu = false;
                            $scope.contMenuConfigs = 0;
                        }
                    } else {
                        $scope.contMenuConfigs = 0;
                    }
                });
                //Close menu
                $scope.cancel = function () {
                    $scope.displayList = false;
                };

                var parseDescriptionHelper = function parseDescriptionHelper(selected) {
                    $scope.descriptionEmpty = true;
                    return selected === "showSelectedList" ? "" : "Description";
                };

                $scope.blockTrigger = function () {
                    Intercom('trackEvent', 'AP - Block Trigger');
                    var status = $scope.blocked ? 1 : 0;
                    canvasService.blockJourney($rootScope.currentAPId, status).success(function (_ref) {
                        var ReportInformation = _ref.ReportInformation;

                        $scope.blocked = !$scope.blocked;
                        if ($scope.blocked) {
                            $scope.blockDate = ReportInformation.History[8];
                        }
                    });
                };

                $scope.description = '';
                $rootScope.$watch('contactListData', function (list) {
                    if (list && list.length) {
                        if ($rootScope.firstNodejourneyLists && $rootScope.firstNodejourneyLists != null && $rootScope.firstNodejourneyLists != undefined) {
                            $scope.data.selectedList = $rootScope.firstNodejourneyLists;
                        }
                        $scope.contactListData = list;
                        var desc = $scope.parseDescription($scope.data.selectedList, 'showDescription');

                        if (desc) {
                            $scope.description = desc;
                        }
                    }
                });
            }],
            link: function link(scope, elem, attr) {
                // scope initialization
                scope.displayList = false;

                if ($rootScope.aElement) {
                    // bullet proving multiple targets
                    if (document.getElementById($rootScope.aElement.id)) {
                        delete $rootScope.aElement;
                        return false;
                    }

                    // load template
                    var template = $templateCache.get('active_templates/entries/active-added-to-list'),
                        modalTemplate = $templateCache.get('active_templates/entries/modal-active-added-to-list');

                    scope.left = $rootScope.aElement.left;
                    scope.top = $rootScope.aElement.top;
                    scope.id = $rootScope.aElement.id;
                    scope.color = $rootScope.aElement.color;
                    scope.type = $rootScope.aElement.type;
                    scope.data = $rootScope.aElement.data;
                    scope.contactListData = $rootScope.contactListData;
                    scope.numbers = '0';

                    delete $rootScope.aElement;

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    var modalContent = $compile(modalTemplate)(scope);
                    $('body').append(modalContent);

                    $rootScope.$on('reporter_' + $rootScope.currentAPId + scope.id, function (evt, data) {
                        if (data) {
                            scope.numbers = data;
                        }
                    });

                    $rootScope.$on('entryBlock', function (evt, block, date) {
                        scope.blocked = block;
                        scope.blockDate = date;
                    });
                }
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    angular.module('active-add-to-segment-entry.dir', []).directive('activeAddToSegmentEntry', ['$rootScope', '$compile', '$templateCache', 'canvasService', 'helpers', activeAddToSegmentEntry]);

    function activeAddToSegmentEntry($rootScope, $compile, $templateCache, canvasService, helpers) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;
                $scope.descriptionEmpty = false;

                $scope.getAPLSegments = function () {
                    if ($scope.lists) {
                        $scope.listView = true;
                    } else {
                        canvasService.getSegmentsById($scope.data.selectedList).success(function (res) {
                            $scope.lists = res.Results;
                            $scope.listView = true;
                        });
                    }
                };

                $scope.getSelectedText = function (desc) {
                    if ($scope.data.selectedList.length === 1) {
                        for (var item in desc) {
                            desc = helpers.getContactListItem(desc[item], null, $scope.segmentData);
                        }

                        return desc;
                    } else {
                        var lists = [];

                        for (var i = 0; i < desc.length; i++) {
                            lists.push(helpers.getContactListItem(desc[i], null, $scope.segmentData));
                        }

                        return lists.join().replace(/,/g, '<br />');
                    }
                };

                $scope.showReport = function () {
                    var firstOccurrence = $scope.id.indexOf('_');
                    var secondOccurrence = $scope.id.indexOf('_', firstOccurrence + 1);
                    var elementId = $scope.id.slice(0, secondOccurrence);
                    canvasService.getNodeDetails($rootScope.currentAPId, elementId).then(function (res) {
                        return res.data;
                    }).then(function (nodeDetails) {
                        canvasService.getNodeMetricDetailsGroupByType($rootScope.currentAPId, nodeDetails.NodeId, nodeDetails.NodeActionType).then(function (res) {
                            var data = [nodeDetails, res.data];
                            $rootScope.$emit('summary', true, $rootScope.currentAPId, $rootScope.currentJBTitle, undefined, -1, false, true, data);
                        });
                    });
                };

                $scope.parseDescription = function (desc, selected) {
                    var textToParse = desc;

                    if (textToParse && (typeof textToParse === 'undefined' ? 'undefined' : _typeof(textToParse)) === 'object') {
                        var descriptionCheck = false;
                        for (var item in textToParse) {
                            if (textToParse[item]) {
                                $scope.descriptionEmpty = false;
                                descriptionCheck = true;
                                var totalLists = $scope.data.selectedList.length;
                                textToParse = helpers.getContactListItem(textToParse[item], $scope.ListName, $scope.segmentData);

                                //One list selected and > 19
                                if (totalLists === 1 && textToParse.length > 15) {
                                    textToParse = textToParse.slice(0, 15) + '...';
                                    //More than one selected
                                } else if (totalLists > 1) {
                                    textToParse = totalLists + ' ' + $scope.translate('canvas.entry.addedToSegment.selectedSegment');
                                    //One selected but < 19
                                } else if (totalLists === 1 && textToParse.length < 15) {
                                    textToParse = textToParse;
                                }
                            }
                        }
                        if (!descriptionCheck) {
                            textToParse = parseDescriptionHelper(selected);
                        }
                    } else {
                        textToParse = parseDescriptionHelper(selected);
                    }

                    return textToParse;
                };

                //Show or hide menu on Element click
                $scope.config = function (evt) {
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $scope.listView = false;
                    } else {
                        $scope.displayList = false;
                    }
                };

                $scope.contMenuConfigs = 0;
                $scope.stopMenuBroadcast = function () {
                    $scope.contMenuConfigs = 0;
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displayList || $scope.displaySubMenu) {
                        if ($scope.contMenuConfigs === 0) {
                            $scope.contMenuConfigs = 1;
                        } else {
                            $scope.cancel();
                            $scope.displaySubMenu = false;
                            $scope.contMenuConfigs = 0;
                        }
                    } else {
                        $scope.contMenuConfigs = 0;
                    }
                });
                //Close menu
                $scope.cancel = function () {
                    $scope.displayList = false;
                };

                var parseDescriptionHelper = function parseDescriptionHelper(selected) {
                    $scope.descriptionEmpty = true;
                    return selected === 'showSelectedList' ? '' : 'Description';
                };

                $scope.blockTrigger = function () {
                    Intercom('trackEvent', 'AP - Block Trigger');
                    var status = $scope.blocked ? 1 : 0;
                    canvasService.blockJourney($rootScope.currentAPId, status).success(function (_ref) {
                        var ReportInformation = _ref.ReportInformation;

                        $scope.blocked = !$scope.blocked;
                        if ($scope.blocked) {
                            $scope.blockDate = ReportInformation.History[8];
                        }
                    });
                };

                $scope.description = '';
                $rootScope.$watch('segmentData', function (list) {
                    if (list && list.length) {
                        $scope.segmentData = list;
                        var desc = $scope.parseDescription($scope.data.selectedList, 'showDescription');

                        if (desc) {
                            $scope.description = desc;
                        }
                    }
                });
            }],
            link: function link(scope, elem, attr) {
                // scope initialization
                scope.displayList = false;

                if ($rootScope.aElement) {
                    // bullet proving multiple targets
                    if (document.getElementById($rootScope.aElement.id)) {
                        delete $rootScope.aElement;
                        return false;
                    }

                    // load template
                    var template = $templateCache.get('active_templates/entries/active-added-to-segment'),
                        modalTemplate = $templateCache.get('active_templates/entries/modal-active-added-to-segment');

                    scope.left = $rootScope.aElement.left;
                    scope.top = $rootScope.aElement.top;
                    scope.id = $rootScope.aElement.id;
                    scope.color = $rootScope.aElement.color;
                    scope.type = $rootScope.aElement.type;
                    scope.data = $rootScope.aElement.data;
                    scope.segmentData = $rootScope.segmentData;
                    scope.numbers = '0';

                    $rootScope.segmentSelected = helpers.getContactListItem(scope.data.selectedList[0], '', scope.segmentData);

                    delete $rootScope.aElement;

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    var modalContent = $compile(modalTemplate)(scope);
                    $('body').append(modalContent);

                    $rootScope.$on('reporter_' + $rootScope.currentAPId + scope.id, function (evt, data) {
                        if (data) {
                            scope.numbers = data;
                        }
                    });

                    $rootScope.$on('entryBlock', function (evt, block, date) {
                        scope.blocked = block;
                        scope.blockDate = date;
                    });
                }
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    angular.module('active-date-and-time.dir', []).directive('activeDateAndTime', ['$rootScope', '$compile', '$templateCache', 'helpers', 'canvasService', activeDateAndTime]);

    //Website Engagement Directive
    function activeDateAndTime($rootScope, $compile, $templateCache, helpers, canvasService) {

        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                $scope.getAPLists = function () {
                    if ($scope.lists) {
                        $scope.listView = true;
                    } else {
                        canvasService.getLists($scope.data.selectedList).success(function (res) {
                            $scope.lists = res;
                            $scope.listView = true;
                        });
                    }
                };

                $scope.getSelectedText = function (desc) {
                    if ($scope.data.selectedList.length === 1) {
                        for (var item in desc) {
                            desc = helpers.getContactListItem(desc[item], $scope.contactListData);
                        }

                        return desc;
                    } else {
                        var lists = [];

                        for (var i = 0; i < desc.length; i++) {
                            lists.push(helpers.getContactListItem(desc[i], $scope.contactListData));
                        }

                        return lists.join().replace(/,/g, '<br />');
                    }
                };

                $scope.showReport = function () {
                    var firstOccurrence = $scope.id.indexOf('_');
                    var secondOccurrence = $scope.id.indexOf('_', firstOccurrence + 1);
                    var elementId = $scope.id.slice(0, secondOccurrence);
                    canvasService.getNodeDetails($rootScope.currentAPId, elementId).then(function (res) {
                        return res.data;
                    }).then(function (nodeDetails) {
                        canvasService.getNodeMetricDetailsGroupByType($rootScope.currentAPId, nodeDetails.NodeId, nodeDetails.NodeActionType).then(function (res) {
                            var data = [nodeDetails, res.data];
                            $rootScope.$emit('summary', true, $rootScope.currentAPId, $rootScope.currentJBTitle, undefined, -1, false, true, data);
                        });
                    });
                };

                $scope.parseDescription = function (desc, selected) {
                    var textToParse = desc;

                    if (textToParse && (typeof textToParse === 'undefined' ? 'undefined' : _typeof(textToParse)) === 'object') {

                        var descriptionCheck = false;
                        for (var item in textToParse) {
                            if (textToParse[item]) {

                                $scope.descriptionEmpty = false;
                                descriptionCheck = true;
                                var totalLists = $scope.data.selectedList.length;
                                textToParse = helpers.getContactListItem(textToParse[item], $scope.contactListData);

                                //One list selected and > 19
                                if (totalLists === 1 && textToParse.length > 15) {
                                    textToParse = textToParse.slice(0, 15) + '...';
                                    //More than one selected
                                } else if (totalLists > 1) {
                                    textToParse = totalLists + " Lists Selected";
                                    //One selected but < 19
                                } else if (totalLists === 1 && textToParse.length < 15) {
                                    textToParse = textToParse;
                                }
                            }
                        }
                        if (!descriptionCheck) {
                            textToParse = parseDescriptionHelper(selected);
                        }
                    } else {
                        textToParse = parseDescriptionHelper(selected);
                    }

                    return textToParse;
                };

                //Show or hide menu on Element click

                //Show or hide menu on Element click
                $scope.config = function (evt) {
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $scope.listView = false;
                    } else {
                        $scope.displayList = false;
                    }
                };

                $scope.contMenuConfigs = 0;
                $scope.stopMenuBroadcast = function () {
                    $scope.contMenuConfigs = 0;
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displayList || $scope.displaySubMenu) {
                        if ($scope.contMenuConfigs === 0) {
                            $scope.contMenuConfigs = 1;
                        } else {
                            $scope.cancel();
                            $scope.displaySubMenu = false;
                            $scope.contMenuConfigs = 0;
                        }
                    } else {
                        $scope.contMenuConfigs = 0;
                    }
                });

                //Close menu
                $scope.cancel = function () {
                    $scope.displayList = false;
                };

                var parseDescriptionHelper = function parseDescriptionHelper(selected) {
                    $scope.descriptionEmpty = true;
                    return selected === "showSelectedList" ? "" : "Description";
                };

                $scope.blockTrigger = function () {
                    Intercom('trackEvent', 'AP - Block Trigger');
                    var status = $scope.blocked ? 1 : 0;
                    canvasService.blockJourney($rootScope.currentAPId, status).success(function (_ref) {
                        var ReportInformation = _ref.ReportInformation;

                        $scope.blocked = !$scope.blocked;
                        if ($scope.blocked) {
                            $scope.blockDate = ReportInformation.History[8];
                        }
                    });
                };
            }],
            link: function link(scope, elem, attr) {
                if ($rootScope.aElement) {
                    // bullet proving multiple targets
                    if (document.getElementById($rootScope.aElement.id)) {
                        delete $rootScope.aElement;
                        return false;
                    }

                    // load template
                    var template = $templateCache.get('active_templates/entries/active-date-and-time'),
                        modalTemplate = $templateCache.get('active_templates/entries/modal-active-date-and-time');

                    scope.left = $rootScope.aElement.left;
                    scope.top = $rootScope.aElement.top;
                    scope.id = $rootScope.aElement.id;
                    scope.color = $rootScope.aElement.color;
                    scope.type = $rootScope.aElement.type;
                    scope.data = $rootScope.aElement.data;
                    scope.contactListData = $rootScope.contactListData;
                    scope.numbers = '0';

                    $rootScope.listSelected = helpers.getContactListItem(scope.data.selectedList[0], scope.contactListData, '');

                    delete $rootScope.aElement;

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    var modalContent = $compile(modalTemplate)(scope);
                    $('body').append(modalContent);

                    $rootScope.$on('reporter_' + $rootScope.currentAPId + scope.id, function (evt, data) {
                        if (data) {
                            scope.numbers = data;
                        }
                    });

                    $rootScope.$on('entryBlock', function (evt, block, date) {
                        scope.blocked = block;
                        scope.blockDate = date;
                    });
                }
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    angular.module('active-website-engagement.dir', ['ngclipboard']).directive('activeWebsiteEngagement', ['$rootScope', '$compile', '$templateCache', 'helpers', 'canvasService', activeWebsiteEngagement]);

    //Website Engagement Directive
    function activeWebsiteEngagement($rootScope, $compile, $templateCache, helpers, canvasService) {

        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                $scope.breakUrl = function () {
                    return $scope.data.specificUrl.replace(/(.{70})/g, "$1<br />");
                };

                $scope.parseDescription = function (desc, specificUrl) {
                    if (specificUrl) {
                        if (desc) {
                            var arrLen = desc.split("");
                            arrLen = arrLen.length;
                            if (arrLen > 15) {
                                return desc.slice(0, 15) + '...';
                            } else {
                                return desc;
                            }
                        } else if ($scope.data.source === 'contains-url') {
                            return $scope.translate('canvas.entry.websiteEngagement.containsUrl');
                        } else {
                            return $scope.translate('canvas.condition.websiteActivity.specificUrl');
                        }
                    } else {
                        if (desc) {
                            desc = desc.splitCharAndUpper();
                        } else {
                            return $scope.translate('commons.enterDetails');
                        }
                    }

                    return desc;
                };

                //Show or hide menu on Element click
                $scope.config = function (evt) {
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                    } else {
                        $scope.displayList = false;
                        $scope.trackingTestClass = '';
                    }
                };

                $scope.showReport = function () {
                    var firstOccurrence = $scope.id.indexOf('_');
                    var secondOccurrence = $scope.id.indexOf('_', firstOccurrence + 1);
                    var elementId = $scope.id.slice(0, secondOccurrence);
                    canvasService.getNodeDetails($rootScope.currentAPId, elementId).then(function (res) {
                        return res.data;
                    }).then(function (nodeDetails) {
                        canvasService.getNodeMetricDetailsGroupByType($rootScope.currentAPId, nodeDetails.NodeId, nodeDetails.NodeActionType).then(function (res) {
                            var data = [nodeDetails, res.data];
                            $rootScope.$emit('summary', true, $rootScope.currentAPId, $rootScope.currentJBTitle, undefined, -1, false, true, data);
                        });
                    });
                };

                $scope.contMenuConfigs = 0;
                $scope.stopMenuBroadcast = function () {
                    $scope.contMenuConfigs = 0;
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displayList || $scope.displaySubMenu) {
                        if ($scope.contMenuConfigs === 0) {
                            $scope.contMenuConfigs = 1;
                        } else {
                            $scope.cancel();
                            $scope.displaySubMenu = false;
                            $scope.contMenuConfigs = 0;
                        }
                    } else {
                        $scope.contMenuConfigs = 0;
                    }
                });
                //Close menu
                $scope.cancel = function () {
                    $scope.displayList = false;
                };

                $scope.displayTrackerModal = function () {
                    $rootScope.$emit('displayTrackerModal');
                };

                $scope.specificUrlOptions = [{
                    value: 'any-tracked-page',
                    message: $scope.translate('canvas.entry.websiteEngagement.anyTracked')
                }, {
                    value: 'is-url',
                    message: $scope.translate('canvas.entry.websiteEngagement.specificUrl')
                }, {
                    value: 'contains-url',
                    message: $scope.translate('canvas.entry.websiteEngagement.containsUrl')
                }, {
                    value: 'doesnotcontain-url',
                    message: $scope.translate('canvas.entry.websiteEngagement.not.containsUrl')
                }, {
                    value: 'startswith-url',
                    message: $scope.translate('canvas.entry.websiteEngagement.starts.with.url')
                }, {
                    value: 'endswith-url',
                    message: $scope.translate('canvas.entry.websiteEngagement.ends.with.url')
                }, {
                    value: 'wildcardmatch-url',
                    message: $scope.translate('canvas.entry.websiteEngagement.wildcard.url')
                }];

                $scope.blockTrigger = function () {
                    Intercom('trackEvent', 'AP - Block Trigger');
                    var status = $scope.blocked ? 1 : 0;
                    canvasService.blockJourney($rootScope.currentAPId, status).success(function (_ref) {
                        var ReportInformation = _ref.ReportInformation;

                        $scope.blocked = !$scope.blocked;
                        if ($scope.blocked) {
                            $scope.blockDate = ReportInformation.History[8];
                        }
                    });
                };
            }],
            link: function link(scope, elem, attr) {
                //Setting initial form on true to display radio buttons
                scope.displayForm = true;

                if ($rootScope.aElement) {
                    // bullet proving multiple targets
                    if (document.getElementById($rootScope.aElement.id)) {
                        delete $rootScope.aElement;
                        return false;
                    }

                    // load template
                    var template = $templateCache.get('active_templates/entries/active-website-engagement'),
                        modalTemplate = $templateCache.get('active_templates/entries/modal-active-website-engagement');

                    scope.left = $rootScope.aElement.left;
                    scope.top = $rootScope.aElement.top;
                    scope.id = $rootScope.aElement.id;
                    scope.type = $rootScope.aElement.type;
                    scope.data = $rootScope.aElement.data;
                    scope.color = $rootScope.aElement.color;
                    scope.numbers = '0';

                    delete $rootScope.aElement;

                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    var modalContent = $compile(modalTemplate)(scope);
                    $('body').append(modalContent);

                    $rootScope.$on('reporter_' + $rootScope.currentAPId + scope.id, function (evt, data) {
                        if (data) {
                            scope.numbers = data;
                        }
                    });

                    $rootScope.$on('entryBlock', function (evt, block, date) {
                        scope.blocked = block;
                        scope.blockDate = date;
                    });
                }
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    angular.module('add-to-list-action.dir', ['journey.veil']).directive('addToListAction', ['$rootScope', '$compile', '$templateCache', 'plumbService', 'helpers', 'canvasService', '$timeout', 'CANVAS_OPTS', addToListAction]);

    function addToListAction($rootScope, $compile, $templateCache, plumbService, helpers, canvasService, $timeout, CANVAS_OPTS) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;
                $scope.descriptionEmpty = false;
                $scope.wasSave = false;

                //When we save a the form
                $scope.save = function () {
                    //If form data is missing
                    if ($scope.dataFilledCorrectly() === false) {
                        $rootScope.$emit('displayActionAddListModalError');
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.601'));
                        if ($scope.tempConn) {
                            $scope.connections = angular.copy($scope.tempConn);
                        }
                    }
                    //Else we proceed to save and create new elements
                    else {
                            $scope.isDummyData();

                            //Updates the parent to register its children
                            var parentData = helpers.getConnectionById($scope.connections.parent);
                            if (parentData) {
                                parentData.children = [];
                                parentData.children.push($scope.connections.id);
                                helpers.updateConnections(parentData);
                            }
                            //Save to the global canvas object
                            helpers.updateConnections($scope.connections);

                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1) {
                                $rootScope.unsavedData.splice(index, 1);
                            }

                            //Displays th form data
                            $scope.displayList = false;
                            $rootScope.$emit('hideActionAddListModal');
                            //Displays action menu
                            $scope.displaySubMenu = false;
                            //Hides Error
                            $scope.displayError = false;

                            var desc = $scope.parseDescription($scope.connections.data.selectedList, 'showDescription');
                            if (desc) {
                                $scope.description = desc;
                            }

                            //Save Journey to template
                            canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), $scope.isElegibleForUpdate);

                            if ($scope.isElegibleForUpdate) {
                                $scope.wasSave = true;
                                $timeout(function () {
                                    $scope.wasSave = false;
                                }, 1500);
                            }

                            //Set Back to autoSave
                            $scope.isElegibleForUpdate = true;
                            //Remove Activate Error since its being able to save
                            $scope.displayActivateError = false;
                            $scope.displayErrorBlink = false;
                        }

                    // Listener to show or hide the delete arrow or add connection arrow
                    $rootScope.$on('showDeleteArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showDeleteArrow = condition;
                    });

                    $rootScope.$on('showConnectionArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showConnectionArrow = condition;
                    });
                };

                $scope.isDummyData = function () {
                    if ($scope.connections.isDummy) {
                        if ($scope.connections.data.selectedList[0] !== '11111111') {
                            delete $scope.connections.isDummy;
                        }
                    }
                };

                //Validates if data is filled correctly or not
                $scope.dataFilledCorrectly = function () {
                    if ($scope.connections.data.selectedList === 0 || $scope.descriptionEmpty) {
                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index === -1) {
                            $rootScope.unsavedData.push($scope.connections.id);
                        }

                        $scope.displayError = true;
                        return false;
                    }
                    return true;
                };

                $scope.setLastElem = function (evt) {
                    plumbService.setLastElemClicked($(evt.target).parents('div.shape').attr('id'));
                };

                $scope.toggleConnectionMenu = function (event) {
                    //Check if form data is filled and a connection exists as only one is allowed
                    if (helpers.checkIfIsConnected(event.target.parentNode.id)) {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.602'));
                    } else {
                        if ($('#' + event.target.parentNode.id).find('.action-conditions').inlineStyle('display') === 'none') {
                            //remove the hidden style
                            $('#' + event.target.parentNode.id).find('.action-conditions').show().prev().show();

                            $scope.displaySubMenu = true;
                            $scope.displayList = false;
                            $scope.$broadcast('setMenuDefaults');
                            $rootScope.$emit('hideActionAddListModal');
                        } else {
                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.611'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayActionAddListModal', $scope.connections);
                            } else if ($scope.connections.data.selectedList.length == 0) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.603'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayActionAddListModal', $scope.connections);
                            } else if ($scope.displaySubMenu === false) {
                                $scope.displaySubMenu = true;
                                $scope.displayList = false;
                                $scope.$broadcast('setMenuDefaults');
                                $rootScope.$emit('hideActionAddListModal');
                            } else {
                                $scope.displaySubMenu = false;
                                $scope.displayList = false;
                                $rootScope.$emit('hideActionAddListModal');
                            }
                        }
                    }
                };

                //Cancel Button
                $scope.cancel = function () {
                    //Hide Menu
                    $scope.displayList = false;
                    //Hide Error
                    $scope.displayError = false;

                    if ($scope.connections) {
                        var conn = helpers.getStorageConnectionById($scope.connections.id);
                        if (conn) {
                            $scope.connections.data = conn.data;
                            if ($scope.connections.data.selectedList[0] === '11111111') {
                                $scope.connections.isDummy = true;
                            }
                        }
                    }
                };

                //Cancel Button
                $scope.config = function (evt) {
                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left'));

                    // check if being dragged and update position
                    if (newTop !== $scope.connections.top || $scope.connections.left !== newLeft) {
                        $scope.displayList = false;
                        $rootScope.$emit('hideActionAddListModal');
                        //update rootScope position
                        var wasUpdated = helpers.updatePos($scope.connections.id, newTop, newLeft);
                        // To check if the element has been saved or not in the rootScope
                        if (!wasUpdated) {
                            $scope.connections.top = newTop;
                            $scope.connections.left = newLeft;
                        }
                        return false;
                    }
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $rootScope.$emit('displayActionAddListModal', $scope.connections);
                    } else {
                        $scope.displayList = false;
                        $rootScope.$emit('hideActionAddListModal');
                    }
                    //Hide Error
                    $scope.displayError = false;
                    $scope.displaySubMenu = false;
                };

                $scope.showTipModal = function () {
                    // last options is for is tip modal.
                    $rootScope.$emit('displayActionAddListModal', $scope.connections, true);
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displayList || $scope.displaySubMenu) {
                        $scope.cancel();
                        $scope.displaySubMenu = false;
                        $scope.contMenuConfigs = 0;
                    }
                });

                $scope.getSelectedText = function (desc) {
                    if ($scope.connections.data.selectedList.length === 1) {
                        for (var item in desc) {
                            desc = helpers.getContactListItem(desc[item], $scope.contactListData);
                        }

                        return desc;
                    } else {
                        var lists = [];

                        for (var i = 0; i < desc.length; i++) {
                            lists.push(helpers.getContactListItem(desc[i], $scope.contactListData));
                        }

                        return lists.join().replace(/,/g, '<br />');
                    }
                };

                $scope.parseDescription = function (desc, selected) {
                    if (desc && (typeof desc === 'undefined' ? 'undefined' : _typeof(desc)) === 'object') {
                        var descriptionCheck = false;
                        for (var item in desc) {

                            if (desc[item]) {
                                $scope.descriptionEmpty = false;
                                descriptionCheck = true;
                                //Lists that are currently selected on the node
                                var totalLists = $scope.connections.data.selectedList.length;
                                desc = helpers.getContactListItem(desc[item], $scope.contactListData);

                                //One list selected and > 19
                                if (totalLists === 1 && desc.length > 15) {
                                    desc = desc.slice(0, 15) + '...';
                                    //More than one selected
                                } else if (totalLists > 1) {
                                    desc = totalLists + " " + $scope.translate('commons.selectedList');
                                }

                                break;
                            }
                        }
                        if (!descriptionCheck) {
                            $scope.descriptionEmpty = true;

                            if (selected === 'showSelectedList') {
                                return '';
                            } else {
                                return $scope.translate('commons.enterDetails');
                            }
                        }
                    } else {
                        $scope.descriptionEmpty = true;

                        if (selected === 'showSelectedList') {
                            return '';
                        } else {
                            return $scope.translate('commons.enterDetails');
                        }
                    }

                    return desc;
                };

                $scope.displayModal = function () {
                    $scope.contactListData = $rootScope.contactListData;
                    $scope.modalWindow = true;
                    $rootScope.$emit('displayExtraVeil', true);
                };

                $scope.hideModal = function (clearList) {
                    if (clearList) {
                        $scope.selectedKey = $scope.translate('commons.selectList');
                        $scope.connections.data.selectedList = [];
                    }
                    //Hide Menu
                    $scope.modalWindow = false;
                    $rootScope.$emit('displayExtraVeil', false);
                };

                $scope.contMenu = 0;
                $scope.validClickingArea = function () {
                    $scope.contMenu = 0;
                };
                $scope.$on('hideActionListModal', function () {
                    if ($scope.modalWindow) {
                        if ($scope.contMenu === 0) {
                            $scope.contMenu = 1;
                        } else {
                            $scope.hideModal();
                            $scope.contMenu = 0;
                        }
                    } else {
                        $scope.contMenu = 0;
                    }
                });

                $scope.description = '';
                $rootScope.$watch('contactListData', function (list) {
                    if (list && list.length && $scope.connections) {
                        $scope.contactListData = list;
                        var desc = $scope.parseDescription($scope.connections.data.selectedList, 'showDescription');

                        if (desc) {
                            $scope.description = desc;
                            $scope.placeholder = false;
                        }
                    }
                });

                $scope.$watch('connections', function (conn) {
                    if (conn && conn.children && conn.children.length) {
                        $scope.disAllowDrag = helpers.validateDragging(conn);
                    } else if (conn && !conn.children) {
                        $scope.disAllowDrag = true;
                    }
                });
            }],
            link: function link(scope, elem, attr) {

                //Scope data initialization
                scope.displayList = true;
                scope.displayError = false;
                scope.displaySubMenu = false;
                scope.isElegibleForUpdate = true;

                //load existing
                if ($rootScope.cElement) {
                    // bullet proving multiple targets
                    if (scope.connections) {
                        if (document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    scope.connections = $rootScope.cElement;
                    delete $rootScope.cElement;

                    scope.placeholder = true;
                    scope.isElegibleForUpdate = false;

                    scope.selectedKey = scope.translate('commons.selectList');
                    if (scope.connections.data.selectedList.length) {
                        scope.selectedKey = scope.translate('commons.editSelection');
                    }

                    var template = $templateCache.get('actions/add-to-list');

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('activateErr_' + scope.connections.id, function (evt, display) {
                        scope.displayActivateError = display;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function (evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveActionAddListData' + scope.connections.id, function (evt, conn, descriptionEmpty) {
                        scope.contactListData = $rootScope.contactListData;
                        scope.descriptionEmpty = descriptionEmpty;
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    scope.contactListData = $rootScope.contactListData;

                    if (scope.connections && scope.connections.children && scope.connections.children.length) {
                        $timeout(function () {
                            scope.disAllowDrag = helpers.validateDragging(scope.connections);
                        }, 1000);
                    } else if (scope.connections && !scope.connections.children) {
                        scope.disAllowDrag = true;
                    }

                    scope.save();
                }

                $(elem).click(function (evt) {

                    //Load Template
                    var template = $templateCache.get('actions/add-to-list'),
                        now = new Date(),
                        lastElemId = plumbService.getLastElemClicked(),
                        lastElement = helpers.getConnectionById(lastElemId);

                    scope.selectedKey = scope.translate('commons.selectList');

                    $rootScope.activePlus = false;

                    //Start Connection obj
                    scope.connections = {
                        id: 'element_' + now.getTime(),
                        top: lastElement.type == 'RectangleConnection' ? lastElement.top - 43 : lastElement.top,
                        left: lastElement.left + 250,
                        type: 'Action',
                        data: { selectedList: [] },
                        elemClass: attr.$attr,
                        elemName: 'AddToList',
                        parent: lastElement.id,
                        //Triger: #4F4FC9 // Action: #B21877 // Condition: #FF7F57
                        color: '#B21877'
                    };

                    //Create template and compile it
                    scope.$apply(function () {
                        var content = $compile(template)(scope);
                        $(elem).parents('.canvas').append(content);
                    });

                    // keep track of what has been saved, for activation
                    $rootScope.unsavedData.push(scope.connections.id);

                    $rootScope.$on('activateErr_' + scope.connections.id, function (evt, display) {
                        scope.displayActivateError = display;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function (evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveUnsavedData' + scope.connections.id, function () {
                        scope.isElegibleForUpdate = false;
                        scope.save();
                        scope.isElegibleForUpdate = true;
                        if (scope.displayError) {
                            $timeout(function () {
                                scope.displayList = true;
                                $rootScope.$emit('displayActionAddListModal', scope.connections);
                            }, 250);
                        }
                    });

                    //List modal display new modals
                    $rootScope.$emit('displayActionAddListModal', scope.connections);

                    $rootScope.$on('saveActionAddListData' + scope.connections.id, function (evt, conn, descriptionEmpty) {
                        scope.contactListData = $rootScope.contactListData;
                        scope.descriptionEmpty = descriptionEmpty;
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    // Listener when user cancel the add new list
                    $rootScope.$on('deleteAddListNode' + scope.connections.id, function () {
                        scope.deleteElement();
                    });

                    scope.contactListData = $rootScope.contactListData;

                    $rootScope.$emit('closeMenus', true);

                    plumbService.connectElements(lastElement, scope.connections);
                });

                scope.deleteElement = function () {
                    var idx = $rootScope.unsavedData.indexOf(scope.connections.id);
                    if (idx > -1) {
                        $rootScope.unsavedData.splice(idx, 1);
                    }
                    scope.displayActivateError = false;
                    scope.displayErrorBlink = false;
                    plumbService.deleteElements(scope.connections);

                    if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry') {
                        $rootScope.activePlus = true;
                    } else {
                        $rootScope.activePlus = false;
                    }
                };

                scope.deleteArrow = function () {
                    if (scope.connections.hasOwnProperty('children')) {
                        scope.hasArrow = false;
                        plumbService.deleteArrows(scope.connections);
                    }
                };
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    angular.module('add-to-list-entry.dir', ['journey.canvas.srv', 'journey.veil']).directive('addToListEntry', ['$rootScope', '$compile', '$templateCache', 'canvasService', 'helpers', 'CANVAS_OPTS', '$timeout', 'plumbService', addToListEntry]);

    function addToListEntry($rootScope, $compile, $templateCache, canvasService, helpers, CANVAS_OPTS, $timeout, plumbService) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                //extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;
                $scope.descriptionEmpty = false;

                //When we save a the form
                $scope.save = function (conn) {
                    //If form data is missing
                    if ($scope.dataFilledCorrectly() === false) {
                        $rootScope.$emit('displayEntryListModalError');
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.601'));
                        if ($scope.tempConn) {
                            $scope.connections = angular.copy($scope.tempConn);
                        }
                    }
                    //Else we proceed to save and create new elements
                    else {
                            $scope.setIntercomm();

                            $scope.isDummyData();
                            //Save to the global canvas object
                            helpers.updateConnections($scope.connections);

                            //Displays th form data
                            $scope.displayList = false;
                            $rootScope.$emit('hideEntryListModal');

                            //Displays action menu
                            $scope.displaySubMenu = false;
                            //Hides Error
                            $scope.displayError = false;
                            $scope.errorList = false;
                            $scope.errorContacts = false;

                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1) {
                                $rootScope.unsavedData.splice(index, 1);
                            }

                            var desc = $scope.parseDescription($scope.connections.data.selectedList, 'showDescription');
                            if (desc) {
                                $scope.description = desc;
                            }

                            //Save Journey to template
                            canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), $scope.isElegibleForUpdate);
                            //Set Back to autoSave
                            $scope.isElegibleForUpdate = true;
                            //Remove Activate Error since its being able to save
                            $scope.displayActivateError = false;
                            $scope.displayErrorBlink = false;
                        }

                    // Listener to show or hide the delete arrow or add connection arrow
                    $rootScope.$on('showDeleteArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showDeleteArrow = condition;
                    });

                    $rootScope.$on('showConnectionArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showConnectionArrow = condition;
                    });
                };

                $scope.setIntercomm = function () {
                    //Intercom track event Activated Journey
                    Intercom('trackEvent', 'AP - Started with added to list');

                    if ($scope.connections.data.contactOptions === 'add-contacts-list') {
                        Intercom('trackEvent', 'AP - List Subscribers - Existing', {
                            description: 'Existing subscribers only in added to list trigger'
                        });
                    }

                    if ($scope.connections.data.contactOptions === 'all-in-any-future') {
                        Intercom('trackEvent', 'AP - List Subscribers - All', {
                            description: 'All Subscribers in added to list trigger'
                        });
                    }

                    if ($scope.connections.data.contactOptions === 'add-contacts-future') {
                        Intercom('trackEvent', 'AP - List Subscribers - New', {
                            description: 'New subscribers only in added to list trigger'
                        });
                    }
                };

                $scope.isDummyData = function () {
                    if ($scope.connections.isDummy) {
                        if ($scope.connections.data.selectedList[0] !== '11111111') {
                            delete $scope.connections.isDummy;
                        }
                    }
                };

                //Validates if data is filled correctly or not
                $scope.dataFilledCorrectly = function () {

                    var res = true,
                        lists = $scope.connections.data.selectedList,
                        contactOptions = $scope.connections.data.contactOptions;

                    if (lists.length == 0 && !contactOptions) {

                        $scope.errorList = true;
                        $scope.errorContacts = true;

                        res = false;
                    } else if (lists.length === 0) {

                        $scope.errorList = true;
                        $scope.errorContacts = false;

                        res = false;
                    } else if (!contactOptions) {

                        $scope.errorContacts = true;
                        $scope.errorList = false;

                        res = false;
                    } else if (lists === '400 Error') {
                        res = false;
                    } else if (lists.length > 0 && contactOptions != 'add-contacts-future') {

                        for (var item in lists) {
                            var contacts = helpers.getContactsFromList(lists[item], $scope.contactListData);
                            if (contacts > 200000) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.610'), 'error');
                                $scope.errorList = true;
                                res = false;
                            }
                        }
                    }

                    if (!res) {
                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index === -1) {
                            $rootScope.unsavedData.push($scope.connections.id);
                        }
                    }

                    return res;
                };

                //Toggle List Item to check if a checkbox is checked, If not we add it to the array of IDs, if not we delete it and just save the ones selected
                $scope.toggelListItem = function (listItem) {
                    if ($scope.connections.isDummy) {
                        $scope.connections.data.selectedList = [];
                        delete $scope.connections.isDummy;
                    }

                    var index = $scope.connections.data.selectedList.indexOf(listItem);
                    if (index > -1) {
                        $scope.connections.data.selectedList.splice(index, 1);
                    } else {
                        $scope.connections.data.selectedList.push(listItem);
                    }

                    if ($scope.connections.data.selectedList.length) {
                        $scope.selectedKey = $scope.translate('commons.editSelection');
                    } else {
                        $scope.selectedKey = $scope.translate('commons.selectList');
                    }
                };

                $scope.setLastElem = function (evt) {
                    plumbService.setLastElemClicked($(evt.target).parents('div.shape').attr('id'));
                };

                $scope.menuPos = {
                    left: 440
                };
                $scope.toggleConnectionMenu = function (event) {
                    if ($rootScope.connections && $rootScope.connections.length > 1) {
                        $scope.menuPos.left = 200;
                    } else {
                        $scope.menuPos.left = 440;
                    }

                    //Move Canvas when element is close to the edge
                    //Check if form data is filled and a connection exists as only one is allowed
                    if (helpers.checkIfIsConnected(event.target.parentNode.id)) {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.602'));
                    } else {
                        if ($('#' + event.target.parentNode.id).find('.action-conditions').inlineStyle('display') === 'none') {
                            //remove the hidden style
                            $('#' + event.target.parentNode.id).find('.action-conditions').show().prev().show();
                            $scope.displaySubMenu = true;
                            $scope.displayList = false;
                            $rootScope.$emit('hideEntryListModal');
                            $scope.$broadcast('setMenuDefaults');
                        } else {
                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.611'));
                                $rootScope.$emit('displayEntryListModal', $scope.connections);
                                $scope.displaySubMenu = false;
                            } else if ($scope.connections.data.selectedList.length === 0 || !$scope.connections.data.contactOptions) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.603'));
                                $rootScope.$emit('displayEntryListModal', $scope.connections);
                                $scope.displaySubMenu = false;
                            } else if ($scope.displaySubMenu === false) {
                                $scope.displaySubMenu = true;
                                $scope.displayList = false;
                                $rootScope.$emit('hideEntryListModal');
                                $scope.$broadcast('setMenuDefaults');
                            } else {
                                $scope.displaySubMenu = false;
                                $scope.displayList = false;
                                $rootScope.$emit('hideEntryListModal');
                            }
                        }
                    }
                };

                //Cancel Button
                $scope.cancel = function () {
                    //Hide Menu
                    $scope.displayList = false;
                    if ($scope.connections) {
                        var conn = helpers.getStorageConnectionById($scope.connections.id);
                        if (conn) {
                            $scope.connections.data = conn.data;
                            if ($scope.connections.data.selectedList[0] === '11111111') {
                                $scope.connections.isDummy = true;
                            }
                        }
                    }
                };

                $scope.config = function (evt) {
                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left'));

                    // check if being dragged and update position
                    if (newTop !== $scope.connections.top || $scope.connections.left !== newLeft) {
                        //update rootScope position
                        var wasUpdated = helpers.updatePos($scope.connections.id, newTop, newLeft);
                        // To check if the element has been saved or not in the rootScope
                        if (!wasUpdated) {
                            $scope.connections.top = newTop;
                            $scope.connections.left = newLeft;
                        }
                        return false;
                    }
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $rootScope.$emit('displayEntryModal', 'isAddToListFormDisplayed', $scope.connections);
                    }

                    //Hide Error
                    $scope.displayError = false;
                    $scope.displaySubMenu = false;
                };

                $scope.showTipModal = function () {
                    // displays tip modal
                    $rootScope.$emit('displayEntryListModal', $scope.connections, true);
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displayList || $scope.displaySubMenu) {
                        $scope.cancel();
                        $scope.displaySubMenu = false;
                        $scope.contMenuConfigs = 0;
                    }
                });

                $scope.getSelectedText = function (desc) {
                    if ($scope.connections.data.selectedList.length === 1) {
                        for (var item in desc) {
                            desc = helpers.getContactListItem(desc[item], $scope.contactListData);
                        }

                        return desc;
                    } else {
                        var lists = [];

                        for (var i = 0; i < desc.length; i++) {
                            lists.push(helpers.getContactListItem(desc[i], $scope.contactListData));
                        }

                        return lists.join().replace(/,/g, '<br />');
                    }
                };

                $scope.parseDescription = function (desc, selected) {
                    if (desc && (typeof desc === 'undefined' ? 'undefined' : _typeof(desc)) === 'object') {
                        var descriptionCheck = false;
                        for (var item in desc) {
                            if (desc[item]) {
                                $scope.descriptionEmpty = false;
                                descriptionCheck = true;
                                var totalLists = $scope.connections.data.selectedList.length;
                                desc = helpers.getContactListItem(desc[item], $scope.contactListData);

                                //One list selected and > 19
                                if (totalLists === 1 && desc.length > 15) {
                                    desc = desc.slice(0, 15) + '...';
                                    //More than one selected
                                } else if (totalLists > 1) {
                                    desc = totalLists + " " + $scope.translate('commons.selectedList');
                                }

                                break;
                            }
                        }
                        if (!descriptionCheck) {
                            $scope.descriptionEmpty = true;

                            if (selected === 'showSelectedList') {
                                return '';
                            } else {
                                return $scope.translate('commons.enterDetails');
                            }
                        }
                    } else {
                        $scope.descriptionEmpty = true;

                        if (selected === 'showSelectedList') {
                            return '';
                        } else {
                            return $scope.translate('commons.enterDetails');
                        }
                    }

                    return desc;
                };

                $scope.displayModal = function () {
                    $scope.contactListData = $rootScope.contactListData;
                    $scope.modalWindow = true;
                    $rootScope.$emit('displayExtraVeil', true);
                };

                $scope.hideModal = function (clearList) {
                    if (clearList) {
                        $scope.selectedKey = $scope.translate('commons.selectList');
                        $scope.connections.data.selectedList = [];
                    }
                    $scope.modalWindow = false;
                    $rootScope.$emit('displayExtraVeil', false);
                };

                $scope.deleteEntry = function () {
                    var idx = $rootScope.unsavedData.indexOf($scope.connections.id);
                    if (idx > -1) {
                        $rootScope.unsavedData.splice(idx, 1);
                    }

                    plumbService.deleteElements($scope.connections);
                    $scope.$emit('displayJourney', true);

                    var shapeDelete;
                    shapeDelete = angular.element(document.querySelector('#step-placeholder' + $scope.connections.id));
                    jsPlumb.detachAllConnections(shapeDelete);
                    shapeDelete.remove();

                    $rootScope.deletedEntry = true;
                };

                $scope.contMenu = 0;
                $scope.validClickingArea = function () {
                    $scope.contMenu = 0;
                };
                $scope.$on('hideEntryListModal', function () {
                    if ($scope.modalWindow) {
                        if ($scope.contMenu === 0) {
                            $scope.contMenu = 1;
                        } else {
                            $scope.hideModal();
                            $scope.contMenu = 0;
                        }
                    } else {
                        $scope.contMenu = 0;
                    }
                });

                //Check RootScope connection to check if there is only an Entry on the Canvas.
                //We listen the saveJourneyStorage function on Canvas Service.
                $timeout(function () {
                    $rootScope.$watch('conn', function () {
                        if ($scope.connections && $scope.connections.id && document.getElementById($scope.connections.id)) {
                            if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry') {
                                setTimeout(function () {
                                    plumbService.simpleConnect($scope.connections.id, 'step-placeholder' + $scope.connections.id, 'rgba(207, 207, 218, 1)');
                                }, 100);
                            } else {
                                var arrowConn = angular.element(document.querySelector('#' + $scope.connections.id));
                                jsPlumb.detachAllConnections(arrowConn);
                            }
                        }
                    });
                }, 1000);

                $scope.description = '';
                $rootScope.$watch('contactListData', function (list) {
                    if (list && list.length && $scope.connections) {
                        $scope.contactListData = list;
                        var desc = $scope.parseDescription($scope.connections.data.selectedList, 'showDescription');

                        if (desc) {
                            $scope.description = desc;
                        }
                    }
                });
            }],
            link: function link(scope, elem, attr) {
                // load existing
                if ($rootScope.cElement) {
                    // bullet proving multiple targets
                    if (scope.connections) {

                        if (document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    scope.connections = $rootScope.cElement;

                    delete $rootScope.cElement;

                    // scope initialization
                    scope.displayList = true;
                    scope.displayError = false;
                    scope.displaySubMenu = false;

                    // global scope data initialization
                    scope.isElegibleForUpdate = scope.connections.isElegibleForUpdate || false;
                    delete scope.connections.isElegibleForUpdate;

                    scope.selectedKey = scope.translate('commons.selectList');
                    if (scope.connections.data.selectedList.length) {
                        scope.selectedKey = scope.translate('commons.editSelection');
                    }

                    //Create template and compile it
                    //Load Template
                    var template = angular.element($templateCache.get('entry/added-to-list')),
                        canvasEl = angular.element(document.querySelector('.canvas'));

                    canvasEl.append(template);

                    scope.$apply(function () {
                        $compile(template)(scope);
                    });

                    $rootScope.$on('activateErr_' + scope.connections.id, function (evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function (evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveEntryData' + scope.connections.id, function (evt, conn) {
                        scope.contactListData = $rootScope.contactListData;
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save(scope.connections);
                        scope.connections.wasSave = true;

                        $timeout(function () {
                            scope.connections.wasSave = false;
                        }, 1500);
                    });

                    scope.contactListData = $rootScope.contactListData;

                    scope.save();
                    scope.connections.wasSave = false;

                    $timeout(function () {
                        if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry') {
                            var timeout = setTimeout(function () {
                                plumbService.simpleConnect(scope.connections.id, 'step-placeholder' + scope.connections.id, 'rgba(207, 207, 218, 1)');
                            }, 100);
                            clearTimeout(timeout);
                        }
                    }, 200);

                    $rootScope.$emit('closeMenus', true);
                    plumbService.setInitDragConnect(scope.connections);
                }

                scope.deleteArrow = function () {
                    if (scope.connections.hasOwnProperty('children')) {
                        scope.hasArrow = false;
                        plumbService.deleteArrows(scope.connections);
                    }
                };
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    angular.module('add-to-segment-entry.dir', ['journey.canvas.srv', 'journey.veil']).directive('addToSegmentEntry', ['$rootScope', '$compile', '$templateCache', 'canvasService', 'helpers', 'CANVAS_OPTS', '$timeout', 'plumbService', '$sce', addToSegmentEntry]);

    function addToSegmentEntry($rootScope, $compile, $templateCache, canvasService, helpers, CANVAS_OPTS, $timeout, plumbService, $sce) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                //extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;
                $scope.descriptionEmpty = false;
                $scope.trackOnce = true;

                //When we save a the form
                $scope.save = function () {
                    //If form data is missing
                    if ($scope.dataFilledCorrectly() === false) {
                        $rootScope.$emit('displayEntrySegmentModalError');
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.601'));
                        if ($scope.tempConn) {
                            $scope.connections = angular.copy($scope.tempConn);
                        }
                    }
                    //Else we proceed to save and create new elements
                    else {
                            $scope.isDummyData();

                            // intercom Tracking Event
                            if ($scope.trackOnce) {
                                Intercom('trackEvent', 'AP - Started with added to segment');
                                $scope.trackOnce = false;
                            }

                            if ($scope.connections.data.listData) {
                                $scope.connections.data.listData = $scope.connections.data.selectedList.map(function (sId) {
                                    return {
                                        listId: sId,
                                        segmentId: helpers.getListBySegmentId(sId)
                                    };
                                });
                            }

                            //Save to the global canvas object
                            helpers.updateConnections($scope.connections);
                            //Displays th form data
                            $scope.displayList = false;
                            $rootScope.$emit('hideEntrySegmentModal');
                            //Displays action menu
                            $scope.displaySubMenu = false;
                            //Hides Error
                            $scope.displayError = false;
                            $scope.errorList = false;
                            $scope.errorContacts = false;

                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1) {
                                $rootScope.unsavedData.splice(index, 1);
                            }

                            var desc = $scope.parseDescription($scope.connections.data.selectedList, 'showDescription');
                            if (desc) {
                                $scope.description = desc;
                            }

                            //Save Journey to template
                            canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), $scope.isElegibleForUpdate);

                            //Set Back to autoSave
                            $scope.isElegibleForUpdate = true;
                            //Remove Activate Error since its being able to save
                            $scope.displayActivateError = false;
                        }

                    // Listener to show or hide the delete arrow or add connection arrow
                    $rootScope.$on('showDeleteArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showDeleteArrow = condition;
                    });

                    $rootScope.$on('showConnectionArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showConnectionArrow = condition;
                    });
                };

                $scope.isDummyData = function () {
                    if ($scope.connections.isDummy) {
                        if ($scope.connections.data.selectedList[0] !== '11111111') {
                            delete $scope.connections.isDummy;
                        }
                    }
                };

                //Validates if data is filled correctly or not
                $scope.dataFilledCorrectly = function () {
                    var res = true,
                        lists = $scope.connections.data.selectedList,
                        contactOptions = $scope.connections.data.contactOptions;

                    if (lists.length == 0 && !contactOptions) {
                        $scope.errorList = true;
                        $scope.errorContacts = true;

                        res = false;
                    } else if (lists.length === 0) {
                        $scope.errorList = true;
                        $scope.errorContacts = false;

                        res = false;
                    } else if (!contactOptions) {
                        $scope.errorContacts = true;
                        $scope.errorList = false;

                        res = false;
                    } else if (lists === '400 Error') {
                        res = false;
                    } else if (lists.length > 0 && contactOptions != 'add-contacts-future') {
                        for (var item in lists) {
                            var contacts = helpers.getContactsFromList(lists[item], null, $scope.segmentData);
                            if (contacts > 200000) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.612'), 'error');
                                $scope.errorList = true;
                                res = false;
                            }
                        }
                    }

                    if (!res) {
                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index === -1) {
                            $rootScope.unsavedData.push($scope.connections.id);
                        }
                    }

                    return res;
                };

                //Toggle List Item to check if a checkbox is checked, If not we add it to the array of IDs, if not we delete it and just save the ones selected
                $scope.toggelListItem = function (listItem) {
                    if ($scope.connections.isDummy) {
                        $scope.connections.data.selectedList = [];
                        delete $scope.connections.isDummy;
                    }

                    $scope.connections.data.selectedList = [];
                    $scope.connections.data.selectedList.push(listItem);

                    if ($scope.connections.data.selectedList.length) {
                        $scope.selectedKey = $scope.translate('commons.editSelection');
                    } else {
                        $scope.selectedKey = $scope.translate('canvas.entry.addedToSegment.selectSegment');
                    }
                };

                $scope.setLastElem = function (evt) {
                    plumbService.setLastElemClicked($(evt.target).parents('div.shape').attr('id'));
                };

                $scope.menuPos = {
                    left: 440
                };
                $scope.toggleConnectionMenu = function (event) {
                    if ($rootScope.connections && $rootScope.connections.length > 1) {
                        $scope.menuPos.left = 200;
                    } else {
                        $scope.menuPos.left = 440;
                    }

                    //Check if form data is filled and a connection exists as only one is allowed
                    if (helpers.checkIfIsConnected(event.target.parentNode.id)) {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.602'));
                    } else {
                        if ($('#' + event.target.parentNode.id).find('.action-conditions').inlineStyle('display') === 'none') {
                            //remove the hidden style
                            $('#' + event.target.parentNode.id).find('.action-conditions').show().prev().show();
                            $scope.displaySubMenu = true;
                            $scope.displayList = false;
                            $rootScope.$emit('hideEntrySegmentModal');
                            $scope.$broadcast('setMenuDefaults');
                        } else {
                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.611'));
                                $scope.displayList = true;
                                $rootScope.$emit('displayEntrySegmentModal', $scope.connections);
                                $scope.displaySubMenu = false;
                            } else if ($scope.connections.data.selectedList.length === 0 || !$scope.connections.data.contactOptions) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.603'));
                                $scope.displayList = true;
                                $rootScope.$emit('displayEntrySegmentModal', $scope.connections);
                                $scope.displaySubMenu = false;
                            } else if ($scope.displaySubMenu === false) {
                                $scope.displaySubMenu = true;
                                $scope.displayList = false;
                                $rootScope.$emit('hideEntrySegmentModal');
                                $scope.$broadcast('setMenuDefaults');
                            } else {
                                $scope.displaySubMenu = false;
                                $scope.displayList = false;
                                $rootScope.$emit('hideEntrySegmentModal');
                            }
                        }
                    }
                };

                $scope.showTipModal = function () {
                    // displays tip modal
                    $rootScope.$emit('displayEntrySegmentModal', $scope.connections, true);
                };

                //Cancel Button
                $scope.cancel = function () {
                    //Hide Menu
                    $scope.displayList = false;
                    //Hide Error
                    $scope.displayError = false;

                    if ($scope.connections) {
                        var conn = helpers.getStorageConnectionById($scope.connections.id);
                        if (conn) {
                            $scope.connections.data = conn.data;
                            if ($scope.connections.data.selectedList[0] === '11111111') {
                                $scope.connections.isDummy = true;
                            }
                        }
                    }
                };

                $scope.config = function (evt) {
                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left'));

                    // check if being dragged and update position
                    if (newTop !== $scope.connections.top || $scope.connections.left !== newLeft) {
                        //update rootScope position
                        var wasUpdated = helpers.updatePos($scope.connections.id, newTop, newLeft);
                        // To check if the element has been saved or not in the rootScope
                        if (!wasUpdated) {
                            $scope.connections.top = newTop;
                            $scope.connections.left = newLeft;
                        }
                        return false;
                    }
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $rootScope.$emit('displayEntryModal', 'isAddToSegmentFormDisplayed', $scope.connections);
                    }

                    //Hide Error
                    $scope.displayError = false;
                    $scope.displaySubMenu = false;
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displayList || $scope.displaySubMenu) {
                        $scope.cancel();
                        $scope.displaySubMenu = false;
                        $scope.contMenuConfigs = 0;
                    }
                });

                $scope.decodeHtml = function (html) {
                    var txt = document.createElement('textarea');
                    txt.innerHTML = html;
                    return txt.value;
                };

                $scope.getSelectedText = function (desc) {
                    if ($scope.connections.data.selectedList.length === 1) {
                        for (var item in desc) {
                            desc = helpers.getContactListItem(desc[item], null, $scope.segmentData);
                        }

                        return desc;
                    } else {
                        var lists = [];

                        for (var i = 0; i < desc.length; i++) {
                            lists.push(helpers.getContactListItem(desc[i], null, $scope.segmentData));
                        }

                        return lists.join().replace(/,/g, '<br />');
                    }
                };

                $scope.parseDescription = function (desc, selected) {
                    if (desc && (typeof desc === 'undefined' ? 'undefined' : _typeof(desc)) === 'object') {
                        var descriptionCheck = false;
                        for (var item in desc) {
                            if (desc[item]) {
                                $scope.descriptionEmpty = false;
                                descriptionCheck = true;
                                var totalLists = $scope.connections.data.selectedList.length;
                                desc = $scope.decodeHtml(helpers.getContactListItem(desc[item], $scope.ListName, $scope.segmentData));

                                //One list selected and > 19
                                if (totalLists === 1 && desc.length > 15) {
                                    desc = desc.slice(0, 15) + '...';
                                    //More than one selected
                                } else if (totalLists > 1) {
                                    desc = totalLists + ' ' + $scope.translate('canvas.entry.addedToSegment.selectedSegment');
                                }

                                break;
                            }
                        }
                        if (!descriptionCheck) {
                            $scope.descriptionEmpty = true;

                            if (selected === 'showSelectedList') {
                                return '';
                            } else {
                                return $scope.translate('commons.enterDetails');
                            }
                        }
                    } else {
                        $scope.descriptionEmpty = true;

                        if (selected === 'showSelectedList') {
                            return '';
                        } else {
                            return $scope.translate('commons.enterDetails');
                        }
                    }

                    return desc;
                };

                $scope.displayModal = function () {
                    $scope.segmentData = $rootScope.segmentData;
                    $scope.modalWindow = true;
                    $rootScope.$emit('displayExtraVeil', true);
                };

                $scope.hideModal = function (clearList) {
                    if (clearList) {
                        $scope.selectedKey = $scope.translate('canvas.entry.addedToSegment.selectSegment');
                        $scope.connections.data.selectedList = [];
                    }
                    $scope.modalWindow = false;
                    $rootScope.$emit('displayExtraVeil', false);
                };

                $scope.deleteEntry = function () {
                    var idx = $rootScope.unsavedData.indexOf($scope.connections.id);
                    if (idx > -1) {
                        $rootScope.unsavedData.splice(idx, 1);
                    }

                    plumbService.deleteElements($scope.connections);
                    $scope.$emit('displayJourney', true);

                    var shapeDelete;
                    shapeDelete = angular.element(document.querySelector('#step-placeholder' + $scope.connections.id));
                    jsPlumb.detachAllConnections(shapeDelete);
                    shapeDelete.remove();

                    $rootScope.deletedEntry = true;
                };

                $scope.contMenu = 0;
                $scope.validClickingArea = function () {
                    $scope.contMenu = 0;
                };
                $scope.$on('hideEntryListModal', function () {
                    if ($scope.modalWindow) {
                        if ($scope.contMenu === 0) {
                            $scope.contMenu = 1;
                        } else {
                            $scope.hideModal();
                            $scope.contMenu = 0;
                        }
                    } else {
                        $scope.contMenu = 0;
                    }
                });

                //Check RootScope connection to check if there is only an Entry on the Canvas.
                //We listen the saveJourneyStorage function on Canvas Service.
                $timeout(function () {
                    $rootScope.$watch('conn', function () {
                        if ($scope.connections && $scope.connections.id && document.getElementById($scope.connections.id)) {
                            if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry') {
                                setTimeout(function () {
                                    plumbService.simpleConnect($scope.connections.id, 'step-placeholder' + $scope.connections.id, 'rgba(207, 207, 218, 1)');
                                }, 100);
                            } else {
                                var arrowConn = angular.element(document.querySelector('#' + $scope.connections.id));
                                jsPlumb.detachAllConnections(arrowConn);
                            }
                        }
                    });
                }, 1000);

                $scope.description = '';
                $rootScope.$watch('segmentData', function (list) {
                    if (list && list.length && $scope.connections) {
                        $scope.segmentData = list;
                        var desc = $scope.parseDescription($scope.connections.data.selectedList, 'showDescription');

                        if (desc) {
                            $scope.description = desc;
                            $scope.placeholder = false;
                        }
                    }
                });
            }],
            link: function link(scope, elem, attr) {
                // scope initialization
                scope.displayList = true;
                scope.displayError = false;
                scope.displaySubMenu = false;
                scope.isElegibleForUpdate = true;

                // load existing
                if ($rootScope.cElement) {
                    // bullet proving multiple targets
                    if (scope.connections) {
                        if (document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    scope.connections = $rootScope.cElement;
                    delete $rootScope.cElement;

                    // global scope data initialization
                    scope.isElegibleForUpdate = scope.connections.isElegibleForUpdate || false;
                    delete scope.connections.isElegibleForUpdate;
                    scope.placeholder = true;

                    scope.selectedKey = scope.translate('canvas.entry.addedToSegment.selectSegment');
                    if (scope.connections.data.selectedList.length) {
                        scope.selectedKey = scope.translate('commons.editSelection');
                    }

                    //Load Template
                    var template = angular.element($templateCache.get('entry/added-to-segment')),
                        canvasEl = angular.element(document.querySelector('.canvas'));

                    canvasEl.append(template);

                    scope.$apply(function () {
                        $compile(template)(scope);
                    });

                    $rootScope.$on('activateErr_' + scope.connections.id, function (evt, display) {
                        scope.displayActivateError = display;
                    });

                    $rootScope.$on('saveEntrySegmentData' + scope.connections.id, function (evt, conn) {
                        scope.segmentData = $rootScope.segmentData;
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                        scope.connections.wasSave = true;

                        $timeout(function () {
                            scope.connections.wasSave = false;
                        }, 1500);
                    });

                    scope.segmentData = $rootScope.segmentData;

                    scope.save();
                    scope.connections.wasSave = false;

                    $timeout(function () {
                        if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry') {
                            setTimeout(function () {
                                plumbService.simpleConnect(scope.connections.id, 'step-placeholder' + scope.connections.id, 'rgba(207, 207, 218, 1)');
                            }, 100);
                        }
                    }, 200);

                    $rootScope.$emit('closeMenus', true);
                    plumbService.setInitDragConnect(scope.connections);
                }

                scope.deleteArrow = function () {
                    if (scope.connections.hasOwnProperty('children')) {
                        scope.hasArrow = false;
                        scope.displayActivateError = false;
                        plumbService.deleteArrows(scope.connections);
                    }
                };
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    angular.module('add-wait-time-action.dir', []).directive('addWaitTimeAction', ['$rootScope', '$compile', '$templateCache', 'plumbService', 'helpers', 'canvasService', 'CANVAS_OPTS', '$timeout', addWaitTimeAction]);

    function addWaitTimeAction($rootScope, $compile, $templateCache, plumbService, helpers, canvasService, CANVAS_OPTS, $timeout) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                // accepted values
                $scope.enums = {
                    minutes: 60,
                    hours: 24,
                    days: 365,
                    weeks: 52,
                    months: 12
                };

                //When we save a the form
                $scope.save = function (dummy) {
                    //If form data is missing
                    if ($scope.dataFilledCorrectly() === false) {
                        $scope.displayError = true;
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.601'));
                        $rootScope.$emit('displayActionAddWaitTimeModalError', $scope.errorUnits, $scope.errorDelay);
                        if ($scope.tempConn) {
                            $scope.connections = angular.copy($scope.tempConn);
                        }
                    }
                    //Else we proceed to save and create new elements
                    else {
                            if (!dummy && $scope.connections.isDummy) {
                                delete $scope.connections.isDummy;
                            }

                            //Updates the parent to register its children
                            var parentData = helpers.getConnectionById($scope.connections.parent);
                            if (parentData) {
                                parentData.children = [];
                                parentData.children.push($scope.connections.id);
                                helpers.updateConnections(parentData);
                            }
                            //Save to the global canvas object
                            helpers.updateConnections($scope.connections);

                            if (!$scope.connections.isDummy) {
                                var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                                if (index > -1) {
                                    $rootScope.unsavedData.splice(index, 1);
                                }
                            }

                            //Displays th form data
                            $scope.displayList = false;
                            $rootScope.$emit('hideActionAddWaitTimeModal');
                            //Displays action menu
                            $scope.displaySubMenu = false;
                            //Hides Error
                            $scope.displayError = false;
                            $scope.errorDelay = false;
                            $scope.errorUnits = false;
                            //Save Journey to template
                            canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), $scope.isElegibleForUpdate);

                            if ($scope.isElegibleForUpdate && !dummy) {
                                $scope.wasSave = true;
                                $timeout(function () {
                                    $scope.wasSave = false;
                                }, 1500);
                            }

                            //Set Back to autoSave
                            $scope.isElegibleForUpdate = true;
                            //Remove Activate Error since its being able to save
                            $scope.displayActivateError = false;
                            $scope.displayErrorBlink = false;
                        }

                    // Listener to show or hide the delete arrow or add connection arrow
                    $rootScope.$on('showDeleteArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showDeleteArrow = condition;
                    });

                    $rootScope.$on('showConnectionArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showConnectionArrow = condition;
                    });
                };

                //Validates if data is filled correctly or not
                $scope.dataFilledCorrectly = function () {
                    var res = true;
                    $scope.errorUnits = false;
                    $scope.errorDelay = false;

                    if ($scope.connections.data.delay && $scope.connections.data.units) {
                        if ($scope.connections.data.delay > $scope.enums[$scope.connections.data.units]) {
                            $scope.connections.data.delay = '';
                            $scope.errorDelay = true;
                            res = false;
                        }
                    }

                    if (!$scope.connections.data.delay) {
                        $scope.errorDelay = true;
                        res = false;
                    }

                    if (!$scope.connections.data.units) {
                        $scope.errorUnits = true;
                        res = false;
                    }

                    if (!res) {
                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index === -1) {
                            $rootScope.unsavedData.push($scope.connections.id);
                        }
                    }

                    return res;
                };

                $scope.toggleConnectionMenu = function (event) {
                    if (helpers.checkIfIsConnected(event.target.parentNode.id)) {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.602'));
                    } else {
                        if ($('#' + event.target.parentNode.id).find('.action-conditions').inlineStyle('display') === 'none') {
                            //remove the hidden style
                            $('#' + event.target.parentNode.id).find('.action-conditions').show().prev().show();
                            $scope.displaySubMenu = true;
                            $scope.displayList = false;
                            $scope.$broadcast('setMenuDefaults');
                            $rootScope.$emit('hideActionAddWaitTimeModal');
                        } else {
                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1 || $scope.connections.isDummy) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.611'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayActionAddWaitTimeModal', $scope.connections);
                            } else if (!$scope.connections.data.delay || !$scope.connections.data.units) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.603'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayActionAddWaitTimeModal', $scope.connections);
                            } else if ($scope.displaySubMenu === false) {
                                $scope.displaySubMenu = true;
                                $scope.displayList = false;
                                $scope.$broadcast('setMenuDefaults');
                                $rootScope.$emit('hideActionAddWaitTimeModal');
                            } else {
                                $scope.displaySubMenu = false;
                                $scope.displayList = false;
                                $rootScope.$emit('hideActionAddWaitTimeModal');
                            }
                        }
                    }
                };

                $scope.showTipModal = function () {
                    // displays tip modal
                    $rootScope.$emit('displayActionAddWaitTimeModal', $scope.connections, true);
                };

                //Cancel Button
                $scope.cancel = function () {
                    //Hide Menu
                    $scope.displayList = false;
                    //Hide Error
                    $scope.displayError = false;

                    if ($scope.connections) {
                        var conn = helpers.getStorageConnectionById($scope.connections.id);
                        if (conn) {
                            $scope.connections.data = conn.data;
                        }
                    }
                };

                $scope.config = function (evt) {
                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left'));

                    // check if being dragged and update position
                    if (newTop !== $scope.connections.top || $scope.connections.left !== newLeft) {
                        $scope.displayList = false;
                        //update rootScope position
                        var wasUpdated = helpers.updatePos($scope.connections.id, newTop, newLeft);
                        // To check if the element has been saved or not in the rootScope
                        if (!wasUpdated) {
                            $scope.connections.top = newTop;
                            $scope.connections.left = newLeft;
                        }
                        $rootScope.$emit('hideActionAddWaitTimeModal');
                        return false;
                    }
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $rootScope.$emit('displayActionAddWaitTimeModal', $scope.connections);
                    } else {
                        $scope.displayList = false;
                        $rootScope.$emit('hideActionAddWaitTimeModal');
                    }
                    //Hide Error
                    $scope.displayError = false;
                    $scope.displaySubMenu = false;
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displayList || $scope.displaySubMenu) {
                        $scope.cancel();
                        $scope.displaySubMenu = false;
                        $scope.contMenuConfigs = 0;
                    }
                });

                $scope.parseDescription = function (delay, units) {
                    if (delay && units) {
                        var period = delay > 1 ? 'plural' : 'singular';

                        switch (units) {
                            case "minutes":
                                units = $scope.translate('canvas.action.addWaitTime.minutes.' + period);
                                $scope.connections.data.units = '';
                                break;
                            case "hours":
                                units = $scope.translate('canvas.action.addWaitTime.hours.' + period);
                                break;
                            case "days":
                                units = $scope.translate('canvas.action.addWaitTime.days.' + period);
                                break;
                            case "weeks":
                                units = $scope.translate('canvas.action.addWaitTime.weeks.' + period);
                                break;
                            case "months":
                                units = $scope.translate('canvas.action.addWaitTime.months.' + period);
                                break;
                            default:
                                units = units;
                        }
                        return delay + ' ' + units.firstUpper();
                    } else {
                        return $scope.translate('commons.enterDetails');
                    }
                };

                $scope.setLastElem = function (evt) {
                    plumbService.setLastElemClicked($(evt.target).parents('div.shape').attr('id'));
                };

                $rootScope.$on('generateWaitTime', function (evt, id) {
                    $rootScope.delayConns = $rootScope.delayConns || [];
                    if (!$rootScope.delayConns.includes(id) && !$scope.hasChildren(id)) {
                        $rootScope.currentDelayConn = id;
                        $rootScope.delayConns.push(id);
                        plumbService.setLastElemClicked(id);
                        $timeout(function () {
                            $('#' + id + ' li[add-wait-time-action]').click();
                        }, 0);
                    }
                });

                $scope.hasChildren = function (id) {
                    var el = helpers.getConnectionById(id);

                    return el.children && el.children.length > 0;
                };

                $scope.$watch('connections', function (conn) {
                    if (conn && conn.children && conn.children.length) {
                        $scope.disAllowDrag = helpers.validateDragging(conn);
                    } else if (conn && !conn.children) {
                        $scope.disAllowDrag = true;
                    }
                });
            }],
            link: function link(scope, elem, attr) {
                //Scope data initialization
                scope.displayList = true;
                scope.displayError = false;
                scope.displaySubMenu = false;
                scope.isElegibleForUpdate = true;
                scope.wasSave = false;

                //load existing
                if ($rootScope.cElement) {
                    // bullet proving multiple targets
                    if (scope.connections) {
                        if (document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    scope.connections = $rootScope.cElement;
                    delete $rootScope.cElement;
                    scope.isElegibleForUpdate = false;

                    var template = $templateCache.get('actions/add-wait-time');

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('activateErr_' + scope.connections.id, function (evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function (evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveActionAddWaitTimeData' + scope.connections.id, function (evt, conn) {
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    scope.save(true);

                    if (scope.connections && scope.connections.children && scope.connections.children.length) {
                        $timeout(function () {
                            scope.disAllowDrag = helpers.validateDragging(scope.connections);
                        }, 1000);
                    } else if (scope.connections && !scope.connections.children) {
                        scope.disAllowDrag = true;
                    }
                }

                // when a directive is clicked
                $(elem).click(function (evt) {
                    // bullet proving multiple targets
                    if (scope.connections) {
                        if (document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    $rootScope.activePlus = false;

                    if ($rootScope.currentDelayConn) {
                        scope.currentDelayConn = $rootScope.currentDelayConn;
                        delete $rootScope.currentDelayConn;
                    }

                    //Load Template
                    var template = $templateCache.get('actions/add-wait-time'),
                        now = new Date(),
                        lastElemId = plumbService.getLastElemClicked(),
                        lastElement = helpers.getConnectionById(lastElemId);

                    //Start Connection obj
                    scope.connections = {
                        id: 'element_' + now.getTime(),
                        top: lastElement.type == 'RectangleConnection' ? lastElement.top - 43 : lastElement.top,
                        left: lastElement.left + 250,
                        type: 'Action',
                        data: { delay: 24, units: 'hours' },
                        elemClass: attr.$attr,
                        elemName: 'AddWaitTime',
                        parent: lastElement.id,
                        //Triger: #4F4FC9 // Action: #B21877 // Condition: #FF7F57
                        color: '#B21877'
                    };

                    //Create template and compile it
                    scope.$apply(function () {
                        var content = $compile(template)(scope);
                        $(elem).parents('.canvas').append(content);
                    });

                    // keep track of what has been saved, for activation
                    $rootScope.unsavedData.push(scope.connections.id);

                    $rootScope.$on('activateErr_' + scope.connections.id, function (evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function (evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveUnsavedData' + scope.connections.id, function () {
                        scope.isElegibleForUpdate = false;
                        scope.save();
                        scope.isElegibleForUpdate = true;
                        if (scope.displayError) {
                            $timeout(function () {
                                scope.displayList = true;
                                $rootScope.$emit('displayActionAddWaitTimeModal', scope.connections);
                            }, 250);
                        }
                    });

                    $rootScope.$on('saveActionAddWaitTimeData' + scope.connections.id, function (evt, conn) {
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    // Listener when user cancel the add the node of delay
                    $rootScope.$on('deleteWaitTimeNode' + scope.connections.id, function () {
                        scope.deleteElement();
                    });

                    if (!scope.currentDelayConn) {
                        $rootScope.$emit('displayActionAddWaitTimeModal', scope.connections);
                    } else {
                        // setting default data
                        scope.connections.data = { delay: 24, units: 'hours' };
                        scope.save();
                    }

                    //Hide hide menus
                    $rootScope.$emit('closeMenus', true);
                    scope.displayList = true;

                    plumbService.connectElements(lastElement, scope.connections);
                });

                scope.deleteElement = function () {
                    var idx = $rootScope.unsavedData.indexOf(scope.connections.id);
                    if (idx > -1) {
                        $rootScope.unsavedData.splice(idx, 1);
                    }
                    scope.displayActivateError = false;
                    scope.displayErrorBlink = false;
                    plumbService.deleteElements(scope.connections);
                    scope.connections = null;
                    scope.currentDelayConn = null;
                    $rootScope.delayConns = $rootScope.delayConns || [];
                    $rootScope.delayConns.splice(scope.currentDelayConn, 1);

                    if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry') {
                        $rootScope.activePlus = true;
                    } else {
                        $rootScope.activePlus = false;
                    }
                };

                scope.deleteArrow = function () {
                    if (scope.connections.hasOwnProperty('children')) {
                        scope.hasArrow = false;
                        plumbService.deleteArrows(scope.connections);
                    }
                };
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    angular.module('date-and-time.dir', []).directive('dateAndTime', ['$rootScope', '$compile', '$templateCache', 'helpers', 'canvasService', 'CANVAS_OPTS', 'timezoneFactory', 'plumbService', '$timeout', dateAndTime]);

    //Website Engagement Directive
    function dateAndTime($rootScope, $compile, $templateCache, helpers, canvasService, CANVAS_OPTS, timezoneFactory, plumbService, $timeout) {

        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                //When we save a the form
                $scope.save = function () {

                    //If form data is missing data to be filled
                    if ($scope.dataFilledCorrectly() === false) {
                        var errors = {
                            selectedListError: $scope.selectedListError,
                            errorTime: $scope.errorTime,
                            errorTimezone: $scope.errorTimezone
                        };

                        $rootScope.$emit('displayEntryDateTimeModalError', errors);

                        if ($scope.tempConn) {
                            $scope.connections = angular.copy($scope.tempConn);
                        }

                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.601'));
                    }
                    //Else we proceed to save and create new elements
                    else {
                            //Tracking event Intercom Date and Time
                            Intercom('trackEvent', 'AP - Started with date/time');
                            //Save to the global canvas object
                            helpers.updateConnections($scope.connections);
                            //Displays th form data
                            $scope.displayList = false;
                            $rootScope.$emit('hideEntryDateTimeModal');
                            //Displays action menu
                            $scope.displaySubMenu = false;
                            //Hides Error
                            $scope.displayError = false;
                            $scope.selectedListError = false;
                            $scope.errorTime = false;

                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1) {
                                $rootScope.unsavedData.splice(index, 1);
                            }

                            //Save Journey to template
                            canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), $scope.isElegibleForUpdate);
                            //Set Back to autoSave
                            $scope.isElegibleForUpdate = true;
                            //Remove Activate Error since its being able to save
                            $scope.displayActivateError = false;
                            $scope.displayErrorBlink = false;
                        }

                    // Listener to show or hide the delete arrow or add connection arrow
                    $rootScope.$on('showDeleteArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showDeleteArrow = condition;
                    });

                    $rootScope.$on('showConnectionArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showConnectionArrow = condition;
                    });
                };

                //Validates if data is filled correctly or not

                $scope.dataFilledCorrectly = function () {

                    var isClean = true,
                        lists = $scope.connections.data.selectedList;
                    $scope.selectedListError = false;
                    $scope.errorTime = false;
                    $scope.errorTimezone = false;

                    if (!$scope.connections.data.time) {
                        $scope.errorTime = true;
                        isClean = false;
                    }

                    if (lists.length === 0) {
                        $scope.selectedListError = true;
                        isClean = false;
                    }

                    if (!$scope.connections.data.timezoneName) {
                        $scope.errorTimezone = true;
                        isClean = false;
                    } else if (lists.length > 0) {

                        for (var item in lists) {
                            var contacts = helpers.getContactsFromList(lists[item], $scope.contactListData);
                            if (contacts > 200000) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.610'), 'error');
                                $scope.selectedListError = true;
                                isClean = false;
                            }
                        }
                    }

                    if (!isClean) {
                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index === -1) {
                            $rootScope.unsavedData.push($scope.connections.id);
                        }
                    }

                    return isClean;
                };

                //Toggle List Item to check if a checkbox is checked, If not we add it to the array of IDs, if not we delete it and just save the ones selected
                $scope.toggelListItem = function (listItem) {
                    var index = $scope.connections.data.selectedList.indexOf(listItem);
                    if (index > -1) {
                        $scope.connections.data.selectedList.splice(index, 1);
                    } else {
                        $scope.connections.data.selectedList.push(listItem);
                    }

                    if ($scope.connections.data.selectedList.length) {
                        $scope.selectedKey = $scope.translate('commons.editSelection');
                    } else {
                        $scope.selectedKey = $scope.translate('commons.selectList');
                    }
                };

                $scope.setLastElem = function (evt) {
                    plumbService.setLastElemClicked($(evt.target).parents('div.shape').attr('id'));
                };

                $scope.menuPos = {
                    left: 440
                };
                $scope.toggleConnectionMenu = function (event) {
                    if ($rootScope.connections && $rootScope.connections.length > 1) {
                        $scope.menuPos.left = 200;
                    } else {
                        $scope.menuPos.left = 440;
                    }

                    //Move Canvas when element is close to the edge
                    if (helpers.checkIfIsConnected(event.target.parentNode.id)) {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.602'));
                    } else {
                        if ($('#' + event.target.parentNode.id).find('.action-conditions').inlineStyle('display') === 'none') {
                            //remove the hidden style
                            $('#' + event.target.parentNode.id).find('.action-conditions').show().prev().show();
                            $scope.displaySubMenu = true;
                            $scope.displayList = false;
                            $rootScope.$emit('hideEntryDateTimeModal');
                            $scope.$broadcast('setMenuDefaults');
                        } else {
                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.611'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayEntryDateTimeModal', $scope.connections);
                            } else if ($scope.connections.data.selectedList.length === 0 || !$scope.connections.data.time) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.603'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayEntryDateTimeModal', $scope.connections);
                            } else if ($scope.displaySubMenu === false) {
                                $scope.displaySubMenu = true;
                                $scope.displayList = false;
                                $scope.$broadcast('setMenuDefaults');
                                $rootScope.$emit('hideEntryDateTimeModal');
                            } else {
                                $scope.displaySubMenu = false;
                                $scope.displayList = false;
                                $rootScope.$emit('hideEntryDateTimeModal');
                            }
                        }
                    }
                };

                $scope.showTipModal = function () {
                    // displays tip modal
                    $rootScope.$emit('displayEntryDateTimeModal', $scope.connections, true);
                };

                //Cancel Button
                $scope.cancel = function () {};

                $scope.config = function (evt) {
                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left'));

                    // check if being dragged and update position
                    if (newTop !== $scope.connections.top || $scope.connections.left !== newLeft) {
                        //update rootScope position
                        var wasUpdated = helpers.updatePos($scope.connections.id, newTop, newLeft);
                        // To check if the element has been saved or not in the rootScope
                        if (!wasUpdated) {
                            $scope.connections.top = newTop;
                            $scope.connections.left = newLeft;
                        }
                        return false;
                    }
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $rootScope.$emit('displayEntryModal', 'isDateTimeFormDisplayed', $scope.connections);
                    }

                    //Hide Error
                    $scope.displayError = false;
                    $scope.displaySubMenu = false;
                };

                $scope.$on('closeConfigMenus', function (evt) {
                    if ($scope.displayList || $scope.displaySubMenu) {
                        $scope.cancel();
                        $scope.displaySubMenu = false;
                        $scope.contMenuConfigs = 0;
                    }
                });

                $scope.getSelectedText = function (desc) {
                    if ($scope.connections.data.selectedList.length === 1) {
                        for (var item in desc) {
                            desc = helpers.getContactListItem(desc[item], $scope.contactListData);
                        }

                        return desc;
                    } else {
                        var lists = [];

                        for (var i = 0; i < desc.length; i++) {
                            lists.push(helpers.getContactListItem(desc[i], $scope.contactListData));
                        }

                        return lists.join().replace(/,/g, '<br />');
                    }
                };

                $scope.parseDescription = function (desc, selected) {
                    if (desc && (typeof desc === 'undefined' ? 'undefined' : _typeof(desc)) === 'object') {
                        var descriptionCheck = false;
                        for (var item in desc) {
                            if (desc[item]) {
                                $scope.descriptionEmpty = false;
                                descriptionCheck = true;
                                //Lists that are currently selected on the node
                                var totalLists = $scope.connections.data.selectedList.length;
                                desc = helpers.getContactListItem(desc[item], $scope.contactListData);

                                //One list selected and > 19
                                if (totalLists === 1 && desc.length > 15) {
                                    desc = desc.slice(0, 15) + '...';
                                    //More than one selected
                                } else if (totalLists > 1) {
                                    desc = totalLists + " " + $scope.translate('commons.selectedList');
                                    //One selected but < 19
                                } else if (totalLists === 1 && desc.length < 15) {
                                    desc = desc;
                                }

                                break;
                            }
                        }
                        if (!descriptionCheck) {
                            $scope.descriptionEmpty = true;

                            if (selected === 'showSelectedList') {
                                return '';
                            } else {
                                return $scope.translate('commons.enterDetails');
                            }
                        }
                    } else {
                        $scope.descriptionEmpty = true;

                        if (selected === 'showSelectedList') {
                            return '';
                        } else {
                            return $scope.translate('commons.enterDetails');
                        }
                    }

                    return desc;
                };

                $scope.parseDescriptionMenu = function (desc) {
                    if (desc && (typeof desc === 'undefined' ? 'undefined' : _typeof(desc)) === 'object') {
                        for (var item in desc) {
                            desc = helpers.getContactListItem(item, $scope.contactListData);
                            desc = desc.slice(0, 19) + '...';
                            break;
                        }
                    } else {
                        return '...';
                    }

                    return desc;
                };

                $scope.deleteEntry = function () {
                    var idx = $rootScope.unsavedData.indexOf($scope.connections.id);
                    if (idx > -1) {
                        $rootScope.unsavedData.splice(idx, 1);
                    }

                    plumbService.deleteElements($scope.connections);
                    $scope.$emit('displayJourney', true);

                    var shapeDelete;
                    shapeDelete = angular.element(document.querySelector('#step-placeholder' + $scope.connections.id));
                    jsPlumb.detachAllConnections(shapeDelete);
                    shapeDelete.remove();

                    $rootScope.deletedEntry = true;
                };

                $scope.contMenu = 0;
                $scope.validClickingArea = function () {
                    $scope.contMenu = 0;
                };
                $scope.$on('hideDateTimeModal', function () {
                    if ($scope.modalWindow) {
                        if ($scope.contMenu === 0) {
                            $scope.contMenu = 1;
                        } else {
                            $scope.hideModal();
                            $scope.contMenu = 0;
                        }
                    } else {
                        $scope.contMenu = 0;
                    }
                });

                //Check RootScope connection to check if there is only an Entry on the Canvas.
                //We listen the saveJourneyStorage function on Canvas Service.
                $timeout(function () {
                    $rootScope.$watch('conn', function () {
                        if ($scope.connections && $scope.connections.id && document.getElementById($scope.connections.id)) {
                            if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry') {
                                setTimeout(function () {
                                    plumbService.simpleConnect($scope.connections.id, 'step-placeholder' + $scope.connections.id, 'rgba(207, 207, 218, 1)');
                                }, 100);
                            } else {
                                var arrowConn = angular.element(document.querySelector('#' + $scope.connections.id));
                                jsPlumb.detachAllConnections(arrowConn);
                            }
                        }
                    });
                }, 1000);
            }],
            link: function link(scope, elem, attr) {
                //Scope data initialization
                scope.displayList = true;
                scope.displayError = false;
                scope.displaySubMenu = false;
                scope.contactListData = $rootScope.contactListData;
                scope.timeZones = timezoneFactory.get();

                // load existing
                if ($rootScope.cElement) {
                    // bullet proving multiple targets
                    if (scope.connections) {
                        if (document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    scope.connections = $rootScope.cElement;
                    delete $rootScope.cElement;

                    ///Global scope data initialization
                    scope.isElegibleForUpdate = scope.connections.isElegibleForUpdate || false;
                    delete scope.connections.isElegibleForUpdate;

                    scope.selectedKey = scope.translate('commons.selectList');
                    if (scope.connections.data.selectedList.length) {
                        scope.selectedKey = scope.translate('commons.editSelection');
                    }

                    //Load Template
                    var template = angular.element($templateCache.get('entry/date-and-time')),
                        canvasEl = angular.element(document.querySelector('.canvas'));

                    canvasEl.append(template);

                    scope.$apply(function () {
                        $compile(template)(scope);
                    });

                    $rootScope.$on('activateErr_' + scope.connections.id, function (evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function (evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveEntryDateTimeData' + scope.connections.id, function (evt, conn) {
                        scope.selectedList = $rootScope.selectedList;
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                        scope.connections.wasSave = true;

                        $timeout(function () {
                            scope.connections.wasSave = false;
                        }, 1500);
                    });

                    scope.save();
                    scope.connections.wasSave = false;

                    $timeout(function () {
                        if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry') {
                            setTimeout(function () {
                                plumbService.simpleConnect(scope.connections.id, 'step-placeholder' + scope.connections.id, 'rgba(207, 207, 218, 1)');
                            }, 100);
                        }
                    }, 200);

                    $rootScope.$emit('closeMenus', true);
                    plumbService.setInitDragConnect(scope.connections);
                }

                scope.deleteArrow = function () {
                    if (scope.connections.hasOwnProperty('children')) {
                        scope.hasArrow = false;
                        plumbService.deleteArrows(scope.connections);
                    }
                };
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    angular.module('drag-canvas.dir', []).directive('draggable', ['$document', '$rootScope', dragCanvas]);

    //Function to Drag the canvas area
    function dragCanvas($document, $rootScope) {
        return {
            restrict: 'A',
            link: function link(scope, element, attrs) {
                var initX, initY, initMouseX, initMouseY;

                element.bind('mousedown', function ($event) {

                    initX = element.prop('offsetLeft');
                    initY = element.prop('offsetTop');
                    initMouseX = $event.clientX;
                    initMouseY = $event.clientY;

                    var cursorSettings = {
                        cursor: 'url(../../imgs/closedhand.cur), move'
                    };

                    if ($rootScope.isFireFox) {
                        cursorSettings.cursor = '-moz-grabbing';
                    }

                    if ($rootScope.isChrome) {
                        cursorSettings.cursor = '-webkit-grabbing';
                    }

                    element.css(cursorSettings);

                    $document.bind('mousemove', mousemove);
                    $document.bind('mouseup', mouseup);

                    return false;
                });

                function mousemove($event) {
                    var dx = $event.clientX - initMouseX;
                    var dy = $event.clientY - initMouseY;

                    element.css({
                        top: initY + dy + 'px',
                        left: initX + dx + 'px'
                    });

                    return false;
                }

                function mouseup() {
                    var cursorSettings = {
                        cursor: 'url(../../imgs/openhand.cur), move'
                    };

                    if ($rootScope.isFireFox) {
                        cursorSettings.cursor = '-moz-grab';
                    }

                    if ($rootScope.isChrome) {
                        cursorSettings.cursor = '-webkit-grab';
                    }

                    element.css(cursorSettings);

                    $document.unbind('mousemove');
                    $document.unbind('mouseup');
                }
            }
        };
    }
})();

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    angular.module('editor-menu.dir', []).directive('editorMenu', ['$rootScope', editorMenu]);

    function editorMenu($rootScope) {
        return {
            scope: {
                isActiveEmail: '=',
                connections: '='
            },
            templateUrl: function templateUrl(elem, attrs) {
                return attrs.templateUrl || 'app/views/templates/editor-menu.tpl.html';
            },
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                // Default value for editor
                $scope.editor = 'dad';

                $scope.redirectTo = function (id) {
                    if ($scope.isActiveEmail) {
                        $rootScope.$emit('activeRedirectTo', id);
                    } else {
                        $rootScope.$emit('redirectToEditor', id);
                    }

                    $scope.$parent.editorSubMenu = false;
                };

                $scope.switcher = function (editor) {
                    $scope.editor = editor;
                };

                $scope.hideModal = function () {
                    $rootScope.editorSubMenu = false;
                    $rootScope.$emit('hideEditorModal', $scope.connections);
                };

                $scope.upsellTracking = function ($event) {
                    if ($event.target.matches('a')) {
                        var eventName = 'code editor upsell - link';
                        if (typeof FS != 'undefined') {
                            FS.event(eventName);
                        }
                        Intercom('trackEvent', eventName);
                    }
                };
            }],
            link: function link(scope, elem) {
                scope.endJourney = function () {
                    scope.$parent.displaySubMenu = false;
                };
            }

        };
    }
})();

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    angular.module('element-menu-if-else.dir', []).directive('elementMenuIfElse', ['$rootScope', '$timeout', '$compile', elementMenuIfElse]);

    function elementMenuIfElse($rootScope, $timeout, $compile) {
        return {
            scope: {},
            templateUrl: 'app/views/templates/elements-menu-if-else.tpl.html',
            controller: ['$scope', '$http', '$sce', function ($scope, $http, $sce) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                $scope.actionList = true;

                //Function to Display Menu options on the view: Action / Condition
                function onDataComplete(response) {
                    $scope.menu = response.data;
                };

                function onError(reason) {
                    $scope.error = 'Could not load the list';
                };

                $http.get("app/services/mocks/elementMenuIfElse.json").then(onDataComplete, onError);
                //

                $scope.selectedPanel = function ($event) {
                    //Controller resources: Wrap, Action and Condition List
                    var wrap = $('.wrap');
                    var currentSelection = $event.target.id;

                    //adding Class active to the wrap, to be moved to the left to display panels
                    wrap.addClass('active');
                };

                $scope.selectedOption = function (option) {
                    $scope.$emit('selectedOption', option, $scope.$parent.connections.id);
                };
            }]
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    angular.module('element-menu.dir', []).directive('elementMenu', ['$rootScope', '$timeout', '$compile', 'plumbService', 'helpers', 'CANVAS_OPTS', elementMenu]);

    function elementMenu($rootScope, $timeout, $compile, plumbService) {
        return {
            transclude: true,
            templateUrl: 'app/views/templates/elements-menu.tpl.html',
            controller: ['$scope', '$http', '$sce', 'helpers', 'CANVAS_OPTS', function ($scope, $http, $sce, helpers, CANVAS_OPTS) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                $scope.actionList = false;
                $scope.conditionList = false;
                $scope.instructionsJumpTo = '<div style="max-width: 200px;"><div><img width="180" src="../../../imgs/reconnect.gif" /></div><div><p class="p-looping">' + $scope.translate("canvas.looping.tooltip-menu") + ' <br/> ' + $scope.translate("canvas.looping.tooltip-menu-2") + '</p></div></div>';

                $scope.$on('setMenuDefaults', function () {
                    if ($scope.actionList || $scope.conditionList) {
                        $scope.backMenu();
                    }
                });

                $scope.setLastElem = function (evt, id) {
                    var optId = $(evt.target).parents('div.shape').attr('id');
                    plumbService.setLastElemClicked(optId || id);
                };

                $scope.selectedPanel = function ($event, id) {
                    //Controller resources: Wrap, Action and Condition List
                    var wrap = $($event.currentTarget).parents('div.wrap');

                    //adding Class active to the wrap, to be moved to the left to display panels
                    wrap.addClass('active');

                    if (id == 'actionPanel') {
                        //Display Acions List
                        $scope.actionList = true;
                        $scope.conditionList = false;
                    } else {
                        //Display Conditions List
                        $scope.conditionList = true;
                        $scope.actionList = false;
                    }
                };

                $scope.backMenu = function () {
                    var wrap = $('.wrap');
                    wrap.removeClass("active");
                    $scope.conditionList = false;
                    $scope.actionList = false;
                };
            }],
            link: function link(scope, elem) {}
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    angular.module('email-engagement-condition.dir', []).directive('emailEngagementCondition', ['$rootScope', '$compile', '$templateCache', 'plumbService', 'helpers', 'canvasService', 'CANVAS_OPTS', '$timeout', emailEngagementCondition]);

    function emailEngagementCondition($rootScope, $compile, $templateCache, plumbService, helpers, canvasService, CANVAS_OPTS, $timeout) {
        return {
            scope: {},
            controller: ['$scope', '$http', function ($scope, $http) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;
                $scope.emailList = helpers.jbContainsSendEmail();
                $scope.wasSave = false;

                //When we save a the form
                $scope.save = function (dummy) {
                    if ($scope.hasErrors() === false) {
                        if (!dummy && $scope.connections.isDummy) {
                            delete $scope.connections.isDummy;
                        }

                        for (var j = 0; j < $scope.connections.data.conditions.length; j++) {
                            $scope.connections.data.conditions[j].name = $scope.connections.data.conditions[j].selectedCondition;
                            if (!$scope.connections.data.conditions[j].url) {
                                delete $scope.connections.data.conditions[j].url;
                            }
                        }

                        //Updates the parent to register its children
                        var parentData = helpers.getConnectionById($scope.connections.parent);
                        if (parentData) {
                            parentData.children = [];
                            parentData.children.push($scope.connections.id);
                            helpers.updateConnections(parentData);
                        }

                        //Save to the global canvas object
                        helpers.updateConnections($scope.connections);

                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index > -1) {
                            $rootScope.unsavedData.splice(index, 1);
                        }

                        //Displays th form data
                        $rootScope.$emit('hideConditionEmailEngagementtModal');
                        $scope.displayList = false;
                        //Hides Error
                        $scope.displayError = false;
                        $scope.urlError = false;

                        $scope.displayConditionMenu = [];
                        $scope.displayConditionConnectors = true;

                        var lastElement = $scope.connections;

                        lastElement.children = [];

                        //Create conditions connections
                        if ($rootScope.cElement) {
                            delete $rootScope.cElement;
                            $scope.newlyCreate = false;
                            for (var i = 0; i < $rootScope.loaderData.length; i++) {
                                if ($rootScope.loaderData[i].parent === lastElement.id) {
                                    if ($rootScope.loaderData[i].selectedId) {
                                        $rootScope.loaderData[i].label = $scope.getConditionListById($rootScope.loaderData[i].selectedId);
                                    }

                                    $scope.rectangleCons.push($rootScope.loaderData[i]);
                                    $scope.setPlumbRectangles(lastElement, $scope.rectangleCons.length - 1);

                                    if ($rootScope.loaderData[i].children) {
                                        $scope.hasArrow[$rootScope.loaderData[i].id] = true;
                                        $scope.showConnectionArrow[$rootScope.loaderData[i].id] = false;
                                    } else {
                                        $scope.hasArrow[$rootScope.loaderData[i].id] = false;
                                        $scope.showConnectionArrow[$rootScope.loaderData[i].id] = false;
                                    }

                                    $rootScope.$on('arrowReconnected' + $rootScope.loaderData[i].id, function (evt, id) {
                                        if (id) {
                                            $scope.hasArrow[id] = true;
                                        }
                                    });

                                    $rootScope.$on('hideArrowDelete' + $rootScope.loaderData[i].id, function (evt, id) {
                                        if (id) {
                                            $scope.hasArrow[id] = false;
                                        }
                                    });

                                    $rootScope.$on('showConnectionArrow_' + $rootScope.loaderData[i].id, function (event, condition, id) {
                                        $scope.showConnectionArrow[id] = condition;
                                    });
                                }
                            }
                        } else {

                            // saved for the first time
                            if ($scope.newlyCreate) {
                                $scope.newlyCreate = false;
                                for (var con in $scope.connections.data.conditions) {
                                    var lastTopRectangle;
                                    if (con != 0) {
                                        $scope.newlyCreate;
                                        lastTopRectangle = $scope.rectangleCons[con - 1].top + 200;
                                    }
                                    $scope.createNewConnection(lastElement, con, lastTopRectangle);
                                }
                            } else {
                                // on update, when save again
                                for (var cu in $scope.connections.data.conditions) {
                                    var lastTopRectangle;
                                    if (cu != 0) {
                                        lastTopRectangle = $scope.rectangleCons[cu - 1].top + 200;
                                    }
                                    if (cu < $scope.rectangleCons.length) {
                                        $scope.rectangleCons[cu].label = $scope.getConditionListById($scope.connections.data.conditions[cu].selectedCondition);
                                        $scope.rectangleCons[cu].selectedId = $scope.connections.data.conditions[cu].selectedCondition;
                                    } else {
                                        $scope.createNewConnection(lastElement, cu, lastTopRectangle);
                                    }
                                }

                                if ($scope.connections.data.conditions.length < $scope.rectangleCons.length) {
                                    var dataLeh = $scope.connections.data.conditions.length;
                                    var rectangleLen = $scope.rectangleCons.length;
                                    var rm = rectangleLen - dataLeh;
                                    var spliced = $scope.rectangleCons.splice(dataLeh, rm);

                                    for (var i = 0; i < spliced.length; i++) {
                                        var shapeDelete, el, arrowDelete, arrowDeleteTarget, loopDeleteTarget;

                                        shapeDelete = angular.element(document.querySelector('#' + spliced[i].id));
                                        arrowDelete = angular.element(document.querySelector('#' + spliced[i].id + '-center'));
                                        arrowDeleteTarget = angular.element(document.querySelector('#' + spliced[i].id + '-center-target'));
                                        loopDeleteTarget = angular.element(document.querySelector('#' + spliced[i].id + '-center-looping'));

                                        jsPlumb.detachAllConnections(shapeDelete);
                                        jsPlumb.detachAllConnections(arrowDelete);
                                        jsPlumb.detachAllConnections(arrowDeleteTarget);
                                        jsPlumb.detachAllConnections(loopDeleteTarget);

                                        shapeDelete.remove();
                                        el = helpers.deleteConnection(spliced[i]);

                                        if (el.deleted) {
                                            for (var j = 0; j < $rootScope.connections.length; j++) {
                                                if ($rootScope.connections[j].parent === el.elem.id) {
                                                    delete $rootScope.connections[j].parent;
                                                }
                                            }
                                            var parentCon = helpers.getConnectionById(el.elem.parent);
                                            if (parentCon.children) {
                                                var idx = parentCon.children.indexOf(el.elem.id);
                                                if (idx > -1) {
                                                    parentCon.children.splice(idx, 1);
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        for (var i = 0; i < $scope.rectangleCons.length; i++) {
                            $scope.rectangleCons[i].dataIndex = i;
                            $scope.displayPlus[i] = true;
                            if (lastElement) {
                                if (lastElement.children.indexOf($scope.rectangleCons[i].id) === -1) {
                                    lastElement.children.push($scope.rectangleCons[i].id);
                                }
                                helpers.updateConnections(lastElement);
                            }
                            //Save to the global canvas object
                            helpers.updateConnections($scope.rectangleCons[i]);
                        }

                        //Save Journey to template
                        canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), $scope.isElegibleForUpdate);

                        if ($scope.isElegibleForUpdate) {
                            $scope.wasSave = true;
                            $timeout(function () {
                                $scope.wasSave = false;
                            }, 1500);
                        }

                        //Set Back to autoSave
                        $scope.isElegibleForUpdate = true;
                        //Remove Activate Error since its being able to save
                        $scope.displayActivateError = false;
                        $scope.displayErrorBlink = false;
                    } else {

                        $scope.displayList = true;
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.601'));

                        if ($scope.tempConn) {
                            $scope.connections = angular.copy($scope.tempConn);
                        }
                    }
                };

                $scope.createNewConnection = function (lastElement, con, lastTopRectangle) {
                    var now = new Date(),
                        last,
                        idN;

                    $scope.rectangleCons.push({
                        id: 'element_' + now.getTime() + con,
                        top: con == 0 ? lastElement.top + 45 : lastTopRectangle,
                        left: lastElement.left + 250,
                        type: 'RectangleConnection',
                        data: {},
                        elemClass: 'rectangle-connector',
                        parent: lastElement.id,
                        //Triger: #4F4FC9 // Action: #B21877 // Condition: #FF7F57
                        color: '#FF7F57',
                        //Select first list element as label
                        selectedId: $scope.connections.data.conditions[con].selectedCondition,
                        label: $scope.getConditionListById($scope.connections.data.conditions[con].selectedCondition),
                        elemName: 'EmailEngagementConnector'
                    });

                    last = $scope.rectangleCons.length - 1;
                    idN = $scope.rectangleCons[last].id;
                    $scope.hasArrow[idN] = false;
                    $scope.showConnectionArrow[idN] = false;

                    $rootScope.$on('arrowReconnected' + idN, function (evt, id) {
                        if (id) {
                            $scope.hasArrow[id] = true;
                        }
                    });

                    $rootScope.$on('hideArrowDelete' + idN, function (evt, id) {
                        if (id) {
                            $scope.hasArrow[id] = false;
                        }
                    });

                    $rootScope.$on('showConnectionArrow_' + idN, function (event, condition, id) {
                        $scope.showConnectionArrow[id] = condition;
                    });

                    $scope.setPlumbRectangles(lastElement, con);
                };
                //Set up the rectangle connections
                $scope.setPlumbRectangles = function (lastElement, con) {
                    $timeout(function () {
                        plumbService.connectElements(lastElement, $scope.rectangleCons[con]);
                    }, 0);
                };

                $scope.hasErrors = function () {
                    $scope.hasError = false;
                    $scope.emailError = false;

                    if (!$scope.connections.data.emailNode || $scope.connections.data.emailNode === '') {
                        $scope.emailError = true;
                        $scope.hasError = true;
                        $rootScope.$emit('displayConditionEmailEngagementError', $scope.emailError);
                    }

                    for (var item in $scope.connections.data.conditions) {
                        $scope.conditionError[parseInt(item)] = false;
                        if ($scope.connections.data.conditions[item].selectedCondition === "" || !$scope.connections.data.conditions[item].selectedCondition) {
                            $scope.conditionError[parseInt(item)] = true;
                            $scope.hasError = true;
                            $rootScope.$emit('displayConditionEmailEngagementError', $scope.emailError, $scope.conditionError[parseInt(item)], item);
                        }
                    }

                    if ($scope.hasError) {
                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index === -1) {
                            $rootScope.unsavedData.push($scope.connections.id);
                        }
                    }

                    return $scope.hasError;
                };

                $scope.getConditionListById = function (prop) {
                    var propOrDefault = prop || 'hasOpened';
                    return {
                        hasOpened: $scope.translate('canvas.condition.emailEngagement.hasOpened'),
                        hasNotOpened: $scope.translate('canvas.condition.emailEngagement.hasNotOpened'),
                        hasClicked: $scope.translate('canvas.condition.emailEngagement.hasClicked'),
                        hasNotClicked: $scope.translate('canvas.condition.emailEngagement.hasNotClicked')
                    }[propOrDefault];
                };

                $scope.setLastElem = function (evt) {
                    var elemId = $(evt.target).parents('div.shape').attr('id');
                    plumbService.setLastElemClicked(elemId);
                };

                $scope.toggleConnectionMenu = function (event) {
                    //Check if form data is filled and a connection exists as only one is allowed
                    if (helpers.checkIfIsConnected(event.target.parentNode.id)) {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.602'));
                    } else {
                        if ($('#' + event.target.parentNode.id).find('.action-conditions').inlineStyle('display') === 'none') {
                            //remove the hidden style
                            $('#' + event.target.parentNode.id).find('.action-conditions').show();
                            $scope.displaySubMenu = true;
                            $scope.displayList = false;
                            $rootScope.$emit('hideConditionEmailEngagementtModal');
                            $scope.$broadcast('setMenuDefaults');
                        } else {
                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.611'));
                                $rootScope.$emit('displayConditionEmailEngagementModal', $scope.connections);
                                $scope.displaySubMenu = false;
                            } else if ($scope.hasErrors() === true) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.603'));
                                $rootScope.$emit('displayConditionEmailEngagementModal', $scope.connections);
                                $scope.displaySubMenu = false;
                            } else if ($scope.displaySubMenu === false) {
                                $scope.displaySubMenu = true;
                                $scope.displayList = false;
                                $rootScope.$emit('hideConditionEmailEngagementtModal');
                                $scope.$broadcast('setMenuDefaults');
                            } else {
                                $scope.displaySubMenu = false;
                                $scope.displayList = false;
                                $rootScope.$emit('hideConditionEmailEngagementtModal');
                            }
                        }
                    }
                };

                $scope.showTipModal = function () {
                    // displays tip modal
                    $rootScope.$emit('displayConditionEmailEngagementModal', $scope.connections, true);
                };

                //Cancel Button
                $scope.cancel = function () {
                    //Hide Menu
                    $scope.displayList = false;
                    //Hide Error
                    $scope.displayError = false;

                    if ($scope.connections) {
                        var conn = helpers.getStorageConnectionById($scope.connections.id);
                        if (conn) {
                            $scope.connections.data = conn.data;
                        }
                    }
                };

                $scope.config = function (evt) {
                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left'));

                    // check if being dragged and update position
                    if (newTop !== $scope.connections.top || $scope.connections.left !== newLeft) {
                        $scope.displayList = false;
                        $rootScope.$emit('hideConditionEmailEngagementtModal');
                        //update rootScope position
                        var wasUpdated = helpers.updatePos($scope.connections.id, newTop, newLeft);
                        // To check if the element has been saved or not in the rootScope
                        if (!wasUpdated) {
                            $scope.connections.top = newTop;
                            $scope.connections.left = newLeft;
                        }
                        return false;
                    }
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $scope.displayConditionMenu = [];
                        $rootScope.$emit('displayConditionEmailEngagementModal', $scope.connections);
                    } else {
                        $scope.displayList = false;
                        $rootScope.$emit('hideConditionEmailEngagementtModal');
                    }
                    //Hide Error
                    $scope.displayError = false;
                    $scope.displaySubMenu = false;
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displayConditionMenu) {
                        var rectangleMenu = $scope.displayConditionMenu.length > 0;
                    }

                    if ($scope.displayList || $scope.displaySubMenu || rectangleMenu) {
                        $scope.cancel();
                        $scope.displaySubMenu = false;
                        $scope.displayConditionMenu = [];
                        $scope.contMenuConfigs = 0;
                    }
                });

                $scope.parseDescription = function (id, complete) {
                    var eName, completeName;

                    if (!id) {
                        return $scope.translate('commons.enterDetails');
                    }
                    for (var i = 0; i < $scope.emailList.length; i++) {
                        if ($scope.emailList[i].id === id) {
                            completeName = $scope.emailList[i].name;
                            break;
                        }
                    }

                    if (completeName && completeName.length > 15) {
                        eName = completeName.slice(0, 15) + '...';
                    } else if (completeName && completeName.length < 15) {
                        eName = completeName;
                    }

                    if (complete) {
                        return completeName;
                    }

                    return eName;
                };

                $scope.toggleConnectionRectangle = function (event, index) {
                    $scope.displayConditionMenu = [];

                    //Show form menu
                    if ($scope.displayConditionMenu[index] === false || !$scope.displayConditionMenu[index]) {
                        $scope.displayConditionMenu[index] = true;
                        $('#' + event.target.parentNode.id).find('.action-conditions').show().prev().show();
                    } else {
                        $scope.displayConditionMenu[index] = false;
                    }
                };

                $rootScope.$on('deletedEmailEngagement', function (evt, id) {
                    if (!$scope.hasOwnProperty('connections')) {
                        return;
                    }
                    if ($scope.connections.id === id) {
                        for (var i = 0; i < $rootScope.connections.length; i++) {
                            for (var j = 0; j < $scope.connections.children.length; j++) {
                                if ($rootScope.connections[i].id === $scope.connections.children[j]) {
                                    plumbService.deleteElements($rootScope.connections[i]);
                                }
                            }
                        }
                    }
                });

                $scope.updateRectPos = function (evt) {

                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left')),
                        id = evt.currentTarget.id,
                        con = helpers.getConnectionById(id);

                    // check if being dragged and update position
                    if (newTop !== con.top || con.left !== newLeft) {
                        //update rootScope position
                        helpers.updatePos(id, newTop, newLeft);
                    }
                };

                $rootScope.$on('emailDeleted', function (evt, Id) {
                    if ($scope.connections && $scope.connections.data.emailNode === Id) {
                        $scope.connections.data.emailNode = '';
                        $scope.save();
                        $scope.emailList = helpers.jbContainsSendEmail();
                        $scope.displayList = true;
                        helpers.updateConnections($scope.connections);
                        canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), true);
                    }
                });

                $rootScope.$on('emailUpdated', function (evt, Id) {
                    if (Id) {
                        $scope.emailList = helpers.jbContainsSendEmail();
                    }
                });

                $scope.$watch('connections', function (conn) {
                    if (conn && conn.children && conn.children.length) {
                        $scope.disAllowDrag = helpers.validateDragging(conn);
                    } else if (conn && !conn.children) {
                        $scope.disAllowDrag = true;
                    }
                });
            }],
            link: function link(scope, elem, attr) {
                //Scope data initialization
                scope.newlyCreate = true;
                scope.displayList = true;
                scope.displayError = false;
                scope.displaySubMenu = false;
                scope.conditionError = [];
                scope.displayPlus = [];
                scope.selectUrl = [];
                scope.rectangleCons = [];
                scope.isElegibleForUpdate = true;
                scope.hasArrow = {};
                scope.showConnectionArrow = {};

                //load existing
                if ($rootScope.cElement) {
                    // bullet proving multiple targets
                    if (scope.connections) {
                        if (document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    scope.connections = $rootScope.cElement;
                    scope.isElegibleForUpdate = false;

                    var template = $templateCache.get('conditions/email-engagement');

                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('activateErr_' + scope.connections.id, function (evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function (evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveConditionEmailEngagementData' + scope.connections.id, function (evt, conn) {
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    if (scope.connections && scope.connections.children && scope.connections.children.length) {
                        $timeout(function () {
                            scope.disAllowDrag = helpers.validateDragging(scope.connections);
                        }, 1000);
                    } else if (scope.connections && !scope.connections.children) {
                        scope.disAllowDrag = true;
                    }

                    scope.save(true);
                }

                $(elem).click(function (evt) {
                    scope.emailList = helpers.jbContainsSendEmail();

                    if (!scope.emailList) {
                        $timeout(function () {
                            scope.$emit('errorMsg', scope.translate('canvas.error.606'));
                        }, 0);
                        return;
                    }

                    $rootScope.activePlus = false;

                    scope.newlyCreate = true;
                    scope.displayError = false;
                    scope.displaySubMenu = false;
                    scope.conditionError = [];
                    scope.displayPlus = [];
                    scope.selectUrl = [];
                    scope.rectangleCons = [];
                    scope.hasArrow = {};
                    scope.showConnectionArrow = {};

                    //Load Template
                    var template = $templateCache.get('conditions/email-engagement'),
                        now = new Date(),
                        lastElemId = plumbService.getLastElemClicked(),
                        lastElement = helpers.getConnectionById(lastElemId);

                    if (!lastElement) {
                        return false;
                    }

                    //Start Connection obj
                    scope.connections = {
                        id: 'element_' + now.getTime(),
                        top: lastElement.type == 'RectangleConnection' ? lastElement.top - 43 : lastElement.top,
                        left: lastElement.left + 250,
                        type: 'Condition',
                        data: {
                            emailNode: undefined,
                            conditions: [],
                            url: undefined
                        },
                        elemClass: attr.$attr,
                        elemName: 'EmailEngagement',
                        parent: lastElement.id,
                        //Triger: #4F4FC9 // Action: #B21877 // Condition: #FF7F57
                        color: '#FF7F57'
                    };

                    //start condition 1
                    scope.connections.data.conditions.push({
                        label: scope.translate('canvas.condition.emailEngagement.conditionLabel.1'),
                        selectedCondition: ''
                    });

                    //Create template and compile it
                    scope.$apply(function () {
                        var content = $compile(template)(scope);
                        $(elem).parents('.canvas').append(content);
                    });

                    // keep track of what has been saved, for activation
                    $rootScope.unsavedData.push(scope.connections.id);

                    $rootScope.$on('activateErr_' + scope.connections.id, function (evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function (evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveUnsavedData' + scope.connections.id, function () {
                        scope.isElegibleForUpdate = false;
                        scope.save();
                        scope.isElegibleForUpdate = true;

                        if (scope.hasError) {
                            $timeout(function () {
                                $rootScope.$emit('displayConditionEmailEngagementModal', scope.connections);
                                scope.displayList = true;
                            }, 250);
                        }
                    });

                    //Hide hide menus
                    $rootScope.$emit('closeMenus', true);

                    plumbService.connectElements(lastElement, scope.connections);

                    //List modal display new modals
                    $rootScope.$emit('displayConditionEmailEngagementModal', scope.connections);

                    $rootScope.$on('saveConditionEmailEngagementData' + scope.connections.id, function (evt, conn) {
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    // Listener when user cancel the email engagement node
                    $rootScope.$on('deleteEmailEngagementNode' + scope.connections.id, function () {
                        scope.deleteElement();
                    });
                });

                scope.deleteElement = function () {
                    scope.rectangleCons = [];
                    scope.displayActivateError = false;
                    scope.displayErrorBlink = false;

                    var idx = $rootScope.unsavedData.indexOf(scope.connections.id);
                    if (idx > -1) {
                        $rootScope.unsavedData.splice(idx, 1);
                    }

                    plumbService.deleteElements(scope.connections);

                    if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry') {
                        $rootScope.activePlus = true;
                    } else {
                        $rootScope.activePlus = false;
                    }
                };

                scope.deleteArrow = function (rectangle) {
                    if (rectangle.hasOwnProperty('children')) {
                        scope.hasArrow[rectangle.id] = false;
                        scope.showConnectionArrow[rectangle.id] = false;
                        plumbService.deleteArrows(rectangle);
                    }
                };
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    angular.module('facebook-audience-action.dir', ['journey.veil']).directive('facebookAudience', ['$rootScope', '$compile', '$templateCache', 'plumbService', 'helpers', 'canvasService', '$timeout', 'CANVAS_OPTS', facebookAudience]);

    function facebookAudience($rootScope, $compile, $templateCache, plumbService, helpers, canvasService, $timeout, CANVAS_OPTS) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;
                $scope.descriptionEmpty = false;
                $scope.wasSave = false;

                //When we save a the form
                $scope.save = function (dummy) {
                    if (!dummy && $scope.connections.isDummy) {
                        delete $scope.connections.isDummy;
                    }

                    //Updates the parent to register its children
                    var parentData = helpers.getConnectionById($scope.connections.parent);
                    if (parentData) {
                        parentData.children = [];
                        parentData.children.push($scope.connections.id);
                        helpers.updateConnections(parentData);
                    }
                    //Save to the global canvas object
                    helpers.updateConnections($scope.connections);

                    if (!$scope.connections.isDummy) {
                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index > -1) {
                            $rootScope.unsavedData.splice(index, 1);
                        }
                    }

                    var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                    if (index > -1) {
                        $rootScope.unsavedData.splice(index, 1);
                    }

                    //Displays th form data
                    $scope.displayList = false;
                    $rootScope.$emit('hideFacebookAudienceModal');
                    //Displays action menu
                    $scope.displaySubMenu = false;
                    //Save Journey to template
                    canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), $scope.isElegibleForUpdate);

                    if ($scope.isElegibleForUpdate && !dummy) {
                        $scope.wasSave = true;
                        $timeout(function () {
                            $scope.wasSave = false;
                        }, 1500);
                    }

                    //Set Back to autoSave
                    $scope.isElegibleForUpdate = true;
                    //Remove Activate Error since its being able to save
                    $scope.displayActivateError = false;
                    $scope.displayErrorBlink = false;

                    // Listener to show or hide the delete arrow or add connection arrow
                    $rootScope.$on('showDeleteArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showDeleteArrow = condition;
                    });

                    $rootScope.$on('showConnectionArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showConnectionArrow = condition;
                    });
                };

                $scope.setLastElem = function (evt) {
                    plumbService.setLastElemClicked($(evt.target).parents('div.shape').attr('id'));
                };

                $scope.toggleConnectionMenu = function (event) {
                    //Check if form data is filled and a connection exists as only one is allowed
                    if (helpers.checkIfIsConnected(event.target.parentNode.id)) {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.602'));
                    } else {
                        if ($('#' + event.target.parentNode.id).find('.action-conditions').inlineStyle('display') === 'none') {
                            //remove the hidden style
                            $('#' + event.target.parentNode.id).find('.action-conditions').show().prev().show();

                            $scope.displaySubMenu = true;
                            $scope.displayList = false;
                            $scope.$broadcast('setMenuDefaults');
                            $rootScope.$emit('hideFacebookAudienceModal');
                        } else {
                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.611'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayFacebookAudienceModal', $scope.connections);
                            } else if ($scope.connections.data.audiances.length == 0) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.603'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayFacebookAudienceModal', $scope.connections);
                            } else if ($scope.displaySubMenu === false) {
                                $scope.displaySubMenu = true;
                                $scope.displayList = false;
                                $scope.$broadcast('setMenuDefaults');
                                $rootScope.$emit('hideFacebookAudienceModal');
                            } else {
                                $scope.displaySubMenu = false;
                                $scope.displayList = false;
                                $rootScope.$emit('hideFacebookAudienceModal');
                            }
                        }
                    }
                };

                //Cancel Button
                $scope.cancel = function () {
                    //Hide Menu
                    $scope.displayList = false;
                    //Hide Error
                    $scope.displayError = false;
                };

                //Cancel Button
                $scope.config = function (evt) {
                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left'));

                    // check if being dragged and update position
                    if (newTop !== $scope.connections.top || $scope.connections.left !== newLeft) {
                        $scope.displayList = false;
                        $rootScope.$emit('hideFacebookAudienceModal');
                        //update rootScope position
                        var wasUpdated = helpers.updatePos($scope.connections.id, newTop, newLeft);
                        // To check if the element has been saved or not in the rootScope
                        if (!wasUpdated) {
                            $scope.connections.top = newTop;
                            $scope.connections.left = newLeft;
                        }
                        return false;
                    }
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $rootScope.$emit('displayFacebookAudienceModal', $scope.connections);
                    } else {
                        $scope.displayList = false;
                        $rootScope.$emit('hideFacebookAudienceModal');
                    }
                    //Hide Error
                    $scope.displayError = false;
                    $scope.displaySubMenu = false;
                };

                $scope.showTipModal = function () {
                    // last options is for is tip modal.
                    $rootScope.$emit('displayFacebookAudienceModal', $scope.connections, true);
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displayList || $scope.displaySubMenu) {
                        $scope.cancel();
                        $scope.displaySubMenu = false;
                        $scope.contMenuConfigs = 0;
                    }
                });

                $scope.parseTitle = function (desc) {
                    if (desc) {
                        var title = JSON.parse(desc);
                        return title.name;
                    }

                    return desc;
                };

                $scope.defineTitle = function (title) {
                    if (title) {
                        if (title === '1') {
                            return 'Add to';
                        }
                        return 'Remove from';
                    }

                    return title;
                };

                $scope.displayModal = function () {
                    $scope.contactListData = $rootScope.contactListData;
                    $scope.modalWindow = true;
                    $rootScope.$emit('displayExtraVeil', true);
                };

                $scope.hideModal = function () {
                    //Hide Menu
                    $scope.modalWindow = false;
                };

                $scope.contMenu = 0;
                $scope.validClickingArea = function () {
                    $scope.contMenu = 0;
                };
                $scope.$on('hideActionListModal', function () {
                    if ($scope.modalWindow) {
                        if ($scope.contMenu === 0) {
                            $scope.contMenu = 1;
                        } else {
                            $scope.hideModal();
                            $scope.contMenu = 0;
                        }
                    } else {
                        $scope.contMenu = 0;
                    }
                });

                $scope.$watch('connections', function (conn) {
                    if (conn && conn.children && conn.children.length) {
                        $scope.disAllowDrag = helpers.validateDragging(conn);
                    } else if (conn && !conn.children) {
                        $scope.disAllowDrag = true;
                    }
                });
            }],
            link: function link(scope, elem, attr) {

                //Scope data initialization
                scope.displayError = false;
                scope.displaySubMenu = false;
                scope.isElegibleForUpdate = true;

                //load existing
                if ($rootScope.cElement) {
                    // bullet proving multiple targets
                    if (scope.connections) {
                        if (document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    scope.connections = $rootScope.cElement;
                    delete $rootScope.cElement;

                    scope.isElegibleForUpdate = false;

                    var template = $templateCache.get('actions/facebook-audience');
                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('activateErr_' + scope.connections.id, function (evt, display) {
                        scope.displayActivateError = display;
                    });

                    $rootScope.$on('activateFbErr_' + scope.connections.id, function (evt, display) {
                        scope.displayFbActivateError = display;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function (evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveActionFacebookAudienceData' + scope.connections.id, function (evt, conn) {
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    // Listener when user cancel the add new list
                    $rootScope.$on('deleteFBAudienceNode' + scope.connections.id, function () {
                        scope.deleteElement();
                    });

                    scope.contactListData = $rootScope.contactListData;

                    var fromFb = localStorage.getItem('offToFacebook_' + scope.connections.id);
                    if (fromFb && fromFb === '1') {
                        $timeout(function () {
                            localStorage.removeItem('offToFacebook_' + scope.connections.id);
                            $rootScope.$emit('displayFacebookAudienceModal', scope.connections);
                        }, 500);
                    }

                    if (scope.connections && scope.connections.children && scope.connections.children.length) {
                        $timeout(function () {
                            scope.disAllowDrag = helpers.validateDragging(scope.connections);
                        }, 1000);
                    } else if (scope.connections && !scope.connections.children) {
                        scope.disAllowDrag = true;
                    }

                    scope.save(true);
                }

                $(elem).click(function (evt) {
                    //Load Template
                    var template = $templateCache.get('actions/facebook-audience'),
                        now = new Date(),
                        lastElemId = plumbService.getLastElemClicked(),
                        lastElement = helpers.getConnectionById(lastElemId);

                    $rootScope.activePlus = false;

                    //Start Connection obj
                    scope.connections = {
                        id: 'element_' + now.getTime(),
                        top: lastElement.type == 'RectangleConnection' ? lastElement.top - 43 : lastElement.top,
                        left: lastElement.left + 250,
                        type: 'Action',
                        data: { audiances: [], action: '' },
                        elemClass: attr.$attr,
                        elemName: 'FacebookAudiance',
                        parent: lastElement.id,
                        //Triger: #4F4FC9 // Action: #B21877 // Condition: #FF7F57
                        color: '#B21877'
                    };

                    //Create template and compile it
                    scope.$apply(function () {
                        var content = $compile(template)(scope);
                        $(elem).parents('.canvas').append(content);
                    });

                    // keep track of what has been saved, for activation
                    $rootScope.unsavedData.push(scope.connections.id);

                    $rootScope.$on('activateErr_' + scope.connections.id, function (evt, display) {
                        scope.displayActivateError = display;
                    });

                    $rootScope.$on('activateFbErr_' + scope.connections.id, function (evt, display) {
                        scope.displayFbActivateError = display;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function (evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveUnsavedData' + scope.connections.id, function () {
                        scope.isElegibleForUpdate = false;
                        scope.save();
                        scope.isElegibleForUpdate = true;
                        if (scope.displayError) {
                            $timeout(function () {
                                scope.displayList = true;
                                $rootScope.$emit('displayFacebookAudienceModal', scope.connections);
                            }, 250);
                        }
                    });

                    //List modal display new modals
                    $rootScope.$emit('displayFacebookAudienceModal', scope.connections);

                    $rootScope.$on('saveActionFacebookAudienceData' + scope.connections.id, function (evt, conn) {
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    // Listener when user cancel the add new list
                    $rootScope.$on('deleteFBAudienceNode' + scope.connections.id, function () {
                        scope.deleteElement();
                    });

                    scope.contactListData = $rootScope.contactListData;

                    $rootScope.$emit('closeMenus', true);

                    plumbService.connectElements(lastElement, scope.connections);
                });

                scope.deleteElement = function () {
                    var idx = $rootScope.unsavedData.indexOf(scope.connections.id);
                    if (idx > -1) {
                        $rootScope.unsavedData.splice(idx, 1);
                    }
                    scope.displayActivateError = false;
                    scope.displayErrorBlink = false;
                    plumbService.deleteElements(scope.connections);

                    if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry') {
                        $rootScope.activePlus = true;
                    } else {
                        $rootScope.activePlus = false;
                    }
                };

                scope.deleteArrow = function () {
                    if (scope.connections.hasOwnProperty('children')) {
                        scope.hasArrow = false;
                        plumbService.deleteArrows(scope.connections);
                    }
                };
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    angular.module('if-else.dir', []).directive('ifElse', ['$rootScope', '$compile', '$templateCache', 'plumbService', 'helpers', 'canvasService', '$timeout', 'CANVAS_OPTS', ifElse]);

    function ifElse($rootScope, $compile, $templateCache, plumbService, helpers, canvasService, $timeout, CANVAS_OPTS) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;
                $scope.wasSave = false;

                //When we save a the form
                $scope.save = function (dummy) {
                    //If form data is missing
                    if ($scope.passesConnectionCheck() === false) {
                        $scope.displayError = true;
                        $rootScope.$emit('errorMsg', $rootScope.translate('canvas.error.601'));

                        if ($scope.tempConn) {
                            $scope.connections = angular.copy($scope.tempConn);
                        }
                    }
                    //Else we proceed to save and create new elements
                    else {
                            if (!dummy && $scope.connections.isDummy) {
                                delete $scope.connections.isDummy;
                            }

                            Intercom('trackEvent', 'AP Node - Multiple Condition');

                            //Updates the parent to register its children
                            var parentData = helpers.getConnectionById($scope.connections.parent);
                            if (parentData) {
                                parentData.children = [];
                                parentData.children.push($scope.connections.id);
                                helpers.updateConnections(parentData);
                            }
                            //Save to the global canvas object
                            helpers.updateConnections($scope.connections);

                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1) {
                                $rootScope.unsavedData.splice(index, 1);
                            }

                            //Displays th form data
                            $scope.displayList = false;
                            $rootScope.$emit('hideConditionIfElseModal');

                            //Displays action menu
                            $scope.displaySubMenuIf = false;
                            $scope.displayInnerSubMenuIf = [];
                            //Hides Error
                            $scope.displayError = false;

                            $scope.displayConditionMenu = [];
                            $scope.displayConditionConnectors = true;

                            var lastElement = $scope.connections;

                            lastElement.children = [];

                            if ($rootScope.cElement) {
                                delete $rootScope.cElement;
                                $scope.newlyCreate = false;
                                for (var i = 0; i < $rootScope.loaderData.length; i++) {
                                    // update label according to language
                                    if ($rootScope.loaderData[i].parent === lastElement.id) {
                                        $rootScope.loaderData[i].label = $rootScope.loaderData[i].elemName === 'ifElseMeets' ? $scope.translate('commons.meetsConditions') : $scope.translate('commons.doesNotMeetsConditions');

                                        $scope.rectangleCons.push($rootScope.loaderData[i]);
                                        $scope.setPlumbRectangles(lastElement, $scope.rectangleCons.length - 1);

                                        if ($rootScope.loaderData[i].children) {
                                            $scope.hasArrow[$rootScope.loaderData[i].id] = true;
                                            $scope.showConnectionArrow[$rootScope.loaderData[i].id] = false;
                                        } else {
                                            $scope.hasArrow[$rootScope.loaderData[i].id] = false;
                                            $scope.showConnectionArrow[$rootScope.loaderData[i].id] = false;
                                        }

                                        $rootScope.$on('arrowReconnected' + $rootScope.loaderData[i].id, function (evt, id) {
                                            if (id) {
                                                $scope.hasArrow[id] = true;
                                            }
                                        });

                                        $rootScope.$on('hideArrowDelete' + $rootScope.loaderData[i].id, function (evt, id) {
                                            if (id) {
                                                $scope.hasArrow[id] = false;
                                            }
                                        });

                                        $rootScope.$on('showConnectionArrow_' + $rootScope.loaderData[i].id, function (event, condition, id) {
                                            $scope.showConnectionArrow[id] = condition;
                                        });
                                    }
                                }
                            } else {
                                // saved for the first time
                                if ($scope.newlyCreate) {
                                    $scope.newlyCreate = false;
                                    for (var i = 0; i < 2; i++) {
                                        var lastTopRectangle;
                                        if (i != 0) {
                                            lastTopRectangle = $scope.rectangleCons[i - 1].top + 200;
                                        }
                                        $scope.createNewConnection(lastElement, i, lastTopRectangle);
                                    }
                                }
                            }
                            for (var i = 0; i < $scope.rectangleCons.length; i++) {
                                $scope.rectangleCons[i].dataIndex = i;
                                $scope.displayPlus[i] = true;
                                if (lastElement) {
                                    if (lastElement.children.indexOf($scope.rectangleCons[i].id) === -1) {
                                        lastElement.children.push($scope.rectangleCons[i].id);
                                    }
                                    helpers.updateConnections(lastElement);
                                }
                                //Save to the global canvas object
                                helpers.updateConnections($scope.rectangleCons[i]);
                            }

                            //Save Journey to template
                            canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), $scope.isElegibleForUpdate);

                            if ($scope.isElegibleForUpdate) {
                                $scope.wasSave = true;
                                $timeout(function () {
                                    $scope.wasSave = false;
                                }, 1500);
                            }

                            //Set Back to autoSave
                            $scope.isElegibleForUpdate = true;

                            //Remove Activate Error since its being able to save
                            $scope.displayActivateError = false;
                            $scope.displayErrorBlink = false;
                        }
                };

                $scope.calculateLastTop = function (index, rootTop, lastTopRectangle) {
                    if (rootTop && !$rootScope.baseTop) {
                        $rootScope.baseTop = rootTop;
                    }

                    return lastTopRectangle || rootTop + 45;
                };

                $scope.createNewConnection = function (lastElement, con, lastTopRectangle) {
                    var now = new Date();
                    var nextLeft = con === 0 ? lastElement.left + 250 : lastElement.left;
                    var nextTop = $scope.calculateLastTop(con, lastElement.top, lastTopRectangle);
                    var last;
                    var idN;

                    $scope.rectangleCons.push({
                        id: 'element_' + now.getTime() + con,
                        top: nextTop,
                        left: nextLeft,
                        type: 'RectangleConnection',
                        data: {},
                        elemClass: 'rectangle-connector',
                        parent: lastElement.id,
                        color: '#FF7F57',
                        label: con === 0 ? $scope.translate('commons.meetsConditions') : $scope.translate('commons.doesNotMeetsConditions'),
                        elemName: con === 0 ? 'ifElseMeets' : 'ifElseNotMeets'
                    });

                    last = $scope.rectangleCons.length - 1;
                    idN = $scope.rectangleCons[last].id;
                    $scope.hasArrow[idN] = false;
                    $scope.showConnectionArrow[idN] = false;

                    $rootScope.$on('arrowReconnected' + idN, function (evt, id) {
                        if (id) {
                            $scope.hasArrow[id] = true;
                        }
                    });

                    $rootScope.$on('hideArrowDelete' + idN, function (evt, id) {
                        if (id) {
                            $scope.hasArrow[id] = false;
                        }
                    });

                    $rootScope.$on('showConnectionArrow_' + idN, function (event, condition, id) {
                        $scope.showConnectionArrow[id] = condition;
                    });

                    $scope.setPlumbRectangles(lastElement, con);
                };

                //Set up the rectangle connections
                $scope.setPlumbRectangles = function (lastElement, con) {
                    $timeout(function () {
                        plumbService.connectElements(lastElement, $scope.rectangleCons[con]);
                    }, 0);
                };

                $scope.config = function (evt) {
                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left'));

                    // check if being dragged and update position
                    if (newTop !== $scope.connections.top || $scope.connections.left !== newLeft) {
                        $scope.displayList = false;
                        //update rootScope position
                        var wasUpdated = helpers.updatePos($scope.connections.id, newTop, newLeft);
                        // To check if the element has been saved or not in the rootScope
                        if (!wasUpdated) {
                            $scope.connections.top = newTop;
                            $scope.connections.left = newLeft;
                        }

                        $rootScope.$emit('hideConditionIfElseModal');

                        return false;
                    }
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $scope.displayConditionMenu = [];
                        $rootScope.$emit('displayConditionIfElseModal', $scope.connections);
                    } else {
                        $scope.displayList = false;
                        $rootScope.$emit('hideConditionIfElseModal');
                    }
                    //Hide Error
                    $scope.displayError = false;
                    $scope.displaySubMenu = false;
                    $scope.displayInnerSubMenuIf = [];
                };

                $scope.showTipModal = function () {
                    // displays tip modal
                    $rootScope.$emit('displayConditionIfElseModal', $scope.connections, true);
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displayConditionMenu) {
                        var rectangleMenu = $scope.displayConditionMenu.length > 0;
                    }

                    if ($scope.displayList || $scope.displaySubMenu || rectangleMenu) {
                        $scope.displaySubMenu = false;
                        $scope.displayConditionMenu = [];
                        $scope.contMenuConfigs = 0;
                    }
                });

                $scope.passesConnectionCheck = function () {
                    var conditionsGroup = $scope.connections.data.conditionGroups,
                        res = true;

                    if (conditionsGroup === undefined) {
                        res = false;
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.603'));
                    } else {
                        for (var grp = 0; grp < conditionsGroup.length; grp++) {
                            if (conditionsGroup[grp] === undefined) {
                                res = false;
                            }

                            if (conditionsGroup[grp].length === 0) {
                                res = false;
                            }

                            for (var con = 0; con < conditionsGroup[grp].length; con++) {
                                if (conditionsGroup[grp][con].type === 'list') {
                                    if (conditionsGroup[grp][con].selectedOpt.length === 0) {
                                        res = false;
                                        $scope.connections.data.conditionGroups[grp][con].hasError = true;
                                    }
                                }

                                if (conditionsGroup[grp][con].type === 'url' && conditionsGroup[grp][con].selectedOpt[0] !== 'any-tracked-page' && !conditionsGroup[grp][con].selectedOpt[1]) {
                                    res = false;
                                    $scope.connections.data.conditionGroups[grp][con].hasError = true;
                                }

                                if ((conditionsGroup[grp][con].selectedOpt[0] === '' || conditionsGroup[grp][con].selectedOpt[0] === undefined) && conditionsGroup[grp][con].type !== 'visited') {
                                    res = false;
                                    $scope.connections.data.conditionGroups[grp][con].hasError = true;
                                }
                            }
                        }
                    }

                    if (!res) {
                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index === -1) {
                            $rootScope.unsavedData.push($scope.connections.id);
                        }

                        $rootScope.$emit('inputErrorsConditionIfElse', $scope.connections.data.conditionGroups);
                    }

                    return res;
                };

                $scope.toggleConnectionMenu = function (event) {
                    //No validation needed since when information is filled we remove the plus icon.
                    $rootScope.$emit('errorMsg', $scope.translate('canvas.error.603'));
                    $scope.displayList = true;
                    $rootScope.$emit('displayConditionIfElseModal', $scope.connections);
                };

                $scope.parseDescription = function (desc) {
                    if (!desc) {
                        return $scope.translate('commons.enterDetails');
                    }

                    return desc;
                };

                $scope.setLastElem = function (evt) {
                    plumbService.setLastElemClicked($(evt.target).parents('div.shape').attr('id'));
                };

                $scope.toggleConnectionRectangle = function (event, index) {
                    $scope.displayConditionMenu = [];
                    //Show form menu
                    if ($scope.displayConditionMenu[index] === false || !$scope.displayConditionMenu[index]) {
                        $scope.displayConditionMenu[index] = true;
                        $('#' + event.target.parentNode.id).find('.action-conditions').show();
                        $scope.$broadcast('setMenuDefaults');
                    } else {
                        $scope.displayConditionMenu[index] = false;
                    }
                };

                $rootScope.$on('deletedIfElse', function (evt, id) {
                    if (!$scope.hasOwnProperty('connections')) {
                        return;
                    }
                    if ($scope.connections.id === id) {
                        for (var i = 0; i < $rootScope.connections.length; i++) {
                            for (var j = 0; j < $scope.connections.children.length; j++) {
                                if ($rootScope.connections[i].id === $scope.connections.children[j]) {
                                    plumbService.deleteElements($rootScope.connections[i]);
                                }
                            }
                        }
                    }
                });

                var hideCont = 0;
                $scope.$on('hideSubMenuIf', function () {

                    if ($scope.displaySubMenuIf) {
                        if (hideCont === 0) {
                            hideCont = 1;
                        } else {
                            $scope.displaySubMenuIf = false;
                            $scope.displayInnerSubMenuIf = [];
                            hideCont = 0;
                        }
                    } else {
                        hideCont = 0;
                    }
                });

                $scope.updateRectPos = function (evt) {

                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left')),
                        id = evt.currentTarget.id,
                        con = helpers.getConnectionById(id);

                    // check if being dragged and update position
                    if (newTop !== con.top || con.left !== newLeft) {
                        //update rootScope position
                        helpers.updatePos(id, newTop, newLeft);
                    }
                };

                $scope.setActionsModel = function (group) {
                    var elIndex = $scope.connections.data.conditionGroups[group].length - 1;

                    $scope.$watch('connections.data.conditionGroups[' + group + '][' + elIndex + '].condition', function (andOr) {
                        if (andOr) {
                            for (var i = 0; i < $scope.connections.data.conditionGroups[group].length; i++) {
                                $scope.connections.data.conditionGroups[group][i].condition = andOr;
                            }
                        }
                    });

                    var UpdateFlag = false;
                    $scope.$watch('connections.data.conditionGroups[' + group + '][' + elIndex + '].selectedAction', function (newValue, oldValue) {
                        if (newValue !== oldValue && newValue !== undefined) {
                            if ((newValue === 'hasOpenedEmail' || newValue === 'hasNotOpenedEmail' || newValue === 'hasClickedALink' || newValue === 'hasNotClickedALink') && !$scope.emailList) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.606'));
                                UpdateFlag = true;
                                var selectedOpt = $scope.connections.data.conditionGroups[group][elIndex].selectedOpt;
                                //update connection model
                                $scope.connections.data.conditionGroups[group][elIndex] = canvasService.getInitIfElseModel(oldValue);
                                $scope.connections.data.conditionGroups[group][elIndex].selectedOpt = selectedOpt;
                            } else if (!UpdateFlag) {
                                //update connection model
                                $scope.connections.data.conditionGroups[group][elIndex] = canvasService.getInitIfElseModel(newValue);
                                $scope.connections.data.conditionGroups[group][elIndex].selectedOpt = [];
                                $scope.checkList[group][elIndex] = {};
                                $scope.listTitle[group][elIndex] = 'Select Option';
                            } else {
                                UpdateFlag = false;
                            }
                        }
                    });

                    $scope.$watch('connections.data.conditionGroups[' + group + '][' + elIndex + '].selectedOpt', function (val) {
                        if (val) {
                            if (val === 'anyPage') {
                                $scope.connections.data.conditionGroups[group][elIndex].selectedOpt[1] = '';
                                $scope.append[group][elIndex] = false;
                            }
                        }
                    });

                    $scope.$watch('connections.data.conditionGroups[' + group + '][' + elIndex + '].selectedOpt[1]', function (url) {
                        if (url && $scope.connections.data.conditionGroups[group][elIndex].selectedOpt[0] !== 'contains-url' && $scope.connections.data.conditionGroups[group][elIndex].type !== 'link') {
                            if ('http://'.indexOf(url) === 0 || 'https://'.indexOf(url) === 0) {
                                $scope.urlError[group][elIndex] = false;
                                $scope.append[group][elIndex] = false;
                            } else {
                                if (url.indexOf('http://') !== 0 && url.indexOf('https://') !== 0 && !$scope.append[group][elIndex]) {
                                    $scope.append[group][elIndex] = true;
                                    $scope.connections.data.conditionGroups[group][elIndex].selectedOpt[1] = 'http://' + url;
                                }

                                var reg = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
                                if (!reg.test(url)) {
                                    $scope.urlError[group][elIndex] = true;
                                } else {
                                    $scope.urlError[group][elIndex] = false;
                                }
                            }
                        }
                    });
                };

                $rootScope.$on('emailDeleted', function (evt, Id) {
                    if (Id) {
                        if ($scope.connections && $scope.connections.data) {
                            $scope.emailList = helpers.jbContainsSendEmail();

                            for (var i = 0; i < $scope.connections.data.conditionGroups.length; i++) {
                                for (var j = 0; j < $scope.connections.data.conditionGroups[i].length; j++) {
                                    if ($scope.connections.data.conditionGroups[i][j].selectedOpt[0] === Id) {
                                        $scope.connections.data.conditionGroups[i][j].selectedOpt[0] = '';
                                        $scope.save();
                                        $scope.displayList = true;
                                        $rootScope.$emit('displayConditionIfElseModal', $scope.connections);
                                        helpers.updateConnections($scope.connections);
                                        canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), true);
                                    }
                                }
                            }
                        }
                    }
                });

                $rootScope.$on('emailUpdated', function (evt, Id) {
                    if (Id) {
                        $scope.emailList = helpers.jbContainsSendEmail();
                    }
                });
            }],
            link: function link(scope, elem, attr) {
                //Scope data initialization
                scope.newlyCreate = true;
                scope.displayList = true;
                scope.displayError = false;
                scope.displaySubMenuIf = false;
                scope.selectedAction = {};
                scope.ConnectionsFromLoader = false;
                scope.displayPlus = [];
                scope.rectangleCons = [];
                scope.isElegibleForUpdate = true;
                scope.hideWhenLimit = true;
                scope.modalWindow = [];
                scope.hideForLimitCon = [];
                scope.displayInnerSubMenuIf = [];
                scope.checkList = [];
                scope.listTitle = [];
                scope.append = [];
                scope.urlError = [];
                scope.emailList = helpers.jbContainsSendEmail();
                scope.hasArrow = {};
                scope.showConnectionArrow = {};

                if (!scope.contactListData) {
                    scope.contactListData = $rootScope.contactListData;
                }

                // load existing
                if ($rootScope.cElement) {
                    // bullet proving multiple targets
                    if (scope.connections) {
                        if (document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    scope.connections = $rootScope.cElement;
                    scope.isElegibleForUpdate = false;

                    if (scope.connections.data.conditionGroups) {
                        for (var i = 0; i < scope.connections.data.conditionGroups.length; i++) {
                            scope.setActionsModel(i);

                            scope.checkList[i] = [];
                            scope.listTitle[i] = [];
                            scope.modalWindow[i] = [];
                            scope.append[i] = [];
                            scope.urlError[i] = [];
                            if (scope.connections.data.conditionGroups[i].length >= 5) {
                                scope.hideForLimitCon[i] = true;
                            }
                            for (var j = 0; j < scope.connections.data.conditionGroups[i].length; j++) {
                                if (scope.connections.data.conditionGroups[i][j].type === 'list') {
                                    var key = scope.connections.data.conditionGroups[i][j].selectedOpt[0],
                                        val = helpers.getContactListItem(key, scope.contactListData);

                                    scope.checkList[i][j] = {};
                                    scope.checkList[i][j][key] = true;
                                    scope.listTitle[i][j] = val.substring(0, 26) + '...';
                                }
                            }
                        }
                    }

                    var template = $templateCache.get('conditions/options/if-else');

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('activateErr_' + scope.connections.id, function (evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function (evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveConditionIfElse' + scope.connections.id, function (evt, conn) {
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    scope.save(true);
                }

                $(elem).click(function (evt) {
                    scope.newlyCreate = true;
                    scope.displayError = false;
                    scope.displaySubMenuIf = false;
                    scope.selectedAction = {};
                    scope.ConnectionsFromLoader = false;
                    scope.displayPlus = [];
                    scope.rectangleCons = [];
                    scope.isElegibleForUpdate = true;
                    scope.hideWhenLimit = true;
                    scope.modalWindow = [];
                    scope.hideForLimitCon = [];
                    scope.displayInnerSubMenuIf = [];
                    scope.checkList = [];
                    scope.listTitle = [];
                    scope.append = [];
                    scope.urlError = [];
                    scope.emailList = helpers.jbContainsSendEmail();
                    scope.hasArrow = {};
                    scope.showConnectionArrow = {};

                    if (!scope.contactListData) {
                        scope.contactListData = $rootScope.contactListData;
                    }

                    $rootScope.activePlus = false;

                    //Load Template
                    var template = $templateCache.get('conditions/options/if-else'),
                        now = new Date(),
                        lastElemId = plumbService.getLastElemClicked(),
                        lastElement = helpers.getConnectionById(lastElemId);

                    //Start Connection obj
                    scope.connections = {
                        id: 'element_' + now.getTime(),
                        top: lastElement.type == 'RectangleConnection' ? lastElement.top - 43 : lastElement.top,
                        left: lastElement.left + 250,
                        type: 'Condition',
                        data: {},
                        elemClass: attr.$attr,
                        elemName: 'IfElse',
                        parent: lastElement.id,
                        //Triger: #4F4FC9 // Action: #B21877 // Condition: #FF7F57
                        color: '#FF7F57'
                    };

                    scope.connections.data.additionals = {};
                    scope.connections.data.additionals.initialCondition = true;
                    scope.connections.data.additionals.showForNewGroup = [];
                    scope.connections.data.selectedGroupConditions = [];

                    //Create template and compile it
                    scope.$apply(function () {
                        var content = $compile(template)(scope);
                        $(elem).parents('.canvas').append(content);
                    });

                    // keep track of what has been saved, for activation
                    $rootScope.unsavedData.push(scope.connections.id);

                    $rootScope.$on('activateErr_' + scope.connections.id, function (evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function (evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveUnsavedData' + scope.connections.id, function () {
                        scope.isElegibleForUpdate = false;
                        scope.save();
                        scope.isElegibleForUpdate = true;
                        if (scope.displayError) {
                            $timeout(function () {
                                scope.displayList = true;
                                $rootScope.$emit('displayConditionIfElseModal', scope.connections);
                            }, 250);
                        }
                    });

                    $rootScope.$emit('displayConditionIfElseModal', scope.connections);

                    $rootScope.$on('saveConditionIfElse' + scope.connections.id, function (evt, conn) {
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    // Listener when user cancel the if/else node
                    $rootScope.$on('deleteIfElseNode' + scope.connections.id, function () {
                        scope.deleteElement();
                    });

                    //Hide hide menus
                    $rootScope.$emit('closeMenus', true);
                    scope.displayList = true;

                    plumbService.connectElements(lastElement, scope.connections);
                });

                scope.deleteElement = function () {
                    scope.rectangleCons = [];
                    scope.displayActivateError = false;
                    scope.displayErrorBlink = false;

                    var idx = $rootScope.unsavedData.indexOf(scope.connections.id);

                    if (idx > -1) {
                        $rootScope.unsavedData.splice(idx, 1);
                    }

                    plumbService.deleteElements(scope.connections);

                    if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry') {
                        $rootScope.activePlus = true;
                    } else {
                        $rootScope.activePlus = false;
                    }
                };

                scope.deleteArrow = function (rectangle) {
                    if (rectangle.hasOwnProperty('children')) {
                        scope.hasArrow[rectangle.id] = false;
                        scope.showConnectionArrow[rectangle.id] = false;
                        plumbService.deleteArrows(rectangle);
                    }
                };
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    angular.module('is-in-segment.dir', ['journey.veil']).directive('isInSegment', ['$rootScope', '$compile', '$templateCache', 'plumbService', 'helpers', 'canvasService', '$timeout', 'CANVAS_OPTS', isInSegment]);

    function isInSegment($rootScope, $compile, $templateCache, plumbService, helpers, canvasService, $timeout, CANVAS_OPTS) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;
                $scope.wasSave = false;

                //When we save a the form
                $scope.save = function () {
                    //If form data is missing
                    if ($scope.dataFilledCorrectly() === false) {
                        $rootScope.$emit('displayConditionIsInSegmentModalError');
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.601'));
                        if ($scope.tempConn) {
                            $scope.connections = angular.copy($scope.tempConn);
                        }
                    }
                    //Else we proceed to save and create new elements
                    else {

                            //Updates the parent to register its children
                            var parentData = helpers.getConnectionById($scope.connections.parent);
                            if (parentData) {
                                parentData.children = [];
                                parentData.children.push($scope.connections.id);
                                helpers.updateConnections(parentData);
                            }
                            //Save to the global canvas object
                            helpers.updateConnections($scope.connections);

                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1) {
                                $rootScope.unsavedData.splice(index, 1);
                            }

                            //Displays th form data
                            $scope.displayList = false;
                            $rootScope.$emit('hideConditionIsInSegmentModal');
                            //Displays action menu
                            $scope.displaySubMenu = false;
                            //Hides Error
                            $scope.displayError = false;

                            var desc = $scope.parseDescription($scope.connections.data.selectedList, 'showDescription');
                            if (desc) {
                                $scope.description = desc;
                            }

                            //Save Journey to template
                            canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), $scope.isElegibleForUpdate);

                            if ($scope.isElegibleForUpdate) {
                                $scope.wasSave = true;
                                $timeout(function () {
                                    $scope.wasSave = false;
                                }, 1500);
                            }

                            //Set Back to autoSave
                            $scope.isElegibleForUpdate = true;
                            //Remove Activate Error since its being able to save
                            $scope.displayActivateError = false;
                            $scope.displayErrorBlink = false;
                        }

                    // Listener to show or hide the delete arrow or add connection arrow
                    $rootScope.$on('showDeleteArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showDeleteArrow = condition;
                    });

                    $rootScope.$on('showConnectionArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showConnectionArrow = condition;
                    });
                };

                //Validates if data is filled correctly or not
                $scope.dataFilledCorrectly = function () {
                    if ($scope.connections.data.selectedList.length === 0 || $scope.descriptionEmpty) {
                        $scope.displayError = true;

                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index === -1) {
                            $rootScope.unsavedData.push($scope.connections.id);
                        }

                        return false;
                    }

                    return true;
                };

                //Cancel Button
                $scope.cancel = function () {
                    //Hide Menu
                    $scope.displayList = false;
                    //Hide Error
                    $scope.displayError = false;

                    if ($scope.connections) {
                        var conn = helpers.getStorageConnectionById($scope.connections.id);
                        if (conn) {
                            $scope.connections.data = conn.data;
                        }
                    }
                };

                $scope.config = function (evt) {
                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left'));

                    // check if being dragged and update position
                    if (newTop !== $scope.connections.top || $scope.connections.left !== newLeft) {
                        $scope.displayList = false;
                        $rootScope.$emit('hideConditionIsInSegmentModal');
                        //update rootScope position
                        var wasUpdated = helpers.updatePos($scope.connections.id, newTop, newLeft);
                        // To check if the element has been saved or not in the rootScope
                        if (!wasUpdated) {
                            $scope.connections.top = newTop;
                            $scope.connections.left = newLeft;
                        }
                        return false;
                    }
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $rootScope.$emit('displayConditionIsInSegmentModal', $scope.connections);
                    } else {
                        $scope.displayList = false;
                        $rootScope.$emit('hideConditionIsInSegmentModal');
                    }
                    //Hide Error
                    $scope.displayError = false;
                    $scope.displaySubMenu = false;
                };

                $scope.showTipModal = function () {
                    // displays tip modal
                    $rootScope.$emit('displayConditionIsInSegmentModal', $scope.connections, true);
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displayList || $scope.displaySubMenu) {
                        $scope.cancel();
                        $scope.displaySubMenu = false;
                        $scope.contMenuConfigs = 0;
                    }
                });

                $scope.toggleConnectionMenu = function (event) {
                    //Check if form data is filled and a connection exists as only one is allowed
                    if (helpers.checkIfIsConnected(event.target.parentNode.id)) {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.602'));
                    } else {
                        if ($('#' + event.target.parentNode.id).find('.action-conditions').inlineStyle('display') === 'none') {
                            //remove the hidden style
                            $('#' + event.target.parentNode.id).find('.action-conditions').show().prev().show();
                            $scope.displaySubMenu = true;
                            $scope.displayList = false;
                            $scope.$broadcast('setMenuDefaults');
                            $rootScope.$emit('hideConditionIsInSegmentModal');
                        } else {
                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.611'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayConditionIsInSegmentModal', $scope.connections);
                            } else if ($scope.connections.data.selectedList.length === 0) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.603'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayConditionIsInSegmentModal', $scope.connections);
                            } else if ($scope.displaySubMenu === false) {
                                $scope.displaySubMenu = true;
                                $scope.displayList = false;
                                $scope.$broadcast('setMenuDefaults');
                                $rootScope.$emit('hideConditionIsInSegmentModal');
                            } else {
                                $scope.displaySubMenu = false;
                                $scope.displayList = false;
                                $rootScope.$emit('hideConditionIsInSegmentModal');
                            }
                        }
                    }
                };

                $scope.setLastElem = function (evt) {
                    plumbService.setLastElemClicked($(evt.target).parents('div.shape').attr('id'));
                };

                $scope.contMenu = 0;
                $scope.validClickingArea = function () {
                    $scope.contMenu = 0;
                };

                $scope.displayModal = function () {
                    $scope.modalWindow = true;
                    $scope.segmentData = $rootScope.segmentData;
                };

                $scope.hideModal = function (clearList) {
                    if (clearList) {
                        $scope.selectedKey = $scope.translate('canvas.condition.isInSegment.selectSegment');
                        $scope.connections.data.selectedList = [];
                    }
                    $scope.modalWindow = false;
                };

                $scope.$on('hideConditionIsListModal', function () {
                    if ($scope.modalWindow) {
                        if ($scope.contMenu === 0) {
                            $scope.contMenu = 1;
                        } else {
                            $scope.hideModal();
                            $scope.contMenu = 0;
                        }
                    } else {
                        $scope.contMenu = 0;
                    }
                });

                $scope.decodeHtml = function (html) {
                    var txt = document.createElement("textarea");
                    txt.innerHTML = html;
                    return txt.value;
                };

                $scope.getSelectedText = function (desc) {
                    if ($scope.connections.data.selectedList.length === 1) {
                        for (var item in desc) {
                            desc = helpers.getContactListItem(desc[item], $scope.ListName, $scope.segmentData);
                        }

                        return desc;
                    }
                };

                $scope.parseDescription = function (desc, selected) {
                    if (desc && (typeof desc === 'undefined' ? 'undefined' : _typeof(desc)) === 'object') {
                        var descriptionCheck = false;
                        for (var item in desc) {
                            if (desc[item]) {
                                $scope.descriptionEmpty = false;
                                descriptionCheck = true;
                                //Lists that are currently selected on the node
                                var totalLists = $scope.connections.data.selectedList.length;
                                desc = $scope.decodeHtml(helpers.getContactListItem(desc[item], $scope.ListName, $scope.segmentData));

                                //One list selected and > 19
                                if (totalLists === 1 && desc.length > 15) {
                                    desc = desc.slice(0, 15) + '...';
                                    //More than one selected
                                } else if (totalLists > 1) {
                                    desc = totalLists + " Segment Selected";
                                }
                                break;
                            }
                        }
                        if (!descriptionCheck) {
                            $scope.descriptionEmpty = true;

                            if (selected === 'showSelectedList') {
                                return '';
                            } else {
                                return $scope.translate('commons.enterDetails');
                            }
                        }
                    } else {
                        $scope.descriptionEmpty = true;

                        if (selected === 'showSelectedList') {
                            return '';
                        } else {
                            return $scope.translate('commons.enterDetails');
                        }
                    }

                    return desc;
                };

                $scope.description = '';
                $rootScope.$watch('segmentData', function (list) {
                    if (list && list.length && $scope.connections) {
                        $scope.segmentData = list;
                        var desc = $scope.parseDescription($scope.connections.data.selectedList, 'showDescription');

                        if (desc) {
                            $scope.description = desc;
                            $scope.placeholder = false;
                        }
                    }
                });

                $scope.$watch('connections', function (conn) {
                    if (conn && conn.children && conn.children.length) {
                        $scope.disAllowDrag = helpers.validateDragging(conn);
                    } else if (conn && !conn.children) {
                        $scope.disAllowDrag = true;
                    }
                });
            }],
            link: function link(scope, elem, attr) {
                //Scope data initialization
                scope.displayList = true;
                scope.displayError = false;
                scope.displaySubMenu = false;
                scope.isElegibleForUpdate = true;
                //load existing
                if ($rootScope.cElement) {
                    // bullet proving multiple targets
                    if (scope.connections) {
                        if (document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    scope.connections = $rootScope.cElement;
                    delete $rootScope.cElement;
                    scope.isElegibleForUpdate = false;
                    scope.placeholder = true;

                    scope.selectedKey = scope.translate('canvas.condition.isInSegment.selectSegment');
                    if (scope.connections.data.selectedList.length) {
                        scope.selectedKey = scope.translate('commons.editSelection');
                    }

                    var template = $templateCache.get('conditions/is-in-segment');

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('activateErr_' + scope.connections.id, function (evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function (evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveConditionIsInSegmentData' + scope.connections.id, function (evt, conn, descriptionEmpty) {
                        scope.segmentData = $rootScope.segmentData;
                        scope.descriptionEmpty = descriptionEmpty;
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    scope.segmentData = $rootScope.segmentData;

                    if (scope.connections && scope.connections.children && scope.connections.children.length) {
                        $timeout(function () {
                            scope.disAllowDrag = helpers.validateDragging(scope.connections);
                        }, 1000);
                    } else if (scope.connections && !scope.connections.children) {
                        scope.disAllowDrag = true;
                    }

                    scope.save();
                }

                $(elem).click(function (evt) {
                    //Load Template
                    var template = $templateCache.get('conditions/is-in-segment'),
                        now = new Date(),
                        lastElemId = plumbService.getLastElemClicked(),
                        lastElement = helpers.getConnectionById(lastElemId);

                    scope.selectedKey = scope.translate('canvas.condition.isInSegment.selectSegment');

                    $rootScope.activePlus = false;

                    //Start Connection obj
                    scope.connections = {
                        id: 'element_' + now.getTime(),
                        top: lastElement.type == 'RectangleConnection' ? lastElement.top - 43 : lastElement.top,
                        left: lastElement.left + 250,
                        type: 'Condition',
                        data: { selectedList: [] },
                        elemClass: attr.$attr,
                        elemName: 'IsInSegment',
                        parent: lastElement.id,
                        //Triger: #4F4FC9 // Action: #B21877 // Condition: #FF7F57
                        color: '#FF7F57'
                    };

                    //Create template and compile it
                    scope.$apply(function () {
                        var content = $compile(template)(scope);
                        $(elem).parents('.canvas').append(content);
                    });

                    // keep track of what has been saved, for activation
                    $rootScope.unsavedData.push(scope.connections.id);

                    $rootScope.$on('activateErr_' + scope.connections.id, function (evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function (evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveUnsavedData' + scope.connections.id, function () {
                        scope.isElegibleForUpdate = false;
                        scope.save();
                        scope.isElegibleForUpdate = true;

                        if (scope.displayError) {
                            $timeout(function () {
                                scope.displayList = true;
                                $rootScope.$emit('displayConditionIsInSegmentModal', scope.connections);
                            }, 250);
                        }
                    });
                    //List modal display new modals
                    $rootScope.$emit('displayConditionIsInSegmentModal', scope.connections);

                    $rootScope.$on('saveConditionIsInSegmentData' + scope.connections.id, function (evt, conn, descriptionEmpty) {
                        scope.segmentData = $rootScope.segmentData;
                        scope.descriptionEmpty = descriptionEmpty;
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    // Listener istener when user cancel the is in segment node
                    $rootScope.$on('deleteIsInSegmentNode' + scope.connections.id, function () {
                        scope.deleteElement();
                    });

                    scope.segmentData = $rootScope.segmentData;

                    //Hide hide menus
                    $rootScope.$emit('closeMenus', true);
                    plumbService.connectElements(lastElement, scope.connections);
                });

                scope.deleteElement = function () {
                    var idx = $rootScope.unsavedData.indexOf(scope.connections.id);
                    if (idx > -1) {
                        $rootScope.unsavedData.splice(idx, 1);
                    }
                    scope.displayActivateError = false;
                    scope.displayErrorBlink = false;
                    plumbService.deleteElements(scope.connections);

                    if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry') {
                        $rootScope.activePlus = true;
                    } else {
                        $rootScope.activePlus = false;
                    }
                };

                scope.deleteArrow = function () {
                    if (scope.connections.hasOwnProperty('children')) {
                        scope.hasArrow = false;
                        plumbService.deleteArrows(scope.connections);
                    }
                };
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    angular.module('is-not-in-segment.dir', ['journey.veil']).directive('isNotInSegment', ['$rootScope', '$compile', '$templateCache', 'plumbService', 'helpers', 'canvasService', '$timeout', 'CANVAS_OPTS', isNotInSegment]);

    function isNotInSegment($rootScope, $compile, $templateCache, plumbService, helpers, canvasService, $timeout, CANVAS_OPTS) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;
                $scope.wasSave = false;

                //When we save a the form
                $scope.save = function () {
                    //If form data is missing
                    if ($scope.dataFilledCorrectly() === false) {
                        $rootScope.$emit('displayConditionIsNotInSegmentModalError');
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.601'));
                        if ($scope.tempConn) {
                            $scope.connections = angular.copy($scope.tempConn);
                        }
                    }
                    //Else we proceed to save and create new elements
                    else {
                            //Updates the parent to register its children
                            var parentData = helpers.getConnectionById($scope.connections.parent);
                            if (parentData) {
                                parentData.children = [];
                                parentData.children.push($scope.connections.id);
                                helpers.updateConnections(parentData);
                            }
                            //Save to the global canvas object
                            helpers.updateConnections($scope.connections);

                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1) {
                                $rootScope.unsavedData.splice(index, 1);
                            }

                            //Displays th form data
                            $scope.displayList = false;
                            $rootScope.$emit('hideConditionIsNotInSegmentModal');
                            //Displays action menu
                            $scope.displaySubMenu = false;
                            //Hides Error
                            $scope.displayError = false;

                            var desc = $scope.parseDescription($scope.connections.data.selectedList, 'showDescription');
                            if (desc) {
                                $scope.description = desc;
                            }

                            //Save Journey to template
                            canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), $scope.isElegibleForUpdate);

                            if ($scope.isElegibleForUpdate) {
                                $scope.wasSave = true;
                                $timeout(function () {
                                    $scope.wasSave = false;
                                }, 1500);
                            }

                            //Set Back to autoSave
                            $scope.isElegibleForUpdate = true;
                            //Remove Activate Error since its being able to save
                            $scope.displayActivateError = false;
                            $scope.displayErrorBlink = false;
                        }

                    // Listener to show or hide the delete arrow or add connection arrow
                    $rootScope.$on('showDeleteArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showDeleteArrow = condition;
                    });

                    $rootScope.$on('showConnectionArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showConnectionArrow = condition;
                    });
                };

                //Validates if data is filled correctly or not
                $scope.dataFilledCorrectly = function () {
                    if ($scope.connections.data.selectedList.length === 0 || $scope.descriptionEmpty) {
                        $scope.displayError = true;

                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index === -1) {
                            $rootScope.unsavedData.push($scope.connections.id);
                        }

                        return false;
                    }

                    return true;
                };

                //Cancel Button
                $scope.cancel = function () {
                    //Hide Menu
                    $scope.displayList = false;
                    //Hide Error
                    $scope.displayError = false;

                    if ($scope.connections) {
                        var conn = helpers.getStorageConnectionById($scope.connections.id);
                        if (conn) {
                            $scope.connections.data = conn.data;
                        }
                    }
                };

                $scope.config = function (evt) {
                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left'));

                    // check if being dragged and update position
                    if (newTop !== $scope.connections.top || $scope.connections.left !== newLeft) {
                        $scope.displayList = false;
                        $rootScope.$emit('hideConditionIsNotInSegmentModal');
                        //update rootScope position
                        var wasUpdated = helpers.updatePos($scope.connections.id, newTop, newLeft);
                        // To check if the element has been saved or not in the rootScope
                        if (!wasUpdated) {
                            $scope.connections.top = newTop;
                            $scope.connections.left = newLeft;
                        }
                        return false;
                    }
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $rootScope.$emit('displayConditionIsNotInSegmentModal', $scope.connections);
                    } else {
                        $scope.displayList = false;
                        $rootScope.$emit('hideConditionIsNotInSegmentModal');
                    }
                    //Hide Error
                    $scope.displayError = false;
                    $scope.displaySubMenu = false;
                };

                $scope.showTipModal = function () {
                    // displays tip modal
                    $rootScope.$emit('displayConditionIsNotInSegmentModal', $scope.connections, true);
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displayList || $scope.displaySubMenu) {
                        $scope.cancel();
                        $scope.displaySubMenu = false;
                        $scope.contMenuConfigs = 0;
                    }
                });

                $scope.toggleConnectionMenu = function (event) {
                    //Check if form data is filled and a connection exists as only one is allowed
                    if (helpers.checkIfIsConnected(event.target.parentNode.id)) {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.602'));
                    } else {
                        if ($('#' + event.target.parentNode.id).find('.action-conditions').inlineStyle('display') === 'none') {
                            //remove the hidden style
                            $('#' + event.target.parentNode.id).find('.action-conditions').show().prev().show();
                            $scope.displaySubMenu = true;
                            $scope.displayList = false;
                            $scope.$broadcast('setMenuDefaults');
                            $rootScope.$emit('hideConditionIsNotInSegmentModal');
                        } else {
                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.611'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayConditionIsNotInSegmentModal', $scope.connections);
                            } else if ($scope.connections.data.selectedList.length === 0) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.603'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayConditionIsNotInSegmentModal', $scope.connections);
                            } else if ($scope.displaySubMenu === false) {
                                $scope.displaySubMenu = true;
                                $scope.displayList = false;
                                $scope.$broadcast('setMenuDefaults');
                                $rootScope.$emit('hideConditionIsNotInSegmentModal');
                            } else {
                                $scope.displaySubMenu = false;
                                $scope.displayList = false;
                                $rootScope.$emit('hideConditionIsNotInSegmentModal');
                            }
                        }
                    }
                };

                $scope.setLastElem = function (evt) {
                    plumbService.setLastElemClicked($(evt.target).parents('div.shape').attr('id'));
                };

                $scope.contMenu = 0;
                $scope.validClickingArea = function () {
                    $scope.contMenu = 0;
                };

                $scope.displayModal = function () {
                    $scope.modalWindow = true;
                    $scope.segmentData = $rootScope.segmentData;
                };

                $scope.hideModal = function (clearList) {
                    if (clearList) {
                        $scope.selectedKey = $scope.translate('canvas.condition.isInSegment.selectSegment');
                        $scope.connections.data.selectedList = [];
                    }
                    $scope.modalWindow = false;
                };

                $scope.$on('hideConditionIsListModal', function () {
                    if ($scope.modalWindow) {
                        if ($scope.contMenu === 0) {
                            $scope.contMenu = 1;
                        } else {
                            $scope.hideModal();
                            $scope.contMenu = 0;
                        }
                    } else {
                        $scope.contMenu = 0;
                    }
                });

                $scope.decodeHtml = function (html) {
                    var txt = document.createElement("textarea");
                    txt.innerHTML = html;
                    return txt.value;
                };

                $scope.getSelectedText = function (desc) {
                    if ($scope.connections.data.selectedList.length === 1) {
                        for (var item in desc) {
                            desc = helpers.getContactListItem(desc[item], $scope.ListName, $scope.segmentData);
                        }

                        return desc;
                    }
                };

                $scope.parseDescription = function (desc, selected) {
                    if (desc && (typeof desc === 'undefined' ? 'undefined' : _typeof(desc)) === 'object') {
                        var descriptionCheck = false;
                        for (var item in desc) {
                            if (desc[item]) {
                                $scope.descriptionEmpty = false;
                                descriptionCheck = true;
                                //Lists that are currently selected on the node
                                var totalLists = $scope.connections.data.selectedList.length;
                                desc = $scope.decodeHtml(helpers.getContactListItem(desc[item], $scope.ListName, $scope.segmentData));

                                //One list selected and > 19
                                if (totalLists === 1 && desc.length > 15) {
                                    desc = desc.slice(0, 15) + '...';
                                    //More than one selected
                                } else if (totalLists > 1) {
                                    desc = totalLists + " Segment Selected";
                                    //One selected but < 19
                                } else if (totalLists === 1 && desc.length < 15) {
                                    desc = desc;
                                }
                                break;
                            }
                        }
                        if (!descriptionCheck) {
                            $scope.descriptionEmpty = true;

                            if (selected === 'showSelectedList') {
                                return '';
                            } else {
                                return $scope.translate('commons.enterDetails');
                            }
                        }
                    } else {
                        $scope.descriptionEmpty = true;

                        if (selected === 'showSelectedList') {
                            return '';
                        } else {
                            return $scope.translate('commons.enterDetails');
                        }
                    }

                    return desc;
                };

                $scope.description = '';
                $rootScope.$watch('segmentData', function (list) {
                    if (list && list.length && $scope.connections) {
                        $scope.segmentData = list;
                        var desc = $scope.parseDescription($scope.connections.data.selectedList, 'showDescription');

                        if (desc) {
                            $scope.description = desc;
                            $scope.placeholder = false;
                        }
                    }
                });

                $scope.$watch('connections', function (conn) {
                    if (conn && conn.children && conn.children.length) {
                        $scope.disAllowDrag = helpers.validateDragging(conn);
                    } else if (conn && !conn.children) {
                        $scope.disAllowDrag = true;
                    }
                });
            }],
            link: function link(scope, elem, attr) {
                //Scope data initialization
                scope.displayList = true;
                scope.displayError = false;
                scope.displaySubMenu = false;
                scope.isElegibleForUpdate = true;
                //load existing
                if ($rootScope.cElement) {
                    // bullet proving multiple targets
                    if (scope.connections) {
                        if (document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    scope.connections = $rootScope.cElement;
                    delete $rootScope.cElement;
                    scope.isElegibleForUpdate = false;
                    scope.placeholder = true;

                    scope.selectedKey = scope.translate('canvas.condition.isInSegment.selectSegment');
                    if (scope.connections.data.selectedList.length) {
                        scope.selectedKey = scope.translate('commons.editSelection');
                    }

                    var template = $templateCache.get('conditions/is-not-in-segment');

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('activateErr_' + scope.connections.id, function (evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function (evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveConditionIsNotInSegmentData' + scope.connections.id, function (evt, conn, descriptionEmpty) {
                        scope.segmentData = $rootScope.segmentData;
                        scope.descriptionEmpty = descriptionEmpty;
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    scope.segmentData = $rootScope.segmentData;

                    if (scope.connections && scope.connections.children && scope.connections.children.length) {
                        $timeout(function () {
                            scope.disAllowDrag = helpers.validateDragging(scope.connections);
                        }, 1000);
                    } else if (scope.connections && !scope.connections.children) {
                        scope.disAllowDrag = true;
                    }

                    scope.save();
                }

                $(elem).click(function (evt) {
                    //Load Template
                    var template = $templateCache.get('conditions/is-not-in-segment'),
                        now = new Date(),
                        lastElemId = plumbService.getLastElemClicked(),
                        lastElement = helpers.getConnectionById(lastElemId);

                    $rootScope.activePlus = false;

                    scope.selectedKey = scope.translate('canvas.condition.isInSegment.selectSegment');

                    //Start Connection obj
                    scope.connections = {
                        id: 'element_' + now.getTime(),
                        top: lastElement.type == 'RectangleConnection' ? lastElement.top - 43 : lastElement.top,
                        left: lastElement.left + 250,
                        type: 'Condition',
                        data: { selectedList: [] },
                        elemClass: attr.$attr,
                        elemName: 'IsNotInSegment',
                        parent: lastElement.id,
                        //Triger: #4F4FC9 // Action: #B21877 // Condition: #FF7F57
                        color: '#FF7F57'
                    };

                    //Create template and compile it
                    scope.$apply(function () {
                        var content = $compile(template)(scope);
                        $(elem).parents('.canvas').append(content);
                    });

                    // keep track of what has been saved, for activation
                    $rootScope.unsavedData.push(scope.connections.id);

                    $rootScope.$on('activateErr_' + scope.connections.id, function (evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function (evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveUnsavedData' + scope.connections.id, function () {
                        scope.isElegibleForUpdate = false;
                        scope.save();
                        scope.isElegibleForUpdate = true;

                        if (scope.displayError) {
                            $timeout(function () {
                                scope.displayList = true;
                                $rootScope.$emit('displayConditionIsNotInSegmentModal', scope.connections);
                            }, 250);
                        }
                    });
                    //List modal display new modals
                    $rootScope.$emit('displayConditionIsNotInSegmentModal', scope.connections);

                    $rootScope.$on('saveConditionIsNotInSegmentData' + scope.connections.id, function (evt, conn, descriptionEmpty) {
                        scope.segmentData = $rootScope.segmentData;
                        scope.descriptionEmpty = descriptionEmpty;
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    // Listener when user cancel the is not in segment node
                    $rootScope.$on('deleteIsNotInSegmentNode' + scope.connections.id, function () {
                        scope.deleteElement();
                    });

                    scope.segmentData = $rootScope.segmentData;

                    //Hide hide menus
                    $rootScope.$emit('closeMenus', true);
                    plumbService.connectElements(lastElement, scope.connections);
                });

                scope.deleteElement = function () {
                    var idx = $rootScope.unsavedData.indexOf(scope.connections.id);
                    if (idx > -1) {
                        $rootScope.unsavedData.splice(idx, 1);
                    }
                    scope.displayActivateError = false;
                    scope.displayErrorBlink = false;
                    plumbService.deleteElements(scope.connections);

                    if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry') {
                        $rootScope.activePlus = true;
                    } else {
                        $rootScope.activePlus = false;
                    }
                };

                scope.deleteArrow = function () {
                    if (scope.connections.hasOwnProperty('children')) {
                        scope.hasArrow = false;
                        plumbService.deleteArrows(scope.connections);
                    }
                };
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    angular.module('is-in-list-or-segment.dir', ['journey.veil']).directive('listSegment', ['$rootScope', '$compile', '$templateCache', 'plumbService', 'helpers', 'canvasService', '$timeout', 'CANVAS_OPTS', listSegment]);

    function listSegment($rootScope, $compile, $templateCache, plumbService, helpers, canvasService, $timeout, CANVAS_OPTS) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;
                $scope.wasSave = false;

                //When we save a the form
                $scope.save = function () {
                    //If form data is missing
                    if ($scope.dataFilledCorrectly() === false) {
                        $rootScope.$emit('displayConditionIsInListModalError');
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.601'));
                        if ($scope.tempConn) {
                            $scope.connections = angular.copy($scope.tempConn);
                        }
                    }
                    //Else we proceed to save and create new elements
                    else {

                            //Updates the parent to register its children
                            var parentData = helpers.getConnectionById($scope.connections.parent);
                            if (parentData) {
                                parentData.children = [];
                                parentData.children.push($scope.connections.id);
                                helpers.updateConnections(parentData);
                            }
                            //Save to the global canvas object
                            helpers.updateConnections($scope.connections);

                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1) {
                                $rootScope.unsavedData.splice(index, 1);
                            }

                            //Displays th form data
                            $scope.displayList = false;
                            $rootScope.$emit('hideConditionIsInListModal');
                            //Displays action menu
                            $scope.displaySubMenu = false;
                            //Hides Error
                            $scope.displayError = false;

                            var desc = $scope.parseDescription($scope.connections.data.selectedList, 'showDescription');
                            if (desc) {
                                $scope.description = desc;
                            }

                            //Save Journey to template
                            canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), $scope.isElegibleForUpdate);
                            if ($scope.isElegibleForUpdate) {
                                $scope.wasSave = true;
                                $timeout(function () {
                                    $scope.wasSave = false;
                                }, 1500);
                            }
                            //Set Back to autoSave
                            $scope.isElegibleForUpdate = true;
                            //Remove Activate Error since its being able to save
                            $scope.displayActivateError = false;
                            $scope.displayErrorBlink = false;
                        }

                    // Listener to show or hide the delete arrow or add connection arrow
                    $rootScope.$on('showDeleteArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showDeleteArrow = condition;
                    });

                    $rootScope.$on('showConnectionArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showConnectionArrow = condition;
                    });
                };

                //Validates if data is filled correctly or not
                $scope.dataFilledCorrectly = function () {
                    if ($scope.connections.data.selectedList.length === 0 || $scope.descriptionEmpty) {
                        $scope.displayError = true;

                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index === -1) {
                            $rootScope.unsavedData.push($scope.connections.id);
                        }

                        return false;
                    }

                    return true;
                };

                //Toggle List Item to check if a checkbox is checked, If not we add it to the array of IDs, if not we delete it and just save the ones selected
                $scope.toggelListItem = function (listItem) {
                    var index = $scope.connections.data.selectedList.indexOf(listItem);
                    if (index > -1) {
                        $scope.connections.data.selectedList.splice(index, 1);
                    } else {
                        $scope.connections.data.selectedList.push(listItem);
                    }

                    if ($scope.connections.data.selectedList.length) {
                        $scope.selectedKey = $scope.translate('commons.editSelection');
                    } else {
                        $scope.selectedKey = $scope.translate('commons.selectList');
                    }
                };

                //Cancel Button
                $scope.cancel = function () {
                    //Hide Menu
                    $scope.displayList = false;
                    //Hide Error
                    $scope.displayError = false;

                    if ($scope.connections) {
                        var conn = helpers.getStorageConnectionById($scope.connections.id);
                        if (conn) {
                            $scope.connections.data = conn.data;
                        }
                    }
                };

                $scope.config = function (evt) {
                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left'));

                    // check if being dragged and update position
                    if (newTop !== $scope.connections.top || $scope.connections.left !== newLeft) {
                        $scope.displayList = false;
                        //update rootScope position
                        var wasUpdated = helpers.updatePos($scope.connections.id, newTop, newLeft);
                        // To check if the element has been saved or not in the rootScope
                        if (!wasUpdated) {
                            $scope.connections.top = newTop;
                            $scope.connections.left = newLeft;
                        }

                        $rootScope.$emit('hideConditionIsInListModal');

                        return false;
                    }
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $rootScope.$emit('displayConditionIsInListModal', $scope.connections);
                    } else {
                        $scope.displayList = false;
                        $rootScope.$emit('hideConditionIsInListModal');
                    }
                    //Hide Error
                    $scope.displayError = false;
                    $scope.displaySubMenu = false;
                };

                $scope.showTipModal = function () {
                    // displays tip modal
                    $rootScope.$emit('displayConditionIsInListModal', $scope.connections, true);
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displayList || $scope.displaySubMenu) {
                        $scope.cancel();
                        $scope.displaySubMenu = false;
                        $scope.contMenuConfigs = 0;
                    }
                });

                $scope.toggleConnectionMenu = function (event) {
                    //Check if form data is filled and a connection exists as only one is allowed
                    if (helpers.checkIfIsConnected(event.target.parentNode.id)) {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.602'));
                    } else {
                        if ($('#' + event.target.parentNode.id).find('.action-conditions').inlineStyle('display') === 'none') {
                            //remove the hidden style
                            $('#' + event.target.parentNode.id).find('.action-conditions').show().prev().show();
                            $scope.displaySubMenu = true;
                            $scope.displayList = false;
                            $scope.$broadcast('setMenuDefaults');
                            $rootScope.$emit('hideConditionIsInListModal');
                        } else {
                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.611'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayConditionIsInListModal', $scope.connections);
                            } else if ($scope.connections.data.selectedList.length === 0) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.603'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayConditionIsInListModal', $scope.connections);
                            } else if ($scope.displaySubMenu === false) {
                                $scope.displaySubMenu = true;
                                $scope.displayList = false;
                                $scope.$broadcast('setMenuDefaults');
                                $rootScope.$emit('hideConditionIsInListModal');
                            } else {
                                $scope.displaySubMenu = false;
                                $scope.displayList = false;
                                $rootScope.$emit('hideConditionIsInListModal');
                            }
                        }
                    }
                };

                $scope.getSelectedText = function (desc) {
                    if ($scope.connections.data.selectedList.length === 1) {
                        for (var item in desc) {
                            desc = helpers.getContactListItem(desc[item], $scope.contactListData);
                        }

                        return desc;
                    } else {
                        var lists = [];

                        for (var i = 0; i < desc.length; i++) {
                            lists.push(helpers.getContactListItem(desc[i], $scope.contactListData));
                        }

                        return lists.join().replace(/,/g, '<br />');
                    }
                };

                $scope.parseDescription = function (desc, selected) {
                    if (desc && (typeof desc === 'undefined' ? 'undefined' : _typeof(desc)) === 'object') {
                        var descriptionCheck = false;
                        for (var item in desc) {
                            if (desc[item]) {
                                $scope.descriptionEmpty = false;
                                descriptionCheck = true;
                                //Lists that are currently selected on the node
                                var totalLists = $scope.connections.data.selectedList.length;
                                desc = helpers.getContactListItem(desc[item], $scope.contactListData);

                                //One list selected and > 19
                                if (totalLists === 1 && desc.length > 15) {
                                    desc = desc.slice(0, 15) + '...';
                                    //More than one selected
                                } else if (totalLists > 1) {
                                    desc = totalLists + $scope.translate('commons.selectedList');
                                }
                                break;
                            }
                        }
                        if (!descriptionCheck) {
                            $scope.descriptionEmpty = true;

                            if (selected === 'showSelectedList') {
                                return '';
                            } else {
                                return $scope.translate('commons.enterDetails');
                            }
                        }
                    } else {
                        $scope.descriptionEmpty = true;

                        if (selected === 'showSelectedList') {
                            return '';
                        } else {
                            return $scope.translate('commons.enterDetails');
                        }
                    }

                    return desc;
                };

                $scope.parseDescriptionMenu = function (desc) {
                    if (desc && (typeof desc === 'undefined' ? 'undefined' : _typeof(desc)) === 'object') {
                        for (var item in desc) {
                            desc = helpers.getContactListItem(item, $scope.contactListData);
                            desc = desc.slice(0, 19) + '...';
                            break;
                        }
                    } else {
                        return '...';
                    }

                    return desc;
                };

                $scope.displayModal = function () {
                    $scope.contactListData = $rootScope.contactListData;
                    $scope.modalWindow = true;
                    $rootScope.$emit('displayExtraVeil', true);
                };

                $scope.hideModal = function (clearList) {
                    if (clearList) {
                        $scope.selectedKey = $scope.translate('commons.selectList');
                        $scope.connections.data.selectedList = [];
                    }
                    $scope.modalWindow = false;
                    $rootScope.$emit('displayExtraVeil', false);
                };

                $scope.setLastElem = function (evt) {
                    plumbService.setLastElemClicked($(evt.target).parents('div.shape').attr('id'));
                };

                $scope.contMenu = 0;
                $scope.validClickingArea = function () {
                    $scope.contMenu = 0;
                };
                $scope.$on('hideConditionIsListModal', function () {
                    if ($scope.modalWindow) {
                        if ($scope.contMenu === 0) {
                            $scope.contMenu = 1;
                        } else {
                            $scope.hideModal();
                            $scope.contMenu = 0;
                        }
                    } else {
                        $scope.contMenu = 0;
                    }
                });

                $scope.description = '';
                $rootScope.$watch('segmentData', function (list) {
                    if (list && list.length && $scope.connections) {
                        $scope.segmentData = list;
                        var desc = $scope.parseDescription($scope.connections.data.selectedList, 'showDescription');

                        if (desc) {
                            $scope.description = desc;
                            $scope.placeholder = false;
                        }
                    }
                });

                $scope.$watch('connections', function (conn) {
                    if (conn && conn.children && conn.children.length) {
                        $scope.disAllowDrag = helpers.validateDragging(conn);
                    } else if (conn && !conn.children) {
                        $scope.disAllowDrag = true;
                    }
                });
            }],
            link: function link(scope, elem, attr) {
                //Scope data initialization
                scope.displayList = true;
                scope.displayError = false;
                scope.displaySubMenu = false;
                scope.isElegibleForUpdate = true;
                //load existing
                if ($rootScope.cElement) {
                    // bullet proving multiple targets
                    if (scope.connections) {
                        if (document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    scope.connections = $rootScope.cElement;
                    delete $rootScope.cElement;
                    scope.isElegibleForUpdate = false;
                    scope.placeholder = true;

                    scope.selectedKey = scope.translate('commons.selectList');
                    if (scope.connections.data.selectedList.length) {
                        scope.selectedKey = scope.translate('commons.editSelection');
                    }

                    var template = $templateCache.get('conditions/is-on-list-or-segment');

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('activateErr_' + scope.connections.id, function (evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function (evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveConditionIsInListData' + scope.connections.id, function (evt, conn, descriptionEmpty) {
                        scope.contactListData = $rootScope.contactListData;
                        scope.descriptionEmpty = descriptionEmpty;
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    scope.contactListData = $rootScope.contactListData;

                    if (scope.connections && scope.connections.children && scope.connections.children.length) {
                        $timeout(function () {
                            scope.disAllowDrag = helpers.validateDragging(scope.connections);
                        }, 1000);
                    } else if (scope.connections && !scope.connections.children) {
                        scope.disAllowDrag = true;
                    }

                    scope.save();
                }

                $(elem).click(function (evt) {
                    //Load Template
                    var template = $templateCache.get('conditions/is-on-list-or-segment'),
                        now = new Date(),
                        lastElemId = plumbService.getLastElemClicked(),
                        lastElement = helpers.getConnectionById(lastElemId);

                    $rootScope.activePlus = false;

                    scope.selectedKey = scope.translate('commons.selectList');

                    //Start Connection obj
                    scope.connections = {
                        id: 'element_' + now.getTime(),
                        top: lastElement.type == 'RectangleConnection' ? lastElement.top - 43 : lastElement.top,
                        left: lastElement.left + 250,
                        type: 'Condition',
                        data: { selectedList: [] },
                        elemClass: attr.$attr,
                        elemName: 'IsOnList',
                        parent: lastElement.id,
                        //Triger: #4F4FC9 // Action: #B21877 // Condition: #FF7F57
                        color: '#FF7F57'
                    };

                    //Create template and compile it
                    scope.$apply(function () {
                        var content = $compile(template)(scope);
                        $(elem).parents('.canvas').append(content);
                    });

                    // keep track of what has been saved, for activation
                    $rootScope.unsavedData.push(scope.connections.id);

                    $rootScope.$on('activateErr_' + scope.connections.id, function (evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function (evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveUnsavedData' + scope.connections.id, function () {
                        scope.isElegibleForUpdate = false;
                        scope.save();
                        scope.isElegibleForUpdate = true;

                        if (scope.displayError) {
                            $timeout(function () {
                                scope.displayList = true;
                                $rootScope.$emit('displayConditionIsInListModal', scope.connections);
                            }, 250);
                        }
                    });

                    $rootScope.$on('saveConditionIsInListData' + scope.connections.id, function (evt, conn, descriptionEmpty) {
                        scope.contactListData = $rootScope.contactListData;
                        scope.descriptionEmpty = descriptionEmpty;
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    // Listener when user cancel the is in the list node
                    $rootScope.$on('deleteIsInListNode' + scope.connections.id, function () {
                        scope.deleteElement();
                    });

                    $rootScope.$emit('displayConditionIsInListModal', scope.connections);

                    //Hide hide menus
                    $rootScope.$emit('closeMenus', true);
                    scope.displayList = true;

                    plumbService.connectElements(lastElement, scope.connections);

                    scope.contactListData = $rootScope.contactListData;
                });

                scope.deleteElement = function () {
                    var idx = $rootScope.unsavedData.indexOf(scope.connections.id);
                    if (idx > -1) {
                        $rootScope.unsavedData.splice(idx, 1);
                    }
                    scope.displayActivateError = false;
                    scope.displayErrorBlink = false;
                    plumbService.deleteElements(scope.connections);

                    if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry') {
                        $rootScope.activePlus = true;
                    } else {
                        $rootScope.activePlus = false;
                    }
                };

                scope.deleteArrow = function () {
                    if (scope.connections.hasOwnProperty('children')) {
                        scope.hasArrow = false;
                        plumbService.deleteArrows(scope.connections);
                    }
                };
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    angular.module('journey-loader.dir', ['journey.canvas.srv']).directive('journeyLoader', ['$rootScope', 'canvasService', '$timeout', '$interval', '$compile', 'plumbService', 'signalSrv', 'helpers', journeyLoader]);

    function journeyLoader($rootScope, canvasService, $timeout, $interval, $compile, plumbService, signalSrv, helpers) {
        return {
            controller: ['$rootScope', '$scope', function ($rootScope, $scope) {

                var setLoaderData = function setLoaderData(type, journeyId) {
                    switch (type) {
                        case 'active':
                        case 'service':
                            return JSON.parse($scope.journeyRes);
                            break;
                        case 'local':
                            if (canvasService.journeyStorageExists(journeyId)) {
                                return canvasService.getJourneyStorage(journeyId);
                            }
                            break;
                    }
                };

                $scope.hasTriggered = false;
                $timeout(function () {
                    $scope.$emit('allPromisesResolved');
                }, 0);

                $scope.$on('allPromisesResolved', function () {
                    if (!$scope.hasTriggered) {
                        $scope.hasTriggered = true;
                        $scope.allElementsCreated = false;
                        $scope.allElementsConnected = false;

                        $rootScope.loaderData = setLoaderData($scope.loaderType, $scope.journeyStorageId) || [];
                        $rootScope.unique = '';
                        if ($scope.loaderType === 'active') {
                            $scope.$emit('triggerActiveLoader');
                        } else {
                            if ($rootScope.loaderData.length <= 0) {
                                $scope.$emit('displayJourney', true);
                            } else if ($rootScope.loaderData[0].type !== 'Entry') {
                                $scope.$emit('displayJourney', true);
                            }

                            $scope.$emit('triggerLoaderData');
                        }
                    }
                });
            }],
            link: function link($scope) {

                var createDomElements = function createDomElements(elem) {
                    var lastElem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                    var directiveName,
                        newScope = $scope.$new(true);

                    if (elem) {
                        directiveName = getObjVal(elem.elemClass);
                    }

                    if (elem.type !== 'RectangleConnection' && elem) {
                        // load the journey
                        $timeout(function () {
                            $rootScope.cElement = elem;
                            $compile('<' + directiveName + '></' + directiveName + '>')(newScope);
                            if (lastElem) {
                                $timeout(function () {
                                    $scope.allElementsCreated = true;
                                }, 10);
                            }
                        }, 10);
                    } else if (lastElem) {
                        $timeout(function () {
                            $scope.allElementsCreated = true;
                        }, 10);
                    }
                };

                var connectAllLoaderElements = function connectAllLoaderElements(elems) {
                    var lastElem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                    var _hasChildren = function _hasChildren(el) {
                        var res = false;
                        if (el.hasOwnProperty('children')) {
                            if (el.children.length > 0) {
                                res = true;
                            }
                        }
                        return res;
                    };

                    while (elems.length > 0) {
                        var baseElem = elems[0];
                        if (baseElem.elemName !== 'IfElse' && baseElem.elemName !== 'EmailEngagement') {
                            if (_hasChildren(baseElem)) {
                                for (var j = 0; j < baseElem.children.length; j++) {
                                    for (var i = 0; i < elems.length; i++) {
                                        if (baseElem.type === 'Looping') {
                                            var target = helpers.getConnectionById(baseElem.children[0]);
                                            plumbService.connectLoopingElements(baseElem, target);
                                        } else if (baseElem.children[j] === elems[i].id) {
                                            plumbService.connectElements(baseElem, elems[i]);
                                        }
                                    }
                                }
                            } else {
                                // make element draggable
                                plumbService.makeDraggable(baseElem.id);
                                plumbService.setManualConnection(baseElem.color, baseElem.color);
                            }
                        }
                        elems.splice(0, 1);
                    }

                    if (lastElem) {
                        $timeout(function () {
                            $scope.allElementsConnected = true;
                        }, 0);
                    }
                };

                $scope.$on('triggerLoaderData', function () {
                    //Checks if we have data in localstorage
                    if ($rootScope.loaderData.length > 0 && typeof $rootScope.loaderData !== 'string') {
                        //Elements iterator
                        var totalNodes = $rootScope.loaderData.length;
                        for (var i = 0; i < totalNodes; i++) {
                            var cElem = $rootScope.loaderData[i];
                            var lastElem = totalNodes - 1 === i;
                            createDomElements(cElem, lastElem);
                        }
                    } else {
                        // remove the loader once the promises resolve
                        $scope.$emit('jbLoader', false);
                    }
                });

                //afterDomElements were created
                $scope.$watch('allElementsCreated', function (wereCreated) {
                    if (wereCreated) {
                        $scope.$emit('jbLoader', false);
                        connectAllLoaderElements($rootScope.loaderData, true);
                    }
                });

                //all elements were connected lets move on
                $scope.$watch('allElementsConnected', function (wereConnected) {
                    if (wereConnected) {
                        // Todo: 'timer' remove this is just to test loading time
                        if (console && typeof console.timeEnd === 'function') {
                            console.timeEnd("answer time");
                        }
                        $scope.validateJourney();
                    }
                });

                var getObjVal = function getObjVal(obj) {
                    var temp = Object.keys(obj);
                    return obj[temp[0]] || '';
                };

                var createActiveElement = function createActiveElement(aElem) {
                    var directiveName,
                        newScope = $scope.$new(true);

                    if (aElem.type === 'RectangleConnection') {
                        directiveName = 'active-' + aElem.elemClass;
                    } else {
                        directiveName = 'active-' + getObjVal(aElem.elemClass);
                    }

                    // load the journey
                    $timeout(function () {
                        $rootScope.aElement = aElem;
                        $compile('<' + directiveName + '></' + directiveName + '>')(newScope);
                    }, 0);
                };

                var connectAllElements = function connectAllElements(elems) {
                    var _hasChildren = function _hasChildren(el) {
                        var res = false;
                        if (el.hasOwnProperty('children')) {
                            if (el.children.length > 0) {
                                res = true;
                            }
                        }
                        return res;
                    },
                        conns = elems.length || 0,
                        cont = 0;

                    while (conns > 0) {
                        var baseElem = elems[cont];

                        if (_hasChildren(baseElem)) {
                            for (var j = 0; j < baseElem.children.length; j++) {
                                for (var i = 0; i < elems.length; i++) {
                                    if (baseElem.type === 'Looping') {
                                        var naturalId = helpers.getNaturalId(baseElem.children[0]);
                                        var target = helpers.getConnectionById(naturalId);
                                        plumbService.connectLoopingElements(baseElem, target);
                                    } else if (baseElem.children[j] === elems[i].id) {
                                        plumbService.connectElements(baseElem, elems[i]);
                                    }
                                }
                            }
                        }

                        conns--;
                        cont++;
                    }
                };

                $scope.$on('triggerActiveLoader', function () {
                    //Checks if we have data in local storage
                    if ($rootScope.loaderData.length > 0) {
                        var date = new Date(),
                            unique = date.getTime();

                        $rootScope.loaderData = $rootScope.loaderData.map(function (conn) {
                            conn.id = conn.id + '_' + unique;
                            conn.unique = unique;

                            if (conn.children) {
                                conn.children = conn.children.map(function (i) {
                                    return i + '_' + unique;
                                });
                            }

                            if (conn.parent) {
                                conn.parent = conn.parent + '_' + unique;
                            }

                            return conn;
                        });

                        $rootScope.unique = unique;

                        var data = $rootScope.loaderData;
                        //Elements iterator
                        for (var i = 0; i < data.length; i++) {
                            var aElem = data[i];
                            createActiveElement(aElem);
                        }
                        $timeout(function () {
                            $scope.$emit('jbLoader', false);
                            connectAllElements(data);
                        }, 1000);

                        // moving hub login to until the canvas comes back
                        var HUB = signalSrv.init(),
                            connection = $.hubConnection(HUB.URL),
                            downloader = connection.createHubProxy(HUB.NAME);

                        downloader.logging = true;

                        downloader.on("raiseMetric", function (msg) {
                            if (msg) {
                                var reportEl = JSON.parse(msg);
                                // emit the event
                                if (!reportEl.Error) {
                                    $timeout(function () {
                                        $rootScope.$emit('reporter_' + reportEl.JourneyId + reportEl.ElmentId + '_' + unique, reportEl.Count);
                                    }, 0);
                                }
                            }
                        });

                        connection.start().done(function () {
                            downloader.invoke(HUB.EVENT, $scope.jbId, '1', $rootScope.jbToken);
                        });
                    } else {
                        // remove the loader once the promises resolve
                        $scope.$emit('jbLoader', false);
                    }
                });

                $scope.validateJourney = function () {
                    var validRes = helpers.isValidJourney();

                    if (!validRes.isValid) {
                        if (validRes.unsavedData.length > 0) {
                            for (var i = 0; i < validRes.unsavedData.length; i++) {
                                $scope.$emit('emptyErr_' + validRes.unsavedData[i], true);
                            }
                        }

                        if (validRes.dummyNodes.length > 0) {
                            for (var i = 0; i < validRes.dummyNodes.length; i++) {
                                $scope.$emit('emptyErr_' + validRes.dummyNodes[i], true);
                            }
                        }
                    }

                    if (validRes.hasFacebookAudience.length) {
                        canvasService.getConnections().then(function (_ref) {
                            var data = _ref.data;

                            if (!data.ValidConnection) {
                                for (var i = 0; i < validRes.hasFacebookAudience.length; i++) {
                                    $scope.$emit('activateFbErr_' + validRes.hasFacebookAudience[i], true);
                                }
                            }
                        });
                    }
                };
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    angular.module('looping-action.dir', []).directive('loopingAction', ['$rootScope', '$compile', '$templateCache', 'plumbService', 'helpers', 'canvasService', 'CANVAS_OPTS', '$timeout', loopingAction]);

    function loopingAction($rootScope, $compile, $templateCache, plumbService, helpers, canvasService, CANVAS_OPTS, $timeout) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                //When we save a the form
                $scope.save = function (dummy) {
                    var parentData = helpers.getConnectionById($scope.connections.parent);
                    if (parentData) {
                        parentData.children = [];
                        parentData.children.push($scope.connections.id);
                        helpers.updateConnections(parentData);
                    }
                    //Save to the global canvas object
                    helpers.updateConnections($scope.connections);

                    //Displays th form data
                    $scope.displayList = false;
                    //Displays action menu
                    $scope.displaySubMenu = false;

                    //Save Journey to template
                    canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), true);

                    //Set Back to autoSave
                    $scope.isElegibleForUpdate = true;
                    //Remove Activate Error since its being able to save
                    $scope.displayActivateError = false;
                    $scope.displayErrorBlink = false;

                    // Listener to show or hide the delete arrow or add connection arrow
                    $rootScope.$on('showDeleteArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showDeleteArrow = condition;
                    });

                    $rootScope.$on('showConnectionArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showConnectionArrow = condition;
                    });
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displayList || $scope.displaySubMenu) {
                        $scope.displaySubMenu = false;
                        $scope.contMenuConfigs = 0;
                    }
                });
            }],
            link: function link(scope, elem) {
                //Scope data initialization
                scope.displayList = true;
                scope.displayError = false;
                scope.displaySubMenu = false;
                scope.isElegibleForUpdate = true;
                scope.wasSave = false;

                //load existing
                if ($rootScope.cElement) {
                    // bullet proving multiple targets
                    if (scope.connections) {
                        if (document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    scope.connections = $rootScope.cElement;
                    delete $rootScope.cElement;
                    scope.isElegibleForUpdate = true;

                    var template = $templateCache.get('actions/looping');

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('saveActionLoopingData' + scope.connections.id, function (evt, conn) {
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    scope.save();
                }

                // when a directive is clicked
                $(elem).click(function (evt) {
                    // bullet proving multiple targets
                    if (scope.connections) {
                        if (document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    //Load Template
                    var template = $templateCache.get('actions/looping'),
                        now = new Date(),
                        lastElemId = plumbService.getLastElemClicked(),
                        lastElement = helpers.getConnectionById(lastElemId);

                    //Start Connection obj
                    scope.connections = {
                        id: 'element_' + now.getTime(),
                        top: lastElement.type == 'RectangleConnection' ? lastElement.top - 18 : lastElement.top + 25,
                        left: lastElement.left + 250,
                        type: 'Looping',
                        data: { delayTime: '1', allowedLoops: '3' },
                        elemClass: { loopingAction: 'looping-action' },
                        elemName: 'Loop',
                        parent: lastElement.id,
                        //Triger: #4F4FC9 // Action: #B21877 // Condition: #FF7F57
                        color: '#B21877'
                    };

                    //Create template and compile it
                    scope.$apply(function () {
                        var content = $compile(template)(scope);
                        $(elem).parents('.canvas').append(content);
                    });

                    $rootScope.$on('saveActionLoopingData' + scope.connections.id, function (evt, conn) {
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    // Listener when user cancel the add the node of delay
                    $rootScope.$on('deleteLoopingNode' + scope.connections.id, function () {
                        scope.deleteElement();
                    });

                    //Hide hide menus
                    $rootScope.$emit('closeMenus', true);
                    scope.displayList = true;

                    scope.save();
                    plumbService.connectElements(lastElement, scope.connections);

                    $rootScope.$emit('coach-register', 'tipLooping');
                });

                scope.deleteElement = function () {
                    var idx = $rootScope.unsavedData.indexOf(scope.connections.id);
                    if (idx > -1) {
                        $rootScope.unsavedData.splice(idx, 1);
                    }
                    scope.displayActivateError = false;
                    scope.displayErrorBlink = false;
                    plumbService.deleteElements(scope.connections);
                    scope.connections = null;
                    scope.currentDelayConn = null;
                    $rootScope.delayConns = $rootScope.delayConns || [];
                    $rootScope.delayConns.splice(scope.currentDelayConn, 1);

                    if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry') {
                        $rootScope.activePlus = true;
                    } else {
                        $rootScope.activePlus = false;
                    }
                };

                scope.deleteArrow = function () {
                    if (scope.connections.hasOwnProperty('children')) {
                        scope.hasArrow = false;
                        plumbService.deleteArrows(scope.connections);
                    }
                };
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    angular.module('remove-from-list-action.dir', ['journey.veil']).directive('removeFromListAction', ['$rootScope', '$compile', '$templateCache', 'plumbService', 'helpers', 'canvasService', '$timeout', 'CANVAS_OPTS', removeFromListAction]);

    function removeFromListAction($rootScope, $compile, $templateCache, plumbService, helpers, canvasService, $timeout, CANVAS_OPTS) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;
                $scope.descriptionEmpty = false;
                $scope.wasSave = false;

                //When we save a the form
                $scope.save = function () {
                    //If form data is missing
                    if ($scope.dataFilledCorrectly() === false) {
                        $rootScope.$emit('displayActionRemoveListModalError');
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.601'));
                        if ($scope.tempConn) {
                            $scope.connections = angular.copy($scope.tempConn);
                        }
                    }
                    //Else we proceed to save and create new elements
                    else {
                            $scope.isDummyData();

                            //Updates the parent to register its children
                            var parentData = helpers.getConnectionById($scope.connections.parent);
                            if (parentData) {
                                parentData.children = [];
                                parentData.children.push($scope.connections.id);
                                helpers.updateConnections(parentData);
                            }
                            //Save to the global canvas object
                            helpers.updateConnections($scope.connections);

                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1) {
                                $rootScope.unsavedData.splice(index, 1);
                            }

                            //Displays th form data
                            $scope.displayList = false;
                            $rootScope.$emit('hideActionRemoveListModal');
                            //Displays action menu
                            $scope.displaySubMenu = false;
                            //Hides Error
                            $scope.displayError = false;

                            var desc = $scope.parseDescription($scope.connections.data.selectedList, 'showDescription');
                            if (desc) {
                                $scope.description = desc;
                            }

                            //Save Journey to template
                            canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), $scope.isElegibleForUpdate);
                            if ($scope.isElegibleForUpdate) {
                                $scope.wasSave = true;
                                $timeout(function () {
                                    $scope.wasSave = false;
                                }, 1500);
                            }
                            //Set Back to autoSave
                            $scope.isElegibleForUpdate = true;
                            //Remove Activate Error since its being able to save
                            $scope.displayActivateError = false;
                            $scope.displayErrorBlink = false;
                        }

                    // Listener to show or hide the delete arrow or add connection arrow
                    $rootScope.$on('showDeleteArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showDeleteArrow = condition;
                    });

                    $rootScope.$on('showConnectionArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showConnectionArrow = condition;
                    });
                };

                $scope.isDummyData = function () {
                    if ($scope.connections.isDummy) {
                        if ($scope.connections.data.selectedList[0] !== '11111111') {
                            delete $scope.connections.isDummy;
                        }
                    }
                };

                //Validates if data is filled correctly or not
                $scope.dataFilledCorrectly = function () {

                    if ($scope.connections.data.selectedList.length === 0 || $scope.descriptionEmpty) {
                        $scope.displayError = true;

                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index === -1) {
                            $rootScope.unsavedData.push($scope.connections.id);
                        }

                        return false;
                    }

                    return true;
                };

                //Toggle List Item to check if a checkbox is checked, If not we add it to the array of IDs, if not we delete it and just save the ones selected
                $scope.toggelListItem = function (listItem) {
                    if ($scope.connections.isDummy) {
                        $scope.connections.data.selectedList = [];
                        delete $scope.connections.isDummy;
                    }

                    var index = $scope.connections.data.selectedList.indexOf(listItem);
                    if (index > -1) {
                        $scope.connections.data.selectedList.splice(index, 1);
                    } else {
                        $scope.connections.data.selectedList.push(listItem);
                    }

                    if ($scope.connections.data.selectedList.length) {
                        $scope.selectedKey = $scope.translate('commons.editSelection');
                    } else {
                        $scope.selectedKey = $scope.translate('commons.selectList');
                    }
                };

                $scope.setLastElem = function (evt) {
                    plumbService.setLastElemClicked($(evt.target).parents('div.shape').attr('id'));
                };

                $scope.toggleConnectionMenu = function (event) {
                    //Check if form data is filled and a connection exists as only one is allowed
                    if (helpers.checkIfIsConnected(event.target.parentNode.id)) {
                        $rootScope.$emit('errorMsg', $rootScope.translate('canvas.error.602'));
                    } else {
                        if ($('#' + event.target.parentNode.id).find('.action-conditions').inlineStyle('display') === 'none') {
                            //remove the hidden style
                            $('#' + event.target.parentNode.id).find('.action-conditions').show().prev().show();
                            $scope.displaySubMenu = true;
                            $scope.displayList = false;
                            $scope.$broadcast('setMenuDefaults');
                            $rootScope.$emit('hideActionRemoveListModal');
                        } else {
                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.611'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayActionRemoveListModal', $scope.connections);
                            } else if ($scope.connections.data.selectedList.length === 0) {
                                $rootScope.$emit('errorMsg', $rootScope.translate('canvas.error.603'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayActionRemoveListModal', $scope.connections);
                            } else if ($scope.displaySubMenu === false) {
                                $scope.displaySubMenu = true;
                                $scope.displayList = false;
                                $scope.$broadcast('setMenuDefaults');
                                $rootScope.$emit('hideActionRemoveListModal');
                            } else {
                                $scope.displaySubMenu = false;
                                $scope.displayList = false;
                                $rootScope.$emit('hideActionRemoveListModal');
                            }
                        }
                    }
                };

                //Cancel Button
                $scope.cancel = function () {
                    //Hide Menu
                    $scope.displayList = false;
                    //Hide Error
                    $scope.displayError = false;

                    if ($scope.connections) {
                        var conn = helpers.getStorageConnectionById($scope.connections.id);
                        if (conn) {
                            $scope.connections.data = conn.data;
                            if ($scope.connections.data.selectedList[0] === '11111111') {
                                $scope.connections.isDummy = true;
                            }
                        }
                    }
                };

                $scope.config = function (evt) {
                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left'));

                    // check if being dragged and update position
                    if (newTop !== $scope.connections.top || $scope.connections.left !== newLeft) {
                        $scope.displayList = false;
                        //update rootScope position
                        var wasUpdated = helpers.updatePos($scope.connections.id, newTop, newLeft);
                        // To check if the element has been saved or not in the rootScope
                        if (!wasUpdated) {
                            $scope.connections.top = newTop;
                            $scope.connections.left = newLeft;
                        }

                        $rootScope.$emit('hideActionRemoveListModal');

                        return false;
                    }
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $rootScope.$emit('displayActionRemoveListModal', $scope.connections);
                    } else {
                        $scope.displayList = false;
                        $rootScope.$emit('hideActionRemoveListModal');
                    }
                    //Hide Error
                    $scope.displayError = false;
                    $scope.displaySubMenu = false;
                };

                $scope.showTipModal = function () {
                    // displays tip modal
                    $rootScope.$emit('displayActionRemoveListModal', $scope.connections, true);
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displayList || $scope.displaySubMenu) {
                        $scope.cancel();
                        $scope.displaySubMenu = false;
                        $scope.contMenuConfigs = 0;
                    }
                });

                $scope.getSelectedText = function (desc) {
                    if ($scope.connections.data.selectedList.length === 1) {
                        for (var item in desc) {
                            desc = helpers.getContactListItem(desc[item], $scope.contactListData);
                        }

                        return desc;
                    } else {
                        var lists = [];

                        for (var i = 0; i < desc.length; i++) {
                            lists.push(helpers.getContactListItem(desc[i], $scope.contactListData));
                        }

                        return lists.join().replace(/,/g, '<br />');
                    }
                };

                $scope.parseDescription = function (desc, selected) {
                    if (desc && (typeof desc === 'undefined' ? 'undefined' : _typeof(desc)) === 'object') {
                        var descriptionCheck = false;
                        for (var item in desc) {
                            if (desc[item]) {
                                $scope.descriptionEmpty = false;
                                descriptionCheck = true;
                                var totalLists = $scope.connections.data.selectedList.length;
                                desc = helpers.getContactListItem(desc[item], $scope.contactListData);

                                //One list selected and > 19
                                if (totalLists === 1 && desc.length > 15) {
                                    desc = desc.slice(0, 15) + '...';
                                    //More than one selected
                                } else if (totalLists > 1) {
                                    desc = totalLists + ' ' + $scope.translate('commons.selectedList');
                                }

                                break;
                            }
                        }
                        if (!descriptionCheck) {
                            $scope.descriptionEmpty = true;

                            if (selected === 'showSelectedList') {
                                return '';
                            } else {
                                return $scope.translate('commons.enterDetails');
                            }
                        }
                    } else {
                        $scope.descriptionEmpty = true;

                        if (selected === 'showSelectedList') {
                            return '';
                        } else {
                            return $scope.translate('commons.enterDetails');
                        }
                    }

                    return desc;
                };

                $scope.parseDescriptionMenu = function (desc) {
                    if (desc && (typeof desc === 'undefined' ? 'undefined' : _typeof(desc)) === 'object') {
                        for (var item in desc) {
                            desc = helpers.getContactListItem(item, $scope.contactListData);
                            desc = desc.slice(0, 19) + '...';
                            break;
                        }
                    } else {
                        return '...';
                    }

                    return desc;
                };

                $scope.displayModal = function () {
                    $scope.contactListData = $rootScope.contactListData;
                    $scope.modalWindow = true;
                    $rootScope.$emit('displayExtraVeil', true);
                };

                $scope.hideModal = function (clearList) {
                    if (clearList) {
                        $scope.selectedKey = $scope.translate('commons.selectList');
                        $scope.connections.data.selectedList = [];
                    }
                    $scope.modalWindow = false;
                    $rootScope.$emit('displayExtraVeil', false);
                };

                $scope.contMenu = 0;
                $scope.validClickingArea = function () {
                    $scope.contMenu = 0;
                };
                $scope.$on('hideActionListModal', function () {
                    if ($scope.modalWindow) {
                        if ($scope.contMenu === 0) {
                            $scope.contMenu = 1;
                        } else {
                            $scope.hideModal();
                            $scope.contMenu = 0;
                        }
                    } else {
                        $scope.contMenu = 0;
                    }
                });

                $scope.description = '';
                $rootScope.$watch('contactListData', function (list) {
                    if (list && list.length && $scope.connections) {
                        $scope.contactListData = list;
                        var desc = $scope.parseDescription($scope.connections.data.selectedList, 'showDescription');

                        if (desc) {
                            $scope.description = desc;
                            $scope.placeholder = false;
                        }
                    }
                });

                $scope.$watch('connections', function (conn) {
                    if (conn && conn.children && conn.children.length) {
                        $scope.disAllowDrag = helpers.validateDragging(conn);
                    } else if (conn && !conn.children) {
                        $scope.disAllowDrag = true;
                    }
                });
            }],
            link: function link(scope, elem, attr) {
                //Scope data initialization
                scope.displayError = false;
                scope.displaySubMenu = false;
                scope.isElegibleForUpdate = true;
                //load existing
                if ($rootScope.cElement) {
                    // bullet proving multiple targets
                    if (scope.connections) {
                        if (document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    scope.connections = $rootScope.cElement;
                    delete $rootScope.cElement;
                    scope.isElegibleForUpdate = false;
                    scope.placeholder = true;

                    scope.selectedKey = scope.translate('commons.selectList');
                    if (scope.connections.data.selectedList.length) {
                        scope.selectedKey = scope.translate('commons.editSelection');
                    }

                    var template = $templateCache.get('actions/remove-from-list');

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('activateErr_' + scope.connections.id, function (evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function (evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveActionRemoveListData' + scope.connections.id, function (evt, conn, descriptionEmpty) {
                        scope.contactListData = $rootScope.contactListData;
                        scope.descriptionEmpty = descriptionEmpty;
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    scope.contactListData = $rootScope.contactListData;

                    if (scope.connections && scope.connections.children && scope.connections.children.length) {
                        $timeout(function () {
                            scope.disAllowDrag = helpers.validateDragging(scope.connections);
                        }, 1000);
                    } else if (scope.connections && !scope.connections.children) {
                        scope.disAllowDrag = true;
                    }

                    scope.save();
                }

                $(elem).click(function (evt) {
                    //Load Template
                    var template = $templateCache.get('actions/remove-from-list'),
                        now = new Date(),
                        lastElemId = plumbService.getLastElemClicked(),
                        lastElement = helpers.getConnectionById(lastElemId);

                    scope.selectedKey = scope.translate('commons.selectList');

                    $rootScope.activePlus = false;

                    //Start Connection obj
                    scope.connections = {
                        id: 'element_' + now.getTime(),
                        top: lastElement.type == 'RectangleConnection' ? lastElement.top - 43 : lastElement.top,
                        left: lastElement.left + 250,
                        type: 'Action',
                        data: { selectedList: [] },
                        elemClass: attr.$attr,
                        elemName: 'DeleteContactList',
                        parent: lastElement.id,
                        //Triger: #4F4FC9 // Action: #B21877 // Condition: #FF7F57
                        color: '#B21877'
                    };

                    //Create template and compile it
                    scope.$apply(function () {
                        var content = $compile(template)(scope);
                        $(elem).parents('.canvas').append(content);
                    });

                    // keep track of what has been saved, for activation
                    $rootScope.unsavedData.push(scope.connections.id);

                    $rootScope.$on('activateErr_' + scope.connections.id, function (evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function (evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveUnsavedData' + scope.connections.id, function () {
                        scope.isElegibleForUpdate = false;
                        scope.save();
                        scope.isElegibleForUpdate = true;

                        if (scope.displayError) {
                            $timeout(function () {
                                scope.displayList = true;
                                $rootScope.$emit('displayActionRemoveListModal', scope.connections);
                            }, 250);
                        }
                    });

                    $rootScope.$on('saveActionRemoveListData' + scope.connections.id, function (evt, conn, descriptionEmpty) {
                        scope.contactListData = $rootScope.contactListData;
                        scope.descriptionEmpty = descriptionEmpty;
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    //List modal display new modals
                    $rootScope.$emit('displayActionRemoveListModal', scope.connections);

                    //Hide hide menus
                    $rootScope.$emit('closeMenus', true);
                    scope.displayList = true;

                    // Listener when user cancel the remove list
                    $rootScope.$on('deleteRemoveListNode' + scope.connections.id, function () {
                        scope.deleteElement();
                    });

                    plumbService.connectElements(lastElement, scope.connections);

                    scope.contactListData = $rootScope.contactListData;
                });

                scope.deleteElement = function () {
                    var idx = $rootScope.unsavedData.indexOf(scope.connections.id);
                    if (idx > -1) {
                        $rootScope.unsavedData.splice(idx, 1);
                    }
                    scope.displayActivateError = false;
                    scope.displayErrorBlink = false;
                    plumbService.deleteElements(scope.connections);

                    if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry') {
                        $rootScope.activePlus = true;
                    } else {
                        $rootScope.activePlus = false;
                    }
                };

                scope.deleteArrow = function () {
                    if (scope.connections.hasOwnProperty('children')) {
                        scope.hasArrow = false;
                        plumbService.deleteArrows(scope.connections);
                    }
                };
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	angular.module('scroll-into.dir', ['journey.canvas.srv', 'journey.veil']).directive('scrollInto', function () {
		return function (scope, element, attrs) {
			scope.$watch(attrs.scrollInto, function (value) {
				if (value) {
					element[0].scrollIntoView({ block: 'end', behavior: 'smooth' });
				}
			});
		};
	});
})();

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    angular.module('send-email-action.dir', ['journey.veil', 'ngSanitize']).directive('sendEmailAction', ['$rootScope', '$compile', '$templateCache', '$q', 'plumbService', 'helpers', 'canvasService', 'CANVAS_OPTS', '$stateParams', '$timeout', 'scrollLoaderEmails', sendEmailAction]);

    function sendEmailAction($rootScope, $compile, $templateCache, $q, plumbService, helpers, canvasService, CANVAS_OPTS, $stateParams, $timeout, scrollLoaderEmails) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;
                $scope.search = {};
                $scope.wasSave = false;

                //Function to emit Add Wait Time msg to the user when adding the send email node. Creating or Reusing.
                $scope.$watch('connections.data.emailStatus', function () {
                    if ($scope.connections != undefined) {
                        var emailStatusCheck = $scope.connections.data.emailStatus;
                        if ($stateParams.emailId && $stateParams.status && emailStatusCheck === 'fromEditor') {
                            $rootScope.$emit('coach-register', 'tipSendEmail');
                        }
                    }
                });

                $scope.saveData = function (displayUpdate) {
                    $scope.isDummyData();
                    $scope.connections.emailData.TemplateContent = '';
                    $scope.connections.emailData.TemplateText = '';

                    //Updates the parent to register its children
                    var parentData = helpers.getConnectionById($scope.connections.parent);
                    if (parentData) {
                        parentData.children = [];
                        parentData.children.push($scope.connections.id);
                        helpers.updateConnections(parentData);
                    }
                    //Save to the global canvas object
                    helpers.updateConnections($scope.connections);

                    var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                    if (index > -1) {
                        $rootScope.unsavedData.splice(index, 1);
                    }

                    $scope.selectedView = false;
                    //Displays action menu
                    $scope.displaySubMenu = false;
                    //Hides Error
                    $scope.displayError = false;
                    //Save Journey to template
                    canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), $scope.isElegibleForUpdate);

                    if (!displayUpdate) {
                        $scope.wasSave = true;
                        $timeout(function () {
                            $scope.wasSave = false;
                        }, 1500);
                    }
                    //Set Back to autoSave
                    $scope.isElegibleForUpdate = true;
                    //Remove Activate Error since its being able to save
                    $scope.displayActivateError = false;
                    $scope.displayErrorBlink = false;

                    if ($scope.reuse) {
                        $scope.reuse = false;
                        $rootScope.$emit('coach-register', 'tipSendEmail');
                    }

                    $rootScope.$emit('emailUpdated', $scope.connections.id);

                    // Generates a wait time node
                    $rootScope.$emit('generateWaitTime', $scope.connections.id);

                    // Listener to show or hide the delete arrow or add connection arrow
                    $rootScope.$on('showDeleteArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showDeleteArrow = condition;
                    });

                    $rootScope.$on('showConnectionArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showConnectionArrow = condition;
                    });
                };

                $scope.isDummyData = function () {
                    if ($scope.connections.isDummy) {
                        if ($scope.connections.data.emailId !== '11111111') {
                            delete $scope.connections.isDummy;
                        }
                    }
                };

                $scope.$watch('connections.emailData.EmailName', function (newVal, oldVal) {
                    if (newVal && newVal !== oldVal) {
                        if ($scope.didReuse) {
                            $scope.didReuse = false;
                        } else {
                            $scope.emailChanged = true;
                        }
                    }
                });

                var checkPermissionReminder = function checkPermissionReminder() {
                    if (!$scope.connections.data.permisionReminder) {
                        return false;
                    } else if ($scope.connections.emailData.PermissionReminderMessage !== '') {
                        return false;
                    } else {
                        return true;
                    }
                };

                $scope.emailChanged = false;
                $scope.validateFields = function () {
                    var deferred = $q.defer();
                    var partialRes;
                    var emailName = $scope.connections.emailData.EmailName;
                    var emailStatus = $scope.connections.data.emailStatus;

                    if (emailStatus === "fromEditor") {
                        $scope.storedEmailName = emailName;
                    }

                    if (!$scope.connections.emailData.Subject || !emailName || !$scope.connections.emailData.FromName || !$scope.connections.emailData.FromEmail || !$scope.connections.emailData.ReplyEmail || checkPermissionReminder()) {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.601'));
                        $scope.sbjErr = $scope.connections.emailData.Subject === '';
                        $scope.eNameErr = emailName === '';
                        $scope.eFromErr = $scope.connections.emailData.FromName === '';
                        $scope.eFromSubjErr = $scope.connections.emailData.FromEmail === '';
                        $scope.eFromReplyErr = $scope.connections.emailData.ReplyEmail === '';
                        $scope.ePermissionReminder = $scope.connections.emailData.PermissionReminderMessage === '';
                        $rootScope.$emit('sendEmailBackMenu');
                        partialRes = true;
                    }

                    if ($scope.connections.data.permisionReminder && !$scope.connections.emailData.PermissionReminderMessage || $scope.connections.data.googleAnalyticsAllUrl && !$scope.connections.emailData.GoogleAnalyticsCampaign || $scope.connections.data.pageTextTextarea && !$scope.connections.emailData.InboxPreviewText) {
                        $scope.permError = $scope.connections.emailData.PermissionReminderMessage === '' && $scope.connections.data.permisionReminder;
                        $scope.analyticsError = $scope.connections.emailData.GoogleAnalyticsCampaign === '' && $scope.connections.data.googleAnalyticsAllUrl;
                        $scope.pgTextError = $scope.connections.emailData.InboxPreviewText === '' && $scope.connections.data.pageTextTextarea;
                        partialRes = $scope.analyticsError || $scope.permError || $scope.pgTextError || partialRes;
                    }

                    if (!partialRes && emailStatus != "fromEditor" && emailStatus != "insertExisting") {
                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index === -1) {
                            $rootScope.unsavedData.push($scope.connections.id);
                        }

                        $scope.sbjErr = $scope.eNameErr = $scope.eFromErr = $scope.eFromSubjErr = $scope.eFromReplyErr = $scope.ePermissionReminder = false;
                        $scope.permError = $scope.analyticsError = $scope.pgTextError = false;

                        if (emailStatus === "updateEmail" && $scope.emailChanged || emailStatus === "createNew" && $scope.storedEmailName != emailName) {
                            canvasService.validateDuplicateEmailName(emailName).success(function (res) {

                                if (res.IsUniqueName) {
                                    deferred.resolve();
                                    $scope.eNameErr = false;
                                    $scope.storedEmailName = emailName;
                                    $scope.emailChanged = false;
                                } else {
                                    $rootScope.$emit('errorMsg', $scope.translate('canvas.action.sendEmail.duplicateEmailName'));
                                    $scope.eNameErr = true;
                                    deferred.reject();
                                    $rootScope.$emit('sendEmailBackMenu');
                                }
                            }).error(function (err) {
                                var error = err.Message || $scope.translate('canvas.error.601');
                                //Error msg from backend when failing
                                $rootScope.$emit('errorMsg', error);
                                deferred.reject();
                                $scope.eNameErr = true;
                            });
                        } else {
                            $rootScope.$emit('cleanSendEmailErrors');
                            deferred.resolve();
                        }
                    } else {
                        deferred.reject();
                    }
                    return deferred.promise;
                };

                //When we save a the form
                $scope.save = function (trackAddWaitTimeMsg) {
                    //If form data is missing
                    $scope.validateFields().then(function () {
                        if ($scope.connections.data.emailStatus === 'createNew') {
                            // when creating a new email
                            $rootScope.editorSubMenu = true;
                            $scope.displayList = false;
                            $rootScope.$emit('hideActionSendEmailModal');
                        } else if ($scope.connections.data.emailStatus === 'updateEmail') {
                            // this is an update email action
                            canvasService.updateEmailData($scope.connections.data.emailId, $scope.connections.emailData).success(function (id) {
                                $scope.ePermissionReminder = true;
                                if (id) {
                                    $scope.saveData(true);
                                    $rootScope.editorSubMenu = false;
                                    $timeout(function () {
                                        $scope.displayList = false;
                                        $rootScope.$emit('hideActionSendEmailModal');
                                    }, 0);
                                }
                            }).error(function (err) {});
                        }
                    }).catch(function () {
                        var errors = {
                            sbjErr: $scope.sbjErr,
                            eNameErr: $scope.eNameErr,
                            eFromErr: $scope.eFromErr,
                            eFromSubjErr: $scope.eFromSubjErr,
                            eFromReplyErr: $scope.eFromReplyErr,
                            permError: $scope.permError,
                            analyticsError: $scope.analyticsError,
                            pgTextError: $scope.pgTextError,
                            ePermissionReminder: $scope.ePermissionReminder
                        };

                        $rootScope.$emit('displayActionSendEmailModalError', errors);

                        if ($scope.tempConn) {
                            $scope.connections = angular.copy($scope.tempConn);
                        }

                        for (var key in errors) {
                            if (errors[key]) {
                                $rootScope.scrollTarget = key;
                                break;
                            }
                        }

                        $timeout(function () {
                            $rootScope.scrollTarget = '';
                        }, 500);
                    });
                };

                $scope.onRedirect = function () {
                    // when redirection is back
                    if ($stateParams.emailId) {
                        $scope.insertExisting($stateParams.emailId, true);
                        canvasService.generateThumbs($stateParams.emailId).then(function () {});
                    }
                };

                $scope.setLastElem = function (evt) {
                    var elemId = $(evt.target).parents('div.shape').attr('id');
                    plumbService.setLastElemClicked(elemId);
                };

                $scope.toggleConnectionMenu = function (event) {
                    //Check if form data is filled and a connection exists as only one is allowed
                    if (helpers.checkIfIsConnected(event.target.parentNode.id)) {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.605'));
                    } else {
                        if ($('#' + event.target.parentNode.id).find('.action-conditions').inlineStyle('display') === 'none') {
                            //remove the hidden style
                            $('#' + event.target.parentNode.id).find('.action-conditions').show().prev().show();
                            $scope.displaySubMenu = true;

                            $scope.modalWindow = false;
                            $scope.$broadcast('setMenuDefaults');
                            //Element position on screen when creating a new email
                        } else {
                            if (!$scope.connections.data.emailId) {
                                $scope.displayModal();
                                $scope.displaySubMenu = false;
                            } else if ($scope.displaySubMenu === false) {
                                $scope.$broadcast('setMenuDefaults');
                                $scope.displaySubMenu = true;

                                $scope.modalWindow = false;
                            } else {
                                $scope.displaySubMenu = false;

                                $scope.modalWindow = false;
                            }
                        }
                    }
                };

                $scope.config = function (evt) {
                    var type = 'displayList';
                    if ($scope.connections.data.emailId) {
                        $scope[type] = false;
                        type = 'selectedView';
                    }

                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left'));

                    // check if being dragged and update position
                    if (newTop !== $scope.connections.top || $scope.connections.left !== newLeft) {
                        $scope.displayList = false;
                        //update rootScope position

                        helpers.updatePos($scope.connections.id, newTop, newLeft);

                        $scope.connections.top = newTop;
                        $scope.connections.left = newLeft;

                        $rootScope.$emit('hideActionSendEmailModal');
                        return false;
                    }

                    if ($rootScope.editorSubMenu) {
                        $rootScope.editorSubMenu = false;
                        $scope.displayList = true;
                        $rootScope.$emit('displayActionSendEmailModal', $scope.connections, true, false);

                        if ($scope.connections.data.emailId) {
                            $scope.connections.data.emailStatus = 'updateEmail';
                        } else {
                            $scope.connections.data.emailStatus = 'createNew';
                        }
                    } else {
                        if ($scope.connections.isDummy) {
                            $rootScope.$emit('displayModalSendEmail' + $scope.connections.id);
                        } else {
                            //Show form menu
                            $scope.selectedView = false;
                            $scope[type] = !$scope[type];
                            $rootScope.$emit('displayActionSendEmailModal', $scope.connections, $scope.displayList, $scope.selectedView);
                        }
                    }
                    //Hide Error
                    $scope.displayError = false;
                    $scope.displaySubMenu = false;
                };

                $scope.showTipModal = function () {
                    // last options is for is tip modal.
                    $rootScope.$emit('displayActionSendEmailModal', $scope.connections, false, false, true);
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displaySubMenu) {
                        $scope.displayList = false;
                        $scope.displaySubMenu = false;
                        $scope.contMenuConfigs = 0;
                    }
                });

                $scope.parseDescription = function (desc) {

                    if (desc) {
                        if (desc.length > 15) {
                            desc = desc.slice(0, 15) + '...';
                            //Desc < 15
                        } else if (desc.length < 15) {
                            desc = desc;
                        }
                    } else {
                        return $scope.translate('commons.enterDetails');
                    }

                    return desc;
                };

                $scope.hideModal = function () {
                    $scope.modalWindow = false;
                    $scope.displayList = false;
                    $scope.search.email = "";
                    $scope.emailList = $rootScope.emailData;

                    var node = _.find($rootScope.connections, function (conn) {
                        return conn.id === $scope.connections.id;
                    });

                    if (!node) {
                        $scope.deleteElement();
                    }
                };

                $scope.saveDuplicate = function () {
                    if ($scope.duplicateName) {
                        $scope.duplicateError = false;
                        $scope.didReuse = false;
                        $scope.reuse = false;
                        $scope.duplicating = true;

                        var mergeTags = helpers.getMergeTags() || [];
                        //Once the service is ready
                        canvasService.duplicateEmail($scope.currentDuplicateEmailId, $scope.duplicateName, mergeTags).success(function (res) {
                            var d = new Date(),
                                createdDate = d.getMonth() + ' ' + d.getDate() + ', ' + d.getFullYear(),
                                mergeTags = helpers.getMergeTags() || [];

                            $scope.didReuse = true;
                            $scope.reuse = true;
                            $scope.duplicateName = "";
                            $scope.duplicateModal = !$scope.duplicateModal;
                            $scope.emailList.push({
                                EmailTemplateCreatedDate: res.CreatedDate || createdDate,
                                EmailTemplateId: res.Id,
                                EmailTemplateName: res.EmailName
                            });

                            $scope.connections.data.emailStatus = 'insertExisting';
                            $scope.connections.data.emailId = res.Id;
                            $scope.connections.data.emailName = res.EmailName;
                            $scope.connections.emailData = {
                                EmailName: res.EmailName,
                                FromEmail: res.FromEmail,
                                FromName: res.FromName,
                                GoogleAnalyticsCampaign: res.GoogleAnalyticsCampaign,
                                PermissionReminderMessage: res.PermissionReminderMessage,
                                ReplyEmail: res.ReplyEmail || res.FromEmail,
                                Subject: res.Subject,
                                TemplateContent: res.TemplateContent,
                                InboxPreviewText: res.InboxPreviewText,
                                ToListName: res.ToListName,
                                ToListId: res.ToListId + '',
                                WebpageVersion: res.WebpageVersion,
                                Version: res.Version,
                                Reuse: $scope.reuse
                            };

                            if (!$scope.connections.emailData.PermissionReminderMessage) {
                                $scope.connections.emailData.PermissionReminderMessage = $scope.translate('canvas.action.sendEmail.permisionReminder1') + $rootScope.cSettings.ClientCompany + $scope.translate('canvas.action.sendEmail.permisionReminder2');
                                $scope.connections.data.permisionReminder = true;
                            }

                            $scope.displayList = $rootScope.editorSubMenu = $scope.modalWindow = false;

                            if ($scope.isFromEditor) {
                                $scope.selectedView = false;
                            } else {

                                $scope.selectedView = true;
                                $rootScope.$emit('displayActionSendEmailModal', $scope.connections, false, true);
                            }
                            //Hide Extra veils top and header
                            $scope.duplicating = false;
                            canvasService.generateThumbs(res.Id).then(function () {});
                        }).error(function (err) {
                            if (err.ErrorType === "Duplicate") {
                                err.Message = $scope.translate('canvas.action.sendEmail.duplicateEmailName');
                            }

                            $rootScope.$emit('errorMsg', err.Message);
                            $scope.duplicateName = "";
                            $scope.duplicating = false;
                        });
                    } else {
                        $scope.duplicateError = true;
                    }
                };

                //Display Duplicate modal
                $scope.settingsMenu = function (index) {
                    //initialize toggle
                    if (typeof $scope.duplicateSettings[index] === 'undefined') {
                        $scope.duplicateSettings[index] = false;
                    }
                    $scope.duplicateSettings[index] = !$scope.duplicateSettings[index];
                };

                $scope.cancelDuplicate = function () {
                    $scope.duplicateModal = !$scope.duplicateModal;
                };

                $scope.createNew = function () {
                    $scope.connections.data.emailStatus = 'createNew';
                    $scope.connections.data.emailId = '';
                    $scope.connections.data.emailName = '';

                    $scope.modalWindow = false;
                    $scope.selectedView = false;
                    $rootScope.editorSubMenu = false;
                    $scope.connections.emailData = {
                        EmailName: '',
                        FromName: $rootScope.emptyEmail.FromName,
                        FromEmail: $rootScope.emptyEmail.FromEmail,
                        ReplyEmail: $rootScope.emptyEmail.ReplyEmail,
                        PermissionReminderMessage: $rootScope.emptyEmail.PermissionReminderMessage,
                        GoogleAnalyticsCampaign: '',
                        Subject: '',
                        TemplateContent: '',
                        InboxPreviewText: '',
                        ToListId: '',
                        ToListName: '',
                        WebpageVersion: true
                    };

                    $rootScope.$emit('displayActionSendEmailModal', $scope.connections, true, false);
                };

                $scope.insertExisting = function (emailId, fromEditor) {
                    var emailName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Copy';

                    $scope.isFromEditor = fromEditor;
                    $scope.currentDuplicateEmailId = emailId;
                    $scope.duplicateName = emailName + ' Copy';
                    $scope.duplicateModal = !$scope.duplicateModal;
                };

                $scope.displayModal = function () {
                    $scope.loadEmailListAsync();
                    $scope.loadTrashEmailListAsync();
                    var canvasEl = document.querySelector(".canvas");
                    $scope.modalLeft = canvasEl.offsetLeft * -1 + 200;
                    $scope.modalTop = canvasEl.offsetTop * -1.0050;
                    $scope.selectedView = false;
                    $scope.contMenu = 0;
                    $scope.modalWindow = true;
                };

                $scope.displaySearchInput = function (show) {
                    var input = document.getElementById("search-email");
                    $scope.displaySearch = show;
                    $scope.search.email = '';

                    input.focus();
                };

                $scope.contMenu = 0;
                $scope.validClickingArea = function () {
                    $scope.contMenu = 0;
                };
                $scope.$on('hideActionSendEmailModal', function () {
                    if ($scope.modalWindow) {
                        if ($scope.contMenu === 0) {
                            $scope.contMenu = 1;
                        } else {
                            $scope.hideModal();
                            $scope.contMenu = 0;
                        }
                    } else {
                        $scope.contMenu = 0;
                    }
                });

                $scope.listView = true;
                $scope.toggleEmailsView = function (display) {
                    $scope.listView = display;
                };

                $scope.loadTrashEmailListAsync = function () {
                    if (!$rootScope.trashList) {
                        canvasService.getTrashEmails().then(function (_ref) {
                            var data = _ref.data;

                            $rootScope.trashList = data.Results;
                            $rootScope.trashCount = data.Results && data.Results.length || 0;
                        });
                    }
                };

                $scope.loadEmailListAsync = function () {
                    if (!$rootScope.emailData) {
                        $rootScope.$emit('jbLoader', true, true);
                        canvasService.getEmailList(0, 15).success(function (data) {
                            if (!data.Results.length) {
                                $scope.createNew();
                                $scope.hideModal();
                                $rootScope.emailData = [];
                            } else {
                                $rootScope.emailData = data.Results;
                                $scope.emailList = $rootScope.emailData;
                                $scope.setScrollLogic($scope.connections.id);
                                $scope.modalWindow = true;
                            }
                            $rootScope.$emit('jbLoader', false, true);
                        }).catch(function () {
                            $rootScope.$emit('jbLoader', false, true);
                        });
                    } else {
                        $scope.emailList = $rootScope.emailData;
                        $scope.setScrollLogic($scope.connections.id);
                        if (!$scope.emailList.length) {
                            $scope.hideModal();
                            $scope.createNew();
                        } else {
                            $scope.modalWindow = true;
                        }
                    }
                };

                $scope.searching = false;
                $scope.search.search = function (val) {
                    if (val && val.length > 0 && !$scope.searching) {
                        $scope.searching = true;
                        canvasService.searchEmails(val).then(function (res) {
                            $scope.searching = false;
                            $scope.emailList = res.data.Results;
                        }).catch(function () {
                            $scope.searching = false;
                        });
                    } else {
                        $scope.emailList = $rootScope.emailData;
                    }
                };

                if (!$rootScope.userEmailAddress) {
                    canvasService.getUserEmailAddress().success(function (data) {
                        $rootScope.userEmailAddress = data.Results || [];
                        $scope.emailAddressList = $rootScope.userEmailAddress.map(function (obj) {
                            return obj.Email;
                        });
                    });
                }

                $scope.sortBy = function (val) {
                    $scope.sortList = val;
                };

                var inProcess = false;
                $scope.movedToTrash = false;
                $scope.moveToTrash = function (eId) {
                    if (!inProcess) {
                        inProcess = true;
                        canvasService.trashEmail(eId).then(function () {
                            var index = $rootScope.emailData.findIndex(function (i) {
                                return i.EmailTemplateId == eId;
                            });
                            var splicedEl = $rootScope.emailData.splice(index, 1);
                            $scope.emailList = $rootScope.emailData;

                            delete splicedEl.$$hashKey;
                            $rootScope.trashList.unshift(splicedEl[0]);
                            $rootScope.trashCount++;
                        }).finally(function () {
                            inProcess = false;
                            $scope.movedToTrash = true;
                            $timeout(function () {
                                $scope.movedToTrash = false;
                            }, 2000);
                        });
                    }
                };

                $scope.restored = false;
                $scope.restoreEmail = function (eId) {
                    if (!inProcess) {
                        inProcess = true;
                        canvasService.restoreTrashEmail(eId).then(function () {
                            var index = $rootScope.trashList.findIndex(function (i) {
                                return i.EmailTemplateId == eId;
                            });
                            var splicedEl = $rootScope.trashList.splice(index, 1);
                            $rootScope.trashCount--;

                            delete splicedEl.$$hashKey;
                            $rootScope.emailData.unshift(splicedEl[0]);
                            $scope.emailList = $rootScope.emailData;
                        }).finally(function () {
                            inProcess = false;
                            $scope.restored = true;
                            $timeout(function () {
                                $scope.restored = false;
                            }, 2000);
                        });
                    }
                };

                $scope.displayPreviewForEmail = function (eId) {
                    $scope.modalWindow = false;
                    $scope.displayList = false;
                    $scope.search.email = "";

                    $rootScope.$emit('previewEmail', 'showEmailList', false, false, $scope.connections.id);
                    $("#dvPreviewContent").html("<div class=\"loading-animation\"><span></span><span></span><span></span><span></span></div>");

                    canvasService.getPreview(eId).then(function (_ref2) {
                        var data = _ref2.data;

                        if (data.Response.ID) {
                            var obj = data.Response;
                            var content = obj.TemplateContent;
                            if (content.indexOf("<!-- /Footer Path -->") != -1) {
                                content = content.substring(0, content.indexOf("<!-- /Footer Path -->"));
                            }
                            $("#dvPreviewContent").html("");
                            var iframe = document.createElement('iframe');
                            $(iframe).attr("id", "ifrPreviewContent");
                            $("div#dvPreviewContent").append(iframe);
                            iframe.contentWindow.document.open();
                            iframe.contentWindow.document.write(content);
                            iframe.contentWindow.document.close();
                        } else {
                            alert("Could not load Preview");
                        }
                    });

                    $rootScope.$on('closePreviewEmailShowModal' + $scope.connections.id, function () {
                        $scope.displayModal();
                    });
                };

                $scope.$watch('connections', function (conn) {
                    if (conn && conn.children && conn.children.length) {
                        $scope.disAllowDrag = helpers.validateDragging(conn);
                    } else if (conn && !conn.children) {
                        $scope.disAllowDrag = true;
                    }
                });
            }],
            link: function link(scope, elem, attr) {
                // Detect if browser is firefox
                if (typeof InstallTrigger !== 'undefined') {
                    scope._timeout = null;
                    angular.element(document.getElementsByClassName('send-email')).bind("scroll", function () {
                        var elementActions = angular.element(document.getElementsByClassName('send-email-form'));

                        elementActions.css({ 'margin-right': '10px' });

                        // Cancel timeout
                        if (scope._timeout) {
                            $timeout.cancel(scope._timeout);
                        }

                        scope._timeout = $timeout(function () {
                            scope._timeout = null;

                            elementActions.css({ 'margin-right': '0' });
                        }, 1000);
                    });
                }

                // scope data initialization
                scope.sortList = '-EmailTemplateCreatedDate';
                scope.displayList = false;
                scope.displayError = false;
                scope.displaySubMenu = false;
                scope.selectedView = false;
                $rootScope.editorSubMenu = false;
                scope.duplicateSettings = [];
                scope.duplicateModal = false;
                scope.duplicateName = '';
                scope.isFromEditor = false;
                scope.emailOptions = false;
                scope.wrapOptions = false;

                // when the directive is loaded from service
                if ($rootScope.cElement) {
                    // bullet proving multiple targets
                    if (scope.connections) {
                        if (document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    scope.connections = $rootScope.cElement;
                    delete $rootScope.cElement;

                    var canvasEl = document.querySelector(".canvas");
                    scope.modalLeft = canvasEl.offsetLeft * -1.05;
                    scope.modalTop = canvasEl.offsetTop * -1.0090;

                    //load template
                    var template = $templateCache.get('actions/send-email');

                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    // Modal
                    var modalTemplate = $templateCache.get('actions/send-email-modal');

                    var modalContent = $compile(modalTemplate)(scope);
                    $('body').append(modalContent);

                    $rootScope.$on('activateErr_' + scope.connections.id, function (evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function (evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('errEngagement_' + scope.connections.id, function (evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;

                        $timeout(function () {
                            scope.displayErrorBlink = false;
                        }, 5000);
                    });

                    $rootScope.$on('saveActionSendEmailData' + scope.connections.id, function (evt, conn) {
                        scope.connections = angular.copy(conn);
                        scope.saveData();
                    });

                    $rootScope.$on('saveActionSendEmail' + scope.connections.id, function (evt, conn) {
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    $rootScope.$on('displayModalSendEmail' + scope.connections.id, function () {
                        scope.displayModal();
                    });

                    $rootScope.$on('updateSendEmailConn' + scope.connections.id, function (evt, conn, selectedView) {
                        scope.connections = angular.copy(conn);
                        angular.extend(scope, { selectedView: selectedView });
                    });

                    if (!scope.connections.isDummy) {
                        scope.save();
                    }

                    if (scope.connections && scope.connections.children && scope.connections.children.length) {
                        $timeout(function () {
                            scope.disAllowDrag = helpers.validateDragging(scope.connections);
                        }, 1000);
                    } else if (scope.connections && !scope.connections.children) {
                        scope.disAllowDrag = true;
                    }

                    scope.isElegibleForUpdate = false;
                    scope.saveData(true);
                }

                // when the directive is clicked
                $(elem).click(function (evt) {
                    //getting the inital positon to not move the email list modal
                    $rootScope.nodeVerticalPos = evt;

                    var canvasEl = document.querySelector(".canvas"),
                        modalTop = canvasEl.offsetTop * -1 + 100;

                    if ($rootScope.isFireFox) {
                        modalTop = modalTop - 70;
                    }

                    scope.modalLeft = canvasEl.offsetLeft * -1 + (window.innerWidth / 2 - 475);
                    scope.modalTop = modalTop;
                    scope.emailListLoader = false;

                    //load template
                    var template = $templateCache.get('actions/send-email'),
                        modalTemplate = $templateCache.get('actions/send-email-modal'),
                        now = new Date(),
                        lastElemId = plumbService.getLastElemClicked(),
                        lastElement = helpers.getConnectionById(lastElemId);

                    // start connection obj
                    scope.connections = {
                        id: 'element_' + now.getTime(),
                        top: lastElement.type == 'RectangleConnection' ? lastElement.top - 43 : lastElement.top,
                        left: lastElement.left + 250,
                        type: 'Action',
                        emailData: {
                            EmailName: '',
                            FromEmail: '',
                            FromName: '',
                            GoogleAnalyticsCampaign: '',
                            PermissionReminderMessage: scope.translate('canvas.action.sendEmail.permisionReminder1') + $rootScope.cSettings.ClientCompany + scope.translate('canvas.action.sendEmail.permisionReminder2'),
                            ReplyEmail: '',
                            Subject: '',
                            TemplateContent: '',
                            InboxPreviewText: '',
                            ToListId: 0,
                            ToListName: '',
                            WebpageVersion: true
                        },
                        data: {
                            pageTextTextareas: false,
                            googleAnalyticsAllUrl: false,
                            editorType: '',
                            permisionReminder: true
                        },
                        elemClass: attr.$attr,
                        elemName: 'SendMail',
                        parent: lastElement.id,
                        //Triger: #4F4FC9 // Action: #B21877 // Condition: #FF7F57
                        color: '#B21877'
                    };

                    //Create template and compile it
                    scope.$apply(function () {
                        var content = $compile(template)(scope);
                        $(elem).parents('.canvas').append(content);

                        var modalContent = $compile(modalTemplate)(scope);
                        $(elem).parents('body').append(modalContent);
                    });

                    // keep track of what has been saved, for activation
                    $rootScope.unsavedData.push(scope.connections.id);

                    $rootScope.$on('activateErr_' + scope.connections.id, function (evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function (evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('errEngagement_' + scope.connections.id, function (evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;

                        $timeout(function () {
                            scope.displayErrorBlink = false;
                        }, 5000);
                    });

                    $rootScope.$on('saveUnsavedData' + scope.connections.id, function () {
                        scope.isElegibleForUpdate = false;
                        if (scope.connections.emailData.EmailName) {
                            scope.saveData();
                            scope.isElegibleForUpdate = true;
                        }
                    });

                    $rootScope.$on('saveActionSendEmailData' + scope.connections.id, function (evt, conn) {
                        scope.connections = angular.copy(conn);
                        scope.saveData();
                    });

                    $rootScope.$on('saveActionSendEmail' + scope.connections.id, function (evt, conn) {
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    $rootScope.$on('displayModalSendEmail' + scope.connections.id, function () {
                        scope.displayModal();
                    });

                    $rootScope.$on('updateSendEmailConn' + scope.connections.id, function (evt, conn, selectedView) {
                        scope.connections = angular.copy(conn);
                        angular.extend(scope, { selectedView: selectedView });
                    });

                    scope.loadEmailListAsync();
                    scope.loadTrashEmailListAsync();

                    // Listener when user cancel the send email
                    $rootScope.$on('deleteSendEmailNode' + scope.connections.id, function () {
                        scope.deleteElement();
                    });

                    // check if it comes from the editor to handle the return
                    if (scope.connections.data.emailStatus === 'fromEditor') {
                        scope.onRedirect();
                    }

                    // plumb service connect elements
                    plumbService.connectElements(lastElement, scope.connections);

                    $rootScope.$emit('closeMenus', true);
                });

                scope.setScrollLogic = function (id) {
                    scope.emailListLoader = false;
                    angular.element(document.getElementById('listEmailContainer' + id)).bind("scroll", function () {
                        if (!scope.emailListLoader && !$rootScope.stopLoadingEmailList && !scope.search.email) {
                            scope.emailListLoader = true;
                            canvasService.getEmailList($rootScope.emailListOffset, 5).success(function (data) {
                                if (!data.Results.length) {
                                    $rootScope.stopLoadingEmailList = true;
                                } else {
                                    $rootScope.emailListOffset++;
                                    $rootScope.emailData = _.uniqBy($rootScope.emailData.concat(data.Results), 'EmailTemplateId');
                                    scope.emailList = $rootScope.emailData;
                                }
                                scope.emailListLoader = false;
                            }).error(function () {
                                scope.emailListLoader = false;
                            });
                        }
                    });
                };

                scope.deleteElement = function () {
                    if ($('.modal-email-form-' + scope.connections.id).length) {
                        $('.modal-email-form-' + scope.connections.id).remove();
                    }

                    var idx = $rootScope.unsavedData.indexOf(scope.connections.id);
                    if (idx > -1) {
                        $rootScope.unsavedData.splice(idx, 1);
                    }
                    scope.displayActivateError = false;
                    scope.displayErrorBlink = false;
                    plumbService.deleteElements(scope.connections);
                    $rootScope.$emit('emailDeleted', scope.connections.id);

                    if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry') {
                        $rootScope.activePlus = true;
                    } else {
                        $rootScope.activePlus = false;
                    }
                };

                scope.deleteArrow = function () {
                    if (scope.connections.hasOwnProperty('children')) {
                        scope.hasArrow = false;
                        plumbService.deleteArrows(scope.connections);
                    }
                };
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = angular.module('add-to-list-form', [__webpack_require__(191).name]).directive('addToListForm', function () {
    return {
        restrict: 'E',
        scope: false,
        templateUrl: 'app/views/triggerPanel/add-to-list-form.tpl.html',
        controller: 'addToListFormCtrl'
    };
});

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = angular.module('add-to-segment-form', [__webpack_require__(192).name]).directive('addToSegmentForm', function () {
    return {
        restrict: 'E',
        scope: false,
        templateUrl: 'app/views/triggerPanel/add-to-segment-form.tpl.html',
        controller: 'addToSegmentFormCtrl'
    };
});

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = angular.module('date-time-form', [__webpack_require__(190).name]).directive('dateTimeForm', function () {
    return {
        restrict: 'E',
        scope: false,
        templateUrl: 'app/views/triggerPanel/date-time-form.tpl.html',
        controller: 'addDateTimeFormCtrl'
    };
});

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = angular.module('email-engagement-form', [__webpack_require__(193).name]).directive('emailEngagementForm', function () {
    return {
        restrict: 'E',
        scope: false,
        templateUrl: 'app/views/triggerPanel/email-engagement-form.tpl.html',
        controller: 'websiteEngagementCtrl'
    };
});

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = angular.module('trigger-panel-alert', []).directive('panelAlert', function () {
    return {
        restrict: 'E',
        scope: {
            isSuccess: '=',
            message: '@'
        },
        templateUrl: 'app/views/triggerPanel/panel-alert.tpl.html',
        controller: ['$rootScope', '$scope', function ($rootScope, $scope) {
            $scope.translate = $rootScope.translate;
        }]
    };
});

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    angular.module('update-field-action.dir', []).directive('updateFieldAction', ['$rootScope', '$compile', '$templateCache', 'plumbService', 'helpers', 'canvasService', 'CANVAS_OPTS', '$timeout', updateFieldAction]);

    function updateFieldAction($rootScope, $compile, $templateCache, plumbService, helpers, canvasService, CANVAS_OPTS, $timeout) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                //When we save a the form
                $scope.save = function (dummy) {
                    var check = $scope.dataFilledCorrectly();
                    $rootScope.$emit('displayActionUpdateFieldModalError', check.errors);

                    //If form data is missing
                    if (check.result === false) {
                        if ($scope.tempConn) {
                            $scope.connections = angular.copy($scope.tempConn);
                        }
                    }
                    //Else we proceed to save and create new elements
                    else {
                            if (!dummy && $scope.connections.isDummy) {
                                delete $scope.connections.isDummy;
                            }

                            //Updates the parent to register its children
                            var parentData = helpers.getConnectionById($scope.connections.parent);
                            if (parentData) {
                                parentData.children = [];
                                parentData.children.push($scope.connections.id);
                                helpers.updateConnections(parentData);
                            }
                            //Save to the global canvas object
                            helpers.updateConnections($scope.connections);

                            if (!$scope.connections.isDummy) {
                                var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                                if (index > -1) {
                                    $rootScope.unsavedData.splice(index, 1);
                                }
                            }

                            //Displays th form data
                            $scope.displayList = false;
                            $rootScope.$emit('hideActionUpdateFieldModal');
                            //Displays action menu
                            $scope.displaySubMenu = false;
                            //Hides Error
                            $scope.displayError = false;
                            $scope.errorDelay = false;
                            $scope.errorUnits = false;
                            //Save Journey to template
                            canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), $scope.isElegibleForUpdate);

                            if ($scope.isElegibleForUpdate && !dummy) {
                                $scope.wasSave = true;
                                $timeout(function () {
                                    $scope.wasSave = false;
                                }, 1500);
                            }

                            //Set Back to autoSave
                            $scope.isElegibleForUpdate = true;
                            //Remove Activate Error since its being able to save
                            $scope.displayActivateError = false;
                            $scope.displayErrorBlink = false;
                        }

                    // Listener to show or hide the delete arrow or add connection arrow
                    $rootScope.$on('showDeleteArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showDeleteArrow = condition;
                    });

                    $rootScope.$on('showConnectionArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showConnectionArrow = condition;
                    });
                };

                // validates if data is filled correctly or not
                $scope.dataFilledCorrectly = function () {
                    var res = true,
                        errorList = [];

                    $scope.connections.data.fields.map(function (f, index) {
                        errorList.push({});

                        if (!f.pickedField) {
                            errorList[index].pickedField = true;
                            res = false;
                        } else {
                            errorList[index].pickedField = false;
                        }

                        if (!f.pickedList) {
                            errorList[index].pickedList = true;
                            res = false;
                        } else {
                            errorList[index].pickedList = false;
                        }
                    });

                    return {
                        result: res,
                        errors: errorList
                    };
                };

                $scope.toggleConnectionMenu = function (event) {
                    if (helpers.checkIfIsConnected(event.target.parentNode.id)) {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.602'));
                    } else {
                        if ($('#' + event.target.parentNode.id).find('.action-conditions').inlineStyle('display') === 'none') {
                            //remove the hidden style
                            $('#' + event.target.parentNode.id).find('.action-conditions').show().prev().show();
                            $scope.displaySubMenu = true;
                            $scope.displayList = false;
                            $scope.$broadcast('setMenuDefaults');
                            $rootScope.$emit('hideActionUpdateFieldModal');
                        } else {
                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1 || $scope.connections.isDummy) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.611'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayActionUpdateFieldModal', $scope.connections);
                            } else if (!$scope.dataFilledCorrectly().result) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.603'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayActionUpdateFieldModal', $scope.connections);
                            } else if ($scope.displaySubMenu === false) {
                                $scope.displaySubMenu = true;
                                $scope.displayList = false;
                                $scope.$broadcast('setMenuDefaults');
                                $rootScope.$emit('hideActionUpdateFieldModal');
                            } else {
                                $scope.displaySubMenu = false;
                                $scope.displayList = false;
                                $rootScope.$emit('hideActionUpdateFieldModal');
                            }
                        }
                    }
                };

                $scope.showTipModal = function () {
                    // displays tip modal
                    $rootScope.$emit('displayActionUpdateFieldModal', $scope.connections, true);
                };

                //Cancel Button
                $scope.cancel = function () {
                    //Hide Menu
                    $scope.displayList = false;
                    //Hide Error
                    $scope.displayError = false;

                    if ($scope.connections) {
                        var conn = helpers.getStorageConnectionById($scope.connections.id);
                        if (conn) {
                            $scope.connections.data = conn.data;
                        }
                    }
                };

                $scope.config = function (evt) {
                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left'));

                    // check if being dragged and update position
                    if (newTop !== $scope.connections.top || $scope.connections.left !== newLeft) {
                        $scope.displayList = false;
                        //update rootScope position
                        var wasUpdated = helpers.updatePos($scope.connections.id, newTop, newLeft);
                        // To check if the element has been saved or not in the rootScope
                        if (!wasUpdated) {
                            $scope.connections.top = newTop;
                            $scope.connections.left = newLeft;
                        }
                        $rootScope.$emit('hideActionUpdateFieldModal');
                        return false;
                    }
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $rootScope.$emit('displayActionUpdateFieldModal', $scope.connections);
                    } else {
                        $scope.displayList = false;
                        $rootScope.$emit('hideActionUpdateFieldModal');
                    }
                    //Hide Error
                    $scope.displayError = false;
                    $scope.displaySubMenu = false;
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displayList || $scope.displaySubMenu) {
                        $scope.cancel();
                        $scope.displaySubMenu = false;
                        $scope.contMenuConfigs = 0;
                    }
                });

                $scope.parseDescription = function () {
                    if (!$scope.connections) return;

                    var description = '';
                    var fieldCount = $scope.connections && $scope.connections.data && $scope.connections.data.fields.length;
                    if (fieldCount) {
                        if (fieldCount > 1) {
                            description = fieldCount + ' Fields';
                        } else {
                            description = $scope.connections.data.fields[0].pickedFieldName;
                        }
                    }

                    var fieldsDesc = '';
                    $scope.connections.data.fields.map(function (i) {
                        fieldsDesc += '<tr><td>' + i.pickedFieldName + '</td><td>' + i.updateTo + '</tr>';
                    });

                    $scope.descriptionTooltip = '<table class=contactUsageBreakdown-table><tbody>' + fieldsDesc + '</tbody></table>';

                    return description;
                };

                $scope.setLastElem = function (evt) {
                    plumbService.setLastElemClicked($(evt.target).parents('div.shape').attr('id'));
                };

                $rootScope.$on('generateWaitTime', function (evt, id) {
                    $rootScope.delayConns = $rootScope.delayConns || [];
                    if (!$rootScope.delayConns.includes(id) && !$scope.hasChildren(id)) {
                        $rootScope.currentDelayConn = id;
                        $rootScope.delayConns.push(id);
                        plumbService.setLastElemClicked(id);
                        $timeout(function () {
                            $('#' + id + ' li[add-wait-time-action]').click();
                        }, 0);
                    }
                });

                $scope.hasChildren = function (id) {
                    var el = helpers.getConnectionById(id);

                    return el.children && el.children.length > 0;
                };

                $scope.saveEvents = function () {
                    $rootScope.$on('saveActionUpdateFieldData' + $scope.connections.id, function (evt, conn) {
                        $scope.tempConn = angular.copy($scope.connections);
                        $scope.connections = angular.copy(conn);
                        $scope.save();
                    });
                };

                $scope.$watch('connections', function (conn) {
                    if (conn && conn.children && conn.children.length) {
                        $scope.disAllowDrag = helpers.validateDragging(conn);
                    } else if (conn && !conn.children) {
                        $scope.disAllowDrag = true;
                    }
                });
            }],
            link: function link(scope, elem, attr) {
                //Scope data initialization
                scope.displayList = true;
                scope.displayError = false;
                scope.displaySubMenu = false;
                scope.isElegibleForUpdate = true;
                scope.wasSave = false;

                //load existing
                if ($rootScope.cElement) {
                    // bullet proving multiple targets
                    if (scope.connections) {
                        if (document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    scope.connections = $rootScope.cElement;
                    delete $rootScope.cElement;
                    scope.isElegibleForUpdate = false;

                    var template = $templateCache.get('actions/update-field');

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('activateErr_' + scope.connections.id, function (evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function (evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    if (scope.connections && scope.connections.children && scope.connections.children.length) {
                        $timeout(function () {
                            scope.disAllowDrag = helpers.validateDragging(scope.connections);
                        }, 1000);
                    } else if (scope.connections && !scope.connections.children) {
                        scope.disAllowDrag = true;
                    }

                    scope.saveEvents();
                    scope.save(true);
                }

                // when a directive is clicked
                $(elem).click(function (evt) {
                    // bullet proving multiple targets
                    if (scope.connections) {
                        if (document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    $rootScope.activePlus = false;

                    if ($rootScope.currentDelayConn) {
                        scope.currentDelayConn = $rootScope.currentDelayConn;
                        delete $rootScope.currentDelayConn;
                    }

                    //Load Template
                    var template = $templateCache.get('actions/update-field'),
                        now = new Date(),
                        lastElemId = plumbService.getLastElemClicked(),
                        lastElement = helpers.getConnectionById(lastElemId);

                    //Start Connection obj
                    scope.connections = {
                        id: 'element_' + now.getTime(),
                        top: lastElement.type == 'RectangleConnection' ? lastElement.top - 43 : lastElement.top,
                        left: lastElement.left + 250,
                        type: 'Action',
                        data: { fields: [] },
                        elemClass: attr.$attr,
                        elemName: 'UpdateFields',
                        parent: lastElement.id,
                        //Triger: #4F4FC9 // Action: #B21877 // Condition: #FF7F57
                        color: '#B21877'
                    };

                    //Create template and compile it
                    scope.$apply(function () {
                        var content = $compile(template)(scope);
                        $(elem).parents('.canvas').append(content);
                    });

                    // keep track of what has been saved, for activation
                    $rootScope.unsavedData.push(scope.connections.id);

                    $rootScope.$on('activateErr_' + scope.connections.id, function (evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function (evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveUnsavedData' + scope.connections.id, function () {
                        scope.isElegibleForUpdate = false;
                        scope.save();
                        scope.isElegibleForUpdate = true;
                        if (scope.displayError) {
                            $timeout(function () {
                                scope.displayList = true;
                                $rootScope.$emit('displayActionUpdateFieldModal', scope.connections);
                            }, 250);
                        }
                    });

                    scope.saveEvents();

                    // Listener when user cancel the add the node of delay
                    $rootScope.$on('deleteUpdateFieldNode' + scope.connections.id, function () {
                        scope.deleteElement();
                    });

                    if (!scope.currentDelayConn) {
                        $rootScope.$emit('displayActionUpdateFieldModal', scope.connections);
                    } else {
                        // setting default data
                        scope.connections.data = { delay: 24, units: 'hours' };
                        scope.save();
                    }

                    //Hide hide menus
                    $rootScope.$emit('closeMenus', true);
                    scope.displayList = true;

                    plumbService.connectElements(lastElement, scope.connections);
                });

                scope.deleteElement = function () {
                    var idx = $rootScope.unsavedData.indexOf(scope.connections.id);
                    if (idx > -1) {
                        $rootScope.unsavedData.splice(idx, 1);
                    }
                    scope.displayActivateError = false;
                    scope.displayErrorBlink = false;
                    plumbService.deleteElements(scope.connections);
                    scope.connections = null;
                    scope.currentDelayConn = null;
                    $rootScope.delayConns = $rootScope.delayConns || [];
                    $rootScope.delayConns.splice(scope.currentDelayConn, 1);

                    if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry') {
                        $rootScope.activePlus = true;
                    } else {
                        $rootScope.activePlus = false;
                    }
                };

                scope.deleteArrow = function () {
                    if (scope.connections.hasOwnProperty('children')) {
                        scope.hasArrow = false;
                        plumbService.deleteArrows(scope.connections);
                    }
                };
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    angular.module('website-activity-condition.dir', ['ngclipboard']).directive('websiteActivityCondition', ['$rootScope', '$compile', '$templateCache', 'plumbService', 'helpers', 'canvasService', 'CANVAS_OPTS', '$timeout', websiteActivity]);

    function websiteActivity($rootScope, $compile, $templateCache, plumbService, helpers, canvasService, CANVAS_OPTS, $timeout) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;
                $scope.wasSave = false;

                $scope.breakUrl = function () {
                    return $scope.connections.data.specificUrl.replace(/(.{70})/g, "$1<br />");
                };

                //When we save a the form
                $scope.save = function () {
                    var trackCoach = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                    var dummy = arguments[1];

                    //If form data is missing
                    if ($scope.dataFilledCorrectly() === false) {
                        $rootScope.$emit('displayConditionWebsiteActivityModalError');
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.601'));
                        if ($scope.tempConn) {
                            $scope.connections = angular.copy($scope.tempConn);
                        }
                    }
                    //Else we proceed to save and create new elements
                    else {
                            if (!dummy && $scope.connections.isDummy) {
                                delete $scope.connections.isDummy;
                            }

                            $scope.trackingTestState = $scope.translate('canvas.entry.websiteEngagement.url.test');
                            $scope.trackingTestClass = '';

                            //Updates the parent to register its children
                            var parentData = helpers.getConnectionById($scope.connections.parent);
                            if (parentData) {
                                parentData.children = [];
                                parentData.children.push($scope.connections.id);
                                helpers.updateConnections(parentData);
                            }
                            //Save to the global canvas object
                            helpers.updateConnections($scope.connections);

                            if (!$scope.connections.isDummy) {
                                var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                                if (index > -1) {
                                    $rootScope.unsavedData.splice(index, 1);
                                }
                            }

                            //Displays th form data
                            $scope.displayList = false;
                            $rootScope.$emit('hideConditionWebsiteActivityModal');
                            //Displays action menu
                            $scope.displaySubMenu = false;
                            //Hides Error
                            $scope.displayError = false;
                            $scope.specificUrlError = false;
                            //Save Journey to template
                            canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), $scope.isElegibleForUpdate);
                            if ($scope.isElegibleForUpdate) {
                                $scope.wasSave = true;
                                $timeout(function () {
                                    $scope.wasSave = false;
                                }, 2000);
                            }
                            //Set Back to autoSave
                            $scope.isElegibleForUpdate = true;
                            //Remove Activate Error since its being able to save
                            $scope.displayActivateError = false;
                            $scope.displayErrorBlink = false;
                        }

                    // Listener to show or hide the delete arrow or add connection arrow
                    $rootScope.$on('showDeleteArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showDeleteArrow = condition;
                    });

                    $rootScope.$on('showConnectionArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showConnectionArrow = condition;
                    });
                };

                //Validates if data is filled correctly or not
                $scope.dataFilledCorrectly = function () {
                    var res = true;

                    if (!$scope.connections.data.source) {

                        $scope.displayError = true;
                        res = false;
                    }

                    if ($scope.connections.data.source !== 'any-tracked-page' && ($scope.connections.data.specificUrl === undefined || $scope.connections.data.specificUrl === '' || $scope.specificUrlError === true)) {

                        $scope.specificUrlError = true;
                        res = false;
                    }

                    if (!res) {
                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index === -1) {
                            $rootScope.unsavedData.push($scope.connections.id);
                        }
                    }

                    return res;
                };

                //Cancel Button
                $scope.cancel = function () {

                    //Hide Menu
                    $scope.displayList = false;
                    //Hide Error
                    $scope.displayError = false;

                    if ($scope.connections) {
                        var conn = helpers.getStorageConnectionById($scope.connections.id);
                        if (conn) {
                            $scope.connections.data = conn.data;
                        }
                    }
                };

                $scope.config = function (evt) {
                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left'));

                    // check if being dragged and update position
                    if (newTop !== $scope.connections.top || $scope.connections.left !== newLeft) {
                        $scope.displayList = false;
                        //update rootScope position
                        var wasUpdated = helpers.updatePos($scope.connections.id, newTop, newLeft);
                        // To check if the element has been saved or not in the rootScope
                        if (!wasUpdated) {
                            $scope.connections.top = newTop;
                            $scope.connections.left = newLeft;
                        }

                        $rootScope.$emit('hideConditionWebsiteActivityModal');

                        return false;
                    }
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $rootScope.$emit('displayConditionWebsiteActivityModal', $scope.connections);
                    } else {
                        $scope.displayList = false;
                        $scope.trackingTestState = $scope.translate('canvas.entry.websiteEngagement.url.test');
                        $scope.trackingTestClass = '';
                        $rootScope.$emit('hideConditionWebsiteActivityModal');
                    }
                    //Hide Error
                    $scope.displayError = false;
                    $scope.displaySubMenu = false;
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displayList || $scope.displaySubMenu) {
                        $scope.cancel();
                        $scope.displaySubMenu = false;
                        $scope.contMenuConfigs = 0;
                    }
                });

                $scope.setLastElem = function (evt) {
                    plumbService.setLastElemClicked($(evt.target).parents('div.shape').attr('id'));
                };

                $scope.toggleConnectionMenu = function (event) {
                    //Check if form data is filled and a connection exists as only one is allowed
                    if (helpers.checkIfIsConnected(event.target.parentNode.id)) {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.602'));
                    } else {
                        if ($('#' + event.target.parentNode.id).find('.action-conditions').inlineStyle('display') === 'none') {
                            //remove the hidden style
                            $('#' + event.target.parentNode.id).find('.action-conditions').show().prev().show();
                            $scope.displaySubMenu = true;
                            $scope.displayList = false;
                            $scope.$broadcast('setMenuDefaults');
                            $rootScope.$emit('hideConditionWebsiteActivityModal');
                        } else {
                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1 || $scope.connections.isDummy) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.611'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayConditionWebsiteActivityModal', $scope.connections);
                            } else if ($scope.dataFilledCorrectly() === false) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.603'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayConditionWebsiteActivityModal', $scope.connections);
                            } else if ($scope.displaySubMenu === false) {
                                $scope.displaySubMenu = true;
                                $scope.displayList = false;
                                $scope.$broadcast('setMenuDefaults');
                                $rootScope.$emit('hideConditionWebsiteActivityModal');
                            } else {
                                $scope.displaySubMenu = false;
                                $scope.displayList = false;
                                $rootScope.$emit('hideConditionWebsiteActivityModal');
                            }
                        }
                    }
                };

                $scope.showTipModal = function () {
                    // displays tip modal
                    $rootScope.$emit('displayConditionWebsiteActivityModal', $scope.connections, true);
                };

                $scope.parseDescription = function (desc, specificUrl) {
                    if (specificUrl) {
                        if (desc) {
                            var arrLen = desc.split("");
                            arrLen = arrLen.length;
                            if (arrLen > 15) {
                                return desc.slice(0, 15) + '...';
                            } else {
                                return desc;
                            }
                        } else if ($scope.connections.data.source === 'contains-url') {
                            return $scope.translate('canvas.entry.websiteEngagement.containsUrl');
                        } else {
                            return $scope.translate('canvas.condition.websiteActivity.specificUrl');
                        }
                    } else {
                        if (desc) {
                            desc = $scope.translate('canvas.condition.websiteActivity.anyTracked');
                        } else {
                            return $scope.translate('commons.enterDetails');
                        }
                        return desc;
                    }
                };

                $scope.$watch('connections', function (conn) {
                    if (conn && conn.children && conn.children.length) {
                        $scope.disAllowDrag = helpers.validateDragging(conn);
                    } else if (conn && !conn.children) {
                        $scope.disAllowDrag = true;
                    }
                });
            }],
            link: function link(scope, elem, attr) {
                // scope data initialization
                scope.displayError = false;
                scope.displaySubMenu = false;
                scope.displayForm = true;
                scope.token = $rootScope.getTrackerToken;
                scope.isElegibleForUpdate = true;
                scope.trackingTestState = scope.translate('canvas.entry.websiteEngagement.url.test');
                scope.trackingTestClass = '';
                // load existing
                if ($rootScope.cElement) {
                    // bullet proving multiple targets
                    if (scope.connections) {
                        if (document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    scope.connections = $rootScope.cElement;
                    delete $rootScope.cElement;
                    scope.isElegibleForUpdate = false;

                    if (scope.connections.data.specificUrl) {
                        scope.specificUrl = true;
                        scope.append = true;
                    }

                    if (!scope.token) {
                        $rootScope.$watch('getTrackerToken', function (token) {
                            if (token) {
                                scope.trackingCode = helpers.generateTrackerScript(token);
                            }
                        });
                    } else {
                        scope.trackingCode = helpers.generateTrackerScript(scope.token);
                    }

                    //Load Template
                    var template = $templateCache.get('conditions/website-activity');

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('activateErr_' + scope.connections.id, function (evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function (evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveConditionWebsiteActivityData' + scope.connections.id, function (evt, conn) {
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    if (scope.connections && scope.connections.children && scope.connections.children.length) {
                        $timeout(function () {
                            scope.disAllowDrag = helpers.validateDragging(scope.connections);
                        }, 1000);
                    } else if (scope.connections && !scope.connections.children) {
                        scope.disAllowDrag = true;
                    }

                    scope.save(false, true);
                }

                $(elem).click(function (evt) {
                    scope.trackingTestState = scope.translate('canvas.entry.websiteEngagement.url.test');
                    scope.trackingTestClass = '';

                    if (!scope.token) {
                        $rootScope.$watch('getTrackerToken', function (token) {
                            if (token) {
                                scope.trackingCode = helpers.generateTrackerScript(token);
                            }
                        });
                    } else {
                        scope.trackingCode = helpers.generateTrackerScript(scope.token);
                    }

                    $rootScope.activePlus = false;

                    //Load Template
                    var template = $templateCache.get('conditions/website-activity'),
                        now = new Date(),
                        lastElemId = plumbService.getLastElemClicked(),
                        lastElement = helpers.getConnectionById(lastElemId);

                    //Start Connection obj
                    scope.connections = {
                        id: 'element_' + now.getTime(),
                        top: lastElement.type == 'RectangleConnection' ? lastElement.top - 43 : lastElement.top,
                        left: lastElement.left + 250,
                        type: 'Condition',
                        data: { source: "any-tracked-page", specificUrl: undefined },
                        elemClass: attr.$attr,
                        elemName: 'WebActivity',
                        parent: lastElement.id,
                        //Triger: #4F4FC9 // Action: #B21877 // Condition: #FF7F57
                        color: '#FF7F57'
                    };

                    //Create template and compile it
                    scope.$apply(function () {
                        var content = $compile(template)(scope);
                        $(elem).parents('.canvas').append(content);
                    });

                    // keep track of what has been saved, for activation
                    $rootScope.unsavedData.push(scope.connections.id);

                    $rootScope.$on('activateErr_' + scope.connections.id, function (evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function (evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveUnsavedData' + scope.connections.id, function () {
                        scope.isElegibleForUpdate = false;
                        scope.save();
                        scope.isElegibleForUpdate = true;
                    });

                    //Hide hide menus
                    $rootScope.$emit('closeMenus', true);

                    plumbService.connectElements(lastElement, scope.connections);

                    scope.manualConnection = function () {
                        plumbService.manualConnection(scope.connections);
                    };

                    $rootScope.$on('saveConditionWebsiteActivityData' + scope.connections.id, function (evt, conn) {
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    // Listener when user cancel the web site activity node
                    $rootScope.$on('deleteWebSiteActivityNode' + scope.connections.id, function () {
                        scope.deleteElement();
                    });

                    $rootScope.$emit('displayConditionWebsiteActivityModal', scope.connections);
                });

                scope.deleteElement = function () {
                    var idx = $rootScope.unsavedData.indexOf(scope.connections.id);
                    if (idx > -1) {
                        $rootScope.unsavedData.splice(idx, 1);
                    }
                    scope.displayActivateError = false;
                    scope.displayErrorBlink = false;
                    plumbService.deleteElements(scope.connections);

                    if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry') {
                        $rootScope.activePlus = true;
                    } else {
                        $rootScope.activePlus = false;
                    }
                };

                scope.deleteArrow = function () {
                    if (scope.connections.hasOwnProperty('children')) {
                        scope.hasArrow = false;
                        plumbService.deleteArrows(scope.connections);
                    }
                };
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    angular.module('website-engagement.dir', ['ngclipboard']).directive('websiteEngagement', ['$rootScope', '$compile', '$templateCache', 'helpers', 'canvasService', 'CANVAS_OPTS', 'plumbService', '$timeout', '$sce', websiteEngagement]);

    //Website Engagement Directive
    function websiteEngagement($rootScope, $compile, $templateCache, helpers, canvasService, CANVAS_OPTS, plumbService, $timeout, $sce) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                //var to trigger intercom Script
                var trackIntercom = true;
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;
                $scope.wasSave = false;

                $scope.breakUrl = function () {
                    return $scope.connections.data.specificUrl.replace(/(.{70})/g, "$1<br />");
                };

                //When we save a the form
                $scope.save = function (notTrackEvent) {
                    var trackCoach = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

                    $scope.isDummyData();

                    //If form data is missing
                    if ($scope.dataFilledCorrectly() === false) {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.601'));
                        $rootScope.$emit('displayEntryEngagementModalError');
                        if ($scope.tempConn) {
                            $scope.connections = angular.copy($scope.tempConn);
                        }
                    }
                    //Else we proceed to save and create new elements
                    else {
                            $scope.isDummyData();

                            $scope.trackingTestState = $scope.translate('canvas.entry.websiteEngagement.url.test');
                            $scope.trackingTestClass = '';

                            //Intercom Tracking Event
                            if (trackIntercom && !notTrackEvent) {
                                Intercom('trackEvent', 'AP - Started with website engagement');
                                trackIntercom = false;
                            }

                            //Updates the parent to register its children
                            var parentData = helpers.getConnectionById($scope.connections.parent);
                            if (parentData) {
                                parentData.children = [];
                                parentData.children.push($scope.connections.id);
                                helpers.updateConnections(parentData);
                            }
                            //Save to the global canvas object
                            helpers.updateConnections($scope.connections);
                            //Displays th form data
                            $scope.displayList = false;
                            $rootScope.$emit('hideEntryEngagementModal');
                            //Displays action menu
                            $scope.displaySubMenu = false;
                            //Hides Error
                            $scope.displayError = false;

                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1) {
                                $rootScope.unsavedData.splice(index, 1);
                            }

                            //Save Journey to template
                            canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), $scope.isElegibleForUpdate);
                            if ($scope.isElegibleForUpdate) {
                                $scope.wasSave = true;
                                $timeout(function () {
                                    $scope.wasSave = false;
                                }, 1500);
                            }
                            //Set Back to autoSave
                            $scope.isElegibleForUpdate = true;
                            //Remove Activate Error since its being able to save
                            $scope.displayActivateError = false;
                            $scope.displayErrorBlink = false;
                        }

                    // Listener to show or hide the delete arrow or add connection arrow
                    $rootScope.$on('showDeleteArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showDeleteArrow = condition;
                    });

                    $rootScope.$on('showConnectionArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showConnectionArrow = condition;
                    });
                };

                $scope.isDummyData = function () {
                    if ($scope.connections.isDummy) {
                        if ($scope.connections.data.specificUrl !== 'http://www.yourdomain.com') {
                            delete $scope.connections.isDummy;
                        }
                    }
                };

                //Validates if data is filled correctly or not
                $scope.dataFilledCorrectly = function () {
                    var res = true;

                    if (!$scope.connections.data.source) {
                        $scope.errorInput = true;
                        res = false;
                    }

                    if (($scope.connections.data.source === 'specific-url' || $scope.connections.data.source === 'contains-url') && ($scope.connections.data.specificUrl === undefined || $scope.connections.data.specificUrl === '' || $scope.errorUrl === true || 'http://'.indexOf($scope.connections.data.specificUrl) > -1 || 'https://'.indexOf($scope.connections.data.specificUrl) > -1)) {
                        $scope.errorUrl = true;
                        res = false;
                    }

                    if (!res) {
                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index === -1) {
                            $rootScope.unsavedData.push($scope.connections.id);
                        }
                    }

                    return res;
                };

                $scope.setLastElem = function (evt) {
                    plumbService.setLastElemClicked($(evt.target).parents('div.shape').attr('id'));
                };

                $scope.menuPos = {
                    left: 440
                };
                $scope.toggleConnectionMenu = function (event) {
                    if ($rootScope.connections && $rootScope.connections.length > 1) {
                        $scope.menuPos.left = 200;
                    } else {
                        $scope.menuPos.left = 440;
                    }

                    //Check if form data is filled and a connection exists as only one is allowed
                    if (helpers.checkIfIsConnected(event.target.parentNode.id)) {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.602'));
                    } else {
                        if ($('#' + event.target.parentNode.id).find('.action-conditions').inlineStyle('display') === 'none') {
                            //remove the hidden style
                            $('#' + event.target.parentNode.id).find('.action-conditions').show().prev().show();
                            $scope.displaySubMenu = true;
                            $scope.displayList = false;
                            $rootScope.$emit('hideEntryEngagementModal');
                            $scope.$broadcast('setMenuDefaults');
                        } else {
                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.611'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayEntryEngagementModal', $scope.connections);
                            } else if ($scope.dataFilledCorrectly() === false) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.603'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayEntryEngagementModal', $scope.connections);
                            } else if ($scope.displaySubMenu === false) {
                                $scope.isElegibleForUpdate = false;
                                $scope.save(true, false);
                                $scope.displaySubMenu = true;
                                $scope.displayList = false;
                                $rootScope.$emit('hideEntryEngagementModal');
                                $scope.$broadcast('setMenuDefaults');
                            } else {
                                $scope.displaySubMenu = false;
                                $scope.displayList = false;
                                $rootScope.$emit('hideEntryEngagementModal');
                            }
                        }
                    }
                };

                $scope.config = function (evt) {
                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left'));

                    // check if being dragged and update position
                    if (newTop !== $scope.connections.top || $scope.connections.left !== newLeft) {
                        //update rootScope position
                        helpers.updatePos($scope.connections.id, newTop, newLeft);

                        $scope.connections.top = newTop;
                        $scope.connections.left = newLeft;

                        return false;
                    }
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $rootScope.$emit('displayEntryModal', 'isWebsiteEngagementFormDisplayed', $scope.connections);
                    } else {
                        $scope.trackingTestState = $scope.translate('canvas.entry.websiteEngagement.url.test');
                        $scope.trackingTestClass = '';
                    }
                    //Hide Error
                    $scope.displayError = false;
                    $scope.errorUrl = false;
                    $scope.errorInput = false;
                    $scope.displaySubMenu = false;
                };

                $scope.showTipModal = function () {
                    // displays tip modal
                    $rootScope.$emit('displayEntryEngagementModal', $scope.connections, true);
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displayList || $scope.displaySubMenu) {
                        $scope.cancel();
                        $scope.displaySubMenu = false;
                        $scope.contMenuConfigs = 0;
                    }
                });

                $scope.cancel = function () {
                    return;
                };

                $scope.parseDescription = function (desc, specificUrl) {
                    if (specificUrl) {
                        if (desc) {
                            var arrLen = desc.split("");
                            arrLen = arrLen.length;
                            if (arrLen > 15) {
                                return desc.slice(0, 15) + '...';
                            } else {
                                return desc;
                            }
                        } else if ($scope.connections.data.source === 'contains-url') {
                            return $scope.translate('canvas.entry.websiteEngagement.containsUrl');
                        } else {
                            return $scope.translate('canvas.condition.websiteActivity.specificUrl');
                        }
                    } else {
                        if (desc) {
                            desc = desc.splitCharAndUpper();
                        } else {
                            return $scope.translate('commons.enterDetails');
                        }
                    }

                    return desc;
                };

                $scope.deleteEntry = function () {
                    var idx = $rootScope.unsavedData.indexOf($scope.connections.id);
                    if (idx > -1) {
                        $rootScope.unsavedData.splice(idx, 1);
                    }

                    plumbService.deleteElements($scope.connections);
                    $scope.$emit('displayJourney', true);

                    var shapeDelete;
                    shapeDelete = angular.element(document.querySelector('#step-placeholder' + $scope.connections.id));
                    jsPlumb.detachAllConnections(shapeDelete);
                    shapeDelete.remove();

                    $rootScope.deletedEntry = true;
                };

                //Check RootScope connection to check if there is only an Entry on the Canvas.
                //We listen the saveJourneyStorage function on Canvas Service.
                $timeout(function () {
                    $rootScope.$watch('conn', function () {
                        if ($scope.connections && $scope.connections.id && document.getElementById($scope.connections.id)) {
                            if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry') {
                                setTimeout(function () {
                                    plumbService.simpleConnect($scope.connections.id, 'step-placeholder' + $scope.connections.id, 'rgba(207, 207, 218, 1)');
                                }, 100);
                            } else {
                                var arrowConn = angular.element(document.querySelector('#' + $scope.connections.id));
                                jsPlumb.detachAllConnections(arrowConn);
                            }
                        }
                    });
                }, 1000);

                $scope.$watch('connections', function (conn) {
                    if (conn && conn.children && conn.children.length) {
                        $scope.disAllowDrag = helpers.validateDragging(conn);
                    } else if (conn && !conn.children) {
                        $scope.disAllowDrag = true;
                    }
                });
            }],
            link: function link(scope, elem, attr) {
                // scope data initialization
                scope.displaySubMenu = false;
                scope.token = $rootScope.getTrackerToken;
                scope.isElegibleForUpdate = true;
                scope.trackingTestState = scope.translate('canvas.entry.websiteEngagement.url.test');
                scope.trackingTestClass = '';

                // load existing
                if ($rootScope.cElement) {
                    // bullet proving multiple targets
                    if (scope.connections) {
                        if (document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    scope.connections = $rootScope.cElement;
                    delete $rootScope.cElement;

                    //account for legacy change
                    if (scope.connections.data.source === 'anyPage') {
                        scope.connections.data.source = 'any-tracked-page';
                    }

                    if (scope.connections.data.source === 'specificUrl') {
                        scope.connections.data.source = 'specific-url';
                    }

                    // global scope data initialization
                    scope.isElegibleForUpdate = scope.connections.isElegibleForUpdate || false;
                    delete scope.connections.isElegibleForUpdate;

                    if (scope.connections.data.specificUrl) {
                        scope.specificUrl = true;
                        scope.append = true;
                    }

                    //Load Template
                    var template = angular.element($templateCache.get('entry/website-engagement'));

                    var canvasEl = angular.element(document.querySelector('.canvas'));
                    canvasEl.append(template);

                    scope.$apply(function () {
                        $compile(template)(scope);
                    });

                    $rootScope.$on('activateErr_' + scope.connections.id, function (evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function (evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveEngagementEntryData' + scope.connections.id, function (evt, conn, err) {
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.errorUrl = err;
                        scope.save();
                        scope.connections.wasSave = true;

                        $timeout(function () {
                            scope.connections.wasSave = false;
                        }, 2000);
                    });

                    if (scope.connections && scope.connections.children && scope.connections.children.length) {
                        $timeout(function () {
                            scope.disAllowDrag = helpers.validateDragging(scope.connections);
                        }, 1000);
                    } else if (scope.connections && !scope.connections.children) {
                        scope.disAllowDrag = true;
                    }

                    scope.save(true, false);
                    scope.connections.wasSave = false;

                    $timeout(function () {
                        if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry') {
                            setTimeout(function () {
                                plumbService.simpleConnect(scope.connections.id, 'step-placeholder' + scope.connections.id, 'rgba(207, 207, 218, 1)');
                            }, 100);
                        }
                    }, 200);
                    $rootScope.$emit('closeMenus', true);
                    plumbService.setInitDragConnect(scope.connections);
                }

                scope.deleteArrow = function () {
                    if (scope.connections.hasOwnProperty('children')) {
                        scope.hasArrow = false;
                        plumbService.deleteArrows(scope.connections);
                    }
                };
            }
        };
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
    __webpack_require__(244);
    __webpack_require__(219);
    __webpack_require__(241);
    __webpack_require__(240);
    __webpack_require__(215);
    __webpack_require__(216);
    __webpack_require__(218);
    __webpack_require__(222);
    __webpack_require__(220);
    __webpack_require__(217);
    __webpack_require__(233);
    __webpack_require__(214);
    __webpack_require__(231);
    __webpack_require__(228);
    __webpack_require__(226);
    __webpack_require__(227);
    __webpack_require__(223);
    __webpack_require__(225);
    __webpack_require__(221);
    __webpack_require__(224);
    __webpack_require__(239);
    __webpack_require__(230);
    __webpack_require__(197);
    __webpack_require__(196);
    __webpack_require__(198);
    __webpack_require__(201);
    __webpack_require__(200);
    __webpack_require__(202);
    __webpack_require__(199);
    __webpack_require__(207);
    __webpack_require__(205);
    __webpack_require__(206);
    __webpack_require__(209);
    __webpack_require__(203);
    __webpack_require__(208);
    __webpack_require__(204);
    __webpack_require__(213);
    __webpack_require__(210);
    __webpack_require__(212);
    __webpack_require__(211);
    __webpack_require__(229);
    __webpack_require__(232);
    __webpack_require__(245);
    __webpack_require__(195);
    __webpack_require__(243);
}();

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    'use strict';

    angular.module('ngModalDragabble', []).directive('modalDragabble', function () {
        return {
            restrict: 'A',
            scope: {},
            link: function link(scope, element) {
                $('#' + element[0].id + '.options-modal > .modal-container').draggable({
                    containment: '#' + element[0].id + '.options-modal',
                    scroll: false,
                    start: function start() {},
                    drag: function drag() {},
                    stop: function stop() {}
                });
            }
        };
    });
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//add get inline style lib
__webpack_require__(246);
//add the jquery visible lib
__webpack_require__(247);

(function () {
    'use strict';

    angular.module('ngCanvas.dir', ['drag-canvas.dir', 'website-engagement.dir', 'add-to-list-entry.dir', 'add-to-segment-entry.dir', 'date-and-time.dir', 'element-menu.dir', 'journey.canvas.srv', 'helpers.srv', 'add-wait-time-action.dir', 'update-field-action.dir', 'send-email-action.dir', 'add-to-list-action.dir', 'remove-from-list-action.dir', 'is-in-list-or-segment.dir', 'is-in-segment.dir', 'is-not-in-segment.dir', 'website-activity-condition.dir', 'email-engagement-condition.dir', 'element-menu-if-else.dir', 'if-else.dir', 'editor-menu.dir', 'facebook-audience-action.dir', 'looping-action.dir', 'active-add-wait-time-action.dir', 'active-website-engagement.dir', 'active-add-to-list-action.dir', 'active-send-email-action.dir', 'active-remove-from-list-action.dir', 'active-add-to-list-entry.dir', 'active-add-to-segment-entry.dir', 'active-date-and-time.dir', 'active-is-in-list-or-segment.dir', 'active-is-in-segment.dir', 'active-is-not-in-segment.dir', 'active-website-activity-condition.dir', 'active-email-engagement-condition.dir', 'active-rectangle-connector.dir', 'active-if-else.dir', 'active-facebook-audience.dir', 'active-update-field-action.dir', 'active-looping-action.dir', 'scroll-into.dir', __webpack_require__(234).name, __webpack_require__(235).name, __webpack_require__(237).name, __webpack_require__(236).name, __webpack_require__(238).name]).run(['canvasService', '$rootScope', '$location', preloadTemplates]).directive('ngInitJourney', ['plumbService', '$rootScope', 'helpers', 'canvasService', 'CANVAS_OPTS', '$compile', '$timeout', ngInitJourney]);

    function ngInitJourney(plumbService, $rootScope) {
        return {
            scope: false,
            controller: ['$scope', '$http', function ($scope, $http) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                $scope.newJourneyOpts = false;
                $scope.showInitJourney = false;

                //Function to Display Menu options on the Entry Section
                function onDataCompleteListEntry(response) {
                    $scope.menuEntry = response.data;
                };

                function onError(reason) {
                    $scope.error = 'Could not load the list';
                };

                $http.get("app/services/mocks/entry.json").then(onDataCompleteListEntry, onError);

                $scope.hideJourney = function () {
                    $scope.showInitJourney = false;
                    $scope.showInitStep = false;
                    $rootScope.triggeredEntry = true;
                    var arrowConn = angular.element(document.querySelector('#newAp'));
                    jsPlumb.detachAllConnections(arrowConn);
                };

                $rootScope.$on('displayJourney', function (evt, status) {
                    if ($rootScope.conn && $rootScope.conn.length > 0) {
                        $scope.showInitJourney = status;
                        $scope.showInitStep = false;
                    } else {
                        $scope.showInitJourney = status;
                        $scope.showInitStep = status;
                        setTimeout(function () {
                            if (!$rootScope.conn || $rootScope.conn.length === 0) {
                                plumbService.simpleConnect('newAp', 'initial-placeholder', 'rgba(207, 207, 218, 0.3)');
                            }
                        }, 0);
                    }
                });

                $rootScope.$watch('conn', function () {
                    if ($rootScope.currentJourneyStatus != 3 && $rootScope.currentJourneyStatus != 8 && $rootScope.currentJourneyStatus != 4) {
                        if ($rootScope.conn && ($rootScope.conn.length == 0 || $rootScope.conn[0].type !== 'Entry')) {
                            $rootScope.$emit('displayJourney', true);
                        }

                        if ($rootScope.conn && $rootScope.conn.length > 0) {
                            $scope.showInitStep = false;
                            $scope.showInitJourney = false;

                            var entry = $rootScope.conn.find(function (element) {
                                return element.type === 'Entry';
                            });

                            if (!entry) {
                                $scope.showInitJourney = true;
                                $scope.showInitStep = false;
                            }
                        }
                    }
                });

                $scope.initJourneyCont = 0;
                $scope.$on('closeConfigMenus', function () {
                    if ($scope.newJourneyOpts) {
                        if ($scope.initJourneyCont === 0) {
                            $scope.initJourneyCont = 1;
                        } else {
                            $scope.newJourneyOpts = false;
                            $scope.initJourneyCont = 0;
                        }
                    } else {
                        $scope.initJourneyCont = 0;
                    }
                });

                // Open trigger modal
                $scope.showInitialOptions = function () {
                    $rootScope.$emit('displayEntryModal');
                };
            }],
            templateUrl: 'app/views/templates/init-journey.tpl.html',
            link: function link(scope, elem, attr) {
                //Inits Plumb
                plumbService.initPlumb();
            }
        };
    }

    function preloadTemplates(canvasService, $rootScope, $location) {
        //Checking url to display Journey name Element.
        $rootScope.$on('$locationChangeStart', function () {
            //Checks if path contains canvas word in the url
            var isCanvasPath = function isCanvasPath() {
                return $location.path().indexOf('canvas') > -1;
            },
                templateList,
                i;

            if (isCanvasPath()) {
                //Template names and sub dirs
                templateList = canvasService.getTemplateList();

                //Iterate and preload all templates
                for (i = 0; i < templateList.length; i++) {
                    //Preload templates
                    canvasService.preloadTemplate(templateList[i]);
                }
            }
        });
    };
})();

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! ngclipboard - v1.1.0 - 2015-12-30
* https://github.com/sachinchoolur/ngclipboard
* Copyright (c) 2015 Sachin; Licensed MIT */
(function () {
    'use strict';

    var MODULE_NAME = 'ngclipboard';
    var angular, Clipboard;

    if (typeof module !== 'undefined' && _typeof(module.exports) === 'object') {
        angular = __webpack_require__(3);
        Clipboard = __webpack_require__(4);
        module.exports = MODULE_NAME;
    } else {
        angular = window.angular;
        Clipboard = window.Clipboard;
    }

    angular.module(MODULE_NAME, []).directive('ngclipboard', function () {
        return {
            restrict: 'A',
            scope: {
                ngclipboardSuccess: '&',
                ngclipboardError: '&'
            },
            link: function link(scope, element) {
                var clipboard = new Clipboard(element[0]);

                clipboard.on('success', function (e) {
                    scope.ngclipboardSuccess({
                        e: e
                    });
                });

                clipboard.on('error', function (e) {
                    scope.ngclipboardError({
                        e: e
                    });
                });
            }
        };
    });
})();

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

(function ($) {
    $.fn.inlineStyle = function (prop) {
        var styles = this.attr("style"),
            value;
        styles && styles.split(";").forEach(function (e) {
            var style = e.split(":");
            if ($.trim(style[0]) === prop) {
                value = style[1];
            }
        });
        return $.trim(value);
    };
})(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

(function ($) {

    /**
     * Copyright 2012, Digital Fusion
     * Licensed under the MIT license.
     * http://teamdf.com/jquery-plugins/license/
     *
     * @author Sam Sehnert
     * @desc A small plugin that checks whether elements are within
     *       the user visible viewport of a web browser.
     *       only accounts for vertical position, not horizontal.
     */
    var $w = $(window);
    $.fn.visible = function (partial, hidden, direction) {

        if (this.length < 1) return;

        var $t = this.length > 1 ? this.eq(0) : this,
            t = $t.get(0),
            vpWidth = $w.width(),
            vpHeight = $w.height(),
            direction = direction ? direction : 'both',
            clientSize = hidden === true ? t.offsetWidth * t.offsetHeight : true;

        if (typeof t.getBoundingClientRect === 'function') {

            // Use this native browser method, if available.
            var rec = t.getBoundingClientRect(),
                tViz = rec.top >= 0 && rec.top < vpHeight,
                bViz = rec.bottom > 0 && rec.bottom <= vpHeight,
                lViz = rec.left >= 0 && rec.left < vpWidth,
                rViz = rec.right > 0 && rec.right <= vpWidth,
                vVisible = partial ? tViz || bViz : tViz && bViz,
                hVisible = partial ? lViz || rViz : lViz && rViz;

            if (direction === 'both') return clientSize && vVisible && hVisible;else if (direction === 'vertical') return clientSize && vVisible;else if (direction === 'horizontal') return clientSize && hVisible;
        } else {

            var viewTop = $w.scrollTop(),
                viewBottom = viewTop + vpHeight,
                viewLeft = $w.scrollLeft(),
                viewRight = viewLeft + vpWidth,
                offset = $t.offset(),
                _top = offset.top,
                _bottom = _top + $t.height(),
                _left = offset.left,
                _right = _left + $t.width(),
                compareTop = partial === true ? _bottom : _top,
                compareBottom = partial === true ? _top : _bottom,
                compareLeft = partial === true ? _right : _left,
                compareRight = partial === true ? _left : _right;

            if (direction === 'both') return !!clientSize && compareBottom <= viewBottom && compareTop >= viewTop && compareRight <= viewRight && compareLeft >= viewLeft;else if (direction === 'vertical') return !!clientSize && compareBottom <= viewBottom && compareTop >= viewTop;else if (direction === 'horizontal') return !!clientSize && compareRight <= viewRight && compareLeft >= viewLeft;
        }
    };
})(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _package = __webpack_require__(2);

(function () {
    angular.module('JB.translate.srv', ['auth.srv']).constant('DEFAULT_LOCALE', 'english').factory('Translate', ['$q', '$http', '$rootScope', 'DEFAULT_LOCALE', translate]);

    function translate($q, $http, $rootScope, DEFAULT_LOCALE) {

        var getCookie = function getCookie(cname) {
            var name = cname + "=",
                ca = document.cookie.split(';');

            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }

                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        };

        var _getLocaleData = function _getLocaleData(locale) {
            return $http.get('app/locales/' + locale + '.json');
        };

        var _getUserLocale = function _getUserLocale() {
            var lang = getCookie('L'),
                cLang = lang.toLowerCase(),
                hasLang = ['spanish', 'english', 'chinese', 'chineset', 'german', 'japanese', 'italian', 'portuguese', 'brazil', 'french', 'indian'].indexOf(cLang);

            if (hasLang === -1) {
                cLang = 'english';
            }

            return cLang;
        };

        // return a complete directory, english extending
        var _createDirectory = function _createDirectory() {
            var userLocale = _getUserLocale(),
                localPromise = _getLocaleData(userLocale),
                basePromise = _getLocaleData('english'),
                _resolveBasePromise = function _resolveBasePromise() {
                // if there is an error load base data, so at least english displays
                basePromise.success(function (data) {
                    if ($rootScope.localStorageSupported) {
                        localStorage.setItem('dictionary-' + userLocale + '-' + _package.version, JSON.stringify(data));
                    }

                    $rootScope.directory = data;
                    $rootScope.translate = _getTranslateKey;
                });
            };

            if (userLocale !== 'english') {
                $q.all([basePromise, localPromise]).then(function (resolved) {
                    $rootScope.directory = angular.extend({}, resolved[0].data, resolved[1].data);
                    if ($rootScope.localStorageSupported) {
                        localStorage.setItem('dictionary-' + userLocale + '-' + _package.version, JSON.stringify($rootScope.directory));
                    }
                    $rootScope.translate = _getTranslateKey;
                }).catch(function () {
                    _resolveBasePromise();
                });
            } else {
                _resolveBasePromise();
            }
            return $rootScope.translatePromise = basePromise;
        };

        var _deletePastStorage = function _deletePastStorage() {
            var arr = [];

            for (var i = 0; i < localStorage.length; i++) {
                if (localStorage.key(i).indexOf('dictionary-') > -1) {
                    arr.push(localStorage.key(i));
                }
            }

            if (arr.length) {
                var temp = arr.map(function (item) {
                    return item;
                });

                for (var _i = temp.length - 1; _i >= 0; _i--) {
                    if (arr[_i].indexOf(_package.version) > -1) {
                        arr.splice(_i, 1);
                    }
                }
            }

            if (arr.length) {
                for (var _i2 = 0; _i2 < arr.length; _i2++) {
                    localStorage.removeItem(arr[_i2]);
                }
            }
        };

        var _getDirectory = function _getDirectory() {
            var userLocale = getCookie('L') || DEFAULT_LOCALE;
            var dictionary = localStorage.getItem('dictionary-' + userLocale + '-' + _package.version);

            if (!dictionary || dictionary.length < 100) {
                _createDirectory();
                _deletePastStorage();
                if (!$rootScope.translate) {
                    $rootScope.translate = function () {};
                }
            } else {
                $rootScope.directory = JSON.parse(dictionary);
                $rootScope.translate = _getTranslateKey;
            }
        };

        var _getTranslateKey = function _getTranslateKey(key) {
            return $rootScope.directory[key] || "";
        };

        // exports directory
        return {
            buildDirectory: _getDirectory
        };
    }
})();

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {

    angular.module('auth.srv', []).constant('AUTH_EVENTS', {
        loginSuccess: 'auth-login-success',
        loginFailed: 'auth-login-failed',
        logoutSuccess: 'auth-logout-success',
        sessionTimeout: 'auth-session-timeout',
        notAuthenticated: 'auth-not-authenticated',
        notAuthorized: 'auth-not-authorized',
        benchmarkLoginUrl: 'https://ui.benchmarkemail.com/gotojb',
        maintenancePage: 'https://app.benchmarkemail.com/automationpro',
        benchmarkUi: 'https://ui.benchmarkemail.com/',
        benchmarkScriptApp: 'https://scriptapp.benchmarkemail.com/',
        benchmarkScriptAppURLTemplate: 'tkn/229C5A3C-2854-41E6-AB6A-50BA3571CBF2?c=##c##&rdn=##rdn##'
    }).service('Session', ['AUTH_EVENTS', function (AUTH_EVENTS) {
        var setCookie = function setCookie(cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
            var expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + "; " + expires;
        };

        this.create = function (sessionName, sessionVal) {
            setCookie(sessionName, sessionVal);
        };

        this.destroy = function () {
            document.cookie = 'BenchmarkToken=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        };

        this.getCookie = function (cname) {
            var name = cname + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        };

        this.getTokenViaAPI = function () {
            try {
                var p = "Z12";
                var rdn = Date.now() + "" + Math.floor(Math.random() * 90000000);
                var url = AUTH_EVENTS.benchmarkScriptApp + AUTH_EVENTS.benchmarkScriptAppURLTemplate.replace('##c##', p).replace('##rdn##', rdn);
                return fetch(url, {
                    method: 'POST',
                    credentials: 'include',
                    cache: 'no-store',
                    headers: {
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        'Pragma': 'no-cache',
                        'Expires': '0'
                    }
                }).then(function (response) {
                    return response.json();
                }).then(function (data) {
                    return data[p];
                });
            } catch (ex) {
                return "";
            }
        };

        this.getClientDetailsViaAPI = function () {
            try {
                var p = "A62";
                var rdn = Date.now() + "" + Math.floor(Math.random() * 90000000);
                var url = AUTH_EVENTS.benchmarkScriptApp + AUTH_EVENTS.benchmarkScriptAppURLTemplate.replace('##c##', p).replace('##rdn##', rdn);
                return fetch(url, {
                    method: 'POST',
                    credentials: 'include',
                    cache: 'no-store',
                    headers: {
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        'Pragma': 'no-cache',
                        'Expires': '0'
                    }
                }).then(function (response) {
                    return response.json();
                }).then(function (data) {
                    return data[p];
                });
            } catch (ex) {
                return { "t": "", "c": "", "f": "", "l": "" };
            }
        };
    }]).factory('AuthSrv', ['$rootScope', 'Session', 'uiService', '$http', 'API_OPTS', '$q', auth]);

    function auth($rootScope, Session, uiService, $http, API_OPTS, $q) {
        var isAuthenticated = function isAuthenticated() {
            var token = Session.getCookie('BenchmarkToken'),
                lang = Session.getCookie('L');

            if (token) {
                $rootScope.jbToken = token;
                $rootScope.jbLang = getLangVal(lang);
                return $q.resolve(true);
            } else {
                return Session.getTokenViaAPI().then(function (apiToken) {
                    if (apiToken) {
                        $rootScope.jbToken = apiToken;
                        $rootScope.jbLang = getLangVal(lang);
                        return true;
                    }
                    return false;
                }).catch(function () {
                    return false;
                });
            }
        };

        var destroySession = function destroySession() {
            Session.destroy();
        };

        var getCurrentSession = function getCurrentSession() {
            var token = Session.getCookie('BenchmarkToken'),
                lang = Session.getCookie('L');

            if (token) {
                return $q.resolve({
                    token: token,
                    lang: lang
                });
            } else {
                return Session.getTokenViaAPI().then(function (apiToken) {
                    return {
                        token: apiToken,
                        lang: lang
                    };
                });
            }
        };

        var authUser = function authUser(token) {
            return $http.get(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_CSETTING, {
                headers: { 'Authorization': 'OAuth ' + token }
            });
        };

        function getLangVal(lang) {

            var cLang = lang.toLowerCase(),
                hasLang = ['spanish', 'english', 'chinese', 'chineset', 'german', 'japanese', 'italian', 'portuguese', 'brazil', 'french', 'indian'].indexOf(cLang);

            if (hasLang === -1) {
                cLang = 'english';
            }

            return cLang;
        }

        function getUrlParam(parameterName) {
            var result = null,
                tmp = [];
            location.search.substr(1).split("&").forEach(function (item) {
                tmp = item.split("=");
                if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
            });
            return result;
        }

        return {
            isAuthenticated: isAuthenticated,
            authUser: authUser,
            getParamUrl: getUrlParam,
            getCurrentSession: getCurrentSession,
            destroySession: destroySession,
            hasToken: function hasToken() {
                return !!Session.getCookie('BenchmarkToken');
            }
        };
    }
})();

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    angular.module('journey.canvas.srv', []).factory('canvasService', ['$rootScope', '$http', '$templateCache', 'API_OPTS', 'EDITOR_URL', '$stateParams', 'cacheService', 'helpers', 'EDITOR_NEW_URL', canvasService]).factory('plumbService', ['canvasService', 'helpers', '$rootScope', plumbService]).factory('uiService', ['$http', 'API_OPTS', uiService]).factory('cacheService', ['$rootScope', cacheSetter]).factory('signalSrv', ['HUB', signalRHub]).constant('HUB', {
        URL: calcAProHubUrl(),
        NAME: 'download',
        EVENT: 'downloadPdf'
    }).constant('CANVAS_OPTS', { canvasOptions: { top: 12020, left: 12020, updatePos: 12400 } }).constant('API_OPTS', {
        API_BASE_UI_URL: 'http://api.benchmarkemail.com/1.0/',
        API_FEEDBACK: 'https://script.google.com/a/benchmarkemail.com/macros/s/AKfycbzV0is9krj7yu9cngz3vaLvbVwrcLlcGg3wUCaY4gQNDcntsaUG/exec',
        API_BENCHMARK_REST: 'https://restapi.benchmarkemail.com/',
        API_INTEGRATIONS: calcIntegrationsApiUrl(),
        API_BASE_URL: calcAProApiUrl(),
        API_VERSION: 'api/v1/',
        API_VERSION_2: 'api/v2/',
        API_VERSION_3: 'api/v3/',
        API_VERSION_4: 'api/v4/',
        API_CONTACT_LIST: 'lists/',
        API_CONTACT_LIST_CREATE: 'lists/create',
        API_SEGMENT_LIST: 'segment/',
        API_ACTIVE_EMAILS: 'activated/',
        API_SUMMARY: 'reports/reports/summary/',
        API_EMAILS: 'emails/',
        API_EMAILS_USERS: 'emails/user/',
        API_DUPLICATE_EMAILS: 'validateemailname/',
        API_DUPLICATE_EMAIL_VALID: 'emails/duplicatevalidname/',
        API_SEGMENTS: 'segments/',
        API_TEMPLATE: 'journeytemplate/',
        API_EDITOR_GET_PERMANENT_TOKEN: 'editor/permanenttoken/',
        API_DUPLICATE_EMAIL: 'emails/duplicate/',
        API_DUPLICATE_ACTIVATE_EMAIL: 'activated/emails/duplicate/',
        API_GET_TOKEN: 'token/gettoken',
        API_ACTIVATE_JOURNEY: 'activate/',
        API_BLOCK_JOURNEY: 'block/',
        API_SUMMARY_EMAIL: 'reports/reports/summary/',
        API_SAVE_STATS: 'reports/export/summary/',
        API_ALL_SUMMARY_EMAIL: 'reports/emails/summary/',
        API_CSETTING: 'client/settings',
        API_SEARCH_LIST: 'list',
        API_SEARCH_SEGMENT: 'segment',
        API_SEARCH_EMAIL: 'emails/search',
        API_TRACKER_TESTED: 'tracker/tested',
        API_CLIENT_SETTINGS: 'Client/Setting',
        API_CLIENT_NOTIFICATIONS: 'Client/Notification?status=1',
        API_UPDATE_ACTIVATED: 'activated/update/',
        API_NODE_DETAILS: 'journey/:journeyId/node/element/:elementId',
        API_NODE_METRIC_DETAILS_GROUP: 'journey/:journeyId/node/:nodeId/metric/summary?nodeType={nodeType}',
        API_METRIC_DETAILS_SUMMARY_BY_TYPE: 'journey/:journeyId/node/:nodeId/metric?metricType={metricType}&page={page}&size={size}&filter={filter}'
    }).constant('EDITOR_URL', 'https://jb-edit.benchmarkemail.com/editor/').constant('EDITOR_NEW_URL', 'https://ui.benchmarkemail.com/AP/').run(['$q', '$rootScope', 'canvasService', '$location', preBuildServices]);

    function canvasService($rootScope, $http, $templateCache, API_OPTS, EDITOR_URL, $stateParams, cacheService, helpers, EDITOR_NEW_URL) {
        //Returns the list of templates
        var getTemplateList = function getTemplateList() {
            return ["actions/add-to-list", "actions/facebook-audience", "actions/add-wait-time", "actions/remove-from-list", "actions/remove-from-segment", "actions/update-field", "actions/send-email", "actions/send-email-modal", "actions/looping", "entry/added-to-list", "entry/added-to-segment", "entry/date-and-time", "entry/website-engagement", "conditions/is-on-list-or-segment", "conditions/is-in-segment", "conditions/is-not-in-segment", "conditions/website-activity", "conditions/email-engagement", "conditions/options/if-else", "elements-menu-if-else", "active_templates/entries/active-website-engagement", "active_templates/entries/active-added-to-list", "active_templates/entries/active-added-to-segment", "active_templates/entries/active-date-and-time", "active_templates/actions/active-add-wait-time", "active_templates/actions/active-add-to-list", "active_templates/actions/active-send-email", "active_templates/actions/active-send-email-modal", "active_templates/actions/active-remove-from-list", "active_templates/actions/active-facebook-audience", "active_templates/actions/active-update-field", "active_templates/actions/active-looping", "active_templates/actions/modal-active-facebook-audience", "active_templates/actions/modal-active-add-wait-time", "active_templates/conditions/active-is-on-list-or-segment", "active_templates/conditions/active-in-segment-condition", "active_templates/conditions/active-not-in-segment", "active_templates/conditions/active-website-activity", "active_templates/conditions/active-email-engagement", "active_templates/conditions/active-rectangle-connector", "active_templates/conditions/active-if-else", "active_templates/entries/modal-active-added-to-list", "active_templates/entries/modal-active-added-to-segment", "active_templates/entries/modal-active-website-engagement", "active_templates/entries/modal-active-date-and-time"];
        };

        //Preloads templates to the dom
        var preloadTemplate = function preloadTemplate(tplName) {
            $http.get('app/views/templates/' + tplName + '.tpl.html').success(function (data) {
                $templateCache.put(tplName, data);
            });
        };

        //Preloads templates to the dom
        var preloadDefaultJourneys = function preloadDefaultJourneys(tplName) {
            return $http.get('app/services/mocks/defaultTemplate' + tplName + '.json');
        };

        //Returns journey promise
        var getJourney = function getJourney(journeyId) {
            return $http.get(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'journeys/' + journeyId, {
                headers: { Authorization: 'OAuth ' + $rootScope.jbToken }
            });
        };

        //Returns promise of paginate journeys
        var getPaginateJourneys = function getPaginateJourneys(limit, offset) {
            return $http.get(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'getalljourneys/' + limit, {
                headers: {
                    'Authorization': 'OAuth ' + $rootScope.jbToken,
                    'Offset': offset
                }
            });
        };

        //Returns promise of paginate templates
        var getPaginateTemplates = function getPaginateTemplates(limit, offset) {
            return $http.get(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'journeytemplate/alltemplates/' + limit, {
                headers: {
                    'Authorization': 'OAuth ' + $rootScope.jbToken,
                    'Offset': offset
                }
            });
        };

        // returns value true or false if the email isUniqueName
        var validateDuplicateEmailName = function validateDuplicateEmailName(emailName) {
            var data = { EmailName: emailName };

            return $http.post(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_DUPLICATE_EMAILS, data, {
                headers: {
                    'Authorization': 'OAuth ' + $rootScope.jbToken
                }
            });
        };

        //Returns value true or false if the email isUniqueName
        var duplicateEmailValidName = function duplicateEmailValidName(emailId, emailName) {
            var status = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
            var journeyId = arguments[3];

            var data = { EmailName: emailName },
                url = status === 3 || status === 4 ? API_OPTS.API_BASE_URL + API_OPTS.API_VERSION_2 + API_OPTS.API_DUPLICATE_EMAIL_VALID : API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_DUPLICATE_EMAIL_VALID;
            if (status === 3 || status === 4) {
                data.JourneyId = journeyId;
            }

            return $http.post(url + emailId, data, {
                headers: { 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        //Create Journey
        var createJourney = function createJourney(name, payload) {
            cacheService.deleteCachable();

            var data = {
                JourneyTitle: name,
                JourneyConfiguration: payload
            };

            return $http.post(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'journeys', data, {
                headers: { 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        //Create Journey
        var journeyName = function journeyName(name) {
            cacheService.deleteCachable();

            var data = {
                JourneyTitle: name
            };

            return $http.post(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'journeyname', data, {
                headers: { 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        //Update Journey
        var updateJourney = function updateJourney(payload, jbId) {
            var jbSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

            cacheService.deleteCachable();
            var url = jbSize < 40 ? API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'journeys/' + jbId : API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'journeys/' + jbId,
                settings = {
                url: url,
                method: 'PUT',
                headers: {
                    'content-type': 'application/json',
                    'Authorization': 'OAuth ' + $rootScope.jbToken
                },
                data: JSON.stringify(payload)
            };

            return $.ajax(settings);
        };
        //End update Journey

        var deleteTemplate = function deleteTemplate(templatesId) {
            var cId = $rootScope.jbClient;

            var payload = {
                "ClientId": cId,
                "TemplateIds": templatesId
            };

            return $.ajax({
                url: API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'journeytemplatemultiple/',
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'OAuth ' + $rootScope.jbToken
                },
                data: JSON.stringify(payload)
            });
        };

        //Create Journey Template
        var createJourneyTemplate = function createJourneyTemplate(title, name, description, payload) {
            var data = {
                JourneyTitle: title,
                JourneyName: name,
                JourneyDescription: description,
                JourneyConfiguration: payload
            };

            return $http.post(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_TEMPLATE, data, {
                headers: {
                    'content-type': 'application/json',
                    'Authorization': 'OAuth ' + $rootScope.jbToken
                }
            });
        };
        //End create Journey Template

        //Saves the current journey to local storage
        var saveJourneyStorage = function saveJourneyStorage(id, data, updateToDb) {
            if (updateToDb) {
                var updatedPosData = helpers.updateAllPos(JSON.parse(data));
                _saveProgress(JSON.stringify(updatedPosData), $stateParams.canvasId);
            }
            if (typeof Storage !== "undefined") {
                //var for checking connection when change on canvas controller
                if (data) {
                    $rootScope.conn = JSON.parse(data);
                }
                //
                return $rootScope.localStorageSupported ? localStorage.setItem(id, data) : [];
            } else {
                return { 'noStorage': true };
            }
        };

        var _saveProgress = function _saveProgress(data, id) {
            var jbTitle = $rootScope.currentJBTitle || 'Journey Name',
                payload = {
                JourneyTitle: jbTitle,
                JourneyConfiguration: data
            };

            updateJourney(payload, id).success(function (res) {/*data saved, no action needed*/});
        };

        //Get journey from local storage
        var getJourneyStorage = function getJourneyStorage(id) {
            if (typeof Storage !== "undefined") {
                return JSON.parse(localStorage.getItem(id));
            } else {
                return { 'noStorage': true };
            }
        };

        //Remove journey storage
        var removeJourneyStorage = function removeJourneyStorage(id) {
            if (typeof Storage !== "undefined") {
                return JSON.parse(localStorage.removeItem(id));
            } else {
                return { 'noStorage': true };
            }
        };

        var journeyStorageExists = function journeyStorageExists(id) {
            if (this.getJourneyStorage(id)) {
                return true;
            } else {
                return false;
            }
        };

        var getInitIfElseModel = function getInitIfElseModel(val) {
            var conditionModel = {
                'inList': {
                    'class': 'select-list',
                    'label': 'Select a List',
                    'selectedAction': 'inList',
                    'selectedOpt': [],
                    'type': 'list',
                    'condition': 'and',
                    'hasError': false
                },
                'notInList': {
                    'class': 'select-list',
                    'label': 'Select a List Not',
                    'selectedAction': 'notInList',
                    'selectedOpt': [],
                    'type': 'list',
                    'condition': 'and',
                    'hasError': false
                },
                'inSegment': {
                    'class': 'select-list',
                    'label': 'Select a List',
                    'selectedAction': 'inSegment',
                    'selectedOpt': [],
                    'type': 'list',
                    'condition': 'and',
                    'hasError': false
                },
                'notInSegment': {
                    'class': 'select-list',
                    'label': 'Select a List Not',
                    'selectedAction': 'notInSegment',
                    'selectedOpt': [],
                    'type': 'list',
                    'condition': 'and',
                    'hasError': false
                },
                'hasOpenedEmail': {
                    'class': 'select-list',
                    'label': 'Select an option',
                    'selectedAction': 'hasOpenedEmail',
                    'selectedOpt': [],
                    'type': 'email',
                    'condition': 'and',
                    'hasError': false
                },
                'hasNotOpenedEmail': {
                    'class': 'select-list',
                    'label': 'Select an option',
                    'selectedAction': 'hasNotOpenedEmail',
                    'selectedOpt': [],
                    'type': 'email',
                    'condition': 'and',
                    'hasError': false
                },
                'hasClickedALink': {
                    'class': 'select-list',
                    'label': 'Select an option',
                    'selectedAction': 'hasClickedALink',
                    'selectedOpt': [],
                    'type': 'link',
                    'condition': 'and',
                    'hasError': false
                },
                'hasNotClickedALink': {
                    'class': 'select-list',
                    'label': 'Select an option',
                    'selectedAction': 'hasNotClickedALink',
                    'selectedOpt': [],
                    'type': 'link',
                    'condition': 'and',
                    'hasError': false
                },
                'hasVisitedAnyWebsite': {
                    'class': 'select-list',
                    'label': 'Select an option',
                    'selectedAction': 'hasVisitedAnyWebsite',
                    'selectedOpt': [],
                    'type': 'visited',
                    'condition': 'and',
                    'hasError': false
                },
                'hasNotVisitedAnyWebsite': {
                    'class': 'select-list',
                    'label': 'Select an option',
                    'selectedAction': 'hasNotVisitedAnyWebsite',
                    'selectedOpt': [],
                    'type': 'visited',
                    'condition': 'and',
                    'hasError': false
                },
                'hasVisitedUrl': {
                    'class': 'select-list',
                    'label': 'Select an option',
                    'selectedAction': 'hasVisitedUrl',
                    'selectedOpt': [],
                    'type': 'url',
                    'condition': 'and',
                    'hasError': false
                },
                'hasNotVisitedUrl': {
                    'class': 'select-list',
                    'label': 'Select an option',
                    'selectedAction': 'hasNotVisitedUrl',
                    'selectedOpt': [],
                    'type': 'url',
                    'condition': 'and',
                    'hasError': false
                }
            };

            return conditionModel[val];
        };

        var getActionIfElseList = function getActionIfElseList(type) {
            var list = {
                'action': {
                    inSegment: $rootScope.translate('canvas.journey.isInSegment'),
                    notInSegment: $rootScope.translate('canvas.journey.isNotInSegment'),
                    inList: $rootScope.translate('canvas.condition.ifElse.inList'),
                    notInList: $rootScope.translate('canvas.condition.ifElse.notInList'),
                    hasOpenedEmail: $rootScope.translate('canvas.condition.ifElse.hasOpenEmail'),
                    hasNotOpenedEmail: $rootScope.translate('canvas.condition.ifElse.hasNotOpenEmail'),
                    hasClickedALink: $rootScope.translate('canvas.condition.ifElse.hasClickedLink'),
                    hasNotClickedALink: $rootScope.translate('canvas.condition.ifElse.hasNotClickedLink'),
                    hasVisitedUrl: $rootScope.translate('canvas.condition.ifElse.hasVisitedUrl'),
                    hasNotVisitedUrl: $rootScope.translate('canvas.condition.ifElse.hasNotVisitedUrl')
                },
                'contact-details': {},
                'date-and-time': {}

            };

            return list[type];
        };

        var getContactList = function getContactList(offset, limit) {
            return $http.get(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_CONTACT_LIST + offset + '/' + limit, {
                headers: { 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        var searchContactList = function searchContactList(search) {
            var data = JSON.stringify({ PageNumber: 0, PageSize: 50, Name: search });
            return $http.post('' + API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_SEARCH_LIST, data, {
                headers: { 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        var searchContactSegment = function searchContactSegment(search) {
            var data = JSON.stringify({ PageNumber: 0, PageSize: 50, Name: search });
            return $http.post('' + API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_SEARCH_SEGMENT, data, {
                headers: { 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        var searchEmails = function searchEmails(search) {
            var data = JSON.stringify({ PageNumber: 0, PageSize: 50, Name: search });
            return $http.post('' + API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_SEARCH_EMAIL, data, {
                headers: { 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        var createContactList = function createContactList(listName) {
            var data = JSON.stringify({ "ListName": listName });
            return $http.post(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_CONTACT_LIST_CREATE, data, {
                headers: { 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        var getSegments = function getSegments(offset, limit) {
            return $http.get(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_SEGMENT_LIST + offset + '/' + limit, {
                headers: { 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        var getSegmentsById = function getSegmentsById(segments) {
            var data = JSON.stringify({ "Segments": segments });
            return $http.post(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_SEGMENTS, data, {
                headers: { 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        var getLists = function getLists(lists) {
            var data = JSON.stringify({ "Lists": lists });
            return $http.post(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_CONTACT_LIST, data, {
                headers: { 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        var getEmailList = function getEmailList(offset, limit) {
            return $http.get(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_EMAILS + offset + '/' + limit, {
                headers: { 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        var getEmailDetails = function getEmailDetails(eid) {
            return $http.get(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION_2 + API_OPTS.API_EMAILS + eid, {
                headers: { 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        var getUserEmailAddress = function getUserEmailAddress() {
            return $http.get(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_EMAILS_USERS, {
                headers: { 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        var createEmail = function createEmail(data) {
            return $http.post(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_EMAILS, data, {
                headers: { 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        var updateEmailData = function updateEmailData(eid, data) {
            var settings = {
                'url': API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_EMAILS + eid,
                'method': 'PUT',
                'headers': {
                    'content-type': 'application/json',
                    'Authorization': 'OAuth ' + $rootScope.jbToken
                },
                'data': JSON.stringify(data)
            };
            return $.ajax(settings);
        };

        var duplicateEmail = function duplicateEmail(eId, eName, mergeTags) {
            var prom = void 0;

            if (mergeTags.length) {
                prom = $http.post(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION_2 + API_OPTS.API_DUPLICATE_EMAIL + eId, { EmailName: eName, ListId: mergeTags[0].id }, {
                    headers: { 'Authorization': 'OAuth ' + $rootScope.jbToken }
                });
            } else {
                prom = $http.post(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_DUPLICATE_EMAIL + eId, { EmailName: eName }, {
                    headers: { 'Authorization': 'OAuth ' + $rootScope.jbToken }
                });
            }

            return prom;
        };

        var redirectToEditor = function redirectToEditor(editor, emailId, jbId) {
            var redirectUrl = AP.Flags.newEditor ? EDITOR_NEW_URL : EDITOR_URL;
            switch (editor) {
                case '400':
                    // dad
                    redirectUrl += AP.Flags.newEditor ? 'EmailEditor' : 'c.html';
                    break;
                case '402':
                    // html
                    redirectUrl += AP.Flags.newEditor ? 'EmailCustom' : 'b.html';
                    break;
                case '401':
                    // text
                    redirectUrl += AP.Flags.newEditor ? 'EmailText' : 'a.html';
                    break;
                default:
                    redirectUrl += AP.Flags.newEditor ? 'EmailText' : 'a.html';
            }

            redirectUrl += !AP.Flags.newEditor ? '?eid=' + emailId : '?e=' + emailId;
            redirectUrl += !AP.Flags.newEditor ? '&token=' + $rootScope.jbToken : '';
            redirectUrl += '&redirect=' + encodeURIComponent(window.location.origin + '/#/canvas/' + jbId + '/' + emailId);
            window.location = redirectUrl;
            return;
        };

        var getVersionByType = function getVersionByType(type) {
            var resType;
            switch (type) {
                case 'dad':
                    resType = '400';
                    break;
                case 'html':
                    resType = '402';
                    break;
                case 'text':
                    resType = '401';
                    break;
                default:
                    resType = '401';
            }
            return resType;
        };

        var getTrackerToken = function getTrackerToken() {
            return $http.post(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_GET_TOKEN, { UserToken: $rootScope.jbToken }, { headers: { 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        var activateJourney = function activateJourney(jbId) {
            cacheService.deleteCachable();

            return $http.get(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_ACTIVATE_JOURNEY + jbId, {
                headers: { 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        //Unknow = 0,Draft = 1,New = 2,Active = 3,Deactivated = 4,Paused = 5,Deleted = 6
        var setJourneyStatus = function setJourneyStatus(jbId, status) {
            cacheService.deleteCachable();

            return $http.post(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'journeys/' + jbId + '/' + status, {}, {
                headers: { 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        // block status 1: block, 0: unblock
        var blockJourney = function blockJourney(jbId, status) {
            cacheService.deleteCachable();
            return $http.get('' + API_OPTS.API_BASE_URL + API_OPTS.API_VERSION_2 + 'journeys/' + API_OPTS.API_BLOCK_JOURNEY + jbId + '/' + status, {
                headers: { 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        var saveStatsAsLists = function saveStatsAsLists(payload) {
            return $http.post('' + API_OPTS.API_BASE_URL + API_OPTS.API_VERSION_2 + API_OPTS.API_SAVE_STATS, payload, {
                headers: {
                    'Authorization': 'OAuth ' + $rootScope.jbToken,
                    'Content-Type': 'application/json'
                }
            });
        };

        var getCoach = function getCoach(id) {
            return $http.get('' + API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'coach/' + id, {
                headers: { 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        var saveCoach = function saveCoach(id, data, status) {
            var payload = {
                JourneyVersion: 1,
                Parameters: JSON.stringify(data),
                JourneyId: id,
                EnableCoach: status
            };

            return $http.post('' + API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'coach', payload, {
                headers: {
                    'Authorization': 'OAuth ' + $rootScope.jbToken,
                    'Content-Type': 'application/json'
                }
            });
        };

        var sendFeedback = function sendFeedback(payload) {
            return $http({
                url: API_OPTS.API_FEEDBACK,
                dataType: 'json',
                method: "GET",
                params: payload
            });
        };

        var getResponsiveInfo = function getResponsiveInfo() {
            return $http.get(API_OPTS.API_BENCHMARK_REST + 'Client/Responsive', {
                headers: { 'AuthToken': $rootScope.jbToken }
            });
        };

        var getSmartSendingInfo = function getSmartSendingInfo() {
            return $http.get(API_OPTS.API_BENCHMARK_REST + 'Client/SSEnabled', {
                headers: { 'AuthToken': $rootScope.jbToken }
            });
        };

        var getClientInfo = function getClientInfo() {
            return $http.get(API_OPTS.API_BENCHMARK_REST + 'Client', {
                headers: { 'AuthToken': $rootScope.jbToken }
            });
        };

        var getPlanInfo = function getPlanInfo() {
            return $http.get(API_OPTS.API_BENCHMARK_REST + 'Client/Plan', {
                headers: { 'AuthToken': $rootScope.jbToken }
            });
        };

        var getDownloadInfo = function getDownloadInfo(emailId, reportType) {
            return $http.get(API_OPTS.API_BENCHMARK_REST + 'Emails/' + emailId + '/' + reportType + '/Report/Download', {
                headers: { 'AuthToken': $rootScope.jbToken }
            });
        };

        var downloadFile = function downloadFile(emailId, reportType, payload) {
            return $http.post(API_OPTS.API_BENCHMARK_REST + 'Emails/' + emailId + '/' + reportType + '/Report/Download', payload, {
                headers: { 'AuthToken': $rootScope.jbToken }
            });
        };

        var emailPin = function emailPin(emailId) {
            return $http.post(API_OPTS.API_BENCHMARK_REST + 'Emails/' + emailId + '/' + reportType + '/Report/Download', payload, {
                headers: { 'AuthToken': $rootScope.jbToken }
            });
        };

        var getReportByType = function getReportByType(emailId, type) {
            var sort = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'desc';
            var pageNum = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
            var pageSize = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 10;
            return $http.get(API_OPTS.API_BENCHMARK_REST + 'Emails/' + emailId + '/Report/' + type + '?Filter=&PageNumber=' + pageNum + '&PageSize=' + pageSize + '&Status=&OrderBy=date&SortOrder=' + sort, {
                headers: { 'AuthToken': $rootScope.jbToken }
            });
        };

        var getPreview = function getPreview(emailId) {
            return $http.get(API_OPTS.API_BENCHMARK_REST + 'Emails/' + emailId + '/Preview', {
                headers: { 'AuthToken': $rootScope.jbToken }
            });
        };

        var searchAutomations = function searchAutomations(search, status) {
            var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

            var data = JSON.stringify({ JourneyTitle: search, Status: status });
            return $http.post('' + API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'journeys/filter/50', data, {
                headers: { 'Authorization': 'OAuth ' + $rootScope.jbToken, Offset: offset }
            });
        };

        var getActiveEmails = function getActiveEmails(elementId, journeyId) {
            var url = '' + API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_ACTIVE_EMAILS + API_OPTS.API_EMAILS + elementId,
                payload = { JourneyId: journeyId, JourneyVersion: 1 };

            return $http.post(url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'OAuth ' + $rootScope.jbToken
                }
            });
        };

        // Create draft email endpoint
        var createDraftEmail = function createDraftEmail(payload) {
            var url = '' + API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_ACTIVE_EMAILS + API_OPTS.API_EMAILS;

            return $http.post(url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'OAuth ' + $rootScope.jbToken
                }
            });
        };

        // Create duplicate activated email endpoint
        var createDuplicateActivated = function createDuplicateActivated(payload, emailId) {
            var url = '' + API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_DUPLICATE_ACTIVATE_EMAIL + emailId;

            return $http.post(url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'OAuth ' + $rootScope.jbToken
                }
            });
        };

        // Active draft email endpoint
        var activeDraftEmail = function activeDraftEmail(payload, vertsion) {
            var url = '' + API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_ACTIVE_EMAILS + API_OPTS.API_EMAILS + API_OPTS.API_ACTIVATE_JOURNEY + vertsion;

            return $http.post(url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'OAuth ' + $rootScope.jbToken
                }
            });
        };

        var testTracker = function testTracker(testUrl) {
            var url = '' + API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_TRACKER_TESTED;

            return $http.post(url, JSON.stringify({
                SiteUrl: testUrl
            }), {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'OAuth 4B6AA6FB-73AC-44CF-B4E3-BC96BD1A3024'
                }
            });
        };

        // Delete draft email endpoint
        var deleteDraftEmail = function deleteDraftEmail(payload, vertsion) {
            var url = '' + API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_ACTIVE_EMAILS + API_OPTS.API_EMAILS + vertsion;

            return $http.delete(url, {
                data: payload,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'OAuth ' + $rootScope.jbToken
                }
            });
        };
        // Get url links
        var emailUrls = function emailUrls(elId) {
            return $http.get(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'emails/urls/' + elId, {
                headers: { 'Content-Type': 'application/json', 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        // get all connections
        var getConnections = function getConnections() {
            return $http.get(API_OPTS.API_INTEGRATIONS + 'connect/test/FacebookAudiance', {
                headers: { 'Content-Type': 'application/json', 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        // get audiences
        var getAudiences = function getAudiences() {
            return $http.get(API_OPTS.API_INTEGRATIONS + 'configuration/Facebook/Audiance/', {
                headers: { 'Content-Type': 'application/json', 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        // connect fb
        var fbConnect = function fbConnect(redirectUrl) {
            return $http.get(API_OPTS.API_INTEGRATIONS + 'connect/facebookaudiance', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'OAuth ' + $rootScope.jbToken,
                    'Redirect': redirectUrl
                }
            });
        };

        // disconnect fb
        var fbDisconnect = function fbDisconnect(redirectUrl) {
            return $http.get(API_OPTS.API_INTEGRATIONS + 'disconnect/FacebookAudiance/', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'OAuth ' + $rootScope.jbToken,
                    'Redirect': redirectUrl
                }
            });
        };

        // Get client settings
        var getClientSettings = function getClientSettings() {
            return $http.get(API_OPTS.API_BENCHMARK_REST + API_OPTS.API_CLIENT_SETTINGS, {
                headers: { 'Content-Type': 'application/json', 'AuthToken': $rootScope.jbToken }
            });
        };

        // Get client settings
        var getNotificationBadge = function getNotificationBadge() {
            return $http.get(API_OPTS.API_BENCHMARK_REST + API_OPTS.API_CLIENT_NOTIFICATIONS, {
                headers: { 'Content-Type': 'application/json', 'AuthToken': $rootScope.jbToken }
            });
        };

        var updateActivatedNodes = function updateActivatedNodes(payload) {
            var url = '' + API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_UPDATE_ACTIVATED + payload.JourneyId;

            return $http.post(url, JSON.stringify(payload), {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'OAuth ' + $rootScope.jbToken
                }
            });
        };

        // Gets all summary report data
        var getAllSummaryReports = function getAllSummaryReports(id) {
            return $http.get(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION_2 + API_OPTS.API_ALL_SUMMARY_EMAIL + id, {
                headers: { 'Content-Type': 'application/json', 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        /****
         **** Trash emails section
         ****/
        var getTrashEmails = function getTrashEmails() {
            return $http.get(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'emails/trash', {
                headers: { 'Content-Type': 'application/json', 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        var trashEmail = function trashEmail(id) {
            return $http.put(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'emails/trash/' + id, {}, {
                headers: { 'Content-Type': 'application/json', 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        var restoreTrashEmail = function restoreTrashEmail(id) {
            return $http.get(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'emails/restore/trash/' + id, {
                headers: { 'Content-Type': 'application/json', 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        // get update fields
        var getFields = function getFields(listId) {
            return $http.get(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'fields/' + listId, {
                headers: { 'Content-Type': 'application/json', 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        var getTrackerSummary = function getTrackerSummary(startDate, endDate) {
            var payload = {
                FromDate: startDate,
                ToDate: endDate
            };

            return $http.post('' + API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'reports/tracker/summary', JSON.stringify(payload), {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'OAuth ' + $rootScope.jbToken
                }
            });
        };

        var getTrackerSummaryDetails = function getTrackerSummaryDetails(startDate, endDate, url) {
            var payload = {
                FromDate: startDate,
                ToDate: endDate,
                URL: url
            };

            return $http.post('' + API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'reports/tracker/detail', JSON.stringify(payload), {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'OAuth ' + $rootScope.jbToken
                }
            });
        };

        var getNotifications = function getNotifications(status) {
            return $http.get(API_OPTS.API_BENCHMARK_REST + ('Client/Notification?status=' + status), {
                headers: { 'AuthToken': $rootScope.jbToken }
            });
        };

        var setNotificationAsRead = function setNotificationAsRead() {
            return $http.patch(API_OPTS.API_BENCHMARK_REST + 'Client/Notification', { 'isNew': '0' }, {
                headers: { 'AuthToken': $rootScope.jbToken }
            });
        };

        var updateNotificationRead = function updateNotificationRead(id) {
            return $http.patch(API_OPTS.API_BENCHMARK_REST + ('Client/Notification/' + id), {}, {
                headers: { 'AuthToken': $rootScope.jbToken }
            });
        };

        var generateThumbs = function generateThumbs(id) {
            return $http.post(API_OPTS.API_BENCHMARK_REST + ('/Emails/' + id + '/ScreenCapture'), {}, {
                headers: { 'AuthToken': $rootScope.jbToken }
            });
        };

        var getSubjectLine = function getSubjectLine() {
            return $http.get('' + API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'subjectline', {
                headers: { 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        var getEmptyEmail = function getEmptyEmail() {
            return $http.get(API_OPTS.API_BENCHMARK_REST + 'Emails/0', {
                headers: { 'AuthToken': $rootScope.jbToken }
            });
        };

        var getNodeMetricDetailsGroupByType = function getNodeMetricDetailsGroupByType(journeyId, nodeId, nodeType) {
            var methodUrl = API_OPTS.API_NODE_METRIC_DETAILS_GROUP.replace(':journeyId', journeyId).replace(':nodeId', nodeId).replace('{nodeType}', nodeType);

            var uri = API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + methodUrl;

            return $http.get(uri, {
                headers: { 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        var getNodeMetricDetailsSummaryByType = function getNodeMetricDetailsSummaryByType(journeyId, nodeId, metricType) {
            var page = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
            var size = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 10;
            var filter = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';

            var methodUrl = API_OPTS.API_METRIC_DETAILS_SUMMARY_BY_TYPE.replace(':journeyId', journeyId).replace(':nodeId', nodeId).replace('{metricType}', metricType).replace('{page}', page).replace('{size}', size).replace('{filter}', filter);

            var uri = API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + methodUrl;

            return $http.get(uri, {
                headers: { 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        var getNodeDetails = function getNodeDetails(journeyId, elementId) {
            var methodUrl = API_OPTS.API_NODE_DETAILS.replace(':journeyId', journeyId).replace(':elementId', elementId);

            var uri = API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + methodUrl;

            return $http.get(uri, {
                headers: { 'Authorization': 'OAuth ' + $rootScope.jbToken }
            });
        };

        return {
            //Gets a list of all available templates
            getTemplateList: getTemplateList,
            //PreLoads templates from canvas
            preloadTemplate: preloadTemplate,
            //Grabs a Journey by ID
            getJourney: getJourney,
            //Save Journey
            updateJourney: updateJourney,
            //Creates a new Journey
            createJourney: createJourney,
            //Save Data to journey storage
            saveJourneyStorge: saveJourneyStorage,
            //Save Data to journey storage
            getJourneyStorage: getJourneyStorage,
            //Remove journey storage
            removeJourneyStorage: removeJourneyStorage,
            //Check if journey storage exists
            journeyStorageExists: journeyStorageExists,
            //Gets the list of conditions for the if else
            getInitIfElseModel: getInitIfElseModel,
            //Get Action lists by type
            getActionIfElseList: getActionIfElseList,
            //Get Contact List
            getContactList: getContactList,
            // create contact list
            createContactList: createContactList,
            //Get Segments
            getSegments: getSegments,
            //Gets a list of segments by Array
            getSegmentsById: getSegmentsById,
            //Gets a list by Array
            getLists: getLists,
            //Get Email List
            getEmailList: getEmailList,
            // update email details
            getEmailDetails: getEmailDetails,
            // gets list of email addresses for a user
            getUserEmailAddress: getUserEmailAddress,
            //Create email
            createEmail: createEmail,
            // update an email
            updateEmailData: updateEmailData,
            // duplicates an existing email
            duplicateEmail: duplicateEmail,
            // validates email name true or false
            validateDuplicateEmailName: validateDuplicateEmailName,
            // redirects to an editor URL
            redirectToEditor: redirectToEditor,
            // delete Templates
            deleteTemplate: deleteTemplate,
            //Get list of journeys with paginate parameters
            getPaginateJourneys: getPaginateJourneys,
            // gets the type of editor by type
            getVersionByType: getVersionByType,
            //Generates an encrypted token
            getTrackerToken: getTrackerToken,
            //Create Journey Template
            createJourneyTemplate: createJourneyTemplate,
            //Get paginated Journey Templates
            getPaginateTemplates: getPaginateTemplates,
            //Deactivate, Delete
            setJourneyStatus: setJourneyStatus,
            //Activate a Journey
            activateJourney: activateJourney,
            //Load Default Templates
            preloadDefaultJourneys: preloadDefaultJourneys,
            // duplicates email with a valid name
            duplicateEmailValidName: duplicateEmailValidName,
            // gets a coach object
            getCoach: getCoach,
            // saves a coach object
            saveCoach: saveCoach,
            // validate journey name
            journeyName: journeyName,
            // blocks/unblocks a journey
            blockJourney: blockJourney,
            // searches in a list
            searchContactList: searchContactList,
            // searches in a list
            searchContactSegment: searchContactSegment,
            // searches emails
            searchEmails: searchEmails,
            // saves stats as lists
            saveStatsAsLists: saveStatsAsLists,
            // sends feedback to the spreassheet
            sendFeedback: sendFeedback,
            // get client info
            getResponsiveInfo: getResponsiveInfo,
            // get client info
            getClientInfo: getClientInfo,
            // gets plan info
            getPlanInfo: getPlanInfo,
            // gets download info
            getDownloadInfo: getDownloadInfo,
            // downloads a report file by type
            downloadFile: downloadFile,
            // sends the pin through email
            emailPin: emailPin,
            // get opens reports
            getReportByType: getReportByType,
            // get preview
            getPreview: getPreview,
            // search Automations
            searchAutomations: searchAutomations,
            // Get active emails of a element_id
            getActiveEmails: getActiveEmails,
            // Create draft email after save new email
            createDraftEmail: createDraftEmail,
            // Active Draft Email
            activeDraftEmail: activeDraftEmail,
            // Delete draft email
            deleteDraftEmail: deleteDraftEmail,
            // creates an activate duplicate
            createDuplicateActivated: createDuplicateActivated,
            // tests is a tracker is installed in a site
            testTracker: testTracker,
            // get links of an email
            emailUrls: emailUrls,
            // Get client settings
            getClientSettings: getClientSettings,
            // get all connections
            getConnections: getConnections,
            // fb connect
            fbConnect: fbConnect,
            // get audiences
            getAudiences: getAudiences,
            // disconnect fb
            fbDisconnect: fbDisconnect,
            // get notifications
            getNotificationBadge: getNotificationBadge,
            // update activated nodes
            updateActivatedNodes: updateActivatedNodes,
            // get all summaries
            getAllSummaryReports: getAllSummaryReports,
            // get trash emails
            getTrashEmails: getTrashEmails,
            // set trash email
            trashEmail: trashEmail,
            // restore trash email
            restoreTrashEmail: restoreTrashEmail,
            // update fields
            getFields: getFields,
            // get tracking data
            getTrackerSummary: getTrackerSummary,
            // get tracker summary details
            getTrackerSummaryDetails: getTrackerSummaryDetails,
            // get notifications
            getNotifications: getNotifications,
            // mark as read
            updateNotificationRead: updateNotificationRead,
            // generates thumbs
            generateThumbs: generateThumbs,
            // get subject line
            getSubjectLine: getSubjectLine,
            // get empty email data
            getEmptyEmail: getEmptyEmail,
            // sets notification as read
            setNotificationAsRead: setNotificationAsRead,
            // get smart send info
            getSmartSendingInfo: getSmartSendingInfo,
            // get node metric details group by metric type
            getNodeMetricDetailsGroupByType: getNodeMetricDetailsGroupByType,
            // get node metric details summary by metric type
            getNodeMetricDetailsSummaryByType: getNodeMetricDetailsSummaryByType,
            // get node  details by Journey Id and Element Id
            getNodeDetails: getNodeDetails
        };
    }

    function cacheSetter($rootScope) {
        var _setCache = function _setCache(id, data) {
            var res = false;

            if (typeof Storage !== "undefined" && $rootScope.localStorageSupported) {
                res = sessionStorage.setItem(id, data);
            }
            return res;
        };

        var _destroyCache = function _destroyCache(id) {
            var res = false;

            if (typeof Storage !== "undefined") {
                res = sessionStorage.removeItem(id);
            }

            return res;
        };

        var _getCache = function _getCache(id, isJSON) {
            var res = false;

            if (typeof Storage !== "undefined") {
                res = sessionStorage.getItem(id);
            }

            return res;
        };

        var _deleteCacheByPattern = function _deleteCacheByPattern(pattern) {
            var l = sessionStorage.length,
                removeArr = [];

            for (var i = 0; i < l; i++) {
                var key = sessionStorage.key(i);
                if (key.indexOf(pattern) > -1) {
                    removeArr.push(key);
                }
            }

            for (var j = 0; j < removeArr.length; j++) {
                sessionStorage.removeItem(removeArr[j]);
            }
        };

        var _deleteCachable = function _deleteCachable() {
            localStorage.removeItem('cache:journeys:list');
        };

        return {
            setCache: _setCache,
            destroyCache: _destroyCache,
            getCache: _getCache,
            deleteCachePattern: _deleteCacheByPattern,
            deleteCachable: _deleteCachable
        };
    }

    function signalRHub(HUB) {

        function _initFunc() {
            return HUB;
        }

        return {
            init: _initFunc
        };
    }

    function uiService($http, API_OPTS) {
        $http.defaults.useXDomain = true;
        //Sets the user context

        var _getPermanentToken = function _getPermanentToken(userName, password) {

            var payload = {
                "Password": password,
                "UserName": userName
            };

            return $http({
                method: 'POST',
                url: API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_EDITOR_GET_PERMANENT_TOKEN,
                data: JSON.stringify(payload)
            });
        };

        return {
            permanentTokenGet: _getPermanentToken
        };
    }

    function plumbService(canvasService, helpers, $rootScope) {

        var initPlumb = function initPlumb() {
            //Bind ready event to use later
            jsPlumb.bind('ready', function () {
                jsPlumb.setContainer($('.canvas'));
            });

            jsPlumb.bind("beforeDrop", function (connection) {
                _resolveManualConnection(connection);
                $rootScope.isDraggingLoop = false;
                return false;
            });

            jsPlumb.bind("connectionDrag", function (connection) {
                if (connection.sourceId.indexOf('looping-conn-') > -1) {
                    $rootScope.isDraggingLoop = true;
                }
            });

            jsPlumb.bind("connectionDragStop", function (connection) {
                $rootScope.isDraggingLoop = false;
            });
        };

        var setInitDragConnect = function setInitDragConnect(sourceEl) {
            jsPlumb.ready(function () {
                //Add drag event
                jsPlumb.draggable(sourceEl.id, { containment: 'parent' });

                var manualSource = document.getElementsByClassName("add-connection"),
                    commonManualConnect = {
                    connector: ['Straight'],
                    anchor: ['Left', 'Right'],
                    endpoint: "Blank",
                    connectorStyle: {
                        gradient: { stops: [[0, '#4F4FC9'], [1, '#4F4FC9']] },
                        lineWidth: 2,
                        strokeStyle: '#4F4FC9'
                    }
                };

                //Manual Source
                jsPlumb.makeSource(manualSource, {}, commonManualConnect);
            });
        };

        var simpleConnect = function simpleConnect(source, target, color) {
            //Options
            var common = {
                connector: ['Straight'],
                anchor: ['Left', 'Right', 'Top', 'Bottom'],
                endpoint: "Blank"
            };

            //Connect
            jsPlumb.connect({
                source: source,
                target: target,

                paintStyle: {
                    lineWidth: 2,
                    strokeStyle: color
                },
                overlays: [["Arrow", { width: 11, length: 10, location: 1 }]]

            }, common);
        };

        var connectElements = function connectElements(sourceEl, targetEl) {
            var targetType = targetEl.type,
                targetNode,
                arrowLocation;

            if (targetType === 'Action') {
                targetNode = targetEl.id + '-center-target';
                arrowLocation = -80;
            } else if (targetType === 'Condition') {
                targetNode = targetEl.id + '-center-target';
                arrowLocation = -94;
            } else if (targetType === 'Looping') {
                targetNode = targetEl.id + '-center-target';
                arrowLocation = -71;
            } else {
                targetNode = targetEl.id + '-center-target';
                arrowLocation = 1;
            }

            //Options
            var common = {
                connector: ['Straight'],
                anchor: ['Left', 'Right', 'Top', 'Bottom'],
                endpoint: "Blank"
            };

            //Connect
            jsPlumb.connect({
                source: sourceEl.id + '-center',
                target: targetNode,

                paintStyle: {
                    gradient: { stops: [[0, sourceEl.color], [1, targetEl.color]] },
                    lineWidth: 2,
                    strokeStyle: targetEl.color
                },
                endpointStyles: [{ gradient: { stops: [[0, sourceEl.color], [1, targetEl.color]] } }],
                overlays: [["Arrow", { width: 11, length: 10, location: arrowLocation }]]

            }, common);

            //Getting the source Element
            var sourceElement = angular.element(document.querySelector('#' + sourceEl.id));
            //Setting the plus-menu invisible
            angular.element(sourceElement[0].querySelector('.plus-menu')).addClass("invisible");
            //Remove visible class
            angular.element(sourceElement[0].querySelector('.plus-menu')).removeClass("visible");

            //Add Visible class to the connect Icon
            angular.element(sourceElement[0].querySelector('.add-connection')).addClass("invisible");
            //Set the connect icon invisible for the user when connection exist
            angular.element(sourceElement[0].querySelector('.add-connection')).removeClass("visible");

            $rootScope.$emit('arrowReconnected' + sourceEl.id, sourceEl.id);

            //Add drag event
            jsPlumb.draggable(sourceEl.id, { containment: 'parent' });
            jsPlumb.draggable(targetEl.id, { containment: 'parent' });

            _setManualConnections(sourceEl.color, targetEl.color);
        };

        var connectLoopingElements = function connectLoopingElements(sourceEl, targetEl) {
            if (!targetEl) {
                return;
            }

            var targetType = targetEl.type,
                targetNode,
                arrowLocation;

            if (targetType === 'Action') {
                targetNode = targetEl.id + '-center-looping';
                arrowLocation = -79;
            } else if (targetType === 'Condition') {
                targetNode = targetEl.id + '-center-looping';
                arrowLocation = -93;
            } else {
                targetNode = targetEl.id + '-center-looping';
                arrowLocation = -80;
            }

            //Options
            var common = {
                connector: ['Straight'],
                anchor: ['Left', 'Right', 'Top', 'Bottom'],
                endpoint: "Blank"
            };

            //Connect
            jsPlumb.connect({
                source: sourceEl.id + '-center',
                target: targetNode,

                paintStyle: {
                    gradient: { stops: [[0, sourceEl.color], [1, targetEl.color]] },
                    lineWidth: 2,
                    strokeStyle: targetEl.color
                },
                endpointStyles: [{ gradient: { stops: [[0, sourceEl.color], [1, targetEl.color]] } }],
                overlays: [["Arrow", { width: 11, length: 10, location: arrowLocation }]]

            }, common);

            $rootScope.$emit('showConnectionArrow_' + sourceEl.id, false, sourceEl.id);
            $rootScope.$emit('showDeleteArrow_' + sourceEl.id, true, sourceEl.id);

            //Add drag event
            jsPlumb.draggable(sourceEl.id, { containment: 'parent' });
            jsPlumb.draggable(targetEl.id, { containment: 'parent' });

            _setManualConnections(sourceEl.color, targetEl.color);
        };

        var makeDraggable = function makeDraggable(id) {
            //Add drag event
            jsPlumb.draggable(id, { containment: 'parent' });
        };

        var _setManualConnections = function _setManualConnections(sourceColor, targetColor) {
            var manualSource = document.getElementsByClassName("add-connection"),
                manualTarget = document.getElementsByClassName("shape"),
                commonManualConnect = {
                connector: ['Straight'],
                anchor: ['Left', 'Right'],
                endpoint: "Blank",
                connectorStyle: {
                    gradient: { stops: [[0, sourceColor], [1, targetColor]] },
                    lineWidth: 2,
                    strokeStyle: targetColor
                }
            };

            var filteredSource = Array.prototype.filter.call(manualSource, function (el) {
                return el.className.indexOf('jsplumb-droppable') == -1;
            });

            var filteredTarget = Array.prototype.filter.call(manualTarget, function (el) {
                return el.className.indexOf('jsplumb-droppable') == -1;
            });

            //Manual Source
            if (filteredSource.length) {
                jsPlumb.makeSource(filteredSource, {}, commonManualConnect);
            }

            //Manual Target
            if (filteredTarget.length) {
                jsPlumb.makeTarget(filteredTarget, {}, commonManualConnect);
            }
        };

        var _resolveManualConnection = function _resolveManualConnection(connection) {
            var sourceId = $('#' + connection.sourceId).closest('div.shape').attr('id'),
                source,
                target;
            if (sourceId !== connection.targetId) {
                source = helpers.getConnectionById(sourceId);
                target = helpers.getConnectionById(connection.targetId);

                if (_isLooping(source, target)) {
                    //connect and update rootscope, and save journey
                    connectLoopingElements(source, target);
                    helpers.updateChildrenProp(source.id, target.id);
                    $rootScope.$emit('arrowReconnected' + source.id, source.id);
                    canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), true);
                } else if (_isConnectable(source, target)) {
                    //connect and update rootscope, and save journey
                    connectElements(source, target);
                    helpers.updateParentProp(source.id, target.id);
                    helpers.updateChildrenProp(source.id, target.id);
                    helpers.reOrderConnections();
                    $rootScope.$emit('arrowReconnected' + source.id, source.id);
                    canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), true);
                } else {
                    console.log('Element already connected');
                }
            } else {
                console.log('not elegible for connection');
                return false;
            }
        };

        var _isLooping = function _isLooping(source, target) {
            if (target.type === 'RectangleConnection') {
                return false;
            }

            if (target.type === 'Entry') {
                return false;
            }

            if (target.type === 'Looping') {
                return false;
            }

            if (source.parent === target.id) {
                return false;
            }

            if (source.type === 'Looping') {
                return true;
            }

            return false;
        };

        var _isConnectable = function _isConnectable(source, target) {

            //means its not saved yet
            if (!source) {
                return false;
            }

            //means its not saved yet
            if (!target) {
                return false;
            }

            //Do not connect entry as target
            if (target.type === 'Entry') {
                return false;
            }

            if (source.type === 'Looping' && target.type === 'Looping') {
                return false;
            }

            //Checks for the parent property
            if (target.hasOwnProperty('parent') && target.parent) {
                return false;
            }
            //Checks if the source has a current connection
            if (helpers.checkIfIsConnected(source.id)) {
                return false;
            }

            return true;
        };

        //Delete Elements Function
        var deleteElements = function deleteElements(elem) {
            //Select the parent Element.
            var parentElement = angular.element(document.querySelector('#' + elem.parent));
            // to hide the delete arrow button
            $rootScope.$emit('hideArrowDelete' + elem.parent, elem.parent);
            if (parentElement[0]) {
                //Add Visible class to the menu Icon
                angular.element(parentElement[0].querySelector('.plus-menu')).addClass("visible");
                //Set the menu invisible for the user
                angular.element(parentElement[0].querySelector('.plus-menu')).removeClass("invisible");

                //Add Visible class to the menu Icon
                angular.element(parentElement[0].querySelector('.add-connection')).addClass("visible");
                //Set the menu invisible for the user
                angular.element(parentElement[0].querySelector('.add-connection')).removeClass("invisible");
            }
            jsPlumb.ready(function () {
                var shapeDelete, el, arrowDelete, arrowDeleteTarget, loopDeleteTarget;

                shapeDelete = angular.element(document.querySelector('#' + elem.id));
                arrowDelete = angular.element(document.querySelector('#' + elem.id + '-center'));
                arrowDeleteTarget = angular.element(document.querySelector('#' + elem.id + '-center-target'));
                loopDeleteTarget = angular.element(document.querySelector('#' + elem.id + '-center-looping'));

                jsPlumb.detachAllConnections(shapeDelete);
                jsPlumb.detachAllConnections(arrowDelete);
                jsPlumb.detachAllConnections(arrowDeleteTarget);
                jsPlumb.detachAllConnections(loopDeleteTarget);

                shapeDelete.remove();
                el = helpers.deleteConnection(elem);

                if (el && el.elem) {
                    helpers.removeSiblings(el.elem.id);
                    canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), true);
                }
            });
        };

        var deleteArrows = function deleteArrows(elem) {
            //Select the parent Element.
            var currentElem = angular.element(document.querySelector('#' + elem.id));
            if (currentElem[0]) {
                //Add Visible class to the menu Icon
                angular.element(currentElem[0].querySelector('.plus-menu')).addClass("visible");
                //Set the menu invisible for the user
                angular.element(currentElem[0].querySelector('.plus-menu')).removeClass("invisible");

                //Add Visible class to the menu Icon
                angular.element(currentElem[0].querySelector('.add-connection')).addClass("visible");
                //Set the menu invisible for the user
                angular.element(currentElem[0].querySelector('.add-connection')).removeClass("invisible");
            }

            jsPlumb.ready(function () {
                var arrowDelete;

                arrowDelete = angular.element(document.querySelector('#' + elem.id + '-center'));
                jsPlumb.detachAllConnections(arrowDelete);

                if (elem.id) {
                    helpers.deleteParent(elem.id);
                    canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), true);
                }
            });
        };

        var lastElem;
        var getLastElemClicked = function getLastElemClicked() {
            return lastElem;
        };

        var setLastElemClicked = function setLastElemClicked(elemClicked) {
            lastElem = elemClicked;
            return lastElem;
        };

        return {
            //Starts jsPlumb
            initPlumb: initPlumb,
            //Connects two elements with jsPlumb
            connectElements: connectElements,
            // connect two looping elements
            connectLoopingElements: connectLoopingElements,
            //Sets the last element clicked
            setLastElemClicked: setLastElemClicked,
            //Get the id of the canvas element that was clicked
            getLastElemClicked: getLastElemClicked,
            //Delete elements(shapes)
            deleteElements: deleteElements,
            //Set Single element initial state
            setInitDragConnect: setInitDragConnect,
            //Makes an element draggable
            makeDraggable: makeDraggable,
            //Sets a manual connection
            setManualConnection: _setManualConnections,
            //Deletes only arrow connection
            deleteArrows: deleteArrows,
            // does a simple connection
            simpleConnect: simpleConnect
        };
    }

    function preBuildServices($q, $rootScope, canvasService, $location) {
        //Checking url to display Journey name Element.
        $rootScope.$on('$locationChangeStart', function () {
            //Checks if path contains canvas word in the url
            var isCanvasPath = function isCanvasPath() {
                return $location.path().indexOf('canvas') > -1;
            };

            if (!$rootScope.journeyDefaultTemplates && isCanvasPath()) {
                var templatePromises = [canvasService.preloadDefaultJourneys(1), canvasService.preloadDefaultJourneys(2), canvasService.preloadDefaultJourneys(3), canvasService.preloadDefaultJourneys(4), canvasService.preloadDefaultJourneys(5), canvasService.preloadDefaultJourneys(6), canvasService.preloadDefaultJourneys(7), canvasService.preloadDefaultJourneys(8), canvasService.preloadDefaultJourneys(9)];

                $q.all(templatePromises).then(function (results) {
                    $rootScope.journeyDefaultTemplates = results.map(function (res) {
                        return res.data;
                    });
                });
            }
        });
    }

    function getTestEnvUrls() {
        return ['jbdev.benchmarkemail.com', 'apbeta.benchmarkemail.com', 'aptest.benchmarkemail.com'];
    }

    function calcAProApiUrl() {
        var serviceUrl = 'https://aproapi.benchmarkemail.com/';

        if (getTestEnvUrls().indexOf(window.location.hostname) > -1) {
            serviceUrl = 'https://aproapi.beta.benchmarkemail.com/';
        }

        return serviceUrl;
    }

    function calcAProHubUrl() {
        var serviceUrl = 'https://reports.benchmarkemail.com/private';

        if (getTestEnvUrls().indexOf(window.location.hostname) > -1) {
            serviceUrl = 'https://reports.beta.benchmarkemail.com/private';
        }

        return serviceUrl;
    }

    function calcIntegrationsApiUrl() {
        var serviceUrl = 'https://aproapi.benchmarkemail.com/integrations/api/v1/';

        if (getTestEnvUrls().indexOf(window.location.hostname) > -1) {
            serviceUrl = 'https://intgrapi.beta.benchmarkemail.com/api/v1/';
        }

        return serviceUrl;
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    'use strict';

    var moment = __webpack_require__(0);
    angular.module('customDate', []).filter('customDateFilter', ['momentLocales', customDateFilter]).constant('moment', moment).service('momentLocales', ['$rootScope', function ($rootScope) {

        var langObj = {
            "brazil": "pt",
            "chinese": "zh-tw",
            "chineset": "zh-cn",
            "english": "en",
            "french": "fr",
            "german": "de",
            "indian": "en",
            "italian": "it",
            "japanese": "ja",
            "porguguese": "pt",
            "spanish": "es"
        };
        var lang = $rootScope.jbLang;

        function processRelativeTime(number, withoutSuffix, key, isFuture) {
            var format = {
                'm': ['eine Minute', 'einer Minute'],
                'h': ['eine Stunde', 'einer Stunde'],
                'd': ['ein Tag', 'einem Tag'],
                'dd': [number + ' Tage', number + ' Tagen'],
                'M': ['ein Monat', 'einem Monat'],
                'MM': [number + ' Monate', number + ' Monaten'],
                'y': ['ein Jahr', 'einem Jahr'],
                'yy': [number + ' Jahre', number + ' Jahren']
            };
            return withoutSuffix ? format[key][0] : format[key][1];
        }

        //Spanish
        moment.defineLocale('es', {
            months: 'enero_febrero_marzo_abril_Mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
            monthsShort: function (_monthsShort) {
                function monthsShort(_x, _x2) {
                    return _monthsShort.apply(this, arguments);
                }

                monthsShort.toString = function () {
                    return _monthsShort.toString();
                };

                return monthsShort;
            }(function (m, format) {
                if (!m) {
                    return monthsShortDot;
                } else if (/-MMM-/.test(format)) {
                    return monthsShort[m.month()];
                } else {
                    return monthsShortDot[m.month()];
                }
            }),
            monthsParseExact: true,
            weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
            weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
            weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
            weekdaysParseExact: true,
            longDateFormat: {
                LT: 'H:mm',
                LTS: 'H:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D [de] MMMM [de] YYYY',
                LLL: 'D [de] MMMM [de] YYYY H:mm',
                LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
            },
            calendar: {
                sameDay: function sameDay() {
                    return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
                },
                nextDay: function nextDay() {
                    return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
                },
                nextWeek: function nextWeek() {
                    return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
                },
                lastDay: function lastDay() {
                    return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
                },
                lastWeek: function lastWeek() {
                    return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
                },
                sameElse: 'L'
            },
            relativeTime: {
                future: 'en %s',
                past: 'hace %s',
                s: 'unos segundos',
                m: 'un minuto',
                mm: '%d minutos',
                h: 'una hora',
                hh: '%d horas',
                d: 'un día',
                dd: '%d días',
                M: 'un mes',
                MM: '%d meses',
                y: 'un año',
                yy: '%d años'
            },
            dayOfMonthOrdinalParse: /\d{1,2}º/,
            ordinal: '%dº',
            week: {
                dow: 1, // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.
            }
        });
        //End Spanish

        //German
        moment.defineLocale('de', {
            months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
            monthsShort: 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
            monthsParseExact: true,
            weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
            weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
            weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
            weekdaysParseExact: true,
            longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D. MMMM YYYY',
                LLL: 'D. MMMM YYYY HH:mm',
                LLLL: 'dddd, D. MMMM YYYY HH:mm'
            },
            calendar: {
                sameDay: '[heute um] LT [Uhr]',
                sameElse: 'L',
                nextDay: '[morgen um] LT [Uhr]',
                nextWeek: 'dddd [um] LT [Uhr]',
                lastDay: '[gestern um] LT [Uhr]',
                lastWeek: '[letzten] dddd [um] LT [Uhr]'
            },
            relativeTime: {
                future: 'in %s',
                past: 'vor %s',
                s: 'ein paar Sekunden',
                m: processRelativeTime,
                mm: '%d Minuten',
                h: processRelativeTime,
                hh: '%d Stunden',
                d: processRelativeTime,
                dd: processRelativeTime,
                M: processRelativeTime,
                MM: processRelativeTime,
                y: processRelativeTime,
                yy: processRelativeTime
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: '%d.',
            week: {
                dow: 1, // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.
            }
        });
        //End German

        //portuguesse
        moment.defineLocale('pt', {
            months: 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
            monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
            weekdays: 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
            weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
            weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
            weekdaysParseExact: true,
            longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D [de] MMMM [de] YYYY',
                LLL: 'D [de] MMMM [de] YYYY HH:mm',
                LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm'
            },
            calendar: {
                sameDay: '[Hoje às] LT',
                nextDay: '[Amanhã às] LT',
                nextWeek: 'dddd [às] LT',
                lastDay: '[Ontem às] LT',
                lastWeek: function lastWeek() {
                    return this.day() === 0 || this.day() === 6 ? '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
                },
                sameElse: 'L'
            },
            relativeTime: {
                future: 'em %s',
                past: 'há %s',
                s: 'segundos',
                m: 'um minuto',
                mm: '%d minutos',
                h: 'uma hora',
                hh: '%d horas',
                d: 'um dia',
                dd: '%d dias',
                M: 'um mês',
                MM: '%d meses',
                y: 'um ano',
                yy: '%d anos'
            },
            dayOfMonthOrdinalParse: /\d{1,2}º/,
            ordinal: '%dº',
            week: {
                dow: 1, // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.
            }
        });
        //End Portuguesse

        //French
        moment.defineLocale('fr', {
            months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
            monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
            monthsParseExact: true,
            weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
            weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
            weekdaysMin: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
            weekdaysParseExact: true,
            longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd D MMMM YYYY HH:mm'
            },
            calendar: {
                sameDay: '[Aujourd’hui à] LT',
                nextDay: '[Demain à] LT',
                nextWeek: 'dddd [à] LT',
                lastDay: '[Hier à] LT',
                lastWeek: 'dddd [dernier à] LT',
                sameElse: 'L'
            },
            relativeTime: {
                future: 'dans %s',
                past: 'il y a %s',
                s: 'quelques secondes',
                m: 'une minute',
                mm: '%d minutes',
                h: 'une heure',
                hh: '%d heures',
                d: 'un jour',
                dd: '%d jours',
                M: 'un mois',
                MM: '%d mois',
                y: 'un an',
                yy: '%d ans'
            },
            dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
            ordinal: function ordinal(number, period) {
                switch (period) {
                    // TODO: Return 'e' when day of month > 1. Move this case inside
                    // block for masculine words below.
                    // See https://github.com/moment/moment/issues/3375
                    case 'D':
                        return number + (number === 1 ? 'er' : '');

                    // Words with masculine grammatical gender: mois, trimestre, jour
                    default:
                    case 'M':
                    case 'Q':
                    case 'DDD':
                    case 'd':
                        return number + (number === 1 ? 'er' : 'e');

                    // Words with feminine grammatical gender: semaine
                    case 'w':
                    case 'W':
                        return number + (number === 1 ? 're' : 'e');
                }
            },
            week: {
                dow: 1, // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.
            }
        });
        //End French

        //Italian
        moment.defineLocale('it', {
            months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
            monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
            weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
            weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
            weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
            longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd, D MMMM YYYY HH:mm'
            },
            calendar: {
                sameDay: '[Oggi alle] LT',
                nextDay: '[Domani alle] LT',
                nextWeek: 'dddd [alle] LT',
                lastDay: '[Ieri alle] LT',
                lastWeek: function lastWeek() {
                    switch (this.day()) {
                        case 0:
                            return '[la scorsa] dddd [alle] LT';
                        default:
                            return '[lo scorso] dddd [alle] LT';
                    }
                },
                sameElse: 'L'
            },
            relativeTime: {
                future: function future(s) {
                    return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
                },
                past: '%s fa',
                s: 'alcuni secondi',
                m: 'un minuto',
                mm: '%d minuti',
                h: 'un\'ora',
                hh: '%d ore',
                d: 'un giorno',
                dd: '%d giorni',
                M: 'un mese',
                MM: '%d mesi',
                y: 'un anno',
                yy: '%d anni'
            },
            dayOfMonthOrdinalParse: /\d{1,2}º/,
            ordinal: '%dº',
            week: {
                dow: 1, // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.
            }
        });
        //End Italian

        //Japan
        moment.defineLocale('ja', {
            months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
            monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
            weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
            weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
            weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
            longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'YYYY/MM/DD',
                LL: 'YYYY年M月D日',
                LLL: 'YYYY年M月D日 HH:mm',
                LLLL: 'YYYY年M月D日 HH:mm dddd',
                l: 'YYYY/MM/DD',
                ll: 'YYYY年M月D日',
                lll: 'YYYY年M月D日 HH:mm',
                llll: 'YYYY年M月D日 HH:mm dddd'
            },
            meridiemParse: /午前|午後/i,
            isPM: function isPM(input) {
                return input === '午後';
            },
            meridiem: function meridiem(hour, minute, isLower) {
                if (hour < 12) {
                    return '午前';
                } else {
                    return '午後';
                }
            },
            calendar: {
                sameDay: '[今日] LT',
                nextDay: '[明日] LT',
                nextWeek: '[来週]dddd LT',
                lastDay: '[昨日] LT',
                lastWeek: '[前週]dddd LT',
                sameElse: 'L'
            },
            dayOfMonthOrdinalParse: /\d{1,2}日/,
            ordinal: function ordinal(number, period) {
                switch (period) {
                    case 'd':
                    case 'D':
                    case 'DDD':
                        return number + '日';
                    default:
                        return number;
                }
            },
            relativeTime: {
                future: '%s後',
                past: '%s前',
                s: '数秒',
                m: '1分',
                mm: '%d分',
                h: '1時間',
                hh: '%d時間',
                d: '1日',
                dd: '%d日',
                M: '1ヶ月',
                MM: '%dヶ月',
                y: '1年',
                yy: '%d年'
            }
        });
        //End Japan

        //Traditional Ch
        moment.defineLocale('zh-tw', {
            months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
            monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
            weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
            weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
            weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
            longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'YYYY年MMMD日',
                LL: 'YYYY年MMMD日',
                LLL: 'YYYY年MMMD日 HH:mm',
                LLLL: 'YYYY年MMMD日dddd HH:mm',
                l: 'YYYY年MMMD日',
                ll: 'YYYY年MMMD日',
                lll: 'YYYY年MMMD日 HH:mm',
                llll: 'YYYY年MMMD日dddd HH:mm'
            },
            meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
            meridiemHour: function meridiemHour(hour, meridiem) {
                if (hour === 12) {
                    hour = 0;
                }
                if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                    return hour;
                } else if (meridiem === '中午') {
                    return hour >= 11 ? hour : hour + 12;
                } else if (meridiem === '下午' || meridiem === '晚上') {
                    return hour + 12;
                }
            },
            meridiem: function meridiem(hour, minute, isLower) {
                var hm = hour * 100 + minute;
                if (hm < 600) {
                    return '凌晨';
                } else if (hm < 900) {
                    return '早上';
                } else if (hm < 1130) {
                    return '上午';
                } else if (hm < 1230) {
                    return '中午';
                } else if (hm < 1800) {
                    return '下午';
                } else {
                    return '晚上';
                }
            },
            calendar: {
                sameDay: '[今天]LT',
                nextDay: '[明天]LT',
                nextWeek: '[下]ddddLT',
                lastDay: '[昨天]LT',
                lastWeek: '[上]ddddLT',
                sameElse: 'L'
            },
            dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
            ordinal: function ordinal(number, period) {
                switch (period) {
                    case 'd':
                    case 'D':
                    case 'DDD':
                        return number + '日';
                    case 'M':
                        return number + '月';
                    case 'w':
                    case 'W':
                        return number + '週';
                    default:
                        return number;
                }
            },
            relativeTime: {
                future: '%s內',
                past: '%s前',
                s: '幾秒',
                m: '1 分鐘',
                mm: '%d 分鐘',
                h: '1 小時',
                hh: '%d 小時',
                d: '1 天',
                dd: '%d 天',
                M: '1 個月',
                MM: '%d 個月',
                y: '1 年',
                yy: '%d 年'
            }
        });
        //End Traditional CH

        //Ch
        moment.defineLocale('zh-cn', {
            months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
            monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
            weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
            weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
            weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
            longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'YYYY年MMMD日',
                LL: 'YYYY年MMMD日',
                LLL: 'YYYY年MMMD日Ah点mm分',
                LLLL: 'YYYY年MMMD日ddddAh点mm分',
                l: 'YYYY年MMMD日',
                ll: 'YYYY年MMMD日',
                lll: 'YYYY年MMMD日 HH:mm',
                llll: 'YYYY年MMMD日dddd HH:mm'
            },
            meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
            meridiemHour: function meridiemHour(hour, meridiem) {
                if (hour === 12) {
                    hour = 0;
                }
                if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                    return hour;
                } else if (meridiem === '下午' || meridiem === '晚上') {
                    return hour + 12;
                } else {
                    // '中午'
                    return hour >= 11 ? hour : hour + 12;
                }
            },
            meridiem: function meridiem(hour, minute, isLower) {
                var hm = hour * 100 + minute;
                if (hm < 600) {
                    return '凌晨';
                } else if (hm < 900) {
                    return '早上';
                } else if (hm < 1130) {
                    return '上午';
                } else if (hm < 1230) {
                    return '中午';
                } else if (hm < 1800) {
                    return '下午';
                } else {
                    return '晚上';
                }
            },
            calendar: {
                sameDay: '[今天]LT',
                nextDay: '[明天]LT',
                nextWeek: '[下]ddddLT',
                lastDay: '[昨天]LT',
                lastWeek: '[上]ddddLT',
                sameElse: 'L'
            },
            dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
            ordinal: function ordinal(number, period) {
                switch (period) {
                    case 'd':
                    case 'D':
                    case 'DDD':
                        return number + '日';
                    case 'M':
                        return number + '月';
                    case 'w':
                    case 'W':
                        return number + '周';
                    default:
                        return number;
                }
            },
            relativeTime: {
                future: '%s内',
                past: '%s前',
                s: '几秒',
                m: '1 分钟',
                mm: '%d 分钟',
                h: '1 小时',
                hh: '%d 小时',
                d: '1 天',
                dd: '%d 天',
                M: '1 个月',
                MM: '%d 个月',
                y: '1 年',
                yy: '%d 年'
            },
            week: {
                // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
                dow: 1, // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.
            }
        });
        //End Ch

        //Setting the lang if not, english by default
        moment.locale(langObj[lang] || 'en');
    }]);

    function customDateFilter() {
        return function (date, format) {
            return moment(date).format(format);
        };
    }
})();

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _package = __webpack_require__(2);

(function () {
    var moment = __webpack_require__(0);
    angular.module('helpers.srv', []).constant('_', _).constant('moment', moment).constant('TRACKER_URL', getJbTrackerUrl()).constant('APRO_BME_URL', getBmeUrl()).factory('helpers', ['$rootScope', '$http', 'TRACKER_URL', Helpers]).factory('timezoneFactory', ['_', 'moment', timeZoneFactory])
    // Timezone name to country codemap
    .factory('zoneToCC', ['_', zoneToCC])
    // Country code to country name map
    .factory('CCToCountryName', ['_', CCToCountryName])
    // Factory for Scroll Loader on the home page
    .factory('scrollLoader', ['$rootScope', '$http', 'canvasService', 'cacheService', 'AUTH_EVENTS', scrollLoader]).factory('scrollLoaderEmails', ['canvasService', scrollLoaderEmails]);

    function Helpers($rootScope, $http, TRACKER_URL) {
        var updateElementPosition = function updateElementPosition(id, top, left) {
            if (id && top && left) {
                for (var i = 0; i < $rootScope.connections.length; i++) {
                    if ($rootScope.connections[i].id === id) {
                        $rootScope.connections[i].top = top;
                        $rootScope.connections[i].left = left;
                        return true;
                    }
                }
            }
            return false;
        };

        var updateAllElementPositions = function updateAllElementPositions(connections) {
            return connections.map(function (node) {
                var $el = $('#' + node.id);
                var newTop = parseInt($el.inlineStyle('top'));
                var newLeft = parseInt($el.inlineStyle('left'));

                if (!isNaN(newTop) && !isNaN(newLeft)) {
                    node.top = newTop;
                    node.left = newLeft;
                }
                return node;
            });
        };

        var fitElementToScreen = function fitElementToScreen(evt, elemName, left) {
            if ($rootScope.scalePosition && $rootScope.scalePosition < 1) {
                return;
            }

            var windowWidth = window.innerWidth * 0.75,
                windowHeight = window.innerHeight * 0.55,
                windowHeightLargeNodes = window.innerHeight * 0.45,
                windowHeightTop = window.innerHeight * 0.16,
                canvasPosLeft = parseInt($('.canvas').inlineStyle('left')),
                canvasPosTop = parseInt($('.canvas').inlineStyle('top')),

            //hardcoded value to take node height.
            nodeHeight = 160;

            //Right to left
            if (evt.clientX > windowWidth) {
                if (isNaN(canvasPosLeft)) {
                    $('.canvas').css({ 'left': -left + 'px' });
                } else if (elemName === 'IfElse') {
                    $('.canvas').css({
                        'left': parseInt(canvasPosLeft - 500) + 'px'
                    });
                } else {
                    $('.canvas').css({
                        'left': parseInt(canvasPosLeft - 300) + 'px'
                    }).addClass('transition-left');
                }
            }
            var moveToTop = parseInt($(evt.target).closest(".shape").css("top")) - nodeHeight;

            if (elemName === 'newEntry') {
                moveToTop = 12000;
            }

            //Bottom to top
            if (evt.clientY > windowHeight && (elemName != 'SendMail' || elemName != 'IfElse')) {
                if (isNaN(canvasPosTop)) {
                    $('.canvas').css({ 'top': -12000 + 'px' });
                } else {
                    $('.canvas').css({
                        'top': parseInt(-moveToTop) + 'px'
                    }).addClass('transition-top');
                }
            }

            //bottom to top only for ifElse and Send email node
            if (evt.clientY > windowHeightLargeNodes && (elemName === 'SendMail' || elemName === 'IfElse')) {
                if (isNaN(canvasPosTop)) {
                    $('.canvas').css({ 'top': -12000 + 'px' });
                } else {
                    $('.canvas').css({
                        'top': parseInt(-moveToTop) + 'px'
                    }).addClass('transition-top');
                }
            }

            //Top to bottom
            if (evt.clientY < windowHeightTop) {
                if (isNaN(canvasPosTop)) {
                    $('.canvas').css({ 'top': -12000 + 'px' });
                } else {
                    $('.canvas').css({
                        'top': parseInt(canvasPosTop + 100) + 'px'
                    }).addClass('transition-top');
                }
            }

            setTimeout(function () {
                $('.canvas').removeClass('transition-top transition-left');
            }, 1000);
        };

        var _checkIfConnExists = function _checkIfConnExists(conn) {
            var index = -1,
                connId = conn.id;

            for (var i = 0; i < $rootScope.connections.length; i++) {
                if ($rootScope.connections[i].id === connId) {
                    index = i;
                }
            }

            return index;
        };

        var updateConnections = function updateConnections(scopeConnections) {
            //Verify if the connection is new or an update.
            var conIndex = _checkIfConnExists(scopeConnections);
            //Updates the conn if there in an index otherwise push to new in array
            if (conIndex > -1) {
                $rootScope.connections[conIndex] = scopeConnections;
            } else {
                if (scopeConnections.type === 'Entry') {
                    $rootScope.connections.unshift(scopeConnections);
                } else {
                    $rootScope.connections.push(scopeConnections);
                }
            }

            $rootScope.$emit('connectionUpdated', $rootScope.connections);
        };

        var deleteConnection = function deleteConnection(scopeConnections) {
            for (var i = 0; i < $rootScope.connections.length; i++) {
                if ($rootScope.connections[i].id === scopeConnections.id) {
                    $rootScope.connections.splice(i, 1);
                    if (scopeConnections.elemName === 'EmailEngagement' && scopeConnections.type === 'Condition') {
                        $rootScope.$emit('deletedEmailEngagement', scopeConnections.id);
                    }

                    if (scopeConnections.elemName === 'IfElse' && scopeConnections.type === 'Condition') {
                        $rootScope.$emit('deletedIfElse', scopeConnections.id);
                    }

                    $rootScope.$emit('connectionUpdated', $rootScope.connections);

                    return {
                        deleted: true,
                        elem: scopeConnections
                    };
                }
            }
            return false;
        };

        var deleteParent = function deleteParent(id) {
            for (var i = 0; i < $rootScope.connections.length; i++) {
                if ($rootScope.connections[i].parent === id) {
                    delete $rootScope.connections[i].parent;
                }

                if ($rootScope.connections[i].id === id) {
                    delete $rootScope.connections[i].children;
                }
            }
        };

        var reOrderConnections = function reOrderConnections() {
            if (!$rootScope.connections) {
                return;
            }

            var sortedList = [],
                sortedListIds = [],
                noChildrenList = [],
                index = 0,
                current,
                deleteIds = [],
                tempArray = $rootScope.connections.map(function (item) {
                return item;
            });

            while (tempArray.length) {
                current = tempArray[index];

                if (current.isRoot) {
                    sortedList.unshift(current);
                    sortedListIds.unshift(current.id);
                    tempArray.splice(index, 1);
                    index = 0;
                } else if (!current.parent && !current.children) {
                    noChildrenList.push(current);
                    tempArray.splice(index, 1);
                    index = 0;
                } else if (current.parent && !current.children) {
                    if (sortedListIds.indexOf(current.parent) > -1) {
                        sortedList.push(current);
                        sortedListIds.push(current.id);
                        tempArray.splice(index, 1);
                        index = 0;
                    } else {
                        index++;
                    }
                } else {
                    var parentIndex = sortedListIds.indexOf(current.parent);

                    if (parentIndex > -1) {
                        sortedList.splice(parentIndex + 1, 0, current);
                        sortedListIds.splice(parentIndex + 1, 0, current.id);
                        deleteIds.push(index);
                    } else {
                        sortedList.push(current);
                        sortedListIds.push(current.id);
                        deleteIds.push(index);
                    }

                    for (var len = 0; len < current.children.length; len++) {
                        for (var x = 0; x < tempArray.length; x++) {
                            if (tempArray[x].id === current.children[len]) {
                                sortedList.push(tempArray[x]);
                                sortedListIds.push(tempArray[x].id);
                                deleteIds.push(x);
                            }
                        }
                    }

                    deleteIds = deleteIds.sort(function (a, b) {
                        return a - b;
                    });

                    for (var i = deleteIds.length - 1; i >= 0; i--) {
                        tempArray.splice(deleteIds[i], 1);
                    }

                    deleteIds = [];
                    index = 0;
                }
            }

            $rootScope.connections = sortedList.concat(noChildrenList);
        };

        var reOrderConnectionsV2 = function reOrderConnectionsV2(conns) {
            if (!conns.length) {
                return;
            }

            var sortedList = [],
                sortedListIds = [],
                noChildrenList = [],
                index = 0,
                current = void 0,
                deleteIds = [],
                tempArray = conns.map(function (item) {
                return item;
            });

            while (tempArray.length) {
                current = tempArray[index];

                if (current.isRoot) {
                    sortedList.unshift(current);
                    sortedListIds.unshift(current.id);
                    tempArray.splice(index, 1);
                    index = 0;
                } else if (!current.parent && !current.children) {
                    noChildrenList.push(current);
                    tempArray.splice(index, 1);
                    index = 0;
                } else if (current.parent && !current.children) {
                    if (sortedListIds.indexOf(current.parent) > -1) {
                        sortedList.push(current);
                        sortedListIds.push(current.id);
                        tempArray.splice(index, 1);
                        index = 0;
                    } else {
                        index++;
                    }
                } else {
                    var parentIndex = sortedListIds.indexOf(current.parent);

                    if (parentIndex > -1) {
                        sortedList.splice(parentIndex + 1, 0, current);
                        sortedListIds.splice(parentIndex + 1, 0, current.id);
                        deleteIds.push(index);
                    } else {
                        sortedList.push(current);
                        sortedListIds.push(current.id);
                        deleteIds.push(index);
                    }

                    for (var len = 0; len < current.children.length; len++) {
                        for (var x = 0; x < tempArray.length; x++) {
                            if (tempArray[x].id === current.children[len]) {
                                sortedList.push(tempArray[x]);
                                sortedListIds.push(tempArray[x].id);
                                deleteIds.push(x);
                            }
                        }
                    }

                    deleteIds = deleteIds.sort(function (a, b) {
                        return a - b;
                    });

                    for (var i = deleteIds.length - 1; i >= 0; i--) {
                        tempArray.splice(deleteIds[i], 1);
                    }

                    deleteIds = [];
                    index = 0;
                }
            }

            return sortedList.concat(noChildrenList);
        };

        var needsReorder = function needsReorder(conns) {
            //TODO: Implementation
            return true;
        };

        var getNaturalId = function getNaturalId(id) {
            return id.split('_').splice(0, 2).join('_');
        };

        var removeSiblings = function removeSiblings(id) {
            for (var i = 0; i < $rootScope.connections.length; i++) {
                if ($rootScope.connections[i].parent === id) {
                    delete $rootScope.connections[i].parent;
                }
                if ($rootScope.connections[i].children) {
                    if ($rootScope.connections[i].children.length > 0) {
                        for (var j = 0; j < $rootScope.connections[i].children.length; j++) {
                            if ($rootScope.connections[i].children[j] === id) {
                                $rootScope.$emit('displayActionMenuRect', $rootScope.connections[i].dataIndex);
                                $rootScope.connections[i].children.splice(j, 1);
                            }
                        }
                    }

                    if ($rootScope.connections[i].children.length === 0) {
                        delete $rootScope.connections[i].children;
                    }
                }
            }
        };

        var removeChildrenProps = function removeChildrenProps(id) {
            for (var i = 0; i < $rootScope.connections.length; i++) {
                if ($rootScope.connections[i].children) {
                    if ($rootScope.connections[i].children.length > 0) {
                        for (var j = 0; j < $rootScope.connections[i].children.length; j++) {
                            if ($rootScope.connections[i].children[j] === id) {
                                $rootScope.$emit('displayActionMenuRect', $rootScope.connections[i].dataIndex);
                                $rootScope.connections[i].children.splice(j, 1);
                            }
                        }
                    }

                    if ($rootScope.connections[i].children.length === 0) {
                        delete $rootScope.connections[i].children;
                    }
                }
            }
        };

        var getConnectionById = function getConnectionById(id) {
            var result = void 0;
            if ($rootScope.connections.length) {
                result = $rootScope.connections.filter(function (jbItem) {
                    return id === jbItem.id;
                });
            } else {
                result = $rootScope.loaderData.filter(function (jbItem) {
                    return id === getNaturalId(jbItem.id);
                });
            }

            return result[0];
        };

        var getStorageConnectionById = function getStorageConnectionById(id) {
            var connections = JSON.parse(localStorage.getItem('journey'));

            if (!connections) return false;

            for (var i = 0; i < connections.length; i++) {
                if (connections[i].id === id) {
                    return connections[i];
                }
            }
        };

        var getLoaderConnectionById = function getLoaderConnectionById(id) {
            var connections = $rootScope.loaderData,
                uniqueConn = id + '_' + $rootScope.unique,
                result = {};

            for (var i = 0; i < connections.length; i++) {
                if (connections[i].id === id || connections[i].id === uniqueConn) {
                    result = connections[i];
                    break;
                }
            }

            return result;
        };

        var checkIfIsConnected = function checkIfIsConnected(id) {
            for (var i = 0; i < $rootScope.connections.length; i++) {
                if ($rootScope.connections[i].parent === id) {
                    return true;
                }
            }
        };

        var updateParentProp = function updateParentProp(parentId, targetId) {
            for (var i = 0; i < $rootScope.connections.length; i++) {
                if ($rootScope.connections[i].id === targetId) {
                    $rootScope.connections[i].parent = parentId;
                }
            }
        };

        var updateChildrenProp = function updateChildrenProp(parentId, targetId) {
            for (var i = 0; i < $rootScope.connections.length; i++) {
                if ($rootScope.connections[i].id === parentId) {
                    if (!$rootScope.connections[i].children) {
                        $rootScope.connections[i].children = [];
                    }
                    $rootScope.connections[i].children.push(targetId);
                }
            }
        };

        var isEmptyObj = function isEmptyObj(obj) {
            return Object.keys(obj).length === 0;
        };

        var getObjLength = function getObjLength(obj) {
            return Object.keys(obj).length;
        };

        //Function that generates the tracker script
        var generateTrackerScript = function generateTrackerScript(token) {
            var script = ' <!--JB Tracker--> ' + '<script type="text/javascript"> ' + 'var _paq = _paq || []; ' + '(function(){ ' + 'if(window.apScriptInserted) return; ' + '_paq.push([\'clientToken\', \'' + token + '\']); ' + 'var d=document, g=d.createElement(\'script\'), s=d.getElementsByTagName(\'script\')[0]; ' + 'g.type=\'text/javascript\'; g.async=true; g.defer=true; g.src=\'' + TRACKER_URL + '\'; s.parentNode.insertBefore(g,s); window.apScriptInserted=true;' + '})(); ' + '</script> ' + '<!--/JB Tracker--> ';
            return script;
        };

        var getContactListItem = function getContactListItem(key, list, segment) {
            if (list) {
                for (var i = 0; i < list.length; i++) {
                    if (list[i].ListId === key) {
                        return list[i].ListName;
                    }
                }
            }
            if (segment) {
                for (var i = 0; i < segment.length; i++) {
                    if (segment[i].SegmentId === key || segment[i].ListId === key) {
                        return segment[i].SegmentName;
                    }
                }
            }

            if (key === '11111111') {
                return $rootScope.translate('commons.enterDetails');
            }

            return "";
        };

        var getContactsFromList = function getContactsFromList(key, list, segment) {
            if (list) {
                for (var i = 0; i < list.length; i++) {
                    if (list[i].ListId === key) {
                        return list[i].ContactCount;
                    }
                }
            }
            if (segment) {
                for (var i = 0; i < segment.length; i++) {
                    if (segment[i].SegmentId === key) {
                        return segment[i].ContactCount;
                    }
                }
            }
        };

        var jbContainsSendEmail = function jbContainsSendEmail() {
            var emailNodes = [],
                data = $rootScope.connections || {};

            if (!data.length && $rootScope.loaderData) {
                data = $rootScope.loaderData;
            }

            if (data.length) {
                for (var i = 0; i < data.length; i++) {
                    if (data[i].elemName === 'SendMail') {
                        emailNodes.push({
                            'id': getNaturalId(data[i].id),
                            'name': data[i].emailData.EmailName
                        });
                    }
                }
            }

            return emailNodes.length > 0 ? emailNodes : false;
        };

        var isValidJourney = function isValidJourney() {
            var res = {
                unsavedData: [],
                disconnectedElements: [],
                dummyNodes: [],
                hasFacebookAudience: [],
                hasEntry: false
            };

            if ($rootScope.connections.length > 0) {
                // check that there is a entry element
                if ($rootScope.connections[0].type === 'Entry') {
                    res.hasEntry = true;
                }
            }

            // check that all elements are connected or log
            for (var i = 0; i < $rootScope.connections.length; i++) {
                if (!$rootScope.connections[i].parent && $rootScope.connections[i].type !== 'Entry') {
                    res.disconnectedElements.push($rootScope.connections[i].id);
                } else if ($rootScope.connections[i].parent) {
                    var conn = getConnectionById($rootScope.connections[i].parent);
                    if (!conn) {
                        delete $rootScope.connections[i].parent;
                        res.disconnectedElements.push($rootScope.connections[i].id);
                    }
                }
                // checking for dummy data
                if ($rootScope.connections[i].isDummy) {
                    res.dummyNodes.push($rootScope.connections[i].id);
                }

                // checking for dummy data
                if ($rootScope.connections[i].elemName === 'FacebookAudiance') {
                    res.hasFacebookAudience.push($rootScope.connections[i].id);
                }
            }

            // setting the unsaved elements
            if ($rootScope.unsavedData.length > 0) {
                res.unsavedData = $rootScope.unsavedData;
                for (var j = 0; j < res.unsavedData.length; j++) {
                    if (!$('#' + res.unsavedData[j]).hasClass('jsplumb-connected')) {
                        res.disconnectedElements.push(res.unsavedData[j]);
                    }
                }
            }

            // check if there is unsaved data
            res.isValid = res.unsavedData.length === 0 && res.disconnectedElements.length === 0 && res.dummyNodes.length === 0 && res.hasEntry;

            return res;
        };

        var dragChangeState = function dragChangeState(state) {
            $('.canvas').draggable(state);
        };

        var currentScale = {},
            canvasScale = 1;
        var calculateScale = function calculateScale(config) {
            var storageNodes = localStorage.getItem('journey') || false;
            var nodes = storageNodes ? JSON.parse(localStorage.journey) : [];

            if (config) {
                nodes = JSON.parse(config);
            }

            var initTop = 12000;
            var initBottomTop = _.max(_.map(nodes, function (i) {
                return i.top;
            })) + 165;
            var initRightLeft = _.max(_.map(nodes, function (i) {
                return i.left;
            })) + 165;

            var SCALE_WIDTH = 145;
            var SCALE_HEIGHT = 75;

            var width = initRightLeft - initTop;
            var height = initBottomTop - initTop;

            var inMainWindowHeight = false;
            var inMainWindowWidth = false;

            var viewableAreaHeight = window.innerHeight - 70 - 65;
            var viewableAreaWidth = window.innerWidth;

            if (height < viewableAreaHeight) {
                height = viewableAreaHeight;
                inMainWindowHeight = true;
            }

            if (width < viewableAreaWidth) {
                width = viewableAreaWidth;
                inMainWindowWidth = true;
            }

            var x = SCALE_WIDTH / width;
            var y = SCALE_HEIGHT / height;

            if (!nodes.length) {
                x = .13;
                y = .13;
            }

            var dragHeight = 73;
            if (!inMainWindowHeight) {
                dragHeight = y * viewableAreaHeight;
            }

            var dragWidth = 143;
            if (!inMainWindowWidth) {
                dragWidth = x * viewableAreaWidth;
            }

            currentScale = {
                x: x * canvasScale,
                y: y * canvasScale,
                maxLeft: initRightLeft,
                maxBottom: initBottomTop,
                heightInWindow: inMainWindowHeight,
                widthInWindow: inMainWindowWidth,
                viewableHeight: viewableAreaHeight,
                viewableWidth: viewableAreaWidth,
                actualWidth: width,
                actualHeight: height,
                dragWidth: dragWidth,
                dragHeight: dragHeight

            };

            return currentScale;
        };

        var getListBySegmentId = function getListBySegmentId(id) {
            var segments = $rootScope.segmentData || [],
                result = [];

            result = segments.filter(function (segment) {
                return id === segment.SegmentId;
            });

            return result.length ? result[0].ListId : null;
        };

        var getJourneyFirstList = function getJourneyFirstList() {
            var list = 0,
                lists;

            lists = $rootScope.connections.filter(function (conn) {
                return conn.data.selectedList;
            });

            if (lists.length > 0) {
                if (lists[0].elemName !== 'AddedToSegment' && lists[0].elemName !== 'IsInSegment') {
                    list = lists[0].data.selectedList[0];
                }
            }

            return parseInt(list, 10);
        };

        var getMergeTags = function getMergeTags(connections) {
            var tags = connections || $rootScope.connections;
            var conn = _.find(tags, function (conn) {
                return conn.elemName === 'AddedToList' || conn.elemName === 'AddedToSegment' || conn.elemName === 'DateAndTime';
            }),
                lists = $rootScope.contactListData,
                segments = $rootScope.segmentData,
                results = [];

            if (conn && !conn.isDummy) {
                results = conn.data.selectedList.map(function (val) {
                    var name;

                    if (conn.elemName === 'AddedToList' || conn.elemName === 'DateAndTime') {
                        name = lists.filter(function (list) {
                            return val === list.ListId;
                        });

                        results = name.length ? {
                            id: val,
                            name: name[0].ListName || 'N/A'
                        } : {};
                    } else {
                        name = segments.filter(function (segment) {
                            return val === segment.SegmentId;
                        });

                        results = name.length ? {
                            id: name[0].ListId,
                            name: name[0].SegmentName || 'N/A'
                        } : {};
                    }

                    return results;
                });
            }

            return results;
        };

        var move = function move(arr, old_index, new_index) {
            while (old_index < 0) {
                old_index += arr.length;
            }
            while (new_index < 0) {
                new_index += arr.length;
            }
            if (new_index >= arr.length) {
                var k = new_index - arr.length;
                while (k-- + 1) {
                    arr.push(undefined);
                }
            }
            arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
            return arr;
        };

        var createChunks = function createChunks(arr, chunkSize) {
            chunkSize = parseInt(chunkSize);
            var chunkedArr = [];
            var mapAsArray = arr.slice();
            for (var i = 0; i < arr.length; i += chunkSize) {
                var chunked = mapAsArray.slice(i, i + chunkSize);
                chunkedArr.push(chunked);
            }
            return chunkedArr;
        };

        /**
         * Business Rules
         * */
        var readCookie = function readCookie(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1, c.length);
                }
                if (c.indexOf(nameEQ) == 0) {
                    return c.substring(nameEQ.length, c.length);
                }
            }
            return null;
        };

        var getDayDiff = function getDayDiff(activationDate, lastEditOn) {
            var acDate = activationDate === '0001-01-01T00:00:00' ? lastEditOn : activationDate;
            var date1 = new Date(acDate);
            var date2 = new Date();
            var diffTime = Math.abs(date2.getTime() - date1.getTime());
            var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            return diffDays;
        };

        var getRelativeDate = function getRelativeDate(date) {
            moment.updateLocale('en', {
                relativeTime: {
                    past: '%s ago',
                    dd: '%d days',
                    M: 'a month',
                    MM: '%d months',
                    y: 'a year',
                    yy: '%d years'
                }
            });

            var created = moment(date, "MMM D, YYYY");
            var hoursDiff = moment({ hours: 0 }).diff(created, 'hours');
            var timeMessage = void 0;

            if (hoursDiff <= 0) {
                timeMessage = 'Today';
            } else if (hoursDiff >= 24 && hoursDiff < 48) {
                timeMessage = 'Yesterday';
            } else {
                timeMessage = created.fromNow();
            }

            return timeMessage;
        };

        var validateDragging = function validateDragging(conn) {
            var id = conn.children[0];
            var childrenConn = getStorageConnectionById(id);
            if (childrenConn && childrenConn.type != 'Looping') {
                return true;
            } else {
                return false;
            }
        };

        var getFeatureFlags = function getFeatureFlags() {
            var FEATURE_FLAG_API_URL = 'https://fs-api.benchmarkemail.com/v1/flags';

            if (getTestEnvUrls().indexOf(window.location.hostname) > -1) {
                FEATURE_FLAG_API_URL = 'https://hkk2ereied.execute-api.us-west-2.amazonaws.com/v1/flags';
            }
            return $http.get(FEATURE_FLAG_API_URL, {
                headers: { Authorization: $rootScope.jbToken }
            });
        };

        return {
            updatePos: updateElementPosition,
            updateAllPos: updateAllElementPositions,
            fitElementToScreen: fitElementToScreen,
            updateConnections: updateConnections,
            checkIfIsConnected: checkIfIsConnected,
            isEmptyObj: isEmptyObj,
            getObjLength: getObjLength,
            getConnectionById: getConnectionById,
            deleteConnection: deleteConnection,
            generateTrackerScript: generateTrackerScript,
            reOrderConnections: reOrderConnections,
            reOrderConnectionsV2: reOrderConnectionsV2,
            needsReorder: needsReorder,
            removeSiblings: removeSiblings,
            updateParentProp: updateParentProp,
            updateChildrenProp: updateChildrenProp,
            getContactListItem: getContactListItem,
            getContactsFromList: getContactsFromList,
            jbContainsSendEmail: jbContainsSendEmail,
            getJourneyFirstList: getJourneyFirstList,
            isValidJourney: isValidJourney,
            getStorageConnectionById: getStorageConnectionById,
            dragChangeState: dragChangeState,
            deleteParent: deleteParent,
            removeChildrenProps: removeChildrenProps,
            getLoaderConnectionById: getLoaderConnectionById,
            getListBySegmentId: getListBySegmentId,
            getNaturalId: getNaturalId,
            getMergeTags: getMergeTags,
            move: move,
            createChunks: createChunks,
            readCookie: readCookie,
            getDayDiff: getDayDiff,
            getRelativeDate: getRelativeDate,
            validateDragging: validateDragging,
            getFeatureFlags: getFeatureFlags
        };
    }

    function timeZoneFactory(_, moment) {
        return {
            get: function get() {
                var timezoneMap = {};
                _.forEach(moment.tz.names(), function (zoneName) {
                    var tz = moment.tz(zoneName);
                    timezoneMap[zoneName] = {
                        id: zoneName,
                        name: zoneName.replace(/_/g, ' '),
                        offset: 'UTC' + tz.format('Z'),
                        nOffset: tz.utcOffset()
                    };
                });
                return timezoneMap;
            }
        };
    }

    function zoneToCC(_) {
        // Note: zones is populated with the data from 'data/zone.csv' when this file is built
        var zones = [{ "id": "1", "cca2": "AD", "name": "Europe/Andorra" }, { "id": "2", "cca2": "AE", "name": "Asia/Dubai" }, { "id": "3", "cca2": "AF", "name": "Asia/Kabul" }, { "id": "4", "cca2": "AG", "name": "America/Antigua" }, { "id": "5", "cca2": "AI", "name": "America/Anguilla" }, { "id": "6", "cca2": "AL", "name": "Europe/Tirane" }, { "id": "7", "cca2": "AM", "name": "Asia/Yerevan" }, { "id": "8", "cca2": "AO", "name": "Africa/Luanda" }, { "id": "9", "cca2": "AQ", "name": "Antarctica/McMurdo" }, { "id": "10", "cca2": "AQ", "name": "Antarctica/Rothera" }, { "id": "11", "cca2": "AQ", "name": "Antarctica/Palmer" }, { "id": "12", "cca2": "AQ", "name": "Antarctica/Mawson" }, { "id": "13", "cca2": "AQ", "name": "Antarctica/Davis" }, { "id": "14", "cca2": "AQ", "name": "Antarctica/Casey" }, { "id": "15", "cca2": "AQ", "name": "Antarctica/Vostok" }, { "id": "16", "cca2": "AQ", "name": "Antarctica/DumontDUrville" }, { "id": "17", "cca2": "AQ", "name": "Antarctica/Syowa" }, { "id": "18", "cca2": "AQ", "name": "Antarctica/Troll" }, { "id": "19", "cca2": "AR", "name": "America/Argentina/Buenos_Aires" }, { "id": "20", "cca2": "AR", "name": "America/Argentina/Cordoba" }, { "id": "21", "cca2": "AR", "name": "America/Argentina/Salta" }, { "id": "22", "cca2": "AR", "name": "America/Argentina/Jujuy" }, { "id": "23", "cca2": "AR", "name": "America/Argentina/Tucuman" }, { "id": "24", "cca2": "AR", "name": "America/Argentina/Catamarca" }, { "id": "25", "cca2": "AR", "name": "America/Argentina/La_Rioja" }, { "id": "26", "cca2": "AR", "name": "America/Argentina/San_Juan" }, { "id": "27", "cca2": "AR", "name": "America/Argentina/Mendoza" }, { "id": "28", "cca2": "AR", "name": "America/Argentina/San_Luis" }, { "id": "29", "cca2": "AR", "name": "America/Argentina/Rio_Gallegos" }, { "id": "30", "cca2": "AR", "name": "America/Argentina/Ushuaia" }, { "id": "31", "cca2": "AS", "name": "Pacific/Pago_Pago" }, { "id": "32", "cca2": "AT", "name": "Europe/Vienna" }, { "id": "33", "cca2": "AU", "name": "Australia/Lord_Howe" }, { "id": "34", "cca2": "AU", "name": "Antarctica/Macquarie" }, { "id": "35", "cca2": "AU", "name": "Australia/Hobart" }, { "id": "36", "cca2": "AU", "name": "Australia/Currie" }, { "id": "37", "cca2": "AU", "name": "Australia/Melbourne" }, { "id": "38", "cca2": "AU", "name": "Australia/Sydney" }, { "id": "39", "cca2": "AU", "name": "Australia/Broken_Hill" }, { "id": "40", "cca2": "AU", "name": "Australia/Brisbane" }, { "id": "41", "cca2": "AU", "name": "Australia/Lindeman" }, { "id": "42", "cca2": "AU", "name": "Australia/Adelaide" }, { "id": "43", "cca2": "AU", "name": "Australia/Darwin" }, { "id": "44", "cca2": "AU", "name": "Australia/Perth" }, { "id": "45", "cca2": "AU", "name": "Australia/Eucla" }, { "id": "46", "cca2": "AW", "name": "America/Aruba" }, { "id": "47", "cca2": "AX", "name": "Europe/Mariehamn" }, { "id": "48", "cca2": "AZ", "name": "Asia/Baku" }, { "id": "49", "cca2": "BA", "name": "Europe/Sarajevo" }, { "id": "50", "cca2": "BB", "name": "America/Barbados" }, { "id": "51", "cca2": "BD", "name": "Asia/Dhaka" }, { "id": "52", "cca2": "BE", "name": "Europe/Brussels" }, { "id": "53", "cca2": "BF", "name": "Africa/Ouagadougou" }, { "id": "54", "cca2": "BG", "name": "Europe/Sofia" }, { "id": "55", "cca2": "BH", "name": "Asia/Bahrain" }, { "id": "56", "cca2": "BI", "name": "Africa/Bujumbura" }, { "id": "57", "cca2": "BJ", "name": "Africa/Porto-Novo" }, { "id": "58", "cca2": "BL", "name": "America/St_Barthelemy" }, { "id": "59", "cca2": "BM", "name": "Atlantic/Bermuda" }, { "id": "60", "cca2": "BN", "name": "Asia/Brunei" }, { "id": "61", "cca2": "BO", "name": "America/La_Paz" }, { "id": "62", "cca2": "BQ", "name": "America/Kralendijk" }, { "id": "63", "cca2": "BR", "name": "America/Noronha" }, { "id": "64", "cca2": "BR", "name": "America/Belem" }, { "id": "65", "cca2": "BR", "name": "America/Fortaleza" }, { "id": "66", "cca2": "BR", "name": "America/Recife" }, { "id": "67", "cca2": "BR", "name": "America/Araguaina" }, { "id": "68", "cca2": "BR", "name": "America/Maceio" }, { "id": "69", "cca2": "BR", "name": "America/Bahia" }, { "id": "70", "cca2": "BR", "name": "America/Sao_Paulo" }, { "id": "71", "cca2": "BR", "name": "America/Campo_Grande" }, { "id": "72", "cca2": "BR", "name": "America/Cuiaba" }, { "id": "73", "cca2": "BR", "name": "America/Santarem" }, { "id": "74", "cca2": "BR", "name": "America/Porto_Velho" }, { "id": "75", "cca2": "BR", "name": "America/Boa_Vista" }, { "id": "76", "cca2": "BR", "name": "America/Manaus" }, { "id": "77", "cca2": "BR", "name": "America/Eirunepe" }, { "id": "78", "cca2": "BR", "name": "America/Rio_Branco" }, { "id": "79", "cca2": "BS", "name": "America/Nassau" }, { "id": "80", "cca2": "BT", "name": "Asia/Thimphu" }, { "id": "81", "cca2": "BW", "name": "Africa/Gaborone" }, { "id": "82", "cca2": "BY", "name": "Europe/Minsk" }, { "id": "83", "cca2": "BZ", "name": "America/Belize" }, { "id": "84", "cca2": "CA", "name": "America/St_Johns" }, { "id": "85", "cca2": "CA", "name": "America/Halifax" }, { "id": "86", "cca2": "CA", "name": "America/Glace_Bay" }, { "id": "87", "cca2": "CA", "name": "America/Moncton" }, { "id": "88", "cca2": "CA", "name": "America/Goose_Bay" }, { "id": "89", "cca2": "CA", "name": "America/Blanc-Sablon" }, { "id": "90", "cca2": "CA", "name": "America/Toronto" }, { "id": "91", "cca2": "CA", "name": "America/Nipigon" }, { "id": "92", "cca2": "CA", "name": "America/Thunder_Bay" }, { "id": "93", "cca2": "CA", "name": "America/Iqaluit" }, { "id": "94", "cca2": "CA", "name": "America/Pangnirtung" }, { "id": "95", "cca2": "CA", "name": "America/Resolute" }, { "id": "96", "cca2": "CA", "name": "America/Atikokan" }, { "id": "97", "cca2": "CA", "name": "America/Rankin_Inlet" }, { "id": "98", "cca2": "CA", "name": "America/Winnipeg" }, { "id": "99", "cca2": "CA", "name": "America/Rainy_River" }, { "id": "100", "cca2": "CA", "name": "America/Regina" }, { "id": "101", "cca2": "CA", "name": "America/Swift_Current" }, { "id": "102", "cca2": "CA", "name": "America/Edmonton" }, { "id": "103", "cca2": "CA", "name": "America/Cambridge_Bay" }, { "id": "104", "cca2": "CA", "name": "America/Yellowknife" }, { "id": "105", "cca2": "CA", "name": "America/Inuvik" }, { "id": "106", "cca2": "CA", "name": "America/Creston" }, { "id": "107", "cca2": "CA", "name": "America/Dawson_Creek" }, { "id": "108", "cca2": "CA", "name": "America/Vancouver" }, { "id": "109", "cca2": "CA", "name": "America/Whitehorse" }, { "id": "110", "cca2": "CA", "name": "America/Dawson" }, { "id": "111", "cca2": "CC", "name": "Indian/Cocos" }, { "id": "112", "cca2": "CD", "name": "Africa/Kinshasa" }, { "id": "113", "cca2": "CD", "name": "Africa/Lubumbashi" }, { "id": "114", "cca2": "CF", "name": "Africa/Bangui" }, { "id": "115", "cca2": "CG", "name": "Africa/Brazzaville" }, { "id": "116", "cca2": "CH", "name": "Europe/Zurich" }, { "id": "117", "cca2": "CI", "name": "Africa/Abidjan" }, { "id": "118", "cca2": "CK", "name": "Pacific/Rarotonga" }, { "id": "119", "cca2": "CL", "name": "America/Santiago" }, { "id": "120", "cca2": "CL", "name": "Pacific/Easter" }, { "id": "121", "cca2": "CM", "name": "Africa/Douala" }, { "id": "122", "cca2": "CN", "name": "Asia/Shanghai" }, { "id": "123", "cca2": "CN", "name": "Asia/Harbin" }, { "id": "124", "cca2": "CN", "name": "Asia/Chongqing" }, { "id": "125", "cca2": "CN", "name": "Asia/Urumqi" }, { "id": "126", "cca2": "CN", "name": "Asia/Kashgar" }, { "id": "127", "cca2": "CO", "name": "America/Bogota" }, { "id": "128", "cca2": "CR", "name": "America/Costa_Rica" }, { "id": "129", "cca2": "CU", "name": "America/Havana" }, { "id": "130", "cca2": "CV", "name": "Atlantic/Cape_Verde" }, { "id": "131", "cca2": "CW", "name": "America/Curacao" }, { "id": "132", "cca2": "CX", "name": "Indian/Christmas" }, { "id": "133", "cca2": "CY", "name": "Asia/Nicosia" }, { "id": "134", "cca2": "CZ", "name": "Europe/Prague" }, { "id": "135", "cca2": "DE", "name": "Europe/Berlin" }, { "id": "136", "cca2": "DE", "name": "Europe/Busingen" }, { "id": "137", "cca2": "DJ", "name": "Africa/Djibouti" }, { "id": "138", "cca2": "DK", "name": "Europe/Copenhagen" }, { "id": "139", "cca2": "DM", "name": "America/Dominica" }, { "id": "140", "cca2": "DO", "name": "America/Santo_Domingo" }, { "id": "141", "cca2": "DZ", "name": "Africa/Algiers" }, { "id": "142", "cca2": "EC", "name": "America/Guayaquil" }, { "id": "143", "cca2": "EC", "name": "Pacific/Galapagos" }, { "id": "144", "cca2": "EE", "name": "Europe/Tallinn" }, { "id": "145", "cca2": "EG", "name": "Africa/Cairo" }, { "id": "146", "cca2": "EH", "name": "Africa/El_Aaiun" }, { "id": "147", "cca2": "ER", "name": "Africa/Asmara" }, { "id": "148", "cca2": "ES", "name": "Europe/Madrid" }, { "id": "149", "cca2": "ES", "name": "Africa/Ceuta" }, { "id": "150", "cca2": "ES", "name": "Atlantic/Canary" }, { "id": "151", "cca2": "ET", "name": "Africa/Addis_Ababa" }, { "id": "152", "cca2": "FI", "name": "Europe/Helsinki" }, { "id": "153", "cca2": "FJ", "name": "Pacific/Fiji" }, { "id": "154", "cca2": "FK", "name": "Atlantic/Stanley" }, { "id": "155", "cca2": "FM", "name": "Pacific/Chuuk" }, { "id": "156", "cca2": "FM", "name": "Pacific/Pohnpei" }, { "id": "157", "cca2": "FM", "name": "Pacific/Kosrae" }, { "id": "158", "cca2": "FO", "name": "Atlantic/Faroe" }, { "id": "159", "cca2": "FR", "name": "Europe/Paris" }, { "id": "160", "cca2": "GA", "name": "Africa/Libreville" }, { "id": "161", "cca2": "GB", "name": "Europe/London" }, { "id": "162", "cca2": "GD", "name": "America/Grenada" }, { "id": "163", "cca2": "GE", "name": "Asia/Tbilisi" }, { "id": "164", "cca2": "GF", "name": "America/Cayenne" }, { "id": "165", "cca2": "GG", "name": "Europe/Guernsey" }, { "id": "166", "cca2": "GH", "name": "Africa/Accra" }, { "id": "167", "cca2": "GI", "name": "Europe/Gibraltar" }, { "id": "168", "cca2": "GL", "name": "America/Godthab" }, { "id": "169", "cca2": "GL", "name": "America/Danmarkshavn" }, { "id": "170", "cca2": "GL", "name": "America/Scoresbysund" }, { "id": "171", "cca2": "GL", "name": "America/Thule" }, { "id": "172", "cca2": "GM", "name": "Africa/Banjul" }, { "id": "173", "cca2": "GN", "name": "Africa/Conakry" }, { "id": "174", "cca2": "GP", "name": "America/Guadeloupe" }, { "id": "175", "cca2": "GQ", "name": "Africa/Malabo" }, { "id": "176", "cca2": "GR", "name": "Europe/Athens" }, { "id": "177", "cca2": "GS", "name": "Atlantic/South_Georgia" }, { "id": "178", "cca2": "GT", "name": "America/Guatemala" }, { "id": "179", "cca2": "GU", "name": "Pacific/Guam" }, { "id": "180", "cca2": "GW", "name": "Africa/Bissau" }, { "id": "181", "cca2": "GY", "name": "America/Guyana" }, { "id": "182", "cca2": "HK", "name": "Asia/Hong_Kong" }, { "id": "183", "cca2": "HN", "name": "America/Tegucigalpa" }, { "id": "184", "cca2": "HR", "name": "Europe/Zagreb" }, { "id": "185", "cca2": "HT", "name": "America/Port-au-Prince" }, { "id": "186", "cca2": "HU", "name": "Europe/Budapest" }, { "id": "187", "cca2": "ID", "name": "Asia/Jakarta" }, { "id": "188", "cca2": "ID", "name": "Asia/Pontianak" }, { "id": "189", "cca2": "ID", "name": "Asia/Makassar" }, { "id": "190", "cca2": "ID", "name": "Asia/Jayapura" }, { "id": "191", "cca2": "IE", "name": "Europe/Dublin" }, { "id": "192", "cca2": "IL", "name": "Asia/Jerusalem" }, { "id": "193", "cca2": "IM", "name": "Europe/Isle_of_Man" }, { "id": "194", "cca2": "IN", "name": "Asia/Kolkata" }, { "id": "195", "cca2": "IO", "name": "Indian/Chagos" }, { "id": "196", "cca2": "IQ", "name": "Asia/Baghdad" }, { "id": "197", "cca2": "IR", "name": "Asia/Tehran" }, { "id": "198", "cca2": "IS", "name": "Atlantic/Reykjavik" }, { "id": "199", "cca2": "IT", "name": "Europe/Rome" }, { "id": "200", "cca2": "JE", "name": "Europe/Jersey" }, { "id": "201", "cca2": "JM", "name": "America/Jamaica" }, { "id": "202", "cca2": "JO", "name": "Asia/Amman" }, { "id": "203", "cca2": "JP", "name": "Asia/Tokyo" }, { "id": "204", "cca2": "KE", "name": "Africa/Nairobi" }, { "id": "205", "cca2": "KG", "name": "Asia/Bishkek" }, { "id": "206", "cca2": "KH", "name": "Asia/Phnom_Penh" }, { "id": "207", "cca2": "KI", "name": "Pacific/Tarawa" }, { "id": "208", "cca2": "KI", "name": "Pacific/Enderbury" }, { "id": "209", "cca2": "KI", "name": "Pacific/Kiritimati" }, { "id": "210", "cca2": "KM", "name": "Indian/Comoro" }, { "id": "211", "cca2": "KN", "name": "America/St_Kitts" }, { "id": "212", "cca2": "KP", "name": "Asia/Pyongyang" }, { "id": "213", "cca2": "KR", "name": "Asia/Seoul" }, { "id": "214", "cca2": "KW", "name": "Asia/Kuwait" }, { "id": "215", "cca2": "KY", "name": "America/Cayman" }, { "id": "216", "cca2": "KZ", "name": "Asia/Almaty" }, { "id": "217", "cca2": "KZ", "name": "Asia/Qyzylorda" }, { "id": "218", "cca2": "KZ", "name": "Asia/Aqtobe" }, { "id": "219", "cca2": "KZ", "name": "Asia/Aqtau" }, { "id": "220", "cca2": "KZ", "name": "Asia/Oral" }, { "id": "221", "cca2": "LA", "name": "Asia/Vientiane" }, { "id": "222", "cca2": "LB", "name": "Asia/Beirut" }, { "id": "223", "cca2": "LC", "name": "America/St_Lucia" }, { "id": "224", "cca2": "LI", "name": "Europe/Vaduz" }, { "id": "225", "cca2": "LK", "name": "Asia/Colombo" }, { "id": "226", "cca2": "LR", "name": "Africa/Monrovia" }, { "id": "227", "cca2": "LS", "name": "Africa/Maseru" }, { "id": "228", "cca2": "LT", "name": "Europe/Vilnius" }, { "id": "229", "cca2": "LU", "name": "Europe/Luxembourg" }, { "id": "230", "cca2": "LV", "name": "Europe/Riga" }, { "id": "231", "cca2": "LY", "name": "Africa/Tripoli" }, { "id": "232", "cca2": "MA", "name": "Africa/Casablanca" }, { "id": "233", "cca2": "MC", "name": "Europe/Monaco" }, { "id": "234", "cca2": "MD", "name": "Europe/Chisinau" }, { "id": "235", "cca2": "ME", "name": "Europe/Podgorica" }, { "id": "236", "cca2": "MF", "name": "America/Marigot" }, { "id": "237", "cca2": "MG", "name": "Indian/Antananarivo" }, { "id": "238", "cca2": "MH", "name": "Pacific/Majuro" }, { "id": "239", "cca2": "MH", "name": "Pacific/Kwajalein" }, { "id": "240", "cca2": "MK", "name": "Europe/Skopje" }, { "id": "241", "cca2": "ML", "name": "Africa/Bamako" }, { "id": "242", "cca2": "MM", "name": "Asia/Rangoon" }, { "id": "243", "cca2": "MN", "name": "Asia/Ulaanbaatar" }, { "id": "244", "cca2": "MN", "name": "Asia/Hovd" }, { "id": "245", "cca2": "MN", "name": "Asia/Choibalsan" }, { "id": "246", "cca2": "MO", "name": "Asia/Macau" }, { "id": "247", "cca2": "MP", "name": "Pacific/Saipan" }, { "id": "248", "cca2": "MQ", "name": "America/Martinique" }, { "id": "249", "cca2": "MR", "name": "Africa/Nouakchott" }, { "id": "250", "cca2": "MS", "name": "America/Montserrat" }, { "id": "251", "cca2": "MT", "name": "Europe/Malta" }, { "id": "252", "cca2": "MU", "name": "Indian/Mauritius" }, { "id": "253", "cca2": "MV", "name": "Indian/Maldives" }, { "id": "254", "cca2": "MW", "name": "Africa/Blantyre" }, { "id": "255", "cca2": "MX", "name": "America/Mexico_City" }, { "id": "256", "cca2": "MX", "name": "America/Cancun" }, { "id": "257", "cca2": "MX", "name": "America/Merida" }, { "id": "258", "cca2": "MX", "name": "America/Monterrey" }, { "id": "259", "cca2": "MX", "name": "America/Matamoros" }, { "id": "260", "cca2": "MX", "name": "America/Mazatlan" }, { "id": "261", "cca2": "MX", "name": "America/Chihuahua" }, { "id": "262", "cca2": "MX", "name": "America/Ojinaga" }, { "id": "263", "cca2": "MX", "name": "America/Hermosillo" }, { "id": "264", "cca2": "MX", "name": "America/Tijuana" }, { "id": "265", "cca2": "MX", "name": "America/Santa_Isabel" }, { "id": "266", "cca2": "MX", "name": "America/Bahia_Banderas" }, { "id": "267", "cca2": "MY", "name": "Asia/Kuala_Lumpur" }, { "id": "268", "cca2": "MY", "name": "Asia/Kuching" }, { "id": "269", "cca2": "MZ", "name": "Africa/Maputo" }, { "id": "270", "cca2": "NA", "name": "Africa/Windhoek" }, { "id": "271", "cca2": "NC", "name": "Pacific/Noumea" }, { "id": "272", "cca2": "NE", "name": "Africa/Niamey" }, { "id": "273", "cca2": "NF", "name": "Pacific/Norfolk" }, { "id": "274", "cca2": "NG", "name": "Africa/Lagos" }, { "id": "275", "cca2": "NI", "name": "America/Managua" }, { "id": "276", "cca2": "NL", "name": "Europe/Amsterdam" }, { "id": "277", "cca2": "NO", "name": "Europe/Oslo" }, { "id": "278", "cca2": "NP", "name": "Asia/Kathmandu" }, { "id": "279", "cca2": "NR", "name": "Pacific/Nauru" }, { "id": "280", "cca2": "NU", "name": "Pacific/Niue" }, { "id": "281", "cca2": "NZ", "name": "Pacific/Auckland" }, { "id": "282", "cca2": "NZ", "name": "Pacific/Chatham" }, { "id": "283", "cca2": "OM", "name": "Asia/Muscat" }, { "id": "284", "cca2": "PA", "name": "America/Panama" }, { "id": "285", "cca2": "PE", "name": "America/Lima" }, { "id": "286", "cca2": "PF", "name": "Pacific/Tahiti" }, { "id": "287", "cca2": "PF", "name": "Pacific/Marquesas" }, { "id": "288", "cca2": "PF", "name": "Pacific/Gambier" }, { "id": "289", "cca2": "PG", "name": "Pacific/Port_Moresby" }, { "id": "290", "cca2": "PH", "name": "Asia/Manila" }, { "id": "291", "cca2": "PK", "name": "Asia/Karachi" }, { "id": "292", "cca2": "PL", "name": "Europe/Warsaw" }, { "id": "293", "cca2": "PM", "name": "America/Miquelon" }, { "id": "294", "cca2": "PN", "name": "Pacific/Pitcairn" }, { "id": "295", "cca2": "PR", "name": "America/Puerto_Rico" }, { "id": "296", "cca2": "PS", "name": "Asia/Gaza" }, { "id": "297", "cca2": "PS", "name": "Asia/Hebron" }, { "id": "298", "cca2": "PT", "name": "Europe/Lisbon" }, { "id": "299", "cca2": "PT", "name": "Atlantic/Madeira" }, { "id": "300", "cca2": "PT", "name": "Atlantic/Azores" }, { "id": "301", "cca2": "PW", "name": "Pacific/Palau" }, { "id": "302", "cca2": "PY", "name": "America/Asuncion" }, { "id": "303", "cca2": "QA", "name": "Asia/Qatar" }, { "id": "304", "cca2": "RE", "name": "Indian/Reunion" }, { "id": "305", "cca2": "RO", "name": "Europe/Bucharest" }, { "id": "306", "cca2": "RS", "name": "Europe/Belgrade" }, { "id": "307", "cca2": "RU", "name": "Europe/Kaliningrad" }, { "id": "308", "cca2": "RU", "name": "Europe/Moscow" }, { "id": "309", "cca2": "RU", "name": "Europe/Volgograd" }, { "id": "310", "cca2": "RU", "name": "Europe/Samara" }, { "id": "311", "cca2": "RU", "name": "Europe/Simferopol" }, { "id": "312", "cca2": "RU", "name": "Asia/Yekaterinburg" }, { "id": "313", "cca2": "RU", "name": "Asia/Omsk" }, { "id": "314", "cca2": "RU", "name": "Asia/Novosibirsk" }, { "id": "315", "cca2": "RU", "name": "Asia/Novokuznetsk" }, { "id": "316", "cca2": "RU", "name": "Asia/Krasnoyarsk" }, { "id": "317", "cca2": "RU", "name": "Asia/Irkutsk" }, { "id": "318", "cca2": "RU", "name": "Asia/Yakutsk" }, { "id": "319", "cca2": "RU", "name": "Asia/Khandyga" }, { "id": "320", "cca2": "RU", "name": "Asia/Vladivostok" }, { "id": "321", "cca2": "RU", "name": "Asia/Sakhalin" }, { "id": "322", "cca2": "RU", "name": "Asia/Ust-Nera" }, { "id": "323", "cca2": "RU", "name": "Asia/Magadan" }, { "id": "324", "cca2": "RU", "name": "Asia/Kamchatka" }, { "id": "325", "cca2": "RU", "name": "Asia/Anadyr" }, { "id": "326", "cca2": "RW", "name": "Africa/Kigali" }, { "id": "327", "cca2": "SA", "name": "Asia/Riyadh" }, { "id": "328", "cca2": "SB", "name": "Pacific/Guadalcanal" }, { "id": "329", "cca2": "SC", "name": "Indian/Mahe" }, { "id": "330", "cca2": "SD", "name": "Africa/Khartoum" }, { "id": "331", "cca2": "SE", "name": "Europe/Stockholm" }, { "id": "332", "cca2": "SG", "name": "Asia/Singapore" }, { "id": "333", "cca2": "SH", "name": "Atlantic/St_Helena" }, { "id": "334", "cca2": "SI", "name": "Europe/Ljubljana" }, { "id": "335", "cca2": "SJ", "name": "Arctic/Longyearbyen" }, { "id": "336", "cca2": "SK", "name": "Europe/Bratislava" }, { "id": "337", "cca2": "SL", "name": "Africa/Freetown" }, { "id": "338", "cca2": "SM", "name": "Europe/San_Marino" }, { "id": "339", "cca2": "SN", "name": "Africa/Dakar" }, { "id": "340", "cca2": "SO", "name": "Africa/Mogadishu" }, { "id": "341", "cca2": "SR", "name": "America/Paramaribo" }, { "id": "342", "cca2": "SS", "name": "Africa/Juba" }, { "id": "343", "cca2": "ST", "name": "Africa/Sao_Tome" }, { "id": "344", "cca2": "SV", "name": "America/El_Salvador" }, { "id": "345", "cca2": "SX", "name": "America/Lower_Princes" }, { "id": "346", "cca2": "SY", "name": "Asia/Damascus" }, { "id": "347", "cca2": "SZ", "name": "Africa/Mbabane" }, { "id": "348", "cca2": "TC", "name": "America/Grand_Turk" }, { "id": "349", "cca2": "TD", "name": "Africa/Ndjamena" }, { "id": "350", "cca2": "TF", "name": "Indian/Kerguelen" }, { "id": "351", "cca2": "TG", "name": "Africa/Lome" }, { "id": "352", "cca2": "TH", "name": "Asia/Bangkok" }, { "id": "353", "cca2": "TJ", "name": "Asia/Dushanbe" }, { "id": "354", "cca2": "TK", "name": "Pacific/Fakaofo" }, { "id": "355", "cca2": "TL", "name": "Asia/Dili" }, { "id": "356", "cca2": "TM", "name": "Asia/Ashgabat" }, { "id": "357", "cca2": "TN", "name": "Africa/Tunis" }, { "id": "358", "cca2": "TO", "name": "Pacific/Tongatapu" }, { "id": "359", "cca2": "TR", "name": "Europe/Istanbul" }, { "id": "360", "cca2": "TT", "name": "America/Port_of_Spain" }, { "id": "361", "cca2": "TV", "name": "Pacific/Funafuti" }, { "id": "362", "cca2": "TW", "name": "Asia/Taipei" }, { "id": "363", "cca2": "TZ", "name": "Africa/Dar_es_Salaam" }, { "id": "364", "cca2": "UA", "name": "Europe/Kiev" }, { "id": "365", "cca2": "UA", "name": "Europe/Uzhgorod" }, { "id": "366", "cca2": "UA", "name": "Europe/Zaporozhye" }, { "id": "367", "cca2": "UG", "name": "Africa/Kampala" }, { "id": "368", "cca2": "UM", "name": "Pacific/Johnston" }, { "id": "369", "cca2": "UM", "name": "Pacific/Midway" }, { "id": "370", "cca2": "UM", "name": "Pacific/Wake" }, { "id": "371", "cca2": "US", "name": "America/New_York" }, { "id": "372", "cca2": "US", "name": "America/Detroit" }, { "id": "373", "cca2": "US", "name": "America/Kentucky/Louisville" }, { "id": "374", "cca2": "US", "name": "America/Kentucky/Monticello" }, { "id": "375", "cca2": "US", "name": "America/Indiana/Indianapolis" }, { "id": "376", "cca2": "US", "name": "America/Indiana/Vincennes" }, { "id": "377", "cca2": "US", "name": "America/Indiana/Winamac" }, { "id": "378", "cca2": "US", "name": "America/Indiana/Marengo" }, { "id": "379", "cca2": "US", "name": "America/Indiana/Petersburg" }, { "id": "380", "cca2": "US", "name": "America/Indiana/Vevay" }, { "id": "381", "cca2": "US", "name": "America/Chicago" }, { "id": "382", "cca2": "US", "name": "America/Indiana/Tell_City" }, { "id": "383", "cca2": "US", "name": "America/Indiana/Knox" }, { "id": "384", "cca2": "US", "name": "America/Menominee" }, { "id": "385", "cca2": "US", "name": "America/North_Dakota/Center" }, { "id": "386", "cca2": "US", "name": "America/North_Dakota/New_Salem" }, { "id": "387", "cca2": "US", "name": "America/North_Dakota/Beulah" }, { "id": "388", "cca2": "US", "name": "America/Denver" }, { "id": "389", "cca2": "US", "name": "America/Boise" }, { "id": "390", "cca2": "US", "name": "America/Phoenix" }, { "id": "391", "cca2": "US", "name": "America/Los_Angeles" }, { "id": "392", "cca2": "US", "name": "America/Anchorage" }, { "id": "393", "cca2": "US", "name": "America/Juneau" }, { "id": "394", "cca2": "US", "name": "America/Sitka" }, { "id": "395", "cca2": "US", "name": "America/Yakutat" }, { "id": "396", "cca2": "US", "name": "America/Nome" }, { "id": "397", "cca2": "US", "name": "America/Adak" }, { "id": "398", "cca2": "US", "name": "America/Metlakatla" }, { "id": "399", "cca2": "US", "name": "Pacific/Honolulu" }, { "id": "400", "cca2": "UY", "name": "America/Montevideo" }, { "id": "401", "cca2": "UZ", "name": "Asia/Samarkand" }, { "id": "402", "cca2": "UZ", "name": "Asia/Tashkent" }, { "id": "403", "cca2": "VA", "name": "Europe/Vatican" }, { "id": "404", "cca2": "VC", "name": "America/St_Vincent" }, { "id": "405", "cca2": "VE", "name": "America/Caracas" }, { "id": "406", "cca2": "VG", "name": "America/Tortola" }, { "id": "407", "cca2": "VI", "name": "America/St_Thomas" }, { "id": "408", "cca2": "VN", "name": "Asia/Ho_Chi_Minh" }, { "id": "409", "cca2": "VU", "name": "Pacific/Efate" }, { "id": "410", "cca2": "WF", "name": "Pacific/Wallis" }, { "id": "411", "cca2": "WS", "name": "Pacific/Apia" }, { "id": "412", "cca2": "YE", "name": "Asia/Aden" }, { "id": "413", "cca2": "YT", "name": "Indian/Mayotte" }, { "id": "414", "cca2": "ZA", "name": "Africa/Johannesburg" }, { "id": "415", "cca2": "ZM", "name": "Africa/Lusaka" }, { "id": "416", "cca2": "ZW", "name": "Africa/Harare" }, { "id": "417", "cca2": "CA", "name": "America/Montreal" }];
        var zoneMap = {};
        _.forEach(zones, function (zone) {
            zoneMap[zone.name] = zone.cca2;
        });
        return zoneMap;
    }

    function CCToCountryName(_) {
        // Note: codes is populated with the data from 'data/cca2_to_country_name.csv' when this file is built
        var codes = [{ "cca2": "AF", "name": "Afghanistan" }, { "cca2": "AX", "name": "Aland Islands" }, { "cca2": "AL", "name": "Albania" }, { "cca2": "DZ", "name": "Algeria" }, { "cca2": "AS", "name": "American Samoa" }, { "cca2": "AD", "name": "Andorra" }, { "cca2": "AO", "name": "Angola" }, { "cca2": "AI", "name": "Anguilla" }, { "cca2": "AQ", "name": "Antarctica" }, { "cca2": "AG", "name": "Antigua And Barbuda" }, { "cca2": "AR", "name": "Argentina" }, { "cca2": "AM", "name": "Armenia" }, { "cca2": "AW", "name": "Aruba" }, { "cca2": "AU", "name": "Australia" }, { "cca2": "AT", "name": "Austria" }, { "cca2": "AZ", "name": "Azerbaijan" }, { "cca2": "BS", "name": "Bahamas" }, { "cca2": "BH", "name": "Bahrain" }, { "cca2": "BD", "name": "Bangladesh" }, { "cca2": "BB", "name": "Barbados" }, { "cca2": "BY", "name": "Belarus" }, { "cca2": "BE", "name": "Belgium" }, { "cca2": "BZ", "name": "Belize" }, { "cca2": "BJ", "name": "Benin" }, { "cca2": "BM", "name": "Bermuda" }, { "cca2": "BT", "name": "Bhutan" }, { "cca2": "BO", "name": "Bolivia" }, { "cca2": "BA", "name": "Bosnia And Herzegovina" }, { "cca2": "BW", "name": "Botswana" }, { "cca2": "BV", "name": "Bouvet Island" }, { "cca2": "BR", "name": "Brazil" }, { "cca2": "IO", "name": "British Indian Ocean Territory" }, { "cca2": "BN", "name": "Brunei Darussalam" }, { "cca2": "BG", "name": "Bulgaria" }, { "cca2": "BF", "name": "Burkina Faso" }, { "cca2": "BI", "name": "Burundi" }, { "cca2": "KH", "name": "Cambodia" }, { "cca2": "CM", "name": "Cameroon" }, { "cca2": "CA", "name": "Canada" }, { "cca2": "CV", "name": "Cape Verde" }, { "cca2": "KY", "name": "Cayman Islands" }, { "cca2": "CF", "name": "Central African Republic" }, { "cca2": "TD", "name": "Chad" }, { "cca2": "CL", "name": "Chile" }, { "cca2": "CN", "name": "China" }, { "cca2": "CX", "name": "Christmas Island" }, { "cca2": "CC", "name": "Cocos (Keeling) Islands" }, { "cca2": "CO", "name": "Colombia" }, { "cca2": "KM", "name": "Comoros" }, { "cca2": "CG", "name": "Congo" }, { "cca2": "CD", "name": "Congo (Democratic Republic)" }, { "cca2": "CK", "name": "Cook Islands" }, { "cca2": "CR", "name": "Costa Rica" }, { "cca2": "CI", "name": "Cote D'Ivoire" }, { "cca2": "HR", "name": "Croatia" }, { "cca2": "CU", "name": "Cuba" }, { "cca2": "CY", "name": "Cyprus" }, { "cca2": "CZ", "name": "Czech Republic" }, { "cca2": "DK", "name": "Denmark" }, { "cca2": "DJ", "name": "Djibouti" }, { "cca2": "DM", "name": "Dominica" }, { "cca2": "DO", "name": "Dominican Republic" }, { "cca2": "EC", "name": "Ecuador" }, { "cca2": "EG", "name": "Egypt" }, { "cca2": "SV", "name": "El Salvador" }, { "cca2": "GQ", "name": "Equatorial Guinea" }, { "cca2": "ER", "name": "Eritrea" }, { "cca2": "EE", "name": "Estonia" }, { "cca2": "ET", "name": "Ethiopia" }, { "cca2": "FK", "name": "Falkland Islands (Malvinas)" }, { "cca2": "FO", "name": "Faroe Islands" }, { "cca2": "FJ", "name": "Fiji" }, { "cca2": "FI", "name": "Finland" }, { "cca2": "FR", "name": "France" }, { "cca2": "GF", "name": "French Guiana" }, { "cca2": "PF", "name": "French Polynesia" }, { "cca2": "TF", "name": "French Southern Territories" }, { "cca2": "GA", "name": "Gabon" }, { "cca2": "GM", "name": "Gambia" }, { "cca2": "GE", "name": "Georgia" }, { "cca2": "DE", "name": "Germany" }, { "cca2": "GH", "name": "Ghana" }, { "cca2": "GI", "name": "Gibraltar" }, { "cca2": "GR", "name": "Greece" }, { "cca2": "GL", "name": "Greenland" }, { "cca2": "GD", "name": "Grenada" }, { "cca2": "GP", "name": "Guadeloupe" }, { "cca2": "GU", "name": "Guam" }, { "cca2": "GT", "name": "Guatemala" }, { "cca2": "GG", "name": "Guernsey" }, { "cca2": "GN", "name": "Guinea" }, { "cca2": "GW", "name": "Guinea-Bissau" }, { "cca2": "GY", "name": "Guyana" }, { "cca2": "HT", "name": "Haiti" }, { "cca2": "HM", "name": "Heard Island & Mcdonald Islands" }, { "cca2": "VA", "name": "Holy See (Vatican City State)" }, { "cca2": "HN", "name": "Honduras" }, { "cca2": "HK", "name": "Hong Kong" }, { "cca2": "HU", "name": "Hungary" }, { "cca2": "IS", "name": "Iceland" }, { "cca2": "IN", "name": "India" }, { "cca2": "ID", "name": "Indonesia" }, { "cca2": "IR", "name": "Iran (Islamic Republic Of)" }, { "cca2": "IQ", "name": "Iraq" }, { "cca2": "IE", "name": "Ireland" }, { "cca2": "IM", "name": "Isle Of Man" }, { "cca2": "IL", "name": "Israel" }, { "cca2": "IT", "name": "Italy" }, { "cca2": "JM", "name": "Jamaica" }, { "cca2": "JP", "name": "Japan" }, { "cca2": "JE", "name": "Jersey" }, { "cca2": "JO", "name": "Jordan" }, { "cca2": "KZ", "name": "Kazakhstan" }, { "cca2": "KE", "name": "Kenya" }, { "cca2": "KI", "name": "Kiribati" }, { "cca2": "KR", "name": "Korea" }, { "cca2": "KW", "name": "Kuwait" }, { "cca2": "KG", "name": "Kyrgyzstan" }, { "cca2": "LA", "name": "Lao People's Democratic Republic" }, { "cca2": "LV", "name": "Latvia" }, { "cca2": "LB", "name": "Lebanon" }, { "cca2": "LS", "name": "Lesotho" }, { "cca2": "LR", "name": "Liberia" }, { "cca2": "LY", "name": "Libyan Arab Jamahiriya" }, { "cca2": "LI", "name": "Liechtenstein" }, { "cca2": "LT", "name": "Lithuania" }, { "cca2": "LU", "name": "Luxembourg" }, { "cca2": "MO", "name": "Macao" }, { "cca2": "MK", "name": "Macedonia" }, { "cca2": "MG", "name": "Madagascar" }, { "cca2": "MW", "name": "Malawi" }, { "cca2": "MY", "name": "Malaysia" }, { "cca2": "MV", "name": "Maldives" }, { "cca2": "ML", "name": "Mali" }, { "cca2": "MT", "name": "Malta" }, { "cca2": "MH", "name": "Marshall Islands" }, { "cca2": "MQ", "name": "Martinique" }, { "cca2": "MR", "name": "Mauritania" }, { "cca2": "MU", "name": "Mauritius" }, { "cca2": "YT", "name": "Mayotte" }, { "cca2": "MX", "name": "Mexico" }, { "cca2": "FM", "name": "Micronesia (Federated States Of)" }, { "cca2": "MD", "name": "Moldova" }, { "cca2": "MC", "name": "Monaco" }, { "cca2": "MN", "name": "Mongolia" }, { "cca2": "ME", "name": "Montenegro" }, { "cca2": "MS", "name": "Montserrat" }, { "cca2": "MA", "name": "Morocco" }, { "cca2": "MZ", "name": "Mozambique" }, { "cca2": "MM", "name": "Myanmar" }, { "cca2": "NA", "name": "Namibia" }, { "cca2": "NR", "name": "Nauru" }, { "cca2": "NP", "name": "Nepal" }, { "cca2": "NL", "name": "Netherlands" }, { "cca2": "AN", "name": "Netherlands Antilles" }, { "cca2": "NC", "name": "New Caledonia" }, { "cca2": "NZ", "name": "New Zealand" }, { "cca2": "NI", "name": "Nicaragua" }, { "cca2": "NE", "name": "Niger" }, { "cca2": "NG", "name": "Nigeria" }, { "cca2": "NU", "name": "Niue" }, { "cca2": "NF", "name": "Norfolk Island" }, { "cca2": "MP", "name": "Northern Mariana Islands" }, { "cca2": "NO", "name": "Norway" }, { "cca2": "OM", "name": "Oman" }, { "cca2": "PK", "name": "Pakistan" }, { "cca2": "PW", "name": "Palau" }, { "cca2": "PS", "name": "Palestinian Territory (Occupied)" }, { "cca2": "PA", "name": "Panama" }, { "cca2": "PG", "name": "Papua New Guinea" }, { "cca2": "PY", "name": "Paraguay" }, { "cca2": "PE", "name": "Peru" }, { "cca2": "PH", "name": "Philippines" }, { "cca2": "PN", "name": "Pitcairn" }, { "cca2": "PL", "name": "Poland" }, { "cca2": "PT", "name": "Portugal" }, { "cca2": "PR", "name": "Puerto Rico" }, { "cca2": "QA", "name": "Qatar" }, { "cca2": "RE", "name": "Reunion" }, { "cca2": "RO", "name": "Romania" }, { "cca2": "RU", "name": "Russian Federation" }, { "cca2": "RW", "name": "Rwanda" }, { "cca2": "BL", "name": "Saint Barthelemy" }, { "cca2": "SH", "name": "Saint Helena" }, { "cca2": "KN", "name": "Saint Kitts And Nevis" }, { "cca2": "LC", "name": "Saint Lucia" }, { "cca2": "MF", "name": "Saint Martin" }, { "cca2": "PM", "name": "Saint Pierre And Miquelon" }, { "cca2": "VC", "name": "Saint Vincent And Grenadines" }, { "cca2": "WS", "name": "Samoa" }, { "cca2": "SM", "name": "San Marino" }, { "cca2": "ST", "name": "Sao Tome And Principe" }, { "cca2": "SA", "name": "Saudi Arabia" }, { "cca2": "SN", "name": "Senegal" }, { "cca2": "RS", "name": "Serbia" }, { "cca2": "SC", "name": "Seychelles" }, { "cca2": "SL", "name": "Sierra Leone" }, { "cca2": "SG", "name": "Singapore" }, { "cca2": "SK", "name": "Slovakia" }, { "cca2": "SI", "name": "Slovenia" }, { "cca2": "SB", "name": "Solomon Islands" }, { "cca2": "SO", "name": "Somalia" }, { "cca2": "SS", "name": "South Sudan" }, { "cca2": "ZA", "name": "South Africa" }, { "cca2": "GS", "name": "South Georgia And Sandwich Isl." }, { "cca2": "ES", "name": "Spain" }, { "cca2": "LK", "name": "Sri Lanka" }, { "cca2": "SD", "name": "Sudan" }, { "cca2": "SR", "name": "Suriname" }, { "cca2": "SJ", "name": "Svalbard And Jan Mayen" }, { "cca2": "SZ", "name": "Swaziland" }, { "cca2": "SE", "name": "Sweden" }, { "cca2": "CH", "name": "Switzerland" }, { "cca2": "SY", "name": "Syrian Arab Republic" }, { "cca2": "TW", "name": "Taiwan" }, { "cca2": "TJ", "name": "Tajikistan" }, { "cca2": "TZ", "name": "Tanzania" }, { "cca2": "TH", "name": "Thailand" }, { "cca2": "TL", "name": "Timor-Leste" }, { "cca2": "TG", "name": "Togo" }, { "cca2": "TK", "name": "Tokelau" }, { "cca2": "TO", "name": "Tonga" }, { "cca2": "TT", "name": "Trinidad And Tobago" }, { "cca2": "TN", "name": "Tunisia" }, { "cca2": "TR", "name": "Turkey" }, { "cca2": "TM", "name": "Turkmenistan" }, { "cca2": "TC", "name": "Turks And Caicos Islands" }, { "cca2": "TV", "name": "Tuvalu" }, { "cca2": "UG", "name": "Uganda" }, { "cca2": "UA", "name": "Ukraine" }, { "cca2": "AE", "name": "United Arab Emirates" }, { "cca2": "GB", "name": "United Kingdom" }, { "cca2": "US", "name": "United States" }, { "cca2": "UM", "name": "United States Outlying Islands" }, { "cca2": "UY", "name": "Uruguay" }, { "cca2": "UZ", "name": "Uzbekistan" }, { "cca2": "VU", "name": "Vanuatu" }, { "cca2": "VE", "name": "Venezuela" }, { "cca2": "VN", "name": "Viet Nam" }, { "cca2": "VG", "name": "Virgin Islands (British)" }, { "cca2": "VI", "name": "Virgin Islands (U.S.)" }, { "cca2": "WF", "name": "Wallis And Futuna" }, { "cca2": "EH", "name": "Western Sahara" }, { "cca2": "YE", "name": "Yemen" }, { "cca2": "ZM", "name": "Zambia" }, { "cca2": "ZW", "name": "Zimbabwe" }, { "cca2": "SX", "name": "Sint Maarten" }, { "cca2": "CW", "name": "Curacao" }, { "cca2": "BQ", "name": "Bonaire" }, { "cca2": "KP", "name": "North Korea" }];
        var codeMap = {};
        _.forEach(codes, function (code) {
            codeMap[code.cca2] = code.name;
        });
        return codeMap;
    }

    //Function to load data on scroll (Used on Home Controller)
    function scrollLoader($rootScope, $http, canvasService, cacheService, AUTH_EVENTS) {

        var scrollLoader = function scrollLoader(isTemplate) {
            $rootScope.rawDashboardData = [];

            this.resList = [];
            this.busy = false;
            this.offset = 0;
            this.limit = 10;
            this.stopLoading = false;
            this.isTemplate = isTemplate || false;
            this.noResults = false;
        };

        scrollLoader.prototype.nextPage = function () {
            if (this.busy) return;
            this.busy = true;

            if (!this.stopLoading) {
                processData = processData.bind(this);

                var listPromise = this.isTemplate ? canvasService.getPaginateTemplates(this.limit, this.offset) : canvasService.getPaginateJourneys(this.limit, this.offset);

                listPromise.success(processData).catch(function (err, status) {
                    console.log(err, status);
                    if (err.status === 401) {
                        window.location = AUTH_EVENTS.benchmarkUi;
                    } else {
                        Intercom('trackEvent', 'AP-ERROR-404', {
                            description: 'Trigger this event whenever a user will be redirected to 404',
                            metadata: {
                                api: 'homepage list loading',
                                errStatus: err.status
                            }
                        });

                        window.location = AUTH_EVENTS.maintenancePage;
                    }
                });
            } else {
                this.busy = false;
            }

            function processData(data) {
                var resultsLength = data.Results.length;
                var listLength = this.resList.length;

                // sets single jb cache
                if (data.Metadata.ResultSet.Offset === '0') {
                    this.stopLoading = true;
                }

                if (listLength == 0) {
                    this.resList.push(data.Results);
                } else if (resultsLength > 0 && listLength > 0) {
                    if (this.isTemplate) {
                        for (var i = 0; i < resultsLength; i++) {
                            this.resList[0].push(data.Results[i]);
                        }
                    } else {
                        this.resList.push(data.Results);
                    }
                }

                if (resultsLength && !this.isTemplate) {
                    $rootScope.rawDashboardData = _.uniqBy($rootScope.rawDashboardData.concat(data.Results), 'Id');
                    $rootScope.$emit('resultUpdated');
                }

                if (!resultsLength && !listLength) {
                    this.noResults = true;
                }

                this.offset = data.Metadata.ResultSet.Offset;
                this.busy = false;
            }
        };

        return scrollLoader;
    }

    //Function to load data on scroll (Used on Home Controller)
    function scrollLoaderEmails(canvasService) {

        var scrollLoaderEmails = function scrollLoaderEmails() {
            this.resList = [];
            this.busy = false;
            this.offset = 2;
            this.limit = 5;
            this.stopLoading = false;
        };

        scrollLoaderEmails.prototype.nextPage = function () {
            if (this.busy) return;
            this.busy = true;

            if (!this.stopLoading) {
                var listPromise = canvasService.getEmailList(this.offset, this.limit);

                listPromise.success(function (data) {
                    var resultsLength = data.Results.length;
                    var listLength = this.resList.length;

                    if (!resultsLength) {
                        this.stopLoading = true;
                    } else {
                        this.resList = data.Results;
                    }

                    this.offset += 1;
                    this.busy = false;
                }.bind(this));
            } else {
                this.busy = false;
            }
        };

        return scrollLoaderEmails;
    }

    function getTestEnvUrls() {
        return ['jbdev.benchmarkemail.com', 'apbeta.benchmarkemail.com', 'aptest.benchmarkemail.com'];
    }

    function getBmeUrl() {
        var url = 'https://app.benchmarkemail.com/automationpro';

        if (getTestEnvUrls().indexOf(window.location.hostname) > -1) {
            url = 'https://test4.benchmarkemail.com/automationpro';
        }

        return url;
    }

    function getJbTrackerUrl() {
        var url = window.location.origin + '/tracker.bundle.js';

        if (getTestEnvUrls().indexOf(window.location.hostname) > -1) {
            url = window.location.origin + '/tracker-test.bundle.js';
        }

        return url;
    }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
    __webpack_require__(250);
    __webpack_require__(254);
    __webpack_require__(255);
    __webpack_require__(252);
    __webpack_require__(249);
    __webpack_require__(248);
    __webpack_require__(251);
}();

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    angular.module('journey.tracker', []).factory('trackerService', ['$http', '$templateCache', trackerService]);

    function trackerService($http, $templateCache) {
        var getUserTrackerJourneys = function getUserTrackerJourneys() {
            return $http({ method: 'GET', url: 'app/services/mocks/userJourneys.json' });
        };

        return {
            getUserTracker: getUserTrackerJourneys
        };
    }
})();

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    angular.module('journey.veil', []).service('veilService', [veilService]);

    function veilService() {

        //Flag to initialize veil
        var showVeil = false;

        //Display Veil
        this.displayVeil = function () {
            showVeil = true;
        };

        //Hide Veil
        this.hideVeil = function () {
            showVeil = false;
        };

        //Current Veil State
        this.veilState = function () {
            return showVeil;
        };
    }
})();

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var emojiPickerIcons = exports.emojiPickerIcons = {
    emoji_group_name_1: "Smileys & People",
    emoji_group_list_1: [["😀", "Grinning Face"], ["😁", "Beaming Face With Smiling Eyes"], ["😂", "Face With Tears of Joy"], ["😃", "Grinning Face With Big Eyes"], ["😄", "Grinning Face With Smiling Eyes"], ["😅", "Grinning Face With Sweat"], ["😆", "Grinning Squinting Face"], ["😉", "Winking Face"], ["😊", "Smiling Face With Smiling Eyes"], ["😋", "Face Savoring Food"], ["😎", "Smiling Face With Sunglasses"], ["😍", "Smiling Face With Heart-Eyes"], ["😘", "Face Blowing a Kiss"], ["😗", "Kissing Face"], ["😙", "Kissing Face With Smiling Eyes"], ["😚", "Kissing Face With Closed Eyes"], ["☺", "Smiling Face"], ["🙂", "Slightly Smiling Face"], ["🤗", "Hugging Face"], ["🤔", "Thinking Face"], ["😐", "Neutral Face"], ["😑", "Expressionless Face"], ["😶", "Face Without Mouth"], ["🙄", "Face With Rolling Eyes"], ["😏", "Smirking Face"], ["😣", "Persevering Face"], ["😥", "Sad but Relieved Face"], ["😮", "Face With Open Mouth"], ["🤐", "Zipper-Mouth Face"], ["😯", "Hushed Face"], ["😪", "Sleepy Face"], ["😫", "Tired Face"], ["😴", "Sleeping Face"], ["😌", "Relieved Face"], ["😛", "Face With Tongue"], ["😜", "Winking Face With Tongue"], ["😝", "Squinting Face With Tongue"], ["😒", "Unamused Face"], ["😓", "Downcast Face With Sweat"], ["😔", "Pensive Face"], ["😕", "Confused Face"], ["🙃", "Upside-Down Face"], ["🤑", "Money-Mouth Face"], ["😲", "Astonished Face"], ["☹", "Frowning Face"], ["🙁", "Slightly Frowning Face"], ["😖", "Confounded Face"], ["😞", "Disappointed Face"], ["😟", "Worried Face"], ["😤", "Face With Steam From Nose"], ["😢", "Crying Face"], ["😭", "Loudly Crying Face"], ["😦", "Frowning Face With Open Mouth"], ["😧", "Anguished Face"], ["😨", "Fearful Face"], ["😩", "Weary Face"], ["😬", "Grimacing Face"], ["😰", "Anxious Face With Sweat"], ["😱", "Face Screaming in Fear"], ["😳", "Flushed Face"], ["😵", "Dizzy Face"], ["😡", "Pouting Face"], ["😠", "Angry Face"], ["😷", "Face With Medical Mask"], ["🤒", "Face With Thermometer"], ["🤕", "Face With Head-Bandage"], ["😇", "Smiling Face With Halo"], ["🤓", "Nerd Face"], ["😈", "Smiling Face With Horns"], ["👿", "Angry Face With Horns"], ["👹", "Ogre"], ["👺", "Goblin"], ["💀", "Skull"], ["☠", "Skull and Crossbones"], ["👻", "Ghost"], ["👽", "Alien"], ["👾", "Alien Monster"], ["🤖", "Robot Face"], ["💩", "Pile of Poo"], ["😺", "Grinning Cat Face"], ["😸", "Grinning Cat Face With Smiling Eyes"], ["😹", "Cat Face With Tears of Joy"], ["😻", "Smiling Cat Face With Heart-Eyes"], ["😼", "Cat Face With Wry Smile"], ["😽", "Kissing Cat Face"], ["🙀", "Weary Cat Face"], ["😿", "Crying Cat Face"], ["😾", "Pouting Cat Face"], ["🙈", "See-No-Evil Monkey"], ["🙉", "Hear-No-Evil Monkey"], ["🙊", "Speak-No-Evil Monkey"], ["👶", "Baby"], ["👦", "Boy"], ["👧", "Girl"], ["👨", "Man"], ["👩", "Woman"], ["👴", "Old Man"], ["👵", "Old Woman"], ["👮", "Police Officer"], ["🕵", "Detective"], ["💂", "Guard"], ["👷", "Construction Worker"], ["👸", "Princess"], ["👳", "Person Wearing Turban"], ["👲", "Man With Chinese Cap"], ["👱", "Blond-Haired Person"], ["👰", "Bride With Veil"], ["👼", "Baby Angel"], ["🎅", "Santa Claus"], ["🙍", "Person Frowning"], ["🙎", "Person Pouting"], ["🙅", "Person Gesturing No"], ["🙆", "Person Gesturing OK"], ["💁", "Person Tipping Hand"], ["🙋", "Person Raising Hand"], ["🙇", "Person Bowing"], ["💆", "Person Getting Massage"], ["💇", "Person Getting Haircut"], ["🚶", "Person Walking"], ["🏃", "Person Running"], ["💃", "Woman Dancing"], ["👯", "People With Bunny Ears"], ["🛀", "Person Taking Bath"], ["🛌", "Person in Bed"], ["🕴", "Man in Suit Levitating"], ["🗣", "Speaking Head"], ["👤", "Bust in Silhouette"], ["👥", "Busts in Silhouette"], ["🏇", "Horse Racing"], ["⛷", "Skier"], ["🏂", "Snowboarder"], ["🏌", "Person Golfing"], ["🏄", "Person Surfing"], ["🚣", "Person Rowing Boat"], ["🏊", "Person Swimming"], ["⛹", "Person Bouncing Ball"], ["🏋", "Person Lifting Weights"], ["🚴", "Person Biking"], ["🚵", "Person Mountain Biking"], ["🏎", "Racing Car"], ["🏍", "Motorcycle"], ["👫", "Man and Woman Holding Hands"], ["👬", "Two Men Holding Hands"], ["👭", "Two Women Holding Hands"], ["💏", "Kiss"], ["💑", "Couple With Heart"], ["👪", "Family"], ["💪", "Flexed Biceps"], ["👈", "Backhand Index Pointing Left"], ["👉", "Backhand Index Pointing Right"], ["☝", "Index Pointing Up"], ["👆", "Backhand Index Pointing Up"], ["🖕", "Middle Finger"], ["👇", "Backhand Index Pointing Down"], ["✌", "Victory Hand"], ["🖖", "Vulcan Salute"], ["🤘", "Sign of the Horns"], ["🖐", "Hand With Fingers Splayed"], ["✋", "Raised Hand"], ["👌", "OK Hand"], ["👍", "Thumbs Up"], ["👎", "Thumbs Down"], ["✊", "Raised Fist"], ["👊", "Oncoming Fist"], ["👋", "Waving Hand"], ["✍", "Writing Hand"], ["👏", "Clapping Hands"], ["👐", "Open Hands"], ["🙌", "Raising Hands"], ["🙏", "Folded Hands"], ["💅", "Nail Polish"], ["👂", "Ear"], ["👃", "Nose"], ["👣", "Footprints"], ["👀", "Eyes"], ["👁", "Eye"], ["👅", "Tongue"], ["👄", "Mouth"], ["💋", "Kiss Mark"], ["💘", "Heart With Arrow"], ["❤", "Red Heart"], ["💓", "Beating Heart"], ["💔", "Broken Heart"], ["💕", "Two Hearts"], ["💖", "Sparkling Heart"], ["💗", "Growing Heart"], ["💙", "Blue Heart"], ["💚", "Green Heart"], ["💛", "Yellow Heart"], ["💜", "Purple Heart"], ["💝", "Heart With Ribbon"], ["💞", "Revolving Hearts"], ["💟", "Heart Decoration"], ["❣", "Heavy Heart Exclamation"], ["💌", "Love Letter"], ["💤", "Zzz"], ["💢", "Anger Symbol"], ["💣", "Bomb"], ["💥", "Collision"], ["💦", "Sweat Droplets"], ["💨", "Dashing Away"], ["💫", "Dizzy"], ["💬", "Speech Balloon"], ["🗯", "Right Anger Bubble"], ["💭", "Thought Balloon"], ["🕳", "Hole"], ["👓", "Glasses"], ["🕶", "Sunglasses"], ["👔", "Necktie"], ["👕", "T-Shirt"], ["👖", "Jeans"], ["👗", "Dress"], ["👘", "Kimono"], ["👙", "Bikini"], ["👚", "Woman’s Clothes"], ["👛", "Purse"], ["👜", "Handbag"], ["👝", "Clutch Bag"], ["🛍", "Shopping Bags"], ["🎒", "School Backpack"], ["👞", "Man’s Shoe"], ["👟", "Running Shoe"], ["👠", "High-Heeled Shoe"], ["👡", "Woman’s Sandal"], ["👢", "Woman’s Boot"], ["👑", "Crown"], ["👒", "Woman’s Hat"], ["🎩", "Top Hat"], ["🎓", "Graduation Cap"], ["⛑", "Rescue Worker’s Helmet"], ["📿", "Prayer Beads"], ["💄", "Lipstick"], ["💍", "Ring"], ["💎", "Gem Stone"]],
    emoji_group_name_2: "Animals & Nature",
    emoji_group_list_2: [["🐵", "Monkey Face"], ["🐒", "Monkey"], ["🐶", "Dog Face"], ["🐕", "Dog"], ["🐩", "Poodle"], ["🐺", "Wolf Face"], ["🐱", "Cat Face"], ["🐈", "Cat"], ["🦁", "Lion Face"], ["🐯", "Tiger Face"], ["🐅", "Tiger"], ["🐆", "Leopard"], ["🐴", "Horse Face"], ["🐎", "Horse"], ["🦄", "Unicorn Face"], ["🐮", "Cow Face"], ["🐂", "Ox"], ["🐃", "Water Buffalo"], ["🐄", "Cow"], ["🐷", "Pig Face"], ["🐖", "Pig"], ["🐗", "Boar"], ["🐽", "Pig Nose"], ["🐏", "Ram"], ["🐑", "Ewe"], ["🐐", "Goat"], ["🐪", "Camel"], ["🐫", "Two-Hump Camel"], ["🐘", "Elephant"], ["🐭", "Mouse Face"], ["🐁", "Mouse"], ["🐀", "Rat"], ["🐹", "Hamster Face"], ["🐰", "Rabbit Face"], ["🐇", "Rabbit"], ["🐿", "Chipmunk"], ["🐻", "Bear Face"], ["🐨", "Koala"], ["🐼", "Panda Face"], ["🐾", "Paw Prints"], ["🦃", "Turkey"], ["🐔", "Chicken"], ["🐓", "Rooster"], ["🐣", "Hatching Chick"], ["🐤", "Baby Chick"], ["🐥", "Front-Facing Baby Chick"], ["🐦", "Bird"], ["🐧", "Penguin"], ["🕊", "Dove"], ["🐸", "Frog Face"], ["🐊", "Crocodile"], ["🐢", "Turtle"], ["🐍", "Snake"], ["🐲", "Dragon Face"], ["🐉", "Dragon"], ["🐳", "Spouting Whale"], ["🐋", "Whale"], ["🐬", "Dolphin"], ["🐟", "Fish"], ["🐠", "Tropical Fish"], ["🐡", "Blowfish"], ["🐙", "Octopus"], ["🐚", "Spiral Shell"], ["🦀", "Crab"], ["🐌", "Snail"], ["🐛", "Bug"], ["🐜", "Ant"], ["🐝", "Honeybee"], ["🐞", "Lady Beetle"], ["🕷", "Spider"], ["🕸", "Spider Web"], ["🦂", "Scorpion"], ["💐", "Bouquet"], ["🌸", "Cherry Blossom"], ["💮", "White Flower"], ["🏵", "Rosette"], ["🌹", "Rose"], ["🌺", "Hibiscus"], ["🌻", "Sunflower"], ["🌼", "Blossom"], ["🌷", "Tulip"], ["🌱", "Seedling"], ["🌲", "Evergreen Tree"], ["🌳", "Deciduous Tree"], ["🌴", "Palm Tree"], ["🌵", "Cactus"], ["🌾", "Sheaf of Rice"], ["🌿", "Herb"], ["☘", "Shamrock"], ["🍀", "Four Leaf Clover"], ["🍁", "Maple Leaf"], ["🍂", "Fallen Leaf"], ["🍃", "Leaf Fluttering in Wind"]],
    emoji_group_name_3: "Food & Drink",
    emoji_group_list_3: [["🍇", "Grapes"], ["🍈", "Melon"], ["🍉", "Watermelon"], ["🍊", "Tangerine"], ["🍋", "Lemon"], ["🍌", "Banana"], ["🍍", "Pineapple"], ["🍎", "Red Apple"], ["🍏", "Green Apple"], ["🍐", "Pear"], ["🍑", "Peach"], ["🍒", "Cherries"], ["🍓", "Strawberry"], ["🍅", "Tomato"], ["🍆", "Eggplant"], ["🌽", "Ear of Corn"], ["🌶", "Hot Pepper"], ["🍄", "Mushroom"], ["🌰", "Chestnut"], ["🍞", "Bread"], ["🧀", "Cheese Wedge"], ["🍖", "Meat on Bone"], ["🍗", "Poultry Leg"], ["🍔", "Hamburger"], ["🍟", "French Fries"], ["🍕", "Pizza"], ["🌭", "Hot Dog"], ["🌮", "Taco"], ["🌯", "Burrito"], ["🍳", "Cooking"], ["🍲", "Pot of Food"], ["🍿", "Popcorn"], ["🍱", "Bento Box"], ["🍘", "Rice Cracker"], ["🍙", "Rice Ball"], ["🍚", "Cooked Rice"], ["🍛", "Curry Rice"], ["🍜", "Steaming Bowl"], ["🍝", "Spaghetti"], ["🍠", "Roasted Sweet Potato"], ["🍢", "Oden"], ["🍣", "Sushi"], ["🍤", "Fried Shrimp"], ["🍥", "Fish Cake With Swirl"], ["🍡", "Dango"], ["🍦", "Soft Ice Cream"], ["🍧", "Shaved Ice"], ["🍨", "Ice Cream"], ["🍩", "Doughnut"], ["🍪", "Cookie"], ["🎂", "Birthday Cake"], ["🍰", "Shortcake"], ["🍫", "Chocolate Bar"], ["🍬", "Candy"], ["🍭", "Lollipop"], ["🍮", "Custard"], ["🍯", "Honey Pot"], ["🍼", "Baby Bottle"], ["☕", "Hot Beverage"], ["🍵", "Teacup Without Handle"], ["🍶", "Sake"], ["🍾", "Bottle With Popping Cork"], ["🍷", "Wine Glass"], ["🍸", "Cocktail Glass"], ["🍹", "Tropical Drink"], ["🍺", "Beer Mug"], ["🍻", "Clinking Beer Mugs"], ["🍽", "Fork and Knife With Plate"], ["🍴", "Fork and Knife"], ["🔪", "Kitchen Knife"], ["🏺", "Amphora"]],
    emoji_group_name_4: "Activity",
    emoji_group_list_4: [["🎃", "Jack-O-Lantern"], ["🎄", "Christmas Tree"], ["🎆", "Fireworks"], ["🎇", "Sparkler"], ["✨", "Sparkles"], ["🎈", "Balloon"], ["🎉", "Party Popper"], ["🎊", "Confetti Ball"], ["🎋", "Tanabata Tree"], ["🎍", "Pine Decoration"], ["🎎", "Japanese Dolls"], ["🎏", "Carp Streamer"], ["🎐", "Wind Chime"], ["🎑", "Moon Viewing Ceremony"], ["🎀", "Ribbon"], ["🎁", "Wrapped Gift"], ["🎗", "Reminder Ribbon"], ["🎟", "Admission Tickets"], ["🎫", "Ticket"], ["🎖", "Military Medal"], ["🏆", "Trophy"], ["🏅", "Sports Medal"], ["⚽", "Soccer Ball"], ["⚾", "Baseball"], ["🏀", "Basketball"], ["🏐", "Volleyball"], ["🏈", "American Football"], ["🏉", "Rugby Football"], ["🎾", "Tennis"], ["🎳", "Bowling"], ["🏏", "Cricket Game"], ["🏑", "Field Hockey"], ["🏒", "Ice Hockey"], ["🏓", "Ping Pong"], ["🏸", "Badminton"], ["⛳", "Flag in Hole"], ["⛸", "Ice Skate"], ["🎣", "Fishing Pole"], ["🎽", "Running Shirt"], ["🎿", "Skis"], ["🎯", "Direct Hit"], ["🎱", "Pool 8 Ball"], ["🔮", "Crystal Ball"], ["🎮", "Video Game"], ["🕹", "Joystick"], ["🎰", "Slot Machine"], ["🎲", "Game Die"], ["♠", "Spade Suit"], ["♥", "Heart Suit"], ["♦", "Diamond Suit"], ["♣", "Club Suit"], ["🃏", "Joker"], ["🀄", "Mahjong Red Dragon"], ["🎴", "Flower Playing Cards"], ["🎭", "Performing Arts"], ["🖼", "Framed Picture"], ["🎨", "Artist Palette"]],
    emoji_group_name_5: "Travel & Places",
    emoji_group_list_5: [["🌍", "Globe Showing Europe-Africa"], ["🌎", "Globe Showing Americas"], ["🌏", "Globe Showing Asia-Australia"], ["🌐", "Globe With Meridians"], ["🗺", "World Map"], ["🗾", "Map of Japan"], ["🏔", "Snow-Capped Mountain"], ["⛰", "Mountain"], ["🌋", "Volcano"], ["🗻", "Mount Fuji"], ["🏕", "Camping"], ["🏖", "Beach With Umbrella"], ["🏜", "Desert"], ["🏝", "Desert Island"], ["🏞", "National Park"], ["🏟", "Stadium"], ["🏛", "Classical Building"], ["🏗", "Building Construction"], ["🏘", "Houses"], ["🏚", "Derelict House"], ["🏠", "House"], ["🏡", "House With Garden"], ["🏢", "Office Building"], ["🏣", "Japanese Post Office"], ["🏤", "Post Office"], ["🏥", "Hospital"], ["🏦", "Bank"], ["🏨", "Hotel"], ["🏩", "Love Hotel"], ["🏪", "Convenience Store"], ["🏫", "School"], ["🏬", "Department Store"], ["🏭", "Factory"], ["🏯", "Japanese Castle"], ["🏰", "Castle"], ["💒", "Wedding"], ["🗼", "Tokyo Tower"], ["🗽", "Statue of Liberty"], ["⛪", "Church"], ["🕌", "Mosque"], ["🕍", "Synagogue"], ["⛩", "Shinto Shrine"], ["🕋", "Kaaba"], ["⛲", "Fountain"], ["⛺", "Tent"], ["🌁", "Foggy"], ["🌃", "Night With Stars"], ["🏙", "Cityscape"], ["🌄", "Sunrise Over Mountains"], ["🌅", "Sunrise"], ["🌆", "Cityscape at Dusk"], ["🌇", "Sunset"], ["🌉", "Bridge at Night"], ["♨", "Hot Springs"], ["🌌", "Milky Way"], ["🎠", "Carousel Horse"], ["🎡", "Ferris Wheel"], ["🎢", "Roller Coaster"], ["💈", "Barber Pole"], ["🎪", "Circus Tent"], ["🚂", "Locomotive"], ["🚃", "Railway Car"], ["🚄", "High-Speed Train"], ["🚅", "Bullet Train"], ["🚆", "Train"], ["🚇", "Metro"], ["🚈", "Light Rail"], ["🚉", "Station"], ["🚊", "Tram"], ["🚝", "Monorail"], ["🚞", "Mountain Railway"], ["🚋", "Tram Car"], ["🚌", "Bus"], ["🚍", "Oncoming Bus"], ["🚎", "Trolleybus"], ["🚐", "Minibus"], ["🚑", "Ambulance"], ["🚒", "Fire Engine"], ["🚓", "Police Car"], ["🚔", "Oncoming Police Car"], ["🚕", "Taxi"], ["🚖", "Oncoming Taxi"], ["🚗", "Automobile"], ["🚘", "Oncoming Automobile"], ["🚙", "Sport Utility Vehicle"], ["🚚", "Delivery Truck"], ["🚛", "Articulated Lorry"], ["🚜", "Tractor"], ["🚲", "Bicycle"], ["🚏", "Bus Stop"], ["🛣", "Motorway"], ["🛤", "Railway Track"], ["🛢", "Oil Drum"], ["⛽", "Fuel Pump"], ["🚨", "Police Car Light"], ["🚥", "Horizontal Traffic Light"], ["🚦", "Vertical Traffic Light"], ["🚧", "Construction"], ["⚓", "Anchor"], ["⛵", "Sailboat"], ["🚤", "Speedboat"], ["🛳", "Passenger Ship"], ["⛴", "Ferry"], ["🛥", "Motor Boat"], ["🚢", "Ship"], ["✈", "Airplane"], ["🛩", "Small Airplane"], ["🛫", "Airplane Departure"], ["🛬", "Airplane Arrival"], ["💺", "Seat"], ["🚁", "Helicopter"], ["🚟", "Suspension Railway"], ["🚠", "Mountain Cableway"], ["🚡", "Aerial Tramway"], ["🛰", "Satellite"], ["🚀", "Rocket"], ["🛎", "Bellhop Bell"], ["⌛", "Hourglass Done"], ["⏳", "Hourglass Not Done"], ["⌚", "Watch"], ["⏰", "Alarm Clock"], ["⏱", "Stopwatch"], ["⏲", "Timer Clock"], ["🕰", "Mantelpiece Clock"], ["🕛", "Twelve O’clock"], ["🕧", "Twelve-Thirty"], ["🕐", "One O’clock"], ["🕜", "One-Thirty"], ["🕑", "Two O’clock"], ["🕝", "Two-Thirty"], ["🕒", "Three O’clock"], ["🕞", "Three-Thirty"], ["🕓", "Four O’clock"], ["🕟", "Four-Thirty"], ["🕔", "Five O’clock"], ["🕠", "Five-Thirty"], ["🕕", "Six O’clock"], ["🕡", "Six-Thirty"], ["🕖", "Seven O’clock"], ["🕢", "Seven-Thirty"], ["🕗", "Eight O’clock"], ["🕣", "Eight-Thirty"], ["🕘", "Nine O’clock"], ["🕤", "Nine-Thirty"], ["🕙", "Ten O’clock"], ["🕥", "Ten-Thirty"], ["🕚", "Eleven O’clock"], ["🕦", "Eleven-Thirty"], ["🌑", "New Moon"], ["🌒", "Waxing Crescent Moon"], ["🌓", "First Quarter Moon"], ["🌔", "Waxing Gibbous Moon"], ["🌕", "Full Moon"], ["🌖", "Waning Gibbous Moon"], ["🌗", "Last Quarter Moon"], ["🌘", "Waning Crescent Moon"], ["🌙", "Crescent Moon"], ["🌚", "New Moon Face"], ["🌛", "First Quarter Moon Face"], ["🌜", "Last Quarter Moon Face"], ["🌡", "Thermometer"], ["☀", "Sun"], ["🌝", "Full Moon Face"], ["🌞", "Sun With Face"], ["⭐", "White Medium Star"], ["🌟", "Glowing Star"], ["🌠", "Shooting Star"], ["☁", "Cloud"], ["⛅", "Sun Behind Cloud"], ["⛈", "Cloud With Lightning and Rain"], ["🌤", "Sun Behind Small Cloud"], ["🌥", "Sun Behind Large Cloud"], ["🌦", "Sun Behind Rain Cloud"], ["🌧", "Cloud With Rain"], ["🌨", "Cloud With Snow"], ["🌩", "Cloud With Lightning"], ["🌪", "Tornado"], ["🌫", "Fog"], ["🌬", "Wind Face"], ["🌀", "Cyclone"], ["🌈", "Rainbow"], ["🌂", "Closed Umbrella"], ["☂", "Umbrella"], ["☔", "Umbrella With Rain Drops"], ["⛱", "Umbrella on Ground"], ["⚡", "High Voltage"], ["❄", "Snowflake"], ["☃", "Snowman"], ["⛄", "Snowman Without Snow"], ["☄", "Comet"], ["🔥", "Fire"], ["💧", "Droplet"], ["🌊", "Water Wave"]],
    emoji_group_name_6: "Objects",
    emoji_group_list_6: [["🔇", "Muted Speaker"], ["🔈", "Speaker Low Volume"], ["🔉", "Speaker Medium Volume"], ["🔊", "Speaker High Volume"], ["📢", "Loudspeaker"], ["📣", "Megaphone"], ["📯", "Postal Horn"], ["🔔", "Bell"], ["🔕", "Bell With Slash"], ["🎼", "Musical Score"], ["🎵", "Musical Note"], ["🎶", "Musical Notes"], ["🎙", "Studio Microphone"], ["🎚", "Level Slider"], ["🎛", "Control Knobs"], ["🎤", "Microphone"], ["🎧", "Headphone"], ["📻", "Radio"], ["🎷", "Saxophone"], ["🎸", "Guitar"], ["🎹", "Musical Keyboard"], ["🎺", "Trumpet"], ["🎻", "Violin"], ["📱", "Mobile Phone"], ["📲", "Mobile Phone With Arrow"], ["☎", "Telephone"], ["📞", "Telephone Receiver"], ["📟", "Pager"], ["📠", "Fax Machine"], ["🔋", "Battery"], ["🔌", "Electric Plug"], ["💻", "Laptop Computer"], ["🖥", "Desktop Computer"], ["🖨", "Printer"], ["⌨", "Keyboard"], ["🖱", "Computer Mouse"], ["🖲", "Trackball"], ["💽", "Computer Disk"], ["💾", "Floppy Disk"], ["💿", "Optical Disk"], ["📀", "DVD"], ["🎥", "Movie Camera"], ["🎞", "Film Frames"], ["📽", "Film Projector"], ["🎬", "Clapper Board"], ["📺", "Television"], ["📷", "Camera"], ["📸", "Camera With Flash"], ["📹", "Video Camera"], ["📼", "Videocassette"], ["🔍", "Magnifying Glass Tilted Left"], ["🔎", "Magnifying Glass Tilted Right"], ["🕯", "Candle"], ["💡", "Light Bulb"], ["🔦", "Flashlight"], ["🏮", "Red Paper Lantern"], ["📔", "Notebook With Decorative Cover"], ["📕", "Closed Book"], ["📖", "Open Book"], ["📗", "Green Book"], ["📘", "Blue Book"], ["📙", "Orange Book"], ["📚", "Books"], ["📓", "Notebook"], ["📒", "Ledger"], ["📃", "Page With Curl"], ["📜", "Scroll"], ["📄", "Page Facing Up"], ["📰", "Newspaper"], ["🗞", "Rolled-Up Newspaper"], ["📑", "Bookmark Tabs"], ["🔖", "Bookmark"], ["🏷", "Label"], ["💰", "Money Bag"], ["💴", "Yen Banknote"], ["💵", "Dollar Banknote"], ["💶", "Euro Banknote"], ["💷", "Pound Banknote"], ["💸", "Money With Wings"], ["💳", "Credit Card"], ["💹", "Chart Increasing With Yen"], ["💱", "Currency Exchange"], ["💲", "Heavy Dollar Sign"], ["✉", "Envelope"], ["📧", "E-Mail"], ["📨", "Incoming Envelope"], ["📩", "Envelope With Arrow"], ["📤", "Outbox Tray"], ["📥", "Inbox Tray"], ["📦", "Package"], ["📫", "Closed Mailbox With Raised Flag"], ["📪", "Closed Mailbox With Lowered Flag"], ["📬", "Open Mailbox With Raised Flag"], ["📭", "Open Mailbox With Lowered Flag"], ["📮", "Postbox"], ["🗳", "Ballot Box With Ballot"], ["✏", "Pencil"], ["✒", "Black Nib"], ["🖋", "Fountain Pen"], ["🖊", "Pen"], ["🖌", "Paintbrush"], ["🖍", "Crayon"], ["📝", "Memo"], ["💼", "Briefcase"], ["📁", "File Folder"], ["📂", "Open File Folder"], ["🗂", "Card Index Dividers"], ["📅", "Calendar"], ["📆", "Tear-Off Calendar"], ["🗒", "Spiral Notepad"], ["🗓", "Spiral Calendar"], ["📇", "Card Index"], ["📈", "Chart Increasing"], ["📉", "Chart Decreasing"], ["📊", "Bar Chart"], ["📋", "Clipboard"], ["📌", "Pushpin"], ["📍", "Round Pushpin"], ["📎", "Paperclip"], ["🖇", "Linked Paperclips"], ["📏", "Straight Ruler"], ["📐", "Triangular Ruler"], ["✂", "Scissors"], ["🗃", "Card File Box"], ["🗄", "File Cabinet"], ["🗑", "Wastebasket"], ["🔒", "Locked"], ["🔓", "Unlocked"], ["🔏", "Locked With Pen"], ["🔐", "Locked With Key"], ["🔑", "Key"], ["🗝", "Old Key"], ["🔨", "Hammer"], ["⛏", "Pick"], ["⚒", "Hammer and Pick"], ["🛠", "Hammer and Wrench"], ["🗡", "Dagger"], ["⚔", "Crossed Swords"], ["🔫", "Pistol"], ["🏹", "Bow and Arrow"], ["🛡", "Shield"], ["🔧", "Wrench"], ["🔩", "Nut and Bolt"], ["⚙", "Gear"], ["🗜", "Clamp"], ["⚖", "Balance Scale"], ["🔗", "Link"], ["⛓", "Chains"], ["⚗", "Alembic"], ["🔬", "Microscope"], ["🔭", "Telescope"], ["📡", "Satellite Antenna"], ["💉", "Syringe"], ["💊", "Pill"], ["🚪", "Door"], ["🛏", "Bed"], ["🛋", "Couch and Lamp"], ["🚽", "Toilet"], ["🚿", "Shower"], ["🛁", "Bathtub"], ["🚬", "Cigarette"], ["⚰", "Coffin"], ["⚱", "Funeral Urn"], ["🗿", "Moai"]],
    emoji_group_name_7: "Symbols",
    emoji_group_list_7: [["🏧", "Atm Sign"], ["🚮", "Litter in Bin Sign"], ["🚰", "Potable Water"], ["♿", "Wheelchair Symbol"], ["🚹", "Men’s Room"], ["🚺", "Women’s Room"], ["🚻", "Restroom"], ["🚼", "Baby Symbol"], ["🚾", "Water Closet"], ["🛂", "Passport Control"], ["🛃", "Customs"], ["🛄", "Baggage Claim"], ["🛅", "Left Luggage"], ["⚠", "Warning"], ["🚸", "Children Crossing"], ["⛔", "No Entry"], ["🚫", "Prohibited"], ["🚳", "No Bicycles"], ["🚭", "No Smoking"], ["🚯", "No Littering"], ["🚱", "Non-Potable Water"], ["🚷", "No Pedestrians"], ["📵", "No Mobile Phones"], ["🔞", "No One Under Eighteen"], ["☢", "Radioactive"], ["☣", "Biohazard"], ["⬆", "Up Arrow"], ["↗", "Up-Right Arrow"], ["➡", "Right Arrow"], ["↘", "Down-Right Arrow"], ["⬇", "Down Arrow"], ["↙", "Down-Left Arrow"], ["⬅", "Left Arrow"], ["↖", "Up-Left Arrow"], ["↕", "Up-Down Arrow"], ["↔", "Left-Right Arrow"], ["↩", "Right Arrow Curving Left"], ["↪", "Left Arrow Curving Right"], ["⤴", "Right Arrow Curving Up"], ["⤵", "Right Arrow Curving Down"], ["🔃", "Clockwise Vertical Arrows"], ["🔄", "Counterclockwise Arrows Button"], ["🔙", "Back Arrow"], ["🔚", "End Arrow"], ["🔛", "On! Arrow"], ["🔜", "Soon Arrow"], ["🔝", "Top Arrow"], ["🛐", "Place of Worship"], ["⚛", "Atom Symbol"], ["🕉", "Om"], ["✡", "Star of David"], ["☸", "Wheel of Dharma"], ["☯", "Yin Yang"], ["✝", "Latin Cross"], ["☦", "Orthodox Cross"], ["☪", "Star and Crescent"], ["☮", "Peace Symbol"], ["🕎", "Menorah"], ["🔯", "Dotted Six-Pointed Star"], ["♈", "Aries"], ["♉", "Taurus"], ["♊", "Gemini"], ["♋", "Cancer"], ["♌", "Leo"], ["♍", "Virgo"], ["♎", "Libra"], ["♏", "Scorpio"], ["♐", "Sagittarius"], ["♑", "Capricorn"], ["♒", "Aquarius"], ["♓", "Pisces"], ["⛎", "Ophiuchus"], ["🔀", "Shuffle Tracks Button"], ["🔁", "Repeat Button"], ["🔂", "Repeat Single Button"], ["▶", "Play Button"], ["⏩", "Fast-Forward Button"], ["⏭", "Next Track Button"], ["⏯", "Play or Pause Button"], ["◀", "Reverse Button"], ["⏪", "Fast Reverse Button"], ["⏮", "Last Track Button"], ["🔼", "Upwards Button"], ["⏫", "Fast Up Button"], ["🔽", "Downwards Button"], ["⏬", "Fast Down Button"], ["⏸", "Pause Button"], ["⏹", "Stop Button"], ["⏺", "Record Button"], ["⏏", "Eject Button"], ["🎦", "Cinema"], ["🔅", "Dim Button"], ["🔆", "Bright Button"], ["📶", "Antenna Bars"], ["📳", "Vibration Mode"], ["📴", "Mobile Phone Off"], ["♻", "Recycling Symbol"], ["⚜", "Fleur-De-Lis"], ["🔱", "Trident Emblem"], ["📛", "Name Badge"], ["🔰", "Japanese Symbol for Beginner"], ["⭕", "Heavy Large Circle"], ["✅", "White Heavy Check Mark"], ["☑", "Ballot Box With Check"], ["✔", "Heavy Check Mark"], ["✖", "Heavy Multiplication X"], ["❌", "Cross Mark"], ["❎", "Cross Mark Button"], ["➕", "Heavy Plus Sign"], ["➖", "Heavy Minus Sign"], ["➗", "Heavy Division Sign"], ["➰", "Curly Loop"], ["➿", "Double Curly Loop"], ["〽", "Part Alternation Mark"], ["✳", "Eight-Spoked Asterisk"], ["✴", "Eight-Pointed Star"], ["❇", "Sparkle"], ["‼", "Double Exclamation Mark"], ["⁉", "Exclamation Question Mark"], ["❓", "Question Mark"], ["❔", "White Question Mark"], ["❕", "White Exclamation Mark"], ["❗", "Exclamation Mark"], ["〰", ""], ["©", "Copyright"], ["®", "Registered"], ["™", "Trade Mark"], ["🔟", "Keycap 10"], ["💯", "Hundred Points"], ["🔠", "Input Latin Uppercase"], ["🔡", "Input Latin Lowercase"], ["🔢", "Input Numbers"], ["🔣", "Input Symbols"], ["🔤", "Input Latin Letters"], ["🅰", "A Button (blood Type)"], ["🆎", "Ab Button (blood Type)"], ["🅱", "B Button (blood Type)"], ["🆑", "CL Button"], ["🆒", "Cool Button"], ["🆓", "Free Button"], ["ℹ", "Information"], ["🆔", "ID Button"], ["Ⓜ", "Circled M"], ["🆕", "New Button"], ["🆖", "NG Button"], ["🅾", "O Button (blood Type)"], ["🆗", "OK Button"], ["🅿", "P Button"], ["🆘", "SOS Button"], ["🆙", "Up! Button"], ["🆚", "Vs Button"], ["🈁", "Japanese “here” Button"], ["🈂", "Japanese “service Charge” Button"], ["🈷", "Japanese “monthly Amount” Button"], ["🈶", "Japanese “not Free of Charge” Button"], ["🈯", "Japanese “reserved” Button"], ["🉐", "Japanese “bargain” Button"], ["🈹", "Japanese “discount” Button"], ["🈚", "Japanese “free of Charge” Button"], ["🈲", "Japanese “prohibited” Button"], ["🉑", "Japanese “acceptable” Button"], ["🈸", "Japanese “application” Button"], ["🈴", "Japanese “passing Grade” Button"], ["🈳", "Japanese “vacancy” Button"], ["㊗", "Japanese “congratulations” Button"], ["㊙", "Japanese “secret” Button"], ["🈺", "Japanese “open for Business” Button"], ["🈵", "Japanese “no Vacancy” Button"], ["▪", "Black Small Square"], ["▫", "White Small Square"], ["◻", "White Medium Square"], ["◼", "Black Medium Square"], ["◽", "White Medium-Small Square"], ["◾", "Black Medium-Small Square"], ["⬛", "Black Large Square"], ["⬜", "White Large Square"], ["🔶", "Large Orange Diamond"], ["🔷", "Large Blue Diamond"], ["🔸", "Small Orange Diamond"], ["🔹", "Small Blue Diamond"], ["🔺", "Red Triangle Pointed Up"], ["🔻", "Red Triangle Pointed Down"], ["💠", "Diamond With a Dot"], ["🔘", "Radio Button"], ["🔲", "Black Square Button"], ["🔳", "White Square Button"], ["⚪", "White Circle"], ["⚫", "Black Circle"], ["🔴", "Red Circle"], ["🔵", "Blue Circle"]],
    emoji_group_name_8: "Flags",
    emoji_group_list_8: [["🏁", "Chequered Flag"], ["🚩", "Triangular Flag"], ["🎌", "Crossed Flags"], ["🏴", "Black Flag"], ["🏳", "White Flag"], ["🇦🇨", "Ascension Island"], ["🇦🇩", "Andorra"], ["🇦🇪", "United Arab Emirates"], ["🇦🇫", "Afghanistan"], ["🇦🇬", "Antigua & Barbuda"], ["🇦🇮", "Anguilla"], ["🇦🇱", "Albania"], ["🇦🇲", "Armenia"], ["🇦🇴", "Angola"], ["🇦🇶", "Antarctica"], ["🇦🇷", "Argentina"], ["🇦🇸", "American Samoa"], ["🇦🇹", "Austria"], ["🇦🇺", "Australia"], ["🇦🇼", "Aruba"], ["🇦🇽", "Åland Islands"], ["🇦🇿", "Azerbaijan"], ["🇧🇦", "Bosnia & Herzegovina"], ["🇧🇧", "Barbados"], ["🇧🇩", "Bangladesh"], ["🇧🇪", "Belgium"], ["🇧🇫", "Burkina Faso"], ["🇧🇬", "Bulgaria"], ["🇧🇭", "Bahrain"], ["🇧🇮", "Burundi"], ["🇧🇯", "Benin"], ["🇧🇱", "St. Barthélemy"], ["🇧🇲", "Bermuda"], ["🇧🇳", "Brunei"], ["🇧🇴", "Bolivia"], ["🇧🇶", "Caribbean Netherlands"], ["🇧🇷", "Brazil"], ["🇧🇸", "Bahamas"], ["🇧🇹", "Bhutan"], ["🇧🇻", "Bouvet Island"], ["🇧🇼", "Botswana"], ["🇧🇾", "Belarus"], ["🇧🇿", "Belize"], ["🇨🇦", "Canada"], ["🇨🇨", "Cocos (Keeling) Islands"], ["🇨🇩", "Congo - Kinshasa"], ["🇨🇫", "Central African Republic"], ["🇨🇬", "Congo - Brazzaville"], ["🇨🇭", "Switzerland"], ["🇨🇮", "Côte D’Ivoire"], ["🇨🇰", "Cook Islands"], ["🇨🇱", "Chile"], ["🇨🇲", "Cameroon"], ["🇨🇳", "China"], ["🇨🇴", "Colombia"], ["🇨🇵", "Clipperton Island"], ["🇨🇷", "Costa Rica"], ["🇨🇺", "Cuba"], ["🇨🇻", "Cape Verde"], ["🇨🇼", "Curaçao"], ["🇨🇽", "Christmas Island"], ["🇨🇾", "Cyprus"], ["🇨🇿", "Czechia"], ["🇩🇪", "Germany"], ["🇩🇬", "Diego Garcia"], ["🇩🇯", "Djibouti"], ["🇩🇰", "Denmark"], ["🇩🇲", "Dominica"], ["🇩🇴", "Dominican Republic"], ["🇩🇿", "Algeria"], ["🇪🇦", "Ceuta & Melilla"], ["🇪🇨", "Ecuador"], ["🇪🇪", "Estonia"], ["🇪🇬", "Egypt"], ["🇪🇭", "Western Sahara"], ["🇪🇷", "Eritrea"], ["🇪🇸", "Spain"], ["🇪🇹", "Ethiopia"], ["🇪🇺", "European Union"], ["🇫🇮", "Finland"], ["🇫🇯", "Fiji"], ["🇫🇰", "Falkland Islands"], ["🇫🇲", "Micronesia"], ["🇫🇴", "Faroe Islands"], ["🇫🇷", "France"], ["🇬🇦", "Gabon"], ["🇬🇧", "United Kingdom"], ["🇬🇩", "Grenada"], ["🇬🇪", "Georgia"], ["🇬🇫", "French Guiana"], ["🇬🇬", "Guernsey"], ["🇬🇭", "Ghana"], ["🇬🇮", "Gibraltar"], ["🇬🇱", "Greenland"], ["🇬🇲", "Gambia"], ["🇬🇳", "Guinea"], ["🇬🇵", "Guadeloupe"], ["🇬🇶", "Equatorial Guinea"], ["🇬🇷", "Greece"], ["🇬🇸", "South Georgia & South Sandwich Islands"], ["🇬🇹", "Guatemala"], ["🇬🇺", "Guam"], ["🇬🇼", "Guinea-Bissau"], ["🇬🇾", "Guyana"], ["🇭🇰", "Hong Kong SAR China"], ["🇭🇲", "Heard & McDonald Islands"], ["🇭🇳", "Honduras"], ["🇭🇷", "Croatia"], ["🇭🇹", "Haiti"], ["🇭🇺", "Hungary"], ["🇮🇨", "Canary Islands"], ["🇮🇩", "Indonesia"], ["🇮🇪", "Ireland"], ["🇮🇱", "Israel"], ["🇮🇲", "Isle of Man"], ["🇮🇳", "India"], ["🇮🇴", "British Indian Ocean Territory"], ["🇮🇶", "Iraq"], ["🇮🇷", "Iran"], ["🇮🇸", "Iceland"], ["🇮🇹", "Italy"], ["🇯🇪", "Jersey"], ["🇯🇲", "Jamaica"], ["🇯🇴", "Jordan"], ["🇯🇵", "Japan"], ["🇰🇪", "Kenya"], ["🇰🇬", "Kyrgyzstan"], ["🇰🇭", "Cambodia"], ["🇰🇮", "Kiribati"], ["🇰🇲", "Comoros"], ["🇰🇳", "St. Kitts & Nevis"], ["🇰🇵", "North Korea"], ["🇰🇷", "South Korea"], ["🇰🇼", "Kuwait"], ["🇰🇾", "Cayman Islands"], ["🇰🇿", "Kazakhstan"], ["🇱🇦", "Laos"], ["🇱🇧", "Lebanon"], ["🇱🇨", "St. Lucia"], ["🇱🇮", "Liechtenstein"], ["🇱🇰", "Sri Lanka"], ["🇱🇷", "Liberia"], ["🇱🇸", "Lesotho"], ["🇱🇹", "Lithuania"], ["🇱🇺", "Luxembourg"], ["🇱🇻", "Latvia"], ["🇱🇾", "Libya"], ["🇲🇦", "Morocco"], ["🇲🇨", "Monaco"], ["🇲🇩", "Moldova"], ["🇲🇪", "Montenegro"], ["🇲🇫", "St. Martin"], ["🇲🇬", "Madagascar"], ["🇲🇭", "Marshall Islands"], ["🇲🇰", "Macedonia"], ["🇲🇱", "Mali"], ["🇲🇲", "Myanmar (Burma)"], ["🇲🇳", "Mongolia"], ["🇲🇴", "Macau SAR China"], ["🇲🇵", "Northern Mariana Islands"], ["🇲🇶", "Martinique"], ["🇲🇷", "Mauritania"], ["🇲🇸", "Montserrat"], ["🇲🇹", "Malta"], ["🇲🇺", "Mauritius"], ["🇲🇻", "Maldives"], ["🇲🇼", "Malawi"], ["🇲🇽", "Mexico"], ["🇲🇾", "Malaysia"], ["🇲🇿", "Mozambique"], ["🇳🇦", "Namibia"], ["🇳🇨", "New Caledonia"], ["🇳🇪", "Niger"], ["🇳🇫", "Norfolk Island"], ["🇳🇬", "Nigeria"], ["🇳🇮", "Nicaragua"], ["🇳🇱", "Netherlands"], ["🇳🇴", "Norway"], ["🇳🇵", "Nepal"], ["🇳🇷", "Nauru"], ["🇳🇺", "Niue"], ["🇳🇿", "New Zealand"], ["🇴🇲", "Oman"], ["🇵🇦", "Panama"], ["🇵🇪", "Peru"], ["🇵🇫", "French Polynesia"], ["🇵🇬", "Papua New Guinea"], ["🇵🇭", "Philippines"], ["🇵🇰", "Pakistan"], ["🇵🇱", "Poland"], ["🇵🇲", "St. Pierre & Miquelon"], ["🇵🇳", "Pitcairn Islands"], ["🇵🇷", "Puerto Rico"], ["🇵🇸", "Palestinian Territories"], ["🇵🇹", "Portugal"], ["🇵🇼", "Palau"], ["🇵🇾", "Paraguay"], ["🇶🇦", "Qatar"], ["🇷🇪", "Réunion"], ["🇷🇴", "Romania"], ["🇷🇸", "Serbia"], ["🇷🇺", "Russia"], ["🇷🇼", "Rwanda"], ["🇸🇦", "Saudi Arabia"], ["🇸🇧", "Solomon Islands"], ["🇸🇨", "Seychelles"], ["🇸🇩", "Sudan"], ["🇸🇪", "Sweden"], ["🇸🇬", "Singapore"], ["🇸🇭", "St. Helena"], ["🇸🇮", "Slovenia"], ["🇸🇯", "Svalbard & Jan Mayen"], ["🇸🇰", "Slovakia"], ["🇸🇱", "Sierra Leone"], ["🇸🇲", "San Marino"], ["🇸🇳", "Senegal"], ["🇸🇴", "Somalia"], ["🇸🇷", "Suriname"], ["🇸🇸", "South Sudan"], ["🇸🇹", "São Tomé & Príncipe"], ["🇸🇻", "El Salvador"], ["🇸🇽", "Sint Maarten"], ["🇸🇾", "Syria"], ["🇸🇿", "Swaziland"], ["🇹🇦", "Tristan Da Cunha"], ["🇹🇨", "Turks & Caicos Islands"], ["🇹🇩", "Chad"], ["🇹🇫", "French Southern Territories"], ["🇹🇬", "Togo"], ["🇹🇭", "Thailand"], ["🇹🇯", "Tajikistan"], ["🇹🇰", "Tokelau"], ["🇹🇱", "Timor-Leste"], ["🇹🇲", "Turkmenistan"], ["🇹🇳", "Tunisia"], ["🇹🇴", "Tonga"], ["🇹🇷", "Turkey"], ["🇹🇹", "Trinidad & Tobago"], ["🇹🇻", "Tuvalu"], ["🇹🇼", "Taiwan"], ["🇹🇿", "Tanzania"], ["🇺🇦", "Ukraine"], ["🇺🇬", "Uganda"], ["🇺🇲", "U.S. Outlying Islands"], ["🇺🇸", "United States"], ["🇺🇾", "Uruguay"], ["🇺🇿", "Uzbekistan"], ["🇻🇦", "Vatican City"], ["🇻🇨", "St. Vincent & Grenadines"], ["🇻🇪", "Venezuela"], ["🇻🇬", "British Virgin Islands"], ["🇻🇮", "U.S. Virgin Islands"], ["🇻🇳", "Vietnam"], ["🇻🇺", "Vanuatu"], ["🇼🇫", "Wallis & Futuna"], ["🇼🇸", "Samoa"], ["🇽🇰", "Kosovo"], ["🇾🇪", "Yemen"], ["🇾🇹", "Mayotte"], ["🇿🇦", "South Africa"], ["🇿🇲", "Zambia"], ["🇿🇼", "Zimbabwe"]]
};

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, jQuery) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = initEmojiPicker;

var _emojiPickerIcons = __webpack_require__(256);

var totalEmojiGroups = 8;
var current_emojiPickerInputID = '';

function initEmojiPicker($containerWrapper, callbackValue) {
    for (var i = 1, l = totalEmojiGroups; i <= l; i++) {
        $containerWrapper.append(renderEmojiPickerList(i));
    }

    initEvents(callbackValue);
}

function initEvents(callbackValue) {
    $(document).on('click, mousedown', function (event) {
        var $container = $('.emoji-picker-container');
        var $emojiPicker = $('.emoji-picker');

        if ($(event.target).hasClass('emoji-picker') && !$(event.target).hasClass('disabled')) {
            var $emojiPickerwrapper = $('.emoji-picker-wrapper');

            if (!$container.is(':visible')) {
                var containerWidth = $container.outerWidth();
                var picker = $(event.target);
                var pickerHeight = picker.outerWidth();
                var pickerWidth = picker.outerHeight();
                var pickerTop = picker.offset().top;
                var pickerLeft = picker.offset().left;

                current_emojiPickerInputID = picker.context.dataset.for;

                $container.css('top', pickerTop + pickerHeight + 1);
                $container.css('left', pickerLeft + pickerWidth - containerWidth + 6);

                $emojiPicker.removeClass('is-active');
                picker.addClass('is-active');

                $container.addClass('active');
                $emojiPickerwrapper.scrollTop('0');
            } else {
                $container.removeClass('active');
            }
        } else if ($(event.target).closest($container).length === 0 && $container.is(":visible")) {
            $container.removeClass('active');
            $('.emoji-picker').removeClass('is-active');
        }
    });

    $(".emoji-block button").click(function (ev) {
        var emoji = $(this).text();
        var $emojiId = $('#' + current_emojiPickerInputID);
        var inputvalue = $emojiId.val();
        var inputlength = inputvalue.length;
        var isPreview = false;
        if (current_emojiPickerInputID.indexOf('txtPreview') > -1) {
            isPreview = true;
        }

        if (inputvalue) {
            var surrogatePairs = inputvalue.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [];
            inputlength = inputlength - surrogatePairs.length;
        }
        var maxlength = $emojiId.attr('maxlength');

        if (maxlength) {
            maxlength = parseInt(maxlength);
        }
        if (typeof maxlength != 'undefined') {
            if (inputlength < maxlength) {
                $emojiId.insertAtCaret(emoji);
                $emojiId.change();
                callbackValue($emojiId.val(), isPreview);
            }
        } else {
            $emojiId.insertAtCaret(emoji);
            $emojiId.change();
            callbackValue($emojiId.val());
        }
    });

    $('.emoji-picker-group-nav').click(function (ev) {
        ev.preventDefault();

        var $emojiPickerwrapper = $('.emoji-picker-wrapper');
        var group = $(this).data('value');

        $emojiPickerwrapper.scrollTop('0');

        var element = $(".emoji-group-name[data-group='" + group + "']");
        var elementTop = element.position().top;

        if (group != '1') {
            $emojiPickerwrapper.scrollTop(elementTop - 46);
        }
    });

    var $emojiPickerWrapperId = document.getElementById('emojiPickerWrapper');
    var emojiPickerWrapperScroll = debounce(function () {
        emojiPickerWrapperNavUpdate();
    }, 10);

    if ($emojiPickerWrapperId) {
        $emojiPickerWrapperId.addEventListener('scroll', emojiPickerWrapperScroll);
    }
}

function emojiPickerWrapperNavUpdate() {
    for (var i = totalEmojiGroups, l = 0; i > l; i--) {
        var element = $('.emoji-group-name[data-group="' + i + '"]');
        if (element) {
            var paddingTop = 46;
            var top = element.position().top - paddingTop;
            if (top <= 0) {
                $('.emoji-picker-group-nav').removeClass('current-group');
                $('.emoji-picker-group-nav[data-value="' + i + '"]').addClass('current-group');
                break;
            }
        }
    }
}

function renderEmojiPickerList(group) {
    var groupname = _emojiPickerIcons.emojiPickerIcons['emoji_group_name_' + group];
    var grouplist = _emojiPickerIcons.emojiPickerIcons['emoji_group_list_' + group];
    var html = '';

    html += '<div class="emoji-group-name" data-group="' + group + '">' + groupname + '</div>';
    html += '<ul class="emoji-list">';

    for (var i = 0, l = grouplist.length; i < l; i++) {
        html += '<li class="emoji-block">';
        html += '<button type="button" title="' + grouplist[i][1] + '">' + grouplist[i][0] + '</button>';
        html += '</li>';
    }

    html += '<ul>';

    return html;
}

function debounce(func, wait, immediate) {
    var _this = this,
        _arguments = arguments;

    var timeout = void 0;
    return function () {
        var context = _this,
            args = _arguments,
            later = function later() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        },
            callNow = immediate && !timeout;

        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

jQuery.fn.extend({
    insertAtCaret: function insertAtCaret(myValue) {
        return this.each(function (i) {
            //For browsers like Internet Explorer
            if (document.selection) {
                var sel = document.selection.createRange();

                this.focus();
                sel.text = myValue;
                this.focus();
            }
            //For browsers like Firefox and Webkit based
            else if (this.selectionStart || this.selectionStart == '0') {
                    var startPos = this.selectionStart;
                    var endPos = this.selectionEnd;
                    var scrollTop = this.scrollTop;

                    this.value = this.value.substring(0, startPos) + myValue + this.value.substring(endPos, this.value.length);
                    this.focus();
                    this.selectionStart = startPos + myValue.length;
                    this.selectionEnd = startPos + myValue.length;
                    this.scrollTop = scrollTop;
                } else {
                    this.value += myValue;
                    this.focus();
                }
        });
    }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(1)))

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var useLiveChat = exports.useLiveChat = function useLiveChat(lang) {
    // eslint-disable-next-line no-underscore-dangle
    if (window.__lc) {
        var liveChat = document.getElementById('chat-widget-container');
        if (liveChat) {
            liveChat.classList.remove('display-none');
        }
        return;
    }

    // eslint-disable-next-line no-underscore-dangle
    var __lc = {};
    __lc.license = 1067033;
    if (lang === 'es' || lang === 'spanish') {
        __lc.skill = 58;
    } else if (lang === 'chinese') {
        __lc.skill = 62;
    } else if (lang === 'chineset') {
        __lc.skill = 59;
    } else if (lang === 'it' || lang === 'italian') {
        __lc.skill = 56;
    } else if (lang === 'pt' || lang === 'portuguese' || lang === 'br' || lang === 'brazil') {
        __lc.skill = 54;
    } else if (lang === 'de' || lang === 'german') {
        __lc.skill = 55;
    } else if (lang === 'indian') {
        __lc.skill = 60;
    } else if (lang === 'jp' || lang === 'japanese') {
        __lc.skill = 57;
    } else if (lang === 'fr' || lang === 'french') {
        __lc.skill = 63;
    } else {
        __lc.skill = 61;
    }

    // eslint-disable-next-line no-underscore-dangle
    window.__lc = __lc;
    var lc = document.createElement('script');
    lc.type = 'text/javascript';
    lc.async = true;
    lc.id = 'livechat-script';
    lc.src = (document.location.protocol === 'https:' ? 'https://' : 'http://') + 'cdn.livechatinc.com/tracking.js';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(lc, s);
};

var destroyLiveChat = exports.destroyLiveChat = function destroyLiveChat() {
    var liveChat = document.getElementById('chat-widget-container');
    if (liveChat) {
        liveChat.classList.add('display-none');
    }
};

/***/ }),
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 275 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*! jQuery UI - v1.10.2 - 2013-03-14
 * http://jqueryui.com
 * Includes: jquery.ui.core.js, jquery.ui.widget.js, jquery.ui.mouse.js, jquery.ui.draggable.js, jquery.ui.droppable.js, jquery.ui.resizable.js, jquery.ui.selectable.js, jquery.ui.sortable.js, jquery.ui.effect.js, jquery.ui.accordion.js, jquery.ui.autocomplete.js, jquery.ui.button.js, jquery.ui.datepicker.js, jquery.ui.dialog.js, jquery.ui.effect-blind.js, jquery.ui.effect-bounce.js, jquery.ui.effect-clip.js, jquery.ui.effect-drop.js, jquery.ui.effect-explode.js, jquery.ui.effect-fade.js, jquery.ui.effect-fold.js, jquery.ui.effect-highlight.js, jquery.ui.effect-pulsate.js, jquery.ui.effect-scale.js, jquery.ui.effect-shake.js, jquery.ui.effect-slide.js, jquery.ui.effect-transfer.js, jquery.ui.menu.js, jquery.ui.position.js, jquery.ui.progressbar.js, jquery.ui.slider.js, jquery.ui.spinner.js, jquery.ui.tabs.js, jquery.ui.tooltip.js
 * Copyright 2013 jQuery Foundation and other contributors; Licensed MIT */
(function( $, undefined ) {

    var uuid = 0,
        runiqueId = /^ui-id-\d+$/;

// $.ui might exist from components with no dependencies, e.g., $.ui.position
    $.ui = $.ui || {};

    $.extend( $.ui, {
        version: "1.10.2",

        keyCode: {
            BACKSPACE: 8,
            COMMA: 188,
            DELETE: 46,
            DOWN: 40,
            END: 35,
            ENTER: 13,
            ESCAPE: 27,
            HOME: 36,
            LEFT: 37,
            NUMPAD_ADD: 107,
            NUMPAD_DECIMAL: 110,
            NUMPAD_DIVIDE: 111,
            NUMPAD_ENTER: 108,
            NUMPAD_MULTIPLY: 106,
            NUMPAD_SUBTRACT: 109,
            PAGE_DOWN: 34,
            PAGE_UP: 33,
            PERIOD: 190,
            RIGHT: 39,
            SPACE: 32,
            TAB: 9,
            UP: 38
        }
    });

// plugins
    $.fn.extend({
        focus: (function( orig ) {
            return function( delay, fn ) {
                return typeof delay === "number" ?
                    this.each(function() {
                        var elem = this;
                        setTimeout(function() {
                            $( elem ).focus();
                            if ( fn ) {
                                fn.call( elem );
                            }
                        }, delay );
                    }) :
                    orig.apply( this, arguments );
            };
        })( $.fn.focus ),

        scrollParent: function() {
            var scrollParent;
            if (($.ui.ie && (/(static|relative)/).test(this.css("position"))) || (/absolute/).test(this.css("position"))) {
                scrollParent = this.parents().filter(function() {
                    return (/(relative|absolute|fixed)/).test($.css(this,"position")) && (/(auto|scroll)/).test($.css(this,"overflow")+$.css(this,"overflow-y")+$.css(this,"overflow-x"));
                }).eq(0);
            } else {
                scrollParent = this.parents().filter(function() {
                    return (/(auto|scroll)/).test($.css(this,"overflow")+$.css(this,"overflow-y")+$.css(this,"overflow-x"));
                }).eq(0);
            }

            return (/fixed/).test(this.css("position")) || !scrollParent.length ? $(document) : scrollParent;
        },

        zIndex: function( zIndex ) {
            if ( zIndex !== undefined ) {
                return this.css( "zIndex", zIndex );
            }

            if ( this.length ) {
                var elem = $( this[ 0 ] ), position, value;
                while ( elem.length && elem[ 0 ] !== document ) {
                    // Ignore z-index if position is set to a value where z-index is ignored by the browser
                    // This makes behavior of this function consistent across browsers
                    // WebKit always returns auto if the element is positioned
                    position = elem.css( "position" );
                    if ( position === "absolute" || position === "relative" || position === "fixed" ) {
                        // IE returns 0 when zIndex is not specified
                        // other browsers return a string
                        // we ignore the case of nested elements with an explicit value of 0
                        // <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
                        value = parseInt( elem.css( "zIndex" ), 10 );
                        if ( !isNaN( value ) && value !== 0 ) {
                            return value;
                        }
                    }
                    elem = elem.parent();
                }
            }

            return 0;
        },

        uniqueId: function() {
            return this.each(function() {
                if ( !this.id ) {
                    this.id = "ui-id-" + (++uuid);
                }
            });
        },

        removeUniqueId: function() {
            return this.each(function() {
                if ( runiqueId.test( this.id ) ) {
                    $( this ).removeAttr( "id" );
                }
            });
        }
    });

// selectors
    function focusable( element, isTabIndexNotNaN ) {
        var map, mapName, img,
            nodeName = element.nodeName.toLowerCase();
        if ( "area" === nodeName ) {
            map = element.parentNode;
            mapName = map.name;
            if ( !element.href || !mapName || map.nodeName.toLowerCase() !== "map" ) {
                return false;
            }
            img = $( "img[usemap=#" + mapName + "]" )[0];
            return !!img && visible( img );
        }
        return ( /input|select|textarea|button|object/.test( nodeName ) ?
                !element.disabled :
                "a" === nodeName ?
                element.href || isTabIndexNotNaN :
                    isTabIndexNotNaN) &&
            // the element and all of its ancestors must be visible
            visible( element );
    }

    function visible( element ) {
        return $.expr.filters.visible( element ) &&
            !$( element ).parents().addBack().filter(function() {
                return $.css( this, "visibility" ) === "hidden";
            }).length;
    }

    $.extend( $.expr[ ":" ], {
        data: $.expr.createPseudo ?
            $.expr.createPseudo(function( dataName ) {
                return function( elem ) {
                    return !!$.data( elem, dataName );
                };
            }) :
            // support: jQuery <1.8
            function( elem, i, match ) {
                return !!$.data( elem, match[ 3 ] );
            },

        focusable: function( element ) {
            return focusable( element, !isNaN( $.attr( element, "tabindex" ) ) );
        },

        tabbable: function( element ) {
            var tabIndex = $.attr( element, "tabindex" ),
                isTabIndexNaN = isNaN( tabIndex );
            return ( isTabIndexNaN || tabIndex >= 0 ) && focusable( element, !isTabIndexNaN );
        }
    });

// support: jQuery <1.8
    if ( !$( "<a>" ).outerWidth( 1 ).jquery ) {
        $.each( [ "Width", "Height" ], function( i, name ) {
            var side = name === "Width" ? [ "Left", "Right" ] : [ "Top", "Bottom" ],
                type = name.toLowerCase(),
                orig = {
                    innerWidth: $.fn.innerWidth,
                    innerHeight: $.fn.innerHeight,
                    outerWidth: $.fn.outerWidth,
                    outerHeight: $.fn.outerHeight
                };

            function reduce( elem, size, border, margin ) {
                $.each( side, function() {
                    size -= parseFloat( $.css( elem, "padding" + this ) ) || 0;
                    if ( border ) {
                        size -= parseFloat( $.css( elem, "border" + this + "Width" ) ) || 0;
                    }
                    if ( margin ) {
                        size -= parseFloat( $.css( elem, "margin" + this ) ) || 0;
                    }
                });
                return size;
            }

            $.fn[ "inner" + name ] = function( size ) {
                if ( size === undefined ) {
                    return orig[ "inner" + name ].call( this );
                }

                return this.each(function() {
                    $( this ).css( type, reduce( this, size ) + "px" );
                });
            };

            $.fn[ "outer" + name] = function( size, margin ) {
                if ( typeof size !== "number" ) {
                    return orig[ "outer" + name ].call( this, size );
                }

                return this.each(function() {
                    $( this).css( type, reduce( this, size, true, margin ) + "px" );
                });
            };
        });
    }

// support: jQuery <1.8
    if ( !$.fn.addBack ) {
        $.fn.addBack = function( selector ) {
            return this.add( selector == null ?
                this.prevObject : this.prevObject.filter( selector )
            );
        };
    }

// support: jQuery 1.6.1, 1.6.2 (http://bugs.jquery.com/ticket/9413)
    if ( $( "<a>" ).data( "a-b", "a" ).removeData( "a-b" ).data( "a-b" ) ) {
        $.fn.removeData = (function( removeData ) {
            return function( key ) {
                if ( arguments.length ) {
                    return removeData.call( this, $.camelCase( key ) );
                } else {
                    return removeData.call( this );
                }
            };
        })( $.fn.removeData );
    }





// deprecated
    $.ui.ie = !!/msie [\w.]+/.exec( navigator.userAgent.toLowerCase() );

    $.support.selectstart = "onselectstart" in document.createElement( "div" );
    $.fn.extend({
        disableSelection: function() {
            return this.bind( ( $.support.selectstart ? "selectstart" : "mousedown" ) +
                ".ui-disableSelection", function( event ) {
                event.preventDefault();
            });
        },

        enableSelection: function() {
            return this.unbind( ".ui-disableSelection" );
        }
    });

    $.extend( $.ui, {
        // $.ui.plugin is deprecated.  Use the proxy pattern instead.
        plugin: {
            add: function( module, option, set ) {
                var i,
                    proto = $.ui[ module ].prototype;
                for ( i in set ) {
                    proto.plugins[ i ] = proto.plugins[ i ] || [];
                    proto.plugins[ i ].push( [ option, set[ i ] ] );
                }
            },
            call: function( instance, name, args ) {
                var i,
                    set = instance.plugins[ name ];
                if ( !set || !instance.element[ 0 ].parentNode || instance.element[ 0 ].parentNode.nodeType === 11 ) {
                    return;
                }

                for ( i = 0; i < set.length; i++ ) {
                    if ( instance.options[ set[ i ][ 0 ] ] ) {
                        set[ i ][ 1 ].apply( instance.element, args );
                    }
                }
            }
        },

        // only used by resizable
        hasScroll: function( el, a ) {

            //If overflow is hidden, the element might have extra content, but the user wants to hide it
            if ( $( el ).css( "overflow" ) === "hidden") {
                return false;
            }

            var scroll = ( a && a === "left" ) ? "scrollLeft" : "scrollTop",
                has = false;

            if ( el[ scroll ] > 0 ) {
                return true;
            }

            // TODO: determine which cases actually cause this to happen
            // if the element doesn't have the scroll set, see if it's possible to
            // set the scroll
            el[ scroll ] = 1;
            has = ( el[ scroll ] > 0 );
            el[ scroll ] = 0;
            return has;
        }
    });

})( jQuery );

(function( $, undefined ) {

    var uuid = 0,
        slice = Array.prototype.slice,
        _cleanData = $.cleanData;
    $.cleanData = function( elems ) {
        for ( var i = 0, elem; (elem = elems[i]) != null; i++ ) {
            try {
                $( elem ).triggerHandler( "remove" );
                // http://bugs.jquery.com/ticket/8235
            } catch( e ) {}
        }
        _cleanData( elems );
    };

    $.widget = function( name, base, prototype ) {
        var fullName, existingConstructor, constructor, basePrototype,
            // proxiedPrototype allows the provided prototype to remain unmodified
            // so that it can be used as a mixin for multiple widgets (#8876)
            proxiedPrototype = {},
            namespace = name.split( "." )[ 0 ];

        name = name.split( "." )[ 1 ];
        fullName = namespace + "-" + name;

        if ( !prototype ) {
            prototype = base;
            base = $.Widget;
        }

        // create selector for plugin
        $.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
            return !!$.data( elem, fullName );
        };

        $[ namespace ] = $[ namespace ] || {};
        existingConstructor = $[ namespace ][ name ];
        constructor = $[ namespace ][ name ] = function( options, element ) {
            // allow instantiation without "new" keyword
            if ( !this._createWidget ) {
                return new constructor( options, element );
            }

            // allow instantiation without initializing for simple inheritance
            // must use "new" keyword (the code above always passes args)
            if ( arguments.length ) {
                this._createWidget( options, element );
            }
        };
        // extend with the existing constructor to carry over any static properties
        $.extend( constructor, existingConstructor, {
            version: prototype.version,
            // copy the object used to create the prototype in case we need to
            // redefine the widget later
            _proto: $.extend( {}, prototype ),
            // track widgets that inherit from this widget in case this widget is
            // redefined after a widget inherits from it
            _childConstructors: []
        });

        basePrototype = new base();
        // we need to make the options hash a property directly on the new instance
        // otherwise we'll modify the options hash on the prototype that we're
        // inheriting from
        basePrototype.options = $.widget.extend( {}, basePrototype.options );
        $.each( prototype, function( prop, value ) {
            if ( !$.isFunction( value ) ) {
                proxiedPrototype[ prop ] = value;
                return;
            }
            proxiedPrototype[ prop ] = (function() {
                var _super = function() {
                        return base.prototype[ prop ].apply( this, arguments );
                    },
                    _superApply = function( args ) {
                        return base.prototype[ prop ].apply( this, args );
                    };
                return function() {
                    var __super = this._super,
                        __superApply = this._superApply,
                        returnValue;

                    this._super = _super;
                    this._superApply = _superApply;

                    returnValue = value.apply( this, arguments );

                    this._super = __super;
                    this._superApply = __superApply;

                    return returnValue;
                };
            })();
        });
        constructor.prototype = $.widget.extend( basePrototype, {
            // TODO: remove support for widgetEventPrefix
            // always use the name + a colon as the prefix, e.g., draggable:start
            // don't prefix for widgets that aren't DOM-based
            widgetEventPrefix: existingConstructor ? basePrototype.widgetEventPrefix : name
        }, proxiedPrototype, {
            constructor: constructor,
            namespace: namespace,
            widgetName: name,
            widgetFullName: fullName
        });

        // If this widget is being redefined then we need to find all widgets that
        // are inheriting from it and redefine all of them so that they inherit from
        // the new version of this widget. We're essentially trying to replace one
        // level in the prototype chain.
        if ( existingConstructor ) {
            $.each( existingConstructor._childConstructors, function( i, child ) {
                var childPrototype = child.prototype;

                // redefine the child widget using the same prototype that was
                // originally used, but inherit from the new version of the base
                $.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor, child._proto );
            });
            // remove the list of existing child constructors from the old constructor
            // so the old child constructors can be garbage collected
            delete existingConstructor._childConstructors;
        } else {
            base._childConstructors.push( constructor );
        }

        $.widget.bridge( name, constructor );
    };

    $.widget.extend = function( target ) {
        var input = slice.call( arguments, 1 ),
            inputIndex = 0,
            inputLength = input.length,
            key,
            value;
        for ( ; inputIndex < inputLength; inputIndex++ ) {
            for ( key in input[ inputIndex ] ) {
                value = input[ inputIndex ][ key ];
                if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {
                    // Clone objects
                    if ( $.isPlainObject( value ) ) {
                        target[ key ] = $.isPlainObject( target[ key ] ) ?
                            $.widget.extend( {}, target[ key ], value ) :
                            // Don't extend strings, arrays, etc. with objects
                            $.widget.extend( {}, value );
                        // Copy everything else by reference
                    } else {
                        target[ key ] = value;
                    }
                }
            }
        }
        return target;
    };

    $.widget.bridge = function( name, object ) {
        var fullName = object.prototype.widgetFullName || name;
        $.fn[ name ] = function( options ) {
            var isMethodCall = typeof options === "string",
                args = slice.call( arguments, 1 ),
                returnValue = this;

            // allow multiple hashes to be passed on init
            options = !isMethodCall && args.length ?
                $.widget.extend.apply( null, [ options ].concat(args) ) :
                options;

            if ( isMethodCall ) {
                this.each(function() {
                    var methodValue,
                        instance = $.data( this, fullName );
                    if ( !instance ) {
                        return $.error( "cannot call methods on " + name + " prior to initialization; " +
                            "attempted to call method '" + options + "'" );
                    }
                    if ( !$.isFunction( instance[options] ) || options.charAt( 0 ) === "_" ) {
                        return $.error( "no such method '" + options + "' for " + name + " widget instance" );
                    }
                    methodValue = instance[ options ].apply( instance, args );
                    if ( methodValue !== instance && methodValue !== undefined ) {
                        returnValue = methodValue && methodValue.jquery ?
                            returnValue.pushStack( methodValue.get() ) :
                            methodValue;
                        return false;
                    }
                });
            } else {
                this.each(function() {
                    var instance = $.data( this, fullName );
                    if ( instance ) {
                        instance.option( options || {} )._init();
                    } else {
                        $.data( this, fullName, new object( options, this ) );
                    }
                });
            }

            return returnValue;
        };
    };

    $.Widget = function( /* options, element */ ) {};
    $.Widget._childConstructors = [];

    $.Widget.prototype = {
        widgetName: "widget",
        widgetEventPrefix: "",
        defaultElement: "<div>",
        options: {
            disabled: false,

            // callbacks
            create: null
        },
        _createWidget: function( options, element ) {
            element = $( element || this.defaultElement || this )[ 0 ];
            this.element = $( element );
            this.uuid = uuid++;
            this.eventNamespace = "." + this.widgetName + this.uuid;
            this.options = $.widget.extend( {},
                this.options,
                this._getCreateOptions(),
                options );

            this.bindings = $();
            this.hoverable = $();
            this.focusable = $();

            if ( element !== this ) {
                $.data( element, this.widgetFullName, this );
                this._on( true, this.element, {
                    remove: function( event ) {
                        if ( event.target === element ) {
                            this.destroy();
                        }
                    }
                });
                this.document = $( element.style ?
                    // element within the document
                    element.ownerDocument :
                    // element is window or document
                element.document || element );
                this.window = $( this.document[0].defaultView || this.document[0].parentWindow );
            }

            this._create();
            this._trigger( "create", null, this._getCreateEventData() );
            this._init();
        },
        _getCreateOptions: $.noop,
        _getCreateEventData: $.noop,
        _create: $.noop,
        _init: $.noop,

        destroy: function() {
            this._destroy();
            // we can probably remove the unbind calls in 2.0
            // all event bindings should go through this._on()
            this.element
                .unbind( this.eventNamespace )
                // 1.9 BC for #7810
                // TODO remove dual storage
                .removeData( this.widgetName )
                .removeData( this.widgetFullName )
                // support: jquery <1.6.3
                // http://bugs.jquery.com/ticket/9413
                .removeData( $.camelCase( this.widgetFullName ) );
            this.widget()
                .unbind( this.eventNamespace )
                .removeAttr( "aria-disabled" )
                .removeClass(
                    this.widgetFullName + "-disabled " +
                    "ui-state-disabled" );

            // clean up events and states
            this.bindings.unbind( this.eventNamespace );
            this.hoverable.removeClass( "ui-state-hover" );
            this.focusable.removeClass( "ui-state-focus" );
        },
        _destroy: $.noop,

        widget: function() {
            return this.element;
        },

        option: function( key, value ) {
            var options = key,
                parts,
                curOption,
                i;

            if ( arguments.length === 0 ) {
                // don't return a reference to the internal hash
                return $.widget.extend( {}, this.options );
            }

            if ( typeof key === "string" ) {
                // handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
                options = {};
                parts = key.split( "." );
                key = parts.shift();
                if ( parts.length ) {
                    curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
                    for ( i = 0; i < parts.length - 1; i++ ) {
                        curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
                        curOption = curOption[ parts[ i ] ];
                    }
                    key = parts.pop();
                    if ( value === undefined ) {
                        return curOption[ key ] === undefined ? null : curOption[ key ];
                    }
                    curOption[ key ] = value;
                } else {
                    if ( value === undefined ) {
                        return this.options[ key ] === undefined ? null : this.options[ key ];
                    }
                    options[ key ] = value;
                }
            }

            this._setOptions( options );

            return this;
        },
        _setOptions: function( options ) {
            var key;

            for ( key in options ) {
                this._setOption( key, options[ key ] );
            }

            return this;
        },
        _setOption: function( key, value ) {
            this.options[ key ] = value;

            if ( key === "disabled" ) {
                this.widget()
                    .toggleClass( this.widgetFullName + "-disabled ui-state-disabled", !!value )
                    .attr( "aria-disabled", value );
                this.hoverable.removeClass( "ui-state-hover" );
                this.focusable.removeClass( "ui-state-focus" );
            }

            return this;
        },

        enable: function() {
            return this._setOption( "disabled", false );
        },
        disable: function() {
            return this._setOption( "disabled", true );
        },

        _on: function( suppressDisabledCheck, element, handlers ) {
            var delegateElement,
                instance = this;

            // no suppressDisabledCheck flag, shuffle arguments
            if ( typeof suppressDisabledCheck !== "boolean" ) {
                handlers = element;
                element = suppressDisabledCheck;
                suppressDisabledCheck = false;
            }

            // no element argument, shuffle and use this.element
            if ( !handlers ) {
                handlers = element;
                element = this.element;
                delegateElement = this.widget();
            } else {
                // accept selectors, DOM elements
                element = delegateElement = $( element );
                this.bindings = this.bindings.add( element );
            }

            $.each( handlers, function( event, handler ) {
                function handlerProxy() {
                    // allow widgets to customize the disabled handling
                    // - disabled as an array instead of boolean
                    // - disabled class as method for disabling individual parts
                    if ( !suppressDisabledCheck &&
                        ( instance.options.disabled === true ||
                        $( this ).hasClass( "ui-state-disabled" ) ) ) {
                        return;
                    }
                    return ( typeof handler === "string" ? instance[ handler ] : handler )
                        .apply( instance, arguments );
                }

                // copy the guid so direct unbinding works
                if ( typeof handler !== "string" ) {
                    handlerProxy.guid = handler.guid =
                        handler.guid || handlerProxy.guid || $.guid++;
                }

                var match = event.match( /^(\w+)\s*(.*)$/ ),
                    eventName = match[1] + instance.eventNamespace,
                    selector = match[2];
                if ( selector ) {
                    delegateElement.delegate( selector, eventName, handlerProxy );
                } else {
                    element.bind( eventName, handlerProxy );
                }
            });
        },

        _off: function( element, eventName ) {
            eventName = (eventName || "").split( " " ).join( this.eventNamespace + " " ) + this.eventNamespace;
            element.unbind( eventName ).undelegate( eventName );
        },

        _delay: function( handler, delay ) {
            function handlerProxy() {
                return ( typeof handler === "string" ? instance[ handler ] : handler )
                    .apply( instance, arguments );
            }
            var instance = this;
            return setTimeout( handlerProxy, delay || 0 );
        },

        _hoverable: function( element ) {
            this.hoverable = this.hoverable.add( element );
            this._on( element, {
                mouseenter: function( event ) {
                    $( event.currentTarget ).addClass( "ui-state-hover" );
                },
                mouseleave: function( event ) {
                    $( event.currentTarget ).removeClass( "ui-state-hover" );
                }
            });
        },

        _focusable: function( element ) {
            this.focusable = this.focusable.add( element );
            this._on( element, {
                focusin: function( event ) {
                    $( event.currentTarget ).addClass( "ui-state-focus" );
                },
                focusout: function( event ) {
                    $( event.currentTarget ).removeClass( "ui-state-focus" );
                }
            });
        },

        _trigger: function( type, event, data ) {
            var prop, orig,
                callback = this.options[ type ];

            data = data || {};
            event = $.Event( event );
            event.type = ( type === this.widgetEventPrefix ?
                type :
            this.widgetEventPrefix + type ).toLowerCase();
            // the original event may come from any element
            // so we need to reset the target on the new event
            event.target = this.element[ 0 ];

            // copy original event properties over to the new event
            orig = event.originalEvent;
            if ( orig ) {
                for ( prop in orig ) {
                    if ( !( prop in event ) ) {
                        event[ prop ] = orig[ prop ];
                    }
                }
            }

            this.element.trigger( event, data );
            return !( $.isFunction( callback ) &&
            callback.apply( this.element[0], [ event ].concat( data ) ) === false ||
            event.isDefaultPrevented() );
        }
    };

    $.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
        $.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
            if ( typeof options === "string" ) {
                options = { effect: options };
            }
            var hasOptions,
                effectName = !options ?
                    method :
                    options === true || typeof options === "number" ?
                        defaultEffect :
                    options.effect || defaultEffect;
            options = options || {};
            if ( typeof options === "number" ) {
                options = { duration: options };
            }
            hasOptions = !$.isEmptyObject( options );
            options.complete = callback;
            if ( options.delay ) {
                element.delay( options.delay );
            }
            if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
                element[ method ]( options );
            } else if ( effectName !== method && element[ effectName ] ) {
                element[ effectName ]( options.duration, options.easing, callback );
            } else {
                element.queue(function( next ) {
                    $( this )[ method ]();
                    if ( callback ) {
                        callback.call( element[ 0 ] );
                    }
                    next();
                });
            }
        };
    });

})( jQuery );

(function( $, undefined ) {

    var mouseHandled = false;
    $( document ).mouseup( function() {
        mouseHandled = false;
    });

    $.widget("ui.mouse", {
        version: "1.10.2",
        options: {
            cancel: "input,textarea,button,select,option",
            distance: 1,
            delay: 0
        },
        _mouseInit: function() {
            var that = this;

            this.element
                .bind("mousedown."+this.widgetName, function(event) {
                    return that._mouseDown(event);
                })
                .bind("click."+this.widgetName, function(event) {
                    if (true === $.data(event.target, that.widgetName + ".preventClickEvent")) {
                        $.removeData(event.target, that.widgetName + ".preventClickEvent");
                        event.stopImmediatePropagation();
                        return false;
                    }
                });

            this.started = false;
        },

        // TODO: make sure destroying one instance of mouse doesn't mess with
        // other instances of mouse
        _mouseDestroy: function() {
            this.element.unbind("."+this.widgetName);
            if ( this._mouseMoveDelegate ) {
                $(document)
                    .unbind("mousemove."+this.widgetName, this._mouseMoveDelegate)
                    .unbind("mouseup."+this.widgetName, this._mouseUpDelegate);
            }
        },

        _mouseDown: function(event) {
            // don't let more than one widget handle mouseStart
            if( mouseHandled ) { return; }

            // we may have missed mouseup (out of window)
            (this._mouseStarted && this._mouseUp(event));

            this._mouseDownEvent = event;

            var that = this,
                btnIsLeft = (event.which === 1),
                // event.target.nodeName works around a bug in IE 8 with
                // disabled inputs (#7620)
                elIsCancel = (typeof this.options.cancel === "string" && event.target.nodeName ? $(event.target).closest(this.options.cancel).length : false);
            if (!btnIsLeft || elIsCancel || !this._mouseCapture(event)) {
                return true;
            }

            this.mouseDelayMet = !this.options.delay;
            if (!this.mouseDelayMet) {
                this._mouseDelayTimer = setTimeout(function() {
                    that.mouseDelayMet = true;
                }, this.options.delay);
            }

            if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
                this._mouseStarted = (this._mouseStart(event) !== false);
                if (!this._mouseStarted) {
                    event.preventDefault();
                    return true;
                }
            }

            // Click event may never have fired (Gecko & Opera)
            if (true === $.data(event.target, this.widgetName + ".preventClickEvent")) {
                $.removeData(event.target, this.widgetName + ".preventClickEvent");
            }

            // these delegates are required to keep context
            this._mouseMoveDelegate = function(event) {
                return that._mouseMove(event);
            };
            this._mouseUpDelegate = function(event) {
                return that._mouseUp(event);
            };
            $(document)
                .bind("mousemove."+this.widgetName, this._mouseMoveDelegate)
                .bind("mouseup."+this.widgetName, this._mouseUpDelegate);

            event.preventDefault();

            mouseHandled = true;
            return true;
        },

        _mouseMove: function(event) {
            // IE mouseup check - mouseup happened when mouse was out of window
            if ($.ui.ie && ( !document.documentMode || document.documentMode < 9 ) && !event.button) {
                return this._mouseUp(event);
            }

            if (this._mouseStarted) {
                this._mouseDrag(event);
                return event.preventDefault();
            }

            if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
                this._mouseStarted =
                    (this._mouseStart(this._mouseDownEvent, event) !== false);
                (this._mouseStarted ? this._mouseDrag(event) : this._mouseUp(event));
            }

            return !this._mouseStarted;
        },

        _mouseUp: function(event) {
            $(document)
                .unbind("mousemove."+this.widgetName, this._mouseMoveDelegate)
                .unbind("mouseup."+this.widgetName, this._mouseUpDelegate);

            if (this._mouseStarted) {
                this._mouseStarted = false;

                if (event.target === this._mouseDownEvent.target) {
                    $.data(event.target, this.widgetName + ".preventClickEvent", true);
                }

                this._mouseStop(event);
            }

            return false;
        },

        _mouseDistanceMet: function(event) {
            return (Math.max(
                    Math.abs(this._mouseDownEvent.pageX - event.pageX),
                    Math.abs(this._mouseDownEvent.pageY - event.pageY)
                ) >= this.options.distance
            );
        },

        _mouseDelayMet: function(/* event */) {
            return this.mouseDelayMet;
        },

        // These are placeholder methods, to be overriden by extending plugin
        _mouseStart: function(/* event */) {},
        _mouseDrag: function(/* event */) {},
        _mouseStop: function(/* event */) {},
        _mouseCapture: function(/* event */) { return true; }
    });

})(jQuery);

(function( $, undefined ) {

    $.widget("ui.draggable", $.ui.mouse, {
        version: "1.10.2",
        widgetEventPrefix: "drag",
        options: {
            addClasses: true,
            appendTo: "parent",
            axis: false,
            connectToSortable: false,
            containment: false,
            cursor: "auto",
            cursorAt: false,
            grid: false,
            handle: false,
            helper: "original",
            iframeFix: false,
            opacity: false,
            refreshPositions: false,
            revert: false,
            revertDuration: 500,
            scope: "default",
            scroll: true,
            scrollSensitivity: 20,
            scrollSpeed: 20,
            snap: false,
            snapMode: "both",
            snapTolerance: 20,
            stack: false,
            zIndex: false,

            // callbacks
            drag: null,
            start: null,
            stop: null
        },
        _create: function() {

            if (this.options.helper === "original" && !(/^(?:r|a|f)/).test(this.element.css("position"))) {
                this.element[0].style.position = "relative";
            }
            if (this.options.addClasses){
                this.element.addClass("ui-draggable");
            }
            if (this.options.disabled){
                this.element.addClass("ui-draggable-disabled");
            }

            this._mouseInit();

        },

        _destroy: function() {
            this.element.removeClass( "ui-draggable ui-draggable-dragging ui-draggable-disabled" );
            this._mouseDestroy();
        },

        _mouseCapture: function(event) {

            var o = this.options;

            // among others, prevent a drag on a resizable-handle
            if (this.helper || o.disabled || $(event.target).closest(".ui-resizable-handle").length > 0) {
                return false;
            }

            //Quit if we're not on a valid handle
            this.handle = this._getHandle(event);
            if (!this.handle) {
                return false;
            }

            $(o.iframeFix === true ? "iframe" : o.iframeFix).each(function() {
                $("<div class='ui-draggable-iframeFix' style='background: #fff;'></div>")
                    .css({
                        width: this.offsetWidth+"px", height: this.offsetHeight+"px",
                        position: "absolute", opacity: "0.001", zIndex: 1000
                    })
                    .css($(this).offset())
                    .appendTo("body");
            });

            return true;

        },

        _mouseStart: function(event) {

            var o = this.options;

            //Create and append the visible helper
            this.helper = this._createHelper(event);

            this.helper.addClass("ui-draggable-dragging");

            //Cache the helper size
            this._cacheHelperProportions();

            //If ddmanager is used for droppables, set the global draggable
            if($.ui.ddmanager) {
                $.ui.ddmanager.current = this;
            }

            /*
             * - Position generation -
             * This block generates everything position related - it's the core of draggables.
             */

            //Cache the margins of the original element
            this._cacheMargins();

            //Store the helper's css position
            this.cssPosition = this.helper.css("position");
            this.scrollParent = this.helper.scrollParent();

            //The element's absolute position on the page minus margins
            this.offset = this.positionAbs = this.element.offset();
            this.offset = {
                top: this.offset.top - this.margins.top,
                left: this.offset.left - this.margins.left
            };

            $.extend(this.offset, {
                click: { //Where the click happened, relative to the element
                    left: event.pageX - this.offset.left,
                    top: event.pageY - this.offset.top
                },
                parent: this._getParentOffset(),
                relative: this._getRelativeOffset() //This is a relative to absolute position minus the actual position calculation - only used for relative positioned helper
            });

            //Generate the original position
            this.originalPosition = this.position = this._generatePosition(event);
            this.originalPageX = event.pageX;
            this.originalPageY = event.pageY;

            //Adjust the mouse offset relative to the helper if "cursorAt" is supplied
            (o.cursorAt && this._adjustOffsetFromHelper(o.cursorAt));

            //Set a containment if given in the options
            if(o.containment) {
                this._setContainment();
            }

            //Trigger event + callbacks
            if(this._trigger("start", event) === false) {
                this._clear();
                return false;
            }

            //Recache the helper size
            this._cacheHelperProportions();

            //Prepare the droppable offsets
            if ($.ui.ddmanager && !o.dropBehaviour) {
                $.ui.ddmanager.prepareOffsets(this, event);
            }


            this._mouseDrag(event, true); //Execute the drag once - this causes the helper not to be visible before getting its correct position

            //If the ddmanager is used for droppables, inform the manager that dragging has started (see #5003)
            if ( $.ui.ddmanager ) {
                $.ui.ddmanager.dragStart(this, event);
            }

            return true;
        },

        _mouseDrag: function(event, noPropagation) {

            //Compute the helpers position
            this.position = this._generatePosition(event);
            this.positionAbs = this._convertPositionTo("absolute");

            //Call plugins and callbacks and use the resulting position if something is returned
            if (!noPropagation) {
                var ui = this._uiHash();
                if(this._trigger("drag", event, ui) === false) {
                    this._mouseUp({});
                    return false;
                }
                this.position = ui.position;
            }

            if(!this.options.axis || this.options.axis !== "y") {
                this.helper[0].style.left = this.position.left+"px";
            }
            if(!this.options.axis || this.options.axis !== "x") {
                this.helper[0].style.top = this.position.top+"px";
            }
            if($.ui.ddmanager) {
                $.ui.ddmanager.drag(this, event);
            }

            return false;
        },

        _mouseStop: function(event) {

            //If we are using droppables, inform the manager about the drop
            var element,
                that = this,
                elementInDom = false,
                dropped = false;
            if ($.ui.ddmanager && !this.options.dropBehaviour) {
                dropped = $.ui.ddmanager.drop(this, event);
            }

            //if a drop comes from outside (a sortable)
            if(this.dropped) {
                dropped = this.dropped;
                this.dropped = false;
            }

            //if the original element is no longer in the DOM don't bother to continue (see #8269)
            element = this.element[0];
            while ( element && (element = element.parentNode) ) {
                if (element === document ) {
                    elementInDom = true;
                }
            }
            if ( !elementInDom && this.options.helper === "original" ) {
                return false;
            }

            if((this.options.revert === "invalid" && !dropped) || (this.options.revert === "valid" && dropped) || this.options.revert === true || ($.isFunction(this.options.revert) && this.options.revert.call(this.element, dropped))) {
                $(this.helper).animate(this.originalPosition, parseInt(this.options.revertDuration, 10), function() {
                    if(that._trigger("stop", event) !== false) {
                        that._clear();
                    }
                });
            } else {
                if(this._trigger("stop", event) !== false) {
                    this._clear();
                }
            }

            return false;
        },

        _mouseUp: function(event) {
            //Remove frame helpers
            $("div.ui-draggable-iframeFix").each(function() {
                this.parentNode.removeChild(this);
            });

            //If the ddmanager is used for droppables, inform the manager that dragging has stopped (see #5003)
            if( $.ui.ddmanager ) {
                $.ui.ddmanager.dragStop(this, event);
            }

            return $.ui.mouse.prototype._mouseUp.call(this, event);
        },

        cancel: function() {

            if(this.helper.is(".ui-draggable-dragging")) {
                this._mouseUp({});
            } else {
                this._clear();
            }

            return this;

        },

        _getHandle: function(event) {
            return this.options.handle ?
                !!$( event.target ).closest( this.element.find( this.options.handle ) ).length :
                true;
        },

        _createHelper: function(event) {

            var o = this.options,
                helper = $.isFunction(o.helper) ? $(o.helper.apply(this.element[0], [event])) : (o.helper === "clone" ? this.element.clone().removeAttr("id") : this.element);

            if(!helper.parents("body").length) {
                helper.appendTo((o.appendTo === "parent" ? this.element[0].parentNode : o.appendTo));
            }

            if(helper[0] !== this.element[0] && !(/(fixed|absolute)/).test(helper.css("position"))) {
                helper.css("position", "absolute");
            }

            return helper;

        },

        _adjustOffsetFromHelper: function(obj) {
            if (typeof obj === "string") {
                obj = obj.split(" ");
            }
            if ($.isArray(obj)) {
                obj = {left: +obj[0], top: +obj[1] || 0};
            }
            if ("left" in obj) {
                this.offset.click.left = obj.left + this.margins.left;
            }
            if ("right" in obj) {
                this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
            }
            if ("top" in obj) {
                this.offset.click.top = obj.top + this.margins.top;
            }
            if ("bottom" in obj) {
                this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
            }
        },

        _getParentOffset: function() {

            //Get the offsetParent and cache its position
            this.offsetParent = this.helper.offsetParent();
            var po = this.offsetParent.offset();

            // This is a special case where we need to modify a offset calculated on start, since the following happened:
            // 1. The position of the helper is absolute, so it's position is calculated based on the next positioned parent
            // 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't the document, which means that
            //    the scroll is included in the initial calculation of the offset of the parent, and never recalculated upon drag
            if(this.cssPosition === "absolute" && this.scrollParent[0] !== document && $.contains(this.scrollParent[0], this.offsetParent[0])) {
                po.left += this.scrollParent.scrollLeft();
                po.top += this.scrollParent.scrollTop();
            }

            //This needs to be actually done for all browsers, since pageX/pageY includes this information
            //Ugly IE fix
            if((this.offsetParent[0] === document.body) ||
                (this.offsetParent[0].tagName && this.offsetParent[0].tagName.toLowerCase() === "html" && $.ui.ie)) {
                po = { top: 0, left: 0 };
            }

            return {
                top: po.top + (parseInt(this.offsetParent.css("borderTopWidth"),10) || 0),
                left: po.left + (parseInt(this.offsetParent.css("borderLeftWidth"),10) || 0)
            };

        },

        _getRelativeOffset: function() {

            if(this.cssPosition === "relative") {
                var p = this.element.position();
                return {
                    top: p.top - (parseInt(this.helper.css("top"),10) || 0) + this.scrollParent.scrollTop(),
                    left: p.left - (parseInt(this.helper.css("left"),10) || 0) + this.scrollParent.scrollLeft()
                };
            } else {
                return { top: 0, left: 0 };
            }

        },

        _cacheMargins: function() {
            this.margins = {
                left: (parseInt(this.element.css("marginLeft"),10) || 0),
                top: (parseInt(this.element.css("marginTop"),10) || 0),
                right: (parseInt(this.element.css("marginRight"),10) || 0),
                bottom: (parseInt(this.element.css("marginBottom"),10) || 0)
            };
        },

        _cacheHelperProportions: function() {
            this.helperProportions = {
                width: this.helper.outerWidth(),
                height: this.helper.outerHeight()
            };
        },

        _setContainment: function() {

            var over, c, ce,
                o = this.options;

            if(o.containment === "parent") {
                o.containment = this.helper[0].parentNode;
            }
            if(o.containment === "document" || o.containment === "window") {
                this.containment = [
                    o.containment === "document" ? 0 : $(window).scrollLeft() - this.offset.relative.left - this.offset.parent.left,
                    o.containment === "document" ? 0 : $(window).scrollTop() - this.offset.relative.top - this.offset.parent.top,
                    (o.containment === "document" ? 0 : $(window).scrollLeft()) + $(o.containment === "document" ? document : window).width() - this.helperProportions.width - this.margins.left,
                    (o.containment === "document" ? 0 : $(window).scrollTop()) + ($(o.containment === "document" ? document : window).height() || document.body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top
                ];
            }

            if(!(/^(document|window|parent)$/).test(o.containment) && o.containment.constructor !== Array) {
                c = $(o.containment);
                ce = c[0];

                if(!ce) {
                    return;
                }

                over = ($(ce).css("overflow") !== "hidden");

                this.containment = [
                    (parseInt($(ce).css("borderLeftWidth"),10) || 0) + (parseInt($(ce).css("paddingLeft"),10) || 0),
                    (parseInt($(ce).css("borderTopWidth"),10) || 0) + (parseInt($(ce).css("paddingTop"),10) || 0),
                    (over ? Math.max(ce.scrollWidth,ce.offsetWidth) : ce.offsetWidth) - (parseInt($(ce).css("borderRightWidth"),10) || 0) - (parseInt($(ce).css("paddingRight"),10) || 0) - this.helperProportions.width - this.margins.left - this.margins.right,
                    (over ? Math.max(ce.scrollHeight,ce.offsetHeight) : ce.offsetHeight) - (parseInt($(ce).css("borderBottomWidth"),10) || 0) - (parseInt($(ce).css("paddingBottom"),10) || 0) - this.helperProportions.height - this.margins.top  - this.margins.bottom
                ];
                this.relative_container = c;

            } else if(o.containment.constructor === Array) {
                this.containment = o.containment;
            }

        },

        _convertPositionTo: function(d, pos) {

            if(!pos) {
                pos = this.position;
            }

            var mod = d === "absolute" ? 1 : -1,
                scroll = this.cssPosition === "absolute" && !(this.scrollParent[0] !== document && $.contains(this.scrollParent[0], this.offsetParent[0])) ? this.offsetParent : this.scrollParent, scrollIsRootNode = (/(html|body)/i).test(scroll[0].tagName);

            return {
                top: (
                    pos.top	+																// The absolute mouse position
                    this.offset.relative.top * mod +										// Only for relative positioned nodes: Relative offset from element to offset parent
                    this.offset.parent.top * mod -										// The offsetParent's offset without borders (offset + border)
                    ( ( this.cssPosition === "fixed" ? -this.scrollParent.scrollTop() : ( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) * mod)
                ),
                left: (
                    pos.left +																// The absolute mouse position
                    this.offset.relative.left * mod +										// Only for relative positioned nodes: Relative offset from element to offset parent
                    this.offset.parent.left * mod	-										// The offsetParent's offset without borders (offset + border)
                    ( ( this.cssPosition === "fixed" ? -this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 : scroll.scrollLeft() ) * mod)
                )
            };

        },

        _generatePosition: function(event) {

            var containment, co, top, left,
                o = this.options,
                scroll = this.cssPosition === "absolute" && !(this.scrollParent[0] !== document && $.contains(this.scrollParent[0], this.offsetParent[0])) ? this.offsetParent : this.scrollParent,
                scrollIsRootNode = (/(html|body)/i).test(scroll[0].tagName),
                pageX = event.pageX,
                pageY = event.pageY;

            /*
             * - Position constraining -
             * Constrain the position to a mix of grid, containment.
             */

            if(this.originalPosition) { //If we are not dragging yet, we won't check for options
                if(this.containment) {
                    if (this.relative_container){
                        co = this.relative_container.offset();
                        containment = [ this.containment[0] + co.left,
                            this.containment[1] + co.top,
                            this.containment[2] + co.left,
                            this.containment[3] + co.top ];
                    }
                    else {
                        containment = this.containment;
                    }

                    if(event.pageX - this.offset.click.left < containment[0]) {
                        pageX = containment[0] + this.offset.click.left;
                    }
                    if(event.pageY - this.offset.click.top < containment[1]) {
                        pageY = containment[1] + this.offset.click.top;
                    }
                    if(event.pageX - this.offset.click.left > containment[2]) {
                        pageX = containment[2] + this.offset.click.left;
                    }
                    if(event.pageY - this.offset.click.top > containment[3]) {
                        pageY = containment[3] + this.offset.click.top;
                    }
                }

                if(o.grid) {
                    //Check for grid elements set to 0 to prevent divide by 0 error causing invalid argument errors in IE (see ticket #6950)
                    top = o.grid[1] ? this.originalPageY + Math.round((pageY - this.originalPageY) / o.grid[1]) * o.grid[1] : this.originalPageY;
                    pageY = containment ? ((top - this.offset.click.top >= containment[1] || top - this.offset.click.top > containment[3]) ? top : ((top - this.offset.click.top >= containment[1]) ? top - o.grid[1] : top + o.grid[1])) : top;

                    left = o.grid[0] ? this.originalPageX + Math.round((pageX - this.originalPageX) / o.grid[0]) * o.grid[0] : this.originalPageX;
                    pageX = containment ? ((left - this.offset.click.left >= containment[0] || left - this.offset.click.left > containment[2]) ? left : ((left - this.offset.click.left >= containment[0]) ? left - o.grid[0] : left + o.grid[0])) : left;
                }

            }

            return {
                top: (
                    pageY -																	// The absolute mouse position
                    this.offset.click.top	-												// Click offset (relative to the element)
                    this.offset.relative.top -												// Only for relative positioned nodes: Relative offset from element to offset parent
                    this.offset.parent.top +												// The offsetParent's offset without borders (offset + border)
                    ( ( this.cssPosition === "fixed" ? -this.scrollParent.scrollTop() : ( scrollIsRootNode ? 0 : scroll.scrollTop() ) ))
                ),
                left: (
                    pageX -																	// The absolute mouse position
                    this.offset.click.left -												// Click offset (relative to the element)
                    this.offset.relative.left -												// Only for relative positioned nodes: Relative offset from element to offset parent
                    this.offset.parent.left +												// The offsetParent's offset without borders (offset + border)
                    ( ( this.cssPosition === "fixed" ? -this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 : scroll.scrollLeft() ))
                )
            };

        },

        _clear: function() {
            this.helper.removeClass("ui-draggable-dragging");
            if(this.helper[0] !== this.element[0] && !this.cancelHelperRemoval) {
                this.helper.remove();
            }
            this.helper = null;
            this.cancelHelperRemoval = false;
        },

        // From now on bulk stuff - mainly helpers

        _trigger: function(type, event, ui) {
            ui = ui || this._uiHash();
            $.ui.plugin.call(this, type, [event, ui]);
            //The absolute position has to be recalculated after plugins
            if(type === "drag") {
                this.positionAbs = this._convertPositionTo("absolute");
            }
            return $.Widget.prototype._trigger.call(this, type, event, ui);
        },

        plugins: {},

        _uiHash: function() {
            return {
                helper: this.helper,
                position: this.position,
                originalPosition: this.originalPosition,
                offset: this.positionAbs
            };
        }

    });

    $.ui.plugin.add("draggable", "connectToSortable", {
        start: function(event, ui) {

            var inst = $(this).data("ui-draggable"), o = inst.options,
                uiSortable = $.extend({}, ui, { item: inst.element });
            inst.sortables = [];
            $(o.connectToSortable).each(function() {
                var sortable = $.data(this, "ui-sortable");
                if (sortable && !sortable.options.disabled) {
                    inst.sortables.push({
                        instance: sortable,
                        shouldRevert: sortable.options.revert
                    });
                    sortable.refreshPositions();	// Call the sortable's refreshPositions at drag start to refresh the containerCache since the sortable container cache is used in drag and needs to be up to date (this will ensure it's initialised as well as being kept in step with any changes that might have happened on the page).
                    sortable._trigger("activate", event, uiSortable);
                }
            });

        },
        stop: function(event, ui) {

            //If we are still over the sortable, we fake the stop event of the sortable, but also remove helper
            var inst = $(this).data("ui-draggable"),
                uiSortable = $.extend({}, ui, { item: inst.element });

            $.each(inst.sortables, function() {
                if(this.instance.isOver) {

                    this.instance.isOver = 0;

                    inst.cancelHelperRemoval = true; //Don't remove the helper in the draggable instance
                    this.instance.cancelHelperRemoval = false; //Remove it in the sortable instance (so sortable plugins like revert still work)

                    //The sortable revert is supported, and we have to set a temporary dropped variable on the draggable to support revert: "valid/invalid"
                    if(this.shouldRevert) {
                        this.instance.options.revert = this.shouldRevert;
                    }

                    //Trigger the stop of the sortable
                    this.instance._mouseStop(event);

                    this.instance.options.helper = this.instance.options._helper;

                    //If the helper has been the original item, restore properties in the sortable
                    if(inst.options.helper === "original") {
                        this.instance.currentItem.css({ top: "auto", left: "auto" });
                    }

                } else {
                    this.instance.cancelHelperRemoval = false; //Remove the helper in the sortable instance
                    this.instance._trigger("deactivate", event, uiSortable);
                }

            });

        },
        drag: function(event, ui) {

            var inst = $(this).data("ui-draggable"), that = this;

            $.each(inst.sortables, function() {

                var innermostIntersecting = false,
                    thisSortable = this;

                //Copy over some variables to allow calling the sortable's native _intersectsWith
                this.instance.positionAbs = inst.positionAbs;
                this.instance.helperProportions = inst.helperProportions;
                this.instance.offset.click = inst.offset.click;

                if(this.instance._intersectsWith(this.instance.containerCache)) {
                    innermostIntersecting = true;
                    $.each(inst.sortables, function () {
                        this.instance.positionAbs = inst.positionAbs;
                        this.instance.helperProportions = inst.helperProportions;
                        this.instance.offset.click = inst.offset.click;
                        if (this !== thisSortable &&
                            this.instance._intersectsWith(this.instance.containerCache) &&
                            $.contains(thisSortable.instance.element[0], this.instance.element[0])
                        ) {
                            innermostIntersecting = false;
                        }
                        return innermostIntersecting;
                    });
                }


                if(innermostIntersecting) {
                    //If it intersects, we use a little isOver variable and set it once, so our move-in stuff gets fired only once
                    if(!this.instance.isOver) {

                        this.instance.isOver = 1;
                        //Now we fake the start of dragging for the sortable instance,
                        //by cloning the list group item, appending it to the sortable and using it as inst.currentItem
                        //We can then fire the start event of the sortable with our passed browser event, and our own helper (so it doesn't create a new one)
                        this.instance.currentItem = $(that).clone().removeAttr("id").appendTo(this.instance.element).data("ui-sortable-item", true);
                        this.instance.options._helper = this.instance.options.helper; //Store helper option to later restore it
                        this.instance.options.helper = function() { return ui.helper[0]; };

                        event.target = this.instance.currentItem[0];
                        this.instance._mouseCapture(event, true);
                        this.instance._mouseStart(event, true, true);

                        //Because the browser event is way off the new appended portlet, we modify a couple of variables to reflect the changes
                        this.instance.offset.click.top = inst.offset.click.top;
                        this.instance.offset.click.left = inst.offset.click.left;
                        this.instance.offset.parent.left -= inst.offset.parent.left - this.instance.offset.parent.left;
                        this.instance.offset.parent.top -= inst.offset.parent.top - this.instance.offset.parent.top;

                        inst._trigger("toSortable", event);
                        inst.dropped = this.instance.element; //draggable revert needs that
                        //hack so receive/update callbacks work (mostly)
                        inst.currentItem = inst.element;
                        this.instance.fromOutside = inst;

                    }

                    //Provided we did all the previous steps, we can fire the drag event of the sortable on every draggable drag, when it intersects with the sortable
                    if(this.instance.currentItem) {
                        this.instance._mouseDrag(event);
                    }

                } else {

                    //If it doesn't intersect with the sortable, and it intersected before,
                    //we fake the drag stop of the sortable, but make sure it doesn't remove the helper by using cancelHelperRemoval
                    if(this.instance.isOver) {

                        this.instance.isOver = 0;
                        this.instance.cancelHelperRemoval = true;

                        //Prevent reverting on this forced stop
                        this.instance.options.revert = false;

                        // The out event needs to be triggered independently
                        this.instance._trigger("out", event, this.instance._uiHash(this.instance));

                        this.instance._mouseStop(event, true);
                        this.instance.options.helper = this.instance.options._helper;

                        //Now we remove our currentItem, the list group clone again, and the placeholder, and animate the helper back to it's original size
                        this.instance.currentItem.remove();
                        if(this.instance.placeholder) {
                            this.instance.placeholder.remove();
                        }

                        inst._trigger("fromSortable", event);
                        inst.dropped = false; //draggable revert needs that
                    }

                }

            });

        }
    });

    $.ui.plugin.add("draggable", "cursor", {
        start: function() {
            var t = $("body"), o = $(this).data("ui-draggable").options;
            if (t.css("cursor")) {
                o._cursor = t.css("cursor");
            }
            t.css("cursor", o.cursor);
        },
        stop: function() {
            var o = $(this).data("ui-draggable").options;
            if (o._cursor) {
                $("body").css("cursor", o._cursor);
            }
        }
    });

    $.ui.plugin.add("draggable", "opacity", {
        start: function(event, ui) {
            var t = $(ui.helper), o = $(this).data("ui-draggable").options;
            if(t.css("opacity")) {
                o._opacity = t.css("opacity");
            }
            t.css("opacity", o.opacity);
        },
        stop: function(event, ui) {
            var o = $(this).data("ui-draggable").options;
            if(o._opacity) {
                $(ui.helper).css("opacity", o._opacity);
            }
        }
    });

    $.ui.plugin.add("draggable", "scroll", {
        start: function() {
            var i = $(this).data("ui-draggable");
            if(i.scrollParent[0] !== document && i.scrollParent[0].tagName !== "HTML") {
                i.overflowOffset = i.scrollParent.offset();
            }
        },
        drag: function( event ) {

            var i = $(this).data("ui-draggable"), o = i.options, scrolled = false;

            if(i.scrollParent[0] !== document && i.scrollParent[0].tagName !== "HTML") {

                if(!o.axis || o.axis !== "x") {
                    if((i.overflowOffset.top + i.scrollParent[0].offsetHeight) - event.pageY < o.scrollSensitivity) {
                        i.scrollParent[0].scrollTop = scrolled = i.scrollParent[0].scrollTop + o.scrollSpeed;
                    } else if(event.pageY - i.overflowOffset.top < o.scrollSensitivity) {
                        i.scrollParent[0].scrollTop = scrolled = i.scrollParent[0].scrollTop - o.scrollSpeed;
                    }
                }

                if(!o.axis || o.axis !== "y") {
                    if((i.overflowOffset.left + i.scrollParent[0].offsetWidth) - event.pageX < o.scrollSensitivity) {
                        i.scrollParent[0].scrollLeft = scrolled = i.scrollParent[0].scrollLeft + o.scrollSpeed;
                    } else if(event.pageX - i.overflowOffset.left < o.scrollSensitivity) {
                        i.scrollParent[0].scrollLeft = scrolled = i.scrollParent[0].scrollLeft - o.scrollSpeed;
                    }
                }

            } else {

                if(!o.axis || o.axis !== "x") {
                    if(event.pageY - $(document).scrollTop() < o.scrollSensitivity) {
                        scrolled = $(document).scrollTop($(document).scrollTop() - o.scrollSpeed);
                    } else if($(window).height() - (event.pageY - $(document).scrollTop()) < o.scrollSensitivity) {
                        scrolled = $(document).scrollTop($(document).scrollTop() + o.scrollSpeed);
                    }
                }

                if(!o.axis || o.axis !== "y") {
                    if(event.pageX - $(document).scrollLeft() < o.scrollSensitivity) {
                        scrolled = $(document).scrollLeft($(document).scrollLeft() - o.scrollSpeed);
                    } else if($(window).width() - (event.pageX - $(document).scrollLeft()) < o.scrollSensitivity) {
                        scrolled = $(document).scrollLeft($(document).scrollLeft() + o.scrollSpeed);
                    }
                }

            }

            if(scrolled !== false && $.ui.ddmanager && !o.dropBehaviour) {
                $.ui.ddmanager.prepareOffsets(i, event);
            }

        }
    });

    $.ui.plugin.add("draggable", "snap", {
        start: function() {

            var i = $(this).data("ui-draggable"),
                o = i.options;

            i.snapElements = [];

            $(o.snap.constructor !== String ? ( o.snap.items || ":data(ui-draggable)" ) : o.snap).each(function() {
                var $t = $(this),
                    $o = $t.offset();
                if(this !== i.element[0]) {
                    i.snapElements.push({
                        item: this,
                        width: $t.outerWidth(), height: $t.outerHeight(),
                        top: $o.top, left: $o.left
                    });
                }
            });

        },
        drag: function(event, ui) {

            var ts, bs, ls, rs, l, r, t, b, i, first,
                inst = $(this).data("ui-draggable"),
                o = inst.options,
                d = o.snapTolerance,
                x1 = ui.offset.left, x2 = x1 + inst.helperProportions.width,
                y1 = ui.offset.top, y2 = y1 + inst.helperProportions.height;

            for (i = inst.snapElements.length - 1; i >= 0; i--){

                l = inst.snapElements[i].left;
                r = l + inst.snapElements[i].width;
                t = inst.snapElements[i].top;
                b = t + inst.snapElements[i].height;

                //Yes, I know, this is insane ;)
                if(!((l-d < x1 && x1 < r+d && t-d < y1 && y1 < b+d) || (l-d < x1 && x1 < r+d && t-d < y2 && y2 < b+d) || (l-d < x2 && x2 < r+d && t-d < y1 && y1 < b+d) || (l-d < x2 && x2 < r+d && t-d < y2 && y2 < b+d))) {
                    if(inst.snapElements[i].snapping) {
                        (inst.options.snap.release && inst.options.snap.release.call(inst.element, event, $.extend(inst._uiHash(), { snapItem: inst.snapElements[i].item })));
                    }
                    inst.snapElements[i].snapping = false;
                    continue;
                }

                if(o.snapMode !== "inner") {
                    ts = Math.abs(t - y2) <= d;
                    bs = Math.abs(b - y1) <= d;
                    ls = Math.abs(l - x2) <= d;
                    rs = Math.abs(r - x1) <= d;
                    if(ts) {
                        ui.position.top = inst._convertPositionTo("relative", { top: t - inst.helperProportions.height, left: 0 }).top - inst.margins.top;
                    }
                    if(bs) {
                        ui.position.top = inst._convertPositionTo("relative", { top: b, left: 0 }).top - inst.margins.top;
                    }
                    if(ls) {
                        ui.position.left = inst._convertPositionTo("relative", { top: 0, left: l - inst.helperProportions.width }).left - inst.margins.left;
                    }
                    if(rs) {
                        ui.position.left = inst._convertPositionTo("relative", { top: 0, left: r }).left - inst.margins.left;
                    }
                }

                first = (ts || bs || ls || rs);

                if(o.snapMode !== "outer") {
                    ts = Math.abs(t - y1) <= d;
                    bs = Math.abs(b - y2) <= d;
                    ls = Math.abs(l - x1) <= d;
                    rs = Math.abs(r - x2) <= d;
                    if(ts) {
                        ui.position.top = inst._convertPositionTo("relative", { top: t, left: 0 }).top - inst.margins.top;
                    }
                    if(bs) {
                        ui.position.top = inst._convertPositionTo("relative", { top: b - inst.helperProportions.height, left: 0 }).top - inst.margins.top;
                    }
                    if(ls) {
                        ui.position.left = inst._convertPositionTo("relative", { top: 0, left: l }).left - inst.margins.left;
                    }
                    if(rs) {
                        ui.position.left = inst._convertPositionTo("relative", { top: 0, left: r - inst.helperProportions.width }).left - inst.margins.left;
                    }
                }

                if(!inst.snapElements[i].snapping && (ts || bs || ls || rs || first)) {
                    (inst.options.snap.snap && inst.options.snap.snap.call(inst.element, event, $.extend(inst._uiHash(), { snapItem: inst.snapElements[i].item })));
                }
                inst.snapElements[i].snapping = (ts || bs || ls || rs || first);

            }

        }
    });

    $.ui.plugin.add("draggable", "stack", {
        start: function() {
            var min,
                o = this.data("ui-draggable").options,
                group = $.makeArray($(o.stack)).sort(function(a,b) {
                    return (parseInt($(a).css("zIndex"),10) || 0) - (parseInt($(b).css("zIndex"),10) || 0);
                });

            if (!group.length) { return; }

            min = parseInt($(group[0]).css("zIndex"), 10) || 0;
            $(group).each(function(i) {
                $(this).css("zIndex", min + i);
            });
            this.css("zIndex", (min + group.length));
        }
    });

    $.ui.plugin.add("draggable", "zIndex", {
        start: function(event, ui) {
            var t = $(ui.helper), o = $(this).data("ui-draggable").options;
            if(t.css("zIndex")) {
                o._zIndex = t.css("zIndex");
            }
            t.css("zIndex", o.zIndex);
        },
        stop: function(event, ui) {
            var o = $(this).data("ui-draggable").options;
            if(o._zIndex) {
                $(ui.helper).css("zIndex", o._zIndex);
            }
        }
    });

})(jQuery);

(function( $, undefined ) {

    function isOverAxis( x, reference, size ) {
        return ( x > reference ) && ( x < ( reference + size ) );
    }

    $.widget("ui.droppable", {
        version: "1.10.2",
        widgetEventPrefix: "drop",
        options: {
            accept: "*",
            activeClass: false,
            addClasses: true,
            greedy: false,
            hoverClass: false,
            scope: "default",
            tolerance: "intersect",

            // callbacks
            activate: null,
            deactivate: null,
            drop: null,
            out: null,
            over: null
        },
        _create: function() {

            var o = this.options,
                accept = o.accept;

            this.isover = false;
            this.isout = true;

            this.accept = $.isFunction(accept) ? accept : function(d) {
                return d.is(accept);
            };

            //Store the droppable's proportions
            this.proportions = { width: this.element[0].offsetWidth, height: this.element[0].offsetHeight };

            // Add the reference and positions to the manager
            $.ui.ddmanager.droppables[o.scope] = $.ui.ddmanager.droppables[o.scope] || [];
            $.ui.ddmanager.droppables[o.scope].push(this);

            (o.addClasses && this.element.addClass("ui-droppable"));

        },

        _destroy: function() {
            var i = 0,
                drop = $.ui.ddmanager.droppables[this.options.scope];

            for ( ; i < drop.length; i++ ) {
                if ( drop[i] === this ) {
                    drop.splice(i, 1);
                }
            }

            this.element.removeClass("ui-droppable ui-droppable-disabled");
        },

        _setOption: function(key, value) {

            if(key === "accept") {
                this.accept = $.isFunction(value) ? value : function(d) {
                    return d.is(value);
                };
            }
            $.Widget.prototype._setOption.apply(this, arguments);
        },

        _activate: function(event) {
            var draggable = $.ui.ddmanager.current;
            if(this.options.activeClass) {
                this.element.addClass(this.options.activeClass);
            }
            if(draggable){
                this._trigger("activate", event, this.ui(draggable));
            }
        },

        _deactivate: function(event) {
            var draggable = $.ui.ddmanager.current;
            if(this.options.activeClass) {
                this.element.removeClass(this.options.activeClass);
            }
            if(draggable){
                this._trigger("deactivate", event, this.ui(draggable));
            }
        },

        _over: function(event) {

            var draggable = $.ui.ddmanager.current;

            // Bail if draggable and droppable are same element
            if (!draggable || (draggable.currentItem || draggable.element)[0] === this.element[0]) {
                return;
            }

            if (this.accept.call(this.element[0],(draggable.currentItem || draggable.element))) {
                if(this.options.hoverClass) {
                    this.element.addClass(this.options.hoverClass);
                }
                this._trigger("over", event, this.ui(draggable));
            }

        },

        _out: function(event) {

            var draggable = $.ui.ddmanager.current;

            // Bail if draggable and droppable are same element
            if (!draggable || (draggable.currentItem || draggable.element)[0] === this.element[0]) {
                return;
            }

            if (this.accept.call(this.element[0],(draggable.currentItem || draggable.element))) {
                if(this.options.hoverClass) {
                    this.element.removeClass(this.options.hoverClass);
                }
                this._trigger("out", event, this.ui(draggable));
            }

        },

        _drop: function(event,custom) {

            var draggable = custom || $.ui.ddmanager.current,
                childrenIntersection = false;

            // Bail if draggable and droppable are same element
            if (!draggable || (draggable.currentItem || draggable.element)[0] === this.element[0]) {
                return false;
            }

            this.element.find(":data(ui-droppable)").not(".ui-draggable-dragging").each(function() {
                var inst = $.data(this, "ui-droppable");
                if(
                    inst.options.greedy &&
                    !inst.options.disabled &&
                    inst.options.scope === draggable.options.scope &&
                    inst.accept.call(inst.element[0], (draggable.currentItem || draggable.element)) &&
                    $.ui.intersect(draggable, $.extend(inst, { offset: inst.element.offset() }), inst.options.tolerance)
                ) { childrenIntersection = true; return false; }
            });
            if(childrenIntersection) {
                return false;
            }

            if(this.accept.call(this.element[0],(draggable.currentItem || draggable.element))) {
                if(this.options.activeClass) {
                    this.element.removeClass(this.options.activeClass);
                }
                if(this.options.hoverClass) {
                    this.element.removeClass(this.options.hoverClass);
                }
                this._trigger("drop", event, this.ui(draggable));
                return this.element;
            }

            return false;

        },

        ui: function(c) {
            return {
                draggable: (c.currentItem || c.element),
                helper: c.helper,
                position: c.position,
                offset: c.positionAbs
            };
        }

    });

    $.ui.intersect = function(draggable, droppable, toleranceMode) {

        if (!droppable.offset) {
            return false;
        }

        var draggableLeft, draggableTop,
            x1 = (draggable.positionAbs || draggable.position.absolute).left, x2 = x1 + draggable.helperProportions.width,
            y1 = (draggable.positionAbs || draggable.position.absolute).top, y2 = y1 + draggable.helperProportions.height,
            l = droppable.offset.left, r = l + droppable.proportions.width,
            t = droppable.offset.top, b = t + droppable.proportions.height;

        switch (toleranceMode) {
            case "fit":
                return (l <= x1 && x2 <= r && t <= y1 && y2 <= b);
            case "intersect":
                return (l < x1 + (draggable.helperProportions.width / 2) && // Right Half
                x2 - (draggable.helperProportions.width / 2) < r && // Left Half
                t < y1 + (draggable.helperProportions.height / 2) && // Bottom Half
                y2 - (draggable.helperProportions.height / 2) < b ); // Top Half
            case "pointer":
                draggableLeft = ((draggable.positionAbs || draggable.position.absolute).left + (draggable.clickOffset || draggable.offset.click).left);
                draggableTop = ((draggable.positionAbs || draggable.position.absolute).top + (draggable.clickOffset || draggable.offset.click).top);
                return isOverAxis( draggableTop, t, droppable.proportions.height ) && isOverAxis( draggableLeft, l, droppable.proportions.width );
            case "touch":
                return (
                        (y1 >= t && y1 <= b) ||	// Top edge touching
                        (y2 >= t && y2 <= b) ||	// Bottom edge touching
                        (y1 < t && y2 > b)		// Surrounded vertically
                    ) && (
                        (x1 >= l && x1 <= r) ||	// Left edge touching
                        (x2 >= l && x2 <= r) ||	// Right edge touching
                        (x1 < l && x2 > r)		// Surrounded horizontally
                    );
            default:
                return false;
        }

    };

    /*
     This manager tracks offsets of draggables and droppables
     */
    $.ui.ddmanager = {
        current: null,
        droppables: { "default": [] },
        prepareOffsets: function(t, event) {

            var i, j,
                m = $.ui.ddmanager.droppables[t.options.scope] || [],
                type = event ? event.type : null, // workaround for #2317
                list = (t.currentItem || t.element).find(":data(ui-droppable)").addBack();

            droppablesLoop: for (i = 0; i < m.length; i++) {

                //No disabled and non-accepted
                if(m[i].options.disabled || (t && !m[i].accept.call(m[i].element[0],(t.currentItem || t.element)))) {
                    continue;
                }

                // Filter out elements in the current dragged item
                for (j=0; j < list.length; j++) {
                    if(list[j] === m[i].element[0]) {
                        m[i].proportions.height = 0;
                        continue droppablesLoop;
                    }
                }

                m[i].visible = m[i].element.css("display") !== "none";
                if(!m[i].visible) {
                    continue;
                }

                //Activate the droppable if used directly from draggables
                if(type === "mousedown") {
                    m[i]._activate.call(m[i], event);
                }

                m[i].offset = m[i].element.offset();
                m[i].proportions = { width: m[i].element[0].offsetWidth, height: m[i].element[0].offsetHeight };

            }

        },
        drop: function(draggable, event) {

            var dropped = false;
            // Create a copy of the droppables in case the list changes during the drop (#9116)
            $.each(($.ui.ddmanager.droppables[draggable.options.scope] || []).slice(), function() {

                if(!this.options) {
                    return;
                }
                if (!this.options.disabled && this.visible && $.ui.intersect(draggable, this, this.options.tolerance)) {
                    dropped = this._drop.call(this, event) || dropped;
                }

                if (!this.options.disabled && this.visible && this.accept.call(this.element[0],(draggable.currentItem || draggable.element))) {
                    this.isout = true;
                    this.isover = false;
                    this._deactivate.call(this, event);
                }

            });
            return dropped;

        },
        dragStart: function( draggable, event ) {
            //Listen for scrolling so that if the dragging causes scrolling the position of the droppables can be recalculated (see #5003)
            draggable.element.parentsUntil( "body" ).bind( "scroll.droppable", function() {
                if( !draggable.options.refreshPositions ) {
                    $.ui.ddmanager.prepareOffsets( draggable, event );
                }
            });
        },
        drag: function(draggable, event) {

            //If you have a highly dynamic page, you might try this option. It renders positions every time you move the mouse.
            if(draggable.options.refreshPositions) {
                $.ui.ddmanager.prepareOffsets(draggable, event);
            }

            //Run through all droppables and check their positions based on specific tolerance options
            $.each($.ui.ddmanager.droppables[draggable.options.scope] || [], function() {

                if(this.options.disabled || this.greedyChild || !this.visible) {
                    return;
                }

                var parentInstance, scope, parent,
                    intersects = $.ui.intersect(draggable, this, this.options.tolerance),
                    c = !intersects && this.isover ? "isout" : (intersects && !this.isover ? "isover" : null);
                if(!c) {
                    return;
                }

                if (this.options.greedy) {
                    // find droppable parents with same scope
                    scope = this.options.scope;
                    parent = this.element.parents(":data(ui-droppable)").filter(function () {
                        return $.data(this, "ui-droppable").options.scope === scope;
                    });

                    if (parent.length) {
                        parentInstance = $.data(parent[0], "ui-droppable");
                        parentInstance.greedyChild = (c === "isover");
                    }
                }

                // we just moved into a greedy child
                if (parentInstance && c === "isover") {
                    parentInstance.isover = false;
                    parentInstance.isout = true;
                    parentInstance._out.call(parentInstance, event);
                }

                this[c] = true;
                this[c === "isout" ? "isover" : "isout"] = false;
                this[c === "isover" ? "_over" : "_out"].call(this, event);

                // we just moved out of a greedy child
                if (parentInstance && c === "isout") {
                    parentInstance.isout = false;
                    parentInstance.isover = true;
                    parentInstance._over.call(parentInstance, event);
                }
            });

        },
        dragStop: function( draggable, event ) {
            draggable.element.parentsUntil( "body" ).unbind( "scroll.droppable" );
            //Call prepareOffsets one final time since IE does not fire return scroll events when overflow was caused by drag (see #5003)
            if( !draggable.options.refreshPositions ) {
                $.ui.ddmanager.prepareOffsets( draggable, event );
            }
        }
    };

})(jQuery);

(function( $, undefined ) {

    function num(v) {
        return parseInt(v, 10) || 0;
    }

    function isNumber(value) {
        return !isNaN(parseInt(value, 10));
    }

    $.widget("ui.resizable", $.ui.mouse, {
        version: "1.10.2",
        widgetEventPrefix: "resize",
        options: {
            alsoResize: false,
            animate: false,
            animateDuration: "slow",
            animateEasing: "swing",
            aspectRatio: false,
            autoHide: false,
            containment: false,
            ghost: false,
            grid: false,
            handles: "e,s,se",
            helper: false,
            maxHeight: null,
            maxWidth: null,
            minHeight: 10,
            minWidth: 10,
            // See #7960
            zIndex: 90,

            // callbacks
            resize: null,
            start: null,
            stop: null
        },
        _create: function() {

            var n, i, handle, axis, hname,
                that = this,
                o = this.options;
            this.element.addClass("ui-resizable");

            $.extend(this, {
                _aspectRatio: !!(o.aspectRatio),
                aspectRatio: o.aspectRatio,
                originalElement: this.element,
                _proportionallyResizeElements: [],
                _helper: o.helper || o.ghost || o.animate ? o.helper || "ui-resizable-helper" : null
            });

            //Wrap the element if it cannot hold child nodes
            if(this.element[0].nodeName.match(/canvas|textarea|input|select|button|img/i)) {

                //Create a wrapper element and set the wrapper to the new current internal element
                this.element.wrap(
                    $("<div class='ui-wrapper' style='overflow: hidden;'></div>").css({
                        position: this.element.css("position"),
                        width: this.element.outerWidth(),
                        height: this.element.outerHeight(),
                        top: this.element.css("top"),
                        left: this.element.css("left")
                    })
                );

                //Overwrite the original this.element
                this.element = this.element.parent().data(
                    "ui-resizable", this.element.data("ui-resizable")
                );

                this.elementIsWrapper = true;

                //Move margins to the wrapper
                this.element.css({ marginLeft: this.originalElement.css("marginLeft"), marginTop: this.originalElement.css("marginTop"), marginRight: this.originalElement.css("marginRight"), marginBottom: this.originalElement.css("marginBottom") });
                this.originalElement.css({ marginLeft: 0, marginTop: 0, marginRight: 0, marginBottom: 0});

                //Prevent Safari textarea resize
                this.originalResizeStyle = this.originalElement.css("resize");
                this.originalElement.css("resize", "none");

                //Push the actual element to our proportionallyResize internal array
                this._proportionallyResizeElements.push(this.originalElement.css({ position: "static", zoom: 1, display: "block" }));

                // avoid IE jump (hard set the margin)
                this.originalElement.css({ margin: this.originalElement.css("margin") });

                // fix handlers offset
                this._proportionallyResize();

            }

            this.handles = o.handles || (!$(".ui-resizable-handle", this.element).length ? "e,s,se" : { n: ".ui-resizable-n", e: ".ui-resizable-e", s: ".ui-resizable-s", w: ".ui-resizable-w", se: ".ui-resizable-se", sw: ".ui-resizable-sw", ne: ".ui-resizable-ne", nw: ".ui-resizable-nw" });
            if(this.handles.constructor === String) {

                if ( this.handles === "all") {
                    this.handles = "n,e,s,w,se,sw,ne,nw";
                }

                n = this.handles.split(",");
                this.handles = {};

                for(i = 0; i < n.length; i++) {

                    handle = $.trim(n[i]);
                    hname = "ui-resizable-"+handle;
                    axis = $("<div class='ui-resizable-handle " + hname + "'></div>");

                    // Apply zIndex to all handles - see #7960
                    axis.css({ zIndex: o.zIndex });

                    //TODO : What's going on here?
                    if ("se" === handle) {
                        axis.addClass("ui-icon ui-icon-gripsmall-diagonal-se");
                    }

                    //Insert into internal handles object and append to element
                    this.handles[handle] = ".ui-resizable-"+handle;
                    this.element.append(axis);
                }

            }

            this._renderAxis = function(target) {

                var i, axis, padPos, padWrapper;

                target = target || this.element;

                for(i in this.handles) {

                    if(this.handles[i].constructor === String) {
                        this.handles[i] = $(this.handles[i], this.element).show();
                    }

                    //Apply pad to wrapper element, needed to fix axis position (textarea, inputs, scrolls)
                    if (this.elementIsWrapper && this.originalElement[0].nodeName.match(/textarea|input|select|button/i)) {

                        axis = $(this.handles[i], this.element);

                        //Checking the correct pad and border
                        padWrapper = /sw|ne|nw|se|n|s/.test(i) ? axis.outerHeight() : axis.outerWidth();

                        //The padding type i have to apply...
                        padPos = [ "padding",
                            /ne|nw|n/.test(i) ? "Top" :
                                /se|sw|s/.test(i) ? "Bottom" :
                                    /^e$/.test(i) ? "Right" : "Left" ].join("");

                        target.css(padPos, padWrapper);

                        this._proportionallyResize();

                    }

                    //TODO: What's that good for? There's not anything to be executed left
                    if(!$(this.handles[i]).length) {
                        continue;
                    }
                }
            };

            //TODO: make renderAxis a prototype function
            this._renderAxis(this.element);

            this._handles = $(".ui-resizable-handle", this.element)
                .disableSelection();

            //Matching axis name
            this._handles.mouseover(function() {
                if (!that.resizing) {
                    if (this.className) {
                        axis = this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i);
                    }
                    //Axis, default = se
                    that.axis = axis && axis[1] ? axis[1] : "se";
                }
            });

            //If we want to auto hide the elements
            if (o.autoHide) {
                this._handles.hide();
                $(this.element)
                    .addClass("ui-resizable-autohide")
                    .mouseenter(function() {
                        if (o.disabled) {
                            return;
                        }
                        $(this).removeClass("ui-resizable-autohide");
                        that._handles.show();
                    })
                    .mouseleave(function(){
                        if (o.disabled) {
                            return;
                        }
                        if (!that.resizing) {
                            $(this).addClass("ui-resizable-autohide");
                            that._handles.hide();
                        }
                    });
            }

            //Initialize the mouse interaction
            this._mouseInit();

        },

        _destroy: function() {

            this._mouseDestroy();

            var wrapper,
                _destroy = function(exp) {
                    $(exp).removeClass("ui-resizable ui-resizable-disabled ui-resizable-resizing")
                        .removeData("resizable").removeData("ui-resizable").unbind(".resizable").find(".ui-resizable-handle").remove();
                };

            //TODO: Unwrap at same DOM position
            if (this.elementIsWrapper) {
                _destroy(this.element);
                wrapper = this.element;
                this.originalElement.css({
                    position: wrapper.css("position"),
                    width: wrapper.outerWidth(),
                    height: wrapper.outerHeight(),
                    top: wrapper.css("top"),
                    left: wrapper.css("left")
                }).insertAfter( wrapper );
                wrapper.remove();
            }

            this.originalElement.css("resize", this.originalResizeStyle);
            _destroy(this.originalElement);

            return this;
        },

        _mouseCapture: function(event) {
            var i, handle,
                capture = false;

            for (i in this.handles) {
                handle = $(this.handles[i])[0];
                if (handle === event.target || $.contains(handle, event.target)) {
                    capture = true;
                }
            }

            return !this.options.disabled && capture;
        },

        _mouseStart: function(event) {

            var curleft, curtop, cursor,
                o = this.options,
                iniPos = this.element.position(),
                el = this.element;

            this.resizing = true;

            // bugfix for http://dev.jquery.com/ticket/1749
            if ( (/absolute/).test( el.css("position") ) ) {
                el.css({ position: "absolute", top: el.css("top"), left: el.css("left") });
            } else if (el.is(".ui-draggable")) {
                el.css({ position: "absolute", top: iniPos.top, left: iniPos.left });
            }

            this._renderProxy();

            curleft = num(this.helper.css("left"));
            curtop = num(this.helper.css("top"));

            if (o.containment) {
                curleft += $(o.containment).scrollLeft() || 0;
                curtop += $(o.containment).scrollTop() || 0;
            }

            //Store needed variables
            this.offset = this.helper.offset();
            this.position = { left: curleft, top: curtop };
            this.size = this._helper ? { width: el.outerWidth(), height: el.outerHeight() } : { width: el.width(), height: el.height() };
            this.originalSize = this._helper ? { width: el.outerWidth(), height: el.outerHeight() } : { width: el.width(), height: el.height() };
            this.originalPosition = { left: curleft, top: curtop };
            this.sizeDiff = { width: el.outerWidth() - el.width(), height: el.outerHeight() - el.height() };
            this.originalMousePosition = { left: event.pageX, top: event.pageY };

            //Aspect Ratio
            this.aspectRatio = (typeof o.aspectRatio === "number") ? o.aspectRatio : ((this.originalSize.width / this.originalSize.height) || 1);

            cursor = $(".ui-resizable-" + this.axis).css("cursor");
            $("body").css("cursor", cursor === "auto" ? this.axis + "-resize" : cursor);

            el.addClass("ui-resizable-resizing");
            this._propagate("start", event);
            return true;
        },

        _mouseDrag: function(event) {

            //Increase performance, avoid regex
            var data,
                el = this.helper, props = {},
                smp = this.originalMousePosition,
                a = this.axis,
                prevTop = this.position.top,
                prevLeft = this.position.left,
                prevWidth = this.size.width,
                prevHeight = this.size.height,
                dx = (event.pageX-smp.left)||0,
                dy = (event.pageY-smp.top)||0,
                trigger = this._change[a];

            if (!trigger) {
                return false;
            }

            // Calculate the attrs that will be change
            data = trigger.apply(this, [event, dx, dy]);

            // Put this in the mouseDrag handler since the user can start pressing shift while resizing
            this._updateVirtualBoundaries(event.shiftKey);
            if (this._aspectRatio || event.shiftKey) {
                data = this._updateRatio(data, event);
            }

            data = this._respectSize(data, event);

            this._updateCache(data);

            // plugins callbacks need to be called first
            this._propagate("resize", event);

            if (this.position.top !== prevTop) {
                props.top = this.position.top + "px";
            }
            if (this.position.left !== prevLeft) {
                props.left = this.position.left + "px";
            }
            if (this.size.width !== prevWidth) {
                props.width = this.size.width + "px";
            }
            if (this.size.height !== prevHeight) {
                props.height = this.size.height + "px";
            }
            el.css(props);

            if (!this._helper && this._proportionallyResizeElements.length) {
                this._proportionallyResize();
            }

            // Call the user callback if the element was resized
            if ( ! $.isEmptyObject(props) ) {
                this._trigger("resize", event, this.ui());
            }

            return false;
        },

        _mouseStop: function(event) {

            this.resizing = false;
            var pr, ista, soffseth, soffsetw, s, left, top,
                o = this.options, that = this;

            if(this._helper) {

                pr = this._proportionallyResizeElements;
                ista = pr.length && (/textarea/i).test(pr[0].nodeName);
                soffseth = ista && $.ui.hasScroll(pr[0], "left") /* TODO - jump height */ ? 0 : that.sizeDiff.height;
                soffsetw = ista ? 0 : that.sizeDiff.width;

                s = { width: (that.helper.width()  - soffsetw), height: (that.helper.height() - soffseth) };
                left = (parseInt(that.element.css("left"), 10) + (that.position.left - that.originalPosition.left)) || null;
                top = (parseInt(that.element.css("top"), 10) + (that.position.top - that.originalPosition.top)) || null;

                if (!o.animate) {
                    this.element.css($.extend(s, { top: top, left: left }));
                }

                that.helper.height(that.size.height);
                that.helper.width(that.size.width);

                if (this._helper && !o.animate) {
                    this._proportionallyResize();
                }
            }

            $("body").css("cursor", "auto");

            this.element.removeClass("ui-resizable-resizing");

            this._propagate("stop", event);

            if (this._helper) {
                this.helper.remove();
            }

            return false;

        },

        _updateVirtualBoundaries: function(forceAspectRatio) {
            var pMinWidth, pMaxWidth, pMinHeight, pMaxHeight, b,
                o = this.options;

            b = {
                minWidth: isNumber(o.minWidth) ? o.minWidth : 0,
                maxWidth: isNumber(o.maxWidth) ? o.maxWidth : Infinity,
                minHeight: isNumber(o.minHeight) ? o.minHeight : 0,
                maxHeight: isNumber(o.maxHeight) ? o.maxHeight : Infinity
            };

            if(this._aspectRatio || forceAspectRatio) {
                // We want to create an enclosing box whose aspect ration is the requested one
                // First, compute the "projected" size for each dimension based on the aspect ratio and other dimension
                pMinWidth = b.minHeight * this.aspectRatio;
                pMinHeight = b.minWidth / this.aspectRatio;
                pMaxWidth = b.maxHeight * this.aspectRatio;
                pMaxHeight = b.maxWidth / this.aspectRatio;

                if(pMinWidth > b.minWidth) {
                    b.minWidth = pMinWidth;
                }
                if(pMinHeight > b.minHeight) {
                    b.minHeight = pMinHeight;
                }
                if(pMaxWidth < b.maxWidth) {
                    b.maxWidth = pMaxWidth;
                }
                if(pMaxHeight < b.maxHeight) {
                    b.maxHeight = pMaxHeight;
                }
            }
            this._vBoundaries = b;
        },

        _updateCache: function(data) {
            this.offset = this.helper.offset();
            if (isNumber(data.left)) {
                this.position.left = data.left;
            }
            if (isNumber(data.top)) {
                this.position.top = data.top;
            }
            if (isNumber(data.height)) {
                this.size.height = data.height;
            }
            if (isNumber(data.width)) {
                this.size.width = data.width;
            }
        },

        _updateRatio: function( data ) {

            var cpos = this.position,
                csize = this.size,
                a = this.axis;

            if (isNumber(data.height)) {
                data.width = (data.height * this.aspectRatio);
            } else if (isNumber(data.width)) {
                data.height = (data.width / this.aspectRatio);
            }

            if (a === "sw") {
                data.left = cpos.left + (csize.width - data.width);
                data.top = null;
            }
            if (a === "nw") {
                data.top = cpos.top + (csize.height - data.height);
                data.left = cpos.left + (csize.width - data.width);
            }

            return data;
        },

        _respectSize: function( data ) {

            var o = this._vBoundaries,
                a = this.axis,
                ismaxw = isNumber(data.width) && o.maxWidth && (o.maxWidth < data.width), ismaxh = isNumber(data.height) && o.maxHeight && (o.maxHeight < data.height),
                isminw = isNumber(data.width) && o.minWidth && (o.minWidth > data.width), isminh = isNumber(data.height) && o.minHeight && (o.minHeight > data.height),
                dw = this.originalPosition.left + this.originalSize.width,
                dh = this.position.top + this.size.height,
                cw = /sw|nw|w/.test(a), ch = /nw|ne|n/.test(a);
            if (isminw) {
                data.width = o.minWidth;
            }
            if (isminh) {
                data.height = o.minHeight;
            }
            if (ismaxw) {
                data.width = o.maxWidth;
            }
            if (ismaxh) {
                data.height = o.maxHeight;
            }

            if (isminw && cw) {
                data.left = dw - o.minWidth;
            }
            if (ismaxw && cw) {
                data.left = dw - o.maxWidth;
            }
            if (isminh && ch) {
                data.top = dh - o.minHeight;
            }
            if (ismaxh && ch) {
                data.top = dh - o.maxHeight;
            }

            // fixing jump error on top/left - bug #2330
            if (!data.width && !data.height && !data.left && data.top) {
                data.top = null;
            } else if (!data.width && !data.height && !data.top && data.left) {
                data.left = null;
            }

            return data;
        },

        _proportionallyResize: function() {

            if (!this._proportionallyResizeElements.length) {
                return;
            }

            var i, j, borders, paddings, prel,
                element = this.helper || this.element;

            for ( i=0; i < this._proportionallyResizeElements.length; i++) {

                prel = this._proportionallyResizeElements[i];

                if (!this.borderDif) {
                    this.borderDif = [];
                    borders = [prel.css("borderTopWidth"), prel.css("borderRightWidth"), prel.css("borderBottomWidth"), prel.css("borderLeftWidth")];
                    paddings = [prel.css("paddingTop"), prel.css("paddingRight"), prel.css("paddingBottom"), prel.css("paddingLeft")];

                    for ( j = 0; j < borders.length; j++ ) {
                        this.borderDif[ j ] = ( parseInt( borders[ j ], 10 ) || 0 ) + ( parseInt( paddings[ j ], 10 ) || 0 );
                    }
                }

                prel.css({
                    height: (element.height() - this.borderDif[0] - this.borderDif[2]) || 0,
                    width: (element.width() - this.borderDif[1] - this.borderDif[3]) || 0
                });

            }

        },

        _renderProxy: function() {

            var el = this.element, o = this.options;
            this.elementOffset = el.offset();

            if(this._helper) {

                this.helper = this.helper || $("<div style='overflow:hidden;'></div>");

                this.helper.addClass(this._helper).css({
                    width: this.element.outerWidth() - 1,
                    height: this.element.outerHeight() - 1,
                    position: "absolute",
                    left: this.elementOffset.left +"px",
                    top: this.elementOffset.top +"px",
                    zIndex: ++o.zIndex //TODO: Don't modify option
                });

                this.helper
                    .appendTo("body")
                    .disableSelection();

            } else {
                this.helper = this.element;
            }

        },

        _change: {
            e: function(event, dx) {
                return { width: this.originalSize.width + dx };
            },
            w: function(event, dx) {
                var cs = this.originalSize, sp = this.originalPosition;
                return { left: sp.left + dx, width: cs.width - dx };
            },
            n: function(event, dx, dy) {
                var cs = this.originalSize, sp = this.originalPosition;
                return { top: sp.top + dy, height: cs.height - dy };
            },
            s: function(event, dx, dy) {
                return { height: this.originalSize.height + dy };
            },
            se: function(event, dx, dy) {
                return $.extend(this._change.s.apply(this, arguments), this._change.e.apply(this, [event, dx, dy]));
            },
            sw: function(event, dx, dy) {
                return $.extend(this._change.s.apply(this, arguments), this._change.w.apply(this, [event, dx, dy]));
            },
            ne: function(event, dx, dy) {
                return $.extend(this._change.n.apply(this, arguments), this._change.e.apply(this, [event, dx, dy]));
            },
            nw: function(event, dx, dy) {
                return $.extend(this._change.n.apply(this, arguments), this._change.w.apply(this, [event, dx, dy]));
            }
        },

        _propagate: function(n, event) {
            $.ui.plugin.call(this, n, [event, this.ui()]);
            (n !== "resize" && this._trigger(n, event, this.ui()));
        },

        plugins: {},

        ui: function() {
            return {
                originalElement: this.originalElement,
                element: this.element,
                helper: this.helper,
                position: this.position,
                size: this.size,
                originalSize: this.originalSize,
                originalPosition: this.originalPosition
            };
        }

    });

    /*
     * Resizable Extensions
     */

    $.ui.plugin.add("resizable", "animate", {

        stop: function( event ) {
            var that = $(this).data("ui-resizable"),
                o = that.options,
                pr = that._proportionallyResizeElements,
                ista = pr.length && (/textarea/i).test(pr[0].nodeName),
                soffseth = ista && $.ui.hasScroll(pr[0], "left") /* TODO - jump height */ ? 0 : that.sizeDiff.height,
                soffsetw = ista ? 0 : that.sizeDiff.width,
                style = { width: (that.size.width - soffsetw), height: (that.size.height - soffseth) },
                left = (parseInt(that.element.css("left"), 10) + (that.position.left - that.originalPosition.left)) || null,
                top = (parseInt(that.element.css("top"), 10) + (that.position.top - that.originalPosition.top)) || null;

            that.element.animate(
                $.extend(style, top && left ? { top: top, left: left } : {}), {
                    duration: o.animateDuration,
                    easing: o.animateEasing,
                    step: function() {

                        var data = {
                            width: parseInt(that.element.css("width"), 10),
                            height: parseInt(that.element.css("height"), 10),
                            top: parseInt(that.element.css("top"), 10),
                            left: parseInt(that.element.css("left"), 10)
                        };

                        if (pr && pr.length) {
                            $(pr[0]).css({ width: data.width, height: data.height });
                        }

                        // propagating resize, and updating values for each animation step
                        that._updateCache(data);
                        that._propagate("resize", event);

                    }
                }
            );
        }

    });

    $.ui.plugin.add("resizable", "containment", {

        start: function() {
            var element, p, co, ch, cw, width, height,
                that = $(this).data("ui-resizable"),
                o = that.options,
                el = that.element,
                oc = o.containment,
                ce = (oc instanceof $) ? oc.get(0) : (/parent/.test(oc)) ? el.parent().get(0) : oc;

            if (!ce) {
                return;
            }

            that.containerElement = $(ce);

            if (/document/.test(oc) || oc === document) {
                that.containerOffset = { left: 0, top: 0 };
                that.containerPosition = { left: 0, top: 0 };

                that.parentData = {
                    element: $(document), left: 0, top: 0,
                    width: $(document).width(), height: $(document).height() || document.body.parentNode.scrollHeight
                };
            }

            // i'm a node, so compute top, left, right, bottom
            else {
                element = $(ce);
                p = [];
                $([ "Top", "Right", "Left", "Bottom" ]).each(function(i, name) { p[i] = num(element.css("padding" + name)); });

                that.containerOffset = element.offset();
                that.containerPosition = element.position();
                that.containerSize = { height: (element.innerHeight() - p[3]), width: (element.innerWidth() - p[1]) };

                co = that.containerOffset;
                ch = that.containerSize.height;
                cw = that.containerSize.width;
                width = ($.ui.hasScroll(ce, "left") ? ce.scrollWidth : cw );
                height = ($.ui.hasScroll(ce) ? ce.scrollHeight : ch);

                that.parentData = {
                    element: ce, left: co.left, top: co.top, width: width, height: height
                };
            }
        },

        resize: function( event ) {
            var woset, hoset, isParent, isOffsetRelative,
                that = $(this).data("ui-resizable"),
                o = that.options,
                co = that.containerOffset, cp = that.position,
                pRatio = that._aspectRatio || event.shiftKey,
                cop = { top:0, left:0 }, ce = that.containerElement;

            if (ce[0] !== document && (/static/).test(ce.css("position"))) {
                cop = co;
            }

            if (cp.left < (that._helper ? co.left : 0)) {
                that.size.width = that.size.width + (that._helper ? (that.position.left - co.left) : (that.position.left - cop.left));
                if (pRatio) {
                    that.size.height = that.size.width / that.aspectRatio;
                }
                that.position.left = o.helper ? co.left : 0;
            }

            if (cp.top < (that._helper ? co.top : 0)) {
                that.size.height = that.size.height + (that._helper ? (that.position.top - co.top) : that.position.top);
                if (pRatio) {
                    that.size.width = that.size.height * that.aspectRatio;
                }
                that.position.top = that._helper ? co.top : 0;
            }

            that.offset.left = that.parentData.left+that.position.left;
            that.offset.top = that.parentData.top+that.position.top;

            woset = Math.abs( (that._helper ? that.offset.left - cop.left : (that.offset.left - cop.left)) + that.sizeDiff.width );
            hoset = Math.abs( (that._helper ? that.offset.top - cop.top : (that.offset.top - co.top)) + that.sizeDiff.height );

            isParent = that.containerElement.get(0) === that.element.parent().get(0);
            isOffsetRelative = /relative|absolute/.test(that.containerElement.css("position"));

            if(isParent && isOffsetRelative) {
                woset -= that.parentData.left;
            }

            if (woset + that.size.width >= that.parentData.width) {
                that.size.width = that.parentData.width - woset;
                if (pRatio) {
                    that.size.height = that.size.width / that.aspectRatio;
                }
            }

            if (hoset + that.size.height >= that.parentData.height) {
                that.size.height = that.parentData.height - hoset;
                if (pRatio) {
                    that.size.width = that.size.height * that.aspectRatio;
                }
            }
        },

        stop: function(){
            var that = $(this).data("ui-resizable"),
                o = that.options,
                co = that.containerOffset,
                cop = that.containerPosition,
                ce = that.containerElement,
                helper = $(that.helper),
                ho = helper.offset(),
                w = helper.outerWidth() - that.sizeDiff.width,
                h = helper.outerHeight() - that.sizeDiff.height;

            if (that._helper && !o.animate && (/relative/).test(ce.css("position"))) {
                $(this).css({ left: ho.left - cop.left - co.left, width: w, height: h });
            }

            if (that._helper && !o.animate && (/static/).test(ce.css("position"))) {
                $(this).css({ left: ho.left - cop.left - co.left, width: w, height: h });
            }

        }
    });

    $.ui.plugin.add("resizable", "alsoResize", {

        start: function () {
            var that = $(this).data("ui-resizable"),
                o = that.options,
                _store = function (exp) {
                    $(exp).each(function() {
                        var el = $(this);
                        el.data("ui-resizable-alsoresize", {
                            width: parseInt(el.width(), 10), height: parseInt(el.height(), 10),
                            left: parseInt(el.css("left"), 10), top: parseInt(el.css("top"), 10)
                        });
                    });
                };

            if (typeof(o.alsoResize) === "object" && !o.alsoResize.parentNode) {
                if (o.alsoResize.length) { o.alsoResize = o.alsoResize[0]; _store(o.alsoResize); }
                else { $.each(o.alsoResize, function (exp) { _store(exp); }); }
            }else{
                _store(o.alsoResize);
            }
        },

        resize: function (event, ui) {
            var that = $(this).data("ui-resizable"),
                o = that.options,
                os = that.originalSize,
                op = that.originalPosition,
                delta = {
                    height: (that.size.height - os.height) || 0, width: (that.size.width - os.width) || 0,
                    top: (that.position.top - op.top) || 0, left: (that.position.left - op.left) || 0
                },

                _alsoResize = function (exp, c) {
                    $(exp).each(function() {
                        var el = $(this), start = $(this).data("ui-resizable-alsoresize"), style = {},
                            css = c && c.length ? c : el.parents(ui.originalElement[0]).length ? ["width", "height"] : ["width", "height", "top", "left"];

                        $.each(css, function (i, prop) {
                            var sum = (start[prop]||0) + (delta[prop]||0);
                            if (sum && sum >= 0) {
                                style[prop] = sum || null;
                            }
                        });

                        el.css(style);
                    });
                };

            if (typeof(o.alsoResize) === "object" && !o.alsoResize.nodeType) {
                $.each(o.alsoResize, function (exp, c) { _alsoResize(exp, c); });
            }else{
                _alsoResize(o.alsoResize);
            }
        },

        stop: function () {
            $(this).removeData("resizable-alsoresize");
        }
    });

    $.ui.plugin.add("resizable", "ghost", {

        start: function() {

            var that = $(this).data("ui-resizable"), o = that.options, cs = that.size;

            that.ghost = that.originalElement.clone();
            that.ghost
                .css({ opacity: 0.25, display: "block", position: "relative", height: cs.height, width: cs.width, margin: 0, left: 0, top: 0 })
                .addClass("ui-resizable-ghost")
                .addClass(typeof o.ghost === "string" ? o.ghost : "");

            that.ghost.appendTo(that.helper);

        },

        resize: function(){
            var that = $(this).data("ui-resizable");
            if (that.ghost) {
                that.ghost.css({ position: "relative", height: that.size.height, width: that.size.width });
            }
        },

        stop: function() {
            var that = $(this).data("ui-resizable");
            if (that.ghost && that.helper) {
                that.helper.get(0).removeChild(that.ghost.get(0));
            }
        }

    });

    $.ui.plugin.add("resizable", "grid", {

        resize: function() {
            var that = $(this).data("ui-resizable"),
                o = that.options,
                cs = that.size,
                os = that.originalSize,
                op = that.originalPosition,
                a = that.axis,
                grid = typeof o.grid === "number" ? [o.grid, o.grid] : o.grid,
                gridX = (grid[0]||1),
                gridY = (grid[1]||1),
                ox = Math.round((cs.width - os.width) / gridX) * gridX,
                oy = Math.round((cs.height - os.height) / gridY) * gridY,
                newWidth = os.width + ox,
                newHeight = os.height + oy,
                isMaxWidth = o.maxWidth && (o.maxWidth < newWidth),
                isMaxHeight = o.maxHeight && (o.maxHeight < newHeight),
                isMinWidth = o.minWidth && (o.minWidth > newWidth),
                isMinHeight = o.minHeight && (o.minHeight > newHeight);

            o.grid = grid;

            if (isMinWidth) {
                newWidth = newWidth + gridX;
            }
            if (isMinHeight) {
                newHeight = newHeight + gridY;
            }
            if (isMaxWidth) {
                newWidth = newWidth - gridX;
            }
            if (isMaxHeight) {
                newHeight = newHeight - gridY;
            }

            if (/^(se|s|e)$/.test(a)) {
                that.size.width = newWidth;
                that.size.height = newHeight;
            } else if (/^(ne)$/.test(a)) {
                that.size.width = newWidth;
                that.size.height = newHeight;
                that.position.top = op.top - oy;
            } else if (/^(sw)$/.test(a)) {
                that.size.width = newWidth;
                that.size.height = newHeight;
                that.position.left = op.left - ox;
            } else {
                that.size.width = newWidth;
                that.size.height = newHeight;
                that.position.top = op.top - oy;
                that.position.left = op.left - ox;
            }
        }

    });

})(jQuery);

(function( $, undefined ) {

    $.widget("ui.selectable", $.ui.mouse, {
        version: "1.10.2",
        options: {
            appendTo: "body",
            autoRefresh: true,
            distance: 0,
            filter: "*",
            tolerance: "touch",

            // callbacks
            selected: null,
            selecting: null,
            start: null,
            stop: null,
            unselected: null,
            unselecting: null
        },
        _create: function() {
            var selectees,
                that = this;

            this.element.addClass("ui-selectable");

            this.dragged = false;

            // cache selectee children based on filter
            this.refresh = function() {
                selectees = $(that.options.filter, that.element[0]);
                selectees.addClass("ui-selectee");
                selectees.each(function() {
                    var $this = $(this),
                        pos = $this.offset();
                    $.data(this, "selectable-item", {
                        element: this,
                        $element: $this,
                        left: pos.left,
                        top: pos.top,
                        right: pos.left + $this.outerWidth(),
                        bottom: pos.top + $this.outerHeight(),
                        startselected: false,
                        selected: $this.hasClass("ui-selected"),
                        selecting: $this.hasClass("ui-selecting"),
                        unselecting: $this.hasClass("ui-unselecting")
                    });
                });
            };
            this.refresh();

            this.selectees = selectees.addClass("ui-selectee");

            this._mouseInit();

            this.helper = $("<div class='ui-selectable-helper'></div>");
        },

        _destroy: function() {
            this.selectees
                .removeClass("ui-selectee")
                .removeData("selectable-item");
            this.element
                .removeClass("ui-selectable ui-selectable-disabled");
            this._mouseDestroy();
        },

        _mouseStart: function(event) {
            var that = this,
                options = this.options;

            this.opos = [event.pageX, event.pageY];

            if (this.options.disabled) {
                return;
            }

            this.selectees = $(options.filter, this.element[0]);

            this._trigger("start", event);

            $(options.appendTo).append(this.helper);
            // position helper (lasso)
            this.helper.css({
                "left": event.pageX,
                "top": event.pageY,
                "width": 0,
                "height": 0
            });

            if (options.autoRefresh) {
                this.refresh();
            }

            this.selectees.filter(".ui-selected").each(function() {
                var selectee = $.data(this, "selectable-item");
                selectee.startselected = true;
                if (!event.metaKey && !event.ctrlKey) {
                    selectee.$element.removeClass("ui-selected");
                    selectee.selected = false;
                    selectee.$element.addClass("ui-unselecting");
                    selectee.unselecting = true;
                    // selectable UNSELECTING callback
                    that._trigger("unselecting", event, {
                        unselecting: selectee.element
                    });
                }
            });

            $(event.target).parents().addBack().each(function() {
                var doSelect,
                    selectee = $.data(this, "selectable-item");
                if (selectee) {
                    doSelect = (!event.metaKey && !event.ctrlKey) || !selectee.$element.hasClass("ui-selected");
                    selectee.$element
                        .removeClass(doSelect ? "ui-unselecting" : "ui-selected")
                        .addClass(doSelect ? "ui-selecting" : "ui-unselecting");
                    selectee.unselecting = !doSelect;
                    selectee.selecting = doSelect;
                    selectee.selected = doSelect;
                    // selectable (UN)SELECTING callback
                    if (doSelect) {
                        that._trigger("selecting", event, {
                            selecting: selectee.element
                        });
                    } else {
                        that._trigger("unselecting", event, {
                            unselecting: selectee.element
                        });
                    }
                    return false;
                }
            });

        },

        _mouseDrag: function(event) {

            this.dragged = true;

            if (this.options.disabled) {
                return;
            }

            var tmp,
                that = this,
                options = this.options,
                x1 = this.opos[0],
                y1 = this.opos[1],
                x2 = event.pageX,
                y2 = event.pageY;

            if (x1 > x2) { tmp = x2; x2 = x1; x1 = tmp; }
            if (y1 > y2) { tmp = y2; y2 = y1; y1 = tmp; }
            this.helper.css({left: x1, top: y1, width: x2-x1, height: y2-y1});

            this.selectees.each(function() {
                var selectee = $.data(this, "selectable-item"),
                    hit = false;

                //prevent helper from being selected if appendTo: selectable
                if (!selectee || selectee.element === that.element[0]) {
                    return;
                }

                if (options.tolerance === "touch") {
                    hit = ( !(selectee.left > x2 || selectee.right < x1 || selectee.top > y2 || selectee.bottom < y1) );
                } else if (options.tolerance === "fit") {
                    hit = (selectee.left > x1 && selectee.right < x2 && selectee.top > y1 && selectee.bottom < y2);
                }

                if (hit) {
                    // SELECT
                    if (selectee.selected) {
                        selectee.$element.removeClass("ui-selected");
                        selectee.selected = false;
                    }
                    if (selectee.unselecting) {
                        selectee.$element.removeClass("ui-unselecting");
                        selectee.unselecting = false;
                    }
                    if (!selectee.selecting) {
                        selectee.$element.addClass("ui-selecting");
                        selectee.selecting = true;
                        // selectable SELECTING callback
                        that._trigger("selecting", event, {
                            selecting: selectee.element
                        });
                    }
                } else {
                    // UNSELECT
                    if (selectee.selecting) {
                        if ((event.metaKey || event.ctrlKey) && selectee.startselected) {
                            selectee.$element.removeClass("ui-selecting");
                            selectee.selecting = false;
                            selectee.$element.addClass("ui-selected");
                            selectee.selected = true;
                        } else {
                            selectee.$element.removeClass("ui-selecting");
                            selectee.selecting = false;
                            if (selectee.startselected) {
                                selectee.$element.addClass("ui-unselecting");
                                selectee.unselecting = true;
                            }
                            // selectable UNSELECTING callback
                            that._trigger("unselecting", event, {
                                unselecting: selectee.element
                            });
                        }
                    }
                    if (selectee.selected) {
                        if (!event.metaKey && !event.ctrlKey && !selectee.startselected) {
                            selectee.$element.removeClass("ui-selected");
                            selectee.selected = false;

                            selectee.$element.addClass("ui-unselecting");
                            selectee.unselecting = true;
                            // selectable UNSELECTING callback
                            that._trigger("unselecting", event, {
                                unselecting: selectee.element
                            });
                        }
                    }
                }
            });

            return false;
        },

        _mouseStop: function(event) {
            var that = this;

            this.dragged = false;

            $(".ui-unselecting", this.element[0]).each(function() {
                var selectee = $.data(this, "selectable-item");
                selectee.$element.removeClass("ui-unselecting");
                selectee.unselecting = false;
                selectee.startselected = false;
                that._trigger("unselected", event, {
                    unselected: selectee.element
                });
            });
            $(".ui-selecting", this.element[0]).each(function() {
                var selectee = $.data(this, "selectable-item");
                selectee.$element.removeClass("ui-selecting").addClass("ui-selected");
                selectee.selecting = false;
                selectee.selected = true;
                selectee.startselected = true;
                that._trigger("selected", event, {
                    selected: selectee.element
                });
            });
            this._trigger("stop", event);

            this.helper.remove();

            return false;
        }

    });

})(jQuery);

(function( $, undefined ) {

    /*jshint loopfunc: true */

    function isOverAxis( x, reference, size ) {
        return ( x > reference ) && ( x < ( reference + size ) );
    }

    function isFloating(item) {
        return (/left|right/).test(item.css("float")) || (/inline|table-cell/).test(item.css("display"));
    }

    $.widget("ui.sortable", $.ui.mouse, {
        version: "1.10.2",
        widgetEventPrefix: "sort",
        ready: false,
        options: {
            appendTo: "parent",
            axis: false,
            connectWith: false,
            containment: false,
            cursor: "auto",
            cursorAt: false,
            dropOnEmpty: true,
            forcePlaceholderSize: false,
            forceHelperSize: false,
            grid: false,
            handle: false,
            helper: "original",
            items: "> *",
            opacity: false,
            placeholder: false,
            revert: false,
            scroll: true,
            scrollSensitivity: 20,
            scrollSpeed: 20,
            scope: "default",
            tolerance: "intersect",
            zIndex: 1000,

            // callbacks
            activate: null,
            beforeStop: null,
            change: null,
            deactivate: null,
            out: null,
            over: null,
            receive: null,
            remove: null,
            sort: null,
            start: null,
            stop: null,
            update: null
        },
        _create: function() {

            var o = this.options;
            this.containerCache = {};
            this.element.addClass("ui-sortable");

            //Get the items
            this.refresh();

            //Let's determine if the items are being displayed horizontally
            this.floating = this.items.length ? o.axis === "x" || isFloating(this.items[0].item) : false;

            //Let's determine the parent's offset
            this.offset = this.element.offset();

            //Initialize mouse events for interaction
            this._mouseInit();

            //We're ready to go
            this.ready = true;

        },

        _destroy: function() {
            this.element
                .removeClass("ui-sortable ui-sortable-disabled");
            this._mouseDestroy();

            for ( var i = this.items.length - 1; i >= 0; i-- ) {
                this.items[i].item.removeData(this.widgetName + "-item");
            }

            return this;
        },

        _setOption: function(key, value){
            if ( key === "disabled" ) {
                this.options[ key ] = value;

                this.widget().toggleClass( "ui-sortable-disabled", !!value );
            } else {
                // Don't call widget base _setOption for disable as it adds ui-state-disabled class
                $.Widget.prototype._setOption.apply(this, arguments);
            }
        },

        _mouseCapture: function(event, overrideHandle) {
            var currentItem = null,
                validHandle = false,
                that = this;

            if (this.reverting) {
                return false;
            }

            if(this.options.disabled || this.options.type === "static") {
                return false;
            }

            //We have to refresh the items data once first
            this._refreshItems(event);

            //Find out if the clicked node (or one of its parents) is a actual item in this.items
            $(event.target).parents().each(function() {
                if($.data(this, that.widgetName + "-item") === that) {
                    currentItem = $(this);
                    return false;
                }
            });
            if($.data(event.target, that.widgetName + "-item") === that) {
                currentItem = $(event.target);
            }

            if(!currentItem) {
                return false;
            }
            if(this.options.handle && !overrideHandle) {
                $(this.options.handle, currentItem).find("*").addBack().each(function() {
                    if(this === event.target) {
                        validHandle = true;
                    }
                });
                if(!validHandle) {
                    return false;
                }
            }

            this.currentItem = currentItem;
            this._removeCurrentsFromItems();
            return true;

        },

        _mouseStart: function(event, overrideHandle, noActivation) {

            var i, body,
                o = this.options;

            this.currentContainer = this;

            //We only need to call refreshPositions, because the refreshItems call has been moved to mouseCapture
            this.refreshPositions();

            //Create and append the visible helper
            this.helper = this._createHelper(event);

            //Cache the helper size
            this._cacheHelperProportions();

            /*
             * - Position generation -
             * This block generates everything position related - it's the core of draggables.
             */

            //Cache the margins of the original element
            this._cacheMargins();

            //Get the next scrolling parent
            this.scrollParent = this.helper.scrollParent();

            //The element's absolute position on the page minus margins
            this.offset = this.currentItem.offset();
            this.offset = {
                top: this.offset.top - this.margins.top,
                left: this.offset.left - this.margins.left
            };

            $.extend(this.offset, {
                click: { //Where the click happened, relative to the element
                    left: event.pageX - this.offset.left,
                    top: event.pageY - this.offset.top
                },
                parent: this._getParentOffset(),
                relative: this._getRelativeOffset() //This is a relative to absolute position minus the actual position calculation - only used for relative positioned helper
            });

            // Only after we got the offset, we can change the helper's position to absolute
            // TODO: Still need to figure out a way to make relative sorting possible
            this.helper.css("position", "absolute");
            this.cssPosition = this.helper.css("position");

            //Generate the original position
            this.originalPosition = this._generatePosition(event);
            this.originalPageX = event.pageX;
            this.originalPageY = event.pageY;

            //Adjust the mouse offset relative to the helper if "cursorAt" is supplied
            (o.cursorAt && this._adjustOffsetFromHelper(o.cursorAt));

            //Cache the former DOM position
            this.domPosition = { prev: this.currentItem.prev()[0], parent: this.currentItem.parent()[0] };

            //If the helper is not the original, hide the original so it's not playing any role during the drag, won't cause anything bad this way
            if(this.helper[0] !== this.currentItem[0]) {
                this.currentItem.hide();
            }

            //Create the placeholder
            this._createPlaceholder();

            //Set a containment if given in the options
            if(o.containment) {
                this._setContainment();
            }

            if( o.cursor && o.cursor !== "auto" ) { // cursor option
                body = this.document.find( "body" );

                // support: IE
                this.storedCursor = body.css( "cursor" );
                body.css( "cursor", o.cursor );

                this.storedStylesheet = $( "<style>*{ cursor: "+o.cursor+" !important; }</style>" ).appendTo( body );
            }

            if(o.opacity) { // opacity option
                if (this.helper.css("opacity")) {
                    this._storedOpacity = this.helper.css("opacity");
                }
                this.helper.css("opacity", o.opacity);
            }

            if(o.zIndex) { // zIndex option
                if (this.helper.css("zIndex")) {
                    this._storedZIndex = this.helper.css("zIndex");
                }
                this.helper.css("zIndex", o.zIndex);
            }

            //Prepare scrolling
            if(this.scrollParent[0] !== document && this.scrollParent[0].tagName !== "HTML") {
                this.overflowOffset = this.scrollParent.offset();
            }

            //Call callbacks
            this._trigger("start", event, this._uiHash());

            //Recache the helper size
            if(!this._preserveHelperProportions) {
                this._cacheHelperProportions();
            }


            //Post "activate" events to possible containers
            if( !noActivation ) {
                for ( i = this.containers.length - 1; i >= 0; i-- ) {
                    this.containers[ i ]._trigger( "activate", event, this._uiHash( this ) );
                }
            }

            //Prepare possible droppables
            if($.ui.ddmanager) {
                $.ui.ddmanager.current = this;
            }

            if ($.ui.ddmanager && !o.dropBehaviour) {
                $.ui.ddmanager.prepareOffsets(this, event);
            }

            this.dragging = true;

            this.helper.addClass("ui-sortable-helper");
            this._mouseDrag(event); //Execute the drag once - this causes the helper not to be visible before getting its correct position
            return true;

        },

        _mouseDrag: function(event) {
            var i, item, itemElement, intersection,
                o = this.options,
                scrolled = false;

            //Compute the helpers position
            this.position = this._generatePosition(event);
            this.positionAbs = this._convertPositionTo("absolute");

            if (!this.lastPositionAbs) {
                this.lastPositionAbs = this.positionAbs;
            }

            //Do scrolling
            if(this.options.scroll) {
                if(this.scrollParent[0] !== document && this.scrollParent[0].tagName !== "HTML") {

                    if((this.overflowOffset.top + this.scrollParent[0].offsetHeight) - event.pageY < o.scrollSensitivity) {
                        this.scrollParent[0].scrollTop = scrolled = this.scrollParent[0].scrollTop + o.scrollSpeed;
                    } else if(event.pageY - this.overflowOffset.top < o.scrollSensitivity) {
                        this.scrollParent[0].scrollTop = scrolled = this.scrollParent[0].scrollTop - o.scrollSpeed;
                    }

                    if((this.overflowOffset.left + this.scrollParent[0].offsetWidth) - event.pageX < o.scrollSensitivity) {
                        this.scrollParent[0].scrollLeft = scrolled = this.scrollParent[0].scrollLeft + o.scrollSpeed;
                    } else if(event.pageX - this.overflowOffset.left < o.scrollSensitivity) {
                        this.scrollParent[0].scrollLeft = scrolled = this.scrollParent[0].scrollLeft - o.scrollSpeed;
                    }

                } else {

                    if(event.pageY - $(document).scrollTop() < o.scrollSensitivity) {
                        scrolled = $(document).scrollTop($(document).scrollTop() - o.scrollSpeed);
                    } else if($(window).height() - (event.pageY - $(document).scrollTop()) < o.scrollSensitivity) {
                        scrolled = $(document).scrollTop($(document).scrollTop() + o.scrollSpeed);
                    }

                    if(event.pageX - $(document).scrollLeft() < o.scrollSensitivity) {
                        scrolled = $(document).scrollLeft($(document).scrollLeft() - o.scrollSpeed);
                    } else if($(window).width() - (event.pageX - $(document).scrollLeft()) < o.scrollSensitivity) {
                        scrolled = $(document).scrollLeft($(document).scrollLeft() + o.scrollSpeed);
                    }

                }

                if(scrolled !== false && $.ui.ddmanager && !o.dropBehaviour) {
                    $.ui.ddmanager.prepareOffsets(this, event);
                }
            }

            //Regenerate the absolute position used for position checks
            this.positionAbs = this._convertPositionTo("absolute");

            //Set the helper position
            if(!this.options.axis || this.options.axis !== "y") {
                this.helper[0].style.left = this.position.left+"px";
            }
            if(!this.options.axis || this.options.axis !== "x") {
                this.helper[0].style.top = this.position.top+"px";
            }

            //Rearrange
            for (i = this.items.length - 1; i >= 0; i--) {

                //Cache variables and intersection, continue if no intersection
                item = this.items[i];
                itemElement = item.item[0];
                intersection = this._intersectsWithPointer(item);
                if (!intersection) {
                    continue;
                }

                // Only put the placeholder inside the current Container, skip all
                // items form other containers. This works because when moving
                // an item from one container to another the
                // currentContainer is switched before the placeholder is moved.
                //
                // Without this moving items in "sub-sortables" can cause the placeholder to jitter
                // beetween the outer and inner container.
                if (item.instance !== this.currentContainer) {
                    continue;
                }

                // cannot intersect with itself
                // no useless actions that have been done before
                // no action if the item moved is the parent of the item checked
                if (itemElement !== this.currentItem[0] &&
                    this.placeholder[intersection === 1 ? "next" : "prev"]()[0] !== itemElement &&
                    !$.contains(this.placeholder[0], itemElement) &&
                    (this.options.type === "semi-dynamic" ? !$.contains(this.element[0], itemElement) : true)
                ) {

                    this.direction = intersection === 1 ? "down" : "up";

                    if (this.options.tolerance === "pointer" || this._intersectsWithSides(item)) {
                        this._rearrange(event, item);
                    } else {
                        break;
                    }

                    this._trigger("change", event, this._uiHash());
                    break;
                }
            }

            //Post events to containers
            this._contactContainers(event);

            //Interconnect with droppables
            if($.ui.ddmanager) {
                $.ui.ddmanager.drag(this, event);
            }

            //Call callbacks
            this._trigger("sort", event, this._uiHash());

            this.lastPositionAbs = this.positionAbs;
            return false;

        },

        _mouseStop: function(event, noPropagation) {

            if(!event) {
                return;
            }

            //If we are using droppables, inform the manager about the drop
            if ($.ui.ddmanager && !this.options.dropBehaviour) {
                $.ui.ddmanager.drop(this, event);
            }

            if(this.options.revert) {
                var that = this,
                    cur = this.placeholder.offset(),
                    axis = this.options.axis,
                    animation = {};

                if ( !axis || axis === "x" ) {
                    animation.left = cur.left - this.offset.parent.left - this.margins.left + (this.offsetParent[0] === document.body ? 0 : this.offsetParent[0].scrollLeft);
                }
                if ( !axis || axis === "y" ) {
                    animation.top = cur.top - this.offset.parent.top - this.margins.top + (this.offsetParent[0] === document.body ? 0 : this.offsetParent[0].scrollTop);
                }
                this.reverting = true;
                $(this.helper).animate( animation, parseInt(this.options.revert, 10) || 500, function() {
                    that._clear(event);
                });
            } else {
                this._clear(event, noPropagation);
            }

            return false;

        },

        cancel: function() {

            if(this.dragging) {

                this._mouseUp({ target: null });

                if(this.options.helper === "original") {
                    this.currentItem.css(this._storedCSS).removeClass("ui-sortable-helper");
                } else {
                    this.currentItem.show();
                }

                //Post deactivating events to containers
                for (var i = this.containers.length - 1; i >= 0; i--){
                    this.containers[i]._trigger("deactivate", null, this._uiHash(this));
                    if(this.containers[i].containerCache.over) {
                        this.containers[i]._trigger("out", null, this._uiHash(this));
                        this.containers[i].containerCache.over = 0;
                    }
                }

            }

            if (this.placeholder) {
                //$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately, it unbinds ALL events from the original node!
                if(this.placeholder[0].parentNode) {
                    this.placeholder[0].parentNode.removeChild(this.placeholder[0]);
                }
                if(this.options.helper !== "original" && this.helper && this.helper[0].parentNode) {
                    this.helper.remove();
                }

                $.extend(this, {
                    helper: null,
                    dragging: false,
                    reverting: false,
                    _noFinalSort: null
                });

                if(this.domPosition.prev) {
                    $(this.domPosition.prev).after(this.currentItem);
                } else {
                    $(this.domPosition.parent).prepend(this.currentItem);
                }
            }

            return this;

        },

        serialize: function(o) {

            var items = this._getItemsAsjQuery(o && o.connected),
                str = [];
            o = o || {};

            $(items).each(function() {
                var res = ($(o.item || this).attr(o.attribute || "id") || "").match(o.expression || (/(.+)[\-=_](.+)/));
                if (res) {
                    str.push((o.key || res[1]+"[]")+"="+(o.key && o.expression ? res[1] : res[2]));
                }
            });

            if(!str.length && o.key) {
                str.push(o.key + "=");
            }

            return str.join("&");

        },

        toArray: function(o) {

            var items = this._getItemsAsjQuery(o && o.connected),
                ret = [];

            o = o || {};

            items.each(function() { ret.push($(o.item || this).attr(o.attribute || "id") || ""); });
            return ret;

        },

        /* Be careful with the following core functions */
        _intersectsWith: function(item) {

            var x1 = this.positionAbs.left,
                x2 = x1 + this.helperProportions.width,
                y1 = this.positionAbs.top,
                y2 = y1 + this.helperProportions.height,
                l = item.left,
                r = l + item.width,
                t = item.top,
                b = t + item.height,
                dyClick = this.offset.click.top,
                dxClick = this.offset.click.left,
                isOverElement = (y1 + dyClick) > t && (y1 + dyClick) < b && (x1 + dxClick) > l && (x1 + dxClick) < r;

            if ( this.options.tolerance === "pointer" ||
                this.options.forcePointerForContainers ||
                (this.options.tolerance !== "pointer" && this.helperProportions[this.floating ? "width" : "height"] > item[this.floating ? "width" : "height"])
            ) {
                return isOverElement;
            } else {

                return (l < x1 + (this.helperProportions.width / 2) && // Right Half
                x2 - (this.helperProportions.width / 2) < r && // Left Half
                t < y1 + (this.helperProportions.height / 2) && // Bottom Half
                y2 - (this.helperProportions.height / 2) < b ); // Top Half

            }
        },

        _intersectsWithPointer: function(item) {

            var isOverElementHeight = (this.options.axis === "x") || isOverAxis(this.positionAbs.top + this.offset.click.top, item.top, item.height),
                isOverElementWidth = (this.options.axis === "y") || isOverAxis(this.positionAbs.left + this.offset.click.left, item.left, item.width),
                isOverElement = isOverElementHeight && isOverElementWidth,
                verticalDirection = this._getDragVerticalDirection(),
                horizontalDirection = this._getDragHorizontalDirection();

            if (!isOverElement) {
                return false;
            }

            return this.floating ?
                ( ((horizontalDirection && horizontalDirection === "right") || verticalDirection === "down") ? 2 : 1 )
                : ( verticalDirection && (verticalDirection === "down" ? 2 : 1) );

        },

        _intersectsWithSides: function(item) {

            var isOverBottomHalf = isOverAxis(this.positionAbs.top + this.offset.click.top, item.top + (item.height/2), item.height),
                isOverRightHalf = isOverAxis(this.positionAbs.left + this.offset.click.left, item.left + (item.width/2), item.width),
                verticalDirection = this._getDragVerticalDirection(),
                horizontalDirection = this._getDragHorizontalDirection();

            if (this.floating && horizontalDirection) {
                return ((horizontalDirection === "right" && isOverRightHalf) || (horizontalDirection === "left" && !isOverRightHalf));
            } else {
                return verticalDirection && ((verticalDirection === "down" && isOverBottomHalf) || (verticalDirection === "up" && !isOverBottomHalf));
            }

        },

        _getDragVerticalDirection: function() {
            var delta = this.positionAbs.top - this.lastPositionAbs.top;
            return delta !== 0 && (delta > 0 ? "down" : "up");
        },

        _getDragHorizontalDirection: function() {
            var delta = this.positionAbs.left - this.lastPositionAbs.left;
            return delta !== 0 && (delta > 0 ? "right" : "left");
        },

        refresh: function(event) {
            this._refreshItems(event);
            this.refreshPositions();
            return this;
        },

        _connectWith: function() {
            var options = this.options;
            return options.connectWith.constructor === String ? [options.connectWith] : options.connectWith;
        },

        _getItemsAsjQuery: function(connected) {

            var i, j, cur, inst,
                items = [],
                queries = [],
                connectWith = this._connectWith();

            if(connectWith && connected) {
                for (i = connectWith.length - 1; i >= 0; i--){
                    cur = $(connectWith[i]);
                    for ( j = cur.length - 1; j >= 0; j--){
                        inst = $.data(cur[j], this.widgetFullName);
                        if(inst && inst !== this && !inst.options.disabled) {
                            queries.push([$.isFunction(inst.options.items) ? inst.options.items.call(inst.element) : $(inst.options.items, inst.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"), inst]);
                        }
                    }
                }
            }

            queries.push([$.isFunction(this.options.items) ? this.options.items.call(this.element, null, { options: this.options, item: this.currentItem }) : $(this.options.items, this.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"), this]);

            for (i = queries.length - 1; i >= 0; i--){
                queries[i][0].each(function() {
                    items.push(this);
                });
            }

            return $(items);

        },

        _removeCurrentsFromItems: function() {

            var list = this.currentItem.find(":data(" + this.widgetName + "-item)");

            this.items = $.grep(this.items, function (item) {
                for (var j=0; j < list.length; j++) {
                    if(list[j] === item.item[0]) {
                        return false;
                    }
                }
                return true;
            });

        },

        _refreshItems: function(event) {

            this.items = [];
            this.containers = [this];

            var i, j, cur, inst, targetData, _queries, item, queriesLength,
                items = this.items,
                queries = [[$.isFunction(this.options.items) ? this.options.items.call(this.element[0], event, { item: this.currentItem }) : $(this.options.items, this.element), this]],
                connectWith = this._connectWith();

            if(connectWith && this.ready) { //Shouldn't be run the first time through due to massive slow-down
                for (i = connectWith.length - 1; i >= 0; i--){
                    cur = $(connectWith[i]);
                    for (j = cur.length - 1; j >= 0; j--){
                        inst = $.data(cur[j], this.widgetFullName);
                        if(inst && inst !== this && !inst.options.disabled) {
                            queries.push([$.isFunction(inst.options.items) ? inst.options.items.call(inst.element[0], event, { item: this.currentItem }) : $(inst.options.items, inst.element), inst]);
                            this.containers.push(inst);
                        }
                    }
                }
            }

            for (i = queries.length - 1; i >= 0; i--) {
                targetData = queries[i][1];
                _queries = queries[i][0];

                for (j=0, queriesLength = _queries.length; j < queriesLength; j++) {
                    item = $(_queries[j]);

                    item.data(this.widgetName + "-item", targetData); // Data for target checking (mouse manager)

                    items.push({
                        item: item,
                        instance: targetData,
                        width: 0, height: 0,
                        left: 0, top: 0
                    });
                }
            }

        },

        refreshPositions: function(fast) {

            //This has to be redone because due to the item being moved out/into the offsetParent, the offsetParent's position will change
            if(this.offsetParent && this.helper) {
                this.offset.parent = this._getParentOffset();
            }

            var i, item, t, p;

            for (i = this.items.length - 1; i >= 0; i--){
                item = this.items[i];

                //We ignore calculating positions of all connected containers when we're not over them
                if(item.instance !== this.currentContainer && this.currentContainer && item.item[0] !== this.currentItem[0]) {
                    continue;
                }

                t = this.options.toleranceElement ? $(this.options.toleranceElement, item.item) : item.item;

                if (!fast) {
                    item.width = t.outerWidth();
                    item.height = t.outerHeight();
                }

                p = t.offset();
                item.left = p.left;
                item.top = p.top;
            }

            if(this.options.custom && this.options.custom.refreshContainers) {
                this.options.custom.refreshContainers.call(this);
            } else {
                for (i = this.containers.length - 1; i >= 0; i--){
                    p = this.containers[i].element.offset();
                    this.containers[i].containerCache.left = p.left;
                    this.containers[i].containerCache.top = p.top;
                    this.containers[i].containerCache.width	= this.containers[i].element.outerWidth();
                    this.containers[i].containerCache.height = this.containers[i].element.outerHeight();
                }
            }

            return this;
        },

        _createPlaceholder: function(that) {
            that = that || this;
            var className,
                o = that.options;

            if(!o.placeholder || o.placeholder.constructor === String) {
                className = o.placeholder;
                o.placeholder = {
                    element: function() {

                        var nodeName = that.currentItem[0].nodeName.toLowerCase(),
                            element = $( that.document[0].createElement( nodeName ) )
                                .addClass(className || that.currentItem[0].className+" ui-sortable-placeholder")
                                .removeClass("ui-sortable-helper");

                        if ( nodeName === "tr" ) {
                            // Use a high colspan to force the td to expand the full
                            // width of the table (browsers are smart enough to
                            // handle this properly)
                            element.append( "<td colspan='99'>&#160;</td>" );
                        } else if ( nodeName === "img" ) {
                            element.attr( "src", that.currentItem.attr( "src" ) );
                        }

                        if ( !className ) {
                            element.css( "visibility", "hidden" );
                        }

                        return element;
                    },
                    update: function(container, p) {

                        // 1. If a className is set as 'placeholder option, we don't force sizes - the class is responsible for that
                        // 2. The option 'forcePlaceholderSize can be enabled to force it even if a class name is specified
                        if(className && !o.forcePlaceholderSize) {
                            return;
                        }

                        //If the element doesn't have a actual height by itself (without styles coming from a stylesheet), it receives the inline height from the dragged item
                        if(!p.height()) { p.height(that.currentItem.innerHeight() - parseInt(that.currentItem.css("paddingTop")||0, 10) - parseInt(that.currentItem.css("paddingBottom")||0, 10)); }
                        if(!p.width()) { p.width(that.currentItem.innerWidth() - parseInt(that.currentItem.css("paddingLeft")||0, 10) - parseInt(that.currentItem.css("paddingRight")||0, 10)); }
                    }
                };
            }

            //Create the placeholder
            that.placeholder = $(o.placeholder.element.call(that.element, that.currentItem));

            //Append it after the actual current item
            that.currentItem.after(that.placeholder);

            //Update the size of the placeholder (TODO: Logic to fuzzy, see line 316/317)
            o.placeholder.update(that, that.placeholder);

        },

        _contactContainers: function(event) {
            var i, j, dist, itemWithLeastDistance, posProperty, sizeProperty, base, cur, nearBottom, floating,
                innermostContainer = null,
                innermostIndex = null;

            // get innermost container that intersects with item
            for (i = this.containers.length - 1; i >= 0; i--) {

                // never consider a container that's located within the item itself
                if($.contains(this.currentItem[0], this.containers[i].element[0])) {
                    continue;
                }

                if(this._intersectsWith(this.containers[i].containerCache)) {

                    // if we've already found a container and it's more "inner" than this, then continue
                    if(innermostContainer && $.contains(this.containers[i].element[0], innermostContainer.element[0])) {
                        continue;
                    }

                    innermostContainer = this.containers[i];
                    innermostIndex = i;

                } else {
                    // container doesn't intersect. trigger "out" event if necessary
                    if(this.containers[i].containerCache.over) {
                        this.containers[i]._trigger("out", event, this._uiHash(this));
                        this.containers[i].containerCache.over = 0;
                    }
                }

            }

            // if no intersecting containers found, return
            if(!innermostContainer) {
                return;
            }

            // move the item into the container if it's not there already
            if(this.containers.length === 1) {
                if (!this.containers[innermostIndex].containerCache.over) {
                    this.containers[innermostIndex]._trigger("over", event, this._uiHash(this));
                    this.containers[innermostIndex].containerCache.over = 1;
                }
            } else {

                //When entering a new container, we will find the item with the least distance and append our item near it
                dist = 10000;
                itemWithLeastDistance = null;
                floating = innermostContainer.floating || isFloating(this.currentItem);
                posProperty = floating ? "left" : "top";
                sizeProperty = floating ? "width" : "height";
                base = this.positionAbs[posProperty] + this.offset.click[posProperty];
                for (j = this.items.length - 1; j >= 0; j--) {
                    if(!$.contains(this.containers[innermostIndex].element[0], this.items[j].item[0])) {
                        continue;
                    }
                    if(this.items[j].item[0] === this.currentItem[0]) {
                        continue;
                    }
                    if (floating && !isOverAxis(this.positionAbs.top + this.offset.click.top, this.items[j].top, this.items[j].height)) {
                        continue;
                    }
                    cur = this.items[j].item.offset()[posProperty];
                    nearBottom = false;
                    if(Math.abs(cur - base) > Math.abs(cur + this.items[j][sizeProperty] - base)){
                        nearBottom = true;
                        cur += this.items[j][sizeProperty];
                    }

                    if(Math.abs(cur - base) < dist) {
                        dist = Math.abs(cur - base); itemWithLeastDistance = this.items[j];
                        this.direction = nearBottom ? "up": "down";
                    }
                }

                //Check if dropOnEmpty is enabled
                if(!itemWithLeastDistance && !this.options.dropOnEmpty) {
                    return;
                }

                if(this.currentContainer === this.containers[innermostIndex]) {
                    return;
                }

                itemWithLeastDistance ? this._rearrange(event, itemWithLeastDistance, null, true) : this._rearrange(event, null, this.containers[innermostIndex].element, true);
                this._trigger("change", event, this._uiHash());
                this.containers[innermostIndex]._trigger("change", event, this._uiHash(this));
                this.currentContainer = this.containers[innermostIndex];

                //Update the placeholder
                this.options.placeholder.update(this.currentContainer, this.placeholder);

                this.containers[innermostIndex]._trigger("over", event, this._uiHash(this));
                this.containers[innermostIndex].containerCache.over = 1;
            }


        },

        _createHelper: function(event) {

            var o = this.options,
                helper = $.isFunction(o.helper) ? $(o.helper.apply(this.element[0], [event, this.currentItem])) : (o.helper === "clone" ? this.currentItem.clone() : this.currentItem);

            //Add the helper to the DOM if that didn't happen already
            if(!helper.parents("body").length) {
                $(o.appendTo !== "parent" ? o.appendTo : this.currentItem[0].parentNode)[0].appendChild(helper[0]);
            }

            if(helper[0] === this.currentItem[0]) {
                this._storedCSS = { width: this.currentItem[0].style.width, height: this.currentItem[0].style.height, position: this.currentItem.css("position"), top: this.currentItem.css("top"), left: this.currentItem.css("left") };
            }

            if(!helper[0].style.width || o.forceHelperSize) {
                helper.width(this.currentItem.width());
            }
            if(!helper[0].style.height || o.forceHelperSize) {
                helper.height(this.currentItem.height());
            }

            return helper;

        },

        _adjustOffsetFromHelper: function(obj) {
            if (typeof obj === "string") {
                obj = obj.split(" ");
            }
            if ($.isArray(obj)) {
                obj = {left: +obj[0], top: +obj[1] || 0};
            }
            if ("left" in obj) {
                this.offset.click.left = obj.left + this.margins.left;
            }
            if ("right" in obj) {
                this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
            }
            if ("top" in obj) {
                this.offset.click.top = obj.top + this.margins.top;
            }
            if ("bottom" in obj) {
                this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
            }
        },

        _getParentOffset: function() {


            //Get the offsetParent and cache its position
            this.offsetParent = this.helper.offsetParent();
            var po = this.offsetParent.offset();

            // This is a special case where we need to modify a offset calculated on start, since the following happened:
            // 1. The position of the helper is absolute, so it's position is calculated based on the next positioned parent
            // 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't the document, which means that
            //    the scroll is included in the initial calculation of the offset of the parent, and never recalculated upon drag
            if(this.cssPosition === "absolute" && this.scrollParent[0] !== document && $.contains(this.scrollParent[0], this.offsetParent[0])) {
                po.left += this.scrollParent.scrollLeft();
                po.top += this.scrollParent.scrollTop();
            }

            // This needs to be actually done for all browsers, since pageX/pageY includes this information
            // with an ugly IE fix
            if( this.offsetParent[0] === document.body || (this.offsetParent[0].tagName && this.offsetParent[0].tagName.toLowerCase() === "html" && $.ui.ie)) {
                po = { top: 0, left: 0 };
            }

            return {
                top: po.top + (parseInt(this.offsetParent.css("borderTopWidth"),10) || 0),
                left: po.left + (parseInt(this.offsetParent.css("borderLeftWidth"),10) || 0)
            };

        },

        _getRelativeOffset: function() {

            if(this.cssPosition === "relative") {
                var p = this.currentItem.position();
                return {
                    top: p.top - (parseInt(this.helper.css("top"),10) || 0) + this.scrollParent.scrollTop(),
                    left: p.left - (parseInt(this.helper.css("left"),10) || 0) + this.scrollParent.scrollLeft()
                };
            } else {
                return { top: 0, left: 0 };
            }

        },

        _cacheMargins: function() {
            this.margins = {
                left: (parseInt(this.currentItem.css("marginLeft"),10) || 0),
                top: (parseInt(this.currentItem.css("marginTop"),10) || 0)
            };
        },

        _cacheHelperProportions: function() {
            this.helperProportions = {
                width: this.helper.outerWidth(),
                height: this.helper.outerHeight()
            };
        },

        _setContainment: function() {

            var ce, co, over,
                o = this.options;
            if(o.containment === "parent") {
                o.containment = this.helper[0].parentNode;
            }
            if(o.containment === "document" || o.containment === "window") {
                this.containment = [
                    0 - this.offset.relative.left - this.offset.parent.left,
                    0 - this.offset.relative.top - this.offset.parent.top,
                    $(o.containment === "document" ? document : window).width() - this.helperProportions.width - this.margins.left,
                    ($(o.containment === "document" ? document : window).height() || document.body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top
                ];
            }

            if(!(/^(document|window|parent)$/).test(o.containment)) {
                ce = $(o.containment)[0];
                co = $(o.containment).offset();
                over = ($(ce).css("overflow") !== "hidden");

                this.containment = [
                    co.left + (parseInt($(ce).css("borderLeftWidth"),10) || 0) + (parseInt($(ce).css("paddingLeft"),10) || 0) - this.margins.left,
                    co.top + (parseInt($(ce).css("borderTopWidth"),10) || 0) + (parseInt($(ce).css("paddingTop"),10) || 0) - this.margins.top,
                    co.left+(over ? Math.max(ce.scrollWidth,ce.offsetWidth) : ce.offsetWidth) - (parseInt($(ce).css("borderLeftWidth"),10) || 0) - (parseInt($(ce).css("paddingRight"),10) || 0) - this.helperProportions.width - this.margins.left,
                    co.top+(over ? Math.max(ce.scrollHeight,ce.offsetHeight) : ce.offsetHeight) - (parseInt($(ce).css("borderTopWidth"),10) || 0) - (parseInt($(ce).css("paddingBottom"),10) || 0) - this.helperProportions.height - this.margins.top
                ];
            }

        },

        _convertPositionTo: function(d, pos) {

            if(!pos) {
                pos = this.position;
            }
            var mod = d === "absolute" ? 1 : -1,
                scroll = this.cssPosition === "absolute" && !(this.scrollParent[0] !== document && $.contains(this.scrollParent[0], this.offsetParent[0])) ? this.offsetParent : this.scrollParent,
                scrollIsRootNode = (/(html|body)/i).test(scroll[0].tagName);

            return {
                top: (
                    pos.top	+																// The absolute mouse position
                    this.offset.relative.top * mod +										// Only for relative positioned nodes: Relative offset from element to offset parent
                    this.offset.parent.top * mod -											// The offsetParent's offset without borders (offset + border)
                    ( ( this.cssPosition === "fixed" ? -this.scrollParent.scrollTop() : ( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) * mod)
                ),
                left: (
                    pos.left +																// The absolute mouse position
                    this.offset.relative.left * mod +										// Only for relative positioned nodes: Relative offset from element to offset parent
                    this.offset.parent.left * mod	-										// The offsetParent's offset without borders (offset + border)
                    ( ( this.cssPosition === "fixed" ? -this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 : scroll.scrollLeft() ) * mod)
                )
            };

        },

        _generatePosition: function(event) {

            var top, left,
                o = this.options,
                pageX = event.pageX,
                pageY = event.pageY,
                scroll = this.cssPosition === "absolute" && !(this.scrollParent[0] !== document && $.contains(this.scrollParent[0], this.offsetParent[0])) ? this.offsetParent : this.scrollParent, scrollIsRootNode = (/(html|body)/i).test(scroll[0].tagName);

            // This is another very weird special case that only happens for relative elements:
            // 1. If the css position is relative
            // 2. and the scroll parent is the document or similar to the offset parent
            // we have to refresh the relative offset during the scroll so there are no jumps
            if(this.cssPosition === "relative" && !(this.scrollParent[0] !== document && this.scrollParent[0] !== this.offsetParent[0])) {
                this.offset.relative = this._getRelativeOffset();
            }

            /*
             * - Position constraining -
             * Constrain the position to a mix of grid, containment.
             */

            if(this.originalPosition) { //If we are not dragging yet, we won't check for options

                if(this.containment) {
                    if(event.pageX - this.offset.click.left < this.containment[0]) {
                        pageX = this.containment[0] + this.offset.click.left;
                    }
                    if(event.pageY - this.offset.click.top < this.containment[1]) {
                        pageY = this.containment[1] + this.offset.click.top;
                    }
                    if(event.pageX - this.offset.click.left > this.containment[2]) {
                        pageX = this.containment[2] + this.offset.click.left;
                    }
                    if(event.pageY - this.offset.click.top > this.containment[3]) {
                        pageY = this.containment[3] + this.offset.click.top;
                    }
                }

                if(o.grid) {
                    top = this.originalPageY + Math.round((pageY - this.originalPageY) / o.grid[1]) * o.grid[1];
                    pageY = this.containment ? ( (top - this.offset.click.top >= this.containment[1] && top - this.offset.click.top <= this.containment[3]) ? top : ((top - this.offset.click.top >= this.containment[1]) ? top - o.grid[1] : top + o.grid[1])) : top;

                    left = this.originalPageX + Math.round((pageX - this.originalPageX) / o.grid[0]) * o.grid[0];
                    pageX = this.containment ? ( (left - this.offset.click.left >= this.containment[0] && left - this.offset.click.left <= this.containment[2]) ? left : ((left - this.offset.click.left >= this.containment[0]) ? left - o.grid[0] : left + o.grid[0])) : left;
                }

            }

            return {
                top: (
                    pageY -																// The absolute mouse position
                    this.offset.click.top -													// Click offset (relative to the element)
                    this.offset.relative.top	-											// Only for relative positioned nodes: Relative offset from element to offset parent
                    this.offset.parent.top +												// The offsetParent's offset without borders (offset + border)
                    ( ( this.cssPosition === "fixed" ? -this.scrollParent.scrollTop() : ( scrollIsRootNode ? 0 : scroll.scrollTop() ) ))
                ),
                left: (
                    pageX -																// The absolute mouse position
                    this.offset.click.left -												// Click offset (relative to the element)
                    this.offset.relative.left	-											// Only for relative positioned nodes: Relative offset from element to offset parent
                    this.offset.parent.left +												// The offsetParent's offset without borders (offset + border)
                    ( ( this.cssPosition === "fixed" ? -this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 : scroll.scrollLeft() ))
                )
            };

        },

        _rearrange: function(event, i, a, hardRefresh) {

            a ? a[0].appendChild(this.placeholder[0]) : i.item[0].parentNode.insertBefore(this.placeholder[0], (this.direction === "down" ? i.item[0] : i.item[0].nextSibling));

            //Various things done here to improve the performance:
            // 1. we create a setTimeout, that calls refreshPositions
            // 2. on the instance, we have a counter variable, that get's higher after every append
            // 3. on the local scope, we copy the counter variable, and check in the timeout, if it's still the same
            // 4. this lets only the last addition to the timeout stack through
            this.counter = this.counter ? ++this.counter : 1;
            var counter = this.counter;

            this._delay(function() {
                if(counter === this.counter) {
                    this.refreshPositions(!hardRefresh); //Precompute after each DOM insertion, NOT on mousemove
                }
            });

        },

        _clear: function(event, noPropagation) {

            this.reverting = false;
            // We delay all events that have to be triggered to after the point where the placeholder has been removed and
            // everything else normalized again
            var i,
                delayedTriggers = [];

            // We first have to update the dom position of the actual currentItem
            // Note: don't do it if the current item is already removed (by a user), or it gets reappended (see #4088)
            if(!this._noFinalSort && this.currentItem.parent().length) {
                this.placeholder.before(this.currentItem);
            }
            this._noFinalSort = null;

            if(this.helper[0] === this.currentItem[0]) {
                for(i in this._storedCSS) {
                    if(this._storedCSS[i] === "auto" || this._storedCSS[i] === "static") {
                        this._storedCSS[i] = "";
                    }
                }
                this.currentItem.css(this._storedCSS).removeClass("ui-sortable-helper");
            } else {
                this.currentItem.show();
            }

            if(this.fromOutside && !noPropagation) {
                delayedTriggers.push(function(event) { this._trigger("receive", event, this._uiHash(this.fromOutside)); });
            }
            if((this.fromOutside || this.domPosition.prev !== this.currentItem.prev().not(".ui-sortable-helper")[0] || this.domPosition.parent !== this.currentItem.parent()[0]) && !noPropagation) {
                delayedTriggers.push(function(event) { this._trigger("update", event, this._uiHash()); }); //Trigger update callback if the DOM position has changed
            }

            // Check if the items Container has Changed and trigger appropriate
            // events.
            if (this !== this.currentContainer) {
                if(!noPropagation) {
                    delayedTriggers.push(function(event) { this._trigger("remove", event, this._uiHash()); });
                    delayedTriggers.push((function(c) { return function(event) { c._trigger("receive", event, this._uiHash(this)); };  }).call(this, this.currentContainer));
                    delayedTriggers.push((function(c) { return function(event) { c._trigger("update", event, this._uiHash(this));  }; }).call(this, this.currentContainer));
                }
            }


            //Post events to containers
            for (i = this.containers.length - 1; i >= 0; i--){
                if(!noPropagation) {
                    delayedTriggers.push((function(c) { return function(event) { c._trigger("deactivate", event, this._uiHash(this)); };  }).call(this, this.containers[i]));
                }
                if(this.containers[i].containerCache.over) {
                    delayedTriggers.push((function(c) { return function(event) { c._trigger("out", event, this._uiHash(this)); };  }).call(this, this.containers[i]));
                    this.containers[i].containerCache.over = 0;
                }
            }

            //Do what was originally in plugins
            if ( this.storedCursor ) {
                this.document.find( "body" ).css( "cursor", this.storedCursor );
                this.storedStylesheet.remove();
            }
            if(this._storedOpacity) {
                this.helper.css("opacity", this._storedOpacity);
            }
            if(this._storedZIndex) {
                this.helper.css("zIndex", this._storedZIndex === "auto" ? "" : this._storedZIndex);
            }

            this.dragging = false;
            if(this.cancelHelperRemoval) {
                if(!noPropagation) {
                    this._trigger("beforeStop", event, this._uiHash());
                    for (i=0; i < delayedTriggers.length; i++) {
                        delayedTriggers[i].call(this, event);
                    } //Trigger all delayed events
                    this._trigger("stop", event, this._uiHash());
                }

                this.fromOutside = false;
                return false;
            }

            if(!noPropagation) {
                this._trigger("beforeStop", event, this._uiHash());
            }

            //$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately, it unbinds ALL events from the original node!
            this.placeholder[0].parentNode.removeChild(this.placeholder[0]);

            if(this.helper[0] !== this.currentItem[0]) {
                this.helper.remove();
            }
            this.helper = null;

            if(!noPropagation) {
                for (i=0; i < delayedTriggers.length; i++) {
                    delayedTriggers[i].call(this, event);
                } //Trigger all delayed events
                this._trigger("stop", event, this._uiHash());
            }

            this.fromOutside = false;
            return true;

        },

        _trigger: function() {
            if ($.Widget.prototype._trigger.apply(this, arguments) === false) {
                this.cancel();
            }
        },

        _uiHash: function(_inst) {
            var inst = _inst || this;
            return {
                helper: inst.helper,
                placeholder: inst.placeholder || $([]),
                position: inst.position,
                originalPosition: inst.originalPosition,
                offset: inst.positionAbs,
                item: inst.currentItem,
                sender: _inst ? _inst.element : null
            };
        }

    });

})(jQuery);

(function($, undefined) {

    var dataSpace = "ui-effects-";

    $.effects = {
        effect: {}
    };

    /*!
     * jQuery Color Animations v2.1.2
     * https://github.com/jquery/jquery-color
     *
     * Copyright 2013 jQuery Foundation and other contributors
     * Released under the MIT license.
     * http://jquery.org/license
     *
     * Date: Wed Jan 16 08:47:09 2013 -0600
     */
    (function( jQuery, undefined ) {

        var stepHooks = "backgroundColor borderBottomColor borderLeftColor borderRightColor borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor",

            // plusequals test for += 100 -= 100
            rplusequals = /^([\-+])=\s*(\d+\.?\d*)/,
            // a set of RE's that can match strings and generate color tuples.
            stringParsers = [{
                re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
                parse: function( execResult ) {
                    return [
                        execResult[ 1 ],
                        execResult[ 2 ],
                        execResult[ 3 ],
                        execResult[ 4 ]
                    ];
                }
            }, {
                re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
                parse: function( execResult ) {
                    return [
                        execResult[ 1 ] * 2.55,
                        execResult[ 2 ] * 2.55,
                        execResult[ 3 ] * 2.55,
                        execResult[ 4 ]
                    ];
                }
            }, {
                // this regex ignores A-F because it's compared against an already lowercased string
                re: /#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/,
                parse: function( execResult ) {
                    return [
                        parseInt( execResult[ 1 ], 16 ),
                        parseInt( execResult[ 2 ], 16 ),
                        parseInt( execResult[ 3 ], 16 )
                    ];
                }
            }, {
                // this regex ignores A-F because it's compared against an already lowercased string
                re: /#([a-f0-9])([a-f0-9])([a-f0-9])/,
                parse: function( execResult ) {
                    return [
                        parseInt( execResult[ 1 ] + execResult[ 1 ], 16 ),
                        parseInt( execResult[ 2 ] + execResult[ 2 ], 16 ),
                        parseInt( execResult[ 3 ] + execResult[ 3 ], 16 )
                    ];
                }
            }, {
                re: /hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
                space: "hsla",
                parse: function( execResult ) {
                    return [
                        execResult[ 1 ],
                        execResult[ 2 ] / 100,
                        execResult[ 3 ] / 100,
                        execResult[ 4 ]
                    ];
                }
            }],

            // jQuery.Color( )
            color = jQuery.Color = function( color, green, blue, alpha ) {
                return new jQuery.Color.fn.parse( color, green, blue, alpha );
            },
            spaces = {
                rgba: {
                    props: {
                        red: {
                            idx: 0,
                            type: "byte"
                        },
                        green: {
                            idx: 1,
                            type: "byte"
                        },
                        blue: {
                            idx: 2,
                            type: "byte"
                        }
                    }
                },

                hsla: {
                    props: {
                        hue: {
                            idx: 0,
                            type: "degrees"
                        },
                        saturation: {
                            idx: 1,
                            type: "percent"
                        },
                        lightness: {
                            idx: 2,
                            type: "percent"
                        }
                    }
                }
            },
            propTypes = {
                "byte": {
                    floor: true,
                    max: 255
                },
                "percent": {
                    max: 1
                },
                "degrees": {
                    mod: 360,
                    floor: true
                }
            },
            support = color.support = {},

            // element for support tests
            supportElem = jQuery( "<p>" )[ 0 ],

            // colors = jQuery.Color.names
            colors,

            // local aliases of functions called often
            each = jQuery.each;

// determine rgba support immediately
        supportElem.style.cssText = "background-color:rgba(1,1,1,.5)";
        support.rgba = supportElem.style.backgroundColor.indexOf( "rgba" ) > -1;

// define cache name and alpha properties
// for rgba and hsla spaces
        each( spaces, function( spaceName, space ) {
            space.cache = "_" + spaceName;
            space.props.alpha = {
                idx: 3,
                type: "percent",
                def: 1
            };
        });

        function clamp( value, prop, allowEmpty ) {
            var type = propTypes[ prop.type ] || {};

            if ( value == null ) {
                return (allowEmpty || !prop.def) ? null : prop.def;
            }

            // ~~ is an short way of doing floor for positive numbers
            value = type.floor ? ~~value : parseFloat( value );

            // IE will pass in empty strings as value for alpha,
            // which will hit this case
            if ( isNaN( value ) ) {
                return prop.def;
            }

            if ( type.mod ) {
                // we add mod before modding to make sure that negatives values
                // get converted properly: -10 -> 350
                return (value + type.mod) % type.mod;
            }

            // for now all property types without mod have min and max
            return 0 > value ? 0 : type.max < value ? type.max : value;
        }

        function stringParse( string ) {
            var inst = color(),
                rgba = inst._rgba = [];

            string = string.toLowerCase();

            each( stringParsers, function( i, parser ) {
                var parsed,
                    match = parser.re.exec( string ),
                    values = match && parser.parse( match ),
                    spaceName = parser.space || "rgba";

                if ( values ) {
                    parsed = inst[ spaceName ]( values );

                    // if this was an rgba parse the assignment might happen twice
                    // oh well....
                    inst[ spaces[ spaceName ].cache ] = parsed[ spaces[ spaceName ].cache ];
                    rgba = inst._rgba = parsed._rgba;

                    // exit each( stringParsers ) here because we matched
                    return false;
                }
            });

            // Found a stringParser that handled it
            if ( rgba.length ) {

                // if this came from a parsed string, force "transparent" when alpha is 0
                // chrome, (and maybe others) return "transparent" as rgba(0,0,0,0)
                if ( rgba.join() === "0,0,0,0" ) {
                    jQuery.extend( rgba, colors.transparent );
                }
                return inst;
            }

            // named colors
            return colors[ string ];
        }

        color.fn = jQuery.extend( color.prototype, {
            parse: function( red, green, blue, alpha ) {
                if ( red === undefined ) {
                    this._rgba = [ null, null, null, null ];
                    return this;
                }
                if ( red.jquery || red.nodeType ) {
                    red = jQuery( red ).css( green );
                    green = undefined;
                }

                var inst = this,
                    type = jQuery.type( red ),
                    rgba = this._rgba = [];

                // more than 1 argument specified - assume ( red, green, blue, alpha )
                if ( green !== undefined ) {
                    red = [ red, green, blue, alpha ];
                    type = "array";
                }

                if ( type === "string" ) {
                    return this.parse( stringParse( red ) || colors._default );
                }

                if ( type === "array" ) {
                    each( spaces.rgba.props, function( key, prop ) {
                        rgba[ prop.idx ] = clamp( red[ prop.idx ], prop );
                    });
                    return this;
                }

                if ( type === "object" ) {
                    if ( red instanceof color ) {
                        each( spaces, function( spaceName, space ) {
                            if ( red[ space.cache ] ) {
                                inst[ space.cache ] = red[ space.cache ].slice();
                            }
                        });
                    } else {
                        each( spaces, function( spaceName, space ) {
                            var cache = space.cache;
                            each( space.props, function( key, prop ) {

                                // if the cache doesn't exist, and we know how to convert
                                if ( !inst[ cache ] && space.to ) {

                                    // if the value was null, we don't need to copy it
                                    // if the key was alpha, we don't need to copy it either
                                    if ( key === "alpha" || red[ key ] == null ) {
                                        return;
                                    }
                                    inst[ cache ] = space.to( inst._rgba );
                                }

                                // this is the only case where we allow nulls for ALL properties.
                                // call clamp with alwaysAllowEmpty
                                inst[ cache ][ prop.idx ] = clamp( red[ key ], prop, true );
                            });

                            // everything defined but alpha?
                            if ( inst[ cache ] && jQuery.inArray( null, inst[ cache ].slice( 0, 3 ) ) < 0 ) {
                                // use the default of 1
                                inst[ cache ][ 3 ] = 1;
                                if ( space.from ) {
                                    inst._rgba = space.from( inst[ cache ] );
                                }
                            }
                        });
                    }
                    return this;
                }
            },
            is: function( compare ) {
                var is = color( compare ),
                    same = true,
                    inst = this;

                each( spaces, function( _, space ) {
                    var localCache,
                        isCache = is[ space.cache ];
                    if (isCache) {
                        localCache = inst[ space.cache ] || space.to && space.to( inst._rgba ) || [];
                        each( space.props, function( _, prop ) {
                            if ( isCache[ prop.idx ] != null ) {
                                same = ( isCache[ prop.idx ] === localCache[ prop.idx ] );
                                return same;
                            }
                        });
                    }
                    return same;
                });
                return same;
            },
            _space: function() {
                var used = [],
                    inst = this;
                each( spaces, function( spaceName, space ) {
                    if ( inst[ space.cache ] ) {
                        used.push( spaceName );
                    }
                });
                return used.pop();
            },
            transition: function( other, distance ) {
                var end = color( other ),
                    spaceName = end._space(),
                    space = spaces[ spaceName ],
                    startColor = this.alpha() === 0 ? color( "transparent" ) : this,
                    start = startColor[ space.cache ] || space.to( startColor._rgba ),
                    result = start.slice();

                end = end[ space.cache ];
                each( space.props, function( key, prop ) {
                    var index = prop.idx,
                        startValue = start[ index ],
                        endValue = end[ index ],
                        type = propTypes[ prop.type ] || {};

                    // if null, don't override start value
                    if ( endValue === null ) {
                        return;
                    }
                    // if null - use end
                    if ( startValue === null ) {
                        result[ index ] = endValue;
                    } else {
                        if ( type.mod ) {
                            if ( endValue - startValue > type.mod / 2 ) {
                                startValue += type.mod;
                            } else if ( startValue - endValue > type.mod / 2 ) {
                                startValue -= type.mod;
                            }
                        }
                        result[ index ] = clamp( ( endValue - startValue ) * distance + startValue, prop );
                    }
                });
                return this[ spaceName ]( result );
            },
            blend: function( opaque ) {
                // if we are already opaque - return ourself
                if ( this._rgba[ 3 ] === 1 ) {
                    return this;
                }

                var rgb = this._rgba.slice(),
                    a = rgb.pop(),
                    blend = color( opaque )._rgba;

                return color( jQuery.map( rgb, function( v, i ) {
                    return ( 1 - a ) * blend[ i ] + a * v;
                }));
            },
            toRgbaString: function() {
                var prefix = "rgba(",
                    rgba = jQuery.map( this._rgba, function( v, i ) {
                        return v == null ? ( i > 2 ? 1 : 0 ) : v;
                    });

                if ( rgba[ 3 ] === 1 ) {
                    rgba.pop();
                    prefix = "rgb(";
                }

                return prefix + rgba.join() + ")";
            },
            toHslaString: function() {
                var prefix = "hsla(",
                    hsla = jQuery.map( this.hsla(), function( v, i ) {
                        if ( v == null ) {
                            v = i > 2 ? 1 : 0;
                        }

                        // catch 1 and 2
                        if ( i && i < 3 ) {
                            v = Math.round( v * 100 ) + "%";
                        }
                        return v;
                    });

                if ( hsla[ 3 ] === 1 ) {
                    hsla.pop();
                    prefix = "hsl(";
                }
                return prefix + hsla.join() + ")";
            },
            toHexString: function( includeAlpha ) {
                var rgba = this._rgba.slice(),
                    alpha = rgba.pop();

                if ( includeAlpha ) {
                    rgba.push( ~~( alpha * 255 ) );
                }

                return "#" + jQuery.map( rgba, function( v ) {

                        // default to 0 when nulls exist
                        v = ( v || 0 ).toString( 16 );
                        return v.length === 1 ? "0" + v : v;
                    }).join("");
            },
            toString: function() {
                return this._rgba[ 3 ] === 0 ? "transparent" : this.toRgbaString();
            }
        });
        color.fn.parse.prototype = color.fn;

// hsla conversions adapted from:
// https://code.google.com/p/maashaack/source/browse/packages/graphics/trunk/src/graphics/colors/HUE2RGB.as?r=5021

        function hue2rgb( p, q, h ) {
            h = ( h + 1 ) % 1;
            if ( h * 6 < 1 ) {
                return p + (q - p) * h * 6;
            }
            if ( h * 2 < 1) {
                return q;
            }
            if ( h * 3 < 2 ) {
                return p + (q - p) * ((2/3) - h) * 6;
            }
            return p;
        }

        spaces.hsla.to = function ( rgba ) {
            if ( rgba[ 0 ] == null || rgba[ 1 ] == null || rgba[ 2 ] == null ) {
                return [ null, null, null, rgba[ 3 ] ];
            }
            var r = rgba[ 0 ] / 255,
                g = rgba[ 1 ] / 255,
                b = rgba[ 2 ] / 255,
                a = rgba[ 3 ],
                max = Math.max( r, g, b ),
                min = Math.min( r, g, b ),
                diff = max - min,
                add = max + min,
                l = add * 0.5,
                h, s;

            if ( min === max ) {
                h = 0;
            } else if ( r === max ) {
                h = ( 60 * ( g - b ) / diff ) + 360;
            } else if ( g === max ) {
                h = ( 60 * ( b - r ) / diff ) + 120;
            } else {
                h = ( 60 * ( r - g ) / diff ) + 240;
            }

            // chroma (diff) == 0 means greyscale which, by definition, saturation = 0%
            // otherwise, saturation is based on the ratio of chroma (diff) to lightness (add)
            if ( diff === 0 ) {
                s = 0;
            } else if ( l <= 0.5 ) {
                s = diff / add;
            } else {
                s = diff / ( 2 - add );
            }
            return [ Math.round(h) % 360, s, l, a == null ? 1 : a ];
        };

        spaces.hsla.from = function ( hsla ) {
            if ( hsla[ 0 ] == null || hsla[ 1 ] == null || hsla[ 2 ] == null ) {
                return [ null, null, null, hsla[ 3 ] ];
            }
            var h = hsla[ 0 ] / 360,
                s = hsla[ 1 ],
                l = hsla[ 2 ],
                a = hsla[ 3 ],
                q = l <= 0.5 ? l * ( 1 + s ) : l + s - l * s,
                p = 2 * l - q;

            return [
                Math.round( hue2rgb( p, q, h + ( 1 / 3 ) ) * 255 ),
                Math.round( hue2rgb( p, q, h ) * 255 ),
                Math.round( hue2rgb( p, q, h - ( 1 / 3 ) ) * 255 ),
                a
            ];
        };


        each( spaces, function( spaceName, space ) {
            var props = space.props,
                cache = space.cache,
                to = space.to,
                from = space.from;

            // makes rgba() and hsla()
            color.fn[ spaceName ] = function( value ) {

                // generate a cache for this space if it doesn't exist
                if ( to && !this[ cache ] ) {
                    this[ cache ] = to( this._rgba );
                }
                if ( value === undefined ) {
                    return this[ cache ].slice();
                }

                var ret,
                    type = jQuery.type( value ),
                    arr = ( type === "array" || type === "object" ) ? value : arguments,
                    local = this[ cache ].slice();

                each( props, function( key, prop ) {
                    var val = arr[ type === "object" ? key : prop.idx ];
                    if ( val == null ) {
                        val = local[ prop.idx ];
                    }
                    local[ prop.idx ] = clamp( val, prop );
                });

                if ( from ) {
                    ret = color( from( local ) );
                    ret[ cache ] = local;
                    return ret;
                } else {
                    return color( local );
                }
            };

            // makes red() green() blue() alpha() hue() saturation() lightness()
            each( props, function( key, prop ) {
                // alpha is included in more than one space
                if ( color.fn[ key ] ) {
                    return;
                }
                color.fn[ key ] = function( value ) {
                    var vtype = jQuery.type( value ),
                        fn = ( key === "alpha" ? ( this._hsla ? "hsla" : "rgba" ) : spaceName ),
                        local = this[ fn ](),
                        cur = local[ prop.idx ],
                        match;

                    if ( vtype === "undefined" ) {
                        return cur;
                    }

                    if ( vtype === "function" ) {
                        value = value.call( this, cur );
                        vtype = jQuery.type( value );
                    }
                    if ( value == null && prop.empty ) {
                        return this;
                    }
                    if ( vtype === "string" ) {
                        match = rplusequals.exec( value );
                        if ( match ) {
                            value = cur + parseFloat( match[ 2 ] ) * ( match[ 1 ] === "+" ? 1 : -1 );
                        }
                    }
                    local[ prop.idx ] = value;
                    return this[ fn ]( local );
                };
            });
        });

// add cssHook and .fx.step function for each named hook.
// accept a space separated string of properties
        color.hook = function( hook ) {
            var hooks = hook.split( " " );
            each( hooks, function( i, hook ) {
                jQuery.cssHooks[ hook ] = {
                    set: function( elem, value ) {
                        var parsed, curElem,
                            backgroundColor = "";

                        if ( value !== "transparent" && ( jQuery.type( value ) !== "string" || ( parsed = stringParse( value ) ) ) ) {
                            value = color( parsed || value );
                            if ( !support.rgba && value._rgba[ 3 ] !== 1 ) {
                                curElem = hook === "backgroundColor" ? elem.parentNode : elem;
                                while (
                                (backgroundColor === "" || backgroundColor === "transparent") &&
                                curElem && curElem.style
                                    ) {
                                    try {
                                        backgroundColor = jQuery.css( curElem, "backgroundColor" );
                                        curElem = curElem.parentNode;
                                    } catch ( e ) {
                                    }
                                }

                                value = value.blend( backgroundColor && backgroundColor !== "transparent" ?
                                    backgroundColor :
                                    "_default" );
                            }

                            value = value.toRgbaString();
                        }
                        try {
                            elem.style[ hook ] = value;
                        } catch( e ) {
                            // wrapped to prevent IE from throwing errors on "invalid" values like 'auto' or 'inherit'
                        }
                    }
                };
                jQuery.fx.step[ hook ] = function( fx ) {
                    if ( !fx.colorInit ) {
                        fx.start = color( fx.elem, hook );
                        fx.end = color( fx.end );
                        fx.colorInit = true;
                    }
                    jQuery.cssHooks[ hook ].set( fx.elem, fx.start.transition( fx.end, fx.pos ) );
                };
            });

        };

        color.hook( stepHooks );

        jQuery.cssHooks.borderColor = {
            expand: function( value ) {
                var expanded = {};

                each( [ "Top", "Right", "Bottom", "Left" ], function( i, part ) {
                    expanded[ "border" + part + "Color" ] = value;
                });
                return expanded;
            }
        };

// Basic color names only.
// Usage of any of the other color names requires adding yourself or including
// jquery.color.svg-names.js.
        colors = jQuery.Color.names = {
            // 4.1. Basic color keywords
            aqua: "#00ffff",
            black: "#000000",
            blue: "#0000ff",
            fuchsia: "#ff00ff",
            gray: "#808080",
            green: "#008000",
            lime: "#00ff00",
            maroon: "#800000",
            navy: "#000080",
            olive: "#808000",
            purple: "#800080",
            red: "#ff0000",
            silver: "#c0c0c0",
            teal: "#008080",
            white: "#ffffff",
            yellow: "#ffff00",

            // 4.2.3. "transparent" color keyword
            transparent: [ null, null, null, 0 ],

            _default: "#ffffff"
        };

    })( jQuery );


    /******************************************************************************/
    /****************************** CLASS ANIMATIONS ******************************/
    /******************************************************************************/
    (function() {

        var classAnimationActions = [ "add", "remove", "toggle" ],
            shorthandStyles = {
                border: 1,
                borderBottom: 1,
                borderColor: 1,
                borderLeft: 1,
                borderRight: 1,
                borderTop: 1,
                borderWidth: 1,
                margin: 1,
                padding: 1
            };

        $.each([ "borderLeftStyle", "borderRightStyle", "borderBottomStyle", "borderTopStyle" ], function( _, prop ) {
            $.fx.step[ prop ] = function( fx ) {
                if ( fx.end !== "none" && !fx.setAttr || fx.pos === 1 && !fx.setAttr ) {
                    jQuery.style( fx.elem, prop, fx.end );
                    fx.setAttr = true;
                }
            };
        });

        function getElementStyles( elem ) {
            var key, len,
                style = elem.ownerDocument.defaultView ?
                    elem.ownerDocument.defaultView.getComputedStyle( elem, null ) :
                    elem.currentStyle,
                styles = {};

            if ( style && style.length && style[ 0 ] && style[ style[ 0 ] ] ) {
                len = style.length;
                while ( len-- ) {
                    key = style[ len ];
                    if ( typeof style[ key ] === "string" ) {
                        styles[ $.camelCase( key ) ] = style[ key ];
                    }
                }
                // support: Opera, IE <9
            } else {
                for ( key in style ) {
                    if ( typeof style[ key ] === "string" ) {
                        styles[ key ] = style[ key ];
                    }
                }
            }

            return styles;
        }


        function styleDifference( oldStyle, newStyle ) {
            var diff = {},
                name, value;

            for ( name in newStyle ) {
                value = newStyle[ name ];
                if ( oldStyle[ name ] !== value ) {
                    if ( !shorthandStyles[ name ] ) {
                        if ( $.fx.step[ name ] || !isNaN( parseFloat( value ) ) ) {
                            diff[ name ] = value;
                        }
                    }
                }
            }

            return diff;
        }

// support: jQuery <1.8
        if ( !$.fn.addBack ) {
            $.fn.addBack = function( selector ) {
                return this.add( selector == null ?
                    this.prevObject : this.prevObject.filter( selector )
                );
            };
        }

        $.effects.animateClass = function( value, duration, easing, callback ) {
            var o = $.speed( duration, easing, callback );

            return this.queue( function() {
                var animated = $( this ),
                    baseClass = animated.attr( "class" ) || "",
                    applyClassChange,
                    allAnimations = o.children ? animated.find( "*" ).addBack() : animated;

                // map the animated objects to store the original styles.
                allAnimations = allAnimations.map(function() {
                    var el = $( this );
                    return {
                        el: el,
                        start: getElementStyles( this )
                    };
                });

                // apply class change
                applyClassChange = function() {
                    $.each( classAnimationActions, function(i, action) {
                        if ( value[ action ] ) {
                            animated[ action + "Class" ]( value[ action ] );
                        }
                    });
                };
                applyClassChange();

                // map all animated objects again - calculate new styles and diff
                allAnimations = allAnimations.map(function() {
                    this.end = getElementStyles( this.el[ 0 ] );
                    this.diff = styleDifference( this.start, this.end );
                    return this;
                });

                // apply original class
                animated.attr( "class", baseClass );

                // map all animated objects again - this time collecting a promise
                allAnimations = allAnimations.map(function() {
                    var styleInfo = this,
                        dfd = $.Deferred(),
                        opts = $.extend({}, o, {
                            queue: false,
                            complete: function() {
                                dfd.resolve( styleInfo );
                            }
                        });

                    this.el.animate( this.diff, opts );
                    return dfd.promise();
                });

                // once all animations have completed:
                $.when.apply( $, allAnimations.get() ).done(function() {

                    // set the final class
                    applyClassChange();

                    // for each animated element,
                    // clear all css properties that were animated
                    $.each( arguments, function() {
                        var el = this.el;
                        $.each( this.diff, function(key) {
                            el.css( key, "" );
                        });
                    });

                    // this is guarnteed to be there if you use jQuery.speed()
                    // it also handles dequeuing the next anim...
                    o.complete.call( animated[ 0 ] );
                });
            });
        };

        $.fn.extend({
            addClass: (function( orig ) {
                return function( classNames, speed, easing, callback ) {
                    return speed ?
                        $.effects.animateClass.call( this,
                            { add: classNames }, speed, easing, callback ) :
                        orig.apply( this, arguments );
                };
            })( $.fn.addClass ),

            removeClass: (function( orig ) {
                return function( classNames, speed, easing, callback ) {
                    return arguments.length > 1 ?
                        $.effects.animateClass.call( this,
                            { remove: classNames }, speed, easing, callback ) :
                        orig.apply( this, arguments );
                };
            })( $.fn.removeClass ),

            toggleClass: (function( orig ) {
                return function( classNames, force, speed, easing, callback ) {
                    if ( typeof force === "boolean" || force === undefined ) {
                        if ( !speed ) {
                            // without speed parameter
                            return orig.apply( this, arguments );
                        } else {
                            return $.effects.animateClass.call( this,
                                (force ? { add: classNames } : { remove: classNames }),
                                speed, easing, callback );
                        }
                    } else {
                        // without force parameter
                        return $.effects.animateClass.call( this,
                            { toggle: classNames }, force, speed, easing );
                    }
                };
            })( $.fn.toggleClass ),

            switchClass: function( remove, add, speed, easing, callback) {
                return $.effects.animateClass.call( this, {
                    add: add,
                    remove: remove
                }, speed, easing, callback );
            }
        });

    })();

    /******************************************************************************/
    /*********************************** EFFECTS **********************************/
    /******************************************************************************/

    (function() {

        $.extend( $.effects, {
            version: "1.10.2",

            // Saves a set of properties in a data storage
            save: function( element, set ) {
                for( var i=0; i < set.length; i++ ) {
                    if ( set[ i ] !== null ) {
                        element.data( dataSpace + set[ i ], element[ 0 ].style[ set[ i ] ] );
                    }
                }
            },

            // Restores a set of previously saved properties from a data storage
            restore: function( element, set ) {
                var val, i;
                for( i=0; i < set.length; i++ ) {
                    if ( set[ i ] !== null ) {
                        val = element.data( dataSpace + set[ i ] );
                        // support: jQuery 1.6.2
                        // http://bugs.jquery.com/ticket/9917
                        // jQuery 1.6.2 incorrectly returns undefined for any falsy value.
                        // We can't differentiate between "" and 0 here, so we just assume
                        // empty string since it's likely to be a more common value...
                        if ( val === undefined ) {
                            val = "";
                        }
                        element.css( set[ i ], val );
                    }
                }
            },

            setMode: function( el, mode ) {
                if (mode === "toggle") {
                    mode = el.is( ":hidden" ) ? "show" : "hide";
                }
                return mode;
            },

            // Translates a [top,left] array into a baseline value
            // this should be a little more flexible in the future to handle a string & hash
            getBaseline: function( origin, original ) {
                var y, x;
                switch ( origin[ 0 ] ) {
                    case "top": y = 0; break;
                    case "middle": y = 0.5; break;
                    case "bottom": y = 1; break;
                    default: y = origin[ 0 ] / original.height;
                }
                switch ( origin[ 1 ] ) {
                    case "left": x = 0; break;
                    case "center": x = 0.5; break;
                    case "right": x = 1; break;
                    default: x = origin[ 1 ] / original.width;
                }
                return {
                    x: x,
                    y: y
                };
            },

            // Wraps the element around a wrapper that copies position properties
            createWrapper: function( element ) {

                // if the element is already wrapped, return it
                if ( element.parent().is( ".ui-effects-wrapper" )) {
                    return element.parent();
                }

                // wrap the element
                var props = {
                        width: element.outerWidth(true),
                        height: element.outerHeight(true),
                        "float": element.css( "float" )
                    },
                    wrapper = $( "<div></div>" )
                        .addClass( "ui-effects-wrapper" )
                        .css({
                            fontSize: "100%",
                            background: "transparent",
                            border: "none",
                            margin: 0,
                            padding: 0
                        }),
                    // Store the size in case width/height are defined in % - Fixes #5245
                    size = {
                        width: element.width(),
                        height: element.height()
                    },
                    active = document.activeElement;

                // support: Firefox
                // Firefox incorrectly exposes anonymous content
                // https://bugzilla.mozilla.org/show_bug.cgi?id=561664
                try {
                    active.id;
                } catch( e ) {
                    active = document.body;
                }

                element.wrap( wrapper );

                // Fixes #7595 - Elements lose focus when wrapped.
                if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
                    $( active ).focus();
                }

                wrapper = element.parent(); //Hotfix for jQuery 1.4 since some change in wrap() seems to actually lose the reference to the wrapped element

                // transfer positioning properties to the wrapper
                if ( element.css( "position" ) === "static" ) {
                    wrapper.css({ position: "relative" });
                    element.css({ position: "relative" });
                } else {
                    $.extend( props, {
                        position: element.css( "position" ),
                        zIndex: element.css( "z-index" )
                    });
                    $.each([ "top", "left", "bottom", "right" ], function(i, pos) {
                        props[ pos ] = element.css( pos );
                        if ( isNaN( parseInt( props[ pos ], 10 ) ) ) {
                            props[ pos ] = "auto";
                        }
                    });
                    element.css({
                        position: "relative",
                        top: 0,
                        left: 0,
                        right: "auto",
                        bottom: "auto"
                    });
                }
                element.css(size);

                return wrapper.css( props ).show();
            },

            removeWrapper: function( element ) {
                var active = document.activeElement;

                if ( element.parent().is( ".ui-effects-wrapper" ) ) {
                    element.parent().replaceWith( element );

                    // Fixes #7595 - Elements lose focus when wrapped.
                    if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
                        $( active ).focus();
                    }
                }


                return element;
            },

            setTransition: function( element, list, factor, value ) {
                value = value || {};
                $.each( list, function( i, x ) {
                    var unit = element.cssUnit( x );
                    if ( unit[ 0 ] > 0 ) {
                        value[ x ] = unit[ 0 ] * factor + unit[ 1 ];
                    }
                });
                return value;
            }
        });

// return an effect options object for the given parameters:
        function _normalizeArguments( effect, options, speed, callback ) {

            // allow passing all options as the first parameter
            if ( $.isPlainObject( effect ) ) {
                options = effect;
                effect = effect.effect;
            }

            // convert to an object
            effect = { effect: effect };

            // catch (effect, null, ...)
            if ( options == null ) {
                options = {};
            }

            // catch (effect, callback)
            if ( $.isFunction( options ) ) {
                callback = options;
                speed = null;
                options = {};
            }

            // catch (effect, speed, ?)
            if ( typeof options === "number" || $.fx.speeds[ options ] ) {
                callback = speed;
                speed = options;
                options = {};
            }

            // catch (effect, options, callback)
            if ( $.isFunction( speed ) ) {
                callback = speed;
                speed = null;
            }

            // add options to effect
            if ( options ) {
                $.extend( effect, options );
            }

            speed = speed || options.duration;
            effect.duration = $.fx.off ? 0 :
                typeof speed === "number" ? speed :
                    speed in $.fx.speeds ? $.fx.speeds[ speed ] :
                        $.fx.speeds._default;

            effect.complete = callback || options.complete;

            return effect;
        }

        function standardAnimationOption( option ) {
            // Valid standard speeds (nothing, number, named speed)
            if ( !option || typeof option === "number" || $.fx.speeds[ option ] ) {
                return true;
            }

            // Invalid strings - treat as "normal" speed
            if ( typeof option === "string" && !$.effects.effect[ option ] ) {
                return true;
            }

            // Complete callback
            if ( $.isFunction( option ) ) {
                return true;
            }

            // Options hash (but not naming an effect)
            if ( typeof option === "object" && !option.effect ) {
                return true;
            }

            // Didn't match any standard API
            return false;
        }

        $.fn.extend({
            effect: function( /* effect, options, speed, callback */ ) {
                var args = _normalizeArguments.apply( this, arguments ),
                    mode = args.mode,
                    queue = args.queue,
                    effectMethod = $.effects.effect[ args.effect ];

                if ( $.fx.off || !effectMethod ) {
                    // delegate to the original method (e.g., .show()) if possible
                    if ( mode ) {
                        return this[ mode ]( args.duration, args.complete );
                    } else {
                        return this.each( function() {
                            if ( args.complete ) {
                                args.complete.call( this );
                            }
                        });
                    }
                }

                function run( next ) {
                    var elem = $( this ),
                        complete = args.complete,
                        mode = args.mode;

                    function done() {
                        if ( $.isFunction( complete ) ) {
                            complete.call( elem[0] );
                        }
                        if ( $.isFunction( next ) ) {
                            next();
                        }
                    }

                    // If the element already has the correct final state, delegate to
                    // the core methods so the internal tracking of "olddisplay" works.
                    if ( elem.is( ":hidden" ) ? mode === "hide" : mode === "show" ) {
                        elem[ mode ]();
                        done();
                    } else {
                        effectMethod.call( elem[0], args, done );
                    }
                }

                return queue === false ? this.each( run ) : this.queue( queue || "fx", run );
            },

            show: (function( orig ) {
                return function( option ) {
                    if ( standardAnimationOption( option ) ) {
                        return orig.apply( this, arguments );
                    } else {
                        var args = _normalizeArguments.apply( this, arguments );
                        args.mode = "show";
                        return this.effect.call( this, args );
                    }
                };
            })( $.fn.show ),

            hide: (function( orig ) {
                return function( option ) {
                    if ( standardAnimationOption( option ) ) {
                        return orig.apply( this, arguments );
                    } else {
                        var args = _normalizeArguments.apply( this, arguments );
                        args.mode = "hide";
                        return this.effect.call( this, args );
                    }
                };
            })( $.fn.hide ),

            toggle: (function( orig ) {
                return function( option ) {
                    if ( standardAnimationOption( option ) || typeof option === "boolean" ) {
                        return orig.apply( this, arguments );
                    } else {
                        var args = _normalizeArguments.apply( this, arguments );
                        args.mode = "toggle";
                        return this.effect.call( this, args );
                    }
                };
            })( $.fn.toggle ),

            // helper functions
            cssUnit: function(key) {
                var style = this.css( key ),
                    val = [];

                $.each( [ "em", "px", "%", "pt" ], function( i, unit ) {
                    if ( style.indexOf( unit ) > 0 ) {
                        val = [ parseFloat( style ), unit ];
                    }
                });
                return val;
            }
        });

    })();

    /******************************************************************************/
    /*********************************** EASING ***********************************/
    /******************************************************************************/

    (function() {

// based on easing equations from Robert Penner (http://www.robertpenner.com/easing)

        var baseEasings = {};

        $.each( [ "Quad", "Cubic", "Quart", "Quint", "Expo" ], function( i, name ) {
            baseEasings[ name ] = function( p ) {
                return Math.pow( p, i + 2 );
            };
        });

        $.extend( baseEasings, {
            Sine: function ( p ) {
                return 1 - Math.cos( p * Math.PI / 2 );
            },
            Circ: function ( p ) {
                return 1 - Math.sqrt( 1 - p * p );
            },
            Elastic: function( p ) {
                return p === 0 || p === 1 ? p :
                -Math.pow( 2, 8 * (p - 1) ) * Math.sin( ( (p - 1) * 80 - 7.5 ) * Math.PI / 15 );
            },
            Back: function( p ) {
                return p * p * ( 3 * p - 2 );
            },
            Bounce: function ( p ) {
                var pow2,
                    bounce = 4;

                while ( p < ( ( pow2 = Math.pow( 2, --bounce ) ) - 1 ) / 11 ) {}
                return 1 / Math.pow( 4, 3 - bounce ) - 7.5625 * Math.pow( ( pow2 * 3 - 2 ) / 22 - p, 2 );
            }
        });

        $.each( baseEasings, function( name, easeIn ) {
            $.easing[ "easeIn" + name ] = easeIn;
            $.easing[ "easeOut" + name ] = function( p ) {
                return 1 - easeIn( 1 - p );
            };
            $.easing[ "easeInOut" + name ] = function( p ) {
                return p < 0.5 ?
                easeIn( p * 2 ) / 2 :
                1 - easeIn( p * -2 + 2 ) / 2;
            };
        });

    })();

})(jQuery);

(function( $, undefined ) {

    var uid = 0,
        hideProps = {},
        showProps = {};

    hideProps.height = hideProps.paddingTop = hideProps.paddingBottom =
        hideProps.borderTopWidth = hideProps.borderBottomWidth = "hide";
    showProps.height = showProps.paddingTop = showProps.paddingBottom =
        showProps.borderTopWidth = showProps.borderBottomWidth = "show";

    $.widget( "ui.accordion", {
        version: "1.10.2",
        options: {
            active: 0,
            animate: {},
            collapsible: false,
            event: "click",
            header: "> li > :first-child,> :not(li):even",
            heightStyle: "auto",
            icons: {
                activeHeader: "ui-icon-triangle-1-s",
                header: "ui-icon-triangle-1-e"
            },

            // callbacks
            activate: null,
            beforeActivate: null
        },

        _create: function() {
            var options = this.options;
            this.prevShow = this.prevHide = $();
            this.element.addClass( "ui-accordion ui-widget ui-helper-reset" )
            // ARIA
                .attr( "role", "tablist" );

            // don't allow collapsible: false and active: false / null
            if ( !options.collapsible && (options.active === false || options.active == null) ) {
                options.active = 0;
            }

            this._processPanels();
            // handle negative values
            if ( options.active < 0 ) {
                options.active += this.headers.length;
            }
            this._refresh();
        },

        _getCreateEventData: function() {
            return {
                header: this.active,
                panel: !this.active.length ? $() : this.active.next(),
                content: !this.active.length ? $() : this.active.next()
            };
        },

        _createIcons: function() {
            var icons = this.options.icons;
            if ( icons ) {
                $( "<span>" )
                    .addClass( "ui-accordion-header-icon ui-icon " + icons.header )
                    .prependTo( this.headers );
                this.active.children( ".ui-accordion-header-icon" )
                    .removeClass( icons.header )
                    .addClass( icons.activeHeader );
                this.headers.addClass( "ui-accordion-icons" );
            }
        },

        _destroyIcons: function() {
            this.headers
                .removeClass( "ui-accordion-icons" )
                .children( ".ui-accordion-header-icon" )
                .remove();
        },

        _destroy: function() {
            var contents;

            // clean up main element
            this.element
                .removeClass( "ui-accordion ui-widget ui-helper-reset" )
                .removeAttr( "role" );

            // clean up headers
            this.headers
                .removeClass( "ui-accordion-header ui-accordion-header-active ui-helper-reset ui-state-default ui-corner-all ui-state-active ui-state-disabled ui-corner-top" )
                .removeAttr( "role" )
                .removeAttr( "aria-selected" )
                .removeAttr( "aria-controls" )
                .removeAttr( "tabIndex" )
                .each(function() {
                    if ( /^ui-accordion/.test( this.id ) ) {
                        this.removeAttribute( "id" );
                    }
                });
            this._destroyIcons();

            // clean up content panels
            contents = this.headers.next()
                .css( "display", "" )
                .removeAttr( "role" )
                .removeAttr( "aria-expanded" )
                .removeAttr( "aria-hidden" )
                .removeAttr( "aria-labelledby" )
                .removeClass( "ui-helper-reset ui-widget-content ui-corner-bottom ui-accordion-content ui-accordion-content-active ui-state-disabled" )
                .each(function() {
                    if ( /^ui-accordion/.test( this.id ) ) {
                        this.removeAttribute( "id" );
                    }
                });
            if ( this.options.heightStyle !== "content" ) {
                contents.css( "height", "" );
            }
        },

        _setOption: function( key, value ) {
            if ( key === "active" ) {
                // _activate() will handle invalid values and update this.options
                this._activate( value );
                return;
            }

            if ( key === "event" ) {
                if ( this.options.event ) {
                    this._off( this.headers, this.options.event );
                }
                this._setupEvents( value );
            }

            this._super( key, value );

            // setting collapsible: false while collapsed; open first panel
            if ( key === "collapsible" && !value && this.options.active === false ) {
                this._activate( 0 );
            }

            if ( key === "icons" ) {
                this._destroyIcons();
                if ( value ) {
                    this._createIcons();
                }
            }

            // #5332 - opacity doesn't cascade to positioned elements in IE
            // so we need to add the disabled class to the headers and panels
            if ( key === "disabled" ) {
                this.headers.add( this.headers.next() )
                    .toggleClass( "ui-state-disabled", !!value );
            }
        },

        _keydown: function( event ) {
            /*jshint maxcomplexity:15*/
            if ( event.altKey || event.ctrlKey ) {
                return;
            }

            var keyCode = $.ui.keyCode,
                length = this.headers.length,
                currentIndex = this.headers.index( event.target ),
                toFocus = false;

            switch ( event.keyCode ) {
                case keyCode.RIGHT:
                case keyCode.DOWN:
                    toFocus = this.headers[ ( currentIndex + 1 ) % length ];
                    break;
                case keyCode.LEFT:
                case keyCode.UP:
                    toFocus = this.headers[ ( currentIndex - 1 + length ) % length ];
                    break;
                case keyCode.SPACE:
                case keyCode.ENTER:
                    this._eventHandler( event );
                    break;
                case keyCode.HOME:
                    toFocus = this.headers[ 0 ];
                    break;
                case keyCode.END:
                    toFocus = this.headers[ length - 1 ];
                    break;
            }

            if ( toFocus ) {
                $( event.target ).attr( "tabIndex", -1 );
                $( toFocus ).attr( "tabIndex", 0 );
                toFocus.focus();
                event.preventDefault();
            }
        },

        _panelKeyDown : function( event ) {
            if ( event.keyCode === $.ui.keyCode.UP && event.ctrlKey ) {
                $( event.currentTarget ).prev().focus();
            }
        },

        refresh: function() {
            var options = this.options;
            this._processPanels();

            // was collapsed or no panel
            if ( ( options.active === false && options.collapsible === true ) || !this.headers.length ) {
                options.active = false;
                this.active = $();
                // active false only when collapsible is true
            } if ( options.active === false ) {
                this._activate( 0 );
                // was active, but active panel is gone
            } else if ( this.active.length && !$.contains( this.element[ 0 ], this.active[ 0 ] ) ) {
                // all remaining panel are disabled
                if ( this.headers.length === this.headers.find(".ui-state-disabled").length ) {
                    options.active = false;
                    this.active = $();
                    // activate previous panel
                } else {
                    this._activate( Math.max( 0, options.active - 1 ) );
                }
                // was active, active panel still exists
            } else {
                // make sure active index is correct
                options.active = this.headers.index( this.active );
            }

            this._destroyIcons();

            this._refresh();
        },

        _processPanels: function() {
            this.headers = this.element.find( this.options.header )
                .addClass( "ui-accordion-header ui-helper-reset ui-state-default ui-corner-all" );

            this.headers.next()
                .addClass( "ui-accordion-content ui-helper-reset ui-widget-content ui-corner-bottom" )
                .filter(":not(.ui-accordion-content-active)")
                .hide();
        },

        _refresh: function() {
            var maxHeight,
                options = this.options,
                heightStyle = options.heightStyle,
                parent = this.element.parent(),
                accordionId = this.accordionId = "ui-accordion-" +
                    (this.element.attr( "id" ) || ++uid);

            this.active = this._findActive( options.active )
                .addClass( "ui-accordion-header-active ui-state-active ui-corner-top" )
                .removeClass( "ui-corner-all" );
            this.active.next()
                .addClass( "ui-accordion-content-active" )
                .show();

            this.headers
                .attr( "role", "tab" )
                .each(function( i ) {
                    var header = $( this ),
                        headerId = header.attr( "id" ),
                        panel = header.next(),
                        panelId = panel.attr( "id" );
                    if ( !headerId ) {
                        headerId = accordionId + "-header-" + i;
                        header.attr( "id", headerId );
                    }
                    if ( !panelId ) {
                        panelId = accordionId + "-panel-" + i;
                        panel.attr( "id", panelId );
                    }
                    header.attr( "aria-controls", panelId );
                    panel.attr( "aria-labelledby", headerId );
                })
                .next()
                .attr( "role", "tabpanel" );

            this.headers
                .not( this.active )
                .attr({
                    "aria-selected": "false",
                    tabIndex: -1
                })
                .next()
                .attr({
                    "aria-expanded": "false",
                    "aria-hidden": "true"
                })
                .hide();

            // make sure at least one header is in the tab order
            if ( !this.active.length ) {
                this.headers.eq( 0 ).attr( "tabIndex", 0 );
            } else {
                this.active.attr({
                    "aria-selected": "true",
                    tabIndex: 0
                })
                    .next()
                    .attr({
                        "aria-expanded": "true",
                        "aria-hidden": "false"
                    });
            }

            this._createIcons();

            this._setupEvents( options.event );

            if ( heightStyle === "fill" ) {
                maxHeight = parent.height();
                this.element.siblings( ":visible" ).each(function() {
                    var elem = $( this ),
                        position = elem.css( "position" );

                    if ( position === "absolute" || position === "fixed" ) {
                        return;
                    }
                    maxHeight -= elem.outerHeight( true );
                });

                this.headers.each(function() {
                    maxHeight -= $( this ).outerHeight( true );
                });

                this.headers.next()
                    .each(function() {
                        $( this ).height( Math.max( 0, maxHeight -
                            $( this ).innerHeight() + $( this ).height() ) );
                    })
                    .css( "overflow", "auto" );
            } else if ( heightStyle === "auto" ) {
                maxHeight = 0;
                this.headers.next()
                    .each(function() {
                        maxHeight = Math.max( maxHeight, $( this ).css( "height", "" ).height() );
                    })
                    .height( maxHeight );
            }
        },

        _activate: function( index ) {
            var active = this._findActive( index )[ 0 ];

            // trying to activate the already active panel
            if ( active === this.active[ 0 ] ) {
                return;
            }

            // trying to collapse, simulate a click on the currently active header
            active = active || this.active[ 0 ];

            this._eventHandler({
                target: active,
                currentTarget: active,
                preventDefault: $.noop
            });
        },

        _findActive: function( selector ) {
            return typeof selector === "number" ? this.headers.eq( selector ) : $();
        },

        _setupEvents: function( event ) {
            var events = {
                keydown: "_keydown"
            };
            if ( event ) {
                $.each( event.split(" "), function( index, eventName ) {
                    events[ eventName ] = "_eventHandler";
                });
            }

            this._off( this.headers.add( this.headers.next() ) );
            this._on( this.headers, events );
            this._on( this.headers.next(), { keydown: "_panelKeyDown" });
            this._hoverable( this.headers );
            this._focusable( this.headers );
        },

        _eventHandler: function( event ) {
            var options = this.options,
                active = this.active,
                clicked = $( event.currentTarget ),
                clickedIsActive = clicked[ 0 ] === active[ 0 ],
                collapsing = clickedIsActive && options.collapsible,
                toShow = collapsing ? $() : clicked.next(),
                toHide = active.next(),
                eventData = {
                    oldHeader: active,
                    oldPanel: toHide,
                    newHeader: collapsing ? $() : clicked,
                    newPanel: toShow
                };

            event.preventDefault();

            if (
                // click on active header, but not collapsible
            ( clickedIsActive && !options.collapsible ) ||
            // allow canceling activation
            ( this._trigger( "beforeActivate", event, eventData ) === false ) ) {
                return;
            }

            options.active = collapsing ? false : this.headers.index( clicked );

            // when the call to ._toggle() comes after the class changes
            // it causes a very odd bug in IE 8 (see #6720)
            this.active = clickedIsActive ? $() : clicked;
            this._toggle( eventData );

            // switch classes
            // corner classes on the previously active header stay after the animation
            active.removeClass( "ui-accordion-header-active ui-state-active" );
            if ( options.icons ) {
                active.children( ".ui-accordion-header-icon" )
                    .removeClass( options.icons.activeHeader )
                    .addClass( options.icons.header );
            }

            if ( !clickedIsActive ) {
                clicked
                    .removeClass( "ui-corner-all" )
                    .addClass( "ui-accordion-header-active ui-state-active ui-corner-top" );
                if ( options.icons ) {
                    clicked.children( ".ui-accordion-header-icon" )
                        .removeClass( options.icons.header )
                        .addClass( options.icons.activeHeader );
                }

                clicked
                    .next()
                    .addClass( "ui-accordion-content-active" );
            }
        },

        _toggle: function( data ) {
            var toShow = data.newPanel,
                toHide = this.prevShow.length ? this.prevShow : data.oldPanel;

            // handle activating a panel during the animation for another activation
            this.prevShow.add( this.prevHide ).stop( true, true );
            this.prevShow = toShow;
            this.prevHide = toHide;

            if ( this.options.animate ) {
                this._animate( toShow, toHide, data );
            } else {
                toHide.hide();
                toShow.show();
                this._toggleComplete( data );
            }

            toHide.attr({
                "aria-expanded": "false",
                "aria-hidden": "true"
            });
            toHide.prev().attr( "aria-selected", "false" );
            // if we're switching panels, remove the old header from the tab order
            // if we're opening from collapsed state, remove the previous header from the tab order
            // if we're collapsing, then keep the collapsing header in the tab order
            if ( toShow.length && toHide.length ) {
                toHide.prev().attr( "tabIndex", -1 );
            } else if ( toShow.length ) {
                this.headers.filter(function() {
                    return $( this ).attr( "tabIndex" ) === 0;
                })
                    .attr( "tabIndex", -1 );
            }

            toShow
                .attr({
                    "aria-expanded": "true",
                    "aria-hidden": "false"
                })
                .prev()
                .attr({
                    "aria-selected": "true",
                    tabIndex: 0
                });
        },

        _animate: function( toShow, toHide, data ) {
            var total, easing, duration,
                that = this,
                adjust = 0,
                down = toShow.length &&
                    ( !toHide.length || ( toShow.index() < toHide.index() ) ),
                animate = this.options.animate || {},
                options = down && animate.down || animate,
                complete = function() {
                    that._toggleComplete( data );
                };

            if ( typeof options === "number" ) {
                duration = options;
            }
            if ( typeof options === "string" ) {
                easing = options;
            }
            // fall back from options to animation in case of partial down settings
            easing = easing || options.easing || animate.easing;
            duration = duration || options.duration || animate.duration;

            if ( !toHide.length ) {
                return toShow.animate( showProps, duration, easing, complete );
            }
            if ( !toShow.length ) {
                return toHide.animate( hideProps, duration, easing, complete );
            }

            total = toShow.show().outerHeight();
            toHide.animate( hideProps, {
                duration: duration,
                easing: easing,
                step: function( now, fx ) {
                    fx.now = Math.round( now );
                }
            });
            toShow
                .hide()
                .animate( showProps, {
                    duration: duration,
                    easing: easing,
                    complete: complete,
                    step: function( now, fx ) {
                        fx.now = Math.round( now );
                        if ( fx.prop !== "height" ) {
                            adjust += fx.now;
                        } else if ( that.options.heightStyle !== "content" ) {
                            fx.now = Math.round( total - toHide.outerHeight() - adjust );
                            adjust = 0;
                        }
                    }
                });
        },

        _toggleComplete: function( data ) {
            var toHide = data.oldPanel;

            toHide
                .removeClass( "ui-accordion-content-active" )
                .prev()
                .removeClass( "ui-corner-top" )
                .addClass( "ui-corner-all" );

            // Work around for rendering bug in IE (#5421)
            if ( toHide.length ) {
                toHide.parent()[0].className = toHide.parent()[0].className;
            }

            this._trigger( "activate", null, data );
        }
    });

})( jQuery );

(function( $, undefined ) {

// used to prevent race conditions with remote data sources
    var requestIndex = 0;

    $.widget( "ui.autocomplete", {
        version: "1.10.2",
        defaultElement: "<input>",
        options: {
            appendTo: null,
            autoFocus: false,
            delay: 300,
            minLength: 1,
            position: {
                my: "left top",
                at: "left bottom",
                collision: "none"
            },
            source: null,

            // callbacks
            change: null,
            close: null,
            focus: null,
            open: null,
            response: null,
            search: null,
            select: null
        },

        pending: 0,

        _create: function() {
            // Some browsers only repeat keydown events, not keypress events,
            // so we use the suppressKeyPress flag to determine if we've already
            // handled the keydown event. #7269
            // Unfortunately the code for & in keypress is the same as the up arrow,
            // so we use the suppressKeyPressRepeat flag to avoid handling keypress
            // events when we know the keydown event was used to modify the
            // search term. #7799
            var suppressKeyPress, suppressKeyPressRepeat, suppressInput,
                nodeName = this.element[0].nodeName.toLowerCase(),
                isTextarea = nodeName === "textarea",
                isInput = nodeName === "input";

            this.isMultiLine =
                // Textareas are always multi-line
                isTextarea ? true :
                    // Inputs are always single-line, even if inside a contentEditable element
                    // IE also treats inputs as contentEditable
                    isInput ? false :
                        // All other element types are determined by whether or not they're contentEditable
                        this.element.prop( "isContentEditable" );

            this.valueMethod = this.element[ isTextarea || isInput ? "val" : "text" ];
            this.isNewMenu = true;

            this.element
                .addClass( "ui-autocomplete-input" )
                .attr( "autocomplete", "off" );

            this._on( this.element, {
                keydown: function( event ) {
                    /*jshint maxcomplexity:15*/
                    if ( this.element.prop( "readOnly" ) ) {
                        suppressKeyPress = true;
                        suppressInput = true;
                        suppressKeyPressRepeat = true;
                        return;
                    }

                    suppressKeyPress = false;
                    suppressInput = false;
                    suppressKeyPressRepeat = false;
                    var keyCode = $.ui.keyCode;
                    switch( event.keyCode ) {
                        case keyCode.PAGE_UP:
                            suppressKeyPress = true;
                            this._move( "previousPage", event );
                            break;
                        case keyCode.PAGE_DOWN:
                            suppressKeyPress = true;
                            this._move( "nextPage", event );
                            break;
                        case keyCode.UP:
                            suppressKeyPress = true;
                            this._keyEvent( "previous", event );
                            break;
                        case keyCode.DOWN:
                            suppressKeyPress = true;
                            this._keyEvent( "next", event );
                            break;
                        case keyCode.ENTER:
                        case keyCode.NUMPAD_ENTER:
                            // when menu is open and has focus
                            if ( this.menu.active ) {
                                // #6055 - Opera still allows the keypress to occur
                                // which causes forms to submit
                                suppressKeyPress = true;
                                event.preventDefault();
                                this.menu.select( event );
                            }
                            break;
                        case keyCode.TAB:
                            if ( this.menu.active ) {
                                this.menu.select( event );
                            }
                            break;
                        case keyCode.ESCAPE:
                            if ( this.menu.element.is( ":visible" ) ) {
                                this._value( this.term );
                                this.close( event );
                                // Different browsers have different default behavior for escape
                                // Single press can mean undo or clear
                                // Double press in IE means clear the whole form
                                event.preventDefault();
                            }
                            break;
                        default:
                            suppressKeyPressRepeat = true;
                            // search timeout should be triggered before the input value is changed
                            this._searchTimeout( event );
                            break;
                    }
                },
                keypress: function( event ) {
                    if ( suppressKeyPress ) {
                        suppressKeyPress = false;
                        event.preventDefault();
                        return;
                    }
                    if ( suppressKeyPressRepeat ) {
                        return;
                    }

                    // replicate some key handlers to allow them to repeat in Firefox and Opera
                    var keyCode = $.ui.keyCode;
                    switch( event.keyCode ) {
                        case keyCode.PAGE_UP:
                            this._move( "previousPage", event );
                            break;
                        case keyCode.PAGE_DOWN:
                            this._move( "nextPage", event );
                            break;
                        case keyCode.UP:
                            this._keyEvent( "previous", event );
                            break;
                        case keyCode.DOWN:
                            this._keyEvent( "next", event );
                            break;
                    }
                },
                input: function( event ) {
                    if ( suppressInput ) {
                        suppressInput = false;
                        event.preventDefault();
                        return;
                    }
                    this._searchTimeout( event );
                },
                focus: function() {
                    this.selectedItem = null;
                    this.previous = this._value();
                },
                blur: function( event ) {
                    if ( this.cancelBlur ) {
                        delete this.cancelBlur;
                        return;
                    }

                    clearTimeout( this.searching );
                    this.close( event );
                    this._change( event );
                }
            });

            this._initSource();
            this.menu = $( "<ul>" )
                .addClass( "ui-autocomplete ui-front" )
                .appendTo( this._appendTo() )
                .menu({
                    // custom key handling for now
                    input: $(),
                    // disable ARIA support, the live region takes care of that
                    role: null
                })
                .hide()
                .data( "ui-menu" );

            this._on( this.menu.element, {
                mousedown: function( event ) {
                    // prevent moving focus out of the text field
                    event.preventDefault();

                    // IE doesn't prevent moving focus even with event.preventDefault()
                    // so we set a flag to know when we should ignore the blur event
                    this.cancelBlur = true;
                    this._delay(function() {
                        delete this.cancelBlur;
                    });

                    // clicking on the scrollbar causes focus to shift to the body
                    // but we can't detect a mouseup or a click immediately afterward
                    // so we have to track the next mousedown and close the menu if
                    // the user clicks somewhere outside of the autocomplete
                    var menuElement = this.menu.element[ 0 ];
                    if ( !$( event.target ).closest( ".ui-menu-item" ).length ) {
                        this._delay(function() {
                            var that = this;
                            this.document.one( "mousedown", function( event ) {
                                if ( event.target !== that.element[ 0 ] &&
                                    event.target !== menuElement &&
                                    !$.contains( menuElement, event.target ) ) {
                                    that.close();
                                }
                            });
                        });
                    }
                },
                menufocus: function( event, ui ) {
                    // support: Firefox
                    // Prevent accidental activation of menu items in Firefox (#7024 #9118)
                    if ( this.isNewMenu ) {
                        this.isNewMenu = false;
                        if ( event.originalEvent && /^mouse/.test( event.originalEvent.type ) ) {
                            this.menu.blur();

                            this.document.one( "mousemove", function() {
                                $( event.target ).trigger( event.originalEvent );
                            });

                            return;
                        }
                    }

                    var item = ui.item.data( "ui-autocomplete-item" );
                    if ( false !== this._trigger( "focus", event, { item: item } ) ) {
                        // use value to match what will end up in the input, if it was a key event
                        if ( event.originalEvent && /^key/.test( event.originalEvent.type ) ) {
                            this._value( item.value );
                        }
                    } else {
                        // Normally the input is populated with the item's value as the
                        // menu is navigated, causing screen readers to notice a change and
                        // announce the item. Since the focus event was canceled, this doesn't
                        // happen, so we update the live region so that screen readers can
                        // still notice the change and announce it.
                        this.liveRegion.text( item.value );
                    }
                },
                menuselect: function( event, ui ) {
                    var item = ui.item.data( "ui-autocomplete-item" ),
                        previous = this.previous;

                    // only trigger when focus was lost (click on menu)
                    if ( this.element[0] !== this.document[0].activeElement ) {
                        this.element.focus();
                        this.previous = previous;
                        // #6109 - IE triggers two focus events and the second
                        // is asynchronous, so we need to reset the previous
                        // term synchronously and asynchronously :-(
                        this._delay(function() {
                            this.previous = previous;
                            this.selectedItem = item;
                        });
                    }

                    if ( false !== this._trigger( "select", event, { item: item } ) ) {
                        this._value( item.value );
                    }
                    // reset the term after the select event
                    // this allows custom select handling to work properly
                    this.term = this._value();

                    this.close( event );
                    this.selectedItem = item;
                }
            });

            this.liveRegion = $( "<span>", {
                role: "status",
                "aria-live": "polite"
            })
                .addClass( "ui-helper-hidden-accessible" )
                .insertAfter( this.element );

            // turning off autocomplete prevents the browser from remembering the
            // value when navigating through history, so we re-enable autocomplete
            // if the page is unloaded before the widget is destroyed. #7790
            this._on( this.window, {
                beforeunload: function() {
                    this.element.removeAttr( "autocomplete" );
                }
            });
        },

        _destroy: function() {
            clearTimeout( this.searching );
            this.element
                .removeClass( "ui-autocomplete-input" )
                .removeAttr( "autocomplete" );
            this.menu.element.remove();
            this.liveRegion.remove();
        },

        _setOption: function( key, value ) {
            this._super( key, value );
            if ( key === "source" ) {
                this._initSource();
            }
            if ( key === "appendTo" ) {
                this.menu.element.appendTo( this._appendTo() );
            }
            if ( key === "disabled" && value && this.xhr ) {
                this.xhr.abort();
            }
        },

        _appendTo: function() {
            var element = this.options.appendTo;

            if ( element ) {
                element = element.jquery || element.nodeType ?
                    $( element ) :
                    this.document.find( element ).eq( 0 );
            }

            if ( !element ) {
                element = this.element.closest( ".ui-front" );
            }

            if ( !element.length ) {
                element = this.document[0].body;
            }

            return element;
        },

        _initSource: function() {
            var array, url,
                that = this;
            if ( $.isArray(this.options.source) ) {
                array = this.options.source;
                this.source = function( request, response ) {
                    response( $.ui.autocomplete.filter( array, request.term ) );
                };
            } else if ( typeof this.options.source === "string" ) {
                url = this.options.source;
                this.source = function( request, response ) {
                    if ( that.xhr ) {
                        that.xhr.abort();
                    }
                    that.xhr = $.ajax({
                        url: url,
                        data: request,
                        dataType: "json",
                        success: function( data ) {
                            response( data );
                        },
                        error: function() {
                            response( [] );
                        }
                    });
                };
            } else {
                this.source = this.options.source;
            }
        },

        _searchTimeout: function( event ) {
            clearTimeout( this.searching );
            this.searching = this._delay(function() {
                // only search if the value has changed
                if ( this.term !== this._value() ) {
                    this.selectedItem = null;
                    this.search( null, event );
                }
            }, this.options.delay );
        },

        search: function( value, event ) {
            value = value != null ? value : this._value();

            // always save the actual value, not the one passed as an argument
            this.term = this._value();

            if ( value.length < this.options.minLength ) {
                return this.close( event );
            }

            if ( this._trigger( "search", event ) === false ) {
                return;
            }

            return this._search( value );
        },

        _search: function( value ) {
            this.pending++;
            this.element.addClass( "ui-autocomplete-loading" );
            this.cancelSearch = false;

            this.source( { term: value }, this._response() );
        },

        _response: function() {
            var that = this,
                index = ++requestIndex;

            return function( content ) {
                if ( index === requestIndex ) {
                    that.__response( content );
                }

                that.pending--;
                if ( !that.pending ) {
                    that.element.removeClass( "ui-autocomplete-loading" );
                }
            };
        },

        __response: function( content ) {
            if ( content ) {
                content = this._normalize( content );
            }
            this._trigger( "response", null, { content: content } );
            if ( !this.options.disabled && content && content.length && !this.cancelSearch ) {
                this._suggest( content );
                this._trigger( "open" );
            } else {
                // use ._close() instead of .close() so we don't cancel future searches
                this._close();
            }
        },

        close: function( event ) {
            this.cancelSearch = true;
            this._close( event );
        },

        _close: function( event ) {
            if ( this.menu.element.is( ":visible" ) ) {
                this.menu.element.hide();
                this.menu.blur();
                this.isNewMenu = true;
                this._trigger( "close", event );
            }
        },

        _change: function( event ) {
            if ( this.previous !== this._value() ) {
                this._trigger( "change", event, { item: this.selectedItem } );
            }
        },

        _normalize: function( items ) {
            // assume all items have the right format when the first item is complete
            if ( items.length && items[0].label && items[0].value ) {
                return items;
            }
            return $.map( items, function( item ) {
                if ( typeof item === "string" ) {
                    return {
                        label: item,
                        value: item
                    };
                }
                return $.extend({
                    label: item.label || item.value,
                    value: item.value || item.label
                }, item );
            });
        },

        _suggest: function( items ) {
            var ul = this.menu.element.empty();
            this._renderMenu( ul, items );
            this.isNewMenu = true;
            this.menu.refresh();

            // size and position menu
            ul.show();
            this._resizeMenu();
            ul.position( $.extend({
                of: this.element
            }, this.options.position ));

            if ( this.options.autoFocus ) {
                this.menu.next();
            }
        },

        _resizeMenu: function() {
            var ul = this.menu.element;
            ul.outerWidth( Math.max(
                // Firefox wraps long text (possibly a rounding bug)
                // so we add 1px to avoid the wrapping (#7513)
                ul.width( "" ).outerWidth() + 1,
                this.element.outerWidth()
            ) );
        },

        _renderMenu: function( ul, items ) {
            var that = this;
            $.each( items, function( index, item ) {
                that._renderItemData( ul, item );
            });
        },

        _renderItemData: function( ul, item ) {
            return this._renderItem( ul, item ).data( "ui-autocomplete-item", item );
        },

        _renderItem: function( ul, item ) {
            return $( "<li>" )
                .append( $( "<a>" ).text( item.label ) )
                .appendTo( ul );
        },

        _move: function( direction, event ) {
            if ( !this.menu.element.is( ":visible" ) ) {
                this.search( null, event );
                return;
            }
            if ( this.menu.isFirstItem() && /^previous/.test( direction ) ||
                this.menu.isLastItem() && /^next/.test( direction ) ) {
                this._value( this.term );
                this.menu.blur();
                return;
            }
            this.menu[ direction ]( event );
        },

        widget: function() {
            return this.menu.element;
        },

        _value: function() {
            return this.valueMethod.apply( this.element, arguments );
        },

        _keyEvent: function( keyEvent, event ) {
            if ( !this.isMultiLine || this.menu.element.is( ":visible" ) ) {
                this._move( keyEvent, event );

                // prevents moving cursor to beginning/end of the text field in some browsers
                event.preventDefault();
            }
        }
    });

    $.extend( $.ui.autocomplete, {
        escapeRegex: function( value ) {
            return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
        },
        filter: function(array, term) {
            var matcher = new RegExp( $.ui.autocomplete.escapeRegex(term), "i" );
            return $.grep( array, function(value) {
                return matcher.test( value.label || value.value || value );
            });
        }
    });


// live region extension, adding a `messages` option
// NOTE: This is an experimental API. We are still investigating
// a full solution for string manipulation and internationalization.
    $.widget( "ui.autocomplete", $.ui.autocomplete, {
        options: {
            messages: {
                noResults: "No search results.",
                results: function( amount ) {
                    return amount + ( amount > 1 ? " results are" : " result is" ) +
                        " available, use up and down arrow keys to navigate.";
                }
            }
        },

        __response: function( content ) {
            var message;
            this._superApply( arguments );
            if ( this.options.disabled || this.cancelSearch ) {
                return;
            }
            if ( content && content.length ) {
                message = this.options.messages.results( content.length );
            } else {
                message = this.options.messages.noResults;
            }
            this.liveRegion.text( message );
        }
    });

}( jQuery ));

(function( $, undefined ) {

    var lastActive, startXPos, startYPos, clickDragged,
        baseClasses = "ui-button ui-widget ui-state-default ui-corner-all",
        stateClasses = "ui-state-hover ui-state-active ",
        typeClasses = "ui-button-icons-only ui-button-icon-only ui-button-text-icons ui-button-text-icon-primary ui-button-text-icon-secondary ui-button-text-only",
        formResetHandler = function() {
            var buttons = $( this ).find( ":ui-button" );
            setTimeout(function() {
                buttons.button( "refresh" );
            }, 1 );
        },
        radioGroup = function( radio ) {
            var name = radio.name,
                form = radio.form,
                radios = $( [] );
            if ( name ) {
                name = name.replace( /'/g, "\\'" );
                if ( form ) {
                    radios = $( form ).find( "[name='" + name + "']" );
                } else {
                    radios = $( "[name='" + name + "']", radio.ownerDocument )
                        .filter(function() {
                            return !this.form;
                        });
                }
            }
            return radios;
        };

    $.widget( "ui.button", {
        version: "1.10.2",
        defaultElement: "<button>",
        options: {
            disabled: null,
            text: true,
            label: null,
            icons: {
                primary: null,
                secondary: null
            }
        },
        _create: function() {
            this.element.closest( "form" )
                .unbind( "reset" + this.eventNamespace )
                .bind( "reset" + this.eventNamespace, formResetHandler );

            if ( typeof this.options.disabled !== "boolean" ) {
                this.options.disabled = !!this.element.prop( "disabled" );
            } else {
                this.element.prop( "disabled", this.options.disabled );
            }

            this._determineButtonType();
            this.hasTitle = !!this.buttonElement.attr( "title" );

            var that = this,
                options = this.options,
                toggleButton = this.type === "checkbox" || this.type === "radio",
                activeClass = !toggleButton ? "ui-state-active" : "",
                focusClass = "ui-state-focus";

            if ( options.label === null ) {
                options.label = (this.type === "input" ? this.buttonElement.val() : this.buttonElement.html());
            }

            this._hoverable( this.buttonElement );

            this.buttonElement
                .addClass( baseClasses )
                .attr( "role", "button" )
                .bind( "mouseenter" + this.eventNamespace, function() {
                    if ( options.disabled ) {
                        return;
                    }
                    if ( this === lastActive ) {
                        $( this ).addClass( "ui-state-active" );
                    }
                })
                .bind( "mouseleave" + this.eventNamespace, function() {
                    if ( options.disabled ) {
                        return;
                    }
                    $( this ).removeClass( activeClass );
                })
                .bind( "click" + this.eventNamespace, function( event ) {
                    if ( options.disabled ) {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                    }
                });

            this.element
                .bind( "focus" + this.eventNamespace, function() {
                    // no need to check disabled, focus won't be triggered anyway
                    that.buttonElement.addClass( focusClass );
                })
                .bind( "blur" + this.eventNamespace, function() {
                    that.buttonElement.removeClass( focusClass );
                });

            if ( toggleButton ) {
                this.element.bind( "change" + this.eventNamespace, function() {
                    if ( clickDragged ) {
                        return;
                    }
                    that.refresh();
                });
                // if mouse moves between mousedown and mouseup (drag) set clickDragged flag
                // prevents issue where button state changes but checkbox/radio checked state
                // does not in Firefox (see ticket #6970)
                this.buttonElement
                    .bind( "mousedown" + this.eventNamespace, function( event ) {
                        if ( options.disabled ) {
                            return;
                        }
                        clickDragged = false;
                        startXPos = event.pageX;
                        startYPos = event.pageY;
                    })
                    .bind( "mouseup" + this.eventNamespace, function( event ) {
                        if ( options.disabled ) {
                            return;
                        }
                        if ( startXPos !== event.pageX || startYPos !== event.pageY ) {
                            clickDragged = true;
                        }
                    });
            }

            if ( this.type === "checkbox" ) {
                this.buttonElement.bind( "click" + this.eventNamespace, function() {
                    if ( options.disabled || clickDragged ) {
                        return false;
                    }
                });
            } else if ( this.type === "radio" ) {
                this.buttonElement.bind( "click" + this.eventNamespace, function() {
                    if ( options.disabled || clickDragged ) {
                        return false;
                    }
                    $( this ).addClass( "ui-state-active" );
                    that.buttonElement.attr( "aria-pressed", "true" );

                    var radio = that.element[ 0 ];
                    radioGroup( radio )
                        .not( radio )
                        .map(function() {
                            return $( this ).button( "widget" )[ 0 ];
                        })
                        .removeClass( "ui-state-active" )
                        .attr( "aria-pressed", "false" );
                });
            } else {
                this.buttonElement
                    .bind( "mousedown" + this.eventNamespace, function() {
                        if ( options.disabled ) {
                            return false;
                        }
                        $( this ).addClass( "ui-state-active" );
                        lastActive = this;
                        that.document.one( "mouseup", function() {
                            lastActive = null;
                        });
                    })
                    .bind( "mouseup" + this.eventNamespace, function() {
                        if ( options.disabled ) {
                            return false;
                        }
                        $( this ).removeClass( "ui-state-active" );
                    })
                    .bind( "keydown" + this.eventNamespace, function(event) {
                        if ( options.disabled ) {
                            return false;
                        }
                        if ( event.keyCode === $.ui.keyCode.SPACE || event.keyCode === $.ui.keyCode.ENTER ) {
                            $( this ).addClass( "ui-state-active" );
                        }
                    })
                    // see #8559, we bind to blur here in case the button element loses
                    // focus between keydown and keyup, it would be left in an "active" state
                    .bind( "keyup" + this.eventNamespace + " blur" + this.eventNamespace, function() {
                        $( this ).removeClass( "ui-state-active" );
                    });

                if ( this.buttonElement.is("a") ) {
                    this.buttonElement.keyup(function(event) {
                        if ( event.keyCode === $.ui.keyCode.SPACE ) {
                            // TODO pass through original event correctly (just as 2nd argument doesn't work)
                            $( this ).click();
                        }
                    });
                }
            }

            // TODO: pull out $.Widget's handling for the disabled option into
            // $.Widget.prototype._setOptionDisabled so it's easy to proxy and can
            // be overridden by individual plugins
            this._setOption( "disabled", options.disabled );
            this._resetButton();
        },

        _determineButtonType: function() {
            var ancestor, labelSelector, checked;

            if ( this.element.is("[type=checkbox]") ) {
                this.type = "checkbox";
            } else if ( this.element.is("[type=radio]") ) {
                this.type = "radio";
            } else if ( this.element.is("input") ) {
                this.type = "input";
            } else {
                this.type = "button";
            }

            if ( this.type === "checkbox" || this.type === "radio" ) {
                // we don't search against the document in case the element
                // is disconnected from the DOM
                ancestor = this.element.parents().last();
                labelSelector = "label[for='" + this.element.attr("id") + "']";
                this.buttonElement = ancestor.find( labelSelector );
                if ( !this.buttonElement.length ) {
                    ancestor = ancestor.length ? ancestor.siblings() : this.element.siblings();
                    this.buttonElement = ancestor.filter( labelSelector );
                    if ( !this.buttonElement.length ) {
                        this.buttonElement = ancestor.find( labelSelector );
                    }
                }
                this.element.addClass( "ui-helper-hidden-accessible" );

                checked = this.element.is( ":checked" );
                if ( checked ) {
                    this.buttonElement.addClass( "ui-state-active" );
                }
                this.buttonElement.prop( "aria-pressed", checked );
            } else {
                this.buttonElement = this.element;
            }
        },

        widget: function() {
            return this.buttonElement;
        },

        _destroy: function() {
            this.element
                .removeClass( "ui-helper-hidden-accessible" );
            this.buttonElement
                .removeClass( baseClasses + " " + stateClasses + " " + typeClasses )
                .removeAttr( "role" )
                .removeAttr( "aria-pressed" )
                .html( this.buttonElement.find(".ui-button-text").html() );

            if ( !this.hasTitle ) {
                this.buttonElement.removeAttr( "title" );
            }
        },

        _setOption: function( key, value ) {
            this._super( key, value );
            if ( key === "disabled" ) {
                if ( value ) {
                    this.element.prop( "disabled", true );
                } else {
                    this.element.prop( "disabled", false );
                }
                return;
            }
            this._resetButton();
        },

        refresh: function() {
            //See #8237 & #8828
            var isDisabled = this.element.is( "input, button" ) ? this.element.is( ":disabled" ) : this.element.hasClass( "ui-button-disabled" );

            if ( isDisabled !== this.options.disabled ) {
                this._setOption( "disabled", isDisabled );
            }
            if ( this.type === "radio" ) {
                radioGroup( this.element[0] ).each(function() {
                    if ( $( this ).is( ":checked" ) ) {
                        $( this ).button( "widget" )
                            .addClass( "ui-state-active" )
                            .attr( "aria-pressed", "true" );
                    } else {
                        $( this ).button( "widget" )
                            .removeClass( "ui-state-active" )
                            .attr( "aria-pressed", "false" );
                    }
                });
            } else if ( this.type === "checkbox" ) {
                if ( this.element.is( ":checked" ) ) {
                    this.buttonElement
                        .addClass( "ui-state-active" )
                        .attr( "aria-pressed", "true" );
                } else {
                    this.buttonElement
                        .removeClass( "ui-state-active" )
                        .attr( "aria-pressed", "false" );
                }
            }
        },

        _resetButton: function() {
            if ( this.type === "input" ) {
                if ( this.options.label ) {
                    this.element.val( this.options.label );
                }
                return;
            }
            var buttonElement = this.buttonElement.removeClass( typeClasses ),
                buttonText = $( "<span></span>", this.document[0] )
                    .addClass( "ui-button-text" )
                    .html( this.options.label )
                    .appendTo( buttonElement.empty() )
                    .text(),
                icons = this.options.icons,
                multipleIcons = icons.primary && icons.secondary,
                buttonClasses = [];

            if ( icons.primary || icons.secondary ) {
                if ( this.options.text ) {
                    buttonClasses.push( "ui-button-text-icon" + ( multipleIcons ? "s" : ( icons.primary ? "-primary" : "-secondary" ) ) );
                }

                if ( icons.primary ) {
                    buttonElement.prepend( "<span class='ui-button-icon-primary ui-icon " + icons.primary + "'></span>" );
                }

                if ( icons.secondary ) {
                    buttonElement.append( "<span class='ui-button-icon-secondary ui-icon " + icons.secondary + "'></span>" );
                }

                if ( !this.options.text ) {
                    buttonClasses.push( multipleIcons ? "ui-button-icons-only" : "ui-button-icon-only" );

                    if ( !this.hasTitle ) {
                        buttonElement.attr( "title", $.trim( buttonText ) );
                    }
                }
            } else {
                buttonClasses.push( "ui-button-text-only" );
            }
            buttonElement.addClass( buttonClasses.join( " " ) );
        }
    });

    $.widget( "ui.buttonset", {
        version: "1.10.2",
        options: {
            items: "button, input[type=button], input[type=submit], input[type=reset], input[type=checkbox], input[type=radio], a, :data(ui-button)"
        },

        _create: function() {
            this.element.addClass( "ui-buttonset" );
        },

        _init: function() {
            this.refresh();
        },

        _setOption: function( key, value ) {
            if ( key === "disabled" ) {
                this.buttons.button( "option", key, value );
            }

            this._super( key, value );
        },

        refresh: function() {
            var rtl = this.element.css( "direction" ) === "rtl";

            this.buttons = this.element.find( this.options.items )
                .filter( ":ui-button" )
                .button( "refresh" )
                .end()
                .not( ":ui-button" )
                .button()
                .end()
                .map(function() {
                    return $( this ).button( "widget" )[ 0 ];
                })
                .removeClass( "ui-corner-all ui-corner-left ui-corner-right" )
                .filter( ":first" )
                .addClass( rtl ? "ui-corner-right" : "ui-corner-left" )
                .end()
                .filter( ":last" )
                .addClass( rtl ? "ui-corner-left" : "ui-corner-right" )
                .end()
                .end();
        },

        _destroy: function() {
            this.element.removeClass( "ui-buttonset" );
            this.buttons
                .map(function() {
                    return $( this ).button( "widget" )[ 0 ];
                })
                .removeClass( "ui-corner-left ui-corner-right" )
                .end()
                .button( "destroy" );
        }
    });

}( jQuery ) );

(function( $, undefined ) {

    $.extend($.ui, { datepicker: { version: "1.10.2" } });

    var PROP_NAME = "datepicker",
        dpuuid = new Date().getTime(),
        instActive;

    /* Date picker manager.
     Use the singleton instance of this class, $.datepicker, to interact with the date picker.
     Settings for (groups of) date pickers are maintained in an instance object,
     allowing multiple different settings on the same page. */

    function Datepicker() {
        this._curInst = null; // The current instance in use
        this._keyEvent = false; // If the last event was a key event
        this._disabledInputs = []; // List of date picker inputs that have been disabled
        this._datepickerShowing = false; // True if the popup picker is showing , false if not
        this._inDialog = false; // True if showing within a "dialog", false if not
        this._mainDivId = "ui-datepicker-div"; // The ID of the main datepicker division
        this._inlineClass = "ui-datepicker-inline"; // The name of the inline marker class
        this._appendClass = "ui-datepicker-append"; // The name of the append marker class
        this._triggerClass = "ui-datepicker-trigger"; // The name of the trigger marker class
        this._dialogClass = "ui-datepicker-dialog"; // The name of the dialog marker class
        this._disableClass = "ui-datepicker-disabled"; // The name of the disabled covering marker class
        this._unselectableClass = "ui-datepicker-unselectable"; // The name of the unselectable cell marker class
        this._currentClass = "ui-datepicker-current-day"; // The name of the current day marker class
        this._dayOverClass = "ui-datepicker-days-cell-over"; // The name of the day hover marker class
        this.regional = []; // Available regional settings, indexed by language code
        this.regional[""] = { // Default regional settings
            closeText: "Done", // Display text for close link
            prevText: "Prev", // Display text for previous month link
            nextText: "Next", // Display text for next month link
            currentText: "Today", // Display text for current month link
            monthNames: ["January","February","March","April","May","June",
                "July","August","September","October","November","December"], // Names of months for drop-down and formatting
            monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], // For formatting
            dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], // For formatting
            dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], // For formatting
            dayNamesMin: ["Su","Mo","Tu","We","Th","Fr","Sa"], // Column headings for days starting at Sunday
            weekHeader: "Wk", // Column header for week of the year
            dateFormat: "mm/dd/yy", // See format options on parseDate
            firstDay: 0, // The first day of the week, Sun = 0, Mon = 1, ...
            isRTL: false, // True if right-to-left language, false if left-to-right
            showMonthAfterYear: false, // True if the year select precedes month, false for month then year
            yearSuffix: "" // Additional text to append to the year in the month headers
        };
        this._defaults = { // Global defaults for all the date picker instances
            showOn: "focus", // "focus" for popup on focus,
            // "button" for trigger button, or "both" for either
            showAnim: "fadeIn", // Name of jQuery animation for popup
            showOptions: {}, // Options for enhanced animations
            defaultDate: null, // Used when field is blank: actual date,
            // +/-number for offset from today, null for today
            appendText: "", // Display text following the input box, e.g. showing the format
            buttonText: "...", // Text for trigger button
            buttonImage: "", // URL for trigger button image
            buttonImageOnly: false, // True if the image appears alone, false if it appears on a button
            hideIfNoPrevNext: false, // True to hide next/previous month links
            // if not applicable, false to just disable them
            navigationAsDateFormat: false, // True if date formatting applied to prev/today/next links
            gotoCurrent: false, // True if today link goes back to current selection instead
            changeMonth: false, // True if month can be selected directly, false if only prev/next
            changeYear: false, // True if year can be selected directly, false if only prev/next
            yearRange: "c-10:c+10", // Range of years to display in drop-down,
            // either relative to today's year (-nn:+nn), relative to currently displayed year
            // (c-nn:c+nn), absolute (nnnn:nnnn), or a combination of the above (nnnn:-n)
            showOtherMonths: false, // True to show dates in other months, false to leave blank
            selectOtherMonths: false, // True to allow selection of dates in other months, false for unselectable
            showWeek: false, // True to show week of the year, false to not show it
            calculateWeek: this.iso8601Week, // How to calculate the week of the year,
            // takes a Date and returns the number of the week for it
            shortYearCutoff: "+10", // Short year values < this are in the current century,
            // > this are in the previous century,
            // string value starting with "+" for current year + value
            minDate: null, // The earliest selectable date, or null for no limit
            maxDate: null, // The latest selectable date, or null for no limit
            duration: "fast", // Duration of display/closure
            beforeShowDay: null, // Function that takes a date and returns an array with
            // [0] = true if selectable, false if not, [1] = custom CSS class name(s) or "",
            // [2] = cell title (optional), e.g. $.datepicker.noWeekends
            beforeShow: null, // Function that takes an input field and
            // returns a set of custom settings for the date picker
            onSelect: null, // Define a callback function when a date is selected
            onChangeMonthYear: null, // Define a callback function when the month or year is changed
            onClose: null, // Define a callback function when the datepicker is closed
            numberOfMonths: 1, // Number of months to show at a time
            showCurrentAtPos: 0, // The position in multipe months at which to show the current month (starting at 0)
            stepMonths: 1, // Number of months to step back/forward
            stepBigMonths: 12, // Number of months to step back/forward for the big links
            altField: "", // Selector for an alternate field to store selected dates into
            altFormat: "", // The date format to use for the alternate field
            constrainInput: true, // The input is constrained by the current date format
            showButtonPanel: false, // True to show button panel, false to not show it
            autoSize: false, // True to size the input for the date format, false to leave as is
            disabled: false // The initial disabled state
        };
        $.extend(this._defaults, this.regional[""]);
        this.dpDiv = bindHover($("<div id='" + this._mainDivId + "' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"));
    }

    $.extend(Datepicker.prototype, {
        /* Class name added to elements to indicate already configured with a date picker. */
        markerClassName: "hasDatepicker",

        //Keep track of the maximum number of rows displayed (see #7043)
        maxRows: 4,

        // TODO rename to "widget" when switching to widget factory
        _widgetDatepicker: function() {
            return this.dpDiv;
        },

        /* Override the default settings for all instances of the date picker.
         * @param  settings  object - the new settings to use as defaults (anonymous object)
         * @return the manager object
         */
        setDefaults: function(settings) {
            extendRemove(this._defaults, settings || {});
            return this;
        },

        /* Attach the date picker to a jQuery selection.
         * @param  target	element - the target input field or division or span
         * @param  settings  object - the new settings to use for this date picker instance (anonymous)
         */
        _attachDatepicker: function(target, settings) {
            var nodeName, inline, inst;
            nodeName = target.nodeName.toLowerCase();
            inline = (nodeName === "div" || nodeName === "span");
            if (!target.id) {
                this.uuid += 1;
                target.id = "dp" + this.uuid;
            }
            inst = this._newInst($(target), inline);
            inst.settings = $.extend({}, settings || {});
            if (nodeName === "input") {
                this._connectDatepicker(target, inst);
            } else if (inline) {
                this._inlineDatepicker(target, inst);
            }
        },

        /* Create a new instance object. */
        _newInst: function(target, inline) {
            var id = target[0].id.replace(/([^A-Za-z0-9_\-])/g, "\\\\$1"); // escape jQuery meta chars
            return {id: id, input: target, // associated target
                selectedDay: 0, selectedMonth: 0, selectedYear: 0, // current selection
                drawMonth: 0, drawYear: 0, // month being drawn
                inline: inline, // is datepicker inline or not
                dpDiv: (!inline ? this.dpDiv : // presentation div
                    bindHover($("<div class='" + this._inlineClass + " ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>")))};
        },

        /* Attach the date picker to an input field. */
        _connectDatepicker: function(target, inst) {
            var input = $(target);
            inst.append = $([]);
            inst.trigger = $([]);
            if (input.hasClass(this.markerClassName)) {
                return;
            }
            this._attachments(input, inst);
            input.addClass(this.markerClassName).keydown(this._doKeyDown).
            keypress(this._doKeyPress).keyup(this._doKeyUp);
            this._autoSize(inst);
            $.data(target, PROP_NAME, inst);
            //If disabled option is true, disable the datepicker once it has been attached to the input (see ticket #5665)
            if( inst.settings.disabled ) {
                this._disableDatepicker( target );
            }
        },

        /* Make attachments based on settings. */
        _attachments: function(input, inst) {
            var showOn, buttonText, buttonImage,
                appendText = this._get(inst, "appendText"),
                isRTL = this._get(inst, "isRTL");

            if (inst.append) {
                inst.append.remove();
            }
            if (appendText) {
                inst.append = $("<span class='" + this._appendClass + "'>" + appendText + "</span>");
                input[isRTL ? "before" : "after"](inst.append);
            }

            input.unbind("focus", this._showDatepicker);

            if (inst.trigger) {
                inst.trigger.remove();
            }

            showOn = this._get(inst, "showOn");
            if (showOn === "focus" || showOn === "both") { // pop-up date picker when in the marked field
                input.focus(this._showDatepicker);
            }
            if (showOn === "button" || showOn === "both") { // pop-up date picker when button clicked
                buttonText = this._get(inst, "buttonText");
                buttonImage = this._get(inst, "buttonImage");
                inst.trigger = $(this._get(inst, "buttonImageOnly") ?
                    $("<img/>").addClass(this._triggerClass).
                    attr({ src: buttonImage, alt: buttonText, title: buttonText }) :
                    $("<button type='button'></button>").addClass(this._triggerClass).
                    html(!buttonImage ? buttonText : $("<img/>").attr(
                        { src:buttonImage, alt:buttonText, title:buttonText })));
                input[isRTL ? "before" : "after"](inst.trigger);
                inst.trigger.click(function() {
                    if ($.datepicker._datepickerShowing && $.datepicker._lastInput === input[0]) {
                        $.datepicker._hideDatepicker();
                    } else if ($.datepicker._datepickerShowing && $.datepicker._lastInput !== input[0]) {
                        $.datepicker._hideDatepicker();
                        $.datepicker._showDatepicker(input[0]);
                    } else {
                        $.datepicker._showDatepicker(input[0]);
                    }
                    return false;
                });
            }
        },

        /* Apply the maximum length for the date format. */
        _autoSize: function(inst) {
            if (this._get(inst, "autoSize") && !inst.inline) {
                var findMax, max, maxI, i,
                    date = new Date(2009, 12 - 1, 20), // Ensure double digits
                    dateFormat = this._get(inst, "dateFormat");

                if (dateFormat.match(/[DM]/)) {
                    findMax = function(names) {
                        max = 0;
                        maxI = 0;
                        for (i = 0; i < names.length; i++) {
                            if (names[i].length > max) {
                                max = names[i].length;
                                maxI = i;
                            }
                        }
                        return maxI;
                    };
                    date.setMonth(findMax(this._get(inst, (dateFormat.match(/MM/) ?
                        "monthNames" : "monthNamesShort"))));
                    date.setDate(findMax(this._get(inst, (dateFormat.match(/DD/) ?
                            "dayNames" : "dayNamesShort"))) + 20 - date.getDay());
                }
                inst.input.attr("size", this._formatDate(inst, date).length);
            }
        },

        /* Attach an inline date picker to a div. */
        _inlineDatepicker: function(target, inst) {
            var divSpan = $(target);
            if (divSpan.hasClass(this.markerClassName)) {
                return;
            }
            divSpan.addClass(this.markerClassName).append(inst.dpDiv);
            $.data(target, PROP_NAME, inst);
            this._setDate(inst, this._getDefaultDate(inst), true);
            this._updateDatepicker(inst);
            this._updateAlternate(inst);
            //If disabled option is true, disable the datepicker before showing it (see ticket #5665)
            if( inst.settings.disabled ) {
                this._disableDatepicker( target );
            }
            // Set display:block in place of inst.dpDiv.show() which won't work on disconnected elements
            // http://bugs.jqueryui.com/ticket/7552 - A Datepicker created on a detached div has zero height
            inst.dpDiv.css( "display", "block" );
        },

        /* Pop-up the date picker in a "dialog" box.
         * @param  input element - ignored
         * @param  date	string or Date - the initial date to display
         * @param  onSelect  function - the function to call when a date is selected
         * @param  settings  object - update the dialog date picker instance's settings (anonymous object)
         * @param  pos int[2] - coordinates for the dialog's position within the screen or
         *					event - with x/y coordinates or
         *					leave empty for default (screen centre)
         * @return the manager object
         */
        _dialogDatepicker: function(input, date, onSelect, settings, pos) {
            var id, browserWidth, browserHeight, scrollX, scrollY,
                inst = this._dialogInst; // internal instance

            if (!inst) {
                this.uuid += 1;
                id = "dp" + this.uuid;
                this._dialogInput = $("<input type='text' id='" + id +
                    "' style='position: absolute; top: -100px; width: 0px;'/>");
                this._dialogInput.keydown(this._doKeyDown);
                $("body").append(this._dialogInput);
                inst = this._dialogInst = this._newInst(this._dialogInput, false);
                inst.settings = {};
                $.data(this._dialogInput[0], PROP_NAME, inst);
            }
            extendRemove(inst.settings, settings || {});
            date = (date && date.constructor === Date ? this._formatDate(inst, date) : date);
            this._dialogInput.val(date);

            this._pos = (pos ? (pos.length ? pos : [pos.pageX, pos.pageY]) : null);
            if (!this._pos) {
                browserWidth = document.documentElement.clientWidth;
                browserHeight = document.documentElement.clientHeight;
                scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;
                scrollY = document.documentElement.scrollTop || document.body.scrollTop;
                this._pos = // should use actual width/height below
                    [(browserWidth / 2) - 100 + scrollX, (browserHeight / 2) - 150 + scrollY];
            }

            // move input on screen for focus, but hidden behind dialog
            this._dialogInput.css("left", (this._pos[0] + 20) + "px").css("top", this._pos[1] + "px");
            inst.settings.onSelect = onSelect;
            this._inDialog = true;
            this.dpDiv.addClass(this._dialogClass);
            this._showDatepicker(this._dialogInput[0]);
            if ($.blockUI) {
                $.blockUI(this.dpDiv);
            }
            $.data(this._dialogInput[0], PROP_NAME, inst);
            return this;
        },

        /* Detach a datepicker from its control.
         * @param  target	element - the target input field or division or span
         */
        _destroyDatepicker: function(target) {
            var nodeName,
                $target = $(target),
                inst = $.data(target, PROP_NAME);

            if (!$target.hasClass(this.markerClassName)) {
                return;
            }

            nodeName = target.nodeName.toLowerCase();
            $.removeData(target, PROP_NAME);
            if (nodeName === "input") {
                inst.append.remove();
                inst.trigger.remove();
                $target.removeClass(this.markerClassName).
                unbind("focus", this._showDatepicker).
                unbind("keydown", this._doKeyDown).
                unbind("keypress", this._doKeyPress).
                unbind("keyup", this._doKeyUp);
            } else if (nodeName === "div" || nodeName === "span") {
                $target.removeClass(this.markerClassName).empty();
            }
        },

        /* Enable the date picker to a jQuery selection.
         * @param  target	element - the target input field or division or span
         */
        _enableDatepicker: function(target) {
            var nodeName, inline,
                $target = $(target),
                inst = $.data(target, PROP_NAME);

            if (!$target.hasClass(this.markerClassName)) {
                return;
            }

            nodeName = target.nodeName.toLowerCase();
            if (nodeName === "input") {
                target.disabled = false;
                inst.trigger.filter("button").
                each(function() { this.disabled = false; }).end().
                filter("img").css({opacity: "1.0", cursor: ""});
            } else if (nodeName === "div" || nodeName === "span") {
                inline = $target.children("." + this._inlineClass);
                inline.children().removeClass("ui-state-disabled");
                inline.find("select.ui-datepicker-month, select.ui-datepicker-year").
                prop("disabled", false);
            }
            this._disabledInputs = $.map(this._disabledInputs,
                function(value) { return (value === target ? null : value); }); // delete entry
        },

        /* Disable the date picker to a jQuery selection.
         * @param  target	element - the target input field or division or span
         */
        _disableDatepicker: function(target) {
            var nodeName, inline,
                $target = $(target),
                inst = $.data(target, PROP_NAME);

            if (!$target.hasClass(this.markerClassName)) {
                return;
            }

            nodeName = target.nodeName.toLowerCase();
            if (nodeName === "input") {
                target.disabled = true;
                inst.trigger.filter("button").
                each(function() { this.disabled = true; }).end().
                filter("img").css({opacity: "0.5", cursor: "default"});
            } else if (nodeName === "div" || nodeName === "span") {
                inline = $target.children("." + this._inlineClass);
                inline.children().addClass("ui-state-disabled");
                inline.find("select.ui-datepicker-month, select.ui-datepicker-year").
                prop("disabled", true);
            }
            this._disabledInputs = $.map(this._disabledInputs,
                function(value) { return (value === target ? null : value); }); // delete entry
            this._disabledInputs[this._disabledInputs.length] = target;
        },

        /* Is the first field in a jQuery collection disabled as a datepicker?
         * @param  target	element - the target input field or division or span
         * @return boolean - true if disabled, false if enabled
         */
        _isDisabledDatepicker: function(target) {
            if (!target) {
                return false;
            }
            for (var i = 0; i < this._disabledInputs.length; i++) {
                if (this._disabledInputs[i] === target) {
                    return true;
                }
            }
            return false;
        },

        /* Retrieve the instance data for the target control.
         * @param  target  element - the target input field or division or span
         * @return  object - the associated instance data
         * @throws  error if a jQuery problem getting data
         */
        _getInst: function(target) {
            try {
                return $.data(target, PROP_NAME);
            }
            catch (err) {
                throw "Missing instance data for this datepicker";
            }
        },

        /* Update or retrieve the settings for a date picker attached to an input field or division.
         * @param  target  element - the target input field or division or span
         * @param  name	object - the new settings to update or
         *				string - the name of the setting to change or retrieve,
         *				when retrieving also "all" for all instance settings or
         *				"defaults" for all global defaults
         * @param  value   any - the new value for the setting
         *				(omit if above is an object or to retrieve a value)
         */
        _optionDatepicker: function(target, name, value) {
            var settings, date, minDate, maxDate,
                inst = this._getInst(target);

            if (arguments.length === 2 && typeof name === "string") {
                return (name === "defaults" ? $.extend({}, $.datepicker._defaults) :
                    (inst ? (name === "all" ? $.extend({}, inst.settings) :
                        this._get(inst, name)) : null));
            }

            settings = name || {};
            if (typeof name === "string") {
                settings = {};
                settings[name] = value;
            }

            if (inst) {
                if (this._curInst === inst) {
                    this._hideDatepicker();
                }

                date = this._getDateDatepicker(target, true);
                minDate = this._getMinMaxDate(inst, "min");
                maxDate = this._getMinMaxDate(inst, "max");
                extendRemove(inst.settings, settings);
                // reformat the old minDate/maxDate values if dateFormat changes and a new minDate/maxDate isn't provided
                if (minDate !== null && settings.dateFormat !== undefined && settings.minDate === undefined) {
                    inst.settings.minDate = this._formatDate(inst, minDate);
                }
                if (maxDate !== null && settings.dateFormat !== undefined && settings.maxDate === undefined) {
                    inst.settings.maxDate = this._formatDate(inst, maxDate);
                }
                if ( "disabled" in settings ) {
                    if ( settings.disabled ) {
                        this._disableDatepicker(target);
                    } else {
                        this._enableDatepicker(target);
                    }
                }
                this._attachments($(target), inst);
                this._autoSize(inst);
                this._setDate(inst, date);
                this._updateAlternate(inst);
                this._updateDatepicker(inst);
            }
        },

        // change method deprecated
        _changeDatepicker: function(target, name, value) {
            this._optionDatepicker(target, name, value);
        },

        /* Redraw the date picker attached to an input field or division.
         * @param  target  element - the target input field or division or span
         */
        _refreshDatepicker: function(target) {
            var inst = this._getInst(target);
            if (inst) {
                this._updateDatepicker(inst);
            }
        },

        /* Set the dates for a jQuery selection.
         * @param  target element - the target input field or division or span
         * @param  date	Date - the new date
         */
        _setDateDatepicker: function(target, date) {
            var inst = this._getInst(target);
            if (inst) {
                this._setDate(inst, date);
                this._updateDatepicker(inst);
                this._updateAlternate(inst);
            }
        },

        /* Get the date(s) for the first entry in a jQuery selection.
         * @param  target element - the target input field or division or span
         * @param  noDefault boolean - true if no default date is to be used
         * @return Date - the current date
         */
        _getDateDatepicker: function(target, noDefault) {
            var inst = this._getInst(target);
            if (inst && !inst.inline) {
                this._setDateFromField(inst, noDefault);
            }
            return (inst ? this._getDate(inst) : null);
        },

        /* Handle keystrokes. */
        _doKeyDown: function(event) {
            var onSelect, dateStr, sel,
                inst = $.datepicker._getInst(event.target),
                handled = true,
                isRTL = inst.dpDiv.is(".ui-datepicker-rtl");

            inst._keyEvent = true;
            if ($.datepicker._datepickerShowing) {
                switch (event.keyCode) {
                    case 9: $.datepicker._hideDatepicker();
                        handled = false;
                        break; // hide on tab out
                    case 13: sel = $("td." + $.datepicker._dayOverClass + ":not(." +
                        $.datepicker._currentClass + ")", inst.dpDiv);
                        if (sel[0]) {
                            $.datepicker._selectDay(event.target, inst.selectedMonth, inst.selectedYear, sel[0]);
                        }

                        onSelect = $.datepicker._get(inst, "onSelect");
                        if (onSelect) {
                            dateStr = $.datepicker._formatDate(inst);

                            // trigger custom callback
                            onSelect.apply((inst.input ? inst.input[0] : null), [dateStr, inst]);
                        } else {
                            $.datepicker._hideDatepicker();
                        }

                        return false; // don't submit the form
                    case 27: $.datepicker._hideDatepicker();
                        break; // hide on escape
                    case 33: $.datepicker._adjustDate(event.target, (event.ctrlKey ?
                        -$.datepicker._get(inst, "stepBigMonths") :
                        -$.datepicker._get(inst, "stepMonths")), "M");
                        break; // previous month/year on page up/+ ctrl
                    case 34: $.datepicker._adjustDate(event.target, (event.ctrlKey ?
                        +$.datepicker._get(inst, "stepBigMonths") :
                        +$.datepicker._get(inst, "stepMonths")), "M");
                        break; // next month/year on page down/+ ctrl
                    case 35: if (event.ctrlKey || event.metaKey) {
                        $.datepicker._clearDate(event.target);
                    }
                        handled = event.ctrlKey || event.metaKey;
                        break; // clear on ctrl or command +end
                    case 36: if (event.ctrlKey || event.metaKey) {
                        $.datepicker._gotoToday(event.target);
                    }
                        handled = event.ctrlKey || event.metaKey;
                        break; // current on ctrl or command +home
                    case 37: if (event.ctrlKey || event.metaKey) {
                        $.datepicker._adjustDate(event.target, (isRTL ? +1 : -1), "D");
                    }
                        handled = event.ctrlKey || event.metaKey;
                        // -1 day on ctrl or command +left
                        if (event.originalEvent.altKey) {
                            $.datepicker._adjustDate(event.target, (event.ctrlKey ?
                                -$.datepicker._get(inst, "stepBigMonths") :
                                -$.datepicker._get(inst, "stepMonths")), "M");
                        }
                        // next month/year on alt +left on Mac
                        break;
                    case 38: if (event.ctrlKey || event.metaKey) {
                        $.datepicker._adjustDate(event.target, -7, "D");
                    }
                        handled = event.ctrlKey || event.metaKey;
                        break; // -1 week on ctrl or command +up
                    case 39: if (event.ctrlKey || event.metaKey) {
                        $.datepicker._adjustDate(event.target, (isRTL ? -1 : +1), "D");
                    }
                        handled = event.ctrlKey || event.metaKey;
                        // +1 day on ctrl or command +right
                        if (event.originalEvent.altKey) {
                            $.datepicker._adjustDate(event.target, (event.ctrlKey ?
                                +$.datepicker._get(inst, "stepBigMonths") :
                                +$.datepicker._get(inst, "stepMonths")), "M");
                        }
                        // next month/year on alt +right
                        break;
                    case 40: if (event.ctrlKey || event.metaKey) {
                        $.datepicker._adjustDate(event.target, +7, "D");
                    }
                        handled = event.ctrlKey || event.metaKey;
                        break; // +1 week on ctrl or command +down
                    default: handled = false;
                }
            } else if (event.keyCode === 36 && event.ctrlKey) { // display the date picker on ctrl+home
                $.datepicker._showDatepicker(this);
            } else {
                handled = false;
            }

            if (handled) {
                event.preventDefault();
                event.stopPropagation();
            }
        },

        /* Filter entered characters - based on date format. */
        _doKeyPress: function(event) {
            var chars, chr,
                inst = $.datepicker._getInst(event.target);

            if ($.datepicker._get(inst, "constrainInput")) {
                chars = $.datepicker._possibleChars($.datepicker._get(inst, "dateFormat"));
                chr = String.fromCharCode(event.charCode == null ? event.keyCode : event.charCode);
                return event.ctrlKey || event.metaKey || (chr < " " || !chars || chars.indexOf(chr) > -1);
            }
        },

        /* Synchronise manual entry and field/alternate field. */
        _doKeyUp: function(event) {
            var date,
                inst = $.datepicker._getInst(event.target);

            if (inst.input.val() !== inst.lastVal) {
                try {
                    date = $.datepicker.parseDate($.datepicker._get(inst, "dateFormat"),
                        (inst.input ? inst.input.val() : null),
                        $.datepicker._getFormatConfig(inst));

                    if (date) { // only if valid
                        $.datepicker._setDateFromField(inst);
                        $.datepicker._updateAlternate(inst);
                        $.datepicker._updateDatepicker(inst);
                    }
                }
                catch (err) {
                }
            }
            return true;
        },

        /* Pop-up the date picker for a given input field.
         * If false returned from beforeShow event handler do not show.
         * @param  input  element - the input field attached to the date picker or
         *					event - if triggered by focus
         */
        _showDatepicker: function(input) {
            input = input.target || input;
            if (input.nodeName.toLowerCase() !== "input") { // find from button/image trigger
                input = $("input", input.parentNode)[0];
            }

            if ($.datepicker._isDisabledDatepicker(input) || $.datepicker._lastInput === input) { // already here
                return;
            }

            var inst, beforeShow, beforeShowSettings, isFixed,
                offset, showAnim, duration;

            inst = $.datepicker._getInst(input);
            if ($.datepicker._curInst && $.datepicker._curInst !== inst) {
                $.datepicker._curInst.dpDiv.stop(true, true);
                if ( inst && $.datepicker._datepickerShowing ) {
                    $.datepicker._hideDatepicker( $.datepicker._curInst.input[0] );
                }
            }

            beforeShow = $.datepicker._get(inst, "beforeShow");
            beforeShowSettings = beforeShow ? beforeShow.apply(input, [input, inst]) : {};
            if(beforeShowSettings === false){
                return;
            }
            extendRemove(inst.settings, beforeShowSettings);

            inst.lastVal = null;
            $.datepicker._lastInput = input;
            $.datepicker._setDateFromField(inst);

            if ($.datepicker._inDialog) { // hide cursor
                input.value = "";
            }
            if (!$.datepicker._pos) { // position below input
                $.datepicker._pos = $.datepicker._findPos(input);
                $.datepicker._pos[1] += input.offsetHeight; // add the height
            }

            isFixed = false;
            $(input).parents().each(function() {
                isFixed |= $(this).css("position") === "fixed";
                return !isFixed;
            });

            offset = {left: $.datepicker._pos[0], top: $.datepicker._pos[1]};
            $.datepicker._pos = null;
            //to avoid flashes on Firefox
            inst.dpDiv.empty();
            // determine sizing offscreen
            inst.dpDiv.css({position: "absolute", display: "block", top: "-1000px"});
            $.datepicker._updateDatepicker(inst);
            // fix width for dynamic number of date pickers
            // and adjust position before showing
            offset = $.datepicker._checkOffset(inst, offset, isFixed);
            inst.dpDiv.css({position: ($.datepicker._inDialog && $.blockUI ?
                "static" : (isFixed ? "fixed" : "absolute")), display: "none",
                left: offset.left + "px", top: offset.top + "px"});

            if (!inst.inline) {
                showAnim = $.datepicker._get(inst, "showAnim");
                duration = $.datepicker._get(inst, "duration");
                inst.dpDiv.zIndex($(input).zIndex()+1);
                $.datepicker._datepickerShowing = true;

                if ( $.effects && $.effects.effect[ showAnim ] ) {
                    inst.dpDiv.show(showAnim, $.datepicker._get(inst, "showOptions"), duration);
                } else {
                    inst.dpDiv[showAnim || "show"](showAnim ? duration : null);
                }

                if (inst.input.is(":visible") && !inst.input.is(":disabled")) {
                    inst.input.focus();
                }
                $.datepicker._curInst = inst;
            }
        },

        /* Generate the date picker content. */
        _updateDatepicker: function(inst) {
            this.maxRows = 4; //Reset the max number of rows being displayed (see #7043)
            instActive = inst; // for delegate hover events
            inst.dpDiv.empty().append(this._generateHTML(inst));
            this._attachHandlers(inst);
            inst.dpDiv.find("." + this._dayOverClass + " a").mouseover();

            var origyearshtml,
                numMonths = this._getNumberOfMonths(inst),
                cols = numMonths[1],
                width = 17;

            inst.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width("");
            if (cols > 1) {
                inst.dpDiv.addClass("ui-datepicker-multi-" + cols).css("width", (width * cols) + "em");
            }
            inst.dpDiv[(numMonths[0] !== 1 || numMonths[1] !== 1 ? "add" : "remove") +
            "Class"]("ui-datepicker-multi");
            inst.dpDiv[(this._get(inst, "isRTL") ? "add" : "remove") +
            "Class"]("ui-datepicker-rtl");

            // #6694 - don't focus the input if it's already focused
            // this breaks the change event in IE
            if (inst === $.datepicker._curInst && $.datepicker._datepickerShowing && inst.input &&
                inst.input.is(":visible") && !inst.input.is(":disabled") && inst.input[0] !== document.activeElement) {
                inst.input.focus();
            }

            // deffered render of the years select (to avoid flashes on Firefox)
            if( inst.yearshtml ){
                origyearshtml = inst.yearshtml;
                setTimeout(function(){
                    //assure that inst.yearshtml didn't change.
                    if( origyearshtml === inst.yearshtml && inst.yearshtml ){
                        inst.dpDiv.find("select.ui-datepicker-year:first").replaceWith(inst.yearshtml);
                    }
                    origyearshtml = inst.yearshtml = null;
                }, 0);
            }
        },

        /* Retrieve the size of left and top borders for an element.
         * @param  elem  (jQuery object) the element of interest
         * @return  (number[2]) the left and top borders
         */
        _getBorders: function(elem) {
            var convert = function(value) {
                return {thin: 1, medium: 2, thick: 3}[value] || value;
            };
            return [parseFloat(convert(elem.css("border-left-width"))),
                parseFloat(convert(elem.css("border-top-width")))];
        },

        /* Check positioning to remain on screen. */
        _checkOffset: function(inst, offset, isFixed) {
            var dpWidth = inst.dpDiv.outerWidth(),
                dpHeight = inst.dpDiv.outerHeight(),
                inputWidth = inst.input ? inst.input.outerWidth() : 0,
                inputHeight = inst.input ? inst.input.outerHeight() : 0,
                viewWidth = document.documentElement.clientWidth + (isFixed ? 0 : $(document).scrollLeft()),
                viewHeight = document.documentElement.clientHeight + (isFixed ? 0 : $(document).scrollTop());

            offset.left -= (this._get(inst, "isRTL") ? (dpWidth - inputWidth) : 0);
            offset.left -= (isFixed && offset.left === inst.input.offset().left) ? $(document).scrollLeft() : 0;
            offset.top -= (isFixed && offset.top === (inst.input.offset().top + inputHeight)) ? $(document).scrollTop() : 0;

            // now check if datepicker is showing outside window viewport - move to a better place if so.
            offset.left -= Math.min(offset.left, (offset.left + dpWidth > viewWidth && viewWidth > dpWidth) ?
                Math.abs(offset.left + dpWidth - viewWidth) : 0);
            offset.top -= Math.min(offset.top, (offset.top + dpHeight > viewHeight && viewHeight > dpHeight) ?
                Math.abs(dpHeight + inputHeight) : 0);

            return offset;
        },

        /* Find an object's position on the screen. */
        _findPos: function(obj) {
            var position,
                inst = this._getInst(obj),
                isRTL = this._get(inst, "isRTL");

            while (obj && (obj.type === "hidden" || obj.nodeType !== 1 || $.expr.filters.hidden(obj))) {
                obj = obj[isRTL ? "previousSibling" : "nextSibling"];
            }

            position = $(obj).offset();
            return [position.left, position.top];
        },

        /* Hide the date picker from view.
         * @param  input  element - the input field attached to the date picker
         */
        _hideDatepicker: function(input) {
            var showAnim, duration, postProcess, onClose,
                inst = this._curInst;

            if (!inst || (input && inst !== $.data(input, PROP_NAME))) {
                return;
            }

            if (this._datepickerShowing) {
                showAnim = this._get(inst, "showAnim");
                duration = this._get(inst, "duration");
                postProcess = function() {
                    $.datepicker._tidyDialog(inst);
                };

                // DEPRECATED: after BC for 1.8.x $.effects[ showAnim ] is not needed
                if ( $.effects && ( $.effects.effect[ showAnim ] || $.effects[ showAnim ] ) ) {
                    inst.dpDiv.hide(showAnim, $.datepicker._get(inst, "showOptions"), duration, postProcess);
                } else {
                    inst.dpDiv[(showAnim === "slideDown" ? "slideUp" :
                        (showAnim === "fadeIn" ? "fadeOut" : "hide"))]((showAnim ? duration : null), postProcess);
                }

                if (!showAnim) {
                    postProcess();
                }
                this._datepickerShowing = false;

                onClose = this._get(inst, "onClose");
                if (onClose) {
                    onClose.apply((inst.input ? inst.input[0] : null), [(inst.input ? inst.input.val() : ""), inst]);
                }

                this._lastInput = null;
                if (this._inDialog) {
                    this._dialogInput.css({ position: "absolute", left: "0", top: "-100px" });
                    if ($.blockUI) {
                        $.unblockUI();
                        $("body").append(this.dpDiv);
                    }
                }
                this._inDialog = false;
            }
        },

        /* Tidy up after a dialog display. */
        _tidyDialog: function(inst) {
            inst.dpDiv.removeClass(this._dialogClass).unbind(".ui-datepicker-calendar");
        },

        /* Close date picker if clicked elsewhere. */
        _checkExternalClick: function(event) {
            if (!$.datepicker._curInst) {
                return;
            }

            var $target = $(event.target),
                inst = $.datepicker._getInst($target[0]);

            if ( ( ( $target[0].id !== $.datepicker._mainDivId &&
                $target.parents("#" + $.datepicker._mainDivId).length === 0 &&
                !$target.hasClass($.datepicker.markerClassName) &&
                !$target.closest("." + $.datepicker._triggerClass).length &&
                $.datepicker._datepickerShowing && !($.datepicker._inDialog && $.blockUI) ) ) ||
                ( $target.hasClass($.datepicker.markerClassName) && $.datepicker._curInst !== inst ) ) {
                $.datepicker._hideDatepicker();
            }
        },

        /* Adjust one of the date sub-fields. */
        _adjustDate: function(id, offset, period) {
            var target = $(id),
                inst = this._getInst(target[0]);

            if (this._isDisabledDatepicker(target[0])) {
                return;
            }
            this._adjustInstDate(inst, offset +
                (period === "M" ? this._get(inst, "showCurrentAtPos") : 0), // undo positioning
                period);
            this._updateDatepicker(inst);
        },

        /* Action for current link. */
        _gotoToday: function(id) {
            var date,
                target = $(id),
                inst = this._getInst(target[0]);

            if (this._get(inst, "gotoCurrent") && inst.currentDay) {
                inst.selectedDay = inst.currentDay;
                inst.drawMonth = inst.selectedMonth = inst.currentMonth;
                inst.drawYear = inst.selectedYear = inst.currentYear;
            } else {
                date = new Date();
                inst.selectedDay = date.getDate();
                inst.drawMonth = inst.selectedMonth = date.getMonth();
                inst.drawYear = inst.selectedYear = date.getFullYear();
            }
            this._notifyChange(inst);
            this._adjustDate(target);
        },

        /* Action for selecting a new month/year. */
        _selectMonthYear: function(id, select, period) {
            var target = $(id),
                inst = this._getInst(target[0]);

            inst["selected" + (period === "M" ? "Month" : "Year")] =
                inst["draw" + (period === "M" ? "Month" : "Year")] =
                    parseInt(select.options[select.selectedIndex].value,10);

            this._notifyChange(inst);
            this._adjustDate(target);
        },

        /* Action for selecting a day. */
        _selectDay: function(id, month, year, td) {
            var inst,
                target = $(id);

            if ($(td).hasClass(this._unselectableClass) || this._isDisabledDatepicker(target[0])) {
                return;
            }

            inst = this._getInst(target[0]);
            inst.selectedDay = inst.currentDay = $("a", td).html();
            inst.selectedMonth = inst.currentMonth = month;
            inst.selectedYear = inst.currentYear = year;
            this._selectDate(id, this._formatDate(inst,
                inst.currentDay, inst.currentMonth, inst.currentYear));
        },

        /* Erase the input field and hide the date picker. */
        _clearDate: function(id) {
            var target = $(id);
            this._selectDate(target, "");
        },

        /* Update the input field with the selected date. */
        _selectDate: function(id, dateStr) {
            var onSelect,
                target = $(id),
                inst = this._getInst(target[0]);

            dateStr = (dateStr != null ? dateStr : this._formatDate(inst));
            if (inst.input) {
                inst.input.val(dateStr);
            }
            this._updateAlternate(inst);

            onSelect = this._get(inst, "onSelect");
            if (onSelect) {
                onSelect.apply((inst.input ? inst.input[0] : null), [dateStr, inst]);  // trigger custom callback
            } else if (inst.input) {
                inst.input.trigger("change"); // fire the change event
            }

            if (inst.inline){
                this._updateDatepicker(inst);
            } else {
                this._hideDatepicker();
                this._lastInput = inst.input[0];
                if (typeof(inst.input[0]) !== "object") {
                    inst.input.focus(); // restore focus
                }
                this._lastInput = null;
            }
        },

        /* Update any alternate field to synchronise with the main field. */
        _updateAlternate: function(inst) {
            var altFormat, date, dateStr,
                altField = this._get(inst, "altField");

            if (altField) { // update alternate field too
                altFormat = this._get(inst, "altFormat") || this._get(inst, "dateFormat");
                date = this._getDate(inst);
                dateStr = this.formatDate(altFormat, date, this._getFormatConfig(inst));
                $(altField).each(function() { $(this).val(dateStr); });
            }
        },

        /* Set as beforeShowDay function to prevent selection of weekends.
         * @param  date  Date - the date to customise
         * @return [boolean, string] - is this date selectable?, what is its CSS class?
         */
        noWeekends: function(date) {
            var day = date.getDay();
            return [(day > 0 && day < 6), ""];
        },

        /* Set as calculateWeek to determine the week of the year based on the ISO 8601 definition.
         * @param  date  Date - the date to get the week for
         * @return  number - the number of the week within the year that contains this date
         */
        iso8601Week: function(date) {
            var time,
                checkDate = new Date(date.getTime());

            // Find Thursday of this week starting on Monday
            checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7));

            time = checkDate.getTime();
            checkDate.setMonth(0); // Compare with Jan 1
            checkDate.setDate(1);
            return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
        },

        /* Parse a string value into a date object.
         * See formatDate below for the possible formats.
         *
         * @param  format string - the expected format of the date
         * @param  value string - the date in the above format
         * @param  settings Object - attributes include:
         *					shortYearCutoff  number - the cutoff year for determining the century (optional)
         *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
         *					dayNames		string[7] - names of the days from Sunday (optional)
         *					monthNamesShort string[12] - abbreviated names of the months (optional)
         *					monthNames		string[12] - names of the months (optional)
         * @return  Date - the extracted date value or null if value is blank
         */
        parseDate: function (format, value, settings) {
            if (format == null || value == null) {
                throw "Invalid arguments";
            }

            value = (typeof value === "object" ? value.toString() : value + "");
            if (value === "") {
                return null;
            }

            var iFormat, dim, extra,
                iValue = 0,
                shortYearCutoffTemp = (settings ? settings.shortYearCutoff : null) || this._defaults.shortYearCutoff,
                shortYearCutoff = (typeof shortYearCutoffTemp !== "string" ? shortYearCutoffTemp :
                new Date().getFullYear() % 100 + parseInt(shortYearCutoffTemp, 10)),
                dayNamesShort = (settings ? settings.dayNamesShort : null) || this._defaults.dayNamesShort,
                dayNames = (settings ? settings.dayNames : null) || this._defaults.dayNames,
                monthNamesShort = (settings ? settings.monthNamesShort : null) || this._defaults.monthNamesShort,
                monthNames = (settings ? settings.monthNames : null) || this._defaults.monthNames,
                year = -1,
                month = -1,
                day = -1,
                doy = -1,
                literal = false,
                date,
                // Check whether a format character is doubled
                lookAhead = function(match) {
                    var matches = (iFormat + 1 < format.length && format.charAt(iFormat + 1) === match);
                    if (matches) {
                        iFormat++;
                    }
                    return matches;
                },
                // Extract a number from the string value
                getNumber = function(match) {
                    var isDoubled = lookAhead(match),
                        size = (match === "@" ? 14 : (match === "!" ? 20 :
                            (match === "y" && isDoubled ? 4 : (match === "o" ? 3 : 2)))),
                        digits = new RegExp("^\\d{1," + size + "}"),
                        num = value.substring(iValue).match(digits);
                    if (!num) {
                        throw "Missing number at position " + iValue;
                    }
                    iValue += num[0].length;
                    return parseInt(num[0], 10);
                },
                // Extract a name from the string value and convert to an index
                getName = function(match, shortNames, longNames) {
                    var index = -1,
                        names = $.map(lookAhead(match) ? longNames : shortNames, function (v, k) {
                            return [ [k, v] ];
                        }).sort(function (a, b) {
                            return -(a[1].length - b[1].length);
                        });

                    $.each(names, function (i, pair) {
                        var name = pair[1];
                        if (value.substr(iValue, name.length).toLowerCase() === name.toLowerCase()) {
                            index = pair[0];
                            iValue += name.length;
                            return false;
                        }
                    });
                    if (index !== -1) {
                        return index + 1;
                    } else {
                        throw "Unknown name at position " + iValue;
                    }
                },
                // Confirm that a literal character matches the string value
                checkLiteral = function() {
                    if (value.charAt(iValue) !== format.charAt(iFormat)) {
                        throw "Unexpected literal at position " + iValue;
                    }
                    iValue++;
                };

            for (iFormat = 0; iFormat < format.length; iFormat++) {
                if (literal) {
                    if (format.charAt(iFormat) === "'" && !lookAhead("'")) {
                        literal = false;
                    } else {
                        checkLiteral();
                    }
                } else {
                    switch (format.charAt(iFormat)) {
                        case "d":
                            day = getNumber("d");
                            break;
                        case "D":
                            getName("D", dayNamesShort, dayNames);
                            break;
                        case "o":
                            doy = getNumber("o");
                            break;
                        case "m":
                            month = getNumber("m");
                            break;
                        case "M":
                            month = getName("M", monthNamesShort, monthNames);
                            break;
                        case "y":
                            year = getNumber("y");
                            break;
                        case "@":
                            date = new Date(getNumber("@"));
                            year = date.getFullYear();
                            month = date.getMonth() + 1;
                            day = date.getDate();
                            break;
                        case "!":
                            date = new Date((getNumber("!") - this._ticksTo1970) / 10000);
                            year = date.getFullYear();
                            month = date.getMonth() + 1;
                            day = date.getDate();
                            break;
                        case "'":
                            if (lookAhead("'")){
                                checkLiteral();
                            } else {
                                literal = true;
                            }
                            break;
                        default:
                            checkLiteral();
                    }
                }
            }

            if (iValue < value.length){
                extra = value.substr(iValue);
                if (!/^\s+/.test(extra)) {
                    throw "Extra/unparsed characters found in date: " + extra;
                }
            }

            if (year === -1) {
                year = new Date().getFullYear();
            } else if (year < 100) {
                year += new Date().getFullYear() - new Date().getFullYear() % 100 +
                    (year <= shortYearCutoff ? 0 : -100);
            }

            if (doy > -1) {
                month = 1;
                day = doy;
                do {
                    dim = this._getDaysInMonth(year, month - 1);
                    if (day <= dim) {
                        break;
                    }
                    month++;
                    day -= dim;
                } while (true);
            }

            date = this._daylightSavingAdjust(new Date(year, month - 1, day));
            if (date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day) {
                throw "Invalid date"; // E.g. 31/02/00
            }
            return date;
        },

        /* Standard date formats. */
        ATOM: "yy-mm-dd", // RFC 3339 (ISO 8601)
        COOKIE: "D, dd M yy",
        ISO_8601: "yy-mm-dd",
        RFC_822: "D, d M y",
        RFC_850: "DD, dd-M-y",
        RFC_1036: "D, d M y",
        RFC_1123: "D, d M yy",
        RFC_2822: "D, d M yy",
        RSS: "D, d M y", // RFC 822
        TICKS: "!",
        TIMESTAMP: "@",
        W3C: "yy-mm-dd", // ISO 8601

        _ticksTo1970: (((1970 - 1) * 365 + Math.floor(1970 / 4) - Math.floor(1970 / 100) +
        Math.floor(1970 / 400)) * 24 * 60 * 60 * 10000000),

        /* Format a date object into a string value.
         * The format can be combinations of the following:
         * d  - day of month (no leading zero)
         * dd - day of month (two digit)
         * o  - day of year (no leading zeros)
         * oo - day of year (three digit)
         * D  - day name short
         * DD - day name long
         * m  - month of year (no leading zero)
         * mm - month of year (two digit)
         * M  - month name short
         * MM - month name long
         * y  - year (two digit)
         * yy - year (four digit)
         * @ - Unix timestamp (ms since 01/01/1970)
         * ! - Windows ticks (100ns since 01/01/0001)
         * "..." - literal text
         * '' - single quote
         *
         * @param  format string - the desired format of the date
         * @param  date Date - the date value to format
         * @param  settings Object - attributes include:
         *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
         *					dayNames		string[7] - names of the days from Sunday (optional)
         *					monthNamesShort string[12] - abbreviated names of the months (optional)
         *					monthNames		string[12] - names of the months (optional)
         * @return  string - the date in the above format
         */
        formatDate: function (format, date, settings) {
            if (!date) {
                return "";
            }

            var iFormat,
                dayNamesShort = (settings ? settings.dayNamesShort : null) || this._defaults.dayNamesShort,
                dayNames = (settings ? settings.dayNames : null) || this._defaults.dayNames,
                monthNamesShort = (settings ? settings.monthNamesShort : null) || this._defaults.monthNamesShort,
                monthNames = (settings ? settings.monthNames : null) || this._defaults.monthNames,
                // Check whether a format character is doubled
                lookAhead = function(match) {
                    var matches = (iFormat + 1 < format.length && format.charAt(iFormat + 1) === match);
                    if (matches) {
                        iFormat++;
                    }
                    return matches;
                },
                // Format a number, with leading zero if necessary
                formatNumber = function(match, value, len) {
                    var num = "" + value;
                    if (lookAhead(match)) {
                        while (num.length < len) {
                            num = "0" + num;
                        }
                    }
                    return num;
                },
                // Format a name, short or long as requested
                formatName = function(match, value, shortNames, longNames) {
                    return (lookAhead(match) ? longNames[value] : shortNames[value]);
                },
                output = "",
                literal = false;

            if (date) {
                for (iFormat = 0; iFormat < format.length; iFormat++) {
                    if (literal) {
                        if (format.charAt(iFormat) === "'" && !lookAhead("'")) {
                            literal = false;
                        } else {
                            output += format.charAt(iFormat);
                        }
                    } else {
                        switch (format.charAt(iFormat)) {
                            case "d":
                                output += formatNumber("d", date.getDate(), 2);
                                break;
                            case "D":
                                output += formatName("D", date.getDay(), dayNamesShort, dayNames);
                                break;
                            case "o":
                                output += formatNumber("o",
                                    Math.round((new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() - new Date(date.getFullYear(), 0, 0).getTime()) / 86400000), 3);
                                break;
                            case "m":
                                output += formatNumber("m", date.getMonth() + 1, 2);
                                break;
                            case "M":
                                output += formatName("M", date.getMonth(), monthNamesShort, monthNames);
                                break;
                            case "y":
                                output += (lookAhead("y") ? date.getFullYear() :
                                (date.getYear() % 100 < 10 ? "0" : "") + date.getYear() % 100);
                                break;
                            case "@":
                                output += date.getTime();
                                break;
                            case "!":
                                output += date.getTime() * 10000 + this._ticksTo1970;
                                break;
                            case "'":
                                if (lookAhead("'")) {
                                    output += "'";
                                } else {
                                    literal = true;
                                }
                                break;
                            default:
                                output += format.charAt(iFormat);
                        }
                    }
                }
            }
            return output;
        },

        /* Extract all possible characters from the date format. */
        _possibleChars: function (format) {
            var iFormat,
                chars = "",
                literal = false,
                // Check whether a format character is doubled
                lookAhead = function(match) {
                    var matches = (iFormat + 1 < format.length && format.charAt(iFormat + 1) === match);
                    if (matches) {
                        iFormat++;
                    }
                    return matches;
                };

            for (iFormat = 0; iFormat < format.length; iFormat++) {
                if (literal) {
                    if (format.charAt(iFormat) === "'" && !lookAhead("'")) {
                        literal = false;
                    } else {
                        chars += format.charAt(iFormat);
                    }
                } else {
                    switch (format.charAt(iFormat)) {
                        case "d": case "m": case "y": case "@":
                        chars += "0123456789";
                        break;
                        case "D": case "M":
                        return null; // Accept anything
                        case "'":
                            if (lookAhead("'")) {
                                chars += "'";
                            } else {
                                literal = true;
                            }
                            break;
                        default:
                            chars += format.charAt(iFormat);
                    }
                }
            }
            return chars;
        },

        /* Get a setting value, defaulting if necessary. */
        _get: function(inst, name) {
            return inst.settings[name] !== undefined ?
                inst.settings[name] : this._defaults[name];
        },

        /* Parse existing date and initialise date picker. */
        _setDateFromField: function(inst, noDefault) {
            if (inst.input.val() === inst.lastVal) {
                return;
            }

            var dateFormat = this._get(inst, "dateFormat"),
                dates = inst.lastVal = inst.input ? inst.input.val() : null,
                defaultDate = this._getDefaultDate(inst),
                date = defaultDate,
                settings = this._getFormatConfig(inst);

            try {
                date = this.parseDate(dateFormat, dates, settings) || defaultDate;
            } catch (event) {
                dates = (noDefault ? "" : dates);
            }
            inst.selectedDay = date.getDate();
            inst.drawMonth = inst.selectedMonth = date.getMonth();
            inst.drawYear = inst.selectedYear = date.getFullYear();
            inst.currentDay = (dates ? date.getDate() : 0);
            inst.currentMonth = (dates ? date.getMonth() : 0);
            inst.currentYear = (dates ? date.getFullYear() : 0);
            this._adjustInstDate(inst);
        },

        /* Retrieve the default date shown on opening. */
        _getDefaultDate: function(inst) {
            return this._restrictMinMax(inst,
                this._determineDate(inst, this._get(inst, "defaultDate"), new Date()));
        },

        /* A date may be specified as an exact value or a relative one. */
        _determineDate: function(inst, date, defaultDate) {
            var offsetNumeric = function(offset) {
                    var date = new Date();
                    date.setDate(date.getDate() + offset);
                    return date;
                },
                offsetString = function(offset) {
                    try {
                        return $.datepicker.parseDate($.datepicker._get(inst, "dateFormat"),
                            offset, $.datepicker._getFormatConfig(inst));
                    }
                    catch (e) {
                        // Ignore
                    }

                    var date = (offset.toLowerCase().match(/^c/) ?
                                $.datepicker._getDate(inst) : null) || new Date(),
                        year = date.getFullYear(),
                        month = date.getMonth(),
                        day = date.getDate(),
                        pattern = /([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,
                        matches = pattern.exec(offset);

                    while (matches) {
                        switch (matches[2] || "d") {
                            case "d" : case "D" :
                            day += parseInt(matches[1],10); break;
                            case "w" : case "W" :
                            day += parseInt(matches[1],10) * 7; break;
                            case "m" : case "M" :
                            month += parseInt(matches[1],10);
                            day = Math.min(day, $.datepicker._getDaysInMonth(year, month));
                            break;
                            case "y": case "Y" :
                            year += parseInt(matches[1],10);
                            day = Math.min(day, $.datepicker._getDaysInMonth(year, month));
                            break;
                        }
                        matches = pattern.exec(offset);
                    }
                    return new Date(year, month, day);
                },
                newDate = (date == null || date === "" ? defaultDate : (typeof date === "string" ? offsetString(date) :
                    (typeof date === "number" ? (isNaN(date) ? defaultDate : offsetNumeric(date)) : new Date(date.getTime()))));

            newDate = (newDate && newDate.toString() === "Invalid Date" ? defaultDate : newDate);
            if (newDate) {
                newDate.setHours(0);
                newDate.setMinutes(0);
                newDate.setSeconds(0);
                newDate.setMilliseconds(0);
            }
            return this._daylightSavingAdjust(newDate);
        },

        /* Handle switch to/from daylight saving.
         * Hours may be non-zero on daylight saving cut-over:
         * > 12 when midnight changeover, but then cannot generate
         * midnight datetime, so jump to 1AM, otherwise reset.
         * @param  date  (Date) the date to check
         * @return  (Date) the corrected date
         */
        _daylightSavingAdjust: function(date) {
            if (!date) {
                return null;
            }
            date.setHours(date.getHours() > 12 ? date.getHours() + 2 : 0);
            return date;
        },

        /* Set the date(s) directly. */
        _setDate: function(inst, date, noChange) {
            var clear = !date,
                origMonth = inst.selectedMonth,
                origYear = inst.selectedYear,
                newDate = this._restrictMinMax(inst, this._determineDate(inst, date, new Date()));

            inst.selectedDay = inst.currentDay = newDate.getDate();
            inst.drawMonth = inst.selectedMonth = inst.currentMonth = newDate.getMonth();
            inst.drawYear = inst.selectedYear = inst.currentYear = newDate.getFullYear();
            if ((origMonth !== inst.selectedMonth || origYear !== inst.selectedYear) && !noChange) {
                this._notifyChange(inst);
            }
            this._adjustInstDate(inst);
            if (inst.input) {
                inst.input.val(clear ? "" : this._formatDate(inst));
            }
        },

        /* Retrieve the date(s) directly. */
        _getDate: function(inst) {
            var startDate = (!inst.currentYear || (inst.input && inst.input.val() === "") ? null :
                this._daylightSavingAdjust(new Date(
                    inst.currentYear, inst.currentMonth, inst.currentDay)));
            return startDate;
        },

        /* Attach the onxxx handlers.  These are declared statically so
         * they work with static code transformers like Caja.
         */
        _attachHandlers: function(inst) {
            var stepMonths = this._get(inst, "stepMonths"),
                id = "#" + inst.id.replace( /\\\\/g, "\\" );
            inst.dpDiv.find("[data-handler]").map(function () {
                var handler = {
                    prev: function () {
                        window["DP_jQuery_" + dpuuid].datepicker._adjustDate(id, -stepMonths, "M");
                    },
                    next: function () {
                        window["DP_jQuery_" + dpuuid].datepicker._adjustDate(id, +stepMonths, "M");
                    },
                    hide: function () {
                        window["DP_jQuery_" + dpuuid].datepicker._hideDatepicker();
                    },
                    today: function () {
                        window["DP_jQuery_" + dpuuid].datepicker._gotoToday(id);
                    },
                    selectDay: function () {
                        window["DP_jQuery_" + dpuuid].datepicker._selectDay(id, +this.getAttribute("data-month"), +this.getAttribute("data-year"), this);
                        return false;
                    },
                    selectMonth: function () {
                        window["DP_jQuery_" + dpuuid].datepicker._selectMonthYear(id, this, "M");
                        return false;
                    },
                    selectYear: function () {
                        window["DP_jQuery_" + dpuuid].datepicker._selectMonthYear(id, this, "Y");
                        return false;
                    }
                };
                $(this).bind(this.getAttribute("data-event"), handler[this.getAttribute("data-handler")]);
            });
        },

        /* Generate the HTML for the current state of the date picker. */
        _generateHTML: function(inst) {
            var maxDraw, prevText, prev, nextText, next, currentText, gotoDate,
                controls, buttonPanel, firstDay, showWeek, dayNames, dayNamesMin,
                monthNames, monthNamesShort, beforeShowDay, showOtherMonths,
                selectOtherMonths, defaultDate, html, dow, row, group, col, selectedDate,
                cornerClass, calender, thead, day, daysInMonth, leadDays, curRows, numRows,
                printDate, dRow, tbody, daySettings, otherMonth, unselectable,
                tempDate = new Date(),
                today = this._daylightSavingAdjust(
                    new Date(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate())), // clear time
                isRTL = this._get(inst, "isRTL"),
                showButtonPanel = this._get(inst, "showButtonPanel"),
                hideIfNoPrevNext = this._get(inst, "hideIfNoPrevNext"),
                navigationAsDateFormat = this._get(inst, "navigationAsDateFormat"),
                numMonths = this._getNumberOfMonths(inst),
                showCurrentAtPos = this._get(inst, "showCurrentAtPos"),
                stepMonths = this._get(inst, "stepMonths"),
                isMultiMonth = (numMonths[0] !== 1 || numMonths[1] !== 1),
                currentDate = this._daylightSavingAdjust((!inst.currentDay ? new Date(9999, 9, 9) :
                    new Date(inst.currentYear, inst.currentMonth, inst.currentDay))),
                minDate = this._getMinMaxDate(inst, "min"),
                maxDate = this._getMinMaxDate(inst, "max"),
                drawMonth = inst.drawMonth - showCurrentAtPos,
                drawYear = inst.drawYear;

            if (drawMonth < 0) {
                drawMonth += 12;
                drawYear--;
            }
            if (maxDate) {
                maxDraw = this._daylightSavingAdjust(new Date(maxDate.getFullYear(),
                    maxDate.getMonth() - (numMonths[0] * numMonths[1]) + 1, maxDate.getDate()));
                maxDraw = (minDate && maxDraw < minDate ? minDate : maxDraw);
                while (this._daylightSavingAdjust(new Date(drawYear, drawMonth, 1)) > maxDraw) {
                    drawMonth--;
                    if (drawMonth < 0) {
                        drawMonth = 11;
                        drawYear--;
                    }
                }
            }
            inst.drawMonth = drawMonth;
            inst.drawYear = drawYear;

            prevText = this._get(inst, "prevText");
            prevText = (!navigationAsDateFormat ? prevText : this.formatDate(prevText,
                this._daylightSavingAdjust(new Date(drawYear, drawMonth - stepMonths, 1)),
                this._getFormatConfig(inst)));

            prev = (this._canAdjustMonth(inst, -1, drawYear, drawMonth) ?
            "<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click'" +
            " title='" + prevText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "e" : "w") + "'>" + prevText + "</span></a>" :
                (hideIfNoPrevNext ? "" : "<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='"+ prevText +"'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "e" : "w") + "'>" + prevText + "</span></a>"));

            nextText = this._get(inst, "nextText");
            nextText = (!navigationAsDateFormat ? nextText : this.formatDate(nextText,
                this._daylightSavingAdjust(new Date(drawYear, drawMonth + stepMonths, 1)),
                this._getFormatConfig(inst)));

            next = (this._canAdjustMonth(inst, +1, drawYear, drawMonth) ?
            "<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click'" +
            " title='" + nextText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "w" : "e") + "'>" + nextText + "</span></a>" :
                (hideIfNoPrevNext ? "" : "<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='"+ nextText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "w" : "e") + "'>" + nextText + "</span></a>"));

            currentText = this._get(inst, "currentText");
            gotoDate = (this._get(inst, "gotoCurrent") && inst.currentDay ? currentDate : today);
            currentText = (!navigationAsDateFormat ? currentText :
                this.formatDate(currentText, gotoDate, this._getFormatConfig(inst)));

            controls = (!inst.inline ? "<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>" +
            this._get(inst, "closeText") + "</button>" : "");

            buttonPanel = (showButtonPanel) ? "<div class='ui-datepicker-buttonpane ui-widget-content'>" + (isRTL ? controls : "") +
            (this._isInRange(inst, gotoDate) ? "<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'" +
            ">" + currentText + "</button>" : "") + (isRTL ? "" : controls) + "</div>" : "";

            firstDay = parseInt(this._get(inst, "firstDay"),10);
            firstDay = (isNaN(firstDay) ? 0 : firstDay);

            showWeek = this._get(inst, "showWeek");
            dayNames = this._get(inst, "dayNames");
            dayNamesMin = this._get(inst, "dayNamesMin");
            monthNames = this._get(inst, "monthNames");
            monthNamesShort = this._get(inst, "monthNamesShort");
            beforeShowDay = this._get(inst, "beforeShowDay");
            showOtherMonths = this._get(inst, "showOtherMonths");
            selectOtherMonths = this._get(inst, "selectOtherMonths");
            defaultDate = this._getDefaultDate(inst);
            html = "";
            dow;
            for (row = 0; row < numMonths[0]; row++) {
                group = "";
                this.maxRows = 4;
                for (col = 0; col < numMonths[1]; col++) {
                    selectedDate = this._daylightSavingAdjust(new Date(drawYear, drawMonth, inst.selectedDay));
                    cornerClass = " ui-corner-all";
                    calender = "";
                    if (isMultiMonth) {
                        calender += "<div class='ui-datepicker-group";
                        if (numMonths[1] > 1) {
                            switch (col) {
                                case 0: calender += " ui-datepicker-group-first";
                                    cornerClass = " ui-corner-" + (isRTL ? "right" : "left"); break;
                                case numMonths[1]-1: calender += " ui-datepicker-group-last";
                                    cornerClass = " ui-corner-" + (isRTL ? "left" : "right"); break;
                                default: calender += " ui-datepicker-group-middle"; cornerClass = ""; break;
                            }
                        }
                        calender += "'>";
                    }
                    calender += "<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix" + cornerClass + "'>" +
                        (/all|left/.test(cornerClass) && row === 0 ? (isRTL ? next : prev) : "") +
                        (/all|right/.test(cornerClass) && row === 0 ? (isRTL ? prev : next) : "") +
                        this._generateMonthYearHeader(inst, drawMonth, drawYear, minDate, maxDate,
                            row > 0 || col > 0, monthNames, monthNamesShort) + // draw month headers
                        "</div><table class='ui-datepicker-calendar'><thead>" +
                        "<tr>";
                    thead = (showWeek ? "<th class='ui-datepicker-week-col'>" + this._get(inst, "weekHeader") + "</th>" : "");
                    for (dow = 0; dow < 7; dow++) { // days of the week
                        day = (dow + firstDay) % 7;
                        thead += "<th" + ((dow + firstDay + 6) % 7 >= 5 ? " class='ui-datepicker-week-end'" : "") + ">" +
                            "<span title='" + dayNames[day] + "'>" + dayNamesMin[day] + "</span></th>";
                    }
                    calender += thead + "</tr></thead><tbody>";
                    daysInMonth = this._getDaysInMonth(drawYear, drawMonth);
                    if (drawYear === inst.selectedYear && drawMonth === inst.selectedMonth) {
                        inst.selectedDay = Math.min(inst.selectedDay, daysInMonth);
                    }
                    leadDays = (this._getFirstDayOfMonth(drawYear, drawMonth) - firstDay + 7) % 7;
                    curRows = Math.ceil((leadDays + daysInMonth) / 7); // calculate the number of rows to generate
                    numRows = (isMultiMonth ? this.maxRows > curRows ? this.maxRows : curRows : curRows); //If multiple months, use the higher number of rows (see #7043)
                    this.maxRows = numRows;
                    printDate = this._daylightSavingAdjust(new Date(drawYear, drawMonth, 1 - leadDays));
                    for (dRow = 0; dRow < numRows; dRow++) { // create date picker rows
                        calender += "<tr>";
                        tbody = (!showWeek ? "" : "<td class='ui-datepicker-week-col'>" +
                        this._get(inst, "calculateWeek")(printDate) + "</td>");
                        for (dow = 0; dow < 7; dow++) { // create date picker days
                            daySettings = (beforeShowDay ?
                                beforeShowDay.apply((inst.input ? inst.input[0] : null), [printDate]) : [true, ""]);
                            otherMonth = (printDate.getMonth() !== drawMonth);
                            unselectable = (otherMonth && !selectOtherMonths) || !daySettings[0] ||
                                (minDate && printDate < minDate) || (maxDate && printDate > maxDate);
                            tbody += "<td class='" +
                                ((dow + firstDay + 6) % 7 >= 5 ? " ui-datepicker-week-end" : "") + // highlight weekends
                                (otherMonth ? " ui-datepicker-other-month" : "") + // highlight days from other months
                                ((printDate.getTime() === selectedDate.getTime() && drawMonth === inst.selectedMonth && inst._keyEvent) || // user pressed key
                                (defaultDate.getTime() === printDate.getTime() && defaultDate.getTime() === selectedDate.getTime()) ?
                                    // or defaultDate is current printedDate and defaultDate is selectedDate
                                " " + this._dayOverClass : "") + // highlight selected day
                                (unselectable ? " " + this._unselectableClass + " ui-state-disabled": "") +  // highlight unselectable days
                                (otherMonth && !showOtherMonths ? "" : " " + daySettings[1] + // highlight custom dates
                                (printDate.getTime() === currentDate.getTime() ? " " + this._currentClass : "") + // highlight selected day
                                (printDate.getTime() === today.getTime() ? " ui-datepicker-today" : "")) + "'" + // highlight today (if different)
                                ((!otherMonth || showOtherMonths) && daySettings[2] ? " title='" + daySettings[2].replace(/'/g, "&#39;") + "'" : "") + // cell title
                                (unselectable ? "" : " data-handler='selectDay' data-event='click' data-month='" + printDate.getMonth() + "' data-year='" + printDate.getFullYear() + "'") + ">" + // actions
                                (otherMonth && !showOtherMonths ? "&#xa0;" : // display for other months
                                    (unselectable ? "<span class='ui-state-default'>" + printDate.getDate() + "</span>" : "<a class='ui-state-default" +
                                    (printDate.getTime() === today.getTime() ? " ui-state-highlight" : "") +
                                    (printDate.getTime() === currentDate.getTime() ? " ui-state-active" : "") + // highlight selected day
                                    (otherMonth ? " ui-priority-secondary" : "") + // distinguish dates from other months
                                    "' href='#'>" + printDate.getDate() + "</a>")) + "</td>"; // display selectable date
                            printDate.setDate(printDate.getDate() + 1);
                            printDate = this._daylightSavingAdjust(printDate);
                        }
                        calender += tbody + "</tr>";
                    }
                    drawMonth++;
                    if (drawMonth > 11) {
                        drawMonth = 0;
                        drawYear++;
                    }
                    calender += "</tbody></table>" + (isMultiMonth ? "</div>" +
                        ((numMonths[0] > 0 && col === numMonths[1]-1) ? "<div class='ui-datepicker-row-break'></div>" : "") : "");
                    group += calender;
                }
                html += group;
            }
            html += buttonPanel;
            inst._keyEvent = false;
            return html;
        },

        /* Generate the month and year header. */
        _generateMonthYearHeader: function(inst, drawMonth, drawYear, minDate, maxDate,
                                           secondary, monthNames, monthNamesShort) {

            var inMinYear, inMaxYear, month, years, thisYear, determineYear, year, endYear,
                changeMonth = this._get(inst, "changeMonth"),
                changeYear = this._get(inst, "changeYear"),
                showMonthAfterYear = this._get(inst, "showMonthAfterYear"),
                html = "<div class='ui-datepicker-title'>",
                monthHtml = "";

            // month selection
            if (secondary || !changeMonth) {
                monthHtml += "<span class='ui-datepicker-month'>" + monthNames[drawMonth] + "</span>";
            } else {
                inMinYear = (minDate && minDate.getFullYear() === drawYear);
                inMaxYear = (maxDate && maxDate.getFullYear() === drawYear);
                monthHtml += "<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>";
                for ( month = 0; month < 12; month++) {
                    if ((!inMinYear || month >= minDate.getMonth()) && (!inMaxYear || month <= maxDate.getMonth())) {
                        monthHtml += "<option value='" + month + "'" +
                            (month === drawMonth ? " selected='selected'" : "") +
                            ">" + monthNamesShort[month] + "</option>";
                    }
                }
                monthHtml += "</select>";
            }

            if (!showMonthAfterYear) {
                html += monthHtml + (secondary || !(changeMonth && changeYear) ? "&#xa0;" : "");
            }

            // year selection
            if ( !inst.yearshtml ) {
                inst.yearshtml = "";
                if (secondary || !changeYear) {
                    html += "<span class='ui-datepicker-year'>" + drawYear + "</span>";
                } else {
                    // determine range of years to display
                    years = this._get(inst, "yearRange").split(":");
                    thisYear = new Date().getFullYear();
                    determineYear = function(value) {
                        var year = (value.match(/c[+\-].*/) ? drawYear + parseInt(value.substring(1), 10) :
                            (value.match(/[+\-].*/) ? thisYear + parseInt(value, 10) :
                                parseInt(value, 10)));
                        return (isNaN(year) ? thisYear : year);
                    };
                    year = determineYear(years[0]);
                    endYear = Math.max(year, determineYear(years[1] || ""));
                    year = (minDate ? Math.max(year, minDate.getFullYear()) : year);
                    endYear = (maxDate ? Math.min(endYear, maxDate.getFullYear()) : endYear);
                    inst.yearshtml += "<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";
                    for (; year <= endYear; year++) {
                        inst.yearshtml += "<option value='" + year + "'" +
                            (year === drawYear ? " selected='selected'" : "") +
                            ">" + year + "</option>";
                    }
                    inst.yearshtml += "</select>";

                    html += inst.yearshtml;
                    inst.yearshtml = null;
                }
            }

            html += this._get(inst, "yearSuffix");
            if (showMonthAfterYear) {
                html += (secondary || !(changeMonth && changeYear) ? "&#xa0;" : "") + monthHtml;
            }
            html += "</div>"; // Close datepicker_header
            return html;
        },

        /* Adjust one of the date sub-fields. */
        _adjustInstDate: function(inst, offset, period) {
            var year = inst.drawYear + (period === "Y" ? offset : 0),
                month = inst.drawMonth + (period === "M" ? offset : 0),
                day = Math.min(inst.selectedDay, this._getDaysInMonth(year, month)) + (period === "D" ? offset : 0),
                date = this._restrictMinMax(inst, this._daylightSavingAdjust(new Date(year, month, day)));

            inst.selectedDay = date.getDate();
            inst.drawMonth = inst.selectedMonth = date.getMonth();
            inst.drawYear = inst.selectedYear = date.getFullYear();
            if (period === "M" || period === "Y") {
                this._notifyChange(inst);
            }
        },

        /* Ensure a date is within any min/max bounds. */
        _restrictMinMax: function(inst, date) {
            var minDate = this._getMinMaxDate(inst, "min"),
                maxDate = this._getMinMaxDate(inst, "max"),
                newDate = (minDate && date < minDate ? minDate : date);
            return (maxDate && newDate > maxDate ? maxDate : newDate);
        },

        /* Notify change of month/year. */
        _notifyChange: function(inst) {
            var onChange = this._get(inst, "onChangeMonthYear");
            if (onChange) {
                onChange.apply((inst.input ? inst.input[0] : null),
                    [inst.selectedYear, inst.selectedMonth + 1, inst]);
            }
        },

        /* Determine the number of months to show. */
        _getNumberOfMonths: function(inst) {
            var numMonths = this._get(inst, "numberOfMonths");
            return (numMonths == null ? [1, 1] : (typeof numMonths === "number" ? [1, numMonths] : numMonths));
        },

        /* Determine the current maximum date - ensure no time components are set. */
        _getMinMaxDate: function(inst, minMax) {
            return this._determineDate(inst, this._get(inst, minMax + "Date"), null);
        },

        /* Find the number of days in a given month. */
        _getDaysInMonth: function(year, month) {
            return 32 - this._daylightSavingAdjust(new Date(year, month, 32)).getDate();
        },

        /* Find the day of the week of the first of a month. */
        _getFirstDayOfMonth: function(year, month) {
            return new Date(year, month, 1).getDay();
        },

        /* Determines if we should allow a "next/prev" month display change. */
        _canAdjustMonth: function(inst, offset, curYear, curMonth) {
            var numMonths = this._getNumberOfMonths(inst),
                date = this._daylightSavingAdjust(new Date(curYear,
                    curMonth + (offset < 0 ? offset : numMonths[0] * numMonths[1]), 1));

            if (offset < 0) {
                date.setDate(this._getDaysInMonth(date.getFullYear(), date.getMonth()));
            }
            return this._isInRange(inst, date);
        },

        /* Is the given date in the accepted range? */
        _isInRange: function(inst, date) {
            var yearSplit, currentYear,
                minDate = this._getMinMaxDate(inst, "min"),
                maxDate = this._getMinMaxDate(inst, "max"),
                minYear = null,
                maxYear = null,
                years = this._get(inst, "yearRange");
            if (years){
                yearSplit = years.split(":");
                currentYear = new Date().getFullYear();
                minYear = parseInt(yearSplit[0], 10);
                maxYear = parseInt(yearSplit[1], 10);
                if ( yearSplit[0].match(/[+\-].*/) ) {
                    minYear += currentYear;
                }
                if ( yearSplit[1].match(/[+\-].*/) ) {
                    maxYear += currentYear;
                }
            }

            return ((!minDate || date.getTime() >= minDate.getTime()) &&
            (!maxDate || date.getTime() <= maxDate.getTime()) &&
            (!minYear || date.getFullYear() >= minYear) &&
            (!maxYear || date.getFullYear() <= maxYear));
        },

        /* Provide the configuration settings for formatting/parsing. */
        _getFormatConfig: function(inst) {
            var shortYearCutoff = this._get(inst, "shortYearCutoff");
            shortYearCutoff = (typeof shortYearCutoff !== "string" ? shortYearCutoff :
            new Date().getFullYear() % 100 + parseInt(shortYearCutoff, 10));
            return {shortYearCutoff: shortYearCutoff,
                dayNamesShort: this._get(inst, "dayNamesShort"), dayNames: this._get(inst, "dayNames"),
                monthNamesShort: this._get(inst, "monthNamesShort"), monthNames: this._get(inst, "monthNames")};
        },

        /* Format the given date for display. */
        _formatDate: function(inst, day, month, year) {
            if (!day) {
                inst.currentDay = inst.selectedDay;
                inst.currentMonth = inst.selectedMonth;
                inst.currentYear = inst.selectedYear;
            }
            var date = (day ? (typeof day === "object" ? day :
                this._daylightSavingAdjust(new Date(year, month, day))) :
                this._daylightSavingAdjust(new Date(inst.currentYear, inst.currentMonth, inst.currentDay)));
            return this.formatDate(this._get(inst, "dateFormat"), date, this._getFormatConfig(inst));
        }
    });

    /*
     * Bind hover events for datepicker elements.
     * Done via delegate so the binding only occurs once in the lifetime of the parent div.
     * Global instActive, set by _updateDatepicker allows the handlers to find their way back to the active picker.
     */
    function bindHover(dpDiv) {
        var selector = "button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";
        return dpDiv.delegate(selector, "mouseout", function() {
            $(this).removeClass("ui-state-hover");
            if (this.className.indexOf("ui-datepicker-prev") !== -1) {
                $(this).removeClass("ui-datepicker-prev-hover");
            }
            if (this.className.indexOf("ui-datepicker-next") !== -1) {
                $(this).removeClass("ui-datepicker-next-hover");
            }
        })
            .delegate(selector, "mouseover", function(){
                if (!$.datepicker._isDisabledDatepicker( instActive.inline ? dpDiv.parent()[0] : instActive.input[0])) {
                    $(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover");
                    $(this).addClass("ui-state-hover");
                    if (this.className.indexOf("ui-datepicker-prev") !== -1) {
                        $(this).addClass("ui-datepicker-prev-hover");
                    }
                    if (this.className.indexOf("ui-datepicker-next") !== -1) {
                        $(this).addClass("ui-datepicker-next-hover");
                    }
                }
            });
    }

    /* jQuery extend now ignores nulls! */
    function extendRemove(target, props) {
        $.extend(target, props);
        for (var name in props) {
            if (props[name] == null) {
                target[name] = props[name];
            }
        }
        return target;
    }

    /* Invoke the datepicker functionality.
     @param  options  string - a command, optionally followed by additional parameters or
     Object - settings for attaching new datepicker functionality
     @return  jQuery object */
    $.fn.datepicker = function(options){

        /* Verify an empty collection wasn't passed - Fixes #6976 */
        if ( !this.length ) {
            return this;
        }

        /* Initialise the date picker. */
        if (!$.datepicker.initialized) {
            $(document).mousedown($.datepicker._checkExternalClick);
            $.datepicker.initialized = true;
        }

        /* Append datepicker main container to body if not exist. */
        if ($("#"+$.datepicker._mainDivId).length === 0) {
            $("body").append($.datepicker.dpDiv);
        }

        var otherArgs = Array.prototype.slice.call(arguments, 1);
        if (typeof options === "string" && (options === "isDisabled" || options === "getDate" || options === "widget")) {
            return $.datepicker["_" + options + "Datepicker"].
            apply($.datepicker, [this[0]].concat(otherArgs));
        }
        if (options === "option" && arguments.length === 2 && typeof arguments[1] === "string") {
            return $.datepicker["_" + options + "Datepicker"].
            apply($.datepicker, [this[0]].concat(otherArgs));
        }
        return this.each(function() {
            typeof options === "string" ?
                $.datepicker["_" + options + "Datepicker"].
                apply($.datepicker, [this].concat(otherArgs)) :
                $.datepicker._attachDatepicker(this, options);
        });
    };

    $.datepicker = new Datepicker(); // singleton instance
    $.datepicker.initialized = false;
    $.datepicker.uuid = new Date().getTime();
    $.datepicker.version = "1.10.2";

// Workaround for #4055
// Add another global to avoid noConflict issues with inline event handlers
    window["DP_jQuery_" + dpuuid] = $;

})(jQuery);

(function( $, undefined ) {

    var sizeRelatedOptions = {
            buttons: true,
            height: true,
            maxHeight: true,
            maxWidth: true,
            minHeight: true,
            minWidth: true,
            width: true
        },
        resizableRelatedOptions = {
            maxHeight: true,
            maxWidth: true,
            minHeight: true,
            minWidth: true
        };

    $.widget( "ui.dialog", {
        version: "1.10.2",
        options: {
            appendTo: "body",
            autoOpen: true,
            buttons: [],
            closeOnEscape: true,
            closeText: "close",
            dialogClass: "",
            draggable: true,
            hide: null,
            height: "auto",
            maxHeight: null,
            maxWidth: null,
            minHeight: 150,
            minWidth: 150,
            modal: false,
            position: {
                my: "center",
                at: "center",
                of: window,
                collision: "fit",
                // Ensure the titlebar is always visible
                using: function( pos ) {
                    var topOffset = $( this ).css( pos ).offset().top;
                    if ( topOffset < 0 ) {
                        $( this ).css( "top", pos.top - topOffset );
                    }
                }
            },
            resizable: true,
            show: null,
            title: null,
            width: 300,

            // callbacks
            beforeClose: null,
            close: null,
            drag: null,
            dragStart: null,
            dragStop: null,
            focus: null,
            open: null,
            resize: null,
            resizeStart: null,
            resizeStop: null
        },

        _create: function() {
            this.originalCss = {
                display: this.element[0].style.display,
                width: this.element[0].style.width,
                minHeight: this.element[0].style.minHeight,
                maxHeight: this.element[0].style.maxHeight,
                height: this.element[0].style.height
            };
            this.originalPosition = {
                parent: this.element.parent(),
                index: this.element.parent().children().index( this.element )
            };
            this.originalTitle = this.element.attr("title");
            this.options.title = this.options.title || this.originalTitle;

            this._createWrapper();

            this.element
                .show()
                .removeAttr("title")
                .addClass("ui-dialog-content ui-widget-content")
                .appendTo( this.uiDialog );

            this._createTitlebar();
            this._createButtonPane();

            if ( this.options.draggable && $.fn.draggable ) {
                this._makeDraggable();
            }
            if ( this.options.resizable && $.fn.resizable ) {
                this._makeResizable();
            }

            this._isOpen = false;
        },

        _init: function() {
            if ( this.options.autoOpen ) {
                this.open();
            }
        },

        _appendTo: function() {
            var element = this.options.appendTo;
            if ( element && (element.jquery || element.nodeType) ) {
                return $( element );
            }
            return this.document.find( element || "body" ).eq( 0 );
        },

        _destroy: function() {
            var next,
                originalPosition = this.originalPosition;

            this._destroyOverlay();

            this.element
                .removeUniqueId()
                .removeClass("ui-dialog-content ui-widget-content")
                .css( this.originalCss )
                // Without detaching first, the following becomes really slow
                .detach();

            this.uiDialog.stop( true, true ).remove();

            if ( this.originalTitle ) {
                this.element.attr( "title", this.originalTitle );
            }

            next = originalPosition.parent.children().eq( originalPosition.index );
            // Don't try to place the dialog next to itself (#8613)
            if ( next.length && next[0] !== this.element[0] ) {
                next.before( this.element );
            } else {
                originalPosition.parent.append( this.element );
            }
        },

        widget: function() {
            return this.uiDialog;
        },

        disable: $.noop,
        enable: $.noop,

        close: function( event ) {
            var that = this;

            if ( !this._isOpen || this._trigger( "beforeClose", event ) === false ) {
                return;
            }

            this._isOpen = false;
            this._destroyOverlay();

            if ( !this.opener.filter(":focusable").focus().length ) {
                // Hiding a focused element doesn't trigger blur in WebKit
                // so in case we have nothing to focus on, explicitly blur the active element
                // https://bugs.webkit.org/show_bug.cgi?id=47182
                $( this.document[0].activeElement ).blur();
            }

            this._hide( this.uiDialog, this.options.hide, function() {
                that._trigger( "close", event );
            });
        },

        isOpen: function() {
            return this._isOpen;
        },

        moveToTop: function() {
            this._moveToTop();
        },

        _moveToTop: function( event, silent ) {
            var moved = !!this.uiDialog.nextAll(":visible").insertBefore( this.uiDialog ).length;
            if ( moved && !silent ) {
                this._trigger( "focus", event );
            }
            return moved;
        },

        open: function() {
            var that = this;
            if ( this._isOpen ) {
                if ( this._moveToTop() ) {
                    this._focusTabbable();
                }
                return;
            }

            this._isOpen = true;
            this.opener = $( this.document[0].activeElement );

            this._size();
            this._position();
            this._createOverlay();
            this._moveToTop( null, true );
            this._show( this.uiDialog, this.options.show, function() {
                that._focusTabbable();
                that._trigger("focus");
            });

            this._trigger("open");
        },

        _focusTabbable: function() {
            // Set focus to the first match:
            // 1. First element inside the dialog matching [autofocus]
            // 2. Tabbable element inside the content element
            // 3. Tabbable element inside the buttonpane
            // 4. The close button
            // 5. The dialog itself
            var hasFocus = this.element.find("[autofocus]");
            if ( !hasFocus.length ) {
                hasFocus = this.element.find(":tabbable");
            }
            if ( !hasFocus.length ) {
                hasFocus = this.uiDialogButtonPane.find(":tabbable");
            }
            if ( !hasFocus.length ) {
                hasFocus = this.uiDialogTitlebarClose.filter(":tabbable");
            }
            if ( !hasFocus.length ) {
                hasFocus = this.uiDialog;
            }
            hasFocus.eq( 0 ).focus();
        },

        _keepFocus: function( event ) {
            function checkFocus() {
                var activeElement = this.document[0].activeElement,
                    isActive = this.uiDialog[0] === activeElement ||
                        $.contains( this.uiDialog[0], activeElement );
                if ( !isActive ) {
                    this._focusTabbable();
                }
            }
            event.preventDefault();
            checkFocus.call( this );
            // support: IE
            // IE <= 8 doesn't prevent moving focus even with event.preventDefault()
            // so we check again later
            this._delay( checkFocus );
        },

        _createWrapper: function() {
            this.uiDialog = $("<div>")
                .addClass( "ui-dialog ui-widget ui-widget-content ui-corner-all ui-front " +
                    this.options.dialogClass )
                .hide()
                .attr({
                    // Setting tabIndex makes the div focusable
                    tabIndex: -1,
                    role: "dialog"
                })
                .appendTo( this._appendTo() );

            this._on( this.uiDialog, {
                keydown: function( event ) {
                    if ( this.options.closeOnEscape && !event.isDefaultPrevented() && event.keyCode &&
                        event.keyCode === $.ui.keyCode.ESCAPE ) {
                        event.preventDefault();
                        this.close( event );
                        return;
                    }

                    // prevent tabbing out of dialogs
                    if ( event.keyCode !== $.ui.keyCode.TAB ) {
                        return;
                    }
                    var tabbables = this.uiDialog.find(":tabbable"),
                        first = tabbables.filter(":first"),
                        last  = tabbables.filter(":last");

                    if ( ( event.target === last[0] || event.target === this.uiDialog[0] ) && !event.shiftKey ) {
                        first.focus( 1 );
                        event.preventDefault();
                    } else if ( ( event.target === first[0] || event.target === this.uiDialog[0] ) && event.shiftKey ) {
                        last.focus( 1 );
                        event.preventDefault();
                    }
                },
                mousedown: function( event ) {
                    if ( this._moveToTop( event ) ) {
                        this._focusTabbable();
                    }
                }
            });

            // We assume that any existing aria-describedby attribute means
            // that the dialog content is marked up properly
            // otherwise we brute force the content as the description
            if ( !this.element.find("[aria-describedby]").length ) {
                this.uiDialog.attr({
                    "aria-describedby": this.element.uniqueId().attr("id")
                });
            }
        },

        _createTitlebar: function() {
            var uiDialogTitle;

            this.uiDialogTitlebar = $("<div>")
                .addClass("ui-dialog-titlebar ui-widget-header ui-corner-all ui-helper-clearfix")
                .prependTo( this.uiDialog );
            this._on( this.uiDialogTitlebar, {
                mousedown: function( event ) {
                    // Don't prevent click on close button (#8838)
                    // Focusing a dialog that is partially scrolled out of view
                    // causes the browser to scroll it into view, preventing the click event
                    if ( !$( event.target ).closest(".ui-dialog-titlebar-close") ) {
                        // Dialog isn't getting focus when dragging (#8063)
                        this.uiDialog.focus();
                    }
                }
            });

            this.uiDialogTitlebarClose = $("<button></button>")
                .button({
                    label: this.options.closeText,
                    icons: {
                        primary: "ui-icon-closethick"
                    },
                    text: false
                })
                .addClass("ui-dialog-titlebar-close")
                .appendTo( this.uiDialogTitlebar );
            this._on( this.uiDialogTitlebarClose, {
                click: function( event ) {
                    event.preventDefault();
                    this.close( event );
                }
            });

            uiDialogTitle = $("<span>")
                .uniqueId()
                .addClass("ui-dialog-title")
                .prependTo( this.uiDialogTitlebar );
            this._title( uiDialogTitle );

            this.uiDialog.attr({
                "aria-labelledby": uiDialogTitle.attr("id")
            });
        },

        _title: function( title ) {
            if ( !this.options.title ) {
                title.html("&#160;");
            }
            title.text( this.options.title );
        },

        _createButtonPane: function() {
            this.uiDialogButtonPane = $("<div>")
                .addClass("ui-dialog-buttonpane ui-widget-content ui-helper-clearfix");

            this.uiButtonSet = $("<div>")
                .addClass("ui-dialog-buttonset")
                .appendTo( this.uiDialogButtonPane );

            this._createButtons();
        },

        _createButtons: function() {
            var that = this,
                buttons = this.options.buttons;

            // if we already have a button pane, remove it
            this.uiDialogButtonPane.remove();
            this.uiButtonSet.empty();

            if ( $.isEmptyObject( buttons ) || ($.isArray( buttons ) && !buttons.length) ) {
                this.uiDialog.removeClass("ui-dialog-buttons");
                return;
            }

            $.each( buttons, function( name, props ) {
                var click, buttonOptions;
                props = $.isFunction( props ) ?
                { click: props, text: name } :
                    props;
                // Default to a non-submitting button
                props = $.extend( { type: "button" }, props );
                // Change the context for the click callback to be the main element
                click = props.click;
                props.click = function() {
                    click.apply( that.element[0], arguments );
                };
                buttonOptions = {
                    icons: props.icons,
                    text: props.showText
                };
                delete props.icons;
                delete props.showText;
                $( "<button></button>", props )
                    .button( buttonOptions )
                    .appendTo( that.uiButtonSet );
            });
            this.uiDialog.addClass("ui-dialog-buttons");
            this.uiDialogButtonPane.appendTo( this.uiDialog );
        },

        _makeDraggable: function() {
            var that = this,
                options = this.options;

            function filteredUi( ui ) {
                return {
                    position: ui.position,
                    offset: ui.offset
                };
            }

            this.uiDialog.draggable({
                cancel: ".ui-dialog-content, .ui-dialog-titlebar-close",
                handle: ".ui-dialog-titlebar",
                containment: "document",
                start: function( event, ui ) {
                    $( this ).addClass("ui-dialog-dragging");
                    that._blockFrames();
                    that._trigger( "dragStart", event, filteredUi( ui ) );
                },
                drag: function( event, ui ) {
                    that._trigger( "drag", event, filteredUi( ui ) );
                },
                stop: function( event, ui ) {
                    options.position = [
                        ui.position.left - that.document.scrollLeft(),
                        ui.position.top - that.document.scrollTop()
                    ];
                    $( this ).removeClass("ui-dialog-dragging");
                    that._unblockFrames();
                    that._trigger( "dragStop", event, filteredUi( ui ) );
                }
            });
        },

        _makeResizable: function() {
            var that = this,
                options = this.options,
                handles = options.resizable,
                // .ui-resizable has position: relative defined in the stylesheet
                // but dialogs have to use absolute or fixed positioning
                position = this.uiDialog.css("position"),
                resizeHandles = typeof handles === "string" ?
                    handles	:
                    "n,e,s,w,se,sw,ne,nw";

            function filteredUi( ui ) {
                return {
                    originalPosition: ui.originalPosition,
                    originalSize: ui.originalSize,
                    position: ui.position,
                    size: ui.size
                };
            }

            this.uiDialog.resizable({
                cancel: ".ui-dialog-content",
                containment: "document",
                alsoResize: this.element,
                maxWidth: options.maxWidth,
                maxHeight: options.maxHeight,
                minWidth: options.minWidth,
                minHeight: this._minHeight(),
                handles: resizeHandles,
                start: function( event, ui ) {
                    $( this ).addClass("ui-dialog-resizing");
                    that._blockFrames();
                    that._trigger( "resizeStart", event, filteredUi( ui ) );
                },
                resize: function( event, ui ) {
                    that._trigger( "resize", event, filteredUi( ui ) );
                },
                stop: function( event, ui ) {
                    options.height = $( this ).height();
                    options.width = $( this ).width();
                    $( this ).removeClass("ui-dialog-resizing");
                    that._unblockFrames();
                    that._trigger( "resizeStop", event, filteredUi( ui ) );
                }
            })
                .css( "position", position );
        },

        _minHeight: function() {
            var options = this.options;

            return options.height === "auto" ?
                options.minHeight :
                Math.min( options.minHeight, options.height );
        },

        _position: function() {
            // Need to show the dialog to get the actual offset in the position plugin
            var isVisible = this.uiDialog.is(":visible");
            if ( !isVisible ) {
                this.uiDialog.show();
            }
            this.uiDialog.position( this.options.position );
            if ( !isVisible ) {
                this.uiDialog.hide();
            }
        },

        _setOptions: function( options ) {
            var that = this,
                resize = false,
                resizableOptions = {};

            $.each( options, function( key, value ) {
                that._setOption( key, value );

                if ( key in sizeRelatedOptions ) {
                    resize = true;
                }
                if ( key in resizableRelatedOptions ) {
                    resizableOptions[ key ] = value;
                }
            });

            if ( resize ) {
                this._size();
                this._position();
            }
            if ( this.uiDialog.is(":data(ui-resizable)") ) {
                this.uiDialog.resizable( "option", resizableOptions );
            }
        },

        _setOption: function( key, value ) {
            /*jshint maxcomplexity:15*/
            var isDraggable, isResizable,
                uiDialog = this.uiDialog;

            if ( key === "dialogClass" ) {
                uiDialog
                    .removeClass( this.options.dialogClass )
                    .addClass( value );
            }

            if ( key === "disabled" ) {
                return;
            }

            this._super( key, value );

            if ( key === "appendTo" ) {
                this.uiDialog.appendTo( this._appendTo() );
            }

            if ( key === "buttons" ) {
                this._createButtons();
            }

            if ( key === "closeText" ) {
                this.uiDialogTitlebarClose.button({
                    // Ensure that we always pass a string
                    label: "" + value
                });
            }

            if ( key === "draggable" ) {
                isDraggable = uiDialog.is(":data(ui-draggable)");
                if ( isDraggable && !value ) {
                    uiDialog.draggable("destroy");
                }

                if ( !isDraggable && value ) {
                    this._makeDraggable();
                }
            }

            if ( key === "position" ) {
                this._position();
            }

            if ( key === "resizable" ) {
                // currently resizable, becoming non-resizable
                isResizable = uiDialog.is(":data(ui-resizable)");
                if ( isResizable && !value ) {
                    uiDialog.resizable("destroy");
                }

                // currently resizable, changing handles
                if ( isResizable && typeof value === "string" ) {
                    uiDialog.resizable( "option", "handles", value );
                }

                // currently non-resizable, becoming resizable
                if ( !isResizable && value !== false ) {
                    this._makeResizable();
                }
            }

            if ( key === "title" ) {
                this._title( this.uiDialogTitlebar.find(".ui-dialog-title") );
            }
        },

        _size: function() {
            // If the user has resized the dialog, the .ui-dialog and .ui-dialog-content
            // divs will both have width and height set, so we need to reset them
            var nonContentHeight, minContentHeight, maxContentHeight,
                options = this.options;

            // Reset content sizing
            this.element.show().css({
                width: "auto",
                minHeight: 0,
                maxHeight: "none",
                height: 0
            });

            if ( options.minWidth > options.width ) {
                options.width = options.minWidth;
            }

            // reset wrapper sizing
            // determine the height of all the non-content elements
            nonContentHeight = this.uiDialog.css({
                height: "auto",
                width: options.width
            })
                .outerHeight();
            minContentHeight = Math.max( 0, options.minHeight - nonContentHeight );
            maxContentHeight = typeof options.maxHeight === "number" ?
                Math.max( 0, options.maxHeight - nonContentHeight ) :
                "none";

            if ( options.height === "auto" ) {
                this.element.css({
                    minHeight: minContentHeight,
                    maxHeight: maxContentHeight,
                    height: "auto"
                });
            } else {
                this.element.height( Math.max( 0, options.height - nonContentHeight ) );
            }

            if (this.uiDialog.is(":data(ui-resizable)") ) {
                this.uiDialog.resizable( "option", "minHeight", this._minHeight() );
            }
        },

        _blockFrames: function() {
            this.iframeBlocks = this.document.find( "iframe" ).map(function() {
                var iframe = $( this );

                return $( "<div>" )
                    .css({
                        position: "absolute",
                        width: iframe.outerWidth(),
                        height: iframe.outerHeight()
                    })
                    .appendTo( iframe.parent() )
                    .offset( iframe.offset() )[0];
            });
        },

        _unblockFrames: function() {
            if ( this.iframeBlocks ) {
                this.iframeBlocks.remove();
                delete this.iframeBlocks;
            }
        },

        _allowInteraction: function( event ) {
            if ( $( event.target ).closest(".ui-dialog").length ) {
                return true;
            }

            // TODO: Remove hack when datepicker implements
            // the .ui-front logic (#8989)
            return !!$( event.target ).closest(".ui-datepicker").length;
        },

        _createOverlay: function() {
            if ( !this.options.modal ) {
                return;
            }

            var that = this,
                widgetFullName = this.widgetFullName;
            if ( !$.ui.dialog.overlayInstances ) {
                // Prevent use of anchors and inputs.
                // We use a delay in case the overlay is created from an
                // event that we're going to be cancelling. (#2804)
                this._delay(function() {
                    // Handle .dialog().dialog("close") (#4065)
                    if ( $.ui.dialog.overlayInstances ) {
                        this.document.bind( "focusin.dialog", function( event ) {
                            if ( !that._allowInteraction( event ) ) {
                                event.preventDefault();
                                $(".ui-dialog:visible:last .ui-dialog-content")
                                    .data( widgetFullName )._focusTabbable();
                            }
                        });
                    }
                });
            }

            this.overlay = $("<div>")
                .addClass("ui-widget-overlay ui-front")
                .appendTo( this._appendTo() );
            this._on( this.overlay, {
                mousedown: "_keepFocus"
            });
            $.ui.dialog.overlayInstances++;
        },

        _destroyOverlay: function() {
            if ( !this.options.modal ) {
                return;
            }

            if ( this.overlay ) {
                $.ui.dialog.overlayInstances--;

                if ( !$.ui.dialog.overlayInstances ) {
                    this.document.unbind( "focusin.dialog" );
                }
                this.overlay.remove();
                this.overlay = null;
            }
        }
    });

    $.ui.dialog.overlayInstances = 0;

// DEPRECATED
    if ( $.uiBackCompat !== false ) {
        // position option with array notation
        // just override with old implementation
        $.widget( "ui.dialog", $.ui.dialog, {
            _position: function() {
                var position = this.options.position,
                    myAt = [],
                    offset = [ 0, 0 ],
                    isVisible;

                if ( position ) {
                    if ( typeof position === "string" || (typeof position === "object" && "0" in position ) ) {
                        myAt = position.split ? position.split(" ") : [ position[0], position[1] ];
                        if ( myAt.length === 1 ) {
                            myAt[1] = myAt[0];
                        }

                        $.each( [ "left", "top" ], function( i, offsetPosition ) {
                            if ( +myAt[ i ] === myAt[ i ] ) {
                                offset[ i ] = myAt[ i ];
                                myAt[ i ] = offsetPosition;
                            }
                        });

                        position = {
                            my: myAt[0] + (offset[0] < 0 ? offset[0] : "+" + offset[0]) + " " +
                            myAt[1] + (offset[1] < 0 ? offset[1] : "+" + offset[1]),
                            at: myAt.join(" ")
                        };
                    }

                    position = $.extend( {}, $.ui.dialog.prototype.options.position, position );
                } else {
                    position = $.ui.dialog.prototype.options.position;
                }

                // need to show the dialog to get the actual offset in the position plugin
                isVisible = this.uiDialog.is(":visible");
                if ( !isVisible ) {
                    this.uiDialog.show();
                }
                this.uiDialog.position( position );
                if ( !isVisible ) {
                    this.uiDialog.hide();
                }
            }
        });
    }

}( jQuery ) );

(function( $, undefined ) {

    var rvertical = /up|down|vertical/,
        rpositivemotion = /up|left|vertical|horizontal/;

    $.effects.effect.blind = function( o, done ) {
        // Create element
        var el = $( this ),
            props = [ "position", "top", "bottom", "left", "right", "height", "width" ],
            mode = $.effects.setMode( el, o.mode || "hide" ),
            direction = o.direction || "up",
            vertical = rvertical.test( direction ),
            ref = vertical ? "height" : "width",
            ref2 = vertical ? "top" : "left",
            motion = rpositivemotion.test( direction ),
            animation = {},
            show = mode === "show",
            wrapper, distance, margin;

        // if already wrapped, the wrapper's properties are my property. #6245
        if ( el.parent().is( ".ui-effects-wrapper" ) ) {
            $.effects.save( el.parent(), props );
        } else {
            $.effects.save( el, props );
        }
        el.show();
        wrapper = $.effects.createWrapper( el ).css({
            overflow: "hidden"
        });

        distance = wrapper[ ref ]();
        margin = parseFloat( wrapper.css( ref2 ) ) || 0;

        animation[ ref ] = show ? distance : 0;
        if ( !motion ) {
            el
                .css( vertical ? "bottom" : "right", 0 )
                .css( vertical ? "top" : "left", "auto" )
                .css({ position: "absolute" });

            animation[ ref2 ] = show ? margin : distance + margin;
        }

        // start at 0 if we are showing
        if ( show ) {
            wrapper.css( ref, 0 );
            if ( ! motion ) {
                wrapper.css( ref2, margin + distance );
            }
        }

        // Animate
        wrapper.animate( animation, {
            duration: o.duration,
            easing: o.easing,
            queue: false,
            complete: function() {
                if ( mode === "hide" ) {
                    el.hide();
                }
                $.effects.restore( el, props );
                $.effects.removeWrapper( el );
                done();
            }
        });

    };

})(jQuery);

(function( $, undefined ) {

    $.effects.effect.bounce = function( o, done ) {
        var el = $( this ),
            props = [ "position", "top", "bottom", "left", "right", "height", "width" ],

            // defaults:
            mode = $.effects.setMode( el, o.mode || "effect" ),
            hide = mode === "hide",
            show = mode === "show",
            direction = o.direction || "up",
            distance = o.distance,
            times = o.times || 5,

            // number of internal animations
            anims = times * 2 + ( show || hide ? 1 : 0 ),
            speed = o.duration / anims,
            easing = o.easing,

            // utility:
            ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
            motion = ( direction === "up" || direction === "left" ),
            i,
            upAnim,
            downAnim,

            // we will need to re-assemble the queue to stack our animations in place
            queue = el.queue(),
            queuelen = queue.length;

        // Avoid touching opacity to prevent clearType and PNG issues in IE
        if ( show || hide ) {
            props.push( "opacity" );
        }

        $.effects.save( el, props );
        el.show();
        $.effects.createWrapper( el ); // Create Wrapper

        // default distance for the BIGGEST bounce is the outer Distance / 3
        if ( !distance ) {
            distance = el[ ref === "top" ? "outerHeight" : "outerWidth" ]() / 3;
        }

        if ( show ) {
            downAnim = { opacity: 1 };
            downAnim[ ref ] = 0;

            // if we are showing, force opacity 0 and set the initial position
            // then do the "first" animation
            el.css( "opacity", 0 )
                .css( ref, motion ? -distance * 2 : distance * 2 )
                .animate( downAnim, speed, easing );
        }

        // start at the smallest distance if we are hiding
        if ( hide ) {
            distance = distance / Math.pow( 2, times - 1 );
        }

        downAnim = {};
        downAnim[ ref ] = 0;
        // Bounces up/down/left/right then back to 0 -- times * 2 animations happen here
        for ( i = 0; i < times; i++ ) {
            upAnim = {};
            upAnim[ ref ] = ( motion ? "-=" : "+=" ) + distance;

            el.animate( upAnim, speed, easing )
                .animate( downAnim, speed, easing );

            distance = hide ? distance * 2 : distance / 2;
        }

        // Last Bounce when Hiding
        if ( hide ) {
            upAnim = { opacity: 0 };
            upAnim[ ref ] = ( motion ? "-=" : "+=" ) + distance;

            el.animate( upAnim, speed, easing );
        }

        el.queue(function() {
            if ( hide ) {
                el.hide();
            }
            $.effects.restore( el, props );
            $.effects.removeWrapper( el );
            done();
        });

        // inject all the animations we just queued to be first in line (after "inprogress")
        if ( queuelen > 1) {
            queue.splice.apply( queue,
                [ 1, 0 ].concat( queue.splice( queuelen, anims + 1 ) ) );
        }
        el.dequeue();

    };

})(jQuery);

(function( $, undefined ) {

    $.effects.effect.clip = function( o, done ) {
        // Create element
        var el = $( this ),
            props = [ "position", "top", "bottom", "left", "right", "height", "width" ],
            mode = $.effects.setMode( el, o.mode || "hide" ),
            show = mode === "show",
            direction = o.direction || "vertical",
            vert = direction === "vertical",
            size = vert ? "height" : "width",
            position = vert ? "top" : "left",
            animation = {},
            wrapper, animate, distance;

        // Save & Show
        $.effects.save( el, props );
        el.show();

        // Create Wrapper
        wrapper = $.effects.createWrapper( el ).css({
            overflow: "hidden"
        });
        animate = ( el[0].tagName === "IMG" ) ? wrapper : el;
        distance = animate[ size ]();

        // Shift
        if ( show ) {
            animate.css( size, 0 );
            animate.css( position, distance / 2 );
        }

        // Create Animation Object:
        animation[ size ] = show ? distance : 0;
        animation[ position ] = show ? 0 : distance / 2;

        // Animate
        animate.animate( animation, {
            queue: false,
            duration: o.duration,
            easing: o.easing,
            complete: function() {
                if ( !show ) {
                    el.hide();
                }
                $.effects.restore( el, props );
                $.effects.removeWrapper( el );
                done();
            }
        });

    };

})(jQuery);

(function( $, undefined ) {

    $.effects.effect.drop = function( o, done ) {

        var el = $( this ),
            props = [ "position", "top", "bottom", "left", "right", "opacity", "height", "width" ],
            mode = $.effects.setMode( el, o.mode || "hide" ),
            show = mode === "show",
            direction = o.direction || "left",
            ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
            motion = ( direction === "up" || direction === "left" ) ? "pos" : "neg",
            animation = {
                opacity: show ? 1 : 0
            },
            distance;

        // Adjust
        $.effects.save( el, props );
        el.show();
        $.effects.createWrapper( el );

        distance = o.distance || el[ ref === "top" ? "outerHeight": "outerWidth" ]( true ) / 2;

        if ( show ) {
            el
                .css( "opacity", 0 )
                .css( ref, motion === "pos" ? -distance : distance );
        }

        // Animation
        animation[ ref ] = ( show ?
                ( motion === "pos" ? "+=" : "-=" ) :
                ( motion === "pos" ? "-=" : "+=" ) ) +
            distance;

        // Animate
        el.animate( animation, {
            queue: false,
            duration: o.duration,
            easing: o.easing,
            complete: function() {
                if ( mode === "hide" ) {
                    el.hide();
                }
                $.effects.restore( el, props );
                $.effects.removeWrapper( el );
                done();
            }
        });
    };

})(jQuery);

(function( $, undefined ) {

    $.effects.effect.explode = function( o, done ) {

        var rows = o.pieces ? Math.round( Math.sqrt( o.pieces ) ) : 3,
            cells = rows,
            el = $( this ),
            mode = $.effects.setMode( el, o.mode || "hide" ),
            show = mode === "show",

            // show and then visibility:hidden the element before calculating offset
            offset = el.show().css( "visibility", "hidden" ).offset(),

            // width and height of a piece
            width = Math.ceil( el.outerWidth() / cells ),
            height = Math.ceil( el.outerHeight() / rows ),
            pieces = [],

            // loop
            i, j, left, top, mx, my;

        // children animate complete:
        function childComplete() {
            pieces.push( this );
            if ( pieces.length === rows * cells ) {
                animComplete();
            }
        }

        // clone the element for each row and cell.
        for( i = 0; i < rows ; i++ ) { // ===>
            top = offset.top + i * height;
            my = i - ( rows - 1 ) / 2 ;

            for( j = 0; j < cells ; j++ ) { // |||
                left = offset.left + j * width;
                mx = j - ( cells - 1 ) / 2 ;

                // Create a clone of the now hidden main element that will be absolute positioned
                // within a wrapper div off the -left and -top equal to size of our pieces
                el
                    .clone()
                    .appendTo( "body" )
                    .wrap( "<div></div>" )
                    .css({
                        position: "absolute",
                        visibility: "visible",
                        left: -j * width,
                        top: -i * height
                    })

                    // select the wrapper - make it overflow: hidden and absolute positioned based on
                    // where the original was located +left and +top equal to the size of pieces
                    .parent()
                    .addClass( "ui-effects-explode" )
                    .css({
                        position: "absolute",
                        overflow: "hidden",
                        width: width,
                        height: height,
                        left: left + ( show ? mx * width : 0 ),
                        top: top + ( show ? my * height : 0 ),
                        opacity: show ? 0 : 1
                    }).animate({
                    left: left + ( show ? 0 : mx * width ),
                    top: top + ( show ? 0 : my * height ),
                    opacity: show ? 1 : 0
                }, o.duration || 500, o.easing, childComplete );
            }
        }

        function animComplete() {
            el.css({
                visibility: "visible"
            });
            $( pieces ).remove();
            if ( !show ) {
                el.hide();
            }
            done();
        }
    };

})(jQuery);

(function( $, undefined ) {

    $.effects.effect.fade = function( o, done ) {
        var el = $( this ),
            mode = $.effects.setMode( el, o.mode || "toggle" );

        el.animate({
            opacity: mode
        }, {
            queue: false,
            duration: o.duration,
            easing: o.easing,
            complete: done
        });
    };

})( jQuery );

(function( $, undefined ) {

    $.effects.effect.fold = function( o, done ) {

        // Create element
        var el = $( this ),
            props = [ "position", "top", "bottom", "left", "right", "height", "width" ],
            mode = $.effects.setMode( el, o.mode || "hide" ),
            show = mode === "show",
            hide = mode === "hide",
            size = o.size || 15,
            percent = /([0-9]+)%/.exec( size ),
            horizFirst = !!o.horizFirst,
            widthFirst = show !== horizFirst,
            ref = widthFirst ? [ "width", "height" ] : [ "height", "width" ],
            duration = o.duration / 2,
            wrapper, distance,
            animation1 = {},
            animation2 = {};

        $.effects.save( el, props );
        el.show();

        // Create Wrapper
        wrapper = $.effects.createWrapper( el ).css({
            overflow: "hidden"
        });
        distance = widthFirst ?
            [ wrapper.width(), wrapper.height() ] :
            [ wrapper.height(), wrapper.width() ];

        if ( percent ) {
            size = parseInt( percent[ 1 ], 10 ) / 100 * distance[ hide ? 0 : 1 ];
        }
        if ( show ) {
            wrapper.css( horizFirst ? {
                height: 0,
                width: size
            } : {
                height: size,
                width: 0
            });
        }

        // Animation
        animation1[ ref[ 0 ] ] = show ? distance[ 0 ] : size;
        animation2[ ref[ 1 ] ] = show ? distance[ 1 ] : 0;

        // Animate
        wrapper
            .animate( animation1, duration, o.easing )
            .animate( animation2, duration, o.easing, function() {
                if ( hide ) {
                    el.hide();
                }
                $.effects.restore( el, props );
                $.effects.removeWrapper( el );
                done();
            });

    };

})(jQuery);

(function( $, undefined ) {

    $.effects.effect.highlight = function( o, done ) {
        var elem = $( this ),
            props = [ "backgroundImage", "backgroundColor", "opacity" ],
            mode = $.effects.setMode( elem, o.mode || "show" ),
            animation = {
                backgroundColor: elem.css( "backgroundColor" )
            };

        if (mode === "hide") {
            animation.opacity = 0;
        }

        $.effects.save( elem, props );

        elem
            .show()
            .css({
                backgroundImage: "none",
                backgroundColor: o.color || "#ffff99"
            })
            .animate( animation, {
                queue: false,
                duration: o.duration,
                easing: o.easing,
                complete: function() {
                    if ( mode === "hide" ) {
                        elem.hide();
                    }
                    $.effects.restore( elem, props );
                    done();
                }
            });
    };

})(jQuery);

(function( $, undefined ) {

    $.effects.effect.pulsate = function( o, done ) {
        var elem = $( this ),
            mode = $.effects.setMode( elem, o.mode || "show" ),
            show = mode === "show",
            hide = mode === "hide",
            showhide = ( show || mode === "hide" ),

            // showing or hiding leaves of the "last" animation
            anims = ( ( o.times || 5 ) * 2 ) + ( showhide ? 1 : 0 ),
            duration = o.duration / anims,
            animateTo = 0,
            queue = elem.queue(),
            queuelen = queue.length,
            i;

        if ( show || !elem.is(":visible")) {
            elem.css( "opacity", 0 ).show();
            animateTo = 1;
        }

        // anims - 1 opacity "toggles"
        for ( i = 1; i < anims; i++ ) {
            elem.animate({
                opacity: animateTo
            }, duration, o.easing );
            animateTo = 1 - animateTo;
        }

        elem.animate({
            opacity: animateTo
        }, duration, o.easing);

        elem.queue(function() {
            if ( hide ) {
                elem.hide();
            }
            done();
        });

        // We just queued up "anims" animations, we need to put them next in the queue
        if ( queuelen > 1 ) {
            queue.splice.apply( queue,
                [ 1, 0 ].concat( queue.splice( queuelen, anims + 1 ) ) );
        }
        elem.dequeue();
    };

})(jQuery);

(function( $, undefined ) {

    $.effects.effect.puff = function( o, done ) {
        var elem = $( this ),
            mode = $.effects.setMode( elem, o.mode || "hide" ),
            hide = mode === "hide",
            percent = parseInt( o.percent, 10 ) || 150,
            factor = percent / 100,
            original = {
                height: elem.height(),
                width: elem.width(),
                outerHeight: elem.outerHeight(),
                outerWidth: elem.outerWidth()
            };

        $.extend( o, {
            effect: "scale",
            queue: false,
            fade: true,
            mode: mode,
            complete: done,
            percent: hide ? percent : 100,
            from: hide ?
                original :
            {
                height: original.height * factor,
                width: original.width * factor,
                outerHeight: original.outerHeight * factor,
                outerWidth: original.outerWidth * factor
            }
        });

        elem.effect( o );
    };

    $.effects.effect.scale = function( o, done ) {

        // Create element
        var el = $( this ),
            options = $.extend( true, {}, o ),
            mode = $.effects.setMode( el, o.mode || "effect" ),
            percent = parseInt( o.percent, 10 ) ||
                ( parseInt( o.percent, 10 ) === 0 ? 0 : ( mode === "hide" ? 0 : 100 ) ),
            direction = o.direction || "both",
            origin = o.origin,
            original = {
                height: el.height(),
                width: el.width(),
                outerHeight: el.outerHeight(),
                outerWidth: el.outerWidth()
            },
            factor = {
                y: direction !== "horizontal" ? (percent / 100) : 1,
                x: direction !== "vertical" ? (percent / 100) : 1
            };

        // We are going to pass this effect to the size effect:
        options.effect = "size";
        options.queue = false;
        options.complete = done;

        // Set default origin and restore for show/hide
        if ( mode !== "effect" ) {
            options.origin = origin || ["middle","center"];
            options.restore = true;
        }

        options.from = o.from || ( mode === "show" ? {
                height: 0,
                width: 0,
                outerHeight: 0,
                outerWidth: 0
            } : original );
        options.to = {
            height: original.height * factor.y,
            width: original.width * factor.x,
            outerHeight: original.outerHeight * factor.y,
            outerWidth: original.outerWidth * factor.x
        };

        // Fade option to support puff
        if ( options.fade ) {
            if ( mode === "show" ) {
                options.from.opacity = 0;
                options.to.opacity = 1;
            }
            if ( mode === "hide" ) {
                options.from.opacity = 1;
                options.to.opacity = 0;
            }
        }

        // Animate
        el.effect( options );

    };

    $.effects.effect.size = function( o, done ) {

        // Create element
        var original, baseline, factor,
            el = $( this ),
            props0 = [ "position", "top", "bottom", "left", "right", "width", "height", "overflow", "opacity" ],

            // Always restore
            props1 = [ "position", "top", "bottom", "left", "right", "overflow", "opacity" ],

            // Copy for children
            props2 = [ "width", "height", "overflow" ],
            cProps = [ "fontSize" ],
            vProps = [ "borderTopWidth", "borderBottomWidth", "paddingTop", "paddingBottom" ],
            hProps = [ "borderLeftWidth", "borderRightWidth", "paddingLeft", "paddingRight" ],

            // Set options
            mode = $.effects.setMode( el, o.mode || "effect" ),
            restore = o.restore || mode !== "effect",
            scale = o.scale || "both",
            origin = o.origin || [ "middle", "center" ],
            position = el.css( "position" ),
            props = restore ? props0 : props1,
            zero = {
                height: 0,
                width: 0,
                outerHeight: 0,
                outerWidth: 0
            };

        if ( mode === "show" ) {
            el.show();
        }
        original = {
            height: el.height(),
            width: el.width(),
            outerHeight: el.outerHeight(),
            outerWidth: el.outerWidth()
        };

        if ( o.mode === "toggle" && mode === "show" ) {
            el.from = o.to || zero;
            el.to = o.from || original;
        } else {
            el.from = o.from || ( mode === "show" ? zero : original );
            el.to = o.to || ( mode === "hide" ? zero : original );
        }

        // Set scaling factor
        factor = {
            from: {
                y: el.from.height / original.height,
                x: el.from.width / original.width
            },
            to: {
                y: el.to.height / original.height,
                x: el.to.width / original.width
            }
        };

        // Scale the css box
        if ( scale === "box" || scale === "both" ) {

            // Vertical props scaling
            if ( factor.from.y !== factor.to.y ) {
                props = props.concat( vProps );
                el.from = $.effects.setTransition( el, vProps, factor.from.y, el.from );
                el.to = $.effects.setTransition( el, vProps, factor.to.y, el.to );
            }

            // Horizontal props scaling
            if ( factor.from.x !== factor.to.x ) {
                props = props.concat( hProps );
                el.from = $.effects.setTransition( el, hProps, factor.from.x, el.from );
                el.to = $.effects.setTransition( el, hProps, factor.to.x, el.to );
            }
        }

        // Scale the content
        if ( scale === "content" || scale === "both" ) {

            // Vertical props scaling
            if ( factor.from.y !== factor.to.y ) {
                props = props.concat( cProps ).concat( props2 );
                el.from = $.effects.setTransition( el, cProps, factor.from.y, el.from );
                el.to = $.effects.setTransition( el, cProps, factor.to.y, el.to );
            }
        }

        $.effects.save( el, props );
        el.show();
        $.effects.createWrapper( el );
        el.css( "overflow", "hidden" ).css( el.from );

        // Adjust
        if (origin) { // Calculate baseline shifts
            baseline = $.effects.getBaseline( origin, original );
            el.from.top = ( original.outerHeight - el.outerHeight() ) * baseline.y;
            el.from.left = ( original.outerWidth - el.outerWidth() ) * baseline.x;
            el.to.top = ( original.outerHeight - el.to.outerHeight ) * baseline.y;
            el.to.left = ( original.outerWidth - el.to.outerWidth ) * baseline.x;
        }
        el.css( el.from ); // set top & left

        // Animate
        if ( scale === "content" || scale === "both" ) { // Scale the children

            // Add margins/font-size
            vProps = vProps.concat([ "marginTop", "marginBottom" ]).concat(cProps);
            hProps = hProps.concat([ "marginLeft", "marginRight" ]);
            props2 = props0.concat(vProps).concat(hProps);

            el.find( "*[width]" ).each( function(){
                var child = $( this ),
                    c_original = {
                        height: child.height(),
                        width: child.width(),
                        outerHeight: child.outerHeight(),
                        outerWidth: child.outerWidth()
                    };
                if (restore) {
                    $.effects.save(child, props2);
                }

                child.from = {
                    height: c_original.height * factor.from.y,
                    width: c_original.width * factor.from.x,
                    outerHeight: c_original.outerHeight * factor.from.y,
                    outerWidth: c_original.outerWidth * factor.from.x
                };
                child.to = {
                    height: c_original.height * factor.to.y,
                    width: c_original.width * factor.to.x,
                    outerHeight: c_original.height * factor.to.y,
                    outerWidth: c_original.width * factor.to.x
                };

                // Vertical props scaling
                if ( factor.from.y !== factor.to.y ) {
                    child.from = $.effects.setTransition( child, vProps, factor.from.y, child.from );
                    child.to = $.effects.setTransition( child, vProps, factor.to.y, child.to );
                }

                // Horizontal props scaling
                if ( factor.from.x !== factor.to.x ) {
                    child.from = $.effects.setTransition( child, hProps, factor.from.x, child.from );
                    child.to = $.effects.setTransition( child, hProps, factor.to.x, child.to );
                }

                // Animate children
                child.css( child.from );
                child.animate( child.to, o.duration, o.easing, function() {

                    // Restore children
                    if ( restore ) {
                        $.effects.restore( child, props2 );
                    }
                });
            });
        }

        // Animate
        el.animate( el.to, {
            queue: false,
            duration: o.duration,
            easing: o.easing,
            complete: function() {
                if ( el.to.opacity === 0 ) {
                    el.css( "opacity", el.from.opacity );
                }
                if( mode === "hide" ) {
                    el.hide();
                }
                $.effects.restore( el, props );
                if ( !restore ) {

                    // we need to calculate our new positioning based on the scaling
                    if ( position === "static" ) {
                        el.css({
                            position: "relative",
                            top: el.to.top,
                            left: el.to.left
                        });
                    } else {
                        $.each([ "top", "left" ], function( idx, pos ) {
                            el.css( pos, function( _, str ) {
                                var val = parseInt( str, 10 ),
                                    toRef = idx ? el.to.left : el.to.top;

                                // if original was "auto", recalculate the new value from wrapper
                                if ( str === "auto" ) {
                                    return toRef + "px";
                                }

                                return val + toRef + "px";
                            });
                        });
                    }
                }

                $.effects.removeWrapper( el );
                done();
            }
        });

    };

})(jQuery);

(function( $, undefined ) {

    $.effects.effect.shake = function( o, done ) {

        var el = $( this ),
            props = [ "position", "top", "bottom", "left", "right", "height", "width" ],
            mode = $.effects.setMode( el, o.mode || "effect" ),
            direction = o.direction || "left",
            distance = o.distance || 20,
            times = o.times || 3,
            anims = times * 2 + 1,
            speed = Math.round(o.duration/anims),
            ref = (direction === "up" || direction === "down") ? "top" : "left",
            positiveMotion = (direction === "up" || direction === "left"),
            animation = {},
            animation1 = {},
            animation2 = {},
            i,

            // we will need to re-assemble the queue to stack our animations in place
            queue = el.queue(),
            queuelen = queue.length;

        $.effects.save( el, props );
        el.show();
        $.effects.createWrapper( el );

        // Animation
        animation[ ref ] = ( positiveMotion ? "-=" : "+=" ) + distance;
        animation1[ ref ] = ( positiveMotion ? "+=" : "-=" ) + distance * 2;
        animation2[ ref ] = ( positiveMotion ? "-=" : "+=" ) + distance * 2;

        // Animate
        el.animate( animation, speed, o.easing );

        // Shakes
        for ( i = 1; i < times; i++ ) {
            el.animate( animation1, speed, o.easing ).animate( animation2, speed, o.easing );
        }
        el
            .animate( animation1, speed, o.easing )
            .animate( animation, speed / 2, o.easing )
            .queue(function() {
                if ( mode === "hide" ) {
                    el.hide();
                }
                $.effects.restore( el, props );
                $.effects.removeWrapper( el );
                done();
            });

        // inject all the animations we just queued to be first in line (after "inprogress")
        if ( queuelen > 1) {
            queue.splice.apply( queue,
                [ 1, 0 ].concat( queue.splice( queuelen, anims + 1 ) ) );
        }
        el.dequeue();

    };

})(jQuery);

(function( $, undefined ) {

    $.effects.effect.slide = function( o, done ) {

        // Create element
        var el = $( this ),
            props = [ "position", "top", "bottom", "left", "right", "width", "height" ],
            mode = $.effects.setMode( el, o.mode || "show" ),
            show = mode === "show",
            direction = o.direction || "left",
            ref = (direction === "up" || direction === "down") ? "top" : "left",
            positiveMotion = (direction === "up" || direction === "left"),
            distance,
            animation = {};

        // Adjust
        $.effects.save( el, props );
        el.show();
        distance = o.distance || el[ ref === "top" ? "outerHeight" : "outerWidth" ]( true );

        $.effects.createWrapper( el ).css({
            overflow: "hidden"
        });

        if ( show ) {
            el.css( ref, positiveMotion ? (isNaN(distance) ? "-" + distance : -distance) : distance );
        }

        // Animation
        animation[ ref ] = ( show ?
                ( positiveMotion ? "+=" : "-=") :
                ( positiveMotion ? "-=" : "+=")) +
            distance;

        // Animate
        el.animate( animation, {
            queue: false,
            duration: o.duration,
            easing: o.easing,
            complete: function() {
                if ( mode === "hide" ) {
                    el.hide();
                }
                $.effects.restore( el, props );
                $.effects.removeWrapper( el );
                done();
            }
        });
    };

})(jQuery);

(function( $, undefined ) {

    $.effects.effect.transfer = function( o, done ) {
        var elem = $( this ),
            target = $( o.to ),
            targetFixed = target.css( "position" ) === "fixed",
            body = $("body"),
            fixTop = targetFixed ? body.scrollTop() : 0,
            fixLeft = targetFixed ? body.scrollLeft() : 0,
            endPosition = target.offset(),
            animation = {
                top: endPosition.top - fixTop ,
                left: endPosition.left - fixLeft ,
                height: target.innerHeight(),
                width: target.innerWidth()
            },
            startPosition = elem.offset(),
            transfer = $( "<div class='ui-effects-transfer'></div>" )
                .appendTo( document.body )
                .addClass( o.className )
                .css({
                    top: startPosition.top - fixTop ,
                    left: startPosition.left - fixLeft ,
                    height: elem.innerHeight(),
                    width: elem.innerWidth(),
                    position: targetFixed ? "fixed" : "absolute"
                })
                .animate( animation, o.duration, o.easing, function() {
                    transfer.remove();
                    done();
                });
    };

})(jQuery);

(function( $, undefined ) {

    $.widget( "ui.menu", {
        version: "1.10.2",
        defaultElement: "<ul>",
        delay: 300,
        options: {
            icons: {
                submenu: "ui-icon-carat-1-e"
            },
            menus: "ul",
            position: {
                my: "left top",
                at: "right top"
            },
            role: "menu",

            // callbacks
            blur: null,
            focus: null,
            select: null
        },

        _create: function() {
            this.activeMenu = this.element;
            // flag used to prevent firing of the click handler
            // as the event bubbles up through nested menus
            this.mouseHandled = false;
            this.element
                .uniqueId()
                .addClass( "ui-menu ui-widget ui-widget-content ui-corner-all" )
                .toggleClass( "ui-menu-icons", !!this.element.find( ".ui-icon" ).length )
                .attr({
                    role: this.options.role,
                    tabIndex: 0
                })
                // need to catch all clicks on disabled menu
                // not possible through _on
                .bind( "click" + this.eventNamespace, $.proxy(function( event ) {
                    if ( this.options.disabled ) {
                        event.preventDefault();
                    }
                }, this ));

            if ( this.options.disabled ) {
                this.element
                    .addClass( "ui-state-disabled" )
                    .attr( "aria-disabled", "true" );
            }

            this._on({
                // Prevent focus from sticking to links inside menu after clicking
                // them (focus should always stay on UL during navigation).
                "mousedown .ui-menu-item > a": function( event ) {
                    event.preventDefault();
                },
                "click .ui-state-disabled > a": function( event ) {
                    event.preventDefault();
                },
                "click .ui-menu-item:has(a)": function( event ) {
                    var target = $( event.target ).closest( ".ui-menu-item" );
                    if ( !this.mouseHandled && target.not( ".ui-state-disabled" ).length ) {
                        this.mouseHandled = true;

                        this.select( event );
                        // Open submenu on click
                        if ( target.has( ".ui-menu" ).length ) {
                            this.expand( event );
                        } else if ( !this.element.is( ":focus" ) ) {
                            // Redirect focus to the menu
                            this.element.trigger( "focus", [ true ] );

                            // If the active item is on the top level, let it stay active.
                            // Otherwise, blur the active item since it is no longer visible.
                            if ( this.active && this.active.parents( ".ui-menu" ).length === 1 ) {
                                clearTimeout( this.timer );
                            }
                        }
                    }
                },
                "mouseenter .ui-menu-item": function( event ) {
                    var target = $( event.currentTarget );
                    // Remove ui-state-active class from siblings of the newly focused menu item
                    // to avoid a jump caused by adjacent elements both having a class with a border
                    target.siblings().children( ".ui-state-active" ).removeClass( "ui-state-active" );
                    this.focus( event, target );
                },
                mouseleave: "collapseAll",
                "mouseleave .ui-menu": "collapseAll",
                focus: function( event, keepActiveItem ) {
                    // If there's already an active item, keep it active
                    // If not, activate the first item
                    var item = this.active || this.element.children( ".ui-menu-item" ).eq( 0 );

                    if ( !keepActiveItem ) {
                        this.focus( event, item );
                    }
                },
                blur: function( event ) {
                    this._delay(function() {
                        if ( !$.contains( this.element[0], this.document[0].activeElement ) ) {
                            this.collapseAll( event );
                        }
                    });
                },
                keydown: "_keydown"
            });

            this.refresh();

            // Clicks outside of a menu collapse any open menus
            this._on( this.document, {
                click: function( event ) {
                    if ( !$( event.target ).closest( ".ui-menu" ).length ) {
                        this.collapseAll( event );
                    }

                    // Reset the mouseHandled flag
                    this.mouseHandled = false;
                }
            });
        },

        _destroy: function() {
            // Destroy (sub)menus
            this.element
                .removeAttr( "aria-activedescendant" )
                .find( ".ui-menu" ).addBack()
                .removeClass( "ui-menu ui-widget ui-widget-content ui-corner-all ui-menu-icons" )
                .removeAttr( "role" )
                .removeAttr( "tabIndex" )
                .removeAttr( "aria-labelledby" )
                .removeAttr( "aria-expanded" )
                .removeAttr( "aria-hidden" )
                .removeAttr( "aria-disabled" )
                .removeUniqueId()
                .show();

            // Destroy menu items
            this.element.find( ".ui-menu-item" )
                .removeClass( "ui-menu-item" )
                .removeAttr( "role" )
                .removeAttr( "aria-disabled" )
                .children( "a" )
                .removeUniqueId()
                .removeClass( "ui-corner-all ui-state-hover" )
                .removeAttr( "tabIndex" )
                .removeAttr( "role" )
                .removeAttr( "aria-haspopup" )
                .children().each( function() {
                var elem = $( this );
                if ( elem.data( "ui-menu-submenu-carat" ) ) {
                    elem.remove();
                }
            });

            // Destroy menu dividers
            this.element.find( ".ui-menu-divider" ).removeClass( "ui-menu-divider ui-widget-content" );
        },

        _keydown: function( event ) {
            /*jshint maxcomplexity:20*/
            var match, prev, character, skip, regex,
                preventDefault = true;

            function escape( value ) {
                return value.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&" );
            }

            switch ( event.keyCode ) {
                case $.ui.keyCode.PAGE_UP:
                    this.previousPage( event );
                    break;
                case $.ui.keyCode.PAGE_DOWN:
                    this.nextPage( event );
                    break;
                case $.ui.keyCode.HOME:
                    this._move( "first", "first", event );
                    break;
                case $.ui.keyCode.END:
                    this._move( "last", "last", event );
                    break;
                case $.ui.keyCode.UP:
                    this.previous( event );
                    break;
                case $.ui.keyCode.DOWN:
                    this.next( event );
                    break;
                case $.ui.keyCode.LEFT:
                    this.collapse( event );
                    break;
                case $.ui.keyCode.RIGHT:
                    if ( this.active && !this.active.is( ".ui-state-disabled" ) ) {
                        this.expand( event );
                    }
                    break;
                case $.ui.keyCode.ENTER:
                case $.ui.keyCode.SPACE:
                    this._activate( event );
                    break;
                case $.ui.keyCode.ESCAPE:
                    this.collapse( event );
                    break;
                default:
                    preventDefault = false;
                    prev = this.previousFilter || "";
                    character = String.fromCharCode( event.keyCode );
                    skip = false;

                    clearTimeout( this.filterTimer );

                    if ( character === prev ) {
                        skip = true;
                    } else {
                        character = prev + character;
                    }

                    regex = new RegExp( "^" + escape( character ), "i" );
                    match = this.activeMenu.children( ".ui-menu-item" ).filter(function() {
                        return regex.test( $( this ).children( "a" ).text() );
                    });
                    match = skip && match.index( this.active.next() ) !== -1 ?
                        this.active.nextAll( ".ui-menu-item" ) :
                        match;

                    // If no matches on the current filter, reset to the last character pressed
                    // to move down the menu to the first item that starts with that character
                    if ( !match.length ) {
                        character = String.fromCharCode( event.keyCode );
                        regex = new RegExp( "^" + escape( character ), "i" );
                        match = this.activeMenu.children( ".ui-menu-item" ).filter(function() {
                            return regex.test( $( this ).children( "a" ).text() );
                        });
                    }

                    if ( match.length ) {
                        this.focus( event, match );
                        if ( match.length > 1 ) {
                            this.previousFilter = character;
                            this.filterTimer = this._delay(function() {
                                delete this.previousFilter;
                            }, 1000 );
                        } else {
                            delete this.previousFilter;
                        }
                    } else {
                        delete this.previousFilter;
                    }
            }

            if ( preventDefault ) {
                event.preventDefault();
            }
        },

        _activate: function( event ) {
            if ( !this.active.is( ".ui-state-disabled" ) ) {
                if ( this.active.children( "a[aria-haspopup='true']" ).length ) {
                    this.expand( event );
                } else {
                    this.select( event );
                }
            }
        },

        refresh: function() {
            var menus,
                icon = this.options.icons.submenu,
                submenus = this.element.find( this.options.menus );

            // Initialize nested menus
            submenus.filter( ":not(.ui-menu)" )
                .addClass( "ui-menu ui-widget ui-widget-content ui-corner-all" )
                .hide()
                .attr({
                    role: this.options.role,
                    "aria-hidden": "true",
                    "aria-expanded": "false"
                })
                .each(function() {
                    var menu = $( this ),
                        item = menu.prev( "a" ),
                        submenuCarat = $( "<span>" )
                            .addClass( "ui-menu-icon ui-icon " + icon )
                            .data( "ui-menu-submenu-carat", true );

                    item
                        .attr( "aria-haspopup", "true" )
                        .prepend( submenuCarat );
                    menu.attr( "aria-labelledby", item.attr( "id" ) );
                });

            menus = submenus.add( this.element );

            // Don't refresh list items that are already adapted
            menus.children( ":not(.ui-menu-item):has(a)" )
                .addClass( "ui-menu-item" )
                .attr( "role", "presentation" )
                .children( "a" )
                .uniqueId()
                .addClass( "ui-corner-all" )
                .attr({
                    tabIndex: -1,
                    role: this._itemRole()
                });

            // Initialize unlinked menu-items containing spaces and/or dashes only as dividers
            menus.children( ":not(.ui-menu-item)" ).each(function() {
                var item = $( this );
                // hyphen, em dash, en dash
                if ( !/[^\-\u2014\u2013\s]/.test( item.text() ) ) {
                    item.addClass( "ui-widget-content ui-menu-divider" );
                }
            });

            // Add aria-disabled attribute to any disabled menu item
            menus.children( ".ui-state-disabled" ).attr( "aria-disabled", "true" );

            // If the active item has been removed, blur the menu
            if ( this.active && !$.contains( this.element[ 0 ], this.active[ 0 ] ) ) {
                this.blur();
            }
        },

        _itemRole: function() {
            return {
                menu: "menuitem",
                listbox: "option"
            }[ this.options.role ];
        },

        _setOption: function( key, value ) {
            if ( key === "icons" ) {
                this.element.find( ".ui-menu-icon" )
                    .removeClass( this.options.icons.submenu )
                    .addClass( value.submenu );
            }
            this._super( key, value );
        },

        focus: function( event, item ) {
            var nested, focused;
            this.blur( event, event && event.type === "focus" );

            this._scrollIntoView( item );

            this.active = item.first();
            focused = this.active.children( "a" ).addClass( "ui-state-focus" );
            // Only update aria-activedescendant if there's a role
            // otherwise we assume focus is managed elsewhere
            if ( this.options.role ) {
                this.element.attr( "aria-activedescendant", focused.attr( "id" ) );
            }

            // Highlight active parent menu item, if any
            this.active
                .parent()
                .closest( ".ui-menu-item" )
                .children( "a:first" )
                .addClass( "ui-state-active" );

            if ( event && event.type === "keydown" ) {
                this._close();
            } else {
                this.timer = this._delay(function() {
                    this._close();
                }, this.delay );
            }

            nested = item.children( ".ui-menu" );
            if ( nested.length && ( /^mouse/.test( event.type ) ) ) {
                this._startOpening(nested);
            }
            this.activeMenu = item.parent();

            this._trigger( "focus", event, { item: item } );
        },

        _scrollIntoView: function( item ) {
            var borderTop, paddingTop, offset, scroll, elementHeight, itemHeight;
            if ( this._hasScroll() ) {
                borderTop = parseFloat( $.css( this.activeMenu[0], "borderTopWidth" ) ) || 0;
                paddingTop = parseFloat( $.css( this.activeMenu[0], "paddingTop" ) ) || 0;
                offset = item.offset().top - this.activeMenu.offset().top - borderTop - paddingTop;
                scroll = this.activeMenu.scrollTop();
                elementHeight = this.activeMenu.height();
                itemHeight = item.height();

                if ( offset < 0 ) {
                    this.activeMenu.scrollTop( scroll + offset );
                } else if ( offset + itemHeight > elementHeight ) {
                    this.activeMenu.scrollTop( scroll + offset - elementHeight + itemHeight );
                }
            }
        },

        blur: function( event, fromFocus ) {
            if ( !fromFocus ) {
                clearTimeout( this.timer );
            }

            if ( !this.active ) {
                return;
            }

            this.active.children( "a" ).removeClass( "ui-state-focus" );
            this.active = null;

            this._trigger( "blur", event, { item: this.active } );
        },

        _startOpening: function( submenu ) {
            clearTimeout( this.timer );

            // Don't open if already open fixes a Firefox bug that caused a .5 pixel
            // shift in the submenu position when mousing over the carat icon
            if ( submenu.attr( "aria-hidden" ) !== "true" ) {
                return;
            }

            this.timer = this._delay(function() {
                this._close();
                this._open( submenu );
            }, this.delay );
        },

        _open: function( submenu ) {
            var position = $.extend({
                of: this.active
            }, this.options.position );

            clearTimeout( this.timer );
            this.element.find( ".ui-menu" ).not( submenu.parents( ".ui-menu" ) )
                .hide()
                .attr( "aria-hidden", "true" );

            submenu
                .show()
                .removeAttr( "aria-hidden" )
                .attr( "aria-expanded", "true" )
                .position( position );
        },

        collapseAll: function( event, all ) {
            clearTimeout( this.timer );
            this.timer = this._delay(function() {
                // If we were passed an event, look for the submenu that contains the event
                var currentMenu = all ? this.element :
                    $( event && event.target ).closest( this.element.find( ".ui-menu" ) );

                // If we found no valid submenu ancestor, use the main menu to close all sub menus anyway
                if ( !currentMenu.length ) {
                    currentMenu = this.element;
                }

                this._close( currentMenu );

                this.blur( event );
                this.activeMenu = currentMenu;
            }, this.delay );
        },

        // With no arguments, closes the currently active menu - if nothing is active
        // it closes all menus.  If passed an argument, it will search for menus BELOW
        _close: function( startMenu ) {
            if ( !startMenu ) {
                startMenu = this.active ? this.active.parent() : this.element;
            }

            startMenu
                .find( ".ui-menu" )
                .hide()
                .attr( "aria-hidden", "true" )
                .attr( "aria-expanded", "false" )
                .end()
                .find( "a.ui-state-active" )
                .removeClass( "ui-state-active" );
        },

        collapse: function( event ) {
            var newItem = this.active &&
                this.active.parent().closest( ".ui-menu-item", this.element );
            if ( newItem && newItem.length ) {
                this._close();
                this.focus( event, newItem );
            }
        },

        expand: function( event ) {
            var newItem = this.active &&
                this.active
                    .children( ".ui-menu " )
                    .children( ".ui-menu-item" )
                    .first();

            if ( newItem && newItem.length ) {
                this._open( newItem.parent() );

                // Delay so Firefox will not hide activedescendant change in expanding submenu from AT
                this._delay(function() {
                    this.focus( event, newItem );
                });
            }
        },

        next: function( event ) {
            this._move( "next", "first", event );
        },

        previous: function( event ) {
            this._move( "prev", "last", event );
        },

        isFirstItem: function() {
            return this.active && !this.active.prevAll( ".ui-menu-item" ).length;
        },

        isLastItem: function() {
            return this.active && !this.active.nextAll( ".ui-menu-item" ).length;
        },

        _move: function( direction, filter, event ) {
            var next;
            if ( this.active ) {
                if ( direction === "first" || direction === "last" ) {
                    next = this.active
                        [ direction === "first" ? "prevAll" : "nextAll" ]( ".ui-menu-item" )
                        .eq( -1 );
                } else {
                    next = this.active
                        [ direction + "All" ]( ".ui-menu-item" )
                        .eq( 0 );
                }
            }
            if ( !next || !next.length || !this.active ) {
                next = this.activeMenu.children( ".ui-menu-item" )[ filter ]();
            }

            this.focus( event, next );
        },

        nextPage: function( event ) {
            var item, base, height;

            if ( !this.active ) {
                this.next( event );
                return;
            }
            if ( this.isLastItem() ) {
                return;
            }
            if ( this._hasScroll() ) {
                base = this.active.offset().top;
                height = this.element.height();
                this.active.nextAll( ".ui-menu-item" ).each(function() {
                    item = $( this );
                    return item.offset().top - base - height < 0;
                });

                this.focus( event, item );
            } else {
                this.focus( event, this.activeMenu.children( ".ui-menu-item" )
                    [ !this.active ? "first" : "last" ]() );
            }
        },

        previousPage: function( event ) {
            var item, base, height;
            if ( !this.active ) {
                this.next( event );
                return;
            }
            if ( this.isFirstItem() ) {
                return;
            }
            if ( this._hasScroll() ) {
                base = this.active.offset().top;
                height = this.element.height();
                this.active.prevAll( ".ui-menu-item" ).each(function() {
                    item = $( this );
                    return item.offset().top - base + height > 0;
                });

                this.focus( event, item );
            } else {
                this.focus( event, this.activeMenu.children( ".ui-menu-item" ).first() );
            }
        },

        _hasScroll: function() {
            return this.element.outerHeight() < this.element.prop( "scrollHeight" );
        },

        select: function( event ) {
            // TODO: It should never be possible to not have an active item at this
            // point, but the tests don't trigger mouseenter before click.
            this.active = this.active || $( event.target ).closest( ".ui-menu-item" );
            var ui = { item: this.active };
            if ( !this.active.has( ".ui-menu" ).length ) {
                this.collapseAll( event, true );
            }
            this._trigger( "select", event, ui );
        }
    });

}( jQuery ));

(function( $, undefined ) {

    $.ui = $.ui || {};

    var cachedScrollbarWidth,
        max = Math.max,
        abs = Math.abs,
        round = Math.round,
        rhorizontal = /left|center|right/,
        rvertical = /top|center|bottom/,
        roffset = /[\+\-]\d+(\.[\d]+)?%?/,
        rposition = /^\w+/,
        rpercent = /%$/,
        _position = $.fn.position;

    function getOffsets( offsets, width, height ) {
        return [
            parseFloat( offsets[ 0 ] ) * ( rpercent.test( offsets[ 0 ] ) ? width / 100 : 1 ),
            parseFloat( offsets[ 1 ] ) * ( rpercent.test( offsets[ 1 ] ) ? height / 100 : 1 )
        ];
    }

    function parseCss( element, property ) {
        return parseInt( $.css( element, property ), 10 ) || 0;
    }

    function getDimensions( elem ) {
        var raw = elem[0];
        if ( raw.nodeType === 9 ) {
            return {
                width: elem.width(),
                height: elem.height(),
                offset: { top: 0, left: 0 }
            };
        }
        if ( $.isWindow( raw ) ) {
            return {
                width: elem.width(),
                height: elem.height(),
                offset: { top: elem.scrollTop(), left: elem.scrollLeft() }
            };
        }
        if ( raw.preventDefault ) {
            return {
                width: 0,
                height: 0,
                offset: { top: raw.pageY, left: raw.pageX }
            };
        }
        return {
            width: elem.outerWidth(),
            height: elem.outerHeight(),
            offset: elem.offset()
        };
    }

    $.position = {
        scrollbarWidth: function() {
            if ( cachedScrollbarWidth !== undefined ) {
                return cachedScrollbarWidth;
            }
            var w1, w2,
                div = $( "<div style='display:block;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>" ),
                innerDiv = div.children()[0];

            $( "body" ).append( div );
            w1 = innerDiv.offsetWidth;
            div.css( "overflow", "scroll" );

            w2 = innerDiv.offsetWidth;

            if ( w1 === w2 ) {
                w2 = div[0].clientWidth;
            }

            div.remove();

            return (cachedScrollbarWidth = w1 - w2);
        },
        getScrollInfo: function( within ) {
            var overflowX = within.isWindow ? "" : within.element.css( "overflow-x" ),
                overflowY = within.isWindow ? "" : within.element.css( "overflow-y" ),
                hasOverflowX = overflowX === "scroll" ||
                    ( overflowX === "auto" && within.width < within.element[0].scrollWidth ),
                hasOverflowY = overflowY === "scroll" ||
                    ( overflowY === "auto" && within.height < within.element[0].scrollHeight );
            return {
                width: hasOverflowY ? $.position.scrollbarWidth() : 0,
                height: hasOverflowX ? $.position.scrollbarWidth() : 0
            };
        },
        getWithinInfo: function( element ) {
            var withinElement = $( element || window ),
                isWindow = $.isWindow( withinElement[0] );
            return {
                element: withinElement,
                isWindow: isWindow,
                offset: withinElement.offset() || { left: 0, top: 0 },
                scrollLeft: withinElement.scrollLeft(),
                scrollTop: withinElement.scrollTop(),
                width: isWindow ? withinElement.width() : withinElement.outerWidth(),
                height: isWindow ? withinElement.height() : withinElement.outerHeight()
            };
        }
    };

    $.fn.position = function( options ) {
        if ( !options || !options.of ) {
            return _position.apply( this, arguments );
        }

        // make a copy, we don't want to modify arguments
        options = $.extend( {}, options );

        var atOffset, targetWidth, targetHeight, targetOffset, basePosition, dimensions,
            target = $( options.of ),
            within = $.position.getWithinInfo( options.within ),
            scrollInfo = $.position.getScrollInfo( within ),
            collision = ( options.collision || "flip" ).split( " " ),
            offsets = {};

        dimensions = getDimensions( target );
        if ( target[0].preventDefault ) {
            // force left top to allow flipping
            options.at = "left top";
        }
        targetWidth = dimensions.width;
        targetHeight = dimensions.height;
        targetOffset = dimensions.offset;
        // clone to reuse original targetOffset later
        basePosition = $.extend( {}, targetOffset );

        // force my and at to have valid horizontal and vertical positions
        // if a value is missing or invalid, it will be converted to center
        $.each( [ "my", "at" ], function() {
            var pos = ( options[ this ] || "" ).split( " " ),
                horizontalOffset,
                verticalOffset;

            if ( pos.length === 1) {
                pos = rhorizontal.test( pos[ 0 ] ) ?
                    pos.concat( [ "center" ] ) :
                    rvertical.test( pos[ 0 ] ) ?
                        [ "center" ].concat( pos ) :
                        [ "center", "center" ];
            }
            pos[ 0 ] = rhorizontal.test( pos[ 0 ] ) ? pos[ 0 ] : "center";
            pos[ 1 ] = rvertical.test( pos[ 1 ] ) ? pos[ 1 ] : "center";

            // calculate offsets
            horizontalOffset = roffset.exec( pos[ 0 ] );
            verticalOffset = roffset.exec( pos[ 1 ] );
            offsets[ this ] = [
                horizontalOffset ? horizontalOffset[ 0 ] : 0,
                verticalOffset ? verticalOffset[ 0 ] : 0
            ];

            // reduce to just the positions without the offsets
            options[ this ] = [
                rposition.exec( pos[ 0 ] )[ 0 ],
                rposition.exec( pos[ 1 ] )[ 0 ]
            ];
        });

        // normalize collision option
        if ( collision.length === 1 ) {
            collision[ 1 ] = collision[ 0 ];
        }

        if ( options.at[ 0 ] === "right" ) {
            basePosition.left += targetWidth;
        } else if ( options.at[ 0 ] === "center" ) {
            basePosition.left += targetWidth / 2;
        }

        if ( options.at[ 1 ] === "bottom" ) {
            basePosition.top += targetHeight;
        } else if ( options.at[ 1 ] === "center" ) {
            basePosition.top += targetHeight / 2;
        }

        atOffset = getOffsets( offsets.at, targetWidth, targetHeight );
        basePosition.left += atOffset[ 0 ];
        basePosition.top += atOffset[ 1 ];

        return this.each(function() {
            var collisionPosition, using,
                elem = $( this ),
                elemWidth = elem.outerWidth(),
                elemHeight = elem.outerHeight(),
                marginLeft = parseCss( this, "marginLeft" ),
                marginTop = parseCss( this, "marginTop" ),
                collisionWidth = elemWidth + marginLeft + parseCss( this, "marginRight" ) + scrollInfo.width,
                collisionHeight = elemHeight + marginTop + parseCss( this, "marginBottom" ) + scrollInfo.height,
                position = $.extend( {}, basePosition ),
                myOffset = getOffsets( offsets.my, elem.outerWidth(), elem.outerHeight() );

            if ( options.my[ 0 ] === "right" ) {
                position.left -= elemWidth;
            } else if ( options.my[ 0 ] === "center" ) {
                position.left -= elemWidth / 2;
            }

            if ( options.my[ 1 ] === "bottom" ) {
                position.top -= elemHeight;
            } else if ( options.my[ 1 ] === "center" ) {
                position.top -= elemHeight / 2;
            }

            position.left += myOffset[ 0 ];
            position.top += myOffset[ 1 ];

            // if the browser doesn't support fractions, then round for consistent results
            if ( !$.support.offsetFractions ) {
                position.left = round( position.left );
                position.top = round( position.top );
            }

            collisionPosition = {
                marginLeft: marginLeft,
                marginTop: marginTop
            };

            $.each( [ "left", "top" ], function( i, dir ) {
                if ( $.ui.position[ collision[ i ] ] ) {
                    $.ui.position[ collision[ i ] ][ dir ]( position, {
                        targetWidth: targetWidth,
                        targetHeight: targetHeight,
                        elemWidth: elemWidth,
                        elemHeight: elemHeight,
                        collisionPosition: collisionPosition,
                        collisionWidth: collisionWidth,
                        collisionHeight: collisionHeight,
                        offset: [ atOffset[ 0 ] + myOffset[ 0 ], atOffset [ 1 ] + myOffset[ 1 ] ],
                        my: options.my,
                        at: options.at,
                        within: within,
                        elem : elem
                    });
                }
            });

            if ( options.using ) {
                // adds feedback as second argument to using callback, if present
                using = function( props ) {
                    var left = targetOffset.left - position.left,
                        right = left + targetWidth - elemWidth,
                        top = targetOffset.top - position.top,
                        bottom = top + targetHeight - elemHeight,
                        feedback = {
                            target: {
                                element: target,
                                left: targetOffset.left,
                                top: targetOffset.top,
                                width: targetWidth,
                                height: targetHeight
                            },
                            element: {
                                element: elem,
                                left: position.left,
                                top: position.top,
                                width: elemWidth,
                                height: elemHeight
                            },
                            horizontal: right < 0 ? "left" : left > 0 ? "right" : "center",
                            vertical: bottom < 0 ? "top" : top > 0 ? "bottom" : "middle"
                        };
                    if ( targetWidth < elemWidth && abs( left + right ) < targetWidth ) {
                        feedback.horizontal = "center";
                    }
                    if ( targetHeight < elemHeight && abs( top + bottom ) < targetHeight ) {
                        feedback.vertical = "middle";
                    }
                    if ( max( abs( left ), abs( right ) ) > max( abs( top ), abs( bottom ) ) ) {
                        feedback.important = "horizontal";
                    } else {
                        feedback.important = "vertical";
                    }
                    options.using.call( this, props, feedback );
                };
            }

            elem.offset( $.extend( position, { using: using } ) );
        });
    };

    $.ui.position = {
        fit: {
            left: function( position, data ) {
                var within = data.within,
                    withinOffset = within.isWindow ? within.scrollLeft : within.offset.left,
                    outerWidth = within.width,
                    collisionPosLeft = position.left - data.collisionPosition.marginLeft,
                    overLeft = withinOffset - collisionPosLeft,
                    overRight = collisionPosLeft + data.collisionWidth - outerWidth - withinOffset,
                    newOverRight;

                // element is wider than within
                if ( data.collisionWidth > outerWidth ) {
                    // element is initially over the left side of within
                    if ( overLeft > 0 && overRight <= 0 ) {
                        newOverRight = position.left + overLeft + data.collisionWidth - outerWidth - withinOffset;
                        position.left += overLeft - newOverRight;
                        // element is initially over right side of within
                    } else if ( overRight > 0 && overLeft <= 0 ) {
                        position.left = withinOffset;
                        // element is initially over both left and right sides of within
                    } else {
                        if ( overLeft > overRight ) {
                            position.left = withinOffset + outerWidth - data.collisionWidth;
                        } else {
                            position.left = withinOffset;
                        }
                    }
                    // too far left -> align with left edge
                } else if ( overLeft > 0 ) {
                    position.left += overLeft;
                    // too far right -> align with right edge
                } else if ( overRight > 0 ) {
                    position.left -= overRight;
                    // adjust based on position and margin
                } else {
                    position.left = max( position.left - collisionPosLeft, position.left );
                }
            },
            top: function( position, data ) {
                var within = data.within,
                    withinOffset = within.isWindow ? within.scrollTop : within.offset.top,
                    outerHeight = data.within.height,
                    collisionPosTop = position.top - data.collisionPosition.marginTop,
                    overTop = withinOffset - collisionPosTop,
                    overBottom = collisionPosTop + data.collisionHeight - outerHeight - withinOffset,
                    newOverBottom;

                // element is taller than within
                if ( data.collisionHeight > outerHeight ) {
                    // element is initially over the top of within
                    if ( overTop > 0 && overBottom <= 0 ) {
                        newOverBottom = position.top + overTop + data.collisionHeight - outerHeight - withinOffset;
                        position.top += overTop - newOverBottom;
                        // element is initially over bottom of within
                    } else if ( overBottom > 0 && overTop <= 0 ) {
                        position.top = withinOffset;
                        // element is initially over both top and bottom of within
                    } else {
                        if ( overTop > overBottom ) {
                            position.top = withinOffset + outerHeight - data.collisionHeight;
                        } else {
                            position.top = withinOffset;
                        }
                    }
                    // too far up -> align with top
                } else if ( overTop > 0 ) {
                    position.top += overTop;
                    // too far down -> align with bottom edge
                } else if ( overBottom > 0 ) {
                    position.top -= overBottom;
                    // adjust based on position and margin
                } else {
                    position.top = max( position.top - collisionPosTop, position.top );
                }
            }
        },
        flip: {
            left: function( position, data ) {
                var within = data.within,
                    withinOffset = within.offset.left + within.scrollLeft,
                    outerWidth = within.width,
                    offsetLeft = within.isWindow ? within.scrollLeft : within.offset.left,
                    collisionPosLeft = position.left - data.collisionPosition.marginLeft,
                    overLeft = collisionPosLeft - offsetLeft,
                    overRight = collisionPosLeft + data.collisionWidth - outerWidth - offsetLeft,
                    myOffset = data.my[ 0 ] === "left" ?
                        -data.elemWidth :
                        data.my[ 0 ] === "right" ?
                            data.elemWidth :
                            0,
                    atOffset = data.at[ 0 ] === "left" ?
                        data.targetWidth :
                        data.at[ 0 ] === "right" ?
                            -data.targetWidth :
                            0,
                    offset = -2 * data.offset[ 0 ],
                    newOverRight,
                    newOverLeft;

                if ( overLeft < 0 ) {
                    newOverRight = position.left + myOffset + atOffset + offset + data.collisionWidth - outerWidth - withinOffset;
                    if ( newOverRight < 0 || newOverRight < abs( overLeft ) ) {
                        position.left += myOffset + atOffset + offset;
                    }
                }
                else if ( overRight > 0 ) {
                    newOverLeft = position.left - data.collisionPosition.marginLeft + myOffset + atOffset + offset - offsetLeft;
                    if ( newOverLeft > 0 || abs( newOverLeft ) < overRight ) {
                        position.left += myOffset + atOffset + offset;
                    }
                }
            },
            top: function( position, data ) {
                var within = data.within,
                    withinOffset = within.offset.top + within.scrollTop,
                    outerHeight = within.height,
                    offsetTop = within.isWindow ? within.scrollTop : within.offset.top,
                    collisionPosTop = position.top - data.collisionPosition.marginTop,
                    overTop = collisionPosTop - offsetTop,
                    overBottom = collisionPosTop + data.collisionHeight - outerHeight - offsetTop,
                    top = data.my[ 1 ] === "top",
                    myOffset = top ?
                        -data.elemHeight :
                        data.my[ 1 ] === "bottom" ?
                            data.elemHeight :
                            0,
                    atOffset = data.at[ 1 ] === "top" ?
                        data.targetHeight :
                        data.at[ 1 ] === "bottom" ?
                            -data.targetHeight :
                            0,
                    offset = -2 * data.offset[ 1 ],
                    newOverTop,
                    newOverBottom;
                if ( overTop < 0 ) {
                    newOverBottom = position.top + myOffset + atOffset + offset + data.collisionHeight - outerHeight - withinOffset;
                    if ( ( position.top + myOffset + atOffset + offset) > overTop && ( newOverBottom < 0 || newOverBottom < abs( overTop ) ) ) {
                        position.top += myOffset + atOffset + offset;
                    }
                }
                else if ( overBottom > 0 ) {
                    newOverTop = position.top -  data.collisionPosition.marginTop + myOffset + atOffset + offset - offsetTop;
                    if ( ( position.top + myOffset + atOffset + offset) > overBottom && ( newOverTop > 0 || abs( newOverTop ) < overBottom ) ) {
                        position.top += myOffset + atOffset + offset;
                    }
                }
            }
        },
        flipfit: {
            left: function() {
                $.ui.position.flip.left.apply( this, arguments );
                $.ui.position.fit.left.apply( this, arguments );
            },
            top: function() {
                $.ui.position.flip.top.apply( this, arguments );
                $.ui.position.fit.top.apply( this, arguments );
            }
        }
    };

// fraction support test
    (function () {
        var testElement, testElementParent, testElementStyle, offsetLeft, i,
            body = document.getElementsByTagName( "body" )[ 0 ],
            div = document.createElement( "div" );

        //Create a "fake body" for testing based on method used in jQuery.support
        testElement = document.createElement( body ? "div" : "body" );
        testElementStyle = {
            visibility: "hidden",
            width: 0,
            height: 0,
            border: 0,
            margin: 0,
            background: "none"
        };
        if ( body ) {
            $.extend( testElementStyle, {
                position: "absolute",
                left: "-1000px",
                top: "-1000px"
            });
        }
        for ( i in testElementStyle ) {
            testElement.style[ i ] = testElementStyle[ i ];
        }
        testElement.appendChild( div );
        testElementParent = body || document.documentElement;
        testElementParent.insertBefore( testElement, testElementParent.firstChild );

        div.style.cssText = "position: absolute; left: 10.7432222px;";

        offsetLeft = $( div ).offset().left;
        $.support.offsetFractions = offsetLeft > 10 && offsetLeft < 11;

        testElement.innerHTML = "";
        testElementParent.removeChild( testElement );
    })();

}( jQuery ) );

(function( $, undefined ) {

    $.widget( "ui.progressbar", {
        version: "1.10.2",
        options: {
            max: 100,
            value: 0,

            change: null,
            complete: null
        },

        min: 0,

        _create: function() {
            // Constrain initial value
            this.oldValue = this.options.value = this._constrainedValue();

            this.element
                .addClass( "ui-progressbar ui-widget ui-widget-content ui-corner-all" )
                .attr({
                    // Only set static values, aria-valuenow and aria-valuemax are
                    // set inside _refreshValue()
                    role: "progressbar",
                    "aria-valuemin": this.min
                });

            this.valueDiv = $( "<div class='ui-progressbar-value ui-widget-header ui-corner-left'></div>" )
                .appendTo( this.element );

            this._refreshValue();
        },

        _destroy: function() {
            this.element
                .removeClass( "ui-progressbar ui-widget ui-widget-content ui-corner-all" )
                .removeAttr( "role" )
                .removeAttr( "aria-valuemin" )
                .removeAttr( "aria-valuemax" )
                .removeAttr( "aria-valuenow" );

            this.valueDiv.remove();
        },

        value: function( newValue ) {
            if ( newValue === undefined ) {
                return this.options.value;
            }

            this.options.value = this._constrainedValue( newValue );
            this._refreshValue();
        },

        _constrainedValue: function( newValue ) {
            if ( newValue === undefined ) {
                newValue = this.options.value;
            }

            this.indeterminate = newValue === false;

            // sanitize value
            if ( typeof newValue !== "number" ) {
                newValue = 0;
            }

            return this.indeterminate ? false :
                Math.min( this.options.max, Math.max( this.min, newValue ) );
        },

        _setOptions: function( options ) {
            // Ensure "value" option is set after other values (like max)
            var value = options.value;
            delete options.value;

            this._super( options );

            this.options.value = this._constrainedValue( value );
            this._refreshValue();
        },

        _setOption: function( key, value ) {
            if ( key === "max" ) {
                // Don't allow a max less than min
                value = Math.max( this.min, value );
            }

            this._super( key, value );
        },

        _percentage: function() {
            return this.indeterminate ? 100 : 100 * ( this.options.value - this.min ) / ( this.options.max - this.min );
        },

        _refreshValue: function() {
            var value = this.options.value,
                percentage = this._percentage();

            this.valueDiv
                .toggle( this.indeterminate || value > this.min )
                .toggleClass( "ui-corner-right", value === this.options.max )
                .width( percentage.toFixed(0) + "%" );

            this.element.toggleClass( "ui-progressbar-indeterminate", this.indeterminate );

            if ( this.indeterminate ) {
                this.element.removeAttr( "aria-valuenow" );
                if ( !this.overlayDiv ) {
                    this.overlayDiv = $( "<div class='ui-progressbar-overlay'></div>" ).appendTo( this.valueDiv );
                }
            } else {
                this.element.attr({
                    "aria-valuemax": this.options.max,
                    "aria-valuenow": value
                });
                if ( this.overlayDiv ) {
                    this.overlayDiv.remove();
                    this.overlayDiv = null;
                }
            }

            if ( this.oldValue !== value ) {
                this.oldValue = value;
                this._trigger( "change" );
            }
            if ( value === this.options.max ) {
                this._trigger( "complete" );
            }
        }
    });

})( jQuery );

(function( $, undefined ) {

// number of pages in a slider
// (how many times can you page up/down to go through the whole range)
    var numPages = 5;

    $.widget( "ui.slider", $.ui.mouse, {
        version: "1.10.2",
        widgetEventPrefix: "slide",

        options: {
            animate: false,
            distance: 0,
            max: 100,
            min: 0,
            orientation: "horizontal",
            range: false,
            step: 1,
            value: 0,
            values: null,

            // callbacks
            change: null,
            slide: null,
            start: null,
            stop: null
        },

        _create: function() {
            this._keySliding = false;
            this._mouseSliding = false;
            this._animateOff = true;
            this._handleIndex = null;
            this._detectOrientation();
            this._mouseInit();

            this.element
                .addClass( "ui-slider" +
                    " ui-slider-" + this.orientation +
                    " ui-widget" +
                    " ui-widget-content" +
                    " ui-corner-all");

            this._refresh();
            this._setOption( "disabled", this.options.disabled );

            this._animateOff = false;
        },

        _refresh: function() {
            this._createRange();
            this._createHandles();
            this._setupEvents();
            this._refreshValue();
        },

        _createHandles: function() {
            var i, handleCount,
                options = this.options,
                existingHandles = this.element.find( ".ui-slider-handle" ).addClass( "ui-state-default ui-corner-all" ),
                handle = "<a class='ui-slider-handle ui-state-default ui-corner-all' href='#'></a>",
                handles = [];

            handleCount = ( options.values && options.values.length ) || 1;

            if ( existingHandles.length > handleCount ) {
                existingHandles.slice( handleCount ).remove();
                existingHandles = existingHandles.slice( 0, handleCount );
            }

            for ( i = existingHandles.length; i < handleCount; i++ ) {
                handles.push( handle );
            }

            this.handles = existingHandles.add( $( handles.join( "" ) ).appendTo( this.element ) );

            this.handle = this.handles.eq( 0 );

            this.handles.each(function( i ) {
                $( this ).data( "ui-slider-handle-index", i );
            });
        },

        _createRange: function() {
            var options = this.options,
                classes = "";

            if ( options.range ) {
                if ( options.range === true ) {
                    if ( !options.values ) {
                        options.values = [ this._valueMin(), this._valueMin() ];
                    } else if ( options.values.length && options.values.length !== 2 ) {
                        options.values = [ options.values[0], options.values[0] ];
                    } else if ( $.isArray( options.values ) ) {
                        options.values = options.values.slice(0);
                    }
                }

                if ( !this.range || !this.range.length ) {
                    this.range = $( "<div></div>" )
                        .appendTo( this.element );

                    classes = "ui-slider-range" +
                        // note: this isn't the most fittingly semantic framework class for this element,
                        // but worked best visually with a variety of themes
                        " ui-widget-header ui-corner-all";
                } else {
                    this.range.removeClass( "ui-slider-range-min ui-slider-range-max" )
                    // Handle range switching from true to min/max
                        .css({
                            "left": "",
                            "bottom": ""
                        });
                }

                this.range.addClass( classes +
                    ( ( options.range === "min" || options.range === "max" ) ? " ui-slider-range-" + options.range : "" ) );
            } else {
                this.range = $([]);
            }
        },

        _setupEvents: function() {
            var elements = this.handles.add( this.range ).filter( "a" );
            this._off( elements );
            this._on( elements, this._handleEvents );
            this._hoverable( elements );
            this._focusable( elements );
        },

        _destroy: function() {
            this.handles.remove();
            this.range.remove();

            this.element
                .removeClass( "ui-slider" +
                    " ui-slider-horizontal" +
                    " ui-slider-vertical" +
                    " ui-widget" +
                    " ui-widget-content" +
                    " ui-corner-all" );

            this._mouseDestroy();
        },

        _mouseCapture: function( event ) {
            var position, normValue, distance, closestHandle, index, allowed, offset, mouseOverHandle,
                that = this,
                o = this.options;

            if ( o.disabled ) {
                return false;
            }

            this.elementSize = {
                width: this.element.outerWidth(),
                height: this.element.outerHeight()
            };
            this.elementOffset = this.element.offset();

            position = { x: event.pageX, y: event.pageY };
            normValue = this._normValueFromMouse( position );
            distance = this._valueMax() - this._valueMin() + 1;
            this.handles.each(function( i ) {
                var thisDistance = Math.abs( normValue - that.values(i) );
                if (( distance > thisDistance ) ||
                    ( distance === thisDistance &&
                    (i === that._lastChangedValue || that.values(i) === o.min ))) {
                    distance = thisDistance;
                    closestHandle = $( this );
                    index = i;
                }
            });

            allowed = this._start( event, index );
            if ( allowed === false ) {
                return false;
            }
            this._mouseSliding = true;

            this._handleIndex = index;

            closestHandle
                .addClass( "ui-state-active" )
                .focus();

            offset = closestHandle.offset();
            mouseOverHandle = !$( event.target ).parents().addBack().is( ".ui-slider-handle" );
            this._clickOffset = mouseOverHandle ? { left: 0, top: 0 } : {
                left: event.pageX - offset.left - ( closestHandle.width() / 2 ),
                top: event.pageY - offset.top -
                ( closestHandle.height() / 2 ) -
                ( parseInt( closestHandle.css("borderTopWidth"), 10 ) || 0 ) -
                ( parseInt( closestHandle.css("borderBottomWidth"), 10 ) || 0) +
                ( parseInt( closestHandle.css("marginTop"), 10 ) || 0)
            };

            if ( !this.handles.hasClass( "ui-state-hover" ) ) {
                this._slide( event, index, normValue );
            }
            this._animateOff = true;
            return true;
        },

        _mouseStart: function() {
            return true;
        },

        _mouseDrag: function( event ) {
            var position = { x: event.pageX, y: event.pageY },
                normValue = this._normValueFromMouse( position );

            this._slide( event, this._handleIndex, normValue );

            return false;
        },

        _mouseStop: function( event ) {
            this.handles.removeClass( "ui-state-active" );
            this._mouseSliding = false;

            this._stop( event, this._handleIndex );
            this._change( event, this._handleIndex );

            this._handleIndex = null;
            this._clickOffset = null;
            this._animateOff = false;

            return false;
        },

        _detectOrientation: function() {
            this.orientation = ( this.options.orientation === "vertical" ) ? "vertical" : "horizontal";
        },

        _normValueFromMouse: function( position ) {
            var pixelTotal,
                pixelMouse,
                percentMouse,
                valueTotal,
                valueMouse;

            if ( this.orientation === "horizontal" ) {
                pixelTotal = this.elementSize.width;
                pixelMouse = position.x - this.elementOffset.left - ( this._clickOffset ? this._clickOffset.left : 0 );
            } else {
                pixelTotal = this.elementSize.height;
                pixelMouse = position.y - this.elementOffset.top - ( this._clickOffset ? this._clickOffset.top : 0 );
            }

            percentMouse = ( pixelMouse / pixelTotal );
            if ( percentMouse > 1 ) {
                percentMouse = 1;
            }
            if ( percentMouse < 0 ) {
                percentMouse = 0;
            }
            if ( this.orientation === "vertical" ) {
                percentMouse = 1 - percentMouse;
            }

            valueTotal = this._valueMax() - this._valueMin();
            valueMouse = this._valueMin() + percentMouse * valueTotal;

            return this._trimAlignValue( valueMouse );
        },

        _start: function( event, index ) {
            var uiHash = {
                handle: this.handles[ index ],
                value: this.value()
            };
            if ( this.options.values && this.options.values.length ) {
                uiHash.value = this.values( index );
                uiHash.values = this.values();
            }
            return this._trigger( "start", event, uiHash );
        },

        _slide: function( event, index, newVal ) {
            var otherVal,
                newValues,
                allowed;

            if ( this.options.values && this.options.values.length ) {
                otherVal = this.values( index ? 0 : 1 );

                if ( ( this.options.values.length === 2 && this.options.range === true ) &&
                    ( ( index === 0 && newVal > otherVal) || ( index === 1 && newVal < otherVal ) )
                ) {
                    newVal = otherVal;
                }

                if ( newVal !== this.values( index ) ) {
                    newValues = this.values();
                    newValues[ index ] = newVal;
                    // A slide can be canceled by returning false from the slide callback
                    allowed = this._trigger( "slide", event, {
                        handle: this.handles[ index ],
                        value: newVal,
                        values: newValues
                    } );
                    otherVal = this.values( index ? 0 : 1 );
                    if ( allowed !== false ) {
                        this.values( index, newVal, true );
                    }
                }
            } else {
                if ( newVal !== this.value() ) {
                    // A slide can be canceled by returning false from the slide callback
                    allowed = this._trigger( "slide", event, {
                        handle: this.handles[ index ],
                        value: newVal
                    } );
                    if ( allowed !== false ) {
                        this.value( newVal );
                    }
                }
            }
        },

        _stop: function( event, index ) {
            var uiHash = {
                handle: this.handles[ index ],
                value: this.value()
            };
            if ( this.options.values && this.options.values.length ) {
                uiHash.value = this.values( index );
                uiHash.values = this.values();
            }

            this._trigger( "stop", event, uiHash );
        },

        _change: function( event, index ) {
            if ( !this._keySliding && !this._mouseSliding ) {
                var uiHash = {
                    handle: this.handles[ index ],
                    value: this.value()
                };
                if ( this.options.values && this.options.values.length ) {
                    uiHash.value = this.values( index );
                    uiHash.values = this.values();
                }

                //store the last changed value index for reference when handles overlap
                this._lastChangedValue = index;

                this._trigger( "change", event, uiHash );
            }
        },

        value: function( newValue ) {
            if ( arguments.length ) {
                this.options.value = this._trimAlignValue( newValue );
                this._refreshValue();
                this._change( null, 0 );
                return;
            }

            return this._value();
        },

        values: function( index, newValue ) {
            var vals,
                newValues,
                i;

            if ( arguments.length > 1 ) {
                this.options.values[ index ] = this._trimAlignValue( newValue );
                this._refreshValue();
                this._change( null, index );
                return;
            }

            if ( arguments.length ) {
                if ( $.isArray( arguments[ 0 ] ) ) {
                    vals = this.options.values;
                    newValues = arguments[ 0 ];
                    for ( i = 0; i < vals.length; i += 1 ) {
                        vals[ i ] = this._trimAlignValue( newValues[ i ] );
                        this._change( null, i );
                    }
                    this._refreshValue();
                } else {
                    if ( this.options.values && this.options.values.length ) {
                        return this._values( index );
                    } else {
                        return this.value();
                    }
                }
            } else {
                return this._values();
            }
        },

        _setOption: function( key, value ) {
            var i,
                valsLength = 0;

            if ( key === "range" && this.options.range === true ) {
                if ( value === "min" ) {
                    this.options.value = this._values( 0 );
                    this.options.values = null;
                } else if ( value === "max" ) {
                    this.options.value = this._values( this.options.values.length-1 );
                    this.options.values = null;
                }
            }

            if ( $.isArray( this.options.values ) ) {
                valsLength = this.options.values.length;
            }

            $.Widget.prototype._setOption.apply( this, arguments );

            switch ( key ) {
                case "orientation":
                    this._detectOrientation();
                    this.element
                        .removeClass( "ui-slider-horizontal ui-slider-vertical" )
                        .addClass( "ui-slider-" + this.orientation );
                    this._refreshValue();
                    break;
                case "value":
                    this._animateOff = true;
                    this._refreshValue();
                    this._change( null, 0 );
                    this._animateOff = false;
                    break;
                case "values":
                    this._animateOff = true;
                    this._refreshValue();
                    for ( i = 0; i < valsLength; i += 1 ) {
                        this._change( null, i );
                    }
                    this._animateOff = false;
                    break;
                case "min":
                case "max":
                    this._animateOff = true;
                    this._refreshValue();
                    this._animateOff = false;
                    break;
                case "range":
                    this._animateOff = true;
                    this._refresh();
                    this._animateOff = false;
                    break;
            }
        },

        //internal value getter
        // _value() returns value trimmed by min and max, aligned by step
        _value: function() {
            var val = this.options.value;
            val = this._trimAlignValue( val );

            return val;
        },

        //internal values getter
        // _values() returns array of values trimmed by min and max, aligned by step
        // _values( index ) returns single value trimmed by min and max, aligned by step
        _values: function( index ) {
            var val,
                vals,
                i;

            if ( arguments.length ) {
                val = this.options.values[ index ];
                val = this._trimAlignValue( val );

                return val;
            } else if ( this.options.values && this.options.values.length ) {
                // .slice() creates a copy of the array
                // this copy gets trimmed by min and max and then returned
                vals = this.options.values.slice();
                for ( i = 0; i < vals.length; i+= 1) {
                    vals[ i ] = this._trimAlignValue( vals[ i ] );
                }

                return vals;
            } else {
                return [];
            }
        },

        // returns the step-aligned value that val is closest to, between (inclusive) min and max
        _trimAlignValue: function( val ) {
            if ( val <= this._valueMin() ) {
                return this._valueMin();
            }
            if ( val >= this._valueMax() ) {
                return this._valueMax();
            }
            var step = ( this.options.step > 0 ) ? this.options.step : 1,
                valModStep = (val - this._valueMin()) % step,
                alignValue = val - valModStep;

            if ( Math.abs(valModStep) * 2 >= step ) {
                alignValue += ( valModStep > 0 ) ? step : ( -step );
            }

            // Since JavaScript has problems with large floats, round
            // the final value to 5 digits after the decimal point (see #4124)
            return parseFloat( alignValue.toFixed(5) );
        },

        _valueMin: function() {
            return this.options.min;
        },

        _valueMax: function() {
            return this.options.max;
        },

        _refreshValue: function() {
            var lastValPercent, valPercent, value, valueMin, valueMax,
                oRange = this.options.range,
                o = this.options,
                that = this,
                animate = ( !this._animateOff ) ? o.animate : false,
                _set = {};

            if ( this.options.values && this.options.values.length ) {
                this.handles.each(function( i ) {
                    valPercent = ( that.values(i) - that._valueMin() ) / ( that._valueMax() - that._valueMin() ) * 100;
                    _set[ that.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
                    $( this ).stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );
                    if ( that.options.range === true ) {
                        if ( that.orientation === "horizontal" ) {
                            if ( i === 0 ) {
                                that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { left: valPercent + "%" }, o.animate );
                            }
                            if ( i === 1 ) {
                                that.range[ animate ? "animate" : "css" ]( { width: ( valPercent - lastValPercent ) + "%" }, { queue: false, duration: o.animate } );
                            }
                        } else {
                            if ( i === 0 ) {
                                that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { bottom: ( valPercent ) + "%" }, o.animate );
                            }
                            if ( i === 1 ) {
                                that.range[ animate ? "animate" : "css" ]( { height: ( valPercent - lastValPercent ) + "%" }, { queue: false, duration: o.animate } );
                            }
                        }
                    }
                    lastValPercent = valPercent;
                });
            } else {
                value = this.value();
                valueMin = this._valueMin();
                valueMax = this._valueMax();
                valPercent = ( valueMax !== valueMin ) ?
                ( value - valueMin ) / ( valueMax - valueMin ) * 100 :
                    0;
                _set[ this.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
                this.handle.stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );

                if ( oRange === "min" && this.orientation === "horizontal" ) {
                    this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { width: valPercent + "%" }, o.animate );
                }
                if ( oRange === "max" && this.orientation === "horizontal" ) {
                    this.range[ animate ? "animate" : "css" ]( { width: ( 100 - valPercent ) + "%" }, { queue: false, duration: o.animate } );
                }
                if ( oRange === "min" && this.orientation === "vertical" ) {
                    this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { height: valPercent + "%" }, o.animate );
                }
                if ( oRange === "max" && this.orientation === "vertical" ) {
                    this.range[ animate ? "animate" : "css" ]( { height: ( 100 - valPercent ) + "%" }, { queue: false, duration: o.animate } );
                }
            }
        },

        _handleEvents: {
            keydown: function( event ) {
                /*jshint maxcomplexity:25*/
                var allowed, curVal, newVal, step,
                    index = $( event.target ).data( "ui-slider-handle-index" );

                switch ( event.keyCode ) {
                    case $.ui.keyCode.HOME:
                    case $.ui.keyCode.END:
                    case $.ui.keyCode.PAGE_UP:
                    case $.ui.keyCode.PAGE_DOWN:
                    case $.ui.keyCode.UP:
                    case $.ui.keyCode.RIGHT:
                    case $.ui.keyCode.DOWN:
                    case $.ui.keyCode.LEFT:
                        event.preventDefault();
                        if ( !this._keySliding ) {
                            this._keySliding = true;
                            $( event.target ).addClass( "ui-state-active" );
                            allowed = this._start( event, index );
                            if ( allowed === false ) {
                                return;
                            }
                        }
                        break;
                }

                step = this.options.step;
                if ( this.options.values && this.options.values.length ) {
                    curVal = newVal = this.values( index );
                } else {
                    curVal = newVal = this.value();
                }

                switch ( event.keyCode ) {
                    case $.ui.keyCode.HOME:
                        newVal = this._valueMin();
                        break;
                    case $.ui.keyCode.END:
                        newVal = this._valueMax();
                        break;
                    case $.ui.keyCode.PAGE_UP:
                        newVal = this._trimAlignValue( curVal + ( (this._valueMax() - this._valueMin()) / numPages ) );
                        break;
                    case $.ui.keyCode.PAGE_DOWN:
                        newVal = this._trimAlignValue( curVal - ( (this._valueMax() - this._valueMin()) / numPages ) );
                        break;
                    case $.ui.keyCode.UP:
                    case $.ui.keyCode.RIGHT:
                        if ( curVal === this._valueMax() ) {
                            return;
                        }
                        newVal = this._trimAlignValue( curVal + step );
                        break;
                    case $.ui.keyCode.DOWN:
                    case $.ui.keyCode.LEFT:
                        if ( curVal === this._valueMin() ) {
                            return;
                        }
                        newVal = this._trimAlignValue( curVal - step );
                        break;
                }

                this._slide( event, index, newVal );
            },
            click: function( event ) {
                event.preventDefault();
            },
            keyup: function( event ) {
                var index = $( event.target ).data( "ui-slider-handle-index" );

                if ( this._keySliding ) {
                    this._keySliding = false;
                    this._stop( event, index );
                    this._change( event, index );
                    $( event.target ).removeClass( "ui-state-active" );
                }
            }
        }

    });

}(jQuery));

(function( $ ) {

    function modifier( fn ) {
        return function() {
            var previous = this.element.val();
            fn.apply( this, arguments );
            this._refresh();
            if ( previous !== this.element.val() ) {
                this._trigger( "change" );
            }
        };
    }

    $.widget( "ui.spinner", {
        version: "1.10.2",
        defaultElement: "<input>",
        widgetEventPrefix: "spin",
        options: {
            culture: null,
            icons: {
                down: "ui-icon-triangle-1-s",
                up: "ui-icon-triangle-1-n"
            },
            incremental: true,
            max: null,
            min: null,
            numberFormat: null,
            page: 10,
            step: 1,

            change: null,
            spin: null,
            start: null,
            stop: null
        },

        _create: function() {
            // handle string values that need to be parsed
            this._setOption( "max", this.options.max );
            this._setOption( "min", this.options.min );
            this._setOption( "step", this.options.step );

            // format the value, but don't constrain
            this._value( this.element.val(), true );

            this._draw();
            this._on( this._events );
            this._refresh();

            // turning off autocomplete prevents the browser from remembering the
            // value when navigating through history, so we re-enable autocomplete
            // if the page is unloaded before the widget is destroyed. #7790
            this._on( this.window, {
                beforeunload: function() {
                    this.element.removeAttr( "autocomplete" );
                }
            });
        },

        _getCreateOptions: function() {
            var options = {},
                element = this.element;

            $.each( [ "min", "max", "step" ], function( i, option ) {
                var value = element.attr( option );
                if ( value !== undefined && value.length ) {
                    options[ option ] = value;
                }
            });

            return options;
        },

        _events: {
            keydown: function( event ) {
                if ( this._start( event ) && this._keydown( event ) ) {
                    event.preventDefault();
                }
            },
            keyup: "_stop",
            focus: function() {
                this.previous = this.element.val();
            },
            blur: function( event ) {
                if ( this.cancelBlur ) {
                    delete this.cancelBlur;
                    return;
                }

                this._stop();
                this._refresh();
                if ( this.previous !== this.element.val() ) {
                    this._trigger( "change", event );
                }
            },
            mousewheel: function( event, delta ) {
                if ( !delta ) {
                    return;
                }
                if ( !this.spinning && !this._start( event ) ) {
                    return false;
                }

                this._spin( (delta > 0 ? 1 : -1) * this.options.step, event );
                clearTimeout( this.mousewheelTimer );
                this.mousewheelTimer = this._delay(function() {
                    if ( this.spinning ) {
                        this._stop( event );
                    }
                }, 100 );
                event.preventDefault();
            },
            "mousedown .ui-spinner-button": function( event ) {
                var previous;

                // We never want the buttons to have focus; whenever the user is
                // interacting with the spinner, the focus should be on the input.
                // If the input is focused then this.previous is properly set from
                // when the input first received focus. If the input is not focused
                // then we need to set this.previous based on the value before spinning.
                previous = this.element[0] === this.document[0].activeElement ?
                    this.previous : this.element.val();
                function checkFocus() {
                    var isActive = this.element[0] === this.document[0].activeElement;
                    if ( !isActive ) {
                        this.element.focus();
                        this.previous = previous;
                        // support: IE
                        // IE sets focus asynchronously, so we need to check if focus
                        // moved off of the input because the user clicked on the button.
                        this._delay(function() {
                            this.previous = previous;
                        });
                    }
                }

                // ensure focus is on (or stays on) the text field
                event.preventDefault();
                checkFocus.call( this );

                // support: IE
                // IE doesn't prevent moving focus even with event.preventDefault()
                // so we set a flag to know when we should ignore the blur event
                // and check (again) if focus moved off of the input.
                this.cancelBlur = true;
                this._delay(function() {
                    delete this.cancelBlur;
                    checkFocus.call( this );
                });

                if ( this._start( event ) === false ) {
                    return;
                }

                this._repeat( null, $( event.currentTarget ).hasClass( "ui-spinner-up" ) ? 1 : -1, event );
            },
            "mouseup .ui-spinner-button": "_stop",
            "mouseenter .ui-spinner-button": function( event ) {
                // button will add ui-state-active if mouse was down while mouseleave and kept down
                if ( !$( event.currentTarget ).hasClass( "ui-state-active" ) ) {
                    return;
                }

                if ( this._start( event ) === false ) {
                    return false;
                }
                this._repeat( null, $( event.currentTarget ).hasClass( "ui-spinner-up" ) ? 1 : -1, event );
            },
            // TODO: do we really want to consider this a stop?
            // shouldn't we just stop the repeater and wait until mouseup before
            // we trigger the stop event?
            "mouseleave .ui-spinner-button": "_stop"
        },

        _draw: function() {
            var uiSpinner = this.uiSpinner = this.element
                .addClass( "ui-spinner-input" )
                .attr( "autocomplete", "off" )
                .wrap( this._uiSpinnerHtml() )
                .parent()
                // add buttons
                .append( this._buttonHtml() );

            this.element.attr( "role", "spinbutton" );

            // button bindings
            this.buttons = uiSpinner.find( ".ui-spinner-button" )
                .attr( "tabIndex", -1 )
                .button()
                .removeClass( "ui-corner-all" );

            // IE 6 doesn't understand height: 50% for the buttons
            // unless the wrapper has an explicit height
            if ( this.buttons.height() > Math.ceil( uiSpinner.height() * 0.5 ) &&
                uiSpinner.height() > 0 ) {
                uiSpinner.height( uiSpinner.height() );
            }

            // disable spinner if element was already disabled
            if ( this.options.disabled ) {
                this.disable();
            }
        },

        _keydown: function( event ) {
            var options = this.options,
                keyCode = $.ui.keyCode;

            switch ( event.keyCode ) {
                case keyCode.UP:
                    this._repeat( null, 1, event );
                    return true;
                case keyCode.DOWN:
                    this._repeat( null, -1, event );
                    return true;
                case keyCode.PAGE_UP:
                    this._repeat( null, options.page, event );
                    return true;
                case keyCode.PAGE_DOWN:
                    this._repeat( null, -options.page, event );
                    return true;
            }

            return false;
        },

        _uiSpinnerHtml: function() {
            return "<span class='ui-spinner ui-widget ui-widget-content ui-corner-all'></span>";
        },

        _buttonHtml: function() {
            return "" +
                "<a class='ui-spinner-button ui-spinner-up ui-corner-tr'>" +
                "<span class='ui-icon " + this.options.icons.up + "'>&#9650;</span>" +
                "</a>" +
                "<a class='ui-spinner-button ui-spinner-down ui-corner-br'>" +
                "<span class='ui-icon " + this.options.icons.down + "'>&#9660;</span>" +
                "</a>";
        },

        _start: function( event ) {
            if ( !this.spinning && this._trigger( "start", event ) === false ) {
                return false;
            }

            if ( !this.counter ) {
                this.counter = 1;
            }
            this.spinning = true;
            return true;
        },

        _repeat: function( i, steps, event ) {
            i = i || 500;

            clearTimeout( this.timer );
            this.timer = this._delay(function() {
                this._repeat( 40, steps, event );
            }, i );

            this._spin( steps * this.options.step, event );
        },

        _spin: function( step, event ) {
            var value = this.value() || 0;

            if ( !this.counter ) {
                this.counter = 1;
            }

            value = this._adjustValue( value + step * this._increment( this.counter ) );

            if ( !this.spinning || this._trigger( "spin", event, { value: value } ) !== false) {
                this._value( value );
                this.counter++;
            }
        },

        _increment: function( i ) {
            var incremental = this.options.incremental;

            if ( incremental ) {
                return $.isFunction( incremental ) ?
                    incremental( i ) :
                    Math.floor( i*i*i/50000 - i*i/500 + 17*i/200 + 1 );
            }

            return 1;
        },

        _precision: function() {
            var precision = this._precisionOf( this.options.step );
            if ( this.options.min !== null ) {
                precision = Math.max( precision, this._precisionOf( this.options.min ) );
            }
            return precision;
        },

        _precisionOf: function( num ) {
            var str = num.toString(),
                decimal = str.indexOf( "." );
            return decimal === -1 ? 0 : str.length - decimal - 1;
        },

        _adjustValue: function( value ) {
            var base, aboveMin,
                options = this.options;

            // make sure we're at a valid step
            // - find out where we are relative to the base (min or 0)
            base = options.min !== null ? options.min : 0;
            aboveMin = value - base;
            // - round to the nearest step
            aboveMin = Math.round(aboveMin / options.step) * options.step;
            // - rounding is based on 0, so adjust back to our base
            value = base + aboveMin;

            // fix precision from bad JS floating point math
            value = parseFloat( value.toFixed( this._precision() ) );

            // clamp the value
            if ( options.max !== null && value > options.max) {
                return options.max;
            }
            if ( options.min !== null && value < options.min ) {
                return options.min;
            }

            return value;
        },

        _stop: function( event ) {
            if ( !this.spinning ) {
                return;
            }

            clearTimeout( this.timer );
            clearTimeout( this.mousewheelTimer );
            this.counter = 0;
            this.spinning = false;
            this._trigger( "stop", event );
        },

        _setOption: function( key, value ) {
            if ( key === "culture" || key === "numberFormat" ) {
                var prevValue = this._parse( this.element.val() );
                this.options[ key ] = value;
                this.element.val( this._format( prevValue ) );
                return;
            }

            if ( key === "max" || key === "min" || key === "step" ) {
                if ( typeof value === "string" ) {
                    value = this._parse( value );
                }
            }
            if ( key === "icons" ) {
                this.buttons.first().find( ".ui-icon" )
                    .removeClass( this.options.icons.up )
                    .addClass( value.up );
                this.buttons.last().find( ".ui-icon" )
                    .removeClass( this.options.icons.down )
                    .addClass( value.down );
            }

            this._super( key, value );

            if ( key === "disabled" ) {
                if ( value ) {
                    this.element.prop( "disabled", true );
                    this.buttons.button( "disable" );
                } else {
                    this.element.prop( "disabled", false );
                    this.buttons.button( "enable" );
                }
            }
        },

        _setOptions: modifier(function( options ) {
            this._super( options );
            this._value( this.element.val() );
        }),

        _parse: function( val ) {
            if ( typeof val === "string" && val !== "" ) {
                val = window.Globalize && this.options.numberFormat ?
                    Globalize.parseFloat( val, 10, this.options.culture ) : +val;
            }
            return val === "" || isNaN( val ) ? null : val;
        },

        _format: function( value ) {
            if ( value === "" ) {
                return "";
            }
            return window.Globalize && this.options.numberFormat ?
                Globalize.format( value, this.options.numberFormat, this.options.culture ) :
                value;
        },

        _refresh: function() {
            this.element.attr({
                "aria-valuemin": this.options.min,
                "aria-valuemax": this.options.max,
                // TODO: what should we do with values that can't be parsed?
                "aria-valuenow": this._parse( this.element.val() )
            });
        },

        // update the value without triggering change
        _value: function( value, allowAny ) {
            var parsed;
            if ( value !== "" ) {
                parsed = this._parse( value );
                if ( parsed !== null ) {
                    if ( !allowAny ) {
                        parsed = this._adjustValue( parsed );
                    }
                    value = this._format( parsed );
                }
            }
            this.element.val( value );
            this._refresh();
        },

        _destroy: function() {
            this.element
                .removeClass( "ui-spinner-input" )
                .prop( "disabled", false )
                .removeAttr( "autocomplete" )
                .removeAttr( "role" )
                .removeAttr( "aria-valuemin" )
                .removeAttr( "aria-valuemax" )
                .removeAttr( "aria-valuenow" );
            this.uiSpinner.replaceWith( this.element );
        },

        stepUp: modifier(function( steps ) {
            this._stepUp( steps );
        }),
        _stepUp: function( steps ) {
            if ( this._start() ) {
                this._spin( (steps || 1) * this.options.step );
                this._stop();
            }
        },

        stepDown: modifier(function( steps ) {
            this._stepDown( steps );
        }),
        _stepDown: function( steps ) {
            if ( this._start() ) {
                this._spin( (steps || 1) * -this.options.step );
                this._stop();
            }
        },

        pageUp: modifier(function( pages ) {
            this._stepUp( (pages || 1) * this.options.page );
        }),

        pageDown: modifier(function( pages ) {
            this._stepDown( (pages || 1) * this.options.page );
        }),

        value: function( newVal ) {
            if ( !arguments.length ) {
                return this._parse( this.element.val() );
            }
            modifier( this._value ).call( this, newVal );
        },

        widget: function() {
            return this.uiSpinner;
        }
    });

}( jQuery ) );

(function( $, undefined ) {

    var tabId = 0,
        rhash = /#.*$/;

    function getNextTabId() {
        return ++tabId;
    }

    function isLocal( anchor ) {
        return anchor.hash.length > 1 &&
            decodeURIComponent( anchor.href.replace( rhash, "" ) ) ===
            decodeURIComponent( location.href.replace( rhash, "" ) );
    }

    $.widget( "ui.tabs", {
        version: "1.10.2",
        delay: 300,
        options: {
            active: null,
            collapsible: false,
            event: "click",
            heightStyle: "content",
            hide: null,
            show: null,

            // callbacks
            activate: null,
            beforeActivate: null,
            beforeLoad: null,
            load: null
        },

        _create: function() {
            var that = this,
                options = this.options;

            this.running = false;

            this.element
                .addClass( "ui-tabs ui-widget ui-widget-content ui-corner-all" )
                .toggleClass( "ui-tabs-collapsible", options.collapsible )
                // Prevent users from focusing disabled tabs via click
                .delegate( ".ui-tabs-nav > li", "mousedown" + this.eventNamespace, function( event ) {
                    if ( $( this ).is( ".ui-state-disabled" ) ) {
                        event.preventDefault();
                    }
                })
                // support: IE <9
                // Preventing the default action in mousedown doesn't prevent IE
                // from focusing the element, so if the anchor gets focused, blur.
                // We don't have to worry about focusing the previously focused
                // element since clicking on a non-focusable element should focus
                // the body anyway.
                .delegate( ".ui-tabs-anchor", "focus" + this.eventNamespace, function() {
                    if ( $( this ).closest( "li" ).is( ".ui-state-disabled" ) ) {
                        this.blur();
                    }
                });

            this._processTabs();
            options.active = this._initialActive();

            // Take disabling tabs via class attribute from HTML
            // into account and update option properly.
            if ( $.isArray( options.disabled ) ) {
                options.disabled = $.unique( options.disabled.concat(
                    $.map( this.tabs.filter( ".ui-state-disabled" ), function( li ) {
                        return that.tabs.index( li );
                    })
                ) ).sort();
            }

            // check for length avoids error when initializing empty list
            if ( this.options.active !== false && this.anchors.length ) {
                this.active = this._findActive( options.active );
            } else {
                this.active = $();
            }

            this._refresh();

            if ( this.active.length ) {
                this.load( options.active );
            }
        },

        _initialActive: function() {
            var active = this.options.active,
                collapsible = this.options.collapsible,
                locationHash = location.hash.substring( 1 );

            if ( active === null ) {
                // check the fragment identifier in the URL
                if ( locationHash ) {
                    this.tabs.each(function( i, tab ) {
                        if ( $( tab ).attr( "aria-controls" ) === locationHash ) {
                            active = i;
                            return false;
                        }
                    });
                }

                // check for a tab marked active via a class
                if ( active === null ) {
                    active = this.tabs.index( this.tabs.filter( ".ui-tabs-active" ) );
                }

                // no active tab, set to false
                if ( active === null || active === -1 ) {
                    active = this.tabs.length ? 0 : false;
                }
            }

            // handle numbers: negative, out of range
            if ( active !== false ) {
                active = this.tabs.index( this.tabs.eq( active ) );
                if ( active === -1 ) {
                    active = collapsible ? false : 0;
                }
            }

            // don't allow collapsible: false and active: false
            if ( !collapsible && active === false && this.anchors.length ) {
                active = 0;
            }

            return active;
        },

        _getCreateEventData: function() {
            return {
                tab: this.active,
                panel: !this.active.length ? $() : this._getPanelForTab( this.active )
            };
        },

        _tabKeydown: function( event ) {
            /*jshint maxcomplexity:15*/
            var focusedTab = $( this.document[0].activeElement ).closest( "li" ),
                selectedIndex = this.tabs.index( focusedTab ),
                goingForward = true;

            if ( this._handlePageNav( event ) ) {
                return;
            }

            switch ( event.keyCode ) {
                case $.ui.keyCode.RIGHT:
                case $.ui.keyCode.DOWN:
                    selectedIndex++;
                    break;
                case $.ui.keyCode.UP:
                case $.ui.keyCode.LEFT:
                    goingForward = false;
                    selectedIndex--;
                    break;
                case $.ui.keyCode.END:
                    selectedIndex = this.anchors.length - 1;
                    break;
                case $.ui.keyCode.HOME:
                    selectedIndex = 0;
                    break;
                case $.ui.keyCode.SPACE:
                    // Activate only, no collapsing
                    event.preventDefault();
                    clearTimeout( this.activating );
                    this._activate( selectedIndex );
                    return;
                case $.ui.keyCode.ENTER:
                    // Toggle (cancel delayed activation, allow collapsing)
                    event.preventDefault();
                    clearTimeout( this.activating );
                    // Determine if we should collapse or activate
                    this._activate( selectedIndex === this.options.active ? false : selectedIndex );
                    return;
                default:
                    return;
            }

            // Focus the appropriate tab, based on which key was pressed
            event.preventDefault();
            clearTimeout( this.activating );
            selectedIndex = this._focusNextTab( selectedIndex, goingForward );

            // Navigating with control key will prevent automatic activation
            if ( !event.ctrlKey ) {
                // Update aria-selected immediately so that AT think the tab is already selected.
                // Otherwise AT may confuse the user by stating that they need to activate the tab,
                // but the tab will already be activated by the time the announcement finishes.
                focusedTab.attr( "aria-selected", "false" );
                this.tabs.eq( selectedIndex ).attr( "aria-selected", "true" );

                this.activating = this._delay(function() {
                    this.option( "active", selectedIndex );
                }, this.delay );
            }
        },

        _panelKeydown: function( event ) {
            if ( this._handlePageNav( event ) ) {
                return;
            }

            // Ctrl+up moves focus to the current tab
            if ( event.ctrlKey && event.keyCode === $.ui.keyCode.UP ) {
                event.preventDefault();
                this.active.focus();
            }
        },

        // Alt+page up/down moves focus to the previous/next tab (and activates)
        _handlePageNav: function( event ) {
            if ( event.altKey && event.keyCode === $.ui.keyCode.PAGE_UP ) {
                this._activate( this._focusNextTab( this.options.active - 1, false ) );
                return true;
            }
            if ( event.altKey && event.keyCode === $.ui.keyCode.PAGE_DOWN ) {
                this._activate( this._focusNextTab( this.options.active + 1, true ) );
                return true;
            }
        },

        _findNextTab: function( index, goingForward ) {
            var lastTabIndex = this.tabs.length - 1;

            function constrain() {
                if ( index > lastTabIndex ) {
                    index = 0;
                }
                if ( index < 0 ) {
                    index = lastTabIndex;
                }
                return index;
            }

            while ( $.inArray( constrain(), this.options.disabled ) !== -1 ) {
                index = goingForward ? index + 1 : index - 1;
            }

            return index;
        },

        _focusNextTab: function( index, goingForward ) {
            index = this._findNextTab( index, goingForward );
            this.tabs.eq( index ).focus();
            return index;
        },

        _setOption: function( key, value ) {
            if ( key === "active" ) {
                // _activate() will handle invalid values and update this.options
                this._activate( value );
                return;
            }

            if ( key === "disabled" ) {
                // don't use the widget factory's disabled handling
                this._setupDisabled( value );
                return;
            }

            this._super( key, value);

            if ( key === "collapsible" ) {
                this.element.toggleClass( "ui-tabs-collapsible", value );
                // Setting collapsible: false while collapsed; open first panel
                if ( !value && this.options.active === false ) {
                    this._activate( 0 );
                }
            }

            if ( key === "event" ) {
                this._setupEvents( value );
            }

            if ( key === "heightStyle" ) {
                this._setupHeightStyle( value );
            }
        },

        _tabId: function( tab ) {
            return tab.attr( "aria-controls" ) || "ui-tabs-" + getNextTabId();
        },

        _sanitizeSelector: function( hash ) {
            return hash ? hash.replace( /[!"$%&'()*+,.\/:;<=>?@\[\]\^`{|}~]/g, "\\$&" ) : "";
        },

        refresh: function() {
            var options = this.options,
                lis = this.tablist.children( ":has(a[href])" );

            // get disabled tabs from class attribute from HTML
            // this will get converted to a boolean if needed in _refresh()
            options.disabled = $.map( lis.filter( ".ui-state-disabled" ), function( tab ) {
                return lis.index( tab );
            });

            this._processTabs();

            // was collapsed or no tabs
            if ( options.active === false || !this.anchors.length ) {
                options.active = false;
                this.active = $();
                // was active, but active tab is gone
            } else if ( this.active.length && !$.contains( this.tablist[ 0 ], this.active[ 0 ] ) ) {
                // all remaining tabs are disabled
                if ( this.tabs.length === options.disabled.length ) {
                    options.active = false;
                    this.active = $();
                    // activate previous tab
                } else {
                    this._activate( this._findNextTab( Math.max( 0, options.active - 1 ), false ) );
                }
                // was active, active tab still exists
            } else {
                // make sure active index is correct
                options.active = this.tabs.index( this.active );
            }

            this._refresh();
        },

        _refresh: function() {
            this._setupDisabled( this.options.disabled );
            this._setupEvents( this.options.event );
            this._setupHeightStyle( this.options.heightStyle );

            this.tabs.not( this.active ).attr({
                "aria-selected": "false",
                tabIndex: -1
            });
            this.panels.not( this._getPanelForTab( this.active ) )
                .hide()
                .attr({
                    "aria-expanded": "false",
                    "aria-hidden": "true"
                });

            // Make sure one tab is in the tab order
            if ( !this.active.length ) {
                this.tabs.eq( 0 ).attr( "tabIndex", 0 );
            } else {
                this.active
                    .addClass( "ui-tabs-active ui-state-active" )
                    .attr({
                        "aria-selected": "true",
                        tabIndex: 0
                    });
                this._getPanelForTab( this.active )
                    .show()
                    .attr({
                        "aria-expanded": "true",
                        "aria-hidden": "false"
                    });
            }
        },

        _processTabs: function() {
            var that = this;

            this.tablist = this._getList()
                .addClass( "ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all" )
                .attr( "role", "tablist" );

            this.tabs = this.tablist.find( "> li:has(a[href])" )
                .addClass( "ui-state-default ui-corner-top" )
                .attr({
                    role: "tab",
                    tabIndex: -1
                });

            this.anchors = this.tabs.map(function() {
                return $( "a", this )[ 0 ];
            })
                .addClass( "ui-tabs-anchor" )
                .attr({
                    role: "presentation",
                    tabIndex: -1
                });

            this.panels = $();

            this.anchors.each(function( i, anchor ) {
                var selector, panel, panelId,
                    anchorId = $( anchor ).uniqueId().attr( "id" ),
                    tab = $( anchor ).closest( "li" ),
                    originalAriaControls = tab.attr( "aria-controls" );

                // inline tab
                if ( isLocal( anchor ) ) {
                    selector = anchor.hash;
                    panel = that.element.find( that._sanitizeSelector( selector ) );
                    // remote tab
                } else {
                    panelId = that._tabId( tab );
                    selector = "#" + panelId;
                    panel = that.element.find( selector );
                    if ( !panel.length ) {
                        panel = that._createPanel( panelId );
                        panel.insertAfter( that.panels[ i - 1 ] || that.tablist );
                    }
                    panel.attr( "aria-live", "polite" );
                }

                if ( panel.length) {
                    that.panels = that.panels.add( panel );
                }
                if ( originalAriaControls ) {
                    tab.data( "ui-tabs-aria-controls", originalAriaControls );
                }
                tab.attr({
                    "aria-controls": selector.substring( 1 ),
                    "aria-labelledby": anchorId
                });
                panel.attr( "aria-labelledby", anchorId );
            });

            this.panels
                .addClass( "ui-tabs-panel ui-widget-content ui-corner-bottom" )
                .attr( "role", "tabpanel" );
        },

        // allow overriding how to find the list for rare usage scenarios (#7715)
        _getList: function() {
            return this.element.find( "ol,ul" ).eq( 0 );
        },

        _createPanel: function( id ) {
            return $( "<div>" )
                .attr( "id", id )
                .addClass( "ui-tabs-panel ui-widget-content ui-corner-bottom" )
                .data( "ui-tabs-destroy", true );
        },

        _setupDisabled: function( disabled ) {
            if ( $.isArray( disabled ) ) {
                if ( !disabled.length ) {
                    disabled = false;
                } else if ( disabled.length === this.anchors.length ) {
                    disabled = true;
                }
            }

            // disable tabs
            for ( var i = 0, li; ( li = this.tabs[ i ] ); i++ ) {
                if ( disabled === true || $.inArray( i, disabled ) !== -1 ) {
                    $( li )
                        .addClass( "ui-state-disabled" )
                        .attr( "aria-disabled", "true" );
                } else {
                    $( li )
                        .removeClass( "ui-state-disabled" )
                        .removeAttr( "aria-disabled" );
                }
            }

            this.options.disabled = disabled;
        },

        _setupEvents: function( event ) {
            var events = {
                click: function( event ) {
                    event.preventDefault();
                }
            };
            if ( event ) {
                $.each( event.split(" "), function( index, eventName ) {
                    events[ eventName ] = "_eventHandler";
                });
            }

            this._off( this.anchors.add( this.tabs ).add( this.panels ) );
            this._on( this.anchors, events );
            this._on( this.tabs, { keydown: "_tabKeydown" } );
            this._on( this.panels, { keydown: "_panelKeydown" } );

            this._focusable( this.tabs );
            this._hoverable( this.tabs );
        },

        _setupHeightStyle: function( heightStyle ) {
            var maxHeight,
                parent = this.element.parent();

            if ( heightStyle === "fill" ) {
                maxHeight = parent.height();
                maxHeight -= this.element.outerHeight() - this.element.height();

                this.element.siblings( ":visible" ).each(function() {
                    var elem = $( this ),
                        position = elem.css( "position" );

                    if ( position === "absolute" || position === "fixed" ) {
                        return;
                    }
                    maxHeight -= elem.outerHeight( true );
                });

                this.element.children().not( this.panels ).each(function() {
                    maxHeight -= $( this ).outerHeight( true );
                });

                this.panels.each(function() {
                    $( this ).height( Math.max( 0, maxHeight -
                        $( this ).innerHeight() + $( this ).height() ) );
                })
                    .css( "overflow", "auto" );
            } else if ( heightStyle === "auto" ) {
                maxHeight = 0;
                this.panels.each(function() {
                    maxHeight = Math.max( maxHeight, $( this ).height( "" ).height() );
                }).height( maxHeight );
            }
        },

        _eventHandler: function( event ) {
            var options = this.options,
                active = this.active,
                anchor = $( event.currentTarget ),
                tab = anchor.closest( "li" ),
                clickedIsActive = tab[ 0 ] === active[ 0 ],
                collapsing = clickedIsActive && options.collapsible,
                toShow = collapsing ? $() : this._getPanelForTab( tab ),
                toHide = !active.length ? $() : this._getPanelForTab( active ),
                eventData = {
                    oldTab: active,
                    oldPanel: toHide,
                    newTab: collapsing ? $() : tab,
                    newPanel: toShow
                };

            event.preventDefault();

            if ( tab.hasClass( "ui-state-disabled" ) ||
                // tab is already loading
                tab.hasClass( "ui-tabs-loading" ) ||
                // can't switch durning an animation
                this.running ||
                // click on active header, but not collapsible
                ( clickedIsActive && !options.collapsible ) ||
                // allow canceling activation
                ( this._trigger( "beforeActivate", event, eventData ) === false ) ) {
                return;
            }

            options.active = collapsing ? false : this.tabs.index( tab );

            this.active = clickedIsActive ? $() : tab;
            if ( this.xhr ) {
                this.xhr.abort();
            }

            if ( !toHide.length && !toShow.length ) {
                $.error( "jQuery UI Tabs: Mismatching fragment identifier." );
            }

            if ( toShow.length ) {
                this.load( this.tabs.index( tab ), event );
            }
            this._toggle( event, eventData );
        },

        // handles show/hide for selecting tabs
        _toggle: function( event, eventData ) {
            var that = this,
                toShow = eventData.newPanel,
                toHide = eventData.oldPanel;

            this.running = true;

            function complete() {
                that.running = false;
                that._trigger( "activate", event, eventData );
            }

            function show() {
                eventData.newTab.closest( "li" ).addClass( "ui-tabs-active ui-state-active" );

                if ( toShow.length && that.options.show ) {
                    that._show( toShow, that.options.show, complete );
                } else {
                    toShow.show();
                    complete();
                }
            }

            // start out by hiding, then showing, then completing
            if ( toHide.length && this.options.hide ) {
                this._hide( toHide, this.options.hide, function() {
                    eventData.oldTab.closest( "li" ).removeClass( "ui-tabs-active ui-state-active" );
                    show();
                });
            } else {
                eventData.oldTab.closest( "li" ).removeClass( "ui-tabs-active ui-state-active" );
                toHide.hide();
                show();
            }

            toHide.attr({
                "aria-expanded": "false",
                "aria-hidden": "true"
            });
            eventData.oldTab.attr( "aria-selected", "false" );
            // If we're switching tabs, remove the old tab from the tab order.
            // If we're opening from collapsed state, remove the previous tab from the tab order.
            // If we're collapsing, then keep the collapsing tab in the tab order.
            if ( toShow.length && toHide.length ) {
                eventData.oldTab.attr( "tabIndex", -1 );
            } else if ( toShow.length ) {
                this.tabs.filter(function() {
                    return $( this ).attr( "tabIndex" ) === 0;
                })
                    .attr( "tabIndex", -1 );
            }

            toShow.attr({
                "aria-expanded": "true",
                "aria-hidden": "false"
            });
            eventData.newTab.attr({
                "aria-selected": "true",
                tabIndex: 0
            });
        },

        _activate: function( index ) {
            var anchor,
                active = this._findActive( index );

            // trying to activate the already active panel
            if ( active[ 0 ] === this.active[ 0 ] ) {
                return;
            }

            // trying to collapse, simulate a click on the current active header
            if ( !active.length ) {
                active = this.active;
            }

            anchor = active.find( ".ui-tabs-anchor" )[ 0 ];
            this._eventHandler({
                target: anchor,
                currentTarget: anchor,
                preventDefault: $.noop
            });
        },

        _findActive: function( index ) {
            return index === false ? $() : this.tabs.eq( index );
        },

        _getIndex: function( index ) {
            // meta-function to give users option to provide a href string instead of a numerical index.
            if ( typeof index === "string" ) {
                index = this.anchors.index( this.anchors.filter( "[href$='" + index + "']" ) );
            }

            return index;
        },

        _destroy: function() {
            if ( this.xhr ) {
                this.xhr.abort();
            }

            this.element.removeClass( "ui-tabs ui-widget ui-widget-content ui-corner-all ui-tabs-collapsible" );

            this.tablist
                .removeClass( "ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all" )
                .removeAttr( "role" );

            this.anchors
                .removeClass( "ui-tabs-anchor" )
                .removeAttr( "role" )
                .removeAttr( "tabIndex" )
                .removeUniqueId();

            this.tabs.add( this.panels ).each(function() {
                if ( $.data( this, "ui-tabs-destroy" ) ) {
                    $( this ).remove();
                } else {
                    $( this )
                        .removeClass( "ui-state-default ui-state-active ui-state-disabled " +
                            "ui-corner-top ui-corner-bottom ui-widget-content ui-tabs-active ui-tabs-panel" )
                        .removeAttr( "tabIndex" )
                        .removeAttr( "aria-live" )
                        .removeAttr( "aria-busy" )
                        .removeAttr( "aria-selected" )
                        .removeAttr( "aria-labelledby" )
                        .removeAttr( "aria-hidden" )
                        .removeAttr( "aria-expanded" )
                        .removeAttr( "role" );
                }
            });

            this.tabs.each(function() {
                var li = $( this ),
                    prev = li.data( "ui-tabs-aria-controls" );
                if ( prev ) {
                    li
                        .attr( "aria-controls", prev )
                        .removeData( "ui-tabs-aria-controls" );
                } else {
                    li.removeAttr( "aria-controls" );
                }
            });

            this.panels.show();

            if ( this.options.heightStyle !== "content" ) {
                this.panels.css( "height", "" );
            }
        },

        enable: function( index ) {
            var disabled = this.options.disabled;
            if ( disabled === false ) {
                return;
            }

            if ( index === undefined ) {
                disabled = false;
            } else {
                index = this._getIndex( index );
                if ( $.isArray( disabled ) ) {
                    disabled = $.map( disabled, function( num ) {
                        return num !== index ? num : null;
                    });
                } else {
                    disabled = $.map( this.tabs, function( li, num ) {
                        return num !== index ? num : null;
                    });
                }
            }
            this._setupDisabled( disabled );
        },

        disable: function( index ) {
            var disabled = this.options.disabled;
            if ( disabled === true ) {
                return;
            }

            if ( index === undefined ) {
                disabled = true;
            } else {
                index = this._getIndex( index );
                if ( $.inArray( index, disabled ) !== -1 ) {
                    return;
                }
                if ( $.isArray( disabled ) ) {
                    disabled = $.merge( [ index ], disabled ).sort();
                } else {
                    disabled = [ index ];
                }
            }
            this._setupDisabled( disabled );
        },

        load: function( index, event ) {
            index = this._getIndex( index );
            var that = this,
                tab = this.tabs.eq( index ),
                anchor = tab.find( ".ui-tabs-anchor" ),
                panel = this._getPanelForTab( tab ),
                eventData = {
                    tab: tab,
                    panel: panel
                };

            // not remote
            if ( isLocal( anchor[ 0 ] ) ) {
                return;
            }

            this.xhr = $.ajax( this._ajaxSettings( anchor, event, eventData ) );

            // support: jQuery <1.8
            // jQuery <1.8 returns false if the request is canceled in beforeSend,
            // but as of 1.8, $.ajax() always returns a jqXHR object.
            if ( this.xhr && this.xhr.statusText !== "canceled" ) {
                tab.addClass( "ui-tabs-loading" );
                panel.attr( "aria-busy", "true" );

                this.xhr
                    .success(function( response ) {
                        // support: jQuery <1.8
                        // http://bugs.jquery.com/ticket/11778
                        setTimeout(function() {
                            panel.html( response );
                            that._trigger( "load", event, eventData );
                        }, 1 );
                    })
                    .complete(function( jqXHR, status ) {
                        // support: jQuery <1.8
                        // http://bugs.jquery.com/ticket/11778
                        setTimeout(function() {
                            if ( status === "abort" ) {
                                that.panels.stop( false, true );
                            }

                            tab.removeClass( "ui-tabs-loading" );
                            panel.removeAttr( "aria-busy" );

                            if ( jqXHR === that.xhr ) {
                                delete that.xhr;
                            }
                        }, 1 );
                    });
            }
        },

        _ajaxSettings: function( anchor, event, eventData ) {
            var that = this;
            return {
                url: anchor.attr( "href" ),
                beforeSend: function( jqXHR, settings ) {
                    return that._trigger( "beforeLoad", event,
                        $.extend( { jqXHR : jqXHR, ajaxSettings: settings }, eventData ) );
                }
            };
        },

        _getPanelForTab: function( tab ) {
            var id = $( tab ).attr( "aria-controls" );
            return this.element.find( this._sanitizeSelector( "#" + id ) );
        }
    });

})( jQuery );

(function( $ ) {

    var increments = 0;

    function addDescribedBy( elem, id ) {
        var describedby = (elem.attr( "aria-describedby" ) || "").split( /\s+/ );
        describedby.push( id );
        elem
            .data( "ui-tooltip-id", id )
            .attr( "aria-describedby", $.trim( describedby.join( " " ) ) );
    }

    function removeDescribedBy( elem ) {
        var id = elem.data( "ui-tooltip-id" ),
            describedby = (elem.attr( "aria-describedby" ) || "").split( /\s+/ ),
            index = $.inArray( id, describedby );
        if ( index !== -1 ) {
            describedby.splice( index, 1 );
        }

        elem.removeData( "ui-tooltip-id" );
        describedby = $.trim( describedby.join( " " ) );
        if ( describedby ) {
            elem.attr( "aria-describedby", describedby );
        } else {
            elem.removeAttr( "aria-describedby" );
        }
    }

    $.widget( "ui.tooltip", {
        version: "1.10.2",
        options: {
            content: function() {
                // support: IE<9, Opera in jQuery <1.7
                // .text() can't accept undefined, so coerce to a string
                var title = $( this ).attr( "title" ) || "";
                // Escape title, since we're going from an attribute to raw HTML
                return $( "<a>" ).text( title ).html();
            },
            hide: true,
            // Disabled elements have inconsistent behavior across browsers (#8661)
            items: "[title]:not([disabled])",
            position: {
                my: "left top+15",
                at: "left bottom",
                collision: "flipfit flip"
            },
            show: true,
            tooltipClass: null,
            track: false,

            // callbacks
            close: null,
            open: null
        },

        _create: function() {
            this._on({
                mouseover: "open",
                focusin: "open"
            });

            // IDs of generated tooltips, needed for destroy
            this.tooltips = {};
            // IDs of parent tooltips where we removed the title attribute
            this.parents = {};

            if ( this.options.disabled ) {
                this._disable();
            }
        },

        _setOption: function( key, value ) {
            var that = this;

            if ( key === "disabled" ) {
                this[ value ? "_disable" : "_enable" ]();
                this.options[ key ] = value;
                // disable element style changes
                return;
            }

            this._super( key, value );

            if ( key === "content" ) {
                $.each( this.tooltips, function( id, element ) {
                    that._updateContent( element );
                });
            }
        },

        _disable: function() {
            var that = this;

            // close open tooltips
            $.each( this.tooltips, function( id, element ) {
                var event = $.Event( "blur" );
                event.target = event.currentTarget = element[0];
                that.close( event, true );
            });

            // remove title attributes to prevent native tooltips
            this.element.find( this.options.items ).addBack().each(function() {
                var element = $( this );
                if ( element.is( "[title]" ) ) {
                    element
                        .data( "ui-tooltip-title", element.attr( "title" ) )
                        .attr( "title", "" );
                }
            });
        },

        _enable: function() {
            // restore title attributes
            this.element.find( this.options.items ).addBack().each(function() {
                var element = $( this );
                if ( element.data( "ui-tooltip-title" ) ) {
                    element.attr( "title", element.data( "ui-tooltip-title" ) );
                }
            });
        },

        open: function( event ) {
            var that = this,
                target = $( event ? event.target : this.element )
                // we need closest here due to mouseover bubbling,
                // but always pointing at the same event target
                    .closest( this.options.items );

            // No element to show a tooltip for or the tooltip is already open
            if ( !target.length || target.data( "ui-tooltip-id" ) ) {
                return;
            }

            if ( target.attr( "title" ) ) {
                target.data( "ui-tooltip-title", target.attr( "title" ) );
            }

            target.data( "ui-tooltip-open", true );

            // kill parent tooltips, custom or native, for hover
            if ( event && event.type === "mouseover" ) {
                target.parents().each(function() {
                    var parent = $( this ),
                        blurEvent;
                    if ( parent.data( "ui-tooltip-open" ) ) {
                        blurEvent = $.Event( "blur" );
                        blurEvent.target = blurEvent.currentTarget = this;
                        that.close( blurEvent, true );
                    }
                    if ( parent.attr( "title" ) ) {
                        parent.uniqueId();
                        that.parents[ this.id ] = {
                            element: this,
                            title: parent.attr( "title" )
                        };
                        parent.attr( "title", "" );
                    }
                });
            }

            this._updateContent( target, event );
        },

        _updateContent: function( target, event ) {
            var content,
                contentOption = this.options.content,
                that = this,
                eventType = event ? event.type : null;

            if ( typeof contentOption === "string" ) {
                return this._open( event, target, contentOption );
            }

            content = contentOption.call( target[0], function( response ) {
                // ignore async response if tooltip was closed already
                if ( !target.data( "ui-tooltip-open" ) ) {
                    return;
                }
                // IE may instantly serve a cached response for ajax requests
                // delay this call to _open so the other call to _open runs first
                that._delay(function() {
                    // jQuery creates a special event for focusin when it doesn't
                    // exist natively. To improve performance, the native event
                    // object is reused and the type is changed. Therefore, we can't
                    // rely on the type being correct after the event finished
                    // bubbling, so we set it back to the previous value. (#8740)
                    if ( event ) {
                        event.type = eventType;
                    }
                    this._open( event, target, response );
                });
            });
            if ( content ) {
                this._open( event, target, content );
            }
        },

        _open: function( event, target, content ) {
            var tooltip, events, delayedShow,
                positionOption = $.extend( {}, this.options.position );

            if ( !content ) {
                return;
            }

            // Content can be updated multiple times. If the tooltip already
            // exists, then just update the content and bail.
            tooltip = this._find( target );
            if ( tooltip.length ) {
                tooltip.find( ".ui-tooltip-content" ).html( content );
                return;
            }

            // if we have a title, clear it to prevent the native tooltip
            // we have to check first to avoid defining a title if none exists
            // (we don't want to cause an element to start matching [title])
            //
            // We use removeAttr only for key events, to allow IE to export the correct
            // accessible attributes. For mouse events, set to empty string to avoid
            // native tooltip showing up (happens only when removing inside mouseover).
            if ( target.is( "[title]" ) ) {
                if ( event && event.type === "mouseover" ) {
                    target.attr( "title", "" );
                } else {
                    target.removeAttr( "title" );
                }
            }

            tooltip = this._tooltip( target );
            addDescribedBy( target, tooltip.attr( "id" ) );
            tooltip.find( ".ui-tooltip-content" ).html( content );

            function position( event ) {
                positionOption.of = event;
                if ( tooltip.is( ":hidden" ) ) {
                    return;
                }
                tooltip.position( positionOption );
            }
            if ( this.options.track && event && /^mouse/.test( event.type ) ) {
                this._on( this.document, {
                    mousemove: position
                });
                // trigger once to override element-relative positioning
                position( event );
            } else {
                tooltip.position( $.extend({
                    of: target
                }, this.options.position ) );
            }

            tooltip.hide();

            this._show( tooltip, this.options.show );
            // Handle tracking tooltips that are shown with a delay (#8644). As soon
            // as the tooltip is visible, position the tooltip using the most recent
            // event.
            if ( this.options.show && this.options.show.delay ) {
                delayedShow = this.delayedShow = setInterval(function() {
                    if ( tooltip.is( ":visible" ) ) {
                        position( positionOption.of );
                        clearInterval( delayedShow );
                    }
                }, $.fx.interval );
            }

            this._trigger( "open", event, { tooltip: tooltip } );

            events = {
                keyup: function( event ) {
                    if ( event.keyCode === $.ui.keyCode.ESCAPE ) {
                        var fakeEvent = $.Event(event);
                        fakeEvent.currentTarget = target[0];
                        this.close( fakeEvent, true );
                    }
                },
                remove: function() {
                    this._removeTooltip( tooltip );
                }
            };
            if ( !event || event.type === "mouseover" ) {
                events.mouseleave = "close";
            }
            if ( !event || event.type === "focusin" ) {
                events.focusout = "close";
            }
            this._on( true, target, events );
        },

        close: function( event ) {
            var that = this,
                target = $( event ? event.currentTarget : this.element ),
                tooltip = this._find( target );

            // disabling closes the tooltip, so we need to track when we're closing
            // to avoid an infinite loop in case the tooltip becomes disabled on close
            if ( this.closing ) {
                return;
            }

            // Clear the interval for delayed tracking tooltips
            clearInterval( this.delayedShow );

            // only set title if we had one before (see comment in _open())
            if ( target.data( "ui-tooltip-title" ) ) {
                target.attr( "title", target.data( "ui-tooltip-title" ) );
            }

            removeDescribedBy( target );

            tooltip.stop( true );
            this._hide( tooltip, this.options.hide, function() {
                that._removeTooltip( $( this ) );
            });

            target.removeData( "ui-tooltip-open" );
            this._off( target, "mouseleave focusout keyup" );
            // Remove 'remove' binding only on delegated targets
            if ( target[0] !== this.element[0] ) {
                this._off( target, "remove" );
            }
            this._off( this.document, "mousemove" );

            if ( event && event.type === "mouseleave" ) {
                $.each( this.parents, function( id, parent ) {
                    $( parent.element ).attr( "title", parent.title );
                    delete that.parents[ id ];
                });
            }

            this.closing = true;
            this._trigger( "close", event, { tooltip: tooltip } );
            this.closing = false;
        },

        _tooltip: function( element ) {
            var id = "ui-tooltip-" + increments++,
                tooltip = $( "<div>" )
                    .attr({
                        id: id,
                        role: "tooltip"
                    })
                    .addClass( "ui-tooltip ui-widget ui-corner-all ui-widget-content " +
                        ( this.options.tooltipClass || "" ) );
            $( "<div>" )
                .addClass( "ui-tooltip-content" )
                .appendTo( tooltip );
            tooltip.appendTo( this.document[0].body );
            this.tooltips[ id ] = element;
            return tooltip;
        },

        _find: function( target ) {
            var id = target.data( "ui-tooltip-id" );
            return id ? $( "#" + id ) : $();
        },

        _removeTooltip: function( tooltip ) {
            tooltip.remove();
            delete this.tooltips[ tooltip.attr( "id" ) ];
        },

        _destroy: function() {
            var that = this;

            // close open tooltips
            $.each( this.tooltips, function( id, element ) {
                // Delegate to close method to handle common cleanup
                var event = $.Event( "blur" );
                event.target = event.currentTarget = element[0];
                that.close( event, true );

                // Remove immediately; destroying an open tooltip doesn't use the
                // hide animation
                $( "#" + id ).remove();

                // Restore the title
                if ( element.data( "ui-tooltip-title" ) ) {
                    element.attr( "title", element.data( "ui-tooltip-title" ) );
                    element.removeData( "ui-tooltip-title" );
                }
            });
        }
    });

}( jQuery ) );

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*
 * jQuery UI Slider Access
 * By: Trent Richardson [http://trentrichardson.com]
 * Version 0.3
 * Last Modified: 10/20/2012
 *
 * Copyright 2011 Trent Richardson
 * Dual licensed under the MIT and GPL licenses.
 * http://trentrichardson.com/Impromptu/GPL-LICENSE.txt
 * http://trentrichardson.com/Impromptu/MIT-LICENSE.txt
 *
 */
 (function($){

	$.fn.extend({
		sliderAccess: function(options){
			options = options || {};
			options.touchonly = options.touchonly !== undefined? options.touchonly : true; // by default only show it if touch device

			if(options.touchonly === true && !("ontouchend" in document)){
				return $(this);
			}

			return $(this).each(function(i,obj){
						var $t = $(this),
							o = $.extend({},{
											where: 'after',
											step: $t.slider('option','step'),
											upIcon: 'ui-icon-plus',
											downIcon: 'ui-icon-minus',
											text: false,
											upText: '+',
											downText: '-',
											buttonset: true,
											buttonsetTag: 'span',
											isRTL: false
										}, options),
							$buttons = $('<'+ o.buttonsetTag +' class="ui-slider-access">'+
											'<button data-icon="'+ o.downIcon +'" data-step="'+ (o.isRTL? o.step : o.step*-1) +'">'+ o.downText +'</button>'+
											'<button data-icon="'+ o.upIcon +'" data-step="'+ (o.isRTL? o.step*-1 : o.step) +'">'+ o.upText +'</button>'+
										'</'+ o.buttonsetTag +'>');

						$buttons.children('button').each(function(j, jobj){
							var $jt = $(this);
							$jt.button({
											text: o.text,
											icons: { primary: $jt.data('icon') }
										})
								.click(function(e){
											var step = $jt.data('step'),
												curr = $t.slider('value'),
												newval = curr += step*1,
												minval = $t.slider('option','min'),
												maxval = $t.slider('option','max'),
												slidee = $t.slider("option", "slide") || function(){},
												stope = $t.slider("option", "stop") || function(){};

											e.preventDefault();

											if(newval < minval || newval > maxval){
												return;
											}

											$t.slider('value', newval);

											slidee.call($t, null, { value: newval });
											stope.call($t, null, { value: newval });
										});
						});

						// before or after
						$t[o.where]($buttons);

						if(o.buttonset){
							$buttons.removeClass('ui-corner-right').removeClass('ui-corner-left').buttonset();
							$buttons.eq(0).addClass('ui-corner-left');
							$buttons.eq(1).addClass('ui-corner-right');
						}

						// adjust the width so we don't break the original layout
						var bOuterWidth = $buttons.css({
									marginLeft: ((o.where === 'after' && !o.isRTL) || (o.where === 'before' && o.isRTL)? 10:0),
									marginRight: ((o.where === 'before' && !o.isRTL) || (o.where === 'after' && o.isRTL)? 10:0)
								}).outerWidth(true) + 5;
						var tOuterWidth = $t.outerWidth(true);
						$t.css('display','inline-block').width(tOuterWidth-bOuterWidth);
					});
		}
	});

})(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*
 * jQuery Timepicker Addon
 * By: Trent Richardson [http://trentrichardson.com]
 *
 * Copyright 2013 Trent Richardson
 * You may use this project under MIT license.
 * http://trentrichardson.com/Impromptu/MIT-LICENSE.txt
 */

(function (factory) {
    factory(jQuery);
}(function ($) {

	/*
	* Lets not redefine timepicker, Prevent "Uncaught RangeError: Maximum call stack size exceeded"
	*/
	$.ui.timepicker = $.ui.timepicker || {};
	if ($.ui.timepicker.version) {
		return;
	}

	/*
	* Extend jQueryUI, get it started with our version number
	*/
	$.extend($.ui, {
		timepicker: {
			version: "@@version"
		}
	});

	/*
	* Timepicker manager.
	* Use the singleton instance of this class, $.timepicker, to interact with the time picker.
	* Settings for (groups of) time pickers are maintained in an instance object,
	* allowing multiple different settings on the same page.
	*/
	var Timepicker = function () {
		this.regional = []; // Available regional settings, indexed by language code
		this.regional[''] = { // Default regional settings
			currentText: 'Now',
			closeText: 'Done',
			amNames: ['AM', 'A'],
			pmNames: ['PM', 'P'],
			timeFormat: 'HH:mm',
			timeSuffix: '',
			timeOnlyTitle: 'Choose Time',
			timeText: 'Time',
			hourText: 'Hour',
			minuteText: 'Minute',
			secondText: 'Second',
			millisecText: 'Millisecond',
			microsecText: 'Microsecond',
			timezoneText: 'Time Zone',
			isRTL: false
		};
		this._defaults = { // Global defaults for all the datetime picker instances
			showButtonPanel: true,
			timeOnly: false,
			timeOnlyShowDate: false,
			showHour: null,
			showMinute: null,
			showSecond: null,
			showMillisec: null,
			showMicrosec: null,
			showTimezone: null,
			showTime: true,
			stepHour: 1,
			stepMinute: 1,
			stepSecond: 1,
			stepMillisec: 1,
			stepMicrosec: 1,
			hour: 0,
			minute: 0,
			second: 0,
			millisec: 0,
			microsec: 0,
			timezone: null,
			hourMin: 0,
			minuteMin: 0,
			secondMin: 0,
			millisecMin: 0,
			microsecMin: 0,
			hourMax: 23,
			minuteMax: 59,
			secondMax: 59,
			millisecMax: 999,
			microsecMax: 999,
			minDateTime: null,
			maxDateTime: null,
			maxTime: null,
			minTime: null,
			onSelect: null,
			hourGrid: 0,
			minuteGrid: 0,
			secondGrid: 0,
			millisecGrid: 0,
			microsecGrid: 0,
			alwaysSetTime: true,
			separator: ' ',
			altFieldTimeOnly: true,
			altTimeFormat: null,
			altSeparator: null,
			altTimeSuffix: null,
			altRedirectFocus: true,
			pickerTimeFormat: null,
			pickerTimeSuffix: null,
			showTimepicker: true,
			timezoneList: null,
			addSliderAccess: false,
			sliderAccessArgs: null,
			controlType: 'slider',
			oneLine: false,
			defaultValue: null,
			parse: 'strict',
			afterInject: null
		};
		$.extend(this._defaults, this.regional['']);
	};

	$.extend(Timepicker.prototype, {
		$input: null,
		$altInput: null,
		$timeObj: null,
		inst: null,
		hour_slider: null,
		minute_slider: null,
		second_slider: null,
		millisec_slider: null,
		microsec_slider: null,
		timezone_select: null,
		maxTime: null,
		minTime: null,
		hour: 0,
		minute: 0,
		second: 0,
		millisec: 0,
		microsec: 0,
		timezone: null,
		hourMinOriginal: null,
		minuteMinOriginal: null,
		secondMinOriginal: null,
		millisecMinOriginal: null,
		microsecMinOriginal: null,
		hourMaxOriginal: null,
		minuteMaxOriginal: null,
		secondMaxOriginal: null,
		millisecMaxOriginal: null,
		microsecMaxOriginal: null,
		ampm: '',
		formattedDate: '',
		formattedTime: '',
		formattedDateTime: '',
		timezoneList: null,
		units: ['hour', 'minute', 'second', 'millisec', 'microsec'],
		support: {},
		control: null,

		/*
		* Override the default settings for all instances of the time picker.
		* @param  {Object} settings  object - the new settings to use as defaults (anonymous object)
		* @return {Object} the manager object
		*/
		setDefaults: function (settings) {
			extendRemove(this._defaults, settings || {});
			return this;
		},

		/*
		* Create a new Timepicker instance
		*/
		_newInst: function ($input, opts) {
			var tp_inst = new Timepicker(),
				inlineSettings = {},
				fns = {},
				overrides, i;

			for (var attrName in this._defaults) {
				if (this._defaults.hasOwnProperty(attrName)) {
					var attrValue = $input.attr('time:' + attrName);
					if (attrValue) {
						try {
							inlineSettings[attrName] = eval(attrValue);
						} catch (err) {
							inlineSettings[attrName] = attrValue;
						}
					}
				}
			}

			overrides = {
				beforeShow: function (input, dp_inst) {
					if ($.isFunction(tp_inst._defaults.evnts.beforeShow)) {
						return tp_inst._defaults.evnts.beforeShow.call($input[0], input, dp_inst, tp_inst);
					}
				},
				onChangeMonthYear: function (year, month, dp_inst) {
					// Update the time as well : this prevents the time from disappearing from the $input field.
					// tp_inst._updateDateTime(dp_inst);
					if ($.isFunction(tp_inst._defaults.evnts.onChangeMonthYear)) {
						tp_inst._defaults.evnts.onChangeMonthYear.call($input[0], year, month, dp_inst, tp_inst);
					}
				},
				onClose: function (dateText, dp_inst) {
					if (tp_inst.timeDefined === true && $input.val() !== '') {
						tp_inst._updateDateTime(dp_inst);
					}
					if ($.isFunction(tp_inst._defaults.evnts.onClose)) {
						tp_inst._defaults.evnts.onClose.call($input[0], dateText, dp_inst, tp_inst);
					}
				}
			};
			for (i in overrides) {
				if (overrides.hasOwnProperty(i)) {
					fns[i] = opts[i] || this._defaults[i] || null;
				}
			}

			tp_inst._defaults = $.extend({}, this._defaults, inlineSettings, opts, overrides, {
				evnts: fns,
				timepicker: tp_inst // add timepicker as a property of datepicker: $.datepicker._get(dp_inst, 'timepicker');
			});
			tp_inst.amNames = $.map(tp_inst._defaults.amNames, function (val) {
				return val.toUpperCase();
			});
			tp_inst.pmNames = $.map(tp_inst._defaults.pmNames, function (val) {
				return val.toUpperCase();
			});

			// detect which units are supported
			tp_inst.support = detectSupport(
					tp_inst._defaults.timeFormat +
					(tp_inst._defaults.pickerTimeFormat ? tp_inst._defaults.pickerTimeFormat : '') +
					(tp_inst._defaults.altTimeFormat ? tp_inst._defaults.altTimeFormat : ''));

			// controlType is string - key to our this._controls
			if (typeof(tp_inst._defaults.controlType) === 'string') {
				if (tp_inst._defaults.controlType === 'slider' && typeof($.ui.slider) === 'undefined') {
					tp_inst._defaults.controlType = 'select';
				}
				tp_inst.control = tp_inst._controls[tp_inst._defaults.controlType];
			}
			// controlType is an object and must implement create, options, value methods
			else {
				tp_inst.control = tp_inst._defaults.controlType;
			}

			// prep the timezone options
			var timezoneList = [-720, -660, -600, -570, -540, -480, -420, -360, -300, -270, -240, -210, -180, -120, -60,
					0, 60, 120, 180, 210, 240, 270, 300, 330, 345, 360, 390, 420, 480, 525, 540, 570, 600, 630, 660, 690, 720, 765, 780, 840];
			if (tp_inst._defaults.timezoneList !== null) {
				timezoneList = tp_inst._defaults.timezoneList;
			}
			var tzl = timezoneList.length, tzi = 0, tzv = null;
			if (tzl > 0 && typeof timezoneList[0] !== 'object') {
				for (; tzi < tzl; tzi++) {
					tzv = timezoneList[tzi];
					timezoneList[tzi] = { value: tzv, label: $.timepicker.timezoneOffsetString(tzv, tp_inst.support.iso8601) };
				}
			}
			tp_inst._defaults.timezoneList = timezoneList;

			// set the default units
			tp_inst.timezone = tp_inst._defaults.timezone !== null ? $.timepicker.timezoneOffsetNumber(tp_inst._defaults.timezone) :
							((new Date()).getTimezoneOffset() * -1);
			tp_inst.hour = tp_inst._defaults.hour < tp_inst._defaults.hourMin ? tp_inst._defaults.hourMin :
							tp_inst._defaults.hour > tp_inst._defaults.hourMax ? tp_inst._defaults.hourMax : tp_inst._defaults.hour;
			tp_inst.minute = tp_inst._defaults.minute < tp_inst._defaults.minuteMin ? tp_inst._defaults.minuteMin :
							tp_inst._defaults.minute > tp_inst._defaults.minuteMax ? tp_inst._defaults.minuteMax : tp_inst._defaults.minute;
			tp_inst.second = tp_inst._defaults.second < tp_inst._defaults.secondMin ? tp_inst._defaults.secondMin :
							tp_inst._defaults.second > tp_inst._defaults.secondMax ? tp_inst._defaults.secondMax : tp_inst._defaults.second;
			tp_inst.millisec = tp_inst._defaults.millisec < tp_inst._defaults.millisecMin ? tp_inst._defaults.millisecMin :
							tp_inst._defaults.millisec > tp_inst._defaults.millisecMax ? tp_inst._defaults.millisecMax : tp_inst._defaults.millisec;
			tp_inst.microsec = tp_inst._defaults.microsec < tp_inst._defaults.microsecMin ? tp_inst._defaults.microsecMin :
							tp_inst._defaults.microsec > tp_inst._defaults.microsecMax ? tp_inst._defaults.microsecMax : tp_inst._defaults.microsec;
			tp_inst.ampm = '';
			tp_inst.$input = $input;

			if (tp_inst._defaults.altField) {
				tp_inst.$altInput = $(tp_inst._defaults.altField);
				if (tp_inst._defaults.altRedirectFocus === true) {
					tp_inst.$altInput.css({
						cursor: 'pointer'
					}).focus(function () {
						$input.trigger("focus");
					});
				}
			}

			if (tp_inst._defaults.minDate === 0 || tp_inst._defaults.minDateTime === 0) {
				tp_inst._defaults.minDate = new Date();
			}
			if (tp_inst._defaults.maxDate === 0 || tp_inst._defaults.maxDateTime === 0) {
				tp_inst._defaults.maxDate = new Date();
			}

			// datepicker needs minDate/maxDate, timepicker needs minDateTime/maxDateTime..
			if (tp_inst._defaults.minDate !== undefined && tp_inst._defaults.minDate instanceof Date) {
				tp_inst._defaults.minDateTime = new Date(tp_inst._defaults.minDate.getTime());
			}
			if (tp_inst._defaults.minDateTime !== undefined && tp_inst._defaults.minDateTime instanceof Date) {
				tp_inst._defaults.minDate = new Date(tp_inst._defaults.minDateTime.getTime());
			}
			if (tp_inst._defaults.maxDate !== undefined && tp_inst._defaults.maxDate instanceof Date) {
				tp_inst._defaults.maxDateTime = new Date(tp_inst._defaults.maxDate.getTime());
			}
			if (tp_inst._defaults.maxDateTime !== undefined && tp_inst._defaults.maxDateTime instanceof Date) {
				tp_inst._defaults.maxDate = new Date(tp_inst._defaults.maxDateTime.getTime());
			}
			tp_inst.$input.bind('focus', function () {
				tp_inst._onFocus();
			});

			return tp_inst;
		},

		/*
		* add our sliders to the calendar
		*/
		_addTimePicker: function (dp_inst) {
			var currDT = $.trim((this.$altInput && this._defaults.altFieldTimeOnly) ? this.$input.val() + ' ' + this.$altInput.val() : this.$input.val());

			this.timeDefined = this._parseTime(currDT);
			this._limitMinMaxDateTime(dp_inst, false);
			this._injectTimePicker();
			this._afterInject();
		},

		/*
		* parse the time string from input value or _setTime
		*/
		_parseTime: function (timeString, withDate) {
			if (!this.inst) {
				this.inst = $.datepicker._getInst(this.$input[0]);
			}

			if (withDate || !this._defaults.timeOnly) {
				var dp_dateFormat = $.datepicker._get(this.inst, 'dateFormat');
				try {
					var parseRes = parseDateTimeInternal(dp_dateFormat, this._defaults.timeFormat, timeString, $.datepicker._getFormatConfig(this.inst), this._defaults);
					if (!parseRes.timeObj) {
						return false;
					}
					$.extend(this, parseRes.timeObj);
				} catch (err) {
					$.timepicker.log("Error parsing the date/time string: " + err +
									"\ndate/time string = " + timeString +
									"\ntimeFormat = " + this._defaults.timeFormat +
									"\ndateFormat = " + dp_dateFormat);
					return false;
				}
				return true;
			} else {
				var timeObj = $.datepicker.parseTime(this._defaults.timeFormat, timeString, this._defaults);
				if (!timeObj) {
					return false;
				}
				$.extend(this, timeObj);
				return true;
			}
		},

		/*
		* Handle callback option after injecting timepicker
		*/
		_afterInject: function() {
			var o = this.inst.settings;
			if ($.isFunction(o.afterInject)) {
				o.afterInject.call(this);
			}
		},

		/*
		* generate and inject html for timepicker into ui datepicker
		*/
		_injectTimePicker: function () {
			var $dp = this.inst.dpDiv,
				o = this.inst.settings,
				tp_inst = this,
				litem = '',
				uitem = '',
				show = null,
				max = {},
				gridSize = {},
				size = null,
				i = 0,
				l = 0;

			// Prevent displaying twice
			if ($dp.find("div.ui-timepicker-div").length === 0 && o.showTimepicker) {
				var noDisplay = ' ui_tpicker_unit_hide',
					html = '<div class="ui-timepicker-div' + (o.isRTL ? ' ui-timepicker-rtl' : '') + (o.oneLine && o.controlType === 'select' ? ' ui-timepicker-oneLine' : '') + '"><dl>' + '<dt class="ui_tpicker_time_label' + ((o.showTime) ? '' : noDisplay) + '">' + o.timeText + '</dt>' +
								'<dd class="ui_tpicker_time '+ ((o.showTime) ? '' : noDisplay) + '"><input class="ui_tpicker_time_input" ' + (o.timeInput ? '' : 'disabled') + '/></dd>';

				// Create the markup
				for (i = 0, l = this.units.length; i < l; i++) {
					litem = this.units[i];
					uitem = litem.substr(0, 1).toUpperCase() + litem.substr(1);
					show = o['show' + uitem] !== null ? o['show' + uitem] : this.support[litem];

					// Added by Peter Medeiros:
					// - Figure out what the hour/minute/second max should be based on the step values.
					// - Example: if stepMinute is 15, then minMax is 45.
					max[litem] = parseInt((o[litem + 'Max'] - ((o[litem + 'Max'] - o[litem + 'Min']) % o['step' + uitem])), 10);
					gridSize[litem] = 0;

					html += '<dt class="ui_tpicker_' + litem + '_label' + (show ? '' : noDisplay) + '">' + o[litem + 'Text'] + '</dt>' +
								'<dd class="ui_tpicker_' + litem + (show ? '' : noDisplay) + '"><div class="ui_tpicker_' + litem + '_slider' + (show ? '' : noDisplay) + '"></div>';

					if (show && o[litem + 'Grid'] > 0) {
						html += '<div style="padding-left: 1px"><table class="ui-tpicker-grid-label"><tr>';

						if (litem === 'hour') {
							for (var h = o[litem + 'Min']; h <= max[litem]; h += parseInt(o[litem + 'Grid'], 10)) {
								gridSize[litem]++;
								var tmph = $.datepicker.formatTime(this.support.ampm ? 'hht' : 'HH', {hour: h}, o);
								html += '<td data-for="' + litem + '">' + tmph + '</td>';
							}
						}
						else {
							for (var m = o[litem + 'Min']; m <= max[litem]; m += parseInt(o[litem + 'Grid'], 10)) {
								gridSize[litem]++;
								html += '<td data-for="' + litem + '">' + ((m < 10) ? '0' : '') + m + '</td>';
							}
						}

						html += '</tr></table></div>';
					}
					html += '</dd>';
				}

				// Timezone
				var showTz = o.showTimezone !== null ? o.showTimezone : this.support.timezone;
				html += '<dt class="ui_tpicker_timezone_label' + (showTz ? '' : noDisplay) + '">' + o.timezoneText + '</dt>';
				html += '<dd class="ui_tpicker_timezone' + (showTz ? '' : noDisplay) + '"></dd>';

				// Create the elements from string
				html += '</dl></div>';
				var $tp = $(html);

				// if we only want time picker...
				if (o.timeOnly === true) {
					$tp.prepend('<div class="ui-widget-header ui-helper-clearfix ui-corner-all">' + '<div class="ui-datepicker-title">' + o.timeOnlyTitle + '</div>' + '</div>');
					$dp.find('.ui-datepicker-header, .ui-datepicker-calendar').hide();
				}

				// add sliders, adjust grids, add events
				for (i = 0, l = tp_inst.units.length; i < l; i++) {
					litem = tp_inst.units[i];
					uitem = litem.substr(0, 1).toUpperCase() + litem.substr(1);
					show = o['show' + uitem] !== null ? o['show' + uitem] : this.support[litem];

					// add the slider
					tp_inst[litem + '_slider'] = tp_inst.control.create(tp_inst, $tp.find('.ui_tpicker_' + litem + '_slider'), litem, tp_inst[litem], o[litem + 'Min'], max[litem], o['step' + uitem]);

					// adjust the grid and add click event
					if (show && o[litem + 'Grid'] > 0) {
						size = 100 * gridSize[litem] * o[litem + 'Grid'] / (max[litem] - o[litem + 'Min']);
						$tp.find('.ui_tpicker_' + litem + ' table').css({
							width: size + "%",
							marginLeft: o.isRTL ? '0' : ((size / (-2 * gridSize[litem])) + "%"),
							marginRight: o.isRTL ? ((size / (-2 * gridSize[litem])) + "%") : '0',
							borderCollapse: 'collapse'
						}).find("td").click(function (e) {
								var $t = $(this),
									h = $t.html(),
									n = parseInt(h.replace(/[^0-9]/g), 10),
									ap = h.replace(/[^apm]/ig),
									f = $t.data('for'); // loses scope, so we use data-for

								if (f === 'hour') {
									if (ap.indexOf('p') !== -1 && n < 12) {
										n += 12;
									}
									else {
										if (ap.indexOf('a') !== -1 && n === 12) {
											n = 0;
										}
									}
								}

								tp_inst.control.value(tp_inst, tp_inst[f + '_slider'], litem, n);

								tp_inst._onTimeChange();
								tp_inst._onSelectHandler();
							}).css({
								cursor: 'pointer',
								width: (100 / gridSize[litem]) + '%',
								textAlign: 'center',
								overflow: 'hidden'
							});
					} // end if grid > 0
				} // end for loop

				// Add timezone options
				this.timezone_select = $tp.find('.ui_tpicker_timezone').append('<select></select>').find("select");
				$.fn.append.apply(this.timezone_select,
				$.map(o.timezoneList, function (val, idx) {
					return $("<option />").val(typeof val === "object" ? val.value : val).text(typeof val === "object" ? val.label : val);
				}));
				if (typeof(this.timezone) !== "undefined" && this.timezone !== null && this.timezone !== "") {
					var local_timezone = (new Date(this.inst.selectedYear, this.inst.selectedMonth, this.inst.selectedDay, 12)).getTimezoneOffset() * -1;
					if (local_timezone === this.timezone) {
						selectLocalTimezone(tp_inst);
					} else {
						this.timezone_select.val(this.timezone);
					}
				} else {
					if (typeof(this.hour) !== "undefined" && this.hour !== null && this.hour !== "") {
						this.timezone_select.val(o.timezone);
					} else {
						selectLocalTimezone(tp_inst);
					}
				}
				this.timezone_select.change(function () {
					tp_inst._onTimeChange();
					tp_inst._onSelectHandler();
					tp_inst._afterInject();
				});
				// End timezone options

				// inject timepicker into datepicker
				var $buttonPanel = $dp.find('.ui-datepicker-buttonpane');
				if ($buttonPanel.length) {
					$buttonPanel.before($tp);
				} else {
					$dp.append($tp);
				}

				this.$timeObj = $tp.find('.ui_tpicker_time_input');
				this.$timeObj.change(function () {
					var timeFormat = tp_inst.inst.settings.timeFormat;
					var parsedTime = $.datepicker.parseTime(timeFormat, this.value);
					var update = new Date();
					if (parsedTime) {
						update.setHours(parsedTime.hour);
						update.setMinutes(parsedTime.minute);
						update.setSeconds(parsedTime.second);
						$.datepicker._setTime(tp_inst.inst, update);
					} else {
						this.value = tp_inst.formattedTime;
						this.blur();
					}
				});

				if (this.inst !== null) {
					var timeDefined = this.timeDefined;
					this._onTimeChange();
					this.timeDefined = timeDefined;
				}

				// slideAccess integration: http://trentrichardson.com/2011/11/11/jquery-ui-sliders-and-touch-accessibility/
				if (this._defaults.addSliderAccess) {
					var sliderAccessArgs = this._defaults.sliderAccessArgs,
						rtl = this._defaults.isRTL;
					sliderAccessArgs.isRTL = rtl;

					setTimeout(function () { // fix for inline mode
						if ($tp.find('.ui-slider-access').length === 0) {
							$tp.find('.ui-slider:visible').sliderAccess(sliderAccessArgs);

							// fix any grids since sliders are shorter
							var sliderAccessWidth = $tp.find('.ui-slider-access:eq(0)').outerWidth(true);
							if (sliderAccessWidth) {
								$tp.find('table:visible').each(function () {
									var $g = $(this),
										oldWidth = $g.outerWidth(),
										oldMarginLeft = $g.css(rtl ? 'marginRight' : 'marginLeft').toString().replace('%', ''),
										newWidth = oldWidth - sliderAccessWidth,
										newMarginLeft = ((oldMarginLeft * newWidth) / oldWidth) + '%',
										css = { width: newWidth, marginRight: 0, marginLeft: 0 };
									css[rtl ? 'marginRight' : 'marginLeft'] = newMarginLeft;
									$g.css(css);
								});
							}
						}
					}, 10);
				}
				// end slideAccess integration

				tp_inst._limitMinMaxDateTime(this.inst, true);
			}
		},

		/*
		* This function tries to limit the ability to go outside the
		* min/max date range
		*/
		_limitMinMaxDateTime: function (dp_inst, adjustSliders) {
			var o = this._defaults,
				dp_date = new Date(dp_inst.selectedYear, dp_inst.selectedMonth, dp_inst.selectedDay);

			if (!this._defaults.showTimepicker) {
				return;
			} // No time so nothing to check here

			if ($.datepicker._get(dp_inst, 'minDateTime') !== null && $.datepicker._get(dp_inst, 'minDateTime') !== undefined && dp_date) {
				var minDateTime = $.datepicker._get(dp_inst, 'minDateTime'),
					minDateTimeDate = new Date(minDateTime.getFullYear(), minDateTime.getMonth(), minDateTime.getDate(), 0, 0, 0, 0);

				if (this.hourMinOriginal === null || this.minuteMinOriginal === null || this.secondMinOriginal === null || this.millisecMinOriginal === null || this.microsecMinOriginal === null) {
					this.hourMinOriginal = o.hourMin;
					this.minuteMinOriginal = o.minuteMin;
					this.secondMinOriginal = o.secondMin;
					this.millisecMinOriginal = o.millisecMin;
					this.microsecMinOriginal = o.microsecMin;
				}

				if (dp_inst.settings.timeOnly || minDateTimeDate.getTime() === dp_date.getTime()) {
					this._defaults.hourMin = minDateTime.getHours();
					if (this.hour <= this._defaults.hourMin) {
						this.hour = this._defaults.hourMin;
						this._defaults.minuteMin = minDateTime.getMinutes();
						if (this.minute <= this._defaults.minuteMin) {
							this.minute = this._defaults.minuteMin;
							this._defaults.secondMin = minDateTime.getSeconds();
							if (this.second <= this._defaults.secondMin) {
								this.second = this._defaults.secondMin;
								this._defaults.millisecMin = minDateTime.getMilliseconds();
								if (this.millisec <= this._defaults.millisecMin) {
									this.millisec = this._defaults.millisecMin;
									this._defaults.microsecMin = minDateTime.getMicroseconds();
								} else {
									if (this.microsec < this._defaults.microsecMin) {
										this.microsec = this._defaults.microsecMin;
									}
									this._defaults.microsecMin = this.microsecMinOriginal;
								}
							} else {
								this._defaults.millisecMin = this.millisecMinOriginal;
								this._defaults.microsecMin = this.microsecMinOriginal;
							}
						} else {
							this._defaults.secondMin = this.secondMinOriginal;
							this._defaults.millisecMin = this.millisecMinOriginal;
							this._defaults.microsecMin = this.microsecMinOriginal;
						}
					} else {
						this._defaults.minuteMin = this.minuteMinOriginal;
						this._defaults.secondMin = this.secondMinOriginal;
						this._defaults.millisecMin = this.millisecMinOriginal;
						this._defaults.microsecMin = this.microsecMinOriginal;
					}
				} else {
					this._defaults.hourMin = this.hourMinOriginal;
					this._defaults.minuteMin = this.minuteMinOriginal;
					this._defaults.secondMin = this.secondMinOriginal;
					this._defaults.millisecMin = this.millisecMinOriginal;
					this._defaults.microsecMin = this.microsecMinOriginal;
				}
			}

			if ($.datepicker._get(dp_inst, 'maxDateTime') !== null && $.datepicker._get(dp_inst, 'maxDateTime') !== undefined && dp_date) {
				var maxDateTime = $.datepicker._get(dp_inst, 'maxDateTime'),
					maxDateTimeDate = new Date(maxDateTime.getFullYear(), maxDateTime.getMonth(), maxDateTime.getDate(), 0, 0, 0, 0);

				if (this.hourMaxOriginal === null || this.minuteMaxOriginal === null || this.secondMaxOriginal === null || this.millisecMaxOriginal === null) {
					this.hourMaxOriginal = o.hourMax;
					this.minuteMaxOriginal = o.minuteMax;
					this.secondMaxOriginal = o.secondMax;
					this.millisecMaxOriginal = o.millisecMax;
					this.microsecMaxOriginal = o.microsecMax;
				}

				if (dp_inst.settings.timeOnly || maxDateTimeDate.getTime() === dp_date.getTime()) {
					this._defaults.hourMax = maxDateTime.getHours();
					if (this.hour >= this._defaults.hourMax) {
						this.hour = this._defaults.hourMax;
						this._defaults.minuteMax = maxDateTime.getMinutes();
						if (this.minute >= this._defaults.minuteMax) {
							this.minute = this._defaults.minuteMax;
							this._defaults.secondMax = maxDateTime.getSeconds();
							if (this.second >= this._defaults.secondMax) {
								this.second = this._defaults.secondMax;
								this._defaults.millisecMax = maxDateTime.getMilliseconds();
								if (this.millisec >= this._defaults.millisecMax) {
									this.millisec = this._defaults.millisecMax;
									this._defaults.microsecMax = maxDateTime.getMicroseconds();
								} else {
									if (this.microsec > this._defaults.microsecMax) {
										this.microsec = this._defaults.microsecMax;
									}
									this._defaults.microsecMax = this.microsecMaxOriginal;
								}
							} else {
								this._defaults.millisecMax = this.millisecMaxOriginal;
								this._defaults.microsecMax = this.microsecMaxOriginal;
							}
						} else {
							this._defaults.secondMax = this.secondMaxOriginal;
							this._defaults.millisecMax = this.millisecMaxOriginal;
							this._defaults.microsecMax = this.microsecMaxOriginal;
						}
					} else {
						this._defaults.minuteMax = this.minuteMaxOriginal;
						this._defaults.secondMax = this.secondMaxOriginal;
						this._defaults.millisecMax = this.millisecMaxOriginal;
						this._defaults.microsecMax = this.microsecMaxOriginal;
					}
				} else {
					this._defaults.hourMax = this.hourMaxOriginal;
					this._defaults.minuteMax = this.minuteMaxOriginal;
					this._defaults.secondMax = this.secondMaxOriginal;
					this._defaults.millisecMax = this.millisecMaxOriginal;
					this._defaults.microsecMax = this.microsecMaxOriginal;
				}
			}

			if (dp_inst.settings.minTime!==null) {
				var tempMinTime=new Date("01/01/1970 " + dp_inst.settings.minTime);
				if (this.hour<tempMinTime.getHours()) {
					this.hour=this._defaults.hourMin=tempMinTime.getHours();
					this.minute=this._defaults.minuteMin=tempMinTime.getMinutes();
				} else if (this.hour===tempMinTime.getHours() && this.minute<tempMinTime.getMinutes()) {
					this.minute=this._defaults.minuteMin=tempMinTime.getMinutes();
				} else {
					if (this._defaults.hourMin<tempMinTime.getHours()) {
						this._defaults.hourMin=tempMinTime.getHours();
						this._defaults.minuteMin=tempMinTime.getMinutes();
					} else if (this._defaults.hourMin===tempMinTime.getHours()===this.hour && this._defaults.minuteMin<tempMinTime.getMinutes()) {
						this._defaults.minuteMin=tempMinTime.getMinutes();
					} else {
						this._defaults.minuteMin=0;
					}
				}
			}

			if (dp_inst.settings.maxTime!==null) {
				var tempMaxTime=new Date("01/01/1970 " + dp_inst.settings.maxTime);
				if (this.hour>tempMaxTime.getHours()) {
					this.hour=this._defaults.hourMax=tempMaxTime.getHours();
					this.minute=this._defaults.minuteMax=tempMaxTime.getMinutes();
				} else if (this.hour===tempMaxTime.getHours() && this.minute>tempMaxTime.getMinutes()) {
					this.minute=this._defaults.minuteMax=tempMaxTime.getMinutes();
				} else {
					if (this._defaults.hourMax>tempMaxTime.getHours()) {
						this._defaults.hourMax=tempMaxTime.getHours();
						this._defaults.minuteMax=tempMaxTime.getMinutes();
					} else if (this._defaults.hourMax===tempMaxTime.getHours()===this.hour && this._defaults.minuteMax>tempMaxTime.getMinutes()) {
						this._defaults.minuteMax=tempMaxTime.getMinutes();
					} else {
						this._defaults.minuteMax=59;
					}
				}
			}

			if (adjustSliders !== undefined && adjustSliders === true) {
				var hourMax = parseInt((this._defaults.hourMax - ((this._defaults.hourMax - this._defaults.hourMin) % this._defaults.stepHour)), 10),
					minMax = parseInt((this._defaults.minuteMax - ((this._defaults.minuteMax - this._defaults.minuteMin) % this._defaults.stepMinute)), 10),
					secMax = parseInt((this._defaults.secondMax - ((this._defaults.secondMax - this._defaults.secondMin) % this._defaults.stepSecond)), 10),
					millisecMax = parseInt((this._defaults.millisecMax - ((this._defaults.millisecMax - this._defaults.millisecMin) % this._defaults.stepMillisec)), 10),
					microsecMax = parseInt((this._defaults.microsecMax - ((this._defaults.microsecMax - this._defaults.microsecMin) % this._defaults.stepMicrosec)), 10);

				if (this.hour_slider) {
					this.control.options(this, this.hour_slider, 'hour', { min: this._defaults.hourMin, max: hourMax, step: this._defaults.stepHour });
					this.control.value(this, this.hour_slider, 'hour', this.hour - (this.hour % this._defaults.stepHour));
				}
				if (this.minute_slider) {
					this.control.options(this, this.minute_slider, 'minute', { min: this._defaults.minuteMin, max: minMax, step: this._defaults.stepMinute });
					this.control.value(this, this.minute_slider, 'minute', this.minute - (this.minute % this._defaults.stepMinute));
				}
				if (this.second_slider) {
					this.control.options(this, this.second_slider, 'second', { min: this._defaults.secondMin, max: secMax, step: this._defaults.stepSecond });
					this.control.value(this, this.second_slider, 'second', this.second - (this.second % this._defaults.stepSecond));
				}
				if (this.millisec_slider) {
					this.control.options(this, this.millisec_slider, 'millisec', { min: this._defaults.millisecMin, max: millisecMax, step: this._defaults.stepMillisec });
					this.control.value(this, this.millisec_slider, 'millisec', this.millisec - (this.millisec % this._defaults.stepMillisec));
				}
				if (this.microsec_slider) {
					this.control.options(this, this.microsec_slider, 'microsec', { min: this._defaults.microsecMin, max: microsecMax, step: this._defaults.stepMicrosec });
					this.control.value(this, this.microsec_slider, 'microsec', this.microsec - (this.microsec % this._defaults.stepMicrosec));
				}
			}

		},

		/*
		* when a slider moves, set the internal time...
		* on time change is also called when the time is updated in the text field
		*/
		_onTimeChange: function () {
			if (!this._defaults.showTimepicker) {
                                return;
			}
			var hour = (this.hour_slider) ? this.control.value(this, this.hour_slider, 'hour') : false,
				minute = (this.minute_slider) ? this.control.value(this, this.minute_slider, 'minute') : false,
				second = (this.second_slider) ? this.control.value(this, this.second_slider, 'second') : false,
				millisec = (this.millisec_slider) ? this.control.value(this, this.millisec_slider, 'millisec') : false,
				microsec = (this.microsec_slider) ? this.control.value(this, this.microsec_slider, 'microsec') : false,
				timezone = (this.timezone_select) ? this.timezone_select.val() : false,
				o = this._defaults,
				pickerTimeFormat = o.pickerTimeFormat || o.timeFormat,
				pickerTimeSuffix = o.pickerTimeSuffix || o.timeSuffix;

			if (typeof(hour) === 'object') {
				hour = false;
			}
			if (typeof(minute) === 'object') {
				minute = false;
			}
			if (typeof(second) === 'object') {
				second = false;
			}
			if (typeof(millisec) === 'object') {
				millisec = false;
			}
			if (typeof(microsec) === 'object') {
				microsec = false;
			}
			if (typeof(timezone) === 'object') {
				timezone = false;
			}

			if (hour !== false) {
				hour = parseInt(hour, 10);
			}
			if (minute !== false) {
				minute = parseInt(minute, 10);
			}
			if (second !== false) {
				second = parseInt(second, 10);
			}
			if (millisec !== false) {
				millisec = parseInt(millisec, 10);
			}
			if (microsec !== false) {
				microsec = parseInt(microsec, 10);
			}
			if (timezone !== false) {
				timezone = timezone.toString();
			}

			var ampm = o[hour < 12 ? 'amNames' : 'pmNames'][0];

			// If the update was done in the input field, the input field should not be updated.
			// If the update was done using the sliders, update the input field.
			var hasChanged = (
						hour !== parseInt(this.hour,10) || // sliders should all be numeric
						minute !== parseInt(this.minute,10) ||
						second !== parseInt(this.second,10) ||
						millisec !== parseInt(this.millisec,10) ||
						microsec !== parseInt(this.microsec,10) ||
						(this.ampm.length > 0 && (hour < 12) !== ($.inArray(this.ampm.toUpperCase(), this.amNames) !== -1)) ||
						(this.timezone !== null && timezone !== this.timezone.toString()) // could be numeric or "EST" format, so use toString()
					);

			if (hasChanged) {

				if (hour !== false) {
					this.hour = hour;
				}
				if (minute !== false) {
					this.minute = minute;
				}
				if (second !== false) {
					this.second = second;
				}
				if (millisec !== false) {
					this.millisec = millisec;
				}
				if (microsec !== false) {
					this.microsec = microsec;
				}
				if (timezone !== false) {
					this.timezone = timezone;
				}

				if (!this.inst) {
					this.inst = $.datepicker._getInst(this.$input[0]);
				}

				this._limitMinMaxDateTime(this.inst, true);
			}
			if (this.support.ampm) {
				this.ampm = ampm;
			}

			// Updates the time within the timepicker
			this.formattedTime = $.datepicker.formatTime(o.timeFormat, this, o);
			if (this.$timeObj) {
				if (pickerTimeFormat === o.timeFormat) {
					this.$timeObj.val(this.formattedTime + pickerTimeSuffix);
				}
				else {
					this.$timeObj.val($.datepicker.formatTime(pickerTimeFormat, this, o) + pickerTimeSuffix);
				}
				if (this.$timeObj[0].setSelectionRange) {
					var sPos = this.$timeObj[0].selectionStart;
					var ePos = this.$timeObj[0].selectionEnd;
					this.$timeObj[0].setSelectionRange(sPos, ePos);
				}
			}

			this.timeDefined = true;
			if (hasChanged) {
				this._updateDateTime();
				//this.$input.focus(); // may automatically open the picker on setDate
			}
		},

		/*
		* call custom onSelect.
		* bind to sliders slidestop, and grid click.
		*/
		_onSelectHandler: function () {
			var onSelect = this._defaults.onSelect || this.inst.settings.onSelect;
			var inputEl = this.$input ? this.$input[0] : null;
			if (onSelect && inputEl) {
				onSelect.apply(inputEl, [this.formattedDateTime, this]);
			}
		},

		/*
		* update our input with the new date time..
		*/
		_updateDateTime: function (dp_inst) {
			dp_inst = this.inst || dp_inst;
			var dtTmp = (dp_inst.currentYear > 0?
							new Date(dp_inst.currentYear, dp_inst.currentMonth, dp_inst.currentDay) :
							new Date(dp_inst.selectedYear, dp_inst.selectedMonth, dp_inst.selectedDay)),
				dt = $.datepicker._daylightSavingAdjust(dtTmp),
				//dt = $.datepicker._daylightSavingAdjust(new Date(dp_inst.selectedYear, dp_inst.selectedMonth, dp_inst.selectedDay)),
				//dt = $.datepicker._daylightSavingAdjust(new Date(dp_inst.currentYear, dp_inst.currentMonth, dp_inst.currentDay)),
				dateFmt = $.datepicker._get(dp_inst, 'dateFormat'),
				formatCfg = $.datepicker._getFormatConfig(dp_inst),
				timeAvailable = dt !== null && this.timeDefined;
			this.formattedDate = $.datepicker.formatDate(dateFmt, (dt === null ? new Date() : dt), formatCfg);
			var formattedDateTime = this.formattedDate;

			// if a slider was changed but datepicker doesn't have a value yet, set it
			if (dp_inst.lastVal === "") {
                dp_inst.currentYear = dp_inst.selectedYear;
                dp_inst.currentMonth = dp_inst.selectedMonth;
                dp_inst.currentDay = dp_inst.selectedDay;
            }

			/*
			* remove following lines to force every changes in date picker to change the input value
			* Bug descriptions: when an input field has a default value, and click on the field to pop up the date picker.
			* If the user manually empty the value in the input field, the date picker will never change selected value.
			*/
			//if (dp_inst.lastVal !== undefined && (dp_inst.lastVal.length > 0 && this.$input.val().length === 0)) {
			//	return;
			//}

			if (this._defaults.timeOnly === true && this._defaults.timeOnlyShowDate === false) {
				formattedDateTime = this.formattedTime;
			} else if ((this._defaults.timeOnly !== true && (this._defaults.alwaysSetTime || timeAvailable)) || (this._defaults.timeOnly === true && this._defaults.timeOnlyShowDate === true)) {
				formattedDateTime += this._defaults.separator + this.formattedTime + this._defaults.timeSuffix;
			}

			this.formattedDateTime = formattedDateTime;

			if (!this._defaults.showTimepicker) {
				this.$input.val(this.formattedDate);
			} else if (this.$altInput && this._defaults.timeOnly === false && this._defaults.altFieldTimeOnly === true) {
				this.$altInput.val(this.formattedTime);
				this.$input.val(this.formattedDate);
			} else if (this.$altInput) {
				this.$input.val(formattedDateTime);
				var altFormattedDateTime = '',
					altSeparator = this._defaults.altSeparator !== null ? this._defaults.altSeparator : this._defaults.separator,
					altTimeSuffix = this._defaults.altTimeSuffix !== null ? this._defaults.altTimeSuffix : this._defaults.timeSuffix;

				if (!this._defaults.timeOnly) {
					if (this._defaults.altFormat) {
						altFormattedDateTime = $.datepicker.formatDate(this._defaults.altFormat, (dt === null ? new Date() : dt), formatCfg);
					}
					else {
						altFormattedDateTime = this.formattedDate;
					}

					if (altFormattedDateTime) {
						altFormattedDateTime += altSeparator;
					}
				}

				if (this._defaults.altTimeFormat !== null) {
					altFormattedDateTime += $.datepicker.formatTime(this._defaults.altTimeFormat, this, this._defaults) + altTimeSuffix;
				}
				else {
					altFormattedDateTime += this.formattedTime + altTimeSuffix;
				}
				this.$altInput.val(altFormattedDateTime);
			} else {
				this.$input.val(formattedDateTime);
			}

			this.$input.trigger("change");
		},

		_onFocus: function () {
			if (!this.$input.val() && this._defaults.defaultValue) {
				this.$input.val(this._defaults.defaultValue);
				var inst = $.datepicker._getInst(this.$input.get(0)),
					tp_inst = $.datepicker._get(inst, 'timepicker');
				if (tp_inst) {
					if (tp_inst._defaults.timeOnly && (inst.input.val() !== inst.lastVal)) {
						try {
							$.datepicker._updateDatepicker(inst);
						} catch (err) {
							$.timepicker.log(err);
						}
					}
				}
			}
		},

		/*
		* Small abstraction to control types
		* We can add more, just be sure to follow the pattern: create, options, value
		*/
		_controls: {
			// slider methods
			slider: {
				create: function (tp_inst, obj, unit, val, min, max, step) {
					var rtl = tp_inst._defaults.isRTL; // if rtl go -60->0 instead of 0->60
					return obj.prop('slide', null).slider({
						orientation: "horizontal",
						value: rtl ? val * -1 : val,
						min: rtl ? max * -1 : min,
						max: rtl ? min * -1 : max,
						step: step,
						slide: function (event, ui) {
							tp_inst.control.value(tp_inst, $(this), unit, rtl ? ui.value * -1 : ui.value);
							tp_inst._onTimeChange();
						},
						stop: function (event, ui) {
							tp_inst._onSelectHandler();
						}
					});
				},
				options: function (tp_inst, obj, unit, opts, val) {
					if (tp_inst._defaults.isRTL) {
						if (typeof(opts) === 'string') {
							if (opts === 'min' || opts === 'max') {
								if (val !== undefined) {
									return obj.slider(opts, val * -1);
								}
								return Math.abs(obj.slider(opts));
							}
							return obj.slider(opts);
						}
						var min = opts.min,
							max = opts.max;
						opts.min = opts.max = null;
						if (min !== undefined) {
							opts.max = min * -1;
						}
						if (max !== undefined) {
							opts.min = max * -1;
						}
						return obj.slider(opts);
					}
					if (typeof(opts) === 'string' && val !== undefined) {
						return obj.slider(opts, val);
					}
					return obj.slider(opts);
				},
				value: function (tp_inst, obj, unit, val) {
					if (tp_inst._defaults.isRTL) {
						if (val !== undefined) {
							return obj.slider('value', val * -1);
						}
						return Math.abs(obj.slider('value'));
					}
					if (val !== undefined) {
						return obj.slider('value', val);
					}
					return obj.slider('value');
				}
			},
			// select methods
			select: {
				create: function (tp_inst, obj, unit, val, min, max, step) {
					var sel = '<select class="ui-timepicker-select ui-state-default ui-corner-all" data-unit="' + unit + '" data-min="' + min + '" data-max="' + max + '" data-step="' + step + '">',
						format = tp_inst._defaults.pickerTimeFormat || tp_inst._defaults.timeFormat;

					for (var i = min; i <= max; i += step) {
						sel += '<option value="' + i + '"' + (i === val ? ' selected' : '') + '>';
						if (unit === 'hour') {
							sel += $.datepicker.formatTime($.trim(format.replace(/[^ht ]/ig, '')), {hour: i}, tp_inst._defaults);
						}
						else if (unit === 'millisec' || unit === 'microsec' || i >= 10) { sel += i; }
						else {sel += '0' + i.toString(); }
						sel += '</option>';
					}
					sel += '</select>';

					obj.children('select').remove();

					$(sel).appendTo(obj).change(function (e) {
						tp_inst._onTimeChange();
						tp_inst._onSelectHandler();
						tp_inst._afterInject();
					});

					return obj;
				},
				options: function (tp_inst, obj, unit, opts, val) {
					var o = {},
						$t = obj.children('select');
					if (typeof(opts) === 'string') {
						if (val === undefined) {
							return $t.data(opts);
						}
						o[opts] = val;
					}
					else { o = opts; }
					return tp_inst.control.create(tp_inst, obj, $t.data('unit'), $t.val(), o.min>=0 ? o.min : $t.data('min'), o.max || $t.data('max'), o.step || $t.data('step'));
				},
				value: function (tp_inst, obj, unit, val) {
					var $t = obj.children('select');
					if (val !== undefined) {
						return $t.val(val);
					}
					return $t.val();
				}
			}
		} // end _controls

	});

	$.fn.extend({
		/*
		* shorthand just to use timepicker.
		*/
		timepicker: function (o) {
			o = o || {};
			var tmp_args = Array.prototype.slice.call(arguments);

			if (typeof o === 'object') {
				tmp_args[0] = $.extend(o, {
					timeOnly: true
				});
			}

			return $(this).each(function () {
				$.fn.datetimepicker.apply($(this), tmp_args);
			});
		},

		/*
		* extend timepicker to datepicker
		*/
		datetimepicker: function (o) {
			o = o || {};
			var tmp_args = arguments;

			if (typeof(o) === 'string') {
				if (o === 'getDate'  || (o === 'option' && tmp_args.length === 2 && typeof (tmp_args[1]) === 'string')) {
					return $.fn.datepicker.apply($(this[0]), tmp_args);
				} else {
					return this.each(function () {
						var $t = $(this);
						$t.datepicker.apply($t, tmp_args);
					});
				}
			} else {
				return this.each(function () {
					var $t = $(this);
					$t.datepicker($.timepicker._newInst($t, o)._defaults);
				});
			}
		}
	});

	/*
	* Public Utility to parse date and time
	*/
	$.datepicker.parseDateTime = function (dateFormat, timeFormat, dateTimeString, dateSettings, timeSettings) {
		var parseRes = parseDateTimeInternal(dateFormat, timeFormat, dateTimeString, dateSettings, timeSettings);
		if (parseRes.timeObj) {
			var t = parseRes.timeObj;
			parseRes.date.setHours(t.hour, t.minute, t.second, t.millisec);
			parseRes.date.setMicroseconds(t.microsec);
		}

		return parseRes.date;
	};

	/*
	* Public utility to parse time
	*/
	$.datepicker.parseTime = function (timeFormat, timeString, options) {
		var o = extendRemove(extendRemove({}, $.timepicker._defaults), options || {}),
			iso8601 = (timeFormat.replace(/\'.*?\'/g, '').indexOf('Z') !== -1);

		// Strict parse requires the timeString to match the timeFormat exactly
		var strictParse = function (f, s, o) {

			// pattern for standard and localized AM/PM markers
			var getPatternAmpm = function (amNames, pmNames) {
				var markers = [];
				if (amNames) {
					$.merge(markers, amNames);
				}
				if (pmNames) {
					$.merge(markers, pmNames);
				}
				markers = $.map(markers, function (val) {
					return val.replace(/[.*+?|()\[\]{}\\]/g, '\\$&');
				});
				return '(' + markers.join('|') + ')?';
			};

			// figure out position of time elements.. cause js cant do named captures
			var getFormatPositions = function (timeFormat) {
				var finds = timeFormat.toLowerCase().match(/(h{1,2}|m{1,2}|s{1,2}|l{1}|c{1}|t{1,2}|z|'.*?')/g),
					orders = {
						h: -1,
						m: -1,
						s: -1,
						l: -1,
						c: -1,
						t: -1,
						z: -1
					};

				if (finds) {
					for (var i = 0; i < finds.length; i++) {
						if (orders[finds[i].toString().charAt(0)] === -1) {
							orders[finds[i].toString().charAt(0)] = i + 1;
						}
					}
				}
				return orders;
			};

			var regstr = '^' + f.toString()
					.replace(/([hH]{1,2}|mm?|ss?|[tT]{1,2}|[zZ]|[lc]|'.*?')/g, function (match) {
							var ml = match.length;
							switch (match.charAt(0).toLowerCase()) {
							case 'h':
								return ml === 1 ? '(\\d?\\d)' : '(\\d{' + ml + '})';
							case 'm':
								return ml === 1 ? '(\\d?\\d)' : '(\\d{' + ml + '})';
							case 's':
								return ml === 1 ? '(\\d?\\d)' : '(\\d{' + ml + '})';
							case 'l':
								return '(\\d?\\d?\\d)';
							case 'c':
								return '(\\d?\\d?\\d)';
							case 'z':
								return '(z|[-+]\\d\\d:?\\d\\d|\\S+)?';
							case 't':
								return getPatternAmpm(o.amNames, o.pmNames);
							default:    // literal escaped in quotes
								return '(' + match.replace(/\'/g, "").replace(/(\.|\$|\^|\\|\/|\(|\)|\[|\]|\?|\+|\*)/g, function (m) { return "\\" + m; }) + ')?';
							}
						})
					.replace(/\s/g, '\\s?') +
					o.timeSuffix + '$',
				order = getFormatPositions(f),
				ampm = '',
				treg;

			treg = s.match(new RegExp(regstr, 'i'));

			var resTime = {
				hour: 0,
				minute: 0,
				second: 0,
				millisec: 0,
				microsec: 0
			};

			if (treg) {
				if (order.t !== -1) {
					if (treg[order.t] === undefined || treg[order.t].length === 0) {
						ampm = '';
						resTime.ampm = '';
					} else {
						ampm = $.inArray(treg[order.t].toUpperCase(), $.map(o.amNames, function (x,i) { return x.toUpperCase(); })) !== -1 ? 'AM' : 'PM';
						resTime.ampm = o[ampm === 'AM' ? 'amNames' : 'pmNames'][0];
					}
				}

				if (order.h !== -1) {
					if (ampm === 'AM' && treg[order.h] === '12') {
						resTime.hour = 0; // 12am = 0 hour
					} else {
						if (ampm === 'PM' && treg[order.h] !== '12') {
							resTime.hour = parseInt(treg[order.h], 10) + 12; // 12pm = 12 hour, any other pm = hour + 12
						} else {
							resTime.hour = Number(treg[order.h]);
						}
					}
				}

				if (order.m !== -1) {
					resTime.minute = Number(treg[order.m]);
				}
				if (order.s !== -1) {
					resTime.second = Number(treg[order.s]);
				}
				if (order.l !== -1) {
					resTime.millisec = Number(treg[order.l]);
				}
				if (order.c !== -1) {
					resTime.microsec = Number(treg[order.c]);
				}
				if (order.z !== -1 && treg[order.z] !== undefined) {
					resTime.timezone = $.timepicker.timezoneOffsetNumber(treg[order.z]);
				}


				return resTime;
			}
			return false;
		};// end strictParse

		// First try JS Date, if that fails, use strictParse
		var looseParse = function (f, s, o) {
			try {
				var d = new Date('2012-01-01 ' + s);
				if (isNaN(d.getTime())) {
					d = new Date('2012-01-01T' + s);
					if (isNaN(d.getTime())) {
						d = new Date('01/01/2012 ' + s);
						if (isNaN(d.getTime())) {
							throw "Unable to parse time with native Date: " + s;
						}
					}
				}

				return {
					hour: d.getHours(),
					minute: d.getMinutes(),
					second: d.getSeconds(),
					millisec: d.getMilliseconds(),
					microsec: d.getMicroseconds(),
					timezone: d.getTimezoneOffset() * -1
				};
			}
			catch (err) {
				try {
					return strictParse(f, s, o);
				}
				catch (err2) {
					$.timepicker.log("Unable to parse \ntimeString: " + s + "\ntimeFormat: " + f);
				}
			}
			return false;
		}; // end looseParse

		if (typeof o.parse === "function") {
			return o.parse(timeFormat, timeString, o);
		}
		if (o.parse === 'loose') {
			return looseParse(timeFormat, timeString, o);
		}
		return strictParse(timeFormat, timeString, o);
	};

	/**
	 * Public utility to format the time
	 * @param {string} format format of the time
	 * @param {Object} time Object not a Date for timezones
	 * @param {Object} [options] essentially the regional[].. amNames, pmNames, ampm
	 * @returns {string} the formatted time
	 */
	$.datepicker.formatTime = function (format, time, options) {
		options = options || {};
		options = $.extend({}, $.timepicker._defaults, options);
		time = $.extend({
			hour: 0,
			minute: 0,
			second: 0,
			millisec: 0,
			microsec: 0,
			timezone: null
		}, time);

		var tmptime = format,
			ampmName = options.amNames[0],
			hour = parseInt(time.hour, 10);

		if (hour > 11) {
			ampmName = options.pmNames[0];
		}

		tmptime = tmptime.replace(/(?:HH?|hh?|mm?|ss?|[tT]{1,2}|[zZ]|[lc]|'.*?')/g, function (match) {
			switch (match) {
			case 'HH':
				return ('0' + hour).slice(-2);
			case 'H':
				return hour;
			case 'hh':
				return ('0' + convert24to12(hour)).slice(-2);
			case 'h':
				return convert24to12(hour);
			case 'mm':
				return ('0' + time.minute).slice(-2);
			case 'm':
				return time.minute;
			case 'ss':
				return ('0' + time.second).slice(-2);
			case 's':
				return time.second;
			case 'l':
				return ('00' + time.millisec).slice(-3);
			case 'c':
				return ('00' + time.microsec).slice(-3);
			case 'z':
				return $.timepicker.timezoneOffsetString(time.timezone === null ? options.timezone : time.timezone, false);
			case 'Z':
				return $.timepicker.timezoneOffsetString(time.timezone === null ? options.timezone : time.timezone, true);
			case 'T':
				return ampmName.charAt(0).toUpperCase();
			case 'TT':
				return ampmName.toUpperCase();
			case 't':
				return ampmName.charAt(0).toLowerCase();
			case 'tt':
				return ampmName.toLowerCase();
			default:
				return match.replace(/'/g, "");
			}
		});

		return tmptime;
	};

	/*
	* the bad hack :/ override datepicker so it doesn't close on select
	// inspired: http://stackoverflow.com/questions/1252512/jquery-datepicker-prevent-closing-picker-when-clicking-a-date/1762378#1762378
	*/
	$.datepicker._base_selectDate = $.datepicker._selectDate;
	$.datepicker._selectDate = function (id, dateStr) {
		var inst = this._getInst($(id)[0]),
			tp_inst = this._get(inst, 'timepicker'),
			was_inline;

		if (tp_inst && inst.settings.showTimepicker) {
			tp_inst._limitMinMaxDateTime(inst, true);
			was_inline = inst.inline;
			inst.inline = inst.stay_open = true;
			//This way the onSelect handler called from calendarpicker get the full dateTime
			this._base_selectDate(id, dateStr);
			inst.inline = was_inline;
			inst.stay_open = false;
			this._notifyChange(inst);
			this._updateDatepicker(inst);
		} else {
			this._base_selectDate(id, dateStr);
		}
	};

	/*
	* second bad hack :/ override datepicker so it triggers an event when changing the input field
	* and does not redraw the datepicker on every selectDate event
	*/
	$.datepicker._base_updateDatepicker = $.datepicker._updateDatepicker;
	$.datepicker._updateDatepicker = function (inst) {

		// don't popup the datepicker if there is another instance already opened
		var input = inst.input[0];
		if ($.datepicker._curInst && $.datepicker._curInst !== inst && $.datepicker._datepickerShowing && $.datepicker._lastInput !== input) {
			return;
		}

		if (typeof(inst.stay_open) !== 'boolean' || inst.stay_open === false) {

			this._base_updateDatepicker(inst);

			// Reload the time control when changing something in the input text field.
			var tp_inst = this._get(inst, 'timepicker');
			if (tp_inst) {
				tp_inst._addTimePicker(inst);
			}
		}
	};

	/*
	* third bad hack :/ override datepicker so it allows spaces and colon in the input field
	*/
	$.datepicker._base_doKeyPress = $.datepicker._doKeyPress;
	$.datepicker._doKeyPress = function (event) {
		var inst = $.datepicker._getInst(event.target),
			tp_inst = $.datepicker._get(inst, 'timepicker');

		if (tp_inst) {
			if ($.datepicker._get(inst, 'constrainInput')) {
				var ampm = tp_inst.support.ampm,
					tz = tp_inst._defaults.showTimezone !== null ? tp_inst._defaults.showTimezone : tp_inst.support.timezone,
					dateChars = $.datepicker._possibleChars($.datepicker._get(inst, 'dateFormat')),
					datetimeChars = tp_inst._defaults.timeFormat.toString()
											.replace(/[hms]/g, '')
											.replace(/TT/g, ampm ? 'APM' : '')
											.replace(/Tt/g, ampm ? 'AaPpMm' : '')
											.replace(/tT/g, ampm ? 'AaPpMm' : '')
											.replace(/T/g, ampm ? 'AP' : '')
											.replace(/tt/g, ampm ? 'apm' : '')
											.replace(/t/g, ampm ? 'ap' : '') +
											" " + tp_inst._defaults.separator +
											tp_inst._defaults.timeSuffix +
											(tz ? tp_inst._defaults.timezoneList.join('') : '') +
											(tp_inst._defaults.amNames.join('')) + (tp_inst._defaults.pmNames.join('')) +
											dateChars,
					chr = String.fromCharCode(event.charCode === undefined ? event.keyCode : event.charCode);
				return event.ctrlKey || (chr < ' ' || !dateChars || datetimeChars.indexOf(chr) > -1);
			}
		}

		return $.datepicker._base_doKeyPress(event);
	};

	/*
	* Fourth bad hack :/ override _updateAlternate function used in inline mode to init altField
	* Update any alternate field to synchronise with the main field.
	*/
	$.datepicker._base_updateAlternate = $.datepicker._updateAlternate;
	$.datepicker._updateAlternate = function (inst) {
		var tp_inst = this._get(inst, 'timepicker');
		if (tp_inst) {
			var altField = tp_inst._defaults.altField;
			if (altField) { // update alternate field too
				var altFormat = tp_inst._defaults.altFormat || tp_inst._defaults.dateFormat,
					date = this._getDate(inst),
					formatCfg = $.datepicker._getFormatConfig(inst),
					altFormattedDateTime = '',
					altSeparator = tp_inst._defaults.altSeparator ? tp_inst._defaults.altSeparator : tp_inst._defaults.separator,
					altTimeSuffix = tp_inst._defaults.altTimeSuffix ? tp_inst._defaults.altTimeSuffix : tp_inst._defaults.timeSuffix,
					altTimeFormat = tp_inst._defaults.altTimeFormat !== null ? tp_inst._defaults.altTimeFormat : tp_inst._defaults.timeFormat;

				altFormattedDateTime += $.datepicker.formatTime(altTimeFormat, tp_inst, tp_inst._defaults) + altTimeSuffix;
				if (!tp_inst._defaults.timeOnly && !tp_inst._defaults.altFieldTimeOnly && date !== null) {
					if (tp_inst._defaults.altFormat) {
						altFormattedDateTime = $.datepicker.formatDate(tp_inst._defaults.altFormat, date, formatCfg) + altSeparator + altFormattedDateTime;
					}
					else {
						altFormattedDateTime = tp_inst.formattedDate + altSeparator + altFormattedDateTime;
					}
				}
				$(altField).val( inst.input.val() ? altFormattedDateTime : "");
			}
		}
		else {
			$.datepicker._base_updateAlternate(inst);
		}
	};

	/*
	* Override key up event to sync manual input changes.
	*/
	$.datepicker._base_doKeyUp = $.datepicker._doKeyUp;
	$.datepicker._doKeyUp = function (event) {
		var inst = $.datepicker._getInst(event.target),
			tp_inst = $.datepicker._get(inst, 'timepicker');

		if (tp_inst) {
			if (tp_inst._defaults.timeOnly && (inst.input.val() !== inst.lastVal)) {
				try {
					$.datepicker._updateDatepicker(inst);
				} catch (err) {
					$.timepicker.log(err);
				}
			}
		}

		return $.datepicker._base_doKeyUp(event);
	};

	/*
	* override "Today" button to also grab the time and set it to input field.
	*/
	$.datepicker._base_gotoToday = $.datepicker._gotoToday;
	$.datepicker._gotoToday = function (id) {
		var inst = this._getInst($(id)[0]);
		this._base_gotoToday(id);
		var tp_inst = this._get(inst, 'timepicker');
		if (!tp_inst) {
		  return;
		}

		var tzoffset = $.timepicker.timezoneOffsetNumber(tp_inst.timezone);
		var now = new Date();
		now.setMinutes(now.getMinutes() + now.getTimezoneOffset() + parseInt(tzoffset, 10));
		this._setTime(inst, now);
		this._setDate(inst, now);
		tp_inst._onSelectHandler();
	};

	/*
	* Disable & enable the Time in the datetimepicker
	*/
	$.datepicker._disableTimepickerDatepicker = function (target) {
		var inst = this._getInst(target);
		if (!inst) {
			return;
		}

		var tp_inst = this._get(inst, 'timepicker');
		$(target).datepicker('getDate'); // Init selected[Year|Month|Day]
		if (tp_inst) {
			inst.settings.showTimepicker = false;
			tp_inst._defaults.showTimepicker = false;
			tp_inst._updateDateTime(inst);
		}
	};

	$.datepicker._enableTimepickerDatepicker = function (target) {
		var inst = this._getInst(target);
		if (!inst) {
			return;
		}

		var tp_inst = this._get(inst, 'timepicker');
		$(target).datepicker('getDate'); // Init selected[Year|Month|Day]
		if (tp_inst) {
			inst.settings.showTimepicker = true;
			tp_inst._defaults.showTimepicker = true;
			tp_inst._addTimePicker(inst); // Could be disabled on page load
			tp_inst._updateDateTime(inst);
		}
	};

	/*
	* Create our own set time function
	*/
	$.datepicker._setTime = function (inst, date) {
		var tp_inst = this._get(inst, 'timepicker');
		if (tp_inst) {
			var defaults = tp_inst._defaults;

			// calling _setTime with no date sets time to defaults
			tp_inst.hour = date ? date.getHours() : defaults.hour;
			tp_inst.minute = date ? date.getMinutes() : defaults.minute;
			tp_inst.second = date ? date.getSeconds() : defaults.second;
			tp_inst.millisec = date ? date.getMilliseconds() : defaults.millisec;
			tp_inst.microsec = date ? date.getMicroseconds() : defaults.microsec;

			//check if within min/max times..
			tp_inst._limitMinMaxDateTime(inst, true);

			tp_inst._onTimeChange();
			tp_inst._updateDateTime(inst);
		}
	};

	/*
	* Create new public method to set only time, callable as $().datepicker('setTime', date)
	*/
	$.datepicker._setTimeDatepicker = function (target, date, withDate) {
		var inst = this._getInst(target);
		if (!inst) {
			return;
		}

		var tp_inst = this._get(inst, 'timepicker');

		if (tp_inst) {
			this._setDateFromField(inst);
			var tp_date;
			if (date) {
				if (typeof date === "string") {
					tp_inst._parseTime(date, withDate);
					tp_date = new Date();
					tp_date.setHours(tp_inst.hour, tp_inst.minute, tp_inst.second, tp_inst.millisec);
					tp_date.setMicroseconds(tp_inst.microsec);
				} else {
					tp_date = new Date(date.getTime());
					tp_date.setMicroseconds(date.getMicroseconds());
				}
				if (tp_date.toString() === 'Invalid Date') {
					tp_date = undefined;
				}
				this._setTime(inst, tp_date);
			}
		}

	};

	/*
	* override setDate() to allow setting time too within Date object
	*/
	$.datepicker._base_setDateDatepicker = $.datepicker._setDateDatepicker;
	$.datepicker._setDateDatepicker = function (target, _date) {
		var inst = this._getInst(target);
		var date = _date;
		if (!inst) {
			return;
		}

		if (typeof(_date) === 'string') {
			date = new Date(_date);
			if (!date.getTime()) {
				this._base_setDateDatepicker.apply(this, arguments);
				date = $(target).datepicker('getDate');
			}
		}

		var tp_inst = this._get(inst, 'timepicker');
		var tp_date;
		if (date instanceof Date) {
			tp_date = new Date(date.getTime());
			tp_date.setMicroseconds(date.getMicroseconds());
		} else {
			tp_date = date;
		}

		// This is important if you are using the timezone option, javascript's Date
		// object will only return the timezone offset for the current locale, so we
		// adjust it accordingly.  If not using timezone option this won't matter..
		// If a timezone is different in tp, keep the timezone as is
		if (tp_inst && tp_date) {
			// look out for DST if tz wasn't specified
			if (!tp_inst.support.timezone && tp_inst._defaults.timezone === null) {
				tp_inst.timezone = tp_date.getTimezoneOffset() * -1;
			}
			date = $.timepicker.timezoneAdjust(date, $.timepicker.timezoneOffsetString(-date.getTimezoneOffset()), tp_inst.timezone);
			tp_date = $.timepicker.timezoneAdjust(tp_date, $.timepicker.timezoneOffsetString(-tp_date.getTimezoneOffset()), tp_inst.timezone);
		}

		this._updateDatepicker(inst);
		this._base_setDateDatepicker.apply(this, arguments);
		this._setTimeDatepicker(target, tp_date, true);
	};

	/*
	* override getDate() to allow getting time too within Date object
	*/
	$.datepicker._base_getDateDatepicker = $.datepicker._getDateDatepicker;
	$.datepicker._getDateDatepicker = function (target, noDefault) {
		var inst = this._getInst(target);
		if (!inst) {
			return;
		}

		var tp_inst = this._get(inst, 'timepicker');

		if (tp_inst) {
			// if it hasn't yet been defined, grab from field
			if (inst.lastVal === undefined) {
				this._setDateFromField(inst, noDefault);
			}

			var date = this._getDate(inst);

			var currDT = null;

			if (tp_inst.$altInput && tp_inst._defaults.altFieldTimeOnly) {
				currDT = tp_inst.$input.val() + ' ' + tp_inst.$altInput.val();
			}
			else if (tp_inst.$input.get(0).tagName !== 'INPUT' && tp_inst.$altInput) {
				/**
				 * in case the datetimepicker has been applied to a non-input tag for inline UI,
				 * and the user has not configured the plugin to display only time in altInput,
				 * pick current date time from the altInput (and hope for the best, for now, until "ER1" is applied)
				 *
				 * @todo ER1. Since altInput can have a totally difference format, convert it to standard format by reading input format from "altFormat" and "altTimeFormat" option values
				 */
				currDT = tp_inst.$altInput.val();
			}
			else {
				currDT = tp_inst.$input.val();
			}

			if (date && tp_inst._parseTime(currDT, !inst.settings.timeOnly)) {
				date.setHours(tp_inst.hour, tp_inst.minute, tp_inst.second, tp_inst.millisec);
				date.setMicroseconds(tp_inst.microsec);

				// This is important if you are using the timezone option, javascript's Date
				// object will only return the timezone offset for the current locale, so we
				// adjust it accordingly.  If not using timezone option this won't matter..
				if (tp_inst.timezone != null) {
					// look out for DST if tz wasn't specified
					if (!tp_inst.support.timezone && tp_inst._defaults.timezone === null) {
						tp_inst.timezone = date.getTimezoneOffset() * -1;
					}
					date = $.timepicker.timezoneAdjust(date, tp_inst.timezone, $.timepicker.timezoneOffsetString(-date.getTimezoneOffset()));
				}
			}
			return date;
		}
		return this._base_getDateDatepicker(target, noDefault);
	};

	/*
	* override parseDate() because UI 1.8.14 throws an error about "Extra characters"
	* An option in datapicker to ignore extra format characters would be nicer.
	*/
	$.datepicker._base_parseDate = $.datepicker.parseDate;
	$.datepicker.parseDate = function (format, value, settings) {
		var date;
		try {
			date = this._base_parseDate(format, value, settings);
		} catch (err) {
			// Hack!  The error message ends with a colon, a space, and
			// the "extra" characters.  We rely on that instead of
			// attempting to perfectly reproduce the parsing algorithm.
			if (err.indexOf(":") >= 0) {
				date = this._base_parseDate(format, value.substring(0, value.length - (err.length - err.indexOf(':') - 2)), settings);
				$.timepicker.log("Error parsing the date string: " + err + "\ndate string = " + value + "\ndate format = " + format);
			} else {
				throw err;
			}
		}
		return date;
	};

	/*
	* override formatDate to set date with time to the input
	*/
	$.datepicker._base_formatDate = $.datepicker._formatDate;
	$.datepicker._formatDate = function (inst, day, month, year) {
		var tp_inst = this._get(inst, 'timepicker');
		if (tp_inst) {
			tp_inst._updateDateTime(inst);
			return tp_inst.$input.val();
		}
		return this._base_formatDate(inst);
	};

	/*
	* override options setter to add time to maxDate(Time) and minDate(Time). MaxDate
	*/
	$.datepicker._base_optionDatepicker = $.datepicker._optionDatepicker;
	$.datepicker._optionDatepicker = function (target, name, value) {
		var inst = this._getInst(target),
			name_clone;
		if (!inst) {
			return null;
		}

		var tp_inst = this._get(inst, 'timepicker');
		if (tp_inst) {
			var min = null,
				max = null,
				onselect = null,
				overrides = tp_inst._defaults.evnts,
				fns = {},
				prop,
				ret,
				oldVal,
				$target;
			if (typeof name === 'string') { // if min/max was set with the string
				if (name === 'minDate' || name === 'minDateTime') {
					min = value;
				} else if (name === 'maxDate' || name === 'maxDateTime') {
					max = value;
				} else if (name === 'onSelect') {
					onselect = value;
				} else if (overrides.hasOwnProperty(name)) {
					if (typeof (value) === 'undefined') {
						return overrides[name];
					}
					fns[name] = value;
					name_clone = {}; //empty results in exiting function after overrides updated
				}
			} else if (typeof name === 'object') { //if min/max was set with the JSON
				if (name.minDate) {
					min = name.minDate;
				} else if (name.minDateTime) {
					min = name.minDateTime;
				} else if (name.maxDate) {
					max = name.maxDate;
				} else if (name.maxDateTime) {
					max = name.maxDateTime;
				}
				for (prop in overrides) {
					if (overrides.hasOwnProperty(prop) && name[prop]) {
						fns[prop] = name[prop];
					}
				}
			}
			for (prop in fns) {
				if (fns.hasOwnProperty(prop)) {
					overrides[prop] = fns[prop];
					if (!name_clone) { name_clone = $.extend({}, name); }
					delete name_clone[prop];
				}
			}
			if (name_clone && isEmptyObject(name_clone)) { return; }
			if (min) { //if min was set
				if (min === 0) {
					min = new Date();
				} else {
					min = new Date(min);
				}
				tp_inst._defaults.minDate = min;
				tp_inst._defaults.minDateTime = min;
			} else if (max) { //if max was set
				if (max === 0) {
					max = new Date();
				} else {
					max = new Date(max);
				}
				tp_inst._defaults.maxDate = max;
				tp_inst._defaults.maxDateTime = max;
			} else if (onselect) {
				tp_inst._defaults.onSelect = onselect;
			}

			// Datepicker will override our date when we call _base_optionDatepicker when
			// calling minDate/maxDate, so we will first grab the value, call
			// _base_optionDatepicker, then set our value back.
			if(min || max){
				$target = $(target);
				oldVal = $target.datetimepicker('getDate');
				ret = this._base_optionDatepicker.call($.datepicker, target, name_clone || name, value);
				$target.datetimepicker('setDate', oldVal);
				return ret;
			}
		}
		if (value === undefined) {
			return this._base_optionDatepicker.call($.datepicker, target, name);
		}
		return this._base_optionDatepicker.call($.datepicker, target, name_clone || name, value);
	};

	/*
	* jQuery isEmptyObject does not check hasOwnProperty - if someone has added to the object prototype,
	* it will return false for all objects
	*/
	var isEmptyObject = function (obj) {
		var prop;
		for (prop in obj) {
			if (obj.hasOwnProperty(prop)) {
				return false;
			}
		}
		return true;
	};

	/*
	* jQuery extend now ignores nulls!
	*/
	var extendRemove = function (target, props) {
		$.extend(target, props);
		for (var name in props) {
			if (props[name] === null || props[name] === undefined) {
				target[name] = props[name];
			}
		}
		return target;
	};

	/*
	* Determine by the time format which units are supported
	* Returns an object of booleans for each unit
	*/
	var detectSupport = function (timeFormat) {
		var tf = timeFormat.replace(/'.*?'/g, '').toLowerCase(), // removes literals
			isIn = function (f, t) { // does the format contain the token?
					return f.indexOf(t) !== -1 ? true : false;
				};
		return {
				hour: isIn(tf, 'h'),
				minute: isIn(tf, 'm'),
				second: isIn(tf, 's'),
				millisec: isIn(tf, 'l'),
				microsec: isIn(tf, 'c'),
				timezone: isIn(tf, 'z'),
				ampm: isIn(tf, 't') && isIn(timeFormat, 'h'),
				iso8601: isIn(timeFormat, 'Z')
			};
	};

	/*
	* Converts 24 hour format into 12 hour
	* Returns 12 hour without leading 0
	*/
	var convert24to12 = function (hour) {
		hour %= 12;

		if (hour === 0) {
			hour = 12;
		}

		return String(hour);
	};

	var computeEffectiveSetting = function (settings, property) {
		return settings && settings[property] ? settings[property] : $.timepicker._defaults[property];
	};

	/*
	* Splits datetime string into date and time substrings.
	* Throws exception when date can't be parsed
	* Returns {dateString: dateString, timeString: timeString}
	*/
	var splitDateTime = function (dateTimeString, timeSettings) {
		// The idea is to get the number separator occurrences in datetime and the time format requested (since time has
		// fewer unknowns, mostly numbers and am/pm). We will use the time pattern to split.
		var separator = computeEffectiveSetting(timeSettings, 'separator'),
			format = computeEffectiveSetting(timeSettings, 'timeFormat'),
			timeParts = format.split(separator), // how many occurrences of separator may be in our format?
			timePartsLen = timeParts.length,
			allParts = dateTimeString.split(separator),
			allPartsLen = allParts.length;

		if (allPartsLen > 1) {
			return {
				dateString: allParts.splice(0, allPartsLen - timePartsLen).join(separator),
				timeString: allParts.splice(0, timePartsLen).join(separator)
			};
		}

		return {
			dateString: dateTimeString,
			timeString: ''
		};
	};

	/*
	* Internal function to parse datetime interval
	* Returns: {date: Date, timeObj: Object}, where
	*   date - parsed date without time (type Date)
	*   timeObj = {hour: , minute: , second: , millisec: , microsec: } - parsed time. Optional
	*/
	var parseDateTimeInternal = function (dateFormat, timeFormat, dateTimeString, dateSettings, timeSettings) {
		var date,
			parts,
			parsedTime;

		parts = splitDateTime(dateTimeString, timeSettings);
		date = $.datepicker._base_parseDate(dateFormat, parts.dateString, dateSettings);

		if (parts.timeString === '') {
			return {
				date: date
			};
		}

		parsedTime = $.datepicker.parseTime(timeFormat, parts.timeString, timeSettings);

		if (!parsedTime) {
			throw 'Wrong time format';
		}

		return {
			date: date,
			timeObj: parsedTime
		};
	};

	/*
	* Internal function to set timezone_select to the local timezone
	*/
	var selectLocalTimezone = function (tp_inst, date) {
		if (tp_inst && tp_inst.timezone_select) {
			var now = date || new Date();
			tp_inst.timezone_select.val(-now.getTimezoneOffset());
		}
	};

	/*
	* Create a Singleton Instance
	*/
	$.timepicker = new Timepicker();

	/**
	 * Get the timezone offset as string from a date object (eg '+0530' for UTC+5.5)
	 * @param {number} tzMinutes if not a number, less than -720 (-1200), or greater than 840 (+1400) this value is returned
	 * @param {boolean} iso8601 if true formats in accordance to iso8601 "+12:45"
	 * @return {string}
	 */
	$.timepicker.timezoneOffsetString = function (tzMinutes, iso8601) {
		if (isNaN(tzMinutes) || tzMinutes > 840 || tzMinutes < -720) {
			return tzMinutes;
		}

		var off = tzMinutes,
			minutes = off % 60,
			hours = (off - minutes) / 60,
			iso = iso8601 ? ':' : '',
			tz = (off >= 0 ? '+' : '-') + ('0' + Math.abs(hours)).slice(-2) + iso + ('0' + Math.abs(minutes)).slice(-2);

		if (tz === '+00:00') {
			return 'Z';
		}
		return tz;
	};

	/**
	 * Get the number in minutes that represents a timezone string
	 * @param  {string} tzString formatted like "+0500", "-1245", "Z"
	 * @return {number} the offset minutes or the original string if it doesn't match expectations
	 */
	$.timepicker.timezoneOffsetNumber = function (tzString) {
		var normalized = tzString.toString().replace(':', ''); // excuse any iso8601, end up with "+1245"

		if (normalized.toUpperCase() === 'Z') { // if iso8601 with Z, its 0 minute offset
			return 0;
		}

		if (!/^(\-|\+)\d{4}$/.test(normalized)) { // possibly a user defined tz, so just give it back
			return parseInt(tzString, 10);
		}

		return ((normalized.substr(0, 1) === '-' ? -1 : 1) * // plus or minus
					((parseInt(normalized.substr(1, 2), 10) * 60) + // hours (converted to minutes)
					parseInt(normalized.substr(3, 2), 10))); // minutes
	};

	/**
	 * No way to set timezone in js Date, so we must adjust the minutes to compensate. (think setDate, getDate)
	 * @param  {Date} date
	 * @param  {string} fromTimezone formatted like "+0500", "-1245"
	 * @param  {string} toTimezone formatted like "+0500", "-1245"
	 * @return {Date}
	 */
	$.timepicker.timezoneAdjust = function (date, fromTimezone, toTimezone) {
		var fromTz = $.timepicker.timezoneOffsetNumber(fromTimezone);
		var toTz = $.timepicker.timezoneOffsetNumber(toTimezone);
		if (!isNaN(toTz)) {
			date.setMinutes(date.getMinutes() + (-fromTz) - (-toTz));
		}
		return date;
	};

	/**
	 * Calls `timepicker()` on the `startTime` and `endTime` elements, and configures them to
	 * enforce date range limits.
	 * n.b. The input value must be correctly formatted (reformatting is not supported)
	 * @param  {Element} startTime
	 * @param  {Element} endTime
	 * @param  {Object} options Options for the timepicker() call
	 * @return {jQuery}
	 */
	$.timepicker.timeRange = function (startTime, endTime, options) {
		return $.timepicker.handleRange('timepicker', startTime, endTime, options);
	};

	/**
	 * Calls `datetimepicker` on the `startTime` and `endTime` elements, and configures them to
	 * enforce date range limits.
	 * @param  {Element} startTime
	 * @param  {Element} endTime
	 * @param  {Object} options Options for the `timepicker()` call. Also supports `reformat`,
	 *   a boolean value that can be used to reformat the input values to the `dateFormat`.
	 * @param  {string} method Can be used to specify the type of picker to be added
	 * @return {jQuery}
	 */
	$.timepicker.datetimeRange = function (startTime, endTime, options) {
		$.timepicker.handleRange('datetimepicker', startTime, endTime, options);
	};

	/**
	 * Calls `datepicker` on the `startTime` and `endTime` elements, and configures them to
	 * enforce date range limits.
	 * @param  {Element} startTime
	 * @param  {Element} endTime
	 * @param  {Object} options Options for the `timepicker()` call. Also supports `reformat`,
	 *   a boolean value that can be used to reformat the input values to the `dateFormat`.
	 * @return {jQuery}
	 */
	$.timepicker.dateRange = function (startTime, endTime, options) {
		$.timepicker.handleRange('datepicker', startTime, endTime, options);
	};

	/**
	 * Calls `method` on the `startTime` and `endTime` elements, and configures them to
	 * enforce date range limits.
	 * @param  {string} method Can be used to specify the type of picker to be added
	 * @param  {Element} startTime
	 * @param  {Element} endTime
	 * @param  {Object} options Options for the `timepicker()` call. Also supports `reformat`,
	 *   a boolean value that can be used to reformat the input values to the `dateFormat`.
	 * @return {jQuery}
	 */
	$.timepicker.handleRange = function (method, startTime, endTime, options) {
		options = $.extend({}, {
			minInterval: 0, // min allowed interval in milliseconds
			maxInterval: 0, // max allowed interval in milliseconds
			start: {},      // options for start picker
			end: {}         // options for end picker
		}, options);

		// for the mean time this fixes an issue with calling getDate with timepicker()
		var timeOnly = false;
		if(method === 'timepicker'){
			timeOnly = true;
			method = 'datetimepicker';
		}

		function checkDates(changed, other) {
			var startdt = startTime[method]('getDate'),
				enddt = endTime[method]('getDate'),
				changeddt = changed[method]('getDate');

			if (startdt !== null) {
				var minDate = new Date(startdt.getTime()),
					maxDate = new Date(startdt.getTime());

				minDate.setMilliseconds(minDate.getMilliseconds() + options.minInterval);
				maxDate.setMilliseconds(maxDate.getMilliseconds() + options.maxInterval);

				if (options.minInterval > 0 && minDate > enddt) { // minInterval check
					endTime[method]('setDate', minDate);
				}
				else if (options.maxInterval > 0 && maxDate < enddt) { // max interval check
					endTime[method]('setDate', maxDate);
				}
				else if (startdt > enddt) {
					other[method]('setDate', changeddt);
				}
			}
		}

		function selected(changed, other, option) {
			if (!changed.val()) {
				return;
			}
			var date = changed[method].call(changed, 'getDate');
			if (date !== null && options.minInterval > 0) {
				if (option === 'minDate') {
					date.setMilliseconds(date.getMilliseconds() + options.minInterval);
				}
				if (option === 'maxDate') {
					date.setMilliseconds(date.getMilliseconds() - options.minInterval);
				}
			}

			if (date.getTime) {
				other[method].call(other, 'option', option, date);
			}
		}

		$.fn[method].call(startTime, $.extend({
			timeOnly: timeOnly,
			onClose: function (dateText, inst) {
				checkDates($(this), endTime);
			},
			onSelect: function (selectedDateTime) {
				selected($(this), endTime, 'minDate');
			}
		}, options, options.start));
		$.fn[method].call(endTime, $.extend({
			timeOnly: timeOnly,
			onClose: function (dateText, inst) {
				checkDates($(this), startTime);
			},
			onSelect: function (selectedDateTime) {
				selected($(this), startTime, 'maxDate');
			}
		}, options, options.end));

		checkDates(startTime, endTime);

		selected(startTime, endTime, 'minDate');
		selected(endTime, startTime, 'maxDate');

		return $([startTime.get(0), endTime.get(0)]);
	};

	/**
	 * Log error or data to the console during error or debugging
	 * @param  {Object} err pass any type object to log to the console during error or debugging
	 * @return {void}
	 */
	$.timepicker.log = function () {
		// Older IE (9, maybe 10) throw error on accessing `window.console.log.apply`, so check first.
		if (window.console && window.console.log && window.console.log.apply) {
			window.console.log.apply(window.console, Array.prototype.slice.call(arguments));
		}
	};

	/*
	 * Add util object to allow access to private methods for testability.
	 */
	$.timepicker._util = {
		_extendRemove: extendRemove,
		_isEmptyObject: isEmptyObject,
		_convert24to12: convert24to12,
		_detectSupport: detectSupport,
		_selectLocalTimezone: selectLocalTimezone,
		_computeEffectiveSetting: computeEffectiveSetting,
		_splitDateTime: splitDateTime,
		_parseDateTimeInternal: parseDateTimeInternal
	};

	/*
	* Microsecond support
	*/
	if (!Date.prototype.getMicroseconds) {
		Date.prototype.microseconds = 0;
		Date.prototype.getMicroseconds = function () { return this.microseconds; };
		Date.prototype.setMicroseconds = function (m) {
			this.setMilliseconds(this.getMilliseconds() + Math.floor(m / 1000));
			this.microseconds = m % 1000;
			return this;
		};
	}

	/*
	* Keep up with the version
	*/
	$.timepicker.version = "@@version";

}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(142);


/***/ })
],[287]);


// WEBPACK FOOTER //
// app.bundle.js